var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var _a, _b;
import * as React from "react";
import React__default, { useRef, useState, useCallback, useEffect, createContext as createContext$1, useMemo, createElement, useContext, forwardRef, Children, isValidElement, cloneElement, Fragment, useLayoutEffect, useReducer, memo, Component } from "react";
import { useLocation, Link as Link$1 } from "react-router-dom";
import { useTranslation } from "react-i18next";
import * as ReactDOM from "react-dom";
import ReactDOM__default, { flushSync, createPortal } from "react-dom";
var button = "vok3j90";
var buttonPrimary = "vok3j91";
var buttonSecondary = "vok3j92";
var buttonTertiary = "vok3j93";
var buttonNegative = "vok3j94";
var buttonLabel = "vok3j95";
var buttonIcon = "vok3j96";
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getDefaultExportFromCjs(x2) {
  return x2 && x2.__esModule && Object.prototype.hasOwnProperty.call(x2, "default") ? x2["default"] : x2;
}
function getAugmentedNamespace(n2) {
  if (n2.__esModule) return n2;
  var f2 = n2.default;
  if (typeof f2 == "function") {
    var a2 = function a3() {
      if (this instanceof a3) {
        return Reflect.construct(f2, arguments, this.constructor);
      }
      return f2.apply(this, arguments);
    };
    a2.prototype = f2.prototype;
  } else a2 = {};
  Object.defineProperty(a2, "__esModule", { value: true });
  Object.keys(n2).forEach(function(k2) {
    var d2 = Object.getOwnPropertyDescriptor(n2, k2);
    Object.defineProperty(a2, k2, d2.get ? d2 : {
      enumerable: true,
      get: function() {
        return n2[k2];
      }
    });
  });
  return a2;
}
var classnames$1 = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(module) {
  (function() {
    var hasOwn2 = {}.hasOwnProperty;
    function classNames2() {
      var classes = "";
      for (var i = 0; i < arguments.length; i++) {
        var arg = arguments[i];
        if (arg) {
          classes = appendClass(classes, parseValue2(arg));
        }
      }
      return classes;
    }
    function parseValue2(arg) {
      if (typeof arg === "string" || typeof arg === "number") {
        return arg;
      }
      if (typeof arg !== "object") {
        return "";
      }
      if (Array.isArray(arg)) {
        return classNames2.apply(null, arg);
      }
      if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) {
        return arg.toString();
      }
      var classes = "";
      for (var key in arg) {
        if (hasOwn2.call(arg, key) && arg[key]) {
          classes = appendClass(classes, key);
        }
      }
      return classes;
    }
    function appendClass(value, newClass) {
      if (!newClass) {
        return value;
      }
      if (value) {
        return value + " " + newClass;
      }
      return value + newClass;
    }
    if (module.exports) {
      classNames2.default = classNames2;
      module.exports = classNames2;
    } else {
      window.classNames = classNames2;
    }
  })();
})(classnames$1);
var classnamesExports = classnames$1.exports;
const classNames$1 = /* @__PURE__ */ getDefaultExportFromCjs(classnamesExports);
var icon = "_2fm3xn0";
var iconWrapper = "_2fm3xn1";
var badge = "_2fm3xn3";
const Sun = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { fill: props.color },
        width: props.size,
        height: props.size,
        ref: forwardedRef,
        viewBox: "0 0 512 512"
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M361.5 1.2c5 2.1 8.6 6.6 9.6 11.9L391 121l107.9 19.8c5.3 1 9.8 4.6 11.9 9.6s1.5 10.7-1.6 15.2L446.9 256l62.3 90.3c3.1 4.5 3.7 10.2 1.6 15.2s-6.6 8.6-11.9 9.6L391 391 371.1 498.9c-1 5.3-4.6 9.8-9.6 11.9s-10.7 1.5-15.2-1.6L256 446.9l-90.3 62.3c-4.5 3.1-10.2 3.7-15.2 1.6s-8.6-6.6-9.6-11.9L121 391 13.1 371.1c-5.3-1-9.8-4.6-11.9-9.6s-1.5-10.7 1.6-15.2L65.1 256 2.8 165.7c-3.1-4.5-3.7-10.2-1.6-15.2s6.6-8.6 11.9-9.6L121 121 140.9 13.1c1-5.3 4.6-9.8 9.6-11.9s10.7-1.5 15.2 1.6L256 65.1 346.3 2.8c4.5-3.1 10.2-3.7 15.2-1.6zM160 256a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm224 0a128 128 0 1 0 -256 0 128 128 0 1 0 256 0z"
        }
      )
    );
  }
);
const Carte_bancaire = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M10.1875 9.72727C9.94588 9.72727 9.75 9.91043 9.75 10.1364C9.75 10.3623 9.94588 10.5455 10.1875 10.5455H11.9375C12.1791 10.5455 12.375 10.3623 12.375 10.1364C12.375 9.91043 12.1791 9.72727 11.9375 9.72727H10.1875Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1 5.63636C1 4.73263 1.7835 4 2.75 4H13.25C14.2165 4 15 4.73263 15 5.63636V11.3636C15 12.2674 14.2165 13 13.25 13H2.75C1.7835 13 1 12.2674 1 11.3636V5.63636ZM2.75 5.02273H13.25C13.6124 5.02273 13.9062 5.29746 13.9062 5.63636H2.09375C2.09375 5.29746 2.38756 5.02273 2.75 5.02273ZM2.09375 6.45455V7.27273H13.9062V6.45455H2.09375ZM2.09375 11.3636V8.09091H13.9062V11.3636C13.9062 11.7025 13.6124 11.9773 13.25 11.9773H2.75C2.38756 11.9773 2.09375 11.7025 2.09375 11.3636Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Aave = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement("title", { id: "title" }, "icone Aave"),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M7.99998 4.16658C8.19757 4.16658 8.37663 4.28295 8.45688 4.46352L11.1236 10.4635C11.2357 10.7159 11.1221 11.0113 10.8697 11.1235C10.6174 11.2356 10.3219 11.122 10.2097 10.8697L7.99998 5.89769L7.28788 7.49992H7.99998C8.27612 7.49992 8.49998 7.72378 8.49998 7.99992C8.49998 8.27606 8.27612 8.49992 7.99998 8.49992H6.84343L5.79022 10.8697C5.67807 11.122 5.38259 11.2356 5.13024 11.1235C4.8779 11.0113 4.76426 10.7159 4.87641 10.4635L5.74912 8.49992H5.33331C5.05717 8.49992 4.83331 8.27606 4.83331 7.99992C4.83331 7.72378 5.05717 7.49992 5.33331 7.49992H6.19356L7.54307 4.46352C7.62332 4.28295 7.80238 4.16658 7.99998 4.16658Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.99998 0.833252C4.04194 0.833252 0.833313 4.04188 0.833313 7.99992C0.833313 11.958 4.04194 15.1666 7.99998 15.1666C11.958 15.1666 15.1666 11.958 15.1666 7.99992C15.1666 4.04188 11.958 0.833252 7.99998 0.833252ZM1.83331 7.99992C1.83331 4.59416 4.59422 1.83325 7.99998 1.83325C11.4057 1.83325 14.1666 4.59416 14.1666 7.99992C14.1666 11.4057 11.4057 14.1666 7.99998 14.1666C4.59422 14.1666 1.83331 11.4057 1.83331 7.99992Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Abo_Web = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement("title", { id: "title" }, "icone Abo web"),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.66667 3.67301C8.66667 5.14928 7.47276 6.34603 6 6.34603C4.52724 6.34603 3.33333 5.14928 3.33333 3.67301C3.33333 2.19675 4.52724 1 6 1C7.47276 1 8.66667 2.19675 8.66667 3.67301ZM7.55556 3.67301C7.55556 4.53417 6.85911 5.23227 6 5.23227C5.14089 5.23227 4.44444 4.53417 4.44444 3.67301C4.44444 2.81186 5.14089 2.11376 6 2.11376C6.85911 2.11376 7.55556 2.81186 7.55556 3.67301Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M8.57151 6.20271C8.32474 6.09163 8.03402 6.17486 7.883 6.39983C7.54931 6.89691 6.85537 7.28372 6 7.28372C5.14463 7.28372 4.45068 6.89691 4.11699 6.39983C3.96597 6.17486 3.67526 6.09163 3.42849 6.20271C1.99802 6.84661 1 8.28768 1 9.96361V10.5521C1 11.3518 1.6467 12 2.44444 12H6.10002C6.03443 11.6769 6 11.3425 6 11C6 10.962 6.00042 10.9241 6.00127 10.8862H2.44444C2.26035 10.8862 2.11111 10.7366 2.11111 10.5521V9.96361C2.11111 8.89067 2.67174 7.94805 3.51696 7.41556C4.12074 8.03054 5.02491 8.39748 6 8.39748C6.26679 8.39748 6.52827 8.37001 6.77975 8.31751C7.3095 7.48581 8.07835 6.82125 8.98949 6.42065C8.85492 6.34032 8.7154 6.26748 8.57151 6.20271Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.5571 7.31447C11.8136 7 11 7 11 7C10.1864 7 9.44293 7.31447 9.44293 7.31447C8.72504 7.61811 8.17157 8.17157 8.17157 8.17157C7.61811 8.72504 7.31447 9.44292 7.31447 9.44292C7.28467 9.51337 7.2577 9.58445 7.23328 9.65541C7.22937 9.66522 7.22595 9.67528 7.22305 9.68555C7 10.3529 7 11 7 11C7 11.5097 7.12341 11.9918 7.21561 12.2809C7.22087 12.313 7.23109 12.3434 7.24546 12.3714C7.28565 12.4889 7.31447 12.5571 7.31447 12.5571C7.61811 13.275 8.17157 13.8284 8.17157 13.8284C8.72504 14.3819 9.44293 14.6855 9.44293 14.6855C10.1864 15 11 15 11 15C11.8136 15 12.5571 14.6855 12.5571 14.6855C13.275 14.3819 13.8284 13.8284 13.8284 13.8284C14.3819 13.275 14.6855 12.5571 14.6855 12.5571C14.7153 12.4866 14.7423 12.4156 14.7667 12.3446C14.7706 12.3348 14.7741 12.3247 14.777 12.3144C15 11.6471 15 11 15 11C15 10.4903 14.8766 10.0082 14.7844 9.71906C14.7791 9.68698 14.7689 9.65657 14.7545 9.62865C14.7144 9.51106 14.6855 9.44292 14.6855 9.44292C14.3819 8.72504 13.8284 8.17157 13.8284 8.17157C13.275 7.61811 12.5571 7.31447 12.5571 7.31447ZM8.60672 13.3933C8.31572 13.1023 8.10637 12.7578 7.98948 12.5385H9.30722C9.44617 13.2337 9.6293 13.6613 9.6293 13.6613C9.72408 13.8826 9.83208 14.0658 9.92749 14.2059C9.77492 14.1578 9.68265 14.1188 9.68265 14.1188C9.07531 13.8619 8.60672 13.3933 8.60672 13.3933ZM12.0712 14.2094C12.1532 14.1833 12.2358 14.1533 12.3174 14.1188C12.3174 14.1188 12.9247 13.8619 13.3933 13.3933C13.3933 13.3933 13.7518 13.0348 14.0136 12.5385H12.6942C12.6239 12.9148 12.5211 13.3101 12.3707 13.6613C12.3707 13.6613 12.2528 13.9366 12.0712 14.2094ZM12.7857 11.9231H14.25C14.317 11.6793 14.3846 11.3473 14.3846 11C14.3846 11 14.3846 10.5685 14.2528 10.0769H12.7908C12.8247 10.3604 12.8462 10.6702 12.8462 11C12.8462 11 12.8462 11.3921 12.7857 11.9231ZM12.1676 10.0769C12.2308 10.6005 12.2308 11 12.2308 11C12.2308 11.3337 12.2074 11.6438 12.1716 11.9231H9.83245C9.76923 11.3995 9.76923 11 9.76923 11C9.76923 10.6663 9.79259 10.3562 9.82836 10.0769H12.1676ZM12.6928 9.46154H14.0105C13.8936 9.2422 13.6843 8.89771 13.3933 8.60672C13.3933 8.60672 12.9247 8.13812 12.3174 7.88124C12.3174 7.88124 12.2251 7.84222 12.0725 7.79407C12.1679 7.9342 12.2759 8.1174 12.3707 8.33871C12.3707 8.33871 12.5538 8.76631 12.6928 9.46154ZM9.92878 7.79058C9.84681 7.81671 9.76423 7.84673 9.68265 7.88124C9.68265 7.88124 9.07531 8.13812 8.60672 8.60672C8.60672 8.60672 8.24819 8.96524 7.98643 9.46154H9.30578C9.37608 9.08518 9.4789 8.68988 9.6293 8.33871C9.6293 8.33871 9.74722 8.06336 9.92878 7.79058ZM9.93422 9.46154C10.0539 8.9103 10.195 8.58097 10.195 8.58097C10.3842 8.13921 10.6174 7.9089 10.6174 7.9089C10.8133 7.71537 11 7.71537 11 7.71537C11.1867 7.71537 11.3826 7.9089 11.3826 7.9089C11.6158 8.13921 11.805 8.58097 11.805 8.58097C11.9223 8.85475 12.0072 9.16119 12.0688 9.46154H9.93422ZM9.21427 10.0769H7.74998C7.68297 10.3207 7.61538 10.6527 7.61538 11C7.61538 11 7.61538 11.4315 7.7472 11.9231H9.20918C9.17534 11.6396 9.15385 11.3298 9.15385 11C9.15385 11 9.15385 10.6079 9.21427 10.0769ZM9.93122 12.5385H12.0658C11.946 13.0897 11.805 13.419 11.805 13.419C11.6158 13.8608 11.3826 14.0911 11.3826 14.0911C11.1867 14.2846 11 14.2846 11 14.2846C10.8133 14.2846 10.6174 14.0911 10.6174 14.0911C10.3842 13.8608 10.195 13.419 10.195 13.419C10.0777 13.1452 9.99279 12.8388 9.93122 12.5385Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Acheter = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement("title", { id: "title" }, "icone Acheter"),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M3.98082 3.58201H7.14146V4.58371H4.15024L4.97349 9.45115L12.1484 9.45115L13.8899 4.58371H10.6V3.58201H13.8899C14.6056 3.58201 15.1085 4.25903 14.8759 4.90935L13.1344 9.77678C12.9897 10.1813 12.5936 10.4528 12.1484 10.4528H4.97349C4.46223 10.4528 4.0264 10.0967 3.94439 9.61182L2.66855 2.06837H1.06665V1.06667H2.66855C3.17981 1.06667 3.61564 1.42285 3.69764 1.9077L3.98082 3.58201Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.41174 11.5211C5.43102 11.5211 4.63598 12.2849 4.63598 13.2272C4.63598 14.1695 5.43102 14.9333 6.41174 14.9333C7.39247 14.9333 8.1875 14.1695 8.1875 13.2272C8.1875 12.2849 7.39247 11.5211 6.41174 11.5211ZM5.67857 13.2272C5.67857 12.8382 6.00682 12.5228 6.41174 12.5228C6.81666 12.5228 7.14491 12.8382 7.14491 13.2272C7.14491 13.6163 6.81666 13.9316 6.41174 13.9316C6.00682 13.9316 5.67857 13.6163 5.67857 13.2272Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.8114 11.5211C10.8307 11.5211 10.0357 12.2849 10.0357 13.2272C10.0357 14.1695 10.8307 14.9333 11.8114 14.9333C12.7921 14.9333 13.5872 14.1695 13.5872 13.2272C13.5872 12.2849 12.7921 11.5211 11.8114 11.5211ZM11.0782 13.2272C11.0782 12.8382 11.4065 12.5228 11.8114 12.5228C12.2163 12.5228 12.5446 12.8382 12.5446 13.2272C12.5446 13.6163 12.2163 13.9316 11.8114 13.9316C11.4065 13.9316 11.0782 13.6163 11.0782 13.2272Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M8.92443 1.52889C9.17971 1.52889 9.38665 1.73583 9.38665 1.99111V6.8841L10.9087 5.36205C11.0892 5.18154 11.3819 5.18154 11.5624 5.36205C11.7429 5.54256 11.7429 5.83522 11.5624 6.01573L9.25127 8.32684C9.16459 8.41352 9.04702 8.46222 8.92443 8.46222C8.80184 8.46222 8.68427 8.41352 8.59759 8.32684L6.28648 6.01573C6.10597 5.83522 6.10597 5.54256 6.28648 5.36205C6.46699 5.18154 6.75965 5.18154 6.94016 5.36205L8.46221 6.8841V1.99111C8.46221 1.73583 8.66915 1.52889 8.92443 1.52889Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const AcheterVendre = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M11.5 6C11.7301 6 11.9167 5.82091 11.9167 5.6V1.36569L13.2887 2.68284C13.4514 2.83905 13.7152 2.83905 13.878 2.68284C14.0407 2.52663 14.0407 2.27337 13.878 2.11716L11.7946 0.117157C11.7165 0.0421428 11.6105 0 11.5 0C11.3895 0 11.2835 0.0421423 11.2054 0.117157L9.12204 2.11716C8.95932 2.27337 8.95932 2.52663 9.12204 2.68284C9.28476 2.83905 9.54858 2.83905 9.71129 2.68284L11.0833 1.36569V5.6C11.0833 5.82091 11.2699 6 11.5 6Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M3.98082 3.58201H5V4.58371H4.15024L4.97349 9.45115L12.1484 9.45115L13.8899 4.58371H13V3.58201H13.8899C14.6056 3.58201 15.1085 4.25903 14.8759 4.90935L13.1344 9.77678C12.9897 10.1813 12.5936 10.4528 12.1484 10.4528H4.97349C4.46223 10.4528 4.0264 10.0967 3.94439 9.61182L2.66855 2.06837H1.06665V1.06667H2.66855C3.17981 1.06667 3.61564 1.42285 3.69764 1.9077L3.98082 3.58201Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.63598 13.2272C4.63598 12.2849 5.43102 11.5211 6.41174 11.5211C7.39247 11.5211 8.1875 12.2849 8.1875 13.2272C8.1875 14.1695 7.39247 14.9333 6.41174 14.9333C5.43102 14.9333 4.63598 14.1695 4.63598 13.2272ZM6.41174 12.5228C6.00682 12.5228 5.67857 12.8382 5.67857 13.2272C5.67857 13.6163 6.00682 13.9316 6.41174 13.9316C6.81666 13.9316 7.14491 13.6163 7.14491 13.2272C7.14491 12.8382 6.81666 12.5228 6.41174 12.5228Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.8114 11.5211C10.8307 11.5211 10.0357 12.2849 10.0357 13.2272C10.0357 14.1695 10.8307 14.9333 11.8114 14.9333C12.7921 14.9333 13.5872 14.1695 13.5872 13.2272C13.5872 12.2849 12.7921 11.5211 11.8114 11.5211ZM11.0782 13.2272C11.0782 12.8382 11.4065 12.5228 11.8114 12.5228C12.2163 12.5228 12.5446 12.8382 12.5446 13.2272C12.5446 13.6163 12.2163 13.9316 11.8114 13.9316C11.4065 13.9316 11.0782 13.6163 11.0782 13.2272Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M7.08333 2.4C7.08333 2.17909 7.26988 2 7.5 2C7.73012 2 7.91667 2.17909 7.91667 2.4V6.63431L9.28871 5.31716C9.45142 5.16095 9.71524 5.16095 9.87796 5.31716C10.0407 5.47337 10.0407 5.72663 9.87796 5.88284L7.79463 7.88284C7.71649 7.95786 7.61051 8 7.5 8C7.38949 8 7.28351 7.95786 7.20537 7.88284L5.12204 5.88284C4.95932 5.72663 4.95932 5.47337 5.12204 5.31716C5.28476 5.16095 5.54857 5.16095 5.71129 5.31716L7.08333 6.63431V2.4Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Actualites = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M6.5 9.5H11.5C11.7761 9.5 12 9.27614 12 9C12 8.72386 11.7761 8.5 11.5 8.5H6.5C6.22386 8.5 6 8.72386 6 9C6 9.27614 6.22386 9.5 6.5 9.5Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M6.5 6C6.22386 6 6 6.22386 6 6.5C6 6.77614 6.22386 7 6.5 7H11.5C11.7761 7 12 6.77614 12 6.5C12 6.22386 11.7761 6 11.5 6H6.5Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M13.5 13H2.5C2.48744 13 2.47498 12.9995 2.46265 12.9986C2.32216 12.9906 1.81443 12.9358 1.43934 12.5607C1.43934 12.5607 1 12.1213 1 11.5V5.5C1 5.22386 1.22386 5 1.5 5C1.77614 5 2 5.22386 2 5.5V11.5C2 11.5 2 11.7071 2.14645 11.8536C2.14645 11.8536 2.29289 12 2.5 12C2.5 12 2.70711 12 2.85355 11.8536C2.85355 11.8536 3 11.7071 3 11.5V4C3 4 3 3.58579 3.29289 3.29289C3.29289 3.29289 3.58579 3 4 3H14C14 3 14.4142 3 14.7071 3.29289C14.7071 3.29289 15 3.58579 15 4V11.5C15 11.5 15 12.1213 14.5607 12.5607C14.5607 12.5607 14.1213 13 13.5 13ZM13.5 12H3.919C3.919 12 4 11.7668 4 11.5V4H14V11.5C14 11.5 14 11.7071 13.8536 11.8536C13.8536 11.8536 13.7071 12 13.5 12Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Wrench = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M14.4734 10.3867L11.4601 7.38C11.5231 7.07292 11.5544 6.76016 11.5534 6.44667C11.5532 5.5871 11.3362 4.74147 10.9227 3.98793C10.5091 3.23438 9.91228 2.59726 9.18732 2.13543C8.46236 1.67361 7.63267 1.40199 6.77495 1.3457C5.91723 1.2894 5.05916 1.45023 4.28005 1.81334C4.18134 1.85843 4.09513 1.92694 4.02891 2.01291C3.96269 2.09888 3.91845 2.19972 3.90005 2.30667C3.88172 2.41226 3.88911 2.52072 3.92161 2.62284C3.9541 2.72497 4.01074 2.81775 4.08672 2.89334L6.98672 5.78667L5.78672 6.98667L2.89338 4.08667C2.81716 4.01187 2.72409 3.95648 2.62199 3.92516C2.5199 3.89383 2.41177 3.88749 2.30672 3.90667C2.20044 3.9244 2.10004 3.96763 2.01412 4.03265C1.9282 4.09766 1.85932 4.18254 1.81338 4.28C1.44907 5.06167 1.28837 5.92279 1.34624 6.78325C1.40412 7.6437 1.67868 8.47555 2.14439 9.20139C2.6101 9.92723 3.25183 10.5235 4.00988 10.9347C4.76793 11.3459 5.61767 11.5587 6.48005 11.5533C6.79354 11.5543 7.1063 11.5231 7.41338 11.46L10.4201 14.4733C10.482 14.5358 10.5558 14.5854 10.637 14.6193C10.7182 14.6531 10.8054 14.6705 10.8934 14.6705C10.9814 14.6705 11.0685 14.6531 11.1498 14.6193C11.231 14.5854 11.3047 14.5358 11.3667 14.4733C11.4292 14.4114 11.4788 14.3376 11.5126 14.2564C11.5465 14.1751 11.5639 14.088 11.5639 14C11.5639 13.912 11.5465 13.8249 11.5126 13.7436C11.4788 13.6624 11.4292 13.5886 11.3667 13.5267L8.10005 10.26C8.01842 10.1789 7.91719 10.1203 7.8062 10.09C7.69522 10.0596 7.57827 10.0585 7.46672 10.0867C7.14483 10.1729 6.81327 10.2177 6.48005 10.22C5.98142 10.2244 5.48684 10.1301 5.02481 9.94252C4.56278 9.75495 4.14243 9.47781 3.78798 9.12707C3.43352 8.77633 3.15197 8.35893 2.95953 7.8989C2.76709 7.43888 2.66758 6.94532 2.66672 6.44667C2.66585 6.22335 2.68369 6.00035 2.72005 5.78L5.33338 8.4C5.39536 8.46249 5.46909 8.51209 5.55033 8.54593C5.63157 8.57978 5.71871 8.5972 5.80672 8.5972C5.89472 8.5972 5.98186 8.57978 6.0631 8.54593C6.14434 8.51209 6.21808 8.46249 6.28005 8.4L8.40005 6.26C8.52021 6.13569 8.58738 5.96956 8.58738 5.79667C8.58738 5.62378 8.52021 5.45765 8.40005 5.33334L5.80672 2.72C6.02711 2.68401 6.25008 2.66617 6.47338 2.66667C7.47475 2.66844 8.43449 3.06746 9.14194 3.77616C9.84939 4.48486 10.2467 5.44531 10.2467 6.44667C10.2444 6.77989 10.1996 7.11145 10.1134 7.43334C10.0852 7.54489 10.0863 7.66184 10.1167 7.77282C10.147 7.88381 10.2056 7.98504 10.2867 8.06667L13.5534 11.3333C13.6789 11.4589 13.8492 11.5294 14.0267 11.5294C14.2043 11.5294 14.3745 11.4589 14.5 11.3333C14.6256 11.2078 14.6961 11.0375 14.6961 10.86C14.6961 10.6825 14.6256 10.5122 14.5 10.3867H14.4734Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const AdresseIP = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M3.52944 6.07486C3.52944 3.63496 5.52546 1.64706 8.00003 1.64706C10.4746 1.64706 12.4706 3.63496 12.4706 6.07486C12.4706 6.46471 12.7867 6.78074 13.1765 6.78074C13.5663 6.78074 13.8824 6.46471 13.8824 6.07486C13.8824 2.84424 11.2432 0.235291 8.00003 0.235291C4.75683 0.235291 2.11768 2.84424 2.11768 6.07486C2.11768 7.54278 2.87554 9.19549 3.78461 10.682C4.71041 12.1959 5.86815 13.6553 6.80974 14.763C7.42782 15.4902 8.55062 15.5366 9.21095 14.8155C10.2515 13.6794 11.4198 12.1862 12.3252 10.6405C12.5222 10.3041 12.4093 9.8717 12.0729 9.67466C11.7365 9.47761 11.3041 9.59056 11.107 9.92695C10.2623 11.3691 9.1583 12.7827 8.16981 13.8621C8.0989 13.9395 7.96856 13.9465 7.88542 13.8487C6.96367 12.7643 5.85939 11.3688 4.98902 9.94549C4.10191 8.49488 3.52944 7.12819 3.52944 6.07486Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement("path", { d: "M7.09813 7.05882H7.42518V5.38353H7.09813V7.05882Z", fill: "currentColor" }),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.01739 5.95294C9.01739 5.76627 8.96876 5.62509 8.87151 5.52941C8.77582 5.43215 8.64014 5.38353 8.46445 5.38353H7.81504V7.05882H8.1421V6.52235H8.46445C8.64014 6.52235 8.77582 6.47451 8.87151 6.37882C8.96876 6.28156 9.01739 6.1396 9.01739 5.95294ZM8.44798 5.67529C8.60955 5.67529 8.69033 5.76784 8.69033 5.95294C8.69033 6.05176 8.66916 6.12235 8.6268 6.1647C8.58602 6.20705 8.52641 6.22823 8.44798 6.22823H8.1421V5.67529H8.44798Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.2941 6.11764C11.2941 7.93693 9.81932 9.41176 8.00003 9.41176C6.18074 9.41176 4.70591 7.93693 4.70591 6.11764C4.70591 4.29835 6.18074 2.82353 8.00003 2.82353C9.81932 2.82353 11.2941 4.29835 11.2941 6.11764ZM9.88238 6.11764C9.88238 7.15724 9.03962 8 8.00003 8C6.96043 8 6.11768 7.15724 6.11768 6.11764C6.11768 5.07805 6.96043 4.23529 8.00003 4.23529C9.03962 4.23529 9.88238 5.07805 9.88238 6.11764Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M13.1765 8.47058C13.1765 8.73048 12.9658 8.94117 12.7059 8.94117C12.446 8.94117 12.2353 8.73048 12.2353 8.47058C12.2353 8.21069 12.446 8 12.7059 8C12.9658 8 13.1765 8.21069 13.1765 8.47058Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Aide = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M7.1246 10.2855V10.3409H8.23256V10.2855C8.23871 9.90388 8.27872 9.58535 8.35258 9.3299C8.42645 9.07446 8.54494 8.8544 8.70805 8.66974C8.87117 8.48201 9.08814 8.3035 9.35898 8.13423C9.62981 7.96804 9.86063 7.77723 10.0514 7.56179C10.2453 7.34635 10.3931 7.10168 10.4946 6.82777C10.5993 6.55386 10.6516 6.24763 10.6516 5.90909C10.6516 5.42898 10.5408 5.00118 10.3192 4.62571C10.1007 4.25024 9.78985 3.95478 9.38667 3.73935C8.98658 3.52391 8.5157 3.41619 7.97403 3.41619C7.47545 3.41619 7.0215 3.51468 6.61217 3.71165C6.20592 3.90862 5.87815 4.1933 5.62886 4.5657C5.38265 4.93809 5.24723 5.38589 5.22261 5.90909H6.38596C6.41059 5.54593 6.50138 5.25201 6.65834 5.02734C6.8153 4.80268 7.01073 4.63802 7.24463 4.53338C7.47853 4.42874 7.72166 4.37642 7.97403 4.37642C8.26333 4.37642 8.52647 4.43643 8.76345 4.55646C9.00043 4.67649 9.1897 4.8473 9.33128 5.06889C9.47285 5.29048 9.54363 5.55208 9.54363 5.85369C9.54363 6.09683 9.50055 6.31842 9.41437 6.51847C9.33128 6.71851 9.2174 6.89548 9.07275 7.04936C8.9281 7.20017 8.76499 7.33097 8.58341 7.44176C8.2818 7.62334 8.02327 7.82185 7.80784 8.03729C7.5924 8.25272 7.42621 8.53433 7.30926 8.8821C7.19231 9.22988 7.13076 9.69768 7.1246 10.2855Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M7.12922 12.8292C7.29233 12.9923 7.48776 13.0739 7.71551 13.0739C7.86939 13.0739 8.00789 13.0369 8.13099 12.9631C8.25718 12.8861 8.3572 12.7846 8.43106 12.6584C8.50801 12.5322 8.54648 12.3937 8.54648 12.2429C8.54648 12.0152 8.46492 11.8197 8.3018 11.6566C8.13869 11.4935 7.94326 11.4119 7.71551 11.4119C7.48776 11.4119 7.29233 11.4935 7.12922 11.6566C6.9661 11.8197 6.88454 12.0152 6.88454 12.2429C6.88454 12.4706 6.9661 12.6661 7.12922 12.8292Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM14.5 8C14.5 11.5899 11.5899 14.5 8 14.5C4.41015 14.5 1.5 11.5899 1.5 8C1.5 4.41015 4.41015 1.5 8 1.5C11.5899 1.5 14.5 4.41015 14.5 8Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Ajouter1 = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M7.05882 14.5882C7.05882 15.108 7.4802 15.5294 7.99999 15.5294C8.51979 15.5294 8.94117 15.108 8.94117 14.5882V8.94117H14.5882C15.108 8.94117 15.5294 8.51979 15.5294 7.99999C15.5294 7.4802 15.108 7.05882 14.5882 7.05882H8.94117V1.41176C8.94117 0.89196 8.51979 0.470581 7.99999 0.470581C7.4802 0.470581 7.05882 0.89196 7.05882 1.41176V7.05882H1.41176C0.89196 7.05882 0.470581 7.4802 0.470581 7.99999C0.470581 8.51979 0.89196 8.94117 1.41176 8.94117H7.05882V14.5882Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Ajouter2 = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M4.90698 8C4.90698 7.73028 5.12563 7.51163 5.39535 7.51163H7.51163V5.39535C7.51163 5.12563 7.73028 4.90698 8 4.90698C8.26972 4.90698 8.48837 5.12563 8.48837 5.39535V7.51163H10.6047C10.8744 7.51163 11.093 7.73028 11.093 8C11.093 8.26972 10.8744 8.48837 10.6047 8.48837H8.48837V10.6047C8.48837 10.8744 8.26972 11.093 8 11.093C7.73028 11.093 7.51163 10.8744 7.51163 10.6047V8.48837H5.39535C5.12563 8.48837 4.90698 8.26972 4.90698 8Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1 8C1 4.14888 4.14888 1 8 1C11.8511 1 15 4.14888 15 8C15 11.8511 11.8511 15 8 15C4.14888 15 1 11.8511 1 8ZM8 1.97674C4.68833 1.97674 1.97674 4.68833 1.97674 8C1.97674 11.3117 4.68833 14.0233 8 14.0233C11.3117 14.0233 14.0233 11.3117 14.0233 8C14.0233 4.68833 11.3117 1.97674 8 1.97674Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Ajouter = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M9.05882 3.05882C9.05882 2.47405 8.58477 2 8 2C7.41523 2 6.94118 2.47405 6.94118 3.05882V6.94118H3.05882C2.47405 6.94118 2 7.41523 2 8C2 8.58477 2.47405 9.05882 3.05882 9.05882H6.94118V12.9412C6.94118 13.5259 7.41523 14 8 14C8.58477 14 9.05882 13.5259 9.05882 12.9412V9.05882H12.9412C13.5259 9.05882 14 8.58477 14 8C14 7.41523 13.5259 6.94118 12.9412 6.94118H9.05882V3.05882Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Ajuster = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M7.53333 13.5C7.53333 13.7761 7.74227 14 8 14C8.25773 14 8.46667 13.7761 8.46667 13.5V2.5C8.46667 2.22386 8.25773 2 8 2C7.74227 2 7.53333 2.22386 7.53333 2.5V13.5Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M1.1317 7.65186L1.13668 7.64645L3.00335 5.64645C3.09023 5.55336 3.20788 5.50074 3.33075 5.50001L3.33333 5.5C3.45501 5.5 3.57214 5.5512 3.65929 5.64218L3.66332 5.64645C3.75083 5.74021 3.8 5.86739 3.8 6C3.8 6.13261 3.75066 6.25997 3.66314 6.35374L2.5933 7.5H6.13333C6.39107 7.5 6.6 7.72386 6.6 8C6.6 8.27614 6.39107 8.5 6.13333 8.5H2.5933L3.66332 9.64645C3.75083 9.74021 3.8 9.86739 3.8 10C3.8 10.1326 3.75083 10.2598 3.66332 10.3536C3.5817 10.441 3.47274 10.4929 3.35748 10.4993C3.34944 10.4998 3.34139 10.5 3.33333 10.5C3.20957 10.5 3.09087 10.4473 3.00335 10.3536L1.13668 8.35355L1.13369 8.35032C1.051 8.2601 1 8.13643 1 8C1 7.86466 1.05018 7.74189 1.1317 7.65186Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M14.8722 8.34373L14.8677 8.34878L14.8633 8.35355L12.9967 10.3536C12.9091 10.4473 12.7904 10.5 12.6667 10.5C12.5429 10.5 12.4242 10.4473 12.3367 10.3536C12.2546 10.2657 12.2061 10.1482 12.2005 10.024C12.2002 10.016 12.2 10.008 12.2 10C12.2 9.86739 12.2493 9.74003 12.3369 9.64626L13.4067 8.5H9.86667C9.60893 8.5 9.4 8.27614 9.4 8C9.4 7.72386 9.60893 7.5 9.86667 7.5H13.4067L12.3367 6.35355C12.2492 6.25978 12.2 6.13261 12.2 6C12.2 5.86739 12.2492 5.74021 12.3367 5.64645C12.4242 5.55268 12.5429 5.5 12.6667 5.5C12.7904 5.5 12.9091 5.55268 12.9967 5.64645L14.8633 7.64645C14.9508 7.74021 15 7.86739 15 8L14.8722 8.34373Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Alertes = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M6.03985 1.21585C6.15808 1.42245 6.08823 1.68683 5.88385 1.80634C5.00523 2.32013 4.2867 3.08297 3.82297 3.99891C3.7154 4.21138 3.4578 4.29547 3.24762 4.18673C3.03743 4.07798 2.95424 3.81758 3.06182 3.60511C3.60073 2.54067 4.43509 1.65497 5.4557 1.05815C5.66009 0.938638 5.92162 1.00924 6.03985 1.21585Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.8618 5.9903C11.8618 4.33556 10.8274 2.91451 9.37957 2.35492C9.11342 1.86893 8.6011 1.5417 8.0141 1.5417C7.42793 1.5417 6.91623 1.86801 6.64976 2.35288C5.19901 2.91018 4.16632 4.32976 4.16632 5.9903V7.65562C4.16632 7.7793 4.13863 7.96026 4.0857 8.153C4.03294 8.34516 3.96456 8.51454 3.90214 8.62063L3.9017 8.62137L3.24712 9.72036C2.98432 10.1619 2.92941 10.6574 3.09062 11.0974C3.25163 11.537 3.61176 11.8767 4.09196 12.041L4.09355 12.0416C4.71409 12.2511 5.34659 12.4096 5.98521 12.517C6.09178 12.841 6.27178 13.1323 6.50331 13.3663C6.88778 13.755 7.42839 14 8.01409 14C8.95717 14 9.76167 13.376 10.0439 12.5159C10.68 12.4085 11.3101 12.2505 11.9282 12.0418C12.8792 11.7235 13.2918 10.5906 12.7756 9.72093L12.122 8.62354C12.061 8.51559 11.994 8.34558 11.9421 8.15429C11.8895 7.96065 11.8618 7.77943 11.8618 7.65562V5.9903ZM5.02137 5.9903C5.02137 4.63978 5.90043 3.49368 7.11075 3.10575C7.53299 2.98646 7.98778 2.9528 8.46841 3.01353L8.46999 3.01373C8.60992 3.03087 8.74824 3.05939 8.88539 3.09682C10.1094 3.4766 11.0067 4.63339 11.0067 5.9903V7.65562C11.0067 7.88332 11.0531 8.1458 11.1174 8.3829C11.1819 8.62047 11.2737 8.86677 11.3832 9.05864L11.3872 9.06559L12.0424 10.1656C12.2783 10.5634 12.0872 11.0783 11.6592 11.2213L11.6579 11.2218C9.28927 12.0217 6.73402 12.0218 4.36533 11.222C4.10495 11.1327 3.95513 10.9684 3.89246 10.7973C3.82994 10.6266 3.83779 10.4046 3.97965 10.1662L4.63519 9.06559L4.63615 9.06397C4.75032 8.87037 4.84421 8.62233 4.9096 8.38419C4.97496 8.1462 5.02137 7.88345 5.02137 7.65562V5.9903ZM9.01656 12.6447C8.34913 12.6998 7.67843 12.7 7.01097 12.6451C7.04127 12.6838 7.07365 12.7205 7.10792 12.7551C7.33908 12.9888 7.66493 13.1356 8.01409 13.1356C8.41828 13.1356 8.78088 12.9432 9.01656 12.6447Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M10.0687 1.80634C9.86436 1.68683 9.79452 1.42245 9.91275 1.21585C10.031 1.00924 10.2925 0.938638 10.4969 1.05815C11.5175 1.65497 12.3519 2.54067 12.8908 3.60511C12.9984 3.81758 12.9152 4.07798 12.705 4.18673C12.4948 4.29547 12.2372 4.21138 12.1296 3.99891C11.6659 3.08297 10.9474 2.32013 10.0687 1.80634Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Ampoule = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.92232 9.60227C5.08883 9.72861 5.18214 9.91173 5.18214 9.91173C5.27572 10.0954 5.27718 10.2999 5.27718 10.2999L5.27717 10.625C5.27717 10.9875 5.54396 11.2437 5.54396 11.2437C5.81074 11.5 6.18804 11.5 6.18804 11.5H8.00666L8.00978 11.5L8.01289 11.5H9.83151C10.2088 11.5 10.4756 11.2437 10.4756 11.2437C10.7424 10.9875 10.7424 10.625 10.7424 10.625V10.2969C10.7428 10.0925 10.8372 9.90826 10.8372 9.90826C10.9315 9.72407 11.1006 9.59852 11.1006 9.59852C12.3762 8.63642 12.8239 7.14246 12.8239 7.14246C13.2715 5.64849 12.7247 4.1853 12.7247 4.1853C12.1779 2.72211 10.8433 1.84274 10.8433 1.84274C9.50872 0.963377 7.89082 1.00022 7.89082 1.00022C6.88923 1.02239 5.97658 1.41558 5.97658 1.41558C5.09674 1.79463 4.42068 2.46476 4.42068 2.46476C3.74518 3.13432 3.3769 3.99155 3.3769 3.99155C2.99539 4.8796 3 5.84192 3 5.84192C3.00376 6.94486 3.51024 7.93535 3.51024 7.93535C4.01636 8.92514 4.92232 9.60227 4.92232 9.60227ZM8.46521 10.625H9.83151V10.2969C9.83151 10.2969 9.83233 9.88801 10.0199 9.5219C10.0199 9.5219 10.2075 9.15578 10.5436 8.90623C10.5436 8.90623 11.5823 8.12277 11.9485 6.90044C11.9485 6.90044 12.3148 5.6781 11.8674 4.48094C11.8674 4.48094 11.42 3.28379 10.3281 2.5643C10.3281 2.5643 9.23615 1.84482 7.9124 1.87497C7.9124 1.87497 7.09412 1.89308 6.34932 2.21395C6.34932 2.21395 5.6291 2.52424 5.07478 3.07369C5.07478 3.07369 4.52064 3.62296 4.21889 4.32535C4.21889 4.32535 3.90709 5.05112 3.91086 5.83789C3.91086 5.83789 3.91394 6.74021 4.3278 7.54958C4.3278 7.54958 4.74166 8.35895 5.48272 8.91247L5.48507 8.91423C5.48507 8.91423 5.81545 9.16436 6.00026 9.52705C6.00026 9.52705 6.18515 9.88992 6.18803 10.2939L6.18804 10.625H7.55434V8.18127L5.866 6.55942C5.78059 6.47738 5.73261 6.3661 5.73261 6.25007C5.73261 6.13404 5.78059 6.02276 5.866 5.94071C5.95141 5.85866 6.06725 5.81257 6.18804 5.81257C6.30883 5.81257 6.42467 5.85866 6.51008 5.94071L8.00978 7.38134L9.50947 5.94071C9.59488 5.85866 9.71073 5.81257 9.83151 5.81257C9.9523 5.81257 10.0681 5.85866 10.1536 5.94071C10.239 6.02276 10.2869 6.13404 10.2869 6.25007C10.2869 6.3661 10.2388 6.47754 10.1534 6.55959L8.46521 8.18127V10.625Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M10.7424 12.8125C10.7424 13.0541 10.5385 13.25 10.2869 13.25H5.73261C5.48108 13.25 5.27717 13.0541 5.27717 12.8125C5.27717 12.5709 5.48108 12.375 5.73261 12.375H10.2869C10.5385 12.375 10.7424 12.5709 10.7424 12.8125Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M6.64347 14.125C6.39194 14.125 6.18804 14.3209 6.18804 14.5625C6.18804 14.8041 6.39194 15 6.64347 15H9.37608C9.62761 15 9.83151 14.8041 9.83151 14.5625C9.83151 14.3209 9.62761 14.125 9.37608 14.125H6.64347Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Ankr = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M8.22157 0.885036C8.08191 0.815991 7.91805 0.815991 7.77839 0.885036L1.84506 3.81837C1.67456 3.90266 1.56665 4.07639 1.56665 4.26659V6.53325C1.56665 6.80939 1.79051 7.03325 2.06665 7.03325C2.34279 7.03325 2.56665 6.80939 2.56665 6.53325V4.57716L7.99998 1.89102L13.4333 4.57716V6.53325C13.4333 6.80939 13.6572 7.03325 13.9333 7.03325C14.2095 7.03325 14.4333 6.80939 14.4333 6.53325V4.26659C14.4333 4.07639 14.3254 3.90266 14.1549 3.81837L8.22157 0.885036Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2.56665 9.46655C2.56665 9.19041 2.34279 8.96655 2.06665 8.96655C1.79051 8.96655 1.56665 9.19041 1.56665 9.46655V11.7332C1.56665 11.9234 1.67456 12.0971 1.84506 12.1814L7.77052 15.1109C7.82602 15.1396 7.8876 15.1582 7.95281 15.1643C7.98416 15.1673 8.01572 15.1673 8.04706 15.1643C8.11224 15.1582 8.17379 15.1396 8.22927 15.111L14.1549 12.1814C14.3254 12.0971 14.4333 11.9234 14.4333 11.7332V9.46655C14.4333 9.19041 14.2095 8.96655 13.9333 8.96655C13.6572 8.96655 13.4333 9.19041 13.4333 9.46655V11.4226L8.49998 13.8616V11.3972C10.1592 11.1551 11.4333 9.72633 11.4333 7.99998C11.4333 6.10381 9.89616 4.56665 7.99998 4.56665C6.10381 4.56665 4.56665 6.10381 4.56665 7.99998C4.56665 9.72633 5.84079 11.1551 7.49998 11.3972V13.8616L2.56665 11.4226V9.46655ZM8.01046 10.4333C8.00697 10.4332 8.00348 10.4332 7.99998 10.4332C7.99648 10.4332 7.99299 10.4332 7.9895 10.4333C6.65043 10.4276 5.56665 9.34038 5.56665 7.99998C5.56665 6.65609 6.65609 5.56665 7.99998 5.56665C9.34388 5.56665 10.4333 6.65609 10.4333 7.99998C10.4333 9.34038 9.34953 10.4277 8.01046 10.4333Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Assurance = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M7.57217 1.43572C7.54324 1.42103 7.50926 1.42096 7.48027 1.43554L2.4731 3.95253C2.43759 3.97038 2.41509 4.00734 2.41509 4.04781V8.5266C2.41509 8.52916 2.41517 8.53089 2.41517 8.53089C2.44226 8.76288 2.94865 12.5408 7.48196 14.5668C7.50841 14.5787 7.53882 14.5778 7.56233 14.5664C7.77961 14.4613 7.98758 14.3519 8.18663 14.239C8.28688 14.1821 8.41321 14.2192 8.46879 14.3217C8.52437 14.4243 8.48815 14.5535 8.38791 14.6104C8.18105 14.7277 7.96516 14.8412 7.73988 14.9503C7.60535 15.0154 7.44954 15.0158 7.31578 14.956C2.58826 12.8431 2.03827 8.88349 2.00307 8.58205C2.00062 8.56113 2 8.54297 2 8.5266V4.04781C2 3.84543 2.11249 3.66065 2.29005 3.5714L7.29721 1.05441C7.44218 0.981535 7.61204 0.981883 7.75672 1.05535L12.7118 3.57146C12.8883 3.6611 13 3.84531 13 4.04693V7.43522C13 7.55249 12.9071 7.64755 12.7925 7.64755C12.6778 7.64755 12.5849 7.55249 12.5849 7.43522V4.04693C12.5849 4.0066 12.5626 3.96976 12.5273 3.95183L7.57217 1.43572Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M7.42947 2.78516C7.48729 2.75622 7.55496 2.75636 7.61266 2.78554L11.4575 4.72974C11.5283 4.76554 11.5731 4.83931 11.5731 4.92009V7.38618C11.5731 7.50345 11.666 7.59851 11.7807 7.59851C11.8953 7.59851 11.9882 7.50345 11.9882 7.38618V4.92009C11.9882 4.67777 11.8538 4.45643 11.6415 4.34905L7.79659 2.40485C7.62349 2.31731 7.42048 2.3169 7.24703 2.40372L3.36077 4.34911C3.1472 4.45602 3.01179 4.67803 3.01179 4.92127V8.41511C3.01179 8.43431 3.01239 8.45562 3.01555 8.48132C3.05255 8.78257 3.52434 11.9091 7.26838 13.6099C7.42911 13.6829 7.616 13.6818 7.7765 13.6029C7.82849 13.5773 7.87985 13.5515 7.9306 13.5253C8.03298 13.4726 8.07419 13.3449 8.02264 13.2402C7.9711 13.1354 7.84631 13.0933 7.74393 13.146C7.69546 13.171 7.64637 13.1957 7.59667 13.2201C7.54787 13.2441 7.48835 13.2452 7.43684 13.2218C3.8828 11.6073 3.45572 8.65894 3.4274 8.42837L3.42705 8.42425C3.42705 8.42425 3.42689 8.41999 3.42689 8.41511V4.92127C3.42689 4.84019 3.47202 4.76618 3.54321 4.73055L7.42947 2.78516Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M8.2465 10.7038C8.2465 9.55715 9.15511 8.62761 10.2759 8.62761C10.6943 8.62761 11.0825 8.75686 11.4052 8.97842C11.5169 9.05509 11.6682 9.02462 11.7431 8.91036C11.818 8.7961 11.7883 8.64133 11.6766 8.56465C11.2761 8.28972 10.794 8.12933 10.2759 8.12933C8.88611 8.12933 7.75943 9.28196 7.75943 10.7038C7.75943 12.1256 8.88611 13.2783 10.2759 13.2783C11.6658 13.2783 12.7925 12.1256 12.7925 10.7038C12.7925 10.3803 12.734 10.0702 12.6271 9.78432C12.5791 9.65581 12.4383 9.59147 12.3127 9.64062C12.187 9.68978 12.1242 9.83381 12.1722 9.96233C12.2582 10.1923 12.3054 10.4421 12.3054 10.7038C12.3054 11.8504 11.3968 12.78 10.2759 12.78C9.15511 12.78 8.2465 11.8504 8.2465 10.7038Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M12.7314 8.87562C12.8205 8.7725 12.811 8.61505 12.7102 8.52395C12.6094 8.43285 12.4555 8.44259 12.3664 8.54571L10.1339 11.1309L9.46416 10.5181C9.36391 10.4264 9.20995 10.4351 9.12029 10.5377C9.03062 10.6403 9.03921 10.7978 9.13946 10.8895L9.99182 11.6694C10.0402 11.7137 10.1037 11.7363 10.1685 11.7324C10.2332 11.7285 10.2938 11.6984 10.3367 11.6487L12.7314 8.87562Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Attention = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M7.49135 7.63265C7.49135 7.36215 7.71908 7.14286 8 7.14286C8.28092 7.14286 8.50864 7.36215 8.50864 7.63265V9.59184C8.50864 9.86234 8.28092 10.0816 8 10.0816C7.71908 10.0816 7.49135 9.86234 7.49135 9.59184V7.63265Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M8 12.0408C8.28092 12.0408 8.50864 11.8215 8.50864 11.551C8.50864 11.2805 8.28092 11.0612 8 11.0612C7.71908 11.0612 7.49135 11.2805 7.49135 11.551C7.49135 11.8215 7.71908 12.0408 8 12.0408Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.89875 2.61224C7.3882 1.79592 8.6118 1.79592 9.10125 2.61225L14.8277 12.1633C15.3172 12.9796 14.7054 14 13.7265 14H2.27351C1.29462 14 0.682818 12.9796 1.17226 12.1633L6.89875 2.61224ZM8 3.71429L2.71401 12.5306H13.286L8 3.71429Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Augur = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M7.21943 3.77631C7.30413 3.60692 7.47726 3.49992 7.66665 3.49992H8.33331C8.5227 3.49992 8.69583 3.60692 8.78053 3.77631L10.4472 7.10964C10.5707 7.35663 10.4706 7.65697 10.2236 7.78047C9.9766 7.90396 9.67626 7.80385 9.55277 7.55686L8.0243 4.49992H7.97566L6.44719 7.55686C6.3237 7.80385 6.02336 7.90396 5.77637 7.78047C5.52938 7.65697 5.42927 7.35663 5.55277 7.10964L7.21943 3.77631Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M5.78053 8.89019C5.90402 8.6432 5.80391 8.34287 5.55692 8.21937C5.30993 8.09588 5.00959 8.19599 4.8861 8.44298L4.21943 9.77631C4.10259 10.01 4.18536 10.2942 4.4094 10.4287L7.74273 12.4287C7.90107 12.5237 8.09889 12.5237 8.25723 12.4287L11.5906 10.4287C11.8146 10.2942 11.8974 10.01 11.7805 9.77631L11.1139 8.44298C10.9904 8.19599 10.69 8.09588 10.443 8.21937C10.196 8.34287 10.0959 8.6432 10.2194 8.89019L10.679 9.80939L7.99998 11.4168L5.32093 9.80939L5.78053 8.89019Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0.833313 7.99992C0.833313 4.04188 4.04194 0.833252 7.99998 0.833252C11.958 0.833252 15.1666 4.04188 15.1666 7.99992C15.1666 11.958 11.958 15.1666 7.99998 15.1666C4.04194 15.1666 0.833313 11.958 0.833313 7.99992ZM7.99998 1.83325C4.59422 1.83325 1.83331 4.59416 1.83331 7.99992C1.83331 11.4057 4.59422 14.1666 7.99998 14.1666C11.4057 14.1666 14.1666 11.4057 14.1666 7.99992C14.1666 4.59416 11.4057 1.83325 7.99998 1.83325Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Authentification1 = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M7.99516 1C8.38509 1 8.79741 1.05481 9.13558 1.17989L9.13933 1.18129L12.3578 2.40449C12.8325 2.58453 13.2384 2.94658 13.5237 3.36486C13.8091 3.78323 14 4.2962 14 4.81014V8.53513C13.7181 8.37205 13.4144 8.2424 13.0944 8.15157V4.81014C13.0944 4.51946 12.9822 4.18529 12.779 3.88735C12.5757 3.58935 12.3073 3.36583 12.0402 3.26456L8.82356 2.04204C8.61354 1.96471 8.31388 1.91839 7.99516 1.91839C7.67531 1.91839 7.38004 1.96504 7.17854 2.04124L3.96052 3.27082L3.95946 3.27122C3.69235 3.37251 3.42411 3.59602 3.22075 3.89348C3.01733 4.19102 2.90556 4.52342 2.90556 4.81014V9.67057C2.90556 9.96533 3.00484 10.3406 3.18543 10.7047C3.36594 11.0686 3.60457 11.3748 3.83973 11.5531L6.61436 13.6537C6.97681 13.93 7.47779 14.0816 8 14.0816C8.18763 14.0816 8.37251 14.062 8.54922 14.0242C8.71679 14.3092 8.91869 14.5717 9.14922 14.8059C8.78086 14.9369 8.387 15 8 15C7.31956 15 6.61714 14.8045 6.07021 14.3878L3.29762 12.2887C2.92 12.0025 2.60069 11.5695 2.37645 11.1174C2.15228 10.6654 2 10.1477 2 9.67057V4.81014C2 4.29878 2.19139 3.78731 2.47658 3.37018C2.76171 2.95313 3.16788 2.59107 3.64231 2.411L6.85993 1.18158L6.86114 1.18112C7.195 1.05466 7.60578 1 7.99516 1Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M8.75705 3.12849C8.53161 3.03915 8.25673 3 7.99677 3C7.73719 3 7.46333 3.03904 7.24076 3.12937L5.09487 4.00786C4.77858 4.13648 4.50781 4.39509 4.31772 4.69299C4.1276 4.99094 4 5.35627 4 5.72153V9.19326C4 9.53408 4.10152 9.90386 4.25096 10.2267C4.40046 10.5496 4.61333 10.8589 4.86508 11.0634L6.71347 12.5627C7.07809 12.8603 7.54637 13 8 13C8.04162 13 8.08335 12.9988 8.12511 12.9965C8.07094 12.7852 8.0336 12.5672 8.01458 12.3439L8 12.344C7.65186 12.344 7.31787 12.2357 7.07624 12.0384L5.22649 10.5379C5.06972 10.4106 4.91062 10.1919 4.79028 9.93191C4.66989 9.67184 4.60371 9.40381 4.60371 9.19326V5.72153C4.60371 5.51673 4.67822 5.2793 4.81383 5.06677C4.94941 4.8543 5.12823 4.69465 5.30631 4.6223L7.45236 3.74374C7.58669 3.68931 7.78354 3.65599 7.99677 3.65599C8.20925 3.65599 8.40902 3.68908 8.54904 3.74431L10.6935 4.61754C10.8715 4.68988 11.0505 4.84954 11.186 5.06239C11.3215 5.27521 11.3963 5.5139 11.3963 5.72153V8.04526C11.5932 8.01545 11.7948 8 12 8V5.72153C12 5.35443 11.8727 4.98802 11.6825 4.68919C11.4923 4.39041 11.2217 4.1318 10.9052 4.00321L8.75955 3.1295L8.75705 3.12849Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M12 9.58065C10.6638 9.58065 9.58064 10.6638 9.58064 12C9.58064 13.3362 10.6638 14.4194 12 14.4194C13.3362 14.4194 14.4194 13.3362 14.4194 12C14.4194 11.695 14.3631 11.4039 14.2606 11.136C14.2033 10.9862 14.2783 10.8184 14.428 10.7611C14.5778 10.7038 14.7456 10.7788 14.8029 10.9285C14.9303 11.2617 15 11.623 15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C12.6175 9 13.1923 9.1869 13.6697 9.50728C13.8029 9.59662 13.8384 9.77698 13.749 9.91013C13.6597 10.0433 13.4793 10.0788 13.3462 9.98943C12.9615 9.73126 12.4988 9.58065 12 9.58065Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M14.9019 9.45984C15.0221 9.566 15.0334 9.74948 14.9272 9.86964L12.0724 13.1011C12.0212 13.159 11.9491 13.1941 11.8719 13.1987C11.7947 13.2032 11.7189 13.1768 11.6613 13.1252L10.6452 12.2164C10.5257 12.1095 10.5154 11.926 10.6223 11.8065C10.7292 11.6869 10.9127 11.6767 11.0323 11.7836L11.8307 12.4977L14.4921 9.4852C14.5983 9.36504 14.7817 9.35368 14.9019 9.45984Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.45 6.21501C9.45 6.88604 8.91274 7.43001 8.25 7.43001C7.58726 7.43001 7.05 6.88604 7.05 6.21501C7.05 5.54398 7.58726 5 8.25 5C8.91274 5 9.45 5.54398 9.45 6.21501ZM8.95 6.21501C8.95 6.60644 8.6366 6.92376 8.25 6.92376C7.8634 6.92376 7.55 6.60644 7.55 6.21501C7.55 5.82357 7.8634 5.50625 8.25 5.50625C8.6366 5.50625 8.95 5.82357 8.95 6.21501Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M9.40718 7.36487C9.29613 7.31438 9.16531 7.35221 9.09735 7.45447C8.94719 7.68041 8.63492 7.85624 8.25 7.85624C7.86508 7.85624 7.55281 7.68041 7.40265 7.45447C7.33469 7.35221 7.20387 7.31438 7.09282 7.36487C6.44911 7.65755 6 8.31258 6 9.07437V9.34187C6 9.70535 6.29102 10 6.65 10H8.53513C8.63802 9.82214 8.75421 9.65293 8.88234 9.49375H6.65C6.56716 9.49375 6.5 9.42575 6.5 9.34187V9.07437C6.5 8.58667 6.75228 8.1582 7.13263 7.91617C7.40433 8.1957 7.81121 8.36249 8.25 8.36249C8.68879 8.36249 9.09566 8.1957 9.36736 7.91616C9.61404 8.07313 9.80684 8.30851 9.9119 8.58761C10.0547 8.50004 10.2034 8.42119 10.3573 8.35178C10.1759 7.91301 9.83442 7.55913 9.40718 7.36487Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Authentification = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M7.57217 1.43572C7.54324 1.42103 7.50926 1.42096 7.48027 1.43554L2.4731 3.95253C2.43759 3.97038 2.41509 4.00734 2.41509 4.04781V8.5266C2.41509 8.52916 2.41517 8.53089 2.41517 8.53089C2.44226 8.76288 2.94865 12.5408 7.48196 14.5668C7.50841 14.5787 7.53882 14.5778 7.56233 14.5664C7.77961 14.4613 7.98758 14.3519 8.18663 14.239C8.28688 14.1821 8.41321 14.2192 8.46879 14.3217C8.52437 14.4243 8.48815 14.5535 8.38791 14.6104C8.18105 14.7277 7.96516 14.8412 7.73988 14.9503C7.60535 15.0154 7.44954 15.0158 7.31578 14.956C2.58826 12.8431 2.03827 8.88349 2.00307 8.58205C2.00062 8.56113 2 8.54297 2 8.5266V4.04781C2 3.84543 2.11249 3.66065 2.29005 3.5714L7.29721 1.05441C7.44218 0.981535 7.61204 0.981883 7.75672 1.05535L12.7118 3.57146C12.8883 3.6611 13 3.84531 13 4.04693V7.43522C13 7.55249 12.9071 7.64755 12.7925 7.64755C12.6778 7.64755 12.5849 7.55249 12.5849 7.43522V4.04693C12.5849 4.0066 12.5626 3.96976 12.5273 3.95183L7.57217 1.43572Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M8.62137 6.89578L8.76445 6.97436C8.87322 7.03409 8.9773 7.10154 9.07599 7.17598C9.16825 7.24556 9.1879 7.37849 9.11989 7.47288C9.05186 7.56726 8.92193 7.58737 8.82967 7.51778C8.78771 7.48614 8.74461 7.456 8.70043 7.42746C8.36893 7.73975 7.92573 7.9308 7.43914 7.9308C6.99583 7.9308 6.58841 7.77219 6.26874 7.50774C5.72532 7.91105 5.37264 8.56504 5.37264 9.30297V9.74506C5.37264 10.0252 5.59489 10.2526 5.86951 10.2526H6.85749C6.97211 10.2526 7.06503 10.3477 7.06503 10.4649C7.06503 10.5822 6.97211 10.6773 6.85749 10.6773H5.86951C5.36606 10.6773 4.95755 10.2601 4.95755 9.74506V9.30297C4.95755 8.35613 5.44504 7.52592 6.17637 7.05979L6.31424 6.97191L6.43075 7.08772C6.69145 7.34686 7.04686 7.50615 7.43914 7.50615C7.86493 7.50615 8.24747 7.31842 8.51241 7.01896L8.62137 6.89578Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M7.42947 2.78516C7.48729 2.75622 7.55496 2.75636 7.61266 2.78554L11.4575 4.72974C11.5283 4.76554 11.5731 4.83931 11.5731 4.92009V7.38618C11.5731 7.50345 11.666 7.59851 11.7807 7.59851C11.8953 7.59851 11.9882 7.50345 11.9882 7.38618V4.92009C11.9882 4.67777 11.8538 4.45643 11.6415 4.34905L7.79659 2.40485C7.62349 2.31731 7.42048 2.3169 7.24703 2.40372L3.36077 4.34911C3.1472 4.45602 3.01179 4.67803 3.01179 4.92127V8.41511C3.01179 8.43431 3.01239 8.45562 3.01555 8.48132C3.05255 8.78257 3.52434 11.9091 7.26838 13.6099C7.42911 13.6829 7.616 13.6818 7.7765 13.6029C7.82849 13.5773 7.87985 13.5515 7.9306 13.5253C8.03298 13.4726 8.07419 13.3449 8.02264 13.2402C7.9711 13.1354 7.84631 13.0933 7.74393 13.146C7.69546 13.171 7.64637 13.1957 7.59667 13.2201C7.54787 13.2441 7.48835 13.2452 7.43684 13.2218C3.8828 11.6073 3.45572 8.65894 3.4274 8.42837L3.42705 8.42425C3.42705 8.42425 3.42689 8.41999 3.42689 8.41511V4.92127C3.42689 4.84019 3.47202 4.76618 3.54321 4.73055L7.42947 2.78516Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M8.2465 10.7038C8.2465 9.55715 9.15511 8.62761 10.2759 8.62761C10.6943 8.62761 11.0825 8.75686 11.4052 8.97842C11.5169 9.05509 11.6682 9.02462 11.7431 8.91036C11.818 8.7961 11.7883 8.64133 11.6766 8.56465C11.2761 8.28972 10.794 8.12933 10.2759 8.12933C8.88611 8.12933 7.75943 9.28196 7.75943 10.7038C7.75943 12.1256 8.88611 13.2783 10.2759 13.2783C11.6658 13.2783 12.7925 12.1256 12.7925 10.7038C12.7925 10.3803 12.734 10.0702 12.6271 9.78432C12.5791 9.65581 12.4383 9.59147 12.3127 9.64062C12.187 9.68978 12.1242 9.83381 12.1722 9.96233C12.2582 10.1923 12.3054 10.4421 12.3054 10.7038C12.3054 11.8504 11.3968 12.78 10.2759 12.78C9.15511 12.78 8.2465 11.8504 8.2465 10.7038Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M12.7314 8.87562C12.8205 8.7725 12.811 8.61505 12.7102 8.52395C12.6094 8.43285 12.4555 8.44259 12.3664 8.54571L10.1339 11.1309L9.46416 10.5181C9.36391 10.4264 9.20995 10.4351 9.12029 10.5377C9.03062 10.6403 9.03921 10.7978 9.13946 10.8895L9.99182 11.6694C10.0402 11.7137 10.1037 11.7363 10.1685 11.7324C10.2332 11.7285 10.2938 11.6984 10.3367 11.6487L12.7314 8.87562Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.95283 5.31599C8.95283 6.13685 8.30238 6.80228 7.5 6.80228C6.69762 6.80228 6.04717 6.13685 6.04717 5.31599C6.04717 4.49513 6.69762 3.8297 7.5 3.8297C8.30238 3.8297 8.95283 4.49513 8.95283 5.31599ZM8.53774 5.31599C8.53774 5.90232 8.07313 6.37763 7.5 6.37763C6.92687 6.37763 6.46226 5.90232 6.46226 5.31599C6.46226 4.72967 6.92687 4.25435 7.5 4.25435C8.07313 4.25435 8.53774 4.72967 8.53774 5.31599Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M12.7314 8.87562C12.8205 8.7725 12.8109 8.61505 12.7101 8.52395C12.6094 8.43285 12.4554 8.44259 12.3664 8.54571L10.1339 11.1309L9.46415 10.5181C9.3639 10.4264 9.20994 10.4352 9.12028 10.5377C9.03061 10.6403 9.0392 10.7978 9.13945 10.8895L9.99181 11.6694C10.0401 11.7137 10.1037 11.7363 10.1685 11.7324C10.2332 11.7285 10.2937 11.6984 10.3367 11.6487L12.7314 8.87562Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Autonio = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.42513 3.67001C8.33399 3.52278 8.17315 3.43319 8 3.43319C7.82684 3.43319 7.66601 3.52278 7.57486 3.67001L5.84153 6.47001C5.74606 6.62423 5.7416 6.81806 5.82986 6.97651C5.91813 7.13496 6.08528 7.23319 6.26666 7.23319H9.73333C9.91471 7.23319 10.0819 7.13496 10.1701 6.97651C10.2584 6.81806 10.2539 6.62423 10.1585 6.47001L8.42513 3.67001ZM8 4.88312L8.83575 6.23319H7.16424L8 4.88312Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.73768 7.43321C5.91238 7.43473 6.07362 7.52732 6.16297 7.67744L7.82964 10.4774C7.92162 10.632 7.92353 10.824 7.83466 10.9803C7.74579 11.1366 7.57982 11.2332 7.39999 11.2332H3.99999C3.81862 11.2332 3.65146 11.135 3.56319 10.9765C3.47493 10.8181 3.47939 10.6242 3.57486 10.47L5.3082 7.67001C5.40015 7.52146 5.56298 7.43169 5.73768 7.43321ZM4.89757 10.2332H6.5205L5.72495 8.89665L4.89757 10.2332Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.6918 7.67001C10.5998 7.52146 10.437 7.43169 10.2623 7.43321C10.0876 7.43473 9.92638 7.52732 9.83702 7.67744L8.17035 10.4774C8.07837 10.632 8.07646 10.824 8.16533 10.9803C8.2542 11.1366 8.42017 11.2332 8.6 11.2332H12C12.1814 11.2332 12.3485 11.135 12.4368 10.9765C12.5251 10.8181 12.5206 10.6242 12.4251 10.47L10.6918 7.67001ZM9.47949 10.2332L10.275 8.89665L11.1024 10.2332H9.47949Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.99999 0.833252C4.04195 0.833252 0.833328 4.04188 0.833328 7.99992C0.833328 11.958 4.04195 15.1666 7.99999 15.1666C11.958 15.1666 15.1667 11.958 15.1667 7.99992C15.1667 4.04188 11.958 0.833252 7.99999 0.833252ZM1.83333 7.99992C1.83333 4.59416 4.59424 1.83325 7.99999 1.83325C11.4058 1.83325 14.1667 4.59416 14.1667 7.99992C14.1667 11.4057 11.4058 14.1666 7.99999 14.1666C4.59424 14.1666 1.83333 11.4057 1.83333 7.99992Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Avalanche = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.74001 3.70878C8.40506 3.22568 7.71212 3.23025 7.38395 3.7225C7.37841 3.73081 7.37312 3.73929 7.36809 3.74792L3.64062 10.1379C3.48311 10.3857 3.47576 10.6861 3.59443 10.9235C3.65586 11.0463 3.76001 11.1685 3.91354 11.2432C4.04281 11.3061 4.18523 11.3242 4.32361 11.2999H6.19998C6.80284 11.2999 7.35122 10.9166 7.62641 10.461L9.82072 6.93675C10.2236 6.32511 10.0933 5.57174 9.74934 5.05584C9.74421 5.04814 9.73886 5.04059 9.73331 5.03319L8.74001 3.70878ZM8.08548 4.50274L4.70383 10.2999H6.19998C6.39542 10.2999 6.64565 10.1519 6.77123 9.94261L6.77547 9.93554L8.97553 6.40224C8.97827 6.39784 8.98108 6.39348 8.98395 6.38917C9.10715 6.20438 9.10541 5.90023 8.92416 5.62098L8.08548 4.50274Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.71729 7.9891C10.0485 7.49224 10.7514 7.49224 11.0827 7.9891C11.0875 7.99634 11.0921 8.00371 11.0966 8.01119L12.3579 10.1356C12.7041 10.6753 12.3161 11.3665 11.6666 11.3665H9.13331C8.48384 11.3665 8.09585 10.6753 8.44202 10.1356L9.70339 8.01119C9.70783 8.00371 9.71246 7.99634 9.71729 7.9891ZM10.4 8.79669L9.46793 10.3665H11.332L10.4 8.79669Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.99998 0.833252C4.04194 0.833252 0.833313 4.04188 0.833313 7.99992C0.833313 11.958 4.04194 15.1666 7.99998 15.1666C11.958 15.1666 15.1666 11.958 15.1666 7.99992C15.1666 4.04188 11.958 0.833252 7.99998 0.833252ZM1.83331 7.99992C1.83331 4.59416 4.59422 1.83325 7.99998 1.83325C11.4057 1.83325 14.1666 4.59416 14.1666 7.99992C14.1666 11.4057 11.4057 14.1666 7.99998 14.1666C4.59422 14.1666 1.83331 11.4057 1.83331 7.99992Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Baguette_magique = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M12.4617 7.5012V10.5997C12.4617 10.8849 12.689 11.1161 12.9694 11.1161C13.2497 11.1161 13.477 10.8849 13.477 10.5997V7.5012C13.477 7.21599 13.2497 6.98479 12.9694 6.98479C12.689 6.98479 12.4617 7.21599 12.4617 7.5012Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M11.4464 9.56687H14.4923C14.7727 9.56687 15 9.33567 15 9.05046C15 8.76525 14.7727 8.53404 14.4923 8.53404H11.4464C11.166 8.53404 10.9387 8.76525 10.9387 9.05046C10.9387 9.33567 11.166 9.56687 11.4464 9.56687Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M4.08536 1.82061V4.4027C4.08536 4.68791 4.31265 4.91912 4.59302 4.91912C4.87339 4.91912 5.10068 4.68791 5.10068 4.4027V1.82061C5.10068 1.5354 4.87339 1.30419 4.59302 1.30419C4.31265 1.30419 4.08536 1.5354 4.08536 1.82061Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M3.32387 3.62807H5.86216C6.14253 3.62807 6.36982 3.39686 6.36982 3.11166C6.36982 2.82645 6.14253 2.59524 5.86216 2.59524H3.32387C3.0435 2.59524 2.81622 2.82645 2.81622 3.11166C2.81622 3.39686 3.0435 3.62807 3.32387 3.62807Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M9.41577 11.1161V13.1818C9.41577 13.467 9.64305 13.6982 9.92342 13.6982C10.2038 13.6982 10.4311 13.467 10.4311 13.1818V11.1161C10.4311 10.8309 10.2038 10.5997 9.92342 10.5997C9.64305 10.5997 9.41577 10.8309 9.41577 11.1161Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M8.90811 12.6654H10.9387C11.2191 12.6654 11.4464 12.4342 11.4464 12.149C11.4464 11.8638 11.2191 11.6325 10.9387 11.6325H8.90811C8.62774 11.6325 8.40045 11.8638 8.40045 12.149C8.40045 12.4342 8.62774 12.6654 8.90811 12.6654Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1.29738 12.3624C1.29738 12.3624 1 12.0599 1 11.632C1 11.632 1 11.2042 1.29738 10.9017L10.7338 1.30251C10.7338 1.30251 11.0311 1 11.4517 1C11.4517 1 11.8722 1 12.1696 1.30251L13.4821 2.63763C13.4821 2.63763 13.7795 2.94015 13.7795 3.36796C13.7795 3.36796 13.7795 3.79577 13.4821 4.09828L4.04573 13.6975C4.04573 13.6975 3.74835 14 3.32779 14C3.32779 14 2.90723 14 2.60986 13.6975L1.29738 12.3624ZM2.01532 11.632L3.32779 12.9672L12.7642 3.36796L11.4517 2.03283L2.01532 11.632Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M10.072 6.83337C10.1672 6.93022 10.2964 6.98479 10.4311 6.98479C10.4398 6.98479 10.4486 6.98456 10.4573 6.9841C10.5827 6.97749 10.7013 6.92385 10.79 6.83353C10.8853 6.73668 10.9387 6.60533 10.9387 6.46837C10.9387 6.33141 10.8853 6.20005 10.79 6.10321L8.75942 4.03754C8.66421 3.94069 8.53509 3.88628 8.40045 3.88628C8.26581 3.88628 8.13669 3.94069 8.04148 4.03754C7.94628 4.13438 7.89279 4.26574 7.89279 4.4027C7.89279 4.53966 7.94628 4.67101 8.04148 4.76786L10.072 6.83337Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Banque = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8 4.14286C7.26585 4.14286 6.6 4.65217 6.6 5.35714C6.6 6.06211 7.26585 6.57143 8 6.57143C8.73415 6.57143 9.4 6.06211 9.4 5.35714C9.4 4.65217 8.73415 4.14286 8 4.14286ZM7.53333 5.35714C7.53333 5.19424 7.70321 5 8 5C8.29679 5 8.46667 5.19424 8.46667 5.35714C8.46667 5.52005 8.29679 5.71429 8 5.71429C7.70321 5.71429 7.53333 5.52005 7.53333 5.35714Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M13.1333 8H13.32C13.9294 8 14.3778 7.52323 14.3778 6.99423V5.07791C14.3778 4.87507 14.3018 4.68261 14.1966 4.53026C14.0921 4.37888 13.9324 4.22915 13.7214 4.14673L8.40135 2.06882C8.26618 2.01602 8.11904 2 8 2C7.88096 2 7.73382 2.01602 7.59865 2.06882L2.27865 4.14673C2.06764 4.22915 1.90787 4.37888 1.80337 4.53026C1.6982 4.68261 1.62222 4.87507 1.62222 5.07791V6.99423C1.62222 7.52323 2.0706 8 2.68 8H2.86667V11H2.68C2.103 11 1.62222 11.4276 1.62222 11.9643V13.1429H1.46667C1.20893 13.1429 1 13.3347 1 13.5714C1 13.8081 1.20893 14 1.46667 14H14.5333C14.7911 14 15 13.8081 15 13.5714C15 13.3347 14.7911 13.1429 14.5333 13.1429H14.3778V11.9643C14.3778 11.4276 13.897 11 13.32 11H13.1333V8ZM7.95642 2.86052L2.64518 4.93501C2.64518 4.93501 2.63902 4.93838 2.63058 4.94546C2.61875 4.95539 2.6048 4.97014 2.59164 4.9892C2.56234 5.03165 2.55556 5.06719 2.55556 5.07791V6.99423C2.55556 7.04215 2.57547 7.08189 2.60247 7.10826C2.6291 7.13427 2.65699 7.14286 2.68 7.14286H13.32C13.343 7.14286 13.3709 7.13427 13.3975 7.10826C13.4245 7.08189 13.4444 7.04215 13.4444 6.99423V5.07791C13.4444 5.06719 13.4377 5.03165 13.4084 4.9892C13.3952 4.97014 13.3813 4.95539 13.3694 4.94546C13.361 4.93837 13.3548 4.93501 13.3548 4.93501L8.04358 2.86052L8.0396 2.85985C8.03004 2.85837 8.01619 2.85714 8 2.85714C7.98381 2.85714 7.96996 2.85837 7.9604 2.85985L7.95642 2.86052ZM13.4444 11.9643V13.1429H2.55556V11.9643C2.55556 11.9117 2.60678 11.8571 2.68 11.8571H13.32C13.3932 11.8571 13.4444 11.9117 13.4444 11.9643ZM12.2 8H10.8V11H12.2V8ZM8.46667 8H9.86667V11H8.46667V8ZM7.53333 8H6.13333V11H7.53333V8ZM3.8 8H5.2V11H3.8V8Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Binance_coin = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.6322 1.14304C7.82269 0.95232 8.13155 0.95232 8.32204 1.14304L12.2244 5.05002C12.4149 5.24074 12.4149 5.54996 12.2244 5.74068L10.9236 7.04301C10.7331 7.23373 10.4243 7.23373 10.2338 7.04301L7.97712 4.78369L5.72047 7.04301C5.52997 7.23373 5.22112 7.23373 5.03062 7.04301L3.72983 5.74068C3.53934 5.54996 3.53934 5.24074 3.72983 5.05002L7.6322 1.14304ZM4.7646 5.39535L5.37554 6.00701L7.6322 3.74769C7.82269 3.55697 8.13155 3.55697 8.32204 3.74769L10.5787 6.00701L11.1896 5.39535L7.97712 2.17903L4.7646 5.39535Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.72047 8.95699L7.97712 11.2163L10.2338 8.95699C10.4243 8.76627 10.7331 8.76627 10.9236 8.95699L12.2244 10.2593C12.4149 10.45 12.4149 10.7593 12.2244 10.95L8.32204 14.857C8.13155 15.0477 7.82269 15.0477 7.6322 14.857L3.72983 10.95C3.53934 10.7593 3.53934 10.45 3.72983 10.2593L5.03062 8.95699C5.22112 8.76627 5.52997 8.76627 5.72047 8.95699ZM4.7646 10.6047L7.97712 13.821L11.1896 10.6047L10.5787 9.99299L8.32204 12.2523C8.13155 12.443 7.82269 12.443 7.6322 12.2523L5.37554 9.99299L4.7646 10.6047Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.224 7.63178C11.0335 7.8225 11.0335 8.13172 11.224 8.32244L12.6956 9.79583C12.8861 9.98655 13.195 9.98655 13.3855 9.79583L14.8571 8.32244C15.0476 8.13172 15.0476 7.8225 14.8571 7.63178L13.3855 6.15838C13.195 5.96766 12.8861 5.96766 12.6956 6.15838L11.224 7.63178ZM13.0406 8.75985L12.2587 7.97711L13.0405 7.19437L13.8224 7.97711L13.0406 8.75985Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1.14287 8.32228C0.952376 8.13156 0.952376 7.82234 1.14287 7.63162L2.61453 6.15822C2.80502 5.9675 3.11388 5.9675 3.30437 6.15822L4.77603 7.63162C4.96652 7.82234 4.96652 8.13156 4.77603 8.32228L3.30437 9.79568C3.11388 9.98639 2.80502 9.98639 2.61453 9.79568L1.14287 8.32228ZM2.17763 7.97695L2.95945 8.75969L3.74127 7.97695L2.95945 7.19421L2.17763 7.97695Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.97652 7.65467C5.78603 7.84539 5.78603 8.15461 5.97652 8.34533L7.58615 9.95686C7.77664 10.1476 8.08549 10.1476 8.27599 9.95686L9.88561 8.34533C10.0761 8.15461 10.0761 7.84539 9.88561 7.65467L8.27599 6.04314C8.08549 5.85242 7.77664 5.85242 7.58615 6.04314L5.97652 7.65467ZM7.93107 8.92087L7.01128 8L7.93107 7.07913L8.85085 8L7.93107 8.92087Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Binance_usd = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.39857 1.23782C8.08148 0.920728 7.58363 0.920728 7.26654 1.23782L3.85027 4.65407C3.53319 4.97116 3.53319 5.46901 3.85027 5.7861L4.98903 6.92485C5.30612 7.24194 5.80397 7.24194 6.12105 6.92485L9.53732 3.50859C9.85441 3.1915 9.85441 2.69366 9.53732 2.37657L8.39857 1.23782ZM4.61051 5.22009L7.83256 1.99805L8.77709 2.94258L5.55504 6.16462L4.61051 5.22009Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.011 3.85018C10.6939 3.5331 10.1961 3.5331 9.87898 3.85018L3.85027 9.87888C3.53319 10.196 3.53319 10.6938 3.85027 11.0109L4.98903 12.1497C5.30612 12.4667 5.80397 12.4667 6.12105 12.1497L12.1498 6.12096C12.4669 5.80387 12.4669 5.30602 12.1498 4.98894L11.011 3.85018ZM11.3895 5.55495L10.445 4.61042L4.61051 10.4449L5.55504 11.3894L11.3895 5.55495Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.4914 6.46272C12.8085 6.14563 13.3063 6.14563 13.6234 6.46272L14.7622 7.60147C15.0793 7.91856 15.0793 8.4164 14.7622 8.73349L8.73347 14.7622C8.41638 15.0793 7.91854 15.0793 7.60145 14.7622L6.46269 13.6234C6.1456 13.3063 6.1456 12.8085 6.46269 12.4914L12.4914 6.46272ZM13.0574 7.22295L14.0019 8.16748L8.16746 14.002L7.22293 13.0574L13.0574 7.22295Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.5086 6.12779C3.19151 5.8107 2.69366 5.8107 2.37657 6.12779L1.23782 7.26654C0.920728 7.58363 0.920728 8.08148 1.23782 8.39856L2.37657 9.53732C2.69366 9.8544 3.19151 9.8544 3.5086 9.53732L4.64735 8.39856C4.96444 8.08148 4.96444 7.58363 4.64735 7.26654L3.5086 6.12779ZM1.99805 7.83255L2.94258 6.88802L3.88712 7.83255L2.94258 8.77708L1.99805 7.83255Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Bitcoin = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.66865 4.4186C8.66865 4.14888 8.45 3.93023 8.18028 3.93023C7.91056 3.93023 7.69191 4.14888 7.69191 4.4186V5.15498H7.14344V4.4186C7.14344 4.14888 6.92479 3.93023 6.65507 3.93023C6.38535 3.93023 6.1667 4.14888 6.1667 4.4186V5.15498H5.06977C4.80005 5.15498 4.5814 5.37363 4.5814 5.64335C4.5814 5.91307 4.80005 6.13172 5.06977 6.13172H5.55814V10.0387H5.06977C4.80005 10.0387 4.5814 10.2574 4.5814 10.5271C4.5814 10.7968 4.80005 11.0154 5.06977 11.0154H5.96068C5.98855 11.0204 6.01723 11.023 6.04651 11.023H6.1667V11.7518C6.1667 12.0215 6.38535 12.2401 6.65507 12.2401C6.92479 12.2401 7.14344 12.0215 7.14344 11.7518V11.023H7.69191V11.7518C7.69191 12.0215 7.91056 12.2401 8.18028 12.2401C8.45 12.2401 8.66865 12.0215 8.66865 11.7518V11.023H9.53274C10.5143 11.023 11.4186 10.3139 11.4186 9.3099C11.4186 8.65976 11.0394 8.1333 10.5056 7.84296C10.6976 7.56622 10.81 7.23024 10.81 6.86804C10.81 5.99769 10.0581 5.15498 9.09696 5.15498H8.66865V4.4186ZM6.53488 10.0387H7.20358C7.23286 10.0387 7.26154 10.0413 7.28941 10.0462H8.09445C8.12231 10.0413 8.151 10.0387 8.18028 10.0387C8.20956 10.0387 8.23824 10.0413 8.26611 10.0462H9.53274C10.0989 10.0462 10.4419 9.6583 10.4419 9.3099C10.4419 8.9615 10.0989 8.57358 9.53274 8.57358H9.25847C9.2053 8.57856 9.15143 8.5811 9.09696 8.5811H6.53488V10.0387ZM6.53488 6.13172V7.59684H9.20251C9.55904 7.5456 9.83328 7.23869 9.83328 6.86804C9.83328 6.50619 9.48823 6.13172 9.09696 6.13172H6.53488Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1ZM1.97674 8C1.97674 4.67345 4.67345 1.97674 8 1.97674C11.3266 1.97674 14.0233 4.67345 14.0233 8C14.0233 11.3266 11.3266 14.0233 8 14.0233C4.67345 14.0233 1.97674 11.3266 1.97674 8Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Box = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M27.32 10.0267C27.3124 9.9915 27.3124 9.95514 27.32 9.91999C27.3135 9.88921 27.3135 9.85743 27.32 9.82665V9.70665L27.24 9.50665C27.2075 9.45208 27.167 9.40265 27.12 9.35999L27 9.25332H26.9333L21.68 5.93332L16.72 2.86665C16.6052 2.77563 16.4739 2.70771 16.3333 2.66665H16.2266C16.1075 2.64676 15.9858 2.64676 15.8666 2.66665H15.7333C15.5784 2.70091 15.4299 2.75941 15.2933 2.83999L5.3333 9.03999L5.2133 9.13332L5.0933 9.23999L4.95997 9.33332L4.8933 9.41332L4.8133 9.61332V9.73332V9.81332C4.80035 9.90174 4.80035 9.99157 4.8133 10.08V21.72C4.81285 21.9466 4.87015 22.1695 4.9798 22.3678C5.08944 22.5661 5.24782 22.7332 5.43997 22.8533L15.44 29.04L15.64 29.12H15.7466C15.9722 29.1915 16.2144 29.1915 16.44 29.12H16.5466L16.7466 29.04L26.6666 22.9467C26.8588 22.8266 27.0172 22.6595 27.1268 22.4612C27.2365 22.2629 27.2938 22.0399 27.2933 21.8133V10.1733C27.2933 10.1733 27.32 10.08 27.32 10.0267ZM16 5.55999L18.3733 7.02665L10.92 11.64L8.5333 10.1733L16 5.55999ZM14.6666 25.56L7.3333 21.08V12.56L14.6666 17.0933V25.56ZM16 14.7467L13.4533 13.2133L20.9066 8.58665L23.4666 10.1733L16 14.7467ZM24.6666 21.04L17.3333 25.6V17.0933L24.6666 12.56V21.04Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const CA = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M1.06815 0.470581C1.39818 0.470581 1.66573 0.738123 1.66573 1.06815V13.9757C1.66573 14.1737 1.82625 14.3343 2.02427 14.3343H14.9318C15.2619 14.3343 15.5294 14.6018 15.5294 14.9318C15.5294 15.2619 15.2619 15.5294 14.9318 15.5294H2.02427C1.16619 15.5294 0.470581 14.8338 0.470581 13.9757V1.06815C0.470581 0.738123 0.738123 0.470581 1.06815 0.470581Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M2.5 11C2.5 10.472 2.92807 10.0439 3.45612 10.0439H3.93417C4.46222 10.0439 4.89029 10.472 4.89029 11L4.89262 13.0196C4.89262 13.5477 4.46455 13.9757 3.9365 13.9757H3.45844C2.9304 13.9757 2.50233 13.5476 2.50233 13.0196L2.5 11Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M5.6097 8.80485C5.6097 8.2768 6.03777 7.84873 6.56582 7.84873H7.04388C7.57193 7.84873 7.99999 8.2768 7.99999 8.80485V13.0196C7.99999 13.5477 7.57193 13.9757 7.04388 13.9757H6.56582C6.03777 13.9757 5.6097 13.5476 5.6097 13.0196V8.80485Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M8.71708 7.5C8.71708 6.97195 9.14515 6.54388 9.6732 6.54388H10.1513C10.6793 6.54388 11.1074 6.97195 11.1074 7.5V13.0196C11.1074 13.5477 10.6793 13.9757 10.1513 13.9757H9.6732C9.14515 13.9757 8.71708 13.5476 8.71708 13.0196V7.5Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M11.8245 5.9365C11.8245 5.40845 12.2525 4.98038 12.7806 4.98038H13.2586C13.7867 4.98038 14.2147 5.40845 14.2147 5.9365V13.0196C14.2147 13.5477 13.7867 13.9757 13.2586 13.9757H12.7806C12.2525 13.9757 11.8245 13.5476 11.8245 13.0196V5.9365Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M3.96341 4.10976C3.96341 4.1024 3.96357 4.09507 3.96389 4.08778H4.67073C4.72461 4.08778 4.76829 4.04842 4.76829 3.99987C4.76829 3.95132 4.72461 3.91197 4.67073 3.91197H4.00325C4.09412 3.69445 4.33059 3.53836 4.60996 3.53836C4.72158 3.53836 4.82627 3.56328 4.91761 3.60705C4.96518 3.62984 5.02426 3.61357 5.04955 3.57071C5.07485 3.52784 5.05679 3.47461 5.00922 3.45182C4.89027 3.39482 4.75419 3.36254 4.60996 3.36254C4.22335 3.36254 3.89586 3.59455 3.79805 3.91197H3.54878C3.4949 3.91197 3.45122 3.95132 3.45122 3.99987C3.45122 4.04842 3.4949 4.08778 3.54878 4.08778H3.76865C3.76841 4.09508 3.76829 4.10241 3.76829 4.10976C3.76829 4.13198 3.76938 4.15397 3.77152 4.17569H3.54878C3.4949 4.17569 3.45122 4.21505 3.45122 4.2636C3.45122 4.31215 3.4949 4.35151 3.54878 4.35151H3.81327C3.92662 4.64616 4.24143 4.85698 4.60996 4.85698C4.75419 4.85698 4.89027 4.8247 5.00922 4.7677C5.05679 4.74491 5.07485 4.69168 5.04955 4.64881C5.02426 4.60595 4.96518 4.58967 4.91761 4.61247C4.82627 4.65623 4.72158 4.68116 4.60996 4.68116C4.34979 4.68116 4.12683 4.54579 4.02402 4.35151H4.67073C4.72461 4.35151 4.76829 4.31215 4.76829 4.2636C4.76829 4.21505 4.72461 4.17569 4.67073 4.17569H3.96768C3.96486 4.15405 3.96341 4.13205 3.96341 4.10976Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.84465 1.94519C3.8347 1.96915 3.82927 1.99509 3.82927 2.02217C3.82927 2.09317 3.86664 2.15631 3.92462 2.19648C3.39114 2.33149 3 2.773 3 3.29683V5.47255C3 5.76385 3.26208 6 3.58537 6H5.41463C5.73792 6 6 5.76385 6 5.47255V3.29683C6 2.761 5.59073 2.3113 5.0385 2.18769C5.08965 2.14741 5.12195 2.08819 5.12195 2.02217C5.12195 1.99468 5.11635 1.96837 5.10612 1.94411L5.20137 1.77955C5.33686 1.54547 5.26226 1.23962 5.01213 1.09557C4.84108 0.997066 4.64009 1.00427 4.48289 1.09046C4.32126 0.982773 4.10091 0.964665 3.9147 1.0719C3.66457 1.21595 3.58997 1.5218 3.72546 1.75588L3.72687 1.75832L3.84465 1.94519ZM4.32904 1.38558C4.27092 1.30413 4.17251 1.28858 4.09859 1.33115C4.01009 1.38212 3.96842 1.50759 4.027 1.61148L4.14733 1.8024H4.80303L4.89861 1.63727C4.95898 1.53298 4.91735 1.40614 4.82824 1.35482C4.75766 1.31417 4.66699 1.32676 4.60816 1.39593L4.46042 1.56965L4.32904 1.38558ZM4.07317 1.97821H4.87805C4.90499 1.97821 4.92683 1.99789 4.92683 2.02217C4.92683 2.04644 4.90499 2.06612 4.87805 2.06612H4.07317C4.04623 2.06612 4.02439 2.04644 4.02439 2.02217C4.02439 1.99789 4.04623 1.97821 4.07317 1.97821ZM4.26829 2.52764H4.73171C5.20317 2.52764 5.58537 2.87202 5.58537 3.29683V5.47255C5.58537 5.55752 5.50893 5.62639 5.41463 5.62639H3.58537C3.49107 5.62639 3.41463 5.55752 3.41463 5.47255V3.29683C3.41463 2.87202 3.79683 2.52764 4.26829 2.52764Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Cacher = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14.2734 2.7146C14.4479 2.55113 14.4479 2.28608 14.2734 2.12261C14.0989 1.95913 13.816 1.95913 13.6415 2.12261L11.5028 4.12628C10.3766 3.47329 9.10972 3.11628 7.79728 3.11628C5.33518 3.11628 3.07261 4.36154 1.51818 6.45691C1.16265 6.93471 1 7.54953 1 8.14032C1 8.7311 1.16265 9.3459 1.51816 9.8237C2.0547 10.5459 2.68176 11.1722 3.36731 11.6777C3.38167 11.6883 3.3965 11.698 3.41173 11.7067L1.72661 13.2854C1.55212 13.4489 1.55212 13.7139 1.72661 13.8774C1.9011 14.0409 2.184 14.0409 2.35849 13.8774L6.80537 9.71122C6.8065 9.71019 6.80762 9.70915 6.80873 9.7081L9.8232 6.88392L9.82653 6.88077L11.8004 5.0315C11.8551 5.00153 11.9038 4.96014 11.9422 4.90807C11.9484 4.89956 11.9543 4.89091 11.9598 4.88214L14.2734 2.7146ZM5.88811 9.38659C5.59349 8.99438 5.42045 8.51715 5.42045 8.00002C5.42045 6.66371 6.57369 5.58328 8.00003 5.58328C8.55201 5.58328 9.06138 5.74539 9.48003 6.02141L10.8513 4.7367C9.90479 4.22561 8.86422 3.95349 7.79728 3.95349C5.67754 3.95349 3.66979 5.02335 2.25179 6.93497L2.25138 6.93552C2.02295 7.24241 1.89362 7.67934 1.89362 8.14032C1.89362 8.6013 2.02318 9.03853 2.25161 9.34543C2.74049 10.0035 3.30759 10.5682 3.92004 11.0199C3.96335 11.0518 3.99866 11.0898 4.02567 11.1315L5.88811 9.38659ZM8.00003 6.42048C7.06722 6.42048 6.31407 7.12609 6.31407 8.00002C6.31407 8.28488 6.39386 8.55062 6.53467 8.78088L8.8335 6.62716C8.58773 6.49523 8.30408 6.42048 8.00003 6.42048Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M13.7206 5.48264C13.5527 5.3132 13.27 5.30336 13.0891 5.46065C12.9083 5.61794 12.8978 5.8828 13.0657 6.05224C13.3039 6.29271 13.533 6.54613 13.7414 6.81264L13.7421 6.81357C13.9751 7.10987 14.1064 7.53045 14.1064 7.97376C14.1064 8.41706 13.9751 8.83765 13.7421 9.13394L13.7417 9.13449C12.2833 10.9956 10.2105 12.0465 8.0107 12.0465C7.24294 12.0465 6.48564 11.9148 5.77015 11.6702C5.53833 11.591 5.28185 11.7028 5.19727 11.92C5.1127 12.1372 5.23207 12.3775 5.46389 12.4567C6.27287 12.7332 7.13364 12.8837 8.0107 12.8837C10.5313 12.8837 12.8579 11.6769 14.4618 9.63023C14.8304 9.16127 15 8.55615 15 7.97376C15 7.39163 14.8306 6.78681 14.4623 6.31795C14.2294 6.01999 13.9771 5.74151 13.7206 5.48264Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M10.5304 8.46657C10.5752 8.23921 10.4147 8.02092 10.1721 7.979C9.92938 7.93707 9.69638 8.0874 9.65163 8.31475C9.53033 8.93102 8.98779 9.43931 8.33 9.55295C8.08733 9.59487 7.92688 9.81317 7.97163 10.0405C8.01638 10.2679 8.24938 10.4182 8.49205 10.3763C9.51426 10.1997 10.3419 9.42425 10.5304 8.46657Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Calculatrice = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.18182 3.69231V6.92308C4.18182 7.22046 4.42603 7.46154 4.72727 7.46154H11.2727C11.574 7.46154 11.8182 7.22046 11.8182 6.92308V3.69231C11.8182 3.39492 11.574 3.15385 11.2727 3.15385H4.72727C4.42603 3.15385 4.18182 3.39492 4.18182 3.69231ZM5.27273 6.38462H10.7273V4.23077H5.27273V6.38462Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M6.09091 9.34615C6.09091 9.7922 5.72457 10.1538 5.27273 10.1538C4.82089 10.1538 4.45455 9.7922 4.45455 9.34615C4.45455 8.90011 4.82089 8.53846 5.27273 8.53846C5.72457 8.53846 6.09091 8.90011 6.09091 9.34615Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M8 10.1538C8.45184 10.1538 8.81818 9.7922 8.81818 9.34615C8.81818 8.90011 8.45184 8.53846 8 8.53846C7.54816 8.53846 7.18182 8.90011 7.18182 9.34615C7.18182 9.7922 7.54816 10.1538 8 10.1538Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M11.5455 9.34615C11.5455 9.7922 11.1791 10.1538 10.7273 10.1538C10.2754 10.1538 9.90909 9.7922 9.90909 9.34615C9.90909 8.90011 10.2754 8.53846 10.7273 8.53846C11.1791 8.53846 11.5455 8.90011 11.5455 9.34615Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M5.27273 12.8462C5.72457 12.8462 6.09091 12.4845 6.09091 12.0385C6.09091 11.5924 5.72457 11.2308 5.27273 11.2308C4.82089 11.2308 4.45455 11.5924 4.45455 12.0385C4.45455 12.4845 4.82089 12.8462 5.27273 12.8462Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M8.81818 12.0385C8.81818 12.4845 8.45184 12.8462 8 12.8462C7.54816 12.8462 7.18182 12.4845 7.18182 12.0385C7.18182 11.5924 7.54816 11.2308 8 11.2308C8.45184 11.2308 8.81818 11.5924 8.81818 12.0385Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M10.7273 12.8462C11.1791 12.8462 11.5455 12.4845 11.5455 12.0385C11.5455 11.5924 11.1791 11.2308 10.7273 11.2308C10.2754 11.2308 9.90909 11.5924 9.90909 12.0385C9.90909 12.4845 10.2754 12.8462 10.7273 12.8462Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M13.6805 1.31542C13.361 1 12.9091 1 12.9091 1H3.09091C2.63904 1 2.31952 1.31542 2.31952 1.31542C2 1.63085 2 2.07692 2 2.07692V13.9231C2 14.3692 2.31952 14.6846 2.31952 14.6846C2.63904 15 3.09091 15 3.09091 15H12.9091C13.361 15 13.6805 14.6846 13.6805 14.6846C14 14.3692 14 13.9231 14 13.9231V2.07692C14 1.63085 13.6805 1.31542 13.6805 1.31542ZM3.09091 2.07692H12.9091V13.9231H3.09091V2.07692Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Calendrier = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.5 2.75C4.5 2.33579 4.16421 2 3.75 2C3.33579 2 3 2.33579 3 2.75V3H1C0.447715 3 0 3.44771 0 4V13C0 13.5523 0.447715 14 1 14H15C15.5523 14 16 13.5523 16 13V4C16 3.44772 15.5523 3 15 3H12.5V2.75C12.5 2.33579 12.1642 2 11.75 2C11.3358 2 11 2.33579 11 2.75V3H4.5V2.75ZM11.75 5C11.4234 5 11.1456 4.7913 11.0427 4.5H4.45732C4.35436 4.7913 4.07655 5 3.75 5C3.42345 5 3.14564 4.7913 3.04268 4.5H1.5V5.5H14.5V4.5H12.4573C12.3544 4.7913 12.0766 5 11.75 5ZM14.5 7H1.5V12.5H14.5V7Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Calendrier2 = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.9167 1.53846V2.07692H5.08333V1.53846C5.08333 1.24108 4.82217 1 4.5 1C4.17783 1 3.91667 1.24108 3.91667 1.53846V2.07692H2.16667C1.68342 2.07692 1.34171 2.39235 1.34171 2.39235C1 2.70777 1 3.15385 1 3.15385V13.9231C1 14.3692 1.34171 14.6846 1.34171 14.6846C1.68342 15 2.16667 15 2.16667 15H13.8333C14.3166 15 14.6583 14.6846 14.6583 14.6846C15 14.3692 15 13.9231 15 13.9231V3.15385C15 2.70777 14.6583 2.39235 14.6583 2.39235C14.3166 2.07692 13.8333 2.07692 13.8333 2.07692H12.0833V1.53846C12.0833 1.24108 11.8222 1 11.5 1C11.1778 1 10.9167 1.24108 10.9167 1.53846ZM2.16667 13.9231V6.38462H13.8333V13.9231H2.16667ZM2.16667 5.30769H13.8333V3.15385H12.0833V3.69231C12.0833 3.98969 11.8222 4.23077 11.5 4.23077C11.1778 4.23077 10.9167 3.98969 10.9167 3.69231V3.15385H5.08333V3.69231C5.08333 3.98969 4.82217 4.23077 4.5 4.23077C4.17783 4.23077 3.91667 3.98969 3.91667 3.69231V3.15385H2.16667V5.30769Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Capital = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.29597 2.83901C4.44578 2.81797 4.60333 2.80717 4.76899 2.80717H10.7624C10.9265 2.80717 11.0652 2.81315 11.1901 2.83213C11.1972 2.83321 11.2043 2.83413 11.2114 2.83489C11.9727 2.91568 12.5758 3.20915 12.9896 3.64674C13.404 4.085 13.6527 4.69368 13.6527 5.44236V5.87444H12.5908C12.1064 5.87444 11.6651 6.06256 11.3484 6.38092C10.9963 6.72165 10.7996 7.20506 10.8483 7.7164C10.9255 8.6136 11.7568 9.26457 12.6676 9.26457H13.6527V9.69665C13.6527 10.5158 13.3555 11.1674 12.8668 11.6135C12.3777 12.0598 11.6623 12.3318 10.7624 12.3318H9.09756C8.85492 12.3318 8.65822 12.5125 8.65822 12.7354C8.65822 12.9583 8.85492 13.139 9.09756 13.139H10.7624C11.8603 13.139 12.8097 12.8033 13.486 12.1861C14.1626 11.5686 14.5314 10.7008 14.5314 9.69665V9.07592C14.82 8.88289 15 8.56338 15 8.21842V6.9206C15 6.57564 14.82 6.25612 14.5314 6.06309V5.44236C14.5314 4.5258 14.2241 3.72144 13.6529 3.1174C13.0832 2.51488 12.275 2.13734 11.3227 2.03417C11.1315 2.00594 10.9411 2 10.7624 2H4.76899C4.56385 2 4.36382 2.01324 4.16925 2.04025C3.22535 2.14957 2.42638 2.52951 1.86423 3.13143C1.30163 3.73384 1 4.53287 1 5.44236V6.65787C1 6.88077 1.19669 7.06146 1.43933 7.06146C1.68197 7.06146 1.87866 6.88077 1.87866 6.65787V5.44236C1.87866 4.69876 2.1231 4.09388 2.53109 3.65702C2.93835 3.22095 3.53232 2.92662 4.28394 2.84054L4.29597 2.83901ZM14.0287 8.41181H12.7868C12.2589 8.41181 11.8241 8.06013 11.7862 7.64516L11.7857 7.64039C11.7592 7.38622 11.8646 7.14653 12.0538 6.97797L12.0617 6.97075C12.2246 6.81809 12.4507 6.7272 12.7069 6.7272H14.0287C14.0818 6.76751 14.1213 6.83331 14.1213 6.9206V8.21842C14.1213 8.3057 14.0818 8.3715 14.0287 8.41181Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1.93724 8.68634C1.93724 8.01363 2.25609 7.41955 2.76235 6.99301C3.27061 6.5585 3.95899 6.30493 4.71309 6.30493L4.71802 6.30494L4.72295 6.30493C5.48238 6.30493 6.17084 6.56573 6.67684 6.98873L6.67935 6.99083C7.18081 7.41659 7.50209 8.01726 7.50209 8.68634V10.4352C7.50209 10.4702 7.50124 10.5049 7.49956 10.5393C7.50123 10.5537 7.50209 10.5682 7.50209 10.583V11.7731C7.50209 13.0644 6.1858 14 4.72295 14C3.26179 14 1.93724 13.0657 1.93724 11.7731V10.583C1.93724 10.5681 1.93811 10.5535 1.9398 10.5391C1.9381 10.5048 1.93724 10.4702 1.93724 10.4352V8.68634ZM6.62343 10.3903V10.4352C6.62343 11.2471 5.84117 11.9013 4.72295 11.9013C3.60407 11.9013 2.8159 11.2403 2.8159 10.4352V10.3874C3.32193 10.7701 3.99732 10.9865 4.71965 10.9865C5.44048 10.9865 6.11654 10.7738 6.62343 10.3903ZM4.71797 7.11211C5.25203 7.11323 5.72707 7.29838 6.07169 7.58937L6.07709 7.59385C6.42001 7.87393 6.62343 8.26634 6.62343 8.69705C6.62343 8.94502 6.55312 9.17193 6.43175 9.37057C6.13616 9.84588 5.50494 10.1794 4.71965 10.1794C3.93707 10.1794 3.30381 9.84132 3.00706 9.36978C2.886 9.17135 2.8159 8.94472 2.8159 8.69705C2.8159 8.26762 3.01854 7.87761 3.35684 7.58741C3.69636 7.29799 4.17258 7.11323 4.71797 7.11211ZM2.91808 12.2246C3.16511 12.7615 3.84007 13.1928 4.72295 13.1928C5.60619 13.1928 6.27876 12.7607 6.52327 12.222C6.02274 12.537 5.38121 12.7102 4.72295 12.7102C4.06265 12.7102 3.41964 12.5385 2.91808 12.2246Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Cardano = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M7.98473 3.23515C7.64783 3.23515 7.37471 2.95865 7.37471 2.61758C7.37471 2.2765 7.64783 2 7.98473 2C8.32164 2 8.59476 2.2765 8.59476 2.61758C8.59476 2.95865 8.32164 3.23515 7.98473 3.23515Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.3638 3.54394C9.94263 3.54394 9.60124 3.88956 9.60124 4.31591C9.60124 4.74226 9.94263 5.08788 10.3638 5.08788C10.7849 5.08788 11.1263 4.74226 11.1263 4.31591C11.1263 3.88956 10.7849 3.54394 10.3638 3.54394ZM10.2113 4.31591C10.2113 4.23064 10.2795 4.16152 10.3638 4.16152C10.448 4.16152 10.5163 4.23064 10.5163 4.31591C10.5163 4.40118 10.448 4.4703 10.3638 4.4703C10.2795 4.4703 10.2113 4.40118 10.2113 4.31591Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.91719 5.73636C6.41183 5.73636 6.00216 6.15111 6.00216 6.66273C6.00216 7.17434 6.41183 7.58909 6.91719 7.58909C7.42255 7.58909 7.83223 7.17434 7.83223 6.66273C7.83223 6.15111 7.42255 5.73636 6.91719 5.73636ZM6.61218 6.66273C6.61218 6.49219 6.74874 6.35394 6.91719 6.35394C7.08565 6.35394 7.22221 6.49219 7.22221 6.66273C7.22221 6.83327 7.08565 6.97152 6.91719 6.97152C6.74874 6.97152 6.61218 6.83327 6.61218 6.66273Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.05227 5.73636C8.54692 5.73636 8.13724 6.15111 8.13724 6.66273C8.13724 7.17434 8.54692 7.58909 9.05227 7.58909C9.55763 7.58909 9.96731 7.17434 9.96731 6.66273C9.96731 6.15111 9.55763 5.73636 9.05227 5.73636ZM8.74726 6.66273C8.74726 6.49219 8.88382 6.35394 9.05227 6.35394C9.22073 6.35394 9.35729 6.49219 9.35729 6.66273C9.35729 6.83327 9.22073 6.97152 9.05227 6.97152C8.88382 6.97152 8.74726 6.83327 8.74726 6.66273Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.20478 8.51545C9.20478 8.00384 9.61446 7.58909 10.1198 7.58909C10.6252 7.58909 11.0349 8.00384 11.0349 8.51545C11.0349 9.02707 10.6252 9.44182 10.1198 9.44182C9.61446 9.44182 9.20478 9.02707 9.20478 8.51545ZM10.1198 8.20667C9.95136 8.20667 9.8148 8.34492 9.8148 8.51545C9.8148 8.68599 9.95136 8.82424 10.1198 8.82424C10.2883 8.82424 10.4248 8.68599 10.4248 8.51545C10.4248 8.34492 10.2883 8.20667 10.1198 8.20667Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.1263 5.89076C10.7052 5.89076 10.3638 6.23638 10.3638 6.66273C10.3638 7.08907 10.7052 7.4347 11.1263 7.4347C11.5474 7.4347 11.8888 7.08907 11.8888 6.66273C11.8888 6.23638 11.5474 5.89076 11.1263 5.89076ZM10.9738 6.66273C10.9738 6.57746 11.0421 6.50833 11.1263 6.50833C11.2105 6.50833 11.2788 6.57746 11.2788 6.66273C11.2788 6.748 11.2105 6.81712 11.1263 6.81712C11.0421 6.81712 10.9738 6.748 10.9738 6.66273Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.3638 10.3682C10.3638 9.94183 10.7052 9.59621 11.1263 9.59621C11.5474 9.59621 11.8888 9.94183 11.8888 10.3682C11.8888 10.7945 11.5474 11.1402 11.1263 11.1402C10.7052 11.1402 10.3638 10.7945 10.3638 10.3682ZM11.1263 10.2138C11.0421 10.2138 10.9738 10.2829 10.9738 10.3682C10.9738 10.4535 11.0421 10.5226 11.1263 10.5226C11.2105 10.5226 11.2788 10.4535 11.2788 10.3682C11.2788 10.2829 11.2105 10.2138 11.1263 10.2138Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.7124 7.74348C12.2913 7.74348 11.9499 8.08911 11.9499 8.51545C11.9499 8.9418 12.2913 9.28742 12.7124 9.28742C13.1335 9.28742 13.4749 8.9418 13.4749 8.51545C13.4749 8.08911 13.1335 7.74348 12.7124 7.74348ZM12.5599 8.51545C12.5599 8.43019 12.6282 8.36106 12.7124 8.36106C12.7966 8.36106 12.8649 8.43019 12.8649 8.51545C12.8649 8.60072 12.7966 8.66985 12.7124 8.66985C12.6282 8.66985 12.5599 8.60072 12.5599 8.51545Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.05012 6.66273C4.05012 6.23638 4.39151 5.89076 4.81264 5.89076C5.23378 5.89076 5.57517 6.23638 5.57517 6.66273C5.57517 7.08907 5.23378 7.4347 4.81264 7.4347C4.39151 7.4347 4.05012 7.08907 4.05012 6.66273ZM4.81264 6.50833C4.72842 6.50833 4.66014 6.57746 4.66014 6.66273C4.66014 6.748 4.72842 6.81712 4.81264 6.81712C4.89687 6.81712 4.96515 6.748 4.96515 6.66273C4.96515 6.57746 4.89687 6.50833 4.81264 6.50833Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.81264 9.59621C4.39151 9.59621 4.05012 9.94183 4.05012 10.3682C4.05012 10.7945 4.39151 11.1402 4.81264 11.1402C5.23378 11.1402 5.57517 10.7945 5.57517 10.3682C5.57517 9.94183 5.23378 9.59621 4.81264 9.59621ZM4.66014 10.3682C4.66014 10.2829 4.72842 10.2138 4.81264 10.2138C4.89687 10.2138 4.96515 10.2829 4.96515 10.3682C4.96515 10.4535 4.89687 10.5226 4.81264 10.5226C4.72842 10.5226 4.66014 10.4535 4.66014 10.3682Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2.464 8.51545C2.464 8.08911 2.80539 7.74348 3.22652 7.74348C3.64766 7.74348 3.98905 8.08911 3.98905 8.51545C3.98905 8.9418 3.64766 9.28742 3.22652 9.28742C2.80539 9.28742 2.464 8.9418 2.464 8.51545ZM3.22652 8.36106C3.1423 8.36106 3.07402 8.43019 3.07402 8.51545C3.07402 8.60072 3.1423 8.66985 3.22652 8.66985C3.31075 8.66985 3.37903 8.60072 3.37903 8.51545C3.37903 8.43019 3.31075 8.36106 3.22652 8.36106Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.84318 4.31591C4.84318 3.88956 5.18457 3.54394 5.6057 3.54394C6.02684 3.54394 6.36823 3.88956 6.36823 4.31591C6.36823 4.74226 6.02684 5.08788 5.6057 5.08788C5.18457 5.08788 4.84318 4.74226 4.84318 4.31591ZM5.6057 4.16152C5.52148 4.16152 5.4532 4.23064 5.4532 4.31591C5.4532 4.40118 5.52148 4.4703 5.6057 4.4703C5.68993 4.4703 5.75821 4.40118 5.75821 4.31591C5.75821 4.23064 5.68993 4.16152 5.6057 4.16152Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.01527 4.03803C7.59413 4.03803 7.25274 4.38365 7.25274 4.81C7.25274 5.23635 7.59413 5.58197 8.01527 5.58197C8.4364 5.58197 8.77779 5.23635 8.77779 4.81C8.77779 4.38365 8.4364 4.03803 8.01527 4.03803ZM7.86276 4.81C7.86276 4.72473 7.93104 4.65561 8.01527 4.65561C8.09949 4.65561 8.16777 4.72473 8.16777 4.81C8.16777 4.89527 8.09949 4.96439 8.01527 4.96439C7.93104 4.96439 7.86276 4.89527 7.86276 4.81Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.60124 12.8385C9.60124 12.4121 9.94263 12.0665 10.3638 12.0665C10.7849 12.0665 11.1263 12.4121 11.1263 12.8385C11.1263 13.2648 10.7849 13.6105 10.3638 13.6105C9.94263 13.6105 9.60124 13.2648 9.60124 12.8385ZM10.3638 12.6841C10.2795 12.6841 10.2113 12.7532 10.2113 12.8385C10.2113 12.9238 10.2795 12.9929 10.3638 12.9929C10.448 12.9929 10.5163 12.9238 10.5163 12.8385C10.5163 12.7532 10.448 12.6841 10.3638 12.6841Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.6057 12.0665C5.18457 12.0665 4.84318 12.4121 4.84318 12.8385C4.84318 13.2648 5.18457 13.6105 5.6057 13.6105C6.02684 13.6105 6.36823 13.2648 6.36823 12.8385C6.36823 12.4121 6.02684 12.0665 5.6057 12.0665ZM5.4532 12.8385C5.4532 12.7532 5.52148 12.6841 5.6057 12.6841C5.68993 12.6841 5.75821 12.7532 5.75821 12.8385C5.75821 12.9238 5.68993 12.9929 5.6057 12.9929C5.52148 12.9929 5.4532 12.9238 5.4532 12.8385Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.25274 12.3444C7.25274 11.918 7.59413 11.5724 8.01527 11.5724C8.4364 11.5724 8.77779 11.918 8.77779 12.3444C8.77779 12.7707 8.4364 13.1164 8.01527 13.1164C7.59413 13.1164 7.25274 12.7707 7.25274 12.3444ZM8.01527 12.19C7.93104 12.19 7.86276 12.2591 7.86276 12.3444C7.86276 12.4297 7.93104 12.4988 8.01527 12.4988C8.09949 12.4988 8.16777 12.4297 8.16777 12.3444C8.16777 12.2591 8.09949 12.19 8.01527 12.19Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.84965 7.58909C5.34429 7.58909 4.93462 8.00384 4.93462 8.51545C4.93462 9.02707 5.34429 9.44182 5.84965 9.44182C6.35501 9.44182 6.76469 9.02707 6.76469 8.51545C6.76469 8.00384 6.35501 7.58909 5.84965 7.58909ZM5.54464 8.51545C5.54464 8.34492 5.6812 8.20667 5.84965 8.20667C6.01811 8.20667 6.15467 8.34492 6.15467 8.51545C6.15467 8.68599 6.01811 8.82424 5.84965 8.82424C5.6812 8.82424 5.54464 8.68599 5.54464 8.51545Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.00216 10.3682C6.00216 9.85656 6.41183 9.44182 6.91719 9.44182C7.42255 9.44182 7.83223 9.85656 7.83223 10.3682C7.83223 10.8798 7.42255 11.2945 6.91719 11.2945C6.41183 11.2945 6.00216 10.8798 6.00216 10.3682ZM6.91719 10.0594C6.74874 10.0594 6.61218 10.1976 6.61218 10.3682C6.61218 10.5387 6.74874 10.677 6.91719 10.677C7.08565 10.677 7.22221 10.5387 7.22221 10.3682C7.22221 10.1976 7.08565 10.0594 6.91719 10.0594Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.05227 9.44182C8.54692 9.44182 8.13724 9.85656 8.13724 10.3682C8.13724 10.8798 8.54692 11.2945 9.05227 11.2945C9.55763 11.2945 9.96731 10.8798 9.96731 10.3682C9.96731 9.85656 9.55763 9.44182 9.05227 9.44182ZM8.74726 10.3682C8.74726 10.1976 8.88382 10.0594 9.05227 10.0594C9.22073 10.0594 9.35729 10.1976 9.35729 10.3682C9.35729 10.5387 9.22073 10.677 9.05227 10.677C8.88382 10.677 8.74726 10.5387 8.74726 10.3682Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M10.8823 2.8647C10.8823 3.1205 11.0872 3.32788 11.3399 3.32788C11.5925 3.32788 11.7974 3.1205 11.7974 2.8647C11.7974 2.60889 11.5925 2.40151 11.3399 2.40151C11.0872 2.40151 10.8823 2.60889 10.8823 2.8647Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M11.3399 14.6603C11.0872 14.6603 10.8823 14.4529 10.8823 14.1971C10.8823 13.9413 11.0872 13.7339 11.3399 13.7339C11.5925 13.7339 11.7974 13.9413 11.7974 14.1971C11.7974 14.4529 11.5925 14.6603 11.3399 14.6603Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M12.4074 11.2945C12.4074 11.5504 12.6122 11.7577 12.8649 11.7577C13.1176 11.7577 13.3224 11.5504 13.3224 11.2945C13.3224 11.0387 13.1176 10.8314 12.8649 10.8314C12.6122 10.8314 12.4074 11.0387 12.4074 11.2945Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M12.8649 5.89076C12.6122 5.89076 12.4074 5.68338 12.4074 5.42758C12.4074 5.17177 12.6122 4.96439 12.8649 4.96439C13.1176 4.96439 13.3224 5.17177 13.3224 5.42758C13.3224 5.68338 13.1176 5.89076 12.8649 5.89076Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M2.64703 11.2945C2.64703 11.5504 2.85187 11.7577 3.10455 11.7577C3.35723 11.7577 3.56207 11.5504 3.56207 11.2945C3.56207 11.0387 3.35723 10.8314 3.10455 10.8314C2.85187 10.8314 2.64703 11.0387 2.64703 11.2945Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M3.10455 5.89076C2.85187 5.89076 2.64703 5.68338 2.64703 5.42758C2.64703 5.17177 2.85187 4.96439 3.10455 4.96439C3.35723 4.96439 3.56207 5.17177 3.56207 5.42758C3.56207 5.68338 3.35723 5.89076 3.10455 5.89076Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M4.17209 2.8647C4.17209 3.1205 4.37693 3.32788 4.62961 3.32788C4.88229 3.32788 5.08712 3.1205 5.08712 2.8647C5.08712 2.60889 4.88229 2.40151 4.62961 2.40151C4.37693 2.40151 4.17209 2.60889 4.17209 2.8647Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M4.62961 14.6603C4.37693 14.6603 4.17209 14.4529 4.17209 14.1971C4.17209 13.9413 4.37693 13.7339 4.62961 13.7339C4.88229 13.7339 5.08712 13.9413 5.08712 14.1971C5.08712 14.4529 4.88229 14.6603 4.62961 14.6603Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M7.37471 14.3824C7.37471 14.7235 7.64783 15 7.98473 15C8.32164 15 8.59476 14.7235 8.59476 14.3824C8.59476 14.0413 8.32164 13.7648 7.98473 13.7648C7.64783 13.7648 7.37471 14.0413 7.37471 14.3824Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M1.61002 9.13303C1.27312 9.13303 1 8.85653 1 8.51545C1 8.17438 1.27312 7.89788 1.61002 7.89788C1.94693 7.89788 2.22005 8.17438 2.22005 8.51545C2.22005 8.85653 1.94693 9.13303 1.61002 9.13303Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M13.78 8.51545C13.78 8.85653 14.0531 9.13303 14.39 9.13303C14.7269 9.13303 15 8.85653 15 8.51545C15 8.17438 14.7269 7.89788 14.39 7.89788C14.0531 7.89788 13.78 8.17438 13.78 8.51545Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Carte_bancaire2 = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M13 10.75C13 10.9985 12.7761 11.2 12.5 11.2H10.5C10.2239 11.2 10 10.9985 10 10.75C10 10.5015 10.2239 10.3 10.5 10.3H12.5C12.7761 10.3 13 10.5015 13 10.75Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M7 10.75C7 10.9985 7.22386 11.2 7.5 11.2H8.5C8.77614 11.2 9 10.9985 9 10.75C9 10.5015 8.77614 10.3 8.5 10.3H7.5C7.22386 10.3 7 10.5015 7 10.75Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1.29289 4.2636C1 4.52721 1 4.9 1 4.9V12.1C1 12.4728 1.29289 12.7364 1.29289 12.7364C1.58579 13 2 13 2 13H14C14.4142 13 14.7071 12.7364 14.7071 12.7364C15 12.4728 15 12.1 15 12.1V4.9C15 4.52721 14.7071 4.2636 14.7071 4.2636C14.4142 4 14 4 14 4H2C1.58579 4 1.29289 4.2636 1.29289 4.2636ZM14 6.30065V4.9H2V6.30065H14ZM2 7.20065H14V12.1H2V7.20065Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Celo = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.94179 4.94172C5.43007 2.5958 7.5092 0.833252 9.99999 0.833252C12.8535 0.833252 15.1667 3.14645 15.1667 5.99992C15.1667 8.49071 13.4041 10.5698 11.0582 11.0581C10.5699 13.404 8.49079 15.1666 5.99999 15.1666C3.14652 15.1666 0.833328 12.8534 0.833328 9.99992C0.833328 7.50912 2.59588 5.42999 4.94179 4.94172ZM5.99887 4.83325C6.50343 3.09991 8.10379 1.83325 9.99999 1.83325C12.3012 1.83325 14.1667 3.69873 14.1667 5.99992C14.1667 7.89612 12.9 9.49649 11.1667 10.001L11.1667 9.99992C11.1667 7.14645 8.85347 4.83325 5.99999 4.83325L5.99887 4.83325ZM10.0011 11.1666C9.49656 12.8999 7.8962 14.1666 5.99999 14.1666C3.69881 14.1666 1.83333 12.3011 1.83333 9.99992C1.83333 8.10371 3.09998 6.50335 4.83333 5.99879V5.99992C4.83333 8.85339 7.14652 11.1666 9.99999 11.1666H10.0011ZM10.1635 10.1634C10.1093 10.1655 10.0548 10.1666 9.99999 10.1666C7.69881 10.1666 5.83333 8.3011 5.83333 5.99992C5.83333 5.94516 5.83438 5.89065 5.83648 5.8364C5.89072 5.83431 5.94524 5.83325 5.99999 5.83325C8.30118 5.83325 10.1667 7.69873 10.1667 9.99992C10.1667 10.0547 10.1656 10.1092 10.1635 10.1634Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Celsius = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M7.99999 4.89998C6.28799 4.89998 4.89999 6.33078 4.89999 8.06665C4.89999 9.79051 6.27614 11.1666 7.99999 11.1666C8.95912 11.1666 9.88613 10.6546 10.4703 9.89513C10.6387 9.67625 10.9526 9.6353 11.1715 9.80367C11.3904 9.97204 11.4313 10.286 11.263 10.5048C10.5139 11.4787 9.30753 12.1666 7.99999 12.1666C5.72385 12.1666 3.89999 10.3428 3.89999 8.06665C3.89999 5.80252 5.71199 3.89998 7.99999 3.89998C8.90492 3.89998 9.81438 4.19996 10.507 4.73864C10.7249 4.90818 10.7642 5.22231 10.5947 5.44029C10.4251 5.65826 10.111 5.69753 9.89302 5.52799C9.38561 5.13334 8.69507 4.89998 7.99999 4.89998Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.3 6.79992C10.3 6.08195 10.882 5.49992 11.6 5.49992C12.318 5.49992 12.9 6.08195 12.9 6.79992C12.9 7.51789 12.318 8.09992 11.6 8.09992C10.882 8.09992 10.3 7.51789 10.3 6.79992ZM11.6 6.49992C11.4343 6.49992 11.3 6.63423 11.3 6.79992C11.3 6.9656 11.4343 7.09992 11.6 7.09992C11.7657 7.09992 11.9 6.9656 11.9 6.79992C11.9 6.63423 11.7657 6.49992 11.6 6.49992Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.00001 0.833252C4.04197 0.833252 0.833344 4.04188 0.833344 7.99992C0.833344 11.958 4.04197 15.1666 8.00001 15.1666C11.9581 15.1666 15.1667 11.958 15.1667 7.99992C15.1667 4.04188 11.9581 0.833252 8.00001 0.833252ZM1.83334 7.99992C1.83334 4.59416 4.59425 1.83325 8.00001 1.83325C11.4058 1.83325 14.1667 4.59416 14.1667 7.99992C14.1667 11.4057 11.4058 14.1666 8.00001 14.1666C4.59425 14.1666 1.83334 11.4057 1.83334 7.99992Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Certificat = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M0 3.44242C0 2.32092 0.87123 1.41177 1.94595 1.41177H14.0541C15.1288 1.41177 16 2.32092 16 3.44242V10.6625C16 11.784 15.1288 12.6932 14.0541 12.6932H13.1892C12.831 12.6932 12.5405 12.3901 12.5405 12.0163C12.5405 11.6425 12.831 11.3394 13.1892 11.3394H14.0541C14.4123 11.3394 14.7027 11.0364 14.7027 10.6625V3.44242C14.7027 3.06859 14.4123 2.76554 14.0541 2.76554H1.94595C1.58771 2.76554 1.2973 3.06859 1.2973 3.44242V10.6625C1.2973 11.0364 1.58771 11.3394 1.94595 11.3394H8.86487C9.2231 11.3394 9.51351 11.6425 9.51351 12.0163C9.51351 12.3901 9.2231 12.6932 8.86487 12.6932H1.94595C0.87123 12.6932 0 11.784 0 10.6625V3.44242Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M3.24324 5.47307C3.24324 5.09924 3.53365 4.79619 3.89189 4.79619H12.1081C12.4663 4.79619 12.7568 5.09924 12.7568 5.47307C12.7568 5.84691 12.4663 6.14996 12.1081 6.14996H3.89189C3.53365 6.14996 3.24324 5.84691 3.24324 5.47307Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M3.89189 7.95499C3.53365 7.95499 3.24324 8.25804 3.24324 8.63187C3.24324 9.0057 3.53365 9.30875 3.89189 9.30875H6.05405C6.41229 9.30875 6.7027 9.0057 6.7027 8.63187C6.7027 8.25804 6.41229 7.95499 6.05405 7.95499H3.89189Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.3243 11.5652C12.8495 11.1536 13.1892 10.4982 13.1892 9.76001C13.1892 8.5139 12.2212 7.50373 11.027 7.50373C9.8329 7.50373 8.86487 8.5139 8.86487 9.76001C8.86487 10.4982 9.20456 11.1536 9.72973 11.5652V14.5882L11.027 13.8361L12.3243 14.5882V11.5652ZM11.027 8.40624C10.3105 8.40624 9.72973 9.01234 9.72973 9.76001C9.72973 10.5077 10.3105 11.1138 11.027 11.1138C11.7435 11.1138 12.3243 10.5077 12.3243 9.76001C12.3243 9.01234 11.7435 8.40624 11.027 8.40624ZM10.5946 12.0163V13.0544L11.027 12.8037L11.4595 13.0544V12.0163H10.5946Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Certification_ISO9001 = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M5.98313 7.507C6.03912 7.5 6.07996 7.493 6.10563 7.486V5.638C6.10563 5.57733 6.09863 5.52833 6.08463 5.491C6.07062 5.45367 6.04962 5.4245 6.02163 5.4035C5.99363 5.3825 5.95862 5.3685 5.91663 5.3615C5.87696 5.35217 5.83029 5.3475 5.77663 5.3475C5.72529 5.3475 5.67163 5.35217 5.61562 5.3615C5.55963 5.3685 5.51879 5.37433 5.49312 5.379V7.227C5.49312 7.28767 5.50012 7.33667 5.51412 7.374C5.52812 7.41133 5.54913 7.4405 5.57713 7.4615C5.60512 7.4825 5.63896 7.4965 5.67863 7.5035C5.72062 7.51283 5.76846 7.5175 5.82212 7.5175C5.87579 7.5175 5.92946 7.514 5.98313 7.507Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M6.88153 6.5515C6.96553 6.5865 7.05886 6.6215 7.16153 6.6565L7.30853 6.7055C7.3762 6.72883 7.4287 6.75333 7.46603 6.779C7.50336 6.80233 7.52203 6.83733 7.52203 6.884C7.52203 6.93067 7.4987 6.9715 7.45203 7.0065C7.40536 7.0415 7.32486 7.059 7.21053 7.059C7.09853 7.059 6.9947 7.04033 6.89903 7.003C6.8057 6.96567 6.72636 6.92133 6.66103 6.87C6.61436 6.89567 6.5712 6.933 6.53153 6.982C6.49186 7.02867 6.47203 7.08583 6.47203 7.1535C6.47203 7.21883 6.4907 7.27717 6.52803 7.3285C6.5677 7.3775 6.62136 7.4195 6.68903 7.4545C6.75903 7.48717 6.83953 7.51167 6.93053 7.528C7.02386 7.54667 7.1242 7.556 7.23153 7.556C7.53486 7.556 7.7647 7.49533 7.92103 7.374C8.07736 7.25033 8.15553 7.08933 8.15553 6.891C8.15553 6.70433 8.09603 6.55733 7.97703 6.45C7.86036 6.34033 7.69236 6.2505 7.47303 6.1805L7.28753 6.121C7.22686 6.10233 7.18136 6.0825 7.15103 6.0615C7.1207 6.03817 7.10553 6.009 7.10553 5.974C7.10553 5.92967 7.13003 5.8935 7.17903 5.8655C7.22803 5.83517 7.30503 5.82 7.41003 5.82C7.5127 5.82 7.6072 5.83283 7.69353 5.8585C7.77986 5.88183 7.8487 5.90983 7.90003 5.9425C7.9397 5.91217 7.97353 5.876 8.00153 5.834C8.02953 5.78967 8.04353 5.73717 8.04353 5.6765C8.04353 5.61583 8.02603 5.56333 7.99103 5.519C7.95603 5.47233 7.90703 5.435 7.84403 5.407C7.78336 5.37667 7.70986 5.3545 7.62353 5.3405C7.5372 5.3265 7.44386 5.3195 7.34353 5.3195C7.0682 5.3195 6.85353 5.379 6.69953 5.498C6.54786 5.617 6.47203 5.77567 6.47203 5.974C6.47203 6.07667 6.48836 6.16417 6.52103 6.2365C6.55603 6.3065 6.60386 6.36717 6.66453 6.4185C6.7252 6.46983 6.79753 6.51417 6.88153 6.5515Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.47994 5.953C8.42394 6.093 8.39594 6.254 8.39594 6.436C8.39594 6.61567 8.42394 6.7755 8.47994 6.9155C8.53594 7.0555 8.61294 7.17333 8.71094 7.269C8.80894 7.36467 8.9256 7.43817 9.06094 7.4895C9.19627 7.5385 9.34327 7.563 9.50194 7.563C9.6606 7.563 9.8076 7.5385 9.94294 7.4895C10.0783 7.4405 10.1949 7.36933 10.2929 7.276C10.3933 7.18033 10.4714 7.0625 10.5274 6.9225C10.5834 6.78017 10.6114 6.618 10.6114 6.436C10.6114 6.254 10.5823 6.093 10.5239 5.953C10.4679 5.813 10.3898 5.69633 10.2894 5.603C10.1891 5.50733 10.0713 5.435 9.93594 5.386C9.80294 5.337 9.65827 5.3125 9.50194 5.3125C9.3456 5.3125 9.19977 5.337 9.06444 5.386C8.93144 5.435 8.81477 5.50733 8.71444 5.603C8.61644 5.69633 8.53827 5.813 8.47994 5.953ZM9.15544 6.912C9.0691 6.807 9.02594 6.64833 9.02594 6.436C9.02594 6.22367 9.0691 6.06617 9.15544 5.9635C9.2441 5.8585 9.36077 5.806 9.50544 5.806C9.65244 5.806 9.76794 5.8585 9.85194 5.9635C9.93827 6.0685 9.98144 6.226 9.98144 6.436C9.98144 6.64833 9.93827 6.807 9.85194 6.912C9.7656 7.017 9.64894 7.0695 9.50194 7.0695C9.35727 7.0695 9.24177 7.017 9.15544 6.912Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.33069 10.4715C5.24202 10.5485 5.12302 10.587 4.97369 10.587C4.91536 10.587 4.85119 10.58 4.78119 10.566C4.71352 10.5497 4.64819 10.5275 4.58519 10.4995C4.55486 10.5228 4.52802 10.5578 4.50469 10.6045C4.48369 10.6488 4.47319 10.6955 4.47319 10.7445C4.47319 10.8495 4.52569 10.9277 4.63069 10.979C4.73569 11.0303 4.88152 11.056 5.06819 11.056C5.21519 11.056 5.34936 11.0315 5.47069 10.9825C5.59202 10.9335 5.69586 10.86 5.78219 10.762C5.87086 10.664 5.93969 10.5415 5.98869 10.3945C6.03769 10.2475 6.06219 10.0772 6.06219 9.8835C6.06219 9.54283 5.98286 9.28033 5.82419 9.096C5.66786 8.91167 5.45202 8.8195 5.17669 8.8195C5.03902 8.8195 4.91769 8.8405 4.81269 8.8825C4.71002 8.92217 4.62369 8.977 4.55369 9.047C4.48369 9.11467 4.43119 9.194 4.39619 9.285C4.36119 9.37367 4.34369 9.46817 4.34369 9.5685C4.34369 9.68283 4.36119 9.78317 4.39619 9.8695C4.43119 9.95583 4.48019 10.0293 4.54319 10.09C4.60619 10.1483 4.68086 10.1927 4.76719 10.223C4.85586 10.2533 4.95386 10.2685 5.06119 10.2685C5.16852 10.2685 5.25602 10.2545 5.32369 10.2265C5.39369 10.1985 5.44152 10.174 5.46719 10.153C5.46719 10.2883 5.42169 10.3945 5.33069 10.4715ZM5.33069 9.7925C5.28636 9.81117 5.24202 9.8205 5.19769 9.8205C5.12069 9.8205 5.05769 9.79717 5.00869 9.7505C4.95969 9.7015 4.93519 9.63733 4.93519 9.558C4.93519 9.47633 4.95619 9.41217 4.99819 9.3655C5.04252 9.3165 5.10319 9.292 5.18019 9.292C5.26652 9.292 5.33186 9.32233 5.37619 9.383C5.42052 9.44367 5.44386 9.5405 5.44619 9.6735V9.7155C5.41586 9.74817 5.37736 9.77383 5.33069 9.7925Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.11185 10.4155C8.15852 10.2755 8.18185 10.1157 8.18185 9.936C8.18185 9.75633 8.15852 9.59767 8.11185 9.46C8.06518 9.32 7.99985 9.20333 7.91585 9.11C7.83418 9.01433 7.73502 8.942 7.61835 8.893C7.50402 8.844 7.37918 8.8195 7.24385 8.8195C7.10618 8.8195 6.97902 8.844 6.86235 8.893C6.74802 8.942 6.64885 9.01433 6.56485 9.11C6.48318 9.20333 6.41902 9.32 6.37235 9.46C6.32802 9.59767 6.30585 9.75633 6.30585 9.936C6.30585 10.1157 6.32802 10.2755 6.37235 10.4155C6.41902 10.5555 6.48318 10.6733 6.56485 10.769C6.64885 10.8623 6.74802 10.9335 6.86235 10.9825C6.97902 11.0315 7.10618 11.056 7.24385 11.056C7.37918 11.056 7.50402 11.0315 7.61835 10.9825C7.73502 10.9335 7.83418 10.8623 7.91585 10.769C7.99985 10.6733 8.06518 10.5555 8.11185 10.4155ZM7.49235 9.46C7.55302 9.572 7.58335 9.73067 7.58335 9.936C7.58335 10.1413 7.55302 10.3012 7.49235 10.4155C7.43402 10.5275 7.35002 10.5835 7.24035 10.5835C7.13068 10.5835 7.04668 10.5275 6.98835 10.4155C6.93235 10.3012 6.90435 10.1413 6.90435 9.936C6.90435 9.73067 6.93235 9.572 6.98835 9.46C7.04668 9.348 7.13068 9.292 7.24035 9.292C7.35002 9.292 7.43402 9.348 7.49235 9.46Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.2344 10.4155C10.2811 10.2755 10.3044 10.1157 10.3044 9.936C10.3044 9.75633 10.2811 9.59767 10.2344 9.46C10.1877 9.32 10.1224 9.20333 10.0384 9.11C9.95674 9.01433 9.85757 8.942 9.74091 8.893C9.62657 8.844 9.50174 8.8195 9.36641 8.8195C9.22874 8.8195 9.10157 8.844 8.98491 8.893C8.87057 8.942 8.77141 9.01433 8.68741 9.11C8.60574 9.20333 8.54157 9.32 8.49491 9.46C8.45057 9.59767 8.42841 9.75633 8.42841 9.936C8.42841 10.1157 8.45057 10.2755 8.49491 10.4155C8.54157 10.5555 8.60574 10.6733 8.68741 10.769C8.77141 10.8623 8.87057 10.9335 8.98491 10.9825C9.10157 11.0315 9.22874 11.056 9.36641 11.056C9.50174 11.056 9.62657 11.0315 9.74091 10.9825C9.85757 10.9335 9.95674 10.8623 10.0384 10.769C10.1224 10.6733 10.1877 10.5555 10.2344 10.4155ZM9.61491 9.46C9.67558 9.572 9.70591 9.73067 9.70591 9.936C9.70591 10.1413 9.67558 10.3012 9.61491 10.4155C9.55657 10.5275 9.47258 10.5835 9.36291 10.5835C9.25324 10.5835 9.16924 10.5275 9.11091 10.4155C9.05491 10.3012 9.02691 10.1413 9.02691 9.936C9.02691 9.73067 9.05491 9.572 9.11091 9.46C9.16924 9.348 9.25324 9.292 9.36291 9.292C9.47258 9.292 9.55657 9.348 9.61491 9.46Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M10.5868 9.5475L10.9368 9.439V10.748C10.9368 10.8063 10.9438 10.8542 10.9578 10.8915C10.9741 10.9265 10.9963 10.9545 11.0243 10.9755C11.0523 10.9965 11.0861 11.0105 11.1258 11.0175C11.1678 11.0245 11.2145 11.028 11.2658 11.028C11.3171 11.028 11.3673 11.0233 11.4163 11.014C11.4676 11.007 11.5061 11.0012 11.5318 10.9965V9.173C11.5318 9.07267 11.5026 8.99333 11.4443 8.935C11.386 8.87667 11.3066 8.8475 11.2063 8.8475H11.0768L10.6848 8.9805C10.5145 9.0365 10.4293 9.1345 10.4293 9.2745C10.4293 9.34917 10.4468 9.4075 10.4818 9.4495C10.5168 9.4915 10.5518 9.52417 10.5868 9.5475Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.80695 13.4422C5.48322 13.4514 5.7006 13.5424 5.7006 13.5424C5.92245 13.6354 6.42169 14.1138 6.42169 14.1138C6.84047 14.5151 7.07611 14.6779 7.07611 14.6779C7.54229 15 8 15 8 15C8.45973 15 8.93275 14.6726 8.93275 14.6726C9.17157 14.5074 9.5962 14.1015 9.5962 14.1015C10.09 13.6295 10.2983 13.5429 10.2983 13.5429C10.5023 13.4581 11.1683 13.4477 11.1683 13.4477C11.7551 13.4385 12.0441 13.3858 12.0441 13.3858C12.6126 13.282 12.9473 12.9473 12.9473 12.9473C13.28 12.6146 13.3822 12.0557 13.3822 12.0557C13.4342 11.7713 13.4422 11.193 13.4422 11.193C13.4514 10.5168 13.5424 10.2994 13.5424 10.2994C13.6353 10.0775 14.1138 9.57831 14.1138 9.57831C14.5151 9.15953 14.6779 8.92389 14.6779 8.92389C15 8.45771 15 8 15 8C15 7.54027 14.6726 7.06725 14.6726 7.06725C14.5074 6.82843 14.1015 6.4038 14.1015 6.4038C13.6295 5.91 13.5429 5.70173 13.5429 5.70173C13.4581 5.49772 13.4477 4.83171 13.4477 4.83171C13.4385 4.24492 13.3858 3.95591 13.3858 3.95591C13.282 3.38742 12.9473 3.0527 12.9473 3.0527C12.6146 2.71998 12.0557 2.61777 12.0557 2.61777C11.7712 2.56575 11.193 2.55785 11.193 2.55785C10.5168 2.5486 10.2994 2.45756 10.2994 2.45756C10.0775 2.36465 9.57831 1.88621 9.57831 1.88621C9.15953 1.48489 8.92389 1.32209 8.92389 1.32209C8.45771 1 8 1 8 1C7.54027 1 7.06725 1.32735 7.06725 1.32735C6.82843 1.49262 6.4038 1.89849 6.4038 1.89849C5.91 2.37047 5.70173 2.45709 5.70173 2.45709C5.49772 2.54194 4.83171 2.55233 4.83171 2.55233C4.24492 2.56147 3.9559 2.61422 3.9559 2.61422C3.38742 2.71797 3.0527 3.0527 3.0527 3.0527C2.71998 3.38541 2.61777 3.94434 2.61777 3.94434C2.56575 4.22875 2.55785 4.80695 2.55785 4.80695C2.5486 5.48322 2.45756 5.7006 2.45756 5.7006C2.36465 5.92245 1.88621 6.42169 1.88621 6.42169C1.48489 6.84047 1.32209 7.07611 1.32209 7.07611C1 7.54229 1 8 1 8C1 8.45973 1.32735 8.93275 1.32735 8.93275C1.49262 9.17157 1.89849 9.5962 1.89849 9.5962C2.37047 10.09 2.45709 10.2983 2.45709 10.2983C2.54194 10.5023 2.55233 11.1683 2.55233 11.1683C2.56147 11.7551 2.61422 12.0441 2.61422 12.0441C2.71797 12.6126 3.0527 12.9473 3.0527 12.9473C3.38541 13.28 3.94434 13.3822 3.94434 13.3822C4.22875 13.4342 4.80695 13.4422 4.80695 13.4422ZM7.1136 13.3918C6.48017 12.7848 6.0869 12.6201 6.0869 12.6201C5.69072 12.4541 4.82062 12.4422 4.82062 12.4422C3.94995 12.4303 3.7598 12.2402 3.7598 12.2402C3.56614 12.0465 3.5522 11.1527 3.5522 11.1527C3.53884 10.2951 3.38041 9.91423 3.38041 9.91423C3.22219 9.53382 2.62139 8.90525 2.62139 8.90525C2 8.25513 2 8 2 8C2 7.74824 2.6082 7.1136 2.6082 7.1136C3.21523 6.48017 3.37994 6.0869 3.37994 6.0869C3.54586 5.69072 3.55775 4.82062 3.55775 4.82062C3.56966 3.94995 3.7598 3.7598 3.7598 3.7598C3.95347 3.56614 4.84729 3.5522 4.84729 3.5522C5.70487 3.53884 6.08577 3.38041 6.08577 3.38041C6.46618 3.22219 7.09475 2.62139 7.09475 2.62139C7.74487 2 8 2 8 2C8.25176 2 8.8864 2.6082 8.8864 2.6082C9.51983 3.21523 9.9131 3.37994 9.9131 3.37994C10.3093 3.54586 11.1794 3.55775 11.1794 3.55775C12.0501 3.56966 12.2402 3.7598 12.2402 3.7598C12.4339 3.95347 12.4478 4.84729 12.4478 4.84729C12.4612 5.70487 12.6196 6.08577 12.6196 6.08577C12.7778 6.46618 13.3786 7.09475 13.3786 7.09475C14 7.74487 14 8 14 8C14 8.25176 13.3918 8.8864 13.3918 8.8864C12.7848 9.51983 12.6201 9.9131 12.6201 9.9131C12.4541 10.3093 12.4422 11.1794 12.4422 11.1794C12.4303 12.0501 12.2402 12.2402 12.2402 12.2402C12.0465 12.4339 11.1527 12.4478 11.1527 12.4478C10.2951 12.4612 9.91423 12.6196 9.91423 12.6196C9.53382 12.7778 8.90525 13.3786 8.90525 13.3786C8.25513 14 8 14 8 14C7.74824 14 7.1136 13.3918 7.1136 13.3918Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Chainlink = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.36136 1.20523C7.81781 0.93159 7.18219 0.93159 6.63864 1.20523C6.63359 1.20777 6.62859 1.2104 6.62363 1.21311L1.9329 3.77697C1.91955 3.78426 1.90654 3.79217 1.8939 3.80065C1.36431 4.15613 1 4.78032 1 5.43614V10.5639C1 11.2032 1.35355 11.8582 1.93691 12.1578L6.6188 14.7842C6.62533 14.7879 6.63195 14.7914 6.63864 14.7948C7.18219 15.0684 7.81781 15.0684 8.36136 14.7948C8.36451 14.7932 8.36765 14.7916 8.37078 14.7899C8.37427 14.788 8.37775 14.7862 8.3812 14.7842L13.0719 12.1529C13.0836 12.1463 13.095 12.1393 13.1061 12.1319C13.6112 11.7929 14 11.2455 14 10.5639V5.43614C14 4.79684 13.6464 4.14175 13.0631 3.84215L8.3812 1.21578C8.37467 1.21212 8.36805 1.2086 8.36136 1.20523ZM2.43459 4.65431L7.09494 2.10705C7.35097 1.98074 7.64659 1.98038 7.90284 2.10597L12.5827 4.7312C12.5893 4.73487 12.5959 4.73839 12.6026 4.74176C12.8168 4.84959 12.9948 5.13488 12.9948 5.43614V10.5639C12.9948 10.8222 12.8526 11.08 12.5639 11.2794L7.90284 13.894C7.64733 14.0193 7.35267 14.0193 7.09716 13.894L2.41729 11.2688C2.41075 11.2651 2.40413 11.2616 2.39744 11.2582C2.18324 11.1504 2.00515 10.8651 2.00515 10.5639V5.43614C2.00515 5.15336 2.16991 4.84022 2.43459 4.65431Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Check = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M15.7573 2.77217C16.1114 2.33087 16.0736 1.65706 15.6727 1.26718C15.2719 0.877304 14.6599 0.918995 14.3057 1.3603L5.42755 12.4239L1.61413 8.5C1.21545 8.10743 0.603201 8.145 0.246623 8.58391C-0.109955 9.02283 -0.0758288 9.69688 0.322845 10.0894L4.86256 14.7285C5.05477 14.9178 5.30762 15.0148 5.56505 14.9982C5.82249 14.9815 6.06326 14.8525 6.234 14.6397L15.7573 2.77217Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const CheckVert = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8Z",
          fill: "#91D16A"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M11.8787 5.7595C12.0557 5.57037 12.0368 5.2816 11.8364 5.11451C11.6359 4.94742 11.3299 4.96528 11.1529 5.15441L6.71377 9.89595L4.80706 8.21429C4.60773 8.04604 4.3016 8.06214 4.12331 8.25025C3.94502 8.43835 3.96208 8.72723 4.16142 8.89548L6.43128 10.8836C6.52739 10.9648 6.65381 11.0064 6.78253 10.9992C6.91124 10.9921 7.03163 10.9368 7.117 10.8456L11.8787 5.7595Z",
          fill: "white"
        }
      )
    );
  }
);
const ChevronPleinBas = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M8.266 10.2427C8.36608 10.3727 8.56213 10.3727 8.6622 10.2427L11.6184 6.4025C11.7449 6.23811 11.6277 6 11.4203 6H5.50794C5.30049 6 5.18329 6.23811 5.30984 6.4025L8.266 10.2427Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const ChevronPleinHaut = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M8.266 6.25734C8.36608 6.12734 8.56213 6.12734 8.6622 6.25734L11.6184 10.0975C11.7449 10.2619 11.6277 10.5 11.4203 10.5H5.50794C5.30049 10.5 5.18329 10.2619 5.30984 10.0975L8.266 6.25734Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Chevron$1 = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.99002 0.292893C4.60204 -0.0976311 3.97302 -0.0976311 3.58505 0.292893C3.19707 0.683417 3.19707 1.31658 3.58505 1.70711L8.84335 7C8.84335 7 9.25485 7.44772 9.25485 8C9.25485 8.55228 9.25485 8.5 8.84333 9L3.58505 14.2929C3.19707 14.6834 3.19707 15.3166 3.58505 15.7071C3.97302 16.0976 4.60204 16.0976 4.99002 15.7071L11.9436 8.70782C11.946 8.70541 11.9483 8.70298 11.9507 8.70055C12.1261 8.52079 12.2344 8.27463 12.2352 8.003L12.2352 8L12.2352 7.997C12.2348 7.8625 12.2081 7.73425 12.1599 7.61722C12.1125 7.50195 12.0428 7.3938 11.9507 7.29945C11.9484 7.29705 11.946 7.29466 11.9437 7.29228M11.9437 7.29228L4.99002 0.292893L11.9437 7.29228Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Cheque = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M2.5 5C2.22386 5 2 5.22386 2 5.5C2 5.77614 2.22386 6 2.5 6H10.5C10.7761 6 11 5.77614 11 5.5C11 5.22386 10.7761 5 10.5 5H2.5Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M2.5 7C2.22386 7 2 7.22386 2 7.5C2 7.77614 2.22386 8 2.5 8H10.5C10.7761 8 11 7.77614 11 7.5C11 7.22386 10.7761 7 10.5 7H2.5Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.7362 8.49501C10.8062 8.42896 10.8963 8.375 11 8.375C11.2762 8.375 11.5734 8.47945 11.7361 8.72417C11.9032 8.97569 11.8999 9.33086 11.6657 9.76811C11.5476 9.98864 11.3827 10.1689 11.2017 10.3143C11.2954 10.3626 11.4046 10.3841 11.5424 10.3695C11.6497 10.3581 11.7 10.2912 11.7445 10.1846C11.7546 10.1604 11.7634 10.1364 11.7728 10.1111L11.7758 10.103C11.7857 10.0762 11.797 10.046 11.8097 10.0188C11.8219 9.99269 11.8399 9.95933 11.8676 9.93153C11.8983 9.90058 11.9429 9.87497 12 9.87497C12.074 9.87497 12.1213 9.92054 12.1458 9.95621C12.1691 9.99017 12.183 10.0301 12.1924 10.0628C12.2062 10.1109 12.2173 10.1721 12.2272 10.2269C12.2307 10.2457 12.2339 10.2637 12.2371 10.2802C12.2487 10.3398 12.2598 10.3831 12.2711 10.411C12.3136 10.3881 12.3581 10.3517 12.4062 10.3029C12.4507 10.2578 12.4922 10.2088 12.5358 10.1573L12.5776 10.1081C12.6331 10.0435 12.697 9.9723 12.7664 9.92499C12.8394 9.8752 12.9386 9.83915 13.0479 9.88451C13.1484 9.92619 13.1991 10.0076 13.2162 10.0921C13.232 10.1696 13.2204 10.2502 13.2047 10.3143C13.1987 10.339 13.1916 10.363 13.1841 10.3857C13.6737 10.4139 13.8125 10.4139 14.2089 10.4139H14.2111V10.6639C13.7643 10.6639 13.6374 10.6639 12.9924 10.6247L12.7961 10.6128L12.8902 10.4403L12.8917 10.4375L12.8972 10.4265C12.9021 10.4168 12.909 10.4024 12.9167 10.3847C12.9325 10.3488 12.9503 10.3021 12.9619 10.2548C12.974 10.2054 12.9763 10.1668 12.9713 10.1419C12.9676 10.124 12.9628 10.1199 12.9521 10.1154C12.9496 10.1142 12.9399 10.1092 12.9072 10.1316C12.8687 10.1578 12.8244 10.2044 12.7673 10.2709L12.7308 10.3139C12.6862 10.3667 12.6361 10.4259 12.5842 10.4785C12.5171 10.5465 12.4364 10.6148 12.3409 10.6544C12.2895 10.6757 12.2305 10.6818 12.1731 10.6572C12.1195 10.6343 12.0858 10.5925 12.0649 10.557C12.0253 10.4896 12.0054 10.3985 11.9917 10.3278C11.9876 10.3067 11.9839 10.2868 11.9805 10.268L11.9752 10.2809C11.9205 10.4119 11.8169 10.5918 11.5687 10.6181C11.3281 10.6436 11.1384 10.5848 10.9811 10.471C10.6265 10.6939 10.2467 10.8091 10.0205 10.8467L9.97953 10.6C10.1677 10.5688 10.4893 10.4729 10.7967 10.2907C10.7327 10.2117 10.6593 10.1102 10.5938 10.0085C10.5385 9.92255 10.4857 9.83167 10.4462 9.74777C10.4092 9.6691 10.375 9.57863 10.375 9.5C10.375 9.22992 10.4456 8.96054 10.5498 8.75582C10.6018 8.65351 10.6648 8.56236 10.7362 8.49501ZM11.0052 10.1507C11.1818 10.0161 11.338 9.85053 11.4454 9.65008C11.6556 9.25749 11.6246 9.00811 11.5278 8.86254C11.4266 8.71018 11.2238 8.625 11 8.625C10.9853 8.625 10.9536 8.63354 10.9077 8.67687C10.8632 8.71889 10.8159 8.78399 10.7726 8.86918C10.686 9.03946 10.625 9.27008 10.625 9.5C10.625 9.51872 10.6367 9.56549 10.6724 9.64131C10.7057 9.7119 10.7523 9.79275 10.8041 9.87316C10.8748 9.98307 10.9494 10.0835 11.0052 10.1507Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 4C0 3.44772 0.447715 3 1 3H15C15.5523 3 16 3.44772 16 4V12C16 12.5523 15.5523 13 15 13H1C0.447715 13 0 12.5523 0 12V4ZM1.25 11.75V4.25H14.75V11.75H1.25Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Cheque2 = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M2.05654 5.63855C1.84604 5.63855 1.67539 5.81705 1.67539 6.03724C1.67539 6.25743 1.84604 6.43593 2.05654 6.43593H9.3445C9.55501 6.43593 9.72565 6.25743 9.72565 6.03724C9.72565 5.81705 9.55501 5.63855 9.3445 5.63855H2.05654Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M1.67539 7.43045C1.67539 7.21026 1.84604 7.03176 2.05654 7.03176H7.61885C7.82935 7.03176 8 7.21026 8 7.43045C8 7.65064 7.82935 7.82913 7.61885 7.82913H2.05654C1.84604 7.82913 1.67539 7.65064 1.67539 7.43045Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M2.05654 9.63417C1.84604 9.63417 1.67539 9.81267 1.67539 10.0329C1.67539 10.253 1.84604 10.4315 2.05654 10.4315H5.18115C5.39166 10.4315 5.5623 10.253 5.5623 10.0329C5.5623 9.81267 5.39166 9.63417 5.18115 9.63417H2.05654Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.7843 8.19814C12.8336 8.37097 12.8181 8.60684 12.7313 8.89708C12.6195 9.27106 12.4679 9.57601 12.3104 9.81598C12.3358 9.86833 12.3611 9.89896 12.3826 9.91735C12.4077 9.93888 12.4352 9.95019 12.4692 9.95451C12.4706 9.95469 12.4718 9.9548 12.4729 9.95487C12.4734 9.95398 12.474 9.95292 12.4746 9.95167C12.4753 9.95029 12.4761 9.94869 12.477 9.94683C12.4831 9.93317 12.4888 9.91252 12.4924 9.88547C12.496 9.85903 12.4968 9.83116 12.4958 9.80602C12.4927 9.72946 12.5388 9.65726 12.6128 9.63478C12.6926 9.61056 12.7751 9.65332 12.807 9.73174C12.8117 9.7434 12.8156 9.75442 12.8187 9.7632C12.8194 9.76497 12.8199 9.7666 12.8205 9.76812L12.8219 9.77232C12.8237 9.77723 12.825 9.78109 12.8266 9.78551C12.8271 9.78678 12.8275 9.78795 12.8279 9.78903C12.8295 9.78808 12.8316 9.7867 12.8341 9.78471C12.8485 9.77344 12.8651 9.75275 12.8792 9.72767C12.9067 9.67865 12.9493 9.65679 12.9802 9.64855C13.0104 9.64048 13.0383 9.64232 13.0602 9.64743C13.082 9.65254 13.1078 9.66325 13.1317 9.68365C13.1559 9.70438 13.1855 9.74239 13.1912 9.79837C13.1942 9.82896 13.2043 9.86427 13.2236 9.8932C13.2409 9.91922 13.2685 9.94482 13.319 9.95857L13.3193 9.95866L13.3197 9.95876C13.3226 9.95958 13.3249 9.95999 13.3265 9.96019C13.3274 9.9603 13.3281 9.96035 13.3286 9.96037C13.3293 9.96039 13.3298 9.96036 13.33 9.96034L13.3302 9.96032L13.3302 9.96031L13.3303 9.9603C13.3303 9.9603 13.3304 9.96026 13.3306 9.96016C13.331 9.95997 13.332 9.95944 13.3335 9.95825C13.3367 9.95569 13.3415 9.95084 13.3469 9.94287C13.3522 9.93496 13.3568 9.92598 13.3602 9.91748C13.392 9.83763 13.4646 9.81046 13.5165 9.81176C13.5689 9.81307 13.6443 9.84538 13.6699 9.933C13.7148 10.0869 13.835 10.3859 14.0113 10.573L14.0143 10.5761L14.0171 10.5794C14.0586 10.6285 14.0961 10.662 14.1173 10.6788C14.184 10.7316 14.1909 10.8135 14.1747 10.8675C14.1583 10.922 14.1059 10.988 14.0184 10.988H11.0325C10.9469 10.988 10.8775 10.9154 10.8775 10.8258C10.8775 10.7363 10.9469 10.6637 11.0325 10.6637H13.6785C13.5835 10.5315 13.5092 10.3846 13.4557 10.2568C13.3942 10.2852 13.321 10.2945 13.2405 10.2722C13.1098 10.2365 13.0238 10.1615 12.9688 10.0778C12.9144 10.1071 12.8467 10.1246 12.7698 10.1093C12.7624 10.1078 12.7551 10.1061 12.7481 10.1043C12.7247 10.1498 12.69 10.1964 12.6388 10.2306C12.5777 10.2714 12.5063 10.2858 12.4319 10.2764C12.3475 10.2656 12.2627 10.2337 12.1862 10.1682C12.1584 10.1444 12.1329 10.1172 12.1094 10.0866C11.9475 10.2788 11.7947 10.4031 11.6889 10.4641C11.6139 10.5073 11.5196 10.4788 11.4783 10.4004C11.437 10.322 11.4643 10.2234 11.5393 10.1802C11.6273 10.1295 11.7898 9.99487 11.9618 9.76529C11.9027 9.54947 11.872 9.25212 11.872 8.84871C11.872 8.5786 11.9329 8.35635 12.0284 8.19437C12.1207 8.03766 12.2587 7.9184 12.4163 7.90485C12.4983 7.8978 12.58 7.9209 12.6482 7.97693C12.7149 8.03171 12.7591 8.1099 12.7843 8.19814ZM12.2061 9.37325C12.1908 9.23233 12.1819 9.05966 12.1819 8.84871C12.1819 8.62829 12.2318 8.46715 12.2922 8.36448C12.3559 8.25655 12.419 8.22992 12.4417 8.22797C12.4499 8.22726 12.4533 8.22901 12.4567 8.23187C12.4617 8.23599 12.4758 8.25073 12.4873 8.29094C12.5113 8.375 12.5139 8.53803 12.4355 8.80034C12.3703 9.01839 12.291 9.20887 12.2061 9.37325ZM12.4773 9.95489C12.4774 9.95486 12.4775 9.95486 12.4775 9.95486C12.4775 9.95486 12.4775 9.95487 12.4773 9.95489Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.6723 6.19934C10.6723 5.93802 10.8748 5.72618 11.1246 5.72618H14.2576C14.5074 5.72618 14.7099 5.93802 14.7099 6.19934C14.7099 6.46066 14.5074 6.67251 14.2576 6.67251H11.1246C10.8748 6.67251 10.6723 6.46066 10.6723 6.19934ZM11.1246 6.03286H14.2576C14.3455 6.03286 14.4168 6.1074 14.4168 6.19934C14.4168 6.29129 14.3455 6.36583 14.2576 6.36583H11.1246C11.0367 6.36583 10.9654 6.29129 10.9654 6.19934C10.9654 6.1074 11.0367 6.03286 11.1246 6.03286Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 4.77985C0 4.34915 0.333794 4 0.74555 4H15.2545C15.6662 4 16 4.34915 16 4.77985V11.2202C16 11.6509 15.6662 12 15.2545 12H0.74555C0.333794 12 0 11.6509 0 11.2202V4.77985ZM0.762304 11.2026V4.79737H15.2377V11.2026H0.762304Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Chequier_classique = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M3.90698 7.41897C3.76998 7.41897 3.65892 7.53535 3.65892 7.67891C3.65892 7.82247 3.76998 7.93885 3.90698 7.93885H5.27132C5.40832 7.93885 5.51938 7.82247 5.51938 7.67891C5.51938 7.53535 5.40832 7.41897 5.27132 7.41897H3.90698Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M3.65892 8.91362C3.65892 8.77006 3.76998 8.65369 3.90698 8.65369H9.48837C9.62538 8.65369 9.73644 8.77006 9.73644 8.91362C9.73644 9.05719 9.62538 9.17356 9.48837 9.17356H3.90698C3.76998 9.17356 3.65892 9.05719 3.65892 8.91362Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M3.90698 10.1483C3.76998 10.1483 3.65892 10.2647 3.65892 10.4083C3.65892 10.5518 3.76998 10.6682 3.90698 10.6682H9.48837C9.62538 10.6682 9.73644 10.5518 9.73644 10.4083C9.73644 10.2647 9.62538 10.1483 9.48837 10.1483H3.90698Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M11.2248 10.4083C11.2248 10.2647 11.3359 10.1483 11.4729 10.1483H14.2016C14.3386 10.1483 14.4496 10.2647 14.4496 10.4083C14.4496 10.5518 14.3386 10.6682 14.2016 10.6682H11.4729C11.3359 10.6682 11.2248 10.5518 11.2248 10.4083Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.36434 6.63915C9.36434 6.17258 9.72529 5.79435 10.1705 5.79435H13.7674C14.2127 5.79435 14.5736 6.17258 14.5736 6.63915C14.5736 7.10573 14.2127 7.48396 13.7674 7.48396H10.1705C9.72529 7.48396 9.36434 7.10573 9.36434 6.63915ZM10.1705 6.31423H13.7674C13.9387 6.31423 14.0775 6.4597 14.0775 6.63915C14.0775 6.8186 13.9387 6.96408 13.7674 6.96408H10.1705C9.99929 6.96408 9.86047 6.8186 9.86047 6.63915C9.86047 6.4597 9.99929 6.31423 10.1705 6.31423Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1.52189 3C0.681379 3 7.71743e-06 3.714 7.71743e-06 4.59476V11.2504C-2.57394e-06 11.252 -2.57101e-06 11.2537 7.71743e-06 11.2554V11.3459L0.00197657 11.3659C0.0350518 11.7015 0.0985869 12.0019 0.236522 12.2486C0.383613 12.5117 0.596517 12.6814 0.863762 12.7856C1.11561 12.8839 1.4175 12.9249 1.75693 12.9463C2.06636 12.9657 2.43706 12.9701 2.86861 12.9752L2.87065 12.9752C2.91615 12.9758 2.96233 12.9763 3.00918 12.9769C4.26326 12.9922 5.83534 12.9923 7.30602 12.9923H7.30631C8.46564 12.9923 9.56198 12.9924 10.3898 12.9999C10.6121 13.0019 10.8825 12.9766 11.1218 12.8716C11.3729 12.7613 11.6172 12.5471 11.6871 12.1798C11.7191 12.0119 11.7245 11.8459 11.7191 11.708H15.0078C15.5558 11.708 16 11.2425 16 10.6682V5.27447C16 4.70023 15.5558 4.23471 15.0078 4.23471H3.00483C2.84906 3.52736 2.24425 3 1.52189 3ZM0.878643 11.8545C0.828283 11.7644 0.784741 11.6254 0.755083 11.3987C0.901423 11.26 1.11914 11.1209 1.37458 11.0745C1.65268 11.024 2.01807 11.0749 2.43955 11.4473C2.49045 11.5991 2.62845 11.708 2.7907 11.708H10.974C10.9798 11.8076 10.9773 11.9225 10.9573 12.0272C10.9492 12.0701 10.9284 12.111 10.8342 12.1523C10.7282 12.1988 10.5731 12.2217 10.3962 12.2201C9.54628 12.2124 8.4473 12.2124 7.28981 12.2125H7.28943C5.83146 12.2125 4.28066 12.2126 3.01786 12.1971C2.97132 12.1966 2.92571 12.196 2.881 12.1955C2.44314 12.1903 2.09168 12.1861 1.80155 12.1678C1.47868 12.1475 1.26782 12.1112 1.12346 12.0549C0.994491 12.0045 0.927715 11.9422 0.878643 11.8545ZM1.24749 10.3062C1.57664 10.2464 1.93402 10.2785 2.29959 10.4427V4.59476C2.29959 4.14468 1.95141 3.77982 1.52189 3.77982C1.09238 3.77982 0.744193 4.14468 0.744193 4.59476V10.4765C0.895701 10.4 1.06438 10.3394 1.24749 10.3062ZM3.1628 5.01453H15.0078C15.1448 5.01453 15.2558 5.13091 15.2558 5.27447V10.6682C15.2558 10.8118 15.1448 10.9282 15.0078 10.9282H3.1628V5.01453Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Chequier_portefeuille = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.66021 6.53165C9.22516 6.53165 8.87247 6.87636 8.87247 7.30159C8.87247 7.72682 9.22516 8.07154 9.66021 8.07154H13.1747C13.6098 8.07154 13.9625 7.72682 13.9625 7.30159C13.9625 6.87636 13.6098 6.53165 13.1747 6.53165H9.66021ZM13.1747 7.00546H9.66021C9.49288 7.00546 9.35724 7.13804 9.35724 7.30159C9.35724 7.46514 9.49288 7.59773 9.66021 7.59773H13.1747C13.3421 7.59773 13.4777 7.46514 13.4777 7.30159C13.4777 7.13804 13.3421 7.00546 13.1747 7.00546Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M3.54009 8.01231C3.40623 8.01231 3.29771 8.11838 3.29771 8.24922C3.29771 8.38006 3.40623 8.48613 3.54009 8.48613H4.87319C5.00705 8.48613 5.11557 8.38006 5.11557 8.24922C5.11557 8.11838 5.00705 8.01231 4.87319 8.01231H3.54009Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M3.29771 9.37453C3.29771 9.24369 3.40623 9.13762 3.54009 9.13762H8.99367C9.12753 9.13762 9.23605 9.24369 9.23605 9.37453C9.23605 9.50537 9.12753 9.61144 8.99367 9.61144H3.54009C3.40623 9.61144 3.29771 9.50537 3.29771 9.37453Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M3.29771 10.7367C3.29771 10.6059 3.40623 10.4998 3.54009 10.4998H8.99367C9.12753 10.4998 9.23605 10.6059 9.23605 10.7367C9.23605 10.8676 9.12753 10.9737 8.99367 10.9737H3.54009C3.40623 10.9737 3.29771 10.8676 3.29771 10.7367Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M10.6903 10.7367C10.6903 10.6059 10.7989 10.4998 10.9327 10.4998H13.5989C13.7328 10.4998 13.8413 10.6059 13.8413 10.7367C13.8413 10.8676 13.7328 10.9737 13.5989 10.9737H10.9327C10.7989 10.9737 10.6903 10.8676 10.6903 10.7367Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1.34351 11.4304H1.41454C1.55949 11.7644 1.91055 12 2.32061 12H14.0458C14.5854 12 15.0229 11.592 15.0229 11.0886V5.62025C15.0229 5.56166 15.017 5.50437 15.0056 5.44885C15.2484 5.38587 15.4551 5.27323 15.6179 5.12142C15.8743 4.88225 16 4.56555 16 4.25316C16 3.94078 15.8743 3.62408 15.6179 3.38491C15.358 3.14253 14.9861 3 14.5344 3H1.34351C0.601511 3 0 3.56106 0 4.25316V10.1772C0 10.8693 0.601511 11.4304 1.34351 11.4304ZM1.34351 3.68354C1.00624 3.68354 0.732824 3.93857 0.732824 4.25316V10.1772C0.732824 10.4918 1.00624 10.7468 1.34351 10.7468V5.62025C1.34351 5.28291 1.54001 4.98837 1.83206 4.83079V4.82278L1.84737 4.8227C1.98289 4.75259 2.13815 4.71166 2.30342 4.709C2.33955 4.68699 2.3707 4.66297 2.3974 4.63808C2.50739 4.53548 2.56489 4.39647 2.56489 4.25316C2.56489 4.10986 2.50739 3.97085 2.3974 3.86825C2.29084 3.76887 2.11313 3.68354 1.83206 3.68354H1.34351ZM14.5344 4.82278V4.83079C14.3906 4.75324 14.2238 4.70886 14.0458 4.70886H3.2053C3.26711 4.56247 3.29771 4.40729 3.29771 4.25316C3.29771 4.05835 3.24882 3.86186 3.14982 3.68354H14.5344C14.8154 3.68354 14.9931 3.76887 15.0997 3.86825C15.2097 3.97085 15.2672 4.10986 15.2672 4.25316C15.2672 4.39647 15.2097 4.53548 15.0997 4.63808C14.9931 4.73746 14.8154 4.82278 14.5344 4.82278ZM2.4787 5.39241C2.36917 5.43499 2.25056 5.46636 2.12379 5.48527C2.09396 5.52305 2.07634 5.56973 2.07634 5.62025V11.0886C2.07634 11.2144 2.1857 11.3165 2.32061 11.3165H14.0458C14.1807 11.3165 14.2901 11.2144 14.2901 11.0886V5.62025C14.2901 5.49442 14.1807 5.39241 14.0458 5.39241H2.4787Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Civic = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M8.00001 0.833252C4.0572 0.833252 0.833344 4.05711 0.833344 7.99992C0.833344 11.9427 4.0572 15.1666 8.00001 15.1666C11.2194 15.1666 13.9501 13.0893 14.8132 10.1404C14.8908 9.87534 14.7388 9.59762 14.4738 9.52005C14.2088 9.44248 13.931 9.59444 13.8535 9.85947C13.1166 12.3772 10.7806 14.1666 8.00001 14.1666C4.60949 14.1666 1.83334 11.3904 1.83334 7.99992C1.83334 4.60939 4.60949 1.83325 8.00001 1.83325C10.7729 1.83325 13.1215 3.68365 13.9245 6.15446C14.0098 6.41708 14.2919 6.56079 14.5546 6.47544C14.8172 6.39008 14.9609 6.108 14.8755 5.84538C13.9452 2.98286 11.2271 0.833252 8.00001 0.833252Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.6546 5.11486C7.26288 4.76693 6.03334 5.81782 6.03334 7.13327C6.03334 7.72337 6.28561 8.33389 6.76667 8.72743V9.79993C6.76667 10.4488 7.29732 11.0999 8.06667 11.0999C8.7155 11.0999 9.36667 10.5693 9.36667 9.79993V8.71907C9.92883 8.2437 10.2466 7.45598 10.0171 6.60674C9.83273 5.87862 9.22386 5.38618 8.75694 5.15272L8.70785 5.12817L8.6546 5.11486ZM7.03334 7.13327C7.03334 6.465 7.64048 5.92582 8.35929 6.073C8.67327 6.24369 8.96853 6.53561 9.04826 6.85453L9.04955 6.85969L9.05095 6.86482C9.1882 7.36807 8.9635 7.81646 8.60167 8.0426L8.36667 8.18948V9.79993C8.36667 9.88345 8.33261 9.95546 8.27336 10.0114C8.21002 10.0712 8.13078 10.0999 8.06667 10.0999C7.98315 10.0999 7.91114 10.0659 7.85518 10.0066C7.79535 9.94328 7.76667 9.86404 7.76667 9.79993V8.17644L7.51474 8.03248C7.22595 7.86746 7.03334 7.51415 7.03334 7.13327Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Clavier_virtuel = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.41421 1.58579C3.82843 1 3 1 3 1C2.17157 1 1.58579 1.58579 1.58579 1.58579C1 2.17157 1 3 1 3C1 3.82843 1.58579 4.41421 1.58579 4.41421C2.17157 5 3 5 3 5C3.82843 5 4.41421 4.41421 4.41421 4.41421C5 3.82843 5 3 5 3C5 2.17157 4.41421 1.58579 4.41421 1.58579ZM2.29289 2.29289C2.58579 2 3 2 3 2C3.41421 2 3.70711 2.29289 3.70711 2.29289C4 2.58579 4 3 4 3C4 3.41421 3.70711 3.70711 3.70711 3.70711C3.41421 4 3 4 3 4C2.58579 4 2.29289 3.70711 2.29289 3.70711C2 3.41421 2 3 2 3C2 2.58579 2.29289 2.29289 2.29289 2.29289Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.41421 1.58579C8.82843 1 8 1 8 1C7.17157 1 6.58579 1.58579 6.58579 1.58579C6 2.17157 6 3 6 3C6 3.82843 6.58579 4.41421 6.58579 4.41421C7.17157 5 8 5 8 5C8.82843 5 9.41421 4.41421 9.41421 4.41421C10 3.82843 10 3 10 3C10 2.17157 9.41421 1.58579 9.41421 1.58579ZM7.29289 2.29289C7.58579 2 8 2 8 2C8.41421 2 8.70711 2.29289 8.70711 2.29289C9 2.58579 9 3 9 3C9 3.41421 8.70711 3.70711 8.70711 3.70711C8.41421 4 8 4 8 4C7.58579 4 7.29289 3.70711 7.29289 3.70711C7 3.41421 7 3 7 3C7 2.58579 7.29289 2.29289 7.29289 2.29289Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M13 1C13 1 13.8284 1 14.4142 1.58579C14.4142 1.58579 15 2.17157 15 3C15 3 15 3.82843 14.4142 4.41421C14.4142 4.41421 13.8284 5 13 5C13 5 12.1716 5 11.5858 4.41421C11.5858 4.41421 11 3.82843 11 3C11 3 11 2.17157 11.5858 1.58579C11.5858 1.58579 12.1716 1 13 1ZM13 2C13 2 12.5858 2 12.2929 2.29289C12.2929 2.29289 12 2.58579 12 3C12 3 12 3.41421 12.2929 3.70711C12.2929 3.70711 12.5858 4 13 4C13 4 13.4142 4 13.7071 3.70711C13.7071 3.70711 14 3.41421 14 3C14 3 14 2.58579 13.7071 2.29289C13.7071 2.29289 13.4142 2 13 2Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.41421 6.58579C3.82843 6 3 6 3 6C2.17157 6 1.58579 6.58579 1.58579 6.58579C1 7.17157 1 8 1 8C1 8.82843 1.58579 9.41421 1.58579 9.41421C2.17157 10 3 10 3 10C3.82843 10 4.41421 9.41421 4.41421 9.41421C5 8.82843 5 8 5 8C5 7.17157 4.41421 6.58579 4.41421 6.58579ZM2.29289 7.29289C2.58579 7 3 7 3 7C3.41421 7 3.70711 7.29289 3.70711 7.29289C4 7.58579 4 8 4 8C4 8.41421 3.70711 8.70711 3.70711 8.70711C3.41421 9 3 9 3 9C2.58579 9 2.29289 8.70711 2.29289 8.70711C2 8.41421 2 8 2 8C2 7.58579 2.29289 7.29289 2.29289 7.29289Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.41421 6.58579C8.82843 6 8 6 8 6C7.17157 6 6.58579 6.58579 6.58579 6.58579C6 7.17157 6 8 6 8C6 8.82843 6.58579 9.41421 6.58579 9.41421C7.17157 10 8 10 8 10C8.82843 10 9.41421 9.41421 9.41421 9.41421C10 8.82843 10 8 10 8C10 7.17157 9.41421 6.58579 9.41421 6.58579ZM7.29289 7.29289C7.58579 7 8 7 8 7C8.41421 7 8.70711 7.29289 8.70711 7.29289C9 7.58579 9 8 9 8C9 8.41421 8.70711 8.70711 8.70711 8.70711C8.41421 9 8 9 8 9C7.58579 9 7.29289 8.70711 7.29289 8.70711C7 8.41421 7 8 7 8C7 7.58579 7.29289 7.29289 7.29289 7.29289Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M13 6C13 6 13.8284 6 14.4142 6.58579C14.4142 6.58579 15 7.17157 15 8C15 8 15 8.82843 14.4142 9.41421C14.4142 9.41421 13.8284 10 13 10C13 10 12.1716 10 11.5858 9.41421C11.5858 9.41421 11 8.82843 11 8C11 8 11 7.17157 11.5858 6.58579C11.5858 6.58579 12.1716 6 13 6ZM13 7C13 7 12.5858 7 12.2929 7.29289C12.2929 7.29289 12 7.58579 12 8C12 8 12 8.41421 12.2929 8.70711C12.2929 8.70711 12.5858 9 13 9C13 9 13.4142 9 13.7071 8.70711C13.7071 8.70711 14 8.41421 14 8C14 8 14 7.58579 13.7071 7.29289C13.7071 7.29289 13.4142 7 13 7Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.41421 11.5858C8.82843 11 8 11 8 11C7.17157 11 6.58579 11.5858 6.58579 11.5858C6 12.1716 6 13 6 13C6 13.8284 6.58579 14.4142 6.58579 14.4142C7.17157 15 8 15 8 15C8.82843 15 9.41421 14.4142 9.41421 14.4142C10 13.8284 10 13 10 13C10 12.1716 9.41421 11.5858 9.41421 11.5858ZM7.29289 12.2929C7.58579 12 8 12 8 12C8.41421 12 8.70711 12.2929 8.70711 12.2929C9 12.5858 9 13 9 13C9 13.4142 8.70711 13.7071 8.70711 13.7071C8.41421 14 8 14 8 14C7.58579 14 7.29289 13.7071 7.29289 13.7071C7 13.4142 7 13 7 13C7 12.5858 7.29289 12.2929 7.29289 12.2929Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Clipboard = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M10.4954 7.52131C10.6736 7.71005 10.6736 8.01607 10.4954 8.20481L8.06223 10.7825C7.97667 10.8731 7.86063 10.9241 7.73963 10.9241C7.61863 10.9241 7.50259 10.8731 7.41703 10.7825L6.50459 9.81586C6.32643 9.62712 6.32643 9.3211 6.50459 9.13235C6.68276 8.94361 6.97162 8.94361 7.14979 9.13235L7.73963 9.75723L9.85021 7.52131C10.0284 7.33256 10.3172 7.33256 10.4954 7.52131Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.66129 2.41772C5.66129 1.63474 6.29676 1 7.08065 1H9.91935C10.7032 1 11.3387 1.63474 11.3387 2.41772V2.59494C12.8085 2.59494 14 3.78507 14 5.25316V12.3418C14 13.8099 12.8085 15 11.3387 15H5.66129C4.1915 15 3 13.8099 3 12.3418V5.25316C3 3.78507 4.1915 2.59494 5.66129 2.59494V2.41772ZM7.08065 2.06329H9.91935C10.1153 2.06329 10.2742 2.22198 10.2742 2.41772V3.83544C10.2742 4.03119 10.1153 4.18987 9.91935 4.18987H7.08065C6.88467 4.18987 6.72581 4.03119 6.72581 3.83544V2.41772C6.72581 2.22197 6.88467 2.06329 7.08065 2.06329ZM5.66129 3.65823C4.77942 3.65823 4.06452 4.37231 4.06452 5.25316V12.3418C4.06452 13.2226 4.77942 13.9367 5.66129 13.9367H11.3387C12.2206 13.9367 12.9355 13.2226 12.9355 12.3418V5.25316C12.9355 4.37231 12.2206 3.65823 11.3387 3.65823V3.83544C11.3387 4.61843 10.7032 5.25316 9.91935 5.25316H7.08065C6.29676 5.25316 5.66129 4.61843 5.66129 3.83544V3.65823Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Cle = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M10.8669 6.17739C11.4406 6.17739 11.9056 5.71268 11.9056 5.13943C11.9056 4.56618 11.4406 4.10147 10.8669 4.10147C10.2933 4.10147 9.82832 4.56618 9.82832 5.13943C9.82832 5.71268 10.2933 6.17739 10.8669 6.17739Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.22096 11.1125C8.99998 11.3703 9.82832 11.3671 9.82832 11.3671C11.4036 11.3671 12.7135 10.4925 12.7135 10.4925C14.0233 9.61785 14.6262 8.16338 14.6262 8.16338C15.229 6.7089 14.9217 5.16485 14.9217 5.16485C14.6143 3.62078 13.5004 2.50758 13.5004 2.50758C12.3865 1.39437 10.8415 1.08724 10.8415 1.08724C9.2964 0.780109 7.841 1.38257 7.841 1.38257C6.38559 1.98503 5.51039 3.29403 5.51039 3.29403C4.63519 4.60302 4.6352 6.17538 4.6352 6.17538C4.63208 7.00482 4.88999 7.78365 4.88999 7.78365L1.1521 11.5191C1.05471 11.6165 1 11.7485 1 11.8861V14.481C1 14.7676 1.2325 15 1.51931 15H4.11588C4.40269 15 4.63519 14.7676 4.63519 14.481V13.4431H5.67382C5.96063 13.4431 6.19313 13.2107 6.19313 12.9241V11.8861H7.23176C7.36949 11.8861 7.50158 11.8314 7.59897 11.7341L8.22096 11.1125ZM8.28545 10.0306C9.02634 10.3322 9.82832 10.3292 9.82832 10.3292C11.0886 10.3292 12.1364 9.62946 12.1364 9.62946C13.1843 8.92975 13.6666 7.76617 13.6666 7.76617C14.1489 6.60259 13.903 5.36734 13.903 5.36734C13.6571 4.13209 12.766 3.24153 12.766 3.24153C11.8749 2.35097 10.6388 2.10526 10.6388 2.10526C9.40279 1.85955 8.23846 2.34152 8.23846 2.34152C7.07414 2.82349 6.37398 3.87069 6.37398 3.87069C5.67382 4.91788 5.67381 6.17928 5.67381 6.17928C5.6708 6.97923 5.97295 7.72002 5.97295 7.72002C6.05184 7.91341 6.00704 8.13521 5.85927 8.28289L2.03863 12.1011V13.962H3.59657V12.9241C3.59657 12.6375 3.82907 12.4051 4.11588 12.4051H5.1545V11.3671C5.1545 11.0805 5.38701 10.8482 5.67382 10.8482H7.01665L7.72141 10.1438C7.76894 10.0963 7.82524 10.0585 7.88719 10.0325C8.01413 9.97908 8.15791 9.9786 8.28545 10.0306Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Code$1 = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M6.68272 10.6646L8.81605 5.16456C8.85344 5.06819 8.94981 5.00299 9.05915 5.0001L9.06667 5C9.09775 5 9.12859 5.00509 9.1578 5.01505C9.22426 5.03771 9.27841 5.08419 9.30831 5.14428C9.32312 5.17403 9.33154 5.20622 9.33307 5.23902C9.33325 5.24268 9.33333 5.24634 9.33333 5.25C9.33333 5.27914 9.3279 5.30805 9.31728 5.33544L7.18395 10.8354C7.15978 10.8977 7.11019 10.9485 7.04611 10.9765C7.01437 10.9904 6.98003 10.9983 6.94505 10.9998C6.94114 10.9999 6.93724 11 6.93334 11C6.90226 11 6.87141 10.9949 6.8422 10.9849C6.7394 10.9499 6.66986 10.8596 6.66678 10.757L6.66667 10.75C6.66667 10.7209 6.6721 10.6919 6.68272 10.6646Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M4.09596 8.19206L5.6958 9.44193C5.74372 9.47938 5.80429 9.5 5.86667 9.5C5.94583 9.49999 6.02087 9.46704 6.07153 9.41005C6.11146 9.36512 6.13334 9.30849 6.13334 9.25C6.13333 9.24241 6.13297 9.23487 6.13224 9.22737C6.12584 9.16133 6.09172 9.10039 6.03739 9.05794L4.68322 8L6.03735 6.94208C6.09172 6.89961 6.12584 6.83867 6.13224 6.77263C6.13297 6.76511 6.13334 6.75756 6.13334 6.75L6.13333 6.74854C6.13297 6.69056 6.11112 6.6345 6.07153 6.58995C6.02086 6.53296 5.94581 6.5 5.86667 6.5L5.86326 6.50002C5.80205 6.50076 5.74298 6.52121 5.69595 6.55794L4.09596 7.80794C4.08357 7.81762 4.07214 7.82834 4.06181 7.83995C3.96753 7.94602 3.98282 8.10366 4.09596 8.19206Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M11.3168 8L9.96277 9.05782C9.90844 9.10027 9.87416 9.16133 9.86776 9.22737C9.86703 9.23489 9.86666 9.24244 9.86666 9.25L9.86667 9.25146C9.86703 9.30944 9.88888 9.3655 9.92847 9.41005C9.97914 9.46704 10.0542 9.5 10.1333 9.5L10.1367 9.49998C10.1979 9.49924 10.257 9.47879 10.304 9.44206L11.904 8.19206C12.0172 8.10366 12.0325 7.94602 11.9382 7.83995C11.9279 7.82834 11.9164 7.81762 11.904 7.80794L10.3041 6.55797C10.2561 6.5205 10.1957 6.5 10.1333 6.5C10.0542 6.50001 9.97913 6.53296 9.92847 6.58995C9.88854 6.63488 9.86666 6.69152 9.86666 6.75C9.86667 6.82421 9.90182 6.89456 9.96261 6.94206L11.3168 8Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement("circle", { cx: "8", cy: "8", r: "6.5", stroke: "black" })
    );
  }
);
const Code2 = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M6.97123 7.64775C7.17626 7.42808 7.17626 7.07192 6.97123 6.85225C6.76621 6.63258 6.43379 6.63258 6.22877 6.85225L4.82877 8.35225C4.62374 8.57192 4.62374 8.92808 4.82877 9.14775L6.22877 10.6477C6.43379 10.8674 6.76621 10.8674 6.97123 10.6477C7.17626 10.4281 7.17626 10.0719 6.97123 9.85225L5.94246 8.75L6.97123 7.64775Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M9.77123 6.85225C9.56621 6.63258 9.23379 6.63258 9.02877 6.85225C8.82374 7.07192 8.82374 7.42808 9.02877 7.64775L10.0575 8.75L9.02877 9.85225C8.82374 10.0719 8.82374 10.4281 9.02877 10.6477C9.23379 10.8674 9.56621 10.8674 9.77123 10.6477L11.1712 9.14775C11.3763 8.92808 11.3763 8.57192 11.1712 8.35225L9.77123 6.85225Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.1 2C1.9402 2 1 3.00736 1 4.25V11.75C1 12.9926 1.9402 14 3.1 14H12.9C14.0598 14 15 12.9926 15 11.75V4.25C15 3.00736 14.0598 2 12.9 2H3.1ZM12.9 3.125H3.1C2.5201 3.125 2.05 3.62868 2.05 4.25V4.625H13.95V4.25C13.95 3.62868 13.4799 3.125 12.9 3.125ZM13.95 5.75H2.05V11.75C2.05 12.3713 2.5201 12.875 3.1 12.875H12.9C13.4799 12.875 13.95 12.3713 13.95 11.75V5.75Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Colonne = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2.94047 1C2.38026 1 1.86154 1.10201 1.49153 1.45011C1.11402 1.80526 1 2.31218 1 2.85581V13.1442C1 13.6878 1.11402 14.1947 1.49153 14.5499C1.86154 14.898 2.38026 15 2.94047 15H5.57116C6.13137 15 6.65008 14.898 7.0201 14.5499C7.39761 14.1947 7.51163 13.6878 7.51163 13.1442V2.85581C7.51163 2.31218 7.39761 1.80526 7.0201 1.45011C6.65008 1.10201 6.13137 1 5.57116 1H2.94047ZM1.97674 2.85581C1.97674 2.4227 2.0711 2.24591 2.1608 2.16152C2.25799 2.07008 2.46532 1.97674 2.94047 1.97674H5.57116C6.04631 1.97674 6.25364 2.07008 6.35083 2.16152C6.44053 2.24591 6.53488 2.4227 6.53488 2.85581V13.1442C6.53488 13.5773 6.44053 13.7541 6.35083 13.8385C6.25364 13.9299 6.04631 14.0233 5.57116 14.0233H2.94047C2.46532 14.0233 2.25799 13.9299 2.1608 13.8385C2.0711 13.7541 1.97674 13.5773 1.97674 13.1442V2.85581Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.4288 1C9.86863 1 9.34992 1.10201 8.9799 1.45011C8.60239 1.80526 8.48837 2.31218 8.48837 2.85581V8.58605C8.48837 9.12968 8.60239 9.6366 8.9799 9.99175C9.34992 10.3399 9.86863 10.4419 10.4288 10.4419H13.0595C13.6197 10.4419 14.1385 10.3399 14.5085 9.99175C14.886 9.6366 15 9.12968 15 8.58605V2.85581C15 2.31218 14.886 1.80526 14.5085 1.45011C14.1385 1.10201 13.6197 1 13.0595 1H10.4288ZM9.46512 2.85581C9.46512 2.4227 9.55947 2.24591 9.64917 2.16152C9.74636 2.07008 9.95369 1.97674 10.4288 1.97674H13.0595C13.5347 1.97674 13.742 2.07008 13.8392 2.16152C13.9289 2.24591 14.0233 2.4227 14.0233 2.85581V8.58605C14.0233 9.01916 13.9289 9.19595 13.8392 9.28034C13.742 9.37178 13.5347 9.46512 13.0595 9.46512H10.4288C9.95369 9.46512 9.74636 9.37178 9.64917 9.28034C9.55947 9.19595 9.46512 9.01916 9.46512 8.58605V2.85581Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Compte = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M11.36 9.56818C11.8239 9.56818 12.2 9.17131 12.2 8.68182C12.2 8.19233 11.8239 7.79545 11.36 7.79545C10.8961 7.79545 10.52 8.19233 10.52 8.68182C10.52 9.17131 10.8961 9.56818 11.36 9.56818Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2.68 2.18182H12.2C12.5093 2.18182 12.76 1.91726 12.76 1.59091C12.76 1.26456 12.5093 1 12.2 1H2.68C1.98412 1 1.49206 1.51922 1.49206 1.51922C1 2.03844 1 2.77273 1 2.77273V12.2273C1 12.9616 1.49206 13.4808 1.49206 13.4808C1.98412 14 2.68 14 2.68 14H13.88C14.3439 14 14.672 13.6539 14.672 13.6539C15 13.3077 15 12.8182 15 12.8182V4.54545C15 4.05593 14.672 3.70978 14.672 3.70978C14.3439 3.36364 13.88 3.36364 13.88 3.36364H2.68C2.44804 3.36364 2.28402 3.19056 2.28402 3.19056C2.12 3.01749 2.12 2.77273 2.12 2.77273C2.12 2.52796 2.28402 2.35489 2.28402 2.35489C2.44804 2.18182 2.68 2.18182 2.68 2.18182ZM2.12 4.44973V12.2273C2.12 12.472 2.28402 12.6451 2.28402 12.6451C2.44804 12.8182 2.68 12.8182 2.68 12.8182H13.88V4.54545H2.68C2.38121 4.54545 2.12 4.44973 2.12 4.44973Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Compteur = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.87178 8.2849C5.90824 8.12512 5.92647 7.94444 5.92647 7.74285C5.92647 7.54125 5.90878 7.36379 5.87339 7.21045C5.83801 7.05604 5.78117 6.92629 5.7029 6.8212C5.62354 6.71397 5.52168 6.63355 5.39729 6.57993C5.2729 6.52525 5.11903 6.4979 4.93566 6.4979C4.7598 6.4979 4.60861 6.52417 4.48208 6.57672C4.35555 6.62926 4.2526 6.70807 4.17325 6.81316C4.0939 6.91932 4.036 7.04907 3.99954 7.20241C3.96308 7.35575 3.94485 7.53643 3.94485 7.74446C3.94485 7.94605 3.96255 8.12512 3.99793 8.28168C4.03332 8.43716 4.09069 8.56745 4.17004 8.67254C4.24831 8.77762 4.35072 8.85697 4.47725 8.91059C4.60378 8.9642 4.75659 8.99101 4.93566 8.99101C5.11795 8.99101 5.27129 8.96474 5.39568 8.9122C5.52007 8.85858 5.62194 8.77977 5.70129 8.67575C5.77849 8.57388 5.83532 8.4436 5.87178 8.2849ZM5.21875 7.1252C5.27558 7.24744 5.304 7.45333 5.304 7.74285C5.304 8.02915 5.27505 8.23504 5.21714 8.3605C5.15924 8.48595 5.06541 8.54868 4.93566 8.54868C4.80591 8.54868 4.71209 8.48595 4.65418 8.3605C4.59628 8.23504 4.56733 8.03023 4.56733 7.74607C4.56733 7.4544 4.59574 7.24744 4.65257 7.1252C4.70941 7.00189 4.80377 6.94023 4.93566 6.94023C5.06755 6.94023 5.16192 7.00189 5.21875 7.1252Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.75 7.74285C8.75 7.94444 8.73177 8.12512 8.69531 8.2849C8.65885 8.4436 8.60202 8.57388 8.52482 8.67575C8.44547 8.77977 8.3436 8.85858 8.21921 8.9122C8.09482 8.96474 7.94148 8.99101 7.75919 8.99101C7.58012 8.99101 7.42731 8.9642 7.30078 8.91059C7.17425 8.85697 7.07184 8.77762 6.99357 8.67254C6.91422 8.56745 6.85685 8.43716 6.82146 8.28168C6.78608 8.12512 6.76838 7.94605 6.76838 7.74446C6.76838 7.53643 6.78661 7.35575 6.82307 7.20241C6.85953 7.04907 6.91743 6.91932 6.99678 6.81316C7.07613 6.70807 7.17907 6.62926 7.30561 6.57672C7.43214 6.52417 7.58333 6.4979 7.75919 6.4979C7.94255 6.4979 8.09643 6.52525 8.22082 6.57993C8.34521 6.63355 8.44707 6.71397 8.52642 6.8212C8.6047 6.92629 8.66154 7.05604 8.69692 7.21045C8.73231 7.36379 8.75 7.54125 8.75 7.74285ZM8.12753 7.74285C8.12753 7.45333 8.09911 7.24744 8.04228 7.1252C7.98545 7.00189 7.89108 6.94023 7.75919 6.94023C7.6273 6.94023 7.53293 7.00189 7.4761 7.1252C7.41927 7.24744 7.39085 7.4544 7.39085 7.74607C7.39085 8.03023 7.41981 8.23504 7.47771 8.3605C7.53562 8.48595 7.62944 8.54868 7.75919 8.54868C7.88894 8.54868 7.98277 8.48595 8.04067 8.3605C8.09858 8.23504 8.12753 8.02915 8.12753 7.74285Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.1799 7.05879H12.0602V6.60038H10.9841C11.026 6.57036 11.0962 6.51782 11.1949 6.44276C11.2935 6.36662 11.3916 6.28352 11.4892 6.19345C11.6447 6.04868 11.76 5.90821 11.835 5.77203C11.8952 5.66431 11.9316 5.55189 11.9442 5.43477C12.2471 5.51419 12.4706 5.78981 12.4706 6.11762V8.94115C12.4706 9.331 12.1546 9.64703 11.7647 9.64703H11.7507C11.7213 9.62939 11.6905 9.61461 11.6581 9.60268C11.597 9.58016 11.5391 9.56515 11.4844 9.55765V9.53513C11.6195 9.50618 11.7283 9.43969 11.8109 9.33568C11.8935 9.23059 11.9347 9.11157 11.9347 8.9786C11.9347 8.87781 11.9133 8.78988 11.8704 8.71482C11.8275 8.63975 11.7621 8.57595 11.6742 8.52341C11.6002 8.47944 11.5064 8.44459 11.3927 8.41886C11.279 8.39205 11.1466 8.37865 10.9954 8.37865C10.8399 8.37865 10.6866 8.39527 10.5354 8.42851C10.3842 8.46068 10.2646 8.49446 10.1767 8.52984V9.04937H10.2362C10.3467 8.98396 10.4609 8.9341 10.5788 8.89979C10.6968 8.8644 10.8061 8.84671 10.9069 8.84671C10.9477 8.84671 10.9965 8.84993 11.0533 8.85636C11.1101 8.86279 11.1595 8.87566 11.2013 8.89496C11.2388 8.91212 11.2699 8.93571 11.2946 8.96573C11.3192 8.99469 11.3316 9.03329 11.3316 9.08154C11.3316 9.14695 11.3198 9.19682 11.2962 9.23113C11.2726 9.26437 11.2372 9.29118 11.19 9.31155C11.145 9.33085 11.0903 9.34318 11.026 9.34855C10.9616 9.35391 10.8876 9.35659 10.804 9.35659H10.6673V9.64703H9.41177V5.232C9.55618 5.10274 9.64706 4.91491 9.64706 4.70585C9.64706 4.31601 9.33102 3.99997 8.94118 3.99997H4.23529C3.06575 3.99997 2.11765 4.94807 2.11765 6.11762V9.17644C2.11765 10.216 2.96041 11.0588 4 11.0588C4.38985 11.0588 4.70588 10.7428 4.70588 10.3529C4.70588 9.96307 4.38985 9.64703 4 9.64703C3.7401 9.64703 3.52941 9.43634 3.52941 9.17644V6.11762C3.52941 5.72777 3.84545 5.41174 4.23529 5.41174H6.11765V9.64703C5.7278 9.64703 5.41176 9.96307 5.41176 10.3529C5.41176 10.7428 5.7278 11.0588 6.11765 11.0588H11.7647C12.9342 11.0588 13.8824 10.1107 13.8824 8.94115V6.11762C13.8824 4.94807 12.9342 3.99997 11.7647 3.99997H10.8039C10.4141 3.99997 10.098 4.31601 10.098 4.70585C10.098 4.86683 10.1519 5.01523 10.2426 5.13398V5.29914H10.2941C10.3162 5.28415 10.3387 5.2698 10.3617 5.25607C10.4827 5.35345 10.6365 5.41174 10.8039 5.41174H11.3169C11.317 5.41599 11.3171 5.42027 11.3171 5.4246C11.3171 5.51575 11.2898 5.60797 11.2351 5.70126C11.1804 5.79455 11.0882 5.90392 10.9584 6.02938C10.8716 6.11409 10.7557 6.21489 10.611 6.33177C10.4673 6.44865 10.3236 6.5591 10.1799 6.66311V7.05879ZM8.94118 5.41174H6.58824V9.64703H8.94118V5.41174Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 3.29409C0 2.51439 0.632069 1.88232 1.41176 1.88232H14.5882C15.3679 1.88232 16 2.51439 16 3.29409V11.7647C16 12.5444 15.3679 13.1764 14.5882 13.1764H1.41177C0.632069 13.1764 0 12.5444 0 11.7647V3.29409ZM1.41176 3.29409H14.5882V11.7647H1.41176V3.29409Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Connexion = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M10.3266 15H10.2399C7.27983 15 5.85313 13.8072 5.60646 11.1353C5.57979 10.8559 5.77979 10.6037 6.0598 10.5764C6.33314 10.5492 6.57981 10.7605 6.60648 11.0399C6.79982 13.1801 7.7865 13.9776 10.2466 13.9776H10.3332C13.0466 13.9776 14.0066 12.9961 14.0066 10.222V5.77799C14.0066 3.00389 13.0466 2.0224 10.3332 2.0224H10.2466C7.77317 2.0224 6.78648 2.8335 6.60648 5.01461C6.57314 5.29406 6.34647 5.50536 6.0598 5.47809C5.77979 5.45764 5.57979 5.20545 5.59979 4.926C5.82646 2.21324 7.25983 1 10.2399 1H10.3266C13.6 1 15 2.43135 15 5.77799V10.222C15 13.5686 13.6 15 10.3266 15Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M10.0869 8.51121H1.50001C1.22667 8.51121 1 8.27947 1 8.00001C1 7.72056 1.22667 7.48882 1.50001 7.48882H10.0869C10.3602 7.48882 10.5869 7.72056 10.5869 8.00001C10.5869 8.27947 10.3669 8.51121 10.0869 8.51121Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M8.60007 10.7946C8.4734 10.7946 8.34673 10.7469 8.24673 10.6446C8.05339 10.447 8.05339 10.1198 8.24673 9.92213L10.1268 8.00003L8.24673 6.07793C8.05339 5.88027 8.05339 5.5531 8.24673 5.35544C8.44006 5.15777 8.76007 5.15777 8.95341 5.35544L11.1868 7.63879C11.3801 7.83645 11.3801 8.16362 11.1868 8.36128L8.95341 10.6446C8.85341 10.7469 8.72674 10.7946 8.60007 10.7946Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Consultation = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M1.06815 0.470589C1.39818 0.470589 1.66573 0.738131 1.66573 1.06816V13.9757C1.66573 14.1737 1.82625 14.3343 2.02427 14.3343H14.9318C15.2619 14.3343 15.5294 14.6018 15.5294 14.9318C15.5294 15.2619 15.2619 15.5294 14.9318 15.5294H2.02427C1.16619 15.5294 0.470581 14.8338 0.470581 13.9757V1.06816C0.470581 0.738131 0.738123 0.470589 1.06815 0.470589Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M2.50233 7.76097C2.50233 7.23292 2.93039 6.80486 3.45844 6.80486H3.9365C4.46455 6.80486 4.89262 7.23292 4.89262 7.76097V13.0196C4.89262 13.5477 4.46455 13.9757 3.9365 13.9757H3.45844C2.93039 13.9757 2.50233 13.5477 2.50233 13.0196V7.76097Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M6.80485 2.98039C6.2768 2.98039 5.84873 3.40846 5.84873 3.93651V13.0196C5.84873 13.5477 6.2768 13.9757 6.80485 13.9757H7.28291C7.81096 13.9757 8.23902 13.5477 8.23902 13.0196V3.93651C8.23902 3.40846 7.81096 2.98039 7.28291 2.98039H6.80485Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M8.71708 7.76097C8.71708 7.23292 9.14515 6.80486 9.6732 6.80486H10.1513C10.6793 6.80486 11.1074 7.23292 11.1074 7.76097V13.0196C11.1074 13.5477 10.6793 13.9757 10.1513 13.9757H9.6732C9.14515 13.9757 8.71708 13.5477 8.71708 13.0196V7.76097Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M12.5415 2.98039C12.0135 2.98039 11.5854 3.40846 11.5854 3.93651V13.0196C11.5854 13.5477 12.0135 13.9757 12.5415 13.9757H13.0196C13.5477 13.9757 13.9757 13.5477 13.9757 13.0196V3.93651C13.9757 3.40846 13.5477 2.98039 13.0196 2.98039H12.5415Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Consultation_V2 = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M1.06815 0.470589C1.39818 0.470589 1.66573 0.738131 1.66573 1.06816V13.9757C1.66573 14.1737 1.82625 14.3343 2.02427 14.3343H14.9318C15.2619 14.3343 15.5294 14.6018 15.5294 14.9318C15.5294 15.2619 15.2619 15.5294 14.9318 15.5294H2.02427C1.16619 15.5294 0.470581 14.8338 0.470581 13.9757V1.06816C0.470581 0.738131 0.738123 0.470589 1.06815 0.470589Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M3.99999 6.85714C3.99999 6.54155 4.25583 6.28572 4.57142 6.28572C4.88701 6.28572 5.14285 6.54155 5.14285 6.85714V12.1905C5.14285 12.5061 4.88701 12.7619 4.57142 12.7619C4.25583 12.7619 3.99999 12.5061 3.99999 12.1905V6.85714Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M7.23809 2.09524C6.9225 2.09524 6.66666 2.35108 6.66666 2.66667V12.1905C6.66666 12.5061 6.9225 12.7619 7.23809 12.7619C7.55368 12.7619 7.80952 12.5061 7.80952 12.1905V2.66667C7.80952 2.35108 7.55368 2.09524 7.23809 2.09524Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M9.33333 6.85714C9.33333 6.54155 9.58917 6.28572 9.90476 6.28572C10.2203 6.28572 10.4762 6.54155 10.4762 6.85714V12.1905C10.4762 12.5061 10.2203 12.7619 9.90476 12.7619C9.58917 12.7619 9.33333 12.5061 9.33333 12.1905V6.85714Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M12.5714 4C12.2558 4 12 4.25584 12 4.57143V12.1905C12 12.5061 12.2558 12.7619 12.5714 12.7619C12.887 12.7619 13.1429 12.5061 13.1429 12.1905V4.57143C13.1429 4.25584 12.887 4 12.5714 4Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Convertion = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.87736 10.026C7.87736 10.026 7.67826 10.234 7.39669 10.234L1.67977 10.2341C1.67977 10.2341 1.3982 10.2341 1.1991 10.0261C1.1991 10.0261 1 9.81802 1 9.5238V1.71038C1 1.71038 1 1.41616 1.1991 1.20812C1.1991 1.20812 1.3982 1.00007 1.67977 1.00007L5.35739 1C5.44753 1 5.53398 1.03742 5.59772 1.10402L7.9769 3.59011C8.04064 3.65672 8.07645 3.74705 8.07645 3.84124V9.52373C8.07645 9.52373 8.07645 9.81795 7.87736 10.026ZM7.39669 9.52373V3.98835L5.21661 1.71031L1.67977 1.71038V9.5238L7.39669 9.52373Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M5.35739 4.1964H7.73657C7.92428 4.1964 8.07645 4.03739 8.07645 3.84124C8.07645 3.6451 7.92428 3.48609 7.73657 3.48609H5.69727V1.35516C5.69727 1.15901 5.5451 1 5.35739 1C5.16968 1 5.01751 1.15901 5.01751 1.35516V3.84124C5.01751 4.03739 5.16968 4.1964 5.35739 4.1964Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M8.3534 1.96809C8.23868 1.96809 8.14569 2.06811 8.14569 2.19149C8.14569 2.31487 8.23868 2.41489 8.3534 2.41489H10.6382V4.07698L10.153 3.61317C10.0673 3.5312 9.93602 3.5395 9.85981 3.63172C9.7836 3.72394 9.79132 3.86515 9.87705 3.94712L10.7079 4.74144C10.7866 4.81668 10.9052 4.81668 10.9839 4.74144L11.8147 3.94712C11.9004 3.86515 11.9082 3.72394 11.8319 3.63172C11.7557 3.5395 11.6244 3.5312 11.5387 3.61317L11.0536 4.07698V2.19149C11.0536 2.06811 10.9606 1.96809 10.8459 1.96809H8.3534Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M12.8852 11.0933H10.4682C10.3014 11.0933 10.1661 10.9343 10.1661 10.7381C10.1661 10.542 10.3014 10.383 10.4682 10.383H12.8852C13.052 10.383 13.1873 10.542 13.1873 10.7381C13.1873 10.9343 13.052 11.0933 12.8852 11.0933Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M10.4682 12.5139H12.8852C13.052 12.5139 13.1873 12.3549 13.1873 12.1588C13.1873 11.9626 13.052 11.8036 12.8852 11.8036H10.4682C10.3014 11.8036 10.1661 11.9626 10.1661 12.1588C10.1661 12.3549 10.3014 12.5139 10.4682 12.5139Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14.823 14.792C14.823 14.792 14.646 15 14.3958 15H8.95763C8.95763 15 8.70735 15 8.53037 14.792C8.53037 14.792 8.3534 14.5839 8.3534 14.2897V6.47627C8.3534 6.47627 8.3534 6.18205 8.53037 5.974C8.53037 5.974 8.70735 5.76596 8.95763 5.76596H12.5831C12.6665 5.76596 12.742 5.80571 12.7967 5.86998L14.9115 8.35607L14.9134 8.35837C14.967 8.42245 15 8.51029 15 8.6072V14.2897C15 14.2897 15 14.5839 14.823 14.792ZM8.95763 6.47627H12.2809V8.6072C12.2809 8.80335 12.4162 8.96236 12.5831 8.96236H14.3958V14.2897H8.95763V6.47627ZM12.8852 6.97853L13.9685 8.25205H12.8852V6.97853Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M6.62251 13.5106C6.62251 13.634 6.52952 13.734 6.4148 13.734H4.33774C4.22303 13.734 4.13003 13.634 4.13003 13.5106V11.6926L3.79692 12.0748C3.71846 12.1648 3.58701 12.1694 3.50333 12.085C3.41964 12.0006 3.4154 11.8592 3.49386 11.7692L4.18621 10.9749C4.22548 10.9298 4.28033 10.9043 4.33774 10.9043C4.39515 10.9043 4.45 10.9298 4.48927 10.9749L5.18162 11.7692C5.26008 11.8592 5.25584 12.0006 5.17215 12.085C5.08847 12.1694 4.95702 12.1648 4.87857 12.0748L4.54545 11.6926V13.2872H6.4148C6.52952 13.2872 6.62251 13.3873 6.62251 13.5106Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Copier = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.183 1.88142H6.68814C5.84269 1.88142 5.16105 2.56305 5.16105 3.4085C5.16105 3.6519 4.96374 3.84921 4.72035 3.84921C4.47695 3.84921 4.27965 3.6519 4.27965 3.4085C4.27965 2.07627 5.3559 1.00001 6.68814 1.00001H10.3613C10.4071 1.00001 10.4512 1.00699 10.4927 1.01993C10.648 0.971536 10.8188 1.01256 10.9353 1.12909L14.8709 5.06467C14.8933 5.08707 14.9129 5.11147 14.9296 5.13739C14.9771 5.21092 15.0013 5.29661 14.9999 5.38313V9.43649C14.9999 10.6966 13.9762 11.7204 12.7161 11.7204C12.4727 11.7204 12.2754 11.523 12.2754 11.2797C12.2754 11.0363 12.4727 10.8389 12.7161 10.8389C13.4894 10.8389 14.1185 10.2098 14.1185 9.43649V5.81699H12.5915C11.8292 5.81699 11.1807 5.69562 10.7425 5.25746C10.3044 4.8193 10.183 4.17084 10.183 3.4085V1.88142ZM11.0644 3.4085V2.50467L13.4953 4.93559H12.5915C11.878 4.93559 11.5426 4.81098 11.3658 4.63421C11.189 4.45744 11.0644 4.12201 11.0644 3.4085Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.589 8.60445C11.6701 8.68437 11.7203 8.79547 11.7203 8.91831V10.8861C11.7203 12.2414 11.452 13.3048 10.7386 14.0182C10.0251 14.7316 8.96176 15 7.60644 15H5.11391C3.75858 15 2.69521 14.7316 1.98179 14.0182C1.26837 13.3048 1 12.2414 1 10.8861V8.39356C1 7.03824 1.26837 5.97487 1.98179 5.26145C2.69521 4.54802 3.75858 4.27966 5.11391 4.27966H7.08169C7.20457 4.27966 7.3157 4.32995 7.39563 4.41106L11.589 8.60445ZM6.64097 5.16106H5.11391C3.84551 5.16106 3.07229 5.41744 2.60504 5.88469C2.13778 6.35194 1.88141 7.12517 1.88141 8.39356V10.8861C1.88141 12.1545 2.13778 12.9277 2.60504 13.395C3.07229 13.8622 3.84551 14.1186 5.11391 14.1186H7.60644C8.87483 14.1186 9.64806 13.8622 10.1153 13.395C10.5826 12.9277 10.8389 12.1545 10.8389 10.8861V9.35901H9.18065C8.36912 9.35901 7.68786 9.22944 7.2292 8.77078C6.77054 8.31212 6.64097 7.63086 6.64097 6.81933V5.16106ZM7.52238 6.81933V5.78431L10.2157 8.4776H9.18065C8.41795 8.4776 8.04972 8.3448 7.85245 8.14753C7.65518 7.95026 7.52238 7.58203 7.52238 6.81933Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Cours_des_marches = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M2.07692 12.9091V11.4987L5.84615 7.68048L7.61925 9.4766C7.82953 9.68962 8.17047 9.68962 8.38075 9.4766L12.8462 4.95321V6.36364C12.8462 6.66488 13.0872 6.90909 13.3846 6.90909C13.682 6.90909 13.9231 6.66488 13.9231 6.36364V3.63636C13.9231 3.48818 13.8647 3.3538 13.7701 3.2555L13.7654 3.25067L13.7606 3.24588C13.6635 3.14999 13.5309 3.09091 13.3846 3.09091H10.6923C10.3949 3.09091 10.1538 3.33512 10.1538 3.63636C10.1538 3.93761 10.3949 4.18182 10.6923 4.18182H12.0847L8 8.31952L6.2269 6.5234C6.12592 6.4211 5.98896 6.36364 5.84615 6.36364C5.70334 6.36364 5.56638 6.4211 5.4654 6.5234L2.07692 9.95588V2.54545C2.07692 2.24421 1.83585 2 1.53846 2C1.24108 2 1 2.24421 1 2.54545V13.4545C1 13.7558 1.24108 14 1.53846 14H14.4615C14.7589 14 15 13.7558 15 13.4545C15 13.1533 14.7589 12.9091 14.4615 12.9091H2.07692Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Crayon = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.1558 0.354663C12.5528 -0.085212 13.2319 -0.120788 13.6726 0.275202L15.6448 2.04717C16.0855 2.44316 16.121 3.12077 15.724 3.56064L13.8723 5.61235L10.304 2.40637L12.1558 0.354663ZM12.5793 2.28718L12.9934 1.8284L14.1675 2.88337L13.7535 3.34214L12.5793 2.28718Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.48232 15.6855L12.7303 6.69366L9.27629 3.53958L1.02826 12.5315L0.888916 16L4.48232 15.6855ZM9.37677 5.81066L10.4542 6.79449L3.71735 14.1389L2.57201 14.2391L2.61444 13.1829L9.37677 5.81066Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Credit = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M8 1C6.29177 1 4.90698 2.45234 4.90698 4.2439V4.7561C4.90698 5.03898 5.12563 5.26829 5.39535 5.26829C5.66507 5.26829 5.88372 5.03898 5.88372 4.7561V4.2439C5.88372 3.0181 6.83121 2.02439 8 2.02439H11.907C13.0758 2.02439 14.0233 3.0181 14.0233 4.2439V11.7561C14.0233 12.9819 13.0758 13.9756 11.907 13.9756H8C6.83121 13.9756 5.88372 12.9819 5.88372 11.7561V11.2439C5.88372 10.961 5.66507 10.7317 5.39535 10.7317C5.12563 10.7317 4.90698 10.961 4.90698 11.2439V11.7561C4.90698 13.5477 6.29177 15 8 15H11.907C13.6152 15 15 13.5477 15 11.7561V4.2439C15 2.45234 13.6152 1 11.907 1H8Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M7.42678 5.00849C7.6175 4.80846 7.92672 4.80846 8.11744 5.00849L10.2988 7.29629C10.4896 7.49632 10.4896 7.82062 10.2988 8.02065L8.11744 10.3085C7.92672 10.5085 7.6175 10.5085 7.42678 10.3085C7.23606 10.1084 7.23606 9.78412 7.42678 9.5841L8.77441 8.17073H1.48837C1.21865 8.17073 1 7.94141 1 7.65854C1 7.37566 1.21865 7.14634 1.48837 7.14634H8.77453L7.42678 5.73284C7.23606 5.53282 7.23606 5.20851 7.42678 5.00849Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Cursor = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2.02048 2.80477C1.95668 3.09938 2.06232 3.38164 2.06232 3.38164L5.79527 13.3373C5.90921 13.6382 6.17455 13.8202 6.17455 13.8202C6.4399 14.0021 6.76161 14 6.76161 14C7.08333 13.9979 7.34622 13.8124 7.34622 13.8124C7.60911 13.6269 7.71904 13.3245 7.71904 13.3245L9.02001 9.74498L13.0684 13.7938C13.1646 13.8901 13.2954 13.9444 13.4314 13.9444C13.5675 13.9444 13.698 13.8903 13.7942 13.7941C13.8904 13.6979 13.9444 13.5674 13.9444 13.4313C13.9444 13.2952 13.8904 13.1647 13.7942 13.0685L9.74553 9.01942L13.3246 7.71831C13.6269 7.60837 13.8124 7.34545 13.8124 7.34545C13.9978 7.08253 14 6.76078 14 6.76078C14.0021 6.43902 13.8202 6.17365 13.8202 6.17365C13.6383 5.90828 13.3358 5.79373 13.3358 5.79373L3.38357 2.0612C3.10102 1.9552 2.80607 2.01908 2.80607 2.01908C2.51113 2.08297 2.29774 2.29638 2.29774 2.29638C2.08435 2.5098 2.02048 2.80477 2.02048 2.80477ZM3.02325 3.022L6.75477 12.9739L8.24966 8.86087C8.32805 8.6481 8.48838 8.48775 8.48838 8.48775C8.64871 8.3274 8.86357 8.24822 8.86357 8.24822L12.974 6.75393L3.02325 3.022Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Cybersecurite = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8 7.84211C7.55817 7.84211 7.2 8.21913 7.2 8.68421C7.2 9.07718 7.45571 9.40727 7.80152 9.5002C7.80052 9.50875 7.8 9.51747 7.8 9.52632V9.94737C7.8 10.0636 7.88954 10.1579 8 10.1579C8.11046 10.1579 8.2 10.0636 8.2 9.94737V9.52632C8.2 9.51747 8.19948 9.50875 8.19848 9.5002C8.54429 9.40727 8.8 9.07718 8.8 8.68421C8.8 8.21913 8.44183 7.84211 8 7.84211ZM7.6 8.68421C7.6 8.45167 7.77909 8.26316 8 8.26316C8.22091 8.26316 8.4 8.45167 8.4 8.68421C8.4 8.91675 8.22091 9.10526 8 9.10526C7.77909 9.10526 7.6 8.91675 7.6 8.68421Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.95 6.77183L5.95 6.78947H5.8C5.35817 6.78947 5 7.1665 5 7.63158V10.1579C5 10.623 5.35817 11 5.8 11H10.2C10.6418 11 11 10.623 11 10.1579V7.63158C11 7.1665 10.6418 6.78947 10.2 6.78947H10.05C10.05 6.36166 10.0352 5.67562 9.77525 5.09255C9.64274 4.79528 9.44376 4.51776 9.14687 4.31605C8.84971 4.11415 8.4718 4 8 4C7.51282 4 7.12626 4.11319 6.82504 4.31521C6.52335 4.51755 6.32564 4.79667 6.19717 5.09599C5.94987 5.67221 5.94995 6.35084 5.95 6.77183ZM6.65283 5.31268C6.45362 5.77684 6.45 6.35035 6.45 6.78947H9.55C9.55 6.35867 9.53008 5.78156 9.32261 5.31612C9.22143 5.08914 9.07857 4.89607 8.87572 4.75825C8.67315 4.62062 8.39344 4.52632 8 4.52632C7.58718 4.52632 7.29874 4.62159 7.09371 4.75909C6.88915 4.89628 6.74936 5.08775 6.65283 5.31268ZM5.8 7.31579C5.63431 7.31579 5.5 7.45717 5.5 7.63158V10.1579C5.5 10.3323 5.63431 10.4737 5.8 10.4737H10.2C10.3657 10.4737 10.5 10.3323 10.5 10.1579V7.63158C10.5 7.45717 10.3657 7.31579 10.2 7.31579H5.8Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.99516 1C8.38509 1 8.79741 1.05481 9.13558 1.17989L9.13933 1.18129L12.3578 2.40449C12.8325 2.58453 13.2384 2.94658 13.5237 3.36486C13.8091 3.78323 14 4.2962 14 4.81014V9.67057C14 10.1477 13.8477 10.6654 13.6236 11.1174C13.3993 11.5695 13.0798 12.0026 12.7022 12.2889L9.92902 14.3884C9.38209 14.805 8.68044 15 8 15C7.31956 15 6.61714 14.8045 6.07021 14.3878L3.29762 12.2887C2.92 12.0025 2.60069 11.5695 2.37645 11.1174C2.15228 10.6654 2 10.1477 2 9.67057V4.81014C2 4.29878 2.19139 3.78731 2.47658 3.37018C2.76171 2.95313 3.16788 2.59107 3.64231 2.411L6.85993 1.18158L6.86114 1.18112C7.195 1.05466 7.60578 1 7.99516 1ZM7.99516 1.91839C7.67531 1.91839 7.38004 1.96504 7.17854 2.04124L3.96052 3.27082L3.95946 3.27122C3.69235 3.37251 3.42411 3.59602 3.22075 3.89348C3.01733 4.19102 2.90556 4.52342 2.90556 4.81014V9.67057C2.90556 9.96533 3.00484 10.3406 3.18543 10.7047C3.36594 11.0686 3.60457 11.3748 3.83973 11.5531L6.61436 13.6537C6.97681 13.93 7.47779 14.0816 8 14.0816C8.52221 14.0816 9.02319 13.93 9.38564 13.6537L9.38686 13.6528L12.1603 11.5531C12.3954 11.3748 12.6341 11.0686 12.8146 10.7047C12.9952 10.3406 13.0944 9.96533 13.0944 9.67057V4.81014C13.0944 4.51946 12.9822 4.18529 12.779 3.88735C12.5757 3.58935 12.3073 3.36583 12.0402 3.26456L8.82356 2.04204C8.61354 1.96471 8.31388 1.91839 7.99516 1.91839Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Dai = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.33334 4.16658C5.0572 4.16658 4.83334 4.39044 4.83334 4.66658V6.16658H4.33334C4.0572 6.16658 3.83334 6.39044 3.83334 6.66658C3.83334 6.94273 4.0572 7.16658 4.33334 7.16658H4.83334V8.83325H4.33334C4.0572 8.83325 3.83334 9.05711 3.83334 9.33325C3.83334 9.60939 4.0572 9.83325 4.33334 9.83325H4.83334V11.3333C4.83334 11.6094 5.0572 11.8333 5.33334 11.8333H8.00001C9.47535 11.8333 10.7363 11.0319 11.3787 9.83325H12.3333C12.6095 9.83325 12.8333 9.60939 12.8333 9.33325C12.8333 9.05711 12.6095 8.83325 12.3333 8.83325H11.7454C11.803 8.56556 11.8333 8.28679 11.8333 7.99992C11.8333 7.71304 11.803 7.43428 11.7454 7.16658H12.3333C12.6095 7.16658 12.8333 6.94273 12.8333 6.66658C12.8333 6.39044 12.6095 6.16658 12.3333 6.16658H11.3787C10.7363 4.96796 9.47535 4.16658 8.00001 4.16658H5.33334ZM10.7138 8.83325C10.7917 8.5708 10.8333 8.29119 10.8333 7.99992C10.8333 7.70865 10.7917 7.42904 10.7138 7.16658H5.83334V8.83325H10.7138ZM5.83334 9.83325V10.8333H8.00001C8.88494 10.8333 9.66224 10.4485 10.1777 9.83325H5.83334ZM5.83334 6.16658H10.1777C9.66224 5.55131 8.88494 5.16658 8.00001 5.16658H5.83334V6.16658Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.00001 0.833252C4.04197 0.833252 0.833344 4.04188 0.833344 7.99992C0.833344 11.958 4.04197 15.1666 8.00001 15.1666C11.9581 15.1666 15.1667 11.958 15.1667 7.99992C15.1667 4.04188 11.9581 0.833252 8.00001 0.833252ZM1.83334 7.99992C1.83334 4.59416 4.59425 1.83325 8.00001 1.83325C11.4058 1.83325 14.1667 4.59416 14.1667 7.99992C14.1667 11.4057 11.4058 14.1666 8.00001 14.1666C4.59425 14.1666 1.83334 11.4057 1.83334 7.99992Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Dash = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.73336 1.83325C4.50183 1.83325 4.30059 1.99221 4.24696 2.21744L3.58029 5.01744C3.54486 5.16626 3.57951 5.32312 3.67433 5.44317C3.76915 5.56322 3.91372 5.63325 4.0667 5.63325H9.80003C10.4446 5.63325 10.7877 5.80693 10.9793 6.01871C11.1796 6.24008 11.3 6.59673 11.3 7.13325V7.26658C11.3 8.21259 11.0412 8.95989 10.5678 9.46709C10.1 9.96835 9.36209 10.2999 8.2667 10.2999H3.33336C3.10495 10.2999 2.90557 10.4547 2.84896 10.676L2.11563 13.5427C2.07735 13.6923 2.11037 13.8512 2.20509 13.9732C2.2998 14.0952 2.44558 14.1666 2.60003 14.1666H9.00003C10.9427 14.1666 12.4996 13.5455 13.5694 12.4292C14.6358 11.3164 15.1667 9.76535 15.1667 7.99992V6.33325C15.1667 5.07423 14.8061 3.93935 14.0308 3.11557C13.2507 2.28669 12.1075 1.83325 10.6667 1.83325H4.73336ZM4.69972 4.63325L5.12829 2.83325H10.6667C11.8925 2.83325 12.7494 3.21315 13.3026 3.80093C13.8606 4.39382 14.1667 5.25894 14.1667 6.33325V7.99992C14.1667 9.56782 13.6976 10.8501 12.8474 11.7373C12.0005 12.621 10.724 13.1666 9.00003 13.1666H3.24404L3.72156 11.2999H8.2667C9.5713 11.2999 10.6001 10.8982 11.2989 10.1494C11.9922 9.40661 12.3 8.38724 12.3 7.26658V7.13325C12.3 6.46977 12.1538 5.82642 11.7208 5.34779C11.2791 4.85957 10.6222 4.63325 9.80003 4.63325H4.69972Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2.86668 6.49992C2.04889 6.49992 1.3054 7.04546 1.11441 7.88041L0.850231 8.87109C0.810205 9.02118 0.842215 9.18135 0.936854 9.30454C1.03149 9.42772 1.17801 9.49992 1.33335 9.49992H6.13335C6.95114 9.49992 7.69464 8.95438 7.88562 8.11942L8.1498 7.12875C8.18982 6.97865 8.15781 6.81848 8.06318 6.6953C7.96854 6.57212 7.82202 6.49992 7.66668 6.49992H2.86668ZM2.08811 8.10838C2.16785 7.74957 2.48807 7.49992 2.86668 7.49992H7.01588L6.9169 7.87109C6.9151 7.87784 6.91344 7.88463 6.91192 7.89145C6.83218 8.25027 6.51196 8.49992 6.13335 8.49992H1.98415L2.08313 8.12875C2.08493 8.122 2.08659 8.11521 2.08811 8.10838Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Dashboard = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1.31952 2.31952C1 2.63904 1 3.09091 1 3.09091V6.36364V12.9091C1 13.361 1.31952 13.6805 1.31952 13.6805C1.63904 14 2.09091 14 2.09091 14H6.45455H14.0909C14.5428 14 14.8623 13.6805 14.8623 13.6805C15.1818 13.361 15.1818 12.9091 15.1818 12.9091V6.36364V3.09091C15.1818 2.63904 14.8623 2.31952 14.8623 2.31952C14.5428 2 14.0909 2 14.0909 2H2.09091C1.63904 2 1.31952 2.31952 1.31952 2.31952ZM14.0909 5.81818V3.09091H2.09091V5.81818H6.45455H14.0909ZM2.09091 6.90909V12.9091H5.90909V6.90909H2.09091ZM7 12.9091V6.90909H14.0909V12.9091H7Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Data_base = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M4.08794 2.94788C4.35779 2.94788 4.57654 3.16663 4.57654 3.43648V4.73941C4.57654 5.00925 4.35779 5.22801 4.08794 5.22801C3.81809 5.22801 3.59934 5.00925 3.59934 4.73941V3.43648C3.59934 3.16663 3.81809 2.94788 4.08794 2.94788Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M7.1824 3.43648C7.1824 3.16663 6.96365 2.94788 6.6938 2.94788C6.42396 2.94788 6.2052 3.16663 6.2052 3.43648V4.73941C6.2052 5.00925 6.42396 5.22801 6.6938 5.22801C6.96365 5.22801 7.1824 5.00925 7.1824 4.73941V3.43648Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M8.81107 4.08794C8.81107 3.81809 9.02982 3.59934 9.29967 3.59934H11.9055C12.1754 3.59934 12.3941 3.81809 12.3941 4.08794C12.3941 4.35779 12.1754 4.57654 11.9055 4.57654H9.29967C9.02982 4.57654 8.81107 4.35779 8.81107 4.08794Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.23453 1C2.00822 1 1 1.99933 1 3.23453V4.94789C1 6.17421 1.99934 7.18241 3.23453 7.18241H12.7655C13.993 7.18241 15 6.17539 15 4.94789V3.23453C15 2.00822 14.0007 1 12.7655 1H3.23453ZM1.9772 3.23453C1.9772 2.54139 2.54554 1.9772 3.23453 1.9772H12.7655C13.4586 1.9772 14.0228 2.54553 14.0228 3.23453V4.94789C14.0228 5.6357 13.4533 6.20521 12.7655 6.20521H3.23453C2.54139 6.20521 1.9772 5.63688 1.9772 4.94789V3.23453Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M4.08794 10.7655C4.35779 10.7655 4.57654 10.9842 4.57654 11.2541V12.557C4.57654 12.8268 4.35779 13.0456 4.08794 13.0456C3.81809 13.0456 3.59934 12.8268 3.59934 12.557V11.2541C3.59934 10.9842 3.81809 10.7655 4.08794 10.7655Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M7.1824 11.2541C7.1824 10.9842 6.96365 10.7655 6.6938 10.7655C6.42396 10.7655 6.2052 10.9842 6.2052 11.2541V12.557C6.2052 12.8268 6.42396 13.0456 6.6938 13.0456C6.96365 13.0456 7.1824 12.8268 7.1824 12.557V11.2541Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M9.29967 11.4169C9.02982 11.4169 8.81107 11.6357 8.81107 11.9055C8.81107 12.1754 9.02982 12.3941 9.29967 12.3941H11.9055C12.1754 12.3941 12.3941 12.1754 12.3941 11.9055C12.3941 11.6357 12.1754 11.4169 11.9055 11.4169H9.29967Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.23453 8.81759C2.00822 8.81759 1 9.81692 1 11.0521V12.7655C1 13.9918 1.99934 15 3.23453 15H12.7655C13.993 15 15 13.993 15 12.7655V11.0521C15 9.82581 14.0007 8.81759 12.7655 8.81759H3.23453ZM1.9772 11.0521C1.9772 10.359 2.54554 9.79479 3.23453 9.79479H12.7655C13.4586 9.79479 14.0228 10.3631 14.0228 11.0521V12.7655C14.0228 13.4533 13.4533 14.0228 12.7655 14.0228H3.23453C2.54139 14.0228 1.9772 13.4545 1.9772 12.7655V11.0521Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const DateIcon = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.02703 2.04167C3.02703 1.46637 3.51104 1 4.10811 1C4.70517 1 5.18919 1.46637 5.18919 2.04167V2.25H6.91892V2.04167C6.91892 1.46637 7.40293 1 8 1C8.59706 1 9.08108 1.46637 9.08108 2.04167V2.25H10.8108V2.04167C10.8108 1.46637 11.2948 1 11.8919 1C12.489 1 12.973 1.46637 12.973 2.04167V2.25H13.8378C15.032 2.25 16 3.18274 16 4.33333V8.70833C16 8.93845 15.8064 9.125 15.5676 9.125C15.3287 9.125 15.1351 8.93845 15.1351 8.70833V6H0.864865V13.0833C0.864865 13.7737 1.44568 14.3333 2.16216 14.3333H8.64865C8.88747 14.3333 9.08108 14.5199 9.08108 14.75C9.08108 14.9801 8.88747 15.1667 8.64865 15.1667H2.16216C0.968033 15.1667 0 14.2339 0 13.0833V4.33333C0 3.18274 0.968033 2.25 2.16216 2.25H3.02703V2.04167ZM4.10811 1.83333C4.22752 1.83333 4.32432 1.92661 4.32432 2.04167V3.29167C4.32432 3.40673 4.22752 3.5 4.10811 3.5C3.98869 3.5 3.89189 3.40673 3.89189 3.29167V2.04167C3.89189 1.92661 3.98869 1.83333 4.10811 1.83333ZM0.864865 5.16667H15.1351V4.33333C15.1351 3.64298 14.5543 3.08333 13.8378 3.08333H12.973V3.29167C12.973 3.86696 12.489 4.33333 11.8919 4.33333C11.2948 4.33333 10.8108 3.86696 10.8108 3.29167V3.08333H9.08108V3.29167C9.08108 3.86696 8.59706 4.33333 8 4.33333C7.40293 4.33333 6.91892 3.86696 6.91892 3.29167V3.08333H5.18919V3.29167C5.18919 3.86696 4.70517 4.33333 4.10811 4.33333C3.51104 4.33333 3.02703 3.86696 3.02703 3.29167V3.08333H2.16216C1.44568 3.08333 0.864865 3.64298 0.864865 4.33333V5.16667ZM8.21622 2.04167C8.21622 1.92661 8.11941 1.83333 8 1.83333C7.88059 1.83333 7.78378 1.92661 7.78378 2.04167V3.29167C7.78378 3.40673 7.88059 3.5 8 3.5C8.11941 3.5 8.21622 3.40673 8.21622 3.29167V2.04167ZM11.8919 1.83333C12.0113 1.83333 12.1081 1.92661 12.1081 2.04167V3.29167C12.1081 3.40673 12.0113 3.5 11.8919 3.5C11.7725 3.5 11.6757 3.40673 11.6757 3.29167V2.04167C11.6757 1.92661 11.7725 1.83333 11.8919 1.83333Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2.59459 7.04167C2.59459 6.92661 2.6914 6.83333 2.81081 6.83333H4.54054C4.65995 6.83333 4.75676 6.92661 4.75676 7.04167V8.29167C4.75676 8.40673 4.65995 8.5 4.54054 8.5H2.81081C2.6914 8.5 2.59459 8.40673 2.59459 8.29167V7.04167ZM3.24324 7.875V7.45833H4.10811V7.875H3.24324Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2.81081 9.33333C2.6914 9.33333 2.59459 9.42661 2.59459 9.54167V10.7917C2.59459 10.9067 2.6914 11 2.81081 11H4.54054C4.65995 11 4.75676 10.9067 4.75676 10.7917V9.54167C4.75676 9.42661 4.65995 9.33333 4.54054 9.33333H2.81081ZM3.24324 9.95833V10.375H4.10811V9.95833H3.24324Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2.59459 12.0417C2.59459 11.9266 2.6914 11.8333 2.81081 11.8333H4.54054C4.65995 11.8333 4.75676 11.9266 4.75676 12.0417V13.2917C4.75676 13.4067 4.65995 13.5 4.54054 13.5H2.81081C2.6914 13.5 2.59459 13.4067 2.59459 13.2917V12.0417ZM3.24324 12.875V12.4583H4.10811V12.875H3.24324Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.86486 6.83333C8.74545 6.83333 8.64865 6.92661 8.64865 7.04167V8.29167C8.64865 8.40673 8.74545 8.5 8.86486 8.5H10.5946C10.714 8.5 10.8108 8.40673 10.8108 8.29167V7.04167C10.8108 6.92661 10.714 6.83333 10.5946 6.83333H8.86486ZM9.2973 7.45833V7.875H10.1622V7.45833H9.2973Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.62162 7.04167C5.62162 6.92661 5.71842 6.83333 5.83784 6.83333H7.56757C7.68698 6.83333 7.78378 6.92661 7.78378 7.04167V8.29167C7.78378 8.40673 7.68698 8.5 7.56757 8.5H5.83784C5.71842 8.5 5.62162 8.40673 5.62162 8.29167V7.04167ZM6.27027 7.875V7.45833H7.13513V7.875H6.27027Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.83784 9.33333C5.71842 9.33333 5.62162 9.42661 5.62162 9.54167V10.7917C5.62162 10.9067 5.71842 11 5.83784 11H7.56757C7.68698 11 7.78378 10.9067 7.78378 10.7917V9.54167C7.78378 9.42661 7.68698 9.33333 7.56757 9.33333H5.83784ZM6.27027 9.95833V10.375H7.13513V9.95833H6.27027Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.62162 12.0417C5.62162 11.9266 5.71842 11.8333 5.83784 11.8333H7.56757C7.68698 11.8333 7.78378 11.9266 7.78378 12.0417V13.2917C7.78378 13.4067 7.68698 13.5 7.56757 13.5H5.83784C5.71842 13.5 5.62162 13.4067 5.62162 13.2917V12.0417ZM6.27027 12.875V12.4583H7.13513V12.875H6.27027Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.8919 6.83333C11.7725 6.83333 11.6757 6.92661 11.6757 7.04167V8.29167C11.6757 8.40673 11.7725 8.5 11.8919 8.5H13.6216C13.741 8.5 13.8378 8.40673 13.8378 8.29167V7.04167C13.8378 6.92661 13.741 6.83333 13.6216 6.83333H11.8919ZM12.3243 7.45833V7.875H13.1892V7.45833H12.3243Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M9.75065 12.6667C9.75065 11.182 10.9997 9.97849 12.5405 9.97849C13.1157 9.97849 13.6493 10.1458 14.0929 10.4327C14.2464 10.532 14.4544 10.4925 14.5575 10.3446C14.6605 10.1966 14.6195 9.99625 14.466 9.89698C13.9155 9.54101 13.2527 9.33333 12.5405 9.33333C10.6299 9.33333 9.08108 10.8257 9.08108 12.6667C9.08108 14.5076 10.6299 16 12.5405 16C14.4511 16 16 14.5076 16 12.6667C16 12.2478 15.9197 11.8463 15.7727 11.4762C15.7067 11.3098 15.5131 11.2265 15.3404 11.2901C15.1677 11.3537 15.0813 11.5402 15.1473 11.7066C15.2655 12.0044 15.3304 12.3278 15.3304 12.6667C15.3304 14.1513 14.0813 15.3548 12.5405 15.3548C10.9997 15.3548 9.75065 14.1513 9.75065 12.6667Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M15.9161 10.2996C16.0385 10.1661 16.0254 9.96223 15.8869 9.84427C15.7483 9.72632 15.5367 9.73893 15.4143 9.87244L12.3453 13.2197L11.4246 12.4262C11.2868 12.3075 11.0751 12.3188 10.9519 12.4516C10.8286 12.5844 10.8404 12.7883 10.9782 12.9071L12.15 13.9169C12.2164 13.9742 12.3038 14.0036 12.3928 13.9985C12.4818 13.9935 12.565 13.9544 12.624 13.8901L15.9161 10.2996Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Decred = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1.33336 2.16675C1.13113 2.16675 0.948809 2.28857 0.871418 2.47541C0.794028 2.66224 0.836806 2.8773 0.979805 3.0203L2.94482 4.98532C1.65983 5.86621 0.833358 7.34504 0.833358 9.00008C0.833358 11.6762 2.99055 13.8334 5.66669 13.8334H8.66669C8.86892 13.8334 9.05124 13.7116 9.12863 13.5248C9.20602 13.3379 9.16324 13.1229 9.02024 12.9799L7.02024 10.9799C6.92648 10.8861 6.7993 10.8334 6.66669 10.8334H5.66669C4.67617 10.8334 3.83336 9.99061 3.83336 9.00008C3.83336 8.00956 4.67617 7.16675 5.66669 7.16675H8.66669C8.86892 7.16675 9.05124 7.04493 9.12863 6.85809C9.20602 6.67125 9.16324 6.45619 9.02024 6.31319L5.02025 2.31319C4.92648 2.21943 4.7993 2.16675 4.66669 2.16675H1.33336ZM1.83336 9.00008C1.83336 7.56571 2.61325 6.29951 3.79373 5.63341H3.80002C4.00226 5.63341 4.18457 5.51159 4.26196 5.32476C4.33935 5.13792 4.29658 4.92286 4.15358 4.77986L2.54047 3.16675H4.45958L7.45958 6.16675H5.66669C4.12388 6.16675 2.83336 7.45727 2.83336 9.00008C2.83336 10.5429 4.12388 11.8334 5.66669 11.8334H6.45959L7.45958 12.8334H5.66669C3.54283 12.8334 1.83336 11.1239 1.83336 9.00008Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.33336 2.16675C7.13113 2.16675 6.94881 2.28857 6.87142 2.47541C6.79403 2.66224 6.83681 2.8773 6.9798 3.0203L8.9798 5.0203C9.07357 5.11407 9.20075 5.16675 9.33336 5.16675H10.3334C11.3239 5.16675 12.1667 6.00956 12.1667 7.00008C12.1667 7.99061 11.3239 8.83342 10.3334 8.83342H7.33336C7.13113 8.83342 6.94881 8.95524 6.87142 9.14207C6.79403 9.32891 6.83681 9.54397 6.9798 9.68697L10.9798 13.687C11.0736 13.7807 11.2008 13.8334 11.3334 13.8334H14.6667C14.8689 13.8334 15.0512 13.7116 15.1286 13.5248C15.206 13.3379 15.1632 13.1229 15.0202 12.9799L13.0552 11.0148C14.3402 10.134 15.1667 8.65512 15.1667 7.00008C15.1667 4.32394 13.0095 2.16675 10.3334 2.16675H7.33336ZM14.1667 7.00008C14.1667 8.43446 13.3868 9.70066 12.2063 10.3667H12.2C11.9978 10.3667 11.8155 10.4886 11.7381 10.6754C11.6607 10.8622 11.7035 11.0773 11.8465 11.2203L13.4596 12.8334H11.5405L8.54046 9.83342H10.3334C11.8762 9.83342 13.1667 8.54289 13.1667 7.00008C13.1667 5.45727 11.8762 4.16675 10.3334 4.16675H9.54047L8.54047 3.16675H10.3334C12.4572 3.16675 14.1667 4.87622 14.1667 7.00008Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Dent = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.36665 4.79985V5.68119L10.1387 5.24004C10.84 4.7866 11.6544 5.18013 12.016 5.72257C12.486 6.42751 12.0906 7.25156 11.544 7.61595L11.5297 7.6255L10.8744 7.99993L11.5297 8.37436L11.544 8.38392C12.1513 8.78877 12.3613 9.59529 12.0472 10.2235L12.0333 10.2514L12.016 10.2773C11.6112 10.8846 10.8046 11.0946 10.1764 10.7805L10.164 10.7743L9.36665 10.3187V11.2665C9.36665 12.0602 8.68905 12.5665 7.99999 12.5665C7.25718 12.5665 6.63332 11.9427 6.63332 11.1999V10.4234L5.8899 10.8482L5.86362 10.8595C5.23961 11.1269 4.395 10.9993 4.03376 10.318C3.59037 9.6189 3.98275 8.81049 4.52264 8.45056L4.53697 8.44101L5.30886 7.99993L4.57417 7.58011C3.80848 7.23225 3.65496 6.35955 4.02586 5.69702C4.38253 5.00251 5.23502 4.87097 5.86362 5.14037L5.8899 5.15163L6.63332 5.57644V4.79985C6.63332 4.05704 7.25718 3.43319 7.99999 3.43319C8.7428 3.43319 9.36665 4.05704 9.36665 4.79985ZM7.63332 4.79985C7.63332 4.60933 7.80946 4.43319 7.99999 4.43319C8.19051 4.43319 8.36665 4.60933 8.36665 4.79985V6.25262L8.09164 6.40977L7.63332 6.14787V4.79985ZM8.09164 7.56152L7.63332 7.82342V8.17644L8.09164 8.43834L8.36665 8.28119V7.71867L8.09164 7.56152ZM5.06542 9.29079L6.31664 8.57581L6.63332 8.75677V9.27166L5.44649 9.94985C5.15811 10.0625 4.95987 9.93498 4.91387 9.84298L4.89995 9.81514L4.88268 9.78924C4.84534 9.73322 4.83154 9.66007 4.86121 9.56363C4.89152 9.46514 4.96373 9.36253 5.06542 9.29079ZM9.36665 7.13835L9.86664 7.42405L11.0012 6.77572C11.1029 6.70398 11.1751 6.60137 11.2054 6.50288C11.2351 6.40644 11.2213 6.33328 11.184 6.27727C11.112 6.1693 11.0052 6.09262 10.9029 6.06114C10.8065 6.03147 10.7334 6.04527 10.6773 6.08261L10.663 6.09216L9.36665 6.83294V7.13835ZM9.86664 8.57581L9.36665 8.86151V9.16692L10.6333 9.89072C10.7968 9.96599 11.0339 9.91696 11.165 9.74882C11.231 9.5815 11.1745 9.34795 11.0008 9.2239L9.86664 8.57581ZM8.09164 9.59009L7.63332 9.85199V11.1999C7.63332 11.3904 7.80946 11.5665 7.99999 11.5665C8.24426 11.5665 8.36665 11.4062 8.36665 11.2665V9.74724L8.09164 9.59009ZM6.31664 7.42405L6.63332 7.24309V6.7282L5.44649 6.05001C5.15811 5.93736 4.95987 6.06488 4.91387 6.15688L4.90767 6.1693L4.90078 6.18135C4.82565 6.31283 4.82078 6.42769 4.84114 6.50329C4.85983 6.57272 4.9049 6.63425 4.99695 6.6737L5.02324 6.68497L6.31664 7.42405Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.99998 0.833252C4.04194 0.833252 0.833313 4.04188 0.833313 7.99992C0.833313 11.958 4.04194 15.1666 7.99998 15.1666C11.958 15.1666 15.1666 11.958 15.1666 7.99992C15.1666 4.04188 11.958 0.833252 7.99998 0.833252ZM1.83331 7.99992C1.83331 4.59416 4.59422 1.83325 7.99998 1.83325C11.4057 1.83325 14.1666 4.59416 14.1666 7.99992C14.1666 11.4057 11.4057 14.1666 7.99998 14.1666C4.59422 14.1666 1.83331 11.4057 1.83331 7.99992Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Discussion = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.0769 9.06667H3.8791L1.00217 11.3501C0.737819 11.5599 0.350356 11.5196 0.136742 11.2599C0.0482641 11.1524 0 11.0183 0 10.88V1.20889C0 1.20889 0 0.708151 0.360484 0.354075C0.360484 0.354075 0.720968 0 1.23077 0H11.0769C11.0769 0 11.5867 0 11.9472 0.354076C11.9472 0.354076 12.3077 0.708151 12.3077 1.20889V7.85778C12.3077 7.85778 12.3077 8.35852 11.9472 8.71259C11.9472 8.71259 11.5867 9.06667 11.0769 9.06667ZM11.0769 7.85778V1.20889H1.23077V9.61443L3.27476 7.99209C3.38425 7.90518 3.52077 7.85778 3.66154 7.85778H11.0769Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M14.7692 3.62667H11.6923C11.3524 3.62667 11.0769 3.89729 11.0769 4.23111C11.0769 4.56494 11.3524 4.83556 11.6923 4.83556H14.7692V13.2411L12.7252 11.6188C12.6158 11.5318 12.4792 11.4844 12.3385 11.4844H4.92308V8.46222C4.92308 8.1284 4.64756 7.85778 4.30769 7.85778C3.96782 7.85778 3.69231 8.1284 3.69231 8.46222V11.4844C3.69231 11.9852 4.05279 12.3393 4.05279 12.3393C4.41328 12.6933 4.92308 12.6933 4.92308 12.6933H12.1209L14.9978 14.9768C15.1073 15.0637 15.2438 15.1111 15.3846 15.1111C15.7245 15.1111 16 14.8405 16 14.5067V4.83556C16 4.33482 15.6395 3.98074 15.6395 3.98074C15.279 3.62667 14.7692 3.62667 14.7692 3.62667Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Doc = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M13.6805 14.6846C13.6805 14.6846 13.361 15 12.9091 15H3.09091C3.09091 15 2.63904 15 2.31952 14.6846C2.31952 14.6846 2 14.3692 2 13.9231V2.07692C2 2.07692 2 1.63085 2.31952 1.31542C2.31952 1.31542 2.63904 1 3.09091 1H9.63636C9.78103 1 9.91977 1.05673 10.0221 1.15771L13.8402 4.92694C13.9425 5.02792 14 5.16488 14 5.30769V13.9231C14 13.9231 14 14.3692 13.6805 14.6846ZM12.9091 13.9231V5.53073L9.41043 2.07692H3.09091V13.9231H12.9091Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M9.63636 5.84615H13.4545C13.7558 5.84615 14 5.60508 14 5.30769C14 5.01031 13.7558 4.76923 13.4545 4.76923H10.1818V1.53846C10.1818 1.24108 9.93761 1 9.63636 1C9.33512 1 9.09091 1.24108 9.09091 1.53846V5.30769C9.09091 5.60508 9.33512 5.84615 9.63636 5.84615Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M8.69163 11.0597L9.78247 12.1366C9.88477 12.2376 10.0235 12.2943 10.1682 12.2943C10.3128 12.2943 10.4516 12.2376 10.5539 12.1366C10.6562 12.0356 10.7136 11.8986 10.7136 11.7558C10.7136 11.613 10.6562 11.4761 10.5539 11.3751L9.46302 10.2982C9.36066 10.1972 9.22192 10.1404 9.07726 10.1404C8.9326 10.1404 8.79386 10.1972 8.69157 10.2981C8.58927 10.3991 8.53181 10.5361 8.53181 10.6789C8.53181 10.8217 8.58927 10.9587 8.69163 11.0597Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.72727 6.92308C7.72727 6.92308 8.74398 6.92308 9.4629 7.63278C9.4629 7.63278 10.1818 8.34248 10.1818 9.34615C10.1818 9.34615 10.1818 10.3498 9.4629 11.0595C9.4629 11.0595 8.74398 11.7692 7.72727 11.7692C7.72727 11.7692 6.71057 11.7692 5.99165 11.0595C5.99165 11.0595 5.27273 10.3498 5.27273 9.34615C5.27273 9.34615 5.27273 8.34248 5.99165 7.63278C5.99165 7.63278 6.71057 6.92308 7.72727 6.92308ZM7.72727 8C7.72727 8 7.16244 8 6.76304 8.39428C6.76304 8.39428 6.36364 8.78856 6.36364 9.34615C6.36364 9.34615 6.36364 9.90375 6.76304 10.298C6.76304 10.298 7.16244 10.6923 7.72727 10.6923C7.72727 10.6923 8.29217 10.6924 8.69157 10.2981C8.69157 10.2981 9.09091 9.90375 9.09091 9.34615C9.09091 9.34615 9.09091 8.78856 8.69151 8.39428C8.69151 8.39428 8.29211 8 7.72727 8Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Donnees_personnelles = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.49927 1C5.31816 1 3.55002 2.7232 3.55002 4.84889C3.55002 6.97457 5.31816 8.69777 7.49927 8.69777C9.68038 8.69777 11.4485 6.97457 11.4485 4.84889C11.4485 2.7232 9.68038 1 7.49927 1ZM4.34555 4.84889C4.34555 3.1514 5.75752 1.77531 7.49927 1.77531C9.24102 1.77531 10.653 3.1514 10.653 4.84889C10.653 6.54637 9.24102 7.92246 7.49927 7.92246C5.75752 7.92246 4.34555 6.54637 4.34555 4.84889Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.2829 12.1551C11.2829 11.9215 11.4723 11.7321 11.7059 11.7321C11.9395 11.7321 12.1289 11.9215 12.1289 12.1551C12.1289 12.336 12.0153 12.4903 11.8556 12.5508V12.754C11.8556 12.8367 11.7886 12.9037 11.7059 12.9037C11.6232 12.9037 11.5561 12.8367 11.5561 12.754V12.5508C11.3964 12.4903 11.2829 12.336 11.2829 12.1551ZM11.7059 11.9791C11.6087 11.9791 11.5299 12.0579 11.5299 12.1551C11.5299 12.2522 11.6087 12.331 11.7059 12.331C11.803 12.331 11.8818 12.2522 11.8818 12.1551C11.8818 12.0579 11.803 11.9791 11.7059 11.9791Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.6398 11.0878V10.9947C12.6398 10.7679 12.609 10.5189 12.4612 10.3262C12.305 10.1226 12.0525 10.0233 11.7059 10.0233C11.3593 10.0233 11.1068 10.1226 10.9506 10.3262C10.8027 10.5189 10.7719 10.7679 10.7719 10.9947V11.0878C10.6042 11.1128 10.4573 11.1719 10.3505 11.3005C10.2735 11.3932 10.2306 11.5068 10.206 11.6313C10.1815 11.7552 10.173 11.9009 10.173 12.0677V12.3922C10.173 12.559 10.1815 12.7047 10.206 12.8286C10.2306 12.9531 10.2735 13.0667 10.3505 13.1594C10.5098 13.3511 10.7583 13.3885 11.0321 13.3885H12.3797C12.6535 13.3885 12.902 13.3511 13.0612 13.1594C13.1382 13.0667 13.1811 12.9531 13.2058 12.8286C13.2303 12.7047 13.2388 12.559 13.2388 12.3922V12.0677C13.2388 11.9009 13.2303 11.7552 13.2058 11.6313C13.1811 11.5068 13.1382 11.3932 13.0612 11.3005C12.9545 11.1719 12.8076 11.1128 12.6398 11.0878ZM11.2446 10.5518C11.1741 10.6437 11.1425 10.7877 11.1425 10.9947V11.0714H12.2693V10.9947C12.2693 10.7877 12.2377 10.6437 12.1672 10.5518C12.105 10.4707 11.9832 10.3939 11.7059 10.3939C11.4286 10.3939 11.3068 10.4707 11.2446 10.5518ZM10.5436 12.0677C10.5436 11.9101 10.5519 11.7923 10.5695 11.7032C10.587 11.6148 10.6115 11.5663 10.6356 11.5373C10.6784 11.4857 10.7669 11.442 11.0321 11.442H12.3797C12.6449 11.442 12.7333 11.4857 12.7762 11.5373C12.8003 11.5663 12.8247 11.6148 12.8422 11.7032C12.8598 11.7923 12.8682 11.9101 12.8682 12.0677V12.3922C12.8682 12.5498 12.8598 12.6676 12.8422 12.7567C12.8247 12.8451 12.8003 12.8936 12.7762 12.9226C12.7333 12.9742 12.6449 13.0179 12.3797 13.0179H11.0321C10.7669 13.0179 10.6784 12.9742 10.6356 12.9226C10.6115 12.8936 10.587 12.8451 10.5695 12.7567C10.5519 12.6676 10.5436 12.5498 10.5436 12.3922V12.0677Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1.79553 14.6123C1.79553 12.218 4.27182 10.1542 7.49921 10.1542C7.99329 10.1542 8.47503 10.2041 8.93534 10.2977C8.67201 10.7558 8.5221 11.2844 8.5221 11.8434C8.5221 12.4338 8.69137 12.9943 8.99109 13.4694C9.15444 13.7392 9.36504 13.9837 9.60715 14.1889C10.1745 14.6928 10.9284 15 11.761 15C12.9423 15 13.9709 14.3849 14.5304 13.4703C14.7006 13.2012 14.8297 12.8948 14.9033 12.5797C14.968 12.3407 15 12.095 15 11.8434C15 11.0379 14.6842 10.2966 14.1678 9.73741C13.5818 9.08802 12.714 8.68672 11.761 8.68672C10.8653 8.68672 10.0477 9.0415 9.45822 9.62103C8.837 9.46358 8.17772 9.37894 7.49921 9.37894C3.99299 9.37894 1 11.6486 1 14.6123C1 14.8264 1.17809 15 1.39776 15C1.61744 15 1.79553 14.8264 1.79553 14.6123ZM11.761 9.46203C11.0764 9.46203 10.4538 9.73567 10.0077 10.1822C9.58036 10.6106 9.31763 11.1998 9.31763 11.8434C9.31763 12.2899 9.44584 12.711 9.67039 13.0659L9.67467 13.0728C9.79425 13.271 9.95083 13.4532 10.1322 13.6064L10.1345 13.6084L10.1371 13.6106L10.1401 13.6132C10.5666 13.9933 11.1324 14.2247 11.761 14.2247C12.6527 14.2247 13.4274 13.7611 13.8484 13.0712L13.8519 13.0657C13.9778 12.8669 14.0747 12.637 14.1289 12.402C14.1301 12.3971 14.1313 12.3922 14.1327 12.3873C14.1803 12.2132 14.2045 12.0322 14.2045 11.8434C14.2045 11.2375 13.967 10.6782 13.5752 10.2546L13.5717 10.2509C13.135 9.76607 12.4834 9.46203 11.761 9.46203Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Dot2 = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M11 8C11 9.65685 9.65685 11 8 11C6.34315 11 5 9.65685 5 8C5 6.34315 6.34315 5 8 5C9.65685 5 11 6.34315 11 8Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Doublon = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M3.44444 0C2.09442 0 1 0.997441 1 2.22785V13.5696C1 14.8 2.09441 15.7975 3.44444 15.7975H6.33333C6.70152 15.7975 7 15.5254 7 15.1899C7 14.8543 6.70152 14.5823 6.33333 14.5823H3.44444C2.83079 14.5823 2.33333 14.1289 2.33333 13.5696V2.22785C2.33333 1.66857 2.83079 1.21519 3.44444 1.21519H12.3333C12.947 1.21519 13.4444 1.66857 13.4444 2.22785V8.3038C13.4444 8.63936 13.7429 8.91139 14.1111 8.91139C14.4793 8.91139 14.7778 8.63936 14.7778 8.3038V2.22785C14.7778 0.997442 13.6834 0 12.3333 0H3.44444Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M4.33333 3.44304C4.33333 3.21933 4.53232 3.03797 4.77778 3.03797H11C11.2455 3.03797 11.4444 3.21933 11.4444 3.44304C11.4444 3.66675 11.2455 3.8481 11 3.8481H4.77778C4.53232 3.8481 4.33333 3.66675 4.33333 3.44304Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M4.77778 5.46835C4.53232 5.46835 4.33333 5.64971 4.33333 5.87342C4.33333 6.09713 4.53232 6.27848 4.77778 6.27848H11C11.2455 6.27848 11.4444 6.09713 11.4444 5.87342C11.4444 5.64971 11.2455 5.46835 11 5.46835H4.77778Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M4.33333 8.3038C4.33333 8.08009 4.53232 7.89873 4.77778 7.89873H11C11.2455 7.89873 11.4444 8.08009 11.4444 8.3038C11.4444 8.52751 11.2455 8.70886 11 8.70886H4.77778C4.53232 8.70886 4.33333 8.52751 4.33333 8.3038Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M7.50001 14.125C7.39646 14.2286 7.39646 14.3965 7.50001 14.5C7.60356 14.6036 7.77146 14.6036 7.87501 14.5L9.00002 13.375L10.125 14.5C10.2286 14.6036 10.3965 14.6036 10.5 14.5C10.6036 14.3965 10.6036 14.2286 10.5 14.125L9.37502 13L10.5 11.875C10.6036 11.7715 10.6036 11.6036 10.5 11.5C10.3965 11.3965 10.2286 11.3965 10.125 11.5L9.00002 12.625L7.87501 11.5C7.77146 11.3965 7.60356 11.3965 7.50001 11.5C7.39646 11.6036 7.39646 11.7715 7.50001 11.875L8.62501 13L7.50001 14.125Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M11.567 10.947C11.4597 11.0403 11.406 11.1477 11.406 11.269C11.406 11.3577 11.4293 11.4347 11.476 11.5C11.5227 11.5653 11.5787 11.6167 11.644 11.654C11.7467 11.584 11.875 11.5163 12.029 11.451C12.183 11.3857 12.358 11.353 12.554 11.353C12.8013 11.353 12.988 11.409 13.114 11.521C13.2447 11.6283 13.31 11.7707 13.31 11.948C13.31 12.102 13.261 12.2583 13.163 12.417C13.065 12.571 12.8807 12.767 12.61 13.005L11.497 14.027C11.4317 14.0877 11.3757 14.16 11.329 14.244C11.2823 14.3233 11.259 14.4213 11.259 14.538C11.259 14.636 11.2777 14.7247 11.315 14.804C11.357 14.8833 11.4153 14.9487 11.49 15H13.94C14.0287 15 14.101 14.972 14.157 14.916C14.2177 14.86 14.248 14.7713 14.248 14.65C14.248 14.58 14.2363 14.5147 14.213 14.454C14.1943 14.3933 14.1733 14.3467 14.15 14.314H12.267L13.296 13.411C13.6133 13.1403 13.842 12.886 13.982 12.648C14.122 12.4053 14.192 12.158 14.192 11.906C14.192 11.6587 14.1313 11.4417 14.01 11.255C13.8887 11.0637 13.7113 10.9167 13.478 10.814C13.2493 10.7067 12.9693 10.653 12.638 10.653C12.4 10.653 12.1877 10.6787 12.001 10.73C11.819 10.7813 11.6743 10.8537 11.567 10.947Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const DragDrop = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M11.9335 4.9177C11.5973 3.71213 10.7963 2.90633 9.81919 2.45488C8.78126 1.97536 7.54562 1.8932 6.42743 2.12295C5.31308 2.35191 4.26213 2.90245 3.63025 3.75087C3.0647 4.51023 2.86197 5.47408 3.20529 6.55805C1.80392 6.80648 0.999038 7.76484 1 8.83914C1.00107 10.0309 1.99398 11.0806 3.68947 11.1749C3.89982 11.1866 4.07957 11.0208 4.09096 10.8046C4.10234 10.5884 3.94104 10.4036 3.73069 10.3919C2.32465 10.3137 1.76346 9.50502 1.76287 8.83841C1.76227 8.1738 2.31897 7.36686 3.72275 7.28605C4.06565 7.28252 4.40769 7.34696 4.71253 7.46867C4.9089 7.54708 5.12992 7.44701 5.20619 7.24517C5.28247 7.04333 5.18512 6.81614 4.98875 6.73774C4.67782 6.61359 4.34133 6.53647 3.99943 6.51107C3.63644 5.57183 3.8006 4.81213 4.23599 4.22753C4.72237 3.57447 5.58278 3.09615 6.57697 2.89188C7.56732 2.68839 8.6374 2.76861 9.50645 3.1701C10.2462 3.51187 10.8405 4.08429 11.1362 4.9302C10.8866 4.96965 10.6437 5.03547 10.4109 5.1267C10.214 5.20384 10.1153 5.43039 10.1903 5.63272C10.2654 5.83505 10.4858 5.93654 10.6826 5.8594C10.9861 5.7405 11.3144 5.67567 11.6568 5.67079C12.9354 5.81787 13.7865 6.54924 14.0995 7.35335C14.4098 8.15052 14.2196 9.07882 13.2765 9.72532L13.2708 9.72928C12.6813 10.1494 11.8992 10.3909 11.0758 10.3861C10.8651 10.3849 10.6934 10.5594 10.6922 10.7759C10.691 10.9924 10.8608 11.169 11.0714 11.1702C12.0343 11.1758 12.9719 10.8954 13.7026 10.3758C14.9382 9.52709 15.2541 8.20865 14.8077 7.06203C14.3948 6.00126 13.3549 5.14249 11.9335 4.9177Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M8.04997 8.58817L9.10257 9.67012C9.25153 9.82323 9.49304 9.82323 9.642 9.67012C9.79096 9.51701 9.79096 9.26876 9.642 9.11565L7.93827 7.3644C7.78931 7.21129 7.5478 7.21129 7.39884 7.3644L5.69511 9.11565C5.54615 9.26876 5.54615 9.51701 5.69511 9.67012C5.84407 9.82323 6.08558 9.82323 6.23454 9.67012L7.28711 8.58819V12.6079C7.28711 12.8245 7.45788 13 7.66854 13C7.8792 13 8.04997 12.8245 8.04997 12.6079V8.58817Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Debit = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M8 1C6.29177 1 4.90697 2.45234 4.90697 4.2439V4.7561C4.90697 5.03898 5.12563 5.26829 5.39535 5.26829C5.66507 5.26829 5.88372 5.03898 5.88372 4.7561V4.2439C5.88372 3.0181 6.83121 2.02439 8 2.02439H11.907C13.0758 2.02439 14.0233 3.0181 14.0233 4.2439V11.7561C14.0233 12.9819 13.0758 13.9756 11.907 13.9756H8C6.83121 13.9756 5.88372 12.9819 5.88372 11.7561V11.2439C5.88372 10.961 5.66507 10.7317 5.39535 10.7317C5.12563 10.7317 4.90697 10.961 4.90697 11.2439V11.7561C4.90697 13.5477 6.29177 15 8 15H11.907C13.6152 15 15 13.5477 15 11.7561V4.2439C15 2.45234 13.6152 1 11.907 1H8Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M4.0151 5.00849C3.82438 4.80846 3.51516 4.80846 3.32444 5.00849L1.14304 7.29629C0.95232 7.49632 0.95232 7.82062 1.14304 8.02065L3.32444 10.3085C3.51516 10.5085 3.82438 10.5085 4.0151 10.3085C4.20582 10.1084 4.20582 9.78412 4.0151 9.5841L2.66747 8.17073H9.95351C10.2232 8.17073 10.4419 7.94141 10.4419 7.65854C10.4419 7.37566 10.2232 7.14634 9.95351 7.14634H2.66734L4.0151 5.73284C4.20582 5.53282 4.20582 5.20851 4.0151 5.00849Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Deconnexion = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M9.11991 1.03024C9.11991 0.461253 8.65685 0 8.08563 0C7.51441 0 7.05134 0.461253 7.05134 1.03024V7.21167C7.05134 7.78065 7.51441 8.24191 8.08563 8.24191C8.65685 8.24191 9.11991 7.78065 9.11991 7.21167V1.03024Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M1.15743 5.37048C1.86341 3.83897 3.06664 2.58893 4.57311 1.82193L5.47515 3.57978C4.36522 4.14489 3.47871 5.06588 2.95856 6.19426C2.43842 7.32264 2.31495 8.59262 2.60807 9.79945C2.90119 11.0063 3.59382 12.0796 4.57426 12.8463C5.55471 13.6131 6.76583 14.0286 8.01234 14.0258C9.25886 14.0231 10.4681 13.6022 11.4451 12.8311C12.4221 12.06 13.1099 10.9836 13.3977 9.77552C13.6854 8.56741 13.5562 7.29798 13.0311 6.17192C12.5059 5.04586 11.6153 4.12881 10.5028 3.56862L11.397 1.80679C12.9069 2.56711 14.1157 3.8118 14.8285 5.34016C15.5413 6.86852 15.7166 8.59147 15.3261 10.2312C14.9356 11.8709 14.002 13.3319 12.6759 14.3784C11.3499 15.425 9.70861 15.9962 8.01676 16C6.32491 16.0037 4.68109 15.4398 3.35036 14.3991C2.01964 13.3584 1.07956 11.9017 0.681721 10.2637C0.283878 8.6257 0.451457 6.90198 1.15743 5.37048Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Deconnexion2 = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.7879 0.999963H5.87669C8.90925 0.999963 10.3709 2.19276 10.6236 4.86462C10.6509 5.14407 10.446 5.39626 10.1591 5.42353C9.88595 5.45079 9.6264 5.2395 9.59908 4.96004C9.40101 2.81983 8.39016 2.02236 5.86986 2.02236H5.78107C3.00123 2.02236 2.0177 3.00386 2.0177 5.77796V10.222C2.0177 12.9961 3.00123 13.9776 5.78107 13.9776H5.86986C8.40382 13.9776 9.41467 13.1665 9.59908 10.9854C9.63323 10.7059 9.87229 10.4946 10.1591 10.5219C10.446 10.5423 10.6509 10.7945 10.6304 11.074C10.3982 13.7867 8.92974 15 5.87669 15H5.7879C2.43433 15 1.00002 13.5686 1.00002 10.222V5.77796C1.00002 2.43132 2.43433 0.999963 5.7879 0.999963ZM13.2532 8.51114L11.8394 9.922C11.6413 10.1197 11.6413 10.4468 11.8394 10.6445C12.0375 10.8422 12.3653 10.8422 12.5634 10.6445L14.8514 8.36114C15.0495 8.16348 15.0495 7.83631 14.8514 7.63865L12.5634 5.3553C12.4609 5.25306 12.3311 5.20535 12.2014 5.20535C12.0716 5.20535 11.935 5.25306 11.8394 5.3553C11.6413 5.55296 11.6413 5.88013 11.8394 6.07779L13.2533 7.48875H5.95181C5.67178 7.48875 5.43956 7.72049 5.43956 7.99994C5.43956 8.2794 5.67178 8.51114 5.95181 8.51114H13.2532Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Depot2 = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M6.70587 3.76481C6.70587 3.43993 6.96923 3.17657 7.2941 3.17657H10.3529C10.6778 3.17657 10.9412 3.43993 10.9412 3.76481C10.9412 4.08968 10.6778 4.35304 10.3529 4.35304H7.2941C6.96923 4.35304 6.70587 4.08968 6.70587 3.76481Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M7.2941 5.05892C6.96923 5.05892 6.70587 5.32229 6.70587 5.64716C6.70587 5.97203 6.96923 6.23539 7.2941 6.23539H10.3529C10.6778 6.23539 10.9412 5.97203 10.9412 5.64716C10.9412 5.32229 10.6778 5.05892 10.3529 5.05892H7.2941Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.9412 3.90206H13.7647C14.6094 3.90206 15.2941 4.5868 15.2941 5.43147V7.78354C15.5415 8.18287 15.6083 8.69521 15.4028 9.18249L13.6172 13.4178C13.3783 13.9846 12.823 14.353 12.2079 14.353H2.47058C1.62591 14.353 0.941171 13.6683 0.94117 12.8236L0.941162 4.35304C0.941162 3.50837 1.6259 2.82363 2.47057 2.82363H4.23974C4.29981 2.03393 4.9596 1.41187 5.76469 1.41187H11.4117C12.2564 1.41187 12.9412 2.09661 12.9412 2.94128V3.90206ZM4.23528 4.0001H2.47057C2.27565 4.0001 2.11763 4.15812 2.11763 4.35304L2.11764 10.8554L3.32392 7.99418C3.49583 7.58642 3.83145 7.2813 4.23528 7.14218V4.0001ZM5.41175 7.05892H11.7647V2.94128C11.7647 2.74635 11.6067 2.58834 11.4117 2.58834H5.76469C5.56977 2.58834 5.41175 2.74635 5.41175 2.94128V7.05892ZM12.9412 7.05892H13.9935C14.0354 7.05892 14.0768 7.06056 14.1176 7.06376V5.43147C14.1176 5.23655 13.9596 5.07853 13.7647 5.07853H12.9412V7.05892ZM2.9476 13.1766C2.69511 13.1766 2.52429 12.9192 2.62238 12.6865L4.40798 8.45122C4.46312 8.32043 4.59126 8.23539 4.7332 8.23539H13.9935C14.246 8.23539 14.4169 8.49279 14.3188 8.72545L12.5332 12.9607C12.478 13.0915 12.3499 13.1766 12.2079 13.1766H2.9476Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Desactivation = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M3.36416 1.68841C3.35859 1.68233 3.35287 1.67638 3.34701 1.67056C3.25512 1.57935 3.13228 1.52541 3.00247 1.51928L3.00091 1.51921C2.99316 1.51886 2.98539 1.51869 2.97763 1.51869C2.84767 1.51869 2.72239 1.56677 2.62623 1.65354C2.6201 1.65907 2.6141 1.66474 2.60824 1.67056C2.51635 1.76177 2.46201 1.8837 2.45583 2.01254L2.45576 2.01409C2.45541 2.02179 2.45524 2.0295 2.45524 2.0372C2.45524 2.16619 2.50368 2.29055 2.59109 2.38599L13.0388 13.7933C13.1378 13.9013 13.2782 13.963 13.4254 13.963L13.4276 13.963C13.5568 13.9624 13.6812 13.9144 13.7768 13.8281C13.8857 13.7299 13.9478 13.5906 13.9478 13.4445L13.9478 13.4423C13.9472 13.3141 13.8988 13.1906 13.8119 13.0957L3.36416 1.68841Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M10.8134 12.4074V11.8889C10.8134 11.6026 10.5796 11.3704 10.291 11.3704C10.0025 11.3704 9.76866 11.6026 9.76866 11.8889V12.4074C9.76866 13.0518 9.30965 13.5074 9.30965 13.5074C8.85064 13.963 8.2015 13.963 8.2015 13.963C7.55236 13.963 7.09335 13.5074 7.09335 13.5074C6.63434 13.0518 6.63434 12.4074 6.63434 12.4074V11.8889C6.63434 11.6026 6.40046 11.3704 6.11195 11.3704C5.82344 11.3704 5.58956 11.6026 5.58956 11.8889V12.4074C5.58956 13.4813 6.35458 14.2407 6.35458 14.2407C7.1196 15 8.2015 15 8.2015 15C9.2834 15 10.0484 14.2407 10.0484 14.2407C10.8134 13.4813 10.8134 12.4074 10.8134 12.4074Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M4.77261 3.82201L4.77313 3.82127C4.83281 3.73491 4.86476 3.63265 4.86476 3.52793C4.86476 3.51399 4.86419 3.50006 4.86306 3.48617C4.85039 3.33047 4.76768 3.18874 4.63791 3.10037C4.55091 3.04112 4.44788 3.00941 4.34237 3.00941L4.34136 3.00941C4.30963 3.00947 4.27796 3.01241 4.24676 3.01817C4.11055 3.04334 3.99 3.12119 3.91162 3.23458C2.98978 4.56823 2.9907 6.18559 2.9907 6.18559L2.9907 6.70381C2.9907 9.39338 2.14029 10.8514 2.14029 10.8514C2.00025 11.0921 2 11.3695 2 11.3695C1.99975 11.6469 2.13905 11.8873 2.13905 11.8873C2.27835 12.1278 2.52 12.2671 2.52 12.2671C2.76164 12.4065 3.04109 12.4074 3.04109 12.4074L12.0019 12.4074C12.2904 12.4074 12.5243 12.1753 12.5243 11.8889C12.5243 11.6026 12.2904 11.3704 12.0019 11.3704L3.04477 11.3704C4.03547 9.67145 4.03547 6.70381 4.03547 6.70381L4.03547 6.18501C4.03474 4.88996 4.77261 3.82201 4.77261 3.82201Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M12.3675 6.70384C12.3675 9.0205 12.991 10.6062 12.991 10.6062C13.0692 10.8052 13.2624 10.9362 13.4776 10.9362L13.488 10.9361C13.5495 10.9349 13.6102 10.9229 13.6675 10.9007C13.868 10.8231 14 10.6313 14 10.4177L13.9999 10.4074C13.9987 10.3464 13.9866 10.286 13.9643 10.2292C13.4123 8.82532 13.4123 6.70384 13.4123 6.70384V6.24366C13.4123 5.19168 13.0087 4.22423 13.0087 4.22423C12.6182 3.28796 11.906 2.56187 11.906 2.56187C11.1911 1.83294 10.2624 1.42853 10.2624 1.42853C9.2971 1.00819 8.23811 1.00023 8.23811 1.00023C6.83861 0.985673 5.62359 1.67815 5.62359 1.67815L5.62055 1.67989L6.14356 2.57762C7.11198 2.0256 8.23019 2.03722 8.23019 2.03722C9.94598 2.05012 11.1574 3.28526 11.1574 3.28526C12.3675 4.51906 12.3675 6.24366 12.3675 6.24366V6.70384Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Detail = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M3.44444 0C2.09442 0 1 0.997441 1 2.22785V13.5696C1 14.8 2.09441 15.7975 3.44444 15.7975H6.33333C6.70152 15.7975 7 15.5254 7 15.1899C7 14.8543 6.70152 14.5823 6.33333 14.5823H3.44444C2.83079 14.5823 2.33333 14.1289 2.33333 13.5696V2.22785C2.33333 1.66857 2.83079 1.21519 3.44444 1.21519H12.3333C12.947 1.21519 13.4444 1.66857 13.4444 2.22785V8.3038C13.4444 8.63936 13.7429 8.91139 14.1111 8.91139C14.4793 8.91139 14.7778 8.63936 14.7778 8.3038V2.22785C14.7778 0.997442 13.6834 0 12.3333 0H3.44444Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M4.33333 3.44304C4.33333 3.21933 4.53232 3.03797 4.77778 3.03797H11C11.2455 3.03797 11.4444 3.21933 11.4444 3.44304C11.4444 3.66675 11.2455 3.8481 11 3.8481H4.77778C4.53232 3.8481 4.33333 3.66675 4.33333 3.44304Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M4.33333 5.87342C4.33333 5.64971 4.53232 5.46835 4.77778 5.46835H11C11.2455 5.46835 11.4444 5.64971 11.4444 5.87342C11.4444 6.09713 11.2455 6.27848 11 6.27848H4.77778C4.53232 6.27848 4.33333 6.09713 4.33333 5.87342Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M9.5 10C9.22386 10 9 10.2239 9 10.5C9 10.7761 9.22386 11 9.5 11H11.5C11.7761 11 12 10.7761 12 10.5C12 10.2239 11.7761 10 11.5 10H9.5Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M9.5 12C9.22386 12 9 12.2239 9 12.5C9 12.7761 9.22386 13 9.5 13H11.5C11.7761 13 12 12.7761 12 12.5C12 12.2239 11.7761 12 11.5 12H9.5Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.33333 8.3038C4.33333 8.08009 4.53232 7.89873 4.77778 7.89873H11C11.1699 7.89873 11.3175 7.98558 11.3923 8.11321C12.8787 8.49322 13.9732 9.78615 13.9732 11.3227C13.9732 12.3359 13.4973 13.2431 12.747 13.8526C12.7893 13.8798 12.8277 13.9141 12.8601 13.9553L13.9061 15.2843C14.0616 15.4819 14.0196 15.7623 13.8122 15.9105C13.6049 16.0587 13.3107 16.0187 13.1551 15.8211L12.1092 14.492C12.0644 14.4352 12.0361 14.3715 12.0232 14.3061C11.5597 14.5233 11.0381 14.6453 10.4866 14.6453C8.56099 14.6453 7 13.1577 7 11.3227C7 11.2138 7.00549 11.1062 7.01623 11H5.375C5.16789 11 5 10.8321 5 10.625C5 10.4179 5.16789 10.25 5.375 10.25H7.18568C7.40551 9.63547 7.80899 9.10195 8.33377 8.70886H4.77778C4.53232 8.70886 4.33333 8.52751 4.33333 8.3038ZM13.0345 11.3227C13.0345 12.6637 11.8937 13.7508 10.4866 13.7508C9.07942 13.7508 7.93869 12.6637 7.93869 11.3227C7.93869 9.98167 9.07942 8.89457 10.4866 8.89457C11.8937 8.89457 13.0345 9.98167 13.0345 11.3227Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Edge = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.64234 1C8.03432 1 7.45745 1.07418 6.91641 1.19811L6.91231 1.19905L6.90823 1.20011C6.36012 1.34327 5.85767 1.5565 5.38646 1.81827C4.90984 2.08305 4.48037 2.40908 4.09376 2.78649C3.70763 3.16344 3.36966 3.58407 3.08207 4.04369L3.08113 4.04521C2.79433 4.51012 2.55505 5.01261 2.37446 5.55251C2.19506 6.08882 2.06505 6.65433 2 7.24248L2.51502 7.41912C2.79825 6.95225 3.14838 6.51953 3.56714 6.11495C3.98654 5.71395 4.44598 5.36375 4.94572 5.0661C5.44568 4.77252 5.97005 4.54069 6.52108 4.37965L6.52376 4.37886C7.0727 4.21242 7.62044 4.1325 8.16782 4.1325C8.6331 4.1325 9.01672 4.19084 9.32479 4.29775L9.32622 4.29825C9.63107 4.40218 9.86971 4.55832 10.0523 4.75941L10.0541 4.7613C10.2376 4.95976 10.3753 5.2175 10.4639 5.54331C10.5353 5.80581 10.5793 6.1079 10.5944 6.4537H6.44256C6.49277 6.19921 6.56925 5.94432 6.67375 5.68958L6.67493 5.68664C6.81367 5.33726 7.01018 5.03972 7.26116 4.78759L6.96019 4.32977C6.42603 4.5453 5.94464 4.82545 5.51515 5.16841C5.08589 5.51118 4.72148 5.90581 4.42305 6.34989C4.1223 6.79428 3.89526 7.27777 3.73495 7.80722L3.73474 7.80793C3.57599 8.3373 3.49713 8.8896 3.49713 9.4679C3.49713 10.009 3.56723 10.5225 3.70667 11.0072L3.70734 11.0095C3.84983 11.4896 4.04805 11.9397 4.30747 12.3518C4.56498 12.7608 4.87167 13.1312 5.23396 13.4597C5.59174 13.786 5.98487 14.064 6.41501 14.2932C6.84586 14.5229 7.30433 14.6968 7.79169 14.8176C8.28032 14.9386 8.78773 15 9.31127 15C9.69799 15 10.0695 14.9784 10.432 14.9396C10.7985 14.9004 11.1555 14.8352 11.507 14.7485C11.8587 14.664 12.2022 14.5582 12.5432 14.4383L12.5461 14.4372C12.8894 14.3122 13.2332 14.1676 13.5836 13.9949L13.7395 13.918V10.4289L13.3294 10.6489C13.0294 10.81 12.7377 10.9544 12.4502 11.0864L12.4495 11.0868C12.167 11.2174 11.8865 11.3308 11.5974 11.4256C11.3086 11.5203 11.0155 11.595 10.7139 11.6516C10.419 11.7049 10.1057 11.731 9.7649 11.731C9.49834 11.731 9.23521 11.7092 8.96282 11.6653C8.69687 11.6217 8.43578 11.5546 8.18748 11.4642L8.185 11.4633C7.9367 11.3757 7.70514 11.2631 7.49383 11.128L7.49194 11.1268L7.49004 11.1256C7.27606 10.9936 7.09565 10.8383 6.94138 10.6572C6.79058 10.4801 6.67003 10.2751 6.57559 10.0407C6.51931 9.88824 6.48123 9.72169 6.46222 9.54H15V7.5905C15 6.89045 14.9044 6.21532 14.7172 5.56592C14.53 4.91632 14.257 4.31656 13.8953 3.77257C13.533 3.22771 13.088 2.75264 12.5605 2.33656L12.5594 2.33568C12.0282 1.92116 11.426 1.596 10.7545 1.36384L10.7524 1.36314C10.4147 1.24933 10.0695 1.16218 9.7171 1.09703L9.71547 1.09673C9.35938 1.03309 9.0023 1 8.64234 1ZM5.65623 2.30833C6.09108 2.06676 6.54891 1.87299 7.04445 1.74315C7.54741 1.62824 8.08126 1.56 8.64234 1.56C8.96777 1.56 9.29189 1.58986 9.61701 1.64793C9.94544 1.70869 10.2643 1.78938 10.5741 1.89372C11.1896 2.10664 11.7366 2.4028 12.2168 2.77744C12.7008 3.15927 13.1044 3.59127 13.4318 4.08363C13.7599 4.57704 14.0095 5.12388 14.1818 5.72168C14.3542 6.31968 14.4426 6.94235 14.4426 7.5905V8.98H5.89065V9.26C5.89065 9.61132 5.94292 9.93919 6.05456 10.2399L6.05584 10.2433L6.05721 10.2467C6.17161 10.5317 6.32236 10.7918 6.51783 11.0212C6.71012 11.247 6.93463 11.4399 7.19646 11.6016C7.44417 11.7598 7.71325 11.8902 7.99891 11.9912C8.2811 12.0938 8.57553 12.1693 8.87345 12.2181L8.87408 12.2182C9.17434 12.2666 9.46716 12.291 9.7649 12.291C10.1345 12.291 10.4815 12.2626 10.8135 12.2026L10.8153 12.2022C11.1404 12.1413 11.4574 12.0606 11.7704 11.958C12.0832 11.8554 12.3837 11.7337 12.6822 11.5956C12.8473 11.5198 13.0137 11.4401 13.182 11.3557V13.5673C12.905 13.6978 12.6315 13.8104 12.3576 13.9102C12.0304 14.0252 11.7056 14.125 11.3766 14.2041L11.375 14.2045C11.0453 14.2858 10.7127 14.3464 10.373 14.3828C10.0289 14.4196 9.67711 14.44 9.31127 14.44C8.83142 14.44 8.36888 14.3838 7.92518 14.2738C7.48021 14.1636 7.06489 14.0057 6.67629 13.7986C6.28712 13.5911 5.93198 13.34 5.60837 13.0448L5.60774 13.0442C5.28451 12.7512 5.01017 12.4203 4.7786 12.0524C4.54905 11.6878 4.3711 11.2857 4.24187 10.8506C4.11814 10.4201 4.05457 9.95955 4.05457 9.4679C4.05457 8.94173 4.12618 8.44415 4.26838 7.96983C4.41322 7.49159 4.61667 7.05973 4.88431 6.66435L4.88484 6.66355C5.15078 6.26777 5.47612 5.91493 5.86201 5.60679C5.97406 5.51732 6.09019 5.43247 6.2105 5.3523C6.19218 5.39351 6.1746 5.4353 6.15775 5.47768C5.99175 5.88271 5.88706 6.29164 5.84021 6.70178L5.80458 7.0137H11.1578V6.7337C11.1578 6.23297 11.1081 5.78702 11.0016 5.39569C10.8939 4.99955 10.7182 4.65701 10.4633 4.38103C10.2114 4.10399 9.89034 3.89934 9.50613 3.76821C9.12451 3.63588 8.67637 3.5725 8.16782 3.5725C7.56591 3.5725 6.96437 3.66045 6.36403 3.84234C5.76607 4.01721 5.19993 4.2681 4.66365 4.58308L4.66221 4.58393C4.12558 4.90348 3.6322 5.27958 3.18231 5.7098L3.1813 5.71077C3.04154 5.84577 2.90844 5.98412 2.78206 6.12602C2.81902 5.99267 2.85937 5.86093 2.90286 5.73089C3.06918 5.23368 3.28963 4.77043 3.5545 4.34095C3.81868 3.91887 4.12857 3.53336 4.48224 3.18811C4.83564 2.84312 5.22561 2.54755 5.65623 2.30833Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Edito = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M1.84684 0.337402C1.0132 0.337402 0.337402 1.0132 0.337402 1.84684V14.1532C0.337402 14.9868 1.0132 15.6626 1.84684 15.6626H11.8002C12.6339 15.6626 13.3097 14.9868 13.3097 14.1532V12.7818C13.3097 12.4483 13.0393 12.178 12.7059 12.178C12.3724 12.178 12.1021 12.4483 12.1021 12.7818V14.1532C12.1021 14.3199 11.9669 14.455 11.8002 14.455H1.84684C1.68011 14.455 1.54495 14.3199 1.54495 14.1532V1.84684C1.54495 1.68011 1.68011 1.54495 1.84684 1.54495H11.8002C11.9669 1.54495 12.1021 1.68011 12.1021 1.84684V3.44592C12.1021 3.77937 12.3724 4.04969 12.7059 4.04969C13.0393 4.04969 13.3097 3.77937 13.3097 3.44592V1.84684C13.3097 1.0132 12.6339 0.337402 11.8002 0.337402H1.84684Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M13.4849 4.10006C13.7808 3.74981 14.2888 3.72327 14.6196 4.04078L15.6538 5.03357C15.9846 5.35108 16.0129 5.89241 15.717 6.24267L14.512 7.66907L12.28 5.52646L13.4849 4.10006ZM14.1011 5.00472L13.7241 5.45101L14.4316 6.13022L14.8087 5.68393L14.1011 5.00472Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.1028 5.69012L14.2819 7.81603L10.4069 12.3294L8.14766 12.5406L8.23589 10.1941L12.1028 5.69012ZM12.1708 7.22964L9.24278 10.6401L9.21622 11.3464L9.91732 11.2809L12.8373 7.87986L12.1708 7.22964Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Educare = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.20001 1.56665C6.18339 1.56665 6.16679 1.56748 6.15026 1.56913C5.61764 1.62239 5.21748 1.97084 5.04511 2.39513C4.87106 2.82355 4.91988 3.3603 5.31312 3.75354L7.11312 5.55354C7.36144 5.80186 7.70077 5.89998 8.00001 5.89998C8.29925 5.89998 8.63858 5.80186 8.8869 5.55354L10.6869 3.75354C11.0846 3.35581 11.1251 2.80205 10.9569 2.37505C10.7877 1.94554 10.3754 1.56665 9.80001 1.56665H6.20001ZM5.97158 2.77151C6.0137 2.66781 6.10606 2.58596 6.23029 2.56665H9.80001C9.89124 2.56665 9.97901 2.6211 10.0265 2.74158C10.0749 2.86459 10.0487 2.97749 9.97979 3.04643L8.17979 4.84643C8.16144 4.86478 8.10077 4.89998 8.00001 4.89998C7.89925 4.89998 7.83858 4.86478 7.82023 4.84643L6.02023 3.04643C5.9468 2.973 5.92895 2.87642 5.97158 2.77151Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.8869 10.4463C8.63858 10.198 8.29925 10.0999 8.00001 10.0999C7.70077 10.0999 7.36144 10.198 7.11312 10.4463L5.31312 12.2463C4.91988 12.6395 4.87106 13.1763 5.04511 13.6047C5.21748 14.029 5.61764 14.3774 6.15026 14.4307C6.16679 14.4324 6.18339 14.4332 6.20001 14.4332H9.80001C10.3754 14.4332 10.7877 14.0543 10.9569 13.6248C11.1251 13.1978 11.0846 12.644 10.6869 12.2463L8.8869 10.4463ZM7.82023 11.1534C7.83858 11.1351 7.89925 11.0999 8.00001 11.0999C8.10077 11.0999 8.16144 11.1351 8.17979 11.1534L9.97979 12.9534C10.0487 13.0223 10.0749 13.1352 10.0265 13.2583C9.97901 13.3787 9.89124 13.4332 9.80001 13.4332H6.23029C6.10606 13.4139 6.0137 13.332 5.97158 13.2283C5.92895 13.1234 5.9468 13.0268 6.02023 12.9534L7.82023 11.1534Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2.4987 5.08527C2.8782 4.36634 3.81478 4.30766 4.35357 4.84644L6.6869 7.17978C7.14883 7.64171 7.14883 8.35829 6.6869 8.82022L4.35357 11.1536C4.08788 11.4192 3.73707 11.5511 3.37701 11.5041C3.02182 11.4578 2.7186 11.2459 2.51732 10.944L2.51003 10.9327L1.06883 8.63994C0.913998 8.4659 0.816681 8.24456 0.816681 8C0.816681 7.75544 0.913998 7.5341 1.06883 7.36006L2.4987 5.08527ZM3.4787 5.4878C3.43435 5.49335 3.4013 5.51546 3.38056 5.55694C3.37329 5.57148 3.36532 5.58565 3.35667 5.59942L1.89 7.93275C1.87503 7.95656 1.85809 7.97906 1.83936 8C1.85809 8.02094 1.87503 8.04343 1.89 8.06725L3.35249 10.3939C3.41677 10.4881 3.47866 10.5089 3.50635 10.5125C3.52962 10.5156 3.57882 10.5141 3.64646 10.4464L5.97979 8.11311C6.02235 8.07055 6.03335 8.02988 6.03335 8C6.03335 7.97011 6.02235 7.92944 5.97979 7.88689L3.64646 5.55355C3.5886 5.49569 3.52517 5.48199 3.4787 5.4878Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.6454 4.54547C12.9606 4.58487 13.2961 4.74793 13.4923 5.0709L14.9312 7.36001C15.086 7.53405 15.1833 7.75538 15.1833 7.99995C15.1833 8.2445 15.086 8.46584 14.9312 8.63989L13.49 10.9327L13.4827 10.944C13.2814 11.2459 12.9782 11.4577 12.623 11.5041C12.2629 11.551 11.9121 11.4192 11.6465 11.1535L9.31312 8.82017C8.85119 8.35824 8.85119 7.64165 9.31312 7.17973L11.6465 4.84639C11.6595 4.83335 11.6733 4.82104 11.6877 4.80951C11.971 4.58284 12.3264 4.50561 12.6454 4.54547ZM10.0202 7.88683L12.3281 5.57895C12.3779 5.54617 12.4483 5.52863 12.5213 5.53775C12.6045 5.54814 12.6338 5.58357 12.6379 5.59053L12.6434 5.59936L14.11 7.9327C14.125 7.95651 14.1419 7.97901 14.1607 7.99995C14.1419 8.02089 14.125 8.04338 14.11 8.06719L12.6475 10.3939C12.5833 10.488 12.5214 10.5089 12.4937 10.5125C12.4704 10.5155 12.4212 10.514 12.3536 10.4464L10.0202 8.11306C9.97767 8.0705 9.96667 8.02983 9.96667 7.99995C9.96667 7.97006 9.97767 7.92939 10.0202 7.88683Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Emercoin = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M4.49999 5.33325C4.49999 5.05711 4.72385 4.83325 4.99999 4.83325H11C11.2761 4.83325 11.5 5.05711 11.5 5.33325V10.6666C11.5 10.9427 11.2761 11.1666 11 11.1666H4.99999C4.72385 11.1666 4.49999 10.9427 4.49999 10.6666C4.49999 10.3904 4.72385 10.1666 4.99999 10.1666H10.5V5.83325H8.83333V7.99992C8.83333 8.27606 8.60947 8.49992 8.33333 8.49992H4.99999C4.72385 8.49992 4.49999 8.27606 4.49999 7.99992C4.49999 7.72378 4.72385 7.49992 4.99999 7.49992H7.83333V5.83325H4.99999C4.72385 5.83325 4.49999 5.60939 4.49999 5.33325Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0.833328 7.99992C0.833328 4.04188 4.04195 0.833252 7.99999 0.833252C11.958 0.833252 15.1667 4.04188 15.1667 7.99992C15.1667 11.958 11.958 15.1666 7.99999 15.1666C4.04195 15.1666 0.833328 11.958 0.833328 7.99992ZM7.99999 1.83325C4.59424 1.83325 1.83333 4.59416 1.83333 7.99992C1.83333 11.4057 4.59424 14.1666 7.99999 14.1666C11.4058 14.1666 14.1667 11.4057 14.1667 7.99992C14.1667 4.59416 11.4058 1.83325 7.99999 1.83325Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Emission = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M13.6805 14.6846C13.6805 14.6846 13.361 15 12.9091 15H3.09091C3.09091 15 2.63904 15 2.31952 14.6846C2.31952 14.6846 2 14.3692 2 13.9231V2.07692C2 2.07692 2 1.63085 2.31952 1.31542C2.31952 1.31542 2.63904 1 3.09091 1H9.63636C9.78103 1 9.91977 1.05673 10.0221 1.15771L13.8402 4.92694C13.9425 5.02792 14 5.16488 14 5.30769V13.9231C14 13.9231 14 14.3692 13.6805 14.6846ZM12.9091 13.9231V5.53073L9.41043 2.07692H3.09091V13.9231H12.9091Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M9.63636 5.84615H13.4545C13.7558 5.84615 14 5.60508 14 5.30769C14 5.01031 13.7558 4.76923 13.4545 4.76923H10.1818V1.53846C10.1818 1.24108 9.93761 1 9.63636 1C9.33512 1 9.09091 1.24108 9.09091 1.53846V5.30769C9.09091 5.60508 9.33512 5.84615 9.63636 5.84615Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M9.52311 9.72663C9.62541 9.82761 9.76443 9.88462 9.90909 9.88462C10.0538 9.88462 10.1925 9.82789 10.2948 9.7269C10.3971 9.62592 10.4545 9.48896 10.4545 9.34615C10.4545 9.20335 10.3971 9.06639 10.2948 8.9654L8.38569 7.08079C8.2834 6.97981 8.14466 6.92308 8 6.92308C7.85534 6.92308 7.7166 6.97981 7.61431 7.08079L5.70521 8.9654C5.60292 9.06639 5.54545 9.20335 5.54545 9.34615C5.54545 9.35478 5.54566 9.3634 5.54608 9.37202C5.5526 9.50573 5.60933 9.63225 5.70521 9.7269C5.80751 9.82789 5.94625 9.88462 6.09091 9.88462C6.23557 9.88462 6.37431 9.82789 6.4766 9.7269L8 8.22304L9.52311 9.72663Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M8.54545 11.7692V7.46154C8.54545 7.16415 8.30125 6.92308 8 6.92308C7.69875 6.92308 7.45455 7.16415 7.45455 7.46154V11.7692C7.45455 12.0666 7.69875 12.3077 8 12.3077C8.30125 12.3077 8.54545 12.0666 8.54545 11.7692Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Empreinte = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M12.7006 2.729C12.6428 2.729 12.585 2.715 12.5344 2.687C11.1475 1.994 9.94835 1.7 8.51084 1.7C7.08054 1.7 5.72249 2.029 4.48724 2.687C4.31387 2.778 4.09716 2.715 3.99602 2.547C3.90212 2.379 3.96713 2.162 4.1405 2.071C5.48411 1.364 6.95774 1 8.51084 1C10.0495 1 11.3931 1.329 12.8667 2.064C13.0473 2.155 13.1123 2.365 13.0184 2.533C12.9534 2.659 12.8306 2.729 12.7006 2.729Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M2.36347 6.404C2.29123 6.404 2.21899 6.383 2.15398 6.341C1.98783 6.229 1.95172 6.012 2.0673 5.851C2.78244 4.871 3.69263 4.101 4.77618 3.562C7.04442 2.428 9.94835 2.421 12.2238 3.555C13.3074 4.094 14.2176 4.857 14.9327 5.83C15.0483 5.984 15.0122 6.208 14.846 6.32C14.6799 6.432 14.4559 6.397 14.3404 6.236C13.6902 5.354 12.8667 4.661 11.8915 4.178C9.81833 3.149 7.16723 3.149 5.10125 4.185C4.11883 4.675 3.29532 5.375 2.64519 6.257C2.5874 6.355 2.47905 6.404 2.36347 6.404Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M6.62545 14.748C6.69046 14.818 6.78437 14.853 6.87828 14.853C6.97219 14.853 7.0661 14.818 7.14556 14.748C7.28281 14.608 7.28281 14.391 7.14556 14.251C6.58933 13.705 6.27149 13.362 5.80917 12.557C5.36853 11.801 5.13737 10.87 5.13737 9.862C5.13737 8.168 6.64712 6.789 8.50361 6.789C10.3601 6.789 11.8699 8.168 11.8699 9.862C11.8699 10.058 12.0288 10.212 12.231 10.212C12.4333 10.212 12.5922 10.058 12.5922 9.862C12.5922 7.783 10.7574 6.089 8.50361 6.089C6.24982 6.089 4.415 7.783 4.415 9.862C4.415 10.989 4.67505 12.039 5.17349 12.9C5.65747 13.747 5.99699 14.139 6.62545 14.748Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M12.0577 13.558C11.1981 13.558 10.4396 13.348 9.81833 12.935C8.74199 12.228 8.09909 11.08 8.09909 9.862C8.09909 9.666 8.25801 9.512 8.46027 9.512C8.66253 9.512 8.82146 9.666 8.82146 9.862C8.82146 10.849 9.34156 11.78 10.2229 12.354C10.7357 12.69 11.3353 12.851 12.0577 12.851C12.231 12.851 12.52 12.83 12.8089 12.781C13.004 12.746 13.1918 12.872 13.2279 13.068C13.264 13.257 13.134 13.439 12.9317 13.474C12.52 13.551 12.1588 13.558 12.0577 13.558Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M10.5118 14.986C10.5407 14.993 10.5768 15 10.6057 15C10.7574 15 10.9091 14.895 10.9452 14.734C10.9958 14.552 10.8874 14.356 10.6924 14.307C9.67385 14.034 9.01649 13.67 8.33024 13.012C7.45618 12.172 6.97941 11.052 6.97941 9.855C6.97941 9.106 7.65122 8.497 8.48194 8.497C9.31267 8.497 9.98447 9.106 9.98447 9.855C9.98447 10.989 10.9813 11.913 12.2094 11.913C13.4374 11.913 14.4343 10.989 14.4343 9.855C14.4343 6.831 11.7615 4.374 8.47472 4.374C6.14146 4.374 4.01047 5.641 3.04972 7.594C2.72465 8.259 2.55851 9.022 2.55851 9.862C2.55851 10.807 2.73188 11.717 3.08584 12.634C3.15085 12.809 3.36034 12.907 3.54815 12.837C3.73597 12.774 3.82988 12.571 3.75764 12.389C3.32422 11.269 3.27365 10.408 3.27365 9.862C3.27365 9.134 3.41813 8.469 3.69985 7.902C4.54502 6.187 6.42319 5.081 8.47472 5.081C11.3642 5.081 13.7119 7.223 13.7119 9.862C13.7119 10.611 13.0401 11.22 12.2094 11.22C11.3786 11.22 10.7068 10.611 10.7068 9.862C10.7068 8.728 9.70997 7.804 8.48194 7.804C7.25391 7.804 6.25704 8.728 6.25704 9.862C6.25704 11.248 6.81327 12.543 7.82458 13.516C8.61197 14.265 9.36323 14.678 10.5118 14.986Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const En_attente_de_validation = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M8.08297 1.92634C8.31041 1.51464 8.02611 1 7.57122 1H4.50077C4.04589 1 3.76159 1.51464 3.98903 1.92634L4.50038 2.85197C3.54488 3.63146 2.81261 4.6785 2.39366 5.87867C1.88582 7.3335 1.86885 8.92601 2.34556 10.3923C2.82228 11.8586 3.76406 13.1106 5.01485 13.941C6.26564 14.7713 7.75034 15.1301 9.22294 14.9578L9.10004 13.8102C7.87778 13.9531 6.64548 13.6553 5.60733 12.9662C4.56917 12.277 3.78749 11.2378 3.39182 10.0208C2.99614 8.80375 3.01023 7.48197 3.43174 6.27446C3.76158 5.32957 4.3254 4.49902 5.0594 3.86389L5.52426 4.70535C5.7517 5.11706 6.3203 5.11706 6.54774 4.70535L8.08297 1.92634Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M12.0455 3.88392C12.3718 3.88392 12.6364 3.60744 12.6364 3.26637C12.6364 2.92529 12.3718 2.64881 12.0455 2.64881C11.7191 2.64881 11.4545 2.92529 11.4545 3.26637C11.4545 3.60744 11.7191 3.88392 12.0455 3.88392Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M13.8182 5.7366C14.1445 5.7366 14.4091 5.46012 14.4091 5.11904C14.4091 4.77797 14.1445 4.50148 13.8182 4.50148C13.4918 4.50148 13.2273 4.77797 13.2273 5.11904C13.2273 5.46012 13.4918 5.7366 13.8182 5.7366Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M14.4091 8.20684C14.7354 8.20684 15 7.93035 15 7.58928C15 7.24821 14.7354 6.97172 14.4091 6.97172C14.0827 6.97172 13.8182 7.24821 13.8182 7.58928C13.8182 7.93035 14.0827 8.20684 14.4091 8.20684Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M14.4091 10.6771C14.7354 10.6771 15 10.4006 15 10.0595C15 9.71844 14.7354 9.44196 14.4091 9.44196C14.0827 9.44196 13.8182 9.71844 13.8182 10.0595C13.8182 10.4006 14.0827 10.6771 14.4091 10.6771Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M13.2273 13.1473C13.5536 13.1473 13.8182 12.8708 13.8182 12.5298C13.8182 12.1887 13.5536 11.9122 13.2273 11.9122C12.9009 11.9122 12.6364 12.1887 12.6364 12.5298C12.6364 12.8708 12.9009 13.1473 13.2273 13.1473Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M10.8636 14.3824C11.19 14.3824 11.4545 14.1059 11.4545 13.7649C11.4545 13.4238 11.19 13.1473 10.8636 13.1473C10.5373 13.1473 10.2727 13.4238 10.2727 13.7649C10.2727 14.1059 10.5373 14.3824 10.8636 14.3824Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M11.6392 5.41045C11.7749 5.56041 11.7877 5.81956 11.6678 5.9893L8.4438 10.5537C8.386 10.6356 8.30449 10.6852 8.21734 10.6916C8.13018 10.698 8.04458 10.6607 7.97951 10.5879L6.44263 8.80363C6.30766 8.65265 6.29611 8.3934 6.41683 8.22458C6.53754 8.05577 6.74482 8.04132 6.87978 8.19231L8.17078 9.70149L11.1764 5.44627C11.2963 5.27654 11.5035 5.2605 11.6392 5.41045Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const En_cours = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M7.61505 2.86017C7.82499 2.47788 7.56256 2 7.14267 2H4.30841C3.88851 2 3.62608 2.47788 3.83603 2.86017L4.30804 3.71969C3.42604 4.4435 2.7501 5.41575 2.36338 6.53019C1.8946 7.8811 1.87894 9.35986 2.31898 10.7214C2.75903 12.083 3.62836 13.2456 4.78294 14.0166C5.93751 14.7876 7.30801 15.1208 8.66733 14.9609L8.55389 13.8952C7.42565 14.0279 6.28813 13.7514 5.32984 13.1114C4.37154 12.4715 3.64999 11.5065 3.28475 10.3764C2.91952 9.24634 2.93252 8.01897 3.3216 6.89771C3.62607 6.02031 4.14652 5.24909 4.82406 4.65933L5.25316 5.44069C5.46311 5.82299 5.98797 5.82299 6.19791 5.44069L7.61505 2.86017Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M11.2727 4.67793C11.574 4.67793 11.8182 4.42119 11.8182 4.10448C11.8182 3.78777 11.574 3.53103 11.2727 3.53103C10.9715 3.53103 10.7273 3.78777 10.7273 4.10448C10.7273 4.42119 10.9715 4.67793 11.2727 4.67793Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M13.4545 5.82483C13.4545 6.14154 13.2103 6.39827 12.9091 6.39827C12.6078 6.39827 12.3636 6.14154 12.3636 5.82483C12.3636 5.50812 12.6078 5.25138 12.9091 5.25138C13.2103 5.25138 13.4545 5.50812 13.4545 5.82483Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M13.4545 8.69206C13.7558 8.69206 14 8.43533 14 8.11862C14 7.80191 13.7558 7.54517 13.4545 7.54517C13.1533 7.54517 12.9091 7.80191 12.9091 8.11862C12.9091 8.43533 13.1533 8.69206 13.4545 8.69206Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M14 10.4124C14 10.7291 13.7558 10.9859 13.4545 10.9859C13.1533 10.9859 12.9091 10.7291 12.9091 10.4124C12.9091 10.0957 13.1533 9.83896 13.4545 9.83896C13.7558 9.83896 14 10.0957 14 10.4124Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M12.3636 13.2796C12.6649 13.2796 12.9091 13.0229 12.9091 12.7062C12.9091 12.3895 12.6649 12.1328 12.3636 12.1328C12.0624 12.1328 11.8182 12.3895 11.8182 12.7062C11.8182 13.0229 12.0624 13.2796 12.3636 13.2796Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M10.7273 13.8531C10.7273 14.1698 10.4831 14.4265 10.1818 14.4265C9.88057 14.4265 9.63636 14.1698 9.63636 13.8531C9.63636 13.5364 9.88057 13.2796 10.1818 13.2796C10.4831 13.2796 10.7273 13.5364 10.7273 13.8531Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const En_savoir_plus = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement("circle", { cx: "3", cy: "8", r: "2", fill: "currentColor" }),
      /* @__PURE__ */ React__default.createElement("circle", { cx: "8", cy: "8", r: "2", fill: "currentColor" }),
      /* @__PURE__ */ React__default.createElement("circle", { cx: "13", cy: "8", r: "2", fill: "currentColor" })
    );
  }
);
const EnjinCoin = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M4.7 7.33325C4.7 5.99044 5.85719 4.83325 7.2 4.83325H10.5333C10.8095 4.83325 11.0333 5.05711 11.0333 5.33325C11.0333 5.60939 10.8095 5.83325 10.5333 5.83325H7.2C6.40948 5.83325 5.7 6.54273 5.7 7.33325V7.49992H10.5333C10.8095 7.49992 11.0333 7.72378 11.0333 7.99992C11.0333 8.27606 10.8095 8.49992 10.5333 8.49992H5.7V8.66658C5.7 9.45711 6.40948 10.1666 7.2 10.1666H10.5333C10.8095 10.1666 11.0333 10.3904 11.0333 10.6666C11.0333 10.9427 10.8095 11.1666 10.5333 11.1666H7.2C5.85719 11.1666 4.7 10.0094 4.7 8.66658V7.33325Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0.833344 7.99992C0.833344 4.04188 4.04197 0.833252 8.00001 0.833252C11.9581 0.833252 15.1667 4.04188 15.1667 7.99992C15.1667 11.958 11.9581 15.1666 8.00001 15.1666C4.04197 15.1666 0.833344 11.958 0.833344 7.99992ZM8.00001 1.83325C4.59425 1.83325 1.83334 4.59416 1.83334 7.99992C1.83334 11.4057 4.59425 14.1666 8.00001 14.1666C11.4058 14.1666 14.1667 11.4057 14.1667 7.99992C14.1667 4.59416 11.4058 1.83325 8.00001 1.83325Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Enrole = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M7.4186 2.02273C7.22595 2.02273 7.06977 2.17536 7.06977 2.36364C7.06977 2.55192 7.22595 2.70455 7.4186 2.70455H8.5814C8.77405 2.70455 8.93023 2.55192 8.93023 2.36364C8.93023 2.17536 8.77405 2.02273 8.5814 2.02273H7.4186Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M8.05814 14.75C8.34713 14.75 8.5814 14.5211 8.5814 14.2386C8.5814 13.9562 8.34713 13.7273 8.05814 13.7273C7.76915 13.7273 7.53488 13.9562 7.53488 14.2386C7.53488 14.5211 7.76915 14.75 8.05814 14.75Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.51163 1C3.67678 1 3 1.6614 3 2.47727V14.5227C3 15.3386 3.67678 16 4.51163 16H11.4884C12.3232 16 13 15.3386 13 14.5227V2.47727C13 1.6614 12.3232 1 11.4884 1H4.51163ZM11.4884 1.90909H4.51163C4.19053 1.90909 3.93023 2.16347 3.93023 2.47727V2.93182H12.0698V2.47727C12.0698 2.16347 11.8095 1.90909 11.4884 1.90909ZM3.93023 14.5227V13.3864H12.0698V14.5227C12.0698 14.8365 11.8095 15.0909 11.4884 15.0909H4.51163C4.19053 15.0909 3.93023 14.8365 3.93023 14.5227ZM12.0698 12.4773H3.93023V3.84091H12.0698V12.4773Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Entreprise = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M5.2 9.4H7.06667C7.3244 9.4 7.53333 9.14928 7.53333 8.84C7.53333 8.53072 7.3244 8.28 7.06667 8.28H5.2C4.94227 8.28 4.73333 8.53072 4.73333 8.84C4.73333 9.14928 4.94227 9.4 5.2 9.4Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M6.6 11.64C6.6 11.9493 6.39107 12.2 6.13333 12.2H4.26667C4.00893 12.2 3.8 11.9493 3.8 11.64C3.8 11.3307 4.00893 11.08 4.26667 11.08H6.13333C6.39107 11.08 6.6 11.3307 6.6 11.64Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M4.5 4C4.22386 4 4 4.22386 4 4.5C4 4.77614 4.22386 5 4.5 5H6.5C6.77614 5 7 4.77614 7 4.5C7 4.22386 6.77614 4 6.5 4H4.5Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M10.3333 11.64C10.3333 11.9493 10.5423 12.2 10.8 12.2H11.7333C11.9911 12.2 12.2 11.9493 12.2 11.64C12.2 11.3307 11.9911 11.08 11.7333 11.08H10.8C10.5423 11.08 10.3333 11.3307 10.3333 11.64Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M10.8 9.4C10.5423 9.4 10.3333 9.14928 10.3333 8.84C10.3333 8.53072 10.5423 8.28 10.8 8.28H11.7333C11.9911 8.28 12.2 8.53072 12.2 8.84C12.2 9.14928 11.9911 9.4 11.7333 9.4H10.8Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1.93333 2.12V13.88H1.46667C1.20893 13.88 1 14.1307 1 14.44C1 14.7493 1.20893 15 1.46667 15H14.5333C14.7911 15 15 14.7493 15 14.44C15 14.1307 14.7911 13.88 14.5333 13.88H14.0667V6.6C14.0667 6.13608 13.7933 5.80804 13.7933 5.80804C13.5199 5.48 13.1333 5.48 13.1333 5.48H9.4V2.12C9.4 1.65608 9.12663 1.32804 9.12663 1.32804C8.85327 1 8.46667 1 8.46667 1H2.86667C2.48007 1 2.2067 1.32804 2.2067 1.32804C1.93333 1.65608 1.93333 2.12 1.93333 2.12ZM8.46667 2.12H2.86667V13.88H8.46667V2.12ZM9.4 6.6H13.1333V13.88H9.4V6.6Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Envoyer = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14.2364 1.02831C14.2364 1.02831 13.9681 0.959711 13.7024 1.03608L13.7003 1.03667L1.75361 4.40126C1.75361 4.40126 1.44093 4.48674 1.23413 4.73634C1.23413 4.73634 1.02733 4.98594 1.00148 5.30903C1.00148 5.30903 0.975629 5.63213 1.14012 5.91142C1.14012 5.91142 1.3046 6.19072 1.59256 6.3215L7.08106 8.91807L9.67454 14.3991C9.67454 14.3991 9.80865 14.6941 10.088 14.8586C10.088 14.8586 10.3673 15.0231 10.6904 14.9972C10.6904 14.9972 11.0135 14.9714 11.2631 14.7646C11.2631 14.7646 11.5128 14.5578 11.5972 14.249L14.9622 2.30218C14.9622 2.30218 15.0407 2.03403 14.9714 1.76335C14.9714 1.76335 14.9022 1.49267 14.7046 1.29511C14.7046 1.29511 14.507 1.09755 14.2364 1.02831ZM2.02418 5.39084L13.9744 2.0253L10.6096 13.9708L10.6086 13.9746L8.00828 8.47891C8.00828 8.47891 7.85383 8.1454 7.51648 7.98918L2.03134 5.39416L2.02418 5.39084Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M10.7285 5.99634C10.8247 5.90015 10.879 5.76949 10.879 5.63344C10.879 5.4974 10.8249 5.36693 10.7287 5.27073L10.7243 5.26636C10.6285 5.17302 10.4998 5.12049 10.366 5.12049C10.3506 5.12049 10.3352 5.12119 10.3199 5.12257C10.2003 5.13336 10.0882 5.1858 10.0033 5.27073L7.10508 8.1687C7.00888 8.2649 6.95464 8.39556 6.95464 8.5316C6.95464 8.53982 6.95484 8.54803 6.95523 8.55624C6.96136 8.68362 7.01471 8.80414 7.10489 8.89431C7.20109 8.99051 7.33157 9.04455 7.46762 9.04455C7.60368 9.04455 7.73416 8.99051 7.83036 8.89431L10.7285 5.99634Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Eos = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.02494 1C8.46826 1 8.87213 1.2227 9.155 1.60425L11.5411 4.53837C11.5661 4.56903 11.5874 4.60258 11.6048 4.63835C11.6158 4.66091 11.6307 4.68865 11.6545 4.73301C11.6759 4.77299 11.7035 4.82445 11.7295 4.87796C11.7653 4.95162 11.8385 5.1056 11.854 5.28156L12.978 11.1351C12.979 11.1402 12.9798 11.1452 12.9807 11.1503C13.0778 11.7505 12.8033 12.447 12.2798 12.7703L12.2689 12.7769L8.74443 14.8307C8.73699 14.835 8.72944 14.8392 8.72179 14.8431C8.49762 14.9585 8.23136 15 8 15C7.76864 15 7.50238 14.9585 7.27821 14.8431C7.27056 14.8392 7.26301 14.835 7.25557 14.8307L3.7311 12.7769L3.72018 12.7703C3.19674 12.447 2.92217 11.7505 3.01933 11.1503C3.02015 11.1452 3.02104 11.1402 3.02201 11.1351L4.1525 5.24762C4.16117 5.20247 4.1757 5.15873 4.19569 5.11757C4.21773 5.07218 4.24287 5.00848 4.27846 4.91689L4.28216 4.90735C4.31264 4.82888 4.35248 4.72628 4.39519 4.63835C4.41256 4.60258 4.43393 4.56903 4.45886 4.53837L6.85284 1.5946L6.85991 1.5861C7.17012 1.22113 7.58254 1 8.02494 1ZM5.26576 5.14585L7.61383 2.25853C7.76801 2.07888 7.91945 2.02689 8.02494 2.02689C8.12565 2.02689 8.25 2.0734 8.36575 2.23227C8.37109 2.2396 8.37661 2.24678 8.38233 2.25381L10.7416 5.15491C10.7511 5.17317 10.7606 5.19095 10.7694 5.20725C10.7641 5.21951 10.7592 5.23208 10.7548 5.24494L8.06454 13.1029L5.31045 5.24142C5.29853 5.2074 5.28348 5.17547 5.26576 5.14585ZM4.84461 6.93854L4.00229 11.3253C3.97003 11.5432 4.09081 11.7983 4.22938 11.8873L7.18082 13.6071L4.84461 6.93854ZM8.98202 13.5123L11.7706 11.8873C11.9092 11.7983 12.03 11.5432 11.9977 11.3253L11.1831 7.08311L8.98202 13.5123Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const EthereumClassic = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.8591 1.22327L12.1867 5.28295C12.1913 5.28851 12.1957 5.29417 12.2 5.29992C12.4411 5.62134 12.4088 6.016 12.2083 6.28325C12.0131 6.54357 11.6336 6.7005 11.257 6.52063L8.08916 5.13468C8.05025 5.12262 8.02758 5.11859 8.01658 5.11725C8.01124 5.11982 8.00585 5.12229 8.00042 5.12466L4.80957 6.52066C4.43997 6.69697 4.04539 6.55271 3.85065 6.2606C3.6448 5.95182 3.69135 5.55218 3.95949 5.26729L7.27426 1.22327C7.67417 0.703245 8.4592 0.703246 8.8591 1.22327ZM10.8773 5.26299L8.07998 1.85022C8.07543 1.84466 8.07099 1.839 8.06668 1.83325C8.06237 1.839 8.05793 1.84466 8.05338 1.85022L5.29329 5.21752L7.58972 4.21283C7.87869 4.07337 8.1558 4.10258 8.42479 4.19224C8.43913 4.19702 8.45324 4.20245 8.46709 4.20851L10.8773 5.26299Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.2083 9.7166C12.4088 9.98386 12.4411 10.3785 12.2 10.6999C12.1957 10.7057 12.1913 10.7113 12.1867 10.7169L8.85909 14.7766C8.45919 15.2966 7.67417 15.2966 7.27426 14.7766L3.95949 10.7326C3.69135 10.4477 3.6448 10.048 3.85065 9.73925C4.04539 9.44715 4.43997 9.30289 4.80957 9.47919L8.00042 10.8752C8.00585 10.8776 8.01124 10.88 8.01658 10.8826C8.02758 10.8813 8.05025 10.8772 8.08916 10.8652L11.257 9.47923C11.6336 9.29935 12.0131 9.45629 12.2083 9.7166ZM10.8773 10.7369L8.46709 11.7913C8.45324 11.7974 8.43913 11.8028 8.42479 11.8076C8.1558 11.8973 7.87869 11.9265 7.58972 11.787L5.29329 10.7823L8.05338 14.1496C8.05793 14.1552 8.06237 14.1609 8.06668 14.1666C8.07099 14.1609 8.07543 14.1552 8.07998 14.1496L10.8773 10.7369Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.22362 5.81931C8.08286 5.74892 7.91717 5.74893 7.77641 5.81931L4.30974 7.55264C4.14035 7.63734 4.03335 7.81047 4.03335 7.99985C4.03335 8.18924 4.14035 8.36237 4.30974 8.44707L7.77641 10.1804C7.91717 10.2508 8.08286 10.2508 8.22362 10.1804L11.6903 8.44707C11.8597 8.36237 11.9667 8.18924 11.9667 7.99985C11.9667 7.81047 11.8597 7.63734 11.6903 7.55264L8.22362 5.81931ZM5.65138 7.99985L8.00002 6.82554L10.3486 7.99985L8.00002 9.17417L5.65138 7.99985Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Ethereum = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.6001 4.82478L9.31258 1.72385C8.97536 1.25887 8.50299 1 8.00537 1C7.50773 1 7.03444 1.25882 6.69453 1.72252L4.39868 4.82642C4.05855 5.28665 3.93018 5.84194 4.03627 6.36717C4.14231 6.89212 4.47238 7.33708 4.95754 7.59847L4.95852 7.599L7.2471 8.84394L7.25092 8.846C7.48144 8.96851 7.75353 9.01687 7.99999 9.01687C8.24646 9.01687 8.51855 8.96851 8.74907 8.846L8.75289 8.84394L11.0442 7.59752C11.5282 7.33278 11.8577 6.88676 11.9637 6.36217C12.0697 5.83748 11.9419 5.28363 11.601 4.82598L11.6001 4.82478ZM8.46673 2.20097V4.78949L10.7373 6.63729C10.9265 6.50075 11.0288 6.32256 11.064 6.1482C11.1053 5.94379 11.0645 5.6953 10.8842 5.4536L10.8826 5.45146L8.5895 2.34296C8.55012 2.28853 8.50899 2.24138 8.46673 2.20097ZM7.54566 2.19678V4.7893L5.26827 6.64261C5.07543 6.50798 4.97155 6.3293 4.93598 6.1532C4.89472 5.94891 4.9353 5.69792 5.11701 5.45196L7.41353 2.34715L7.41497 2.3452C7.45691 2.28791 7.50073 2.23866 7.54566 2.19678ZM7.65759 7.94928L6.18325 7.14727L8.00608 5.66387L9.82403 7.1433L8.3424 7.94928C8.27178 7.98632 8.14852 8.01746 7.99999 8.01746C7.85147 8.01746 7.72821 7.98632 7.65759 7.94928Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.80858 9.15993C11.134 8.52075 12.3617 10.2565 11.4389 11.4787L9.31447 14.2968C8.97298 14.7501 8.5018 15 8.00842 15C7.51527 15 7.04355 14.7506 6.69944 14.2991L6.69745 14.2964L4.57999 11.4794C3.64419 10.2501 4.88566 8.52577 6.20871 9.15941L6.21076 9.16039L7.19916 9.64C7.71128 9.88817 8.29957 9.88909 8.81991 9.63966L8.82072 9.63928L9.80858 9.15993ZM10.1831 10.073C10.6258 9.85997 11.031 10.4422 10.7263 10.8455L8.60141 13.6642C8.42098 13.9038 8.20424 14.0006 8.00842 14.0006C7.81263 14.0006 7.59395 13.9039 7.41018 13.6634L5.29278 10.8465L5.29064 10.8436C4.98845 10.4476 5.37917 9.85554 5.83592 10.0733L6.82335 10.5524C7.5759 10.9171 8.43662 10.9164 9.1933 10.5533L10.1831 10.073Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Euros = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M6.16678 7.90424C6.16552 7.93602 6.16488 7.96794 6.16488 8C6.16488 8.09711 6.17074 8.19298 6.18215 8.28728H9.02602C9.24397 8.28728 9.42065 8.45877 9.42065 8.67032C9.42065 8.88186 9.24397 9.05335 9.02602 9.05335H6.41005C6.82592 9.89991 7.72779 10.4897 8.7802 10.4897C9.23171 10.4897 9.65519 10.3811 10.0246 10.1904C10.2171 10.0911 10.456 10.162 10.5584 10.3488C10.6607 10.5356 10.5877 10.7675 10.3952 10.8668C9.91405 11.1152 9.36361 11.2558 8.7802 11.2558C7.28946 11.2558 6.01605 10.3372 5.55752 9.05335H4.48766C4.26971 9.05335 4.09302 8.88186 4.09302 8.67032C4.09302 8.45877 4.26971 8.28728 4.48766 8.28728H5.38864C5.38001 8.19265 5.3756 8.09683 5.3756 8C5.3756 7.96797 5.37608 7.93604 5.37704 7.90424H4.48766C4.26971 7.90424 4.09302 7.73275 4.09302 7.5212C4.09302 7.30966 4.26971 7.13817 4.48766 7.13817H5.49599C5.89163 5.75509 7.21633 4.74419 8.7802 4.74419C9.36361 4.74419 9.91405 4.88482 10.3952 5.13318C10.5877 5.2325 10.6607 5.46443 10.5584 5.65121C10.456 5.83799 10.2171 5.90888 10.0246 5.80956C9.65519 5.61887 9.23171 5.51026 8.7802 5.51026C7.65011 5.51026 6.69361 6.19038 6.32604 7.13817H9.02602C9.24397 7.13817 9.42065 7.30966 9.42065 7.5212C9.42065 7.73275 9.24397 7.90424 9.02602 7.90424H6.16678Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1ZM1.97674 8C1.97674 4.67345 4.67345 1.97674 8 1.97674C11.3266 1.97674 14.0233 4.67345 14.0233 8C14.0233 11.3266 11.3266 14.0233 8 14.0233C4.67345 14.0233 1.97674 11.3266 1.97674 8Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Explorer = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.15437 6.88873L6.03332 7.494H11.6534L11.5323 6.88873C11.409 6.27225 10.961 5.83088 10.4752 5.55643C9.98526 5.27961 9.39287 5.13254 8.84335 5.13254C8.33348 5.13254 7.74389 5.28203 7.25008 5.55362C6.76502 5.8204 6.28028 6.2592 6.15437 6.88873ZM6.65057 6.98797C6.68769 6.80236 6.77384 6.63308 6.89462 6.48195C7.32263 5.94637 8.18559 5.63857 8.84335 5.63857C9.57088 5.63857 10.3948 5.94637 10.8022 6.48195C10.9172 6.63308 10.999 6.80236 11.0361 6.98797H6.65057Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.0496 1.45335C10.823 1.14718 11.7173 0.928051 12.5668 1.02196C12.829 1.05094 13.2283 1.12462 13.6254 1.29683C14.022 1.46883 14.4352 1.7476 14.6935 2.19723C15.0933 2.89309 15.0329 3.75906 14.8978 4.40897C14.8288 4.74047 14.7371 5.03092 14.6629 5.23838C14.6256 5.34233 14.5926 5.42603 14.5686 5.48429C14.5566 5.51343 14.5468 5.53625 14.5399 5.5521C14.5364 5.56002 14.5337 5.56621 14.5317 5.57058L14.5294 5.57575L14.5285 5.57781C14.5285 5.57781 14.5294 5.57575 14.5399 5.5521L14.5283 5.57814C14.4948 5.65155 14.4301 5.7018 14.3563 5.71925C14.8895 6.80518 15.0729 8.03156 14.9745 9.29702L14.9564 9.53041H6.29031L6.29246 9.53576C6.37171 9.73304 6.49924 9.995 6.69184 10.2556C7.0734 10.7719 7.70682 11.2816 8.75018 11.2816C9.38638 11.2816 9.86176 11.0466 10.1803 10.8104C10.34 10.6921 10.4594 10.5739 10.5381 10.4864C10.5774 10.4427 10.6062 10.407 10.6246 10.3831C10.6338 10.3712 10.6404 10.3622 10.6444 10.3567L10.6483 10.3512L10.6486 10.3507L10.7234 10.2398H14.8924L14.7878 10.5693L14.5466 10.4928C14.7878 10.5693 14.7878 10.5693 14.7878 10.5693L14.7876 10.5699L14.7873 10.5707L14.7865 10.5732L14.7837 10.5816L14.7792 10.5952L14.7736 10.6114C14.7647 10.6368 14.7516 10.6733 14.7339 10.7194C14.6986 10.8116 14.6449 10.9426 14.5704 11.1019C14.4216 11.4201 14.1889 11.8526 13.8519 12.3134C13.1779 13.2347 12.0798 14.2773 10.3968 14.7306C9.39679 14.9999 8.50021 15.0727 7.63322 14.9247C6.76623 14.7766 5.94589 14.4106 5.09414 13.8268C4.00084 13.0774 3.26303 12.0117 2.83061 10.9378L2.81898 10.9579C2.73787 11.099 2.65738 11.2587 2.57561 11.5028C2.46067 11.8457 2.40478 12.22 2.42474 12.5572C2.44488 12.8976 2.54027 13.1745 2.70028 13.3536C3.18497 13.8959 3.69918 14.0466 4.10546 14.0687C4.31193 14.0799 4.49429 14.0579 4.63559 14.0322C4.70421 14.0198 4.76232 14.0066 4.81145 13.9955L4.81627 13.9944C4.84023 13.989 4.86529 13.9833 4.88685 13.9791C4.90334 13.9759 4.93839 13.9691 4.97449 13.9691C4.99093 13.9691 5.03779 13.9698 5.08963 13.9935C5.1185 14.0068 5.15772 14.0312 5.19007 14.0748C5.22443 14.1212 5.24002 14.1746 5.24059 14.2252C5.24155 14.3115 5.19951 14.3698 5.18844 14.3849C5.17167 14.4077 5.15417 14.4242 5.14348 14.4338C5.1043 14.4686 5.05055 14.5006 5.00448 14.5259C4.90195 14.5822 4.74876 14.6526 4.56692 14.7213C4.20605 14.8576 3.69846 15 3.2153 15C2.20968 15 1.50193 14.3143 1.22135 13.6166C0.83659 12.6598 1.03413 11.7133 1.2107 11.0107C1.30218 10.6468 1.59224 9.88827 1.94876 9.17905L2.34959 8.54122C2.35814 7.46958 2.53907 6.53089 2.94949 5.69986C3.36578 4.85697 4.01013 4.14111 4.91757 3.51321C5.82614 2.88452 7.04244 2.45057 8.32423 2.36084C8.75022 2.07469 9.36098 1.72594 10.0496 1.45335ZM14.1014 5.12451C14.096 5.16241 14.0906 5.19738 14.0855 5.22897C13.6439 4.51353 13.0319 3.87187 12.2276 3.33696C11.8836 3.10819 11.4805 2.92492 11.0921 2.78168C11.5104 2.60901 12.0035 2.51068 12.5073 2.57433C13.0853 2.64735 13.404 2.70198 13.7775 3.03668C13.9189 3.16333 14.0192 3.35992 14.0817 3.61138C14.1437 3.86109 14.1631 4.14383 14.159 4.41636C14.1549 4.6875 14.1277 4.93959 14.1014 5.12451ZM10.2882 2.6374L9.68674 2.93977L10.4338 3.09551C10.9377 3.24687 11.508 3.4661 11.9474 3.75831C13.8494 5.02326 14.5869 6.93138 14.4848 9.02438H5.62102L5.69338 9.33483L5.93979 9.2774C5.69338 9.33483 5.69338 9.33483 5.69338 9.33483L5.69351 9.3354L5.6937 9.33617L5.69421 9.33834L5.69587 9.3451C5.69726 9.35067 5.69922 9.35834 5.70179 9.36797C5.70693 9.38723 5.71452 9.41438 5.72487 9.44828C5.74556 9.51602 5.77738 9.61109 5.82291 9.7244C5.91368 9.95034 6.06044 10.2527 6.2849 10.5564C6.73746 11.1687 7.50923 11.7876 8.75018 11.7876C9.5191 11.7876 10.0976 11.5017 10.4817 11.2169C10.6733 11.0749 10.8174 10.9326 10.9144 10.8248C10.9404 10.7958 10.9631 10.7693 10.9825 10.7458H14.1761C14.157 10.7895 14.1357 10.8369 14.112 10.8875C13.9741 11.1825 13.7574 11.5855 13.4434 12.0146C12.8155 12.873 11.8058 13.8271 10.2652 14.242C9.31763 14.4972 8.4967 14.5588 7.71839 14.4259C6.94008 14.293 6.18732 13.9626 5.38024 13.4094C4.24547 12.6316 3.51915 11.4702 3.14908 10.3338L2.93972 9.44828L2.6374 10.2589C2.58283 10.3674 2.53259 10.4506 2.47721 10.5423C2.44693 10.5924 2.4151 10.645 2.38021 10.7058C2.2854 10.8708 2.18995 11.0611 2.09581 11.342C1.96293 11.7385 1.89535 12.1776 1.91959 12.5871C1.94365 12.9934 2.06013 13.3966 2.32297 13.6908C2.70959 14.1234 3.12281 14.3573 3.50926 14.4745C3.41004 14.487 3.31132 14.494 3.2153 14.494C2.46172 14.494 1.91284 13.9798 1.69084 13.4278C1.37194 12.6348 1.52621 11.8314 1.70146 11.1341C1.78065 10.819 2.05368 10.097 2.40087 9.40633L2.73769 8.73631L2.85542 8.57369L2.85537 8.58392C2.85941 7.54986 3.03044 6.6787 3.4032 5.92394C3.77529 5.17052 4.35639 4.51688 5.20551 3.92932C6.05684 3.34024 7.22112 2.92906 8.44958 2.85995L8.47306 2.85521C8.48328 2.84795 8.48409 2.86495 8.49463 2.85757C8.51191 2.85671 8.46496 2.85593 8.48226 2.85521L8.54515 2.8225C8.94573 2.54721 9.55097 2.19495 10.2358 1.92385C10.972 1.63244 11.7775 1.44382 12.5112 1.52492C12.7415 1.55038 13.0877 1.6152 13.4241 1.76108C13.7609 1.90718 14.0691 2.12611 14.2547 2.4493C14.3839 2.67418 14.4532 2.93156 14.4803 3.2007C14.3989 2.99861 14.2822 2.80944 14.1152 2.65983C13.6165 2.21294 13.1573 2.1464 12.5707 2.07229C11.6866 1.9606 10.8533 2.26267 10.2882 2.6374Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Export = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M6.09091 1C4.43724 1 3.11412 1.32684 2.22048 2.22048C1.32684 3.11412 1 4.43724 1 6.09091V9.90909C1 11.5628 1.32684 12.8859 2.22048 13.7795C3.11412 14.6732 4.43724 15 6.09091 15H9.90909C11.5628 15 12.8859 14.6732 13.7795 13.7795C14.6732 12.8859 15 11.5628 15 9.90909V8.63636C15 8.28491 14.7151 8 14.3636 8C14.0122 8 13.7273 8.28491 13.7273 8.63636V9.90909C13.7273 11.4372 13.4177 12.3414 12.8796 12.8796C12.3414 13.4177 11.4372 13.7273 9.90909 13.7273H6.09091C4.56276 13.7273 3.65861 13.4177 3.12043 12.8796C2.58225 12.3414 2.27273 11.4372 2.27273 9.90909V6.09091C2.27273 4.56276 2.58225 3.65861 3.12043 3.12043C3.65861 2.58225 4.56276 2.27273 6.09091 2.27273H7.36364C7.71509 2.27273 8 1.98782 8 1.63636C8 1.28491 7.71509 1 7.36364 1H6.09091Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M10.6727 1.63636C10.6727 1.28491 10.9576 1 11.3091 1H14.3636C14.7151 1 15 1.28491 15 1.63636V4.69091C15 5.04236 14.7151 5.32727 14.3636 5.32727C14.0122 5.32727 13.7272 5.04236 13.7272 4.69091V3.17274L9.08634 7.81364C8.83783 8.06216 8.4349 8.06216 8.18639 7.81364C7.93787 7.56513 7.93787 7.16221 8.18639 6.91369L12.8273 2.27273H11.3091C10.9576 2.27273 10.6727 1.98782 10.6727 1.63636Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Extract_cpt = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.28571 0C5.97012 0 5.71429 0.268629 5.71429 0.6V3.32308H3.42857C3.18638 3.32308 2.9705 3.48338 2.8898 3.72315C2.8091 3.96292 2.88111 4.23006 3.06952 4.38984L7.64095 8.26677C7.85042 8.44441 8.14958 8.44441 8.35905 8.26677L12.9305 4.38984C13.1189 4.23006 13.1909 3.96292 13.1102 3.72315C13.0295 3.48338 12.8136 3.32308 12.5714 3.32308H10.2857V0.6C10.2857 0.268629 10.0299 0 9.71428 0H6.28571ZM6.85714 3.92308V1.2H9.14286V3.92308C9.14286 4.25445 9.39869 4.52308 9.71428 4.52308H10.9545L8 7.02873L5.04548 4.52308H6.28571C6.60131 4.52308 6.85714 4.25445 6.85714 3.92308Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M11.4286 12C11.4286 12.3314 11.1727 12.6 10.8571 12.6C10.5416 12.6 10.2857 12.3314 10.2857 12C10.2857 11.6686 10.5416 11.4 10.8571 11.4C11.1727 11.4 11.4286 11.6686 11.4286 12Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M13.1429 12.6C13.4584 12.6 13.7143 12.3314 13.7143 12C13.7143 11.6686 13.4584 11.4 13.1429 11.4C12.8273 11.4 12.5714 11.6686 12.5714 12C12.5714 12.3314 12.8273 12.6 13.1429 12.6Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 10.2C0 9.53726 0.511675 9 1.14286 9H6.15231C6.53733 9 6.89223 9.20755 7.13841 9.51838C7.39547 9.84296 7.73782 10.2 8 10.2C8.26218 10.2 8.60453 9.84296 8.86159 9.51838C9.10777 9.20755 9.46267 9 9.84769 9H14.8571C15.4883 9 16 9.53726 16 10.2V13.8C16 14.4627 15.4883 15 14.8571 15H1.14286C0.511675 15 0 14.4627 0 13.8V10.2ZM9.84875 10.2H14.8571V13.8H1.14286V10.2H6.15125C6.15371 10.2005 6.16107 10.2024 6.17372 10.2092C6.19601 10.2213 6.22787 10.2455 6.25969 10.2857C6.40874 10.4739 6.61132 10.7093 6.84176 10.9081C7.01834 11.0604 7.44075 11.4 8 11.4C8.55925 11.4 8.98166 11.0604 9.15824 10.9081C9.38868 10.7093 9.59126 10.4739 9.74031 10.2857C9.77213 10.2455 9.80399 10.2213 9.82628 10.2092C9.83893 10.2024 9.84629 10.2005 9.84875 10.2Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Face_ID = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M1 3.50584C1 2.1219 2.1307 1 3.52549 1H4.89804C5.14061 1 5.33726 1.19511 5.33726 1.4358C5.33726 1.67648 5.14061 1.8716 4.89804 1.8716H3.52549C2.61584 1.8716 1.87843 2.60327 1.87843 3.50584V4.8677C1.87843 5.10839 1.68179 5.3035 1.43922 5.3035C1.19664 5.3035 1 5.10839 1 4.8677V3.50584Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M10.6627 1.4358C10.6627 1.19511 10.8594 1 11.102 1H12.4745C13.8693 1 15 2.1219 15 3.50584V4.8677C15 5.10839 14.8034 5.3035 14.5608 5.3035C14.3182 5.3035 14.1216 5.10839 14.1216 4.8677V3.50584C14.1216 2.60327 13.3842 1.8716 12.4745 1.8716H11.102C10.8594 1.8716 10.6627 1.67648 10.6627 1.4358Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M1.43922 10.6965C1.68179 10.6965 1.87843 10.8916 1.87843 11.1323V12.4942C1.87843 13.3967 2.61584 14.1284 3.52549 14.1284H4.89804C5.14061 14.1284 5.33726 14.3235 5.33726 14.5642C5.33726 14.8049 5.14061 15 4.89804 15H3.52549C2.1307 15 1 13.8781 1 12.4942V11.1323C1 10.8916 1.19664 10.6965 1.43922 10.6965Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M14.5608 10.6965C14.8034 10.6965 15 10.8916 15 11.1323V12.4942C15 13.8781 13.8693 15 12.4745 15H11.102C10.8594 15 10.6627 14.8049 10.6627 14.5642C10.6627 14.3235 10.8594 14.1284 11.102 14.1284H12.4745C13.3842 14.1284 14.1216 13.3967 14.1216 12.4942V11.1323C14.1216 10.8916 14.3182 10.6965 14.5608 10.6965Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M7.97255 5.90272C8.21512 5.90272 8.41176 6.09784 8.41176 6.33852V8.68112L8.41176 8.68338L8.41172 8.6899C8.41168 8.6951 8.41158 8.702 8.4114 8.71043C8.41102 8.72726 8.41027 8.75036 8.40877 8.77825C8.4058 8.83347 8.39974 8.91027 8.38711 8.99601C8.36573 9.14111 8.31305 9.4122 8.14638 9.61228C7.91453 9.89059 7.54922 9.93525 7.37046 9.94548C7.26235 9.95166 7.16526 9.9476 7.09608 9.94229C7.06099 9.9396 7.03184 9.93649 7.01053 9.93392C6.99985 9.93262 6.99106 9.93146 6.9844 9.93053L6.98206 9.9302L6.97601 9.92932L6.97304 9.92888L6.97188 9.9287L6.97137 9.92862L6.97114 9.92859C6.97114 9.92859 6.97092 9.92855 7.03922 9.49805L6.97092 9.92855C6.7313 9.89113 6.56763 9.66805 6.60534 9.43029C6.64297 9.19307 6.86688 9.03086 7.1059 9.06731L7.1062 9.06736L7.1067 9.06742C7.10834 9.06765 7.11178 9.06812 7.11681 9.06872C7.12693 9.06995 7.14314 9.07171 7.16378 9.07329C7.20607 9.07653 7.26195 9.07864 7.31988 9.07533C7.3798 9.0719 7.4279 9.0634 7.46067 9.05256C7.46272 9.05188 7.46462 9.05122 7.46637 9.0506C7.46876 9.04974 7.47087 9.04893 7.47273 9.04819C7.47614 9.0407 7.48082 9.02931 7.48614 9.01314C7.4992 8.97343 7.50998 8.92384 7.51792 8.86994C7.52569 8.81719 7.52965 8.76797 7.53159 8.73179C7.53255 8.71398 7.53298 8.70004 7.53318 8.69125C7.53328 8.68687 7.53331 8.68382 7.53333 8.68227L7.53333 8.6814L7.53333 8.6811L7.53333 8.68093V6.33852C7.53333 6.09784 7.72998 5.90272 7.97255 5.90272Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M5.72157 6.44747C5.72157 6.20679 5.52492 6.01167 5.28235 6.01167C5.03978 6.01167 4.84314 6.20679 4.84314 6.44747V7.53696C4.84314 7.77765 5.03978 7.97276 5.28235 7.97276C5.52492 7.97276 5.72157 7.77765 5.72157 7.53696V6.44747Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M10.8824 6.01167C11.1249 6.01167 11.3216 6.20679 11.3216 6.44747V7.53696C11.3216 7.77765 11.1249 7.97276 10.8824 7.97276C10.6398 7.97276 10.4431 7.77765 10.4431 7.53696V6.44747C10.4431 6.20679 10.6398 6.01167 10.8824 6.01167Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M10.1599 11.685C10.2857 11.4792 10.2194 11.2112 10.012 11.0864C9.8045 10.9617 9.53441 11.0274 9.40869 11.2333C9.33661 11.3513 8.83802 11.8296 7.78841 11.7828C6.70403 11.7345 6.15772 11.3008 6.06259 11.1845C5.90973 10.9976 5.63312 10.9691 5.44478 11.1208C5.25644 11.2725 5.22768 11.5469 5.38054 11.7338C5.66335 12.0795 6.46499 12.5963 7.74897 12.6535C9.06772 12.7123 9.89608 12.117 10.1599 11.685Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const FAQ = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M6.45844 5.96808C6.45844 5.20547 7.14651 4.5906 8.00005 4.5906C8.85359 4.5906 9.54166 5.20547 9.54166 5.96808C9.54166 6.56711 9.10202 6.88374 8.80757 7.06352C8.67956 7.14255 8.59353 7.20675 8.53678 7.27476C8.48836 7.33278 8.45524 7.40056 8.45524 7.50606V7.62884C8.45524 7.85346 8.25144 8.03556 8.00005 8.03556C7.74865 8.03556 7.54486 7.85346 7.54486 7.62884V7.50606C7.54486 6.89319 7.99495 6.57637 8.29119 6.3936L8.29312 6.39242C8.41525 6.31789 8.49854 6.25512 8.55303 6.18939C8.59986 6.13293 8.63128 6.06764 8.63128 5.96808C8.63128 5.65468 8.35075 5.40403 8.00005 5.40403C7.64934 5.40403 7.36882 5.65468 7.36882 5.96808C7.36882 6.1927 7.16502 6.37479 6.91363 6.37479C6.66223 6.37479 6.45844 6.1927 6.45844 5.96808Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M7.99708 8.61978C7.74568 8.61978 7.54189 8.80187 7.54189 9.0265C7.54189 9.25112 7.74568 9.43321 7.99708 9.43321H8.00297C8.25436 9.43321 8.45816 9.25112 8.45816 9.0265C8.45816 8.80187 8.25436 8.61978 8.00297 8.61978H7.99708Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2.03323 2.9232C2.70276 2.32498 3.64243 2 4.72759 2H11.2724C12.3576 2 13.2972 2.32498 13.9668 2.9232C14.6363 3.52143 15 4.36103 15 5.33063V8.83936C15 9.80896 14.6363 10.6486 13.9668 11.2468C13.2972 11.845 12.3576 12.17 11.2724 12.17H8.79204L5.99453 13.8326C5.26213 14.2685 4.27241 13.8036 4.27241 13.0089V12.1503C3.37982 12.0717 2.60724 11.7597 2.03323 11.2468C1.36371 10.6486 1 9.80896 1 8.83936V5.33063C1 4.36103 1.36371 3.52143 2.03323 2.9232ZM2.67697 3.49838C2.20115 3.92353 1.91038 4.54588 1.91038 5.33063V8.83936C1.91038 9.62411 2.20115 10.2465 2.67697 10.6716C3.15278 11.0968 3.84931 11.3566 4.72759 11.3566C4.97899 11.3566 5.18278 11.5387 5.18278 11.7633V13.0089C5.18278 13.1497 5.35806 13.2341 5.48954 13.1558L8.40238 11.4246C8.47707 11.3802 8.56478 11.3566 8.65448 11.3566H11.2724C12.1507 11.3566 12.8472 11.0968 13.323 10.6716C13.7988 10.2465 14.0896 9.62411 14.0896 8.83936V5.33063C14.0896 4.54588 13.7988 3.92353 13.323 3.49838C12.8472 3.07324 12.1507 2.81343 11.2724 2.81343H4.72759C3.84931 2.81343 3.15278 3.07324 2.67697 3.49838Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Favoris = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.99979 12.0796C8.00291 12.0796 8.00554 12.0814 8.00554 12.0814L10.7081 13.8595C10.9524 14.0192 11.2331 13.9992 11.2331 13.9992C11.4919 13.9807 11.7022 13.8157 11.7022 13.8157C11.9096 13.6529 12.0002 13.4019 12.0002 13.4019C12.0975 13.1322 12.0277 12.8466 12.0277 12.8466L11.2458 9.66105C11.2432 9.65017 11.2466 9.63952 11.2466 9.63952C11.25 9.62887 11.2597 9.62051 11.2597 9.62051L13.6816 7.52723C13.9016 7.33791 13.9735 7.05493 13.9735 7.05493C14.0392 6.79633 13.9619 6.53751 13.9619 6.53751C13.8838 6.27581 13.6859 6.10252 13.6859 6.10252C13.4681 5.91177 13.1779 5.89224 13.1779 5.89224L10.0131 5.68102C10.0083 5.68073 10.0045 5.67778 10.0045 5.67778C10.0006 5.67483 9.99897 5.67018 9.99897 5.67018L9.99545 5.66069L8.8183 2.58887C8.72366 2.32541 8.50094 2.16377 8.50094 2.16377C8.27529 2 7.99979 2 7.99979 2C7.72429 2 7.49863 2.16377 7.49863 2.16377C7.27592 2.32541 7.18128 2.58887 7.18128 2.58887L6.00413 5.66069L6.00061 5.67018C5.99894 5.67483 5.99509 5.67778 5.99509 5.67778C5.99125 5.68073 5.98381 5.68119 5.98381 5.68119L2.82142 5.89226C2.53143 5.91177 2.31365 6.10252 2.31365 6.10252C2.1158 6.27581 2.03763 6.53751 2.03763 6.53751C1.96033 6.79632 2.02608 7.05493 2.02608 7.05493C2.09802 7.33791 2.3173 7.52663 2.3173 7.52663L4.74126 9.62172C4.7496 9.62887 4.75298 9.63952 4.75298 9.63952C4.75637 9.65017 4.75432 9.65877 4.75432 9.65877L4.03095 12.6128C3.9532 12.9281 4.06007 13.2258 4.06007 13.2258C4.15947 13.5027 4.38787 13.6826 4.38787 13.6826C4.61917 13.8648 4.90339 13.8854 4.90339 13.8854C5.21224 13.9077 5.4797 13.7314 5.4797 13.7314L7.99404 12.0814C7.99667 12.0796 7.99979 12.0796 7.99979 12.0796ZM8.46576 11.3315L11.1656 13.1079C11.1755 13.1144 11.1845 13.1073 11.1845 13.1073C11.2032 13.0926 11.1966 13.0656 11.1966 13.0656L10.4135 9.87506C10.3514 9.61544 10.4321 9.36138 10.4321 9.36138C10.5129 9.10733 10.7105 8.93808 10.7105 8.93808L13.1337 6.8436C13.1512 6.82854 13.1428 6.80027 13.1428 6.80027C13.1367 6.77999 13.1228 6.77905 13.1228 6.77905L9.9633 6.56817C9.70362 6.55251 9.4945 6.39221 9.4945 6.39221C9.28766 6.23365 9.19692 5.98466 9.19692 5.98466L8.01934 2.91172L8.0149 2.89961C8.01317 2.89468 8.00901 2.89166 8.00901 2.89166C8.00486 2.88865 7.99979 2.88865 7.99979 2.88865C7.99472 2.88865 7.99057 2.89166 7.99057 2.89166C7.98641 2.89468 7.98468 2.89961 7.98468 2.89961L7.98024 2.91172L6.80266 5.98466C6.71192 6.23365 6.50507 6.39221 6.50507 6.39221C6.29596 6.55251 6.03893 6.568 6.03893 6.568L2.87698 6.77904C2.86288 6.77999 2.85683 6.80027 2.85683 6.80027C2.84838 6.82854 2.86657 6.8442 2.86657 6.8442L5.28771 8.93687C5.48664 9.10733 5.56744 9.36138 5.56744 9.36138C5.64823 9.61544 5.58551 9.87734 5.58551 9.87734L4.86178 12.8328C4.83972 12.9223 4.90683 12.9752 4.90683 12.9752C4.96255 13.0191 5.02091 12.9806 5.02091 12.9806L7.5339 11.3315C7.74711 11.191 7.99979 11.191 7.99979 11.191C8.25232 11.191 8.46576 11.3315 8.46576 11.3315Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Filtre = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.20003 0C5.62345 0 5.96669 0.341116 5.96669 0.761905V1.77778C5.96669 1.80979 5.96471 1.84133 5.96085 1.8723C7.28649 2.2086 8.2667 3.40324 8.2667 4.8254C8.2667 6.24547 7.28937 7.43868 5.96669 7.777V15.2381C5.96669 15.6589 5.62345 16 5.20003 16C4.77661 16 4.43336 15.6589 4.43336 15.2381V7.777C3.11069 7.43868 2.13336 6.24547 2.13336 4.8254C2.13336 3.40324 3.11357 2.2086 4.4392 1.8723C4.43535 1.84133 4.43336 1.80979 4.43336 1.77778V0.761905C4.43336 0.341116 4.77661 0 5.20003 0ZM5.20003 6.34921C6.04686 6.34921 6.73336 5.66697 6.73336 4.8254C6.73336 3.98382 6.04686 3.30159 5.20003 3.30159C4.35319 3.30159 3.6667 3.98382 3.6667 4.8254C3.6667 5.66697 4.35319 6.34921 5.20003 6.34921Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.5725 6.95167C10.5687 6.9207 10.5667 6.88915 10.5667 6.85714V0.761905C10.5667 0.341116 10.9099 0 11.3334 0C11.7568 0 12.1 0.341116 12.1 0.761905V6.85714C12.1 6.88915 12.098 6.9207 12.0942 6.95167C13.4198 7.28796 14.4 8.4826 14.4 9.90476C14.4 11.3269 13.4198 12.5216 12.0942 12.8579C12.098 12.8888 12.1 12.9204 12.1 12.9524V14.9841C12.1 15.4049 11.7568 15.746 11.3334 15.746C10.9099 15.746 10.5667 15.4049 10.5667 14.9841V12.9524C10.5667 12.9204 10.5687 12.8888 10.5725 12.8579C9.2469 12.5216 8.2667 11.3269 8.2667 9.90476C8.2667 8.4826 9.2469 7.28796 10.5725 6.95167ZM11.3334 8.38095C10.4865 8.38095 9.80003 9.06319 9.80003 9.90476C9.80003 10.7463 10.4865 11.4286 11.3334 11.4286C12.1802 11.4286 12.8667 10.7463 12.8667 9.90476C12.8667 9.06319 12.1802 8.38095 11.3334 8.38095Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Filtres = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M1.5 5.14286H14.5C14.7761 5.14286 15 4.88702 15 4.57143C15 4.25584 14.7761 4 14.5 4H1.5C1.22386 4 1 4.25584 1 4.57143C1 4.88702 1.22386 5.14286 1.5 5.14286Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M4 8.57143H12C12.2761 8.57143 12.5 8.31559 12.5 8C12.5 7.68441 12.2761 7.42857 12 7.42857H4C3.72386 7.42857 3.5 7.68441 3.5 8C3.5 8.31559 3.72386 8.57143 4 8.57143Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M6.5 12C6.22386 12 6 11.7442 6 11.4286C6 11.113 6.22386 10.8571 6.5 10.8571H9.5C9.77614 10.8571 10 11.113 10 11.4286C10 11.7442 9.77614 12 9.5 12H6.5Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Filtres2 = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.99425 1C2.78326 1 2 2.00186 2 3.0552V4.50628C2 4.8174 2.09235 5.15048 2.21224 5.43266C2.3307 5.71146 2.50639 6.01209 2.73621 6.24832L5.01586 8.75878C5.18132 8.97769 5.34247 9.38389 5.34247 9.64506V13.0055C5.34247 13.7625 5.75388 14.3977 6.36276 14.7381C6.97384 15.0797 7.77992 15.1143 8.45321 14.6793L8.45862 14.6758L9.3029 14.1206C9.60912 13.9211 9.81857 13.6215 9.94793 13.3603C10.0817 13.0901 10.177 12.766 10.177 12.449V9.72143C10.177 9.56155 10.2163 9.36094 10.2933 9.17029C10.3727 8.9737 10.4685 8.84578 10.5349 8.7883C10.541 8.78297 10.5471 8.77754 10.5531 8.77202L13.1644 6.36083C13.1757 6.35035 13.1867 6.33954 13.1974 6.32842C13.423 6.09281 13.6167 5.77808 13.7544 5.46065C13.8922 5.1428 14 4.76249 14 4.38627V2.98974C14 1.97655 13.1929 1 12.0057 1H3.99425ZM3.56522 3.0552C3.56522 2.5811 3.86826 2.44828 3.99425 2.44828H12.0057C12.1555 2.44828 12.4348 2.60641 12.4348 2.98974V4.38627C12.4348 4.52283 12.3911 4.71531 12.3018 4.92116C12.2171 5.11638 12.1147 5.27005 12.0384 5.35444L9.45524 7.73968C9.16166 7.99759 8.95774 8.34001 8.82717 8.6633C8.69265 8.99635 8.61183 9.36853 8.61183 9.72143V12.449C8.61183 12.5139 8.58704 12.6317 8.52497 12.757C8.49599 12.8155 8.46484 12.8633 8.43703 12.8978C8.41626 12.9235 8.40287 12.935 8.40006 12.9374C8.39968 12.9377 8.40005 12.9374 8.40006 12.9374L8.39789 12.9389L7.55523 13.4931C7.4352 13.5697 7.30197 13.5711 7.17217 13.4985C7.03943 13.4243 6.90769 13.263 6.90769 13.0055V9.64506C6.90769 9.01836 6.59683 8.30426 6.26532 7.88585C6.25511 7.87297 6.24445 7.8604 6.23334 7.84817L3.92494 5.30605C3.91763 5.29799 3.91012 5.29008 3.90243 5.28233C3.83566 5.21499 3.74413 5.07976 3.66894 4.90278C3.59298 4.724 3.56522 4.57702 3.56522 4.50628V3.0552Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Firefox = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M3.51683 3.45702C3.57748 3.52678 3.62749 3.57005 3.66727 3.60562C4.09734 3.51274 4.60558 3.52615 5.18311 3.73333L5.18686 3.73028C5.2474 3.65946 5.31581 3.59566 5.3908 3.54013C5.39111 3.56496 5.38974 3.58979 5.38668 3.61444C5.45786 3.48569 5.70243 3.33349 5.80199 3.29588C5.79312 3.31458 5.78871 3.33506 5.78911 3.35574C6.00281 3.23783 6.25285 3.13372 6.45398 3.10626C6.48479 3.10591 6.35339 3.15395 6.31207 3.19058C6.41163 3.15297 6.45126 3.13316 6.63784 3.11443C6.82102 3.09536 7.02857 3.17384 6.98925 3.19031C6.95709 3.20408 6.78675 3.26518 6.76066 3.28635C6.7383 3.30449 6.85003 3.28168 6.82769 3.29984C6.43763 3.55344 6.13808 3.92293 5.97174 4.35565C5.98165 4.39535 5.99488 4.43416 6.01129 4.47169C6.02852 4.50393 6.04576 4.53629 6.06269 4.57194C6.15535 4.73744 6.31848 4.91679 6.59644 4.94118C6.97774 4.97672 7.22491 5.01035 7.3847 5.0449C7.65091 5.10249 7.67448 5.16268 7.67104 5.23877C7.66079 5.40756 7.6187 5.51885 7.56283 5.59819C7.48578 5.7134 7.38495 5.811 7.26704 5.88456C7.19387 5.93157 6.18865 6.33387 6.1388 6.48856L6.13845 6.49192C6.1542 6.52427 6.16569 6.55853 6.17259 6.59384C6.13267 6.54908 6.09676 6.5659 6.11975 6.60892C6.14547 6.65906 6.14206 6.6927 6.14942 6.82251C6.1615 7.00713 6.10658 7.11037 6.07606 7.20919C6.01824 7.16628 5.95688 7.12832 5.8926 7.09577L5.88581 7.09509C5.99411 7.17382 6.02724 7.25188 6.03502 7.27643C6.05633 7.3363 6.02755 7.35042 6.02755 7.35042C6.02755 7.35042 5.9927 7.28918 5.88335 7.22052C5.79942 7.17137 5.63998 7.0909 5.56788 7.05991C5.5608 7.06262 5.55402 7.06194 5.54692 7.06461C5.56722 7.10061 5.60476 7.1689 5.60476 7.1689C5.60476 7.1689 5.54992 7.13626 5.46193 7.09349C5.2797 7.17038 5.17157 7.36001 5.1566 7.50797C5.13787 7.69294 5.06353 7.98782 5.65888 8.42435C5.66841 8.43212 5.56278 8.39442 5.57229 8.40213C5.62913 8.44857 5.84847 8.57921 5.97237 8.63914C6.01401 8.66708 5.83558 8.60508 5.87756 8.62966C5.91616 8.65493 5.95605 8.67818 5.99706 8.69935C6.63375 9.03131 7.07891 8.68856 7.56484 8.61822C8.20007 8.52543 8.6279 8.86032 8.79232 9.09414C8.9601 9.3283 8.77305 9.55418 8.53811 9.47635C8.29978 9.39819 8.0061 9.59644 7.52071 9.86383C7.03905 10.1282 6.24701 10.1815 5.53068 9.92655C5.53068 9.92655 5.5868 10.0402 5.71875 10.1962C5.94901 10.4682 6.41068 10.869 7.21017 11.0204C7.43532 11.0715 7.66555 11.0971 7.89649 11.097C9.59098 11.097 10.9646 9.73274 10.9646 8.04977C10.9646 7.37768 10.7694 6.75288 10.4145 6.24654V6.24691C10.1113 6.00905 9.83495 5.7391 9.59043 5.44182C9.12085 4.86822 8.79656 3.97076 8.90598 3.10987C8.95549 2.72035 9.05985 2.37686 9.18233 2.08618M3.51683 3.45702C3.43403 3.36179 3.33139 3.21719 3.20782 2.97543C3.19328 2.95021 3.18548 3.02756 3.1743 3.00265C3.09112 2.81092 3.04086 2.49679 3.04912 2.28022C3.04912 2.28022 2.87706 2.35814 2.73465 2.68359C2.70821 2.7421 2.69125 2.77437 2.67431 2.80664C2.66652 2.81606 2.69198 2.69976 2.68791 2.70609C2.66316 2.74773 2.59913 2.80592 2.57099 2.88124C2.55166 2.93705 2.52454 2.96831 2.50724 3.03792L2.50317 3.04431C2.50177 3.02379 2.5083 2.9599 2.50355 2.973C2.4368 3.10702 2.37936 3.24541 2.33163 3.38722C2.25496 3.63771 2.1657 3.97867 2.15155 4.42224C2.14814 4.45587 2.15117 4.49352 2.1481 4.52379C1.96652 4.72984 1.84278 4.9043 1.796 4.99473C1.56124 5.35523 1.30255 5.91706 1.05178 6.80572C1.16335 6.56297 1.29677 6.33074 1.45041 6.11184C1.24187 6.58357 1.0403 7.32429 1 8.46505C1.05062 8.22898 1.11532 7.9961 1.19377 7.76769C1.15776 8.52833 1.24691 9.4714 1.73083 10.5354C2.01816 11.1612 2.67956 12.4322 4.29566 13.424C4.29566 13.424 4.84531 13.8308 5.79037 14.1356C5.86021 14.1607 5.93094 14.1856 6.00315 14.2096C5.9805 14.2005 5.95857 14.1909 5.93729 14.1811C6.56631 14.3684 7.21942 14.4638 7.87607 14.4643C10.323 14.4664 11.0447 13.4899 11.0447 13.4899C11.0447 13.4899 11.0422 13.4918 11.0375 13.4951C11.0721 13.4628 11.1053 13.4292 11.1373 13.3944C10.7512 13.7567 9.8702 13.7807 9.54075 13.7545C10.1026 13.5906 10.4723 13.4519 11.1914 13.1782C11.2756 13.1472 11.3616 13.1119 11.4496 13.0722C11.4591 13.068 11.4687 13.0635 11.4783 13.0592C11.4957 13.0511 11.513 13.0435 11.5306 13.035C11.881 12.8709 12.2104 12.666 12.512 12.4244C13.2342 11.8512 13.3913 11.2924 13.4735 10.9239C13.462 10.9592 13.4263 11.0415 13.4012 11.0949C13.2153 11.4902 12.8028 11.7328 12.3549 11.9409C12.568 11.663 12.7657 11.3736 12.947 11.0742C13.0932 10.9301 13.1388 10.7047 13.248 10.5532C13.3011 10.4787 13.3729 10.2404 13.4363 10.1338C13.8215 9.51582 13.8243 9.02306 13.8243 9.01176C14.057 7.85664 14.0359 7.38493 13.8927 6.51263C13.7775 5.81026 13.2736 4.80402 12.8371 4.31948C12.3874 3.82026 12.7042 3.98291 12.2688 3.61826C11.887 3.19777 11.5169 2.78138 11.3154 2.61393C9.85883 1.40385 9.89173 1.14682 9.91979 1.10299C9.91504 1.10814 9.90811 1.11579 9.89923 1.1258C9.88196 1.05747 9.86979 1 9.86979 1C9.86979 1 9.4745 1.39282 9.18233 2.08618M3.51683 3.45702C3.51683 3.45702 4.43617 2.56505 6.31207 2.08618C8.06255 1.69792 9.18233 2.08618 9.18233 2.08618",
          stroke: "black",
          strokeWidth: "0.5"
        }
      )
    );
  }
);
const Flux = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.13645 2.71393C4.42675 2 3.42308 2 3.42308 2C2.41941 2 1.7097 2.71393 1.7097 2.71393C1 3.42785 1 4.4375 1 4.4375C1 5.44715 1.7097 6.16107 1.7097 6.16107C2.08295 6.53654 2.53751 6.71455 2.88462 6.79893L2.88462 9.04917C2.88673 10.6212 3.99137 11.7335 3.99137 11.7335L5.62312 13.375H4.23077C3.93339 13.375 3.69231 13.6175 3.69231 13.9167C3.69231 14.2158 3.93339 14.4583 4.23077 14.4583H6.92308C7.06882 14.4583 7.20105 14.4001 7.29799 14.3055C7.29995 14.3036 7.3019 14.3016 7.30383 14.2997C7.30576 14.2977 7.30767 14.2958 7.30957 14.2938C7.40363 14.1963 7.46154 14.0633 7.46154 13.9167V11.2083C7.46154 10.9092 7.22046 10.6667 6.92308 10.6667C6.62569 10.6667 6.38462 10.9092 6.38462 11.2083V12.609L4.75287 10.9675C3.96305 10.1722 3.96154 9.04771 3.96154 9.04771L3.96154 6.80721C4.67128 6.62902 5.13645 6.16107 5.13645 6.16107C5.84615 5.44715 5.84615 4.4375 5.84615 4.4375C5.84615 3.42785 5.13645 2.71393 5.13645 2.71393ZM2.4712 3.47996C2.86548 3.08333 3.42308 3.08333 3.42308 3.08333C3.98067 3.08333 4.37495 3.47996 4.37495 3.47996C4.76923 3.87659 4.76923 4.4375 4.76923 4.4375C4.76923 4.99841 4.37495 5.39504 4.37495 5.39504C3.98067 5.79167 3.42308 5.79167 3.42308 5.79167C2.86548 5.79167 2.4712 5.39504 2.4712 5.39504C2.07692 4.99841 2.07692 4.4375 2.07692 4.4375C2.07692 3.87659 2.4712 3.47996 2.4712 3.47996Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.7692 2.54167H9.07692C8.77954 2.54167 8.53846 2.78418 8.53846 3.08333V5.79167C8.53846 6.09082 8.77954 6.33333 9.07692 6.33333C9.37431 6.33333 9.61539 6.09082 9.61539 5.79167V4.39103L11.2471 6.0325C12.037 6.82783 12.0385 7.95229 12.0385 7.95229V10.1928C11.3287 10.371 10.8635 10.8389 10.8635 10.8389C10.1538 11.5529 10.1538 12.5625 10.1538 12.5625C10.1538 13.5721 10.8635 14.2861 10.8635 14.2861C11.5733 15 12.5769 15 12.5769 15C13.5806 15 14.2903 14.2861 14.2903 14.2861C15 13.5721 15 12.5625 15 12.5625C15 11.5529 14.2903 10.8389 14.2903 10.8389C13.917 10.4635 13.4625 10.2855 13.1154 10.2011V7.95083C13.1133 6.37881 12.0086 5.26646 12.0086 5.26646L10.3769 3.625H11.7692C12.0666 3.625 12.3077 3.38249 12.3077 3.08333C12.3077 2.78418 12.0666 2.54167 11.7692 2.54167ZM12.5769 11.2083C12.5769 11.2083 12.0193 11.2083 11.625 11.605C11.625 11.605 11.2308 12.0016 11.2308 12.5625C11.2308 12.5625 11.2308 13.1234 11.625 13.52C11.625 13.52 12.0193 13.9167 12.5769 13.9167C12.5769 13.9167 13.1345 13.9167 13.5288 13.52C13.5288 13.52 13.9231 13.1234 13.9231 12.5625C13.9231 12.5625 13.9231 12.0016 13.5288 11.605C13.5288 11.605 13.1345 11.2083 12.5769 11.2083Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Fraude = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M8 12.8156C8.22724 12.8156 8.57398 12.773 8.9135 12.6454C9.2514 12.5185 9.62792 12.2891 9.83541 11.8863L9.16459 11.5607C9.07208 11.7403 8.8861 11.875 8.64275 11.9664C8.40102 12.0573 8.14776 12.0875 8 12.0875V12.8156Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.14017 1.63676C7.00774 1.50821 6.86778 1.37264 6.72823 1.26503C6.59005 1.15848 6.41778 1.05138 6.21284 1.01424C5.7372 0.92805 5.3715 1.24298 5.06298 1.69225C4.95293 1.85251 4.85185 2.08546 4.76122 2.32647C4.71148 2.45872 4.66175 2.60215 4.61267 2.75111C3.87522 2.99005 3.24132 3.31149 2.78229 3.70276C2.31459 4.10142 2 4.59969 2 5.17061C2 5.66907 2.24071 6.11387 2.61299 6.48305C2.92873 6.79616 3.3504 7.06751 3.84275 7.2928C3.83868 7.35783 3.83731 7.42556 3.83918 7.49526C3.65493 7.59709 3.46075 7.74787 3.31 7.95448C3.0665 8.28821 2.95625 8.74274 3.14424 9.29026C3.41612 10.0821 3.89783 10.5864 4.25 10.8328V11.3594C4.25 11.5097 4.27231 11.7414 4.33749 11.9804C4.40108 12.2137 4.51718 12.4977 4.73484 12.709C5.1021 13.0655 5.44223 13.3961 5.78959 14.0706C5.9958 14.4709 6.3802 14.6999 6.76983 14.8282C7.16113 14.957 7.6018 14.9999 8 14.9999L8.06122 14.9999C8.60888 15.0006 9.27872 15.0015 9.76517 14.5292C9.81146 14.4843 9.85315 14.4368 9.8907 14.3761C9.92397 14.3222 9.94816 14.2667 9.9677 14.2215L9.97982 14.1933C10.0198 14.1001 10.0801 13.9594 10.2104 13.7065C10.3709 13.395 10.5197 13.2563 10.6625 13.1524C10.7173 13.1125 10.7654 13.0814 10.8217 13.045C10.8544 13.0239 10.89 13.0009 10.9312 12.9734C11.0341 12.9047 11.1486 12.8221 11.2652 12.709C11.4037 12.5745 11.487 12.3881 11.5416 12.2255C11.5996 12.0533 11.6409 11.8591 11.6707 11.6692C11.7143 11.3915 11.7365 11.1027 11.7453 10.8672C12.2462 10.5967 12.875 9.94919 12.875 8.81109C12.875 8.50214 12.849 8.25273 12.7996 8.05372C12.7509 7.85776 12.6736 7.68603 12.5516 7.55889C12.4706 7.47442 12.3752 7.41564 12.2725 7.38385C12.2667 7.33781 12.2594 7.29281 12.2508 7.24904C12.7118 7.02849 13.1068 6.76605 13.4047 6.46535C13.7669 6.09976 14 5.66105 14 5.17061C14 4.5699 13.6523 4.05043 13.1432 3.6411C12.6823 3.2705 12.0606 2.96467 11.3404 2.73605C11.2242 2.35088 11.0925 1.98811 10.9603 1.73142C10.7395 1.30252 10.4011 1.0059 9.93166 1.03967C9.53318 1.06832 9.16761 1.33797 8.85983 1.63676C8.61339 1.87601 8.32283 2.00886 8.03841 2.02201C7.76176 2.0348 7.44905 1.93663 7.14017 1.63676ZM11.5658 3.59118C11.6741 4.06633 11.7499 4.52468 11.7499 4.80656C11.7499 4.92828 11.6872 5.04194 11.5829 5.10946C10.3604 5.90072 8.7642 6.08258 7.38012 5.98884C6.6825 5.94159 6.02351 5.82346 5.47009 5.66825C4.92503 5.51539 4.45291 5.31841 4.1499 5.09781C4.02075 5.0038 3.96808 4.8401 4.01912 4.69144C4.09276 4.47698 4.17934 4.18241 4.27623 3.85276C4.29774 3.7796 4.31975 3.7047 4.34225 3.62857C3.90217 3.81183 3.54265 4.02357 3.27714 4.24989C2.90898 4.5637 2.75 4.87843 2.75 5.17061C2.75 5.42689 2.8714 5.6985 3.14893 5.97371C3.42815 6.25061 3.84917 6.51301 4.39453 6.73414C5.33587 7.11583 6.59942 7.3549 8 7.3549C9.42653 7.3549 10.7105 7.1069 11.6568 6.71307C12.1863 6.49265 12.5941 6.23326 12.8641 5.96064C13.1324 5.68984 13.25 5.42292 13.25 5.17061C13.25 4.86359 13.0739 4.53075 12.6648 4.20185C12.3859 3.97761 12.0148 3.76961 11.5658 3.59118ZM5.68702 2.09612C5.82319 1.89782 5.9247 1.80143 5.99187 1.75786C6.044 1.72406 6.06428 1.7279 6.07406 1.72976L6.07523 1.72997C6.10315 1.73503 6.16056 1.75713 6.26176 1.83516C6.36157 1.91213 6.47067 2.0165 6.60983 2.1516C7.05095 2.57984 7.56324 2.7729 8.07409 2.74928C8.57717 2.72603 9.03661 2.49484 9.39017 2.1516C9.68239 1.86791 9.87932 1.77352 9.98706 1.76577C10.0238 1.76313 10.1354 1.75775 10.2894 2.05695C10.4466 2.36221 10.6262 2.91194 10.7681 3.47578C10.8802 3.92094 10.959 4.33644 10.9878 4.61258C9.97999 5.18846 8.66153 5.34576 7.43232 5.26251C6.78619 5.21874 6.17954 5.10935 5.67824 4.96876C5.31925 4.86808 5.02871 4.75543 4.81945 4.64749C4.87685 4.4626 4.93996 4.24816 5.00564 4.02497C5.07002 3.80624 5.13686 3.57911 5.20323 3.36316C5.29109 3.07728 5.37976 2.8048 5.46574 2.57616C5.55476 2.33943 5.63066 2.17819 5.68702 2.09612ZM3.92202 8.37533C3.94683 8.34133 3.97449 8.30983 4.00388 8.28087C4.08206 8.46836 4.19273 8.65452 4.3455 8.8263C4.64192 9.15962 5.0764 9.41561 5.67646 9.53211C6.4674 9.68568 7.06061 9.66037 7.49115 9.54406C7.66374 9.49744 7.81593 9.43419 7.94408 9.35873C8.05764 9.43782 8.19463 9.49957 8.34347 9.54239C8.75977 9.66213 9.3874 9.68377 10.3116 9.53423C10.9733 9.42718 11.4527 9.19484 11.7772 8.87482C11.9198 8.73419 12.027 8.582 12.1054 8.4257C12.1175 8.52967 12.125 8.65679 12.125 8.81109C12.125 9.79968 11.4984 10.2076 11.2564 10.286C11.1033 10.3355 11 10.4746 11 10.6313C11 10.8604 10.982 11.2237 10.9293 11.5594C10.9029 11.7274 10.8692 11.879 10.8287 11.9996C10.7849 12.1298 10.7463 12.183 10.7348 12.1941C10.6639 12.263 10.5909 12.317 10.5063 12.3734C10.4838 12.3884 10.4575 12.4055 10.429 12.4239C10.3622 12.4672 10.2832 12.5184 10.2125 12.5699C9.98026 12.739 9.75413 12.9643 9.53959 13.3809C9.39801 13.6558 9.33018 13.8138 9.28807 13.9119L9.27605 13.9399C9.25621 13.9858 9.25017 13.9971 9.24795 14.0008C9.24795 14.0008 9.24567 14.0035 9.2426 14.0066L9.23483 14.0144C8.98956 14.2525 8.64174 14.2718 8 14.2718C7.6482 14.2718 7.2967 14.2328 7.01067 14.1387C6.72296 14.044 6.54486 13.9089 6.46041 13.7449C6.05819 12.964 5.64876 12.5665 5.26637 12.1953L5.26516 12.1941C5.18282 12.1142 5.11142 11.9735 5.06251 11.7941C5.01519 11.6206 5 11.4518 5 11.3594V10.6313C5 10.4934 4.91975 10.3674 4.79271 10.3057C4.63346 10.2284 4.12495 9.84401 3.85576 9.06001C3.74375 8.73382 3.81579 8.52093 3.92202 8.37533ZM7.2901 8.84262C7.47638 8.79229 7.57637 8.72828 7.625 8.68776V8.07759C6.50729 8.04525 5.46755 7.86923 4.5955 7.58453C4.59807 7.61164 4.60139 7.63914 4.60552 7.66693C4.64096 7.90526 4.73362 8.14856 4.91321 8.35051C5.08947 8.54871 5.36955 8.73001 5.82354 8.81816C6.5326 8.95583 7.00189 8.92047 7.2901 8.84262ZM8.375 8.76469V8.07759C9.54874 8.04363 10.6367 7.85121 11.5348 7.54074C11.5397 7.60803 11.5395 7.67805 11.5325 7.74892C11.5112 7.96452 11.4286 8.18078 11.2427 8.36404C11.0555 8.54863 10.7353 8.72755 10.1884 8.81604C9.3126 8.95774 8.81523 8.9187 8.55653 8.84429C8.44766 8.81297 8.39681 8.78247 8.375 8.76469ZM8.36051 8.74889C8.36051 8.74889 8.36291 8.75086 8.36529 8.75578C8.3613 8.75152 8.36051 8.74889 8.36051 8.74889Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const FtxToken = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.00001 0.833252C5.68639 0.833252 5.38618 0.939976 5.16312 1.16303C4.94007 1.38609 4.83334 1.68629 4.83334 1.99992V3.99992C4.83334 4.31354 4.94007 4.61375 5.16312 4.8368C5.38618 5.05986 5.68639 5.16658 6.00001 5.16658H14C14.3136 5.16658 14.6138 5.05986 14.8369 4.8368C15.06 4.61375 15.1667 4.31354 15.1667 3.99992V1.99992C15.1667 1.68629 15.06 1.38609 14.8369 1.16303C14.6138 0.939976 14.3136 0.833252 14 0.833252H6.00001ZM5.83334 1.99992C5.83334 1.91354 5.85995 1.88042 5.87023 1.87014C5.88051 1.85986 5.91363 1.83325 6.00001 1.83325H14C14.0864 1.83325 14.1195 1.85986 14.1298 1.87014C14.1401 1.88042 14.1667 1.91354 14.1667 1.99992V3.99992C14.1667 4.08629 14.1401 4.11942 14.1298 4.1297C14.1195 4.13998 14.0864 4.16658 14 4.16658H6.00001C5.91363 4.16658 5.88051 4.13998 5.87023 4.1297C5.85995 4.11942 5.83334 4.08629 5.83334 3.99992V1.99992Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.66668 10.8333C4.39053 10.8333 4.16668 11.0571 4.16668 11.3333V14.6666C4.16668 14.9427 4.39053 15.1666 4.66668 15.1666H8.00001C8.27615 15.1666 8.50001 14.9427 8.50001 14.6666V11.3333C8.50001 11.0571 8.27615 10.8333 8.00001 10.8333H4.66668ZM5.16668 14.1666V11.8333H7.50001V14.1666H5.16668Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0.833344 6.33325C0.833344 6.05711 1.0572 5.83325 1.33334 5.83325H4.66668C4.94282 5.83325 5.16668 6.05711 5.16668 6.33325V9.66658C5.16668 9.94273 4.94282 10.1666 4.66668 10.1666H1.33334C1.0572 10.1666 0.833344 9.94273 0.833344 9.66658V6.33325ZM1.83334 6.83325V9.16658H4.16668V6.83325H1.83334Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.33334 5.89998C6.0572 5.89998 5.83334 6.12384 5.83334 6.39998V9.53332C5.83334 9.80946 6.0572 10.0333 6.33334 10.0333H12C12.2762 10.0333 12.5 9.80946 12.5 9.53332V6.39998C12.5 6.12384 12.2762 5.89998 12 5.89998H6.33334ZM6.83334 9.03332V6.89998H11.5V9.03332H6.83334Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Geolocalisation = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8 5.25C6.48122 5.25 5.25 6.48122 5.25 8C5.25 9.51878 6.48122 10.75 8 10.75C9.51878 10.75 10.75 9.51878 10.75 8C10.75 6.48122 9.51878 5.25 8 5.25ZM6.75 8C6.75 7.30964 7.30964 6.75 8 6.75C8.69036 6.75 9.25 7.30964 9.25 8C9.25 8.69036 8.69036 9.25 8 9.25C7.30964 9.25 6.75 8.69036 6.75 8Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8 0.25C8.41421 0.25 8.75 0.585786 8.75 1V2C8.75 2.10325 8.72914 2.20162 8.6914 2.29114C11.3144 2.60548 13.3945 4.68564 13.7089 7.30861C13.7984 7.27087 13.8968 7.25 14 7.25H15C15.4142 7.25 15.75 7.58579 15.75 8C15.75 8.41421 15.4142 8.75 15 8.75H14C13.8968 8.75 13.7984 8.72914 13.7089 8.69139C13.3945 11.3144 11.3144 13.3945 8.69139 13.7089C8.72913 13.7984 8.75 13.8968 8.75 14V15C8.75 15.4142 8.41421 15.75 8 15.75C7.58579 15.75 7.25 15.4142 7.25 15V14C7.25 13.8968 7.27087 13.7984 7.30861 13.7089C4.68564 13.3945 2.60548 11.3144 2.29114 8.69139C2.20162 8.72913 2.10325 8.75 2 8.75H1C0.585786 8.75 0.25 8.41421 0.25 8C0.25 7.58579 0.585786 7.25 1 7.25H2C2.10325 7.25 2.20162 7.27086 2.29114 7.30861C2.60548 4.68564 4.68564 2.60548 7.3086 2.29114C7.27086 2.20162 7.25 2.10325 7.25 2V1C7.25 0.585786 7.58579 0.25 8 0.25ZM3.75 8C3.75 5.65279 5.65279 3.75 8 3.75C10.3472 3.75 12.25 5.65279 12.25 8C12.25 10.3472 10.3472 12.25 8 12.25C5.65279 12.25 3.75 10.3472 3.75 8Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Graphe = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M1.97674 1.48837C1.97674 1.21865 1.75809 1 1.48837 1C1.21865 1 1 1.21865 1 1.48837V13.2093C1 14.1983 1.80172 15 2.7907 15H14.5116C14.7813 15 15 14.7813 15 14.5116C15 14.2419 14.7813 14.0233 14.5116 14.0233H2.7907C2.34116 14.0233 1.97674 13.6588 1.97674 13.2093V1.48837Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M14.2314 6.36423C14.4068 6.15939 14.383 5.85108 14.1782 5.67561C13.9733 5.50015 13.665 5.52396 13.4896 5.7288L10.4955 9.22404L10.495 9.22465C10.1849 9.58295 9.63508 9.6021 9.30254 9.26956L8.68602 8.65305L8.68488 8.65189C7.94639 7.90572 6.73795 7.96497 6.06109 8.74871L6.05975 8.75026L3.07091 12.2405C2.89548 12.4453 2.91934 12.7536 3.1242 12.9291C3.32907 13.1045 3.63737 13.0807 3.81281 12.8758L6.80031 9.38713L6.8009 9.38645C7.11355 9.0252 7.66187 9.00618 7.99119 9.33951L7.99327 9.34161L8.61188 9.96022C9.34706 10.6954 10.5549 10.6496 11.2347 9.86246L11.236 9.86097L14.2314 6.36423Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Handshake = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.29408 3.11979L10.3581 4.05636H11.3819L12.8354 3.32964C12.8354 3.32964 13.2002 3.14366 13.5902 3.26874C13.5902 3.26874 13.9802 3.39382 14.1681 3.75613L15.7044 6.69752C15.7044 6.69752 15.7989 6.87609 15.8166 7.07733C15.8166 7.07733 15.8344 7.27857 15.7726 7.47091C15.7726 7.47091 15.7109 7.66326 15.5793 7.81655C15.5793 7.81655 15.4479 7.96953 15.2676 8.05966L15.2669 8.06002L13.8144 8.78335L12.8842 9.87631C12.8732 9.88955 12.8615 9.90216 12.8493 9.9141L10.5535 12.2099C10.5496 12.2138 10.5456 12.2177 10.5415 12.2215C10.3562 12.3947 10.1118 12.4623 10.1118 12.4623C9.86732 12.5298 9.61942 12.4763 9.61942 12.4763C9.61416 12.4752 9.60892 12.4739 9.6037 12.4726L5.9787 11.5664L5.96572 11.5629C5.76492 11.507 5.61105 11.3817 5.61105 11.3817L2.23138 8.74344L0.731894 7.99066C0.731894 7.99066 0.554896 7.90394 0.422653 7.7514C0.422653 7.7514 0.29041 7.59886 0.228171 7.40681C0.228171 7.40681 0.165932 7.21476 0.183566 7.01365C0.183566 7.01365 0.2012 6.81254 0.295911 6.63425L1.83178 3.69359C1.83178 3.69359 2.01902 3.3337 2.405 3.20625C2.405 3.20625 2.79098 3.07881 3.15641 3.2568L4.56192 3.95952L7.6059 3.06948C7.6059 3.06948 7.95882 2.96827 8.29408 3.11979ZM3.13596 8.18097L4.83789 4.9207L7.88156 4.03074L8.36715 4.25108C8.29701 4.30242 8.25353 4.34568 8.25353 4.34568L5.80311 6.78986C5.6472 6.94984 5.57327 7.15299 5.57327 7.15299C5.49933 7.35615 5.51537 7.57174 5.51537 7.57174C5.53141 7.78734 5.63458 7.97732 5.63458 7.97732C5.73775 8.1673 5.90985 8.29814 5.90985 8.29814L6.2476 8.55458C6.91779 9.0548 7.74996 9.0548 7.74996 9.0548C8.58212 9.0548 9.24902 8.55706 9.24902 8.55706L9.75453 8.17793L11.7326 9.61655L9.85593 11.4932C9.85593 11.4932 9.85123 11.4968 9.84544 11.4984C9.84544 11.4984 9.83959 11.5 9.83367 11.4993L6.23388 10.5994L6.22639 10.5934L3.13596 8.18097ZM12.4194 8.87952L12.9006 8.31412L11.1972 5.05636H8.95706L6.51015 7.49703L6.51298 7.49497C6.51298 7.49497 6.51252 7.49623 6.51262 7.49757C6.51262 7.49757 6.51272 7.49891 6.51336 7.50009C6.51336 7.50009 6.514 7.50127 6.51507 7.50208L6.85231 7.75814C6.85231 7.75814 7.24983 8.0548 7.74996 8.0548C7.74996 8.0548 8.25009 8.0548 8.65089 7.75566L9.44996 7.15636C9.62556 7.02466 9.86652 7.02289 10.044 7.15199L12.4194 8.87952ZM3.82128 4.70722L2.71854 4.15583L2.71817 4.15654L1.18201 7.09769L2.28448 7.65116L3.82128 4.70722ZM13.284 4.22334L14.8205 7.16519L13.7159 7.71526L12.179 4.77586L13.284 4.22334Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M3.49997 11.0001C3.62032 11.0001 3.73664 11.0435 3.82756 11.1223L5.23834 12.3458L5.24112 12.3465L7.12237 12.8215C7.25095 12.854 7.36136 12.9362 7.42932 13.0501C7.47156 13.1209 7.49565 13.201 7.49944 13.2833C7.49979 13.291 7.49997 13.2987 7.49997 13.3063C7.49997 13.3476 7.49486 13.3887 7.48476 13.4287C7.43012 13.6451 7.23873 13.7991 7.01568 13.8061C7.01045 13.8062 7.00521 13.8063 6.99997 13.8063C6.9587 13.8063 6.91758 13.8012 6.87757 13.7911L5.00144 13.3174C5.00144 13.3174 4.76265 13.2617 4.58488 13.1028L3.17238 11.8778C3.0722 11.7909 3.01063 11.6678 3.00123 11.5355C3.00039 11.5237 2.99997 11.5119 2.99997 11.5001C2.99997 11.3797 3.04338 11.2634 3.12224 11.1725C3.20912 11.0723 3.33224 11.0107 3.46451 11.0013C3.47631 11.0005 3.48814 11.0001 3.49997 11.0001Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Harmony = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.83331 3.79992C8.83331 2.19044 10.1905 0.833252 11.8 0.833252H12.1333C13.8008 0.833252 15.1666 2.18183 15.1666 3.79992L15.1665 3.83343L15.1666 12.1999C15.1666 13.8848 13.8006 15.1666 12.2 15.1666H11.8666C10.1817 15.1666 8.89998 13.8005 8.89998 12.1999V8.48193C8.60588 8.49988 8.30471 8.49987 8.02384 8.49985L7.99998 8.49985C7.69874 8.49985 7.4197 8.50039 7.16665 8.51544V12.1999C7.16665 13.8848 5.8006 15.1666 4.19998 15.1666H3.79998C2.1905 15.1666 0.833313 13.8094 0.833313 12.1999L0.83345 12.1664L0.833313 3.79992C0.833313 2.19044 2.1905 0.833252 3.79998 0.833252H4.13331C5.80077 0.833252 7.16665 2.18183 7.16665 3.79992V7.51401C7.4394 7.49983 7.71644 7.49984 7.97612 7.49985L7.99998 7.49985C8.30122 7.49985 8.58026 7.49932 8.83331 7.48427V3.79992ZM11.8 1.83325C10.7428 1.83325 9.83331 2.74273 9.83331 3.79992V7.28764C11.1486 7.05669 12.1605 6.6115 12.8713 6.17409L12.876 6.17114C13.7098 5.67089 14.1666 4.77666 14.1666 3.79992C14.1666 2.75134 13.2659 1.83325 12.1333 1.83325H11.8ZM14.1666 6.5162C14.0258 6.62976 13.8678 6.74883 13.6921 6.86992C12.8474 7.45219 11.5979 8.07909 9.89998 8.36477V12.1999C9.89998 13.266 10.7516 14.1666 11.8666 14.1666H12.2C13.266 14.1666 14.1666 13.315 14.1666 12.1999V6.5162ZM3.1287 9.82572C3.83949 9.3883 4.85138 8.94311 6.16665 8.71217V12.1999C6.16665 13.315 5.26602 14.1666 4.19998 14.1666H3.79998C2.74279 14.1666 1.83331 13.2571 1.83331 12.1999C1.83331 11.2231 2.29014 10.3289 3.12389 9.82863L3.1287 9.82572ZM3.79998 1.83325C2.74279 1.83325 1.83331 2.74273 1.83331 3.79992V9.48715C1.97681 9.37213 2.13822 9.25142 2.31806 9.12864C3.17211 8.54559 4.43826 7.91865 6.16665 7.63383V3.79992C6.16665 2.75134 5.26586 1.83325 4.13331 1.83325H3.79998Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const HederaHashgraph = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.46668 4.49992C5.74282 4.49992 5.96668 4.72378 5.96668 4.99992V6.23332H10.0333V4.99992C10.0333 4.72378 10.2572 4.49992 10.5333 4.49992C10.8095 4.49992 11.0333 4.72378 11.0333 4.99992V6.73218L11.0333 6.73332L11.0333 6.73446V9.26538L11.0333 9.26652L11.0333 9.26766V10.9999C11.0333 11.2761 10.8095 11.4999 10.5333 11.4999C10.2572 11.4999 10.0333 11.2761 10.0333 10.9999V9.76652H5.96668V10.9999C5.96668 11.2761 5.74282 11.4999 5.46668 11.4999C5.19053 11.4999 4.96668 11.2761 4.96668 10.9999V4.99992C4.96668 4.72378 5.19053 4.49992 5.46668 4.49992ZM10.0333 7.23332V8.76652H5.96668V7.23332H10.0333Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.00001 0.833252C4.04197 0.833252 0.833344 4.04188 0.833344 7.99992C0.833344 11.958 4.04197 15.1666 8.00001 15.1666C11.9581 15.1666 15.1667 11.958 15.1667 7.99992C15.1667 4.04188 11.9581 0.833252 8.00001 0.833252ZM1.83334 7.99992C1.83334 4.59416 4.59425 1.83325 8.00001 1.83325C11.4058 1.83325 14.1667 4.59416 14.1667 7.99992C14.1667 11.4057 11.4058 14.1666 8.00001 14.1666C4.59425 14.1666 1.83334 11.4057 1.83334 7.99992Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Hex = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.37732 1.69995H11.6227L15.2433 7.99995L11.6227 14.3H4.37732L4.37425 14.2999H4.37328L4.23174 14.0466L0.75663 7.99995L4.37732 1.69995ZM4.96 13.2999H6.97328L7.95847 11.5369L6.97757 9.83325H4.95571L3.9748 11.5369L4.96 13.2999ZM8.11882 13.2999L9.10814 11.5296L7.55571 8.83325H4.37757L3.40084 10.5297L2.84144 9.53519L4.95683 5.83325H9.24714L11.4213 9.53523L9.24486 13.2999H8.11882ZM10.3999 13.3L12.5787 9.53127L9.81954 4.83325H4.37651L2.23943 8.57314L1.91001 7.99995L4.95599 2.69995H11.044L14.09 7.99995L11.044 13.3H10.3999Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Historique = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M11.239 1.13688C9.68993 0.431997 7.9418 0.280957 6.29271 0.709687C4.79786 1.09831 3.46882 1.94135 2.48893 3.1136L1.21401 2.4626C0.865673 2.28474 0.452981 2.54594 0.471161 2.93276L0.726223 8.3597C0.744404 8.74652 1.17982 8.96885 1.50998 8.75989L6.14184 5.8283C6.472 5.61934 6.44927 5.13581 6.10093 4.95794L4.35755 4.06774C5.02852 3.38905 5.87539 2.89892 6.81149 2.65555C8.00316 2.34574 9.26642 2.45481 10.3862 2.96436C11.5061 3.47395 12.4137 4.3528 12.9538 5.45188C13.4938 6.55102 13.6325 7.80195 13.3461 8.99132C13.0596 10.1807 12.3659 11.2341 11.3839 11.9726C10.4021 12.7111 9.19258 13.0891 7.96158 13.0429C6.73057 12.9966 5.55333 12.529 4.63055 11.7189C4.25069 11.3855 3.92363 11.0025 3.65666 10.583C3.35726 10.1125 2.72833 9.97082 2.25192 10.2665C1.7755 10.5621 1.63201 11.1832 1.93141 11.6537C2.30003 12.2329 2.75181 12.762 3.27672 13.2228C4.55205 14.3423 6.18031 14.9896 7.88416 15.0536C9.58801 15.1176 11.2612 14.5942 12.6185 13.5734C13.9758 12.5526 14.9332 11.0977 15.3284 9.45693C15.7236 7.81621 15.5324 6.09046 14.787 4.57352C14.0417 3.05651 12.788 1.84173 11.239 1.13688Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Home = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.58692 0.635213C8.22208 0.415551 7.76594 0.415715 7.40126 0.635639L0.558844 4.76199C-0.439629 5.36413 -0.0134428 6.90077 1.15203 6.90077H1.22671V14.8481C1.22671 15.4843 1.7416 16 2.37675 16H13.6117C14.2469 16 14.7617 15.4843 14.7617 14.8481V6.90077H14.848C16.0139 6.90077 16.4397 5.36321 15.4405 4.76157L8.58692 0.635213ZM1.57646 5.6423L7.9945 1.77187L14.4203 5.6407C13.8873 5.74101 13.4839 6.20972 13.4839 6.77278V14.7201H10.6663C10.6028 13.6264 10.3781 12.6248 10.0308 11.842C9.82413 11.3762 9.56148 10.9597 9.23755 10.6509C8.91033 10.339 8.49146 10.1124 8.00128 10.1124C7.51111 10.1124 7.09224 10.339 6.76501 10.6509C6.44109 10.9597 6.17844 11.3762 5.97176 11.842C5.62444 12.6248 5.39972 13.6264 5.33629 14.7201H2.50453V6.77278C2.50453 6.21265 2.10539 5.74589 1.57646 5.6423ZM6.61653 14.7201H9.38603C9.32429 13.7821 9.1299 12.9631 8.86312 12.3618C8.69982 11.9938 8.52192 11.7356 8.35664 11.578C8.19466 11.4236 8.07568 11.3923 8.00128 11.3923C7.92688 11.3923 7.8079 11.4236 7.64592 11.578C7.48065 11.7356 7.30274 11.9938 7.13944 12.3618C6.87266 12.9631 6.67828 13.7821 6.61653 14.7201Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Horloge = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M1.14304 4.43573C0.95232 4.24294 0.95232 3.93037 1.14304 3.73758L3.70819 1.14459C3.89891 0.951802 4.20813 0.951802 4.39886 1.14459C4.58958 1.33738 4.58958 1.64996 4.39886 1.84275L1.8337 4.43573C1.64298 4.62852 1.33376 4.62852 1.14304 4.43573Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M11.1657 8.98567H7.50665V4.92317C7.50665 4.65393 7.72033 4.43567 7.98392 4.43567C8.24751 4.43567 8.4612 4.65393 8.4612 4.92317V8.01067H11.1657C11.4293 8.01067 11.643 8.22893 11.643 8.49817C11.643 8.76741 11.4293 8.98567 11.1657 8.98567Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.14301 14.1857C11.3797 14.1857 14.0035 11.5334 14.0035 8.26162C14.0035 4.98986 11.3797 2.33757 8.14301 2.33757C4.90637 2.33757 2.28255 4.98986 2.28255 8.26162C2.28255 11.5334 4.90637 14.1857 8.14301 14.1857ZM8.14301 13.1983C10.8402 13.1983 13.0267 10.9881 13.0267 8.26162C13.0267 5.53515 10.8402 3.32491 8.14301 3.32491C5.44581 3.32491 3.25929 5.53515 3.25929 8.26162C3.25929 10.9881 5.44581 13.1983 8.14301 13.1983Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M15.1431 4.43579C15.3338 4.243 15.3338 3.93043 15.1431 3.73763L12.5779 1.14465C12.3872 0.951861 12.078 0.951861 11.8873 1.14465C11.6965 1.33744 11.6965 1.65002 11.8873 1.84281L14.4524 4.43579C14.6431 4.62858 14.9523 4.62858 15.1431 4.43579Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Hotline = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M10.2588 3.84158C10.2588 3.99469 10.1324 4.11881 9.97647 4.11881C9.82053 4.11881 9.69412 3.99469 9.69412 3.84158C9.69412 3.68848 9.82053 3.56436 9.97647 3.56436C10.1324 3.56436 10.2588 3.68848 10.2588 3.84158Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M11.3882 3.84158C11.3882 3.99469 11.2618 4.11881 11.1059 4.11881C10.9499 4.11881 10.8235 3.99469 10.8235 3.84158C10.8235 3.68848 10.9499 3.56436 11.1059 3.56436C11.2618 3.56436 11.3882 3.68848 11.3882 3.84158Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M12.5176 3.84158C12.5176 3.99469 12.3912 4.11881 12.2353 4.11881C12.0794 4.11881 11.9529 3.99469 11.9529 3.84158C11.9529 3.68848 12.0794 3.56436 12.2353 3.56436C12.3912 3.56436 12.5176 3.68848 12.5176 3.84158Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.1059 1C9.51954 1 8.21176 2.22125 8.21176 3.75367C8.21176 4.59198 8.60546 5.34001 9.22038 5.84286C9.22041 5.85032 9.22031 5.85856 9.22004 5.86766C9.21737 5.95688 9.20118 6.06941 9.18116 6.20866L9.17774 6.23245C9.15842 6.367 9.13454 6.53532 9.1377 6.67822C9.13927 6.74925 9.14754 6.84267 9.18307 6.93354C9.22122 7.03108 9.30338 7.15297 9.46145 7.20894C9.5937 7.25576 9.72083 7.2356 9.79967 7.21608C9.88595 7.19471 9.97114 7.15931 10.0472 7.1228C10.1994 7.04976 10.3681 6.94591 10.52 6.8507L10.5974 6.80204C10.7263 6.72088 10.8435 6.64716 10.948 6.58921C11.0098 6.55499 11.0581 6.53142 11.0941 6.51717C11.1077 6.51175 11.1168 6.50881 11.1219 6.5073C12.701 6.49911 14 5.28093 14 3.75367C14 2.22125 12.6922 1 11.1059 1ZM8.91765 3.75367C8.91765 2.62724 9.88531 1.69307 11.1059 1.69307C12.3265 1.69307 13.2941 2.62724 13.2941 3.75367C13.2941 4.8801 12.3265 5.81428 11.1059 5.81428C10.9986 5.81428 10.8995 5.84686 10.8297 5.87456C10.7535 5.90477 10.6753 5.94451 10.6011 5.98565C10.4775 6.05412 10.34 6.14071 10.2116 6.2216L10.14 6.26659C10.0387 6.33015 9.94544 6.38744 9.86214 6.43436C9.86643 6.4017 9.87133 6.36668 9.87671 6.32921L9.88175 6.29429C9.89996 6.16839 9.92172 6.01799 9.92562 5.88803C9.92776 5.81633 9.92547 5.73081 9.90643 5.64721C9.88828 5.56754 9.84449 5.44374 9.72615 5.35308C9.22988 4.97288 8.91765 4.3961 8.91765 3.75367ZM9.6193 6.54554C9.61873 6.54564 9.61842 6.54572 9.6184 6.54576C9.61835 6.54584 9.61966 6.5457 9.6225 6.5451C9.62106 6.54526 9.61999 6.54541 9.6193 6.54554Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.38024 3.21782C3.85438 3.21782 3.37481 3.43684 2.96074 3.83599C2.62769 4.14516 2.38347 4.49654 2.22817 4.88369C2.07511 5.25975 2 5.66382 2 6.08158C2 6.71228 2.14833 7.3624 2.43425 8.02913L2.43468 8.03014C2.7177 8.68431 3.10435 9.33867 3.57983 9.9877L3.58102 9.98932C4.0606 10.636 4.59741 11.2537 5.19111 11.8423L5.19352 11.8446C5.79306 12.4276 6.42198 12.9546 7.08594 13.4307L7.08638 13.431C7.74939 13.905 8.4219 14.2845 9.09836 14.5675C9.78321 14.854 10.4458 15 11.0776 15C11.5174 15 11.9304 14.9197 12.3136 14.763C12.7119 14.6026 13.0588 14.3542 13.3663 14.0214C13.5547 13.8172 13.6981 13.5997 13.8081 13.3709C13.926 13.1258 13.9831 12.8702 13.9831 12.6186C13.9831 12.4103 13.9368 12.2277 13.8675 12.0574L13.8652 12.052L13.8628 12.0466C13.771 11.8417 13.6233 11.6781 13.4319 11.5476L11.5614 10.2437L11.5585 10.2418C11.4042 10.1388 11.2522 10.0532 11.0983 9.99135C10.9375 9.92675 10.7793 9.89347 10.6202 9.89347C10.4106 9.89347 10.2212 9.95167 10.0457 10.0545C9.87667 10.143 9.71608 10.2718 9.56397 10.4211L9.14162 10.8303L9.13716 10.8301L9.1348 10.8299C9.12614 10.8261 9.11719 10.822 9.10694 10.8174L9.10227 10.8153C9.09118 10.8103 9.0765 10.8037 9.06073 10.7971C8.9008 10.7121 8.68411 10.5647 8.40886 10.336C8.1196 10.0948 7.83356 9.83046 7.53243 9.54033C7.24648 9.25405 6.98165 8.96701 6.73217 8.68401C6.50173 8.41649 6.34808 8.20641 6.26079 8.05507C6.25435 8.03869 6.24822 8.02447 6.24376 8.01414L6.24202 8.01009C6.23813 8.00107 6.23487 7.9935 6.232 7.98665C6.23087 7.98056 6.23026 7.97557 6.22995 7.97094L6.64829 7.54398C6.79724 7.39739 6.92456 7.24223 7.01696 7.08303C7.12434 6.90805 7.184 6.71502 7.184 6.51406C7.184 6.35159 7.1415 6.18926 7.07757 6.04201C7.01444 5.89119 6.92672 5.74108 6.81332 5.58631L5.50494 3.77563C5.36523 3.57819 5.18567 3.44066 4.98796 3.35061C4.79675 3.26097 4.5869 3.21782 4.38024 3.21782ZM3.45324 4.3325C3.76138 4.03469 4.07147 3.91089 4.38024 3.91089C4.48893 3.91089 4.59442 3.93392 4.68492 3.97657L4.68974 3.9788C4.78414 4.02157 4.86297 4.08278 4.92581 4.1719L4.92815 4.17517L6.23826 5.98824L6.23969 5.9902C6.32855 6.11138 6.38704 6.21513 6.42534 6.30705L6.4276 6.31235C6.46466 6.39726 6.47812 6.46682 6.47812 6.51406C6.47812 6.57737 6.45983 6.64876 6.41099 6.72754L6.40802 6.73233L6.40521 6.73721C6.35151 6.83049 6.26621 6.93898 6.14667 7.05635L6.14425 7.05872L5.71467 7.49715C5.58288 7.628 5.52376 7.78966 5.52376 7.96119C5.52376 8.03837 5.53416 8.10565 5.55124 8.17276L5.55612 8.19191L5.56318 8.21039C5.57369 8.23792 5.58424 8.26235 5.5913 8.2787L5.59331 8.28334C5.60147 8.30228 5.60331 8.30718 5.60399 8.30919L5.61393 8.33846L5.62898 8.36554C5.7473 8.57854 5.93985 8.83759 6.19457 9.13315L6.19712 9.13607C6.45482 9.42846 6.73093 9.72786 7.03089 10.028L7.03322 10.0304L7.0356 10.0327C7.34338 10.3293 7.6438 10.6074 7.95227 10.8646L7.95273 10.8649C8.25682 11.1176 8.52124 11.3009 8.74404 11.4168L8.76065 11.4254L8.7781 11.4322C8.78286 11.4341 8.79063 11.4375 8.80871 11.4456L8.81309 11.4476C8.82847 11.4545 8.84941 11.4639 8.87179 11.4734L8.87928 11.4765L8.8869 11.4793C8.98365 11.5149 9.07384 11.5236 9.152 11.5236C9.34613 11.5236 9.50761 11.4506 9.63217 11.3287L9.6331 11.3278L10.0606 10.9136L10.0623 10.912C10.1892 10.7874 10.2959 10.708 10.3826 10.6637L10.3929 10.6584L10.4028 10.6524C10.4843 10.6037 10.5514 10.5865 10.6202 10.5865C10.6758 10.5865 10.7434 10.5976 10.8311 10.6328C10.925 10.6705 11.0319 10.7285 11.1587 10.813L13.0249 12.1138L13.0283 12.1162C13.1274 12.1836 13.1821 12.2509 13.2145 12.3208C13.2564 12.4253 13.2772 12.5183 13.2772 12.6186C13.2772 12.7662 13.2439 12.9209 13.1698 13.075C13.0878 13.2455 12.9825 13.4051 12.8434 13.5558C12.5978 13.8215 12.3352 14.0053 12.045 14.1221L12.0431 14.1229C11.7489 14.2432 11.4281 14.3069 11.0776 14.3069C10.5575 14.3069 9.98903 14.1868 9.37505 13.9299C8.75273 13.6696 8.12644 13.3172 7.50197 12.8708C6.86766 12.4159 6.26603 11.912 5.69143 11.3534C5.12258 10.7893 4.60965 10.1989 4.1523 9.58221C3.70205 8.96752 3.34356 8.35814 3.08459 7.75965C2.82854 7.16242 2.70588 6.604 2.70588 6.08158C2.70588 5.74562 2.76618 5.42921 2.88393 5.14018L2.88467 5.13836C3.00003 4.85048 3.18396 4.58204 3.44784 4.33761L3.45057 4.33509L3.45324 4.3325Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const HuobiToken = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.35355 1.11307C8.13253 0.892054 7.82622 0.809179 7.54523 0.869392C7.25905 0.930717 7.00069 1.14327 6.91609 1.47406C6.66498 2.41403 5.89321 4.48556 4.00325 6.96233C2.65691 8.70959 2.58976 10.5652 3.20361 12.0719C3.80586 13.5502 5.0677 14.7012 6.39597 15.0807L6.40608 15.0835C6.56834 15.1262 6.7342 15.162 6.87891 15.163C6.95113 15.1635 7.06426 15.1564 7.1807 15.1028C7.31829 15.0394 7.43682 14.9208 7.48929 14.7547C7.53368 14.6141 7.51465 14.4887 7.49862 14.4186C7.48135 14.343 7.45383 14.2744 7.42986 14.2212C7.38261 14.1163 7.31418 13.9962 7.25078 13.8852L7.23875 13.8642C6.9722 13.3979 6.58638 12.723 6.49815 11.8235C6.41731 10.744 7.07965 9.75985 7.92165 8.6627C7.97985 8.58686 8.03892 8.5104 8.0984 8.43341C8.44914 7.9794 8.81414 7.50693 9.09971 7.03475C9.43543 6.47965 9.69999 5.86557 9.69999 5.19996C9.69999 3.5478 9.05822 2.04426 8.39999 1.16663C8.3858 1.1477 8.37028 1.1298 8.35355 1.11307ZM4.79747 7.56996C6.59202 5.21848 7.43984 3.19247 7.79185 2.04608C8.26593 2.79712 8.69999 3.95265 8.69999 5.19996C8.69999 5.60101 8.53956 6.0286 8.24403 6.51725C7.99053 6.93641 7.66597 7.35688 7.31321 7.81391C7.25235 7.89275 7.19065 7.97269 7.12834 8.05388C6.32159 9.1051 5.38465 10.3864 5.50147 11.905L5.50232 11.9148C5.58235 12.7417 5.86442 13.4133 6.11556 13.8986C5.30153 13.4844 4.53579 12.6914 4.12971 11.6946C3.64367 10.5017 3.67639 9.02435 4.796 7.57188L4.79747 7.56996Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.1483 6.30787C11.017 6.18033 10.8264 6.13477 10.6516 6.18911C10.4839 6.24124 10.3564 6.37728 10.3146 6.54674C10.312 6.55474 10.304 6.57804 10.2869 6.6188C10.2525 6.70075 10.1828 6.8495 10.0483 7.08674C9.77913 7.56177 9.25944 8.37611 8.26789 9.69827C7.72931 10.4046 7.49679 11.0986 7.49167 11.7564C7.4866 12.4092 7.70559 12.9794 7.99023 13.4443C8.48889 14.2588 9.2413 14.822 9.48907 15.0075C9.51821 15.0293 9.54037 15.0459 9.55431 15.057C9.64297 15.1279 9.75312 15.1666 9.86666 15.1666H9.93333C10.0503 15.1666 10.1636 15.1256 10.2534 15.0507C10.269 15.0377 10.3011 15.0143 10.3472 14.9807C10.7155 14.7119 11.9709 13.7958 12.6835 12.4506C13.0945 11.6748 13.3429 10.7326 13.1538 9.66672C12.9652 8.60395 12.352 7.47669 11.1483 6.30787ZM10.9183 7.57975L10.9416 7.5385C11.6956 8.3962 12.0498 9.16912 12.1691 9.84144C12.3112 10.6422 12.1305 11.3584 11.7998 11.9825C11.2648 12.9924 10.383 13.7003 9.90249 14.0629C9.60165 13.825 9.15885 13.4379 8.84309 12.9222C8.62773 12.5704 8.48839 12.1823 8.49164 11.7642C8.49485 11.3518 8.63697 10.863 9.06414 10.3033L9.06666 10.2999C10.0743 8.95638 10.621 8.10452 10.9183 7.57975Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Imprimante = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M4.41026 6.86047C4.11287 6.86047 3.8718 7.07912 3.8718 7.34884C3.8718 7.61856 4.11287 7.83721 4.41026 7.83721H6.5641C6.86149 7.83721 7.10256 7.61856 7.10256 7.34884C7.10256 7.07912 6.86149 6.86047 6.5641 6.86047H4.41026Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.66807 1.64273C5.15209 1.17447 5.87056 1 6.74359 1H9.25641C10.1294 1 10.8479 1.17447 11.3319 1.64273C11.809 2.10428 11.9487 2.74748 11.9487 3.44186V4.25581H12.3077C13.1086 4.25581 13.8083 4.43776 14.3038 4.88723C14.7994 5.3367 15 5.97123 15 6.69767V9.95349C15 10.6799 14.7994 11.3145 14.3038 11.7639C13.8083 12.2134 13.1086 12.3953 12.3077 12.3953H11.4103V12.5581C11.4103 13.2846 11.2097 13.9191 10.7141 14.3686C10.2185 14.8181 9.5189 15 8.71795 15H7.28205C6.4811 15 5.78149 14.8181 5.28592 14.3686C4.79035 13.9191 4.58974 13.2846 4.58974 12.5581V12.3953H3.69231C2.89136 12.3953 2.19174 12.2134 1.69617 11.7639C1.2006 11.3145 1 10.6799 1 9.95349V6.69767C1 5.97123 1.2006 5.3367 1.69617 4.88723C2.19174 4.43776 2.89136 4.25581 3.69231 4.25581H4.05128V3.44186C4.05128 2.74748 4.19098 2.10428 4.66807 1.64273ZM5.12821 4.25581H10.8718V3.44186C10.8718 2.83391 10.7423 2.50037 10.5463 2.31076C10.3572 2.12786 9.99876 1.97674 9.25641 1.97674H6.74359C6.00124 1.97674 5.64278 2.12786 5.45373 2.31076C5.25774 2.50037 5.12821 2.83391 5.12821 3.44186V4.25581ZM4.58974 11.4186V10.4419H4.41026C4.11287 10.4419 3.8718 10.2232 3.8718 9.95349C3.8718 9.68377 4.11287 9.46512 4.41026 9.46512H11.5897C11.8871 9.46512 12.1282 9.68377 12.1282 9.95349C12.1282 10.2232 11.8871 10.4419 11.5897 10.4419H11.4103V11.4186H12.3077C12.9426 11.4186 13.32 11.275 13.5423 11.0733C13.7647 10.8716 13.9231 10.5294 13.9231 9.95349V6.69767C13.9231 6.12179 13.7647 5.77958 13.5423 5.57789C13.32 5.3762 12.9426 5.23256 12.3077 5.23256H3.69231C3.05736 5.23256 2.68005 5.3762 2.45767 5.57789C2.2353 5.77958 2.07692 6.12179 2.07692 6.69767V9.95349C2.07692 10.5294 2.2353 10.8716 2.45767 11.0733C2.68005 11.275 3.05736 11.4186 3.69231 11.4186H4.58974ZM5.66667 10.4419H10.3333V12.5581C10.3333 13.134 10.175 13.4762 9.95258 13.6779C9.73021 13.8796 9.3529 14.0233 8.71795 14.0233H7.28205C6.6471 14.0233 6.26979 13.8796 6.04742 13.6779C5.82504 13.4762 5.66667 13.134 5.66667 12.5581V10.4419Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Infos = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M9 6C9 6.55228 8.55229 7 8 7C7.44772 7 7 6.55228 7 6C7 5.44772 7.44772 5 8 5C8.55229 5 9 5.44772 9 6Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M8 8C7.44772 8 7 8.44771 7 9V11C7 11.5523 7.44772 12 8 12C8.55229 12 9 11.5523 9 11V9C9 8.44771 8.55229 8 8 8Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Instant_payment = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1.25105 4.23431C1 4.46863 1 4.8 1 4.8V11.2C1 11.5314 1.25105 11.7657 1.25105 11.7657C1.5021 12 1.85714 12 1.85714 12H8.33682C8.21729 11.7484 8.12691 11.4803 8.07001 11.2H1.85714V6.84502H12.1429V7.05891C12.4439 7.11479 12.7314 7.2092 13 7.33682V4.8C13 4.46863 12.7489 4.23431 12.7489 4.23431C12.4979 4 12.1429 4 12.1429 4H1.85714C1.5021 4 1.25105 4.23431 1.25105 4.23431ZM12.1429 6.04502V4.8H1.85714V6.04502H12.1429Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M6.57143 10.4C6.33473 10.4 6.14286 10.2209 6.14286 10C6.14286 9.77909 6.33473 9.6 6.57143 9.6H7.42857C7.66526 9.6 7.85714 9.77909 7.85714 10C7.85714 10.2209 7.66526 10.4 7.42857 10.4H6.57143Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M12.1765 9.14706C12.1765 9.00087 12.058 8.88235 11.9118 8.88235C11.7656 8.88235 11.6471 9.00087 11.6471 9.14706V11.0882C11.6471 11.2344 11.7656 11.3529 11.9118 11.3529H13.3235C13.4697 11.3529 13.5882 11.2344 13.5882 11.0882C13.5882 10.942 13.4697 10.8235 13.3235 10.8235H12.1765V9.14706Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12 14C13.6569 14 15 12.6569 15 11C15 9.34315 13.6569 8 12 8C10.3431 8 9 9.34315 9 11C9 12.6569 10.3431 14 12 14ZM12 13.2941C13.267 13.2941 14.2941 12.267 14.2941 11C14.2941 9.73299 13.267 8.70588 12 8.70588C10.733 8.70588 9.70588 9.73299 9.70588 11C9.70588 12.267 10.733 13.2941 12 13.2941Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Interdit = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM11.7133 12.7132C10.6918 13.5191 9.40208 14 8 14C4.68629 14 2 11.3137 2 8C2 7.02598 2.23209 6.10616 2.64399 5.29284L11.7133 12.7132ZM13.0578 11.2291L3.83384 3.68223C4.91305 2.64068 6.3817 2 8 2C11.3137 2 14 4.68629 14 8C14 9.18882 13.6543 10.2969 13.0578 11.2291Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Integrer1 = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M13.25 4.34021V7.07534C13.2003 7.03421 13.1508 6.99447 13.1015 6.95627V6.87596C13.1015 6.61424 12.8764 6.40206 12.5987 6.40206H12.3077V4.34021C12.3077 4.34021 12.3077 4.15516 12.1697 4.02432C12.1697 4.02432 12.0317 3.89347 11.8365 3.89347H2.41346C2.41346 3.89347 2.2183 3.89347 2.08031 4.02432C2.08031 4.02432 1.94231 4.15516 1.94231 4.34021V9.87285C1.94231 9.87285 1.94231 10.0579 2.08031 10.1887C2.08031 10.1887 2.2183 10.3196 2.41346 10.3196H8V10.7366C8 10.9983 8.2251 11.2105 8.50278 11.2105C8.50967 11.2105 8.51694 11.2114 8.52439 11.2131H7.59615V12.1065H8.56234C8.58595 12.1762 8.62709 12.2418 8.68574 12.297L9.31688 12.8919C9.23439 12.9593 9.12702 13 9.00961 13H5.24038C4.98017 13 4.76923 12.8 4.76923 12.5533C4.76923 12.3065 4.98017 12.1065 5.24038 12.1065H6.65385V11.2131H2.41346C2.41346 11.2131 1.82799 11.2131 1.41399 10.8205C1.41399 10.8205 1 10.428 1 9.87285V4.34021C1 4.34021 1 3.78507 1.41399 3.39254C1.41399 3.39254 1.82799 3 2.41346 3H11.8365C11.8365 3 12.422 3 12.836 3.39254C12.836 3.39254 13.25 3.78508 13.25 4.34021Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.351 10.2204C10.351 9.39454 11.0613 8.72502 11.9375 8.72502C12.8137 8.72502 13.524 9.39454 13.524 10.2204C13.524 11.0463 12.8137 11.7158 11.9375 11.7158C11.0613 11.7158 10.351 11.0463 10.351 10.2204ZM11.9375 9.14745C11.3088 9.14745 10.7992 9.62784 10.7992 10.2204C10.7992 10.813 11.3088 11.2934 11.9375 11.2934C12.5662 11.2934 13.0759 10.813 13.0759 10.2204C13.0759 9.62784 12.5662 9.14745 11.9375 9.14745Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.0322 7.59539C11.0322 7.39183 11.2073 7.2268 11.4233 7.2268H12.4518C12.6677 7.2268 12.8428 7.39183 12.8428 7.59539V7.74169C12.8428 7.76947 12.864 7.80687 12.9135 7.82478C12.9319 7.83144 12.9502 7.83829 12.9684 7.84532C13.0158 7.86361 13.0571 7.85133 13.0775 7.83217L13.1864 7.72953C13.3391 7.58558 13.5867 7.58558 13.7394 7.72953L14.4667 8.41502C14.6194 8.55896 14.6194 8.79234 14.4667 8.93628L14.401 8.9982C14.3796 9.01835 14.3666 9.06051 14.3903 9.10689C14.4057 9.13695 14.4205 9.16733 14.4346 9.19803C14.4548 9.24168 14.4927 9.2601 14.5211 9.2601H14.6089C14.8249 9.2601 15 9.42512 15 9.62869V10.5981C15 10.8017 14.8249 10.9667 14.6089 10.9667C14.5775 10.9667 14.5356 10.9892 14.5183 11.0379C14.4989 11.0922 14.4777 11.1457 14.4546 11.1983C14.4368 11.239 14.449 11.2739 14.4667 11.2905C14.6194 11.4345 14.6194 11.6678 14.4667 11.8118L13.7394 12.4973C13.5876 12.6403 13.3422 12.6412 13.1892 12.5C13.1881 12.5001 13.1862 12.5006 13.1849 12.5013C13.075 12.5548 12.9607 12.6014 12.8427 12.6406C12.8375 12.8399 12.6645 13 12.4518 13H11.4233C11.2105 13 11.0375 12.8399 11.0323 12.6406C10.9143 12.6014 10.8 12.5548 10.6901 12.5013L10.688 12.5004L10.6863 12.5C10.5334 12.6413 10.2874 12.6403 10.1356 12.4973L9.40836 11.8118C9.25564 11.6678 9.25564 11.4345 9.40836 11.2905C9.42599 11.2739 9.43822 11.239 9.42039 11.1983C9.39736 11.1457 9.37612 11.0922 9.35677 11.0379C9.33943 10.9892 9.29748 10.9667 9.26605 10.9667C9.05008 10.9667 8.875 10.8017 8.875 10.5981V9.62869C8.875 9.42512 9.05008 9.2601 9.26605 9.2601H9.35387C9.38228 9.2601 9.42025 9.24168 9.44039 9.19803C9.45456 9.16733 9.46934 9.13695 9.48472 9.1069C9.50846 9.06052 9.49543 9.01836 9.47406 8.99821L9.40836 8.93628C9.25564 8.79234 9.25564 8.55896 9.40836 8.41502L10.1356 7.72953C10.2883 7.58558 10.5359 7.58558 10.6887 7.72953L10.7976 7.83217C10.8179 7.85133 10.8592 7.86361 10.9066 7.84532C10.9248 7.83829 10.9432 7.83144 10.9616 7.82478C11.011 7.80687 11.0322 7.76948 11.0322 7.74169V7.59539ZM11.4804 7.64923V7.74169C11.4804 7.96594 11.3224 8.14662 11.1223 8.21911C11.1069 8.22466 11.0917 8.23038 11.0765 8.23624C10.8832 8.31083 10.6442 8.28504 10.4807 8.13088L10.4121 8.0663L9.76565 8.67565L9.79096 8.69951C9.96395 8.86256 9.98407 9.10349 9.88837 9.29045C9.87553 9.31554 9.8632 9.3409 9.85138 9.36651C9.7691 9.54483 9.58226 9.68253 9.35387 9.68253H9.32317V10.5472C9.54283 10.5696 9.71604 10.7194 9.78161 10.9034C9.79775 10.9487 9.81546 10.9933 9.83468 11.0372C9.90637 11.201 9.88983 11.4003 9.76343 11.5491L10.4147 12.163C10.5563 12.0603 10.746 12.053 10.8958 12.1259C10.9883 12.1709 11.0844 12.2101 11.1836 12.243C11.3349 12.2931 11.4543 12.4193 11.4766 12.5776H12.3984C12.4208 12.4193 12.5401 12.2931 12.6914 12.243C12.7906 12.2101 12.8868 12.1709 12.9792 12.1259C13.129 12.053 13.3187 12.0603 13.4603 12.163L14.1116 11.5491C13.9852 11.4003 13.9686 11.201 14.0403 11.0372C14.0596 10.9933 14.0773 10.9487 14.0934 10.9034C14.159 10.7194 14.3322 10.5696 14.5518 10.5472V9.68253H14.5211C14.2928 9.68253 14.1059 9.54483 14.0236 9.36651C14.0118 9.3409 13.9995 9.31554 13.9866 9.29045C13.8909 9.10349 13.9111 8.86255 14.0841 8.6995L14.1094 8.67565L13.4629 8.0663L13.3944 8.13087C13.2308 8.28503 12.9918 8.31083 12.7985 8.23624C12.7833 8.23038 12.7681 8.22466 12.7527 8.2191C12.5526 8.14662 12.3946 7.96594 12.3946 7.74169V7.64923H11.4804Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Integrer = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M13.9657 7.35143V3.47423C13.9657 2.86358 13.5275 2.43179 13.5275 2.43179C13.0894 2 12.4697 2 12.4697 2H2.49605C1.87636 2 1.43818 2.43179 1.43818 2.43179C1 2.86358 1 3.47423 1 3.47423V9.56014C1 10.1708 1.43818 10.6026 1.43818 10.6026C1.87636 11.0344 2.49605 11.0344 2.49605 11.0344H6.98418V12.0172H5.48814C5.21272 12.0172 4.98945 12.2372 4.98945 12.5086C4.98945 12.78 5.21272 13 5.48814 13H9.47759C9.75301 13 9.97627 12.78 9.97627 12.5086C9.97627 12.2372 9.75301 12.0172 9.47759 12.0172H7.98154V11.0344H10.17C10.0595 10.9624 9.90712 10.9214 9.71914 10.9214C9.37896 10.9214 9.10357 10.6529 9.10357 10.3283V10.0515H2.49605C2.28949 10.0515 2.14342 9.90762 2.14342 9.90762C1.99736 9.76369 1.99736 9.56014 1.99736 9.56014V3.47423C1.99736 3.27068 2.14342 3.12675 2.14342 3.12675C2.28949 2.98282 2.49605 2.98282 2.49605 2.98282H12.4697C12.6762 2.98282 12.8223 3.12675 12.8223 3.12675C12.9684 3.27068 12.9684 3.47423 12.9684 3.47423V7.2922C13.1358 7.10324 13.4237 7.0476 13.6523 7.1786L13.9657 7.35143Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.7159 10.0536C11.7159 9.60821 12.0883 9.24718 12.5476 9.24718C13.0069 9.24718 13.3793 9.60821 13.3793 10.0536C13.3793 10.4989 13.0069 10.86 12.5476 10.86C12.0883 10.86 11.7159 10.4989 11.7159 10.0536ZM12.5476 9.68139C12.3356 9.68139 12.1637 9.84802 12.1637 10.0536C12.1637 10.2591 12.3356 10.4258 12.5476 10.4258C12.7596 10.4258 12.9315 10.2591 12.9315 10.0536C12.9315 9.84802 12.7596 9.68139 12.5476 9.68139Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.352 7.97634C12.1907 7.69778 11.8251 7.58222 11.5313 7.7605L11.1475 7.98619C10.8372 8.16855 10.741 8.56624 10.911 8.86868L10.9111 8.86894C10.9904 9.00954 10.973 9.09077 10.9554 9.12206C10.9403 9.14905 10.8903 9.20008 10.7423 9.20008C10.3719 9.20008 10.0952 9.507 10.0952 9.85213V10.255C10.0952 10.6001 10.3719 10.9071 10.7423 10.9071C10.8903 10.9071 10.9403 10.9581 10.9554 10.9851C10.973 11.0164 10.9904 11.0976 10.9111 11.2382L10.911 11.2385C10.741 11.5409 10.837 11.9385 11.1474 12.1209L11.5312 12.3466C11.8251 12.5249 12.1907 12.4094 12.352 12.1308L12.3532 12.1286L12.3777 12.0852C12.4582 11.9423 12.5299 11.9286 12.5484 11.9286C12.5666 11.9286 12.6376 11.9419 12.717 12.0843L12.7175 12.0851L12.742 12.1286L12.7432 12.1308C12.9045 12.4094 13.2701 12.5249 13.564 12.3466L13.9477 12.121C14.2584 11.9385 14.3538 11.5434 14.1847 11.2393L14.1841 11.2382C14.1048 11.0976 14.1222 11.0164 14.1398 10.9851C14.1549 10.9581 14.2049 10.9071 14.3529 10.9071C14.7233 10.9071 15 10.6001 15 10.255V9.85213C15 9.50319 14.7196 9.20008 14.3529 9.20008C14.2049 9.20008 14.1549 9.14905 14.1398 9.12206C14.1222 9.09077 14.1048 9.00954 14.1841 8.86894L14.1842 8.86868C14.3543 8.5662 14.2581 8.16851 13.9477 7.98619L13.5639 7.7605C13.2701 7.58222 12.9045 7.69778 12.7432 7.97634L12.742 7.97854L12.7175 8.02194C12.637 8.16472 12.5653 8.17854 12.5468 8.17854C12.5286 8.17854 12.4576 8.16525 12.3782 8.02282L12.3532 7.97854L12.352 7.97634ZM11.7683 8.1289C11.8258 8.09372 11.913 8.10623 11.9609 8.18798L11.9842 8.22938L11.9845 8.22982C12.1055 8.44658 12.2995 8.61275 12.5468 8.61275C12.7938 8.61275 12.9883 8.4468 13.1105 8.23026L13.1343 8.18798C13.1822 8.10623 13.2694 8.09372 13.3269 8.1289L13.3302 8.13088L13.7156 8.35751C13.8104 8.41324 13.8526 8.55121 13.7911 8.66076C13.6677 8.87952 13.6314 9.12443 13.7463 9.32945C13.8637 9.53882 14.0977 9.63429 14.3529 9.63429C14.4495 9.63429 14.5522 9.72034 14.5522 9.85213V10.255C14.5522 10.386 14.4502 10.4729 14.3529 10.4729C14.0977 10.4729 13.8637 10.5683 13.7463 10.7777C13.6315 10.9825 13.6677 11.2272 13.7907 11.4458C13.853 11.5583 13.8103 11.694 13.7157 11.7496L13.3302 11.9763L13.3269 11.9782C13.2694 12.0134 13.1822 12.0009 13.1343 11.9192L13.111 11.8778L13.1107 11.8774C12.9897 11.6606 12.7957 11.4944 12.5484 11.4944C12.3014 11.4944 12.1069 11.6604 11.9847 11.8769L11.9609 11.9192C11.913 12.0009 11.8258 12.0134 11.7683 11.9782L11.765 11.9763L11.3796 11.7496C11.2848 11.6939 11.2426 11.5559 11.3042 11.4464C11.4275 11.2276 11.4638 10.9827 11.3489 10.7777C11.2315 10.5683 10.9975 10.4729 10.7423 10.4729C10.645 10.4729 10.543 10.386 10.543 10.255V9.85213C10.543 9.72111 10.645 9.63429 10.7423 9.63429C10.9975 9.63429 11.2315 9.53882 11.3489 9.32945C11.4638 9.12442 11.4275 8.87949 11.3041 8.66072C11.2427 8.55117 11.2846 8.4133 11.3795 8.35758L11.765 8.13088L11.7683 8.1289Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Invalide = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.4132 2.08979e-06V0.521741C11.4132 2.08979e-06 11.4132 2.08979e-06 11.4132 2.08979e-06L3.61614 0C2.72314 1.06148e-06 2 0.700395 2 1.56475L2 7.61735C2 7.61738 2 7.61739 2.53892 7.61739L2 7.61735C2 7.80509 2.1042 7.9784 2.27284 8.0711C2.44148 8.1638 2.64857 8.16162 2.8151 8.06541L4.72435 6.96235L6.12173 8.02734C6.31896 8.17765 6.59727 8.17624 6.79286 8.02394L8.10018 7.00593L9.34177 8.01671C9.54055 8.17854 9.83028 8.18008 10.0309 8.02039L11.3502 6.97019L13.1782 8.06148C13.3445 8.16074 13.5532 8.16513 13.7237 8.07296C13.8943 7.98079 14 7.80649 14 7.61739V2.50435C14 2.36915 13.9458 2.23922 13.8488 2.14195L12.8428 1.13326C12.8384 1.12887 12.834 1.12455 12.8294 1.12031L11.7875 0.146401C11.687 0.0524887 11.5528 2.25565e-06 11.4132 2.08979e-06ZM3.61615 1.04348L11.1955 1.04348L12.074 1.86464L12.9222 2.71512V6.68269L11.5883 5.88635C11.3922 5.76931 11.141 5.78582 10.9631 5.92743L9.69249 6.93885L8.45463 5.93112C8.25752 5.77065 7.97069 5.76763 7.77001 5.92389L6.45148 6.95063L5.09982 5.92049C4.9244 5.7868 4.682 5.77166 4.49029 5.88242L3.07784 6.69845L3.07784 1.56475C3.07784 1.27652 3.3186 1.04348 3.61615 1.04348Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.7036 8.54879C11.5182 8.45265 11.292 8.46968 11.1242 8.59241L9.82207 9.5449L8.41929 8.58294C8.22592 8.45034 7.96577 8.45558 7.77826 8.59585L6.50982 9.54476L5.0737 8.58004C4.91391 8.4727 4.70679 8.45704 4.53173 8.53905L2.30419 9.58252C2.11817 9.66966 2 9.85211 2 10.0522V14.4348C2 15.2992 2.72385 16 3.61677 16H12.3832C13.2761 16 14 15.2992 14 14.4348V10.0522C14 9.85983 13.8907 9.68309 13.7156 9.59227L11.7036 8.54879ZM3.07784 14.4348V10.3793L4.71785 9.61108L6.21972 10.62C6.41282 10.7497 6.67049 10.7433 6.85647 10.6041L8.12172 9.65762L9.52083 10.6171C9.71244 10.7485 9.96987 10.7446 10.1572 10.6076L11.4987 9.62632L12.9222 10.3646V14.4348C12.9222 14.7229 12.6809 14.9565 12.3832 14.9565H3.61677C3.31913 14.9565 3.07784 14.7229 3.07784 14.4348Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Iost = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M8.25725 3.57133C8.09891 3.47633 7.9011 3.47633 7.74275 3.57133L4.40942 5.57133C4.25882 5.6617 4.16667 5.82445 4.16667 6.00008C4.16667 6.17571 4.25882 6.33847 4.40942 6.42883L6.15196 7.47435L5.97978 7.64653C5.78452 7.84179 5.78452 8.15837 5.97978 8.35363C6.17504 8.5489 6.49163 8.5489 6.68689 8.35363L7.03584 8.00468L8.23529 8.72435L7.97978 8.97986C7.78452 9.17512 7.78452 9.4917 7.97978 9.68697C8.17504 9.88223 8.49163 9.88223 8.68689 9.68697L9.11918 9.25468L10.3615 10.0001L8 11.417L4.92392 9.57133C4.68713 9.42926 4.38 9.50604 4.23792 9.74283C4.09585 9.97962 4.17263 10.2868 4.40942 10.4288L7.74275 12.4288C7.9011 12.5238 8.09891 12.5238 8.25725 12.4288L11.5906 10.4288C11.7412 10.3385 11.8333 10.1757 11.8333 10.0001C11.8333 9.82445 11.7412 9.6617 11.5906 9.57133L9.84804 8.52581L10.0202 8.35363C10.2155 8.15837 10.2155 7.84179 10.0202 7.64653C9.82496 7.45127 9.50838 7.45127 9.31312 7.64653L8.96416 7.99548L7.76471 7.27581L8.02022 7.0203C8.21548 6.82504 8.21548 6.50846 8.02022 6.31319C7.82496 6.11793 7.50838 6.11793 7.31312 6.31319L6.88083 6.74548L5.63849 6.00008L8 4.58318L11.0761 6.42883C11.3129 6.5709 11.62 6.49412 11.7621 6.25733C11.9042 6.02054 11.8274 5.71341 11.5906 5.57133L8.25725 3.57133Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M13.2396 3.8277L8.93062 1.30858C8.36876 0.941735 7.63124 0.941736 7.06938 1.30858L2.74765 3.83513C2.73917 3.84009 2.73083 3.8453 2.72265 3.85076C2.22019 4.18573 1.83334 4.72658 1.83334 5.40011V10.5334C1.83334 11.1633 2.18302 11.8086 2.76037 12.1059L7.06939 14.625C7.63125 14.9918 8.36875 14.9918 8.93061 14.625L13.2524 12.0984C13.2608 12.0935 13.2692 12.0883 13.2774 12.0828C13.7798 11.7478 14.1667 11.207 14.1667 10.5334V5.40011C14.1667 4.77026 13.817 4.12491 13.2396 3.8277ZM7.61069 2.14947C7.84274 1.99477 8.15727 1.99477 8.38932 2.14947C8.3975 2.15492 8.40584 2.16013 8.41432 2.1651L12.7477 4.69843C12.7571 4.70393 12.7666 4.70912 12.7764 4.71399C12.9895 4.82055 13.1667 5.10244 13.1667 5.40011V10.5334C13.1667 10.7899 13.0239 11.0458 12.734 11.2431L8.41432 13.7685C8.40584 13.7734 8.3975 13.7786 8.38932 13.7841C8.15727 13.9388 7.84274 13.9388 7.61069 13.7841C7.60251 13.7786 7.59417 13.7734 7.58568 13.7685L3.25235 11.2351C3.24294 11.2296 3.23336 11.2244 3.22361 11.2196C3.01051 11.113 2.83334 10.8311 2.83334 10.5334V5.40011C2.83334 5.14363 2.9761 4.88777 3.26604 4.69042L7.58568 2.1651C7.59417 2.16013 7.60251 2.15492 7.61069 2.14947Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Jaime = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.5776 3.2101C10.7611 2.31641 10.1964 1.38807 9.37095 1.10042C8.97053 0.949153 8.5467 0.983018 8.19363 1.10761C7.8417 1.2318 7.50495 1.46549 7.29624 1.78634L7.29564 1.78726L5.29007 4.8504C5.21611 4.60575 5.09415 4.38562 4.9044 4.20581C4.54219 3.86259 4.04286 3.77345 3.5315 3.77345H2.85644C2.34508 3.77345 1.84575 3.86259 1.48354 4.20581C1.11139 4.55846 1 5.06623 1 5.6099V12.4013C1 12.945 1.11139 13.4527 1.48354 13.8054C1.84575 14.1486 2.34508 14.2377 2.85644 14.2377H3.5315C4.04286 14.2377 4.54219 14.1486 4.9044 13.8054C5.05926 13.6586 5.16897 13.485 5.24429 13.2931L6.71011 14.4581C6.93311 14.6732 7.23638 14.8007 7.49343 14.8761C7.77312 14.9581 8.07305 15 8.32447 15H10.8897C11.4161 15 11.9408 14.8 12.3616 14.4839C12.7779 14.1712 13.1273 13.7183 13.2662 13.1706L14.8792 8.13427C15.0951 7.5077 15.0189 6.87535 14.6727 6.39302C14.3276 5.91231 13.7607 5.64451 13.1174 5.64451H10.4172C10.3565 5.64451 10.3103 5.61935 10.2821 5.5865C10.2577 5.55817 10.2302 5.5051 10.243 5.40886L10.5776 3.2101ZM5.38794 12.0927L7.37716 13.6736L7.39985 13.6969C7.44484 13.7431 7.56636 13.8163 7.77162 13.8765C7.96447 13.9331 8.17085 13.9605 8.32447 13.9605H10.8897C11.1734 13.9605 11.4926 13.8486 11.7637 13.645C12.0344 13.4416 12.2217 13.174 12.2887 12.8989L12.2932 12.8806L13.9211 7.79746L13.9233 7.79125C14.0421 7.44978 13.9826 7.18397 13.8575 7.00965C13.73 6.83201 13.4868 6.68401 13.1174 6.68401H10.4172C9.71285 6.68401 9.12858 6.06627 9.2409 5.25916L9.24184 5.25242L9.5819 3.01847L9.5854 3.00231C9.66011 2.65719 9.42136 2.21337 9.04195 2.08354L9.03306 2.0805L9.02428 2.07712C8.88726 2.02437 8.70719 2.02558 8.52281 2.09065C8.33502 2.15691 8.19953 2.26939 8.13817 2.36387L8.13712 2.3655L5.38794 6.56438V12.0927ZM2.0126 5.6099C2.0126 5.18337 2.10373 5.03279 2.17037 4.96964C2.24696 4.89706 2.42269 4.81295 2.85644 4.81295H3.5315C3.96525 4.81295 4.14098 4.89706 4.21757 4.96964C4.28421 5.03279 4.37534 5.18337 4.37534 5.6099V12.4013C4.37534 12.8278 4.28421 12.9784 4.21757 13.0416C4.14098 13.1141 3.96525 13.1982 3.5315 13.1982H2.85644C2.42269 13.1982 2.24696 13.1141 2.17037 13.0416C2.10373 12.9784 2.0126 12.8278 2.0126 12.4013V5.6099Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Journal = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M3.27907 5.56555C3.27907 5.27804 3.49772 5.04498 3.76744 5.04498H5.23256C5.50228 5.04498 5.72093 5.27804 5.72093 5.56555C5.72093 5.85305 5.50228 6.08612 5.23256 6.08612H3.76744C3.49772 6.08612 3.27907 5.85305 3.27907 5.56555Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M3.76744 7.12726C3.49772 7.12726 3.27907 7.36033 3.27907 7.64783C3.27907 7.93534 3.49772 8.1684 3.76744 8.1684H5.72093C5.99065 8.1684 6.2093 7.93534 6.2093 7.64783C6.2093 7.36033 5.99065 7.12726 5.72093 7.12726H3.76744Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2.93503 1.00707C1.87365 0.912444 1 1.77885 1 2.90713V11.2918C1 12.2154 1.6858 13.0642 2.55751 13.1822L2.7435 13.2096L2.74554 13.2099C4.09884 13.4026 6.22276 14.146 7.42056 14.8442C7.42582 14.8473 7.43113 14.8502 7.43649 14.8531L7.45474 14.8628C7.62891 14.9628 7.8245 15 7.99593 15C8.16848 15 8.36877 14.9622 8.54527 14.8552C9.74227 14.1517 11.8673 13.4035 13.2253 13.2103L13.4374 13.1829L13.4392 13.1827C14.3125 13.0663 15 12.2166 15 11.2918V2.91407C15 1.78145 14.1269 0.931228 13.0796 1.01225H13.0595C13.0456 1.01225 13.0317 1.01289 13.0178 1.01416C11.5728 1.14618 9.42074 1.91561 8.19573 2.73722L8.19051 2.74077L8.08759 2.81176C8.0855 2.81279 8.07865 2.81599 8.0661 2.81933C8.04836 2.82404 8.02549 2.82731 8 2.82731C7.97451 2.82731 7.95164 2.82404 7.93391 2.81933C7.92066 2.81581 7.91377 2.81244 7.91211 2.8116L7.74688 2.70593C6.52203 1.89307 4.3797 1.13193 2.93503 1.00707ZM1.97674 2.90713C1.97674 2.38373 2.36594 2.00091 2.85399 2.04463L2.85548 2.04476C4.14425 2.15597 6.13999 2.8648 7.23368 3.59179L7.24083 3.59645L7.40102 3.6989C7.43695 3.72243 7.47395 3.74314 7.51163 3.76125V13.7233C6.18578 13.0337 4.21469 12.3689 2.87598 12.178L2.87492 12.1779L2.68813 12.1504L2.68197 12.1496C2.30502 12.0993 1.97674 11.6997 1.97674 11.2918V2.90713ZM8.48837 13.715C9.81559 13.026 11.7676 12.3667 13.0993 12.1778L13.1049 12.177L13.318 12.1496L13.3188 12.1495C13.6954 12.0988 14.0233 11.6994 14.0233 11.2918V2.91407C14.0233 2.38875 13.6322 2.00743 13.1395 2.05157C13.1259 2.05279 13.1123 2.0534 13.0986 2.0534H13.0809C11.7914 2.17675 9.80641 2.88801 8.71846 3.61672L8.60271 3.69656C8.56563 3.72109 8.52734 3.74252 8.48837 3.76125V13.715Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const KyberNetwork = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.89417 0.94943L12.4183 3.01832C12.9839 3.31088 13.3334 3.95612 13.3334 4.58908V10.9251C13.3334 11.4858 13.059 12.028 12.6181 12.385L12.6116 12.3901C12.6085 12.3925 12.6055 12.3948 12.6023 12.3971L9.04568 14.9891L9.04449 14.99C8.4111 15.4479 7.58894 15.4479 6.95555 14.99L6.95436 14.9891L3.40964 12.4058C3.15701 12.2472 2.97451 12.0031 2.85597 11.7522C2.73428 11.4947 2.66669 11.2027 2.66669 10.9251V4.51708C2.66669 3.84993 3.04486 3.30685 3.5515 2.96498C3.55987 2.95933 3.56846 2.95401 3.57725 2.94903L7.12164 0.939977C7.65579 0.587336 8.3896 0.560953 8.89417 0.94943ZM8.43242 1.58499L8.42498 1.5791C8.42412 1.60275 8.42114 1.62665 8.41589 1.65058L7.18069 7.27673L12.4707 4.316C12.4838 4.3087 12.497 4.30224 12.5105 4.2966C12.4339 4.04125 12.2638 3.8218 12.0582 3.71777C12.051 3.71413 12.0439 3.71027 12.037 3.70618L8.48033 1.61818C8.46357 1.60834 8.44755 1.59724 8.43242 1.58499ZM12.5542 5.17046L7.39432 8.05834L12.5244 11.1612C12.5441 11.0827 12.5542 11.0033 12.5542 10.9251V5.17046ZM12.0761 11.8088L7.163 8.83716L8.25942 14.5094C8.37484 14.4774 8.48691 14.4238 8.59108 14.3486L8.59162 14.3482L12.0761 11.8088ZM6.22369 8.06151C6.22456 8.08279 6.22712 8.10378 6.23128 8.12431L7.43838 14.3691C7.42849 14.3625 7.41866 14.3556 7.40891 14.3486L7.40843 14.3482L3.85296 11.7571C3.84415 11.7507 3.83508 11.7446 3.82577 11.739C3.73065 11.6812 3.63358 11.5701 3.55887 11.412C3.48495 11.2555 3.44584 11.0794 3.44584 10.9251V4.51708C3.44584 4.18014 3.63238 3.86266 3.97183 3.62926L7.5146 1.62113C7.52339 1.61615 7.53198 1.61083 7.54035 1.60517C7.57305 1.58311 7.60655 1.56365 7.64053 1.5467L6.23286 7.95841",
          fill: "currentColor"
        }
      )
    );
  }
);
const Langue = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8 1C8 1 9.42379 1 10.7249 1.55032C10.7249 1.55032 11.9812 2.08169 12.9497 3.05025C12.9497 3.05025 13.9183 4.01882 14.4497 5.27512C14.4497 5.27512 15 6.57621 15 8C15 8 15 9.42378 14.4497 10.7249C14.4497 10.7249 13.9183 11.9812 12.9497 12.9497C12.9497 12.9497 11.9812 13.9183 10.7249 14.4497C10.7249 14.4497 9.42378 15 8 15C8 15 6.57621 15 5.27512 14.4497C5.27512 14.4497 4.01882 13.9183 3.05025 12.9497C3.05025 12.9497 2.08168 11.9812 1.55032 10.7249C1.55032 10.7249 1 9.42379 1 8C1 8 1 6.57621 1.55032 5.27512C1.55032 5.27512 2.08169 4.01882 3.05025 3.05025C3.05025 3.05025 4.01882 2.08169 5.27512 1.55032C5.27512 1.55032 6.57621 1 8 1ZM8 2.07692C8 2.07692 6.7946 2.07692 5.69464 2.54217C5.69464 2.54217 4.63179 2.99171 3.81175 3.81175C3.81175 3.81175 2.99171 4.63179 2.54217 5.69464C2.54217 5.69464 2.07692 6.7946 2.07692 8C2.07692 8 2.07692 9.2054 2.54217 10.3054C2.54217 10.3054 2.99171 11.3682 3.81175 12.1882C3.81175 12.1882 4.63179 13.0083 5.69464 13.4578C5.69464 13.4578 6.7946 13.9231 8 13.9231C8 13.9231 9.2054 13.9231 10.3054 13.4578C10.3054 13.4578 11.3682 13.0083 12.1882 12.1882C12.1882 12.1882 13.0083 11.3682 13.4578 10.3054C13.4578 10.3054 13.9231 9.2054 13.9231 8C13.9231 8 13.9231 6.7946 13.4578 5.69464C13.4578 5.69464 13.0083 4.63179 12.1882 3.81175C12.1882 3.81175 11.3682 2.99171 10.3054 2.54217C10.3054 2.54217 9.2054 2.07692 8 2.07692Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M1.90865 6.38462H14.0913C14.3887 6.38462 14.6298 6.14354 14.6298 5.84615C14.6298 5.54877 14.3887 5.30769 14.0913 5.30769H1.90865C1.61127 5.30769 1.37019 5.54877 1.37019 5.84615C1.37019 6.14354 1.61127 6.38462 1.90865 6.38462Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M1.90865 10.6923H14.0913C14.3887 10.6923 14.6298 10.4512 14.6298 10.1538C14.6298 9.85646 14.3887 9.61538 14.0913 9.61538H1.90865C1.61127 9.61538 1.37019 9.85646 1.37019 10.1538C1.37019 10.4512 1.61127 10.6923 1.90865 10.6923Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8 1.17497C8 1.17497 8.76883 1.17497 9.42634 1.82435C9.42634 1.82435 9.98456 2.37566 10.3987 3.34274C10.3987 3.34274 11.2308 5.28555 11.2308 7.99997C11.2308 7.99997 11.2308 10.7144 10.3987 12.6572C10.3987 12.6572 9.98456 13.6243 9.42634 14.1756C9.42634 14.1756 8.76882 14.825 8 14.825C8 14.825 7.23117 14.825 6.57366 14.1756C6.57366 14.1756 6.01543 13.6243 5.60127 12.6572C5.60127 12.6572 4.76923 10.7144 4.76923 7.99997C4.76923 7.99997 4.76923 5.28555 5.60127 3.34274C5.60127 3.34274 6.01544 2.37567 6.57366 1.82435C6.57366 1.82435 7.23118 1.17497 8 1.17497ZM8 2.2519C8 2.2519 7.67333 2.2519 7.3304 2.59058C7.3304 2.59058 6.92232 2.99361 6.59123 3.7667C6.59123 3.7667 5.84615 5.50646 5.84615 7.99997C5.84615 7.99997 5.84615 10.4935 6.59123 12.2332C6.59123 12.2332 6.92232 13.0063 7.3304 13.4094C7.3304 13.4094 7.67333 13.748 8 13.748C8 13.748 8.32667 13.748 8.6696 13.4094C8.6696 13.4094 9.07768 13.0063 9.40877 12.2332C9.40877 12.2332 10.1538 10.4935 10.1538 7.99997C10.1538 7.99997 10.1538 5.50646 9.40877 3.7667C9.40877 3.7667 9.07768 2.99361 8.6696 2.59058C8.6696 2.59058 8.32667 2.2519 8 2.2519Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Lecture = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M9.82608 5.5H13.4783C13.7664 5.5 14 5.27614 14 5C14 4.72386 13.7664 4.5 13.4783 4.5H10.3478V1.5C10.3478 1.22386 10.1142 1 9.82608 1C9.53793 1 9.30434 1.22386 9.30434 1.5V5C9.30434 5.27614 9.53793 5.5 9.82608 5.5Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M2 2V7.5C2 7.77614 2.23359 8 2.52174 8C2.80989 8 3.04348 7.77614 3.04348 7.5V2H9.60997L12.9565 5.20711V13H11.3913C11.1032 13 10.8696 13.2239 10.8696 13.5C10.8696 13.7761 11.1032 14 11.3913 14H12.9565C13.3887 14 13.6944 13.7071 13.6944 13.7071C14 13.4142 14 13 14 13V5C14 4.86739 13.945 4.74021 13.8472 4.64645L10.195 1.14645C10.0972 1.05268 9.96446 1 9.82608 1H3.04348C2.61126 1 2.30563 1.29289 2.30563 1.29289C2 1.58579 2 2 2 2Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.91303 12.799L7.47825 11.933C7.82608 11.7406 7.82608 11.2594 7.47825 11.067L5.91303 10.201C5.56521 10.0085 5.13042 10.2491 5.13042 10.634V12.366C5.13042 12.7509 5.56521 12.9915 5.91303 12.799ZM7.21738 11.5L5.65216 12.366V10.634L7.21738 11.5Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.82608 11.5C9.82608 13.433 8.19095 15 6.1739 15C4.15686 15 2.52172 13.433 2.52172 11.5C2.52172 9.567 4.15686 8 6.1739 8C8.19095 8 9.82608 9.567 9.82608 11.5ZM8.7826 11.5C8.7826 12.8807 7.61465 14 6.1739 14C4.73316 14 3.5652 12.8807 3.5652 11.5C3.5652 10.1193 4.73316 9 6.1739 9C7.61465 9 8.7826 10.1193 8.7826 11.5Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Link = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M7.38447 8.61704C7.38447 8.61704 7.75327 8.98718 8.23585 9.18758C8.23585 9.18758 8.71842 9.38798 9.24096 9.38798C9.24096 9.38798 9.7635 9.38798 10.2461 9.18758C10.2461 9.18758 10.7286 8.98718 11.0974 8.61704L13.1544 6.56759C13.1544 6.56759 13.8565 5.79047 13.8322 4.74161C13.8322 4.74161 13.8078 3.68604 13.0611 2.93944C13.0611 2.93944 12.3144 2.19284 11.2588 2.1684C11.2588 2.1684 10.2095 2.14411 9.43222 2.84652L7.99687 4.28173C7.88736 4.39123 7.73882 4.45275 7.58394 4.45275C7.42906 4.45275 7.28053 4.39123 7.17101 4.28173C7.06836 4.17908 7.00762 4.04188 7.00065 3.89689C7.0002 3.88754 6.99997 3.87819 6.99997 3.86884C6.99997 3.71398 7.0615 3.56546 7.17101 3.45595L8.61634 2.01077C8.62271 2.0044 8.62923 1.99818 8.63589 1.99211C8.63589 1.99211 9.76222 0.96562 11.2858 1.00089C11.2858 1.00089 12.8094 1.03616 13.887 2.11366C13.887 2.11366 14.9646 3.19117 14.9999 4.71458C14.9999 4.71458 15.0351 6.23799 14.0085 7.36421C14.0022 7.37112 13.9958 7.37788 13.9891 7.38449L11.9248 9.44127C11.9248 9.44127 11.3917 9.97638 10.694 10.2661C10.694 10.2661 9.99638 10.5558 9.24096 10.5558C9.24096 10.5558 8.48554 10.5558 7.78789 10.2661C7.78789 10.2661 7.09023 9.97638 6.55707 9.44127C6.45514 9.33896 6.39473 9.20251 6.38753 9.05828C6.38704 9.04858 6.3868 9.03887 6.3868 9.02916C6.3868 8.87391 6.44863 8.72506 6.55862 8.6155C6.66146 8.51304 6.79879 8.45257 6.94381 8.44587C6.95279 8.44545 6.96178 8.44524 6.97077 8.44524L6.97187 8.44525C7.12674 8.44554 7.27516 8.50733 7.38447 8.61704Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M8.61553 7.38296C8.61553 7.38296 8.24673 7.01282 7.76416 6.81242C7.76416 6.81242 7.28158 6.61202 6.75904 6.61202C6.75904 6.61202 6.23651 6.61202 5.75393 6.81242C5.75393 6.81242 5.27136 7.01282 4.90256 7.38296L2.84563 9.43241C2.84563 9.43241 2.14349 10.2095 2.16777 11.2584C2.16777 11.2584 2.19221 12.314 2.93889 13.0606C2.93889 13.0606 3.68557 13.8072 4.74125 13.8316C4.74125 13.8316 5.79046 13.8559 6.56778 13.1535L8.00313 11.7183C8.11265 11.6088 8.26118 11.5473 8.41606 11.5473C8.57094 11.5473 8.71947 11.6088 8.82899 11.7183C8.9385 11.8278 9.00003 11.9763 9.00003 12.1312C9.00003 12.286 8.9382 12.4348 8.82869 12.5444L7.38366 13.9892C7.37729 13.9956 7.37077 14.0018 7.36411 14.0079C7.36411 14.0079 6.23778 15.0344 4.71421 14.9991C4.71421 14.9991 3.19065 14.9638 2.11303 13.8863C2.11303 13.8863 1.03542 12.8088 1.00015 11.2854C1.00015 11.2854 0.964874 9.76201 1.99146 8.6358C1.99777 8.62888 2.00423 8.62212 2.01086 8.61552L4.07516 6.55873C4.07516 6.55873 4.60832 6.02362 5.30597 5.73391C5.30597 5.73391 6.00362 5.4442 6.75904 5.4442C6.75904 5.4442 7.51447 5.4442 8.21212 5.73391C8.21212 5.73391 8.90977 6.02362 9.44293 6.55873C9.54539 6.66157 9.60588 6.79888 9.61258 6.94389C9.61299 6.95287 9.6132 6.96186 9.6132 6.97085L9.6132 6.97194C9.61291 7.1268 9.55111 7.27521 9.44139 7.38451C9.33907 7.48643 9.2026 7.54683 9.05835 7.55403C9.04865 7.55452 9.03894 7.55476 9.02923 7.55476C8.87397 7.55476 8.72511 7.49294 8.61553 7.38296Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Link2 = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M6.27182 4.48144C6.27182 4.33477 6.3303 4.1939 6.43401 4.09019L8.3901 2.13408C8.3901 2.13408 9.52418 1 11.128 1C11.128 1 12.7318 1 13.8659 2.13409C13.8659 2.13409 15 3.26817 15 4.87201C15 4.87201 15 6.47585 13.8659 7.60993L11.9096 9.56624C11.8059 9.66995 11.6652 9.72822 11.5186 9.72822C11.3719 9.72822 11.2312 9.66995 11.1275 9.56624C11.0238 9.46253 10.9656 9.32187 10.9656 9.1752C10.9656 9.02853 11.0238 8.88786 11.1275 8.78415L13.0838 6.82784C13.0838 6.82784 13.894 6.01771 13.894 4.87201C13.894 4.87201 13.894 3.72631 13.0838 2.91617C13.0838 2.91617 12.2737 2.10604 11.128 2.10604C11.128 2.10604 9.98231 2.10604 9.17218 2.91617L7.21588 4.87248C7.11217 4.97619 6.97151 5.03446 6.82484 5.03446C6.67817 5.03446 6.53751 4.97619 6.4338 4.87248C6.33659 4.77527 6.27907 4.64533 6.27246 4.508C6.27204 4.49915 6.27182 4.4903 6.27182 4.48144Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M10.7344 6.04067C10.838 5.93698 10.8964 5.79616 10.8964 5.64964C10.8963 5.50297 10.8379 5.36194 10.7341 5.2583C10.6305 5.15477 10.4899 5.09662 10.3434 5.09662C10.1967 5.09672 10.0557 5.15509 9.95206 5.25888L5.26539 9.95248C5.16186 10.0562 5.10355 10.1969 5.10355 10.3434C5.10366 10.4901 5.16202 10.6311 5.26581 10.7347C5.3695 10.8383 5.51004 10.8964 5.65657 10.8964C5.80324 10.8963 5.94426 10.8379 6.0479 10.7341L10.7344 6.04067Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M4.87226 7.21605C4.97597 7.11234 5.03444 6.97147 5.03444 6.8248C5.03444 6.67813 4.97617 6.53747 4.87246 6.43376C4.76875 6.33005 4.62809 6.27178 4.48142 6.27178C4.33475 6.27178 4.19409 6.33005 4.09038 6.43376L2.13408 8.39007C1 9.52415 1 11.128 1 11.128C1 12.7318 2.13408 13.8659 2.13408 13.8659C3.26816 15 4.87199 15 4.87199 15C5.64218 15 6.35374 14.7053 6.35374 14.7053C7.06529 14.4105 7.6099 13.8659 7.6099 13.8659L9.5662 11.9096C9.66991 11.8059 9.72817 11.6652 9.72817 11.5186C9.72817 11.3719 9.66991 11.2312 9.5662 11.1275C9.46249 11.0238 9.32183 10.9655 9.17516 10.9655C9.02849 10.9655 8.88783 11.0238 8.78411 11.1275L6.82782 13.0838C6.43878 13.4729 5.93047 13.6834 5.93047 13.6834C5.42217 13.894 4.87199 13.894 4.87199 13.894C3.72629 13.894 2.91616 13.0838 2.91616 13.0838C2.10603 12.2737 2.10603 11.128 2.10603 11.128C2.10603 9.98229 2.91616 9.17216 2.91616 9.17216L4.87226 7.21605Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Liste = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M2 4C2.55228 4 3 3.55228 3 3C3 2.44772 2.55228 2 2 2C1.44772 2 1 2.44772 1 3C1 3.55228 1.44772 4 2 4Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M5 2C4.44772 2 4 2.44772 4 3C4 3.55228 4.44772 4 5 4H14C14.5523 4 15 3.55228 15 3C15 2.44772 14.5523 2 14 2H5Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M5 7C4.44772 7 4 7.44772 4 8C4 8.55228 4.44772 9 5 9H14C14.5523 9 15 8.55228 15 8C15 7.44772 14.5523 7 14 7H5Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M4 13C4 12.4477 4.44772 12 5 12H14C14.5523 12 15 12.4477 15 13C15 13.5523 14.5523 14 14 14H5C4.44772 14 4 13.5523 4 13Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M3 8C3 8.55228 2.55228 9 2 9C1.44772 9 1 8.55228 1 8C1 7.44772 1.44772 7 2 7C2.55228 7 3 7.44772 3 8Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M2 14C2.55228 14 3 13.5523 3 13C3 12.4477 2.55228 12 2 12C1.44772 12 1 12.4477 1 13C1 13.5523 1.44772 14 2 14Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Litecoin = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.85188 4.13154C6.91239 3.9157 7.10916 3.76652 7.33331 3.76652H9.39998C9.55525 3.76652 9.70171 3.83866 9.79635 3.96175C9.891 4.08484 9.92309 4.24491 9.8832 4.39497L9.19591 6.98049L9.90436 6.84248C10.1754 6.78968 10.4379 6.9666 10.4907 7.23765C10.5435 7.50869 10.3666 7.77122 10.0956 7.82403L8.9103 8.05492L8.65025 9.03319H10.8C10.948 9.03319 11.0884 9.09874 11.1834 9.21221C11.2784 9.32568 11.3182 9.4754 11.2922 9.62108L10.9589 11.4877C10.9163 11.7262 10.7089 11.8999 10.4666 11.8999H5.33331C5.17685 11.8999 5.02941 11.8266 4.93488 11.7019C4.84036 11.5773 4.80964 11.4155 4.85188 11.2649L5.56939 8.70575L4.96224 8.82403C4.6912 8.87683 4.42866 8.6999 4.37586 8.42886C4.32306 8.15781 4.49999 7.89528 4.77103 7.84248L5.87153 7.62809L6.85188 4.13154ZM8.7497 4.76652L8.10467 7.19307L6.9701 7.41409L7.71241 4.76652H8.7497ZM5.99278 10.8999L6.66795 8.49175L7.81906 8.2675L7.51676 9.40474C7.47687 9.5548 7.50896 9.71487 7.6036 9.83796C7.69825 9.96105 7.84471 10.0332 7.99998 10.0332H10.2028L10.048 10.8999H5.99278Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.99998 0.833252C4.04194 0.833252 0.833313 4.04188 0.833313 7.99992C0.833313 11.958 4.04194 15.1666 7.99998 15.1666C11.958 15.1666 15.1666 11.958 15.1666 7.99992C15.1666 4.04188 11.958 0.833252 7.99998 0.833252ZM1.83331 7.99992C1.83331 4.59416 4.59422 1.83325 7.99998 1.83325C11.4057 1.83325 14.1666 4.59416 14.1666 7.99992C14.1666 11.4057 11.4057 14.1666 7.99998 14.1666C4.59422 14.1666 1.83331 11.4057 1.83331 7.99992Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Localisation = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8 4C8 4 9.12967 4 9.92847 4.73223C9.92847 4.73223 10.7273 5.46447 10.7273 6.5C10.7273 6.5 10.7273 7.53553 9.92847 8.26777C9.92847 8.26777 9.12967 9 8 9C8 9 6.87033 9 6.07153 8.26777C6.07153 8.26777 5.27273 7.53553 5.27273 6.5C5.27273 6.5 5.27273 5.46447 6.07153 4.73223C6.07153 4.73223 6.87033 4 8 4ZM8 5C8 5 7.3222 5 6.84292 5.43934C6.84292 5.43934 6.36364 5.87868 6.36364 6.5C6.36364 6.5 6.36364 7.12132 6.84292 7.56066C6.84292 7.56066 7.3222 8 8 8C8 8 8.6778 8 9.15708 7.56066C9.15708 7.56066 9.63636 7.12132 9.63636 6.5C9.63636 6.5 9.63636 5.87868 9.15708 5.43934C9.15708 5.43934 8.6778 5 8 5Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M13.5433 4.39524C13.5433 4.39524 14 5.40598 14 6.5C14 6.5 14 9.49949 11.1389 12.5156C11.1389 12.5156 10.2596 13.4425 9.20554 14.2638C9.20554 14.2638 8.67467 14.6774 8.3128 14.9096C8.12499 15.0301 7.87501 15.0301 7.6872 14.9096C7.6872 14.9096 7.32533 14.6774 6.79447 14.2638C6.79447 14.2638 5.74039 13.4425 4.86112 12.5156C4.86112 12.5156 2 9.49949 2 6.5C2 6.5 2 5.40598 2.45672 4.39524C2.45672 4.39524 2.91345 3.3845 3.75736 2.61091C3.75736 2.61091 4.60127 1.83733 5.7039 1.41866C5.7039 1.41866 6.80653 1 8 1C8 1 9.19347 1 10.2961 1.41866C10.2961 1.41866 11.3987 1.83732 12.2426 2.61091C12.2426 2.61091 13.0866 3.3845 13.5433 4.39524ZM12.9091 6.5C12.9091 6.5 12.9091 5.6049 12.5354 4.77792C12.5354 4.77792 12.1617 3.95096 11.4713 3.31802C11.4713 3.31802 10.7808 2.68508 9.87863 2.34254C9.87863 2.34254 8.97648 2 8 2C8 2 7.02352 2 6.12137 2.34254C6.12137 2.34254 5.21922 2.68508 4.52875 3.31802C4.52875 3.31802 3.83827 3.95095 3.46459 4.77792C3.46459 4.77792 3.09091 5.60489 3.09091 6.5C3.09091 6.5 3.09091 9.12551 5.68433 11.8594C5.68433 11.8594 6.5096 12.7294 7.50099 13.5018C7.50099 13.5018 7.77771 13.7175 8 13.8767C8 13.8767 8.22229 13.7175 8.49901 13.5018C8.49901 13.5018 9.4904 12.7294 10.3157 11.8594C10.3157 11.8594 12.9091 9.12551 12.9091 6.5Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Login = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8 8.42967C9.26733 8.42967 10.2947 7.38538 10.2947 6.09719C10.2947 4.80899 9.26733 3.76471 8 3.76471C6.73267 3.76471 5.70529 4.80899 5.70529 6.09719C5.70529 7.38538 6.73267 8.42967 8 8.42967ZM8 7.26343C8.63367 7.26343 9.14735 6.74128 9.14735 6.09719C9.14735 5.45309 8.63367 4.93095 8 4.93095C7.36633 4.93095 6.85265 5.45309 6.85265 6.09719C6.85265 6.74128 7.36633 7.26343 8 7.26343Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.2995 8.51105C4.84137 8.89562 3.76471 10.2424 3.76471 11.8449C3.76471 12.3204 4.14395 12.7059 4.61177 12.7059H11.3882C11.8561 12.7059 12.2353 12.3204 12.2353 11.8449C12.2353 10.2424 11.1586 8.89562 9.7005 8.51105C9.2209 8.85868 8.63395 9.06318 8 9.06318C7.36605 9.06318 6.7791 8.85868 6.2995 8.51105ZM11.068 11.5396C10.9664 10.7694 10.4859 10.1198 9.82256 9.7933C9.2735 10.0723 8.65386 10.2294 8 10.2294C7.34614 10.2294 6.7265 10.0723 6.17744 9.7933C5.51412 10.1198 5.0336 10.7694 4.93203 11.5396H11.068Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM14.5882 8C14.5882 11.6386 11.6386 14.5882 8 14.5882C4.36142 14.5882 1.41176 11.6386 1.41176 8C1.41176 4.36142 4.36142 1.41176 8 1.41176C11.6386 1.41176 14.5882 4.36142 14.5882 8Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Loupe = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.3584 12.0979C9.54967 12.4809 8.64693 12.6949 7.69471 12.6949C4.22474 12.6949 1.41177 9.85308 1.41177 6.34747C1.41177 2.84186 4.22474 0 7.69471 0C11.1647 0 13.9777 2.84186 13.9777 6.34747C13.9777 8.16146 13.2245 9.79773 12.0168 10.9545C12.025 10.9654 12.0331 10.9766 12.041 10.988L14.4064 14.4019C14.7248 14.8614 14.6142 15.4947 14.1594 15.8163C13.7045 16.138 13.0777 16.0262 12.7593 15.5667L10.3939 12.1528C10.3814 12.1347 10.3695 12.1165 10.3584 12.0979ZM11.9671 6.34747C11.9671 8.73128 10.0543 10.6637 7.69471 10.6637C5.33513 10.6637 3.42231 8.73128 3.42231 6.34747C3.42231 3.96365 5.33513 2.03119 7.69471 2.03119C10.0543 2.03119 11.9671 3.96365 11.9671 6.34747Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Mail = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2 3C1.44772 3 1 3.44772 1 4V11C1 11.5523 1.44772 12 2 12H14C14.5523 12 15 11.5523 15 11V4C15 3.44772 14.5523 3 14 3H2ZM13.2795 4H2.72047L8 7.7711L13.2795 4ZM14 4.71429L8.40687 8.70938C8.28435 8.7969 8.13579 8.82122 8 8.78882C7.86421 8.82122 7.71565 8.7969 7.59313 8.70938L2 4.71429V11H14V4.71429Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Maintenance = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.71023 14.3387L8.21401 10.2765C9.39817 10.8078 10.7184 10.6577 10.7184 10.6577C12.2614 10.4822 13.4146 9.44139 13.4146 9.44139C14.5677 8.4006 14.9007 6.88283 14.9007 6.88283C15.2337 5.36507 14.6223 3.93664 14.6223 3.93664C14.5953 3.87336 14.5563 3.81586 14.5076 3.76724C14.4065 3.66627 14.2694 3.60964 14.1265 3.60981C13.9836 3.60998 13.8467 3.66694 13.7458 3.76815L11.1285 6.39329L9.85735 6.1371L9.60133 4.86515L12.2248 2.24626C12.2735 2.19764 12.3125 2.14014 12.3396 2.07686C12.4567 1.80319 12.3299 1.48633 12.0564 1.36913C10.6289 0.757366 9.11209 1.09058 9.11209 1.09058C7.59527 1.4238 6.55513 2.57767 6.55513 2.57767C5.51499 3.73153 5.33963 5.27551 5.33963 5.27551C5.18959 6.59657 5.72054 7.78147 5.72054 7.78147L1.6609 11.2875C1.65093 11.2961 1.64128 11.305 1.63196 11.3144C1 11.9467 1 12.841 1 12.841C1 13.7353 1.63196 14.3676 1.63196 14.3676C2.26392 15 3.15764 15 3.15764 15C4.05137 15 4.68333 14.3676 4.68333 14.3676C4.69265 14.3583 4.70162 14.3487 4.71023 14.3387ZM8.34267 9.13603C9.3975 9.72283 10.5967 9.58645 10.5967 9.58645C11.7964 9.45003 12.6929 8.64085 12.6929 8.64085C13.5894 7.83166 13.8484 6.65165 13.8484 6.65165C14.0149 5.89263 13.8776 5.16234 13.8776 5.16234L11.687 7.35957C11.5595 7.48751 11.3763 7.54298 11.1993 7.50729L9.29358 7.12322C9.08091 7.08036 8.91468 6.91403 8.87185 6.70122L8.48802 4.79434C8.45236 4.61718 8.50779 4.43392 8.63565 4.30629L10.8315 2.1143C10.1017 1.97696 9.34313 2.1436 9.34313 2.1436C8.16385 2.40267 7.35517 3.29976 7.35517 3.29976C6.5465 4.19685 6.41016 5.39725 6.41016 5.39725C6.27382 6.59764 6.86069 7.65344 6.86069 7.65344C6.98482 7.87674 6.93521 8.15658 6.74189 8.32353L2.38117 12.0895C2.07742 12.4023 2.07742 12.841 2.07742 12.841C2.07742 13.2887 2.39381 13.6053 2.39381 13.6053C2.7102 13.9219 3.15764 13.9219 3.15764 13.9219C3.59605 13.9219 3.90865 13.618 3.90865 13.618L7.67229 9.25451C7.74094 9.17493 7.83134 9.11717 7.93237 9.08834C8.06977 9.04913 8.2171 9.06614 8.34196 9.13563L8.34267 9.13603Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Maker = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M4.1529 5.89858C4.30923 5.80971 4.50124 5.81163 4.65576 5.9036L7.45576 7.57027C7.60721 7.66042 7.70001 7.82366 7.70001 7.99992V9.66658C7.70001 9.94273 7.47616 10.1666 7.20001 10.1666C6.92387 10.1666 6.70001 9.94273 6.70001 9.66658V8.28417L4.90001 7.21274V9.66658C4.90001 9.94273 4.67616 10.1666 4.40001 10.1666C4.12387 10.1666 3.90001 9.94273 3.90001 9.66658V6.33325C3.90001 6.15343 3.99658 5.98746 4.1529 5.89858Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M12.1 6.33325C12.1 6.15343 12.0035 5.98746 11.8471 5.89858C11.6908 5.80971 11.4988 5.81163 11.3443 5.9036L8.54428 7.57027C8.39282 7.66042 8.30002 7.82366 8.30002 7.99992V9.66658C8.30002 9.94273 8.52388 10.1666 8.80002 10.1666C9.07616 10.1666 9.30002 9.94273 9.30002 9.66658V8.28417L11.1 7.21274V9.66658C11.1 9.94273 11.3239 10.1666 11.6 10.1666C11.8762 10.1666 12.1 9.94273 12.1 9.66658V6.33325Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0.833344 7.99992C0.833344 4.04188 4.04197 0.833252 8.00001 0.833252C11.9581 0.833252 15.1667 4.04188 15.1667 7.99992C15.1667 11.958 11.9581 15.1666 8.00001 15.1666C4.04197 15.1666 0.833344 11.958 0.833344 7.99992ZM8.00001 1.83325C4.59425 1.83325 1.83334 4.59416 1.83334 7.99992C1.83334 11.4057 4.59425 14.1666 8.00001 14.1666C11.4058 14.1666 14.1667 11.4057 14.1667 7.99992C14.1667 4.59416 11.4058 1.83325 8.00001 1.83325Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Message$1 = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2.68321 14.8533L4.8565 12.9892L4.92752 12.9637H14.0171C14.0171 12.9637 14.4703 12.9637 14.7907 12.6361C14.7907 12.6361 15.1111 12.3084 15.1111 11.8451V2.89642C15.1111 2.89642 15.1111 2.43308 14.7907 2.10546C14.7907 2.10546 14.4703 1.77783 14.0171 1.77783H1.98293C1.98293 1.77783 1.52978 1.77783 1.20935 2.10546C1.20935 2.10546 0.888916 2.43308 0.888916 2.89642L0.888933 14.0028C0.888933 14.0028 0.891443 14.3266 1.06273 14.5989C1.06273 14.5989 1.23401 14.8713 1.5211 15.008C1.5211 15.008 1.80819 15.1447 2.1223 15.1034C2.1223 15.1034 2.4364 15.0622 2.68321 14.8533ZM4.65289 11.8767C4.71115 11.8558 4.77246 11.8451 4.83422 11.8451H14.0171V2.89642H1.98293L1.98291 13.9939L4.22966 12.0668C4.28011 12.0235 4.33778 11.9899 4.3999 11.9676L4.65289 11.8767Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M5.81199 6.81146H10.1881C10.4902 6.81146 10.7351 6.56106 10.7351 6.25217C10.7351 5.94328 10.4902 5.69288 10.1881 5.69288H5.81199C5.50989 5.69288 5.26498 5.94328 5.26498 6.25217C5.26498 6.56106 5.50989 6.81146 5.81199 6.81146Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M5.81199 9.04863H10.1881C10.4902 9.04863 10.7351 8.79823 10.7351 8.48934C10.7351 8.18045 10.4902 7.93005 10.1881 7.93005H5.81199C5.50989 7.93005 5.26498 8.18045 5.26498 8.48934C5.26498 8.79823 5.50989 9.04863 5.81199 9.04863Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Mobilite_bancaire = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.53333 3C6.84813 3 6.22667 3.47536 6.22667 4.13333C6.22667 4.79131 6.84813 5.26667 7.53333 5.26667C8.21854 5.26667 8.84 4.79131 8.84 4.13333C8.84 3.47536 8.21854 3 7.53333 3ZM7.09778 4.13333C7.09778 3.98129 7.25633 3.8 7.53333 3.8C7.81033 3.8 7.96889 3.98129 7.96889 4.13333C7.96889 4.28538 7.81033 4.46667 7.53333 4.46667C7.25633 4.46667 7.09778 4.28538 7.09778 4.13333Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.3244 6.6H12.4987C13.0674 6.6 13.4859 6.15502 13.4859 5.66128V3.87272C13.4859 3.6834 13.415 3.50377 13.3169 3.36157C13.2193 3.22029 13.0702 3.08054 12.8733 3.00362L7.90793 1.06423C7.78177 1.01496 7.64443 1 7.53333 1C7.42223 1 7.2849 1.01496 7.15874 1.06423L2.19341 3.00362C1.99646 3.08054 1.84735 3.22029 1.74981 3.36157C1.65165 3.50377 1.58074 3.6834 1.58074 3.87272V5.66128C1.58074 6.15502 1.99923 6.6 2.568 6.6H2.74222V9.4H2.568C2.02947 9.4 1.58074 9.79911 1.58074 10.3V11.4H1.43556C1.195 11.4 1 11.5791 1 11.8C1 12.0209 1.195 12.2 1.43556 12.2H8.18312C8.10256 11.9435 8.04714 11.6759 8.01975 11.4H2.45185V10.3C2.45185 10.2509 2.49966 10.2 2.568 10.2H8.08001C8.1365 9.92176 8.22186 9.654 8.33284 9.4H7.96889V6.6H9.27556V8.07126C9.53596 7.82891 9.82873 7.62087 10.1467 7.45434V6.6H11.4533V7.03705C11.6321 7.01262 11.8146 7 12 7C12.1092 7 12.2174 7.00438 12.3244 7.01297V6.6ZM7.49266 1.80315L2.5355 3.73935C2.5355 3.73935 2.52975 3.74249 2.52187 3.7491C2.51083 3.75836 2.49781 3.77213 2.48553 3.78992C2.45818 3.82954 2.45185 3.86271 2.45185 3.87272V5.66128C2.45185 5.70601 2.47044 5.7431 2.49564 5.76771C2.5205 5.79198 2.54652 5.8 2.568 5.8H12.4987C12.5201 5.8 12.5462 5.79198 12.571 5.76771C12.5962 5.7431 12.6148 5.70601 12.6148 5.66128V3.87272C12.6148 3.86271 12.6085 3.82954 12.5811 3.78992C12.5689 3.77213 12.5558 3.75836 12.5448 3.7491C12.5369 3.74248 12.5312 3.73935 12.5312 3.73935L7.57401 1.80315L7.57029 1.80252C7.56137 1.80114 7.54844 1.8 7.53333 1.8C7.51822 1.8 7.5053 1.80114 7.49638 1.80252L7.49266 1.80315ZM7.09778 6.6H5.79111V9.4H7.09778V6.6ZM3.61333 6.6H4.92V9.4H3.61333V6.6Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M12 8.66667C10.7023 8.66667 9.66667 9.71123 9.66667 11C9.66667 11.1841 9.51743 11.3333 9.33333 11.3333C9.14924 11.3333 9 11.1841 9 11C9 9.34478 10.3324 8 12 8C12.9883 8 13.7279 8.41333 14.2139 8.8187C14.2555 8.85341 14.2953 8.88812 14.3333 8.92257V8.48267C14.3333 8.29857 14.4826 8.14933 14.6667 8.14933C14.8508 8.14933 15 8.29857 15 8.48267V9.816C15 10.0001 14.8508 10.1493 14.6667 10.1493H13.4827C13.2986 10.1493 13.1493 10.0001 13.1493 9.816C13.1493 9.63191 13.2986 9.48267 13.4827 9.48267H13.9565C13.9046 9.43278 13.848 9.3817 13.7868 9.33063C13.3841 8.99467 12.7904 8.66667 12 8.66667Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M14.6667 10.6667C14.8508 10.6667 15 10.8159 15 11C15 12.6561 13.6561 14 12 14C11.1482 14 10.4789 13.5715 10.0387 13.1722C10.0127 13.1486 9.98732 13.125 9.96267 13.1015V13.5173C9.96267 13.7014 9.81343 13.8507 9.62933 13.8507C9.44524 13.8507 9.296 13.7014 9.296 13.5173V12.184C9.296 11.9999 9.44524 11.8507 9.62933 11.8507H10.8347C11.0188 11.8507 11.168 11.9999 11.168 12.184C11.168 12.3681 11.0188 12.5173 10.8347 12.5173H10.3205C10.3716 12.5702 10.427 12.6243 10.4866 12.6784C10.8638 13.0205 11.3798 13.3333 12 13.3333C13.2879 13.3333 14.3333 12.2879 14.3333 11C14.3333 10.8159 14.4826 10.6667 14.6667 10.6667Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Monero = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.99999 0.833252C4.04195 0.833252 0.833328 4.04188 0.833328 7.99992C0.833328 11.958 4.04195 15.1666 7.99999 15.1666C11.958 15.1666 15.1667 11.958 15.1667 7.99992C15.1667 4.04188 11.958 0.833252 7.99999 0.833252ZM1.83333 7.99992C1.83333 4.59416 4.59424 1.83325 7.99999 1.83325C11.4058 1.83325 14.1667 4.59416 14.1667 7.99992C14.1667 8.51812 14.1027 9.0214 13.9824 9.5023C13.9662 9.50072 13.9499 9.49992 13.9333 9.49992H11.8333V5.99992C11.8333 5.78941 11.7015 5.60145 11.5035 5.52978C11.3056 5.45812 11.084 5.51811 10.9492 5.67983L7.99998 9.21889L5.05076 5.67983C4.91599 5.51811 4.69437 5.45812 4.49643 5.52978C4.2985 5.60145 4.16665 5.78941 4.16665 5.99992V9.49992H2.06665C2.05011 9.49992 2.03376 9.50072 2.01763 9.50229C1.89725 9.0214 1.83333 8.51812 1.83333 7.99992ZM2.36113 10.4999C3.32025 12.66 5.48419 14.1666 7.99999 14.1666C10.5158 14.1666 12.6797 12.66 13.6389 10.4999H11.3333C11.0572 10.4999 10.8333 10.2761 10.8333 9.99992V7.38094L8.38409 10.32C8.28909 10.434 8.14837 10.4999 7.99998 10.4999C7.85159 10.4999 7.71086 10.434 7.61587 10.32L5.16665 7.38094V9.99992C5.16665 10.2761 4.94279 10.4999 4.66665 10.4999H2.36113Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Montant1 = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.13333 3C6.13333 3 8.16649 3 9.62467 3.63914C9.62467 3.63914 10.3554 3.95942 10.7733 4.39251C10.7733 4.39251 11.2667 4.90377 11.2667 5.5C11.2667 5.5 11.2667 6.09623 10.7733 6.60749C10.7733 6.60749 10.3554 7.04058 9.62467 7.36087C9.62467 7.36087 8.1665 8 6.13333 8C6.13333 8 4.10017 8 2.642 7.36086C2.642 7.36086 1.91128 7.04058 1.49336 6.60749C1.49336 6.60749 1 6.09623 1 5.5C1 5.5 1 4.90377 1.49336 4.39251C1.49336 4.39251 1.91128 3.95942 2.642 3.63914C2.642 3.63914 4.10017 3 6.13333 3ZM6.13333 3.90909C6.13333 3.90909 4.3005 3.90909 3.025 4.46816C3.025 4.46816 2.46395 4.71407 2.17344 5.01513C2.17344 5.01513 1.93333 5.26394 1.93333 5.5C1.93333 5.5 1.93333 5.73606 2.17344 5.98487C2.17344 5.98487 2.46395 6.28593 3.025 6.53184C3.025 6.53184 4.3005 7.09091 6.13333 7.09091C6.13333 7.09091 7.96617 7.09091 9.24166 6.53185C9.24166 6.53185 9.80272 6.28593 10.0932 5.98487C10.0932 5.98487 10.3333 5.73606 10.3333 5.5C10.3333 5.5 10.3333 5.26394 10.0932 5.01513C10.0932 5.01513 9.80272 4.71407 9.24166 4.46816C9.24166 4.46816 7.96617 3.90909 6.13333 3.90909Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M11.2667 7.77273V5.5C11.2667 5.24896 11.0577 5.04545 10.8 5.04545C10.5423 5.04545 10.3333 5.24896 10.3333 5.5V7.77273C10.3333 8.00923 10.0933 8.25811 10.0933 8.25811C9.80295 8.55914 9.24207 8.80494 9.24207 8.80494C7.96716 9.36364 6.13333 9.36364 6.13333 9.36364C4.2995 9.36364 3.0246 8.80494 3.0246 8.80494C2.46371 8.55914 2.17338 8.25811 2.17338 8.25811C1.93333 8.00923 1.93333 7.77273 1.93333 7.77273V5.5C1.93333 5.24896 1.7244 5.04545 1.46667 5.04545C1.20893 5.04545 1 5.24896 1 5.5V7.77273C1 8.36926 1.49313 8.88056 1.49313 8.88056C1.91096 9.31377 2.64165 9.63398 2.64165 9.63398C4.09921 10.2727 6.13333 10.2727 6.13333 10.2727C8.16745 10.2727 9.62501 9.63398 9.62501 9.63398C10.3557 9.31377 10.7735 8.88056 10.7735 8.88056C11.2667 8.36926 11.2667 7.77273 11.2667 7.77273Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M3.8 7.375V9.64773C3.8 9.89877 4.00893 10.1023 4.26667 10.1023C4.5244 10.1023 4.73333 9.89877 4.73333 9.64773V7.375C4.73333 7.12396 4.5244 6.92045 4.26667 6.92045C4.00893 6.92045 3.8 7.12396 3.8 7.375Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M10.8446 5.76914C12.5512 5.92417 13.6882 6.5269 13.6882 6.5269C15 7.22233 15 8.22728 15 8.22728C15 8.82382 14.5069 9.33511 14.5069 9.33511C14.089 9.76833 13.3583 10.0885 13.3583 10.0885C11.9008 10.7273 9.86667 10.7273 9.86667 10.7273C8.08879 10.7273 6.70042 10.2217 6.70042 10.2217L6.69915 10.2213C6.58323 10.179 6.48912 10.0936 6.43781 9.98388C6.41241 9.92956 6.39824 9.8709 6.39611 9.81124C6.39593 9.80599 6.39583 9.80073 6.39583 9.79547C6.39583 9.74108 6.40585 9.68714 6.42542 9.6362C6.49249 9.46157 6.66225 9.34454 6.85364 9.341L6.8625 9.34092C6.91834 9.34092 6.97372 9.35068 7.02601 9.36974C8.25674 9.81819 9.86667 9.81819 9.86667 9.81819C11.7005 9.81819 12.9754 9.25949 12.9754 9.25949C13.5363 9.0137 13.8266 8.71267 13.8266 8.71267C14.0667 8.46378 14.0667 8.22728 14.0667 8.22728C14.0667 7.76256 13.242 7.32539 13.242 7.32539C12.2732 6.81178 10.7567 6.67419 10.7567 6.67419C10.5168 6.65242 10.3333 6.45631 10.3333 6.2216C10.3333 6.20797 10.334 6.19434 10.3352 6.18076L10.3353 6.17944C10.3454 6.07391 10.3931 5.97513 10.47 5.90019C10.4802 5.89024 10.4909 5.88075 10.502 5.87176C10.5858 5.80409 10.6912 5.76706 10.8 5.76706C10.814 5.76706 10.828 5.76767 10.8419 5.7689L10.8433 5.76902L10.8446 5.76914Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M15 10.5V8.22728C15 7.97625 14.7911 7.77273 14.5333 7.77273C14.2756 7.77273 14.0667 7.97625 14.0667 8.22728V10.5C14.0667 10.7365 13.8266 10.9854 13.8266 10.9854C13.5363 11.2864 12.9754 11.5322 12.9754 11.5322C11.7005 12.0909 9.86667 12.0909 9.86667 12.0909C8.03284 12.0909 6.75793 11.5322 6.75793 11.5322C6.19705 11.2864 5.90671 10.9854 5.90671 10.9854C5.66667 10.7365 5.66667 10.5 5.66667 10.5L5.66667 9.77841C5.66667 9.52737 5.45773 9.32386 5.2 9.32386C4.94227 9.32386 4.73333 9.52737 4.73333 9.77841L4.73333 10.5C4.73333 11.0965 5.22647 11.6078 5.22647 11.6078C5.64429 12.041 6.37499 12.3613 6.37499 12.3613C7.83255 13 9.86667 13 9.86667 13C11.9008 13 13.3583 12.3613 13.3583 12.3613C14.089 12.041 14.5069 11.6078 14.5069 11.6078C15 11.0965 15 10.5 15 10.5Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M11.2667 10.1023V12.375C11.2667 12.626 11.4756 12.8295 11.7333 12.8295C11.9911 12.8295 12.2 12.626 12.2 12.375V10.1023C12.2 9.85123 11.9911 9.64773 11.7333 9.64773C11.4756 9.64773 11.2667 9.85123 11.2667 10.1023Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M7.53333 7.375V12.375C7.53333 12.626 7.74227 12.8295 8 12.8295C8.25773 12.8295 8.46667 12.626 8.46667 12.375V7.375C8.46667 7.12396 8.25773 6.92045 8 6.92045C7.74227 6.92045 7.53333 7.12396 7.53333 7.375Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Montant = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2.61417 3.36459C2.61417 3.2897 2.62896 3.21856 2.65556 3.15439L2.4357 2.7353L2.43315 2.73C2.17464 2.19343 2.31756 1.49316 2.79324 1.16405C3.15157 0.916141 3.57677 0.961667 3.88515 1.21686C4.18586 1.01148 4.5742 0.991354 4.90381 1.2194C5.3795 1.54851 5.52242 2.24878 5.26391 2.78535L5.08764 3.15121C5.11508 3.2162 5.13037 3.28846 5.13037 3.36459C5.13037 3.51897 5.06748 3.65745 4.96793 3.75166C5.21713 3.81867 5.45138 3.92667 5.66421 4.06867C5.41531 4.1507 5.17929 4.25914 4.95981 4.39047C4.77437 4.32503 4.57638 4.28965 4.37076 4.28965H3.46872C2.41993 4.28965 1.56971 5.21003 1.56971 6.34536V11.4332C1.56971 11.7738 1.82477 12.05 2.13941 12.05H3.33579V12.6667H2.13941C1.51013 12.6667 1 12.1144 1 11.4332V6.34536C1 5.1204 1.76136 4.08793 2.79976 3.77222C2.6869 3.67826 2.61417 3.53062 2.61417 3.36459ZM3.12562 1.727C3.28143 1.6192 3.48731 1.66065 3.60694 1.86202L3.84441 2.26174L4.11143 1.88452C4.23288 1.71295 4.42291 1.67958 4.57144 1.78235C4.75608 1.9101 4.83941 2.22166 4.71668 2.4764L4.53637 2.85066H3.20598L2.97815 2.41637C2.85867 2.16251 2.9421 1.85397 3.12562 1.727ZM4.65561 3.2618H3.08892C3.03648 3.2618 2.99397 3.30782 2.99397 3.36459C2.99397 3.42135 3.03648 3.46737 3.08892 3.46737H4.65561C4.70805 3.46737 4.75056 3.42135 4.75056 3.36459C4.75056 3.30782 4.70805 3.2618 4.65561 3.2618Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M3.33579 9.27973V9.77267C2.98597 9.56422 2.71468 9.22286 2.58302 8.81169H2.0682C1.96332 8.81169 1.8783 8.71965 1.8783 8.60612C1.8783 8.49259 1.96332 8.40055 2.0682 8.40055H2.50175C2.4976 8.34976 2.49548 8.29834 2.49548 8.24637C2.49548 8.22918 2.49571 8.21205 2.49617 8.19498H2.0682C1.96332 8.19498 1.8783 8.10294 1.8783 7.98941C1.8783 7.87587 1.96332 7.78384 2.0682 7.78384H2.55341C2.67452 7.31166 2.97652 6.92031 3.37398 6.69802C3.34883 6.85868 3.33579 7.02313 3.33579 7.19048V7.21302C3.16434 7.36256 3.03095 7.55919 2.95283 7.78384H3.33579V8.19498H2.8762C2.87559 8.21203 2.87528 8.22917 2.87528 8.24637C2.87528 8.29849 2.8781 8.34994 2.88359 8.40055H3.33579V8.81169H2.99326C3.07339 8.99362 3.19103 9.15346 3.33579 9.27973Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M6.75218 10.0272C6.75218 10.0078 6.75255 9.98854 6.75328 9.96935H8.40433C8.53019 9.96935 8.63221 9.86581 8.63221 9.73808C8.63221 9.61036 8.53019 9.50682 8.40433 9.50682H6.84524C7.05749 8.93457 7.60982 8.52393 8.26239 8.52393C8.52311 8.52393 8.76765 8.58951 8.98098 8.70464C9.0921 8.76461 9.23009 8.7218 9.28918 8.60903C9.34827 8.49626 9.30609 8.35623 9.19497 8.29626C8.91712 8.14631 8.59927 8.0614 8.26239 8.0614C7.35934 8.0614 6.5944 8.67175 6.36594 9.50682H5.78368C5.65783 9.50682 5.5558 9.61036 5.5558 9.73808C5.5558 9.86581 5.65783 9.96935 5.78368 9.96935H6.29725C6.2967 9.98855 6.29642 10.0078 6.29642 10.0272C6.29642 10.0856 6.29896 10.1435 6.30395 10.2006H5.78368C5.65783 10.2006 5.5558 10.3042 5.5558 10.4319C5.5558 10.5596 5.65783 10.6632 5.78368 10.6632H6.40147C6.66624 11.4383 7.40156 11.9929 8.26239 11.9929C8.59927 11.9929 8.91712 11.908 9.19497 11.7581C9.30609 11.6981 9.34827 11.5581 9.28918 11.4453C9.23009 11.3325 9.0921 11.2897 8.98098 11.3497C8.76765 11.4648 8.52311 11.5304 8.26239 11.5304C7.65468 11.5304 7.1339 11.1743 6.89375 10.6632H8.40433C8.53019 10.6632 8.63221 10.5596 8.63221 10.4319C8.63221 10.3042 8.53019 10.2006 8.40433 10.2006H6.76216C6.75557 10.1437 6.75218 10.0858 6.75218 10.0272Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.48852 4.29869C6.4566 4.37088 6.43885 4.45091 6.43885 4.53516C6.43885 4.72195 6.52613 4.88805 6.66156 4.99375C5.41547 5.34892 4.50185 6.51045 4.50185 7.88853V13.6124C4.50185 14.3787 5.114 15 5.86914 15H10.1419C10.8971 15 11.5092 14.3787 11.5092 13.6124V7.88853C11.5092 6.47888 10.5533 5.29581 9.26336 4.97061C9.38283 4.86463 9.45829 4.70884 9.45829 4.53516C9.45829 4.44952 9.43994 4.36823 9.40701 4.29511L9.61854 3.88352C9.92875 3.27988 9.75724 2.49208 9.18642 2.12183C8.79089 1.86527 8.32487 1.88791 7.96402 2.11896C7.59397 1.83188 7.08373 1.78066 6.65374 2.05956C6.08292 2.42981 5.91141 3.21761 6.22163 3.82125L6.22469 3.82721L6.48852 4.29869ZM7.63017 2.84478C7.48662 2.61824 7.23956 2.5716 7.05259 2.69288C6.83237 2.83572 6.73225 3.18282 6.87562 3.46841L7.14902 3.95699H8.74548L8.96186 3.53595C9.10914 3.24937 9.00915 2.89886 8.78757 2.75514C8.60933 2.63953 8.3813 2.67707 8.23557 2.87008L7.91513 3.29446L7.63017 2.84478ZM7.00855 4.41953H8.88858C8.95151 4.41953 9.00252 4.4713 9.00252 4.53516C9.00252 4.59902 8.95151 4.65079 8.88858 4.65079H7.00855C6.94562 4.65079 6.89461 4.59902 6.89461 4.53516C6.89461 4.4713 6.94562 4.41953 7.00855 4.41953ZM7.46432 5.57586H8.54676C9.80532 5.57586 10.8256 6.61128 10.8256 7.88853V13.6124C10.8256 13.9956 10.5195 14.3062 10.1419 14.3062H5.86914C5.49157 14.3062 5.18549 13.9956 5.18549 13.6124V7.88853C5.18549 6.61128 6.20576 5.57586 7.46432 5.57586Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.8161 3.15439C10.7895 3.21856 10.7747 3.2897 10.7747 3.36459C10.7747 3.53062 10.8474 3.67826 10.9603 3.77222C10.7378 3.83986 10.5281 3.94039 10.3358 4.06867C10.5847 4.1507 10.8207 4.25914 11.0402 4.39047C11.2256 4.32503 11.4236 4.28965 11.6292 4.28965H12.5313C13.5801 4.28965 14.4303 5.21003 14.4303 6.34536V11.4332C14.4303 11.7738 14.1752 12.05 13.8606 12.05H12.6642V12.6667H13.8606C14.4899 12.6667 15 12.1144 15 11.4332V6.34536C15 5.09233 14.2034 4.04072 13.1284 3.75166C13.228 3.65745 13.2909 3.51897 13.2909 3.36459C13.2909 3.28846 13.2756 3.2162 13.2482 3.15121L13.4244 2.78535C13.6829 2.24878 13.54 1.54851 13.0643 1.2194C12.7347 0.991354 12.3464 1.01148 12.0457 1.21686C11.7373 0.961667 11.3121 0.916141 10.9538 1.16405C10.4781 1.49316 10.3352 2.19343 10.5937 2.73L10.5962 2.7353L10.8161 3.15439ZM11.7675 1.86202C11.6478 1.66065 11.4419 1.6192 11.2861 1.727C11.1026 1.85397 11.0192 2.16251 11.1387 2.41637L11.3665 2.85066H12.6969L12.8772 2.4764C12.9999 2.22166 12.9166 1.9101 12.732 1.78235C12.5834 1.67958 12.3934 1.71295 12.272 1.88452L12.0049 2.26174L11.7675 1.86202ZM11.2494 3.2618H12.8161C12.8686 3.2618 12.9111 3.30782 12.9111 3.36459C12.9111 3.42135 12.8686 3.46737 12.8161 3.46737H11.2494C11.197 3.46737 11.1545 3.42135 11.1545 3.36459C11.1545 3.30782 11.197 3.2618 11.2494 3.2618Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M13.0715 9.78496C12.9447 9.8579 12.808 9.91354 12.6642 9.94896V9.52398C12.7443 9.4979 12.8208 9.46356 12.8931 9.42195C12.9857 9.36865 13.1007 9.40669 13.15 9.50694C13.1992 9.60718 13.1641 9.73165 13.0715 9.78496Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M12.5947 6.52836C12.6251 6.67118 12.6459 6.81735 12.6564 6.96623C12.7392 6.99262 12.8185 7.02782 12.8931 7.07079C12.9857 7.1241 13.1007 7.08605 13.15 6.98581C13.1992 6.88557 13.1641 6.76109 13.0715 6.70779C12.9245 6.62318 12.7641 6.56186 12.5947 6.52836Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const MotDePasse = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.4 10.3684C6.4 9.43826 7.11634 8.68421 8 8.68421C8.88366 8.68421 9.6 9.43826 9.6 10.3684C9.6 11.1544 9.08859 11.8145 8.39695 12.0004C8.39896 12.0175 8.4 12.0349 8.4 12.0526V12.8947C8.4 13.1273 8.22091 13.3158 8 13.3158C7.77909 13.3158 7.6 13.1273 7.6 12.8947V12.0526C7.6 12.0349 7.60104 12.0175 7.60305 12.0004C6.91141 11.8145 6.4 11.1544 6.4 10.3684ZM8 9.52632C7.55817 9.52632 7.2 9.90334 7.2 10.3684C7.2 10.8335 7.55817 11.2105 8 11.2105C8.44183 11.2105 8.8 10.8335 8.8 10.3684C8.8 9.90334 8.44183 9.52632 8 9.52632Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.9 6.57895L3.9 6.54366C3.8999 5.70167 3.89974 4.34442 4.39434 3.19198C4.65127 2.59334 5.0467 2.03509 5.65008 1.63043C6.25253 1.22639 7.02564 1 8 1C8.9436 1 9.69942 1.22831 10.2937 1.6321C10.8875 2.03552 11.2855 2.59056 11.5505 3.1851C12.0703 4.35123 12.1 5.72332 12.1 6.57895H12.4C13.2837 6.57895 14 7.33299 14 8.26316V13.3158C14 14.246 13.2837 15 12.4 15H3.6C2.71634 15 2 14.246 2 13.3158V8.26316C2 7.33299 2.71634 6.57895 3.6 6.57895H3.9ZM4.9 6.57895C4.9 5.7007 4.90723 4.55369 5.30566 3.62536C5.49873 3.1755 5.7783 2.79257 6.18742 2.51818C6.59747 2.24317 7.17436 2.05263 8 2.05263C8.78688 2.05263 9.3463 2.24125 9.75144 2.51651C10.1571 2.79214 10.4429 3.17828 10.6452 3.63224C11.0602 4.56312 11.1 5.71735 11.1 6.57895H4.9ZM3 8.26316C3 7.91435 3.26863 7.63158 3.6 7.63158H12.4C12.7314 7.63158 13 7.91435 13 8.26316V13.3158C13 13.6646 12.7314 13.9474 12.4 13.9474H3.6C3.26863 13.9474 3 13.6646 3 13.3158V8.26316Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Nebulas = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.45658 3.26273C8.37181 3.07285 8.17837 2.95525 7.97078 2.96741C7.76319 2.97957 7.58479 3.11894 7.52277 3.31741L6.58889 6.30584C6.5394 6.31364 6.49026 6.32908 6.44307 6.35267L3.7764 7.68601C3.59587 7.77627 3.48731 7.96624 3.50119 8.16761C3.51508 8.36898 3.64868 8.54225 3.8399 8.60689L5.89141 9.30036L5.89403 9.30524L7.5607 12.3719C7.65578 12.5469 7.84562 12.6487 8.04397 12.6312C8.24232 12.6137 8.41138 12.4802 8.47435 12.2913L9.12086 10.3517C9.16564 10.3406 9.20918 10.3232 9.25015 10.2995L12.2501 8.56615C12.4223 8.46666 12.5192 8.27459 12.4968 8.07698C12.4745 7.87938 12.3371 7.71381 12.1471 7.65533L10.1397 7.03767C10.1349 7.02369 10.1294 7.00981 10.1232 6.99606L8.45658 3.26273ZM7.88967 10.883L7.28566 9.77165L8.16145 10.0677L7.88967 10.883ZM9.43321 7.86657L7.50732 8.79099L8.89346 9.25955C8.9152 9.2669 8.93642 9.27574 8.95695 9.28601L8.9829 9.29898L10.7571 8.27391L9.43321 7.86657ZM5.97422 8.27277L6.18446 7.60001L5.29688 8.0438L5.97422 8.27277ZM7.15353 7.85158L8.08269 4.87829L9.01184 6.95959L7.15353 7.85158Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.00001 0.833252C4.04197 0.833252 0.833344 4.04188 0.833344 7.99992C0.833344 11.958 4.04197 15.1666 8.00001 15.1666C11.9581 15.1666 15.1667 11.958 15.1667 7.99992C15.1667 4.04188 11.9581 0.833252 8.00001 0.833252ZM1.83334 7.99992C1.83334 4.59416 4.59425 1.83325 8.00001 1.83325C11.4058 1.83325 14.1667 4.59416 14.1667 7.99992C14.1667 11.4057 11.4058 14.1666 8.00001 14.1666C4.59425 14.1666 1.83334 11.4057 1.83334 7.99992Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Nem = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0.912149 4.84306C0.90311 4.80304 0.899182 4.76288 0.899976 4.72333C0.856445 4.27588 0.833344 3.81263 0.833344 3.33334V3.05025L1.0761 2.9046H1.1198C1.08395 2.89993 1.0761 2.9046 1.0761 2.9046L1.07714 2.90397L1.0788 2.90298L1.08395 2.89993L1.1015 2.88966C1.11641 2.881 1.13768 2.86879 1.16511 2.85339C1.21998 2.82259 1.29953 2.77903 1.40215 2.72567C1.60731 2.61899 1.90504 2.47292 2.28222 2.31127C3.03583 1.9883 4.11096 1.60125 5.40195 1.34305C7.02577 1.01829 8.99982 0.896227 11.1041 1.36758C11.204 1.36159 11.3002 1.38589 11.3826 1.43328C12.539 1.71994 13.7314 2.1891 14.9239 2.9046L15.1667 3.05025V3.33334H14.6667C15.1667 3.33334 15.1667 3.33334 15.1667 3.33334L15.1667 3.33457L15.1667 3.33647L15.1666 3.34227L15.1664 3.36177C15.1662 3.37824 15.1657 3.40161 15.1648 3.43155C15.163 3.49142 15.1595 3.5776 15.1527 3.68745C15.139 3.9071 15.1117 4.22179 15.0578 4.61046C14.9499 5.38716 14.7346 6.46313 14.3042 7.66818C13.7552 9.20543 12.8539 10.9578 11.3772 12.5636C11.3333 12.6484 11.2681 12.7157 11.1913 12.7618C10.3869 13.6023 9.41984 14.3979 8.25726 15.0954L8.0219 15.2366L7.7764 15.1139L8.00001 14.6667C7.7764 15.1139 7.7764 15.1139 7.7764 15.1139L7.77526 15.1133L7.7735 15.1124L7.76818 15.1097L7.75043 15.1006C7.73549 15.0928 7.7144 15.0817 7.68757 15.0672C7.6339 15.0383 7.55723 14.9957 7.46085 14.9393C7.26815 14.8264 6.99626 14.6577 6.67161 14.4305C6.02293 13.9764 5.15994 13.2859 4.29671 12.3363C2.78473 10.6732 1.26937 8.21061 0.912149 4.84306ZM1.83647 3.627C1.84395 3.97736 1.86475 4.3181 1.89761 4.64936C2.39366 6.21879 3.00788 7.03684 3.58708 7.43647C4.15685 7.82958 4.76084 7.86414 5.35306 7.7152C5.95892 7.56283 6.52927 7.22158 6.96129 6.90076C7.17419 6.74266 7.34652 6.59477 7.46477 6.48723L7.46764 6.48461C7.20658 4.46632 7.92801 3.18978 8.78399 2.42684C8.92548 2.30073 9.06914 2.18991 9.21043 2.09274C7.89804 1.99042 6.67113 2.10902 5.59807 2.32364C4.38906 2.56544 3.38086 2.92839 2.67614 3.23042C2.32415 3.38127 2.04896 3.51645 1.8635 3.61289L1.83647 3.627ZM11.7419 10.5091C12.4876 9.43144 13.0042 8.33507 13.3625 7.33184C13.7654 6.20356 13.9668 5.1962 14.0673 4.47289C14.1174 4.11156 14.1423 3.82209 14.1546 3.62507L14.1553 3.61363C13.1139 3.02137 12.0745 2.62834 11.0643 2.38517L10.8314 2.42398L10.8196 2.42696C10.8015 2.4316 10.7724 2.43947 10.734 2.45114C10.657 2.47452 10.5439 2.51286 10.4083 2.57057C10.1356 2.68665 9.78186 2.87699 9.44936 3.17335C8.84011 3.71638 8.24924 4.6586 8.45504 6.32221C10.7376 7.38053 11.5441 8.87608 11.7126 10.1863C11.7267 10.2961 11.7363 10.4039 11.7419 10.5091ZM8.1006 7.26043C10.0452 8.18238 10.6013 9.3847 10.7208 10.3138C10.786 10.8216 10.7246 11.2796 10.6449 11.6131C10.6053 11.7789 10.5619 11.911 10.5294 11.9995C10.528 12.0034 10.5266 12.0072 10.5252 12.0109C9.82308 12.754 8.98561 13.4603 7.98653 14.0882L7.96625 14.0764C7.79437 13.9757 7.54543 13.8215 7.24507 13.6112C6.64376 13.1903 5.84008 12.5475 5.03665 11.6637C4.18833 10.7305 3.34124 9.53045 2.73142 8.03753C2.8256 8.11827 2.92155 8.1922 3.01918 8.25956C3.88067 8.85395 4.79751 8.88606 5.59696 8.685C6.38276 8.48737 7.07492 8.06195 7.55748 7.7036C7.78078 7.53778 7.96534 7.38169 8.1006 7.26043Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Nexo = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.92392 1.57125C4.76558 1.47625 4.56777 1.47625 4.40943 1.57125L1.0761 3.57125C0.925493 3.66162 0.833344 3.82437 0.833344 4V12C0.833344 12.1756 0.925493 12.3384 1.0761 12.4287L4.40943 14.4287C4.57504 14.5281 4.78307 14.5232 4.94382 14.4162L7.84027 12.4873L11.0761 14.4287C11.2344 14.5238 11.4323 14.5238 11.5906 14.4287L14.9239 12.4287C15.0745 12.3384 15.1667 12.1756 15.1667 12V4C15.1667 3.82437 15.0745 3.66162 14.9239 3.57125L11.5906 1.57125C11.4323 1.47625 11.2344 1.47625 11.0761 1.57125L8.00001 3.4169L4.92392 1.57125ZM4.66668 2.5831L1.83334 4.2831V11.7169L4.65275 13.4085L6.89122 11.9178L4.40943 10.4287C4.25883 10.3384 4.16668 10.1756 4.16668 10V6C4.16668 5.81986 4.26357 5.65365 4.42033 5.5649C4.57708 5.47615 4.76946 5.47857 4.92392 5.57125L10.8333 9.1169V6.2831L4.66668 2.5831ZM11.5906 5.57125L8.97184 4L11.3333 2.5831L14.1667 4.2831V11.7169L11.3333 13.4169L5.16668 9.71691V6.8831L11.0761 10.4287C11.2306 10.5214 11.4229 10.5239 11.5797 10.4351C11.7364 10.3463 11.8333 10.1801 11.8333 10V6C11.8333 5.82437 11.7412 5.66162 11.5906 5.57125Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Note = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M5.23256 8C5.23256 7.73028 5.45121 7.51163 5.72093 7.51163H7.51163V5.72093C7.51163 5.45121 7.73028 5.23256 8 5.23256C8.26972 5.23256 8.48837 5.45121 8.48837 5.72093V7.51163H10.2791C10.5488 7.51163 10.7674 7.73028 10.7674 8C10.7674 8.26972 10.5488 8.48837 10.2791 8.48837H8.48837V10.2791C8.48837 10.5488 8.26972 10.7674 8 10.7674C7.73028 10.7674 7.51163 10.5488 7.51163 10.2791V8.48837H5.72093C5.45121 8.48837 5.23256 8.26972 5.23256 8Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2.11979 2.11979C2.89484 1.34473 4.01774 1 5.39535 1H10.6047C11.9823 1 13.1052 1.34473 13.8802 2.11979C14.6553 2.89484 15 4.01774 15 5.39535V10.6047C15 11.9823 14.6553 13.1052 13.8802 13.8802C13.1052 14.6553 12 15 10.6047 15H2.13953C1.51167 15 1 14.4883 1 13.8605V5.39535C1 4.01774 1.34473 2.89484 2.11979 2.11979ZM2.81045 2.81045C2.28317 3.33772 1.97674 4.1683 1.97674 5.39535V13.8605C1.97674 13.9489 2.05112 14.0233 2.13953 14.0233H10.6047C11.8317 14.0233 12.6623 13.7168 13.1896 13.1896C13.7168 12.6623 14.0233 11.8317 14.0233 10.6047V5.39535C14.0233 4.1683 13.7168 3.33772 13.1896 2.81045C12.6623 2.28317 11.8317 1.97674 10.6047 1.97674H5.39535C4.1683 1.97674 3.33772 2.28317 2.81045 2.81045Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const OceanProtocol = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M9 2.1333C9 1.58102 8.55228 1.1333 8 1.1333C7.44771 1.1333 7 1.58102 7 2.1333V2.13997C7 2.69225 7.44771 3.13997 8 3.13997C8.55228 3.13997 9 2.69225 9 2.13997V2.1333Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M9 5.1333C9 4.58102 8.55228 4.1333 8 4.1333C7.44771 4.1333 7 4.58102 7 5.1333V5.13997C7 5.69225 7.44771 6.13997 8 6.13997C8.55228 6.13997 9 5.69225 9 5.13997V5.1333Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M8 6.79997C8.55228 6.79997 9 7.24768 9 7.79997V7.80663C9 8.35892 8.55228 8.80663 8 8.80663C7.44771 8.80663 7 8.35892 7 7.80663V7.79997C7 7.24768 7.44771 6.79997 8 6.79997Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M8.66667 10.4666C8.66667 10.0984 8.36819 9.79997 8 9.79997C7.63181 9.79997 7.33333 10.0984 7.33333 10.4666V10.4733C7.33333 10.8415 7.63181 11.14 8 11.14C8.36819 11.14 8.66667 10.8415 8.66667 10.4733V10.4666Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M8 12.3C8.27614 12.3 8.5 12.5238 8.5 12.8V12.8066C8.5 13.0828 8.27614 13.3066 8 13.3066C7.72386 13.3066 7.5 13.0828 7.5 12.8066V12.8C7.5 12.5238 7.72386 12.3 8 12.3Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M8.33333 14.8C8.33333 14.6159 8.18409 14.4666 8 14.4666C7.8159 14.4666 7.66667 14.6159 7.66667 14.8V14.8066C7.66667 14.9907 7.8159 15.14 8 15.14C8.18409 15.14 8.33333 14.9907 8.33333 14.8066V14.8Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M2.33333 4.1333C2.88562 4.1333 3.33333 4.58102 3.33333 5.1333V5.13997C3.33333 5.69225 2.88562 6.13997 2.33333 6.13997C1.78105 6.13997 1.33333 5.69225 1.33333 5.13997V5.1333C1.33333 4.58102 1.78105 4.1333 2.33333 4.1333Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M14.6667 5.1333C14.6667 4.58102 14.2189 4.1333 13.6667 4.1333C13.1144 4.1333 12.6667 4.58102 12.6667 5.1333V5.13997C12.6667 5.69225 13.1144 6.13997 13.6667 6.13997C14.2189 6.13997 14.6667 5.69225 14.6667 5.13997V5.1333Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M13.6667 7.1333C14.0349 7.1333 14.3333 7.43178 14.3333 7.79997V7.80663C14.3333 8.17482 14.0349 8.4733 13.6667 8.4733C13.2985 8.4733 13 8.17482 13 7.80663V7.79997C13 7.43178 13.2985 7.1333 13.6667 7.1333Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M3 7.79997C3 7.43178 2.70152 7.1333 2.33333 7.1333C1.96514 7.1333 1.66667 7.43178 1.66667 7.79997V7.80663C1.66667 8.17482 1.96514 8.4733 2.33333 8.4733C2.70152 8.4733 3 8.17482 3 7.80663V7.79997Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M13.6667 9.29997C13.9428 9.29997 14.1667 9.52383 14.1667 9.79997V9.80663C14.1667 10.0828 13.9428 10.3066 13.6667 10.3066C13.3905 10.3066 13.1667 10.0828 13.1667 9.80663V9.79997C13.1667 9.52383 13.3905 9.29997 13.6667 9.29997Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M14 11.8C14 11.6159 13.8508 11.4666 13.6667 11.4666C13.4826 11.4666 13.3333 11.6159 13.3333 11.8V11.8066C13.3333 11.9907 13.4826 12.14 13.6667 12.14C13.8508 12.14 14 11.9907 14 11.8066V11.8Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M2.33333 9.29997C2.60947 9.29997 2.83333 9.52383 2.83333 9.79997V9.80663C2.83333 10.0828 2.60947 10.3066 2.33333 10.3066C2.05719 10.3066 1.83333 10.0828 1.83333 9.80663V9.79997C1.83333 9.52383 2.05719 9.29997 2.33333 9.29997Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M2.66667 11.8C2.66667 11.6159 2.51743 11.4666 2.33333 11.4666C2.14924 11.4666 2 11.6159 2 11.8V11.8066C2 11.9907 2.14924 12.14 2.33333 12.14C2.51743 12.14 2.66667 11.9907 2.66667 11.8066V11.8Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M5.2 5.46663C5.75229 5.46663 6.2 5.91435 6.2 6.46663V6.4733C6.2 7.02559 5.75229 7.4733 5.2 7.4733C4.64772 7.4733 4.2 7.02559 4.2 6.4733V6.46663C4.2 5.91435 4.64772 5.46663 5.2 5.46663Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M6.16667 3.66667C6.16667 3.11438 5.71895 2.66667 5.16667 2.66667C4.61438 2.66667 4.16667 3.11438 4.16667 3.66667V3.67333C4.16667 4.22562 4.61438 4.67333 5.16667 4.67333C5.71895 4.67333 6.16667 4.22562 6.16667 3.67333V3.66667Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M10.8 5.46663C11.3523 5.46663 11.8 5.91435 11.8 6.46663V6.4733C11.8 7.02559 11.3523 7.4733 10.8 7.4733C10.2477 7.4733 9.8 7.02559 9.8 6.4733V6.46663C9.8 5.91435 10.2477 5.46663 10.8 5.46663Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M11.8333 3.66667C11.8333 3.11438 11.3856 2.66667 10.8333 2.66667C10.281 2.66667 9.83333 3.11438 9.83333 3.66667V3.67333C9.83333 4.22562 10.281 4.67333 10.8333 4.67333C11.3856 4.67333 11.8333 4.22562 11.8333 3.67333V3.66667Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M5.2 8.46663C5.56819 8.46663 5.86667 8.76511 5.86667 9.1333V9.13997C5.86667 9.50816 5.56819 9.80663 5.2 9.80663C4.83181 9.80663 4.53333 9.50816 4.53333 9.13997V9.1333C4.53333 8.76511 4.83181 8.46663 5.2 8.46663Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M5.7 11.1333C5.7 10.8572 5.47614 10.6333 5.2 10.6333C4.92386 10.6333 4.7 10.8572 4.7 11.1333V11.14C4.7 11.4161 4.92386 11.64 5.2 11.64C5.47614 11.64 5.7 11.4161 5.7 11.14V11.1333Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M5.2 12.8C5.3841 12.8 5.53333 12.9492 5.53333 13.1333V13.14C5.53333 13.3241 5.3841 13.4733 5.2 13.4733C5.01591 13.4733 4.86667 13.3241 4.86667 13.14V13.1333C4.86667 12.9492 5.01591 12.8 5.2 12.8Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M11.4667 9.1333C11.4667 8.76511 11.1682 8.46663 10.8 8.46663C10.4318 8.46663 10.1333 8.76511 10.1333 9.1333V9.13997C10.1333 9.50816 10.4318 9.80663 10.8 9.80663C11.1682 9.80663 11.4667 9.50816 11.4667 9.13997V9.1333Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M10.8 10.6333C11.0761 10.6333 11.3 10.8572 11.3 11.1333V11.14C11.3 11.4161 11.0761 11.64 10.8 11.64C10.5239 11.64 10.3 11.4161 10.3 11.14V11.1333C10.3 10.8572 10.5239 10.6333 10.8 10.6333Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M11.1333 13.1333C11.1333 12.9492 10.9841 12.8 10.8 12.8C10.6159 12.8 10.4667 12.9492 10.4667 13.1333V13.14C10.4667 13.3241 10.6159 13.4733 10.8 13.4733C10.9841 13.4733 11.1333 13.3241 11.1333 13.14V13.1333Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Okb = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.19535 4.19527C2.30061 4.42758 0.833328 6.0424 0.833328 7.99992C0.833328 9.95744 2.30061 11.5723 4.19535 11.8046C4.42765 13.6993 6.04247 15.1666 7.99999 15.1666C9.95752 15.1666 11.5723 13.6993 11.8046 11.8046C13.6994 11.5723 15.1667 9.95744 15.1667 7.99992C15.1667 6.0424 13.6994 4.42758 11.8046 4.19527C11.5723 2.30053 9.95752 0.833252 7.99999 0.833252C6.04247 0.833252 4.42765 2.30053 4.19535 4.19527ZM5.20424 4.20398C6.40347 4.37228 7.4247 5.09546 8 6.10561C8.57529 5.09547 9.59652 4.37228 10.7957 4.20398C10.5749 2.85922 9.40727 1.83325 7.99999 1.83325C6.59272 1.83325 5.42508 2.85922 5.20424 4.20398ZM7.44582 7.44575C6.32555 7.22361 5.44296 6.34103 5.22083 5.22076C6.3411 5.44289 7.22369 6.32548 7.44582 7.44575ZM5.22083 10.7791C6.3411 10.5569 7.22369 9.67436 7.44582 8.55409C6.32555 8.77623 5.44296 9.65881 5.22083 10.7791ZM5.20424 11.7959C6.40347 11.6276 7.4247 10.9044 7.99999 9.89423C8.57529 10.9044 9.59651 11.6276 10.7957 11.7959C10.5749 13.1406 9.40727 14.1666 7.99999 14.1666C6.59272 14.1666 5.42508 13.1406 5.20424 11.7959ZM4.20406 10.7957C4.37236 9.59644 5.09554 8.57521 6.10568 7.99992C5.09554 7.42462 4.37236 6.4034 4.20406 5.20416C2.8593 5.425 1.83333 6.59265 1.83333 7.99992C1.83333 9.40719 2.8593 10.5748 4.20406 10.7957ZM14.1667 7.99992C14.1667 6.59265 13.1407 5.425 11.7959 5.20417C11.6276 6.4034 10.9044 7.42462 9.8943 7.99992C10.9044 8.57522 11.6276 9.59644 11.7959 10.7957C13.1407 10.5748 14.1667 9.40719 14.1667 7.99992ZM8.55417 7.44575C9.67444 7.22361 10.557 6.34103 10.7792 5.22075C9.65889 5.44289 8.7763 6.32548 8.55417 7.44575ZM8.55416 8.55409C8.7763 9.67436 9.65888 10.5569 10.7792 10.7791C10.557 9.65881 9.67444 8.77622 8.55416 8.55409Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Ontology = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.80253 2.49182C5.02486 1.41329 6.68008 0.762832 8.41532 0.833614C12.1097 0.909153 14.9667 4.08843 14.9667 7.80007V12.4667C14.9667 13.1454 14.163 13.5806 13.5667 13.1334C13.5468 13.1185 13.5281 13.1022 13.5107 13.0845L3.77739 3.21788C3.68087 3.12004 3.62889 2.98679 3.63364 2.84944C3.6384 2.71209 3.69948 2.58275 3.80253 2.49182ZM13.9667 12.1228L4.87816 2.9098C5.86561 2.19178 7.102 1.77976 8.37919 1.83297L8.39021 1.83331C11.4931 1.89415 13.9667 4.58023 13.9667 7.80007V12.1228Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2.36667 2.80015C1.77039 2.35294 0.966675 2.78813 0.966675 3.46682V8.13348C0.966675 11.842 3.82083 15.0913 7.58517 15.1666C9.38364 15.2372 11.0394 14.5891 12.2642 13.5084C12.3674 13.4173 12.4285 13.2876 12.4331 13.1499C12.4376 13.0123 12.3851 12.8788 12.2881 12.7811L2.42142 2.84779C2.40435 2.8306 2.38605 2.81468 2.36667 2.80015ZM1.96667 8.13348V3.80897L11.1869 13.0915C10.2004 13.8076 8.95738 14.2207 7.61999 14.1672L7.60962 14.1669C4.44321 14.106 1.96667 11.3565 1.96667 8.13348Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Opera = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.99933 1C4.1332 1 1 4.13439 1 8C1 11.7542 3.95611 14.8173 7.66746 14.9916C7.7789 14.9972 7.88908 15 8.00066 15C9.78322 15 11.4093 14.3333 12.6449 13.2374L12.6513 13.2332L12.6666 13.2195C14.0982 11.937 15 10.0743 15 8.00003C15 5.92719 14.0983 4.06298 12.6651 2.78172L12.65 2.76824L12.6493 2.76781C11.4187 1.67383 9.80066 1.00693 8.02583 1H7.99933ZM10.0832 2.46025C10.8904 2.51348 11.6467 2.78193 12.3069 3.21633C13.6158 4.39475 14.4373 6.10197 14.4373 8.00003C14.4373 9.89746 13.6175 11.602 12.312 12.7817C11.5704 13.2709 10.7068 13.5495 9.78579 13.5495C9.20519 13.5495 8.64693 13.4383 8.12753 13.2332C9.19683 13.2125 10.1382 12.5981 10.8051 11.6658C11.484 10.7167 11.8951 9.41978 11.8951 8.00003C11.8951 6.58093 11.484 5.28408 10.8051 4.33483C10.1382 3.40233 9.19685 2.78756 8.12745 2.76681C8.64689 2.5617 9.20517 2.45051 9.7858 2.45051C9.86534 2.45051 9.94444 2.45258 10.0231 2.45669C10.0432 2.45774 10.0632 2.45893 10.0832 2.46025ZM6.00209 4.39561C5.30799 5.21618 4.84488 6.44708 4.8134 7.84403V8.15427C4.84489 9.55287 5.30819 10.7841 6.00348 11.6031L6.0078 11.6082L6.01188 11.6135C6.01414 11.6164 6.0164 11.6194 6.01866 11.6223C6.59224 12.2911 7.30871 12.6711 8.07154 12.6711C8.93541 12.6711 9.74388 12.1821 10.3474 11.3384C10.9505 10.4952 11.3324 9.31589 11.3324 8.00003C11.3324 6.68487 10.9505 5.50551 10.3474 4.66212C9.74383 3.81819 8.93535 3.32895 8.07154 3.32895C7.31441 3.32895 6.60283 3.70336 6.03003 4.36312L6.01189 4.38654L6.01066 4.38559L6.00209 4.39561ZM5.56654 11.9579C4.78 11.0262 4.28393 9.66847 4.25074 8.16398L4.2506 8.15777L4.25067 8.15719V7.83468C4.28392 6.32905 4.78162 4.96962 5.56866 4.03671C6.5797 2.72721 8.09024 1.8878 9.78579 1.8878C9.87241 1.8878 9.95856 1.89 10.0442 1.89435C9.40937 1.68179 8.73037 1.56549 8.02418 1.56267H7.9997C4.44451 1.56267 1.56273 4.445 1.56273 8C1.56273 11.4523 4.28136 14.2695 7.69427 14.4296L7.69513 14.4297C7.79749 14.4348 7.89844 14.4373 8.00066 14.4373C8.7141 14.4373 9.4001 14.3213 10.0411 14.1072C9.9565 14.1114 9.87138 14.1136 9.7858 14.1136C8.08781 14.1136 6.57697 13.2704 5.56609 11.9582L5.56654 11.9579Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Opposition = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M10.5454 3.03448V7.17241C10.5454 7.47712 10.7806 7.72414 11.0707 7.72414C11.3608 7.72414 11.5959 7.47712 11.5959 7.17241V3.03448C11.5959 2.23462 11.0575 1.66903 11.0575 1.66903C10.519 1.10345 9.75753 1.10345 9.75753 1.10345C8.99605 1.10345 8.4576 1.66903 8.4576 1.66903C7.91915 2.23462 7.91915 3.03448 7.91915 3.03448C7.91915 3.33919 8.15431 3.58621 8.4444 3.58621C8.73449 3.58621 8.96966 3.33919 8.96966 3.03448C8.96966 2.69169 9.20042 2.44929 9.20042 2.44929C9.43118 2.2069 9.75753 2.2069 9.75753 2.2069C10.0839 2.2069 10.3146 2.44929 10.3146 2.44929C10.5454 2.69169 10.5454 3.03448 10.5454 3.03448Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M7.91915 1.93103V6.62069C7.91915 6.9254 8.15431 7.17241 8.4444 7.17241C8.73449 7.17241 8.96966 6.9254 8.96966 6.62069V1.93103C8.96966 1.13117 8.43121 0.565587 8.43121 0.565587C7.89276 0 7.13127 0 7.13127 0C6.36979 0 5.83134 0.565587 5.83134 0.565587C5.29289 1.13117 5.29289 1.93103 5.29289 1.93103V4.13793C5.29289 4.44264 5.52805 4.68966 5.81814 4.68966C6.10823 4.68966 6.34339 4.44264 6.34339 4.13793V1.93103C6.34339 1.58824 6.57416 1.34584 6.57416 1.34584C6.80492 1.10345 7.13127 1.10345 7.13127 1.10345C7.45762 1.10345 7.68839 1.34584 7.68839 1.34584C7.91915 1.58824 7.91915 1.93103 7.91915 1.93103Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M5.29289 4.13793V7.17241C5.29289 7.47712 5.52805 7.72414 5.81814 7.72414C6.10823 7.72414 6.34339 7.47712 6.34339 7.17241V4.13793C6.34339 3.33807 5.80494 2.77248 5.80494 2.77248C5.26649 2.2069 4.50501 2.2069 4.50501 2.2069C3.74353 2.2069 3.20508 2.77248 3.20508 2.77248C2.66663 3.33807 2.66663 4.13793 2.66663 4.13793V9.93103C2.66663 11.1382 3.10643 12.2535 3.10643 12.2535C3.54624 13.3688 4.3589 14.2224 4.3589 14.2224C5.17156 15.0761 6.23334 15.538 6.23334 15.538C7.29513 16 8.4444 16 8.4444 16C9.59367 16 10.6555 15.538 10.6555 15.538C11.7173 15.0761 12.5299 14.2224 12.5299 14.2224C13.3426 13.3688 13.7824 12.2535 13.7824 12.2535C14.2222 11.1382 14.2222 9.93103 14.2222 9.93103V7.17241C14.2222 6.37255 13.6837 5.80697 13.6837 5.80697C13.1453 5.24138 12.3838 5.24138 12.3838 5.24138C11.6223 5.24138 11.0839 5.80697 11.0839 5.80697C10.5454 6.37255 10.5454 7.17241 10.5454 7.17241V8.04174C9.57374 8.20118 8.84221 8.96958 8.84221 8.96958C7.91915 9.93915 7.91915 11.3103 7.91915 11.3103C7.91915 11.6151 8.15431 11.8621 8.4444 11.8621C8.73449 11.8621 8.96966 11.6151 8.96966 11.3103C8.96966 10.3962 9.58503 9.74983 9.58503 9.74983C10.2004 9.10345 11.0707 9.10345 11.0707 9.10345C11.3608 9.10345 11.5959 8.85643 11.5959 8.55172V7.17241C11.5959 6.82962 11.8267 6.58722 11.8267 6.58722C12.0574 6.34483 12.3838 6.34483 12.3838 6.34483C12.7101 6.34483 12.9409 6.58722 12.9409 6.58722C13.1717 6.82962 13.1717 7.17241 13.1717 7.17241V9.93103C13.1717 10.9187 12.8118 11.8313 12.8118 11.8313C12.452 12.7438 11.7871 13.4422 11.7871 13.4422C11.1222 14.1406 10.2535 14.5186 10.2535 14.5186C9.38472 14.8966 8.4444 14.8966 8.4444 14.8966C7.50409 14.8966 6.63535 14.5186 6.63535 14.5186C5.76662 14.1406 5.10172 13.4422 5.10172 13.4422C4.43681 12.7438 4.07697 11.8313 4.07697 11.8313C3.71713 10.9187 3.71713 9.93103 3.71713 9.93103V4.13793C3.71713 3.79513 3.9479 3.55274 3.9479 3.55274C4.17866 3.31034 4.50501 3.31034 4.50501 3.31034C4.83136 3.31034 5.06212 3.55274 5.06212 3.55274C5.29289 3.79513 5.29289 4.13793 5.29289 4.13793Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Operations = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.8015 1.33802C9.09581 0.912678 8.1961 1.4209 8.1961 2.24486V4.60535H3.29414C2.96927 4.60535 2.7059 4.86871 2.7059 5.19358C2.7059 5.51846 2.96927 5.78182 3.29414 5.78182H8.1961V8.52836C8.1961 9.37589 9.14229 9.87993 9.84566 9.40707L14.7739 6.09396C15.4167 5.66179 15.3931 4.70826 14.7297 4.3084L9.8015 1.33802ZM9.37257 2.45313L13.9642 5.22066L9.37257 8.30751V2.45313Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.19854 14.662C6.90424 15.0873 7.80394 14.5791 7.80394 13.7551L7.80394 11.3947L12.7059 11.3947C13.0308 11.3947 13.2941 11.1313 13.2941 10.8064C13.2941 10.4815 13.0308 10.2182 12.7059 10.2182L7.80394 10.2182L7.80394 7.47165C7.80394 6.62411 6.85775 6.12008 6.15439 6.59293L1.22615 9.90605C0.583313 10.3382 0.606897 11.2917 1.27031 11.6916L6.19854 14.662ZM6.62747 13.5469L2.03581 10.7793L6.62747 7.6925L6.62747 13.5469Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Paint = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M9.34655 11.4796C9.43707 11.5702 9.56008 11.6213 9.6881 11.6213C9.81611 11.6213 9.93888 11.5704 10.0294 11.4799C10.1199 11.3894 10.1708 11.2666 10.1708 11.1386C10.1708 11.0106 10.1199 10.8878 10.0294 10.7973L5.20268 5.97057C5.11216 5.88005 4.98939 5.82919 4.86138 5.82919C4.73336 5.82919 4.61059 5.88005 4.52008 5.97057C4.42956 6.06108 4.3787 6.18385 4.3787 6.31187C4.3787 6.43988 4.42956 6.56265 4.52008 6.65317L9.34655 11.4796Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M7.00043 11.4439C7.09095 11.3534 7.14201 11.2304 7.14201 11.1024C7.14201 10.9744 7.09115 10.8516 7.00064 10.7611L6.99647 10.757C6.90634 10.6692 6.78518 10.6197 6.65934 10.6197L6.65667 10.6197C6.52958 10.6204 6.4079 10.6712 6.31803 10.7611L4.43577 12.6434C4.34525 12.7339 4.29424 12.8568 4.29424 12.9848C4.29424 12.9926 4.29443 13.0003 4.2948 13.008C4.30056 13.1279 4.35077 13.2413 4.43561 13.3261C4.52613 13.4167 4.6489 13.4675 4.77691 13.4675C4.90493 13.4675 5.0277 13.4167 5.11822 13.3261L7.00043 11.4439Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M5.31108 9.75457C5.4016 9.66405 5.45265 9.54107 5.45265 9.41306C5.45265 9.28505 5.4018 9.16228 5.31128 9.07176L5.30712 9.06764C5.21698 8.97981 5.09583 8.93039 4.96998 8.93039L4.96731 8.93039C4.84023 8.9311 4.71855 8.98189 4.62868 9.07176L2.74641 10.954C2.65589 11.0445 2.60489 11.1675 2.60489 11.2955C2.60489 11.3032 2.60508 11.3109 2.60545 11.3187C2.61121 11.4385 2.66141 11.5519 2.74626 11.6368C2.83678 11.7273 2.95955 11.7782 3.08756 11.7782C3.21557 11.7782 3.33834 11.7273 3.42886 11.6368L5.31108 9.75457Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.81514 4.72169L8.37026 5.27681L11.6818 1.58522C11.6877 1.57872 11.6937 1.57239 11.6998 1.56622C11.6998 1.56622 12.266 1 13.0668 1C13.0668 1 13.8676 1 14.4338 1.56622C14.4338 1.56622 15 2.13244 15 2.9332C15 2.9332 15 3.73396 14.4338 4.30018C14.4276 4.30635 14.4213 4.31235 14.4148 4.31817L10.7232 7.62979L11.2808 8.18739C11.2808 8.18739 11.6991 8.61193 11.6991 9.20794C11.6991 9.20794 11.6991 9.80394 11.2783 10.231L6.65069 14.8586C6.4622 15.0471 6.15659 15.0471 5.96809 14.8586L1.14137 10.0319C0.952876 9.84341 0.952876 9.5378 1.14137 9.34931L5.77152 4.71918C5.77152 4.71918 6.19606 4.30086 6.79206 4.30086C6.79206 4.30086 7.38807 4.30086 7.81514 4.72169ZM9.08732 5.92312C9.08732 5.92312 8.95438 6.0706 8.77404 6.15365C8.77404 6.15365 8.5937 6.23669 8.39522 6.24183C8.39522 6.24183 8.19673 6.24696 8.01234 6.17335C8.01234 6.17335 7.82794 6.09973 7.68757 5.95932L7.13254 5.40429C7.13254 5.40429 6.99238 5.26621 6.79206 5.26621C6.79206 5.26621 6.59175 5.26621 6.44906 5.4068L2.16527 9.69061L6.30939 13.8347L10.5957 9.54841C10.5957 9.54841 10.7338 9.40825 10.7338 9.20794C10.7338 9.20794 10.7338 9.00762 10.5932 8.86493L10.0406 8.31239C10.0406 8.31239 9.90027 8.17206 9.82665 7.98766C9.82665 7.98766 9.75304 7.80327 9.75817 7.60479C9.75817 7.60479 9.7633 7.40631 9.84635 7.22596C9.84635 7.22596 9.9294 7.04562 10.0769 6.91269L13.7596 3.60909C13.7596 3.60909 14.0347 3.32812 14.0347 2.9332C14.0347 2.9332 14.0347 2.5323 13.7512 2.24882C13.7512 2.24882 13.4677 1.96534 13.0668 1.96534C13.0668 1.96534 12.6719 1.96534 12.3909 2.24044L9.08732 5.92312Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Parcours = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M3.76487 1.97691C3.03766 1.97691 2.35842 2.35151 2.09316 3.06848L1.07776 3.06834C1.39928 1.67525 2.61179 1 3.76487 1C4.91788 1 6.12934 1.67534 6.44727 3.06907L5.43267 3.06893C5.17022 2.35179 4.49251 1.97691 3.76487 1.97691Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M3.123 3.76466C3.123 3.40497 3.41399 3.11339 3.77294 3.11339H3.78045C4.1394 3.11339 4.43038 3.40497 4.43038 3.76466C4.43038 4.12435 4.1394 4.41594 3.78045 4.41594H3.77294C3.41399 4.41594 3.123 4.12435 3.123 3.76466Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.43267 3.06893L2.09316 3.06848L1.07776 3.06834C0.709578 4.66221 1.7282 5.95402 2.46873 6.66934L2.47335 6.67375C3.19111 7.34913 4.32342 7.36157 5.0473 6.67159L5.04806 6.67085C5.79628 5.95456 6.81518 4.66315 6.44727 3.06907L5.43267 3.06893ZM5.43267 3.06893C5.45813 3.13848 5.47968 3.21128 5.49699 3.28725L5.49732 3.2887C5.73982 4.33825 5.0824 5.28677 4.37505 5.96407C4.03371 6.28909 3.49094 6.28907 3.14283 5.96359C2.44146 5.28536 1.78517 4.3377 2.02754 3.2887C2.04521 3.21213 2.06725 3.13854 2.09316 3.06848L5.43267 3.06893Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M12.2245 9.79223C11.4905 9.79223 10.8081 10.1681 10.5425 10.8837H9.52688C9.84879 9.48886 11.0678 8.81531 12.2245 8.81531C13.3813 8.81531 14.6003 9.48886 14.9222 10.8837H13.9066C13.641 10.1681 12.9586 9.79223 12.2245 9.79223Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M12.2221 10.9287C11.8631 10.9287 11.5722 11.2203 11.5722 11.58C11.5722 11.9397 11.8631 12.2313 12.2221 12.2313H12.2296C12.5886 12.2313 12.8795 11.9397 12.8795 11.58C12.8795 11.2203 12.5886 10.9287 12.2296 10.9287H12.2221Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M13.9066 10.8837H10.5425H9.52688C9.15847 12.4785 10.1779 13.7702 10.934 14.4877L10.9355 14.4891C11.653 15.1642 12.7912 15.1769 13.5151 14.4877C14.2712 13.7702 15.2907 12.4785 14.9222 10.8837H13.9066ZM13.9066 10.8837C13.9327 10.9538 13.9547 11.0272 13.9724 11.1039C14.2148 12.1532 13.5575 13.102 12.8448 13.7783L12.844 13.7791C12.5022 14.1049 11.9517 14.1045 11.6035 13.7775C10.8911 13.1013 10.2343 12.1529 10.4767 11.104C10.4943 11.0274 10.5164 10.9538 10.5425 10.8837H13.9066Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M8.00644 2.95057C7.73723 2.95057 7.51899 3.16926 7.51899 3.43903C7.51899 3.70879 7.73723 3.92748 8.00644 3.92748H9.74826C10.4996 3.92748 10.8508 4.85955 10.2849 5.35768L5.09314 9.90901C3.84984 10.9942 4.61905 13.0454 6.26461 13.0454H8.00644C8.27565 13.0454 8.49389 12.8267 8.49389 12.5569C8.49389 12.2871 8.27565 12.0684 8.00644 12.0684H6.26461C5.51862 12.0684 5.17041 11.1368 5.73325 10.6458L5.73415 10.6451L10.9277 6.09212C12.1682 5.00108 11.4016 2.95057 9.74826 2.95057H8.00644Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Partager = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.3077 6.38462C13.7946 6.38462 15 5.17923 15 3.69231C15 2.20539 13.7946 1 12.3077 1C10.8208 1 9.61539 2.20539 9.61539 3.69231C9.61539 3.99271 9.66459 4.28162 9.75537 4.55143L5.8161 6.34511C5.3234 5.7137 4.55527 5.30769 3.69231 5.30769C2.20539 5.30769 1 6.51308 1 8C1 9.48692 2.20539 10.6923 3.69231 10.6923C4.58088 10.6923 5.36892 10.2618 5.85925 9.59807L9.70788 11.6055C9.64756 11.8293 9.61539 12.0648 9.61539 12.3077C9.61539 13.7946 10.8208 15 12.3077 15C13.7946 15 15 13.7946 15 12.3077C15 10.8208 13.7946 9.61539 12.3077 9.61539C11.4492 9.61539 10.6845 10.0172 10.1915 10.6431L6.31287 8.62006C6.35979 8.42099 6.38462 8.2134 6.38462 8C6.38462 7.76154 6.35362 7.53033 6.29542 7.31016L10.3004 5.48657C10.7934 6.03772 11.51 6.38462 12.3077 6.38462ZM12.3077 5.30769C13.1998 5.30769 13.9231 4.58446 13.9231 3.69231C13.9231 2.80016 13.1998 2.07692 12.3077 2.07692C11.4155 2.07692 10.6923 2.80016 10.6923 3.69231C10.6923 4.58446 11.4155 5.30769 12.3077 5.30769ZM3.69231 9.61539C4.58446 9.61539 5.30769 8.89215 5.30769 8C5.30769 7.10785 4.58446 6.38462 3.69231 6.38462C2.80016 6.38462 2.07692 7.10785 2.07692 8C2.07692 8.89215 2.80016 9.61539 3.69231 9.61539ZM13.9231 12.3077C13.9231 13.1998 13.1998 13.9231 12.3077 13.9231C11.4155 13.9231 10.6923 13.1998 10.6923 12.3077C10.6923 11.4155 11.4155 10.6923 12.3077 10.6923C13.1998 10.6923 13.9231 11.4155 13.9231 12.3077Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Partenaires = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.05131 4.22184C6.08636 4.06764 6.10482 3.90749 6.10482 3.7432C6.10482 2.50951 5.06359 1.5094 3.77918 1.5094C2.49476 1.5094 1.45353 2.50951 1.45353 3.7432C1.45353 3.95061 1.48296 4.15142 1.53803 4.34198C1.64261 4.7039 1.83967 5.02887 2.10323 5.29193C2.52091 5.70883 3.1056 5.97024 3.7539 5.97687C3.76231 5.97696 3.77074 5.977 3.77918 5.977C4.47952 5.977 5.10755 5.67967 5.53392 5.20925C5.78537 4.93181 5.96668 4.59418 6.05131 4.22184ZM3.77918 4.76946C4.443 4.76946 4.89727 4.26459 4.89727 3.7432C4.89727 3.22181 4.443 2.71695 3.77918 2.71695C3.11535 2.71695 2.66108 3.22181 2.66108 3.7432C2.66108 4.26459 3.11535 4.76946 3.77918 4.76946Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M1.17682 6.07169C0.450565 6.7558 0 7.70895 0 8.76318V9.4491C0 10.066 0.520613 10.566 1.16282 10.566H3.48287C3.70214 10.12 3.9926 9.71291 4.34008 9.35846H1.20755V8.76318C1.20755 8.11807 1.46181 7.51817 1.8953 7.05954C2.45102 7.34925 3.08479 7.51233 3.7539 7.51233C4.12707 7.51233 4.48923 7.46162 4.83299 7.3665C4.83113 7.3263 4.83019 7.28588 4.83019 7.24525C4.83019 6.75814 4.96549 6.30098 5.20244 5.90565C4.78926 6.15454 4.30175 6.30012 3.77918 6.30467C3.77076 6.30475 3.76233 6.30478 3.7539 6.30478C3.0137 6.30478 2.3423 6.02184 1.85054 5.56242C1.60678 5.70844 1.38092 5.87944 1.17682 6.07169Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14.2023 4.22184C14.2373 4.06764 14.2558 3.90749 14.2558 3.7432C14.2558 2.50951 13.2145 1.5094 11.9301 1.5094C10.6457 1.5094 9.60447 2.50951 9.60447 3.7432C9.60447 3.95061 9.6339 4.15142 9.68897 4.34198C9.79356 4.7039 9.99062 5.02887 10.2542 5.29193C10.6719 5.70883 11.2565 5.97024 11.9048 5.97687C11.9133 5.97696 11.9217 5.977 11.9301 5.977C12.6305 5.977 13.2585 5.67967 13.6849 5.20925C13.9363 4.93181 14.1176 4.59418 14.2023 4.22184ZM11.9301 4.76946C12.5939 4.76946 13.0482 4.26459 13.0482 3.7432C13.0482 3.22181 12.5939 2.71695 11.9301 2.71695C11.2663 2.71695 10.812 3.22181 10.812 3.7432C10.812 4.26459 11.2663 4.76946 11.9301 4.76946Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M9.96707 5.58327C10.3426 6.04269 10.566 6.61924 10.566 7.24525C10.566 7.25849 10.5659 7.27171 10.5657 7.2849C10.985 7.43235 11.4363 7.51233 11.9048 7.51233C12.6631 7.51233 13.3759 7.30293 13.9813 6.9371C14.4892 7.40848 14.7925 8.05956 14.7925 8.76318V9.35846H11.358C11.7055 9.71291 11.996 10.12 12.2152 10.566H14.8372C15.4794 10.566 16 10.066 16 9.4491V8.76318C16 7.63279 15.482 6.61861 14.6615 5.9277C14.4387 5.74009 14.1936 5.57631 13.9306 5.44052C13.4362 5.96571 12.7236 6.29776 11.9301 6.30467C11.9217 6.30475 11.9133 6.30478 11.9048 6.30478C11.1646 6.30478 10.4932 6.02184 10.0015 5.56242C9.98997 5.56931 9.9785 5.57626 9.96707 5.58327Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.0294 7.36584C10.0294 7.53013 10.0109 7.69028 9.97584 7.84448C9.89121 8.21682 9.7099 8.55446 9.45845 8.83189C9.03208 9.30231 8.40404 9.59965 7.7037 9.59965C7.69527 9.59965 7.68684 9.5996 7.67842 9.59952C7.03013 9.59289 6.44544 9.33147 6.02776 8.91458C5.7642 8.65151 5.56714 8.32655 5.46255 7.96462C5.40749 7.77406 5.37806 7.57325 5.37806 7.36584C5.37806 6.13215 6.41929 5.13204 7.7037 5.13204C8.98812 5.13204 10.0294 6.13215 10.0294 7.36584ZM8.8218 7.36584C8.8218 7.88723 8.36753 8.3921 7.7037 8.3921C7.03988 8.3921 6.5856 7.88723 6.5856 7.36584C6.5856 6.84445 7.03988 6.33959 7.7037 6.33959C8.36753 6.33959 8.8218 6.84445 8.8218 7.36584Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.92453 12.3858C3.92453 11.3316 4.37509 10.3784 5.10135 9.69433C5.30544 9.50209 5.53131 9.33109 5.77506 9.18506C6.26683 9.64448 6.93822 9.92742 7.67842 9.92742C7.68686 9.92742 7.69529 9.92739 7.7037 9.92731C8.49718 9.9204 9.2098 9.58836 9.70415 9.06316C9.96723 9.19896 10.2123 9.36273 10.4351 9.55034C11.2556 10.2412 11.7736 11.2554 11.7736 12.3858V13.0717C11.7736 13.6886 11.253 14.1886 10.6108 14.1886H5.08735C4.44514 14.1886 3.92453 13.6886 3.92453 13.0717V12.3858ZM5.13208 12.3858C5.13208 11.7407 5.38634 11.1408 5.81983 10.6822C6.37555 10.9719 7.00932 11.135 7.67842 11.135C8.4367 11.135 9.14951 10.9256 9.75485 10.5597C10.2628 11.0311 10.566 11.6822 10.566 12.3858V12.9811H5.13208V12.3858Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Partenaires2 = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.58132 3.07874C6.58132 2.31532 7.21648 1.69645 8 1.69645C8.78352 1.69645 9.41868 2.31532 9.41868 3.07874C9.41868 3.84216 8.78352 4.46104 8 4.46104C7.21648 4.46104 6.58132 3.84216 6.58132 3.07874ZM8 2.45043C7.64386 2.45043 7.35514 2.73173 7.35514 3.07874C7.35514 3.42575 7.64386 3.70706 8 3.70706C8.35614 3.70706 8.64486 3.42575 8.64486 3.07874C8.64486 2.73173 8.35614 2.45043 8 2.45043Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.67568 10.0631C2.89216 10.0631 2.25699 10.6819 2.25699 11.4454C2.25699 12.2088 2.89216 12.8277 3.67568 12.8277C4.45919 12.8277 5.09436 12.2088 5.09436 11.4454C5.09436 10.6819 4.45919 10.0631 3.67568 10.0631ZM3.03082 11.4454C3.03082 11.0984 3.31953 10.817 3.67568 10.817C4.03182 10.817 4.32053 11.0984 4.32053 11.4454C4.32053 11.7924 4.03182 12.0737 3.67568 12.0737C3.31953 12.0737 3.03082 11.7924 3.03082 11.4454Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.3243 10.0631C11.5408 10.0631 10.9056 10.6819 10.9056 11.4454C10.9056 12.2088 11.5408 12.8277 12.3243 12.8277C13.1078 12.8277 13.743 12.2088 13.743 11.4454C13.743 10.6819 13.1078 10.0631 12.3243 10.0631ZM11.6795 11.4454C11.6795 11.0984 11.9682 10.817 12.3243 10.817C12.6805 10.817 12.9692 11.0984 12.9692 11.4454C12.9692 11.7924 12.6805 12.0737 12.3243 12.0737C11.9682 12.0737 11.6795 11.7924 11.6795 11.4454Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.32432 3.5814C4.32432 1.60345 5.96998 0 8 0C10.03 0 11.6757 1.60345 11.6757 3.5814C11.6757 5.46822 10.1782 7.01426 8.27799 7.1527V8.56765L9.74735 9.39422C10.4107 8.75868 11.3205 8.36662 12.3243 8.36662C14.3543 8.36662 16 9.97007 16 11.948C16 13.926 14.3543 15.5294 12.3243 15.5294C10.2943 15.5294 8.64865 13.926 8.64865 11.948C8.64865 11.1902 8.89024 10.4873 9.30249 9.9085L7.99036 9.17037L6.66613 9.86513C7.09747 10.452 7.35135 11.1711 7.35135 11.948C7.35135 13.926 5.7057 15.5294 3.67568 15.5294C1.64566 15.5294 0 13.926 0 11.948C0 9.97007 1.64566 8.36662 3.67568 8.36662C4.6576 8.36662 5.5496 8.74178 6.20893 9.35301L7.59846 8.624V7.14167C5.75734 6.94676 4.32432 5.42714 4.32432 3.5814ZM8 0.879641C6.46858 0.879641 5.22712 2.08926 5.22712 3.5814C5.22712 4.38474 5.58697 5.1062 6.15818 5.60108C6.2677 5.35637 6.46395 5.15479 6.69102 5.00729C7.04297 4.77868 7.5069 4.64953 8 4.64953C8.4931 4.64953 8.95703 4.77868 9.30898 5.00729C9.53605 5.15479 9.7323 5.35637 9.84182 5.60108C10.413 5.1062 10.7729 4.38474 10.7729 3.5814C10.7729 2.08926 9.53142 0.879641 8 0.879641ZM9.16946 6.03182H9.16074C9.16074 5.91948 9.09063 5.77163 8.87974 5.63464C8.67154 5.49941 8.36164 5.40351 8 5.40351C7.63836 5.40351 7.32846 5.49941 7.12027 5.63464C6.90937 5.77163 6.83926 5.91948 6.83926 6.03182H6.83054C7.18589 6.1931 7.58215 6.28315 8 6.28315C8.41785 6.28315 8.81411 6.1931 9.16946 6.03182ZM0.902798 11.948C0.902798 10.4559 2.14426 9.24626 3.67568 9.24626C5.20709 9.24626 6.44855 10.4559 6.44855 11.948C6.44855 12.7514 6.08871 13.4728 5.5175 13.9677C5.40797 13.723 5.21172 13.5214 4.98465 13.3739C4.6327 13.1453 4.16878 13.0162 3.67568 13.0162C3.18257 13.0162 2.71865 13.1453 2.3667 13.3739C2.13963 13.5214 1.94338 13.723 1.83386 13.9677C1.26265 13.4728 0.902798 12.7514 0.902798 11.948ZM4.83642 14.3984H4.84513C4.48978 14.5597 4.09352 14.6498 3.67568 14.6498C3.25783 14.6498 2.86157 14.5597 2.50622 14.3984H2.51494C2.51494 14.2861 2.58504 14.1383 2.79594 14.0013C3.00413 13.866 3.31404 13.7701 3.67568 13.7701C4.03732 13.7701 4.34722 13.866 4.55541 14.0013C4.76631 14.1383 4.83642 14.2861 4.83642 14.3984ZM9.55145 11.948C9.55145 10.4559 10.7929 9.24626 12.3243 9.24626C13.8557 9.24626 15.0972 10.4559 15.0972 11.948C15.0972 12.7514 14.7374 13.4728 14.1661 13.9677C14.0566 13.723 13.8604 13.5214 13.6333 13.3739C13.2814 13.1453 12.8174 13.0162 12.3243 13.0162C11.8312 13.0162 11.3673 13.1453 11.0153 13.3739C10.7883 13.5214 10.592 13.723 10.4825 13.9677C9.9113 13.4728 9.55145 12.7514 9.55145 11.948ZM13.4851 14.3984H13.4938C13.1384 14.5597 12.7422 14.6498 12.3243 14.6498C11.9065 14.6498 11.5102 14.5597 11.1549 14.3984H11.1636C11.1636 14.2861 11.2337 14.1383 11.4446 14.0013C11.6528 13.866 11.9627 13.7701 12.3243 13.7701C12.686 13.7701 12.9959 13.866 13.2041 14.0013C13.415 14.1383 13.4851 14.2861 13.4851 14.3984Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Pause = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.002 2.63232C2.81481 2.63232 2.63232 2.79291 2.63232 3.02938V12.9706C2.63232 13.207 2.81481 13.3676 3.002 13.3676H5.61458C5.80176 13.3676 5.98425 13.207 5.98425 12.9706V3.02938C5.98425 2.79291 5.80176 2.63232 5.61458 2.63232H3.002ZM1.13232 3.02938C1.13232 1.99885 1.95243 1.13232 3.002 1.13232H5.61458C6.66415 1.13232 7.48425 1.99885 7.48425 3.02938V12.9706C7.48425 14.0011 6.66415 14.8676 5.61458 14.8676H3.002C1.95243 14.8676 1.13232 14.0011 1.13232 12.9706V3.02938ZM10.3854 2.63232C10.1982 2.63232 10.0157 2.79291 10.0157 3.02938V12.9706C10.0157 13.207 10.1982 13.3676 10.3854 13.3676H12.9979C13.1851 13.3676 13.3676 13.207 13.3676 12.9706V3.02938C13.3676 2.79291 13.1851 2.63232 12.9979 2.63232H10.3854ZM8.51569 3.02938C8.51569 1.99885 9.33579 1.13232 10.3854 1.13232H12.9979C14.0475 1.13232 14.8676 1.99885 14.8676 3.02938V12.9706C14.8676 14.0011 14.0475 14.8676 12.9979 14.8676H10.3854C9.33579 14.8676 8.51569 14.0011 8.51569 12.9706V3.02938Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const PC1 = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M15 10.2083C15 10.2083 15 10.8814 14.5269 11.3574C14.5269 11.3574 14.0537 11.8333 13.3846 11.8333H8.53846V12.9167H10.1538C10.4512 12.9167 10.6923 13.1592 10.6923 13.4583C10.6923 13.7575 10.4512 14 10.1538 14H5.84615C5.54877 14 5.30769 13.7575 5.30769 13.4583C5.30769 13.1592 5.54877 12.9167 5.84615 12.9167H7.46154V11.8333H2.61538C2.61538 11.8333 1.94627 11.8333 1.47313 11.3574C1.47313 11.3574 1 10.8814 1 10.2083V3.5C1 3.5 1 2.8269 1.47313 2.35095C1.47313 2.35095 1.94627 1.875 2.61538 1.875H13.3846C13.3846 1.875 14.0537 1.875 14.5269 2.35095C14.5269 2.35095 15 2.8269 15 3.5V10.2083ZM2.61538 10.75C2.39235 10.75 2.23464 10.5914 2.23464 10.5914C2.07692 10.4327 2.07692 10.2083 2.07692 10.2083V3.5C2.07692 3.27564 2.23464 3.11698 2.23464 3.11698C2.39235 2.95833 2.61538 2.95833 2.61538 2.95833H13.3846C13.6077 2.95833 13.7654 3.11698 13.7654 3.11698C13.9231 3.27563 13.9231 3.5 13.9231 3.5V10.2083C13.9231 10.4327 13.7654 10.5914 13.7654 10.5914C13.6077 10.75 13.3846 10.75 13.3846 10.75H2.61538Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const PC = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2.07692 3C1.81258 3 1.59829 3.2296 1.59829 3.51282V10.4359C1.59829 10.7191 1.81258 10.9487 2.07692 10.9487H13.6838C13.9481 10.9487 14.1624 10.7191 14.1624 10.4359V3.51282C14.1624 3.2296 13.9481 3 13.6838 3H2.07692ZM2.55556 4.02564V9.92308H13.2051V4.02564H2.55556Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1.47863 11.2051C1.21429 11.2051 1 11.4347 1 11.7179V12.4872C1 12.7704 1.21429 13 1.47863 13H14.5214C14.7857 13 15 12.7704 15 12.4872V11.7179C15 11.4347 14.7857 11.2051 14.5214 11.2051H1.47863ZM1.71795 11.9744V12.2308H14.2821V11.9744H9.37607C9.37607 12.0452 9.3225 12.1026 9.25641 12.1026H6.26496C6.19887 12.1026 6.1453 12.0452 6.1453 11.9744H1.71795Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const PDF = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1.375 2C1.375 1.10254 2.10254 0.375 3 0.375H9.01938C9.51302 0.375 9.97991 0.599396 10.2883 0.984871L11.9941 3.11719L13.3 4.85833C13.511 5.13961 13.625 5.48173 13.625 5.83333V9C13.625 9.34518 13.3452 9.625 13 9.625C12.6548 9.625 12.375 9.34518 12.375 9V6.19527L8.19208 6.19534C8.04429 6.19534 7.90408 6.12996 7.80907 6.01676C7.71407 5.90356 7.67401 5.75413 7.69965 5.60859L8.40145 1.625H3C2.79289 1.625 2.625 1.79289 2.625 2V9C2.625 9.34518 2.34518 9.625 2 9.625C1.65482 9.625 1.375 9.34518 1.375 9V2ZM12.375 5.19533H8.78785L9.34198 1.625L12.375 5.19533Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2 14.44V11.08C2 10.7707 2.23359 10.52 2.52174 10.52H3.56522C3.56522 10.52 4.21355 10.52 4.67199 11.0121C4.67199 11.0121 5.13043 11.5041 5.13043 12.2C5.13043 12.2 5.13043 12.8959 4.67199 13.388C4.67199 13.388 4.21355 13.88 3.56522 13.88H3.04348V14.44C3.04348 14.7493 2.80989 15 2.52174 15C2.23359 15 2 14.7493 2 14.44ZM3.56522 12.76H3.04348V11.64H3.56522C3.56522 11.64 3.78133 11.64 3.93414 11.804C3.93414 11.804 4.08696 11.9681 4.08696 12.2C4.08696 12.2 4.08696 12.432 3.93414 12.596C3.93414 12.596 3.78133 12.76 3.56522 12.76Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M11.1304 14.44C11.1304 14.7493 11.364 15 11.6522 15C11.9403 15 12.1739 14.7493 12.1739 14.44V13.6H13.2174C13.5055 13.6 13.7391 13.3493 13.7391 13.04C13.7391 12.7307 13.5055 12.48 13.2174 12.48H12.1739V11.64H13.4783C13.7664 11.64 14 11.3893 14 11.08C14 10.7707 13.7664 10.52 13.4783 10.52H11.6522C11.364 10.52 11.1304 10.7707 11.1304 11.08V14.44Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.82609 15C6.53794 15 6.30435 14.7493 6.30435 14.44V11.08C6.30435 10.7707 6.53794 10.52 6.82609 10.52H7.73913C7.73913 10.52 8.60358 10.52 9.21483 11.1761C9.21483 11.1761 9.82609 11.8322 9.82609 12.76C9.82609 12.76 9.82609 13.6879 9.21483 14.3439C9.21483 14.3439 8.60358 15 7.73913 15H6.82609ZM7.73913 13.88H7.34783V11.64H7.73913C7.73913 11.64 8.17135 11.64 8.47698 11.9681C8.47698 11.9681 8.78261 12.2961 8.78261 12.76C8.78261 12.76 8.78261 13.2239 8.47698 13.552C8.47698 13.552 8.17135 13.88 7.73913 13.88Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const PJ = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M3.44444 0C2.09442 0 1 0.997441 1 2.22785V13.5696C1 14.8 2.09442 15.7975 3.44444 15.7975H6.33333C6.70152 15.7975 7 15.5254 7 15.1899C7 14.8543 6.70152 14.5823 6.33333 14.5823H3.44444C2.83079 14.5823 2.33333 14.1289 2.33333 13.5696V2.22785C2.33333 1.66857 2.83079 1.21519 3.44444 1.21519H12.3333C12.947 1.21519 13.4444 1.66857 13.4444 2.22785V8.3038C13.4444 8.63936 13.7429 8.91139 14.1111 8.91139C14.4793 8.91139 14.7778 8.63936 14.7778 8.3038V2.22785C14.7778 0.997442 13.6834 0 12.3333 0H3.44444Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M14.3382 10.1413C13.4701 9.29762 12.079 9.31382 11.2311 10.1775L9.09639 12.3518C9.08194 12.3665 9.06903 12.3821 9.05765 12.3985L8.33753 13.1572C7.71428 13.8138 7.74404 14.8488 8.404 15.469C9.06083 16.0861 10.0951 16.0602 10.7198 15.4108L12.7508 13.2997L13.3485 12.705C13.7545 12.301 13.7545 11.6461 13.3485 11.2421C12.9438 10.8395 12.2882 10.838 11.8817 11.2387L9.71745 13.3721C9.57658 13.5109 9.57552 13.7371 9.71508 13.8773C9.85464 14.0174 10.082 14.0185 10.2228 13.8796L12.3871 11.7463C12.5128 11.6223 12.7156 11.6228 12.8407 11.7473C12.9663 11.8723 12.9663 12.0748 12.8407 12.1998L12.7725 12.2676C12.7412 12.2847 12.7119 12.3068 12.6859 12.3339L12.2375 12.8L12.0131 13.0232C11.994 13.0422 11.9775 13.0629 11.9636 13.0847L10.2011 14.9168C9.84932 15.2824 9.2669 15.297 8.89705 14.9495C8.52543 14.6003 8.50867 14.0175 8.85962 13.6478L9.63945 12.8262C9.64988 12.8152 9.65947 12.8037 9.66822 12.7918L11.7448 10.6768C12.3156 10.0954 13.252 10.0845 13.8364 10.6524C14.4207 11.2203 14.4317 12.1521 13.8609 12.7335L11.2496 15.3931C11.111 15.5343 11.1137 15.7604 11.2556 15.8983C11.3974 16.0362 11.6247 16.0335 11.7633 15.8924L14.3745 13.2327C15.2225 12.3691 15.2062 10.985 14.3382 10.1413Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M4.33333 3.44304C4.33333 3.21933 4.53232 3.03797 4.77778 3.03797H11C11.2455 3.03797 11.4444 3.21933 11.4444 3.44304C11.4444 3.66675 11.2455 3.8481 11 3.8481H4.77778C4.53232 3.8481 4.33333 3.66675 4.33333 3.44304Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M4.77778 5.46835C4.53232 5.46835 4.33333 5.64971 4.33333 5.87342C4.33333 6.09713 4.53232 6.27848 4.77778 6.27848H11C11.2455 6.27848 11.4444 6.09713 11.4444 5.87342C11.4444 5.64971 11.2455 5.46835 11 5.46835H4.77778Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M4.33333 8.3038C4.33333 8.08009 4.53232 7.89873 4.77778 7.89873H11C11.2455 7.89873 11.4444 8.08009 11.4444 8.3038C11.4444 8.52751 11.2455 8.70886 11 8.70886H4.77778C4.53232 8.70886 4.33333 8.52751 4.33333 8.3038Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M4.77778 10.3291C4.53232 10.3291 4.33333 10.5105 4.33333 10.7342C4.33333 10.9579 4.53232 11.1392 4.77778 11.1392H8.45261C8.69806 11.1392 8.89705 10.9579 8.89705 10.7342C8.89705 10.5105 8.69806 10.3291 8.45261 10.3291H4.77778Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Planning = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M7.76471 2.35294C8.15455 2.35294 8.47059 2.66898 8.47059 3.05882V7.52941L11.5294 7.52941C11.9193 7.52941 12.2353 7.84545 12.2353 8.23529C12.2353 8.62514 11.9193 8.94118 11.5294 8.94118H7.76471C7.37486 8.94118 7.05882 8.62514 7.05882 8.23529V3.05882C7.05882 2.66898 7.37486 2.35294 7.76471 2.35294Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM14.1176 8C14.1176 11.3787 11.3787 14.1176 8 14.1176C4.62132 14.1176 1.88235 11.3787 1.88235 8C1.88235 4.62132 4.62132 1.88235 8 1.88235C11.3787 1.88235 14.1176 4.62132 14.1176 8Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Plus$1 = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M7.8 4C8.35228 4 8.8 4.44772 8.8 5V6.8H10.6C11.1523 6.8 11.6 7.24772 11.6 7.8C11.6 8.35228 11.1523 8.8 10.6 8.8H8.8V10.6C8.8 11.1523 8.35229 11.6 7.8 11.6C7.24772 11.6 6.8 11.1523 6.8 10.6V8.8L5 8.8C4.44772 8.8 4 8.35228 4 7.8C4 7.24771 4.44772 6.8 5 6.8L6.8 6.8V5C6.8 4.44772 7.24772 4 7.8 4Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M15.6 7.8C15.6 12.1078 12.1078 15.6 7.8 15.6C3.49218 15.6 0 12.1078 0 7.8C0 3.49218 3.49218 0 7.8 0C12.1078 0 15.6 3.49218 15.6 7.8ZM13.65 7.8C13.65 11.0309 11.0309 13.65 7.8 13.65C4.56913 13.65 1.95 11.0309 1.95 7.8C1.95 4.56913 4.56913 1.95 7.8 1.95C11.0309 1.95 13.65 4.56913 13.65 7.8Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Polkadot = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M3.5 6.33325C3.5 3.87606 5.54281 1.83325 8 1.83325C10.4572 1.83325 12.5 3.87606 12.5 6.33325C12.5 8.79044 10.4572 10.8333 8 10.8333L8.11458 10.8602C8.03672 10.8419 8 10.8333 8 10.8333L7.99912 10.8333L7.99807 10.8333L7.99547 10.8333L7.98828 10.8333L7.96621 10.8338C7.94817 10.8343 7.92354 10.8352 7.89305 10.8369C7.83216 10.8404 7.74744 10.8471 7.6449 10.8602C7.44089 10.8863 7.16045 10.9384 6.85413 11.0437C6.65248 11.1131 6.43489 11.2073 6.21912 11.335L7.16164 4.7373C7.20069 4.46393 7.01074 4.21066 6.73738 4.17161C6.46401 4.13256 6.21074 4.32251 6.17169 4.59587L4.99756 12.8148C4.8847 13.1723 4.83333 13.57 4.83333 13.9999C4.83333 14.2623 5.03616 14.4801 5.29789 14.4987C5.55962 14.5173 5.7912 14.3304 5.82831 14.0706L5.97468 13.046C5.98073 13.0292 5.98695 13.0126 5.99334 12.9963C6.25122 12.4383 6.72542 12.1454 7.17921 11.9894C7.40621 11.9114 7.61744 11.8719 7.77177 11.8521C7.84839 11.8423 7.90951 11.8376 7.94966 11.8353C7.96969 11.8342 7.98438 11.8337 7.99303 11.8334L8.00135 11.8333C11.0101 11.8324 13.5 9.34222 13.5 6.33325C13.5 3.32378 11.0095 0.833252 8 0.833252C4.99052 0.833252 2.5 3.32378 2.5 6.33325C2.5 7.27603 2.71769 8.1679 3.17125 8.92383C3.31333 9.16062 3.62046 9.2374 3.85725 9.09533C4.09404 8.95326 4.17082 8.64613 4.02875 8.40934C3.68231 7.83194 3.5 7.1238 3.5 6.33325Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M8.66667 13.9999C8.66667 14.3681 8.96514 14.6666 9.33333 14.6666C9.70152 14.6666 10 14.3681 10 13.9999C10 13.6317 9.70152 13.3333 9.33333 13.3333C8.96514 13.3333 8.66667 13.6317 8.66667 13.9999Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Polygon = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M5.17962 2.0706C5.02088 1.97647 4.82526 1.97647 4.66652 2.0706L1.5896 3.89516C1.43101 3.9892 1.33333 4.16291 1.33333 4.35088V8.00002C1.33333 8.18799 1.43101 8.3617 1.5896 8.45574L4.66652 10.2803C4.82526 10.3744 5.02088 10.3744 5.17962 10.2803L8.25655 8.45574C8.25813 8.4548 8.25971 8.45385 8.26129 8.45289L11.0769 6.78327L13.641 8.30374V11.3454L11.0769 12.8658L8.51281 11.3454V10.4561C8.51281 10.1655 8.28322 9.92981 7.99999 9.92981C7.71677 9.92981 7.48717 10.1655 7.48717 10.4561V11.6491C7.48717 11.8371 7.58486 12.0108 7.74344 12.1048L10.8204 13.9294C10.9791 14.0235 11.1747 14.0235 11.3335 13.9294L14.4104 12.1048C14.569 12.0108 14.6667 11.8371 14.6667 11.6491V7.99998C14.6667 7.81201 14.569 7.6383 14.4104 7.54426L11.3335 5.7197C11.1747 5.62557 10.9791 5.62557 10.8204 5.7197L7.74344 7.54426C7.74186 7.5452 7.74028 7.54615 7.7387 7.54711L4.92307 9.21673L2.35897 7.69626V4.65464L4.92307 3.13417L7.48717 4.65464V5.47369C7.48717 5.76437 7.71677 6.00001 7.99999 6.00001C8.28322 6.00001 8.51281 5.76437 8.51281 5.47369V4.35088C8.51281 4.16291 8.41513 3.9892 8.25655 3.89516L5.17962 2.0706Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Polyswarm = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M6.33332 1.6333C6.05718 1.6333 5.83332 1.85716 5.83332 2.1333C5.83332 2.40944 6.05718 2.6333 6.33332 2.6333H9.66666C11.9285 2.6333 13.8333 4.48074 13.8333 6.79997C13.8333 9.06181 11.9859 10.9666 9.66666 10.9666H2.33332C2.05718 10.9666 1.83332 11.1905 1.83332 11.4666C1.83332 11.7428 2.05718 11.9666 2.33332 11.9666H9.66666C12.5474 11.9666 14.8333 9.60479 14.8333 6.79997C14.8333 3.91919 12.4715 1.6333 9.66666 1.6333H6.33332Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M2.13332 4.03337C1.85718 4.03337 1.63332 4.25722 1.63332 4.53337C1.63332 4.80951 1.85718 5.03337 2.13332 5.03337H9.19999C10.2572 5.03337 11.1667 5.94284 11.1667 7.00003C11.1667 8.05722 10.2572 8.9667 9.19999 8.9667H5.33332C5.05718 8.9667 4.83332 9.19056 4.83332 9.4667C4.83332 9.74284 5.05718 9.9667 5.33332 9.9667H9.19999C10.8095 9.9667 12.1667 8.60951 12.1667 7.00003C12.1667 5.39056 10.8095 4.03337 9.19999 4.03337H2.13332Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M3.16666 7.20003C3.16666 6.92389 3.39051 6.70003 3.66666 6.70003H5.66666C5.9428 6.70003 6.16666 6.92389 6.16666 7.20003C6.16666 7.47617 5.9428 7.70003 5.66666 7.70003H3.66666C3.39051 7.70003 3.16666 7.47617 3.16666 7.20003Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M1.66666 13.3667C1.39051 13.3667 1.16666 13.5906 1.16666 13.8667C1.16666 14.1428 1.39051 14.3667 1.66666 14.3667H4.33332C4.60947 14.3667 4.83332 14.1428 4.83332 13.8667C4.83332 13.5906 4.60947 13.3667 4.33332 13.3667H1.66666Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Poubelle = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M6.27272 5.55102C6.91361 5.55102 7.43315 6.0627 7.43315 6.69388L7.43315 12.2449C7.43315 12.8761 6.91361 13.3878 6.27272 13.3878C5.63183 13.3878 5.11229 12.8761 5.11229 12.2449L5.11229 6.69388C5.11229 6.0627 5.63183 5.55102 6.27272 5.55102Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M10.7487 6.69388C10.7487 6.0627 10.2291 5.55102 9.58823 5.55102C8.94734 5.55102 8.4278 6.0627 8.4278 6.69388L8.4278 12.2449C8.4278 12.8761 8.94734 13.3878 9.58823 13.3878C10.2291 13.3878 10.7487 12.8761 10.7487 12.2449L10.7487 6.69388Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.28342 0C3.64253 0 3.12299 0.511675 3.12299 1.14286C3.12299 1.19829 3.12699 1.2528 3.13474 1.30612H1.63101C0.990122 1.30612 0.470581 1.8178 0.470581 2.44898C0.470581 3.08016 0.990122 3.59184 1.63101 3.59184H1.79678V14.6939C1.79678 15.4152 2.39055 16 3.12299 16H12.4064C13.1389 16 13.7326 15.4152 13.7326 14.6939V3.59184H13.8984C14.5393 3.59184 15.0588 3.08016 15.0588 2.44898C15.0588 1.8178 14.5393 1.30612 13.8984 1.30612H12.3947C12.4024 1.2528 12.4064 1.19829 12.4064 1.14286C12.4064 0.511675 11.8869 0 11.246 0H4.28342ZM3.78609 4.2449V14.0408H11.7433V4.2449H3.78609Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Pouvoirs2 = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.05131 4.22184C6.08636 4.06764 6.10482 3.90749 6.10482 3.7432C6.10482 2.50951 5.06359 1.5094 3.77918 1.5094C2.49476 1.5094 1.45353 2.50951 1.45353 3.7432C1.45353 3.95061 1.48296 4.15142 1.53803 4.34198C1.64261 4.7039 1.83967 5.02887 2.10323 5.29193C2.52091 5.70883 3.1056 5.97024 3.7539 5.97687C3.76231 5.97696 3.77074 5.977 3.77918 5.977C4.47952 5.977 5.10755 5.67967 5.53392 5.20925C5.78537 4.93181 5.96668 4.59418 6.05131 4.22184ZM3.77918 4.76946C4.443 4.76946 4.89727 4.26459 4.89727 3.7432C4.89727 3.22181 4.443 2.71695 3.77918 2.71695C3.11535 2.71695 2.66108 3.22181 2.66108 3.7432C2.66108 4.26459 3.11535 4.76946 3.77918 4.76946Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M1.17682 6.07169C0.450565 6.7558 0 7.70895 0 8.76318V9.4491C0 10.066 0.520613 10.566 1.16282 10.566H3.48287C3.70214 10.12 3.9926 9.71291 4.34008 9.35846H1.20755V8.76318C1.20755 8.11807 1.46181 7.51817 1.8953 7.05954C2.45102 7.34925 3.08479 7.51233 3.7539 7.51233C4.12707 7.51233 4.48923 7.46162 4.83299 7.3665C4.83113 7.3263 4.83019 7.28588 4.83019 7.24525C4.83019 6.75814 4.96549 6.30098 5.20244 5.90565C4.78926 6.15454 4.30175 6.30012 3.77918 6.30467C3.77076 6.30475 3.76233 6.30478 3.7539 6.30478C3.0137 6.30478 2.3423 6.02184 1.85054 5.56242C1.60678 5.70844 1.38092 5.87944 1.17682 6.07169Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14.2023 4.22184C14.2373 4.06764 14.2558 3.90749 14.2558 3.7432C14.2558 2.50951 13.2145 1.5094 11.9301 1.5094C10.6457 1.5094 9.60447 2.50951 9.60447 3.7432C9.60447 3.95061 9.6339 4.15142 9.68897 4.34198C9.79356 4.7039 9.99062 5.02887 10.2542 5.29193C10.6719 5.70883 11.2565 5.97024 11.9048 5.97687C11.9133 5.97696 11.9217 5.977 11.9301 5.977C12.6305 5.977 13.2585 5.67967 13.6849 5.20925C13.9363 4.93181 14.1176 4.59418 14.2023 4.22184ZM11.9301 4.76946C12.5939 4.76946 13.0482 4.26459 13.0482 3.7432C13.0482 3.22181 12.5939 2.71695 11.9301 2.71695C11.2663 2.71695 10.812 3.22181 10.812 3.7432C10.812 4.26459 11.2663 4.76946 11.9301 4.76946Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M9.96707 5.58327C10.3426 6.04269 10.566 6.61924 10.566 7.24525C10.566 7.25849 10.5659 7.27171 10.5657 7.2849C10.985 7.43235 11.4363 7.51233 11.9048 7.51233C12.6631 7.51233 13.3759 7.30293 13.9813 6.9371C14.4892 7.40848 14.7925 8.05956 14.7925 8.76318V9.35846H11.358C11.7055 9.71291 11.996 10.12 12.2152 10.566H14.8372C15.4794 10.566 16 10.066 16 9.4491V8.76318C16 7.63279 15.482 6.61861 14.6615 5.9277C14.4387 5.74009 14.1936 5.57631 13.9306 5.44052C13.4362 5.96571 12.7236 6.29776 11.9301 6.30467C11.9217 6.30475 11.9133 6.30478 11.9048 6.30478C11.1646 6.30478 10.4932 6.02184 10.0015 5.56242C9.98997 5.56931 9.9785 5.57626 9.96707 5.58327Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.0294 7.36584C10.0294 7.53013 10.0109 7.69028 9.97584 7.84448C9.89121 8.21682 9.7099 8.55446 9.45845 8.83189C9.03208 9.30231 8.40404 9.59965 7.7037 9.59965C7.69527 9.59965 7.68684 9.5996 7.67842 9.59952C7.03013 9.59289 6.44544 9.33147 6.02776 8.91458C5.7642 8.65151 5.56714 8.32655 5.46255 7.96462C5.40749 7.77406 5.37806 7.57325 5.37806 7.36584C5.37806 6.13215 6.41929 5.13204 7.7037 5.13204C8.98812 5.13204 10.0294 6.13215 10.0294 7.36584ZM8.8218 7.36584C8.8218 7.88723 8.36753 8.3921 7.7037 8.3921C7.03988 8.3921 6.5856 7.88723 6.5856 7.36584C6.5856 6.84445 7.03988 6.33959 7.7037 6.33959C8.36753 6.33959 8.8218 6.84445 8.8218 7.36584Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.92453 12.3858C3.92453 11.3316 4.37509 10.3784 5.10135 9.69433C5.30544 9.50209 5.53131 9.33109 5.77506 9.18506C6.26683 9.64448 6.93822 9.92742 7.67842 9.92742C7.68686 9.92742 7.69529 9.92739 7.7037 9.92731C8.49718 9.9204 9.2098 9.58836 9.70415 9.06316C9.96723 9.19896 10.2123 9.36273 10.4351 9.55034C11.2556 10.2412 11.7736 11.2554 11.7736 12.3858V13.0717C11.7736 13.6886 11.253 14.1886 10.6108 14.1886H5.08735C4.44514 14.1886 3.92453 13.6886 3.92453 13.0717V12.3858ZM5.13208 12.3858C5.13208 11.7407 5.38634 11.1408 5.81983 10.6822C6.37555 10.9719 7.00932 11.135 7.67842 11.135C8.4367 11.135 9.14951 10.9256 9.75485 10.5597C10.2628 11.0311 10.566 11.6822 10.566 12.3858V12.9811H5.13208V12.3858Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Profil2 = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.7333 3.64502C11.7333 5.65811 10.0619 7.29004 8 7.29004C5.93814 7.29004 4.26667 5.65811 4.26667 3.64502C4.26667 1.63193 5.93814 0 8 0C10.0619 0 11.7333 1.63193 11.7333 3.64502ZM10.1778 3.64502C10.1778 4.81932 9.20275 5.77128 8 5.77128C6.79725 5.77128 5.82222 4.81932 5.82222 3.64502C5.82222 2.47072 6.79725 1.51876 8 1.51876C9.20275 1.51876 10.1778 2.47072 10.1778 3.64502Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.6001 7.09461C11.2546 6.94314 10.8476 7.05663 10.6362 7.3634C10.169 8.04124 9.19752 8.56872 8 8.56872C6.80247 8.56872 5.83096 8.04124 5.36379 7.3634C5.15236 7.05663 4.74536 6.94314 4.39988 7.09461C2.39723 7.97265 1 9.93775 1 12.2231V13.0256C1 14.116 1.90538 15 3.02222 15H12.9778C14.0946 15 15 14.116 15 13.0256V12.2231C15 9.93774 13.6028 7.97265 11.6001 7.09461ZM8 10.0875C9.36512 10.0875 10.6309 9.5871 11.4762 8.7485C12.6596 9.47461 13.4444 10.76 13.4444 12.2231V13.0256C13.4444 13.2773 13.2355 13.4812 12.9778 13.4812H3.02222C2.76449 13.4812 2.55556 13.2773 2.55556 13.0256V12.2231C2.55556 10.76 3.34043 9.47461 4.52375 8.7485C5.36904 9.5871 6.63487 10.0875 8 10.0875Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Profil3 = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.87295 1C5.96043 1 4.41961 2.54082 4.41961 4.45334C4.41961 6.32418 5.89205 7.83917 7.74108 7.90616C7.78341 7.90769 7.82578 7.90577 7.86776 7.90041C7.90788 7.90553 7.94835 7.90752 7.98881 7.90634C9.84822 7.85245 11.313 6.31943 11.3263 4.45889L11.3263 4.45334C11.3263 2.55315 9.78743 1 7.87295 1ZM5.97517 4.45334C5.97517 3.39993 6.81954 2.55556 7.87295 2.55556C8.92346 2.55556 9.76923 3.40682 9.77072 4.45056C9.762 5.47408 8.97415 6.29311 7.99648 6.34917C7.91255 6.3415 7.82651 6.3414 7.74253 6.34885C6.75516 6.28481 5.97517 5.46748 5.97517 4.45334Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.8766 9.14651C11.5021 8.54273 9.73309 8.25926 8.00588 8.25926C6.2784 8.25926 4.5063 8.54282 3.12507 9.14579L3.12343 9.14651C1.94429 9.6645 1 10.4993 1 11.6258C1 12.7522 1.94429 13.587 3.12343 14.105C4.5052 14.7139 6.27338 15 8 15C9.72662 15 11.4956 14.7135 12.8774 14.1046C14.0565 13.5866 15 12.7522 15 11.6258C15 10.4993 14.0557 9.6645 12.8766 9.14651ZM2.55556 11.6258C2.55556 11.4708 2.71683 11.0244 3.74828 10.571C4.87626 10.0788 6.42073 9.81481 8.00588 9.81481C9.5917 9.81481 11.1318 10.0791 12.2509 10.5707C13.2831 11.0241 13.4444 11.4708 13.4444 11.6258C13.4444 11.7807 13.2831 12.2274 12.2509 12.6808C11.1234 13.1777 9.58249 13.4444 8 13.4444C6.41751 13.4444 4.8774 13.178 3.74989 12.6812C2.71773 12.2277 2.55556 11.7807 2.55556 11.6258Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Protocole = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M7.21567 4.3871C7.21567 3.95952 7.60194 3.6129 8.07842 3.6129H12.1046C12.581 3.6129 12.9673 3.95952 12.9673 4.3871C12.9673 4.81467 12.581 5.16129 12.1046 5.16129H8.07842C7.60194 5.16129 7.21567 4.81467 7.21567 4.3871Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M8.07842 7.22581C7.60194 7.22581 7.21567 7.57242 7.21567 8C7.21567 8.42758 7.60194 8.77419 8.07842 8.77419H12.1046C12.581 8.77419 12.9673 8.42758 12.9673 8C12.9673 7.57242 12.581 7.22581 12.1046 7.22581H8.07842Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M7.21567 11.6129C7.21567 11.1853 7.60194 10.8387 8.07842 10.8387H12.1046C12.581 10.8387 12.9673 11.1853 12.9673 11.6129C12.9673 12.0405 12.581 12.3871 12.1046 12.3871H8.07842C7.60194 12.3871 7.21567 12.0405 7.21567 11.6129Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M6.48461 3.84388C6.61385 3.67233 6.57772 3.42984 6.40392 3.30227C6.23012 3.17471 5.98447 3.21037 5.85523 3.38192L4.93562 4.60268L4.32884 4.10567C4.16216 3.96916 3.91493 3.99186 3.77663 4.15638C3.63832 4.3209 3.66132 4.56494 3.828 4.70146L4.75308 5.45919C4.83591 5.52703 4.94335 5.55828 5.05021 5.54563C5.15708 5.53298 5.25397 5.47753 5.3182 5.39227L6.48461 3.84388Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M6.40392 6.91518C6.57772 7.04274 6.61385 7.28523 6.48461 7.45679L5.3182 9.00517C5.25397 9.09043 5.15708 9.14588 5.05021 9.15854C4.94335 9.17119 4.83591 9.13993 4.75308 9.07209L3.828 8.31437C3.66132 8.17785 3.63832 7.9338 3.77663 7.76928C3.91493 7.60476 4.16216 7.58206 4.32884 7.71858L4.93562 8.21558L5.85523 6.99482C5.98447 6.82327 6.23012 6.78761 6.40392 6.91518Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M6.48461 11.0697C6.61385 10.8981 6.57772 10.6556 6.40392 10.5281C6.23012 10.4005 5.98447 10.4362 5.85523 10.6077L4.93562 11.8285L4.32884 11.3315C4.16216 11.195 3.91493 11.2177 3.77663 11.3822C3.63832 11.5467 3.66132 11.7908 3.828 11.9273L4.75308 12.685C4.83591 12.7528 4.94335 12.7841 5.05021 12.7714C5.15708 12.7588 5.25397 12.7033 5.3182 12.6181L6.48461 11.0697Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1.98691 0C1.40936 0 0.941162 0.462158 0.941162 1.03226V14.9677C0.941162 15.5378 1.40936 16 1.98691 16H14.0131C14.5906 16 15.0588 15.5378 15.0588 14.9677V1.03226C15.0588 0.462158 14.5906 0 14.0131 0H1.98691ZM2.50979 1.54839V14.4516H13.4902V1.54839H2.50979Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Previsualisation = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M6.25 8.06668C6.12918 7.94702 6.12918 7.75301 6.25 7.63335L7.5625 6.33334L6.25 5.03334C6.12918 4.91368 6.12918 4.71967 6.25 4.6C6.37081 4.48034 6.56668 4.48034 6.6875 4.6L8 5.90001L9.3125 4.6C9.43332 4.48034 9.62919 4.48034 9.75 4.6C9.87082 4.71967 9.87082 4.91368 9.75 5.03334L8.4375 6.33334L9.75 7.63335C9.87082 7.75301 9.87082 7.94702 9.75 8.06668C9.62919 8.18634 9.43332 8.18634 9.3125 8.06668L8 6.76668L6.6875 8.06668C6.56668 8.18634 6.37081 8.18634 6.25 8.06668Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14.5269 12.3574C15 11.8814 15 11.2083 15 11.2083V3.625C15 2.9519 14.5269 2.47595 14.5269 2.47595C14.0537 2 13.3846 2 13.3846 2H2.61538C1.94627 2 1.47313 2.47595 1.47313 2.47595C1 2.9519 1 3.625 1 3.625V11.2083C1 11.8814 1.47313 12.3574 1.47313 12.3574C1.94627 12.8333 2.61538 12.8333 2.61538 12.8333H7.46154V13.9167H5.84615C5.54877 13.9167 5.30769 14.1592 5.30769 14.4583C5.30769 14.7575 5.54877 15 5.84615 15H10.1538C10.4512 15 10.6923 14.7575 10.6923 14.4583C10.6923 14.1592 10.4512 13.9167 10.1538 13.9167H8.53846V12.8333H13.3846C14.0537 12.8333 14.5269 12.3574 14.5269 12.3574ZM2.61538 11.75C2.39235 11.75 2.23464 11.5913 2.23464 11.5913C2.07692 11.4327 2.07692 11.2083 2.07692 11.2083V10.125H13.9231V11.2083C13.9231 11.4327 13.7654 11.5913 13.7654 11.5913C13.6077 11.75 13.3846 11.75 13.3846 11.75H2.61538ZM13.9231 3.625V9.04167H2.07692V3.625C2.07692 3.40064 2.23464 3.24198 2.23464 3.24198C2.39235 3.08333 2.61538 3.08333 2.61538 3.08333H13.3846C13.6077 3.08333 13.7654 3.24198 13.7654 3.24198C13.9231 3.40063 13.9231 3.625 13.9231 3.625Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Puzzle = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M22.6666 29.3333H6.66663C5.60576 29.3333 4.58834 28.9119 3.8382 28.1617C3.08805 27.4116 2.66663 26.3942 2.66663 25.3333V12C2.66663 10.9391 3.08805 9.92167 3.8382 9.17153C4.58834 8.42138 5.60576 7.99995 6.66663 7.99995H7.99996C8.02239 6.87014 8.40309 5.77665 9.08718 4.87719C9.77126 3.97774 10.7234 3.31882 11.8061 2.99546C12.8889 2.67211 14.0464 2.70104 15.1117 3.07808C16.177 3.45512 17.095 4.16078 17.7333 5.09329C18.3312 5.94548 18.6566 6.95897 18.6666 7.99995H22.6666C23.0202 7.99995 23.3594 8.14043 23.6094 8.39048C23.8595 8.64053 24 8.97967 24 9.33329V13.3333C25.1298 13.3557 26.2233 13.7364 27.1227 14.4205C28.0222 15.1046 28.6811 16.0567 29.0044 17.1395C29.3278 18.2223 29.2989 19.3798 28.9218 20.4451C28.5448 21.5103 27.8391 22.4283 26.9066 23.0666C26.0544 23.6645 25.0409 23.99 24 24V28C24 28.3536 23.8595 28.6927 23.6094 28.9428C23.3594 29.1928 23.0202 29.3333 22.6666 29.3333ZM6.66663 10.6666C6.313 10.6666 5.97387 10.8071 5.72382 11.0571C5.47377 11.3072 5.33329 11.6463 5.33329 12V25.3333C5.33329 25.6869 5.47377 26.0261 5.72382 26.2761C5.97387 26.5261 6.313 26.6666 6.66663 26.6666H21.3333V22.4266C21.3321 22.2128 21.3824 22.0019 21.4799 21.8116C21.5773 21.6213 21.7191 21.4573 21.8933 21.3333C22.0669 21.2095 22.2677 21.1291 22.4789 21.0989C22.69 21.0688 22.9053 21.0897 23.1066 21.16C23.4866 21.315 23.9005 21.3682 24.3073 21.3144C24.7142 21.2607 25.1 21.1017 25.4266 20.8533C25.7518 20.655 26.0307 20.3894 26.2445 20.0743C26.4584 19.7592 26.6024 19.402 26.6666 19.0266C26.718 18.648 26.6875 18.2628 26.5771 17.897C26.4667 17.5313 26.2789 17.1935 26.0266 16.9066C25.6854 16.4921 25.2207 16.1974 24.7002 16.0655C24.1798 15.9336 23.6308 15.9714 23.1333 16.1733C22.9319 16.2435 22.7167 16.2645 22.5055 16.2343C22.2944 16.2041 22.0936 16.1238 21.92 16C21.7458 15.876 21.604 15.7119 21.5065 15.5216C21.4091 15.3313 21.3588 15.1204 21.36 14.9066V10.6666H17.0933C16.8742 10.679 16.6554 10.6372 16.4563 10.5447C16.2572 10.4523 16.084 10.3121 15.9521 10.1367C15.8202 9.96128 15.7337 9.756 15.7002 9.53909C15.6666 9.32218 15.6872 9.10035 15.76 8.89329C15.915 8.5133 15.9682 8.09945 15.9144 7.6926C15.8607 7.28575 15.7017 6.89995 15.4533 6.57329C15.2564 6.23884 14.9868 5.95298 14.6645 5.73688C14.3421 5.52078 13.9753 5.37998 13.5911 5.32492C13.207 5.26986 12.8154 5.30194 12.4453 5.41879C12.0752 5.53564 11.7362 5.73427 11.4533 5.99995C11.1906 6.26051 10.985 6.57288 10.8496 6.9172C10.7141 7.26152 10.6518 7.63025 10.6666 7.99995C10.6697 8.30578 10.7284 8.6085 10.84 8.89329C10.9104 9.09491 10.9315 9.31052 10.9012 9.52196C10.871 9.7334 10.7905 9.93449 10.6663 10.1083C10.5422 10.2821 10.3781 10.4235 10.1879 10.5207C9.99765 10.6179 9.78688 10.6679 9.57329 10.6666H6.66663Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const QRCODE = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M1.97674 4.4186C1.97674 3.06693 3.06693 1.97674 4.4186 1.97674H6.04651C6.31623 1.97674 6.53488 1.75809 6.53488 1.48837C6.53488 1.21865 6.31623 1 6.04651 1H4.4186C2.52749 1 1 2.52749 1 4.4186V6.04651C1 6.31623 1.21865 6.53488 1.48837 6.53488C1.75809 6.53488 1.97674 6.31623 1.97674 6.04651V4.4186Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M9.95349 1C9.68377 1 9.46512 1.21865 9.46512 1.48837C9.46512 1.75809 9.68377 1.97674 9.95349 1.97674H11.5814C12.9331 1.97674 14.0233 3.06693 14.0233 4.4186V6.04651C14.0233 6.31623 14.2419 6.53488 14.5116 6.53488C14.7813 6.53488 15 6.31623 15 6.04651V4.4186C15 2.52749 13.4725 1 11.5814 1H9.95349Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M14.5116 10.1163C14.7813 10.1163 15 10.3349 15 10.6047V11.5814C15 13.4725 13.4725 15 11.5814 15H10.6047C10.3349 15 10.1163 14.7813 10.1163 14.5116C10.1163 14.2419 10.3349 14.0233 10.6047 14.0233H11.5814C12.9331 14.0233 14.0233 12.9331 14.0233 11.5814V10.6047C14.0233 10.3349 14.2419 10.1163 14.5116 10.1163Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M1.97674 9.95349C1.97674 9.68377 1.75809 9.46512 1.48837 9.46512C1.21865 9.46512 1 9.68377 1 9.95349V11.5814C1 13.4725 2.52749 15 4.4186 15H6.04651C6.31623 15 6.53488 14.7813 6.53488 14.5116C6.53488 14.2419 6.31623 14.0233 6.04651 14.0233H4.4186C3.06693 14.0233 1.97674 12.9331 1.97674 11.5814V9.95349Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.74419 3.27907C4.34332 3.27907 3.95298 3.37962 3.6663 3.6663C3.37962 3.95298 3.27907 4.34332 3.27907 4.74419V6.04651C3.27907 6.44737 3.37962 6.83772 3.6663 7.1244C3.95298 7.41108 4.34332 7.51163 4.74419 7.51163H6.04651C6.44737 7.51163 6.83772 7.41108 7.1244 7.1244C7.41108 6.83772 7.51163 6.44737 7.51163 6.04651V4.74419C7.51163 4.34332 7.41108 3.95298 7.1244 3.6663C6.83772 3.37962 6.44737 3.27907 6.04651 3.27907H4.74419ZM4.25581 4.74419C4.25581 4.49388 4.31806 4.39586 4.35696 4.35696C4.39586 4.31806 4.49388 4.25581 4.74419 4.25581H6.04651C6.29681 4.25581 6.39484 4.31806 6.43374 4.35696C6.47264 4.39586 6.53488 4.49388 6.53488 4.74419V6.04651C6.53488 6.29681 6.47264 6.39484 6.43374 6.43374C6.39484 6.47264 6.29681 6.53488 6.04651 6.53488H4.74419C4.49388 6.53488 4.39586 6.47264 4.35696 6.43374C4.31806 6.39484 4.25581 6.29681 4.25581 6.04651V4.74419Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.95349 3.27907C9.55263 3.27907 9.16228 3.37962 8.8756 3.6663C8.58892 3.95298 8.48837 4.34332 8.48837 4.74419V6.04651C8.48837 6.44737 8.58892 6.83772 8.8756 7.1244C9.16228 7.41108 9.55263 7.51163 9.95349 7.51163H11.2558C11.6567 7.51163 12.047 7.41108 12.3337 7.1244C12.6204 6.83772 12.7209 6.44737 12.7209 6.04651V4.74419C12.7209 4.34332 12.6204 3.95298 12.3337 3.6663C12.047 3.37962 11.6567 3.27907 11.2558 3.27907H9.95349ZM9.46512 4.74419C9.46512 4.49388 9.52736 4.39586 9.56626 4.35696C9.60516 4.31806 9.70319 4.25581 9.95349 4.25581H11.2558C11.5061 4.25581 11.6041 4.31806 11.643 4.35696C11.6819 4.39586 11.7442 4.49388 11.7442 4.74419V6.04651C11.7442 6.29681 11.6819 6.39484 11.643 6.43374C11.6041 6.47264 11.5061 6.53488 11.2558 6.53488H9.95349C9.70319 6.53488 9.60516 6.47264 9.56626 6.43374C9.52736 6.39484 9.46512 6.29681 9.46512 6.04651V4.74419Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.6663 8.8756C3.95298 8.58892 4.34332 8.48837 4.74419 8.48837H6.04651C6.44737 8.48837 6.83772 8.58892 7.1244 8.8756C7.41108 9.16228 7.51163 9.55263 7.51163 9.95349V11.2558C7.51163 11.6567 7.41108 12.047 7.1244 12.3337C6.83772 12.6204 6.44737 12.7209 6.04651 12.7209H4.74419C4.34332 12.7209 3.95298 12.6204 3.6663 12.3337C3.37962 12.047 3.27907 11.6567 3.27907 11.2558V9.95349C3.27907 9.55263 3.37962 9.16228 3.6663 8.8756ZM4.35696 9.56626C4.31806 9.60516 4.25581 9.70319 4.25581 9.95349V11.2558C4.25581 11.5061 4.31806 11.6041 4.35696 11.643C4.39586 11.6819 4.49388 11.7442 4.74419 11.7442H6.04651C6.29681 11.7442 6.39484 11.6819 6.43374 11.643C6.47264 11.6041 6.53488 11.5061 6.53488 11.2558V9.95349C6.53488 9.70319 6.47264 9.60516 6.43374 9.56626C6.39484 9.52736 6.29681 9.46512 6.04651 9.46512H4.74419C4.49388 9.46512 4.39586 9.52736 4.35696 9.56626Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.95349 8.48837C9.55263 8.48837 9.16228 8.58892 8.8756 8.8756C8.58892 9.16228 8.48837 9.55263 8.48837 9.95349V11.2558C8.48837 11.6567 8.58892 12.047 8.8756 12.3337C9.16228 12.6204 9.55263 12.7209 9.95349 12.7209H11.2558C11.6567 12.7209 12.047 12.6204 12.3337 12.3337C12.6204 12.047 12.7209 11.6567 12.7209 11.2558V9.95349C12.7209 9.55263 12.6204 9.16228 12.3337 8.8756C12.047 8.58892 11.6567 8.48837 11.2558 8.48837H9.95349ZM9.46512 9.95349C9.46512 9.70319 9.52736 9.60516 9.56626 9.56626C9.60516 9.52736 9.70319 9.46512 9.95349 9.46512H11.2558C11.5061 9.46512 11.6041 9.52736 11.643 9.56626C11.6819 9.60516 11.7442 9.70319 11.7442 9.95349V11.2558C11.7442 11.5061 11.6819 11.6041 11.643 11.643C11.6041 11.6819 11.5061 11.7442 11.2558 11.7442H9.95349C9.70319 11.7442 9.60516 11.6819 9.56626 11.643C9.52736 11.6041 9.46512 11.5061 9.46512 11.2558V9.95349Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Quant = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.74552 0.73491C7.82032 0.691567 7.90725 0.666748 7.99998 0.666748C8.09271 0.666748 8.17964 0.691567 8.25444 0.734911L14.3988 4.14027C14.4812 4.18419 14.5523 4.25127 14.6014 4.33836L14.606 4.34669C14.6488 4.42596 14.6682 4.51163 14.6666 4.59579V8.00008C14.6666 8.16525 14.5858 8.32002 14.4501 8.41474L12.3805 9.86005L14.4037 10.9702C14.5658 11.0591 14.6666 11.2291 14.6666 11.4137V14.8273C14.6666 15.0113 14.5665 15.1808 14.4051 15.27C14.2438 15.3592 14.0467 15.354 13.8903 15.2565L11.3942 13.7001L8.23601 15.2754C8.1722 15.3089 8.10036 15.3293 8.02412 15.3328C8.01749 15.3332 8.01085 15.3333 8.0042 15.3334L7.99998 15.3334C7.90723 15.3334 7.8203 15.3086 7.74549 15.2652L1.60257 11.8607C1.51828 11.8161 1.44563 11.7473 1.39621 11.6576C1.35188 11.5772 1.33175 11.49 1.33341 11.4044V4.59579C1.33178 4.51163 1.3512 4.42596 1.39396 4.34669L1.39856 4.33836C1.44763 4.25128 1.51878 4.1842 1.60115 4.14028L7.74552 0.73491ZM10.9144 12.8076L8.50735 14.0083V12.1199L10.9144 10.7752V12.8076ZM11.9291 12.8399L13.6518 13.914V11.7129L11.9291 10.7677V12.8399ZM4.57607 10.4906L7.49261 12.1199V13.967L2.88956 11.4159L4.57607 10.4906ZM7.49261 2.03312L2.88952 4.58426L4.57592 5.50956L7.49261 3.88013V2.03312ZM8.50735 3.88013L11.424 5.50956L13.1104 4.58427L8.50735 2.03312V3.88013ZM13.6518 5.44253L11.9291 6.38774V8.93955L13.6518 7.73655V5.44253ZM4.07083 9.61245V6.38774L2.34814 5.44253V10.5577L4.07083 9.61245ZM5.08557 9.61496V6.38507L7.99998 4.75691L10.9144 6.38507V9.61496L7.99998 11.2431L5.08557 9.61496Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Recevoir = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M13.6805 14.6846C13.6805 14.6846 13.361 15 12.9091 15H3.09091C3.09091 15 2.63904 15 2.31952 14.6846C2.31952 14.6846 2 14.3692 2 13.9231V2.07692C2 2.07692 2 1.63085 2.31952 1.31542C2.31952 1.31542 2.63904 1 3.09091 1H9.63636C9.78103 1 9.91977 1.05673 10.0221 1.15771L13.8402 4.92694C13.9425 5.02792 14 5.16488 14 5.30769V13.9231C14 13.9231 14 14.3692 13.6805 14.6846ZM12.9091 13.9231V5.53073L9.41043 2.07692H3.09091V13.9231H12.9091Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M9.63636 5.84615H13.4545C13.7558 5.84615 14 5.60508 14 5.30769C14 5.01031 13.7558 4.76923 13.4545 4.76923H10.1818V1.53846C10.1818 1.24108 9.93761 1 9.63636 1C9.33512 1 9.09091 1.24108 9.09091 1.53846V5.30769C9.09091 5.60508 9.33512 5.84615 9.63636 5.84615Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M10.2946 10.2656C10.3969 10.1646 10.4545 10.0274 10.4545 9.88462C10.4545 9.74181 10.3971 9.60485 10.2948 9.50387C10.1925 9.40289 10.0538 9.34615 9.90909 9.34615C9.76443 9.34615 9.62569 9.40289 9.5234 9.50387L8 11.0077L6.4766 9.50387C6.37431 9.40289 6.23557 9.34615 6.09091 9.34615C5.94625 9.34615 5.80751 9.40289 5.70521 9.50387C5.60292 9.60485 5.54545 9.74181 5.54545 9.88462C5.54545 10.0274 5.60292 10.1644 5.70521 10.2654L7.61431 12.15C7.7166 12.251 7.85534 12.3077 8 12.3077C8.14466 12.3077 8.2834 12.251 8.38569 12.15L10.2946 10.2656Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M7.45455 7.46154V11.7692C7.45455 12.0666 7.69875 12.3077 8 12.3077C8.30125 12.3077 8.54545 12.0666 8.54545 11.7692V7.46154C8.54545 7.16415 8.30125 6.92308 8 6.92308C7.69875 6.92308 7.45455 7.16415 7.45455 7.46154Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Refresh = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M6.6985 1.15312C7.86117 0.876765 9.07794 0.976117 10.1844 1.43795C11.291 1.89981 12.2345 2.7022 12.8867 3.73754C13.0885 4.05806 13.0028 4.48842 12.6953 4.69878C12.3877 4.90915 11.9747 4.81986 11.7728 4.49934C11.271 3.70264 10.5438 3.08353 9.68904 2.72676C8.83418 2.36996 7.8936 2.29307 6.99481 2.5067C6.09606 2.72033 5.28335 3.21392 4.66626 3.91968C4.25973 4.38461 3.95099 4.92685 3.75491 5.51214H4.70417C4.89065 5.51214 5.0072 5.72249 4.91396 5.89078L3.18318 9.01456C3.08994 9.18285 2.85684 9.18285 2.7636 9.01456L1.03282 5.89078C0.939576 5.72249 1.05613 5.51214 1.24261 5.51214H2.3631C2.59843 4.57546 3.0493 3.70754 3.68139 2.98464C4.48245 2.06848 5.5358 1.42949 6.6985 1.15312Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M13.2364 5.85922C13.1432 5.69094 12.9101 5.69094 12.8168 5.85922L11.086 8.98301C10.9928 9.15129 11.1094 9.36165 11.2958 9.36165H12.224C12.0313 9.9952 11.7079 10.5821 11.2723 11.0803C10.6552 11.7861 9.84253 12.2797 8.94377 12.4933C8.04498 12.7069 7.1044 12.63 6.24955 12.2732C5.39475 11.9165 4.66761 11.2974 4.16579 10.5007C3.96391 10.1801 3.55091 10.0909 3.24332 10.3012C2.93573 10.5116 2.85004 10.9419 3.05192 11.2625C3.70405 12.2978 4.64758 13.1002 5.75414 13.562C6.86064 14.0239 8.07741 14.1232 9.24008 13.8469C10.4028 13.5705 11.4561 12.9315 12.2572 12.0154C12.9176 11.2601 13.3802 10.3465 13.6058 9.36165H14.7574C14.9439 9.36165 15.0604 9.15129 14.9672 8.98301L13.2364 5.85922Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Retirer = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M5.39535 7.51163C5.12563 7.51163 4.90698 7.73028 4.90698 8C4.90698 8.26972 5.12563 8.48837 5.39535 8.48837H10.6047C10.8744 8.48837 11.093 8.26972 11.093 8C11.093 7.73028 10.8744 7.51163 10.6047 7.51163H5.39535Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8 1C4.14888 1 1 4.14888 1 8C1 11.8511 4.14888 15 8 15C11.8511 15 15 11.8511 15 8C15 4.14888 11.8511 1 8 1ZM1.97674 8C1.97674 4.68833 4.68833 1.97674 8 1.97674C11.3117 1.97674 14.0233 4.68833 14.0233 8C14.0233 11.3117 11.3117 14.0233 8 14.0233C4.68833 14.0233 1.97674 11.3117 1.97674 8Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const RIB = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.73858 6.76326C5.76894 6.64012 5.78506 6.51125 5.78506 6.37855C5.78506 5.50674 5.08916 4.8 4.23072 4.8C3.37228 4.8 2.67638 5.50674 2.67638 6.37855C2.67638 6.54122 2.70061 6.69814 2.7456 6.8458C2.81914 7.08714 2.94814 7.30374 3.11749 7.48021C3.39617 7.77061 3.78409 7.95237 4.21383 7.95702L4.23072 7.95711C4.69556 7.95711 5.11274 7.74988 5.39757 7.42144C5.5587 7.23564 5.67747 7.01106 5.73858 6.76326ZM4.23072 7.15711C4.65537 7.15711 4.99818 6.80773 4.99818 6.37855C4.99818 5.94938 4.65537 5.6 4.23072 5.6C3.80607 5.6 3.46327 5.94938 3.46327 6.37855C3.46327 6.80773 3.80607 7.15711 4.23072 7.15711Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2.51688 7.99902C2.01659 8.4841 1.70492 9.16809 1.70492 9.926V10.4107C1.70492 10.8466 2.05287 11.2 2.48209 11.2H6.17365C6.60287 11.2 6.95082 10.8466 6.95082 10.4107V9.92601C6.95082 9.11483 6.5938 8.38833 6.03064 7.89975C5.88863 7.77655 5.73352 7.66848 5.56772 7.57799C5.23732 7.94913 4.76104 8.18377 4.23072 8.18866L4.21383 8.18874C3.71912 8.18874 3.27039 7.98879 2.94172 7.66413C2.78887 7.76095 2.64654 7.87331 2.51688 7.99902ZM2.97146 8.66967C2.67284 9.00161 2.4918 9.4426 2.4918 9.926V10.4H6.16393V9.92601C6.16393 9.39952 5.949 8.92309 5.60155 8.58341C5.19959 8.83993 4.72354 8.98874 4.21383 8.98874C3.76446 8.98874 3.34099 8.873 2.97146 8.66967Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M8.52459 4.8C8.23487 4.8 8 5.03878 8 5.33333C8 5.62789 8.23487 5.86667 8.52459 5.86667H12.7213C13.011 5.86667 13.2459 5.62789 13.2459 5.33333C13.2459 5.03878 13.011 4.8 12.7213 4.8H8.52459Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M8 7.46667C8 7.17212 8.23487 6.93333 8.52459 6.93333H12.7213C13.011 6.93333 13.2459 7.17212 13.2459 7.46667C13.2459 7.76122 13.011 8 12.7213 8H8.52459C8.23487 8 8 7.76122 8 7.46667Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M8.52459 9.06667C8.23487 9.06667 8 9.30545 8 9.6C8 9.89455 8.23487 10.1333 8.52459 10.1333H12.7213C13.011 10.1333 13.2459 9.89455 13.2459 9.6C13.2459 9.30545 13.011 9.06667 12.7213 9.06667H8.52459Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 3.73333C0 2.77604 0.763318 2 1.70492 2H14.2951C15.2367 2 16 2.77604 16 3.73333V12.2667C16 13.224 15.2367 14 14.2951 14H1.70492C0.763318 14 0 13.224 0 12.2667V3.73333ZM1.70492 3.33333C1.48763 3.33333 1.31148 3.51242 1.31148 3.73333V12.2667C1.31148 12.4876 1.48763 12.6667 1.70492 12.6667H14.2951C14.5124 12.6667 14.6885 12.4876 14.6885 12.2667V3.73333C14.6885 3.51242 14.5124 3.33333 14.2951 3.33333H1.70492Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Repertoire = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1.55789 4.82363V4.03759C1.55789 3.25247 2.1849 2.61602 2.95835 2.61602H7.10094L8.14234 1.73925C8.39365 1.52767 8.70989 1.41187 9.0364 1.41187H13.0416C13.8151 1.41187 14.4421 2.04832 14.4421 2.83343V4.82363H14.5991C15.4828 4.82363 16.1456 5.64433 15.9723 6.52399L14.5159 13.9161C14.3849 14.5806 13.8102 15.0589 13.1426 15.0589H2.85741C2.18984 15.0589 1.61507 14.5806 1.48415 13.9161L0.0276718 6.52399C-0.145647 5.64434 0.51718 4.82363 1.40093 4.82363H1.55789ZM8.09604 3.99452L9.13743 3.11775H12.7616V4.82363H3.23844V4.3219H7.20198C7.52848 4.3219 7.84473 4.2061 8.09604 3.99452ZM3.08703 13.353L1.74259 6.52951H14.2574L12.913 13.353H3.08703Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Sinscrire = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.55002 4.84889C3.55002 2.7232 5.31816 1 7.49927 1C9.68038 1 11.4485 2.7232 11.4485 4.84889C11.4485 6.97457 9.68038 8.69777 7.49927 8.69777C5.31816 8.69777 3.55002 6.97457 3.55002 4.84889ZM7.49927 1.77531C5.75752 1.77531 4.34555 3.1514 4.34555 4.84889C4.34555 6.54637 5.75752 7.92246 7.49927 7.92246C9.24102 7.92246 10.653 6.54637 10.653 4.84889C10.653 3.1514 9.24102 1.77531 7.49927 1.77531Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M10.3049 11.8295C10.3049 11.6154 10.483 11.4418 10.7027 11.4418H11.3633V10.8188C11.3633 10.6047 11.5414 10.4312 11.7611 10.4312C11.9807 10.4312 12.1588 10.6047 12.1588 10.8188V11.4418H12.8194C13.0391 11.4418 13.2171 11.6154 13.2171 11.8295C13.2171 12.0436 13.0391 12.2172 12.8194 12.2172H12.1588V12.8886C12.1588 13.1027 11.9807 13.2763 11.7611 13.2763C11.5414 13.2763 11.3633 13.1027 11.3633 12.8886V12.2172H10.7027C10.483 12.2172 10.3049 12.0436 10.3049 11.8295Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.49921 10.1542C4.27182 10.1542 1.79553 12.218 1.79553 14.6123C1.79553 14.8264 1.61744 15 1.39776 15C1.17809 15 1 14.8264 1 14.6123C1 11.6486 3.99299 9.37894 7.49921 9.37894C8.17772 9.37894 8.837 9.46358 9.45822 9.62103C10.0477 9.0415 10.8653 8.68672 11.761 8.68672C12.714 8.68672 13.5818 9.08802 14.1678 9.73741C14.6842 10.2966 15 11.0379 15 11.8434C15 12.095 14.968 12.3407 14.9033 12.5797C14.8297 12.8948 14.7006 13.2012 14.5304 13.4703C13.9709 14.3849 12.9423 15 11.761 15C10.9284 15 10.1745 14.6928 9.60715 14.1889C9.36504 13.9837 9.15444 13.7392 8.99109 13.4694C8.69137 12.9943 8.5221 12.4338 8.5221 11.8434C8.5221 11.2844 8.67201 10.7558 8.93534 10.2977C8.47503 10.2041 7.99329 10.1542 7.49921 10.1542ZM10.0077 10.1822C10.4538 9.73567 11.0764 9.46203 11.761 9.46203C12.4834 9.46203 13.135 9.76607 13.5717 10.2509L13.5752 10.2546C13.967 10.6782 14.2045 11.2375 14.2045 11.8434C14.2045 12.0322 14.1803 12.2132 14.1327 12.3873C14.1313 12.3922 14.1301 12.3971 14.1289 12.402C14.0747 12.637 13.9778 12.8669 13.8519 13.0657L13.8484 13.0712C13.4274 13.7611 12.6527 14.2247 11.761 14.2247C11.1324 14.2247 10.5666 13.9933 10.1401 13.6132C10.1375 13.6109 10.1348 13.6086 10.1322 13.6064C9.95082 13.4532 9.79425 13.271 9.67467 13.0728L9.67039 13.0659C9.44584 12.711 9.31763 12.2899 9.31763 11.8434C9.31763 11.1998 9.58036 10.6106 10.0077 10.1822Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Sablier = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.07407 8L3.44444 5.36154C3.44444 5.36154 3.23444 5.20692 3.11803 4.98126C3.11803 4.98126 3.00161 4.75561 3.00001 4.50332L3 2.07692C3 2.07692 3 1.63085 3.32544 1.31542C3.32544 1.31542 3.65087 1 4.11111 1H11.8889C11.8889 1 12.3491 1 12.6746 1.31542C12.6746 1.31542 13 1.63085 13 2.07692V4.47308C13 4.47308 12.9984 4.72868 12.882 4.95434C12.882 4.95434 12.7656 5.18 12.5583 5.33262L12.0382 5.71397C12.019 5.73019 11.9986 5.74515 11.9772 5.75872L8.92078 8L12.5583 10.6674C12.5583 10.6674 12.7656 10.82 12.882 11.0457C12.882 11.0457 12.9984 11.2713 13 11.5269V13.9231C13 13.9231 13 14.3692 12.6746 14.6846C12.6746 14.6846 12.3491 15 11.8889 15H4.11111C4.11111 15 3.65087 15 3.32544 14.6846C3.32544 14.6846 3 14.3692 3 13.9231L3.00001 11.4967C3.00001 11.4967 3.00161 11.2444 3.11803 11.0187C3.11803 11.0187 3.23444 10.7931 3.44444 10.6385L7.07407 8ZM11.8862 4.47501L11.485 4.76923H4.48148L4.11112 4.5C4.11188 4.50056 4.11203 4.50043 4.11203 4.50043C4.11131 4.49902 4.1111 4.49668 4.1111 4.49668L4.11111 2.07692H11.8889V4.47307L11.8887 4.47211C11.888 4.47346 11.8862 4.47501 11.8862 4.47501ZM5.96296 5.84615H10.0164L7.99854 7.32586L5.96296 5.84615ZM11.8862 11.525L11.8874 11.5261L11.8882 11.5273L11.8889 13.9231H4.11111L4.1111 11.5033C4.11111 11.5018 4.11183 11.5004 4.11183 11.5004L7.44444 9.07692V10.6923C7.44444 10.9897 7.69318 11.2308 8 11.2308C8.30683 11.2308 8.55556 10.9897 8.55556 10.6923V9.0826L11.8862 11.525Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Safari = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.5189 4.64933C11.5898 4.72209 11.5979 4.83544 11.5379 4.91748L8.69874 8.80266C8.68267 8.82465 8.66255 8.84314 8.63994 8.85711L4.66282 11.3132C4.57695 11.3662 4.46541 11.35 4.39818 11.2748C4.33094 11.1995 4.32737 11.0869 4.38971 11.0075L7.27966 7.32795C7.31776 7.27944 7.37541 7.25033 7.43707 7.24845C7.44442 7.24823 7.45173 7.2484 7.45898 7.24894L11.2513 4.62348C11.3349 4.56563 11.448 4.57656 11.5189 4.64933ZM7.79474 7.52291L8.51593 8.34712L10.4734 5.66844L7.79474 7.52291ZM8.21033 8.63304L5.44069 10.3435L7.45324 7.78105L8.21033 8.63304Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.05025 3.05025C4.36301 1.7375 6.14347 1 7.99999 1C8.91925 1 9.82951 1.18106 10.6788 1.53284C11.5281 1.88463 12.2998 2.40024 12.9498 3.05025C13.5998 3.70027 14.1154 4.47193 14.4672 5.3212C14.8189 6.17048 15 7.08075 15 8.00001C15 8.91925 14.8189 9.82951 14.4672 10.6788C14.1154 11.5281 13.5998 12.2997 12.9498 12.9498C12.2998 13.5998 11.5281 14.1154 10.6788 14.4672C9.82951 14.8189 8.91925 15 7.99999 15C6.14347 15 4.36301 14.2625 3.05025 12.9498C1.7375 11.637 1 9.85653 1 8.00001C1 6.1435 1.7375 4.36301 3.05025 3.05025ZM4.68691 2.31073C5.62283 1.76574 6.68582 1.45603 7.78336 1.41994V2.70255H8.19974V1.41941C8.99621 1.44358 9.78226 1.61217 10.5195 1.91753C10.7571 2.01597 10.9883 2.12806 11.212 2.25306L10.4946 3.4957L10.8551 3.70389L11.5689 2.46763C11.9602 2.72004 12.3245 3.01385 12.6553 3.34468C13.0435 3.73288 13.3808 4.16722 13.6599 4.63708L12.5653 5.39239L12.8018 5.7351L13.8621 5.00344C13.9418 5.15924 14.0153 5.31839 14.0825 5.48055C14.4133 6.27931 14.5836 7.13543 14.5836 8.00001C14.5836 8.02743 14.5835 8.05484 14.5831 8.08223H13.1631L13.1631 8.49861H14.5647C14.512 9.19244 14.3496 9.87464 14.0825 10.5195C13.9754 10.7779 13.8522 11.0287 13.7138 11.2705L12.3699 10.4946L12.1617 10.8551L13.4956 11.6253C13.2516 11.9952 12.9702 12.3405 12.6553 12.6553C12.2418 13.0689 11.7759 13.4246 11.2705 13.7139L10.4946 12.3699L10.134 12.5781L10.9025 13.9093C10.7769 13.971 10.6491 14.0288 10.5195 14.0825C9.78226 14.3878 8.99621 14.5564 8.19974 14.5806V13.1631H7.78336V14.5801C6.8039 14.5479 5.85196 14.2977 4.99328 13.857L5.73164 12.5781L5.37105 12.3699L4.629 13.6552C4.16501 13.3786 3.73308 13.0437 3.34467 12.6553C3.01205 12.3227 2.71869 11.9582 2.46759 11.5689L3.70388 10.8551L3.49569 10.4945L2.25303 11.212C1.78924 10.3821 1.508 9.45673 1.43527 8.49861H2.70255V8.08223H1.41689C1.41655 8.05485 1.41638 8.02744 1.41638 8.00001C1.41638 6.96738 1.65897 5.95976 2.11261 5.05335L3.28751 5.73168L3.49569 5.37108L2.31072 4.68694C2.59371 4.20093 2.94016 3.74919 3.34467 3.34468C3.64939 3.03996 3.98091 2.76819 4.33368 2.53167L5.01046 3.70388L5.37105 3.49569L4.68691 2.31073Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Sante = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M6 4C6 3.44772 6.44772 3 7 3H9C9.55229 3 10 3.44772 10 4V6H12C12.5523 6 13 6.44772 13 7V9C13 9.55229 12.5523 10 12 10H10V12C10 12.5523 9.55229 13 9 13H7C6.44772 13 6 12.5523 6 12V10H4C3.44772 10 3 9.55229 3 9L3 7C3 6.44771 3.44772 6 4 6H6V4Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM14.6667 8C14.6667 11.6819 11.6819 14.6667 8 14.6667C4.3181 14.6667 1.33333 11.6819 1.33333 8C1.33333 4.3181 4.3181 1.33333 8 1.33333C11.6819 1.33333 14.6667 4.3181 14.6667 8Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Save = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M5.66667 3.33333H9.75C10.0722 3.33333 10.3333 3.5945 10.3333 3.91666C10.3333 4.23883 10.0722 4.5 9.75 4.5H5.66667C5.3445 4.5 5.08333 4.23883 5.08333 3.91666C5.08333 3.5945 5.3445 3.33333 5.66667 3.33333Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.674 1.00001C10.9049 0.999196 11.1185 1.08693 11.1185 1.08693C11.3321 1.17466 11.4969 1.33856 11.4969 1.33856L14.6625 4.50417C14.8253 4.66786 14.9131 4.88147 14.9131 4.88147C15.0004 5.09414 15 5.32396 15 5.32396L15 5.32492V13.8333C15 14.3166 14.6583 14.6583 14.6583 14.6583C14.3166 15 13.8333 15 13.8333 15H2.16667C1.68342 15 1.34171 14.6583 1.34171 14.6583C1 14.3166 1 13.8333 1 13.8333V2.16667C1 1.68342 1.34171 1.34171 1.34171 1.34171C1.68342 1 2.16667 1 2.16667 1L10.674 1.00001ZM10.675 2.16667L13.8333 5.32496V13.8333H12.0833V9.75C12.0833 9.26675 11.7416 8.92504 11.7416 8.92504C11.3999 8.58333 10.9167 8.58333 10.9167 8.58333H5.08333C4.60008 8.58333 4.25838 8.92504 4.25838 8.92504C3.91667 9.26675 3.91667 9.75 3.91667 9.75V13.8333H2.16667V2.16667L10.675 2.16667ZM10.9167 9.75V13.8333H5.08333V9.75H10.9167Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Se_connecter = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M4 0.25C2.48122 0.25 1.25 1.48122 1.25 3V4C1.25 4.41421 1.58579 4.75 2 4.75C2.41421 4.75 2.75 4.41421 2.75 4V3C2.75 2.30964 3.30964 1.75 4 1.75H12C12.6904 1.75 13.25 2.30964 13.25 3V13C13.25 13.6904 12.6904 14.25 12 14.25H4C3.30964 14.25 2.75 13.6904 2.75 13V12.5C2.75 12.0858 2.41421 11.75 2 11.75C1.58579 11.75 1.25 12.0858 1.25 12.5V13C1.25 14.5188 2.48122 15.75 4 15.75H12C13.5188 15.75 14.75 14.5188 14.75 13V3C14.75 1.48122 13.5188 0.25 12 0.25H4Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M3.6 11.2222C3.6 11.0159 3.6847 10.8177 3.83473 10.6718L5.26863 9.27778H0.799999C0.358171 9.27778 0 8.92955 0 8.5C0 8.07044 0.358171 7.72222 0.799999 7.72222L5.26863 7.72222L3.83431 6.32775C3.68428 6.18189 3.6 5.98406 3.6 5.77778C3.6 5.5715 3.68428 5.37367 3.83431 5.22781C3.97494 5.09108 4.16292 5.01019 4.36157 5.0009C4.37437 5.0003 4.38718 5 4.4 5C4.61217 5 4.81566 5.08194 4.96568 5.22781L7.7651 7.94946C7.91022 8.09026 8 8.28493 8 8.5C8 8.71517 7.91013 8.90993 7.76489 9.05075L4.96568 11.7722C4.81566 11.9181 4.61217 12 4.4 12C4.18783 12 3.98434 11.9181 3.83431 11.7722C3.68428 11.6263 3.6 11.4285 3.6 11.2222Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Services = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.99675 5.10789C6.64877 5.10789 5.55602 6.17889 5.55602 7.50004C5.55602 8.82119 6.64877 9.89219 7.99675 9.89219C9.34472 9.89219 10.4375 8.82119 10.4375 7.50004C10.4375 6.17889 9.34472 5.10789 7.99675 5.10789ZM6.53231 7.50004C6.53231 6.70735 7.18796 6.06475 7.99675 6.06475C8.80553 6.06475 9.46118 6.70735 9.46118 7.50004C9.46118 8.29273 8.80553 8.93533 7.99675 8.93533C7.18796 8.93533 6.53231 8.29273 6.53231 7.50004Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.27726 1.76301C6.83989 1.04249 5.8827 0.774264 5.12807 1.21146L4.0056 1.84101C3.17751 2.30498 2.89646 3.34547 3.36952 4.14793L3.36986 4.1485C3.61389 4.56115 3.57559 4.82474 3.49942 4.95429C3.4232 5.08392 3.20981 5.24819 2.72478 5.24819C1.77011 5.24819 1 6.01263 1 6.93864V8.06136C1 8.98737 1.77011 9.75181 2.72478 9.75181C3.20981 9.75181 3.4232 9.91608 3.49942 10.0457C3.57559 10.1753 3.61389 10.4389 3.36986 10.8515L3.36952 10.8521C2.89646 11.6545 3.17724 12.6949 4.00534 13.1588L5.12812 13.7886C5.88274 14.2257 6.8399 13.9575 7.27726 13.237L7.28019 13.2321L7.35167 13.1111C7.59578 12.6984 7.849 12.5985 8.00244 12.5985C8.15515 12.5985 8.40635 12.6974 8.64717 13.1091L8.64821 13.1109L8.71981 13.2321L8.72274 13.237C9.1601 13.9575 10.1173 14.2257 10.8719 13.7886L11.9944 13.159C12.8231 12.6947 13.1023 11.6614 12.6316 10.854L12.6301 10.8515C12.3861 10.4389 12.4244 10.1753 12.5006 10.0457C12.5768 9.91608 12.7902 9.75181 13.2752 9.75181C14.2299 9.75181 15 8.98737 15 8.06136V6.93864C15 6.00297 14.22 5.24819 13.2752 5.24819C12.7902 5.24819 12.5768 5.08392 12.5006 4.95429C12.4244 4.82474 12.3861 4.56115 12.6301 4.1485L12.6305 4.14793C13.1036 3.34539 12.8227 2.30491 11.9944 1.84101L10.8719 1.21147C10.1173 0.774262 9.16011 1.04248 8.72274 1.76301L8.71981 1.76791L8.64833 1.88891C8.40422 2.30158 8.151 2.40153 7.99756 2.40153C7.84485 2.40153 7.59365 2.30263 7.35283 1.89089L7.35179 1.88912L7.28019 1.76791L7.27726 1.76301ZM5.62336 2.03605C5.89583 1.87717 6.26273 1.96566 6.43694 2.25014L6.50584 2.36676L6.50641 2.36775C6.85137 2.95698 7.37446 3.35839 7.99756 3.35839C8.62024 3.35839 9.14487 2.95741 9.493 2.36874L9.56306 2.25014C9.73727 1.96566 10.1042 1.87717 10.3766 2.03605L10.3838 2.04013L11.5098 2.67165C11.8659 2.87114 11.9889 3.32335 11.7853 3.66901C11.4372 4.25779 11.3437 4.90307 11.6547 5.43205C11.9657 5.96106 12.5822 6.20505 13.2752 6.20505C13.6842 6.20505 14.0237 6.53471 14.0237 6.93864V8.06136C14.0237 8.46219 13.6874 8.79495 13.2752 8.79495C12.5822 8.79495 11.9657 9.03894 11.6547 9.56795C11.3439 10.0966 11.4371 10.7414 11.7846 11.3299C11.9899 11.6832 11.8653 12.1292 11.51 12.3282L10.3838 12.9599L10.3766 12.964C10.1042 13.1228 9.73727 13.0343 9.56306 12.7499L9.49416 12.6332L9.49369 12.6324C9.14874 12.0431 8.6256 11.6416 8.00244 11.6416C7.37976 11.6416 6.85513 12.0426 6.507 12.6313L6.43693 12.7499C6.26271 13.0343 5.89582 13.1228 5.62336 12.964L5.61623 12.9599L4.49024 12.3283C4.1341 12.1289 4.01115 11.6767 4.21466 11.3311C4.5628 10.7423 4.65635 10.097 4.34531 9.56795C4.03426 9.03894 3.41781 8.79495 2.72478 8.79495C2.31264 8.79495 1.97629 8.46219 1.97629 8.06136V6.93864C1.97629 6.53781 2.31264 6.20505 2.72478 6.20505C3.41781 6.20505 4.03426 5.96106 4.34531 5.43205C4.65633 4.90308 4.56281 4.25782 4.21475 3.66905C4.01111 3.32339 4.13378 2.87129 4.48998 2.6718L5.61623 2.04013L5.62336 2.03605Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Shield = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M10.223 6.48241C10.3998 6.30308 10.3998 6.01234 10.223 5.83301C10.0462 5.65369 9.75949 5.65369 9.58267 5.83301L7.12922 8.32121L6.4109 7.59271C6.23408 7.41338 5.94739 7.41338 5.77057 7.59271C5.59375 7.77204 5.59375 8.06278 5.77057 8.24211L6.80906 9.29531C6.98588 9.47463 7.27257 9.47463 7.44939 9.29531L10.223 6.48241Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.13558 1.17989C8.79741 1.05481 8.38509 1 7.99516 1C7.60578 1 7.195 1.05466 6.86114 1.18112L6.85993 1.18158L3.64231 2.411C3.16788 2.59107 2.76171 2.95313 2.47658 3.37018C2.19139 3.78731 2 4.29878 2 4.81014V9.67057C2 10.1477 2.15228 10.6654 2.37645 11.1174C2.60069 11.5695 2.92 12.0025 3.29762 12.2887L6.07021 14.3878L6.07098 14.3884C6.61791 14.805 7.31956 15 8 15C8.68044 15 9.38209 14.805 9.92902 14.3884L9.92979 14.3878L12.7022 12.2889C13.0798 12.0026 13.3993 11.5695 13.6236 11.1174C13.8477 10.6654 14 10.1477 14 9.67057V4.81014C14 4.2962 13.8091 3.78323 13.5237 3.36486C13.2384 2.94658 12.8325 2.58453 12.3578 2.40449L9.13933 1.18129L9.13558 1.17989ZM7.17854 2.04124C7.38004 1.96504 7.67531 1.91839 7.99516 1.91839C8.31388 1.91839 8.61354 1.96471 8.82356 2.04204L12.0402 3.26456C12.3073 3.36583 12.5757 3.58935 12.779 3.88735C12.9822 4.18529 13.0944 4.51946 13.0944 4.81014V9.67057C13.0944 9.96533 12.9952 10.3406 12.8146 10.7047C12.6341 11.0686 12.3954 11.3748 12.1603 11.5531L9.38686 13.6528L9.38564 13.6537C9.02319 13.93 8.52221 14.0816 8 14.0816C7.47779 14.0816 6.97681 13.93 6.61436 13.6537L3.83973 11.5531C3.60457 11.3748 3.36594 11.0686 3.18543 10.7047C3.00484 10.3406 2.90556 9.96533 2.90556 9.67057V4.81014C2.90556 4.52342 3.01733 4.19102 3.22075 3.89348C3.42411 3.59602 3.69235 3.37251 3.95946 3.27122L3.96052 3.27082L7.17854 2.04124Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Shopping2 = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2.6173 2.01134H1V1H2.6173C3.13348 1 3.5735 1.35961 3.65629 1.84912L3.94219 3.53953H13.9465C14.6692 3.53953 15.1769 4.22306 14.942 4.87963L13.1838 9.79387C13.0377 10.2022 12.6378 10.4764 12.1883 10.4764H4.9444C4.42823 10.4764 3.98821 10.1168 3.90541 9.62731L2.6173 2.01134ZM4.11324 4.55087L4.9444 9.4651L12.1883 9.4651L13.9465 4.55087H4.11324Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.60365 13.2775C4.60365 12.3261 5.40633 11.5549 6.39649 11.5549C7.38664 11.5549 8.18932 12.3261 8.18932 13.2775C8.18932 14.2288 7.38664 15 6.39649 15C5.40633 15 4.60365 14.2288 4.60365 13.2775ZM6.39649 12.5663C5.98767 12.5663 5.65627 12.8847 5.65627 13.2775C5.65627 13.6703 5.98767 13.9887 6.39649 13.9887C6.8053 13.9887 7.1367 13.6703 7.1367 13.2775C7.1367 12.8847 6.8053 12.5663 6.39649 12.5663Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.8481 11.5549C10.8579 11.5549 10.0552 12.3261 10.0552 13.2775C10.0552 14.2288 10.8579 15 11.8481 15C12.8382 15 13.6409 14.2288 13.6409 13.2775C13.6409 12.3261 12.8382 11.5549 11.8481 11.5549ZM11.1079 13.2775C11.1079 12.8847 11.4393 12.5663 11.8481 12.5663C12.2569 12.5663 12.5883 12.8847 12.5883 13.2775C12.5883 13.6703 12.2569 13.9887 11.8481 13.9887C11.4393 13.9887 11.1079 13.6703 11.1079 13.2775Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Siacoin = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M8 1.83325C7.13508 1.83325 6.26696 2.01924 5.52564 2.32812C5.27074 2.43433 4.97801 2.31379 4.8718 2.05889C4.76559 1.80399 4.88613 1.51126 5.14103 1.40505C5.99971 1.04726 6.99826 0.833252 8 0.833252C11.9428 0.833252 15.1667 4.05711 15.1667 7.99992C15.1667 11.9427 11.9428 15.1666 8 15.1666C4.05719 15.1666 0.833336 11.9427 0.833336 7.99992C0.833336 6.99817 1.04735 5.99963 1.40513 5.14094C1.51134 4.88604 1.80408 4.7655 2.05898 4.87171C2.31388 4.97792 2.43442 5.27066 2.32821 5.52556C2.01933 6.26688 1.83334 7.135 1.83334 7.99992C1.83334 11.3904 4.60948 14.1666 8 14.1666C11.3905 14.1666 14.1667 11.3904 14.1667 7.99992C14.1667 4.60939 11.3905 1.83325 8 1.83325Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.56667 7.99995C4.56667 6.19047 6.0572 4.69995 7.86667 4.69995C9.67615 4.69995 11.1667 6.19047 11.1667 7.99995V10.8C11.1667 11.0761 10.9428 11.3 10.6667 11.3H7.86667C6.0572 11.3 4.56667 9.80943 4.56667 7.99995ZM7.86667 5.69995C6.60948 5.69995 5.56667 6.74276 5.56667 7.99995C5.56667 9.25714 6.60948 10.3 7.86667 10.3H10.1667V7.99995C10.1667 6.74276 9.12386 5.69995 7.86667 5.69995Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.33334 1.83325C2.50491 1.83325 1.83334 2.50482 1.83334 3.33325C1.83334 4.16168 2.50491 4.83325 3.33334 4.83325C4.16176 4.83325 4.83334 4.16168 4.83334 3.33325C4.83334 2.50482 4.16176 1.83325 3.33334 1.83325ZM2.83334 3.33325C2.83334 3.05711 3.05719 2.83325 3.33334 2.83325C3.60948 2.83325 3.83334 3.05711 3.83334 3.33325C3.83334 3.60939 3.60948 3.83325 3.33334 3.83325C3.05719 3.83325 2.83334 3.60939 2.83334 3.33325Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Signature = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.5215 0.893411C12.8988 0.446696 13.5467 0.412846 13.9686 0.817802L15.6198 2.4028C16.0416 2.80776 16.0777 3.49817 15.7004 3.94489L13.9458 6.02189L10.7669 2.97041L12.5215 0.893411ZM13.2943 1.79799L12.3748 2.8864L13.8563 4.30846L14.7757 3.22005L13.2943 1.79799Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.25245 10.4932L10.1613 3.6109L13.259 6.63302L7.34117 13.5258L4.12712 13.8263C4.10055 13.7563 3.96401 13.5115 3.94105 13.4581C3.92624 13.5629 3.91428 13.6758 3.90242 13.7878C3.89916 13.8186 3.89588 13.8495 3.89257 13.88C3.87552 14.0372 3.84937 14.1807 3.81341 14.3037C3.77842 14.4234 3.72969 14.5394 3.65859 14.6288C3.5851 14.7212 3.46585 14.8087 3.30563 14.7952C3.16066 14.7831 3.04859 14.692 2.96837 14.5996C2.80045 14.4061 2.70928 14.1325 2.60728 13.7708C2.57483 13.6557 2.54069 13.5289 2.50261 13.3874C2.4289 13.1135 2.34039 12.7847 2.22063 12.3795C2.19232 12.5393 2.16509 12.7256 2.13787 12.9263C2.12006 13.0577 2.10223 13.1956 2.08415 13.3354C2.04224 13.6596 1.99902 13.9939 1.95166 14.2806C1.91769 14.4863 1.88019 14.6767 1.83706 14.8282C1.81556 14.9037 1.79089 14.9759 1.76168 15.0381C1.73517 15.0945 1.69287 15.1694 1.6236 15.2226C1.56606 15.2669 1.48 15.3068 1.37613 15.2906C1.27735 15.2751 1.21076 15.216 1.17194 15.1695C1.0997 15.0829 1.05613 14.9589 1.02559 14.8509C0.960411 14.6206 0.910343 14.2899 0.86295 13.9621L0.846969 13.8512C0.806763 13.5716 0.766841 13.294 0.719645 13.0578C0.716113 13.1203 0.713273 13.1866 0.71112 13.2564C0.693831 13.8167 0.72217 14.5319 0.753983 15.0208L0.284388 15.0513C0.25213 14.5557 0.222805 13.8236 0.240755 13.2419C0.249612 12.9548 0.270314 12.6874 0.313417 12.5018C0.332833 12.4182 0.365772 12.3073 0.436003 12.2279C0.47646 12.1822 0.54423 12.1306 0.640084 12.1233C0.733773 12.1162 0.807772 12.1552 0.854751 12.1913C0.958995 12.2713 1.01982 12.4007 1.05942 12.5065C1.10302 12.6231 1.13891 12.7632 1.16992 12.911C1.22501 13.1734 1.27008 13.4871 1.31272 13.7839L1.32869 13.8948C1.36232 14.1273 1.39467 14.3408 1.42956 14.5147C1.44923 14.4228 1.46845 14.3184 1.48736 14.2039C1.53333 13.9256 1.57472 13.6054 1.61609 13.2854C1.63445 13.1434 1.65281 13.0014 1.67155 12.8631C1.70171 12.6407 1.73285 12.4285 1.76632 12.2474C1.79894 12.0709 1.83664 11.9071 1.88398 11.7908C1.90567 11.7374 1.94158 11.662 2.0037 11.6062C2.0382 11.5753 2.09086 11.5414 2.16132 11.532C2.23473 11.5222 2.29942 11.5426 2.34816 11.5724C2.43113 11.6229 2.47955 11.7066 2.50823 11.7644C2.54163 11.8317 2.57255 11.9159 2.60238 12.0141C2.76019 12.5337 2.87198 12.949 2.95972 13.2749C2.99699 13.4134 3.02993 13.5358 3.0602 13.6431C3.16472 14.0137 3.23321 14.1838 3.31955 14.2862C3.3326 14.2588 3.3472 14.2214 3.36173 14.1717C3.38784 14.0824 3.40974 13.9675 3.42473 13.8293C3.42773 13.8016 3.43079 13.7727 3.43392 13.7431C3.44699 13.6196 3.46149 13.4825 3.47999 13.3585C3.50137 13.2151 3.53338 13.0457 3.59597 12.9303C3.62497 12.8768 3.69519 12.7696 3.83268 12.7459C3.97783 12.7209 4.08324 12.8068 4.13566 12.862C4.14467 12.8715 4.15353 12.8815 4.16225 12.8921L4.25245 10.4932ZM10.2371 5.32508L5.37357 10.9898L5.3169 12.4966L6.79603 12.3583L11.6506 6.70408L10.2371 5.32508Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Site_web = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1 3C1 2.44772 1.4643 2 2.03704 2H13.4444C14.0172 2 14.4815 2.44771 14.4815 3V8C14.4815 8.16603 14.3976 8.31316 14.2684 8.40409C14.4185 8.59796 14.5898 8.853 14.7147 9.13756C14.7147 9.13756 14.7408 9.19718 14.7773 9.30007C14.7903 9.3245 14.7996 9.35111 14.8044 9.37918C14.888 9.63214 15 10.054 15 10.5C15 10.5 15 11.0662 14.7976 11.6501C14.795 11.6591 14.7919 11.6679 14.7883 11.6765C14.7662 11.7386 14.7417 11.8008 14.7147 11.8624C14.7147 11.8624 14.4391 12.4906 13.9369 12.9749C13.9369 12.9749 13.4347 13.4592 12.7833 13.7248C12.7833 13.7248 12.1086 14 11.3704 14C11.3704 14 10.6321 14 9.95747 13.7248C9.95747 13.7248 9.30605 13.4592 8.80383 12.9749C8.80383 12.9749 8.74558 12.9187 8.65787 12.8198C8.56275 12.9299 8.41949 13 8.25926 13H2.03704C1.4643 13 1 12.5523 1 12V3ZM13.4444 6V7.63503C13.0898 7.40018 12.7833 7.27516 12.7833 7.27516C12.1086 7 11.3704 7 11.3704 7C10.6321 7 9.95747 7.27516 9.95747 7.27516C9.30605 7.54084 8.80383 8.02513 8.80383 8.02513C8.30162 8.50941 8.02609 9.13756 8.02609 9.13756C7.99905 9.1992 7.97457 9.2614 7.95242 9.32349C7.94887 9.33207 7.94577 9.34086 7.94314 9.34985C7.74074 9.93379 7.74074 10.5 7.74074 10.5C7.74074 10.946 7.85272 11.3679 7.93639 11.6208C7.94116 11.6489 7.95043 11.6755 7.96347 11.6999C7.99994 11.8028 8.02609 11.8624 8.02609 11.8624C8.04657 11.9091 8.06831 11.955 8.09099 12H2.03704V6H13.4444ZM13.4444 5V3L2.03704 3V5H13.4444ZM8.6386 11.8462C8.74467 12.0381 8.93464 12.3395 9.19869 12.5941C9.19869 12.5941 9.62389 13.0041 10.175 13.2289C10.175 13.2289 10.2587 13.2631 10.3972 13.3052C10.3106 13.1826 10.2126 13.0223 10.1266 12.8286C10.1266 12.8286 9.96042 12.4545 9.83433 11.8462H8.6386ZM12.5657 13.2289C12.4917 13.2591 12.4168 13.2854 12.3424 13.3082C12.5071 13.0696 12.6142 12.8286 12.6142 12.8286C12.7506 12.5213 12.8439 12.1755 12.9077 11.8462H14.1049C13.8674 12.2804 13.5421 12.5941 13.5421 12.5941C13.1168 13.0041 12.5657 13.2289 12.5657 13.2289ZM14.3195 11.3077H12.9908C13.0456 10.8431 13.0456 10.5 13.0456 10.5C13.0456 10.2114 13.0261 9.94035 12.9954 9.69231H14.322C14.4416 10.1224 14.4416 10.5 14.4416 10.5C14.4416 10.8039 14.3803 11.0944 14.3195 11.3077ZM12.4872 10.5C12.4872 10.5 12.4872 10.1504 12.4298 9.69231H10.3072C10.2748 9.93664 10.2536 10.208 10.2536 10.5C10.2536 10.5 10.2536 10.8496 10.3109 11.3077H12.4335C12.466 11.0634 12.4872 10.792 12.4872 10.5ZM14.1021 9.15385H12.9064C12.7803 8.54552 12.6142 8.17137 12.6142 8.17137C12.5282 7.97773 12.4302 7.81742 12.3436 7.69481C12.482 7.73694 12.5657 7.77108 12.5657 7.77108C13.1168 7.99586 13.5421 8.40588 13.5421 8.40588C13.8061 8.66049 13.9961 8.96193 14.1021 9.15385ZM10.175 7.77108C10.249 7.74089 10.324 7.71462 10.3983 7.69176C10.2336 7.93044 10.1266 8.17137 10.1266 8.17137C9.99011 8.47865 9.89681 8.82453 9.83302 9.15385H8.63584C8.87336 8.71958 9.19869 8.40588 9.19869 8.40588C9.62389 7.99586 10.175 7.77108 10.175 7.77108ZM10.6399 8.38335C10.6399 8.38335 10.5119 8.67152 10.4033 9.15385H12.3402C12.2843 8.89104 12.2072 8.6229 12.1008 8.38335C12.1008 8.38335 11.9292 7.99681 11.7176 7.79529C11.7176 7.79529 11.5398 7.62595 11.3704 7.62595C11.3704 7.62595 11.201 7.62595 11.0232 7.79529C11.0232 7.79529 10.8116 7.99681 10.6399 8.38335ZM8.42128 9.69231H9.74998C9.69516 10.1569 9.69516 10.5 9.69516 10.5C9.69516 10.7885 9.71466 11.0596 9.74537 11.3077H8.41875C8.29915 10.8776 8.29915 10.5 8.29915 10.5C8.29915 10.1961 8.36047 9.90565 8.42128 9.69231ZM12.3375 11.8462H10.4006C10.4564 12.109 10.5335 12.3771 10.6399 12.6166C10.6399 12.6166 10.8116 13.0032 11.0232 13.2047C11.0232 13.2047 11.201 13.374 11.3704 13.374C11.3704 13.374 11.5398 13.374 11.7176 13.2047C11.7176 13.2047 11.9292 13.0032 12.1008 12.6166C12.1008 12.6166 12.2288 12.3285 12.3375 11.8462Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Slidebar = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1 2.18182C1 2.18182 1 1.69229 1.31542 1.34615C1.31542 1.34615 1.63085 1 2.07692 1H13.9231C13.9231 1 14.3692 1 14.6846 1.34615C14.6846 1.34615 15 1.69229 15 2.18182V12.8182C15 12.8182 15 13.3077 14.6846 13.6539C14.6846 13.6539 14.3692 14 13.9231 14H2.07692C2.07692 14 1.63085 14 1.31542 13.6539C1.31542 13.6539 1 13.3077 1 12.8182V2.18182ZM2.07692 9.27273H3.15385C3.45123 9.27273 3.69231 9.00817 3.69231 8.68182C3.69231 8.35547 3.45123 8.09091 3.15385 8.09091H2.07692V6.90909H3.15385C3.45123 6.90909 3.69231 6.64453 3.69231 6.31818C3.69231 5.99183 3.45123 5.72727 3.15385 5.72727H2.07692V4.54545H3.15385C3.45123 4.54545 3.69231 4.2809 3.69231 3.95455C3.69231 3.6282 3.45123 3.36364 3.15385 3.36364H2.07692V2.18182H4.76923V12.8182H2.07692V9.27273ZM5.84615 2.18182V12.8182H13.9231V2.18182H5.84615Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Social = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.9365 2.25508C11.9365 2.44894 11.9108 2.63708 11.8624 2.81659C11.7698 3.16046 11.5941 3.47266 11.3568 3.73267C10.9222 4.20897 10.2812 4.51015 9.56614 4.51015L9.54037 4.51002C8.87829 4.50331 8.2813 4.23837 7.85542 3.81604C7.60723 3.56992 7.41716 3.27036 7.30618 2.9373C7.23446 2.72208 7.19577 2.49288 7.19577 2.25508C7.19577 1.00963 8.25702 0 9.56614 0C10.8753 0 11.9365 1.00963 11.9365 2.25508ZM10.7937 2.25508C10.7937 2.81631 10.2984 3.3673 9.56614 3.3673C8.83383 3.3673 8.33862 2.81631 8.33862 2.25508C8.33862 1.69384 8.83383 1.14286 9.56614 1.14286C10.2984 1.14286 10.7937 1.69384 10.7937 2.25508Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.71429 7.32286C5.71429 6.22977 6.19873 5.24432 6.9745 4.55023C7.1663 4.37862 7.37591 4.22483 7.60041 4.09162C8.10163 4.55542 8.78594 4.84105 9.54037 4.84105L9.56614 4.84094C10.3749 4.83396 11.1012 4.49876 11.6051 3.96856C11.8481 4.09284 12.0762 4.24035 12.2859 4.40795C13.1592 5.10602 13.7143 6.15277 13.7143 7.32286V8.01532C13.7143 8.63804 13.1837 9.14286 12.5291 9.14286H6.89947C6.24491 9.14286 5.71429 8.63804 5.71429 8.01532V7.32286ZM6.85714 7.32286C6.85714 6.63085 7.14242 5.98737 7.62766 5.50427C8.19618 5.81087 8.84962 5.98391 9.54037 5.98391C10.3197 5.98391 11.0515 5.76367 11.6676 5.37976C12.2331 5.87358 12.5714 6.57025 12.5714 7.32286V7.99036C12.5633 7.995 12.5496 8 12.5291 8H6.89947C6.87893 8 6.86528 7.99499 6.85714 7.99036V7.32286Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2.12154 9.14286H0V16H2.12154C2.70694 16 3.18159 15.5402 3.18231 14.9727L5.28546 15.7169C5.33401 15.7341 5.38529 15.7429 5.43698 15.7429H10.9655C11.0776 15.7429 11.1855 15.7016 11.2674 15.6273L15.4012 11.8793C15.7389 11.5903 15.9536 11.2372 15.9934 10.8543C16.0339 10.464 15.8862 10.0996 15.6093 9.81821C15.2452 9.44813 14.7856 9.36557 14.4046 9.41178C14.0472 9.45512 13.7006 9.61827 13.5071 9.8298C13.5071 9.8298 13.4994 9.83756 13.486 9.84995C13.4703 9.86447 13.4493 9.88319 13.4228 9.9063C13.3696 9.9525 13.2997 10.0113 13.2155 10.0807C13.0473 10.2195 12.83 10.3947 12.5916 10.5862L12.4098 10.732C12.0775 10.9987 11.7214 11.2845 11.4189 11.5335C11.3098 11.281 11.1259 11.0834 10.8835 10.9429C10.5316 10.7388 10.0929 10.6764 9.68576 10.6608C9.12449 10.6394 8.24855 10.6481 7.65051 10.6572C7.48727 10.4812 7.23962 10.257 6.92881 10.0583C6.49156 9.77884 5.88934 9.52468 5.19239 9.56816C4.24028 9.62757 3.55423 10.0048 3.18231 10.2569V10.1714C3.18231 9.60337 2.70739 9.14286 2.12154 9.14286ZM2.12154 10H0.883976V15.1429H2.12154C2.21918 15.1429 2.29834 15.0661 2.29834 14.9714V10.1714C2.29834 10.0768 2.21918 10 2.12154 10ZM9.76299 13.55C9.80884 13.5469 9.85461 13.5432 9.90022 13.5389C10.0075 13.5295 10.1098 13.519 10.2046 13.5073C10.3217 13.4929 10.4329 13.4759 10.5307 13.4554C10.6215 13.4363 10.7285 13.4088 10.8213 13.3644C11.0838 13.2389 11.3084 13.0078 11.4665 12.8176C11.6069 12.6485 11.7257 12.4734 11.8063 12.3401C12.1339 12.0661 12.5662 11.7192 12.9728 11.3929L13.1554 11.2463C13.3935 11.0551 13.6151 10.8765 13.7884 10.7335C13.9485 10.6014 14.0997 10.4737 14.1686 10.3984C14.1686 10.3984 14.171 10.3959 14.1757 10.3919C14.1809 10.3874 14.1884 10.3816 14.1982 10.3748C14.2182 10.361 14.2451 10.3453 14.2784 10.3297C14.3458 10.2982 14.4281 10.2728 14.5143 10.2623C14.6815 10.242 14.8397 10.2777 14.9697 10.4099C15.0882 10.5303 15.1258 10.6534 15.1138 10.7684C15.1013 10.8887 15.0278 11.0568 14.8128 11.2396L14.8095 11.2425L14.8023 11.2488L10.7911 14.8857H5.5151L3.6243 14.2167V11.0047C3.9124 10.8 4.46127 10.4727 5.24915 10.4235C5.68881 10.3961 6.10067 10.5556 6.44226 10.774C6.78611 10.9938 7.01843 11.2478 7.08472 11.338C7.16923 11.4529 7.30667 11.52 7.4522 11.5176C8.04226 11.5077 9.04816 11.4943 9.6509 11.5173C10.0159 11.5313 10.2722 11.5871 10.4298 11.6785C10.5516 11.7491 10.6378 11.8509 10.6474 12.0815C10.6581 12.3361 10.5817 12.436 10.4891 12.5011C10.3705 12.5845 10.1596 12.6528 9.81224 12.6859C9.77479 12.6892 9.73642 12.6923 9.69722 12.6953C9.61353 12.701 9.52073 12.7072 9.42209 12.7137L9.35154 12.7177C8.79534 12.7481 8.18012 12.7583 7.78429 12.7583C7.54839 12.7583 7.35407 12.938 7.34281 13.1665C7.33155 13.3949 7.50732 13.5917 7.74215 13.6135C7.98388 13.636 8.36168 13.6274 8.72368 13.6115C8.98142 13.6001 9.24722 13.5841 9.47848 13.5691C9.57505 13.5634 9.67038 13.5571 9.76299 13.55Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Solana = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2.32179 1.54064C2.59271 1.12416 2.99893 1 3.33444 1H13.7422C14.7477 1 15.3718 2.19718 14.7545 3.10827L14.7509 3.11364L13.6782 4.62153C13.4073 5.03801 13.0011 5.16216 12.6656 5.16216H2.25777C1.25235 5.16216 0.628228 3.96498 1.24549 3.05389L1.24913 3.04852L2.32179 1.54064ZM3.22795 2.16047C3.22381 2.16416 3.21687 2.17129 3.20814 2.1851L3.19985 2.19821L2.11889 3.71775C2.0652 3.79962 2.07143 3.87138 2.09836 3.92599C2.12852 3.98714 2.18453 4.02703 2.25777 4.02703H12.6656C12.7151 4.02703 12.7433 4.01816 12.7568 4.01168C12.7632 4.00864 12.7679 4.00544 12.772 4.00169C12.7762 3.998 12.7831 3.99088 12.7919 3.97706L12.8002 3.96395L13.8811 2.44441C13.9348 2.36254 13.9286 2.29079 13.9016 2.23617C13.8715 2.17502 13.8155 2.13514 13.7422 2.13514H3.33444C3.28493 2.13514 3.25669 2.144 3.24318 2.15048C3.23682 2.15352 3.23215 2.15673 3.22795 2.16047Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1.24549 8.02719C0.628228 7.1161 1.25235 5.91892 2.25777 5.91892H12.6656C13.0011 5.91892 13.4073 6.04307 13.6782 6.45955L14.7509 7.96744L14.7545 7.97281C15.3718 8.8839 14.7477 10.0811 13.7422 10.0811H3.33444C2.99894 10.0811 2.59271 9.95692 2.32178 9.54044L1.24913 8.03256L1.24549 8.02719ZM2.1189 7.36334L3.19985 8.88287L3.20814 8.89598C3.21687 8.90979 3.22381 8.91692 3.22795 8.92061C3.23215 8.92436 3.23682 8.92756 3.24318 8.9306C3.25669 8.93708 3.28493 8.94595 3.33444 8.94595H13.7422C13.8155 8.94595 13.8715 8.90606 13.9016 8.84491C13.9286 8.7903 13.9348 8.71854 13.8811 8.63667L12.8002 7.11713L12.7919 7.10402C12.7831 7.09021 12.7762 7.08308 12.772 7.07939C12.7679 7.07564 12.7632 7.07244 12.7568 7.0694C12.7433 7.06292 12.7151 7.05405 12.6656 7.05405H2.25777C2.18453 7.05405 2.12852 7.09394 2.09836 7.15509C2.07143 7.20971 2.0652 7.28147 2.1189 7.36334Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.33444 10.8378C2.99894 10.8378 2.59271 10.962 2.32179 11.3785L1.24913 12.8864L1.24549 12.8917C0.628228 13.8028 1.25235 15 2.25777 15H12.6656C13.0011 15 13.4073 14.8758 13.6782 14.4594L14.7509 12.9515L14.7545 12.9461C15.3718 12.035 14.7477 10.8378 13.7422 10.8378H3.33444ZM3.20814 12.0229C3.21687 12.0091 3.22381 12.002 3.22795 11.9983C3.23215 11.9946 3.23682 11.9914 3.24318 11.9883C3.25669 11.9818 3.28493 11.973 3.33444 11.973H13.7422C13.8155 11.973 13.8715 12.0129 13.9016 12.074C13.9286 12.1286 13.9348 12.2004 13.8811 12.2822L12.8002 13.8018L12.7919 13.8149C12.7831 13.8287 12.7762 13.8358 12.772 13.8395C12.7679 13.8433 12.7632 13.8465 12.7568 13.8495C12.7433 13.856 12.7151 13.8649 12.6656 13.8649H2.25777C2.18453 13.8649 2.12852 13.825 2.09836 13.7638C2.07143 13.7092 2.0652 13.6375 2.11889 13.5556L3.19985 12.036L3.20814 12.0229Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Stacks = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M5.71326 3.92364C5.93949 3.76528 6.25125 3.8203 6.40961 4.04652L7.93333 6.22326L9.45705 4.04652C9.6154 3.8203 9.92717 3.76528 10.1534 3.92364C10.3796 4.08199 10.4346 4.39376 10.2763 4.61998L8.96032 6.49992H11C11.2761 6.49992 11.5 6.72378 11.5 6.99992C11.5 7.27606 11.2761 7.49992 11 7.49992H4.99999C4.72385 7.49992 4.49999 7.27606 4.49999 6.99992C4.49999 6.72378 4.72385 6.49992 4.99999 6.49992H6.90633L5.59038 4.61998C5.43202 4.39376 5.48704 4.08199 5.71326 3.92364Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M4.49999 8.99992C4.49999 8.72378 4.72385 8.49992 4.99999 8.49992H11C11.2761 8.49992 11.5 8.72378 11.5 8.99992C11.5 9.27606 11.2761 9.49992 11 9.49992H8.96032L10.2763 11.3799C10.4346 11.6061 10.3796 11.9178 10.1534 12.0762C9.92717 12.2346 9.6154 12.1795 9.45705 11.9533L7.93333 9.77658L6.40961 11.9533C6.25125 12.1795 5.93949 12.2346 5.71326 12.0762C5.48704 11.9178 5.43202 11.6061 5.59038 11.3799L6.90633 9.49992H4.99999C4.72385 9.49992 4.49999 9.27606 4.49999 8.99992Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.99999 0.833252C4.04195 0.833252 0.833328 4.04188 0.833328 7.99992C0.833328 11.958 4.04195 15.1666 7.99999 15.1666C11.958 15.1666 15.1667 11.958 15.1667 7.99992C15.1667 4.04188 11.958 0.833252 7.99999 0.833252ZM1.83333 7.99992C1.83333 4.59416 4.59424 1.83325 7.99999 1.83325C11.4058 1.83325 14.1667 4.59416 14.1667 7.99992C14.1667 11.4057 11.4058 14.1666 7.99999 14.1666C4.59424 14.1666 1.83333 11.4057 1.83333 7.99992Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const ChevronDown = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M15.7071 5.69595C16.0976 5.30798 16.0976 4.67895 15.7071 4.29098C15.3166 3.90301 14.6834 3.90301 14.2929 4.29098L9 9.54928C9 9.54928 8.55228 9.96078 8 9.96078C7.44772 9.96078 7.5 9.96078 7 9.54926L1.70711 4.29098C1.31658 3.90301 0.683417 3.90301 0.292893 4.29098C-0.0976315 4.67895 -0.0976315 5.30798 0.292893 5.69595L7.29218 12.6495C7.29459 12.6519 7.29702 12.6543 7.29945 12.6567C7.47921 12.832 7.72537 12.9404 7.997 12.9412L8 12.9412L8.003 12.9412C8.1375 12.9408 8.26575 12.914 8.38278 12.8658C8.49805 12.8184 8.6062 12.7487 8.70055 12.6567C8.70295 12.6543 8.70534 12.652 8.70772 12.6496M8.70772 12.6496L15.7071 5.69595L8.70772 12.6496Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const ChevronLeft = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.5394 15.7071C10.9274 16.0976 11.5564 16.0976 11.9444 15.7071C12.3323 15.3166 12.3323 14.6834 11.9444 14.2929L6.68607 9C6.68607 9 6.27457 8.55228 6.27457 8C6.27457 7.44772 6.27457 7.5 6.68609 7L11.9444 1.70711C12.3323 1.31658 12.3323 0.683417 11.9444 0.292893C11.5564 -0.0976315 10.9274 -0.0976315 10.5394 0.292893L3.58586 7.29218C3.58346 7.29459 3.58107 7.29702 3.5787 7.29945C3.40336 7.47921 3.29497 7.72537 3.29418 7.997L3.29418 8L3.29418 8.003C3.29457 8.1375 3.32134 8.26575 3.36956 8.38278C3.41694 8.49805 3.48665 8.6062 3.5787 8.70055C3.58104 8.70295 3.5834 8.70534 3.58576 8.70772M3.58576 8.70772L10.5394 15.7071L3.58576 8.70772Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const ChevronRight = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.99002 0.292893C4.60204 -0.0976311 3.97302 -0.0976311 3.58505 0.292893C3.19707 0.683417 3.19707 1.31658 3.58505 1.70711L8.84335 7C8.84335 7 9.25485 7.44772 9.25485 8C9.25485 8.55228 9.25485 8.5 8.84333 9L3.58505 14.2929C3.19707 14.6834 3.19707 15.3166 3.58505 15.7071C3.97302 16.0976 4.60204 16.0976 4.99002 15.7071L11.9436 8.70782C11.946 8.70541 11.9483 8.70298 11.9507 8.70055C12.1261 8.52079 12.2344 8.27463 12.2352 8.003L12.2352 8L12.2352 7.997C12.2348 7.8625 12.2081 7.73425 12.1599 7.61722C12.1125 7.50195 12.0428 7.3938 11.9507 7.29945C11.9484 7.29705 11.946 7.29466 11.9437 7.29228M11.9437 7.29228L4.99002 0.292893L11.9437 7.29228Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const ChevronUp = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0.292893 11.2452C-0.0976312 11.6332 -0.0976311 12.2622 0.292893 12.6502C0.683418 13.0382 1.31658 13.0382 1.70711 12.6502L7 7.39188C7 7.39188 7.44772 6.98038 8 6.98038C8.55228 6.98038 8.5 6.98038 9 7.3919L14.2929 12.6502C14.6834 13.0382 15.3166 13.0382 15.7071 12.6502C16.0976 12.2622 16.0976 11.6332 15.7071 11.2452L8.70782 4.29167C8.70541 4.28927 8.70298 4.28688 8.70055 4.28451C8.52079 4.10917 8.27463 4.00078 8.003 3.99999L8 3.99999L7.997 3.99999C7.8625 4.00038 7.73425 4.02715 7.61722 4.07537C7.50195 4.12275 7.39379 4.19246 7.29945 4.28451C7.29705 4.28685 7.29466 4.28921 7.29228 4.29157M7.29228 4.29157L0.292893 11.2452L7.29228 4.29157Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Stellar = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M8 2.03345C4.65322 2.03345 2.03334 4.72796 2.03334 8.00011C2.03334 8.57407 2.10499 9.08361 2.24923 9.59238L1.09239 10.2286C0.850425 10.3617 0.762159 10.6657 0.895237 10.9077C1.02832 11.1497 1.33234 11.2379 1.5743 11.1049L14.9076 3.77152C15.1496 3.63844 15.2379 3.33442 15.1048 3.09246C14.9717 2.8505 14.6677 2.76223 14.4257 2.89531L3.15341 9.09508C3.07353 8.75058 3.03334 8.39789 3.03334 8.00011C3.03334 5.27227 5.21345 3.03345 8 3.03345C8.98192 3.03345 9.8898 3.27836 10.6713 3.75928C10.9065 3.904 11.2144 3.83068 11.3592 3.5955C11.5039 3.36032 11.4306 3.05234 11.1954 2.90762C10.2435 2.32187 9.15142 2.03345 8 2.03345Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M12.904 7.20683L1.5743 13.4382C1.33234 13.5713 1.02832 13.483 0.895237 13.241C0.762159 12.9991 0.850425 12.6951 1.09239 12.562L14.4257 5.22864C14.6677 5.09556 14.9717 5.18383 15.1048 5.42579C15.2379 5.66775 15.1496 5.97178 14.9076 6.10486L13.8307 6.69719C13.9212 7.15251 13.9667 7.60917 13.9667 8.06672C13.9667 11.3389 11.3468 14.0334 8.00002 14.0334C6.82727 14.0334 5.73771 13.6667 4.80463 13.0925C4.56945 12.9478 4.49613 12.6398 4.64085 12.4047C4.78558 12.1695 5.09355 12.0962 5.32873 12.2409C6.12899 12.7334 7.03943 13.0334 8.00002 13.0334C10.7866 13.0334 12.9667 10.7946 12.9667 8.06672C12.9667 7.78062 12.9459 7.49405 12.904 7.20683Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Supprimer1 = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0.961402 8.24957L3.86191 12.86L3.86298 12.8617C3.86298 12.8617 3.99835 13.0794 4.22873 13.2056C4.22873 13.2056 4.46129 13.3329 4.72939 13.3333L14.0953 13.3333C14.0953 13.3333 14.5161 13.3333 14.8136 13.0493C14.8136 13.0493 15.1111 12.7653 15.1111 12.3636V3.63632C15.1111 3.63632 15.1111 3.23466 14.8136 2.95064C14.8136 2.95064 14.5161 2.66663 14.0953 2.66663H4.73019C4.73019 2.66663 4.46129 2.66703 4.22873 2.79435C4.22873 2.79435 3.99617 2.92167 3.86043 3.14235L0.961402 7.75035C0.864754 7.90397 0.864754 8.09595 0.961402 8.24957ZM14.0953 12.3636L4.7346 12.3636L4.73389 12.3625L1.98934 7.99996L4.73457 3.63632H14.0953V12.3636Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M10.8987 6.88844C10.9939 6.79751 11.0476 6.674 11.0476 6.54541C11.0476 6.41682 10.9941 6.2935 10.8989 6.20257L10.8945 6.19844C10.7996 6.11021 10.6721 6.06057 10.5397 6.06057C10.5245 6.06057 10.5092 6.06122 10.4941 6.06253C10.3756 6.07273 10.2647 6.12229 10.1805 6.20257L7.13312 9.11148C7.03786 9.20241 6.98415 9.32592 6.98415 9.4545C6.98415 9.46227 6.98435 9.47004 6.98474 9.4778C6.99081 9.59819 7.04364 9.71211 7.13293 9.79734C7.22818 9.88827 7.35738 9.93935 7.49209 9.93935C7.6268 9.93935 7.756 9.88827 7.85126 9.79734L10.8987 6.88844Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M7.85126 6.20257C7.756 6.11165 7.6268 6.06057 7.49209 6.06057C7.35738 6.06057 7.22818 6.11165 7.13293 6.20257C7.03767 6.2935 6.98415 6.41682 6.98415 6.54541C6.98415 6.674 7.03767 6.79733 7.13293 6.88825L10.1803 9.79709C10.2755 9.88802 10.405 9.93935 10.5397 9.93935C10.6744 9.93935 10.8036 9.88827 10.8989 9.79734C10.9941 9.70642 11.0476 9.58309 11.0476 9.4545C11.0476 9.32592 10.9941 9.20259 10.8989 9.11167L7.85126 6.20257Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Supprimer = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M1.41176 12.9411C0.956941 13.396 0.956941 14.1334 1.41176 14.5882C1.86659 15.043 2.604 15.043 3.05882 14.5882L8 9.64702L12.9412 14.5882C13.396 15.043 14.1334 15.043 14.5882 14.5882C15.0431 14.1334 15.0431 13.396 14.5882 12.9411L9.64706 7.99996L14.5882 3.05878C15.0431 2.60396 15.0431 1.86655 14.5882 1.41172C14.1334 0.9569 13.396 0.9569 12.9412 1.41172L8 6.3529L3.05882 1.41172C2.604 0.9569 1.86659 0.9569 1.41176 1.41172C0.956941 1.86655 0.956941 2.60396 1.41176 3.05878L6.35294 7.99996L1.41176 12.9411Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Swap = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M6.03992 13.0083V1.58333C6.03992 1.26117 6.29064 1 6.59992 1C6.9092 1 7.15992 1.26117 7.15992 1.58333V13.76L7.15998 13.7626L7.15992 14.4167C7.15992 14.5777 7.0973 14.7234 6.99604 14.829C6.93334 14.8943 6.85942 14.941 6.78079 14.9689C6.73271 14.986 6.68169 14.9964 6.62874 14.9992C6.61919 14.9997 6.60958 15 6.59992 15C6.50327 15 6.41234 14.9745 6.33299 14.9296C6.31051 14.9169 6.28896 14.9026 6.26847 14.8869C6.2434 14.8677 6.21992 14.8464 6.19828 14.8232L1.16402 9.57915C1.059 9.46975 1 9.32138 1 9.16667C1 9.01196 1.059 8.86358 1.16402 8.75419C1.26904 8.64479 1.41148 8.58333 1.56 8.58333C1.70852 8.58333 1.85096 8.64479 1.95598 8.75419L6.03992 13.0083Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M9.96008 2.99171V14.4167C9.96008 14.7388 9.70936 15 9.40008 15C9.0908 15 8.84008 14.7388 8.84008 14.4167V2.24003L8.84002 2.23744L8.84008 1.58333C8.84008 1.42232 8.9027 1.27655 9.00396 1.171C9.06649 1.10586 9.14019 1.05921 9.21858 1.03132C9.2755 1.01102 9.33656 1 9.40008 1C9.49673 1 9.58766 1.0255 9.66701 1.07041C9.68631 1.08132 9.70492 1.09339 9.72276 1.10652C9.75115 1.1274 9.77759 1.15096 9.80174 1.17685L14.836 6.42085C14.941 6.53025 15 6.67862 15 6.83333C15 6.98804 14.941 7.13642 14.836 7.24581C14.731 7.35521 14.5885 7.41667 14.44 7.41667C14.2915 7.41667 14.149 7.35521 14.044 7.24581L9.96008 2.99171Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Tablette = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.3636 1C12.3636 1 13.0414 1 13.5207 1.47314C13.5207 1.47314 14 1.94627 14 2.61538V13.3846C14 13.3846 14 14.0537 13.5207 14.5269C13.5207 14.5269 13.0414 15 12.3636 15H3.63636C3.63636 15 2.95856 15 2.47928 14.5269C2.47928 14.5269 2 14.0537 2 13.3846V2.61538C2 2.61538 2 1.94627 2.47928 1.47314C2.47928 1.47314 2.95856 1 3.63636 1H12.3636ZM12.9091 12.7692H3.09091V3.23077H12.9091V12.7692Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Tenx = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.22023 5.51306C6.02709 5.31992 5.71469 5.31752 5.5186 5.50767L3.3186 7.641C3.22149 7.73517 3.16668 7.86468 3.16668 7.99995C3.16668 8.13523 3.22149 8.26473 3.3186 8.3589L5.5186 10.4922C5.71469 10.6824 6.02709 10.68 6.22023 10.4868L8.00001 8.70706L9.77979 10.4868C9.97293 10.68 10.2853 10.6824 10.4814 10.4922L12.6814 8.3589C12.7785 8.26473 12.8333 8.13523 12.8333 7.99995C12.8333 7.86468 12.7785 7.73517 12.6814 7.641L10.4814 5.50767C10.2853 5.31752 9.97293 5.31992 9.77979 5.51306L8.00001 7.29284L6.22023 5.51306ZM5.86128 6.56833L7.2929 7.99995L5.86128 9.43157L4.38492 7.99995L5.86128 6.56833ZM10.1387 9.43157L8.70712 7.99995L10.1387 6.56833L11.6151 7.99995L10.1387 9.43157Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.00001 0.833252C4.04197 0.833252 0.833344 4.04188 0.833344 7.99992C0.833344 11.958 4.04197 15.1666 8.00001 15.1666C11.9581 15.1666 15.1667 11.958 15.1667 7.99992C15.1667 4.04188 11.9581 0.833252 8.00001 0.833252ZM1.83334 7.99992C1.83334 4.59416 4.59425 1.83325 8.00001 1.83325C11.4058 1.83325 14.1667 4.59416 14.1667 7.99992C14.1667 11.4057 11.4058 14.1666 8.00001 14.1666C4.59425 14.1666 1.83334 11.4057 1.83334 7.99992Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Tether = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M4.88359 5.75166C4.88359 5.48519 5.10372 5.26917 5.37526 5.26917H10.6197C10.8913 5.26917 11.1114 5.48519 11.1114 5.75166C11.1114 6.01813 10.8913 6.23415 10.6197 6.23415H8.48915V9.61159C8.48915 9.87806 8.26902 10.0941 7.99748 10.0941C7.72594 10.0941 7.50582 9.87806 7.50582 9.61159V6.23415H5.37526C5.10372 6.23415 4.88359 6.01813 4.88359 5.75166Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.02778 2C4.5791 2 4.11995 2.15702 3.73698 2.38981C3.35501 2.62199 3.00727 2.95484 2.81076 3.35165L1.23878 6.44979C0.998054 6.92248 0.950115 7.47455 1.04684 7.98049C1.14357 8.48644 1.39185 8.98351 1.7905 9.33815L6.3335 13.3846C7.25761 14.2048 8.74325 14.2053 9.66736 13.3852L14.211 9.33815L14.2124 9.33683C14.6065 8.98265 14.8544 8.48657 14.952 7.98128C15.0496 7.4761 15.0041 6.92397 14.763 6.45036L13.1902 3.35063C12.9906 2.95509 12.6415 2.62188 12.2583 2.38955C11.8749 2.15705 11.4159 2 10.9671 2H5.02778ZM3.61417 3.73628C3.71942 3.52296 3.93158 3.3034 4.20769 3.13557C4.48355 2.96789 4.78158 2.87723 5.02778 2.87723H10.9671C11.2133 2.87723 11.5114 2.96786 11.7885 3.13583C12.0656 3.30384 12.2804 3.52429 12.389 3.73963L12.3895 3.74063L13.9631 6.8421C14.102 7.11461 14.1417 7.4661 14.0737 7.81795C14.0058 8.16953 13.8377 8.48377 13.6094 8.68928L9.06777 12.7345C8.48419 13.2521 7.51766 13.2524 6.93408 12.7349L2.39128 8.68858C2.16074 8.48355 1.99257 8.16991 1.92543 7.81873C1.85829 7.46758 1.89898 7.11558 2.03832 6.8421L3.61199 3.74063L3.61417 3.73628Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const TheGraph = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.53335 4.29989C6.00536 4.29989 4.76669 5.53857 4.76669 7.06655C4.76669 8.59454 6.00536 9.83322 7.53335 9.83322C9.06134 9.83322 10.3 8.59454 10.3 7.06655C10.3 5.53857 9.06134 4.29989 7.53335 4.29989ZM5.76669 7.06655C5.76669 6.09085 6.55765 5.29989 7.53335 5.29989C8.50905 5.29989 9.30002 6.09085 9.30002 7.06655C9.30002 8.04226 8.50905 8.83322 7.53335 8.83322C6.55765 8.83322 5.76669 8.04226 5.76669 7.06655Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M10.4202 10.2202C10.6155 10.0249 10.6155 9.70833 10.4202 9.51306C10.2249 9.3178 9.90836 9.3178 9.7131 9.51306L7.7131 11.5131C7.51784 11.7083 7.51784 12.0249 7.7131 12.2202C7.90836 12.4154 8.22494 12.4154 8.42021 12.2202L10.4202 10.2202Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M10.3333 4.87492C10.3333 5.24311 10.6318 5.54158 11 5.54158C11.3682 5.54158 11.6667 5.24311 11.6667 4.87492C11.6667 4.50673 11.3682 4.20825 11 4.20825C10.6318 4.20825 10.3333 4.50673 10.3333 4.87492Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0.833336 7.99992C0.833336 4.04188 4.04196 0.833252 8 0.833252C11.958 0.833252 15.1667 4.04188 15.1667 7.99992C15.1667 11.958 11.958 15.1666 8 15.1666C4.04196 15.1666 0.833336 11.958 0.833336 7.99992ZM8 1.83325C4.59425 1.83325 1.83334 4.59416 1.83334 7.99992C1.83334 11.4057 4.59425 14.1666 8 14.1666C11.4058 14.1666 14.1667 11.4057 14.1667 7.99992C14.1667 4.59416 11.4058 1.83325 8 1.83325Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Theta = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M8.49998 5.66658C8.49998 5.39044 8.27612 5.16658 7.99998 5.16658C7.72384 5.16658 7.49998 5.39044 7.49998 5.66658V6.49992H6.66665C6.3905 6.49992 6.16665 6.72378 6.16665 6.99992C6.16665 7.27606 6.3905 7.49992 6.66665 7.49992H9.33331C9.60945 7.49992 9.83331 7.27606 9.83331 6.99992C9.83331 6.72378 9.60945 6.49992 9.33331 6.49992H8.49998V5.66658Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M9.33331 9.49992H8.49998V10.3333C8.49998 10.6094 8.27612 10.8333 7.99998 10.8333C7.72384 10.8333 7.49998 10.6094 7.49998 10.3333V9.49992H6.66665C6.3905 9.49992 6.16665 9.27606 6.16665 8.99992C6.16665 8.72378 6.3905 8.49992 6.66665 8.49992H9.33331C9.60945 8.49992 9.83331 8.72378 9.83331 8.99992C9.83331 9.27606 9.60945 9.49992 9.33331 9.49992Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.93331 3.49992C4.92384 3.49992 4.16665 4.25711 4.16665 5.26658V10.7333C4.16665 11.7597 5.0078 12.4999 5.93331 12.4999H10.0666C11.0683 12.4999 11.8064 11.7604 11.8975 10.8497C11.8992 10.8331 11.9 10.8165 11.9 10.7999V5.26658C11.9 4.24013 11.0588 3.49992 10.1333 3.49992H5.93331ZM5.16665 5.26658C5.16665 4.80939 5.47612 4.49992 5.93331 4.49992H10.1333C10.5411 4.49992 10.9 4.82638 10.9 5.26658V10.7723C10.8487 11.1841 10.5235 11.4999 10.0666 11.4999H5.93331C5.52549 11.4999 5.16665 11.1735 5.16665 10.7333V5.26658Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.99998 0.833252C4.284 0.833252 2.95274 1.17339 2.06309 2.06303C1.17345 2.95268 0.833313 4.28394 0.833313 5.99992V9.99992C0.833313 11.7159 1.17345 13.0472 2.06309 13.9368C2.95274 14.8265 4.284 15.1666 5.99998 15.1666H9.99998C11.716 15.1666 13.0472 14.8265 13.9369 13.9368C14.8265 13.0472 15.1666 11.7159 15.1666 9.99992V5.99992C15.1666 4.28394 14.8265 2.95268 13.9369 2.06303C13.0472 1.17339 11.716 0.833252 9.99998 0.833252H5.99998ZM1.83331 5.99992C1.83331 4.38257 2.15985 3.38049 2.7702 2.77014C3.38055 2.15978 4.38263 1.83325 5.99998 1.83325H9.99998C11.6173 1.83325 12.6194 2.15978 13.2298 2.77014C13.8401 3.38049 14.1666 4.38257 14.1666 5.99992V9.99992C14.1666 11.6173 13.8401 12.6193 13.2298 13.2297C12.6194 13.8401 11.6173 14.1666 9.99998 14.1666H5.99998C4.38263 14.1666 3.38055 13.8401 2.7702 13.2297C2.15985 12.6193 1.83331 11.6173 1.83331 9.99992V5.99992Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Thorchain = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M13.1947 2.84028C13.9985 1.80684 12.9225 0.508235 11.7625 0.930076L11.7518 0.93394L5.80807 3.40495L5.80305 3.40707C5.39531 3.58181 5.15556 3.94888 5.07778 4.31187C5.00071 4.67152 5.06717 5.10757 5.37979 5.42019L7.77443 7.81483L2.9047 13.1216C2.44862 13.5859 2.49429 14.2203 2.77772 14.6387C3.06863 15.0682 3.64979 15.3342 4.26575 15.0587L11.126 12.1947L11.1303 12.1929C11.9217 11.8537 12.1195 10.8557 11.5841 10.2132L11.5696 10.1958L9.14108 7.76727L13.1905 2.84569L13.1947 2.84028ZM12.4087 2.22199L8.43064 7.05683L6.0869 4.71309C6.06619 4.69238 6.03265 4.62843 6.05558 4.5214C6.07759 4.4187 6.13692 4.35271 6.19532 4.32693L12.1129 1.86682C12.2593 1.81701 12.3623 1.86994 12.4183 1.94383C12.4491 1.98435 12.4641 2.02978 12.4646 2.07231C12.4651 2.11007 12.4547 2.16104 12.4087 2.22199ZM8.48219 8.52259L10.8268 10.8672C10.9427 11.022 10.8747 11.2132 10.7379 11.2731L3.86687 14.1416L3.85978 14.1448C3.78627 14.1782 3.73995 14.1721 3.71148 14.1629C3.67648 14.1515 3.63694 14.1241 3.60564 14.0779C3.57411 14.0313 3.56108 13.9805 3.56302 13.9388C3.56466 13.9034 3.57679 13.8636 3.62023 13.8202L3.62782 13.8126L8.48219 8.52259Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Titre_en_bourse = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M1.26984 0.634921C1.26984 0.284264 0.985578 0 0.634921 0C0.284264 0 0 0.284264 0 0.634921V14.3492C0 15.2609 0.739085 16 1.65079 16H15.3651C15.7157 16 16 15.7157 16 15.3651C16 15.0144 15.7157 14.7302 15.3651 14.7302H1.65079C1.4404 14.7302 1.26984 14.5596 1.26984 14.3492V0.634921Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M15.006 2.81429C15.3739 2.70146 15.7261 3.02929 15.6398 3.4044L14.8541 6.82053C14.7678 7.19563 14.3079 7.33668 14.0261 7.07441L13.1436 6.25283L9.22805 10.9026C9.00652 11.1657 8.61407 11.2003 8.34986 10.9801L5.85956 8.9049L2.75314 13.1208C2.54838 13.3986 2.15712 13.4579 1.87923 13.2532C1.60134 13.0484 1.54206 12.6571 1.74682 12.3793L5.24682 7.62926C5.34899 7.4906 5.50385 7.40025 5.67484 7.37954C5.84583 7.35883 6.01778 7.40961 6.15009 7.51987L8.67243 9.62181L12.2276 5.40003L11.4605 4.68591C11.1788 4.42364 11.2867 3.95475 11.6547 3.84192L15.006 2.81429Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const TPP = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8 1.94595C7.37308 1.94595 6.86487 2.45416 6.86487 3.08108C6.86487 3.708 7.37308 4.21622 8 4.21622C8.62692 4.21622 9.13514 3.708 9.13514 3.08108C9.13514 2.45416 8.62692 1.94595 8 1.94595ZM7.24324 3.08108C7.24324 2.66314 7.58205 2.32432 8 2.32432C8.41794 2.32432 8.75676 2.66314 8.75676 3.08108C8.75676 3.49903 8.41794 3.83784 8 3.83784C7.58205 3.83784 7.24324 3.49903 7.24324 3.08108Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M6.18566 5.91892C6.18566 5.0478 7.03692 4.40541 7.99998 4.40541C8.96305 4.40541 9.81431 5.0478 9.81431 5.91892C9.81431 6.02341 9.7296 6.10811 9.62512 6.10811C9.52063 6.10811 9.43593 6.02341 9.43593 5.91892C9.43593 5.32571 8.83043 4.78378 7.99998 4.78378C7.16954 4.78378 6.56404 5.32571 6.56404 5.91892C6.56404 6.02341 6.47933 6.10811 6.37485 6.10811C6.27036 6.10811 6.18566 6.02341 6.18566 5.91892Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.21622 8.75676C3.5893 8.75676 3.08108 9.26497 3.08108 9.89189C3.08108 10.5188 3.5893 11.027 4.21622 11.027C4.84313 11.027 5.35135 10.5188 5.35135 9.89189C5.35135 9.26497 4.84313 8.75676 4.21622 8.75676ZM3.45946 9.89189C3.45946 9.47395 3.79827 9.13514 4.21622 9.13514C4.63416 9.13514 4.97297 9.47395 4.97297 9.89189C4.97297 10.3098 4.63416 10.6486 4.21622 10.6486C3.79827 10.6486 3.45946 10.3098 3.45946 9.89189Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M4.2162 11.2162C3.25313 11.2162 2.40188 11.8586 2.40188 12.7297C2.40188 12.8342 2.48658 12.9189 2.59106 12.9189C2.69555 12.9189 2.78025 12.8342 2.78025 12.7297C2.78025 12.1365 3.38575 11.5946 4.2162 11.5946C5.04664 11.5946 5.65214 12.1365 5.65214 12.7297C5.65214 12.8342 5.73685 12.9189 5.84133 12.9189C5.94582 12.9189 6.03052 12.8342 6.03052 12.7297C6.03052 11.8586 5.17927 11.2162 4.2162 11.2162Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.6486 9.89189C10.6486 9.26497 11.1569 8.75676 11.7838 8.75676C12.4107 8.75676 12.9189 9.26497 12.9189 9.89189C12.9189 10.5188 12.4107 11.027 11.7838 11.027C11.1569 11.027 10.6486 10.5188 10.6486 9.89189ZM11.7838 9.13514C11.3658 9.13514 11.027 9.47395 11.027 9.89189C11.027 10.3098 11.3658 10.6486 11.7838 10.6486C12.2017 10.6486 12.5405 10.3098 12.5405 9.89189C12.5405 9.47395 12.2017 9.13514 11.7838 9.13514Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M11.7838 11.2162C10.8207 11.2162 9.96944 11.8586 9.96944 12.7297C9.96944 12.8342 10.0541 12.9189 10.1586 12.9189C10.2631 12.9189 10.3478 12.8342 10.3478 12.7297C10.3478 12.1365 10.9533 11.5946 11.7838 11.5946C12.6142 11.5946 13.2197 12.1365 13.2197 12.7297C13.2197 12.8342 13.3044 12.9189 13.4089 12.9189C13.5134 12.9189 13.5981 12.8342 13.5981 12.7297C13.5981 11.8586 12.7468 11.2162 11.7838 11.2162Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.2162 4.21622C11.2162 5.20895 10.7664 6.09663 10.0596 6.6866L11.2311 7.85812C11.4106 7.82702 11.5953 7.81081 11.7838 7.81081C13.5601 7.81081 15 9.25076 15 11.027C15 12.8033 13.5601 14.2432 11.7838 14.2432C10.0075 14.2432 8.56757 12.8033 8.56757 11.027H7.43243C7.43243 12.8033 5.99248 14.2432 4.21622 14.2432C2.43995 14.2432 1 12.8033 1 11.027C1 9.25076 2.43995 7.81081 4.21622 7.81081C4.40868 7.81081 4.5972 7.82772 4.78037 7.86013L5.94779 6.69271C5.23667 6.10277 4.78378 5.21238 4.78378 4.21622C4.78378 2.43995 6.22373 1 8 1C9.77627 1 11.2162 2.43995 11.2162 4.21622ZM10.8378 4.21622C10.8378 5.78351 9.5673 7.05405 8 7.05405C6.43271 7.05405 5.16216 5.78351 5.16216 4.21622C5.16216 2.64892 6.43271 1.37838 8 1.37838C9.5673 1.37838 10.8378 2.64892 10.8378 4.21622ZM6.25637 6.91923L5.20873 7.96687C6.38375 8.3477 7.26249 9.38648 7.41041 10.6486H8.58959C8.73794 9.38284 9.62132 8.34172 10.8014 7.9636L9.75178 6.91394C9.24777 7.2419 8.64614 7.43243 8 7.43243C7.35734 7.43243 6.75871 7.24394 6.25637 6.91923ZM4.21622 13.8649C5.78351 13.8649 7.05405 12.5943 7.05405 11.027C7.05405 9.45973 5.78351 8.18919 4.21622 8.18919C2.64892 8.18919 1.37838 9.45973 1.37838 11.027C1.37838 12.5943 2.64892 13.8649 4.21622 13.8649ZM8.94595 11.027C8.94595 12.5943 10.2165 13.8649 11.7838 13.8649C13.3511 13.8649 14.6216 12.5943 14.6216 11.027C14.6216 9.45973 13.3511 8.18919 11.7838 8.18919C10.2165 8.18919 8.94595 9.45973 8.94595 11.027Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Transfer = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M11.6115 2.15976C11.5105 2.05747 11.3736 2 11.2308 2C11.088 2 10.951 2.05747 10.85 2.15976C10.749 2.26205 10.6923 2.40079 10.6923 2.54545C10.6923 2.69012 10.749 2.82886 10.85 2.93115L13.7 5.81818L10.8502 8.70501C10.7492 8.8073 10.6923 8.94625 10.6923 9.09091C10.6923 9.09965 10.6925 9.10838 10.6929 9.11711C10.6994 9.25256 10.7554 9.38072 10.85 9.4766C10.951 9.5789 11.088 9.63636 11.2308 9.63636C11.3736 9.63636 11.5105 9.5789 11.6115 9.4766L14.8423 6.20388C14.9433 6.10158 15 5.96285 15 5.81818C15 5.67352 14.9433 5.53478 14.8423 5.43249L11.6115 2.15976Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M2.07692 12.9091V4.72727C2.07692 4.42603 1.83585 4.18182 1.53846 4.18182C1.24108 4.18182 1 4.42603 1 4.72727V12.9091C1 13.361 1.31542 13.6805 1.31542 13.6805C1.63085 14 2.07692 14 2.07692 14H12.3077C12.6051 14 12.8462 13.7558 12.8462 13.4545C12.8462 13.1533 12.6051 12.9091 12.3077 12.9091H2.07692Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M10.6923 6.36364H14.4615C14.7589 6.36364 15 6.11943 15 5.81818C15 5.51694 14.7589 5.27273 14.4615 5.27273H10.6923C8.29802 5.27346 6.40493 6.75811 6.40493 6.75811C4.51207 8.24259 3.91158 10.5899 3.91158 10.5899L3.91144 10.5905C3.90001 10.6352 3.89423 10.6811 3.89423 10.7273C3.89423 10.7345 3.89437 10.7418 3.89466 10.749C3.89819 10.8388 3.9236 10.9264 3.96863 11.0039C4.04106 11.1286 4.15941 11.219 4.29766 11.2553C4.34176 11.2669 4.38713 11.2727 4.43269 11.2727L4.4463 11.2726C4.68654 11.2664 4.89368 11.0997 4.95395 10.8641C5.46207 8.87719 7.06419 7.62072 7.06419 7.62072C8.66632 6.36426 10.6923 6.36364 10.6923 6.36364Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Trier = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M12.4946 0.739488C12.6981 0.380945 13.2068 0.380945 13.4103 0.739489L15.9284 5.17646C16.1319 5.53501 15.8775 5.98319 15.4705 5.98319H13.7454V12.0336C13.7454 12.4791 13.3904 12.8403 12.9524 12.8403C12.5144 12.8403 12.1594 12.4791 12.1594 12.0336V5.98319H10.4343C10.0273 5.98319 9.77296 5.53501 9.97644 5.17646L12.4946 0.739488Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M0 3.96638C0 3.52084 0.35504 3.15966 0.793005 3.15966H4.49369C4.93166 3.15966 5.2867 3.52084 5.2867 3.96638C5.2867 4.41192 4.93166 4.7731 4.49369 4.7731H0.793005C0.35504 4.7731 0 4.41192 0 3.96638Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M0 7.19327C0 6.74773 0.35504 6.38655 0.793005 6.38655H7.13704C7.57501 6.38655 7.93005 6.74773 7.93005 7.19327C7.93005 7.63881 7.57501 7.99999 7.13704 7.99999H0.793005C0.35504 7.99999 0 7.63881 0 7.19327Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M0.793005 10.1513C0.35504 10.1513 0 10.5124 0 10.958C0 11.4035 0.35504 11.7647 0.793005 11.7647H9.78039C10.2184 11.7647 10.5734 11.4035 10.5734 10.958C10.5734 10.5124 10.2184 10.1513 9.78039 10.1513H0.793005Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M0 14.7227C0 14.2771 0.35504 13.916 0.793005 13.916H12.4237C12.8617 13.916 13.2167 14.2771 13.2167 14.7227C13.2167 15.1682 12.8617 15.5294 12.4237 15.5294H0.793005C0.35504 15.5294 0 15.1682 0 14.7227Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Trontron = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2.10287 0.700143L11.9408 1.93347C11.9686 1.9353 11.9969 1.93896 12.0251 1.94411C12.1778 1.90868 12.3448 1.95229 12.4612 2.07359C12.5018 2.11593 12.5327 2.16403 12.554 2.21513C12.5843 2.24543 12.6135 2.27937 12.6401 2.31732L14.9337 4.51612C15.4775 4.93417 15.4075 5.67057 15.074 6.09685L15.0667 6.10592L7.93052 14.7666C7.65422 15.1177 7.26758 15.3805 6.81498 15.3263C6.36229 15.2721 6.0488 14.9249 5.86402 14.5263C5.86145 14.5208 5.859 14.5152 5.85665 14.5095L0.767765 2.2767C0.76426 2.26828 0.761007 2.25975 0.75801 2.25113C0.610869 1.82795 0.624943 1.36255 0.922728 1.02355C1.21658 0.689021 1.66779 0.612716 2.10287 0.700143ZM11.0888 2.75269L2.27173 1.64734L7.55388 6.1415L11.0888 2.75269ZM7.99729 7.14676L7.34431 14.0328L13.9602 6.00346L7.99729 7.14676ZM14.1444 5.03257L9.0122 6.01659L12.0915 3.06455L14.1444 5.03257ZM6.46418 13.5768L1.85648 2.50067L7.09209 6.95523L6.46418 13.5768Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Telechargement = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M8.80839 0.813559C8.80839 0.364243 8.4585 0 8.02688 0C7.59526 0 7.24537 0.364243 7.24537 0.813559V10.348L3.55465 6.80926C3.23718 6.50486 2.74277 6.52601 2.45036 6.8565C2.15795 7.187 2.17827 7.70168 2.49574 8.00608L8.00616 13.2896L13.9516 8.02749C14.2804 7.73645 14.3203 7.22302 14.0408 6.8807C13.7612 6.53838 13.268 6.49681 12.9391 6.78785L8.80839 10.4438V0.813559Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M1.72267 14.3729C1.29106 14.3729 0.941162 14.7371 0.941162 15.1864C0.941162 15.6358 1.29106 16 1.72267 16H14.7479C15.1795 16 15.5294 15.6358 15.5294 15.1864C15.5294 14.7371 15.1795 14.3729 14.7479 14.3729H1.72267Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Telephone = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.78087 1C3.1665 1 2.60622 1.26025 2.12245 1.73453C1.73334 2.1019 1.44801 2.51942 1.26657 2.97944C1.08775 3.42629 1 3.90642 1 4.40282C1 5.15224 1.17329 5.92473 1.50734 6.71696L1.50784 6.71816C1.8385 7.49547 2.29024 8.273 2.84574 9.04421L2.84714 9.04613C3.40743 9.8146 4.0346 10.5485 4.72823 11.2479L4.73105 11.2507C5.43149 11.9434 6.16627 12.5695 6.94198 13.1353C7.71659 13.6985 8.50281 14.1498 9.29313 14.4861C10.0932 14.8265 10.8674 15 11.6056 15C12.1193 15 12.6019 14.9045 13.0496 14.7184C13.5148 14.5278 13.9201 14.2326 14.2795 13.8372C14.4996 13.5946 14.6671 13.3361 14.7956 13.0643C14.9333 12.773 15 12.4693 15 12.1704C15 11.9228 14.946 11.7059 14.8649 11.5035L14.8623 11.497L14.8595 11.4906C14.7522 11.2471 14.5796 11.0528 14.3561 10.8978L12.1708 9.34843L12.1673 9.34609C11.9871 9.22369 11.8095 9.12198 11.6297 9.04854C11.4418 8.97178 11.2569 8.93224 11.0712 8.93224C10.8263 8.93224 10.605 9.00139 10.4 9.12363C10.2024 9.2287 10.0148 9.38182 9.8371 9.55917L9.34367 10.0454L9.33847 10.0451L9.33571 10.0449C9.32559 10.0404 9.31513 10.0356 9.30315 10.0301L9.29769 10.0276C9.28474 10.0217 9.26759 10.0138 9.24917 10.006C9.06232 9.90496 8.80915 9.72977 8.48757 9.45807C8.14963 9.17152 7.81544 8.85737 7.46363 8.51262C7.12954 8.17245 6.82014 7.83139 6.52867 7.49511C6.25945 7.17725 6.07993 6.92761 5.97795 6.74779C5.97042 6.72833 5.96326 6.71143 5.95806 6.69915L5.95602 6.69434C5.95148 6.68363 5.94766 6.67462 5.94431 6.66649C5.943 6.65926 5.94228 6.65333 5.94191 6.64783L6.43067 6.14049C6.6047 5.96632 6.75345 5.78194 6.86139 5.59278C6.98685 5.38486 7.05655 5.15549 7.05655 4.91671C7.05655 4.72366 7.0069 4.53076 6.9322 4.3558C6.85845 4.17659 6.75597 3.99823 6.62348 3.81432L5.09487 1.66281C4.93165 1.42821 4.72187 1.26479 4.49088 1.15779C4.26749 1.05127 4.02232 1 3.78087 1ZM2.69785 2.3245C3.05785 1.97063 3.42013 1.82353 3.78087 1.82353C3.90786 1.82353 4.0311 1.85089 4.13683 1.90157L4.14247 1.90422C4.25275 1.95504 4.34486 2.02777 4.41828 2.13367L4.421 2.13756L5.95163 4.29191L5.9533 4.29424C6.05712 4.43823 6.12545 4.56151 6.17019 4.67073L6.17283 4.67703C6.21614 4.77793 6.23186 4.86057 6.23186 4.91671C6.23186 4.99194 6.21049 5.07676 6.15343 5.17037L6.14996 5.17606L6.14668 5.18186C6.08394 5.2927 5.98428 5.42161 5.84462 5.56107L5.8418 5.56389L5.33991 6.08485C5.18594 6.24033 5.11687 6.43242 5.11687 6.63624C5.11687 6.72795 5.12901 6.80789 5.14898 6.88763L5.15467 6.91038L5.16292 6.93235C5.1752 6.96505 5.18753 6.99409 5.19578 7.01352L5.19812 7.01903C5.20765 7.04153 5.20981 7.04736 5.2106 7.04974L5.22221 7.08452L5.23979 7.1167C5.37804 7.36979 5.603 7.6776 5.90058 8.0288L5.90356 8.03227C6.20464 8.3797 6.52722 8.73546 6.87767 9.09214L6.8804 9.09491L6.88317 9.09763C7.24275 9.45006 7.59375 9.78056 7.95413 10.0861C8.30941 10.3863 8.61887 10.6047 8.87917 10.7423L8.89857 10.7525L8.91896 10.7607C8.92452 10.7629 8.9336 10.7669 8.95473 10.7766L8.95985 10.7789C8.97782 10.7871 9.00227 10.7983 9.02843 10.8095L9.03717 10.8133L9.04607 10.8166C9.15911 10.8589 9.26448 10.8692 9.3558 10.8692C9.58261 10.8692 9.77127 10.7825 9.91679 10.6377L9.91787 10.6366L10.4173 10.1444L10.4193 10.1425C10.5675 9.9944 10.6923 9.90014 10.7935 9.84742L10.8055 9.84114L10.8171 9.83408C10.9124 9.7762 10.9908 9.75576 11.0712 9.75576C11.1361 9.75576 11.2151 9.76892 11.3175 9.81075C11.4272 9.85557 11.5521 9.92444 11.7002 10.0248L13.8805 11.5706L13.8845 11.5734C14.0003 11.6534 14.0642 11.7334 14.102 11.8165C14.1511 11.9407 14.1753 12.0512 14.1753 12.1704C14.1753 12.3458 14.1364 12.5296 14.0499 12.7126C13.9541 12.9152 13.8311 13.1049 13.6685 13.284C13.3816 13.5997 13.0748 13.8181 12.7357 13.9569L12.7335 13.9578C12.3898 14.1008 12.015 14.1765 11.6056 14.1765C10.9978 14.1765 10.3337 14.0337 9.61639 13.7285C8.88932 13.4191 8.15762 13.0005 7.42804 12.47C6.68696 11.9295 5.98407 11.3307 5.31276 10.6669C4.64816 9.99669 4.0489 9.29515 3.51457 8.56239C2.98853 7.83199 2.56971 7.10791 2.26714 6.39676C1.968 5.68711 1.82469 5.02358 1.82469 4.40282C1.82469 4.00362 1.89515 3.62765 2.03271 3.28422L2.03357 3.28205C2.16835 2.93999 2.38324 2.62101 2.69154 2.33057L2.69472 2.32757L2.69785 2.3245Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const USB = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.5 4.55172C10.5 5.40872 9.82843 6.10345 9 6.10345C8.31617 6.10345 7.73922 5.63008 7.55864 4.98282C7.17364 4.98464 6.97576 5.0301 6.80719 5.16131C6.6173 5.30913 6.41656 5.60298 6.13731 6.24495C5.997 6.5675 5.89622 6.84619 5.80747 7.0916L5.79865 7.116C5.72919 7.30804 5.66229 7.49281 5.58685 7.65517H12.7083V6.5184C12.7083 6.25295 12.9861 6.08705 13.2083 6.21977L15.8333 7.78758C16.0556 7.9203 16.0556 8.25211 15.8333 8.38484L13.2083 9.95264C12.9861 10.0854 12.7083 9.91946 12.7083 9.65401V8.51724H7.2092C7.38467 8.77372 7.54749 9.09837 7.72064 9.49643C7.86999 9.83976 7.97729 10.1365 8.06573 10.3811L8.07574 10.4088C8.16891 10.6664 8.23496 10.8441 8.3075 10.9781C8.37513 11.103 8.43498 11.1635 8.5025 11.2011C8.57588 11.2418 8.69552 11.2759 8.91667 11.2759H9.16667V10.2414C9.16667 10.1462 9.24129 10.069 9.33333 10.069H11.8333C11.9254 10.069 12 10.1462 12 10.2414V12.8276C12 12.9228 11.9254 13 11.8333 13H9.33333C9.24129 13 9.16667 12.9228 9.16667 12.8276V11.9655H8.91667C8.63781 11.9655 8.39495 11.9241 8.18708 11.8086C7.97336 11.6899 7.8332 11.5134 7.72583 11.315C7.62337 11.1258 7.53942 10.894 7.45135 10.6505L7.44256 10.6262C7.35382 10.3808 7.253 10.102 7.11269 9.77944C6.83255 9.13543 6.6291 8.8135 6.43008 8.64227C6.3695 8.59015 6.30563 8.54892 6.23237 8.51724H3.59766C3.38001 9.31328 2.67252 9.89655 1.83333 9.89655C0.820811 9.89655 0 9.04744 0 8C0 6.95256 0.820811 6.10345 1.83333 6.10345C2.73202 6.10345 3.47969 6.77237 3.63644 7.65517H4.76663C4.82651 7.61692 4.88132 7.5566 4.9425 7.44358C5.01504 7.30958 5.08109 7.13189 5.17427 6.8743L5.18427 6.84665C5.27271 6.60205 5.38001 6.30528 5.52936 5.96194C5.8126 5.31081 6.0702 4.87191 6.40635 4.61024C6.74308 4.34812 7.11342 4.2977 7.52069 4.29342C7.63958 3.55937 8.25664 3 9 3C9.82843 3 10.5 3.69473 10.5 4.55172ZM9.83333 4.55172C9.83333 5.02783 9.46024 5.41379 9 5.41379C8.53976 5.41379 8.16667 5.02783 8.16667 4.55172C8.16667 4.07562 8.53976 3.68966 9 3.68966C9.46024 3.68966 9.83333 4.07562 9.83333 4.55172ZM1.83333 9.2069C2.47767 9.2069 3 8.66655 3 8C3 7.33345 2.47767 6.7931 1.83333 6.7931C1.189 6.7931 0.666667 7.33345 0.666667 8C0.666667 8.66655 1.189 9.2069 1.83333 9.2069ZM9.83333 10.7586V12.3103H11.3333V10.7586H9.83333ZM13.375 7.11566L15 8.08621L13.375 9.05675V7.11566Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const UsdCoin = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M10.9131 4.31303C11.1083 4.11777 11.4249 4.11777 11.6202 4.31303C13.6155 6.30829 13.6155 9.62488 11.6202 11.6201C11.4249 11.8154 11.1083 11.8154 10.9131 11.6201C10.7178 11.4249 10.7178 11.1083 10.9131 10.913C12.5178 9.30829 12.5178 6.62488 10.9131 5.02014C10.7178 4.82488 10.7178 4.50829 10.9131 4.31303Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M5.08687 4.37976C5.28214 4.57503 5.28214 4.89161 5.08687 5.08687C3.48214 6.69161 3.48214 9.37502 5.08687 10.9798C5.28214 11.175 5.28214 11.4916 5.08687 11.6869C4.89161 11.8821 4.57503 11.8821 4.37977 11.6869C2.38451 9.69161 2.38451 6.37503 4.37977 4.37976C4.57503 4.1845 4.89161 4.1845 5.08687 4.37976Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.39999 5.36662H7.49998V5.19995C7.49998 4.92381 7.72384 4.69995 7.99998 4.69995C8.27612 4.69995 8.49998 4.92381 8.49998 5.19995V5.36662H8.59999C9.47613 5.36662 10.1667 6.05714 10.1667 6.93328C10.1667 7.20943 9.9428 7.43328 9.66665 7.43328C9.39051 7.43328 9.16665 7.20943 9.16665 6.93328C9.16665 6.60943 8.92385 6.36662 8.59999 6.36662H8.49998V7.55711L9.16815 7.79575L9.17699 7.79899L9.18568 7.80238C9.38434 7.88184 9.63304 8.00723 9.82217 8.25456C10.0158 8.50779 10.1 8.82538 10.1 9.19995C10.1 10.0321 9.38619 10.6333 8.66665 10.6333H8.49998V10.8C8.49998 11.0761 8.27612 11.3 7.99998 11.3C7.72384 11.3 7.49998 11.0761 7.49998 10.8V10.6329C6.63972 10.6157 5.96665 9.93162 5.96665 9.06662C5.96665 8.79047 6.19051 8.56662 6.46665 8.56662C6.7428 8.56662 6.96665 8.79047 6.96665 9.06662C6.96665 9.37926 7.19294 9.61637 7.49998 9.63242V8.26183L7.00985 8.08679C6.74388 8.04259 6.45769 7.94535 6.24714 7.70242C6.02357 7.44445 5.96665 7.11618 5.96665 6.79995C5.96665 5.99047 6.59051 5.36662 7.39999 5.36662ZM6.96665 6.79995C6.96665 6.54276 7.1428 6.36662 7.39999 6.36662H7.49998V7.19997L7.30149 7.12908C7.26989 7.1178 7.23724 7.10972 7.20403 7.10498C7.05474 7.08365 7.01046 7.05376 7.00281 7.04739C6.9975 7.03941 6.96665 6.98366 6.96665 6.79995ZM8.49998 9.63328V8.61897L8.82239 8.73412C8.95104 8.7864 9.00083 8.82673 9.02781 8.86201C9.05083 8.89211 9.09999 8.97452 9.09999 9.19995C9.09999 9.43443 8.88045 9.63328 8.66665 9.63328H8.49998ZM7.00152 7.04617L7.00281 7.04739C7.00205 7.04674 7.00149 7.04618 7.00152 7.04617Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.99998 0.833252C4.04194 0.833252 0.833313 4.04188 0.833313 7.99992C0.833313 11.958 4.04194 15.1666 7.99998 15.1666C11.958 15.1666 15.1666 11.958 15.1666 7.99992C15.1666 4.04188 11.958 0.833252 7.99998 0.833252ZM1.83331 7.99992C1.83331 4.59416 4.59422 1.83325 7.99998 1.83325C11.4057 1.83325 14.1666 4.59416 14.1666 7.99992C14.1666 11.4057 11.4057 14.1666 7.99998 14.1666C4.59422 14.1666 1.83331 11.4057 1.83331 7.99992Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Valider2 = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M7.08099 15.0552C6.76797 15.0377 6.46084 14.9061 6.22858 14.6622L0.347025 8.48654C-0.13503 7.98038 -0.112043 7.18253 0.398369 6.70449C0.908781 6.22645 1.71333 6.24924 2.19539 6.7554L6.97953 11.7788L13.6607 1.5181C14.0416 0.933215 14.8284 0.765238 15.4182 1.14291C16.008 1.52058 16.1774 2.30088 15.7966 2.88576L8.24579 14.4819C7.98405 14.8839 7.53052 15.0889 7.08099 15.0552Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Valide = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M2.45161 8.5C2.45161 5.15957 5.15957 2.45161 8.5 2.45161C9.74689 2.45161 10.9037 2.82814 11.8655 3.47357C12.1983 3.69693 12.6492 3.60817 12.8726 3.27531C13.096 2.94246 13.0072 2.49156 12.6743 2.2682C11.4808 1.46726 10.0439 1 8.5 1C4.35786 1 1 4.35786 1 8.5C1 12.6421 4.35786 16 8.5 16C12.6421 16 16 12.6421 16 8.5C16 7.55761 15.8258 6.6542 15.5073 5.82136C15.3641 5.44696 14.9445 5.25953 14.5701 5.40273C14.1957 5.54593 14.0083 5.96553 14.1515 6.33993C14.4077 7.0098 14.5484 7.73762 14.5484 8.5C14.5484 11.8404 11.8404 14.5484 8.5 14.5484C5.15957 14.5484 2.45161 11.8404 2.45161 8.5Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M15.8181 3.1741C16.0835 2.87369 16.0551 2.41501 15.7547 2.14961C15.4543 1.88421 14.9956 1.91259 14.7302 2.213L8.07665 9.74427L6.08064 7.95901C5.78186 7.69178 5.32301 7.71735 5.05578 8.01613C4.78855 8.31491 4.81413 8.77376 5.11291 9.04099L7.65323 11.3131C7.79728 11.4419 7.98677 11.508 8.1797 11.4966C8.37263 11.4853 8.55307 11.3975 8.68103 11.2526L15.8181 3.1741Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Velas = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M1.33333 1.5C1.05719 1.5 0.833332 1.72386 0.833332 2C0.833332 2.27614 1.05719 2.5 1.33333 2.5H14.6667C14.9428 2.5 15.1667 2.27614 15.1667 2C15.1667 1.72386 14.9428 1.5 14.6667 1.5H1.33333Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2.66667 3.7666C1.75921 3.7666 1.12098 4.75994 1.55279 5.62354C1.56094 5.63984 1.56997 5.65568 1.57985 5.671L6.91318 13.9377C6.91746 13.9443 6.92189 13.9508 6.92647 13.9572C7.43223 14.6653 8.54441 14.7504 9.02662 13.9276L14.3478 5.67973C14.9073 4.87923 14.331 3.7666 13.3333 3.7666H2.66667ZM7.7458 13.3836L2.43842 5.15719C2.35584 4.96049 2.51246 4.7666 2.66667 4.7666H13.3333C13.5311 4.7666 13.6208 4.97723 13.5265 5.10932C13.5219 5.11573 13.5175 5.12225 13.5132 5.12887L8.17985 13.3955C8.17499 13.4031 8.17033 13.4107 8.16588 13.4185C8.12892 13.4832 8.06924 13.5166 7.99167 13.5166C7.91303 13.5166 7.81772 13.4795 7.7458 13.3836Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Vendre = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M3.98082 3.58201H6V4.58371H4.15024L4.97349 9.45114L12.1484 9.45115L13.8899 4.58371H12V3.58201H13.8899C14.6056 3.58201 15.1085 4.25903 14.8759 4.90935L13.1344 9.77678C12.9897 10.1813 12.5936 10.4528 12.1484 10.4528H4.97349C4.46223 10.4528 4.0264 10.0967 3.94439 9.61181L2.66855 2.06837H1.06665V1.06666H2.66855C3.17981 1.06666 3.61564 1.42285 3.69764 1.9077L3.98082 3.58201Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.63598 13.2272C4.63598 12.2849 5.43102 11.5211 6.41174 11.5211C7.39247 11.5211 8.1875 12.2849 8.1875 13.2272C8.1875 14.1695 7.39247 14.9333 6.41174 14.9333C5.43102 14.9333 4.63598 14.1695 4.63598 13.2272ZM6.41174 12.5228C6.00682 12.5228 5.67857 12.8382 5.67857 13.2272C5.67857 13.6163 6.00682 13.9316 6.41174 13.9316C6.81666 13.9316 7.14491 13.6163 7.14491 13.2272C7.14491 12.8382 6.81666 12.5228 6.41174 12.5228Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.8114 11.5211C10.8307 11.5211 10.0357 12.2849 10.0357 13.2272C10.0357 14.1695 10.8307 14.9333 11.8114 14.9333C12.7921 14.9333 13.5872 14.1695 13.5872 13.2272C13.5872 12.2849 12.7921 11.5211 11.8114 11.5211ZM11.0782 13.2272C11.0782 12.8382 11.4065 12.5228 11.8114 12.5228C12.2163 12.5228 12.5446 12.8382 12.5446 13.2272C12.5446 13.6163 12.2163 13.9316 11.8114 13.9316C11.4065 13.9316 11.0782 13.6163 11.0782 13.2272Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M9.38668 7C9.38668 7.25527 9.17973 7.46222 8.92446 7.46222C8.66918 7.46222 8.46223 7.25527 8.46223 7V2.10701L6.94019 3.62906C6.75968 3.80957 6.46701 3.80957 6.28651 3.62906C6.106 3.44855 6.106 3.15589 6.28651 2.97538L8.59762 0.664267C8.6843 0.577583 8.80187 0.528885 8.92446 0.528885C9.04705 0.528885 9.16461 0.577583 9.2513 0.664267L11.5624 2.97538C11.7429 3.15589 11.7429 3.44855 11.5624 3.62906C11.3819 3.80957 11.0892 3.80957 10.9087 3.62906L9.38668 2.10701V7Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Vibe = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.88718 5.44086C5.97229 5.27263 6.14479 5.16658 6.33333 5.16658H9.66666C9.85519 5.16658 10.0277 5.27263 10.1128 5.44086C10.1979 5.60909 10.1812 5.81089 10.0695 5.96278L8.40282 8.22945C8.3086 8.35758 8.15904 8.43325 7.99999 8.43325C7.84095 8.43325 7.69139 8.35758 7.59717 8.22945L5.9305 5.96278C5.81882 5.81089 5.80207 5.60909 5.88718 5.44086ZM7.32159 6.16658L7.99999 7.08921L8.6784 6.16658H7.32159Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M5.07353 6.37597C4.91302 6.15126 4.60075 6.09921 4.37604 6.25972C4.15134 6.42022 4.09929 6.7325 4.25979 6.9572L7.59313 11.6239C7.68698 11.7553 7.83852 11.8333 7.99999 11.8333C8.16147 11.8333 8.31301 11.7553 8.40686 11.6239L11.7402 6.9572C11.9007 6.7325 11.8487 6.42022 11.6239 6.25972C11.3992 6.09921 11.087 6.15126 10.9265 6.37597L7.99999 10.473L5.07353 6.37597Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0.833328 7.99992C0.833328 4.04188 4.04195 0.833252 7.99999 0.833252C11.958 0.833252 15.1667 4.04188 15.1667 7.99992C15.1667 11.958 11.958 15.1666 7.99999 15.1666C4.04195 15.1666 0.833328 11.958 0.833328 7.99992ZM7.99999 1.83325C4.59424 1.83325 1.83333 4.59416 1.83333 7.99992C1.83333 11.4057 4.59424 14.1666 7.99999 14.1666C11.4058 14.1666 14.1667 11.4057 14.1667 7.99992C14.1667 4.59416 11.4058 1.83325 7.99999 1.83325Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Vignette = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1 2.86667C1 1.83574 1.83574 1 2.86667 1H5.66667C6.6976 1 7.53333 1.83574 7.53333 2.86667V7.53333H2.86667C1.83574 7.53333 1 6.6976 1 5.66667V2.86667ZM2.86667 1.93333H5.66667C6.18213 1.93333 6.6 2.3512 6.6 2.86667V6.6H2.86667C2.3512 6.6 1.93333 6.18213 1.93333 5.66667V2.86667C1.93333 2.3512 2.3512 1.93333 2.86667 1.93333Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1 10.3333C1 9.3024 1.83574 8.46667 2.86667 8.46667H7.53333V13.1333C7.53333 14.1643 6.6976 15 5.66667 15H2.86667C1.83574 15 1 14.1643 1 13.1333V10.3333ZM2.86667 9.4H6.6V13.1333C6.6 13.6488 6.18213 14.0667 5.66667 14.0667H2.86667C2.3512 14.0667 1.93333 13.6488 1.93333 13.1333V10.3333C1.93333 9.81787 2.3512 9.4 2.86667 9.4Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.3333 1C9.3024 1 8.46667 1.83574 8.46667 2.86667V7.53333H13.1333C14.1643 7.53333 15 6.6976 15 5.66667V2.86667C15 1.83574 14.1643 1 13.1333 1H10.3333ZM13.1333 1.93333H10.3333C9.81787 1.93333 9.4 2.3512 9.4 2.86667V6.6H13.1333C13.6488 6.6 14.0667 6.18213 14.0667 5.66667V2.86667C14.0667 2.3512 13.6488 1.93333 13.1333 1.93333Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.46667 8.46667H13.1333C14.1643 8.46667 15 9.3024 15 10.3333V13.1333C15 14.1643 14.1643 15 13.1333 15H10.3333C9.3024 15 8.46667 14.1643 8.46667 13.1333V8.46667ZM9.4 9.4H13.1333C13.6488 9.4 14.0667 9.81787 14.0667 10.3333V13.1333C14.0667 13.6488 13.6488 14.0667 13.1333 14.0667H10.3333C9.81787 14.0667 9.4 13.6488 9.4 13.1333V9.4Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Voice_ID = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.68337 1.34502C9.64992 1.12621 9.42758 0.973462 9.18675 1.00385C8.94592 1.03424 8.7778 1.23626 8.81125 1.45507L8.95599 2.4019C8.96001 2.45156 8.96468 2.49589 8.96904 2.53722C8.9844 2.68285 8.99583 2.7913 8.96097 2.96488C8.91584 3.18951 8.78431 3.53051 8.40875 4.08818C8.09407 4.5012 7.789 4.90482 7.5459 5.23736C7.32306 5.54219 7.13158 5.81476 7.04293 5.97726C6.97689 6.07279 6.91478 6.19426 6.88633 6.33033C6.85475 6.48132 6.8605 6.6775 6.98818 6.86067C7.11654 7.04482 7.32365 7.15206 7.55281 7.20568C7.77808 7.25838 8.05345 7.2672 8.38042 7.23807L8.3826 7.23788L8.38478 7.23766C8.44653 7.2316 8.47917 7.23754 8.49213 7.24106C8.50297 7.24399 8.50624 7.24669 8.50893 7.24907C8.51929 7.25822 8.55372 7.2998 8.57281 7.41447C8.61071 7.64212 8.55598 7.96145 8.47876 8.202C8.38841 8.41076 8.32725 8.67501 8.48293 8.92049C8.62834 9.14979 8.89566 9.24231 9.05899 9.29234C9.17993 9.32937 9.30139 9.35978 9.42691 9.3912C9.68556 9.45594 9.9615 9.52502 10.2855 9.66531C10.1889 9.72241 10.0681 9.78394 9.92861 9.85144C9.88203 9.87399 9.83276 9.89748 9.78233 9.92152L9.78193 9.92171C9.64548 9.98675 9.50056 10.0558 9.37732 10.1213C9.29439 10.1653 9.18383 10.229 9.09548 10.3216C8.99153 10.4304 8.92824 10.568 8.93031 10.728C8.9321 10.8662 8.98284 10.9927 9.03528 11.0957C9.08978 11.2028 9.16584 11.3216 9.25553 11.4519C9.37074 11.6194 9.39868 11.6809 9.41075 11.7333C9.42396 11.7906 9.42634 11.8739 9.39708 12.0999C9.38529 12.1909 9.38006 12.3293 9.44927 12.4734C9.52357 12.628 9.65649 12.7347 9.81009 12.8034C10.0785 12.9236 10.4788 12.9571 11.0179 12.9465C12.0914 12.9253 12.861 12.9378 13.1046 12.9463C13.1328 12.9473 13.2653 12.9669 13.4752 13.2506C13.6804 13.528 13.9073 13.9918 14.1368 14.7113C14.2045 14.9234 14.4487 15.0456 14.6822 14.9841C14.9157 14.9226 15.0502 14.7007 14.9825 14.4885C14.7424 13.736 14.485 13.1814 14.2059 12.8043C13.9315 12.4334 13.5798 12.1623 13.1384 12.1469C12.8732 12.1376 12.0854 12.1252 10.9987 12.1467C10.7405 12.1518 10.5525 12.1444 10.4172 12.1297C10.3594 12.1234 10.3152 12.1162 10.2819 12.1093C10.3043 11.9161 10.3123 11.7419 10.2725 11.5693C10.2259 11.367 10.1218 11.2018 10.0022 11.0279C9.93294 10.9273 9.88526 10.8523 9.85338 10.7953C9.94975 10.7452 10.0558 10.6946 10.1719 10.6393L10.1725 10.639L10.1732 10.6387C10.2275 10.6128 10.2839 10.5859 10.3426 10.5575C10.5281 10.4677 10.7354 10.3631 10.9017 10.2499C10.9854 10.193 11.0739 10.1238 11.147 10.0418C11.2188 9.96114 11.2978 9.84325 11.3154 9.69228C11.3567 9.33739 11.0559 9.12621 10.8314 9.01914C10.3547 8.79177 9.88314 8.67359 9.57564 8.59654C9.47954 8.57246 9.39943 8.55238 9.34024 8.53425C9.32023 8.52813 9.30319 8.52249 9.28875 8.51741C9.29267 8.50754 9.29732 8.4965 9.30282 8.48422L9.31075 8.46653L9.31679 8.44824C9.4129 8.15718 9.5103 7.69663 9.44341 7.29482C9.40967 7.09216 9.32597 6.85508 9.1228 6.67556C8.90404 6.48227 8.61109 6.41129 8.29259 6.44207C8.02197 6.46604 7.86035 6.45154 7.77239 6.43096L7.77124 6.43069C7.77737 6.41951 7.78491 6.4075 7.79393 6.3952L7.81269 6.36964L7.82693 6.34177C7.87336 6.25091 8.0306 6.02025 8.27935 5.67998C8.51921 5.35187 8.82287 4.95013 9.13968 4.53436L9.1466 4.52529L9.15295 4.51588C9.56503 3.90574 9.75513 3.46707 9.82716 3.10851C9.88617 2.81471 9.85988 2.57912 9.84238 2.42228L9.84235 2.42198C9.8386 2.38837 9.83525 2.35836 9.83324 2.3322L9.83219 2.31855L9.68337 1.34502ZM10.4857 9.76219C10.4894 9.76566 10.4918 9.76735 10.4921 9.76732C10.4923 9.76731 10.4918 9.76674 10.4904 9.76565C10.4901 9.76538 10.4897 9.76508 10.4892 9.76474C10.4883 9.76404 10.4871 9.76318 10.4857 9.76219ZM10.4642 9.5366C10.4648 9.53567 10.4652 9.53521 10.4652 9.53521C10.4653 9.53522 10.4649 9.53568 10.4642 9.5366ZM10.2705 12.2056C10.2705 12.2057 10.2705 12.2052 10.2705 12.2042C10.2705 12.2051 10.2705 12.2056 10.2705 12.2056ZM9.26801 8.58763C9.26795 8.58767 9.26795 8.58679 9.26818 8.5849C9.26818 8.58665 9.26807 8.5876 9.26801 8.58763ZM7.71037 6.41002C7.71041 6.41 7.711 6.41033 7.71203 6.41107C7.71085 6.41041 7.71034 6.41004 7.71037 6.41002Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M6.63763 9.32588C6.85195 9.22157 6.93262 8.97914 6.8178 8.78441C6.70299 8.58968 6.43617 8.51639 6.22184 8.62071C5.64136 8.90324 5.36047 9.46069 5.35117 9.99699C5.3418 10.538 5.60491 11.1144 6.18553 11.4661C6.38783 11.5886 6.66117 11.539 6.79604 11.3551C6.93091 11.1713 6.87624 10.923 6.67394 10.8005C6.37405 10.6188 6.22626 10.3152 6.23156 10.0096C6.23694 9.69922 6.3963 9.44334 6.63763 9.32588Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M5.02153 7.61404C5.16697 7.79107 5.12692 8.04171 4.93208 8.17385C4.48426 8.47755 4.18008 9.16112 4.17003 9.96867C4.16011 10.7664 4.44142 11.5421 4.96835 11.9869C5.1465 12.1372 5.15676 12.3903 4.99128 12.5522C4.82581 12.714 4.54725 12.7233 4.3691 12.573C3.60098 11.9247 3.27793 10.897 3.28959 9.95963C3.30113 9.03205 3.64448 8.0488 4.40539 7.53276C4.60023 7.40062 4.87609 7.43701 5.02153 7.61404Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M3.11306 7.0534C3.30763 6.92092 3.34715 6.67022 3.20133 6.49344C3.05552 6.31666 2.77958 6.28075 2.58502 6.41324C1.52226 7.13688 1.01737 8.54172 1.00044 9.9078C0.983396 11.2837 1.45725 12.7675 2.54876 13.6924C2.72658 13.8431 3.00516 13.8343 3.17099 13.6727C3.33683 13.5112 3.32712 13.2581 3.1493 13.1074C2.29824 12.3862 1.86556 11.154 1.88088 9.9168C1.89633 8.66973 2.36273 7.56431 3.11306 7.0534Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Voir = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.88427 5.47372C6.52074 5.47372 5.41812 6.55147 5.41812 7.88425C5.41812 9.21703 6.52074 10.2948 7.88427 10.2948C9.24781 10.2948 10.3504 9.21703 10.3504 7.88425C10.3504 6.55147 9.24781 5.47372 7.88427 5.47372ZM6.49504 7.88425C6.49504 7.13282 7.1155 6.52635 7.88427 6.52635C8.65304 6.52635 9.2735 7.13282 9.2735 7.88425C9.2735 8.63568 8.65304 9.24214 7.88427 9.24214C7.1155 9.24214 6.49504 8.63568 6.49504 7.88425Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8 3C5.4834 3 3.15868 4.21545 1.55565 6.27841C1.17367 6.76854 1 7.39791 1 8C1 8.60195 1.17359 9.23116 1.55538 9.72125C3.15842 11.7844 5.48325 13 8 13C10.5166 13 12.8413 11.7845 14.4443 9.72159C14.8263 9.23146 15 8.60209 15 8C15 7.39805 14.8264 6.76884 14.4446 6.27875C12.8416 4.21559 10.5167 3 8 3ZM2.41301 6.91539C3.83438 5.08605 5.85467 4.05263 8 4.05263C10.1453 4.05263 12.1656 5.08605 13.587 6.91539L13.5875 6.91609C13.7997 7.18819 13.9231 7.58044 13.9231 8C13.9231 8.41955 13.7997 8.81181 13.5875 9.08391L13.587 9.08461C12.1656 10.914 10.1453 11.9474 8 11.9474C5.85467 11.9474 3.83438 10.914 2.41301 9.0846L2.41247 9.08391C2.20033 8.81181 2.07692 8.41955 2.07692 8C2.07692 7.58044 2.20033 7.18819 2.41247 6.91609L2.41301 6.91539Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Wanchain = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.2573 5.50447L8.25726 3.70447C8.09892 3.60947 7.9011 3.60947 7.74276 3.70447L4.74276 5.50447C4.57624 5.60438 4.48885 5.78592 4.50106 5.96723C4.50036 5.97803 4.50001 5.98893 4.50001 5.99992V10.0666C4.50001 10.2467 4.59691 10.4129 4.75366 10.5017C4.91041 10.5904 5.10279 10.588 5.25726 10.4953L8.00001 8.84968L10.7428 10.4953C10.8972 10.588 11.0896 10.5904 11.2464 10.5017C11.4031 10.4129 11.5 10.2467 11.5 10.0666V5.99992C11.5 5.98894 11.4997 5.97804 11.499 5.96723C11.5112 5.78593 11.4238 5.60438 11.2573 5.50447ZM10.5 6.21631L8.00001 4.71631L5.50001 6.21631V9.18349L7.74276 7.83784C7.9011 7.74283 8.09892 7.74283 8.25726 7.83784L10.5 9.18349V6.21631Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M6.12022 10.5182C6.27578 10.2901 6.58685 10.2312 6.815 10.3868L8 11.1947L9.185 10.3868C9.41316 10.2312 9.72422 10.2901 9.87978 10.5182C10.0353 10.7464 9.97649 11.0574 9.74834 11.213L8.28167 12.213C8.11176 12.3288 7.88824 12.3288 7.71833 12.213L6.25167 11.213C6.02351 11.0574 5.96466 10.7464 6.12022 10.5182Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.00001 0.833252C4.04197 0.833252 0.833344 4.04188 0.833344 7.99992C0.833344 11.958 4.04197 15.1666 8.00001 15.1666C11.9581 15.1666 15.1667 11.958 15.1667 7.99992C15.1667 4.04188 11.9581 0.833252 8.00001 0.833252ZM1.83334 7.99992C1.83334 4.59416 4.59425 1.83325 8.00001 1.83325C11.4058 1.83325 14.1667 4.59416 14.1667 7.99992C14.1667 11.4057 11.4058 14.1666 8.00001 14.1666C4.59425 14.1666 1.83334 11.4057 1.83334 7.99992Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Wanchain2 = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.93333 1.5C5.33909 1.5 4.83391 2.1192 5.15279 2.75694L5.16106 2.77348L6.78648 5.5H3.53333C3.39083 5.5 3.2474 5.53395 3.12639 5.59445C3.06615 5.62457 2.99103 5.67145 2.92406 5.74322C2.88878 5.78101 2.84489 5.83799 2.81243 5.91278L0.367177 9.54761L0.352786 9.57639C0.215738 9.85049 0.215738 10.1495 0.352786 10.4236L0.366708 10.4514L2.65064 13.8773C2.82461 14.1383 3.11091 14.25 3.35833 14.25C3.58469 14.25 3.90898 14.1449 4.05008 13.8214L5.54139 11.316L7.47723 14.251L7.51311 14.2869L7.52037 14.2942C7.59763 14.3718 7.79142 14.5667 8.13333 14.5667H12.4667C12.8086 14.5667 13.0024 14.3718 13.0796 14.2942L13.0869 14.2869L13.1211 14.2526L15.6328 10.5191L15.6472 10.4903C15.7086 10.3674 15.75 10.2245 15.75 10.075C15.75 9.94934 15.7191 9.78808 15.6123 9.64709L11.1981 1.93877C11.1651 1.85108 11.1152 1.78528 11.0759 1.74322C11.009 1.67146 10.9338 1.62457 10.8736 1.59445C10.7526 1.53395 10.6092 1.5 10.4667 1.5H5.93333ZM3.62261 6.5H7.09079L4.80508 10.5H4.86624C4.86096 10.5074 4.85575 10.515 4.85064 10.5226L4.84355 10.5333L3.32448 13.0853L1.26783 10.0004L3.62261 6.5ZM6.21603 10.5226C6.21091 10.515 6.20571 10.5074 6.20043 10.5H9.4C9.76863 10.5 10.0239 10.2635 10.1373 10.0179C10.2439 9.78689 10.2625 9.47227 10.0927 9.20477L8.51496 6.5H8.54685L6.16224 2.5H10.3671L14.7148 10.0922L12.3774 13.5667H8.22379L6.21739 10.5247L6.21603 10.5226ZM6.52826 9.5L7.80446 7.26664L9.10726 9.5H6.52826Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Incognito = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 24 24",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement("g", { id: "🔍-Product-Icons", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React__default.createElement("g", { id: "ic_fluent_incognito_24_regular", fill: "currentColor", fillRule: "nonzero" }, /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M17.5,12 C19.9852814,12 22,14.0147186 22,16.5 C22,18.9852814 19.9852814,21 17.5,21 C15.3591076,21 13.5674006,19.5049595 13.1119514,17.5019509 L10.8880486,17.5019509 C10.4325994,19.5049595 8.64089238,21 6.5,21 C4.01471863,21 2,18.9852814 2,16.5 C2,14.0147186 4.01471863,12 6.5,12 C8.81637876,12 10.7239814,13.7501788 10.9725684,16.000297 L13.0274316,16.000297 C13.2760186,13.7501788 15.1836212,12 17.5,12 Z M6.5,13.5 C4.84314575,13.5 3.5,14.8431458 3.5,16.5 C3.5,18.1568542 4.84314575,19.5 6.5,19.5 C8.15685425,19.5 9.5,18.1568542 9.5,16.5 C9.5,14.8431458 8.15685425,13.5 6.5,13.5 Z M17.5,13.5 C15.8431458,13.5 14.5,14.8431458 14.5,16.5 C14.5,18.1568542 15.8431458,19.5 17.5,19.5 C19.1568542,19.5 20.5,18.1568542 20.5,16.5 C20.5,14.8431458 19.1568542,13.5 17.5,13.5 Z M12,9.25 C15.3893368,9.25 18.5301001,9.58954198 21.4217795,10.2699371 C21.8249821,10.3648083 22.0749341,10.7685769 21.9800629,11.1717795 C21.8851917,11.5749821 21.4814231,11.8249341 21.0782205,11.7300629 C18.3032332,11.0771247 15.2773298,10.75 12,10.75 C8.72267018,10.75 5.69676679,11.0771247 2.9217795,11.7300629 C2.51857691,11.8249341 2.11480832,11.5749821 2.01993712,11.1717795 C1.92506593,10.7685769 2.17501791,10.3648083 2.5782205,10.2699371 C5.46989988,9.58954198 8.61066315,9.25 12,9.25 Z M15.7002538,3.25 C16.7230952,3.25 17.6556413,3.81693564 18.1297937,4.71158956 L18.2132356,4.88311922 L19.6853587,8.19539615 C19.8535867,8.57390929 19.683117,9.0171306 19.3046038,9.18535866 C18.9576335,9.33956772 18.5562903,9.20917654 18.3622308,8.89482229 L18.3146413,8.80460385 L16.8425183,5.49232692 C16.6601304,5.08195418 16.2735894,4.80422037 15.8336777,4.75711483 L15.7002538,4.75 L8.29974618,4.75 C7.85066809,4.75 7.43988259,4.99042719 7.21817192,5.37329225 L7.15748174,5.49232692 L5.68535866,8.80460385 C5.5171306,9.18311699 5.07390929,9.35358672 4.69539615,9.18535866 C4.34842577,9.03114961 4.17626965,8.64586983 4.27956492,8.29117594 L4.31464134,8.19539615 L5.78676442,4.88311922 C6.20217965,3.94843495 7.09899484,3.32651789 8.10911143,3.25658537 L8.29974618,3.25 L15.7002538,3.25 Z"
        }
      )))
    );
  }
);
const Warning = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M8.00361 4.74418C8.29842 4.74418 8.53741 4.96283 8.53741 5.23255V8.65116C8.53741 8.92088 8.29842 9.13953 8.00361 9.13953C7.70879 9.13953 7.4698 8.92088 7.4698 8.65116V5.23255C7.4698 4.96283 7.70879 4.74418 8.00361 4.74418Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M8.71535 10.7348C8.71535 10.3752 8.39669 10.0837 8.00361 10.0837C7.61052 10.0837 7.29186 10.3752 7.29186 10.7348V10.8C7.29186 11.1596 7.61052 11.4511 8.00361 11.4511C8.39669 11.4511 8.71535 11.1596 8.71535 10.8V10.7348Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.6121 1.33891C7.46849 0.886586 8.52508 0.887832 9.38585 1.33783L9.38794 1.33893L13.6192 3.57427C14.4702 4.03176 15 4.86135 15 5.77304V10.227C15 11.1313 14.471 11.9678 13.6192 12.4257L13.6157 12.4276L9.38794 14.6611C8.53155 15.1134 7.47492 15.1122 6.61415 14.6622L6.61206 14.6611L2.38435 12.4276C1.52785 11.9752 1 11.1363 1 10.227V5.77304C1 4.86872 1.52903 4.03221 2.3808 3.57429L2.38431 3.5724L6.6121 1.33891ZM8.85519 2.18538C8.32113 1.90659 7.66997 1.908 7.14589 2.18481L2.92009 4.41726C2.39202 4.70185 2.06761 5.21932 2.06761 5.77304V10.227C2.06761 10.7893 2.39386 11.3048 2.91814 11.5817L7.14384 13.8141L7.14486 13.8147C7.6789 14.0934 8.33001 14.092 8.85407 13.8152L13.0783 11.5836L13.08 11.5827C13.608 11.2981 13.9324 10.7807 13.9324 10.227V5.77304C13.9324 5.21367 13.6088 4.70227 13.0799 4.41726L13.0783 4.4164L8.85616 2.18589L8.85519 2.18538Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const WeBank_Pass = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.54901 15.923C7.82965 16.0201 8.13782 16.0252 8.4222 15.9391C13.878 14.2866 15.4316 9.40553 14.9027 3.9078C14.8541 3.40212 14.5256 2.9638 14.0519 2.74083L13.7951 2.61995C12.1447 1.84334 10.4171 1.03032 8.70098 0.172344C8.2496 -0.0533213 7.71345 -0.0582097 7.25953 0.162608C5.3176 1.10727 3.06003 2.1884 1.91094 2.73743C1.43799 2.96342 1.11215 3.40323 1.06883 3.91003C0.582966 9.59505 2.66165 14.2322 7.54901 15.923ZM8.01279 14.5701C10.3123 13.8646 11.7322 12.5198 12.5621 10.7728C12.9691 9.91595 13.2418 8.94417 13.3892 7.88155L7.74097 7.88154V14.4698C7.8305 14.5045 7.92105 14.5379 8.01279 14.5701ZM7.71379 7.81087V1.53714C5.81705 2.45859 3.67619 3.48381 2.56805 4.0133C2.56448 4.01498 2.56142 4.0167 2.5587 4.01841L2.55157 4.02344C2.54681 4.02709 2.54375 4.03037 2.54205 4.03257C2.42602 5.3949 2.46697 6.65966 2.65944 7.81086L7.71379 7.81087Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Wing = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1.19998 2.83325C1.02088 2.83325 0.855453 2.92905 0.76631 3.0844C0.677168 3.23974 0.677925 3.4309 0.768296 3.58554L3.7683 8.71887C3.85789 8.87218 4.02208 8.96647 4.19965 8.96659C4.37722 8.9667 4.54153 8.87263 4.63133 8.71945L5.76466 6.78611C5.85459 6.63271 5.85628 6.4431 5.7691 6.28812L3.9691 3.08812C3.88054 2.93068 3.71395 2.83325 3.53332 2.83325H1.19998ZM4.20064 7.47677L2.07131 3.83325H3.24089L4.75675 6.52811L4.20064 7.47677Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.56725 3.08278C5.65664 2.92835 5.82155 2.83325 5.99999 2.83325H8.33333C8.51235 2.83325 8.67771 2.92896 8.76688 3.08419L10.5669 6.21752C10.6544 6.36995 10.6555 6.55717 10.5697 6.7106L7.10307 12.9106C7.01644 13.0655 6.85415 13.1629 6.67666 13.1665C6.49918 13.17 6.33312 13.0792 6.24036 12.9279L4.97369 10.8612C4.87766 10.7045 4.87532 10.5078 4.9676 10.3489L7.22259 6.46525L5.56644 3.58231C5.47756 3.42759 5.47787 3.23722 5.56725 3.08278ZM6.86386 3.83325L8.23355 6.21752C8.32255 6.37246 8.32211 6.56313 8.23239 6.71765L5.98219 10.593L6.64687 11.6775L9.55861 6.46992L8.04393 3.83325H6.86386Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.2339 3.08278C10.3233 2.92835 10.4882 2.83325 10.6667 2.83325H13C13.179 2.83325 13.3444 2.92896 13.4335 3.08419L15.2335 6.21752C15.3211 6.36995 15.3222 6.55717 15.2364 6.7106L11.7697 12.9106C11.6831 13.0655 11.5208 13.1629 11.3433 13.1665C11.1658 13.17 10.9998 13.0792 10.907 12.9279L9.64036 10.8612C9.54433 10.7045 9.54199 10.5078 9.63427 10.3489L11.8893 6.46525L10.2331 3.58231C10.1442 3.42759 10.1445 3.23722 10.2339 3.08278ZM11.5305 3.83325L12.9002 6.21752C12.9892 6.37246 12.9888 6.56313 12.8991 6.71765L10.6489 10.593L11.3135 11.6775L14.2253 6.46992L12.7106 3.83325H11.5305Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Xrp = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2.73333 0.833252C2.20387 0.833252 1.7747 1.13147 1.58541 1.55372C1.39405 1.98059 1.46324 2.5036 1.84644 2.88681L5.64644 6.68681C6.90837 7.94873 9.02496 7.94873 10.2869 6.68681L14.0763 2.89735C14.4848 2.53076 14.5961 2.01186 14.412 1.56708C14.2311 1.12996 13.7929 0.833252 13.2667 0.833252H12.3333C11.6763 0.833252 11.013 1.0798 10.5131 1.5797L8.11311 3.9797C8.04224 4.05057 7.89387 4.0511 7.82184 3.98129L5.49183 1.58471L5.48688 1.5797C4.98699 1.0798 4.32368 0.833252 3.66666 0.833252H2.73333ZM2.55355 2.1797C2.50632 2.13247 2.49024 2.09084 2.48494 2.06111C2.47928 2.02933 2.48323 1.99555 2.49792 1.96278C2.5253 1.9017 2.59612 1.83325 2.73333 1.83325H3.66666C4.07527 1.83325 4.47761 1.98592 4.77747 2.2845L7.10817 4.68179L7.11311 4.68681C7.57504 5.14873 8.35829 5.14873 8.82022 4.68681L11.2202 2.28681C11.5203 1.9867 11.9237 1.83325 12.3333 1.83325H13.2667C13.4071 1.83325 13.4689 1.90321 13.488 1.94943C13.4983 1.97447 13.5007 2.0008 13.4939 2.02849C13.4873 2.05497 13.4674 2.10152 13.4041 2.15696C13.3957 2.16427 13.3876 2.17185 13.3798 2.1797L9.57978 5.9797C8.70837 6.8511 7.22496 6.8511 6.35355 5.9797L2.55355 2.1797Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.2869 9.31306C9.02495 8.05114 6.90837 8.05114 5.64644 9.31306L5.64333 9.31621L1.91138 13.1148C1.13272 13.8961 1.68802 15.1666 2.73333 15.1666H3.66666C4.3526 15.1666 5.00827 14.8321 5.42021 14.4202L7.82021 12.0202C7.89162 11.9488 8.0417 11.9488 8.11311 12.0202L10.5131 14.4202C11.013 14.9201 11.6763 15.1666 12.3333 15.1666H13.2667C14.3127 15.1666 14.8681 13.8943 14.0869 13.1131L10.2869 9.31306ZM2.62333 13.817L6.35502 10.0187C7.22663 9.14877 8.70886 9.14926 9.57977 10.0202L13.3798 13.8202C13.5319 13.9723 13.4206 14.1666 13.2667 14.1666H12.3333C11.9237 14.1666 11.5203 14.0132 11.2202 13.7131L8.82021 11.3131C8.35828 10.8511 7.57504 10.8511 7.11311 11.3131L4.71311 13.7131C4.45838 13.9678 4.04738 14.1666 3.66666 14.1666H2.73333C2.5794 14.1666 2.46809 13.9723 2.62021 13.8202L2.62333 13.817Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Zel = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.76391 4.75921C7.9114 4.6802 8.08864 4.6802 8.23613 4.75921L10.1028 5.75921C10.2653 5.84625 10.3667 6.01563 10.3667 6.19995V6.26273L10.4147 6.2347C10.5723 6.14277 10.7675 6.14397 10.9239 6.23784L12.5906 7.23784C12.7412 7.3282 12.8333 7.49095 12.8333 7.66658V9.53325C12.8333 9.70888 12.7412 9.87164 12.5906 9.962L10.9239 10.962C10.7656 11.057 10.5678 11.057 10.4094 10.962L8.74276 9.962C8.63278 9.89601 8.55397 9.79141 8.51946 9.67138L8.25727 9.8287C8.09892 9.9237 7.90111 9.9237 7.74277 9.8287L7.48056 9.67137C7.44605 9.7914 7.36724 9.89601 7.25726 9.962L5.59059 10.962C5.43225 11.057 5.23444 11.057 5.0761 10.962L3.40943 9.962C3.25883 9.87164 3.16668 9.70888 3.16668 9.53325V7.66658C3.16668 7.49095 3.25883 7.3282 3.40943 7.23784L5.0761 6.23784C5.23254 6.14397 5.42769 6.14277 5.58528 6.2347L5.63335 6.26274V6.19995C5.63335 6.01563 5.73476 5.84625 5.89724 5.75921L7.76391 4.75921ZM9.50002 8.79995L9.50001 8.80283V9.25016L10.6667 9.95016L11.8333 9.25016V7.94968L10.6631 7.24753L10.1249 7.56149L9.50002 7.94602V8.79995ZM9.36668 6.49932V6.85385L8.73796 7.24076C8.59009 7.33176 8.50001 7.49295 8.50001 7.66658V8.51686L8.00002 8.81686L7.50002 8.51686V7.66662C7.50002 7.64491 7.49861 7.6234 7.49586 7.6022C7.49001 7.55715 7.47809 7.51348 7.46071 7.47228C7.42083 7.37775 7.35218 7.29621 7.26206 7.24076L6.63335 6.85386V6.49932L8.00002 5.76718L9.36668 6.49932ZM6.50001 7.94601L5.87547 7.56167L5.33693 7.24753L4.16668 7.94968V9.25016L5.33334 9.95016L6.50001 9.25016V7.94601Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.00001 0.833252C4.04197 0.833252 0.833344 4.04188 0.833344 7.99992C0.833344 11.958 4.04197 15.1666 8.00001 15.1666C11.9581 15.1666 15.1667 11.958 15.1667 7.99992C15.1667 4.04188 11.9581 0.833252 8.00001 0.833252ZM1.83334 7.99992C1.83334 4.59416 4.59425 1.83325 8.00001 1.83325C11.4058 1.83325 14.1667 4.59416 14.1667 7.99992C14.1667 11.4057 11.4058 14.1666 8.00001 14.1666C4.59425 14.1666 1.83334 11.4057 1.83334 7.99992Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Nosort = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M4.4918 8H3.03241C1.2232 8 0.479839 6.62831 1.38718 4.9531L2.11961 3.60475L2.85203 2.25641C3.75937 0.581197 5.24063 0.581197 6.14797 2.25641L6.88039 3.60475L7.61282 4.9531C8.52016 6.62831 7.7768 8 5.96759 8H4.4918Z",
          stroke: "#898A8D",
          strokeWidth: "1.5",
          strokeMiterlimit: "10",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "transparent"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M4.50344 13H5.96482C7.7765 13 8.52087 14.3717 7.6123 16.0469L6.87887 17.3952L6.14544 18.7436C5.23687 20.4188 3.7536 20.4188 2.84502 18.7436L2.1116 17.3952L1.37817 16.0469C0.486015 14.3717 1.22492 13 3.04206 13H4.50344Z",
          stroke: "#898A8D",
          strokeWidth: "1.5",
          strokeMiterlimit: "10",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "transparent"
        }
      )
    );
  }
);
const ASC = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M4.4918 8H3.03241C1.2232 8 0.479839 6.62831 1.38718 4.9531L2.11961 3.60475L2.85203 2.25641C3.75937 0.581197 5.24063 0.581197 6.14797 2.25641L6.88039 3.60475L7.61282 4.9531C8.52016 6.62831 7.7768 8 5.96759 8H4.4918Z",
          fill: "#898A8D",
          stroke: "#898A8D",
          strokeWidth: "1.5",
          strokeMiterlimit: "10",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    );
  }
);
const Desc = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M4.50344 12H5.96482C7.7765 12 8.52087 13.3717 7.6123 15.0469L6.87887 16.3952L6.14544 17.7436C5.23687 19.4188 3.7536 19.4188 2.84502 17.7436L2.1116 16.3952L1.37817 15.0469C0.486015 13.3717 1.22492 12 3.04206 12H4.50344Z",
          fill: "#898A8D",
          stroke: "#898A8D",
          strokeWidth: "1.5",
          strokeMiterlimit: "10",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    );
  }
);
const CoffreFort = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        ref: forwardedRef,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2C16.714 2 19.0711 2 20.5355 3.46447C22 4.92893 22 7.28595 22 12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12Z",
          stroke: "currentColor",
          strokeWidth: "1.5"
        }
      ),
      /* @__PURE__ */ React__default.createElement("path", { d: "M6 7V17", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round" }),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M11 12C11 10.3431 12.3431 9 14 9C15.6569 9 17 10.3431 17 12C17 13.6569 15.6569 15 14 15C12.3431 15 11 13.6569 11 12Z",
          stroke: "currentColor",
          strokeWidth: "1.5"
        }
      ),
      /* @__PURE__ */ React__default.createElement("path", { d: "M16.5 9.5L18 8", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round" }),
      /* @__PURE__ */ React__default.createElement("path", { d: "M10 16L11.5 14.5", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round" }),
      /* @__PURE__ */ React__default.createElement("path", { d: "M11.5 9.5L10 8", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round" }),
      /* @__PURE__ */ React__default.createElement("path", { d: "M18 16L16.5 14.5", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round" })
    );
  }
);
const Resilier = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        ref: forwardedRef,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.69306 5.84899C3.05534 5.0444 2.45785 4.27479 1.90059 3.54017C1.29112 2.73673 0.665607 1.90818 0.0240581 1.05452C0.088213 0.71975 0.208503 0.460305 0.384929 0.276183C0.561355 0.092061 0.777878 0 1.0345 0C1.30716 0 1.52368 0.0753228 1.68406 0.225968C1.84445 0.359875 2.00484 0.543997 2.16523 0.778335C2.64639 1.44787 3.15161 2.18436 3.68088 2.9878C4.05521 3.54419 4.44156 4.08801 4.83995 4.61928C5.3799 3.89206 5.89171 3.20596 6.37539 2.56097C6.95278 1.79101 7.54621 0.945719 8.15569 0.0251073C8.21984 0.00836909 8.26796 0 8.30003 0H8.42033C8.75714 0 9.02178 0.0836919 9.21424 0.251076C9.4067 0.401721 9.50294 0.610951 9.50294 0.878765C9.50294 1.06289 9.46284 1.23864 9.38265 1.40602C9.31849 1.57341 9.20622 1.7659 9.04583 1.9835C8.50052 2.68651 7.93916 3.39789 7.36177 4.11764C6.89813 4.71211 6.43995 5.29516 5.98725 5.86679C6.57373 6.67132 7.16022 7.46918 7.7467 8.26039C8.42032 9.13079 9.08593 10.0096 9.74352 10.8967C9.71144 11.2147 9.60719 11.4658 9.43076 11.6499C9.25434 11.834 9.02178 11.9261 8.73308 11.9261C8.47646 11.9261 8.25994 11.8591 8.08351 11.7252C7.90709 11.5746 7.7066 11.3486 7.48206 11.0473C7.0009 10.3443 6.48766 9.59947 5.94234 8.81276C5.5511 8.23123 5.17301 7.67714 4.80806 7.15048C4.29957 7.85615 3.7795 8.58599 3.24784 9.34002C2.62233 10.2104 2.02088 11.0641 1.44348 11.901H1.27508H1.10667C0.737781 11.901 0.457103 11.8173 0.264639 11.6499C0.0882129 11.4825 0 11.2733 0 11.0222C0 10.8883 0.0240581 10.746 0.0721743 10.5954C0.136329 10.4448 0.272658 10.2355 0.481161 9.96771C1.05856 9.16427 1.66803 8.37756 2.30957 7.6076C2.78389 7.02597 3.24505 6.43976 3.69306 5.84899ZM21.0036 1.28316C20.3693 0.647691 19.3951 0.700809 18.8277 1.4018L16.1894 4.66108L20.9693 9.44953L23.6075 6.19025C24.1749 5.48926 24.1207 4.40584 23.4864 3.77038L21.0036 1.28316ZM18.6072 4.52925L19.9897 2.82129L22.2172 5.05282L20.8347 6.76078L18.6072 4.52925ZM15.2789 5.66616L6.39412 16.466L6.25849 20.2304C6.24538 20.2138 6.23206 20.1981 6.21851 20.1832C6.13969 20.0965 5.98119 19.9618 5.76294 20.0011C5.55621 20.0383 5.45061 20.2064 5.40702 20.2903C5.3129 20.4714 5.26478 20.7372 5.23263 20.9623C5.2048 21.1569 5.18301 21.372 5.16335 21.5659L5.14953 21.7011C5.127 21.9179 5.09407 22.0982 5.05481 22.2384C5.03296 22.3164 5.011 22.3752 4.99138 22.4181C4.86155 22.2574 4.75857 21.9905 4.60142 21.4089C4.5559 21.2405 4.50637 21.0484 4.45034 20.8312C4.3184 20.3197 4.1503 19.6681 3.91302 18.8526C3.86817 18.6985 3.82168 18.5664 3.77146 18.4608C3.72834 18.3702 3.65552 18.2388 3.53077 18.1595C3.45749 18.1128 3.36021 18.0807 3.24984 18.0961C3.14389 18.1108 3.0647 18.164 3.01283 18.2126C2.91943 18.3001 2.86543 18.4185 2.83281 18.5022C2.76163 18.6848 2.70494 18.9417 2.65589 19.2187C2.60557 19.5029 2.55874 19.8359 2.5134 20.1849C2.48522 20.4019 2.45761 20.6248 2.43001 20.8476L2.43001 20.8476C2.36779 21.3499 2.30556 21.8523 2.23645 22.289C2.20802 22.4686 2.17911 22.6325 2.14954 22.7766C2.09708 22.5038 2.04843 22.1688 1.99787 21.8039L1.97386 21.6298C1.90974 21.1641 1.84197 20.6718 1.75914 20.2601C1.71251 20.0282 1.65854 19.8083 1.59299 19.6254C1.53344 19.4593 1.44198 19.2563 1.28524 19.1306C1.2146 19.074 1.10333 19.0129 0.962458 19.024C0.818329 19.0354 0.716429 19.1164 0.655597 19.1882C0.549994 19.3127 0.500466 19.4868 0.471272 19.618C0.406461 19.9092 0.375333 20.3289 0.362016 20.7793C0.335025 21.6922 0.37912 22.8409 0.427623 23.6188L1.13372 23.5708C1.08588 22.8037 1.04327 21.6813 1.06927 20.8021C1.07251 20.6926 1.07678 20.5885 1.08209 20.4905C1.15305 20.861 1.21308 21.2967 1.27354 21.7355L1.29757 21.9096C1.36883 22.4238 1.44411 22.9428 1.54211 23.3042C1.58804 23.4736 1.65354 23.6683 1.76217 23.8042C1.82054 23.8772 1.92067 23.97 2.0692 23.9942C2.22539 24.0197 2.35478 23.9569 2.4413 23.8876C2.54546 23.804 2.60906 23.6865 2.64892 23.598C2.69285 23.5005 2.72994 23.3871 2.76227 23.2686C2.82712 23.0309 2.8835 22.7321 2.93458 22.4093C3.00579 21.9594 3.07078 21.4348 3.13379 20.9262L3.1338 20.9262L3.1338 20.9261L3.13381 20.926C3.16098 20.7067 3.18779 20.4903 3.21458 20.2841C3.25551 19.9691 3.29645 19.6768 3.33901 19.4261C3.51906 20.0618 3.65214 20.5778 3.76296 21.0075L3.763 21.0077L3.76304 21.0078C3.82029 21.2298 3.8716 21.4288 3.92039 21.6093C4.07377 22.177 4.21085 22.6062 4.46333 22.9099C4.58396 23.0549 4.75246 23.1978 4.97045 23.2169C5.21137 23.2379 5.39067 23.1006 5.50118 22.9557C5.60808 22.8154 5.68136 22.6334 5.73397 22.4456C5.78804 22.2526 5.82736 22.0274 5.853 21.7807L5.86781 21.6359C5.88564 21.4602 5.90363 21.283 5.92588 21.1186C5.94022 21.1534 5.98403 21.2401 6.03321 21.3373C6.10244 21.4742 6.18231 21.6322 6.20567 21.6964L11.0384 21.2248L19.9367 10.4085L15.2789 5.66616ZM8.07986 17.2453L15.3928 8.35608L17.5181 10.52L10.2187 19.3928L7.99466 19.6099L8.07986 17.2453Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const Moon = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { fill: props.color },
        width: props.size,
        height: props.size,
        ref: forwardedRef,
        viewBox: "0 0 384 512"
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M223.5 32C100 32 0 132.3 0 256S100 480 223.5 480c60.6 0 115.5-24.2 155.8-63.4c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-9.8 1.7-19.8 2.6-30.1 2.6c-96.9 0-175.5-78.8-175.5-176c0-65.8 36-123.1 89.3-153.3c6.1-3.5 9.2-10.5 7.7-17.3s-7.3-11.9-14.3-12.5c-6.3-.5-12.6-.8-19-.8z"
        }
      )
    );
  }
);
const Iconi = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M13.4667 1.53345C12.9144 1.53345 12.4667 1.98116 12.4667 2.53345C12.4667 3.08573 12.9144 3.53345 13.4667 3.53345H13.5333C14.0856 3.53345 14.5333 3.08573 14.5333 2.53345C14.5333 1.98116 14.0856 1.53345 13.5333 1.53345H13.4667Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M2.46667 12.4667C1.91439 12.4667 1.46667 12.9144 1.46667 13.4667C1.46667 14.019 1.91439 14.4667 2.46667 14.4667H2.53334C3.08563 14.4667 3.53334 14.019 3.53334 13.4667C3.53334 12.9144 3.08563 12.4667 2.53334 12.4667H2.46667Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M2.83333 8.00008C2.83333 5.12394 5.12386 2.83341 8 2.83341C8.97223 2.83341 9.85463 3.13306 10.6394 3.56113C10.8819 3.69337 10.9712 3.99708 10.8389 4.23951C10.7067 4.48193 10.403 4.57126 10.1606 4.43903C9.4787 4.0671 8.76111 3.83341 8 3.83341C5.67614 3.83341 3.83333 5.67622 3.83333 8.00008C3.83333 8.76777 4.07097 9.5527 4.43895 10.2273C4.57118 10.4697 4.48185 10.7735 4.23943 10.9057C3.997 11.0379 3.69328 10.9486 3.56105 10.7062C3.12903 9.91413 2.83333 8.96573 2.83333 8.00008Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          d: "M12.4389 5.29402C12.3067 5.0516 12.003 4.96227 11.7606 5.0945C11.5181 5.22673 11.4288 5.53045 11.561 5.77287C11.929 6.4475 12.1667 7.23243 12.1667 8.00011C12.1667 10.324 10.3238 12.1668 7.99999 12.1668C7.14438 12.1668 6.44137 11.9853 5.80176 11.5783C5.56879 11.43 5.25975 11.4987 5.11149 11.7317C4.96324 11.9646 5.03192 12.2737 5.26489 12.4219C6.09194 12.9483 6.98894 13.1668 7.99999 13.1668C10.8761 13.1668 13.1667 10.8763 13.1667 8.00011C13.1667 7.03447 12.871 6.08606 12.4389 5.29402Z",
          fill: "currentColor"
        }
      )
    );
  }
);
const XCircle = React__default.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      "svg",
      {
        className: classNames$1(icon, props.className),
        style: { color: props.color },
        width: props.size,
        height: props.size,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ref: forwardedRef
      },
      /* @__PURE__ */ React__default.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M16 31C24.2843 31 31 24.2843 31 16C31 7.71573 24.2843 1 16 1C7.71573 1 1 7.71573 1 16C1 24.2843 7.71573 31 16 31ZM22 11.2C22 11.5183 21.8731 11.8239 21.6481 12.049L17.6971 16L21.6485 19.9515C21.8736 20.1765 22 20.4817 22 20.8C22 21.1183 21.8736 21.4235 21.6485 21.6485C21.4235 21.8736 21.1183 22 20.8 22C20.4817 22 20.1765 21.8736 19.9515 21.6485L16 17.6971L12.0485 21.6485C11.8235 21.8736 11.5183 22 11.2 22C10.8817 22 10.5765 21.8736 10.3515 21.6485C10.1405 21.4376 10.0157 21.1556 10.0014 20.8576C10.0006 20.8408 10.0001 20.824 10 20.8072L10 20.8C10 20.4817 10.1269 20.1761 10.3519 19.951L14.3029 16L10.3515 12.0485C10.1264 11.8235 10 11.5183 10 11.2C10 10.8817 10.1264 10.5765 10.3515 10.3515C10.5765 10.1264 10.8817 10 11.2 10C11.5183 10 11.8235 10.1264 12.0485 10.3515L16 14.3029L19.9515 10.3515C20.1765 10.1264 20.4817 10 20.8 10C21.1129 10 21.4141 10.1229 21.6382 10.3412L21.6485 10.3515C21.8736 10.5765 22 10.8817 22 11.2Z",
          fill: "#D31A1A"
        }
      )
    );
  }
);
const POSSIBLE_LOGO = {
  "Aave": Aave,
  "Abo_Web": Abo_Web,
  "Acheter": Acheter,
  "AcheterVendre": AcheterVendre,
  "Actualites": Actualites,
  "Wrench": Wrench,
  "AdresseIP": AdresseIP,
  "Aide": Aide,
  "Ajouter-1": Ajouter1,
  "Ajouter-2": Ajouter2,
  "Ajouter": Ajouter,
  "Ajuster": Ajuster,
  "Alertes": Alertes,
  "Ampoule": Ampoule,
  "Ankr": Ankr,
  "Assurance": Assurance,
  "Attention": Attention,
  "Augur": Augur,
  "Authentification-1": Authentification1,
  "Authentification": Authentification,
  "Autonio": Autonio,
  "Avalanche": Avalanche,
  "Baguette_magique": Baguette_magique,
  "Banque": Banque,
  "Binance_coin": Binance_coin,
  "Binance_usd": Binance_usd,
  "Bitcoin": Bitcoin,
  "Box": Box,
  "CA": CA,
  "Cacher": Cacher,
  "Calculatrice": Calculatrice,
  "Calendrier": Calendrier,
  "Calendrier2": Calendrier2,
  "Capital": Capital,
  "Cardano": Cardano,
  "Carte_bancaire": Carte_bancaire,
  "Carte_bancaire2": Carte_bancaire2,
  "Celo": Celo,
  "Celsius": Celsius,
  "Certificat": Certificat,
  "Certification_ISO9001": Certification_ISO9001,
  "Chainlink": Chainlink,
  "Check": Check,
  "CheckVert": CheckVert,
  "Chevron_plein-bas": ChevronPleinBas,
  "Chevron_plein-haut": ChevronPleinHaut,
  "Chevron": Chevron$1,
  "Cheque": Cheque,
  "Cheque2": Cheque2,
  "Chequier_classique": Chequier_classique,
  "Chequier_portefeuille": Chequier_portefeuille,
  "Civic": Civic,
  "Clavier_virtuel": Clavier_virtuel,
  "Clipboard": Clipboard,
  "Cle": Cle,
  "Code": Code$1,
  "Code2": Code2,
  "Colonne": Colonne,
  "Compte": Compte,
  "Compteur": Compteur,
  "Connexion": Connexion,
  "Consultation": Consultation,
  "Consultation_V2": Consultation_V2,
  "Convertion": Convertion,
  "Copier": Copier,
  "Cours_des_marches": Cours_des_marches,
  "Crayon": Crayon,
  "Credit": Credit,
  "Cursor": Cursor,
  "Cybersecurite": Cybersecurite,
  "Dai": Dai,
  "Dash": Dash,
  "Dashboard": Dashboard,
  "Data_base": Data_base,
  "Date": DateIcon,
  "Decred": Decred,
  "Dent": Dent,
  "Discussion": Discussion,
  "Doc": Doc,
  "Donnees_personnelles": Donnees_personnelles,
  "Dot2": Dot2,
  "Doublon": Doublon,
  "DragDrop": DragDrop,
  "Debit": Debit,
  "Deconnexion": Deconnexion,
  "Deconnexion2": Deconnexion2,
  "Depot2": Depot2,
  "Desactivation": Desactivation,
  "Detail": Detail,
  "Edge": Edge,
  "Edito": Edito,
  "Educare": Educare,
  "Emercoin": Emercoin,
  "Emission": Emission,
  "Empreinte": Empreinte,
  "En_attente_de_validation": En_attente_de_validation,
  "En_cours": En_cours,
  "En_savoir_plus": En_savoir_plus,
  "Enjin-coin": EnjinCoin,
  "Enrole": Enrole,
  "Entreprise": Entreprise,
  "Envoyer": Envoyer,
  "Eos": Eos,
  "Ethereum-classic": EthereumClassic,
  "Ethereum": Ethereum,
  "Euros": Euros,
  "Explorer": Explorer,
  "Export": Export,
  "Extract_cpt": Extract_cpt,
  "Face_ID": Face_ID,
  "FAQ": FAQ,
  "Favoris": Favoris,
  "Filtre": Filtre,
  "Filtres": Filtres,
  "Filtres2": Filtres2,
  "Firefox": Firefox,
  "Flux": Flux,
  "Fraude": Fraude,
  "Ftx-token": FtxToken,
  "Geolocalisation": Geolocalisation,
  "Graphe": Graphe,
  "Handshake": Handshake,
  "Harmony": Harmony,
  "Hedera-hashgraph": HederaHashgraph,
  "Hex": Hex,
  "Historique": Historique,
  "Home": Home,
  "Horloge": Horloge,
  "Hotline": Hotline,
  "Huobi-token": HuobiToken,
  "Icon": Iconi,
  "Imprimante": Imprimante,
  "Infos": Infos,
  "Instant_payment": Instant_payment,
  "Interdit": Interdit,
  "Integrer-1": Integrer1,
  "Integrer": Integrer,
  "Invalide": Invalide,
  "Iost": Iost,
  "Jaime": Jaime,
  "Journal": Journal,
  "Kyber-network": KyberNetwork,
  "Langue": Langue,
  "Lecture": Lecture,
  "Link": Link,
  "Link2": Link2,
  "Liste": Liste,
  "Litecoin": Litecoin,
  "Localisation": Localisation,
  "Login": Login,
  "Loupe": Loupe,
  "Mail": Mail,
  "Maintenance": Maintenance,
  "Maker": Maker,
  "Message": Message$1,
  "Mobilite_bancaire": Mobilite_bancaire,
  "Monero": Monero,
  "Montant-1": Montant1,
  "Montant": Montant,
  "MotDePasse": MotDePasse,
  "Nebulas": Nebulas,
  "Nem": Nem,
  "Nexo": Nexo,
  "Note": Note,
  "Ocean-protocol": OceanProtocol,
  "Okb": Okb,
  "Ontology": Ontology,
  "Opera": Opera,
  "Opposition": Opposition,
  "Operations": Operations,
  "Paint": Paint,
  "Parcours": Parcours,
  "Partager": Partager,
  "Partenaires": Partenaires,
  "Partenaires2": Partenaires2,
  "Pause": Pause,
  "PC-1": PC1,
  "PC": PC,
  "PDF": PDF,
  "PJ": PJ,
  "Planning": Planning,
  "Plus": Plus$1,
  "Polkadot": Polkadot,
  "Polygon": Polygon,
  "Polyswarm": Polyswarm,
  "Poubelle": Poubelle,
  "Pouvoirs2": Pouvoirs2,
  "Profil2": Profil2,
  "Profil3": Profil3,
  "Protocole": Protocole,
  "Previsualisation": Previsualisation,
  "Puzzle": Puzzle,
  "QR-CODE": QRCODE,
  "Quant": Quant,
  "Recevoir": Recevoir,
  "Refresh": Refresh,
  "Retirer": Retirer,
  "RIB": RIB,
  "Repertoire": Repertoire,
  "Sinscrire": Sinscrire,
  "Sablier": Sablier,
  "Safari": Safari,
  "Sante": Sante,
  "Save": Save,
  "Se_connecter": Se_connecter,
  "Services": Services,
  "Shield": Shield,
  "Shopping2": Shopping2,
  "Siacoin": Siacoin,
  "Signature": Signature,
  "Site_web": Site_web,
  "Slidebar": Slidebar,
  "Social": Social,
  "Solana": Solana,
  "Stacks": Stacks,
  "ChevronDown": ChevronDown,
  "ChevronLeft": ChevronLeft,
  "ChevronRight": ChevronRight,
  "ChevronUp": ChevronUp,
  "Stellar": Stellar,
  "Supprimer-1": Supprimer1,
  "Supprimer": Supprimer,
  "Swap": Swap,
  "Tablette": Tablette,
  "Tenx": Tenx,
  "Tether": Tether,
  "The-graph": TheGraph,
  "Theta": Theta,
  "Thorchain": Thorchain,
  "Titre_en_bourse": Titre_en_bourse,
  "TPP": TPP,
  "Transfer": Transfer,
  "Trier": Trier,
  "Trontron": Trontron,
  "Telechargement": Telechargement,
  "Telephone": Telephone,
  "USB": USB,
  "Usd-coin": UsdCoin,
  "Valider2": Valider2,
  "Valide": Valide,
  "Velas": Velas,
  "Vendre": Vendre,
  "Vibe": Vibe,
  "Vignette": Vignette,
  "Voice_ID": Voice_ID,
  "Voir": Voir,
  "Wanchain": Wanchain,
  "Wanchain2": Wanchain2,
  "Warning": Warning,
  "WeBank_Pass": WeBank_Pass,
  "Wing": Wing,
  "XCircle": XCircle,
  "Xrp": Xrp,
  "Zel": Zel,
  "asc": ASC,
  "desc": Desc,
  "nosort": Nosort,
  "CoffreFort": CoffreFort,
  "Resilier": Resilier,
  "Incognito": Incognito,
  "Moon": Moon,
  "Sun": Sun
};
const Icon$2 = (props) => {
  return props.icon ? /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, typeof POSSIBLE_LOGO[props.icon] !== "undefined" && React__default.createElement(POSSIBLE_LOGO[props.icon], { size: props.size, color: props.color, className: props.className })) : /* @__PURE__ */ React__default.createElement(React__default.Fragment, null);
};
const classType$4 = {
  "primary": buttonPrimary,
  "secondary": buttonSecondary,
  "tertiary": buttonTertiary,
  "negative": buttonNegative
};
const Button = ({
  type: type2 = "primary",
  //size = 'medium',
  label,
  icon: icon2,
  iconProps,
  className,
  children,
  disabled = false,
  submit = false,
  ...props
}) => {
  return /* @__PURE__ */ React__default.createElement(
    "button",
    {
      type: submit ? "submit" : "button",
      className: classNames$1(button, className, classType$4[type2]),
      ...props,
      disabled,
      "aria-disabled": disabled,
      "aria-label": label
    },
    /* @__PURE__ */ React__default.createElement("div", { className: buttonLabel }, label, icon2 && /* @__PURE__ */ React__default.createElement("div", { className: buttonIcon }, iconProps ? /* @__PURE__ */ React__default.createElement(Icon$2, { icon: icon2, size: iconProps.size, color: iconProps.color, className: iconProps.className }) : /* @__PURE__ */ React__default.createElement(Icon$2, { icon: icon2, size: 22 })), children)
  );
};
var box$2 = "_9h0gyh1";
var datePickerWrapper$1 = "_9h0gyh2";
var frameWrapper$2 = "_9h0gyh3";
var frame$2 = "_9h0gyh4";
var inputDefault$2 = "_9h0gyh5";
var inputCorrect$2 = "_9h0gyh6";
var inputError$2 = "_9h0gyh7";
var textWrapper$2 = "_9h0gyh8";
var inputBox$2 = "_9h0gyh9";
var disabledInput = "_9h0gyha";
var inputIcon$1 = "_9h0gyhb";
var valueContainer = "_9h0gyhc";
var placeholderText = "_9h0gyhd";
var disabledplaceholderText = "_9h0gyhe";
var indicatorDisplayNone = "_9h0gyhf";
var defaultText = "_9h0gyhg";
var option = "_9h0gyhh";
var selectedOption = "_9h0gyhi";
var disabledOption = "_9h0gyhj";
var focusedOption = "_9h0gyhk";
var menuPortal = "_9h0gyhl";
var SingleValue$2 = "_9h0gyhm";
var multiValue = "_9h0gyhn";
var multiValueText = "_9h0gyho";
var multiValueDel = "_9h0gyhp";
var stepBtn = "_9h0gyhq";
var Plus = "_9h0gyhr";
var Minus = "_9h0gyhs";
const classType$3 = {
  default: inputDefault$2,
  correct: inputCorrect$2,
  error: inputError$2
};
const Input$3 = ({
  name,
  label,
  id,
  placeholder,
  typeClass = "default",
  register: register2,
  type: type2,
  error,
  disabled = false,
  ...props
}) => {
  const CorrectedTypeClass = error ? classType$3.error : classType$3[typeClass];
  const ref = useRef(null);
  const step = (upOrDown) => {
    var _a2, _b2, _c;
    if (upOrDown === "UP")
      (_a2 = ref.current) == null ? void 0 : _a2.stepUp();
    else
      (_b2 = ref.current) == null ? void 0 : _b2.stepDown();
    const ev = new Event("change", { bubbles: true });
    (_c = ref.current) == null ? void 0 : _c.dispatchEvent(ev);
  };
  return /* @__PURE__ */ React__default.createElement("div", { className: box$2 }, /* @__PURE__ */ React__default.createElement("div", { className: frameWrapper$2 }, /* @__PURE__ */ React__default.createElement("div", { className: classNames$1(frame$2, CorrectedTypeClass) }, /* @__PURE__ */ React__default.createElement("label", { className: textWrapper$2, htmlFor: id }, label), /* @__PURE__ */ React__default.createElement(
    "input",
    {
      name,
      placeholder,
      id,
      type: type2,
      className: classNames$1(inputBox$2, disabled && disabledInput),
      disabled,
      ...register2,
      ...props,
      ref: (instance) => {
        var _a2;
        (_a2 = register2 == null ? void 0 : register2.ref) == null ? void 0 : _a2.call(register2, instance);
        ref.current = instance;
      }
    }
  ), type2 === "number" && /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("button", { className: classNames$1(stepBtn, Minus), onClick: () => step("DOWN"), type: "button", "aria-label": "minus one" }, "-"), /* @__PURE__ */ React__default.createElement("button", { onClick: () => step("UP"), className: classNames$1(stepBtn, Plus), type: "button", "aria-label": "plus one" }, "+"))), error && /* @__PURE__ */ React__default.createElement("span", { className: inputError$2 }, error)));
};
var box$1 = "_1hty8qc1";
var frameWrapper$1 = "_1hty8qc3";
var frame$1 = "_1hty8qc4";
var inputDefault$1 = "_1hty8qc5";
var inputCorrect$1 = "_1hty8qc6";
var inputError$1 = "_1hty8qc7";
var textWrapper$1 = "_1hty8qc8";
var inputBox$1 = "_1hty8qc9";
const classType$2 = {
  default: inputDefault$1,
  correct: inputCorrect$1,
  error: inputError$1
};
const Color$2 = ({
  name,
  label,
  id,
  placeholder,
  typeClass = "default",
  register: register2,
  error,
  disabled = false,
  ...props
}) => {
  const CorrectedTypeClass = error ? classType$2.error : classType$2[typeClass];
  return /* @__PURE__ */ React__default.createElement("div", { className: box$1 }, /* @__PURE__ */ React__default.createElement("div", { className: frameWrapper$1 }, /* @__PURE__ */ React__default.createElement("div", { className: classNames$1(frame$1, CorrectedTypeClass) }, /* @__PURE__ */ React__default.createElement("label", { className: textWrapper$1, htmlFor: id }, label), /* @__PURE__ */ React__default.createElement(
    "input",
    {
      name,
      placeholder,
      id,
      type: "color",
      className: classNames$1(inputBox$1, disabled && disabledInput),
      disabled,
      ...register2,
      ...props
    }
  )), error && /* @__PURE__ */ React__default.createElement("span", { className: inputError$1 }, error)));
};
var searchBarContainer = "e3ajaj0";
var searchIconContainer = "e3ajaj1";
var emptyIconContainer = "e3ajaj2";
var searchBar = "e3ajaj3";
function throttle(cb, delay = 1e3) {
  let shouldWait = false;
  let waitingArgs;
  const timeoutFunc = () => {
    if (waitingArgs == null) {
      shouldWait = false;
    } else {
      cb(...waitingArgs);
      waitingArgs = null;
      setTimeout(timeoutFunc, delay);
    }
  };
  return (...args) => {
    if (shouldWait) {
      waitingArgs = args;
      return;
    }
    cb(...args);
    shouldWait = true;
    setTimeout(timeoutFunc, delay);
  };
}
const SearchBar = ({ onSearch, value, throttled: throttled2 = false, placeholder }) => {
  const [searchQuery, setSearchQuery] = useState(value !== void 0 ? value : "");
  const throttledCallback = useCallback(throttle((query) => {
    onSearch(query);
  }, 500), []);
  const handleSearchQueryChange = (event) => {
    const query = event.target.value;
    throttled2 ? throttledCallback(query) : onSearch(query);
    setSearchQuery(query);
  };
  const handleEmpty = () => {
    setSearchQuery("");
    onSearch("");
  };
  return /* @__PURE__ */ React__default.createElement("div", { className: searchBarContainer }, /* @__PURE__ */ React__default.createElement(
    "input",
    {
      type: "text",
      value: value !== void 0 ? value : searchQuery,
      onChange: handleSearchQueryChange,
      placeholder,
      "aria-label": "Search",
      className: searchBar
    }
  ), /* @__PURE__ */ React__default.createElement("div", { className: searchIconContainer }, /* @__PURE__ */ React__default.createElement(Icon$2, { icon: "Loupe", size: 24 })), /* @__PURE__ */ React__default.createElement("button", { className: emptyIconContainer, "aria-label": "empty search", type: "button", onClick: () => handleEmpty() }, /* @__PURE__ */ React__default.createElement(Icon$2, { icon: "Supprimer", size: 16 })));
};
const Icon$1 = (props) => {
  return props.icon ? /* @__PURE__ */ React__default.createElement("div", { className: iconWrapper }, typeof POSSIBLE_LOGO[props.icon] !== "undefined" && React__default.createElement(POSSIBLE_LOGO[props.icon], {
    size: props.size,
    color: props.color,
    className: props.className
  }), props.badge && /* @__PURE__ */ React__default.createElement("span", { className: badge }, props.badge)) : /* @__PURE__ */ React__default.createElement(React__default.Fragment, null);
};
var FondCardContainer = "dr1d5s0";
var FondCardZoneWrapper = "dr1d5s1";
var FondCardZone1Container = "dr1d5s2";
var FondCardZone2Container = "dr1d5s3";
var CardBehind = "dr1d5s4";
var CardHover = "dr1d5s5";
var Shadow = "dr1d5s6";
const Card = ({ children, hoverEffect = false, className, isBehind = false, shadow = false }) => {
  return /* @__PURE__ */ React__default.createElement(
    "div",
    {
      className: classNames$1(FondCardContainer, hoverEffect ? CardHover : "", className, isBehind && CardBehind, shadow && Shadow)
    },
    children
  );
};
const DoubleZoneCard = ({ renderZone1, renderZone2, hoverEffect = false, className, isBehind = true, shadow = false }) => {
  return /* @__PURE__ */ React__default.createElement("div", { className: classNames$1(FondCardZoneWrapper, shadow && Shadow, hoverEffect && CardHover) }, /* @__PURE__ */ React__default.createElement(
    "div",
    {
      className: classNames$1(FondCardZone1Container, className, isBehind && CardBehind)
    },
    renderZone1 == null ? void 0 : renderZone1()
  ), /* @__PURE__ */ React__default.createElement(
    "div",
    {
      className: classNames$1(FondCardZone2Container, className)
    },
    renderZone2 == null ? void 0 : renderZone2()
  ));
};
var fileNameContainer = "ezwhfp0";
var importFileWrapper = "ezwhfp1";
var importFileMainWrapper = "ezwhfp2";
var importFileError = "ezwhfp3";
var importFileContent = "ezwhfp4";
var importFileLabel = "ezwhfp5";
var importFilePlaceholder = "ezwhfp6";
var fileBoxItem = "ezwhfp7";
var fileBoxDeleteBtn = "ezwhfp8";
var fileBoxLabelName = "ezwhfp9";
var theme = { colours: { brand: { colorContrast: "var(--_6mgf0j0)", colorBackground: "var(--_6mgf0j1)", accentSurface: "var(--_6mgf0j2)", graySurface: "var(--_6mgf0j3)", graySurfaceSolid: "var(--_6mgf0j4)", color1: "var(--_6mgf0j5)", color2: "var(--_6mgf0j6)", color3: "var(--_6mgf0j7)", color4: "var(--_6mgf0j8)", color5: "var(--_6mgf0j9)", color6: "var(--_6mgf0ja)", color7: "var(--_6mgf0jb)", color8: "var(--_6mgf0jc)", color9: "var(--_6mgf0jd)", color10: "var(--_6mgf0je)", color11: "var(--_6mgf0jf)", color12: "var(--_6mgf0jg)", colora1: "var(--_6mgf0jh)", colora2: "var(--_6mgf0ji)", colora3: "var(--_6mgf0jj)", colora4: "var(--_6mgf0jk)", colora5: "var(--_6mgf0jl)", colora6: "var(--_6mgf0jm)", colora7: "var(--_6mgf0jn)", colora8: "var(--_6mgf0jo)", colora9: "var(--_6mgf0jp)", colora10: "var(--_6mgf0jq)", colora11: "var(--_6mgf0jr)", colora12: "var(--_6mgf0js)", colorg1: "var(--_6mgf0jt)", colorg2: "var(--_6mgf0ju)", colorg3: "var(--_6mgf0jv)", colorg4: "var(--_6mgf0jw)", colorg5: "var(--_6mgf0jx)", colorg6: "var(--_6mgf0jy)", colorg7: "var(--_6mgf0jz)", colorg8: "var(--_6mgf0j10)", colorg9: "var(--_6mgf0j11)", colorg10: "var(--_6mgf0j12)", colorg11: "var(--_6mgf0j13)", colorg12: "var(--_6mgf0j14)", colorga1: "var(--_6mgf0j15)", colorga2: "var(--_6mgf0j16)", colorga3: "var(--_6mgf0j17)", colorga4: "var(--_6mgf0j18)", colorga5: "var(--_6mgf0j19)", colorga6: "var(--_6mgf0j1a)", colorga7: "var(--_6mgf0j1b)", colorga8: "var(--_6mgf0j1c)", colorga9: "var(--_6mgf0j1d)", colorga10: "var(--_6mgf0j1e)", colorga11: "var(--_6mgf0j1f)", colorga12: "var(--_6mgf0j1g)" }, information: { colorContrast: "var(--_6mgf0j1h)", colorBackground: "var(--_6mgf0j1i)", accentSurface: "var(--_6mgf0j1j)", graySurface: "var(--_6mgf0j1k)", graySurfaceSolid: "var(--_6mgf0j1l)", color1: "var(--_6mgf0j1m)", color2: "var(--_6mgf0j1n)", color3: "var(--_6mgf0j1o)", color4: "var(--_6mgf0j1p)", color5: "var(--_6mgf0j1q)", color6: "var(--_6mgf0j1r)", color7: "var(--_6mgf0j1s)", color8: "var(--_6mgf0j1t)", color9: "var(--_6mgf0j1u)", color10: "var(--_6mgf0j1v)", color11: "var(--_6mgf0j1w)", color12: "var(--_6mgf0j1x)", colora1: "var(--_6mgf0j1y)", colora2: "var(--_6mgf0j1z)", colora3: "var(--_6mgf0j20)", colora4: "var(--_6mgf0j21)", colora5: "var(--_6mgf0j22)", colora6: "var(--_6mgf0j23)", colora7: "var(--_6mgf0j24)", colora8: "var(--_6mgf0j25)", colora9: "var(--_6mgf0j26)", colora10: "var(--_6mgf0j27)", colora11: "var(--_6mgf0j28)", colora12: "var(--_6mgf0j29)", colorg1: "var(--_6mgf0j2a)", colorg2: "var(--_6mgf0j2b)", colorg3: "var(--_6mgf0j2c)", colorg4: "var(--_6mgf0j2d)", colorg5: "var(--_6mgf0j2e)", colorg6: "var(--_6mgf0j2f)", colorg7: "var(--_6mgf0j2g)", colorg8: "var(--_6mgf0j2h)", colorg9: "var(--_6mgf0j2i)", colorg10: "var(--_6mgf0j2j)", colorg11: "var(--_6mgf0j2k)", colorg12: "var(--_6mgf0j2l)", colorga1: "var(--_6mgf0j2m)", colorga2: "var(--_6mgf0j2n)", colorga3: "var(--_6mgf0j2o)", colorga4: "var(--_6mgf0j2p)", colorga5: "var(--_6mgf0j2q)", colorga6: "var(--_6mgf0j2r)", colorga7: "var(--_6mgf0j2s)", colorga8: "var(--_6mgf0j2t)", colorga9: "var(--_6mgf0j2u)", colorga10: "var(--_6mgf0j2v)", colorga11: "var(--_6mgf0j2w)", colorga12: "var(--_6mgf0j2x)" }, positive: { colorContrast: "var(--_6mgf0j2y)", colorBackground: "var(--_6mgf0j2z)", accentSurface: "var(--_6mgf0j30)", graySurface: "var(--_6mgf0j31)", graySurfaceSolid: "var(--_6mgf0j32)", color1: "var(--_6mgf0j33)", color2: "var(--_6mgf0j34)", color3: "var(--_6mgf0j35)", color4: "var(--_6mgf0j36)", color5: "var(--_6mgf0j37)", color6: "var(--_6mgf0j38)", color7: "var(--_6mgf0j39)", color8: "var(--_6mgf0j3a)", color9: "var(--_6mgf0j3b)", color10: "var(--_6mgf0j3c)", color11: "var(--_6mgf0j3d)", color12: "var(--_6mgf0j3e)", colora1: "var(--_6mgf0j3f)", colora2: "var(--_6mgf0j3g)", colora3: "var(--_6mgf0j3h)", colora4: "var(--_6mgf0j3i)", colora5: "var(--_6mgf0j3j)", colora6: "var(--_6mgf0j3k)", colora7: "var(--_6mgf0j3l)", colora8: "var(--_6mgf0j3m)", colora9: "var(--_6mgf0j3n)", colora10: "var(--_6mgf0j3o)", colora11: "var(--_6mgf0j3p)", colora12: "var(--_6mgf0j3q)", colorg1: "var(--_6mgf0j3r)", colorg2: "var(--_6mgf0j3s)", colorg3: "var(--_6mgf0j3t)", colorg4: "var(--_6mgf0j3u)", colorg5: "var(--_6mgf0j3v)", colorg6: "var(--_6mgf0j3w)", colorg7: "var(--_6mgf0j3x)", colorg8: "var(--_6mgf0j3y)", colorg9: "var(--_6mgf0j3z)", colorg10: "var(--_6mgf0j40)", colorg11: "var(--_6mgf0j41)", colorg12: "var(--_6mgf0j42)", colorga1: "var(--_6mgf0j43)", colorga2: "var(--_6mgf0j44)", colorga3: "var(--_6mgf0j45)", colorga4: "var(--_6mgf0j46)", colorga5: "var(--_6mgf0j47)", colorga6: "var(--_6mgf0j48)", colorga7: "var(--_6mgf0j49)", colorga8: "var(--_6mgf0j4a)", colorga9: "var(--_6mgf0j4b)", colorga10: "var(--_6mgf0j4c)", colorga11: "var(--_6mgf0j4d)", colorga12: "var(--_6mgf0j4e)" }, negative: { colorContrast: "var(--_6mgf0j4f)", colorBackground: "var(--_6mgf0j4g)", accentSurface: "var(--_6mgf0j4h)", graySurface: "var(--_6mgf0j4i)", graySurfaceSolid: "var(--_6mgf0j4j)", color1: "var(--_6mgf0j4k)", color2: "var(--_6mgf0j4l)", color3: "var(--_6mgf0j4m)", color4: "var(--_6mgf0j4n)", color5: "var(--_6mgf0j4o)", color6: "var(--_6mgf0j4p)", color7: "var(--_6mgf0j4q)", color8: "var(--_6mgf0j4r)", color9: "var(--_6mgf0j4s)", color10: "var(--_6mgf0j4t)", color11: "var(--_6mgf0j4u)", color12: "var(--_6mgf0j4v)", colora1: "var(--_6mgf0j4w)", colora2: "var(--_6mgf0j4x)", colora3: "var(--_6mgf0j4y)", colora4: "var(--_6mgf0j4z)", colora5: "var(--_6mgf0j50)", colora6: "var(--_6mgf0j51)", colora7: "var(--_6mgf0j52)", colora8: "var(--_6mgf0j53)", colora9: "var(--_6mgf0j54)", colora10: "var(--_6mgf0j55)", colora11: "var(--_6mgf0j56)", colora12: "var(--_6mgf0j57)", colorg1: "var(--_6mgf0j58)", colorg2: "var(--_6mgf0j59)", colorg3: "var(--_6mgf0j5a)", colorg4: "var(--_6mgf0j5b)", colorg5: "var(--_6mgf0j5c)", colorg6: "var(--_6mgf0j5d)", colorg7: "var(--_6mgf0j5e)", colorg8: "var(--_6mgf0j5f)", colorg9: "var(--_6mgf0j5g)", colorg10: "var(--_6mgf0j5h)", colorg11: "var(--_6mgf0j5i)", colorg12: "var(--_6mgf0j5j)", colorga1: "var(--_6mgf0j5k)", colorga2: "var(--_6mgf0j5l)", colorga3: "var(--_6mgf0j5m)", colorga4: "var(--_6mgf0j5n)", colorga5: "var(--_6mgf0j5o)", colorga6: "var(--_6mgf0j5p)", colorga7: "var(--_6mgf0j5q)", colorga8: "var(--_6mgf0j5r)", colorga9: "var(--_6mgf0j5s)", colorga10: "var(--_6mgf0j5t)", colorga11: "var(--_6mgf0j5u)", colorga12: "var(--_6mgf0j5v)" }, pending: { colorContrast: "var(--_6mgf0j5w)", colorBackground: "var(--_6mgf0j5x)", accentSurface: "var(--_6mgf0j5y)", graySurface: "var(--_6mgf0j5z)", graySurfaceSolid: "var(--_6mgf0j60)", color1: "var(--_6mgf0j61)", color2: "var(--_6mgf0j62)", color3: "var(--_6mgf0j63)", color4: "var(--_6mgf0j64)", color5: "var(--_6mgf0j65)", color6: "var(--_6mgf0j66)", color7: "var(--_6mgf0j67)", color8: "var(--_6mgf0j68)", color9: "var(--_6mgf0j69)", color10: "var(--_6mgf0j6a)", color11: "var(--_6mgf0j6b)", color12: "var(--_6mgf0j6c)", colora1: "var(--_6mgf0j6d)", colora2: "var(--_6mgf0j6e)", colora3: "var(--_6mgf0j6f)", colora4: "var(--_6mgf0j6g)", colora5: "var(--_6mgf0j6h)", colora6: "var(--_6mgf0j6i)", colora7: "var(--_6mgf0j6j)", colora8: "var(--_6mgf0j6k)", colora9: "var(--_6mgf0j6l)", colora10: "var(--_6mgf0j6m)", colora11: "var(--_6mgf0j6n)", colora12: "var(--_6mgf0j6o)", colorg1: "var(--_6mgf0j6p)", colorg2: "var(--_6mgf0j6q)", colorg3: "var(--_6mgf0j6r)", colorg4: "var(--_6mgf0j6s)", colorg5: "var(--_6mgf0j6t)", colorg6: "var(--_6mgf0j6u)", colorg7: "var(--_6mgf0j6v)", colorg8: "var(--_6mgf0j6w)", colorg9: "var(--_6mgf0j6x)", colorg10: "var(--_6mgf0j6y)", colorg11: "var(--_6mgf0j6z)", colorg12: "var(--_6mgf0j70)", colorga1: "var(--_6mgf0j71)", colorga2: "var(--_6mgf0j72)", colorga3: "var(--_6mgf0j73)", colorga4: "var(--_6mgf0j74)", colorga5: "var(--_6mgf0j75)", colorga6: "var(--_6mgf0j76)", colorga7: "var(--_6mgf0j77)", colorga8: "var(--_6mgf0j78)", colorga9: "var(--_6mgf0j79)", colorga10: "var(--_6mgf0j7a)", colorga11: "var(--_6mgf0j7b)", colorga12: "var(--_6mgf0j7c)" }, disp: { colorContrast: "var(--_6mgf0j7d)", colorBackground: "var(--_6mgf0j7e)", accentSurface: "var(--_6mgf0j7f)", graySurface: "var(--_6mgf0j7g)", graySurfaceSolid: "var(--_6mgf0j7h)", color1: "var(--_6mgf0j7i)", color2: "var(--_6mgf0j7j)", color3: "var(--_6mgf0j7k)", color4: "var(--_6mgf0j7l)", color5: "var(--_6mgf0j7m)", color6: "var(--_6mgf0j7n)", color7: "var(--_6mgf0j7o)", color8: "var(--_6mgf0j7p)", color9: "var(--_6mgf0j7q)", color10: "var(--_6mgf0j7r)", color11: "var(--_6mgf0j7s)", color12: "var(--_6mgf0j7t)", colora1: "var(--_6mgf0j7u)", colora2: "var(--_6mgf0j7v)", colora3: "var(--_6mgf0j7w)", colora4: "var(--_6mgf0j7x)", colora5: "var(--_6mgf0j7y)", colora6: "var(--_6mgf0j7z)", colora7: "var(--_6mgf0j80)", colora8: "var(--_6mgf0j81)", colora9: "var(--_6mgf0j82)", colora10: "var(--_6mgf0j83)", colora11: "var(--_6mgf0j84)", colora12: "var(--_6mgf0j85)", colorg1: "var(--_6mgf0j86)", colorg2: "var(--_6mgf0j87)", colorg3: "var(--_6mgf0j88)", colorg4: "var(--_6mgf0j89)", colorg5: "var(--_6mgf0j8a)", colorg6: "var(--_6mgf0j8b)", colorg7: "var(--_6mgf0j8c)", colorg8: "var(--_6mgf0j8d)", colorg9: "var(--_6mgf0j8e)", colorg10: "var(--_6mgf0j8f)", colorg11: "var(--_6mgf0j8g)", colorg12: "var(--_6mgf0j8h)", colorga1: "var(--_6mgf0j8i)", colorga2: "var(--_6mgf0j8j)", colorga3: "var(--_6mgf0j8k)", colorga4: "var(--_6mgf0j8l)", colorga5: "var(--_6mgf0j8m)", colorga6: "var(--_6mgf0j8n)", colorga7: "var(--_6mgf0j8o)", colorga8: "var(--_6mgf0j8p)", colorga9: "var(--_6mgf0j8q)", colorga10: "var(--_6mgf0j8r)", colorga11: "var(--_6mgf0j8s)", colorga12: "var(--_6mgf0j8t)" } }, input: { correctBackground: "var(--_6mgf0j8u)", correctBorder: "var(--_6mgf0j8v)", errorBackground: "var(--_6mgf0j8w)", errorBorder: "var(--_6mgf0j8x)" }, size: { borderRadius: { small: "var(--_6mgf0j8y)", medium: "var(--_6mgf0j8z)", big: "var(--_6mgf0j90)", round: "var(--_6mgf0j91)" }, margin: { small: "var(--_6mgf0j92)", medium: "var(--_6mgf0j93)", big: "var(--_6mgf0j94)" }, font: { small: "var(--_6mgf0j95)", medium: "var(--_6mgf0j96)", big: "var(--_6mgf0j97)" } }, gradient: "var(--_6mgf0j98)" };
var demoLightV2 = "_6mgf0j99";
var demoDarkV2 = "_6mgf0j9a";
const ImportFile = ({ onFileSelect, onFileDelete, placeholder, title: title2 = "Ajouter un fichier", dragText = "Lacher pour ajouter le fichier", fileMaxSize = 10485760, fileTypesAllowed = ["image/png", "image/jpeg", "application/pdf"], onFileError, isInForm = true }) => {
  const [errorState, setErrorState] = useState(false);
  const inputFile = useRef(null);
  const reducer = (state, action) => {
    switch (action.type) {
      case "SET_DROP_DEPTH":
        return { ...state, dropDepth: action.dropDepth };
      case "SET_IN_DROP_ZONE":
        return { ...state, inDropZone: action.inDropZone };
      case "ADD_FILE_TO_LIST":
        return { ...state, fileList: state.fileList.concat(action.files) };
      case "DELETE_FILE_FROM_LIST":
        return { ...state, fileList: state.fileList.filter((item) => !action.files.includes(item)) };
      default:
        return state;
    }
  };
  const [data2, dispatch] = React__default.useReducer(
    reducer,
    { dropDepth: 0, inDropZone: false, fileList: [] }
  );
  const handleError = () => {
    setErrorState(true);
    onFileError == null ? void 0 : onFileError();
  };
  const handleFileSelect = (event) => {
    var _a2;
    const file = (_a2 = event.target.files) == null ? void 0 : _a2[0];
    if (file) {
      if (fileIsCorrect(file)) {
        isInForm && dispatch({ type: "ADD_FILE_TO_LIST", files: [file] });
        setErrorState(false);
        onFileSelect(file);
      } else {
        handleError();
      }
    }
  };
  const handleDragEnter = (e2) => {
    e2.preventDefault();
    e2.stopPropagation();
    dispatch({ type: "SET_DROP_DEPTH", dropDepth: data2.dropDepth + 1 });
  };
  const handleDragLeave = (e2) => {
    e2.preventDefault();
    e2.stopPropagation();
    dispatch({ type: "SET_DROP_DEPTH", dropDepth: data2.dropDepth - 1 });
    if (data2.dropDepth > 0) return;
    dispatch({ type: "SET_IN_DROP_ZONE", inDropZone: false });
  };
  const handleDragOver = (e2) => {
    e2.preventDefault();
    e2.stopPropagation();
    e2.dataTransfer.dropEffect = "copy";
    dispatch({ type: "SET_IN_DROP_ZONE", inDropZone: true });
  };
  const handleDrop = (e2) => {
    e2.preventDefault();
    e2.stopPropagation();
    let files = [...e2.dataTransfer.files];
    if (files && files.length > 0) {
      const existingFiles = data2.fileList.map((f2) => f2.name);
      files = files.filter((f2) => !existingFiles.includes(f2.name));
      const sizeBefore = files.length;
      files = files.filter((f2) => fileIsCorrect(f2));
      if (sizeBefore > files.length) {
        handleError();
      } else {
        setErrorState(false);
      }
      isInForm && dispatch({ type: "ADD_FILE_TO_LIST", files });
      files.forEach((f2) => onFileSelect(f2));
      dispatch({ type: "SET_DROP_DEPTH", dropDepth: 0 });
      dispatch({ type: "SET_IN_DROP_ZONE", inDropZone: false });
    }
  };
  const fileIsCorrect = (file) => {
    return fileMaxSize && file.size < fileMaxSize && (fileTypesAllowed && fileTypesAllowed.includes(file.type));
  };
  const handleFileDelete = (file) => {
    if (file) {
      dispatch({ type: "DELETE_FILE_FROM_LIST", files: [file] });
      onFileDelete(file);
    }
  };
  const onInputClick = () => {
    var _a2;
    (_a2 = inputFile.current) == null ? void 0 : _a2.click();
  };
  return /* @__PURE__ */ React__default.createElement("div", { className: importFileMainWrapper }, /* @__PURE__ */ React__default.createElement("div", { className: `${importFileWrapper} ${errorState ? importFileError : ""}`, tabIndex: 0, onClick: onInputClick }, /* @__PURE__ */ React__default.createElement(
    "div",
    {
      className: importFileContent,
      onDrop: (e2) => handleDrop(e2),
      onDragOver: (e2) => handleDragOver(e2),
      onDragEnter: (e2) => handleDragEnter(e2),
      onDragLeave: (e2) => handleDragLeave(e2)
    },
    /* @__PURE__ */ React__default.createElement(Icon$2, { size: 125, icon: "DragDrop" }),
    data2.inDropZone ? /* @__PURE__ */ React__default.createElement("span", { className: importFileLabel }, dragText) : /* @__PURE__ */ React__default.createElement("span", { className: importFileLabel }, title2),
    /* @__PURE__ */ React__default.createElement(
      "input",
      {
        type: "file",
        id: "import-file",
        "aria-label": "import file",
        ref: inputFile,
        onChange: handleFileSelect,
        style: { opacity: "0", width: "0", height: 0, position: "absolute" }
      }
    ),
    placeholder && /* @__PURE__ */ React__default.createElement("span", { className: importFilePlaceholder }, placeholder)
  )), /* @__PURE__ */ React__default.createElement("div", { className: fileNameContainer }, data2.fileList.map((f2) => {
    return /* @__PURE__ */ React__default.createElement("div", { key: f2.name, className: fileBoxItem }, /* @__PURE__ */ React__default.createElement("span", { className: fileBoxLabelName }, f2.name), /* @__PURE__ */ React__default.createElement("button", { type: "button", className: fileBoxDeleteBtn, "aria-label": "delete", onClick: () => handleFileDelete(f2) }, /* @__PURE__ */ React__default.createElement(Icon$2, { icon: "Supprimer", color: theme.colours.brand.colorg12, size: 16 })));
  })));
};
var switchContainer = "xkwzt30";
var switchInput = "xkwzt31";
var switchSlider = "xkwzt32";
const Switch = ({ onChange: onChange2, name, leftIcon, rightIcon, checked }) => {
  return /* @__PURE__ */ React__default.createElement("label", { className: switchContainer }, /* @__PURE__ */ React__default.createElement("input", { className: switchInput, type: "checkbox", onChange: onChange2, "aria-label": name, checked }), /* @__PURE__ */ React__default.createElement("span", { className: switchSlider }), leftIcon, rightIcon);
};
var topBarContainer = "tup65i0";
var SubMenuContent$1 = "tup65i2";
var SubMenuContentItem = "tup65i3";
var ProfilButtonContainer = "tup65i4";
var ProfilIconAvatar = "tup65i5";
var buttonAlerte = "tup65i6";
var buttonAlerteNew = "tup65i8";
var AlertItemContainer = "tup65i9";
var AlertItemLogoContainer = "tup65ia";
var AlertItemInfoContainer = "tup65ib";
var AlertItemName = "tup65ic";
var AlertItemTime = "tup65id";
const TopBar = ({ children }) => {
  return /* @__PURE__ */ React__default.createElement("div", { className: topBarContainer }, children);
};
var modaleContainer = "_162zrm20";
var show = "_162zrm21";
var backdrop = "_162zrm22";
var TitleStyle = "_162zrm23";
var buttonContainer$1 = "_162zrm24";
var SmallSize$1 = "_162zrm25";
var MediumSize$1 = "_162zrm26";
var LargeSize$1 = "_162zrm27";
const useEscapeTo = (callback2, deps) => {
  const callOnEscape = (evt) => {
    if (evt.key === "Escape")
      callback2();
  };
  useEffect(() => {
    window.addEventListener("keydown", callOnEscape);
    return () => window.removeEventListener("keydown", callOnEscape);
  }, deps);
};
const modalSize$2 = {
  "small": SmallSize$1,
  "medium": MediumSize$1,
  "large": LargeSize$1
};
const DialogModal = ({
  title: title2,
  isOpened,
  onProceed,
  labelClose,
  labelProceed,
  onClose,
  children,
  icon: icon2,
  size: size2 = "medium"
}) => {
  const ref = useRef(null);
  useEffect(() => {
    if (isOpened) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }
  }, [isOpened]);
  const proceed = () => {
    onProceed();
  };
  const onMouseDown = (event) => {
    var _a2;
    if (event.target != ref.current && !((_a2 = ref.current) == null ? void 0 : _a2.contains(event.target))) {
      onClose();
    }
  };
  useEscapeTo(() => {
    if (isOpened)
      onClose();
  }, [isOpened]);
  return /* @__PURE__ */ React__default.createElement("div", { onMouseDown, className: classNames$1(isOpened && show, backdrop) }, /* @__PURE__ */ React__default.createElement(
    "div",
    {
      className: classNames$1(modaleContainer, modalSize$2[size2], isOpened && show),
      ref,
      onMouseDown
    },
    /* @__PURE__ */ React__default.createElement("div", { className: TitleStyle }, /* @__PURE__ */ React__default.createElement(Icon$2, { size: 45, icon: icon2 }), title2),
    children,
    /* @__PURE__ */ React__default.createElement("div", { className: buttonContainer$1 }, /* @__PURE__ */ React__default.createElement(Button, { onClick: onClose, label: labelClose, icon: "Supprimer", type: "secondary" }), /* @__PURE__ */ React__default.createElement(Button, { onClick: proceed, label: labelProceed, icon: "Valide", type: "primary" }))
  ));
};
var RightPanelContainer = "_188sdeb0";
var RightPanelContainerAbsolute = "_188sdeb1";
var RightPanelOpened = "_188sdeb2";
var RightPanelContainerHeader = "_188sdeb3";
var RightPanelTitle = "_188sdeb4";
var RightPanelClose = "_188sdeb5";
var RightPanelContent = "_188sdeb6";
var SmallSize = "_188sdeb7";
var MediumSize = "_188sdeb8";
var LargeSize = "_188sdeb9";
const modalSize$1 = {
  "small": SmallSize,
  "medium": MediumSize,
  "large": LargeSize
};
const RightPanel = ({
  title: title2,
  isOpened,
  onClose,
  children,
  size: size2 = "medium"
}) => {
  const ref = useRef(null);
  useEffect(() => {
    if (isOpened) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }
  }, [isOpened]);
  useEscapeTo(() => {
    if (isOpened)
      onClose();
  }, [isOpened]);
  const onMouseDown = (event) => {
    var _a2;
    if (event.target != ref.current && !((_a2 = ref.current) == null ? void 0 : _a2.contains(event.target))) {
      onClose();
    }
  };
  return /* @__PURE__ */ React__default.createElement("div", { onMouseDown, className: classNames$1(isOpened && show, backdrop) }, /* @__PURE__ */ React__default.createElement(
    "div",
    {
      "data-testid": "RightPanel" + title2,
      className: classNames$1(RightPanelContainerAbsolute, isOpened && RightPanelOpened, modalSize$1[size2]),
      ref,
      onMouseDown
    },
    /* @__PURE__ */ React__default.createElement("div", { className: RightPanelContainerHeader }, /* @__PURE__ */ React__default.createElement("h3", { className: RightPanelTitle }, title2), /* @__PURE__ */ React__default.createElement("button", { "data-testid": "RightPanel" + title2 + "Supprimer", "aria-label": "close", className: RightPanelClose, onClick: onClose }, /* @__PURE__ */ React__default.createElement(Icon$2, { size: 20, icon: "Supprimer", color: theme.colours.brand.colorg12 }))),
    /* @__PURE__ */ React__default.createElement("div", { className: RightPanelContent }, children)
  ));
};
const modalSize = {
  "small": SmallSize,
  "medium": MediumSize,
  "large": LargeSize
};
const isClickInsideRectangle = (e2, element) => {
  const r2 = element.getBoundingClientRect();
  return e2.clientX > r2.left && e2.clientX < r2.right && e2.clientY > r2.top && e2.clientY < r2.bottom;
};
const RelativeRightPanel = ({
  title: title2,
  isOpened,
  onClose,
  children,
  size: size2 = "medium"
}) => {
  const ref = useRef(null);
  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (window.innerWidth < 1500 && isOpened && ref.current && !isClickInsideRectangle(event, ref.current))
        onClose();
    };
    window.addEventListener("mouseup", handleOutsideClick, true);
    return () => window.removeEventListener("mouseup", handleOutsideClick, true);
  }, [isOpened]);
  return /* @__PURE__ */ React__default.createElement(
    "div",
    {
      "data-testid": "RightPanel" + title2,
      className: classNames$1(RightPanelContainer, isOpened && RightPanelOpened, modalSize[size2]),
      ref
    },
    /* @__PURE__ */ React__default.createElement("div", { className: RightPanelContainerHeader }, /* @__PURE__ */ React__default.createElement("h3", { className: RightPanelTitle }, title2), /* @__PURE__ */ React__default.createElement("button", { "data-testid": "RightPanel" + title2 + "Supprimer", "aria-label": "close", className: RightPanelClose, onClick: onClose }, /* @__PURE__ */ React__default.createElement(Icon$2, { size: 20, icon: "Supprimer", color: theme.colours.brand.colorg12 }))),
    /* @__PURE__ */ React__default.createElement("div", { className: RightPanelContent }, children)
  );
};
var menuContainer = "_1ngw5a30";
var expanded = "_1ngw5a32";
var collapsed = "_1ngw5a33";
var logoContainer = "_1ngw5a34";
var buttonContainer = "_1ngw5a35";
var toggleButtonContainer = "_1ngw5a36";
var Items = "_1ngw5a37";
var active$1 = "_1ngw5a38";
var toggleButton = "_1ngw5a39";
var toggleButtonIcon = "_1ngw5a3a";
var SubMenuContent = "_1ngw5a3b";
var SubMenuText = "_1ngw5a3c";
var SubMenuContentCollapsible = "_1ngw5a3e";
var ResizableLogoContainer = "_1ngw5a3f";
var ResizableLogoOnline = "_1ngw5a3g";
var ResizableLogoWeBank = "_1ngw5a3h";
var LogoContainer = "_1ngw5a3j";
var menuLabel = "_1ngw5a3k";
var Orientation = { top: "vzy4u0", right: "vzy4u1", bottom: "vzy4u2", left: "vzy4u3" };
const Chevron = ({ className, orientation }) => {
  return /* @__PURE__ */ React__default.createElement(
    "svg",
    {
      className: `chevron ${className} ${Orientation[orientation]}`,
      fill: "none",
      height: "16",
      viewBox: "0 0 16 16",
      width: "16",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React__default.createElement(
      "path",
      {
        className: "path",
        clipRule: "evenodd",
        d: "M11.0101 15.7071C11.3981 16.0976 12.0271 16.0976 12.4151 15.7071C12.803 15.3166 12.803 14.6834 12.4151 14.2929L7.15678 9C7.15678 9 6.74527 8.55228 6.74527 8C6.74527 7.44772 6.74527 7.5 7.1568 7L12.4151 1.70711C12.803 1.31658 12.803 0.683417 12.4151 0.292893C12.0271 -0.0976315 11.3981 -0.0976315 11.0101 0.292893L4.05657 7.29218C4.05417 7.29459 4.05178 7.29702 4.0494 7.29945C3.87406 7.47921 3.76567 7.72537 3.76488 7.997L3.76488 8L3.76488 8.003C3.76527 8.1375 3.79205 8.26575 3.84026 8.38278C3.88764 8.49805 3.95735 8.6062 4.0494 8.70055C4.05174 8.70295 4.0541 8.70534 4.05647 8.70772M4.05647 8.70772L11.0101 15.7071Z",
        fill: "currentColor",
        fillRule: "evenodd"
      }
    )
  );
};
function _extends$1() {
  _extends$1 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$1.apply(this, arguments);
}
function $e42e1063c40fb3ef$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented = true } = {}) {
  return function handleEvent(event) {
    originalEventHandler === null || originalEventHandler === void 0 || originalEventHandler(event);
    if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler === null || ourEventHandler === void 0 ? void 0 : ourEventHandler(event);
  };
}
function $6ed0406888f73fc4$var$setRef(ref, value) {
  if (typeof ref === "function") ref(value);
  else if (ref !== null && ref !== void 0) ref.current = value;
}
function $6ed0406888f73fc4$export$43e446d32b3d21af(...refs) {
  return (node2) => refs.forEach(
    (ref) => $6ed0406888f73fc4$var$setRef(ref, node2)
  );
}
function $6ed0406888f73fc4$export$c7b2cbe3552a0d05(...refs) {
  return useCallback($6ed0406888f73fc4$export$43e446d32b3d21af(...refs), refs);
}
function $c512c27ab02ef895$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
  let defaultContexts = [];
  function $c512c27ab02ef895$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const BaseContext = /* @__PURE__ */ createContext$1(defaultContext);
    const index2 = defaultContexts.length;
    defaultContexts = [
      ...defaultContexts,
      defaultContext
    ];
    function Provider(props) {
      const { scope, children, ...context } = props;
      const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index2]) || BaseContext;
      const value = useMemo(
        () => context,
        Object.values(context)
      );
      return /* @__PURE__ */ createElement(Context.Provider, {
        value
      }, children);
    }
    function useContext$1(consumerName, scope) {
      const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index2]) || BaseContext;
      const context = useContext(Context);
      if (context) return context;
      if (defaultContext !== void 0) return defaultContext;
      throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    Provider.displayName = rootComponentName + "Provider";
    return [
      Provider,
      useContext$1
    ];
  }
  const createScope = () => {
    const scopeContexts = defaultContexts.map((defaultContext) => {
      return /* @__PURE__ */ createContext$1(defaultContext);
    });
    return function useScope(scope) {
      const contexts = (scope === null || scope === void 0 ? void 0 : scope[scopeName]) || scopeContexts;
      return useMemo(
        () => ({
          [`__scope${scopeName}`]: {
            ...scope,
            [scopeName]: contexts
          }
        }),
        [
          scope,
          contexts
        ]
      );
    };
  };
  createScope.scopeName = scopeName;
  return [
    $c512c27ab02ef895$export$fd42f52fd3ae1109,
    $c512c27ab02ef895$var$composeContextScopes(createScope, ...createContextScopeDeps)
  ];
}
function $c512c27ab02ef895$var$composeContextScopes(...scopes) {
  const baseScope = scopes[0];
  if (scopes.length === 1) return baseScope;
  const createScope1 = () => {
    const scopeHooks = scopes.map(
      (createScope) => ({
        useScope: createScope(),
        scopeName: createScope.scopeName
      })
    );
    return function useComposedScopes(overrideScopes) {
      const nextScopes1 = scopeHooks.reduce((nextScopes, { useScope, scopeName }) => {
        const scopeProps = useScope(overrideScopes);
        const currentScope = scopeProps[`__scope${scopeName}`];
        return {
          ...nextScopes,
          ...currentScope
        };
      }, {});
      return useMemo(
        () => ({
          [`__scope${baseScope.scopeName}`]: nextScopes1
        }),
        [
          nextScopes1
        ]
      );
    };
  };
  createScope1.scopeName = baseScope.scopeName;
  return createScope1;
}
function $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(callback2) {
  const callbackRef = useRef(callback2);
  useEffect(() => {
    callbackRef.current = callback2;
  });
  return useMemo(
    () => (...args) => {
      var _callbackRef$current;
      return (_callbackRef$current = callbackRef.current) === null || _callbackRef$current === void 0 ? void 0 : _callbackRef$current.call(callbackRef, ...args);
    },
    []
  );
}
function $71cd76cc60e0454e$export$6f32135080cb4c3({ prop, defaultProp, onChange: onChange2 = () => {
} }) {
  const [uncontrolledProp, setUncontrolledProp] = $71cd76cc60e0454e$var$useUncontrolledState({
    defaultProp,
    onChange: onChange2
  });
  const isControlled = prop !== void 0;
  const value1 = isControlled ? prop : uncontrolledProp;
  const handleChange = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onChange2);
  const setValue = useCallback((nextValue) => {
    if (isControlled) {
      const setter = nextValue;
      const value = typeof nextValue === "function" ? setter(prop) : nextValue;
      if (value !== prop) handleChange(value);
    } else setUncontrolledProp(nextValue);
  }, [
    isControlled,
    prop,
    setUncontrolledProp,
    handleChange
  ]);
  return [
    value1,
    setValue
  ];
}
function $71cd76cc60e0454e$var$useUncontrolledState({ defaultProp, onChange: onChange2 }) {
  const uncontrolledState = useState(defaultProp);
  const [value] = uncontrolledState;
  const prevValueRef = useRef(value);
  const handleChange = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onChange2);
  useEffect(() => {
    if (prevValueRef.current !== value) {
      handleChange(value);
      prevValueRef.current = value;
    }
  }, [
    value,
    prevValueRef,
    handleChange
  ]);
  return uncontrolledState;
}
const $5e63c961fc1ce211$export$8c6ed5c666ac1360 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { children, ...slotProps } = props;
  const childrenArray = Children.toArray(children);
  const slottable = childrenArray.find($5e63c961fc1ce211$var$isSlottable);
  if (slottable) {
    const newElement = slottable.props.children;
    const newChildren = childrenArray.map((child) => {
      if (child === slottable) {
        if (Children.count(newElement) > 1) return Children.only(null);
        return /* @__PURE__ */ isValidElement(newElement) ? newElement.props.children : null;
      } else return child;
    });
    return /* @__PURE__ */ createElement($5e63c961fc1ce211$var$SlotClone, _extends$1({}, slotProps, {
      ref: forwardedRef
    }), /* @__PURE__ */ isValidElement(newElement) ? /* @__PURE__ */ cloneElement(newElement, void 0, newChildren) : null);
  }
  return /* @__PURE__ */ createElement($5e63c961fc1ce211$var$SlotClone, _extends$1({}, slotProps, {
    ref: forwardedRef
  }), children);
});
$5e63c961fc1ce211$export$8c6ed5c666ac1360.displayName = "Slot";
const $5e63c961fc1ce211$var$SlotClone = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { children, ...slotProps } = props;
  if (/* @__PURE__ */ isValidElement(children)) return /* @__PURE__ */ cloneElement(children, {
    ...$5e63c961fc1ce211$var$mergeProps(slotProps, children.props),
    ref: forwardedRef ? $6ed0406888f73fc4$export$43e446d32b3d21af(forwardedRef, children.ref) : children.ref
  });
  return Children.count(children) > 1 ? Children.only(null) : null;
});
$5e63c961fc1ce211$var$SlotClone.displayName = "SlotClone";
const $5e63c961fc1ce211$export$d9f1ccf0bdb05d45 = ({ children }) => {
  return /* @__PURE__ */ createElement(Fragment, null, children);
};
function $5e63c961fc1ce211$var$isSlottable(child) {
  return /* @__PURE__ */ isValidElement(child) && child.type === $5e63c961fc1ce211$export$d9f1ccf0bdb05d45;
}
function $5e63c961fc1ce211$var$mergeProps(slotProps, childProps) {
  const overrideProps = {
    ...childProps
  };
  for (const propName in childProps) {
    const slotPropValue = slotProps[propName];
    const childPropValue = childProps[propName];
    const isHandler = /^on[A-Z]/.test(propName);
    if (isHandler) {
      if (slotPropValue && childPropValue) overrideProps[propName] = (...args) => {
        childPropValue(...args);
        slotPropValue(...args);
      };
      else if (slotPropValue) overrideProps[propName] = slotPropValue;
    } else if (propName === "style") overrideProps[propName] = {
      ...slotPropValue,
      ...childPropValue
    };
    else if (propName === "className") overrideProps[propName] = [
      slotPropValue,
      childPropValue
    ].filter(Boolean).join(" ");
  }
  return {
    ...slotProps,
    ...overrideProps
  };
}
const $8927f6f2acc4f386$var$NODES = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
];
const $8927f6f2acc4f386$export$250ffa63cdc0d034 = $8927f6f2acc4f386$var$NODES.reduce((primitive, node2) => {
  const Node2 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
    const { asChild, ...primitiveProps } = props;
    const Comp = asChild ? $5e63c961fc1ce211$export$8c6ed5c666ac1360 : node2;
    useEffect(() => {
      window[Symbol.for("radix-ui")] = true;
    }, []);
    return /* @__PURE__ */ createElement(Comp, _extends$1({}, primitiveProps, {
      ref: forwardedRef
    }));
  });
  Node2.displayName = `Primitive.${node2}`;
  return {
    ...primitive,
    [node2]: Node2
  };
}, {});
function $8927f6f2acc4f386$export$6d1a0317bde7de7f(target, event) {
  if (target) flushSync(
    () => target.dispatchEvent(event)
  );
}
function $e02a7d9cb1dc128c$export$c74125a8e3af6bb2(name) {
  const PROVIDER_NAME = name + "CollectionProvider";
  const [createCollectionContext, createCollectionScope] = $c512c27ab02ef895$export$50c7b4e9d9f19c1(PROVIDER_NAME);
  const [CollectionProviderImpl, useCollectionContext] = createCollectionContext(PROVIDER_NAME, {
    collectionRef: {
      current: null
    },
    itemMap: /* @__PURE__ */ new Map()
  });
  const CollectionProvider = (props) => {
    const { scope, children } = props;
    const ref = React__default.useRef(null);
    const itemMap = React__default.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ React__default.createElement(CollectionProviderImpl, {
      scope,
      itemMap,
      collectionRef: ref
    }, children);
  };
  const COLLECTION_SLOT_NAME = name + "CollectionSlot";
  const CollectionSlot = /* @__PURE__ */ React__default.forwardRef((props, forwardedRef) => {
    const { scope, children } = props;
    const context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
    const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, context.collectionRef);
    return /* @__PURE__ */ React__default.createElement($5e63c961fc1ce211$export$8c6ed5c666ac1360, {
      ref: composedRefs
    }, children);
  });
  const ITEM_SLOT_NAME = name + "CollectionItemSlot";
  const ITEM_DATA_ATTR = "data-radix-collection-item";
  const CollectionItemSlot = /* @__PURE__ */ React__default.forwardRef((props, forwardedRef) => {
    const { scope, children, ...itemData } = props;
    const ref = React__default.useRef(null);
    const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, ref);
    const context = useCollectionContext(ITEM_SLOT_NAME, scope);
    React__default.useEffect(() => {
      context.itemMap.set(ref, {
        ref,
        ...itemData
      });
      return () => void context.itemMap.delete(ref);
    });
    return /* @__PURE__ */ React__default.createElement($5e63c961fc1ce211$export$8c6ed5c666ac1360, {
      [ITEM_DATA_ATTR]: "",
      ref: composedRefs
    }, children);
  });
  function useCollection(scope) {
    const context = useCollectionContext(name + "CollectionConsumer", scope);
    const getItems = React__default.useCallback(() => {
      const collectionNode = context.collectionRef.current;
      if (!collectionNode) return [];
      const orderedNodes = Array.from(collectionNode.querySelectorAll(`[${ITEM_DATA_ATTR}]`));
      const items = Array.from(context.itemMap.values());
      const orderedItems = items.sort(
        (a2, b2) => orderedNodes.indexOf(a2.ref.current) - orderedNodes.indexOf(b2.ref.current)
      );
      return orderedItems;
    }, [
      context.collectionRef,
      context.itemMap
    ]);
    return getItems;
  }
  return [
    {
      Provider: CollectionProvider,
      Slot: CollectionSlot,
      ItemSlot: CollectionItemSlot
    },
    useCollection,
    createCollectionScope
  ];
}
const $f631663db3294ace$var$DirectionContext = /* @__PURE__ */ createContext$1(void 0);
function $f631663db3294ace$export$b39126d51d94e6f3(localDir) {
  const globalDir = useContext($f631663db3294ace$var$DirectionContext);
  return localDir || globalDir || "ltr";
}
function $addc16e1bbe58fd0$export$3a72a57244d6e765(onEscapeKeyDownProp, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
  const onEscapeKeyDown = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onEscapeKeyDownProp);
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") onEscapeKeyDown(event);
    };
    ownerDocument.addEventListener("keydown", handleKeyDown);
    return () => ownerDocument.removeEventListener("keydown", handleKeyDown);
  }, [
    onEscapeKeyDown,
    ownerDocument
  ]);
}
const $5cb92bef7577960e$var$CONTEXT_UPDATE = "dismissableLayer.update";
const $5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE = "dismissableLayer.pointerDownOutside";
const $5cb92bef7577960e$var$FOCUS_OUTSIDE = "dismissableLayer.focusOutside";
let $5cb92bef7577960e$var$originalBodyPointerEvents;
const $5cb92bef7577960e$var$DismissableLayerContext = /* @__PURE__ */ createContext$1({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
});
const $5cb92bef7577960e$export$177fb62ff3ec1f22 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  var _node$ownerDocument;
  const { disableOutsidePointerEvents = false, onEscapeKeyDown, onPointerDownOutside, onFocusOutside, onInteractOutside, onDismiss, ...layerProps } = props;
  const context = useContext($5cb92bef7577960e$var$DismissableLayerContext);
  const [node1, setNode] = useState(null);
  const ownerDocument = (_node$ownerDocument = node1 === null || node1 === void 0 ? void 0 : node1.ownerDocument) !== null && _node$ownerDocument !== void 0 ? _node$ownerDocument : globalThis === null || globalThis === void 0 ? void 0 : globalThis.document;
  const [, force] = useState({});
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(
    forwardedRef,
    (node2) => setNode(node2)
  );
  const layers = Array.from(context.layers);
  const [highestLayerWithOutsidePointerEventsDisabled] = [
    ...context.layersWithOutsidePointerEventsDisabled
  ].slice(-1);
  const highestLayerWithOutsidePointerEventsDisabledIndex = layers.indexOf(highestLayerWithOutsidePointerEventsDisabled);
  const index2 = node1 ? layers.indexOf(node1) : -1;
  const isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
  const isPointerEventsEnabled = index2 >= highestLayerWithOutsidePointerEventsDisabledIndex;
  const pointerDownOutside = $5cb92bef7577960e$var$usePointerDownOutside((event) => {
    const target = event.target;
    const isPointerDownOnBranch = [
      ...context.branches
    ].some(
      (branch) => branch.contains(target)
    );
    if (!isPointerEventsEnabled || isPointerDownOnBranch) return;
    onPointerDownOutside === null || onPointerDownOutside === void 0 || onPointerDownOutside(event);
    onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
    if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
  }, ownerDocument);
  const focusOutside = $5cb92bef7577960e$var$useFocusOutside((event) => {
    const target = event.target;
    const isFocusInBranch = [
      ...context.branches
    ].some(
      (branch) => branch.contains(target)
    );
    if (isFocusInBranch) return;
    onFocusOutside === null || onFocusOutside === void 0 || onFocusOutside(event);
    onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
    if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
  }, ownerDocument);
  $addc16e1bbe58fd0$export$3a72a57244d6e765((event) => {
    const isHighestLayer = index2 === context.layers.size - 1;
    if (!isHighestLayer) return;
    onEscapeKeyDown === null || onEscapeKeyDown === void 0 || onEscapeKeyDown(event);
    if (!event.defaultPrevented && onDismiss) {
      event.preventDefault();
      onDismiss();
    }
  }, ownerDocument);
  useEffect(() => {
    if (!node1) return;
    if (disableOutsidePointerEvents) {
      if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
        $5cb92bef7577960e$var$originalBodyPointerEvents = ownerDocument.body.style.pointerEvents;
        ownerDocument.body.style.pointerEvents = "none";
      }
      context.layersWithOutsidePointerEventsDisabled.add(node1);
    }
    context.layers.add(node1);
    $5cb92bef7577960e$var$dispatchUpdate();
    return () => {
      if (disableOutsidePointerEvents && context.layersWithOutsidePointerEventsDisabled.size === 1) ownerDocument.body.style.pointerEvents = $5cb92bef7577960e$var$originalBodyPointerEvents;
    };
  }, [
    node1,
    ownerDocument,
    disableOutsidePointerEvents,
    context
  ]);
  useEffect(() => {
    return () => {
      if (!node1) return;
      context.layers.delete(node1);
      context.layersWithOutsidePointerEventsDisabled.delete(node1);
      $5cb92bef7577960e$var$dispatchUpdate();
    };
  }, [
    node1,
    context
  ]);
  useEffect(() => {
    const handleUpdate = () => force({});
    document.addEventListener($5cb92bef7577960e$var$CONTEXT_UPDATE, handleUpdate);
    return () => document.removeEventListener($5cb92bef7577960e$var$CONTEXT_UPDATE, handleUpdate);
  }, []);
  return /* @__PURE__ */ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.div, _extends$1({}, layerProps, {
    ref: composedRefs,
    style: {
      pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? "auto" : "none" : void 0,
      ...props.style
    },
    onFocusCapture: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onFocusCapture, focusOutside.onFocusCapture),
    onBlurCapture: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onBlurCapture, focusOutside.onBlurCapture),
    onPointerDownCapture: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerDownCapture, pointerDownOutside.onPointerDownCapture)
  }));
});
const $5cb92bef7577960e$export$4d5eb2109db14228 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const context = useContext($5cb92bef7577960e$var$DismissableLayerContext);
  const ref = useRef(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, ref);
  useEffect(() => {
    const node2 = ref.current;
    if (node2) {
      context.branches.add(node2);
      return () => {
        context.branches.delete(node2);
      };
    }
  }, [
    context.branches
  ]);
  return /* @__PURE__ */ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.div, _extends$1({}, props, {
    ref: composedRefs
  }));
});
function $5cb92bef7577960e$var$usePointerDownOutside(onPointerDownOutside, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
  const handlePointerDownOutside = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onPointerDownOutside);
  const isPointerInsideReactTreeRef = useRef(false);
  const handleClickRef = useRef(() => {
  });
  useEffect(() => {
    const handlePointerDown = (event) => {
      if (event.target && !isPointerInsideReactTreeRef.current) {
        let handleAndDispatchPointerDownOutsideEvent = function() {
          $5cb92bef7577960e$var$handleAndDispatchCustomEvent($5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE, handlePointerDownOutside, eventDetail, {
            discrete: true
          });
        };
        const eventDetail = {
          originalEvent: event
        };
        if (event.pointerType === "touch") {
          ownerDocument.removeEventListener("click", handleClickRef.current);
          handleClickRef.current = handleAndDispatchPointerDownOutsideEvent;
          ownerDocument.addEventListener("click", handleClickRef.current, {
            once: true
          });
        } else handleAndDispatchPointerDownOutsideEvent();
      } else
        ownerDocument.removeEventListener("click", handleClickRef.current);
      isPointerInsideReactTreeRef.current = false;
    };
    const timerId = window.setTimeout(() => {
      ownerDocument.addEventListener("pointerdown", handlePointerDown);
    }, 0);
    return () => {
      window.clearTimeout(timerId);
      ownerDocument.removeEventListener("pointerdown", handlePointerDown);
      ownerDocument.removeEventListener("click", handleClickRef.current);
    };
  }, [
    ownerDocument,
    handlePointerDownOutside
  ]);
  return {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => isPointerInsideReactTreeRef.current = true
  };
}
function $5cb92bef7577960e$var$useFocusOutside(onFocusOutside, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
  const handleFocusOutside = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onFocusOutside);
  const isFocusInsideReactTreeRef = useRef(false);
  useEffect(() => {
    const handleFocus = (event) => {
      if (event.target && !isFocusInsideReactTreeRef.current) {
        const eventDetail = {
          originalEvent: event
        };
        $5cb92bef7577960e$var$handleAndDispatchCustomEvent($5cb92bef7577960e$var$FOCUS_OUTSIDE, handleFocusOutside, eventDetail, {
          discrete: false
        });
      }
    };
    ownerDocument.addEventListener("focusin", handleFocus);
    return () => ownerDocument.removeEventListener("focusin", handleFocus);
  }, [
    ownerDocument,
    handleFocusOutside
  ]);
  return {
    onFocusCapture: () => isFocusInsideReactTreeRef.current = true,
    onBlurCapture: () => isFocusInsideReactTreeRef.current = false
  };
}
function $5cb92bef7577960e$var$dispatchUpdate() {
  const event = new CustomEvent($5cb92bef7577960e$var$CONTEXT_UPDATE);
  document.dispatchEvent(event);
}
function $5cb92bef7577960e$var$handleAndDispatchCustomEvent(name, handler, detail, { discrete }) {
  const target = detail.originalEvent.target;
  const event = new CustomEvent(name, {
    bubbles: false,
    cancelable: true,
    detail
  });
  if (handler) target.addEventListener(name, handler, {
    once: true
  });
  if (discrete) $8927f6f2acc4f386$export$6d1a0317bde7de7f(target, event);
  else target.dispatchEvent(event);
}
const $5cb92bef7577960e$export$be92b6f5f03c0fe9 = $5cb92bef7577960e$export$177fb62ff3ec1f22;
const $5cb92bef7577960e$export$aecb2ddcb55c95be = $5cb92bef7577960e$export$4d5eb2109db14228;
let $3db38b7d1fb3fe6a$var$count = 0;
function $3db38b7d1fb3fe6a$export$b7ece24a22aeda8c() {
  useEffect(() => {
    var _edgeGuards$, _edgeGuards$2;
    const edgeGuards = document.querySelectorAll("[data-radix-focus-guard]");
    document.body.insertAdjacentElement("afterbegin", (_edgeGuards$ = edgeGuards[0]) !== null && _edgeGuards$ !== void 0 ? _edgeGuards$ : $3db38b7d1fb3fe6a$var$createFocusGuard());
    document.body.insertAdjacentElement("beforeend", (_edgeGuards$2 = edgeGuards[1]) !== null && _edgeGuards$2 !== void 0 ? _edgeGuards$2 : $3db38b7d1fb3fe6a$var$createFocusGuard());
    $3db38b7d1fb3fe6a$var$count++;
    return () => {
      if ($3db38b7d1fb3fe6a$var$count === 1) document.querySelectorAll("[data-radix-focus-guard]").forEach(
        (node2) => node2.remove()
      );
      $3db38b7d1fb3fe6a$var$count--;
    };
  }, []);
}
function $3db38b7d1fb3fe6a$var$createFocusGuard() {
  const element = document.createElement("span");
  element.setAttribute("data-radix-focus-guard", "");
  element.tabIndex = 0;
  element.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none";
  return element;
}
const $d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT = "focusScope.autoFocusOnMount";
const $d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT = "focusScope.autoFocusOnUnmount";
const $d3863c46a17e8a28$var$EVENT_OPTIONS = {
  bubbles: false,
  cancelable: true
};
const $d3863c46a17e8a28$export$20e40289641fbbb6 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { loop = false, trapped = false, onMountAutoFocus: onMountAutoFocusProp, onUnmountAutoFocus: onUnmountAutoFocusProp, ...scopeProps } = props;
  const [container1, setContainer] = useState(null);
  const onMountAutoFocus = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onMountAutoFocusProp);
  const onUnmountAutoFocus = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onUnmountAutoFocusProp);
  const lastFocusedElementRef = useRef(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(
    forwardedRef,
    (node2) => setContainer(node2)
  );
  const focusScope = useRef({
    paused: false,
    pause() {
      this.paused = true;
    },
    resume() {
      this.paused = false;
    }
  }).current;
  useEffect(() => {
    if (trapped) {
      let handleFocusIn = function(event) {
        if (focusScope.paused || !container1) return;
        const target = event.target;
        if (container1.contains(target)) lastFocusedElementRef.current = target;
        else $d3863c46a17e8a28$var$focus(lastFocusedElementRef.current, {
          select: true
        });
      }, handleFocusOut = function(event) {
        if (focusScope.paused || !container1) return;
        const relatedTarget = event.relatedTarget;
        if (relatedTarget === null) return;
        if (!container1.contains(relatedTarget)) $d3863c46a17e8a28$var$focus(lastFocusedElementRef.current, {
          select: true
        });
      }, handleMutations = function(mutations) {
        const focusedElement = document.activeElement;
        if (focusedElement !== document.body) return;
        for (const mutation of mutations) if (mutation.removedNodes.length > 0) $d3863c46a17e8a28$var$focus(container1);
      };
      document.addEventListener("focusin", handleFocusIn);
      document.addEventListener("focusout", handleFocusOut);
      const mutationObserver = new MutationObserver(handleMutations);
      if (container1) mutationObserver.observe(container1, {
        childList: true,
        subtree: true
      });
      return () => {
        document.removeEventListener("focusin", handleFocusIn);
        document.removeEventListener("focusout", handleFocusOut);
        mutationObserver.disconnect();
      };
    }
  }, [
    trapped,
    container1,
    focusScope.paused
  ]);
  useEffect(() => {
    if (container1) {
      $d3863c46a17e8a28$var$focusScopesStack.add(focusScope);
      const previouslyFocusedElement = document.activeElement;
      const hasFocusedCandidate = container1.contains(previouslyFocusedElement);
      if (!hasFocusedCandidate) {
        const mountEvent = new CustomEvent($d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, $d3863c46a17e8a28$var$EVENT_OPTIONS);
        container1.addEventListener($d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
        container1.dispatchEvent(mountEvent);
        if (!mountEvent.defaultPrevented) {
          $d3863c46a17e8a28$var$focusFirst($d3863c46a17e8a28$var$removeLinks($d3863c46a17e8a28$var$getTabbableCandidates(container1)), {
            select: true
          });
          if (document.activeElement === previouslyFocusedElement) $d3863c46a17e8a28$var$focus(container1);
        }
      }
      return () => {
        container1.removeEventListener($d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
        setTimeout(() => {
          const unmountEvent = new CustomEvent($d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, $d3863c46a17e8a28$var$EVENT_OPTIONS);
          container1.addEventListener($d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
          container1.dispatchEvent(unmountEvent);
          if (!unmountEvent.defaultPrevented) $d3863c46a17e8a28$var$focus(previouslyFocusedElement !== null && previouslyFocusedElement !== void 0 ? previouslyFocusedElement : document.body, {
            select: true
          });
          container1.removeEventListener($d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
          $d3863c46a17e8a28$var$focusScopesStack.remove(focusScope);
        }, 0);
      };
    }
  }, [
    container1,
    onMountAutoFocus,
    onUnmountAutoFocus,
    focusScope
  ]);
  const handleKeyDown = useCallback((event) => {
    if (!loop && !trapped) return;
    if (focusScope.paused) return;
    const isTabKey = event.key === "Tab" && !event.altKey && !event.ctrlKey && !event.metaKey;
    const focusedElement = document.activeElement;
    if (isTabKey && focusedElement) {
      const container = event.currentTarget;
      const [first, last2] = $d3863c46a17e8a28$var$getTabbableEdges(container);
      const hasTabbableElementsInside = first && last2;
      if (!hasTabbableElementsInside) {
        if (focusedElement === container) event.preventDefault();
      } else {
        if (!event.shiftKey && focusedElement === last2) {
          event.preventDefault();
          if (loop) $d3863c46a17e8a28$var$focus(first, {
            select: true
          });
        } else if (event.shiftKey && focusedElement === first) {
          event.preventDefault();
          if (loop) $d3863c46a17e8a28$var$focus(last2, {
            select: true
          });
        }
      }
    }
  }, [
    loop,
    trapped,
    focusScope.paused
  ]);
  return /* @__PURE__ */ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.div, _extends$1({
    tabIndex: -1
  }, scopeProps, {
    ref: composedRefs,
    onKeyDown: handleKeyDown
  }));
});
function $d3863c46a17e8a28$var$focusFirst(candidates, { select = false } = {}) {
  const previouslyFocusedElement = document.activeElement;
  for (const candidate of candidates) {
    $d3863c46a17e8a28$var$focus(candidate, {
      select
    });
    if (document.activeElement !== previouslyFocusedElement) return;
  }
}
function $d3863c46a17e8a28$var$getTabbableEdges(container) {
  const candidates = $d3863c46a17e8a28$var$getTabbableCandidates(container);
  const first = $d3863c46a17e8a28$var$findVisible(candidates, container);
  const last2 = $d3863c46a17e8a28$var$findVisible(candidates.reverse(), container);
  return [
    first,
    last2
  ];
}
function $d3863c46a17e8a28$var$getTabbableCandidates(container) {
  const nodes = [];
  const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (node2) => {
      const isHiddenInput = node2.tagName === "INPUT" && node2.type === "hidden";
      if (node2.disabled || node2.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP;
      return node2.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  while (walker.nextNode()) nodes.push(walker.currentNode);
  return nodes;
}
function $d3863c46a17e8a28$var$findVisible(elements2, container) {
  for (const element of elements2) {
    if (!$d3863c46a17e8a28$var$isHidden(element, {
      upTo: container
    })) return element;
  }
}
function $d3863c46a17e8a28$var$isHidden(node2, { upTo }) {
  if (getComputedStyle(node2).visibility === "hidden") return true;
  while (node2) {
    if (upTo !== void 0 && node2 === upTo) return false;
    if (getComputedStyle(node2).display === "none") return true;
    node2 = node2.parentElement;
  }
  return false;
}
function $d3863c46a17e8a28$var$isSelectableInput(element) {
  return element instanceof HTMLInputElement && "select" in element;
}
function $d3863c46a17e8a28$var$focus(element, { select = false } = {}) {
  if (element && element.focus) {
    const previouslyFocusedElement = document.activeElement;
    element.focus({
      preventScroll: true
    });
    if (element !== previouslyFocusedElement && $d3863c46a17e8a28$var$isSelectableInput(element) && select) element.select();
  }
}
const $d3863c46a17e8a28$var$focusScopesStack = $d3863c46a17e8a28$var$createFocusScopesStack();
function $d3863c46a17e8a28$var$createFocusScopesStack() {
  let stack = [];
  return {
    add(focusScope) {
      const activeFocusScope = stack[0];
      if (focusScope !== activeFocusScope) activeFocusScope === null || activeFocusScope === void 0 || activeFocusScope.pause();
      stack = $d3863c46a17e8a28$var$arrayRemove(stack, focusScope);
      stack.unshift(focusScope);
    },
    remove(focusScope) {
      var _stack$;
      stack = $d3863c46a17e8a28$var$arrayRemove(stack, focusScope);
      (_stack$ = stack[0]) === null || _stack$ === void 0 || _stack$.resume();
    }
  };
}
function $d3863c46a17e8a28$var$arrayRemove(array, item) {
  const updatedArray = [
    ...array
  ];
  const index2 = updatedArray.indexOf(item);
  if (index2 !== -1) updatedArray.splice(index2, 1);
  return updatedArray;
}
function $d3863c46a17e8a28$var$removeLinks(items) {
  return items.filter(
    (item) => item.tagName !== "A"
  );
}
const $9f79659886946c16$export$e5c5a5f917a5871c = Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) ? useLayoutEffect : () => {
};
const $1746a345f3d73bb7$var$useReactId = React["useId".toString()] || (() => void 0);
let $1746a345f3d73bb7$var$count = 0;
function $1746a345f3d73bb7$export$f680877a34711e37(deterministicId) {
  const [id, setId] = React.useState($1746a345f3d73bb7$var$useReactId());
  $9f79659886946c16$export$e5c5a5f917a5871c(() => {
    if (!deterministicId) setId(
      (reactId) => reactId !== null && reactId !== void 0 ? reactId : String($1746a345f3d73bb7$var$count++)
    );
  }, [
    deterministicId
  ]);
  return deterministicId || (id ? `radix-${id}` : "");
}
const sides = ["top", "right", "bottom", "left"];
const min = Math.min;
const max$1 = Math.max;
const round$2 = Math.round;
const floor = Math.floor;
const createCoords = (v2) => ({
  x: v2,
  y: v2
});
const oppositeSideMap = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
const oppositeAlignmentMap = {
  start: "end",
  end: "start"
};
function clamp(start, value, end) {
  return max$1(start, min(value, end));
}
function evaluate(value, param) {
  return typeof value === "function" ? value(param) : value;
}
function getSide(placement) {
  return placement.split("-")[0];
}
function getAlignment(placement) {
  return placement.split("-")[1];
}
function getOppositeAxis(axis) {
  return axis === "x" ? "y" : "x";
}
function getAxisLength(axis) {
  return axis === "y" ? "height" : "width";
}
function getSideAxis(placement) {
  return ["top", "bottom"].includes(getSide(placement)) ? "y" : "x";
}
function getAlignmentAxis(placement) {
  return getOppositeAxis(getSideAxis(placement));
}
function getAlignmentSides(placement, rects, rtl) {
  if (rtl === void 0) {
    rtl = false;
  }
  const alignment = getAlignment(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const length2 = getAxisLength(alignmentAxis);
  let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
  if (rects.reference[length2] > rects.floating[length2]) {
    mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
  }
  return [mainAlignmentSide, getOppositePlacement(mainAlignmentSide)];
}
function getExpandedPlacements(placement) {
  const oppositePlacement = getOppositePlacement(placement);
  return [getOppositeAlignmentPlacement(placement), oppositePlacement, getOppositeAlignmentPlacement(oppositePlacement)];
}
function getOppositeAlignmentPlacement(placement) {
  return placement.replace(/start|end/g, (alignment) => oppositeAlignmentMap[alignment]);
}
function getSideList(side, isStart, rtl) {
  const lr = ["left", "right"];
  const rl = ["right", "left"];
  const tb = ["top", "bottom"];
  const bt = ["bottom", "top"];
  switch (side) {
    case "top":
    case "bottom":
      if (rtl) return isStart ? rl : lr;
      return isStart ? lr : rl;
    case "left":
    case "right":
      return isStart ? tb : bt;
    default:
      return [];
  }
}
function getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
  const alignment = getAlignment(placement);
  let list = getSideList(getSide(placement), direction === "start", rtl);
  if (alignment) {
    list = list.map((side) => side + "-" + alignment);
    if (flipAlignment) {
      list = list.concat(list.map(getOppositeAlignmentPlacement));
    }
  }
  return list;
}
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, (side) => oppositeSideMap[side]);
}
function expandPaddingObject(padding) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...padding
  };
}
function getPaddingObject(padding) {
  return typeof padding !== "number" ? expandPaddingObject(padding) : {
    top: padding,
    right: padding,
    bottom: padding,
    left: padding
  };
}
function rectToClientRect(rect) {
  return {
    ...rect,
    top: rect.y,
    left: rect.x,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  };
}
function computeCoordsFromPlacement(_ref3, placement, rtl) {
  let {
    reference,
    floating
  } = _ref3;
  const sideAxis = getSideAxis(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const alignLength = getAxisLength(alignmentAxis);
  const side = getSide(placement);
  const isVertical = sideAxis === "y";
  const commonX = reference.x + reference.width / 2 - floating.width / 2;
  const commonY = reference.y + reference.height / 2 - floating.height / 2;
  const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
  let coords;
  switch (side) {
    case "top":
      coords = {
        x: commonX,
        y: reference.y - floating.height
      };
      break;
    case "bottom":
      coords = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;
    case "right":
      coords = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;
    case "left":
      coords = {
        x: reference.x - floating.width,
        y: commonY
      };
      break;
    default:
      coords = {
        x: reference.x,
        y: reference.y
      };
  }
  switch (getAlignment(placement)) {
    case "start":
      coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
      break;
    case "end":
      coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
      break;
  }
  return coords;
}
const computePosition$1 = async (reference, floating, config2) => {
  const {
    placement = "bottom",
    strategy = "absolute",
    middleware: middleware2 = [],
    platform: platform2
  } = config2;
  const validMiddleware = middleware2.filter(Boolean);
  const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(floating));
  let rects = await platform2.getElementRects({
    reference,
    floating,
    strategy
  });
  let {
    x: x2,
    y: y2
  } = computeCoordsFromPlacement(rects, placement, rtl);
  let statefulPlacement = placement;
  let middlewareData = {};
  let resetCount = 0;
  for (let i = 0; i < validMiddleware.length; i++) {
    const {
      name,
      fn
    } = validMiddleware[i];
    const {
      x: nextX,
      y: nextY,
      data: data2,
      reset
    } = await fn({
      x: x2,
      y: y2,
      initialPlacement: placement,
      placement: statefulPlacement,
      strategy,
      middlewareData,
      rects,
      platform: platform2,
      elements: {
        reference,
        floating
      }
    });
    x2 = nextX != null ? nextX : x2;
    y2 = nextY != null ? nextY : y2;
    middlewareData = {
      ...middlewareData,
      [name]: {
        ...middlewareData[name],
        ...data2
      }
    };
    if (reset && resetCount <= 50) {
      resetCount++;
      if (typeof reset === "object") {
        if (reset.placement) {
          statefulPlacement = reset.placement;
        }
        if (reset.rects) {
          rects = reset.rects === true ? await platform2.getElementRects({
            reference,
            floating,
            strategy
          }) : reset.rects;
        }
        ({
          x: x2,
          y: y2
        } = computeCoordsFromPlacement(rects, statefulPlacement, rtl));
      }
      i = -1;
    }
  }
  return {
    x: x2,
    y: y2,
    placement: statefulPlacement,
    strategy,
    middlewareData
  };
};
async function detectOverflow(state, options2) {
  var _await$platform$isEle;
  if (options2 === void 0) {
    options2 = {};
  }
  const {
    x: x2,
    y: y2,
    platform: platform2,
    rects,
    elements: elements2,
    strategy
  } = state;
  const {
    boundary = "clippingAncestors",
    rootBoundary = "viewport",
    elementContext = "floating",
    altBoundary = false,
    padding = 0
  } = evaluate(options2, state);
  const paddingObject = getPaddingObject(padding);
  const altContext = elementContext === "floating" ? "reference" : "floating";
  const element = elements2[altBoundary ? altContext : elementContext];
  const clippingClientRect = rectToClientRect(await platform2.getClippingRect({
    element: ((_await$platform$isEle = await (platform2.isElement == null ? void 0 : platform2.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform2.getDocumentElement == null ? void 0 : platform2.getDocumentElement(elements2.floating)),
    boundary,
    rootBoundary,
    strategy
  }));
  const rect = elementContext === "floating" ? {
    ...rects.floating,
    x: x2,
    y: y2
  } : rects.reference;
  const offsetParent = await (platform2.getOffsetParent == null ? void 0 : platform2.getOffsetParent(elements2.floating));
  const offsetScale = await (platform2.isElement == null ? void 0 : platform2.isElement(offsetParent)) ? await (platform2.getScale == null ? void 0 : platform2.getScale(offsetParent)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  };
  const elementClientRect = rectToClientRect(platform2.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform2.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: elements2,
    rect,
    offsetParent,
    strategy
  }) : rect);
  return {
    top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
    bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
    left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
    right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
  };
}
const arrow$2 = (options2) => ({
  name: "arrow",
  options: options2,
  async fn(state) {
    const {
      x: x2,
      y: y2,
      placement,
      rects,
      platform: platform2,
      elements: elements2,
      middlewareData
    } = state;
    const {
      element,
      padding = 0
    } = evaluate(options2, state) || {};
    if (element == null) {
      return {};
    }
    const paddingObject = getPaddingObject(padding);
    const coords = {
      x: x2,
      y: y2
    };
    const axis = getAlignmentAxis(placement);
    const length2 = getAxisLength(axis);
    const arrowDimensions = await platform2.getDimensions(element);
    const isYAxis = axis === "y";
    const minProp = isYAxis ? "top" : "left";
    const maxProp = isYAxis ? "bottom" : "right";
    const clientProp = isYAxis ? "clientHeight" : "clientWidth";
    const endDiff = rects.reference[length2] + rects.reference[axis] - coords[axis] - rects.floating[length2];
    const startDiff = coords[axis] - rects.reference[axis];
    const arrowOffsetParent = await (platform2.getOffsetParent == null ? void 0 : platform2.getOffsetParent(element));
    let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
    if (!clientSize || !await (platform2.isElement == null ? void 0 : platform2.isElement(arrowOffsetParent))) {
      clientSize = elements2.floating[clientProp] || rects.floating[length2];
    }
    const centerToReference = endDiff / 2 - startDiff / 2;
    const largestPossiblePadding = clientSize / 2 - arrowDimensions[length2] / 2 - 1;
    const minPadding = min(paddingObject[minProp], largestPossiblePadding);
    const maxPadding = min(paddingObject[maxProp], largestPossiblePadding);
    const min$1 = minPadding;
    const max2 = clientSize - arrowDimensions[length2] - maxPadding;
    const center = clientSize / 2 - arrowDimensions[length2] / 2 + centerToReference;
    const offset2 = clamp(min$1, center, max2);
    const shouldAddOffset = !middlewareData.arrow && getAlignment(placement) != null && center !== offset2 && rects.reference[length2] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length2] / 2 < 0;
    const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max2 : 0;
    return {
      [axis]: coords[axis] + alignmentOffset,
      data: {
        [axis]: offset2,
        centerOffset: center - offset2 - alignmentOffset,
        ...shouldAddOffset && {
          alignmentOffset
        }
      },
      reset: shouldAddOffset
    };
  }
});
const flip$1 = function(options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  return {
    name: "flip",
    options: options2,
    async fn(state) {
      var _middlewareData$arrow, _middlewareData$flip;
      const {
        placement,
        middlewareData,
        rects,
        initialPlacement,
        platform: platform2,
        elements: elements2
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true,
        fallbackPlacements: specifiedFallbackPlacements,
        fallbackStrategy = "bestFit",
        fallbackAxisSideDirection = "none",
        flipAlignment = true,
        ...detectOverflowOptions
      } = evaluate(options2, state);
      if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      const side = getSide(placement);
      const isBasePlacement = getSide(initialPlacement) === initialPlacement;
      const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements2.floating));
      const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [getOppositePlacement(initialPlacement)] : getExpandedPlacements(initialPlacement));
      if (!specifiedFallbackPlacements && fallbackAxisSideDirection !== "none") {
        fallbackPlacements.push(...getOppositeAxisPlacements(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
      }
      const placements = [initialPlacement, ...fallbackPlacements];
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const overflows = [];
      let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
      if (checkMainAxis) {
        overflows.push(overflow[side]);
      }
      if (checkCrossAxis) {
        const sides2 = getAlignmentSides(placement, rects, rtl);
        overflows.push(overflow[sides2[0]], overflow[sides2[1]]);
      }
      overflowsData = [...overflowsData, {
        placement,
        overflows
      }];
      if (!overflows.every((side2) => side2 <= 0)) {
        var _middlewareData$flip2, _overflowsData$filter;
        const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
        const nextPlacement = placements[nextIndex];
        if (nextPlacement) {
          return {
            data: {
              index: nextIndex,
              overflows: overflowsData
            },
            reset: {
              placement: nextPlacement
            }
          };
        }
        let resetPlacement = (_overflowsData$filter = overflowsData.filter((d2) => d2.overflows[0] <= 0).sort((a2, b2) => a2.overflows[1] - b2.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
        if (!resetPlacement) {
          switch (fallbackStrategy) {
            case "bestFit": {
              var _overflowsData$map$so;
              const placement2 = (_overflowsData$map$so = overflowsData.map((d2) => [d2.placement, d2.overflows.filter((overflow2) => overflow2 > 0).reduce((acc, overflow2) => acc + overflow2, 0)]).sort((a2, b2) => a2[1] - b2[1])[0]) == null ? void 0 : _overflowsData$map$so[0];
              if (placement2) {
                resetPlacement = placement2;
              }
              break;
            }
            case "initialPlacement":
              resetPlacement = initialPlacement;
              break;
          }
        }
        if (placement !== resetPlacement) {
          return {
            reset: {
              placement: resetPlacement
            }
          };
        }
      }
      return {};
    }
  };
};
function getSideOffsets(overflow, rect) {
  return {
    top: overflow.top - rect.height,
    right: overflow.right - rect.width,
    bottom: overflow.bottom - rect.height,
    left: overflow.left - rect.width
  };
}
function isAnySideFullyClipped(overflow) {
  return sides.some((side) => overflow[side] >= 0);
}
const hide$1 = function(options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  return {
    name: "hide",
    options: options2,
    async fn(state) {
      const {
        rects
      } = state;
      const {
        strategy = "referenceHidden",
        ...detectOverflowOptions
      } = evaluate(options2, state);
      switch (strategy) {
        case "referenceHidden": {
          const overflow = await detectOverflow(state, {
            ...detectOverflowOptions,
            elementContext: "reference"
          });
          const offsets = getSideOffsets(overflow, rects.reference);
          return {
            data: {
              referenceHiddenOffsets: offsets,
              referenceHidden: isAnySideFullyClipped(offsets)
            }
          };
        }
        case "escaped": {
          const overflow = await detectOverflow(state, {
            ...detectOverflowOptions,
            altBoundary: true
          });
          const offsets = getSideOffsets(overflow, rects.floating);
          return {
            data: {
              escapedOffsets: offsets,
              escaped: isAnySideFullyClipped(offsets)
            }
          };
        }
        default: {
          return {};
        }
      }
    }
  };
};
async function convertValueToCoords(state, options2) {
  const {
    placement,
    platform: platform2,
    elements: elements2
  } = state;
  const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements2.floating));
  const side = getSide(placement);
  const alignment = getAlignment(placement);
  const isVertical = getSideAxis(placement) === "y";
  const mainAxisMulti = ["left", "top"].includes(side) ? -1 : 1;
  const crossAxisMulti = rtl && isVertical ? -1 : 1;
  const rawValue = evaluate(options2, state);
  let {
    mainAxis,
    crossAxis,
    alignmentAxis
  } = typeof rawValue === "number" ? {
    mainAxis: rawValue,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...rawValue
  };
  if (alignment && typeof alignmentAxis === "number") {
    crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
  }
  return isVertical ? {
    x: crossAxis * crossAxisMulti,
    y: mainAxis * mainAxisMulti
  } : {
    x: mainAxis * mainAxisMulti,
    y: crossAxis * crossAxisMulti
  };
}
const offset$1 = function(options2) {
  if (options2 === void 0) {
    options2 = 0;
  }
  return {
    name: "offset",
    options: options2,
    async fn(state) {
      var _middlewareData$offse, _middlewareData$arrow;
      const {
        x: x2,
        y: y2,
        placement,
        middlewareData
      } = state;
      const diffCoords = await convertValueToCoords(state, options2);
      if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      return {
        x: x2 + diffCoords.x,
        y: y2 + diffCoords.y,
        data: {
          ...diffCoords,
          placement
        }
      };
    }
  };
};
const shift$1 = function(options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  return {
    name: "shift",
    options: options2,
    async fn(state) {
      const {
        x: x2,
        y: y2,
        placement
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = false,
        limiter = {
          fn: (_ref3) => {
            let {
              x: x3,
              y: y3
            } = _ref3;
            return {
              x: x3,
              y: y3
            };
          }
        },
        ...detectOverflowOptions
      } = evaluate(options2, state);
      const coords = {
        x: x2,
        y: y2
      };
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const crossAxis = getSideAxis(getSide(placement));
      const mainAxis = getOppositeAxis(crossAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];
      if (checkMainAxis) {
        const minSide = mainAxis === "y" ? "top" : "left";
        const maxSide = mainAxis === "y" ? "bottom" : "right";
        const min2 = mainAxisCoord + overflow[minSide];
        const max2 = mainAxisCoord - overflow[maxSide];
        mainAxisCoord = clamp(min2, mainAxisCoord, max2);
      }
      if (checkCrossAxis) {
        const minSide = crossAxis === "y" ? "top" : "left";
        const maxSide = crossAxis === "y" ? "bottom" : "right";
        const min2 = crossAxisCoord + overflow[minSide];
        const max2 = crossAxisCoord - overflow[maxSide];
        crossAxisCoord = clamp(min2, crossAxisCoord, max2);
      }
      const limitedCoords = limiter.fn({
        ...state,
        [mainAxis]: mainAxisCoord,
        [crossAxis]: crossAxisCoord
      });
      return {
        ...limitedCoords,
        data: {
          x: limitedCoords.x - x2,
          y: limitedCoords.y - y2
        }
      };
    }
  };
};
const limitShift$1 = function(options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  return {
    options: options2,
    fn(state) {
      const {
        x: x2,
        y: y2,
        placement,
        rects,
        middlewareData
      } = state;
      const {
        offset: offset2 = 0,
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true
      } = evaluate(options2, state);
      const coords = {
        x: x2,
        y: y2
      };
      const crossAxis = getSideAxis(placement);
      const mainAxis = getOppositeAxis(crossAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];
      const rawOffset = evaluate(offset2, state);
      const computedOffset = typeof rawOffset === "number" ? {
        mainAxis: rawOffset,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...rawOffset
      };
      if (checkMainAxis) {
        const len = mainAxis === "y" ? "height" : "width";
        const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
        const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
        if (mainAxisCoord < limitMin) {
          mainAxisCoord = limitMin;
        } else if (mainAxisCoord > limitMax) {
          mainAxisCoord = limitMax;
        }
      }
      if (checkCrossAxis) {
        var _middlewareData$offse, _middlewareData$offse2;
        const len = mainAxis === "y" ? "width" : "height";
        const isOriginSide = ["top", "left"].includes(getSide(placement));
        const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
        const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
        if (crossAxisCoord < limitMin) {
          crossAxisCoord = limitMin;
        } else if (crossAxisCoord > limitMax) {
          crossAxisCoord = limitMax;
        }
      }
      return {
        [mainAxis]: mainAxisCoord,
        [crossAxis]: crossAxisCoord
      };
    }
  };
};
const size$1 = function(options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  return {
    name: "size",
    options: options2,
    async fn(state) {
      const {
        placement,
        rects,
        platform: platform2,
        elements: elements2
      } = state;
      const {
        apply = () => {
        },
        ...detectOverflowOptions
      } = evaluate(options2, state);
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const side = getSide(placement);
      const alignment = getAlignment(placement);
      const isYAxis = getSideAxis(placement) === "y";
      const {
        width,
        height: height2
      } = rects.floating;
      let heightSide;
      let widthSide;
      if (side === "top" || side === "bottom") {
        heightSide = side;
        widthSide = alignment === (await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements2.floating)) ? "start" : "end") ? "left" : "right";
      } else {
        widthSide = side;
        heightSide = alignment === "end" ? "top" : "bottom";
      }
      const overflowAvailableHeight = height2 - overflow[heightSide];
      const overflowAvailableWidth = width - overflow[widthSide];
      const noShift = !state.middlewareData.shift;
      let availableHeight = overflowAvailableHeight;
      let availableWidth = overflowAvailableWidth;
      if (isYAxis) {
        const maximumClippingWidth = width - overflow.left - overflow.right;
        availableWidth = alignment || noShift ? min(overflowAvailableWidth, maximumClippingWidth) : maximumClippingWidth;
      } else {
        const maximumClippingHeight = height2 - overflow.top - overflow.bottom;
        availableHeight = alignment || noShift ? min(overflowAvailableHeight, maximumClippingHeight) : maximumClippingHeight;
      }
      if (noShift && !alignment) {
        const xMin = max$1(overflow.left, 0);
        const xMax = max$1(overflow.right, 0);
        const yMin = max$1(overflow.top, 0);
        const yMax = max$1(overflow.bottom, 0);
        if (isYAxis) {
          availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : max$1(overflow.left, overflow.right));
        } else {
          availableHeight = height2 - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : max$1(overflow.top, overflow.bottom));
        }
      }
      await apply({
        ...state,
        availableWidth,
        availableHeight
      });
      const nextDimensions = await platform2.getDimensions(elements2.floating);
      if (width !== nextDimensions.width || height2 !== nextDimensions.height) {
        return {
          reset: {
            rects: true
          }
        };
      }
      return {};
    }
  };
};
function getNodeName(node2) {
  if (isNode(node2)) {
    return (node2.nodeName || "").toLowerCase();
  }
  return "#document";
}
function getWindow(node2) {
  var _node$ownerDocument;
  return (node2 == null || (_node$ownerDocument = node2.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function getDocumentElement(node2) {
  var _ref3;
  return (_ref3 = (isNode(node2) ? node2.ownerDocument : node2.document) || window.document) == null ? void 0 : _ref3.documentElement;
}
function isNode(value) {
  return value instanceof Node || value instanceof getWindow(value).Node;
}
function isElement(value) {
  return value instanceof Element || value instanceof getWindow(value).Element;
}
function isHTMLElement(value) {
  return value instanceof HTMLElement || value instanceof getWindow(value).HTMLElement;
}
function isShadowRoot(value) {
  if (typeof ShadowRoot === "undefined") {
    return false;
  }
  return value instanceof ShadowRoot || value instanceof getWindow(value).ShadowRoot;
}
function isOverflowElement(element) {
  const {
    overflow,
    overflowX,
    overflowY,
    display: display2
  } = getComputedStyle$2(element);
  return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && !["inline", "contents"].includes(display2);
}
function isTableElement(element) {
  return ["table", "td", "th"].includes(getNodeName(element));
}
function isContainingBlock(element) {
  const webkit = isWebKit();
  const css4 = getComputedStyle$2(element);
  return css4.transform !== "none" || css4.perspective !== "none" || (css4.containerType ? css4.containerType !== "normal" : false) || !webkit && (css4.backdropFilter ? css4.backdropFilter !== "none" : false) || !webkit && (css4.filter ? css4.filter !== "none" : false) || ["transform", "perspective", "filter"].some((value) => (css4.willChange || "").includes(value)) || ["paint", "layout", "strict", "content"].some((value) => (css4.contain || "").includes(value));
}
function getContainingBlock(element) {
  let currentNode = getParentNode(element);
  while (isHTMLElement(currentNode) && !isLastTraversableNode(currentNode)) {
    if (isContainingBlock(currentNode)) {
      return currentNode;
    } else {
      currentNode = getParentNode(currentNode);
    }
  }
  return null;
}
function isWebKit() {
  if (typeof CSS === "undefined" || !CSS.supports) return false;
  return CSS.supports("-webkit-backdrop-filter", "none");
}
function isLastTraversableNode(node2) {
  return ["html", "body", "#document"].includes(getNodeName(node2));
}
function getComputedStyle$2(element) {
  return getWindow(element).getComputedStyle(element);
}
function getNodeScroll(element) {
  if (isElement(element)) {
    return {
      scrollLeft: element.scrollLeft,
      scrollTop: element.scrollTop
    };
  }
  return {
    scrollLeft: element.pageXOffset,
    scrollTop: element.pageYOffset
  };
}
function getParentNode(node2) {
  if (getNodeName(node2) === "html") {
    return node2;
  }
  const result = (
    // Step into the shadow DOM of the parent of a slotted node.
    node2.assignedSlot || // DOM Element detected.
    node2.parentNode || // ShadowRoot detected.
    isShadowRoot(node2) && node2.host || // Fallback.
    getDocumentElement(node2)
  );
  return isShadowRoot(result) ? result.host : result;
}
function getNearestOverflowAncestor(node2) {
  const parentNode = getParentNode(node2);
  if (isLastTraversableNode(parentNode)) {
    return node2.ownerDocument ? node2.ownerDocument.body : node2.body;
  }
  if (isHTMLElement(parentNode) && isOverflowElement(parentNode)) {
    return parentNode;
  }
  return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node2, list, traverseIframes) {
  var _node$ownerDocument2;
  if (list === void 0) {
    list = [];
  }
  if (traverseIframes === void 0) {
    traverseIframes = true;
  }
  const scrollableAncestor = getNearestOverflowAncestor(node2);
  const isBody = scrollableAncestor === ((_node$ownerDocument2 = node2.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
  const win2 = getWindow(scrollableAncestor);
  if (isBody) {
    return list.concat(win2, win2.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], win2.frameElement && traverseIframes ? getOverflowAncestors(win2.frameElement) : []);
  }
  return list.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor, [], traverseIframes));
}
function getCssDimensions(element) {
  const css4 = getComputedStyle$2(element);
  let width = parseFloat(css4.width) || 0;
  let height2 = parseFloat(css4.height) || 0;
  const hasOffset = isHTMLElement(element);
  const offsetWidth = hasOffset ? element.offsetWidth : width;
  const offsetHeight = hasOffset ? element.offsetHeight : height2;
  const shouldFallback = round$2(width) !== offsetWidth || round$2(height2) !== offsetHeight;
  if (shouldFallback) {
    width = offsetWidth;
    height2 = offsetHeight;
  }
  return {
    width,
    height: height2,
    $: shouldFallback
  };
}
function unwrapElement(element) {
  return !isElement(element) ? element.contextElement : element;
}
function getScale$1(element) {
  const domElement = unwrapElement(element);
  if (!isHTMLElement(domElement)) {
    return createCoords(1);
  }
  const rect = domElement.getBoundingClientRect();
  const {
    width,
    height: height2,
    $: $2
  } = getCssDimensions(domElement);
  let x2 = ($2 ? round$2(rect.width) : rect.width) / width;
  let y2 = ($2 ? round$2(rect.height) : rect.height) / height2;
  if (!x2 || !Number.isFinite(x2)) {
    x2 = 1;
  }
  if (!y2 || !Number.isFinite(y2)) {
    y2 = 1;
  }
  return {
    x: x2,
    y: y2
  };
}
const noOffsets = /* @__PURE__ */ createCoords(0);
function getVisualOffsets(element) {
  const win2 = getWindow(element);
  if (!isWebKit() || !win2.visualViewport) {
    return noOffsets;
  }
  return {
    x: win2.visualViewport.offsetLeft,
    y: win2.visualViewport.offsetTop
  };
}
function shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  if (!floatingOffsetParent || isFixed && floatingOffsetParent !== getWindow(element)) {
    return false;
  }
  return isFixed;
}
function getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  const clientRect = element.getBoundingClientRect();
  const domElement = unwrapElement(element);
  let scale2 = createCoords(1);
  if (includeScale) {
    if (offsetParent) {
      if (isElement(offsetParent)) {
        scale2 = getScale$1(offsetParent);
      }
    } else {
      scale2 = getScale$1(element);
    }
  }
  const visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? getVisualOffsets(domElement) : createCoords(0);
  let x2 = (clientRect.left + visualOffsets.x) / scale2.x;
  let y2 = (clientRect.top + visualOffsets.y) / scale2.y;
  let width = clientRect.width / scale2.x;
  let height2 = clientRect.height / scale2.y;
  if (domElement) {
    const win2 = getWindow(domElement);
    const offsetWin = offsetParent && isElement(offsetParent) ? getWindow(offsetParent) : offsetParent;
    let currentWin = win2;
    let currentIFrame = currentWin.frameElement;
    while (currentIFrame && offsetParent && offsetWin !== currentWin) {
      const iframeScale = getScale$1(currentIFrame);
      const iframeRect = currentIFrame.getBoundingClientRect();
      const css4 = getComputedStyle$2(currentIFrame);
      const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css4.paddingLeft)) * iframeScale.x;
      const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css4.paddingTop)) * iframeScale.y;
      x2 *= iframeScale.x;
      y2 *= iframeScale.y;
      width *= iframeScale.x;
      height2 *= iframeScale.y;
      x2 += left;
      y2 += top;
      currentWin = getWindow(currentIFrame);
      currentIFrame = currentWin.frameElement;
    }
  }
  return rectToClientRect({
    width,
    height: height2,
    x: x2,
    y: y2
  });
}
const topLayerSelectors = [":popover-open", ":modal"];
function isTopLayer(floating) {
  return topLayerSelectors.some((selector) => {
    try {
      return floating.matches(selector);
    } catch (e2) {
      return false;
    }
  });
}
function convertOffsetParentRelativeRectToViewportRelativeRect(_ref3) {
  let {
    elements: elements2,
    rect,
    offsetParent,
    strategy
  } = _ref3;
  const isFixed = strategy === "fixed";
  const documentElement = getDocumentElement(offsetParent);
  const topLayer = elements2 ? isTopLayer(elements2.floating) : false;
  if (offsetParent === documentElement || topLayer && isFixed) {
    return rect;
  }
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  let scale2 = createCoords(1);
  const offsets = createCoords(0);
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== "body" || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement(offsetParent)) {
      const offsetRect = getBoundingClientRect(offsetParent);
      scale2 = getScale$1(offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    }
  }
  return {
    width: rect.width * scale2.x,
    height: rect.height * scale2.y,
    x: rect.x * scale2.x - scroll.scrollLeft * scale2.x + offsets.x,
    y: rect.y * scale2.y - scroll.scrollTop * scale2.y + offsets.y
  };
}
function getClientRects(element) {
  return Array.from(element.getClientRects());
}
function getWindowScrollBarX(element) {
  return getBoundingClientRect(getDocumentElement(element)).left + getNodeScroll(element).scrollLeft;
}
function getDocumentRect(element) {
  const html = getDocumentElement(element);
  const scroll = getNodeScroll(element);
  const body = element.ownerDocument.body;
  const width = max$1(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
  const height2 = max$1(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
  let x2 = -scroll.scrollLeft + getWindowScrollBarX(element);
  const y2 = -scroll.scrollTop;
  if (getComputedStyle$2(body).direction === "rtl") {
    x2 += max$1(html.clientWidth, body.clientWidth) - width;
  }
  return {
    width,
    height: height2,
    x: x2,
    y: y2
  };
}
function getViewportRect(element, strategy) {
  const win2 = getWindow(element);
  const html = getDocumentElement(element);
  const visualViewport = win2.visualViewport;
  let width = html.clientWidth;
  let height2 = html.clientHeight;
  let x2 = 0;
  let y2 = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height2 = visualViewport.height;
    const visualViewportBased = isWebKit();
    if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
      x2 = visualViewport.offsetLeft;
      y2 = visualViewport.offsetTop;
    }
  }
  return {
    width,
    height: height2,
    x: x2,
    y: y2
  };
}
function getInnerBoundingClientRect(element, strategy) {
  const clientRect = getBoundingClientRect(element, true, strategy === "fixed");
  const top = clientRect.top + element.clientTop;
  const left = clientRect.left + element.clientLeft;
  const scale2 = isHTMLElement(element) ? getScale$1(element) : createCoords(1);
  const width = element.clientWidth * scale2.x;
  const height2 = element.clientHeight * scale2.y;
  const x2 = left * scale2.x;
  const y2 = top * scale2.y;
  return {
    width,
    height: height2,
    x: x2,
    y: y2
  };
}
function getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
  let rect;
  if (clippingAncestor === "viewport") {
    rect = getViewportRect(element, strategy);
  } else if (clippingAncestor === "document") {
    rect = getDocumentRect(getDocumentElement(element));
  } else if (isElement(clippingAncestor)) {
    rect = getInnerBoundingClientRect(clippingAncestor, strategy);
  } else {
    const visualOffsets = getVisualOffsets(element);
    rect = {
      ...clippingAncestor,
      x: clippingAncestor.x - visualOffsets.x,
      y: clippingAncestor.y - visualOffsets.y
    };
  }
  return rectToClientRect(rect);
}
function hasFixedPositionAncestor(element, stopNode) {
  const parentNode = getParentNode(element);
  if (parentNode === stopNode || !isElement(parentNode) || isLastTraversableNode(parentNode)) {
    return false;
  }
  return getComputedStyle$2(parentNode).position === "fixed" || hasFixedPositionAncestor(parentNode, stopNode);
}
function getClippingElementAncestors(element, cache) {
  const cachedResult = cache.get(element);
  if (cachedResult) {
    return cachedResult;
  }
  let result = getOverflowAncestors(element, [], false).filter((el) => isElement(el) && getNodeName(el) !== "body");
  let currentContainingBlockComputedStyle = null;
  const elementIsFixed = getComputedStyle$2(element).position === "fixed";
  let currentNode = elementIsFixed ? getParentNode(element) : element;
  while (isElement(currentNode) && !isLastTraversableNode(currentNode)) {
    const computedStyle = getComputedStyle$2(currentNode);
    const currentNodeIsContaining = isContainingBlock(currentNode);
    if (!currentNodeIsContaining && computedStyle.position === "fixed") {
      currentContainingBlockComputedStyle = null;
    }
    const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && ["absolute", "fixed"].includes(currentContainingBlockComputedStyle.position) || isOverflowElement(currentNode) && !currentNodeIsContaining && hasFixedPositionAncestor(element, currentNode);
    if (shouldDropCurrentNode) {
      result = result.filter((ancestor) => ancestor !== currentNode);
    } else {
      currentContainingBlockComputedStyle = computedStyle;
    }
    currentNode = getParentNode(currentNode);
  }
  cache.set(element, result);
  return result;
}
function getClippingRect(_ref3) {
  let {
    element,
    boundary,
    rootBoundary,
    strategy
  } = _ref3;
  const elementClippingAncestors = boundary === "clippingAncestors" ? getClippingElementAncestors(element, this._c) : [].concat(boundary);
  const clippingAncestors = [...elementClippingAncestors, rootBoundary];
  const firstClippingAncestor = clippingAncestors[0];
  const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor) => {
    const rect = getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
    accRect.top = max$1(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max$1(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
  return {
    width: clippingRect.right - clippingRect.left,
    height: clippingRect.bottom - clippingRect.top,
    x: clippingRect.left,
    y: clippingRect.top
  };
}
function getDimensions(element) {
  const {
    width,
    height: height2
  } = getCssDimensions(element);
  return {
    width,
    height: height2
  };
}
function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  const documentElement = getDocumentElement(offsetParent);
  const isFixed = strategy === "fixed";
  const rect = getBoundingClientRect(element, true, isFixed, offsetParent);
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const offsets = createCoords(0);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== "body" || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isOffsetParentAnElement) {
      const offsetRect = getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }
  const x2 = rect.left + scroll.scrollLeft - offsets.x;
  const y2 = rect.top + scroll.scrollTop - offsets.y;
  return {
    x: x2,
    y: y2,
    width: rect.width,
    height: rect.height
  };
}
function getTrueOffsetParent(element, polyfill) {
  if (!isHTMLElement(element) || getComputedStyle$2(element).position === "fixed") {
    return null;
  }
  if (polyfill) {
    return polyfill(element);
  }
  return element.offsetParent;
}
function getOffsetParent(element, polyfill) {
  const window2 = getWindow(element);
  if (!isHTMLElement(element) || isTopLayer(element)) {
    return window2;
  }
  let offsetParent = getTrueOffsetParent(element, polyfill);
  while (offsetParent && isTableElement(offsetParent) && getComputedStyle$2(offsetParent).position === "static") {
    offsetParent = getTrueOffsetParent(offsetParent, polyfill);
  }
  if (offsetParent && (getNodeName(offsetParent) === "html" || getNodeName(offsetParent) === "body" && getComputedStyle$2(offsetParent).position === "static" && !isContainingBlock(offsetParent))) {
    return window2;
  }
  return offsetParent || getContainingBlock(element) || window2;
}
const getElementRects = async function(data2) {
  const getOffsetParentFn = this.getOffsetParent || getOffsetParent;
  const getDimensionsFn = this.getDimensions;
  return {
    reference: getRectRelativeToOffsetParent(data2.reference, await getOffsetParentFn(data2.floating), data2.strategy),
    floating: {
      x: 0,
      y: 0,
      ...await getDimensionsFn(data2.floating)
    }
  };
};
function isRTL(element) {
  return getComputedStyle$2(element).direction === "rtl";
}
const platform = {
  convertOffsetParentRelativeRectToViewportRelativeRect,
  getDocumentElement,
  getClippingRect,
  getOffsetParent,
  getElementRects,
  getClientRects,
  getDimensions,
  getScale: getScale$1,
  isElement,
  isRTL
};
function observeMove(element, onMove) {
  let io = null;
  let timeoutId;
  const root = getDocumentElement(element);
  function cleanup() {
    var _io;
    clearTimeout(timeoutId);
    (_io = io) == null || _io.disconnect();
    io = null;
  }
  function refresh(skip2, threshold) {
    if (skip2 === void 0) {
      skip2 = false;
    }
    if (threshold === void 0) {
      threshold = 1;
    }
    cleanup();
    const {
      left,
      top,
      width,
      height: height2
    } = element.getBoundingClientRect();
    if (!skip2) {
      onMove();
    }
    if (!width || !height2) {
      return;
    }
    const insetTop = floor(top);
    const insetRight = floor(root.clientWidth - (left + width));
    const insetBottom = floor(root.clientHeight - (top + height2));
    const insetLeft = floor(left);
    const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
    const options2 = {
      rootMargin,
      threshold: max$1(0, min(1, threshold)) || 1
    };
    let isFirstUpdate = true;
    function handleObserve(entries) {
      const ratio = entries[0].intersectionRatio;
      if (ratio !== threshold) {
        if (!isFirstUpdate) {
          return refresh();
        }
        if (!ratio) {
          timeoutId = setTimeout(() => {
            refresh(false, 1e-7);
          }, 100);
        } else {
          refresh(false, ratio);
        }
      }
      isFirstUpdate = false;
    }
    try {
      io = new IntersectionObserver(handleObserve, {
        ...options2,
        // Handle <iframe>s
        root: root.ownerDocument
      });
    } catch (e2) {
      io = new IntersectionObserver(handleObserve, options2);
    }
    io.observe(element);
  }
  refresh(true);
  return cleanup;
}
function autoUpdate(reference, floating, update, options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  const {
    ancestorScroll = true,
    ancestorResize = true,
    elementResize = typeof ResizeObserver === "function",
    layoutShift = typeof IntersectionObserver === "function",
    animationFrame = false
  } = options2;
  const referenceEl = unwrapElement(reference);
  const ancestors = ancestorScroll || ancestorResize ? [...referenceEl ? getOverflowAncestors(referenceEl) : [], ...getOverflowAncestors(floating)] : [];
  ancestors.forEach((ancestor) => {
    ancestorScroll && ancestor.addEventListener("scroll", update, {
      passive: true
    });
    ancestorResize && ancestor.addEventListener("resize", update);
  });
  const cleanupIo = referenceEl && layoutShift ? observeMove(referenceEl, update) : null;
  let reobserveFrame = -1;
  let resizeObserver = null;
  if (elementResize) {
    resizeObserver = new ResizeObserver((_ref3) => {
      let [firstEntry] = _ref3;
      if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
        resizeObserver.unobserve(floating);
        cancelAnimationFrame(reobserveFrame);
        reobserveFrame = requestAnimationFrame(() => {
          var _resizeObserver;
          (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
        });
      }
      update();
    });
    if (referenceEl && !animationFrame) {
      resizeObserver.observe(referenceEl);
    }
    resizeObserver.observe(floating);
  }
  let frameId;
  let prevRefRect = animationFrame ? getBoundingClientRect(reference) : null;
  if (animationFrame) {
    frameLoop();
  }
  function frameLoop() {
    const nextRefRect = getBoundingClientRect(reference);
    if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) {
      update();
    }
    prevRefRect = nextRefRect;
    frameId = requestAnimationFrame(frameLoop);
  }
  update();
  return () => {
    var _resizeObserver2;
    ancestors.forEach((ancestor) => {
      ancestorScroll && ancestor.removeEventListener("scroll", update);
      ancestorResize && ancestor.removeEventListener("resize", update);
    });
    cleanupIo == null || cleanupIo();
    (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
    resizeObserver = null;
    if (animationFrame) {
      cancelAnimationFrame(frameId);
    }
  };
}
const shift = shift$1;
const flip = flip$1;
const size = size$1;
const hide = hide$1;
const arrow$1 = arrow$2;
const limitShift = limitShift$1;
const computePosition = (reference, floating, options2) => {
  const cache = /* @__PURE__ */ new Map();
  const mergedOptions = {
    platform,
    ...options2
  };
  const platformWithCache = {
    ...mergedOptions.platform,
    _c: cache
  };
  return computePosition$1(reference, floating, {
    ...mergedOptions,
    platform: platformWithCache
  });
};
const arrow = (options2) => {
  function isRef(value) {
    return {}.hasOwnProperty.call(value, "current");
  }
  return {
    name: "arrow",
    options: options2,
    fn(state) {
      const {
        element,
        padding
      } = typeof options2 === "function" ? options2(state) : options2;
      if (element && isRef(element)) {
        if (element.current != null) {
          return arrow$1({
            element: element.current,
            padding
          }).fn(state);
        }
        return {};
      }
      if (element) {
        return arrow$1({
          element,
          padding
        }).fn(state);
      }
      return {};
    }
  };
};
var index$4 = typeof document !== "undefined" ? useLayoutEffect : useEffect;
function deepEqual(a2, b2) {
  if (a2 === b2) {
    return true;
  }
  if (typeof a2 !== typeof b2) {
    return false;
  }
  if (typeof a2 === "function" && a2.toString() === b2.toString()) {
    return true;
  }
  let length2;
  let i;
  let keys;
  if (a2 && b2 && typeof a2 === "object") {
    if (Array.isArray(a2)) {
      length2 = a2.length;
      if (length2 !== b2.length) return false;
      for (i = length2; i-- !== 0; ) {
        if (!deepEqual(a2[i], b2[i])) {
          return false;
        }
      }
      return true;
    }
    keys = Object.keys(a2);
    length2 = keys.length;
    if (length2 !== Object.keys(b2).length) {
      return false;
    }
    for (i = length2; i-- !== 0; ) {
      if (!{}.hasOwnProperty.call(b2, keys[i])) {
        return false;
      }
    }
    for (i = length2; i-- !== 0; ) {
      const key = keys[i];
      if (key === "_owner" && a2.$$typeof) {
        continue;
      }
      if (!deepEqual(a2[key], b2[key])) {
        return false;
      }
    }
    return true;
  }
  return a2 !== a2 && b2 !== b2;
}
function getDPR(element) {
  if (typeof window === "undefined") {
    return 1;
  }
  const win2 = element.ownerDocument.defaultView || window;
  return win2.devicePixelRatio || 1;
}
function roundByDPR(element, value) {
  const dpr = getDPR(element);
  return Math.round(value * dpr) / dpr;
}
function useLatestRef(value) {
  const ref = React.useRef(value);
  index$4(() => {
    ref.current = value;
  });
  return ref;
}
function useFloating(options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  const {
    placement = "bottom",
    strategy = "absolute",
    middleware: middleware2 = [],
    platform: platform2,
    elements: {
      reference: externalReference,
      floating: externalFloating
    } = {},
    transform = true,
    whileElementsMounted,
    open
  } = options2;
  const [data2, setData] = React.useState({
    x: 0,
    y: 0,
    strategy,
    placement,
    middlewareData: {},
    isPositioned: false
  });
  const [latestMiddleware, setLatestMiddleware] = React.useState(middleware2);
  if (!deepEqual(latestMiddleware, middleware2)) {
    setLatestMiddleware(middleware2);
  }
  const [_reference, _setReference] = React.useState(null);
  const [_floating, _setFloating] = React.useState(null);
  const setReference = React.useCallback((node2) => {
    if (node2 !== referenceRef.current) {
      referenceRef.current = node2;
      _setReference(node2);
    }
  }, []);
  const setFloating = React.useCallback((node2) => {
    if (node2 !== floatingRef.current) {
      floatingRef.current = node2;
      _setFloating(node2);
    }
  }, []);
  const referenceEl = externalReference || _reference;
  const floatingEl = externalFloating || _floating;
  const referenceRef = React.useRef(null);
  const floatingRef = React.useRef(null);
  const dataRef = React.useRef(data2);
  const hasWhileElementsMounted = whileElementsMounted != null;
  const whileElementsMountedRef = useLatestRef(whileElementsMounted);
  const platformRef = useLatestRef(platform2);
  const update = React.useCallback(() => {
    if (!referenceRef.current || !floatingRef.current) {
      return;
    }
    const config2 = {
      placement,
      strategy,
      middleware: latestMiddleware
    };
    if (platformRef.current) {
      config2.platform = platformRef.current;
    }
    computePosition(referenceRef.current, floatingRef.current, config2).then((data3) => {
      const fullData = {
        ...data3,
        isPositioned: true
      };
      if (isMountedRef.current && !deepEqual(dataRef.current, fullData)) {
        dataRef.current = fullData;
        ReactDOM.flushSync(() => {
          setData(fullData);
        });
      }
    });
  }, [latestMiddleware, placement, strategy, platformRef]);
  index$4(() => {
    if (open === false && dataRef.current.isPositioned) {
      dataRef.current.isPositioned = false;
      setData((data3) => ({
        ...data3,
        isPositioned: false
      }));
    }
  }, [open]);
  const isMountedRef = React.useRef(false);
  index$4(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);
  index$4(() => {
    if (referenceEl) referenceRef.current = referenceEl;
    if (floatingEl) floatingRef.current = floatingEl;
    if (referenceEl && floatingEl) {
      if (whileElementsMountedRef.current) {
        return whileElementsMountedRef.current(referenceEl, floatingEl, update);
      }
      update();
    }
  }, [referenceEl, floatingEl, update, whileElementsMountedRef, hasWhileElementsMounted]);
  const refs = React.useMemo(() => ({
    reference: referenceRef,
    floating: floatingRef,
    setReference,
    setFloating
  }), [setReference, setFloating]);
  const elements2 = React.useMemo(() => ({
    reference: referenceEl,
    floating: floatingEl
  }), [referenceEl, floatingEl]);
  const floatingStyles = React.useMemo(() => {
    const initialStyles = {
      position: strategy,
      left: 0,
      top: 0
    };
    if (!elements2.floating) {
      return initialStyles;
    }
    const x2 = roundByDPR(elements2.floating, data2.x);
    const y2 = roundByDPR(elements2.floating, data2.y);
    if (transform) {
      return {
        ...initialStyles,
        transform: "translate(" + x2 + "px, " + y2 + "px)",
        ...getDPR(elements2.floating) >= 1.5 && {
          willChange: "transform"
        }
      };
    }
    return {
      position: strategy,
      left: x2,
      top: y2
    };
  }, [strategy, transform, elements2.floating, data2.x, data2.y]);
  return React.useMemo(() => ({
    ...data2,
    update,
    refs,
    elements: elements2,
    floatingStyles
  }), [data2, update, refs, elements2, floatingStyles]);
}
const $7e8f5cd07187803e$export$21b07c8f274aebd5 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { children, width = 10, height: height2 = 5, ...arrowProps } = props;
  return /* @__PURE__ */ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.svg, _extends$1({}, arrowProps, {
    ref: forwardedRef,
    width,
    height: height2,
    viewBox: "0 0 30 10",
    preserveAspectRatio: "none"
  }), props.asChild ? children : /* @__PURE__ */ createElement("polygon", {
    points: "0,0 30,0 15,10"
  }));
});
const $7e8f5cd07187803e$export$be92b6f5f03c0fe9 = $7e8f5cd07187803e$export$21b07c8f274aebd5;
function $db6c3485150b8e66$export$1ab7ae714698c4b8(element) {
  const [size2, setSize] = useState(void 0);
  $9f79659886946c16$export$e5c5a5f917a5871c(() => {
    if (element) {
      setSize({
        width: element.offsetWidth,
        height: element.offsetHeight
      });
      const resizeObserver = new ResizeObserver((entries) => {
        if (!Array.isArray(entries)) return;
        if (!entries.length) return;
        const entry = entries[0];
        let width;
        let height2;
        if ("borderBoxSize" in entry) {
          const borderSizeEntry = entry["borderBoxSize"];
          const borderSize = Array.isArray(borderSizeEntry) ? borderSizeEntry[0] : borderSizeEntry;
          width = borderSize["inlineSize"];
          height2 = borderSize["blockSize"];
        } else {
          width = element.offsetWidth;
          height2 = element.offsetHeight;
        }
        setSize({
          width,
          height: height2
        });
      });
      resizeObserver.observe(element, {
        box: "border-box"
      });
      return () => resizeObserver.unobserve(element);
    } else
      setSize(void 0);
  }, [
    element
  ]);
  return size2;
}
const $cf1ac5d9fe0e8206$var$POPPER_NAME = "Popper";
const [$cf1ac5d9fe0e8206$var$createPopperContext, $cf1ac5d9fe0e8206$export$722aac194ae923] = $c512c27ab02ef895$export$50c7b4e9d9f19c1($cf1ac5d9fe0e8206$var$POPPER_NAME);
const [$cf1ac5d9fe0e8206$var$PopperProvider, $cf1ac5d9fe0e8206$var$usePopperContext] = $cf1ac5d9fe0e8206$var$createPopperContext($cf1ac5d9fe0e8206$var$POPPER_NAME);
const $cf1ac5d9fe0e8206$export$badac9ada3a0bdf9 = (props) => {
  const { __scopePopper, children } = props;
  const [anchor, setAnchor] = useState(null);
  return /* @__PURE__ */ createElement($cf1ac5d9fe0e8206$var$PopperProvider, {
    scope: __scopePopper,
    anchor,
    onAnchorChange: setAnchor
  }, children);
};
const $cf1ac5d9fe0e8206$var$ANCHOR_NAME = "PopperAnchor";
const $cf1ac5d9fe0e8206$export$ecd4e1ccab6ed6d = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopePopper, virtualRef, ...anchorProps } = props;
  const context = $cf1ac5d9fe0e8206$var$usePopperContext($cf1ac5d9fe0e8206$var$ANCHOR_NAME, __scopePopper);
  const ref = useRef(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, ref);
  useEffect(() => {
    context.onAnchorChange((virtualRef === null || virtualRef === void 0 ? void 0 : virtualRef.current) || ref.current);
  });
  return virtualRef ? null : /* @__PURE__ */ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.div, _extends$1({}, anchorProps, {
    ref: composedRefs
  }));
});
const $cf1ac5d9fe0e8206$var$CONTENT_NAME = "PopperContent";
const [$cf1ac5d9fe0e8206$var$PopperContentProvider, $cf1ac5d9fe0e8206$var$useContentContext] = $cf1ac5d9fe0e8206$var$createPopperContext($cf1ac5d9fe0e8206$var$CONTENT_NAME);
const $cf1ac5d9fe0e8206$export$bc4ae5855d3c4fc = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  var _arrowSize$width, _arrowSize$height, _middlewareData$arrow, _middlewareData$arrow2, _middlewareData$arrow3, _middlewareData$trans, _middlewareData$trans2, _middlewareData$hide;
  const { __scopePopper, side = "bottom", sideOffset = 0, align = "center", alignOffset = 0, arrowPadding = 0, avoidCollisions = true, collisionBoundary = [], collisionPadding: collisionPaddingProp = 0, sticky = "partial", hideWhenDetached = false, updatePositionStrategy = "optimized", onPlaced, ...contentProps } = props;
  const context = $cf1ac5d9fe0e8206$var$usePopperContext($cf1ac5d9fe0e8206$var$CONTENT_NAME, __scopePopper);
  const [content, setContent] = useState(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(
    forwardedRef,
    (node2) => setContent(node2)
  );
  const [arrow$12, setArrow] = useState(null);
  const arrowSize = $db6c3485150b8e66$export$1ab7ae714698c4b8(arrow$12);
  const arrowWidth = (_arrowSize$width = arrowSize === null || arrowSize === void 0 ? void 0 : arrowSize.width) !== null && _arrowSize$width !== void 0 ? _arrowSize$width : 0;
  const arrowHeight = (_arrowSize$height = arrowSize === null || arrowSize === void 0 ? void 0 : arrowSize.height) !== null && _arrowSize$height !== void 0 ? _arrowSize$height : 0;
  const desiredPlacement = side + (align !== "center" ? "-" + align : "");
  const collisionPadding = typeof collisionPaddingProp === "number" ? collisionPaddingProp : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...collisionPaddingProp
  };
  const boundary = Array.isArray(collisionBoundary) ? collisionBoundary : [
    collisionBoundary
  ];
  const hasExplicitBoundaries = boundary.length > 0;
  const detectOverflowOptions = {
    padding: collisionPadding,
    boundary: boundary.filter($cf1ac5d9fe0e8206$var$isNotNull),
    // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
    altBoundary: hasExplicitBoundaries
  };
  const { refs, floatingStyles, placement, isPositioned, middlewareData } = useFloating({
    // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
    strategy: "fixed",
    placement: desiredPlacement,
    whileElementsMounted: (...args) => {
      const cleanup = autoUpdate(...args, {
        animationFrame: updatePositionStrategy === "always"
      });
      return cleanup;
    },
    elements: {
      reference: context.anchor
    },
    middleware: [
      offset$1({
        mainAxis: sideOffset + arrowHeight,
        alignmentAxis: alignOffset
      }),
      avoidCollisions && shift({
        mainAxis: true,
        crossAxis: false,
        limiter: sticky === "partial" ? limitShift() : void 0,
        ...detectOverflowOptions
      }),
      avoidCollisions && flip({
        ...detectOverflowOptions
      }),
      size({
        ...detectOverflowOptions,
        apply: ({ elements: elements2, rects, availableWidth, availableHeight }) => {
          const { width: anchorWidth, height: anchorHeight } = rects.reference;
          const contentStyle = elements2.floating.style;
          contentStyle.setProperty("--radix-popper-available-width", `${availableWidth}px`);
          contentStyle.setProperty("--radix-popper-available-height", `${availableHeight}px`);
          contentStyle.setProperty("--radix-popper-anchor-width", `${anchorWidth}px`);
          contentStyle.setProperty("--radix-popper-anchor-height", `${anchorHeight}px`);
        }
      }),
      arrow$12 && arrow({
        element: arrow$12,
        padding: arrowPadding
      }),
      $cf1ac5d9fe0e8206$var$transformOrigin({
        arrowWidth,
        arrowHeight
      }),
      hideWhenDetached && hide({
        strategy: "referenceHidden",
        ...detectOverflowOptions
      })
    ]
  });
  const [placedSide, placedAlign] = $cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement);
  const handlePlaced = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onPlaced);
  $9f79659886946c16$export$e5c5a5f917a5871c(() => {
    if (isPositioned) handlePlaced === null || handlePlaced === void 0 || handlePlaced();
  }, [
    isPositioned,
    handlePlaced
  ]);
  const arrowX = (_middlewareData$arrow = middlewareData.arrow) === null || _middlewareData$arrow === void 0 ? void 0 : _middlewareData$arrow.x;
  const arrowY = (_middlewareData$arrow2 = middlewareData.arrow) === null || _middlewareData$arrow2 === void 0 ? void 0 : _middlewareData$arrow2.y;
  const cannotCenterArrow = ((_middlewareData$arrow3 = middlewareData.arrow) === null || _middlewareData$arrow3 === void 0 ? void 0 : _middlewareData$arrow3.centerOffset) !== 0;
  const [contentZIndex, setContentZIndex] = useState();
  $9f79659886946c16$export$e5c5a5f917a5871c(() => {
    if (content) setContentZIndex(window.getComputedStyle(content).zIndex);
  }, [
    content
  ]);
  return /* @__PURE__ */ createElement("div", {
    ref: refs.setFloating,
    "data-radix-popper-content-wrapper": "",
    style: {
      ...floatingStyles,
      transform: isPositioned ? floatingStyles.transform : "translate(0, -200%)",
      // keep off the page when measuring
      minWidth: "max-content",
      zIndex: contentZIndex,
      ["--radix-popper-transform-origin"]: [
        (_middlewareData$trans = middlewareData.transformOrigin) === null || _middlewareData$trans === void 0 ? void 0 : _middlewareData$trans.x,
        (_middlewareData$trans2 = middlewareData.transformOrigin) === null || _middlewareData$trans2 === void 0 ? void 0 : _middlewareData$trans2.y
      ].join(" ")
    },
    dir: props.dir
  }, /* @__PURE__ */ createElement($cf1ac5d9fe0e8206$var$PopperContentProvider, {
    scope: __scopePopper,
    placedSide,
    onArrowChange: setArrow,
    arrowX,
    arrowY,
    shouldHideArrow: cannotCenterArrow
  }, /* @__PURE__ */ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.div, _extends$1({
    "data-side": placedSide,
    "data-align": placedAlign
  }, contentProps, {
    ref: composedRefs,
    style: {
      ...contentProps.style,
      // if the PopperContent hasn't been placed yet (not all measurements done)
      // we prevent animations so that users's animation don't kick in too early referring wrong sides
      animation: !isPositioned ? "none" : void 0,
      // hide the content if using the hide middleware and should be hidden
      opacity: (_middlewareData$hide = middlewareData.hide) !== null && _middlewareData$hide !== void 0 && _middlewareData$hide.referenceHidden ? 0 : void 0
    }
  }))));
});
const $cf1ac5d9fe0e8206$var$ARROW_NAME = "PopperArrow";
const $cf1ac5d9fe0e8206$var$OPPOSITE_SIDE = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
};
const $cf1ac5d9fe0e8206$export$79d62cd4e10a3fd0 = /* @__PURE__ */ forwardRef(function $cf1ac5d9fe0e8206$export$79d62cd4e10a3fd02(props, forwardedRef) {
  const { __scopePopper, ...arrowProps } = props;
  const contentContext = $cf1ac5d9fe0e8206$var$useContentContext($cf1ac5d9fe0e8206$var$ARROW_NAME, __scopePopper);
  const baseSide = $cf1ac5d9fe0e8206$var$OPPOSITE_SIDE[contentContext.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ createElement("span", {
      ref: contentContext.onArrowChange,
      style: {
        position: "absolute",
        left: contentContext.arrowX,
        top: contentContext.arrowY,
        [baseSide]: 0,
        transformOrigin: {
          top: "",
          right: "0 0",
          bottom: "center 0",
          left: "100% 0"
        }[contentContext.placedSide],
        transform: {
          top: "translateY(100%)",
          right: "translateY(50%) rotate(90deg) translateX(-50%)",
          bottom: `rotate(180deg)`,
          left: "translateY(50%) rotate(-90deg) translateX(50%)"
        }[contentContext.placedSide],
        visibility: contentContext.shouldHideArrow ? "hidden" : void 0
      }
    }, /* @__PURE__ */ createElement($7e8f5cd07187803e$export$be92b6f5f03c0fe9, _extends$1({}, arrowProps, {
      ref: forwardedRef,
      style: {
        ...arrowProps.style,
        // ensures the element can be measured correctly (mostly for if SVG)
        display: "block"
      }
    })))
  );
});
/* @__PURE__ */ Object.assign($cf1ac5d9fe0e8206$export$79d62cd4e10a3fd0, {
  displayName: $cf1ac5d9fe0e8206$var$ARROW_NAME
});
function $cf1ac5d9fe0e8206$var$isNotNull(value) {
  return value !== null;
}
const $cf1ac5d9fe0e8206$var$transformOrigin = (options2) => ({
  name: "transformOrigin",
  options: options2,
  fn(data2) {
    var _middlewareData$arrow4, _middlewareData$arrow5, _middlewareData$arrow6, _middlewareData$arrow7, _middlewareData$arrow8;
    const { placement, rects, middlewareData } = data2;
    const cannotCenterArrow = ((_middlewareData$arrow4 = middlewareData.arrow) === null || _middlewareData$arrow4 === void 0 ? void 0 : _middlewareData$arrow4.centerOffset) !== 0;
    const isArrowHidden = cannotCenterArrow;
    const arrowWidth = isArrowHidden ? 0 : options2.arrowWidth;
    const arrowHeight = isArrowHidden ? 0 : options2.arrowHeight;
    const [placedSide, placedAlign] = $cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement);
    const noArrowAlign = {
      start: "0%",
      center: "50%",
      end: "100%"
    }[placedAlign];
    const arrowXCenter = ((_middlewareData$arrow5 = (_middlewareData$arrow6 = middlewareData.arrow) === null || _middlewareData$arrow6 === void 0 ? void 0 : _middlewareData$arrow6.x) !== null && _middlewareData$arrow5 !== void 0 ? _middlewareData$arrow5 : 0) + arrowWidth / 2;
    const arrowYCenter = ((_middlewareData$arrow7 = (_middlewareData$arrow8 = middlewareData.arrow) === null || _middlewareData$arrow8 === void 0 ? void 0 : _middlewareData$arrow8.y) !== null && _middlewareData$arrow7 !== void 0 ? _middlewareData$arrow7 : 0) + arrowHeight / 2;
    let x2 = "";
    let y2 = "";
    if (placedSide === "bottom") {
      x2 = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
      y2 = `${-arrowHeight}px`;
    } else if (placedSide === "top") {
      x2 = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
      y2 = `${rects.floating.height + arrowHeight}px`;
    } else if (placedSide === "right") {
      x2 = `${-arrowHeight}px`;
      y2 = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
    } else if (placedSide === "left") {
      x2 = `${rects.floating.width + arrowHeight}px`;
      y2 = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
    }
    return {
      data: {
        x: x2,
        y: y2
      }
    };
  }
});
function $cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement) {
  const [side, align = "center"] = placement.split("-");
  return [
    side,
    align
  ];
}
const $cf1ac5d9fe0e8206$export$be92b6f5f03c0fe9 = $cf1ac5d9fe0e8206$export$badac9ada3a0bdf9;
const $cf1ac5d9fe0e8206$export$b688253958b8dfe7 = $cf1ac5d9fe0e8206$export$ecd4e1ccab6ed6d;
const $cf1ac5d9fe0e8206$export$7c6e2c02157bb7d2 = $cf1ac5d9fe0e8206$export$bc4ae5855d3c4fc;
const $cf1ac5d9fe0e8206$export$21b07c8f274aebd5 = $cf1ac5d9fe0e8206$export$79d62cd4e10a3fd0;
const $f1701beae083dbae$export$602eac185826482c = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  var _globalThis$document;
  const { container = globalThis === null || globalThis === void 0 ? void 0 : (_globalThis$document = globalThis.document) === null || _globalThis$document === void 0 ? void 0 : _globalThis$document.body, ...portalProps } = props;
  return container ? /* @__PURE__ */ ReactDOM__default.createPortal(/* @__PURE__ */ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.div, _extends$1({}, portalProps, {
    ref: forwardedRef
  })), container) : null;
});
function $fe963b355347cc68$export$3e6543de14f8614f(initialState, machine) {
  return useReducer((state, event) => {
    const nextState = machine[state][event];
    return nextState !== null && nextState !== void 0 ? nextState : state;
  }, initialState);
}
const $921a889cee6df7e8$export$99c2b779aa4e8b8b = (props) => {
  const { present, children } = props;
  const presence = $921a889cee6df7e8$var$usePresence(present);
  const child = typeof children === "function" ? children({
    present: presence.isPresent
  }) : Children.only(children);
  const ref = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(presence.ref, child.ref);
  const forceMount = typeof children === "function";
  return forceMount || presence.isPresent ? /* @__PURE__ */ cloneElement(child, {
    ref
  }) : null;
};
$921a889cee6df7e8$export$99c2b779aa4e8b8b.displayName = "Presence";
function $921a889cee6df7e8$var$usePresence(present) {
  const [node1, setNode] = useState();
  const stylesRef = useRef({});
  const prevPresentRef = useRef(present);
  const prevAnimationNameRef = useRef("none");
  const initialState = present ? "mounted" : "unmounted";
  const [state, send] = $fe963b355347cc68$export$3e6543de14f8614f(initialState, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  useEffect(() => {
    const currentAnimationName = $921a889cee6df7e8$var$getAnimationName(stylesRef.current);
    prevAnimationNameRef.current = state === "mounted" ? currentAnimationName : "none";
  }, [
    state
  ]);
  $9f79659886946c16$export$e5c5a5f917a5871c(() => {
    const styles = stylesRef.current;
    const wasPresent = prevPresentRef.current;
    const hasPresentChanged = wasPresent !== present;
    if (hasPresentChanged) {
      const prevAnimationName = prevAnimationNameRef.current;
      const currentAnimationName = $921a889cee6df7e8$var$getAnimationName(styles);
      if (present) send("MOUNT");
      else if (currentAnimationName === "none" || (styles === null || styles === void 0 ? void 0 : styles.display) === "none")
        send("UNMOUNT");
      else {
        const isAnimating = prevAnimationName !== currentAnimationName;
        if (wasPresent && isAnimating) send("ANIMATION_OUT");
        else send("UNMOUNT");
      }
      prevPresentRef.current = present;
    }
  }, [
    present,
    send
  ]);
  $9f79659886946c16$export$e5c5a5f917a5871c(() => {
    if (node1) {
      const handleAnimationEnd = (event) => {
        const currentAnimationName = $921a889cee6df7e8$var$getAnimationName(stylesRef.current);
        const isCurrentAnimation = currentAnimationName.includes(event.animationName);
        if (event.target === node1 && isCurrentAnimation)
          flushSync(
            () => send("ANIMATION_END")
          );
      };
      const handleAnimationStart = (event) => {
        if (event.target === node1)
          prevAnimationNameRef.current = $921a889cee6df7e8$var$getAnimationName(stylesRef.current);
      };
      node1.addEventListener("animationstart", handleAnimationStart);
      node1.addEventListener("animationcancel", handleAnimationEnd);
      node1.addEventListener("animationend", handleAnimationEnd);
      return () => {
        node1.removeEventListener("animationstart", handleAnimationStart);
        node1.removeEventListener("animationcancel", handleAnimationEnd);
        node1.removeEventListener("animationend", handleAnimationEnd);
      };
    } else
      send("ANIMATION_END");
  }, [
    node1,
    send
  ]);
  return {
    isPresent: [
      "mounted",
      "unmountSuspended"
    ].includes(state),
    ref: useCallback((node2) => {
      if (node2) stylesRef.current = getComputedStyle(node2);
      setNode(node2);
    }, [])
  };
}
function $921a889cee6df7e8$var$getAnimationName(styles) {
  return (styles === null || styles === void 0 ? void 0 : styles.animationName) || "none";
}
const $d7bdfb9eb0fdf311$var$ENTRY_FOCUS = "rovingFocusGroup.onEntryFocus";
const $d7bdfb9eb0fdf311$var$EVENT_OPTIONS = {
  bubbles: false,
  cancelable: true
};
const $d7bdfb9eb0fdf311$var$GROUP_NAME = "RovingFocusGroup";
const [$d7bdfb9eb0fdf311$var$Collection, $d7bdfb9eb0fdf311$var$useCollection, $d7bdfb9eb0fdf311$var$createCollectionScope] = $e02a7d9cb1dc128c$export$c74125a8e3af6bb2($d7bdfb9eb0fdf311$var$GROUP_NAME);
const [$d7bdfb9eb0fdf311$var$createRovingFocusGroupContext, $d7bdfb9eb0fdf311$export$c7109489551a4f4] = $c512c27ab02ef895$export$50c7b4e9d9f19c1($d7bdfb9eb0fdf311$var$GROUP_NAME, [
  $d7bdfb9eb0fdf311$var$createCollectionScope
]);
const [$d7bdfb9eb0fdf311$var$RovingFocusProvider, $d7bdfb9eb0fdf311$var$useRovingFocusContext] = $d7bdfb9eb0fdf311$var$createRovingFocusGroupContext($d7bdfb9eb0fdf311$var$GROUP_NAME);
const $d7bdfb9eb0fdf311$export$8699f7c8af148338 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  return /* @__PURE__ */ createElement($d7bdfb9eb0fdf311$var$Collection.Provider, {
    scope: props.__scopeRovingFocusGroup
  }, /* @__PURE__ */ createElement($d7bdfb9eb0fdf311$var$Collection.Slot, {
    scope: props.__scopeRovingFocusGroup
  }, /* @__PURE__ */ createElement($d7bdfb9eb0fdf311$var$RovingFocusGroupImpl, _extends$1({}, props, {
    ref: forwardedRef
  }))));
});
const $d7bdfb9eb0fdf311$var$RovingFocusGroupImpl = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeRovingFocusGroup, orientation, loop = false, dir, currentTabStopId: currentTabStopIdProp, defaultCurrentTabStopId, onCurrentTabStopIdChange, onEntryFocus, ...groupProps } = props;
  const ref = useRef(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, ref);
  const direction = $f631663db3294ace$export$b39126d51d94e6f3(dir);
  const [currentTabStopId = null, setCurrentTabStopId] = $71cd76cc60e0454e$export$6f32135080cb4c3({
    prop: currentTabStopIdProp,
    defaultProp: defaultCurrentTabStopId,
    onChange: onCurrentTabStopIdChange
  });
  const [isTabbingBackOut, setIsTabbingBackOut] = useState(false);
  const handleEntryFocus = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onEntryFocus);
  const getItems = $d7bdfb9eb0fdf311$var$useCollection(__scopeRovingFocusGroup);
  const isClickFocusRef = useRef(false);
  const [focusableItemsCount, setFocusableItemsCount] = useState(0);
  useEffect(() => {
    const node2 = ref.current;
    if (node2) {
      node2.addEventListener($d7bdfb9eb0fdf311$var$ENTRY_FOCUS, handleEntryFocus);
      return () => node2.removeEventListener($d7bdfb9eb0fdf311$var$ENTRY_FOCUS, handleEntryFocus);
    }
  }, [
    handleEntryFocus
  ]);
  return /* @__PURE__ */ createElement($d7bdfb9eb0fdf311$var$RovingFocusProvider, {
    scope: __scopeRovingFocusGroup,
    orientation,
    dir: direction,
    loop,
    currentTabStopId,
    onItemFocus: useCallback(
      (tabStopId) => setCurrentTabStopId(tabStopId),
      [
        setCurrentTabStopId
      ]
    ),
    onItemShiftTab: useCallback(
      () => setIsTabbingBackOut(true),
      []
    ),
    onFocusableItemAdd: useCallback(
      () => setFocusableItemsCount(
        (prevCount) => prevCount + 1
      ),
      []
    ),
    onFocusableItemRemove: useCallback(
      () => setFocusableItemsCount(
        (prevCount) => prevCount - 1
      ),
      []
    )
  }, /* @__PURE__ */ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.div, _extends$1({
    tabIndex: isTabbingBackOut || focusableItemsCount === 0 ? -1 : 0,
    "data-orientation": orientation
  }, groupProps, {
    ref: composedRefs,
    style: {
      outline: "none",
      ...props.style
    },
    onMouseDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onMouseDown, () => {
      isClickFocusRef.current = true;
    }),
    onFocus: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onFocus, (event) => {
      const isKeyboardFocus = !isClickFocusRef.current;
      if (event.target === event.currentTarget && isKeyboardFocus && !isTabbingBackOut) {
        const entryFocusEvent = new CustomEvent($d7bdfb9eb0fdf311$var$ENTRY_FOCUS, $d7bdfb9eb0fdf311$var$EVENT_OPTIONS);
        event.currentTarget.dispatchEvent(entryFocusEvent);
        if (!entryFocusEvent.defaultPrevented) {
          const items = getItems().filter(
            (item) => item.focusable
          );
          const activeItem = items.find(
            (item) => item.active
          );
          const currentItem = items.find(
            (item) => item.id === currentTabStopId
          );
          const candidateItems = [
            activeItem,
            currentItem,
            ...items
          ].filter(Boolean);
          const candidateNodes = candidateItems.map(
            (item) => item.ref.current
          );
          $d7bdfb9eb0fdf311$var$focusFirst(candidateNodes);
        }
      }
      isClickFocusRef.current = false;
    }),
    onBlur: $e42e1063c40fb3ef$export$b9ecd428b558ff10(
      props.onBlur,
      () => setIsTabbingBackOut(false)
    )
  })));
});
const $d7bdfb9eb0fdf311$var$ITEM_NAME = "RovingFocusGroupItem";
const $d7bdfb9eb0fdf311$export$ab9df7c53fe8454 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeRovingFocusGroup, focusable = true, active: active2 = false, tabStopId, ...itemProps } = props;
  const autoId = $1746a345f3d73bb7$export$f680877a34711e37();
  const id = tabStopId || autoId;
  const context = $d7bdfb9eb0fdf311$var$useRovingFocusContext($d7bdfb9eb0fdf311$var$ITEM_NAME, __scopeRovingFocusGroup);
  const isCurrentTabStop = context.currentTabStopId === id;
  const getItems = $d7bdfb9eb0fdf311$var$useCollection(__scopeRovingFocusGroup);
  const { onFocusableItemAdd, onFocusableItemRemove } = context;
  useEffect(() => {
    if (focusable) {
      onFocusableItemAdd();
      return () => onFocusableItemRemove();
    }
  }, [
    focusable,
    onFocusableItemAdd,
    onFocusableItemRemove
  ]);
  return /* @__PURE__ */ createElement($d7bdfb9eb0fdf311$var$Collection.ItemSlot, {
    scope: __scopeRovingFocusGroup,
    id,
    focusable,
    active: active2
  }, /* @__PURE__ */ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.span, _extends$1({
    tabIndex: isCurrentTabStop ? 0 : -1,
    "data-orientation": context.orientation
  }, itemProps, {
    ref: forwardedRef,
    onMouseDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onMouseDown, (event) => {
      if (!focusable) event.preventDefault();
      else context.onItemFocus(id);
    }),
    onFocus: $e42e1063c40fb3ef$export$b9ecd428b558ff10(
      props.onFocus,
      () => context.onItemFocus(id)
    ),
    onKeyDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onKeyDown, (event) => {
      if (event.key === "Tab" && event.shiftKey) {
        context.onItemShiftTab();
        return;
      }
      if (event.target !== event.currentTarget) return;
      const focusIntent = $d7bdfb9eb0fdf311$var$getFocusIntent(event, context.orientation, context.dir);
      if (focusIntent !== void 0) {
        event.preventDefault();
        const items = getItems().filter(
          (item) => item.focusable
        );
        let candidateNodes = items.map(
          (item) => item.ref.current
        );
        if (focusIntent === "last") candidateNodes.reverse();
        else if (focusIntent === "prev" || focusIntent === "next") {
          if (focusIntent === "prev") candidateNodes.reverse();
          const currentIndex = candidateNodes.indexOf(event.currentTarget);
          candidateNodes = context.loop ? $d7bdfb9eb0fdf311$var$wrapArray(candidateNodes, currentIndex + 1) : candidateNodes.slice(currentIndex + 1);
        }
        setTimeout(
          () => $d7bdfb9eb0fdf311$var$focusFirst(candidateNodes)
        );
      }
    })
  })));
});
const $d7bdfb9eb0fdf311$var$MAP_KEY_TO_FOCUS_INTENT = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function $d7bdfb9eb0fdf311$var$getDirectionAwareKey(key, dir) {
  if (dir !== "rtl") return key;
  return key === "ArrowLeft" ? "ArrowRight" : key === "ArrowRight" ? "ArrowLeft" : key;
}
function $d7bdfb9eb0fdf311$var$getFocusIntent(event, orientation, dir) {
  const key = $d7bdfb9eb0fdf311$var$getDirectionAwareKey(event.key, dir);
  if (orientation === "vertical" && [
    "ArrowLeft",
    "ArrowRight"
  ].includes(key)) return void 0;
  if (orientation === "horizontal" && [
    "ArrowUp",
    "ArrowDown"
  ].includes(key)) return void 0;
  return $d7bdfb9eb0fdf311$var$MAP_KEY_TO_FOCUS_INTENT[key];
}
function $d7bdfb9eb0fdf311$var$focusFirst(candidates) {
  const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
  for (const candidate of candidates) {
    if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
    candidate.focus();
    if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
  }
}
function $d7bdfb9eb0fdf311$var$wrapArray(array, startIndex) {
  return array.map(
    (_2, index2) => array[(startIndex + index2) % array.length]
  );
}
const $d7bdfb9eb0fdf311$export$be92b6f5f03c0fe9 = $d7bdfb9eb0fdf311$export$8699f7c8af148338;
const $d7bdfb9eb0fdf311$export$6d08773d2e66f8f2 = $d7bdfb9eb0fdf311$export$ab9df7c53fe8454;
var getDefaultParent = function(originalTarget) {
  if (typeof document === "undefined") {
    return null;
  }
  var sampleTarget = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
  return sampleTarget.ownerDocument.body;
};
var counterMap = /* @__PURE__ */ new WeakMap();
var uncontrolledNodes = /* @__PURE__ */ new WeakMap();
var markerMap = {};
var lockCount = 0;
var unwrapHost = function(node2) {
  return node2 && (node2.host || unwrapHost(node2.parentNode));
};
var correctTargets = function(parent, targets) {
  return targets.map(function(target) {
    if (parent.contains(target)) {
      return target;
    }
    var correctedTarget = unwrapHost(target);
    if (correctedTarget && parent.contains(correctedTarget)) {
      return correctedTarget;
    }
    console.error("aria-hidden", target, "in not contained inside", parent, ". Doing nothing");
    return null;
  }).filter(function(x2) {
    return Boolean(x2);
  });
};
var applyAttributeToOthers = function(originalTarget, parentNode, markerName, controlAttribute) {
  var targets = correctTargets(parentNode, Array.isArray(originalTarget) ? originalTarget : [originalTarget]);
  if (!markerMap[markerName]) {
    markerMap[markerName] = /* @__PURE__ */ new WeakMap();
  }
  var markerCounter = markerMap[markerName];
  var hiddenNodes = [];
  var elementsToKeep = /* @__PURE__ */ new Set();
  var elementsToStop = new Set(targets);
  var keep = function(el) {
    if (!el || elementsToKeep.has(el)) {
      return;
    }
    elementsToKeep.add(el);
    keep(el.parentNode);
  };
  targets.forEach(keep);
  var deep = function(parent) {
    if (!parent || elementsToStop.has(parent)) {
      return;
    }
    Array.prototype.forEach.call(parent.children, function(node2) {
      if (elementsToKeep.has(node2)) {
        deep(node2);
      } else {
        try {
          var attr = node2.getAttribute(controlAttribute);
          var alreadyHidden = attr !== null && attr !== "false";
          var counterValue = (counterMap.get(node2) || 0) + 1;
          var markerValue = (markerCounter.get(node2) || 0) + 1;
          counterMap.set(node2, counterValue);
          markerCounter.set(node2, markerValue);
          hiddenNodes.push(node2);
          if (counterValue === 1 && alreadyHidden) {
            uncontrolledNodes.set(node2, true);
          }
          if (markerValue === 1) {
            node2.setAttribute(markerName, "true");
          }
          if (!alreadyHidden) {
            node2.setAttribute(controlAttribute, "true");
          }
        } catch (e2) {
          console.error("aria-hidden: cannot operate on ", node2, e2);
        }
      }
    });
  };
  deep(parentNode);
  elementsToKeep.clear();
  lockCount++;
  return function() {
    hiddenNodes.forEach(function(node2) {
      var counterValue = counterMap.get(node2) - 1;
      var markerValue = markerCounter.get(node2) - 1;
      counterMap.set(node2, counterValue);
      markerCounter.set(node2, markerValue);
      if (!counterValue) {
        if (!uncontrolledNodes.has(node2)) {
          node2.removeAttribute(controlAttribute);
        }
        uncontrolledNodes.delete(node2);
      }
      if (!markerValue) {
        node2.removeAttribute(markerName);
      }
    });
    lockCount--;
    if (!lockCount) {
      counterMap = /* @__PURE__ */ new WeakMap();
      counterMap = /* @__PURE__ */ new WeakMap();
      uncontrolledNodes = /* @__PURE__ */ new WeakMap();
      markerMap = {};
    }
  };
};
var hideOthers = function(originalTarget, parentNode, markerName) {
  if (markerName === void 0) {
    markerName = "data-aria-hidden";
  }
  var targets = Array.from(Array.isArray(originalTarget) ? originalTarget : [originalTarget]);
  var activeParentNode = parentNode || getDefaultParent(originalTarget);
  if (!activeParentNode) {
    return function() {
      return null;
    };
  }
  targets.push.apply(targets, Array.from(activeParentNode.querySelectorAll("[aria-live]")));
  return applyAttributeToOthers(targets, activeParentNode, markerName, "aria-hidden");
};
var __assign$1 = function() {
  __assign$1 = Object.assign || function __assign2(t2) {
    for (var s2, i = 1, n2 = arguments.length; i < n2; i++) {
      s2 = arguments[i];
      for (var p2 in s2) if (Object.prototype.hasOwnProperty.call(s2, p2)) t2[p2] = s2[p2];
    }
    return t2;
  };
  return __assign$1.apply(this, arguments);
};
function __rest$1(s2, e2) {
  var t2 = {};
  for (var p2 in s2) if (Object.prototype.hasOwnProperty.call(s2, p2) && e2.indexOf(p2) < 0)
    t2[p2] = s2[p2];
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p2 = Object.getOwnPropertySymbols(s2); i < p2.length; i++) {
      if (e2.indexOf(p2[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i]))
        t2[p2[i]] = s2[p2[i]];
    }
  return t2;
}
function __spreadArray(to2, from2, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l2 = from2.length, ar; i < l2; i++) {
    if (ar || !(i in from2)) {
      if (!ar) ar = Array.prototype.slice.call(from2, 0, i);
      ar[i] = from2[i];
    }
  }
  return to2.concat(ar || Array.prototype.slice.call(from2));
}
typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message2) {
  var e2 = new Error(message2);
  return e2.name = "SuppressedError", e2.error = error, e2.suppressed = suppressed, e2;
};
var zeroRightClassName = "right-scroll-bar-position";
var fullWidthClassName = "width-before-scroll-bar";
var noScrollbarsClassName = "with-scroll-bars-hidden";
var removedBarSizeVariable = "--removed-body-scroll-bar-size";
function assignRef(ref, value) {
  if (typeof ref === "function") {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
  return ref;
}
function useCallbackRef(initialValue, callback2) {
  var ref = useState(function() {
    return {
      // value
      value: initialValue,
      // last callback
      callback: callback2,
      // "memoized" public interface
      facade: {
        get current() {
          return ref.value;
        },
        set current(value) {
          var last2 = ref.value;
          if (last2 !== value) {
            ref.value = value;
            ref.callback(value, last2);
          }
        }
      }
    };
  })[0];
  ref.callback = callback2;
  return ref.facade;
}
var useIsomorphicLayoutEffect = typeof window !== "undefined" ? React.useLayoutEffect : React.useEffect;
var currentValues = /* @__PURE__ */ new WeakMap();
function useMergeRefs(refs, defaultValue) {
  var callbackRef = useCallbackRef(defaultValue || null, function(newValue) {
    return refs.forEach(function(ref) {
      return assignRef(ref, newValue);
    });
  });
  useIsomorphicLayoutEffect(function() {
    var oldValue = currentValues.get(callbackRef);
    if (oldValue) {
      var prevRefs_1 = new Set(oldValue);
      var nextRefs_1 = new Set(refs);
      var current_1 = callbackRef.current;
      prevRefs_1.forEach(function(ref) {
        if (!nextRefs_1.has(ref)) {
          assignRef(ref, null);
        }
      });
      nextRefs_1.forEach(function(ref) {
        if (!prevRefs_1.has(ref)) {
          assignRef(ref, current_1);
        }
      });
    }
    currentValues.set(callbackRef, refs);
  }, [refs]);
  return callbackRef;
}
var __assign = function() {
  __assign = Object.assign || function __assign2(t2) {
    for (var s2, i = 1, n2 = arguments.length; i < n2; i++) {
      s2 = arguments[i];
      for (var p2 in s2) if (Object.prototype.hasOwnProperty.call(s2, p2)) t2[p2] = s2[p2];
    }
    return t2;
  };
  return __assign.apply(this, arguments);
};
function __rest(s2, e2) {
  var t2 = {};
  for (var p2 in s2) if (Object.prototype.hasOwnProperty.call(s2, p2) && e2.indexOf(p2) < 0)
    t2[p2] = s2[p2];
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p2 = Object.getOwnPropertySymbols(s2); i < p2.length; i++) {
      if (e2.indexOf(p2[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i]))
        t2[p2[i]] = s2[p2[i]];
    }
  return t2;
}
typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message2) {
  var e2 = new Error(message2);
  return e2.name = "SuppressedError", e2.error = error, e2.suppressed = suppressed, e2;
};
function ItoI(a2) {
  return a2;
}
function innerCreateMedium(defaults2, middleware2) {
  if (middleware2 === void 0) {
    middleware2 = ItoI;
  }
  var buffer = [];
  var assigned = false;
  var medium = {
    read: function() {
      if (assigned) {
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      }
      if (buffer.length) {
        return buffer[buffer.length - 1];
      }
      return defaults2;
    },
    useMedium: function(data2) {
      var item = middleware2(data2, assigned);
      buffer.push(item);
      return function() {
        buffer = buffer.filter(function(x2) {
          return x2 !== item;
        });
      };
    },
    assignSyncMedium: function(cb) {
      assigned = true;
      while (buffer.length) {
        var cbs = buffer;
        buffer = [];
        cbs.forEach(cb);
      }
      buffer = {
        push: function(x2) {
          return cb(x2);
        },
        filter: function() {
          return buffer;
        }
      };
    },
    assignMedium: function(cb) {
      assigned = true;
      var pendingQueue = [];
      if (buffer.length) {
        var cbs = buffer;
        buffer = [];
        cbs.forEach(cb);
        pendingQueue = buffer;
      }
      var executeQueue = function() {
        var cbs2 = pendingQueue;
        pendingQueue = [];
        cbs2.forEach(cb);
      };
      var cycle = function() {
        return Promise.resolve().then(executeQueue);
      };
      cycle();
      buffer = {
        push: function(x2) {
          pendingQueue.push(x2);
          cycle();
        },
        filter: function(filter) {
          pendingQueue = pendingQueue.filter(filter);
          return buffer;
        }
      };
    }
  };
  return medium;
}
function createSidecarMedium(options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  var medium = innerCreateMedium(null);
  medium.options = __assign({ async: true, ssr: false }, options2);
  return medium;
}
var SideCar$1 = function(_a2) {
  var sideCar = _a2.sideCar, rest = __rest(_a2, ["sideCar"]);
  if (!sideCar) {
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  }
  var Target = sideCar.read();
  if (!Target) {
    throw new Error("Sidecar medium not found");
  }
  return React.createElement(Target, __assign({}, rest));
};
SideCar$1.isSideCarExport = true;
function exportSidecar(medium, exported) {
  medium.useMedium(exported);
  return SideCar$1;
}
var effectCar = createSidecarMedium();
var nothing = function() {
  return;
};
var RemoveScroll = React.forwardRef(function(props, parentRef) {
  var ref = React.useRef(null);
  var _a2 = React.useState({
    onScrollCapture: nothing,
    onWheelCapture: nothing,
    onTouchMoveCapture: nothing
  }), callbacks = _a2[0], setCallbacks = _a2[1];
  var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b2 = props.as, Container = _b2 === void 0 ? "div" : _b2, rest = __rest$1(props, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as"]);
  var SideCar2 = sideCar;
  var containerRef = useMergeRefs([ref, parentRef]);
  var containerProps = __assign$1(__assign$1({}, rest), callbacks);
  return React.createElement(
    React.Fragment,
    null,
    enabled && React.createElement(SideCar2, { sideCar: effectCar, removeScrollBar, shards, noIsolation, inert, setCallbacks, allowPinchZoom: !!allowPinchZoom, lockRef: ref }),
    forwardProps ? React.cloneElement(React.Children.only(children), __assign$1(__assign$1({}, containerProps), { ref: containerRef })) : React.createElement(Container, __assign$1({}, containerProps, { className, ref: containerRef }), children)
  );
});
RemoveScroll.defaultProps = {
  enabled: true,
  removeScrollBar: true,
  inert: false
};
RemoveScroll.classNames = {
  fullWidth: fullWidthClassName,
  zeroRight: zeroRightClassName
};
var getNonce = function() {
  if (typeof __webpack_nonce__ !== "undefined") {
    return __webpack_nonce__;
  }
  return void 0;
};
function makeStyleTag() {
  if (!document)
    return null;
  var tag = document.createElement("style");
  tag.type = "text/css";
  var nonce = getNonce();
  if (nonce) {
    tag.setAttribute("nonce", nonce);
  }
  return tag;
}
function injectStyles(tag, css4) {
  if (tag.styleSheet) {
    tag.styleSheet.cssText = css4;
  } else {
    tag.appendChild(document.createTextNode(css4));
  }
}
function insertStyleTag(tag) {
  var head = document.head || document.getElementsByTagName("head")[0];
  head.appendChild(tag);
}
var stylesheetSingleton = function() {
  var counter2 = 0;
  var stylesheet = null;
  return {
    add: function(style) {
      if (counter2 == 0) {
        if (stylesheet = makeStyleTag()) {
          injectStyles(stylesheet, style);
          insertStyleTag(stylesheet);
        }
      }
      counter2++;
    },
    remove: function() {
      counter2--;
      if (!counter2 && stylesheet) {
        stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
        stylesheet = null;
      }
    }
  };
};
var styleHookSingleton = function() {
  var sheet = stylesheetSingleton();
  return function(styles, isDynamic) {
    React.useEffect(function() {
      sheet.add(styles);
      return function() {
        sheet.remove();
      };
    }, [styles && isDynamic]);
  };
};
var styleSingleton = function() {
  var useStyle = styleHookSingleton();
  var Sheet = function(_a2) {
    var styles = _a2.styles, dynamic = _a2.dynamic;
    useStyle(styles, dynamic);
    return null;
  };
  return Sheet;
};
var zeroGap = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
};
var parse$4 = function(x2) {
  return parseInt(x2 || "", 10) || 0;
};
var getOffset = function(gapMode) {
  var cs = window.getComputedStyle(document.body);
  var left = cs[gapMode === "padding" ? "paddingLeft" : "marginLeft"];
  var top = cs[gapMode === "padding" ? "paddingTop" : "marginTop"];
  var right = cs[gapMode === "padding" ? "paddingRight" : "marginRight"];
  return [parse$4(left), parse$4(top), parse$4(right)];
};
var getGapWidth = function(gapMode) {
  if (gapMode === void 0) {
    gapMode = "margin";
  }
  if (typeof window === "undefined") {
    return zeroGap;
  }
  var offsets = getOffset(gapMode);
  var documentWidth = document.documentElement.clientWidth;
  var windowWidth = window.innerWidth;
  return {
    left: offsets[0],
    top: offsets[1],
    right: offsets[2],
    gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0])
  };
};
var Style = styleSingleton();
var lockAttribute = "data-scroll-locked";
var getStyles = function(_a2, allowRelative, gapMode, important2) {
  var left = _a2.left, top = _a2.top, right = _a2.right, gap = _a2.gap;
  if (gapMode === void 0) {
    gapMode = "margin";
  }
  return "\n  .".concat(noScrollbarsClassName, " {\n   overflow: hidden ").concat(important2, ";\n   padding-right: ").concat(gap, "px ").concat(important2, ";\n  }\n  body[").concat(lockAttribute, "] {\n    overflow: hidden ").concat(important2, ";\n    overscroll-behavior: contain;\n    ").concat([
    allowRelative && "position: relative ".concat(important2, ";"),
    gapMode === "margin" && "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top, "px;\n    padding-right: ").concat(right, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important2, ";\n    "),
    gapMode === "padding" && "padding-right: ".concat(gap, "px ").concat(important2, ";")
  ].filter(Boolean).join(""), "\n  }\n  \n  .").concat(zeroRightClassName, " {\n    right: ").concat(gap, "px ").concat(important2, ";\n  }\n  \n  .").concat(fullWidthClassName, " {\n    margin-right: ").concat(gap, "px ").concat(important2, ";\n  }\n  \n  .").concat(zeroRightClassName, " .").concat(zeroRightClassName, " {\n    right: 0 ").concat(important2, ";\n  }\n  \n  .").concat(fullWidthClassName, " .").concat(fullWidthClassName, " {\n    margin-right: 0 ").concat(important2, ";\n  }\n  \n  body[").concat(lockAttribute, "] {\n    ").concat(removedBarSizeVariable, ": ").concat(gap, "px;\n  }\n");
};
var getCurrentUseCounter = function() {
  var counter2 = parseInt(document.body.getAttribute(lockAttribute) || "0", 10);
  return isFinite(counter2) ? counter2 : 0;
};
var useLockAttribute = function() {
  React.useEffect(function() {
    document.body.setAttribute(lockAttribute, (getCurrentUseCounter() + 1).toString());
    return function() {
      var newCounter = getCurrentUseCounter() - 1;
      if (newCounter <= 0) {
        document.body.removeAttribute(lockAttribute);
      } else {
        document.body.setAttribute(lockAttribute, newCounter.toString());
      }
    };
  }, []);
};
var RemoveScrollBar = function(_a2) {
  var noRelative = _a2.noRelative, noImportant = _a2.noImportant, _b2 = _a2.gapMode, gapMode = _b2 === void 0 ? "margin" : _b2;
  useLockAttribute();
  var gap = React.useMemo(function() {
    return getGapWidth(gapMode);
  }, [gapMode]);
  return React.createElement(Style, { styles: getStyles(gap, !noRelative, gapMode, !noImportant ? "!important" : "") });
};
var passiveSupported = false;
if (typeof window !== "undefined") {
  try {
    var options$1 = Object.defineProperty({}, "passive", {
      get: function() {
        passiveSupported = true;
        return true;
      }
    });
    window.addEventListener("test", options$1, options$1);
    window.removeEventListener("test", options$1, options$1);
  } catch (err) {
    passiveSupported = false;
  }
}
var nonPassive = passiveSupported ? { passive: false } : false;
var alwaysContainsScroll = function(node2) {
  return node2.tagName === "TEXTAREA";
};
var elementCanBeScrolled = function(node2, overflow) {
  var styles = window.getComputedStyle(node2);
  return (
    // not-not-scrollable
    styles[overflow] !== "hidden" && // contains scroll inside self
    !(styles.overflowY === styles.overflowX && !alwaysContainsScroll(node2) && styles[overflow] === "visible")
  );
};
var elementCouldBeVScrolled = function(node2) {
  return elementCanBeScrolled(node2, "overflowY");
};
var elementCouldBeHScrolled = function(node2) {
  return elementCanBeScrolled(node2, "overflowX");
};
var locationCouldBeScrolled = function(axis, node2) {
  var current = node2;
  do {
    if (typeof ShadowRoot !== "undefined" && current instanceof ShadowRoot) {
      current = current.host;
    }
    var isScrollable = elementCouldBeScrolled(axis, current);
    if (isScrollable) {
      var _a2 = getScrollVariables(axis, current), s2 = _a2[1], d2 = _a2[2];
      if (s2 > d2) {
        return true;
      }
    }
    current = current.parentNode;
  } while (current && current !== document.body);
  return false;
};
var getVScrollVariables = function(_a2) {
  var scrollTop = _a2.scrollTop, scrollHeight = _a2.scrollHeight, clientHeight = _a2.clientHeight;
  return [
    scrollTop,
    scrollHeight,
    clientHeight
  ];
};
var getHScrollVariables = function(_a2) {
  var scrollLeft = _a2.scrollLeft, scrollWidth = _a2.scrollWidth, clientWidth = _a2.clientWidth;
  return [
    scrollLeft,
    scrollWidth,
    clientWidth
  ];
};
var elementCouldBeScrolled = function(axis, node2) {
  return axis === "v" ? elementCouldBeVScrolled(node2) : elementCouldBeHScrolled(node2);
};
var getScrollVariables = function(axis, node2) {
  return axis === "v" ? getVScrollVariables(node2) : getHScrollVariables(node2);
};
var getDirectionFactor = function(axis, direction) {
  return axis === "h" && direction === "rtl" ? -1 : 1;
};
var handleScroll = function(axis, endTarget, event, sourceDelta, noOverscroll) {
  var directionFactor = getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
  var delta = directionFactor * sourceDelta;
  var target = event.target;
  var targetInLock = endTarget.contains(target);
  var shouldCancelScroll = false;
  var isDeltaPositive = delta > 0;
  var availableScroll = 0;
  var availableScrollTop = 0;
  do {
    var _a2 = getScrollVariables(axis, target), position2 = _a2[0], scroll_1 = _a2[1], capacity = _a2[2];
    var elementScroll = scroll_1 - capacity - directionFactor * position2;
    if (position2 || elementScroll) {
      if (elementCouldBeScrolled(axis, target)) {
        availableScroll += elementScroll;
        availableScrollTop += position2;
      }
    }
    target = target.parentNode;
  } while (
    // portaled content
    !targetInLock && target !== document.body || // self content
    targetInLock && (endTarget.contains(target) || endTarget === target)
  );
  if (isDeltaPositive && (noOverscroll && availableScroll === 0 || !noOverscroll && delta > availableScroll)) {
    shouldCancelScroll = true;
  } else if (!isDeltaPositive && (noOverscroll && availableScrollTop === 0 || !noOverscroll && -delta > availableScrollTop)) {
    shouldCancelScroll = true;
  }
  return shouldCancelScroll;
};
var getTouchXY = function(event) {
  return "changedTouches" in event ? [event.changedTouches[0].clientX, event.changedTouches[0].clientY] : [0, 0];
};
var getDeltaXY = function(event) {
  return [event.deltaX, event.deltaY];
};
var extractRef = function(ref) {
  return ref && "current" in ref ? ref.current : ref;
};
var deltaCompare = function(x2, y2) {
  return x2[0] === y2[0] && x2[1] === y2[1];
};
var generateStyle = function(id) {
  return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n");
};
var idCounter = 0;
var lockStack = [];
function RemoveScrollSideCar(props) {
  var shouldPreventQueue = React.useRef([]);
  var touchStartRef = React.useRef([0, 0]);
  var activeAxis = React.useRef();
  var id = React.useState(idCounter++)[0];
  var Style2 = React.useState(function() {
    return styleSingleton();
  })[0];
  var lastProps = React.useRef(props);
  React.useEffect(function() {
    lastProps.current = props;
  }, [props]);
  React.useEffect(function() {
    if (props.inert) {
      document.body.classList.add("block-interactivity-".concat(id));
      var allow_1 = __spreadArray([props.lockRef.current], (props.shards || []).map(extractRef), true).filter(Boolean);
      allow_1.forEach(function(el) {
        return el.classList.add("allow-interactivity-".concat(id));
      });
      return function() {
        document.body.classList.remove("block-interactivity-".concat(id));
        allow_1.forEach(function(el) {
          return el.classList.remove("allow-interactivity-".concat(id));
        });
      };
    }
    return;
  }, [props.inert, props.lockRef.current, props.shards]);
  var shouldCancelEvent = React.useCallback(function(event, parent) {
    if ("touches" in event && event.touches.length === 2) {
      return !lastProps.current.allowPinchZoom;
    }
    var touch = getTouchXY(event);
    var touchStart = touchStartRef.current;
    var deltaX = "deltaX" in event ? event.deltaX : touchStart[0] - touch[0];
    var deltaY = "deltaY" in event ? event.deltaY : touchStart[1] - touch[1];
    var currentAxis;
    var target = event.target;
    var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? "h" : "v";
    if ("touches" in event && moveDirection === "h" && target.type === "range") {
      return false;
    }
    var canBeScrolledInMainDirection = locationCouldBeScrolled(moveDirection, target);
    if (!canBeScrolledInMainDirection) {
      return true;
    }
    if (canBeScrolledInMainDirection) {
      currentAxis = moveDirection;
    } else {
      currentAxis = moveDirection === "v" ? "h" : "v";
      canBeScrolledInMainDirection = locationCouldBeScrolled(moveDirection, target);
    }
    if (!canBeScrolledInMainDirection) {
      return false;
    }
    if (!activeAxis.current && "changedTouches" in event && (deltaX || deltaY)) {
      activeAxis.current = currentAxis;
    }
    if (!currentAxis) {
      return true;
    }
    var cancelingAxis = activeAxis.current || currentAxis;
    return handleScroll(cancelingAxis, parent, event, cancelingAxis === "h" ? deltaX : deltaY, true);
  }, []);
  var shouldPrevent = React.useCallback(function(_event) {
    var event = _event;
    if (!lockStack.length || lockStack[lockStack.length - 1] !== Style2) {
      return;
    }
    var delta = "deltaY" in event ? getDeltaXY(event) : getTouchXY(event);
    var sourceEvent = shouldPreventQueue.current.filter(function(e2) {
      return e2.name === event.type && e2.target === event.target && deltaCompare(e2.delta, delta);
    })[0];
    if (sourceEvent && sourceEvent.should) {
      if (event.cancelable) {
        event.preventDefault();
      }
      return;
    }
    if (!sourceEvent) {
      var shardNodes = (lastProps.current.shards || []).map(extractRef).filter(Boolean).filter(function(node2) {
        return node2.contains(event.target);
      });
      var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
      if (shouldStop) {
        if (event.cancelable) {
          event.preventDefault();
        }
      }
    }
  }, []);
  var shouldCancel = React.useCallback(function(name, delta, target, should) {
    var event = { name, delta, target, should };
    shouldPreventQueue.current.push(event);
    setTimeout(function() {
      shouldPreventQueue.current = shouldPreventQueue.current.filter(function(e2) {
        return e2 !== event;
      });
    }, 1);
  }, []);
  var scrollTouchStart = React.useCallback(function(event) {
    touchStartRef.current = getTouchXY(event);
    activeAxis.current = void 0;
  }, []);
  var scrollWheel = React.useCallback(function(event) {
    shouldCancel(event.type, getDeltaXY(event), event.target, shouldCancelEvent(event, props.lockRef.current));
  }, []);
  var scrollTouchMove = React.useCallback(function(event) {
    shouldCancel(event.type, getTouchXY(event), event.target, shouldCancelEvent(event, props.lockRef.current));
  }, []);
  React.useEffect(function() {
    lockStack.push(Style2);
    props.setCallbacks({
      onScrollCapture: scrollWheel,
      onWheelCapture: scrollWheel,
      onTouchMoveCapture: scrollTouchMove
    });
    document.addEventListener("wheel", shouldPrevent, nonPassive);
    document.addEventListener("touchmove", shouldPrevent, nonPassive);
    document.addEventListener("touchstart", scrollTouchStart, nonPassive);
    return function() {
      lockStack = lockStack.filter(function(inst) {
        return inst !== Style2;
      });
      document.removeEventListener("wheel", shouldPrevent, nonPassive);
      document.removeEventListener("touchmove", shouldPrevent, nonPassive);
      document.removeEventListener("touchstart", scrollTouchStart, nonPassive);
    };
  }, []);
  var removeScrollBar = props.removeScrollBar, inert = props.inert;
  return React.createElement(
    React.Fragment,
    null,
    inert ? React.createElement(Style2, { styles: generateStyle(id) }) : null,
    removeScrollBar ? React.createElement(RemoveScrollBar, { gapMode: "margin" }) : null
  );
}
const SideCar = exportSidecar(effectCar, RemoveScrollSideCar);
var ReactRemoveScroll = React.forwardRef(function(props, ref) {
  return React.createElement(RemoveScroll, __assign$1({}, props, { ref, sideCar: SideCar }));
});
ReactRemoveScroll.classNames = RemoveScroll.classNames;
const $am6gm$RemoveScroll = ReactRemoveScroll;
const $6cc32821e9371a1c$var$SELECTION_KEYS = [
  "Enter",
  " "
];
const $6cc32821e9371a1c$var$FIRST_KEYS = [
  "ArrowDown",
  "PageUp",
  "Home"
];
const $6cc32821e9371a1c$var$LAST_KEYS = [
  "ArrowUp",
  "PageDown",
  "End"
];
const $6cc32821e9371a1c$var$FIRST_LAST_KEYS = [
  ...$6cc32821e9371a1c$var$FIRST_KEYS,
  ...$6cc32821e9371a1c$var$LAST_KEYS
];
const $6cc32821e9371a1c$var$MENU_NAME = "Menu";
const [$6cc32821e9371a1c$var$Collection, $6cc32821e9371a1c$var$useCollection, $6cc32821e9371a1c$var$createCollectionScope] = $e02a7d9cb1dc128c$export$c74125a8e3af6bb2($6cc32821e9371a1c$var$MENU_NAME);
const [$6cc32821e9371a1c$var$createMenuContext, $6cc32821e9371a1c$export$4027731b685e72eb] = $c512c27ab02ef895$export$50c7b4e9d9f19c1($6cc32821e9371a1c$var$MENU_NAME, [
  $6cc32821e9371a1c$var$createCollectionScope,
  $cf1ac5d9fe0e8206$export$722aac194ae923,
  $d7bdfb9eb0fdf311$export$c7109489551a4f4
]);
const $6cc32821e9371a1c$var$usePopperScope = $cf1ac5d9fe0e8206$export$722aac194ae923();
const $6cc32821e9371a1c$var$useRovingFocusGroupScope = $d7bdfb9eb0fdf311$export$c7109489551a4f4();
const [$6cc32821e9371a1c$var$MenuProvider, $6cc32821e9371a1c$var$useMenuContext] = $6cc32821e9371a1c$var$createMenuContext($6cc32821e9371a1c$var$MENU_NAME);
const [$6cc32821e9371a1c$var$MenuRootProvider, $6cc32821e9371a1c$var$useMenuRootContext] = $6cc32821e9371a1c$var$createMenuContext($6cc32821e9371a1c$var$MENU_NAME);
const $6cc32821e9371a1c$export$d9b273488cd8ce6f = (props) => {
  const { __scopeMenu, open = false, children, dir, onOpenChange, modal = true } = props;
  const popperScope = $6cc32821e9371a1c$var$usePopperScope(__scopeMenu);
  const [content, setContent] = useState(null);
  const isUsingKeyboardRef = useRef(false);
  const handleOpenChange = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onOpenChange);
  const direction = $f631663db3294ace$export$b39126d51d94e6f3(dir);
  useEffect(() => {
    const handleKeyDown = () => {
      isUsingKeyboardRef.current = true;
      document.addEventListener("pointerdown", handlePointer, {
        capture: true,
        once: true
      });
      document.addEventListener("pointermove", handlePointer, {
        capture: true,
        once: true
      });
    };
    const handlePointer = () => isUsingKeyboardRef.current = false;
    document.addEventListener("keydown", handleKeyDown, {
      capture: true
    });
    return () => {
      document.removeEventListener("keydown", handleKeyDown, {
        capture: true
      });
      document.removeEventListener("pointerdown", handlePointer, {
        capture: true
      });
      document.removeEventListener("pointermove", handlePointer, {
        capture: true
      });
    };
  }, []);
  return /* @__PURE__ */ createElement($cf1ac5d9fe0e8206$export$be92b6f5f03c0fe9, popperScope, /* @__PURE__ */ createElement($6cc32821e9371a1c$var$MenuProvider, {
    scope: __scopeMenu,
    open,
    onOpenChange: handleOpenChange,
    content,
    onContentChange: setContent
  }, /* @__PURE__ */ createElement($6cc32821e9371a1c$var$MenuRootProvider, {
    scope: __scopeMenu,
    onClose: useCallback(
      () => handleOpenChange(false),
      [
        handleOpenChange
      ]
    ),
    isUsingKeyboardRef,
    dir: direction,
    modal
  }, children)));
};
const $6cc32821e9371a1c$export$9fa5ebd18bee4d43 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeMenu, ...anchorProps } = props;
  const popperScope = $6cc32821e9371a1c$var$usePopperScope(__scopeMenu);
  return /* @__PURE__ */ createElement($cf1ac5d9fe0e8206$export$b688253958b8dfe7, _extends$1({}, popperScope, anchorProps, {
    ref: forwardedRef
  }));
});
const $6cc32821e9371a1c$var$PORTAL_NAME = "MenuPortal";
const [$6cc32821e9371a1c$var$PortalProvider, $6cc32821e9371a1c$var$usePortalContext] = $6cc32821e9371a1c$var$createMenuContext($6cc32821e9371a1c$var$PORTAL_NAME, {
  forceMount: void 0
});
const $6cc32821e9371a1c$export$793392f970497feb = (props) => {
  const { __scopeMenu, forceMount, children, container } = props;
  const context = $6cc32821e9371a1c$var$useMenuContext($6cc32821e9371a1c$var$PORTAL_NAME, __scopeMenu);
  return /* @__PURE__ */ createElement($6cc32821e9371a1c$var$PortalProvider, {
    scope: __scopeMenu,
    forceMount
  }, /* @__PURE__ */ createElement($921a889cee6df7e8$export$99c2b779aa4e8b8b, {
    present: forceMount || context.open
  }, /* @__PURE__ */ createElement($f1701beae083dbae$export$602eac185826482c, {
    asChild: true,
    container
  }, children)));
};
const $6cc32821e9371a1c$var$CONTENT_NAME = "MenuContent";
const [$6cc32821e9371a1c$var$MenuContentProvider, $6cc32821e9371a1c$var$useMenuContentContext] = $6cc32821e9371a1c$var$createMenuContext($6cc32821e9371a1c$var$CONTENT_NAME);
const $6cc32821e9371a1c$export$479f0f2f71193efe = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const portalContext = $6cc32821e9371a1c$var$usePortalContext($6cc32821e9371a1c$var$CONTENT_NAME, props.__scopeMenu);
  const { forceMount = portalContext.forceMount, ...contentProps } = props;
  const context = $6cc32821e9371a1c$var$useMenuContext($6cc32821e9371a1c$var$CONTENT_NAME, props.__scopeMenu);
  const rootContext = $6cc32821e9371a1c$var$useMenuRootContext($6cc32821e9371a1c$var$CONTENT_NAME, props.__scopeMenu);
  return /* @__PURE__ */ createElement($6cc32821e9371a1c$var$Collection.Provider, {
    scope: props.__scopeMenu
  }, /* @__PURE__ */ createElement($921a889cee6df7e8$export$99c2b779aa4e8b8b, {
    present: forceMount || context.open
  }, /* @__PURE__ */ createElement($6cc32821e9371a1c$var$Collection.Slot, {
    scope: props.__scopeMenu
  }, rootContext.modal ? /* @__PURE__ */ createElement($6cc32821e9371a1c$var$MenuRootContentModal, _extends$1({}, contentProps, {
    ref: forwardedRef
  })) : /* @__PURE__ */ createElement($6cc32821e9371a1c$var$MenuRootContentNonModal, _extends$1({}, contentProps, {
    ref: forwardedRef
  })))));
});
const $6cc32821e9371a1c$var$MenuRootContentModal = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const context = $6cc32821e9371a1c$var$useMenuContext($6cc32821e9371a1c$var$CONTENT_NAME, props.__scopeMenu);
  const ref = useRef(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, ref);
  useEffect(() => {
    const content = ref.current;
    if (content) return hideOthers(content);
  }, []);
  return /* @__PURE__ */ createElement($6cc32821e9371a1c$var$MenuContentImpl, _extends$1({}, props, {
    ref: composedRefs,
    trapFocus: context.open,
    disableOutsidePointerEvents: context.open,
    disableOutsideScroll: true,
    onFocusOutside: $e42e1063c40fb3ef$export$b9ecd428b558ff10(
      props.onFocusOutside,
      (event) => event.preventDefault(),
      {
        checkForDefaultPrevented: false
      }
    ),
    onDismiss: () => context.onOpenChange(false)
  }));
});
const $6cc32821e9371a1c$var$MenuRootContentNonModal = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const context = $6cc32821e9371a1c$var$useMenuContext($6cc32821e9371a1c$var$CONTENT_NAME, props.__scopeMenu);
  return /* @__PURE__ */ createElement($6cc32821e9371a1c$var$MenuContentImpl, _extends$1({}, props, {
    ref: forwardedRef,
    trapFocus: false,
    disableOutsidePointerEvents: false,
    disableOutsideScroll: false,
    onDismiss: () => context.onOpenChange(false)
  }));
});
const $6cc32821e9371a1c$var$MenuContentImpl = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeMenu, loop = false, trapFocus, onOpenAutoFocus, onCloseAutoFocus, disableOutsidePointerEvents, onEntryFocus, onEscapeKeyDown, onPointerDownOutside, onFocusOutside, onInteractOutside, onDismiss, disableOutsideScroll, ...contentProps } = props;
  const context = $6cc32821e9371a1c$var$useMenuContext($6cc32821e9371a1c$var$CONTENT_NAME, __scopeMenu);
  const rootContext = $6cc32821e9371a1c$var$useMenuRootContext($6cc32821e9371a1c$var$CONTENT_NAME, __scopeMenu);
  const popperScope = $6cc32821e9371a1c$var$usePopperScope(__scopeMenu);
  const rovingFocusGroupScope = $6cc32821e9371a1c$var$useRovingFocusGroupScope(__scopeMenu);
  const getItems = $6cc32821e9371a1c$var$useCollection(__scopeMenu);
  const [currentItemId, setCurrentItemId] = useState(null);
  const contentRef = useRef(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, contentRef, context.onContentChange);
  const timerRef = useRef(0);
  const searchRef = useRef("");
  const pointerGraceTimerRef = useRef(0);
  const pointerGraceIntentRef = useRef(null);
  const pointerDirRef = useRef("right");
  const lastPointerXRef = useRef(0);
  const ScrollLockWrapper = disableOutsideScroll ? $am6gm$RemoveScroll : Fragment;
  const scrollLockWrapperProps = disableOutsideScroll ? {
    as: $5e63c961fc1ce211$export$8c6ed5c666ac1360,
    allowPinchZoom: true
  } : void 0;
  const handleTypeaheadSearch = (key) => {
    var _items$find, _items$find2;
    const search = searchRef.current + key;
    const items = getItems().filter(
      (item) => !item.disabled
    );
    const currentItem = document.activeElement;
    const currentMatch = (_items$find = items.find(
      (item) => item.ref.current === currentItem
    )) === null || _items$find === void 0 ? void 0 : _items$find.textValue;
    const values2 = items.map(
      (item) => item.textValue
    );
    const nextMatch = $6cc32821e9371a1c$var$getNextMatch(values2, search, currentMatch);
    const newItem = (_items$find2 = items.find(
      (item) => item.textValue === nextMatch
    )) === null || _items$find2 === void 0 ? void 0 : _items$find2.ref.current;
    (function updateSearch(value) {
      searchRef.current = value;
      window.clearTimeout(timerRef.current);
      if (value !== "") timerRef.current = window.setTimeout(
        () => updateSearch(""),
        1e3
      );
    })(search);
    if (newItem)
      setTimeout(
        () => newItem.focus()
      );
  };
  useEffect(() => {
    return () => window.clearTimeout(timerRef.current);
  }, []);
  $3db38b7d1fb3fe6a$export$b7ece24a22aeda8c();
  const isPointerMovingToSubmenu = useCallback((event) => {
    var _pointerGraceIntentRe, _pointerGraceIntentRe2;
    const isMovingTowards = pointerDirRef.current === ((_pointerGraceIntentRe = pointerGraceIntentRef.current) === null || _pointerGraceIntentRe === void 0 ? void 0 : _pointerGraceIntentRe.side);
    return isMovingTowards && $6cc32821e9371a1c$var$isPointerInGraceArea(event, (_pointerGraceIntentRe2 = pointerGraceIntentRef.current) === null || _pointerGraceIntentRe2 === void 0 ? void 0 : _pointerGraceIntentRe2.area);
  }, []);
  return /* @__PURE__ */ createElement($6cc32821e9371a1c$var$MenuContentProvider, {
    scope: __scopeMenu,
    searchRef,
    onItemEnter: useCallback((event) => {
      if (isPointerMovingToSubmenu(event)) event.preventDefault();
    }, [
      isPointerMovingToSubmenu
    ]),
    onItemLeave: useCallback((event) => {
      var _contentRef$current;
      if (isPointerMovingToSubmenu(event)) return;
      (_contentRef$current = contentRef.current) === null || _contentRef$current === void 0 || _contentRef$current.focus();
      setCurrentItemId(null);
    }, [
      isPointerMovingToSubmenu
    ]),
    onTriggerLeave: useCallback((event) => {
      if (isPointerMovingToSubmenu(event)) event.preventDefault();
    }, [
      isPointerMovingToSubmenu
    ]),
    pointerGraceTimerRef,
    onPointerGraceIntentChange: useCallback((intent) => {
      pointerGraceIntentRef.current = intent;
    }, [])
  }, /* @__PURE__ */ createElement(ScrollLockWrapper, scrollLockWrapperProps, /* @__PURE__ */ createElement($d3863c46a17e8a28$export$20e40289641fbbb6, {
    asChild: true,
    trapped: trapFocus,
    onMountAutoFocus: $e42e1063c40fb3ef$export$b9ecd428b558ff10(onOpenAutoFocus, (event) => {
      var _contentRef$current2;
      event.preventDefault();
      (_contentRef$current2 = contentRef.current) === null || _contentRef$current2 === void 0 || _contentRef$current2.focus();
    }),
    onUnmountAutoFocus: onCloseAutoFocus
  }, /* @__PURE__ */ createElement($5cb92bef7577960e$export$177fb62ff3ec1f22, {
    asChild: true,
    disableOutsidePointerEvents,
    onEscapeKeyDown,
    onPointerDownOutside,
    onFocusOutside,
    onInteractOutside,
    onDismiss
  }, /* @__PURE__ */ createElement($d7bdfb9eb0fdf311$export$be92b6f5f03c0fe9, _extends$1({
    asChild: true
  }, rovingFocusGroupScope, {
    dir: rootContext.dir,
    orientation: "vertical",
    loop,
    currentTabStopId: currentItemId,
    onCurrentTabStopIdChange: setCurrentItemId,
    onEntryFocus: $e42e1063c40fb3ef$export$b9ecd428b558ff10(onEntryFocus, (event) => {
      if (!rootContext.isUsingKeyboardRef.current) event.preventDefault();
    })
  }), /* @__PURE__ */ createElement($cf1ac5d9fe0e8206$export$7c6e2c02157bb7d2, _extends$1({
    role: "menu",
    "aria-orientation": "vertical",
    "data-state": $6cc32821e9371a1c$var$getOpenState(context.open),
    "data-radix-menu-content": "",
    dir: rootContext.dir
  }, popperScope, contentProps, {
    ref: composedRefs,
    style: {
      outline: "none",
      ...contentProps.style
    },
    onKeyDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(contentProps.onKeyDown, (event) => {
      const target = event.target;
      const isKeyDownInside = target.closest("[data-radix-menu-content]") === event.currentTarget;
      const isModifierKey = event.ctrlKey || event.altKey || event.metaKey;
      const isCharacterKey = event.key.length === 1;
      if (isKeyDownInside) {
        if (event.key === "Tab") event.preventDefault();
        if (!isModifierKey && isCharacterKey) handleTypeaheadSearch(event.key);
      }
      const content = contentRef.current;
      if (event.target !== content) return;
      if (!$6cc32821e9371a1c$var$FIRST_LAST_KEYS.includes(event.key)) return;
      event.preventDefault();
      const items = getItems().filter(
        (item) => !item.disabled
      );
      const candidateNodes = items.map(
        (item) => item.ref.current
      );
      if ($6cc32821e9371a1c$var$LAST_KEYS.includes(event.key)) candidateNodes.reverse();
      $6cc32821e9371a1c$var$focusFirst(candidateNodes);
    }),
    onBlur: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onBlur, (event) => {
      if (!event.currentTarget.contains(event.target)) {
        window.clearTimeout(timerRef.current);
        searchRef.current = "";
      }
    }),
    onPointerMove: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerMove, $6cc32821e9371a1c$var$whenMouse((event) => {
      const target = event.target;
      const pointerXHasChanged = lastPointerXRef.current !== event.clientX;
      if (event.currentTarget.contains(target) && pointerXHasChanged) {
        const newDir = event.clientX > lastPointerXRef.current ? "right" : "left";
        pointerDirRef.current = newDir;
        lastPointerXRef.current = event.clientX;
      }
    }))
  })))))));
});
const $6cc32821e9371a1c$var$ITEM_NAME = "MenuItem";
const $6cc32821e9371a1c$var$ITEM_SELECT = "menu.itemSelect";
const $6cc32821e9371a1c$export$2ce376c2cc3355c8 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { disabled = false, onSelect, ...itemProps } = props;
  const ref = useRef(null);
  const rootContext = $6cc32821e9371a1c$var$useMenuRootContext($6cc32821e9371a1c$var$ITEM_NAME, props.__scopeMenu);
  const contentContext = $6cc32821e9371a1c$var$useMenuContentContext($6cc32821e9371a1c$var$ITEM_NAME, props.__scopeMenu);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, ref);
  const isPointerDownRef = useRef(false);
  const handleSelect = () => {
    const menuItem = ref.current;
    if (!disabled && menuItem) {
      const itemSelectEvent = new CustomEvent($6cc32821e9371a1c$var$ITEM_SELECT, {
        bubbles: true,
        cancelable: true
      });
      menuItem.addEventListener(
        $6cc32821e9371a1c$var$ITEM_SELECT,
        (event) => onSelect === null || onSelect === void 0 ? void 0 : onSelect(event),
        {
          once: true
        }
      );
      $8927f6f2acc4f386$export$6d1a0317bde7de7f(menuItem, itemSelectEvent);
      if (itemSelectEvent.defaultPrevented) isPointerDownRef.current = false;
      else rootContext.onClose();
    }
  };
  return /* @__PURE__ */ createElement($6cc32821e9371a1c$var$MenuItemImpl, _extends$1({}, itemProps, {
    ref: composedRefs,
    disabled,
    onClick: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onClick, handleSelect),
    onPointerDown: (event) => {
      var _props$onPointerDown;
      (_props$onPointerDown = props.onPointerDown) === null || _props$onPointerDown === void 0 || _props$onPointerDown.call(props, event);
      isPointerDownRef.current = true;
    },
    onPointerUp: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerUp, (event) => {
      var _event$currentTarget;
      if (!isPointerDownRef.current) (_event$currentTarget = event.currentTarget) === null || _event$currentTarget === void 0 || _event$currentTarget.click();
    }),
    onKeyDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onKeyDown, (event) => {
      const isTypingAhead = contentContext.searchRef.current !== "";
      if (disabled || isTypingAhead && event.key === " ") return;
      if ($6cc32821e9371a1c$var$SELECTION_KEYS.includes(event.key)) {
        event.currentTarget.click();
        event.preventDefault();
      }
    })
  }));
});
const $6cc32821e9371a1c$var$MenuItemImpl = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeMenu, disabled = false, textValue, ...itemProps } = props;
  const contentContext = $6cc32821e9371a1c$var$useMenuContentContext($6cc32821e9371a1c$var$ITEM_NAME, __scopeMenu);
  const rovingFocusGroupScope = $6cc32821e9371a1c$var$useRovingFocusGroupScope(__scopeMenu);
  const ref = useRef(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, ref);
  const [isFocused, setIsFocused] = useState(false);
  const [textContent, setTextContent] = useState("");
  useEffect(() => {
    const menuItem = ref.current;
    if (menuItem) {
      var _menuItem$textContent;
      setTextContent(((_menuItem$textContent = menuItem.textContent) !== null && _menuItem$textContent !== void 0 ? _menuItem$textContent : "").trim());
    }
  }, [
    itemProps.children
  ]);
  return /* @__PURE__ */ createElement($6cc32821e9371a1c$var$Collection.ItemSlot, {
    scope: __scopeMenu,
    disabled,
    textValue: textValue !== null && textValue !== void 0 ? textValue : textContent
  }, /* @__PURE__ */ createElement($d7bdfb9eb0fdf311$export$6d08773d2e66f8f2, _extends$1({
    asChild: true
  }, rovingFocusGroupScope, {
    focusable: !disabled
  }), /* @__PURE__ */ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.div, _extends$1({
    role: "menuitem",
    "data-highlighted": isFocused ? "" : void 0,
    "aria-disabled": disabled || void 0,
    "data-disabled": disabled ? "" : void 0
  }, itemProps, {
    ref: composedRefs,
    onPointerMove: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerMove, $6cc32821e9371a1c$var$whenMouse((event) => {
      if (disabled) contentContext.onItemLeave(event);
      else {
        contentContext.onItemEnter(event);
        if (!event.defaultPrevented) {
          const item = event.currentTarget;
          item.focus();
        }
      }
    })),
    onPointerLeave: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerLeave, $6cc32821e9371a1c$var$whenMouse(
      (event) => contentContext.onItemLeave(event)
    )),
    onFocus: $e42e1063c40fb3ef$export$b9ecd428b558ff10(
      props.onFocus,
      () => setIsFocused(true)
    ),
    onBlur: $e42e1063c40fb3ef$export$b9ecd428b558ff10(
      props.onBlur,
      () => setIsFocused(false)
    )
  }))));
});
const $6cc32821e9371a1c$var$RADIO_GROUP_NAME = "MenuRadioGroup";
$6cc32821e9371a1c$var$createMenuContext($6cc32821e9371a1c$var$RADIO_GROUP_NAME, {
  value: void 0,
  onValueChange: () => {
  }
});
const $6cc32821e9371a1c$var$ITEM_INDICATOR_NAME = "MenuItemIndicator";
$6cc32821e9371a1c$var$createMenuContext($6cc32821e9371a1c$var$ITEM_INDICATOR_NAME, {
  checked: false
});
const $6cc32821e9371a1c$var$SUB_NAME = "MenuSub";
$6cc32821e9371a1c$var$createMenuContext($6cc32821e9371a1c$var$SUB_NAME);
function $6cc32821e9371a1c$var$getOpenState(open) {
  return open ? "open" : "closed";
}
function $6cc32821e9371a1c$var$focusFirst(candidates) {
  const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
  for (const candidate of candidates) {
    if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
    candidate.focus();
    if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
  }
}
function $6cc32821e9371a1c$var$wrapArray(array, startIndex) {
  return array.map(
    (_2, index2) => array[(startIndex + index2) % array.length]
  );
}
function $6cc32821e9371a1c$var$getNextMatch(values2, search, currentMatch) {
  const isRepeated = search.length > 1 && Array.from(search).every(
    (char2) => char2 === search[0]
  );
  const normalizedSearch = isRepeated ? search[0] : search;
  const currentMatchIndex = currentMatch ? values2.indexOf(currentMatch) : -1;
  let wrappedValues = $6cc32821e9371a1c$var$wrapArray(values2, Math.max(currentMatchIndex, 0));
  const excludeCurrentMatch = normalizedSearch.length === 1;
  if (excludeCurrentMatch) wrappedValues = wrappedValues.filter(
    (v2) => v2 !== currentMatch
  );
  const nextMatch = wrappedValues.find(
    (value) => value.toLowerCase().startsWith(normalizedSearch.toLowerCase())
  );
  return nextMatch !== currentMatch ? nextMatch : void 0;
}
function $6cc32821e9371a1c$var$isPointInPolygon(point, polygon) {
  const { x: x2, y: y2 } = point;
  let inside = false;
  for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
    const xi = polygon[i].x;
    const yi = polygon[i].y;
    const xj = polygon[j].x;
    const yj = polygon[j].y;
    const intersect = yi > y2 !== yj > y2 && x2 < (xj - xi) * (y2 - yi) / (yj - yi) + xi;
    if (intersect) inside = !inside;
  }
  return inside;
}
function $6cc32821e9371a1c$var$isPointerInGraceArea(event, area) {
  if (!area) return false;
  const cursorPos = {
    x: event.clientX,
    y: event.clientY
  };
  return $6cc32821e9371a1c$var$isPointInPolygon(cursorPos, area);
}
function $6cc32821e9371a1c$var$whenMouse(handler) {
  return (event) => event.pointerType === "mouse" ? handler(event) : void 0;
}
const $6cc32821e9371a1c$export$be92b6f5f03c0fe9 = $6cc32821e9371a1c$export$d9b273488cd8ce6f;
const $6cc32821e9371a1c$export$b688253958b8dfe7 = $6cc32821e9371a1c$export$9fa5ebd18bee4d43;
const $6cc32821e9371a1c$export$602eac185826482c = $6cc32821e9371a1c$export$793392f970497feb;
const $6cc32821e9371a1c$export$7c6e2c02157bb7d2 = $6cc32821e9371a1c$export$479f0f2f71193efe;
const $6cc32821e9371a1c$export$6d08773d2e66f8f2 = $6cc32821e9371a1c$export$2ce376c2cc3355c8;
const $d08ef79370b62062$var$DROPDOWN_MENU_NAME = "DropdownMenu";
const [$d08ef79370b62062$var$createDropdownMenuContext, $d08ef79370b62062$export$c0623cd925aeb687] = $c512c27ab02ef895$export$50c7b4e9d9f19c1($d08ef79370b62062$var$DROPDOWN_MENU_NAME, [
  $6cc32821e9371a1c$export$4027731b685e72eb
]);
const $d08ef79370b62062$var$useMenuScope = $6cc32821e9371a1c$export$4027731b685e72eb();
const [$d08ef79370b62062$var$DropdownMenuProvider, $d08ef79370b62062$var$useDropdownMenuContext] = $d08ef79370b62062$var$createDropdownMenuContext($d08ef79370b62062$var$DROPDOWN_MENU_NAME);
const $d08ef79370b62062$export$e44a253a59704894 = (props) => {
  const { __scopeDropdownMenu, children, dir, open: openProp, defaultOpen, onOpenChange, modal = true } = props;
  const menuScope = $d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
  const triggerRef = useRef(null);
  const [open = false, setOpen] = $71cd76cc60e0454e$export$6f32135080cb4c3({
    prop: openProp,
    defaultProp: defaultOpen,
    onChange: onOpenChange
  });
  return /* @__PURE__ */ createElement($d08ef79370b62062$var$DropdownMenuProvider, {
    scope: __scopeDropdownMenu,
    triggerId: $1746a345f3d73bb7$export$f680877a34711e37(),
    triggerRef,
    contentId: $1746a345f3d73bb7$export$f680877a34711e37(),
    open,
    onOpenChange: setOpen,
    onOpenToggle: useCallback(
      () => setOpen(
        (prevOpen) => !prevOpen
      ),
      [
        setOpen
      ]
    ),
    modal
  }, /* @__PURE__ */ createElement($6cc32821e9371a1c$export$be92b6f5f03c0fe9, _extends$1({}, menuScope, {
    open,
    onOpenChange: setOpen,
    dir,
    modal
  }), children));
};
const $d08ef79370b62062$var$TRIGGER_NAME = "DropdownMenuTrigger";
const $d08ef79370b62062$export$d2469213b3befba9 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeDropdownMenu, disabled = false, ...triggerProps } = props;
  const context = $d08ef79370b62062$var$useDropdownMenuContext($d08ef79370b62062$var$TRIGGER_NAME, __scopeDropdownMenu);
  const menuScope = $d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
  return /* @__PURE__ */ createElement($6cc32821e9371a1c$export$b688253958b8dfe7, _extends$1({
    asChild: true
  }, menuScope), /* @__PURE__ */ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.button, _extends$1({
    type: "button",
    id: context.triggerId,
    "aria-haspopup": "menu",
    "aria-expanded": context.open,
    "aria-controls": context.open ? context.contentId : void 0,
    "data-state": context.open ? "open" : "closed",
    "data-disabled": disabled ? "" : void 0,
    disabled
  }, triggerProps, {
    ref: $6ed0406888f73fc4$export$43e446d32b3d21af(forwardedRef, context.triggerRef),
    onPointerDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerDown, (event) => {
      if (!disabled && event.button === 0 && event.ctrlKey === false) {
        context.onOpenToggle();
        if (!context.open) event.preventDefault();
      }
    }),
    onKeyDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onKeyDown, (event) => {
      if (disabled) return;
      if ([
        "Enter",
        " "
      ].includes(event.key)) context.onOpenToggle();
      if (event.key === "ArrowDown") context.onOpenChange(true);
      if ([
        "Enter",
        " ",
        "ArrowDown"
      ].includes(event.key)) event.preventDefault();
    })
  })));
});
const $d08ef79370b62062$export$cd369b4d4d54efc9 = (props) => {
  const { __scopeDropdownMenu, ...portalProps } = props;
  const menuScope = $d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
  return /* @__PURE__ */ createElement($6cc32821e9371a1c$export$602eac185826482c, _extends$1({}, menuScope, portalProps));
};
const $d08ef79370b62062$var$CONTENT_NAME = "DropdownMenuContent";
const $d08ef79370b62062$export$6e76d93a37c01248 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeDropdownMenu, ...contentProps } = props;
  const context = $d08ef79370b62062$var$useDropdownMenuContext($d08ef79370b62062$var$CONTENT_NAME, __scopeDropdownMenu);
  const menuScope = $d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
  const hasInteractedOutsideRef = useRef(false);
  return /* @__PURE__ */ createElement($6cc32821e9371a1c$export$7c6e2c02157bb7d2, _extends$1({
    id: context.contentId,
    "aria-labelledby": context.triggerId
  }, menuScope, contentProps, {
    ref: forwardedRef,
    onCloseAutoFocus: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onCloseAutoFocus, (event) => {
      var _context$triggerRef$c;
      if (!hasInteractedOutsideRef.current) (_context$triggerRef$c = context.triggerRef.current) === null || _context$triggerRef$c === void 0 || _context$triggerRef$c.focus();
      hasInteractedOutsideRef.current = false;
      event.preventDefault();
    }),
    onInteractOutside: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onInteractOutside, (event) => {
      const originalEvent = event.detail.originalEvent;
      const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
      const isRightClick = originalEvent.button === 2 || ctrlLeftClick;
      if (!context.modal || isRightClick) hasInteractedOutsideRef.current = true;
    }),
    style: {
      ...props.style,
      "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
      "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
      "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }));
});
const $d08ef79370b62062$export$ed97964d1871885d = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeDropdownMenu, ...itemProps } = props;
  const menuScope = $d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
  return /* @__PURE__ */ createElement($6cc32821e9371a1c$export$6d08773d2e66f8f2, _extends$1({}, menuScope, itemProps, {
    ref: forwardedRef
  }));
});
const $d08ef79370b62062$export$be92b6f5f03c0fe9 = $d08ef79370b62062$export$e44a253a59704894;
const $d08ef79370b62062$export$41fb9f06171c75f4 = $d08ef79370b62062$export$d2469213b3befba9;
const $d08ef79370b62062$export$602eac185826482c = $d08ef79370b62062$export$cd369b4d4d54efc9;
const $d08ef79370b62062$export$7c6e2c02157bb7d2 = $d08ef79370b62062$export$6e76d93a37c01248;
const $d08ef79370b62062$export$6d08773d2e66f8f2 = $d08ef79370b62062$export$ed97964d1871885d;
const MenuItem = ({ subMenus, link, label, icon: icon2, collapsible, isExpanded, isOpened, onNavigate, mainContainerState, setOpenedMenuHandler }) => {
  const navigateTo = (link2) => {
    onNavigate && onNavigate(link2);
  };
  let location = useLocation();
  return subMenus ? collapsible && isExpanded ? /* @__PURE__ */ React__default.createElement("div", { key: label }, /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement(
    "button",
    {
      className: classNames$1(Items),
      "aria-label": "Menu " + label,
      onClick: () => setOpenedMenuHandler && setOpenedMenuHandler(label.toUpperCase())
    },
    /* @__PURE__ */ React__default.createElement(Icon$2, { icon: icon2, size: 15 }),
    /* @__PURE__ */ React__default.createElement("span", { className: menuLabel }, label.toUpperCase())
  )), isOpened && /* @__PURE__ */ React__default.createElement("div", { className: SubMenuContentCollapsible }, subMenus.map((subItem) => /* @__PURE__ */ React__default.createElement(
    "button",
    {
      "aria-label": "Sous menu " + subItem.label,
      className: classNames$1(SubMenuText, location.pathname.includes(subItem.link) ? active$1 : ""),
      key: `${subItem.label}`,
      onClick: () => navigateTo("/" + subItem.link)
    },
    subItem.label
  )))) : /* @__PURE__ */ React__default.createElement($d08ef79370b62062$export$be92b6f5f03c0fe9, { key: label }, /* @__PURE__ */ React__default.createElement($d08ef79370b62062$export$41fb9f06171c75f4, { asChild: true }, /* @__PURE__ */ React__default.createElement(
    "button",
    {
      className: location.pathname.includes(link) ? classNames$1(active$1, Items) : classNames$1(Items),
      "aria-label": "Menu " + label
    },
    /* @__PURE__ */ React__default.createElement(Icon$2, { icon: icon2, size: 15 }),
    /* @__PURE__ */ React__default.createElement("span", { className: menuLabel }, label.toUpperCase())
  )), /* @__PURE__ */ React__default.createElement($d08ef79370b62062$export$602eac185826482c, { container: mainContainerState }, /* @__PURE__ */ React__default.createElement($d08ef79370b62062$export$7c6e2c02157bb7d2, { className: SubMenuContent, sideOffset: 10, side: "right", align: "start" }, subMenus.map((subItem) => /* @__PURE__ */ React__default.createElement(
    $d08ef79370b62062$export$6d08773d2e66f8f2,
    {
      className: SubMenuText,
      key: `${subItem.label}`,
      onSelect: () => navigateTo("/" + subItem.link)
    },
    subItem.label
  ))))) : /* @__PURE__ */ React__default.createElement("button", { onClick: () => navigateTo("/" + link), key: label, className: location.pathname.includes(link) ? classNames$1(active$1, Items) : classNames$1(Items) }, /* @__PURE__ */ React__default.createElement(Icon$2, { icon: icon2, size: 15 }), /* @__PURE__ */ React__default.createElement("span", { className: menuLabel }, label.toUpperCase()));
};
const Menu$2 = ({ logo, items, collapsible, onNavigate }) => {
  const [isExpanded, setIsExpanded] = useState(true);
  const [openedMenu, setOpenedMenu] = useState("");
  const mainContainer = useRef(null);
  const [mainContainerState, setMainContainerState] = useState(mainContainer == null ? void 0 : mainContainer.current);
  const [isSizeExpandable, setSizeExpandable] = useState(true);
  const toggleMenu = () => {
    if (isSizeExpandable) setIsExpanded(!isExpanded);
  };
  const navigate = (link) => {
    onNavigate(link);
  };
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 1500) {
        setSizeExpandable(false);
      } else {
        setSizeExpandable(true);
      }
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const setOpenedMenuHandler = (menu) => {
    if (openedMenu == menu)
      setOpenedMenu("");
    else
      setOpenedMenu(menu);
  };
  useEffect(() => {
    if (mainContainer.current instanceof HTMLDivElement)
      setMainContainerState(mainContainer.current);
  }, [mainContainer]);
  return /* @__PURE__ */ React__default.createElement("div", { className: `${menuContainer} ${isExpanded && isSizeExpandable ? expanded : collapsed}`, "data-testid": "menu", ref: mainContainer }, /* @__PURE__ */ React__default.createElement("div", { className: LogoContainer }, logo ? /* @__PURE__ */ React__default.createElement("div", { className: logoContainer }, /* @__PURE__ */ React__default.createElement("img", { src: logo, alt: "Logo" })) : /* @__PURE__ */ React__default.createElement("div", { className: ResizableLogoContainer }, /* @__PURE__ */ React__default.createElement("span", { className: ResizableLogoWeBank }, "WeBank"), /* @__PURE__ */ React__default.createElement("div", { className: ResizableLogoOnline }, "Online"))), /* @__PURE__ */ React__default.createElement("div", { className: toggleButtonContainer }, /* @__PURE__ */ React__default.createElement("button", { className: toggleButton, onClick: toggleMenu, "aria-label": "reduce menu" }, /* @__PURE__ */ React__default.createElement(Chevron, { className: toggleButtonIcon, orientation: isExpanded && isSizeExpandable ? "left" : "right" }))), /* @__PURE__ */ React__default.createElement("div", { className: buttonContainer }, items.map((item) => {
    try {
      return /* @__PURE__ */ React__default.createElement(MenuItem, { key: item.label, collapsible, label: item.label, subMenus: item.subMenus, link: item.link, isOpened: openedMenu == item.label.toUpperCase(), setOpenedMenuHandler, icon: item.icon, isExpanded: isExpanded && isSizeExpandable, mainContainerState, onNavigate: navigate });
    } catch (e2) {
      console.log(e2);
      return "erreur";
    }
  })));
};
function ThemeChooser({ lightTheme, darkTheme, children }) {
  const choosedLightTheme = lightTheme || demoLightV2;
  const choosedDarkTheme = darkTheme || demoDarkV2;
  const [nightMode, setNightMode] = useState(false);
  document.body.className = nightMode ? choosedDarkTheme : choosedLightTheme;
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("div", null, children, /* @__PURE__ */ React__default.createElement("div", { style: { position: "fixed", left: "5px", bottom: "0", zIndex: 1e3 } }, /* @__PURE__ */ React__default.createElement(Switch, { name: "Switch theme", onChange: (event) => {
    setNightMode(event.target.checked);
  } }))));
}
var ProfilInfoContainer = "nea99u0";
var clickable = "nea99u1";
var BienvenueLabel = "nea99u2";
const Profil = ({ nom, currentSession, lastSession, onProfileNavigation, onLogoutNavigation, onAdviserNavigation }) => {
  const { t: t2 } = useTranslation();
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("span", { className: BienvenueLabel }, t2("pages.dashboard.hello")), /* @__PURE__ */ React__default.createElement("div", { className: ProfilInfoContainer }, nom), /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement(Switch, { onChange: () => {
    console.log("Change");
  } }), /* @__PURE__ */ React__default.createElement("label", null, "Entreprise")), /* @__PURE__ */ React__default.createElement("div", { className: ProfilInfoContainer }, /* @__PURE__ */ React__default.createElement("div", { className: "div" }, /* @__PURE__ */ React__default.createElement("div", { className: "frame-2" }, /* @__PURE__ */ React__default.createElement("div", { className: "text-wrapper" }, t2("pages.dashboard.current-session"))), /* @__PURE__ */ React__default.createElement("div", { className: "text-wrapper-2" }, currentSession)), /* @__PURE__ */ React__default.createElement("div", { className: "div" }, /* @__PURE__ */ React__default.createElement("div", { className: "frame-2" }, /* @__PURE__ */ React__default.createElement("div", { className: "text-wrapper" }, t2("pages.dashboard.last-session"))), /* @__PURE__ */ React__default.createElement("div", { className: "text-wrapper-2" }, lastSession))), /* @__PURE__ */ React__default.createElement("button", { "aria-label": "mon profil", className: classNames$1(ProfilInfoContainer, clickable), onClick: onProfileNavigation }, /* @__PURE__ */ React__default.createElement(Icon$2, { size: 18, icon: "Profil2" }), /* @__PURE__ */ React__default.createElement("span", null, t2("pages.profile.title"))), /* @__PURE__ */ React__default.createElement("button", { "aria-label": "", className: classNames$1(ProfilInfoContainer, clickable), onClick: onAdviserNavigation }, /* @__PURE__ */ React__default.createElement(Icon$2, { size: 18, icon: "Discussion" }), /* @__PURE__ */ React__default.createElement("span", null, t2("pages.adviser.title"))), /* @__PURE__ */ React__default.createElement("button", { "aria-label": "Deconnexion", className: classNames$1(ProfilInfoContainer, clickable), onClick: onLogoutNavigation }, /* @__PURE__ */ React__default.createElement(Icon$2, { size: 18, icon: "Deconnexion" }), /* @__PURE__ */ React__default.createElement("span", null, t2("pages.dashboard.logout")))));
};
const $cddcb0b647441e34$var$AVATAR_NAME = "Avatar";
const [$cddcb0b647441e34$var$createAvatarContext, $cddcb0b647441e34$export$90370d16b488820f] = $c512c27ab02ef895$export$50c7b4e9d9f19c1($cddcb0b647441e34$var$AVATAR_NAME);
const [$cddcb0b647441e34$var$AvatarProvider, $cddcb0b647441e34$var$useAvatarContext] = $cddcb0b647441e34$var$createAvatarContext($cddcb0b647441e34$var$AVATAR_NAME);
const $cddcb0b647441e34$export$e2255cf6045e8d47 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeAvatar, ...avatarProps } = props;
  const [imageLoadingStatus, setImageLoadingStatus] = useState("idle");
  return /* @__PURE__ */ createElement($cddcb0b647441e34$var$AvatarProvider, {
    scope: __scopeAvatar,
    imageLoadingStatus,
    onImageLoadingStatusChange: setImageLoadingStatus
  }, /* @__PURE__ */ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.span, _extends$1({}, avatarProps, {
    ref: forwardedRef
  })));
});
const $cddcb0b647441e34$var$IMAGE_NAME = "AvatarImage";
const $cddcb0b647441e34$export$2cd8ae1985206fe8 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeAvatar, src: src2, onLoadingStatusChange = () => {
  }, ...imageProps } = props;
  const context = $cddcb0b647441e34$var$useAvatarContext($cddcb0b647441e34$var$IMAGE_NAME, __scopeAvatar);
  const imageLoadingStatus = $cddcb0b647441e34$var$useImageLoadingStatus(src2);
  const handleLoadingStatusChange = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a((status) => {
    onLoadingStatusChange(status);
    context.onImageLoadingStatusChange(status);
  });
  $9f79659886946c16$export$e5c5a5f917a5871c(() => {
    if (imageLoadingStatus !== "idle") handleLoadingStatusChange(imageLoadingStatus);
  }, [
    imageLoadingStatus,
    handleLoadingStatusChange
  ]);
  return imageLoadingStatus === "loaded" ? /* @__PURE__ */ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.img, _extends$1({}, imageProps, {
    ref: forwardedRef,
    src: src2
  })) : null;
});
const $cddcb0b647441e34$var$FALLBACK_NAME = "AvatarFallback";
const $cddcb0b647441e34$export$69fffb6a9571fbfe = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeAvatar, delayMs, ...fallbackProps } = props;
  const context = $cddcb0b647441e34$var$useAvatarContext($cddcb0b647441e34$var$FALLBACK_NAME, __scopeAvatar);
  const [canRender, setCanRender] = useState(delayMs === void 0);
  useEffect(() => {
    if (delayMs !== void 0) {
      const timerId = window.setTimeout(
        () => setCanRender(true),
        delayMs
      );
      return () => window.clearTimeout(timerId);
    }
  }, [
    delayMs
  ]);
  return canRender && context.imageLoadingStatus !== "loaded" ? /* @__PURE__ */ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.span, _extends$1({}, fallbackProps, {
    ref: forwardedRef
  })) : null;
});
function $cddcb0b647441e34$var$useImageLoadingStatus(src2) {
  const [loadingStatus, setLoadingStatus] = useState("idle");
  $9f79659886946c16$export$e5c5a5f917a5871c(() => {
    if (!src2) {
      setLoadingStatus("error");
      return;
    }
    let isMounted = true;
    const image2 = new window.Image();
    const updateStatus = (status) => () => {
      if (!isMounted) return;
      setLoadingStatus(status);
    };
    setLoadingStatus("loading");
    image2.onload = updateStatus("loaded");
    image2.onerror = updateStatus("error");
    image2.src = src2;
    return () => {
      isMounted = false;
    };
  }, [
    src2
  ]);
  return loadingStatus;
}
const $cddcb0b647441e34$export$be92b6f5f03c0fe9 = $cddcb0b647441e34$export$e2255cf6045e8d47;
const $cddcb0b647441e34$export$3e431a229df88919 = $cddcb0b647441e34$export$2cd8ae1985206fe8;
const $cddcb0b647441e34$export$fb8d7f40caaeea67 = $cddcb0b647441e34$export$69fffb6a9571fbfe;
var AvatarRoot$1 = "sfdoo0";
var AvatarImage$1 = "sfdoo1";
var AvatarFallback$1 = "sfdoo2";
const useInitial = (props) => {
  const { text, separator: separator2 = " " } = props;
  if (text)
    return text.split(separator2).reduce((acc, curr) => acc + curr.charAt(0), "").slice(0, 2);
  else
    return "";
};
const WeAvatar = (props) => {
  const initial = useInitial({ text: props.nom });
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement($cddcb0b647441e34$export$be92b6f5f03c0fe9, { className: AvatarRoot$1 }, props.img != "" && /* @__PURE__ */ React__default.createElement(
    $cddcb0b647441e34$export$3e431a229df88919,
    {
      className: AvatarImage$1,
      src: props.img,
      alt: props.nom
    }
  ), /* @__PURE__ */ React__default.createElement($cddcb0b647441e34$export$fb8d7f40caaeea67, { className: AvatarFallback$1, delayMs: 600 }, initial)));
};
const fond1 = "data:image/jpeg;base64,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";
const fond2 = "data:image/jpeg;base64,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";
const fond3 = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAYGBgYGBgcICAcKCgkKCg4NDAwNDhUPEA8QDxUgFBgUFBgUIB0jHBocIx0zKCQkKDM7Mi8yO0hAQEhaVlp2dp8BBgYGBgYGBwgIBwoKCQoKDg0MDA0OFQ8QDxAPFSAUGBQUGBQgHSMcGhwjHTMoJCQoMzsyLzI7SEBASFpWWnZ2n//CABEIAbMCowMBIgACEQEDEQH/xAAbAAADAQEBAQEAAAAAAAAAAAADBAUCBgEAB//aAAgBAQAAAACyB5IbKiqdHc6Fbd539N4vSa4qHZ1fznqwm+b2367zPO3qxjr85MqsamjM24smyVEWn3srDHo5hpsqJ2zpfF+DNX8clugoe8V0g6iPuJRLsO0kQ87o0w1JMmj1kLn6VMnofbjikrZJQtFw1L9eEepC98M+QKi7TOgEPPZBPq18KDP9NUGebemu/czqzMn2mJVOZW+HNdoS/teKM07vPiB7QE6Vg09G5NYWFkYGBMZwZcJWzFWB6MTW3/pF6R7bL4l4TCimNRb8a8s3E0/CdQyyS1FbmXVsAyu11R+eJR5T9BkevLZlibsLZMrOzOa++9LsWftGZH4ssVw3ijFOJafXEIi+p4np6il7AMCDSguFmOM/JNaz7eq42EPNWbcCJ+ica+8Akha64STVwnBYW15s3mfMkBmmPXze9zcMOhXsEAHwQGtCSWAcnKq9E42sIU2tOK+PAnL/AJ0fPU+Pe03yXQdHy/QMJkRRaR8ZKgs1hM3ut6+EP0fhqGfHWFkCaLqf50Jcg80hn7So9TUWXlZtKbTXluEtdFyMK2xTVwVksiZJ/TgxaDMdbWftuNqqiwIhnBa+GDDATq3PMpG8bJ4mYbajr5fVZIwm0DMMtOPQToq7H8tSqez4znnQxmaVaeOPA/SwS/o9ExvVMDyMQvMnaZ92oDDLjAhm93La8J5g28eTHqXqjaehZwqWd9RXntLfB9PrdxSN7jo7MWNWtjVPCQ6ZNOnNndFuH4PzGvgs7qaINEWG/KRAebEP7fg9hKDxZugSj597jIIHyy9VFFwNCXaV9mlMRWv0Cb3MY68K2Wfzem6azO5h3fag52ccZj+mOz8FRhURHXVgj0X4gCqKDIVhx9n0gvNeD5kiAjK4qTK/NdC3HXtRX6F5Of0vFG6gk4FP86+sxbtNWU50WORGv01SYpSOHwW54PsGM02uD1v4O58ypSeLrRPM+B16TkavEVDblXJ7y1Aa4G1/qWh+SxXugAsdn898uzA3wUx2aKUcDbGpeK662cz/AL7XijNAwBUgrfLBtHb2T0Y/fPA7xy9jlKAji2q7p2F4zq9zl+Pk7SFPoIK3Qwp/VycJjc6VGkxkPL9Ged9n0QTYTx9j30VDweLiShZu67J9YxjGdkoazw7opBDz7OhKVlkW3VZVKfS89j9qfnV+s4XzvFqE9hhWKTkqd9cV7wShdLAc+xjxb5Km+l9fnrkh0WmyZzlf47LfuPOFeGNajErIOKuYYVvTlBgaypjoCzF8RB9XXrMTZ7JVlCZT3Uz5Uih8N57rWBjnO0M7sTtLSbTZ8ZHPYf038Pz7ia4eerBwwq4i6qVDq8Qyzw0XeIrUJ+SY7Di+g7QMXEpp7zC+1a4iN2eWXxXdFOnPqJ0KQVyN+RXX3PFvF1a/z2see54b1pd9JgKtZEL2JHYJjxzx9XIwPRVpfW+cHR/QWpYOQ6grKAd5oLZeo87X8FrCPnhRsVZWOa633nq+2j60LeXdY9355ysqtynRoNr+7+D8RLvedEspkLdVXnkuyl9rIm1LBcKrUJ3i9DYzaYajo+NBR0/UcnzrOJgpd9qIR3DoQ103C/Ex9onAn2r4FlfxanlbLNrn6yM1Ehmuu4gfZ872yKy/lcpQw3pdAipbCOdAH8v6Vj0vixyIfeAq4zPrTzPKMEc2QfnujfmXQc837Ophrx9HmUKk6okLm3yTWPu25XsuV6SjPnEWo1FEhiaSadI2IXPviQbIOk9P+cVIFKmcMKxqbipv3bDg/GRfZ/PukhqEEZt2Z40mxY5SsSUlcXgtEso3Emruo4ftp+nYWcXpKaRMs0hpppkVuPDx0gpSFSntRGtOXcZ20Iz6/wAyvtj81rrA1Pr42VRZWrY5zNGK80jPfyD59y214pQkpsa1qaw0EBggBTVI8P5SroUkTjG7PkAVRWcWhUGAjR1m1pter+ZdBBJ8jURJkesBay4eSIyMt9j36tba2Na3GXIxmC4vU+8mvzjHRO7lNnzEoLdCoVmVLczMy90Cvvu6AfCq53W4VmW7Py2iUiLye3F1un5XoecbhouMY7ykScfVmam2OepP8quLotqs/AIVdYh4hGdhx0WBSLSgz1MEyUtFbGVp/Tq8BTwmaX0gZbPi+Wvvkd9Fz2RIi9tO2qJlZ7xPj/JxT6XYZVyQXmsLuhGNYz/qnzfuxzCXZjlFY4T0DqYH7Ntw+bdyo9NcANpfa3pmEfdhais5170dhjfst8RSAQZoCinLIqgGoUqZfk6i67olX1H6NBYmpaNI63hbeE2J+MoKIF8SZZ8UW1QUnvr0VyGVo88o1dkVvOgrF5ej6gwGh42HiXG0SNkyVZWir69KbOm0vVy5QWXoilhoYXz0WBaQAOUntbwe2CjUWo7ka2+vbl7q5ipTurw0xXTlPaxM6X7Dn3HPGF4TfgT/AC2XQR68q8k+Ki6dJRg3Fl6gqIqxR/CnH52TVzhmX6wynry5z42VnPH5J+08grTfmmPNp0aq6z9HK7vJl9EQ4WheAFUqcqRoLDXvz58hV1iHbsAmeNFGZD3yezDEMhUj+OTk6dTnzE0t0fKWulqDRUH4ht31c7kTqTTyTpDmk2GPgjZi3izFvp3THA0rU9B59rlmz+6uiwwRdRedTtcZzNIBzCJXjkS8topW1z0JPRs0tLTQkItKz4OjfyqCV8b4dNNB8DiXyrDKxn9ZMZQBC/c48764aQlc2JdsWQ55CpL9BZ+8RoJvidx595uzhW42cYeZgXmmdK4tpqhKkVpcbextz8r6R9My2iobpUoxd+o5qlolEIiaerM8JnaH5mzG238fwLuhUQdPCVDbMw4Nt3zwEKdfKvqQ9pYi6juvfEt4aVaRqwXsuxWhsjCKb34AeI0KavOLPHMIX1LdCPz4flX41K1zG70ukO/uTH+6wy1CnvY/PpfNq3Smyj78UeGSp5H6IplLMPOt7cHjZ1ZXTpTt0KZedkz0SV6bBHTrqL8P00k0qz7K6WbsoXqd7h18UbTxNs68LF5xOT1jLyRNZyXYV2J69PaefUmNPp56TKUtR9oBjvtLIcgLvFm5uWHVU+YvTOc6FXa9KS8z5QSh36rnHFoKHapL3GuN99FWpJiAVXwoc+Ybx5QRmaYy3gk/PmI/SeWwl2ffwRQKAZt52VSDM5aF+sIewWMIPTNNHq+gi/Oh0sv0bRfdNKFfLsEWWagdP1oXyW6WRT0awslJ77z/AKu0+5S+8KYmVI2n0oXQs++8dFYJ3vk7lrXO3Jr0wvTkPtdJFJ04FGqPhhsfGoQomWb/AE2J7iYPij9QwFRj1xckcISnPunjpOe8YWTRaplQ5ntPmS/n/nnVXApwFDml+bVP2bMzx9bnFfPPX5nRovqmg0T3/OXpdBs55sfQRqMnALdac0OWe7yVBOip0OVECh0nWeCmdobbCcbl+u7yELUfmWyT9sqK9A8b5hkcPTVbmTEquESexmGZ33148+ONg2QgypSC2JOiz5yt8J43VSGZ0S05Jp3OcBcb5XoiD52G1+pMc6sWZzLT00BD+jGd6gcx/FV7JU3PncyuZp2fUD1xa5Zg+BJmMOfZl6bJMoIXlavHdLOUZ18n4w+mU4o/Qel4s9G3WNBwmurlwclQGWGc6imcrWehg8957rqHeS6UxNDzZyNCEym/hXzw1GCvbheFsVvscxTHLeBUn6dlfUI9BryW0tY2I7GZTw5ozKmoZlICnm1Ve5Wl50VYU0EFlOlZoMiHtlzECmnzhaW/sIEa8QAW/phGU25y3SJl58zjO4k/rEULl71aaOvFEb7oISnczZ8Pyg0nOnx7nRc9HBTsyctVUZXdeGypu+n4aaxJpZoTotAJ20UE6jEexMo/b5zpVMxTdfDT+mPTvP0KE5Vf5n6TjNPpWuG75T7ydEV6BtPn436HjjJQWjfI/dE/fNPY8WLWwtMFce8wPnZDLgVl6EVlh3arSitaYeT91a0/ExT1ju0FOb86IuppbBuj4vscJtLz0lOiJynFdF2fHUfgMfNSs3jJkwyXK2MVqawcBrhm82NkbJm2JyO1aKTiu107nUwl2+e1zVvtUYS+8462Bhfr3IHRH1nUpMrszkJvUdXwqndPE2hOyAzZlPNBAW1mP8iit1dGW7HneiIB6OOj604yvPl9g9NHRZ5NKT2wbPEdAzGKTK4+lmDb6QuPV854XkqL9yXLa+uboFQIZf1Vp77xZc0agJV5pzQVnzM5TSSRPTcFTHKju9dzgrTyPPyrrqROQ7Lh2z9FmLub0izvSE3j7fyvLcqm7YM/qQTwhfqhFWRM+sprxm6VkHKH+SOY9PamgZfYP6Pa0mrTlc90NAvKi6ZRR3jDYAYFB3IZ26AuuPv3wXiziHPzV/hVXHcGwuw9utPGvKOZyZZIKXzenRFcXZb8OdYWjGNiXcRiV6DsIVDB5HOlZT6Lkmc3wsOcaVwnVsfb0ok4b7mEaW/fjDJmWCxWzK6DmTurJWQjyHhLq32smap0PPfB79MOdUX9o6YlIWU4sJzpefzT6HlothSuUyMMBG+oqemzhjAwc9MxsummMD8YPDrvct0WuQI0xrMsA+oc8MRc7a6nPVxD8do4LvT0NM7nO1V0kT2L/wBnlY7AHKhV5M9vbjZiYTLRqhgindbPVP8AeZHzvRzrqNaViqogETGV+j1v2PMsUy8VWRdo0fZBzabhbdPy7hZnlvFgMnq/OCVcnkNUekSjOWvlx6XBbBKZ96VT88pFeHE6Sz4lo8sEVWxWxAN0z0eMpkBquH1btX6EgyU7EwjSciy9z1Kq0AkKR+jB5KfNsSumhX15baOets75rU8ZRtz+z4PlqHcxg3PgIdWhRT/Numocb099Hm+kwrvxb2VKvWkele4Lx05yTKq7UbpWeV62B0PM3IsDuP/EABoBAAIDAQEAAAAAAAAAAAAAAAMEAQIFAAb/2gAIAQIQAAAAuFixTWzVDWirlgEd5m+nWhRRa9K3p09YVoP0+USNRoBUihfgB2uaAWqGrpFr0W6kyK00rW/F43kVL0aT1M/qsZuhDRtPEHJz6jE9WemkUt1LCtPTfxDsVNcfKlPmaBqabCbbFoPalJsuNit4iIhFs895UoTLMq2grOe7oqp+kUT0LNkgdLQETU9HRYMjmZ8y8pfpiQnqpoEOrtyrKA7OmY4/DraO6tad092UrR7Ma7lOqR1A+rzSkVqnuTahJMmyO/QPrTQfZdV289qtBiIzxSWRceVMxlbKrY5Y7PezHyDi0jpM50gRaWuQENU3MPTsGS1AE7+VzIoeA+GzVaU6vR2E2ORBOC13BJtOCZWX186hF+Wtd9iXFrn6BdTqdmtLxSvBNqJ3zrbkw4JXJhVlhBnmBX0qXaIsItBB7PaHXu5hLUR0aWOtm6qFAVaWqRa+q2jm7vOjWaFKfVVYlEpI6GiVcCjnXaFK7K1LMUcfynziq4ozdQiVEG9MWearvKEvYcKr9RqnWp3d2rg6OidM4wO3V5UWN6Rd3OZuWSoTjuu0EilpSPoLSl9HE9AfNZsBZlmoBrk1MfSUX11bXWYVQFp1pQ5x5pxg3FQnLibsHuyJZLrpl9GqFIhl6lUWvK19IImjITRlTSxHyFI3Rw+dnAFcVkvbFzFDjWLnaQALiKzpJjvfl7i0s5i9h1dHNRFyc5gnetKhyiil2zEoitN7MV4wy2aToZYArvq8YpcvKbevvXKhUODS7zbJUkZLVmps6ozc4POZr2dps9E5S3bbTxeMIUAzkqUIYKWxpZvOKqFaClzSaT67LTyEJdb0Tdq3qXqwOESZq92HSKLXkdurKdodTMTP0ZFOZ6Ec6V7BXbsUNfJ966sDyJaCC5aFViTLIbdVA6LEVScCPTcmMq2iSEPPM+lXpNxQsNplrLz17GU4F2tEotBcBVedo6TPUjQa4tqivVBaXHrq4+ee5B8Bo5uWZMmalyribN2eAGurdw4qcurT1OD05pdHvOrmo4y3cZk3YYJ3kPQCatRZbpM2sMwJzWdrCEs13oE0V5OUtr3UM6S/T4vYfzdG9PP0e116j1gA85tLRmErqHsTP0UIYYcw9ITzYG8L/8QAHAEAAgMBAQEBAAAAAAAAAAAABAUCAwYBAAcI/9oACAEDEAAAANSUvpFCH1LCqFFi3xAqatJVn/Xxt770/Q9ZC0Uv0a6/fW3QFq68Rr6S/wAatW8QsQrdHkMyMT3vuz7QXCNtd3oxhD6s2j1Y7yOj9cheqylCnM7o6oEHGhWTlyPL7Pc72m+XYx59uUwvCrIraQXOUg5+EXvFSblolZNsfMCE9/u+929wnr5D6yCTSYC1jIbOaNNkdBpvkD/X4atUJcXHtzHyyUuylQyE73lf1tA0hX3vj1Hm6CCjSfOangWpbAolq+wWs+dXvTnHvJd9HbN+5vXJ7uOORrzu0R4+tM0JvIcfPeVG1cEdqLOe9yUZWdhvZkp9OoIkQxFC7BVE5IhfiKNn8/YClDid1eZ0+ep57nTIe5rqT3q5hAIw1T75/wDRcnwwYO9kyR5rYlqCpZ41E5AU3+st5z3vqCE2F5wd3epCmSpJIBqfjdWcqa3n2BZgCtO7CBjSURGJcdioa+IIjdTlm9b6XzMM5SWy3nmQgD9OMEcKir4kGLPHgxbA6daUR2zylzlNAiIBzL/R5PTM2NQDSXb45Va6Z423NXtk/eayNbYSjRUVehcijNRa20w6hjI8Aovo0lud1CNPcQgfJQy/bAnVZXJkakSarzKkSdxJR1Raqy+F/fS7kd2iyahsoO02PqPu1LLffFW2c1awcOsfS0alUunc1cIIndtEIIBQ7n5mu1SjjV1ngrmBrFXj/oOVYOMS25WwWsXDDN232Ais2oszck2ZpA9dm5qa82U/dW0tBfkjts2gKZzjQ4GhhxJceuHeVFBmpdMELAdTTnF2t2Di0OY7f4KLr3QM3QzNdecR6YmaZlVQ4w51c9EGjfbmWIhLUN8yDvefnKrVebNGlQAELHDGkK5fKAZ1NQbyYjJ1ALPue00hvz67BfiUqdNcZsTKFgSwV20gmZrKgNdcRTYovdCS6Utr9X49jSKp+a03AmnWM9A8lweNxCPOaOpLpDOAkNOiHeqJqCWNrCqe5pTkDBLFdV5J5bf2gsuCTL3LAawicbumEVKnQcG4Ahk32CnHB2UVss1XA0r7IH8yjcdqfLDSvC9pcE+FLaZohgSoUHWvcu2vwCHtGzV5UYjZ71HgCSC6ips70a9brXxMhnN9YoQa07K6Ixc4rzPkNOlKhmEh8xvF0lPG/EGdkx2moHGFhaUEJwdwrpZgsIhjmZwe93eTkG9QQJV3WLW75F9Ivq0F+Uo3kqihQVg3ON1hAQa36FmjM/WYxLs8sAb86ZYyDxe3ONFrxOif+GpEpqHrZ1KYBxI1y4B/kgnWvVdzTKHFvitxmjLXJS5eL0fV5lhaOoC1K2CcC4fQf//EADoQAAIBBAEDAgUDAwMDBAIDAAECAwAREiEEEyIxMkEQFCNCUQUzYUNScSRTYiBjgRU0VKFEkXKCsf/aAAgBAQABDAE9YayNRS53V2xk2caKSKWdCvT6giW+8Q8ElleKmQcUkDsDKY005oxTgD7jEiZhBemN7xp2oSSQRYJyj3xAXqLk5g2jN0ULdmq78h2UeJJU4UCRscmVcpZJ1Vcij/8AybU0TMQBaSvlz/sA10f7oVFYKMRNIuHARmLystjy/IrjNHC8nHyJrjkS5QNomJ5Aknarj6cYn6saovNhZyl42rpxHeLrQiU+nkXpYfzJXRj+58qAsLItq5PJkSR4k00MIKuzOyon6Z+nri5jYlePFELrGaESyDuhxKcdY/TXLySLto4WIA2VGYJq5Aq6kC610Y27kqS6vVz/AOUIDEH0pLLASnkY8eb0/TZuPMnhchf80HFSBDHkAL7tXmgGysFpEF72FaFEijJaupXUrOgwNGltY33TgxOGSnKOglXzJsA+yk3pHzFvcrRXdbFefgVp0NDdMpH8UoYp7UyxZHInKSTkJbLwyTlMsVLKGVkS96mv9SojFmhHaUjMYLk6aTkhwUa6N0o5LDVAEFWBXGR1M4YKwpXtx0n2zZ4dEe1mkYILUseKX1U3IjmgspJPBhTiwGd0F7vNKXcZM2uQgyLCRkUAta8KcnmN6zhJwuJABdyWQcAEnM3Q8OKYt20f1ZfEMLkS/qN9BXaTima95I7BpQk6MprkAx9fE1+ogR8TijyYeNxzFG0sxWklRyRxuoGj4/I7VaU1aVbgXNZzsPpSZV1uSFs8M1JxuTNe+EYTjxxxBBdqve17X6jM/mytynPi4pX5DAnVHrImRkYhrE68Wvqu5a9f+RJgalKSIGC0QV1QFbYBSa3elldPDUsyzKyyKLhrCg+itBqUUAANV4oyEUSTVy5pUUeqhgftoqleKuT4+E/pUVxFuhFNa7AePBpAdGvIogURQrVa96erEbpmuAKvYDdMncakjV0sb0jtFYXDBHzaMIRRdldbDfI4rceRREVeLkl44YkFzSurxjsOX6i6KI0ZTbi3yfVqnJxQrss5kUXsKKIrqTXETqOqnVfqE0schSNrLxeHGHMaarkMeS6W/YLMmSDZUiJNNkYuMHXqchu1+ZHGOksYUFpZbno6iimiBYzEjCL2klY9FpALrKo6lhcNZTzSYwijUPAmkOT2jQs0shUN9PlyfV+gwy4/HieLqSZNG36nMG6XHhXCA4Qqj9rfMgEAZSsIuUBeWLFvnplLI4ZWX9RiMipIxWppnfqIlwVReNGE6oUyyqVxW9LioLtbGGMPFkScuPk8sg6hSm47A+Kax/Bq/sdhgB4o96390lwamIbY1Q9/h5+EfrXdqkKliVBFW+A7rWPcCffyTRuaNxQQCzM1NIL6NdUk2piAB70oF/xWq17+GJkkApbJFqiR4pYyxpEIAoXA2d7pvNKKNapvFG+VqKHIGpUKG9M5JNTFI+Pg8lceSBwQ8YIUrFtAK7p2suq5AEcKw3GU981HuWTjopPqDK3HklaMyVHMrhrLhUQZJYiLsZYhC8jR+qR8oAfFQS9DkI+SyGTjgvx+TEvVihkQRcnMtXH7Is/FBljZixsD9WZkauU5vrShTirBAXmkZzcyXppfSFVjV5C69t1+vlqMCo+FPKym+FQJHxtR3lbESEvIwtyZnZxEl7QwTSSFclI5ZBtELheCqI8pZsTGseBOAahypgtwioF5EiEEsWppI3sUYiuvEgOi1JLgCIoVjJB2TV1AJ0xjTr45OWp7cZQR31LEkih8TUMzghG3UsIJuNEwPjfG/wAE0f4lUo1AWHwuPfyPelBY2Fem/wD0brqH7tgWb0n4teihaliKmrDVeK6gFPIaChPPqsMdVu9RHKjW6v8AAaFIXIu64sWW1XNKCCLbKq2z4pkR2IV8j06eNBzLbpsFA7dyWFse6Tq/Lx+qhLHKw+ptlbPLzXJGQht6Yh04pCSbfKkQC9ce8WOBKh0KzDtIGXbl4EpBfHYPG5jpEE3jC9pJD1A6tnFL32AkB2DSfS55fCyvFJJlJ7SM6zyMLiuHxUKh23UxjiS+Apg8iD7FZ3wuTTK85B0EmcgWRLsp5nIkVicmj43JLEmMLSR9OPpg3r9QOJh8q36cidQF1yr7XXKx7mpYCfyaHD/NqMSq+OzToUF9AiAFiz3NKshkNrIkSETh91JqxNEgRbqMZSX+0tnsUrWIrkNGb+L/AHj3qZbrSbX4W+AZh41WzVvgoLXrxRrdKRJr7vha9AUUBrpipo1W1YhQfFsWKKx8x3xtTqDfuF1bA0HVhqrXorY1Y1iaNEUsYA7jTKAur0oODmsAWBHltsa+qGu7gkFwOo26t01/MnJBVjIi5KFcqGK4UjARIxNwt5LjqCsUsM2tGXWRcF2pOKXey1JPmBbwvSVXGyePDjkj2oqY3ZAa4y6NmF0i698MUV4JI1s3pYqkRzuy9YCHBfE0obixC2+HMnSC1EfmOYQwsJfST4qMiWaxFhc9QkLYPLKeRyFxuYuRHxoz2u4XPlI0ubIONM+GVhaZ15fLa0gCcKJEJIl7mdUiMgsSCF37wSBhY6Z5gL4i5jSxzc7kYW32r53q3zaeEUtWbn/jWTIRmGdiXmkJY4i9mt5BktbzTZkm2h0R7tSoieKlOqTx8PNYkVav4+B+Bvbfj4A2Ip/VVtUpFD4MbXrTuL3sEAJ7RQF2ud1G1vNTAa1TWZQaRsW0b0kgYV5rV6uAxFHYroH+KTIk3dWUL074+OuRr2uDailz4pQCwJ8LZ8mY/Tk+qjltGCP3VyxkjZm9TV01TsxekZEYxIWog7e+TBVS+K0HBBPSBHR8Gd9oYonzaRLAo63MwL9YnKy9oxiLltVBqY1kNKamiCSvH7cZWwlc1BH1IUBOo7QzjFCtIsq/qrSKe3nzz8cxrHIufEkLdJvUZOUVjJXbxQHplpL5SsEiNqXiTyxquWCK8scE9nvXGAa+XqgRBioNqnDLHgqtj43Uf09nZklSFM5GtXWmnXPLpRHjqwuuwqhNil7PTGa+YCnuQ18w5JITXbKpuiq7gj1TqYncG34JotWVMczoWA+HpUAebWq1Wt8D8FkwR/uqNiVHXhKFkCi+SkZA1j2JQvRQGr2pZWX+a9Xc/hQW/ABVPa9W1r4DuU1Z1KtcV0wWsqiu0EjxSA+zCsPcm1AL4Ao2X1VK/bo1mB5otnVqAqx/FNfGSpRaNR4EKy9Rme9ccJLFkbWjdlkjjC2WQy8iSMIcEYjZCiyN1CMavHBf7pMy7Cy93TufTmWkRe1YlJWWJLEoFF4HIZr0kjZYIpQ8eLBS73yF5ZUKtXKYNyTRJXjIANmU8eIWAJDmSVibgSKJoVYAk4Ny8XeP/UC7FUjYYxcMhg7nJmNOtx/MNlTDuA5XFZorRAWhydlYqkRRikV8K6mP8tMq3Vl9LMOpHRHXkZ3GQm/02JZQaMmY3tUhVvcUYSPxRT82NXP813Vv4G/tRvVvzV6HkXoDIgV5Y28YmrUx38Y4zJ6ahcIrW8dY+9dQ29NqEN2ybVMbmh8Ds16FBsL+o73S/wA0zn2Fq6rbutqVlFgRelAud6fIewoyYn1FifOqEqw2HqkRj5ZhdpRvzf6rsVsaEAABBrp/4rEey/DX91q6pHvUh+mfzKvYCxopmji9jxmLwEWAqIN8zLGRULqnXKjt5QsAvioUMEUj230zfWlj9IdaneX5h4gSsfSQRr1C1lUW7YwBh3em9Qs8TFghr5yA+oOKfm6IhS1BCwt7fuSX+xF+Zm96ggGJGrOQiCuGJDz5Xbx+oRlZopI2dHh5MmfTPcblwO2jRApHx7SNcvjrHZwlxwpmjJBmtUhCPiWWhvKI1leRL1AnTiyqe8sTJUMmUa+bqbVIpfa1Krp5r6yea6sn9166z11T71nWVZHIGpGMrA2tVtio7AFqQa8f9LGoWZO6gTsW0gBvbdXtRY/g0KtTMLWFKKPcb14Fq/FWJ/mgn+DTOEbHuJzFhl20ZFOr0kiBycbkda3YmNRIkXjubLd/JERbZodtb/8AGIrdYC96Ma+a6S09vpJTh3YsouyApk0naFcm2NlrIEAZVAAyujap1Isv28uUokca2o3lSU27nxjjsrLS5yyDP1dokm8Z6JARbCZimMSG1Me3ultSXIXHJjHBZyS2RYNv/bc52RVISCEE2oAL4qZgFLBhXGiKLLKVxP6nHkuStauHvlcwULCn81702mFNZ4zUkoLFAovljJF1NVLkCKunIs18XuiRYhi1OnkipA8VnTyOaihS3aI5PmA8jEmOGGAIuMaVMeHF6wBTvw3uV5SmrwXsJlU9KXyFuMZP7aWKQ108fasC3ijYaFD0UPHwNWrAAWvaiqk3Jovurge9QzyZyMSSBNC3lazHtXcaKmvFeq9LXsfgPFTFmsmZC3Co3aoCkvZVsaCWB9RoQvYD0qsCD+aC+AKSMigFX+K8/A1egRRYhgMTWF/anP1o0A1KpWMe1Ti7BWFxEZWFggEamPQyqd5Yp3bEFHKuuY8S9Pp5m1G4iDjzyGjKsPtdikqlTspnyJPAIAWe2zU+HXCixO/mipU2V9BU1XW0OliQmXVDzPZms7rj3GKPBAKmnVWCpt04XLnmEsqqiyzxIGTqC/LfqzRRCv0/6nXm9qIrIEnGhck0ikLuucmHIuBQ6HKKuWIAyfjozeSChv8Abxp19D+TrwaeMSC6+RDgdXFcVXlWWKQjqwFkBVq5HGE63sLtxIBclGVn4D42zBEfBlRgQiGom5Ef9Nmr5t7WbjO1SSQneE6Us8F9Si8axOwXNSnSK3t3AUaJv4pVp9k1asaYG2qGQsymzI6kldKbWrX4r80au1IDs0aNq0At7klWUPnbqdxNsdDiqgxyNLGQNUkYtuhGnuauBpVrurEf9Fr1jQP5rKiCk0dzepl0lNO7c5gTpmEkTIPOaCOP0mubxx0oWLY1HcBho164xarfTkvdanClz3gDjJ9Y5AEyRt12HvGSHLE3KDOCRrxgRS25JuoNcixS0drx2Vi4yYNJJIxcKMuMJVWyNkeRIMumZJLjlR8VLQRy5ycqbzEHkozcpkZV4oWkgHHikP3/AKenS4saH1CpJAoNzUfvQsI8qeQLHlUSPzOU1TcaSJl2pMPdBJD9/tUca3uprSxm5oSbFvLJq5tXTy2RXDl+Z46SPa+K1ImXmmXo2tcooL+LGkjV+03B6ClsRqjBh6XNSRhgQ8YrjRLFJYWZG9Rpx7++iKC2q5OS3+PmrVapEa4ZfMTsxsavoUQR4q//AOqis/bTVfzQJBDWvTMC1xUagtvR9Rq1ACsRQ1RPwvVx8CbKbUIiaxkH81//AEqQueSGYAAkPe3l+GJJuqpNKRE7HHJrHFrNXMDsYl80qqoYEb4je3uzH0+0RLKjP6uIw6oYLauQ2Tg2tQ7eSEUGo43aayJkRGq8m1SKcFGO0gAgBzMdKGwChiWMhigUKwRMb7dWxgadwSkYjTNzbuZ6hkCt38ZrcuTPrSN4/Tsjw4C2zXIAdWDeEkMcRbyIkORNfqEuKkE1+j36k1SRdUWrhonHlk6g7uTDYhsw1Ih9rVLFI2l1UUBFrbpIm8sa5TYRFY9txkEPHiXVZpvvFZx+xvUmOO/Fmjdt1FOsgy+7OxONbPub5n0ybAXCy+xYE3pmuRTdgz8jQPmmUmxHqK5ePOLf2msTRU14rRpbZH820DX/APlb8e3GT7qkUg6o+SajHeKfea6qBcaF9VY/kUKvV6vWVXrVef4Fi5HsqiiSKvQu8pUehu17eKZysEv20scpDWa0fTKIXzuHKyxOpooLwq26jVFGSKKmjhJFrXVR07ZVGAXuval43Yl7gIsY5AxveQNFPY3FRsByZnFPkZdsWbk3+WEbPYQnvkO6Y9RAUXbs8oAtZZFcleNYBYZo4nkHdl2M7nFVHNQzpGsbfSiCoiKPFya5bYofzwVcBwbGmdeLCWNcyzy4te3DlPH5AOOjIt6FpZN9tGJXADC9NxWy7VsBxwPX5ukehTz+fADtJM30wxXkqJBmvUjZvmfGTVBx38meQUZeNF6nkeuoWkLWtVzC+YFw5vfQIZg/cK1Lo6YM0ZxatGraNSlsSiHujBRQvXvQ/wDFHdtXLAebhaORADP2sb2reQ1elFASB5dUhJ80rdtMDegKRekuzUly12prUtkVnbQc+Rao7YCt0tb+GzRIFFjQv4XdYAee44E7NDVXq/wjYocHIzABIdm1Ot4Kj7vuukT/ADMrkk4TsRGhoRnJi57Qy3CDVRnLkFmuabEE7vTkCQ7VaBaxv6g5Eoextyx1ULlrGJh1IywsIWjiBSxErRiXOBgLRr0GOeLAwhkZywyYoMVIBCOzypJJkVUHCRst4tobFWwdmbwJGQC/p64N6meN6jmjjJsb0/J+ZlU+Vdi0jWN6ZhdHF8+Pi9zUSkODlde5DvVdS3lSKkkI80WZjZfJhXHG1zFlDHj4DSSt4a1Hqf3GkmZdNUhEhuKyA/yhJYsagJ6IBoXBNH8ihhOncKkR4T+Rn/itmsaxqx/NWPmgg9zRxHwcladzfE2oHI5CtgAjxQAFstAyZBhX53USBr1O6F0QG4EZckmgDWNWo1oUzWomo4zIbVdVHb4Rf+mxrAs9h3GTAYxL6pQFjDNlgzgdQjLCCLpxD3LP1JWBNXzsnvhZi1+5YumZnNyqCVVV8RQJk5GYUBbqEjxUCi5xKezHOEWqOT6jWN65QfrPUWEhZGqWK0k6KLF2WyS9M2cr3buLMFYZXHH75BEdLP1ehyGOILhY7FHOY5XTUvizIjowJjl1JmzbkiAPCS2U87BXlEXH7Y8DCqhyWqZuB0mBZMY1Q8eMNauJMjN0w2TadReiGTwTUp3uoAcr1LyJJHxU4qDL/cTSh7ftsKKmijVb/FYjyaOvA1x1IgYmlJY39vuYVxQLE+5UOhuLh4LE4m1FXj9YApJo28BzS9EWyVgcYbZe30SPXTpke2QUwYkixoCw3Tumh5LR3b0Y0i2U0F+iTR9qwTPPHuR28lqOOXT98c4pUBsVEORATBsWXTC1LbzQNE1v4PTH2qJcEJNDZoD/AKbGpCSk2GqiIjYfTtUok+YOW45kXFANuBeFNWLKqyMQb0InhUPiaiXZpnyaNfsSCYqCWtUalVUL3O5C2VWvSydIITcVMUGb41L0g1xZXmZpMHsRXFi6kpbK1ckMOW+ZvSmTpSw4g0VaAnJNgdroNkdoHfppyX6jKMuTx3ijtBDiuJDGwWuNAjJ9PRZR1C97VMPo8dVaumeROLEXHDhRRauRx+FgmaKRIFE0iKmSHjS8KSJwwvxbnjqSLUVb2tU0RIF7VGLBqbJbnyYYyii/m+/5yIH87LZVct6fAQf5pYxJIATqSTLtTwA1heiwUEDzxgRc1DsmiOowWgIUYBQtzNGPuY1d38Qsa6fIb2ApuPN/dXy03tuunIPOVCC/tRj/AMAm3jybUy4wAVLpBXlRU0pjY5G0itc39kHc9P8AuUoIH8eKDD/FZA0LUQprEfzWCJ5FbkNBQK1V/harfBbICPZDG5DhbGdZCQRRWSWwLC63wGBFW/wKklJIhyNTN2uguKks74doWWfFSV7RA7dEADZU5KCN3vcgaYR4r3DIR5W7cWiih6KK5GefR5JWF71O15g/kR5rHJ7U7POTewMUkfaxUElgJACopXXpA5EnhzImfHmN0l4TobBrLIhgJDeOhM1sDdWt8lwmHiAiLkswQmkynx8qOVGssuIQuy8QFhZQDPF0dO5YJKrAJlc5GmlOJoC4P5HGGYY7pr2IFKbnFNs2KnzddyWBNBR/4ZLgX8RMLSSe4hBF2Ovl0/vpeNH/AJo2UWFcjkrClh5hvGJD5KxSG7SSb6qi/TjJomLWYyeTgq5uPp0eLKV7ZJCeqU6eKhSnILH1LWZP2NU3IhiUl8zUPL4vI7kD1EcjoalcMQB4cXsKfJYnZQSRCOpHOGPUt7HZXtkFq5cYzNqicOv/ACtYA0LGhb+00zEeKWXe1ot2RGMKCxB0KQWFE0L1lV6v8e1lJZTXFWOSxuLTyEta9RYjM+soJhmGQCmMcfcRuP6SsWX6hZVR5BYssbqi3vTnqOgQXMbLmX+xjk5aiUj7chk4RozGi/VSFZOQgFr83BZI998QwgXfdNG6ISbKI8lgRcbtO6pCgbUjAdST8Ouc0RDY10z05vStPIZBx1lsEicSqyZamjZJWD3pUMbPY2qPiW/T2iao2VORE7eJYVb0HuAVUOjRcN+RTNLllkWKSxK2gbhgR7UAD/Na/imdUGzankMpt4Qjox2Gmb9pqUat7uQotTSk3WgCIgnviGFrUYyPFZuKu76qULEn5KAJHvdM2Ayf1dyqBcRhMSD7AEW0KydtIpNCIM1mcXPTBsMmrpxt9hrocU/02uFjHiM0WY+fEkpW2NqAfMqbGpGXBx7Rlfl10CLHI0p7wa5IviRY1Coterdgo0slqWzfzUkZG6hY7Wh6jV6GyKPx3QNaqTKxX3EbCDFLXbtYnwvakBxJNBx8sq3vTMDEjnzJaxaxVmS0JVvMMS4ZtkwmhMasgN6CshZaUjVr18uEle96XHGUuLpxeOYFfkttuQ4C7YvUeUPH6D36p5RIEQDPUjhR6yW5MsnJmVO2sHyvISTIhCRH7nuwks16aTSe6cWd0VCCceTDE8TSkNW5bBKacnhO9rFIXfkQReKMqmQtux3YndPF7j4ZH80vIMTekivmYH2b3E4+2RTUksTf0ASHAPbCgoksd7Muo41972vRyZh7UIgALVmYmZtUJMT+Tmh81eDd2puTGvpWgxlkLGmN3VKa6mSR/KqWN22VUZeoEnpJez3bpTOAHldBFEiLiiGwiYX7abqHxqhGSR3Wo8c/bJeuhJe1rU/HjQXkarxhVwuBiAXK3p44RDZL3HrpQAakYvJ23pEtZac7NMaApBa1MTuoVu1e/wAFo/Bbb/JZb7tXYfYiuz+41DYMBqpJBFAGCrZoWlxtUmS4JsUUAJ1ZVC9aPLwwPIAfTAIbqltyxtADhJcuBJHCn3SyWYHZMXbIDqz3N3vSI0mERtaWSJFAsUqF+pyOoy2XqSyoQe48R0jWbJSKkMf1U6IZuPDhydp2pC7nIAYGAyxiQNeSVgsAIuTFEbBpLWAursa+Zz4WOVQ2xkjOjxPqGRCbjjkmWQktW38DSekV/wCacd1Wq/t7X/gUUB80OOfJasbaWlXwKJzkaT7EXEC+z353IsV9ObeDtrmoxne4AGR33HE3tGo9Rv3RBcqTEbA1aRJGc0cnIXzWIPauz0UHa16zwsqcWU1HyeO7YtCY2zVVDezs2VsrnkcSXco5rRJxOuFDyMWqPPLNxis/MVQbbozyTH0HKzp68maMRD1XZo0Y9z3Jc2Yqou2YBLX1Cmy9aUfyx81s0qGtmghPirCNSvkj80oJ+BoVMbWHtkLg+SFkY3LMBg3+6ajjsEPlljZQRh2mEKPpuQ05Vo1b3VCiBmF6lByVMsjiPT4WzRnXc00rlSfFKqgRrcXchmcqtqN+mfYqpjj3davjyIcaCJyR33zeFkctmHQMypHinUODejVWkDsrgUvpaV+0QsRG+Wl+YZbxxIKHTiObC6huxHYZUoDi9wtHjcZfBJpoy1srIkEyI5e+oVIjJpUAWxoUfSalGTvTqng1JHj/AIsWsBVgPG63SxmpbQxOb2MceEUaVk55Dfg5nq2tlHIxIkYZFRbzs4l9E1GyyZFP2iskrXFObsIobYyXSK/uWz0dV6EJ+5fopZfVYFTdjZZ2ihta8iKDJ1npS7bMWFWRHuWuZSk4s/7b8oR9sZVFLzynSm3TiQ3OyzZCyLYRxXIy0AiX8CnlWM2AuZCzMq+AwuwjXSooFSOKypb0oLUECi7GwMn9ugB+fggOrUfhGt6mKtbGuRkLSo11hcMqW8Vi3UiS1DIZjwesXGx3yhAoSzCuR49eoE6kqkm1Rx/UYGpGuJW2KPcinLaKXaEaAy7GamIKodiuQQzxnys2fXT8dyKwFTAdUKul4jqhN/E+XzIYBgA6R8o3fqiTUgNuxB6le2IV0lYe8il4kt540ivFhfZwSwC3PUxSym9MkfqOdQ8RE/pjJYVH8VagCavsW8KpyemTzTaJU+LasKCigtvwKZiBqijy8hSfQ/hbeTfKV7ECN8ZH0K/miqqtyLnklhEkAtk6EIka+BcOsSigipdEFTftx+aUXZhT2sbr3NtitN4O7FQHkLuus1a9lFlMjrZRkMDsyEKskonkAYlIkiUWkI3cufyQUj7bhnRsVu9lochCNC9XCofYMeoRq1ROJhJMlrQqNVK/sKNzVqjUk0oCLc6oksbnzofACl9NGgKlYrGbUvqG7DLUxdbR8FcIATWdQm3do0pC3xNRs2Afw0AMjYggVyAFl78qhZvmExtQkBJJOpS/SYH0n0xjVK1hMB5T7yFOMuIRQL5ENeNB5O5je9TgDkBfFSWhlYsbjBma6kYZLNEHVmQssZ5EYbSy8aIR5robQ92hyD3CRbipQ3cY/OAk74/ABWNr9h74VsulBB2JDK8bhxkPC4/mrr7bqaYLryY1Nw77Ydsm6vYCpky2Kw/NAfBrbA7j1IoLkyAv1rkYITUXXYWapIwTH91LYCr32fSFaWcOfDuzSsVW4X1MaRhg1S+IRUfkUbrtmyrQaRvJSTSNQI7wfMjrGuY8vO0UCtcsz9WVz1CAI4lTwbLt0Z/s6JcEdawdcMUgKgwcEx3duQ10CxeSGoh3Yk+Z4ZG48i6Bh/0y9+NL2G3tKmO/IAFBKiUCmuz4+wv5+ABpbm2rUR7UaHmp9gCmGVhUjGWfA6jUWjAqzVGSrZY1n3WWijw4e1DusdhTky63UZNpD5KKlyrKMZyHYwogJTthTqOcUU9ONvAVSkPT1Z3yXdPJ0jG5pmEl76PJ6jkNrLBGC32vUx6bpdTNNZeoD3YRCCNXjzpIWldolN66LO6q18lBZWia9kyZSr/ubUm3qHe4aR6iIc2NDjsrZr3KijTLQUGgBapeOoBehyppMcYRiSW7rWMzNhEyUrOfXVqJt/hyFFCLqC+wiwofRCSOk4IOLClJv4eoxmT+BdiamYeB4U+FQ5UfGC+MQF1VjdY6YhpCfaLzHSJcCmYgy2oiwGrUvoI1R4okliLMbciXqSqg8Kh1fVRuR1LKrUrD9va01oiAtmbN30ztJR6l7tjcdax70Bu4A7iKkMRtlHI1S9XkI6Rwx8eMzQQiBI3Mgta6tsMvSP8Axjq1hfQA2BR1V/egQfFRj3+B96XzUxtc09kWN6wQczdy0sqxjeq+ZDbDXBYIdDavffgAnFBlelZblamYMCoDO/FW0mZN6iI7lPiZGZxIN1OrM0SgGkx6a2yCXPSAyuZYiiK1xUuLK2QvQujDKuQ+EQwJDspjQLfb2Uxve6oWaeJZLLXGmkA5CK3bxnZHPvUzySyZ4VfF75XWQBsXPkxdRdbrj8UuhkZjibRSlcrjjyFW7qON8wcaTqsT6LFitroaZw6kbA45untTk6/B0DfwpB8NW6NyCKf60mPtYSPj9uzRv7UzB3P4BgGhkzS3Qd5VQY88RkrFY8R+AsqXB+0SYu2K13ZXNH3T30Ed/AUhbZGwW5FyNndR5GwpnCo731GqQRRq0d5ZUWQ9zWpQsaF/Kv2TdeRgrwx3bHKgQLhO0FC1sTekiGFzcUkKuPYAQRgeo03EjO8ENdGK320Y8rjKh7g7pQUINiBIR0Qx8b6j33T3r3FRtkxFCjRpLAXrYk7vGJHFF6jAk5bEsb83j8iSRmR1MYj4oAurU6x4BtmlsdLpQxCi+zExS9j3dwI9zEPWLWMaB/NcnbhmW6Tsxivc5fUEdraeRflQAiiiQ2Se+2kist6ILyKlSXeENQ6LArG5IjHVljBGBmuvIzkW448QiMha1gmfJHSvbpEMyt4MfTdhs1ebjHs2kPIjy7fpseshZo+yiGwtJXy3J6QcPpZmVRmtR8ge1Jc2vTG1SZpMBHqtm2Wqa2OjQUWL42rqlPMi1m8uh4SMID+VIWRl80PJpST1KwSSTNw9Ky3tdzUplSxEN6aTkv6CEoQi3c7SVryaDm3aAoA3q98FQd+g75WJsALyHx9P/wCy/i1aUG1YgNGp9MbuQ87eoIkVjJt2JwL+wRmAzjBe2GR+63gCsVjA/Ni/vUecR/K07MviuoW82oXb/OKvf8vDLe9iRMUWAdQ2Gy5NON171H5oeAaNqsKNS/0vegcYp0vdoThPy3rm9SWMnMASGSNsUAxEecZVSbLfHQ2qsnqBAEZyYnxkb5e8bElnLbiV47hjXJA7SdGxbJSavYgGlcjjTILYxqlpCKVjG5tui2d7XVoleZ9WNP1YZR2ACbCLGQN3F4eQDdgg4/IjydMTeKZUlZmFlMgkdAKn4+VitHC5W4FS8QH7bFH5HHawJNcf/URszAAddsTGGFK7JEbKWqKTj/ZZXMy3RRpusWbHKpmH/mIr0wSxuwtJe3bJrfsF71vuhZayBNR265IonuJqEdpqIRSmQlKuB6UomV1tZqsmrybwUMCbrQUse1ST2g7bJs7g2YKAp/tIq9teK/8AqiQKVC3c1RRl3ytrkEpDzGrjIRFH3G6dN5HJF6kkm5LlAcUsU01hTX8DzEgClt2LFpNepFsMRQWhUhFWpXCm9MEmjK4ajgj457HkVpOtIyXllx39NzUv4tW73pe1qWQEUbCrgVcmtF0FK2EAJF64vGKQuZWyk5EgLdCJlY8qZuu+B7fppeNvSw+sDlTX+olJkQ2rtpiRSHBgaLSp0osrxghr33TApKW9sU6xJ0qBXmaLKw400UUs4yLrJ5crYDprhE/Us8crxWfDTgyAmXqZXgcSIDkySAyxEpvlxSECWwWvX1FOjA5spqK2qm48cg2ou6yREho7xycZZUFrsg+YhBCvegAgDuvavKUwqOoFaTkiWMZcdmpUM1uk4amSQ6AjFNxGYXxrjxvx9MgsumNr2EkLkgMLcgdPAioU6t2N8eiKVemDvZudChZRUeKR3pI5ZN3ajHEm5JL0JGP7ShFAUflySzgZWxKqdFjZGZRZUtRtcljWVvSlNr1yKtB4/sQmlhllIy7QezGJPPNIlKcaPwSF8UbRcUm++GmEQPubk/ykIAJepJfYVClxkfGa+1D+aLe1aomrEg2qeYRRi/lI55d2wCQwkjvYnAYhbaeMkD3O/gpAotVzQH82pmxjdqliMkiIuq5s44sOhcwRIkQtiJU+VlUPLYP8sCpyJq4N1ZgDKSPqHVQnvv7t9N8fY30aUdZCn3caVpJGibHOZTIuQpLPHj7qOk/rvXGlVJ3DWynEDQ4+8eEMymRWaOzNCcagnLqlvMgheBt4ueo5ja9RYy/YzNJlFyAtqSyTSLYWTtoG/miB7+DBYfTa1ZZHGRDfooAbAGo4ghJ0KVFgkkdVJHTy+pCQKWRrG8ZrqW8JRm2MmZQBBJ5ZWooijHVci7Naol6cSLVzRJJ1V1QVPIUicnyoBcKxsuRlO+1VjV2J+0C5JLAgA+LUF8M9GXFTjZQCz7LHEyRoQo7mdHsbzENE8NwFykInhRsBjm8kvnUCGfRTj3YoqQg+7O4WIlrVlNMsUZ8vdbKKsUQt5JaRtGliAGT0WaQjVgiBB/JYUZAPFXBoC9SSrx4yxGy0mZdiMsXl92J6Eg8Nal+aXejS89UciRZI6EnHm+8XMTf5oKaETVisQ7zTNkCWskYYtaUi1K0a5TSXwyflursAqYqWZCt6RLIuUYvx5/mIWv5lVklYsCaOQjx94IpGjLoQaklAwRwbEWuPeK4mFqlHSnSa1deGZQyGpB0nDLToJV7dsqhlBYZGCwd1VjjLG0Ul8AoWPEh0td4MM3j9HDWOc3bdTRiCSRY31BM0RvYVNCT9VakkT5kFG7FJYb8hiDatNWABFOoa4NLx2yP1akmHG7JbEQ8njMCOoLBokPrWz8mFSfqkCWeCNiGDX+ZhYNlSrCRiJlKCMCItc5cSI6ZhZS0h/wCNYE+WNNIF7Vo6NybnkksuND1SCrHAY+VQkdx7c8zZdCJQFzIvUj3yc7qOJ5ZLubs4J0uysZQ+mgI3sRGSVhac9slohl9QcfCGIiMHuvIcyQbrYIsPlnqfoN73Tjocnlbzc31s4sLk3Ii5MVvYHIyd171EmC3Pl5/YUCWrBqCsN0/ISMC3c0khYlncZ8eNCCzUZvZKUO33GgGH81vxU3ChYh0XB043LW2HJKUq8725GVGPmvpnYAjj8UFpJATaScrJyRjGC7yg2uZpBLyYkSzAxNMxBaytyLdsVWkPgSWmYGc4XxLlEXO5MzrKkLA2qCWbjFuy9T7SNxROQDZXoja2AWi4mje+nR5bYpjWpoze9A9M/cUaMFgQwFFBndNtHO05CmzF1S5C0XBRV9MohlwzawkBzv8A3dLRW5rj8ljYPauTw1e7IKjd42xfwRcUjDEXrKivuKeMkXvXIhk2T3UIVaQI1HiQLbHIV0Fx71yoxRIpOFBVx0q18vEJLmJTTRxBvpqKzCi1F3/gUzsdZVlav5NWykpUCqjHyO2Kpwemo8UwVU1oSTXUKoIV9KEXzGUQYi9dpvVurKy93TXJsyWxrMyyFQzRxNfGwthIFjuxu1BJDZixuVUf8iiKO+T1M4Gj2gtATvOljeUkK1lHBTwzE1GgRQAABLIWOIptVHyEijLub0s/Nm9CIgMXIb1zOa5F4VxjHdwuFiC0uWcjDSrpUUW/lauaaXHzXzQ/tJr5pgNQCm5PNb0yceOv9Ux3zwKiihicuq5ydO92kcgz85ZAYYDd4oSFCRao5YmBWBbjosHkXb/9VyhIhjk3lLlKkcibqXJIYwy1G3UKr9yoJOH/ADx3Dwj2pr6YDZujLJjogh8Q2gw4rRy/bOMy1lsIScsDQ9ri69pbNXwMJXlQhnALTw9Nwp7ld5gMC9KSfPbJGc9FbP0Dsio5tYMd4LKMWFGFobdMkrcGwItQ8WrVWF6ZQbgrqfhBwPIbqTRMOvsLKGH5rIqMfIwK+k3rze3qlCyv7iRORoLKmygfaMGoxP8Ag1jhROWlqTEfTvWV3F6dlJCrTqMo/NgwXJSMhJdsLbrqKLlt11Xb0rYZ2UJ6mztkE3T6QAXNSHJaeNe22q5bY9ONR37FgWvUapp5dLHM8aM7G9ANIct4lmXxXzE3j26xA8UZ5H/gXa9G5uT444EsqXokJZVWsZm/q40IoIjfbM8x3alBNzUYJ+EjYiuqz3ZbBevB/uvJSuuOuNLXXjHniTChPw/uWVa6/IJ+nDFiZOW57kitGDcpH3PkkFmdsivS6gkjGIFrM5NqbkAMRi9SxxSqRm4qLCAtCz1KtxYrSRCLJkFI/wBMdtjxNylQauxXEHXWg+WMey8mS+acs43sJ0XjQG94VIltUi4kd1wJE2TXDBERbxTxjkDA6qSCTFi6m5se0+RKyEK+jBy1xs2jIqONrQ60RBXuEfIyIzFi2ElqC2AtXgfyT/xvRLavGwostvepG49jlIBREQkyyvSfNO/7lhjMv9RWoSf3rYsA9jutkWKKR0QP7qsg819MfbckSuPGIWKOHbEUuLGQ7sipjYepcXLtWAZ71Na6xKwFBEGzWR9tUbaUeZ1CJHcbkDEouVPbIBK8VyII5XuTYq/UiD04DNalUSxSofTC4fsOn6YrpGuh/ihFXSFSxi3k1xU/1IoEDJz4aWR/4oj80ASdUqE0iWHw5pbpsRe8aCZ7BMw0/I+oPmApy5cn3ykB3tYmQ1AOS+kvXQ5babGvlQv7k9CQAdPjpUaFUxZgaYFNtVkZTmK+j+aZDGwkvTwTFyXBFdrAFGD1IMGt9vHYHNa6UsEy+9eGanWwyBqe4aN/bjccTQqWY25CSceSOMbjQW4zEeVjeVwLNi0Q2fIj/UBHdJsqbnKqjpRmi1lCuVDyKf2zpwyN2SCjFOmlII4k0ZVupZGTkqI1Z9DFX8YtSLEqm9wUkkGiQa+YH9pr5j/jXzP/ABNdZPftqSYNcLIK6PrtYVkFXEyMD1p3+/N0jmQAmRjS4ZX2pZUP9RqKKv3Cvwau38UA7nbAUIyr/a9LESCW7F04PkJdnN7Wp5kUWU0IUQG1TPgLixYM/wD544C5H3lu2C7u1nnA+3roPVoDljIWiY1+o90MiKO5VMSpHTNipNHXQA9PLjjYIwbCTi8+GVQGa0mj4qwqSWKPuY036hD9l3p/m5PNohxUxDlalIyC30KtegoFIB70SBRa1S2GJ9lYKSDZFkgcMrbriyDoAkBal5EcOJd1UlwB3Xp3lkPZe3QtuRqB+1FsMgFCjzc3PuZ2WKIu793zj/7y1IjGy7InheSIxA3bhiQcpPIp06kVcfBcsxU1+i3vULu+n3Sx5MVOq0brXE5J49oydcrN36h8QuGWxNK6Kqg2DSsHLSx6bXWWQ9ymNuRLmjUrdFxHMQRNDHyYiR3FgHsHazRSS8c2cXWVeHOQQQGkgmsBlkpjkQFnV8klm6GfVF+uEC9QC68xGYLfGomLEpqpBDjc6ozZyYBtTGSVR9NUWPjTxglJWB+Snc/Um7YuNHCLIlqsFFzV7+wox/jVEon3XKvHc53v9NR3SvdZEH9YhusAQSVp5xmPXLT8uXIW4r0eu/uFoQgHJ2yZWLHENqXF21oCPxrEMvTjyxJq7KMm9cbqZGJ8JdWH0+8PKGViRTWkLaIprsM/FCM29rC+HHqyyzLIdk8fitKT0wWiMmTYuQJOSY9EklWfmyBBfAHDtjApQHuMr0ptFelAFWq1BRVjV6bdMPpkGkiRuoXAKxpGFMai1IBDJ0z6f1jD6TN5gUyOZWtZ5LeKGcrkClAAIHguL2A1PNFxrsbFhyV5EpbkpmnTb2OlbuBapnXF7eQL8d3Ni4mCuiltugvmKIj2heijRyBmZjQsct90i3ZWqRLEqSDUMhF0bdLHfw1qQaxfGn49oxJGddLjNG+eQlUTxd6aoyxy/uXUxyzcYgg3E8pku6x3MZuh8lTC322lWLkSo1vdOZkpD3SvoSdurYmPwxoIxRs4A0cMHF9S3UvxeOx/dkFfLx+EmApeJMLESIThyTb6Vq6M39tWkuLjUjAAEkAHncBL3kyrlfqXEMeMbXaHizThvrYBf0qH3eUUYBCQLk0s00oJQKFE5FxJFXVzAPSahPG5xHlpgtj5pmaQZCPSI1vagANe9n84GyPhl3ZOXVgb1HHcfhb5fzWyu3OSmOSW1wVkAJOO67+ndLsZCoGIa4TFofalbNlA0WJEj9O2UowgCjZ4o6S6qRcVe3qWMdJDUTKH6Z8MjRaNA/AECshWcdSTKgvTcgyCyVcBCqg24ypiZNE8n0LX6oFeDM+eB/7YGpSFVmNRqYuMinzvrIjaj5XLmSeRY2ABgky7yTWl8KKjhjdATPiX1Lv09Ek93qQ43jPg9YSbAtFlhi7ZMS8MsrqwuLToPakuCy5MC1ve1LHaRhcgLgTEzC68cRcgnp9tPx2Eg3alYIEN2C9LrNngArQSQ2IU1LFG4Uhak48vEbtZcDJDlu6FciO1s6N9WQ3mRJPV6s3RBHKqmuLOOMe5Q6y8njTfsAoRK0YFmL0vJOOAQFm5dz4yLc0ABGjFHkIq5GNSPnOLq0hFZOy3WZqadze8708yNdCWkpUnk/b41h8jJ5YxVxzLEFCMrFJQ2m7WmUNauLAphUmnhAt7Vi+/cCIjeFqVSCbKb92IWxrx5IFIy7qd1cgBqLWGKlVBMN+47PXPe1lF0a3TUGoy0gkMljSQLDbJQKlnd2xW9QjFGvup5DE47g1SXjhRX9XGQvIZPY2BkapRd1qFgpPmmcG7btEpC9ItcAFWjYmsgVZGtY5C/aa6hFFza9PIbDuFZsGUZWqSVVdQ7MzNBO1sJFjpcJVALi+cMS4ooFG7nJvHMdeRJFBG2VQAJCAPHqZfwbmwpzYhq5XGPzOESqTI06LGkl7xBeVJ74xwwhAMKliyBB8qeopH3SxrPdkvk/1Fszd6B4bA3JxR/G6YwmNGc2qdWN2uSsUiuAjG7GNXODEgBsLRn1QyyQMTG1cfkxyjufcnHDrbxQg5CRvjHmyTfTBkDRkpE4Vg2pYHclkbOjEnvda+XV74kE/6hNZmg8++4UwlbbmlhkhjyZe36fU7ReoeUEjtgSYnCPd0uJZVlZWVSpkQ8gjJrUP0/wCYjLNKbrxAwjTw68KZULCS1QcItfPvEcKwjBEAqQSg7K0eVIWISN5Bx+QvXVXuK9V0PqV3+6lOMVqQlha2uQVi/NZ8k+mFqLckDaii0nuUFZEfdejm5v3mkSf/AGqKz2N5ljExhRQyOZDaSX900pTG9gh6isFVL2XIv3NYIIzlmRgXshyqBo2GO2PRPI5T3Gk44wIytUy4s6UwuS3txTlFI27dnSc3GQnMLwofTOv0nqcl+NNakhhVenEGBMapJj1mrY9MhqSQBlS2TKLEljdo8n564+ZidMuhHE6K5TtEZhxY6yhylvfGl48cLPiAHZrABfBDBSb2EbhpyQbq5ONAKWAIDDnyRRxhcO1MlYlbioeUpjXK1yokbxYsAmXbtXJIIUiRooSjGMd7XzYyR2PKaaNrx+llHIQZXDcfMQnLdSxIhB+2ObMsCpFHDHB1vSJNG4ZL2ysT3VHzHBzyvXzU19yGOouW8qGElAThD0yp6bfNPgF6JLfQ5Js/a3J4cwTtvJRM0WpEag8LfwREJNgoTIxaMr0zl0LW+mawIHiumVtdaMMSdNhulVM9rYPEATgbUsJS+NND2jKhBiuQq+LXWpZ/mC6JZjxAFjKg3WVElVgbVuVAf6nVLqFK9zXxqO9gKkX6ru26JZ7sZbBo0cDBjUceIOQJqOCOM5Y7JjBLLZazi3lKzFVi7nwOHTABMUdqjidnOHcycdSCJbZAYsVhRmZpBEFHa8g60jWc5UV67i91RUEF3FiIDZTkwu5a5wNbkl3cmdcePOKUDC19yx5JJoXU/WauORJAhqNgqurVB2vKD6nkSAl27abkzchsY8gIuMONGSzEvOLJiPHGYjlO6+n1ccJQdo4P5btTIC7R8ZOS5LH6LWJzY6a2hauZzDFIsZj7YEWxOeRbLfbqO5LEmub3np0ugyNuhxzIA1rVcpYimAl7h5eNhe7NcMQ4K+uXHkgOrnKbjNDkuiZMogGIpOQT6gbl4WHqAL8UEXQ66kkahHFy3JESj6hC5qwBO2kXjFm9qGS/tymmeQObA1FP0pi7bZedgSyp3LNFzPqWZXSWUAYyBqXn8hSQVuOpw+R64gCeBA+43ZSYOdF6ZFcfNvH+/EVpeVxpFC52pwZMLEWwaM3FqZsrE2pSDbG9WNFhqpuUkJwuWabkcidul02QdKYmMdlRoqCwFWGNcqR4Y+sEJpOS+IJ4zZKrLCM/KsKYVy4bC48LyLov0rgzKBdgwqKZZb9pphKiENGEEXbkv0mpePP08DYB2ER7pAtJJDYhJwAeSshEcIJrBsAkcmIZdFYbil5CxIAAVrju83asWKT8hFNlAIaVZ3R1WweeJNWLSJeJcht+lhxunUHHswYsTWIwNSIDGy1whjxolNSxCKbz2lzjHL7zxq0/vRxjmc236rO26khkx2TdUUKy/Y7iaQ7357d25Unoulit4OJGq+CqRxDdHkJCFaRrM4XkzRuNohCjG2ndo/FrxRWQ3NSiZ3lZPHEWNYQzaNvxe0crKxR/Kt+KNpQQNMyMS66FRZXcayndpbp6lYScnXTXE8Z471HC0oNiqgQcZ/RyBk8E0Q7l6i4xbOFNAjd2INGJ1Bxa9W5AAOmI5kkNldRSzMyDsBVkgYXjkxpORNxBbttIplJY5Ex9VVxGVupKnu4qLl8rG6MJKT9Vjt33UrJDOnsQ/wCmRBThqpIufB3G7UP1LkN+GH/qcgY/RFJ+qm/cprjcwS+ghqedY1ZzXGBY5lVyzF/YVkKZrW/Nhjb3DFwATUNoPpk2Qgf5rVEVImSEUoOSqopxBGnUkuaTmPIwAAgCJxkf3eT505mLjxWPUkYhnkNAwsx8g9LjSglpLVHDx72Dk1ICY8UWwDdKysaXiry3YtfozSpBGUTRSDO7s1keYFx0kxWKOw3Ua3Nx5rW6Y6FZKZU/HCPYRXNP1ID7QLdZwTuU9nGPvM5zJ1SepakZcNXvEvS7MgE7VQ46oyckQMmF1RS5x6W+TdeM8eQrhP1StxUhV5rGM3S2ZL+Wmb33R5AjtfvldeUwODteHizDJWlNDji2Tx0YSCRqhjykte0kh+XVW3Q5Q1bVTF5UZoWAcxzSEKXs0dhEYWsp46SAMxax5JLIbXA4vejRkbbjhPUoFfWjfNJDj84M7SwCyrC63QoS/EV2Rlk08J0VFOtlOa6EfGYsbyJXRkBP3VE8YvHMpwEKn9o5jjhYpPqCuXg1sK71YMjWocrMEHjhgqeJeNIcPmngcKz3QcmFvDWYSQ5d6KpnPFu9gKbhaya1PxcbHBhXzHISH3kEbohmkiyYfMvDcGMhuPyIpABe9A3OQ3Q5CG+t/TIs17sCFFJHJHIxyOFzSvejbIVMMSWFRqC9vbkl82VJBi/y5APaajzW4XiymlbpaPGFMeG2niwr5XiyAYyNUnG5PTbuEozdAYmmkSkXjx3JnLU8jN2gFQkCC+QFTB55N+kSR5BIgHfKQM3UqO6Du9XqPmr1LPHmFOhLaeaHDS8W3UkqWMNGjP5hYLyCCbDRWQCpY2sCRSsb3vSm8lvAJaVWbIioYCQti1PBj5ehmzxL3A/qDNGOMCAy8F2QqFjtXHycySsoEfGZ26h81NOu39+PEgAZfMQSW4aPtaSLj+MFV+co7cWo8j/sSGgCxWRNFJFmOLri/IdROFGqWV4Xven5avJG4utZY8gZdyGMjYqfqIxe10ibpzRst7EI9jo0eNEzabcnHIU2XKm4zawNqEs0Q/Kw8sX+p3GNIZEDJdabiLftFqaFvAIanjZxZrtTF4u7ZXgoWmZhsT8fPwSGlPgciPGpo5Ijj7CaaO7oTdOXw57meFQG4v6Y65rJgr8MDtj5rCjwZxYGVlHS5mLDMMIvn00JFtJD/uJgzvyIh2tlXB67wCSS1Pw4om6iIMcPJrtYASANRRmxwkNGW7NFZxSsJUU0yup/gOP8FbuwJ8TnMuBVzcKNscJWRRuMQzPsMVDRSLuSZiFSKwx7lkgsDhIAg6J78cKAnWxSXNSvIZu5lA6THSzGlQRAhQKkKi2NqlBxZFH1AfqD6ZLJG5cyOouvL4wuDKpI5qvcLoQ/VBY3ssJm5L5G6zMqA2FcUDe7HlMY0jW+lTqdYG4qO+Z/EknkE7j/APpVxmkU1FY6qLpxQmTLthIykmfJirMMh1WdOSjTcLGOzHgxFyQrrSyL0OXixLcVpE6nmp7yiFcrlFTZtrkfMS8oxCUqi/pkHuWNRcfijtVlNdCH8CouO6IGBqWBZBceSS4CSGu5wUb91ip2BUfGfpq3tx2NsDUiAimXpOVFFfcURY391KjXiiA52tSwILEnTQL6fdS8bA+ah5Aey+7ISRZqlgVt+80B3eouS3GRICuJWRJkFWyV4X2AnQmPDckxciKSIjH1IsLsOpZS3DnNxHiV+R5TgDJAx/TphYyzCx4kiZWyBh7v60imFzqzd6lJ+oJFU1x3ZIIw6hS5ZIpc7V8zDF01kdVIMb3ItVqZMlxJNRSNEbNodVT+KyippRYhaZ7eTQVpbjeMSQpa/kk7t5F932FRRdax3UvGUOMBjTZwMSCRXzRH7kQdVkjmfAXykHTe11FdYZhYxnJHG8gZ9F78qRHChUrGV/UzGv8A07IDJTS8Fk9MdLxLC8krX6kax2jUKiyL911VXCpvtGMvKJKmrSBJGGqhyWMm4Whdpi3sp7hiLKWvm4HaiixBqGNzxpI8SKjAA121YgkiwqOI/Lyxg0sZiMrGyKhvFy3U74oynCxStXFjMvLgUVG7qT23HC726rbP6h1WxYHsyRfNCWa3qen5E6KFFcaYuMT6uVEDd6DfTEn3le/VqSePAXa1caS9j7VzbLKKvY0bEG9bZTel0KdgCiYmz45/8nitvbEoAQR5Q5KK1uv1S4RGUuGSeSU9HkAOv6Y7DKNjevLwmv1dPpxyDzH/AKqJHFspOKsgBWNTQ4ajxGyUOLHj65b5SweVMidbiSi2YWp+B7rlWKogApcY3Ua6comNsKmLEYO1fKGZjI4AP/psPt21/qIlJvmFmifxdW9V6IA82FMVT1UGkfsApON5Z/JuFsKKgqPyDKPTXUlOkkUtGSjyB2yPa3vt7XjHvyWQR3KZGQRizK1n6iOT1F7xHGA2UbMUVIWJxbPoksXEYU9OS/dMABJxoT5F7JMgbqNi8ywdvu0r+p26aKF5C39m5HZg2zCgdD1mxCSzHLoDFQ6JGEa8jE8hw2TYi1gEGqkYIpQVfS9wJ4vHJYM47SypkS1yzhmRqIuaCWU1IodzcCzQrFx5ANGMF5mbzXEEh5PWj0spWF2bIFeFiOODXOa/KIHpTGJJJMM2HNlt6I6D5RAC9l7HDCgQ6/wD057HxY9Nk941yV/ysK23uhJicGrnWbpn2XWvh9pq9eb01xeirsfNCE33VgLVy+YvFUEi5fmnk9pxai/RfIC7/p3FKJc+RZO6v1OcCER6y4M/SuMgKjeOS1tEKfaiv53WIsCbVJFCb3iU10VAOIKHpIGurmsbCxxsLgfuOBEu7pGb2lcDNhYtxhHkZFFfMQgLhMtfMqfxRkQ/aTRka11xRYoPdrrSNGgsoApuSqijyHlcKmy8WDXbkWDywjy7GiVcnp5YmNxb6jCoOoAAasdfhlDTFgxI7IU7rATjjzrbokH5eUbQvRXlKDd5RTluw2cGWZHCWyrqDK6KKHMe1ii3MsjkshGS8ck5FpHoCNL3IjocoAFYrmk4zyvlMTivU5H7NljMAjUm7PQDMt1iAqUkaWnZbYjuPD4qoodxczSx+ksADg3jJqszHVLHaivaakz+ZKx1y5WusKd0ndB9JPXxA0UK5R4HkMBCL0NBVqYv8xLdDG0HQWE37W+SDbIKnhxhkN700caS4A3WBjHI8Rrlr4b2yLFG8UJDx5crCw5aFc02OoZZJPJqVslCkWrgyOysH2aBoi3ilYU61bLxR7gR4rkxTprI0OXy0YpLJjStfxOiVB8pH3SSi5/U4FHbUv6lNIMYlJoceWUlnwJ+UUYllvS3i2MrPNNgBfIJy5FAHml5Lsb4UZH8kUwdj/CcZWHcTdBxhb6dOYS3Z1FpGl8JJKawJ0esaWDAArHGgWM3vdTRDeA1z8vyDpmjWni6L9R36jCRnNPiimsDKQgqSXofRh1UcEsgLvem4jJvzQUrJGiWuIplkZmjLhWlOljesZj6+wHkRx3EeyOu5y8UsXI/vkaulP8Ah74yfxRZh7Cjh7xmivH/AIFMvGH3Gnn46kCKMvKnFlmN5pCaHB48fcwAr6MYGKlqeGaftc9NFRUjCgWF+5fxyXs70yk2vXF4gkIdvMjCKOltGhkbyoaU9zE0iBf8qtciTABV2xOCHGTFVze446FRDA0ALEgyYiJcppLUBJLL1XFl5cvSgcjypubublGEKO9qKliS5ctm8TZIxtlfdOqzRK8ds4pFnjINDTsr7X/tN6jdCD7cRyM/FSEySWuDUJCSGxv8fFGx/wA5W01f4ogGnjDLY7HI4Qse0OsnBgF2SO9AIg7I1vFyUX1QUs/Df+mwr6IsySWK3c2Ei2YRQmz2WkibA42ycA2sy3bhzYAlqHH5UY9TUryKveLguD08WN2giXzI13SZY8u2opZhYqtY8gnJsq6MxN2vaFS5N37Ou2VlUAJGdM7Uz8XeUhYnkx27Y6cyvvyeOhQSP93EiyvIxuSCb2Y3J/uFT75A6FzQXlr/AFlFNNJ4blGiXb0q8lKJx5Ww19yMaWdUtYm68q9Gdf7qMyH7TWv+Qoj/ALr0OLfZuKSGGMHEVvVtV9Nd2ppL33Q1+BXqOqep/wB0CokDnHG1fThF71JsGSU4qXl5EwIWwhjEY/ka80GvcVK8YaST2igaZupOAFVNA6VTLGGOLG6AM+Xu3T4+TyMAvI5C8tl1hHHGnHQSzXqXlPKoSwAWCVgCIr05Rj1QO0XVrGMhYpjA38TKInEq+Jbfur3B4iQqZbkBNwy4vA+JXutUpj0ouWiYapTcD46r/wCxtf5DscTbzHOHv7HRqTjqxv6WlhAP1Iw1HicWX3daX9JjB1LqXiywLccgkCPkjuDkhJGIAkFqWOP2UGlmCAoOPiqqq+qLWMWrCS3vjkwV1UsSqKwmv1FWpCVBv4gARFv5zH82mcFTvSoUjtV04/cRct1JzdzXy5t/Ahta7UYwFO6dBHEU94yvUSLxVvY6ZphYg2Y8eI2LtRfkNM6Kka0sjg//AIxozzH18iNa+aA9PJpZpWJtKDQPI/tDVdv/AIppQ58RBaGA9XINZcNd2yKyzP8AtxWQKx9jTFx7isz/AHrWf/cFDH/dFK8XgWrP29iPdtBPqcgt7ZEdibZ3iiuTIDL0uROcpGqNQBZPCilF6nnUAql6h45JDsLszrFs9x6U/I7nOI6Kqu6l5ccWo0D1yJjyMc74wxMzdSUWVeZg0jPGHVVBYuRpePAwBkJzVxd23iI+tdA5yS8gYEb45DRNDJUeSExsoBEXaUIPSls8ZQgZsPJFRWdgha1TRorC1w3H5dmMb9rK1/gCDV6/mj2n+OkA9xqtmrkfyCFYfkcjjlCWS9oyS1vcSCxWTwOMMgwcYFoIVsW0rwSA+Ayo5F1dqBJbAsaZXVT36Odjg21d4Y520JI+RfZvI13kIU2sHHhbGs314p5CWGXlyBU7Zy6a4RaJOwToz9O5Ei4/NIzjuIoKNZbp8Q5ZjthzNPo0QJmJ8jmShUI8nMlnhjW7SBeJDGoiR3zlxJTjxGuty9fTirKX7uHGayjJt8swJmhBCmWdSBHLdc5nqPjAWtx8QYEA9NFiPbfTkf1sbWiT8UX3q1d//E1cfxVx7JTTYDbKtEvKdE2RRGtlsBeSXshuEXixL9ubYD7jeifxSofeuVyAAUQ1FGR3v6m5SpGEXzEoVzJINzcmRpGI5AKuyHS3FRQ5MGdsYsokH013yJf5vXHEgTFozaFTkSLY9OP/AGsq5XEdT1IvUGLKGjJAYhjnH+4cjZhcG/zketTcbkAri1w2ZuQy3jmhv3qb0Y7nWjkwo4vir+I5uRx/P1Y4eTFKO1r0CPgKK3/mun/msbVYUY/xR47uDeQLU3CHHivmXXvU2rIHTXFdMJsrapHkaxaJmqNmTUbFaiVsixa1ISAmw5wZHa2jqRg4azYyeMqEZt6iA5itk7Kobn/pw0cyMIXCNGbhmZ4zbzxiWLHxUINHHGQt6QgVUyYACWNDj1saWZdEYGhPY3AFGYt5UtRmnYWBADBf6jtSTpGcYlAVokkYO8ileOPoqaKLQQfihGLgg7ZM+mxAyErMLgC2R1ur+aMkaA1LL0lLzNYfNchvQgSgzmwcpkZQPcV1W/vqzPrJmqOAD2FIpOkXKm6CkCR+o2bNq2K5jxQuaChRc6EvMMnZDfFEC2PktG7EX7QixxjXjlTlkw0p+V40UdmRSYlYA4RWErrG2/VI09wAQSvHWNyRJk3y46Vz5ijFrmmeW57xUa/TUHzy+K0LmeKm9KulsO6Ze04yAk3I02S8i12CTQSAX6lsgwJyjNqkETaa0ZkjYaNzRDAXBBCFbjFrMUzezpZxJOnpkFDmTjzBevnmHnjyV8//ANthTcyQ+iJjRm51/XGKXk8pfLI1Lz8f3UK0Z1dCVprGJ7+Ndt7UVj3dSC8Xi/iGUvEL1Ikd9LdQSjDzi7pcFVNZF0IxOR4zFMgx6mHLHgRLUrxRLdm6jFpeQSgWwg4sHTtgDSRNwpGjF+jIDJFmnq40WCOpN2uEULU84CsGHbFxQG6k69TkMXjGunHXWlPh4nHVA8ycZaEwY2HKhrqApf54558m/wBMpyFE3GJwki6bcjgxYF47gxoRGgbySBQYfmi9qn5gW6jZTksDScoOPG4ZQ2qlnWJTYCkz5c4d/QSFu4oXPgXpYZW+yliVfJWlQn0qzVM8PHX6vexk5HI/cbpoi4XCJYXqwF6yEKZHzI8nJazeBb2rGQWstHtGb9i/OGbrRlVqCDpXK2MhIjjydyQL8kAyzFEHDjC3kkMa4WAJuxj4xferBUT8mjKxJsbU08dzu9SXVWdfI2oy88qL5OQMnpZenZ0PbqbuHbKbM2JGLdRgApsahkMdyCGpJY5F7/U8fb6Qa6PV7ka9OtrnyqSOgstnjjk4haxjaM9HNLKYzXyxtqHZit6hKK6Sn0ytXQ9zI1YMPw1Yh43UV1orC11Ek5dbBWx6mbHIazwvl4xbNVSlsiha5TpHE3gAc2TM9M3pea4/c47Ch+o8f+4io+dHe4kFPyx/clAHkclm2YkjCRiJaQYiwrUqE2oKUa/sMVckUrEnXqVcuRl5XlcvBxDGwVl60aCb91V43Ics/TAEfGK6Kivlrj0ChC6E4PiZeMSsjsipM7NPwIc+54lYdzUWFS//AMqYye16InsbsbdL86rtBIag7R9opHIJ3apmL2UUqhFsKf0RCo41jT+U44Pq3TTcWD+TN+pu/bGLBbnubzkaEjL4NqWroguTTFp2ufSoP5pQpbx2S83jzKI+qY0jgkYd0rLHCinsgUIpUcVNnRWbmyf2KFh4+CRrvtxKjZXUeJIC/Mql7bIN1sMr8u0UeANnXpkC0ctP+2/w/VPStQb4+6viQRXIVWiJIqN2MCm+5IY+kDjX9RDWbZ+akOKBhoy9vIgtquWiQxwsgxMwHTB94mZbWNRu35pSaaKN8SygnljoSKI9DI+b042x97kk17VH91QgNgp2OIxtxTfeK5eK5LFne5ogF6/TZpXsGckCON0bJAan4nGU6iAqPiwX/bFBQq6FHV7UXbE7r9Mkdp5QWuGA3Snvx9p/pwtjqkAt4qEmUHPdcFQ8LM2zLXJlkjbtYioWbBTfcZzi3um+w+6aHGX2uauaNKKYWtVr0FU5aoIvdqkJN644BN6Gw1H+jQAMq3qU2iFTHZqACl2fhah4pO65OygBlx9pyVkxGl5muMi+3BjS7ki5KqwjBFJqQCwr9QdxETfccaJxbKoAP/uasAAKZmJmJO+HGjxksL1+sTy8XjnothSKOpj7Rwxsikrv/8QAPhAAAQIEAgYJBAICAQMEAwAAAQARAiExQVFhEBJxgZGhAyAiMkJSscHRMGLh8HLxE5KiQ4KyI0Bz0jNjwv/aAAgBAQANPwHJC4uhM7cQop6uaeja44K0Vvwo5a1V5qhG7+gWMVdjWQcxPUj4REnqRioItbWoNiuXkNERbbsWrT32KMzjifVhFhCLlZhhzKx1Fl/a+8tyUmg6O6ipkMEQtYzFEe1DEPDELpiIoZ6sJBnIIjxOJ5LmdqxhLhZ6NujVf/JFQcECBEfHHEbI+YzQEg+mIzxXr1zIrCy5LGFcNEqaWqj9PxD610zuEWMLzQDnAIdGabKLV/22rVpmnAZn4ujC5HhCxEw61YtYRS2IiJ39F7lXJQFy29GgIfXyQHE4bkZl6DBapnd14Yc1SKKg2ALmvuh1uaNCYSGQrE1cwjjCzJuztWsH910kMUUI+6Gqgh1uS1iRbUT+CAmHbNX1xCIuAWFCvL3YvygK/lODOcf4WtrPFcrkhU6Ka1E+0dZ+0cBpFNOqSDoP19b67GipmNqj1hFsCbd2a8l0peERDuol4tikIby+VNiMj3VqdpqPZdFExfDAqMeGxGV0B2cJWUZJz1YcEQdZvLRlABrxeI71CWhAu1UcF0kXEpqMxPwhb2yWFId5Ve7L8pneS1dftRCiH/7H9FSTuT7oCl0DqQ3m0y6AhhgJn3anYujiMQtrxnDJCoEkKTfmn7sIf+lXWd4T/LA/coQHJAngxeaLTaXFNI+iu9VyQ9VMf0oS2qaR5rLqDS/UdPT6Z6hTS2fX57E7CKGFtzLV5LoyCYs/KoouArJABEtCK7yh4T6od4ehUcovuF3QiaGaJ3TCEIDiQihw2hF2eoIxzRPabvTUhtUMJQ9bqCJ4jhqiSZxCZDb+FL+PBDkt0M0JSBKxi8OwYppxH5sm/wC0bAj2YcYzg9ggAI4qhsAoIRTNCRAugDvT0ENEagpvK7I1kIQopp61KaT03o2Mm3K4x2I0xVlcaSnqn+nz0v1z3vhEc/oYV6uGiTZIIihkBtVRmURevNOQT7oxFyiCAozabFQ4qOYX+XcAjCKSRDxEB57EXJILgbc0CTusVrg4lnUZedziFHA5xJd1HqauzFWCssxfYuHIIVeTlAdmCg2lB+xAOyMVqtD2phViizR6OIZ1WpI2d5rVNNHLqeXFYQhEMQn0Cmk30t/7Vk77E2z6ctNsUIXG5Rh8m+E9pgLxEiRGzFUhepCffPJP3jQrWark7GXFQhsSj4TfYyI7IMQEUN6YIh5IxuIs2ZotqeUBcnembWFl0YvV7aqE3NWuoYmPDR0XhzQQtmhDJ8MVEzbfhHvdIBLcjOEPIAY6ITqQxReHEsmaKGoyZUBzR6mddGQXEriFge8h9Hn1j1COtkhS+htAHLH6FrblFXqVLoB8ioyGGVlScoc9qesGF3JQhAFKYI1NRDjNeEGcLYAIw2oNix9Kry0G9CcMI91HFOECeLujmxKhgLQu881HCIkUzw7MFranCFDV9EKgrVAIxhaqjjNcKrpB3tXVcCr/ACukkH8ok6IYvVsEAzItILWaIRS1Ti6iji1tW/3Qow9nIJ3JKCIX7Rf8isYi/qmto2rBlYhEd0QMX+EOuR127tZo3g9wdLdXC5XLqs25MDOyymFw+lIJxvV81A4Ob0Qh1jEaZLxHJUFuKf8AdqoJOM0+TvsWJmFdqcVfVYq1g2xfb0YojV0DMZKGEBGKOJs41FEA1jKaAbEpm2roA3SQYg3hTZgfxbBchs0MgL1TV+VrajQ/t0BJlcqI805PJAtDDbanH/a/1Sih1s08osTdlxWDLDqnQ7rOugrFWFlSLDQe7B8rluWKAE7bk3Wii/pM2KZgtYQiyjgBhv3U8lqvjUqEc0YIXiPF1H2IBldQiX3Zo92EVK2ra6MiPRbF54pI1JuoL+qMoch7LBAUR6GmTqKNo9WThqoAdoS49W7YYLW7p7pCiDiG7Izh2oO6sogyBaLb1MRMcusNNOthoBeHH+lL6F+o3LahoyLheeOXAKKsVvpCJBxuyQA3qJ56rh80L2IQPawQi31UZLvxRMDBdFA2tZyr5DBO07Qrwpwqw1J25J3Miyq5tuT9ovXYg2tmcF4tAKiAlkujihiHogYS27rf5CNyheDPVNEEL47UKlYISi+5Fawhgho+ZRGC+2R5LDpJf8gsIiG3RBZT9PrsHhwzWX0m1osWwRbajLYqSWAkuf0TfRCyLA8UYAYRmjPAJiIcyiHKbeEH/pQkHdgoR+QgzMuyA9MJoQmebIOYmmGZNzZCRwTzdHuhBXVhdODP4V8l/wDkj2CgUUbQ4tDpchfskVXeEDt/2ULwndJ9GOOi4WXwUYteE2jGWgWQwqv9ShQ6+qeS/wDllzWTLOBxyXNT1SDN8Cuf0Qnc/RmwFSoyNgAoFdZfWM9i1ggWCLttVc2+UGGa/wAnIB0GiD4hd3Vu6AEZz1aIEz5yUUIldCEzzZQRCD7i5m59FFrBRylzUgABMqLsww4Nj7q5ZzH+F4tWZGU5IntR9IHiZRQdmLpC3ABREERxxMd6jedtgyUMotvUGgPFssFFIR09EOrkhMFORpNlwWaAcnRx4FRtWvHqj644oiSCt9bV7LTltTAozihvtCk7yKPeNyH9EYSOShD7iECeYRJO+i7UJfBRE6owum/Qo4TrIx65wAgUPa5OhFOzYFa7g4LVI1jNhUlENjGeCDasA9zcq0RkFbU/Nli78kOjYQmi1dBqgBLloKIf20HxYo9U8s02m6h4/wBKGUWKi0G90IgXxFtPi2KxQ5rC/Wl9Ho4mf6g6kEmzxRptVESD2q7lDPBl3oYvYoV2LXgWscg+XuoQwHqgAfyF2kxDms1qgtYmD8IA6u+61Xi9lrWuHxTxncoI4hE2BpuTgPd8NmKgD/lSEJ8XDBA9o2h/KMTRN7oADSSgJBQduL4UYY5YI8VDwUNNGFVzVyge0TXYBZeJjLRwWFUbId4fZfgjx0/tNJvghiNFsUMFVr7yhpi7p6vrkjoAWtrHej9Ll1avZ1CXxKEQLYyV3UPdhPJ1EWzQLkqCe/NAywAQieQ9ECACFDwIKDHfcIQghuaI1C2xOxzAomP/AGm+5R9GACKHahEzXZBi+JdpqIESLEZIkAE+iEUgavmjKK52o0OnJQHcTYJw/qoZ/ITOCDNihTFctGHyirmw2fKGTaM1iENDNuUBI3ITQnox+kUyZHSK7Figg8UWbUV/o+uZ68cTo97KFGPtQiqifVeq6RnIoLqEMBkqlMAydx7qIzTdq2rg2aIJizyUY7RwyTAexUPTuMUWLZtVdIRP2OSIBbOGSjhY7blBtZs0SCRjgc10sLDKIUVI3qDkhXBGqIoRRE7UJkANJHuwej5qT4qGGWKhJZ5SqFCHGy40lDRcGhW7qn9konKZlTRgs6JsVlAUVn1cNFFraGA3KAkBEPoMhE5P0TLd9ARARNgjIl+z/a1A2UlExUQtiiyik+Cmor45KOmAUURlmPZNqA+pRieEiZeFRNJ7qMvq1OLlRAUoQoYQ3ymAfJpIdIBy90It2pdQOBsTvD5oTigAOkFQRaMKKcUVYYhlgpSNytbgECXK6aN4zdsHQAbF4p6H5qWqTTiqyHJP1HWGkrFYlNN8EL6DpHSEBYxTiKyEuKzOjgsRM6M0+l0+g6ogAvNFGE/+yhChi4larDJGn5Qaf4xWtdG2AQAZqGLDNQjtJgwJUYIkmkMyoBtmoZn3dRPOOITQGLEBXk4bNSPKToxgQqOFoQtXVIMp2iWprtm7FAEkYWMKrCcj7Jxqm+QVImLKsMQ91R16KpxUAtNPdGFhkhCNJQoF+zWKAJiOOWxM8XsEFggH+F79QoepmVEQcGGAQ8SPnjf3VXEbjgmlr04LxvRsmqt7rKaFhBNYGFisUNDSAqgJ60yXtsV8H0TQr1jExJmyd/o6szgBQIO0IttzXoFIA1OxCLdNN+yUfIIEQ4NgulA4KsT03lPqjZkhDzVYhg02UQeOL5OCEIGQQE34hdIxapK1meuxwiYhFtxQI1UYuaHRkvsTjMAlCJooxVigWhjbmjIvj+UzGyLonVi2hC1ChUId0pmcK5MLdTmsMVH6JwEZ6MVEXQ6lhmhM5o0CapmdwRynpy7X4CxMZ9l/MhbVmXWFBpAsoI4Yp4UOh0Kp0+nnoP0oipa3qQjC6E5Jni2qGL0ov8ZMWttko2oh2AAjFDk4TyQPLFCUJxRMhZxQqKamwxiiUUPeGFnOSo3mGaEc3nPB8VQNQoY1ei1i2y6YHcJTUUDtfBCZhyTeHBQ918KsUKjArvE1V1zX7z05LH+lmtqxJdXKjjCppJqZyy6maH7xQmdqFFxWHeKwA1mWA70XwneJ76Bo56OaeeKuTQbVGwfnodU6x+mbqEzbFDwm6iLPgMHRisodaI7VHEMmAqrId6yI1ont+EYhA2SE8mwUcRiDWsjEdUDZdQFzAZuFC+pDRHsh7D8qLpNUEVawVoqCHHejAWOOLIBzPuw7FFDTLALpMKnJNysAoi25CFs0SCFF0faFqrox2WllNPopvsUfW/Uxp1IJD3VSjass0T2RcoeuCDuRoPJOO09EJjapaHmV5IA53stmqE9IpPsxVkSZZIByIhrbgvDKbbrrOvDTgKDaV/x3ImQtsCuVAGl5jVW65r1m6kQJAsyNQmcYsnCiRvVlqgDEDNCJEsWRJGJAsgYQfdO5TuFqFrOm7WGxlrauxRvAYLSNVAH/AN0WMJyQoHeaELxm7PRTEBNQF0fZGeSiDtRYLAOhjVQQ6ucS6RiNmlwtfrsngf1RQhurJyTtTPuUPi838clbJBj0sQ9CndPrRKJemW1AbAgNmxyqCb1VADMo2TgxbE9FjFJZ6eOjpDX1dQodbn1wjanom0QQsduCmBlgnIwKAqaKTbF0cIO9H9KELjcUYxtUDl10nStuWsTlgET7IMFHGRm2SgLBCMvvoUIe9DaaEOxPzXSQh9h90IYgVB0kfyEC8OxA8E7OLL1WGH56g7v3RKXqnRV+pAJYayi6RwhHyN1HCC9pSKKJXS98oQowvFEbD5UUWtGUXRiATlkC+gWs+aG5WwG9c0Lic0Bzx0XeyNA09FdE4OjOUM339f8A8R84/Q1XOxM89IFi6at0T+unL5pgzUfNRhopN2cVEWGQUZAf1RjA90QwWrAx3rVFaVWtEdy7OqcQ80ISUGNXc5IwNEd8lAG6Rq7UYZxDxTqgMXCNH9FHXB1ItixRrDgiwgPqmG5AicPdCMzkdOFt6l+j6B/ZBQjshEz2CgQdYoUzTs+Z0fsk81+VrEoRiW5MSgSpIUyzUc1tVtap2BQmWBzXi1Bq8So3AMELsNpqUTPW8SsAiiwqzi4UZHYhpCLucV+8+qxiivKw+g4UcfKBASwJQ0FNhJEdm/FPNpFQzmF2BuXJCHxU27VrWruOj/K+TMmA/pa2qdhTADCah1fyjMbWQik6MBciSMI/QoYiJ4IdmL2KeWRxUBnjtCd/6UPdCK8QusupidFN/UIQGzesaeqGYIRxDDigpr9cq2WaucU+8lO8W3BAfgJoiiSiiStYoeG21ArmjQlU1ohKfqgTXtNm14vRYO6+4rILJAvq2feiGi6SMh2yChGrEfMPkKoRodF3oo5nE4bvoQB1AeRRNPfSWRARAJf2UJLpmhlQLxBuSZwiA/FOZLVbtIFw+GCidDuowwvtURQb0WsdXNAUUMwd9FXnRRSGqph0B2ekGGawH/8AK+1SOBXJYobV9s1mEDIaDXBDRfABeyhr7DSL2XloN6sB8p7CQX7Mo0N9q9EeMR+EZxmwTasKA7WxGfFURiJUIbeoxrRPinngoRSFaoEEAmYPysWtdY49XMLcn5q4RsahQxQk7HT/AEIxyUMQJ2KA9nYiO6ZGWeh60Q3yQMvlPN8bqskQT7hEtuCJZt0lBFDO6et5pq+6gmCitRlBEBFtUMIeTauSELvXWwTuIYKPmjCCdhQDzRCNR8IzyWHhUU4h4dqMTvnkUBdnbcqT6hoguKxElxXAcFdRT2aAjRjLguPNfydPVmZYxmXBX/tY0Rv4twsvKKnahQJ3n4viFepRRlDsuujH+SLbZRShRoPgISAFzYZoRbZhGW7qHl1L6MRRa8JbzZIz0N1nKgAntohqQ72QHahCADcFh6TQM4c6EIlpo1xBT7kIeKMUsinojCNyEnVWIwX+OE5odnIgqEoRPFDRl0jAi+5S1WNJzdO2qaoVNzZRy2YICugmcMVH/cEe69DsPyh4TIhUz3qn9J9sLbF5TRFOrjJcUbo1ROnVTIoRMHwEnWQdZ9kL7ZrA9qL8LEzP4WENd5WEKzWVdP7JD9YImEKMgtho6OITzwhWAmVUqyPLrkMdifw03qEgzArijX6AUUR6SL7pyC6SIxEjFRlo2shIbkWadcFH62WsPRBqXGgGewrXcJ089lkRL+SJAfBxNeYiexRPsxUdYcsVFC1JbEYf/SwfNRwysAQjBPNNqnHVuyNsDoKsWUVRUHYrA96HYUbkdpapDkXx0DxQ+xWEVQrma2qzaOSDFOw0Eo1QRn8ALKQW1ea5WA9ysBT8rCGQWUKyXHRiZD8r9oERwGKB7RUIYJiUBzNUU2g9c2unnFFfYEM5HQOfXModpQID4aomjKfqiHiiNQasj3goC7ZIlwc7IMIxhgQgLLPRDOHHJESiXiCzUQYowjVeiuwtiriGuScmCeButU6r2xUDaoutXhtOKbFB0TLq5UR5I1LKzSTTs5QE7K01howovQJp9TVKggBKFIbDbmhe6HeitshVh85o0QqVjFRHH4VmRNIanfYLywduJeaKcZ2CyPe6SJXPym2KMAnKGw6uHz1rZlHefwr4Lihah3FYxzCxBdYienC6hr+Sv+lCbfdEoCB0eJOLYrWcQmu05K1zxTZJm+ESjCZZPJA0vuQMohnSSdENvqEDMKkVmXiwXsgWh9wfZGcINkC2qiTL2RnqVYpqGu9GFFl4sc0WD4HrbJohwVgn3K8kGR8w9FEHNlKWuV5RNzmsq9QpgOCuUEFYW2leqE28MOjEFR90RGuZyT9ppGP8YBA9ogVPuvupwWWi7+LIZI7tgXorrPrkSAVgKBDqi8MhFtCe85bluWRAXlBeIr/p9CL5lXwAsAujDxbTIBeIrmRohIDCW9HicESRP3QcELVqooQXQwxsUKj3RITNnsKo6YTFGQo8nxCA8VYV+0UJ7MQlzQE/yhUfCqEyurRdbNREMdDrYgE08euJ/Cjmm5oxLWbYg1dFdp0QCdhFtRqcsfhQBmGCpDCpSs6ONBsQuUaPYLiVtlod0LDS7Qw4lY/2uAUWNVd/bLr5kALisIIHURcxx/CPHejIN4cyhlzKHeNkdDOWoUzMnMlrOUHUETe6lxV99QqjYjKIe+1VlTajwyZWQMiFSLaMMFF3T7IFlDQ+xyQqMFjo9VeE+ya9eqKEK0Q0FYLmhSKGUQ+UBUdTFViKaQyThCElO+9ayfcn4q6jidsSbo+i6QglsLKEKKIMgF4YVmnJDzM+u7IDgsoVidA6g8cS+0Ej4WwA8FuWcBVjMg/C/nJRF4zT9CFNUSTTV1uUcUsjgyPIod5ELooZ/cooTI3NtBh1YYWm6htkrFN2WrEoPVMP7QPZURdO4OBUA7WYxQpF+2QoVy0Z1VuplVcVsXJfZEnvXZmuC/boUN1wKzIK/mt8WkmuQTTyVBs0N2mrsVnrwWN0ef4WvoDPoELg4FGAFAAIkCE5tVQjtD32dcFPL6HRgakNnZ32qHCHkv5N6I4xFbSyzjdYQhh1LaCZ+xV3QhAiVtDyITniua1TCUzBRAtkjrfCDTshRlkPVGmtfYFGGEOGKhPZe+SHEI0cawQ+6TZItozmeuashvJwkgfD3QvKZjqcNHFN4qIfskOMRXBE1QDl0e6DJ8dyuf2io59lreyBA4J95UkGG8odGAtUHkhC+9QnsRbbHJUihNj1MgjxKbVhUHr9COQwBBUtZ6jPMJlH3YWeIrauGj1WVNGrKHas2RLauBQJ1c8lMRZDNBUK8KsUJaDRNJk0tiAADvJrwoROB6hEuXRDgoh500WivvWVEdyh7oMk3eQ8JRnJE3kgZ6PNFRkDXHYnvMI1aXV46DOs+SwiDFeaq3zWBksBN9pPsv2iv/ao99gXNBhJNS0IUMJZEdl1CbTdGKEz2p2TEfC1E7QCwGKMVT7IL0QLlW/fRXN4vwp/39ExUQUZBG1DpYVSEaBU2H5VzjokRAmLQUYqzqh2oEFqJiNbHBGg9ldFd0g2QqimBcYL1CBO0IvL9oj4cM1VwspjgvN3oUb1BRqHccEQxhMiFge8vLF8rM+irMyWJnwTglPYsv5I4z4LBbdI0EgbkMB2uK/mgL4IG9VYwraswXVGYrf1DPJPUp3iiPoF+1KsAGhUAGx7lDhsRHZGaghYHYKoQy4OmCjLKOUOzErujOSYfCYeqj5FW6+JWJUcPDAJ1/laHYyK91qz2pkDqyRzdZrBRiaAkcUabU/BCuxGKb4KMFlFwJUQmm22vkhXYVBwV7oyjis6tYHNc0Q8UQk2Ki3wlY1hX2lSn8qx+URUIppixTTFETVYrgr6q2kL+S3Lys6xj7IX8U/aJwWCaIaOSyQus/ZBZLNPyW+KJbPZZ978IViKIkLozasf4XlCjFfjJENDDTiumPbP2qyEMRWrCBwUA2pn3VVYTRf5XO5eifaOOk8US1Jq0OKGEwrq6sKJ5kXMVWyTyQmj6aI5iwz3royTqRQihrO61dA9UP3ih3k/FZryxTP5Ty1UZ4IcViJcUDuIRPahM96f9Gi0WszZMsWkd6NSMcwiZt8LkhhIrNbNBvgjU54hC4odqNVBQoUAEkBJpcUY5m/9aOW9WATVQLEohphiyhUKEUXroZ1tWcQW8r+Pyt3ssYiriGSJDQ6yAcQBcSgLKgxKHezPlRtj+FGZy91Cw3qiYqGBNx2IVGyygjAJyshE6igACbtERNyTd0BZhHu2TTbwjAIAu2DIsCbjFDCsSvrU25p6FR1+0IJu0hANU7VcYLAp2ENQDjOi82d9DVTTTdp8LoRb3QhH9p1XegTwTieCF8laLJQ+PyjFPuT3mGRI8KAb+YyCO8FHxQ0XmEjvWtLVsFsWzQQ2XUfiiUaohtLXWqZ04J3hQb9CgE/lFlrxaAAnacpLGEOtytrRazbE9YYdGZPshdlcmavkrzfijSETniclDPsgADYgoe7tRJJTURKDCLbdEsy1TvUUPtJGFCJlEJfCJwc7EZBFCFyFFBE+QxRNcsVJEtDvXQli3jiwGSibcnXrtRPaizTsnZHgoCjphifPcuRHygWCIeE2zR7zcmQxrxRq6d2sVnMKjVCs2GxP2WhlmsP7VnqBtTNOoCd283wnZ19sTFcVsWRcLgeazDDis16rEJuoaQiqecvVdGZRAVGzQ6DGUi10Q4Nk5Olm92XhaS4oUXh14wOSPli/Cd5A+6MLEXQsOyPyrkUCHeNXT9qO6Bmf26h8RUFvdazB/FF+EJ7EZQ7cU01DR0VAeRUIXSy2KEvF6FdLBXBEvuT9gZo1AqdiEQ/yHw9nwDFQVAzsgGJ9tq6OExk7mAClrHbVCjlR0eq6O/mOSKJ3IldHLPNRVfQE6hunnkrxWIUBtX8ppmyajuEGnmgWOCxqr6B3R/aNpcyjj8rHVc8QvLF7KodEvJc1ihXFZo7xo80BdDJMslhfguK1jrHrW+3Z9vVZPQTnkrdgmPjRG8U4jxQuz+iwBEK/2XBYPo+0OUKZoQuAE7xEqCFoXtiVWddpTbwOpGSNyCE1/ki4RCSACMJ5BCAcFrF2k6EMsAUBzVBGOPFRw0soIYQcXUIOxwhGNUkXUNXxU7U2I72WGrVRTihhZ95shIQ1YaIE4BOiSpFDZAcU7RItO0tAtfkgO7VNMiqzDKrDxIwuHluWFQU7SLPgsu9+V/yhOLYJ7LC6wzQtZDvF2TjWFwiamujEj3UVGLF0Rg7cEPFD81Qi7wrwRasnN1qvFE0m9k9Phc9BmFDNRtFCMMRpMkCECUISYzPs8FJtUEpwR4WV5iJYROFlE4T0vxWc65pg6ag7xyyXltvQ7oVXPcHysRNzgjM/CfknRC6Ou2wUyiiwfOyqE3qhDCPlAxRIGQzRAMivKV0YJ1qLvGPWutY60/MoH1ReI4lEuvC6cRa5uVY3Kail3fnSLIiv3IWxQkdiNTouAnFMNAssqp5qjiTIULNuRctF3s01kyh/2C88MiNqapxNgrFGnSQqKbiYizRI4DFCh/CbwxFHwxFnX3LzwxTbBlqsBH3t6bvQOQeF0zwxX3qJpVcZo96Hy5hG90Ah4YpHcUYZQxc2KYaQgEwdQaxitDFEsmh9kAasx3hRVeYQE4YxrQ8bLz9GdaHiKb0bn5Cu3afirsGK/arG52KMf67c1Q6tEKCwzOegFWUN8rBDkohyXNPAXGRV0/Jd0rUKuhwUPd2I2+UDJ+aA/WUAiMIyotVGMAKgCqwkw0A4u2irJuOS8MSgvjDYoSIWGSAV0IhFDx0GUqp+axujJQjkhis1gsboiuKBcxHx5voNNi6QP0ZwyUOFIh86MYfhDvdp1kgLFN4pzXJQv2h7FatAtV0YXmuOiuY2dU0CuBP/AGOkih0+HV7KvFCP/KG+5eaCvBM7GrJrsjf4UB7hM0DMGaO4LJZkK4hLIXQnO6JfdZQ4osI4rAYQ55qKj4YoGmKDOmaFMjOB7hXCeyJuiwlE75AowwwNvxX+N4nFDcIFyoYYio5xH2QzacSC2leGK+g97I4/K6ItFsuo4aqFW0SHNHqEO47oUuCfYw6jkAAsN4RuzEKEkcFrMuj6T1kh3gbq7yKNwXXBZ1CzkGRwUgdi8LUTvOid4z7KKxwVZRELC7e6AFlsK58lhdYVKICsNPJEdo6bDFFq03lWPwjQzKzhMxgjm3osgsTMo4aOZ2KgD91CjIDjkqGMoBgAJIlySrvhmrryjwoTndGpUQRTIEgPMKOIav8AKyChLG61TrMiSWGZUMO1kCAHptK2FCe++ghHsRexXRlPostYA8es8uoaWCwb0KMPZhIYk4n7Rz0e66SPkgbrDSNBLSLSTMER4Yg3Bbyh4o/YJ6CToGpi5LNiFk6zf3VHH76L/lpOC5rOWgZ6PE6lKywxT+FclyQMyLoF1nIr+SP/AFDQDJcBoNwJnerQoS18dgWZ9Fiq/wBnFS1ToyquA4lU3YDT4sFq+HmjVsckB+lRdJBoJomZG1EIkUDJGR9ij2I9tkBPNXQIRcHJCJtOGkaMV90Lwo+QAc1xKxilyqsSNWFG7dp0MaLW7lgMQjRiqT03wWNFnRfZRH7QhjJbFsWUTeiNpxeqELDIZaSh3oro8SnUXovDq1G5ZwrNYs53BYntn4C/kAv5adxX8FlArPPkvLCabSs0cAy8sNTtOnWbcqznx0BEyQtpMoQie10pmYjhAEe9GT2otp+FGQITfYEcZncFC/8AihNkTqD3RxqoYS3/AG3RrNXQKhG84hEMUZRexQ7pxRkmCjiBwor/AEea4FZzWUlxWFuawqjQol50ZXZYOmxWNCia3hyCKuyIwT2kV91kK5p5AIYrJfcspAJk8nQto1Bo+0F1jEWHJZDRmuOnYvtWMZc8FlJZEP1AnRL9Qd0dTG5+0Id2HJYmu7BYivFP3oplC+eCgdsSn7MGO1Ger8o3NVEe0MIsN6I2hOJ+hURn7j3CIaMYwqvRR4heIW2hUi9lj9TG64rKqdphyqzC/wBgvtLHgqQ/cmsabAsEDSu4rFQsFC3om0W0vSw0bNEUyh0cJ+UDXRF6Yr22r+S+0rOaexGjgrmJZMFnNY/GjNupvWUtEMt6urBC5oFjpJZxU5QoUHhh/OjC29ZyCvEZQjYoe7DCJb0JkxXRMpU2vVEvqw0/pGqMulhyQDw/cgvCf3BA/v4TuDeApuz+Ch3h7Fc9n5XLf1zRO/U9FwK5oF/xoGMtGCBvVE9nZmoW3Zo7yoe814vxoKfRYKyCw1XT3DJxmouO5CopFEE/aljZSDZ4Iyii9QFF5kDaAssDCspKvZiIKwM15ZrNtOHX83/1CF7Q/lXivEs+oO8fZf8AiMPnQ/D8p5NKSMVyoTU3OAV4jRPepPmiywCmxJY5yX7TJYoWxQPd8h+FqjWGKHJQDY+RQdwVhcLze0QTUrwXL8KxuNhWI7w3fQyloyT1NRo4BPWKfBYkAI2Q8yiJDmyGFFlL1W4DkuCGCxUQ7JWCee7QUaRRVi/iPdYGAzWMLhbYSs4pclhCHWfZ9FjCzfKBcz5Mo3PUhLo9TyhE9kVK4+i36cp8ysqcfhDwQUCwvpC82OxCmX5Vc028qKJmyTXxX2j3KtDWM/8A1CMTBnJfaUISd+Lot/Wmi8cOOa46p+EO9n+EKi6AlFaLahY6ORVsfyuW8LOnFWIOqdxusI68V9sY0ZhZyC3q1kb246DCXTBZLJUKPIq9wmqJLFHhwQRF6BAh4rvgFd1GXh+0rBeLboEzDfKHaVFM4QZDRlEyyGsv/jT2lDwTTBiGssIwx4oWsgOph1YSpww+50clxXAK3Rw03ryQS4lDDqWh+VfRC5UUoB4oeF15jNsgnb7ojhCpgCAdnIZph2QmvL0XJD9kFyGjDPRGe0F4ThlsQ/eC5FfeH4HQSvL8YFcI/wArEU3ryxTCyosSvti0DSRMZoWZXlNYhBgTtojbQUbYLFlmFmn8y1W7OOl9BrbkVlVdFN7GPEbEaxlFn1zMHJRWkG5L+ZX2xIikcLoAxQxdH4mrLFRRsIsusysnE9BTLV99F364VgscEA5JlvUXjGH5RFIq7leO6Fh+1QlicwPconbvT1xVZ4pkSN49kYgf4w4aJaNcemgdLBCNhQT6HWqCnUY7WaMU262C1U2khGIwnZgpjdodtDXWzrP1Ao9XWfahEWyn1f8AI25DpOkA49V9Gr1GTD10H6DJ6KIgEb090YtGrEd4VFqaAQAnKay19tky/8QALREAAgICAQMEAQQBBQEAAAAAAQIAEQMSIRMiMQQQMkEjIDNCURQkMENhcVL/2gAIAQIBAQgBeojF+CG0adTU7zINhc9PoxUH1AXq7lqALNjxti5HUMHUi7bWUDs+Qt6djG8wqu1LQUgNQlKR3dENwUxqhoD2+PtU7h5r2uV7X7DzB5qGX7/UPsRuIDRADnkmAG1E17NT6f8AE1H/AJe8KXyMxsDtKAON25JnTo3O3xBYAgTaojZA4rJgyZfPQfWgmMbbvn9UuFaXlgBMeVgdcgIPgQf7B8+3iL9wmV+j7nEzPfTUY1B2MocyyWBPxDTQIbhQtjmpAny3E8VGNIKf5kRFSbAeEycXMQMyMwHC5Mp5IernRyN8tCOWClyDFQCff+0Pb7hF+1zavbkezdqgSgimKNyC4NtaV5ukFGdQgWGctzPBEYcrBRNQYwoImPHxRfCGKmJ9oUJU1Mh2FQLjxLs4yBhz2GarVRUC/rdgBFcw+x9qPu5CrZQvklATj3NWkyJsrKBWTiUo1jAHKpDpVKa5IhSVXgeLgH3MhrLiaY2JuDxMo7SR1G/GYB9xhZN4thwQ7KLgzXzA6N44l+4mwjY9yCVvkH9Fz/3zCgJs3+i5kBPTM45mL5iOKXlP3cbF+3I0UdrRuDU7RFN0SzsbCFHLq2TGO2b/AFGbsmDFeJZiPbGInHg+FqdwBAtdeQ6fXUYCKT93Df17EXz7n/aqMnCwjdBANXxmeoQAZXh5yowzcZYnPUh5a43xg+bxBYqBVUFji+AmUNtxkZnK4gSFbUDN+SFh5jZb8U70I/p3AuY0JBUjHTkQdw5C68Q0BA03isT7bfmZfZzBPv8ARX6XYjUC+AJptlUH1QGvF8pWfUVEOuQGHhxEJfe6DGiB2XFxMyaqhOOrfMK4wJTNkOUfYxHcurpjG9QY9jQoLKRoKURnDZl1EOQY2og451UuoGBnn2v/AFFrPUEqcby7WDiH3bgTx+hrqzycagY62LxvysLC3kNZafJw/lBG+QmMAMI4EA4uBjjfkOueZMJxmzeuJYmVD5ykdsJcVQzabWg2FlyqHg23ywBaLnq45lba6QGlE6ijiHK/8R6gg02yuI3qsS0Al0LzAPjKlb0F+VHuTqJ/2f0bMQbvZVMC9kVTR1RunjczGPuJzkM22yiY/EHIaiAGWZUKmKzI9TM5dbiLugtMSY/mfTAm42HMvhBz3eZkN5TCpqgzKihBuP5bfQdiCALyEcJiK+MWP7yMuBR34xg8pcyuBSxmpTB2qBBCIfjPPvsJYjoF1surr2laQCOaBIZfwqIPCy+xiVBbHQNaKIF0xgxOcrGZGqMgyAWX0QzFa41sgMCDiybY1JhcR3E21NnZh3G9toqHGirOEHDUIG8Alm04UnTkYOvRCf4+CWzLFVR4rchZ59mapy3uZV+aE9QdssfTGuw2LcLl+xMn7aSviIotItdxjWNDAQ2NCFtcjQ4+orUMIVYiVy1wuCDSMRiED9ghyTyRbnxEvUWBrjsN3OK22OSVYBhQk7TuJLTHjDKGd+9ajvtqEr1JbsRBiWYD2GXUL8RO437H2J8Qf3NhPUm2ULzq8wliuTZrDkDIAFE/msG3S4S9J4wzEfMI2QgY3+5vtxCTMnImPjJzdMb2FcezBSJj1FXnzWQqp2oqgKVM4XWf9TEAwEOUDibbEzT6mikQov3zdwG5k4EUUAPY+33HJCcXh+2DFlZsYsgjZ7YFaORqcfguN5UwWLldpA6dgiY+GAgyDG5slSYRkx8jqcWHJJhHeKzdndEKtWtQHzBrdMxwQ6vyoFTdRNr8BSeJjAuZO9zMIWqW64h7RC1n3bJsCCDYX9BsMoD6/wAiVswqWVrw2LWOR5DAqQYhWyJlQhBMZV9TOMb81dwDczKvUUNLZfGPOPEOjCagDt2qrf1Mxr3bA2bM4AhsQDGKCsTcCsRZ7ZvxEcsahbRSSwPBiLqoWEpj7m6hzGChLjNU0Vjc6mvEDX4MLxW2beXtkmrRhsSpPbmFA9zAhutycZa9SuTjUuCvdNxk4IcpC2rbKrDWPjvw1XzwnM6SHwVRPI6ZNTtDECjFxzLUx0/EUgNM+XgAY22Exjsjux7URS3dAdyHY+pUeH2ytMa0s25qAH7xoGokmpsYyITZOMQY7EYmtU+6XpiVss/xRkdWh+dljkxOTDgLuCDRQ3ja1suup4xsGWpkR08Ww8dYiHJcuY3KfFSuSHBqbW++DKROrca2MxgojtA1lUBbGvAWhkqP+0TMJbuEy80or4idMRcaiDWYxdmBRDQjtMhckKCmvkOQZvkim2NFwhnVMWoG1MzOjZ9S2TUI0yq+myOt+ksYs3cI9zqOmTu3442xNwxXGfBTWWJ09qi48qnjfUTroxqdNWPHRIgRvt8TZALGmNaU6qJjx3m2huzRCqeD8sZBrpiWv11B9HJ/ZfTGsGYzq3LhPMYG7mZ3DUo7jyMlGlCL99s8QC7mVikYrqNd9HLF8h9PlIBq7C5Cnn8eTiKqotQOPBbArcqcWRDydhOrkE67wHI/jF6ZgwY5Q+5tbci+lUCAQh3nR/k6sijgsTEUtWpFGocmpKxT2mJwBMwOqzGwy44ePNzmD7hIAEzCsQM+piCm7dSK1GGD+oDUIDyjjZoScibY8i48qvDhy4/AbWbCxqPUNOsn8hmxkTqIRUfU3OE5HXvyfVKqduIvka2cf1jADrWbIy/E5Mq3Ot4luxiixz/4b/l1Ak5a7ICYgAa2Ot7pEOtiDLmbIRP5Qi4pXZpjfd2Ez5TlaUVFk3sDFU8308/sDfmfQhAuwUDTV64ZAfk3p8b2UbDlUkQYc3kHdfkrqfHcx4bFk8kmYvTg8kDXw3zDRXIcbMyv4oVAAaMAsiaY18NmZB2o1+T3dotUSl6jHmd3gYeLhFMRCdGxPGYu9BmsBQeAaRu1qwptkEyZNuBixNk5mNdBLh4lfYgP3NhO0wgyzCiP5CanlvUomXWEcXjfDjbz/jf0MWdVte8/uNmVMaUHRxMmPjhAcYpuZ9xD+O5+WwBTTYAxyn2cigALqz1fTJJCr6fUbNzYWadxaZUPTEU8qYp7bgW7te/tijRxNe4wtS0LMsxCWEHsYXCvRBBgPseJtqDMqryw9Pl0cCCqmq+ZqD4RX7ts/ceMSFlncOJwRyK+uPE7Yah7Z/djDjb4jEqw5FAhzM5pN8rmY0XCuxLKBbPl3qlrgBUoAQf0FS4y7PYobrD9xx3VKgfVis/79jyJlXtBmJ67TLnmZHUHnNk37VwelyswYtjPBmuap+aXkhUnyd5TQgQ/1MWDcXB6VGFzp+nxcjLmYtQJH2cuT+N52m/qaN8kwtoIcsRTlYXmxBNNMODpjZ+DZO23AXtEYgXFU7EwgWBLssZTw15iPq2jbU2pMc9ph5gysnBTIre3mCvqc/RZgZ1GmyzqEw5eTQyM5VZjxF7oYsAjupAQZW54zZAMUCrxsBhm2GdRFn+ZXjqZ8onRx/Y0HgVH1OsJLcs9txMa6CFtRNqg6pE7UFBVnTSJkGVeHBaY2GZNTsVNNVmPjYG1tWh7KMXOgE64vg+pFRMuwteoJ1DDkP1ZcETQzpL9vSEFeceJRMrMSKGYiHM1QINxDjycTo4uIfTYjMmPVqWipBLZWbxqykQBfsEfQH22/wDUvQWw3dov4vBGV+ZrZuCtZ1BFYqbCMuRAwI5uDI1EPr9pvtxG/t7xGa4p+KdFdlIXi7t8flXAYV93CzDx1fqZ3uhMZ7VDZM+6zMzuygHEMYBPZOwrU/JuFgyL9u4MLMJkYETBjLG4OSxPZN//AJr2LDGLKIctuxyD4oiBeYfMuuCLer6mOCen/ZyQ+Uj+RE/eWZfmJj8CN8jB5h8CJ8RMn8o/7OSYf3hP5T7MPxMb5Gf8azJxtPT/AL5jEnLkjfU+pj+TwwQxpg+MHgxonj2wfKZfImX9tYvC8fwEMweMczfxgJn/xAAzEQACAQIEBAMIAgIDAQAAAAAAARECIRAxQVFhcYGREiCxAyIwQlKhwdEy4UDwYoLxkv/aAAgBAgEJPwGU0ak5F90PY1L1bW04l2rUrj/RnGCXYlxsil001b4KZZS3yFfjhmUp8zw8vMv8FaGaF8sizXYyvPUai/MfJ7m8Ic0L1FrZcMHH/ZFU7i4HRERlA6eQ782VUyhNzqVeFu6M9x/4tcxnBoWXM6HvVMnxSoR/Lc0zPmOJnVZFU5G92e9wJVhXMkVOBkxMyyEl/j5uFPMySGpieha2bKqeM7FP4HrJtGHBG44c/kmPUmyJlfcUmpnsZCkSXwU/gMsh+T6nBqWTRpM9CmzU/YuRCGd8d/s8c0KE8UJQU9h+dwU5fAc+nm0dQro1lTxZeK3PGS1suQ51FqjP9jFCKG/t6lS5ccHhnoZ4ZGQ7DKpIH5c18bSTW2wlHs8+RVp/Y7M2g4G1JvcrhItKlJaLiNe7fjhuXqq9B5RipPdPaF0f+iMtME+2Cthsnhr8PZSJ/gX/ACz2NVOY9ZXIzhGrg5dmakap9Tguw9NT7iRyOXQzsIcJZlU8x4afnDIaHLFj9MVc1hknfr8Pi+5qRGRko/pGX6NWas3ZnDPqPmz54dJNalbqPSSRa4a4K5d/ZG4xSRtL4F+J4X1ZT1n9isXeyMxZmcfCymxKXhiD5rmbm45ehbJdRL3cjQ2L/wBmtUfaDkW2F8sdTMp1tWV19/0NtCfQUUo2SR1Y1KKTMyp9SObH4quZDq2IXM8OGb+ExXSVh8GZpMehFzi/wasUSasSlsf8fsaerK4acmrsZmpnl28mY7alMt/Yct5GikyXqxqf9yKqlXoh31KVTxG66ntc91Cl7ml35MvIsFokLi43M/DJnqb4bmUGU+uDtXk+JvIl4jN4746OTqPizPQyyHwPqk0qgqcU5JDhPQTppy6EKlW8WXQmPqf9lUvczlvHTyb40uVZMvVGgnEKNx6Y7s2L2YvlVQtJ7DirWRRixe75KF9xrkM/m8z/AFnM+r0NTTQYoSGxj8+2GZa/qcmVUxGnM4maPqXZmlzNMyY7pQZPBqqjbBCuKZzHjkkU97FFFK3X7HhLe51OQ/dbbF5oXXy6ziktB3puxZ/ktDirma/k/wBgz23F1x1R2HHPLB8pKXYpGPCzZQp4jnaBpF+Iil8iz04f2Zf7GDLU+SjxFMIeOWmHg7CtEyXsuqFldChV2qX5P5LC9DL/AIMjLFGRU7lT6FVSHLFhohZCmxm8xXWuFkszLiNKhO3Ea9SpvBEIVuOKHX/9IyLlqfmfE9MKrJKxTGaKE/Fa2w0tx28J/wC4KPIsMtmU1LoPoOCmTMfMzZrkLxVGdUstb7DheGYMoMllz+AxtlDKYXEc1PXQidthvGd5K4oVogfMz1I8I8xcDt+htc9CvvYnCh+g7cxyNopb4uT2dIrbFXhpKpbzY4p3LcNTaDNJ+htg74M18mlzXUshzxH1O5GKkpTi7WxVKSiukmGPPUy+xnsJ88yGKGSVFWCQ4KnGhe0IpfSoVc8Sh/8AYufssvuIcwLT7LD5vQ0ux4scc9TaD6vxix+RdSM9R5ZibW4mMgowclOFCfQogqfLIdzjh7SY4FT7nu07lTfNiniW5YdTN5HyKDkbiXYUGSLimJuP3VZYKGXlciny5iuQynId9sEU/kcehXIp8umCsURT3E7FNVTPZRsT4i714GXqZ6fsk1FhbxPPDqzXCyp3KZRnGGXkXkV9y+z/AGZLPgP9HuVcrM9rQ+GpV0PZKrjTmX5lh9/J04ipQk/sVNcGVxGwvdemostNjrUO6NbiFp6GhuOUUwmrMUWNxed6eac7zxHZ5nUWRYq8VIsiw1Uj7lWDKkZMuh22EipLgrwLqy73Y7vVjjgO0H+s74aZGlj6sNCpnHyLgdPI4E4KYSvcsxrGlNkDkSGWp1Yoo4/yZSrLUomngrMUcNRqlbIv0KGezrLcNRPqyRZsZkjLBuXohX2M9fJ0OnkvjctgyhlDFBuItJancbYtcNdDwrsVIqRWiR+FFRBBo57DhbFlhmXe37GktYUYZn4LVLMtGR/JHfRnY7GeFWCH08jHhsbDhalJRc00LTnc8XcdS6ktYZCPZspGLDsZshsXcu99jLfDMt+9j3akKRz/AMWZlErdDfckpX3HbuajmnfCmCpIljF/Z2NSu/Ek9CpuHe9iw2xGeG4i2L97YbL1MvVrcUsfRC90ow3Njc+hn0s2fl4YfS/LwNjdj+d47+b6n5fqNmWw3Nsf/8QALxEAAgEEAgEDBAEDBAMAAAAAAQIDAAQREhMhIgUUMRAjMkEgMzRDFSRCUVJhcf/aAAgBAwEBCAGANgVMghy6tGsy4oW/KnC1q/E4SvVfcRJLInpUkhsfbjL+MUbSRSDUpApJo+3xmrgI8BjjHHDbQKvqMYAwIVHGTQkdY9pUdplZ4QXy27vciUiP3siMWSaaWcbu3dCh5YA7oGuqz/DNDusYrNfqlJz/AAI+nVIwiY1rurs0KgoimQoiuwaUtOJRfxm5gzGOoPshkiiVVCM3msheMiNOkVaN0zLrW7Y2pjyMwL3AhyDcxWbQMz2t/bWf9IX9oJCTNcO0PBb2HpTzuJJRopkc3VjG45bYoydMcjuv/f8ADNAg/Qg/qIlUINYo0o/jisVYwa+4kkndvtqEc+FEBEYKA0rR45GmGlCZY56WVd8l/ERmgxY9orm5leSDuJXLPMc4aOR87y2YEpFeoSKdQLVISQHaC2RcJx76Cje2yE8SzowCJNcLACglmklJJx0aHwKx/DFD+GKzWTn64ruiPpjkkJO5llFMxgjxCyARkTbkBCoa5kDJXtkkcI8cIiAjqPJDUhOktOXjVjXLyaGrm5CHZLa/aNZQJsHWZJlEoZ2tVEcu7GS7vZeG2lsZbYhl2uEPiJZw+xkmeYjcmiaX4/hbwmR6niXJNKD/AAzXzXxUEck76JNFDb5U5rH0zQ3AkIhkKOkrNtDljtK5kWondLV0aGcP9xBIcIxEucVvk4MjYyKkcyMFFv8AcjnWruGKMjDZD9WUusio3to25kZ2I2UW0hjCBboRzR5WSC35ClPYkHAkguYj5dmgh+K+KP0MT1FdC3Uok6KQrp/BRk1hWIVT4kgrcSrHpH9TWRVu4DSiuyY9rv8AolqhcNIpSdQltOiQSCW2i1lP3Y2qJgybFt2JxOAAUWGAR+bwmFImSG+bM2ojtQRu0cRNyFF7dLFcHN4i88gqFJf1vLg6ud5TIIpkcoZF5tzpLC7/ANRILZ3IFzxhgExkVHjYbE5JNYqF9cqWXXGKFH5FZ8TSsyhSM5/jj6Qz4kkJ24pStN92GavTbh29nAB/aSRtYLtajaUlfbUmyRaVEMOWJ6hiNSOdjJRd5HRRe/3LtVqYzbd2qRxGW6k0mlVZmms/sbiLkXKqlk57cm3tlzUPqNs5Aq5l4jHIjTK8KSU/2ZAVlblJcRBncAPCAfHgLHuSJEAH04y3p8Un0Vc5P0P4Gtsqv1zQoD6wRI/LI2rGUtTThbaQp6S8nJq2Mq5Nhu+9TxmSAquN4akxEYlAZwhIYhZ9Klu40l5Jp4UuckQ2fHhT6lJvHFbJZO0isr3g4BE8c9yfb7qbriUSEGSUBqaW4i+DtO4qO3eKwl5WOQQIrV541ZCLn4Ps7kIHJDxnX6GghT0vE1enRrOlxCSurlSdX1x9VGzfxgaPbRQFS5kczluJIKhzbRuqySaW42tQbe2G0OSJHpT9o7XOxBarZmGaJJZlp41ngyrQTendiG/juY9UIke9kIayniVuO2VyrgxpAzspew5GixdTCNgq28csqeaGOL+n6nJK0iwJ7S5PVWVuYwgNyVJY0LOVgSUsov8AI/p3jmL/AHEDgUPTr2Qs8suuzBfTW47lHqbT3DaDxdga6pEErADodCs/UxQxY001kkQmT75zJKoccs8YuLqBKncfFT+NsgGmlu5qXYudQdGjZ0ld0marOdJ4xUkccsR2tYRbuEF3NwXGUku5rjygX1NwMGG+s5iMzO4X7RDJ5NZLiyXKOhO7pDLNOblhG2Mpwhhl4UVtnYrChwZJ42/K7vO9LeGf1B2+1cveE6zn5qygdjymKPkkUUx5ZWamoUn5gg9NRoDNcElcMtR3LyGXSKOWGUckcgad2qJWdo1aKQi8d6YeUlYPNEqvok2XAblkNPL7i8kSp+rZUq1jLhsJIYXIAi5pIzXqDiS7k1idonR1vIeK5kUUkbGobZ3YACJWTRSiOBGpAjCijIs0rvXlMw2VmbWmTbYqLdOYhzEizbK9+bLKPKt/fdsUt7dxma4mk+R/t4DJX4j6IhYgDVYvoat1ywqTMS7pzyV6euloBUIlncoyRrCmz2ZA42q27uZ8bnMjU7az1PyMlupTUtIKbMV5cK8gDwx0t2LV4hI96ZJkFXlwT4RKMmorVldDLcRB71ieDWcgx2w/Y2RH44U0RqlA28S3Lc6NFmOBtgmnBWxV2FKwVdKwoCpU9w6ytFBAvt5Qxht9d2nc+nKp5JHa7nVa9Sj0uBqqbHtYPKpRwKF+gr91Ag4+5/txaULNyM16WjRwu8hKBoQbziSW20h1aFGa3dmlkr/C2W4/cAmbXmAoed7V1GOs8hhmRmuIN/tutoYzuoRFPVsCrmpyzW+a02RSBE22WX4os2RSPL0Kn5DsFsrXRd3YF3dmMgcZpS0hmIA+Gq8d4HZhHamQA1xiIIFe5VME+7mjPS3j/oTwaaEgqci1bldamcyOzVmgOqVcsK0ARAY0iluYxLxt+oDEIpI4719UljfigxA6y7x20W1u2L0o0R8GUOUcxspkxMjk3Ojq4uAJIJXElu95aoQgkRMUslvctq3BqdZI40QEhGKRPta4m8KdGHb5zTL+FDkVHdEF8ezHvD4yM+/VcUjfIXQYJdV8zeSFtUqFeGMVesUwZNN8zOMyNS2/GjFsMx6UdgPBZCGVHWZNXZaC9jIXNKCO6UCSPytiTKWijjfjSo5o4pIjH6gquY5agic6q0LpIhSplm0Rqtp0kuJVq6SWETICJLqA6CQKELbe3SrWQQO0FDR8bT2gbBIMsZ63ZmzIsbMWKRena+RZv+NBgMAeTEmosMO2M7ZZo1VR0ZUDaIocmhGD8TqqLsIIDLKtLjGpuZeaV5ivPdYRBax2KDLrLL+SRBPm3h5GDNJNqNKNgZdmQrp1KFH6SHrJZONONVQw265aVdjiJ2iSOWOP73pzbtF9uF1eL2a6pNHGYxIk1oBIZo7dxMBHXA1qdozbJc9FYuSLikliLSZqGfCeUZbFLmbovcyx7brLLLjXedFzRMrRqzZ77knVRVsxwmZS0fdSq7RkJZwsNjUmyfEx+/VtDEuHllcIOMSgwo8EUfpBbt1SC2Txc7yFmKYGxaWIsFW8u+FTGiIH+eDHxDL6jGmgjM4HbzCNs1FGM802TqXf3oHVBhFMK/1p7WCWERY9thF4LmKMKPUVt4cMWKSIouYhyKEgl3B2lQqwIinSRRkxo4NNbA4ysBWhnrMsS3CkSPHJbrtSXqyKVf8AKHANsrUtoqeRTVVFTOrzRICvGGkZVmkO5c/a6tz/ALgLUhQNGzQZGzsOmmdRNTzGnlfYZ9SchkWjNNggDYmrWLrJtkiRDIyMZT09sNcnjtxTjxG3HygYEMQFOGXsSwiZBr6fFPF6cJES02NxGbSSPlMEsUmvrKLJdWRMb4gVMCjBG8WF4gemMVyg2RWuFHmpEnxr3isiI9yXlm3T8fKwK+1miGTzyImX93G9GdceMM6Qk4beaQMyM7dtNKOBgURdUypYnJRhxzBkRhPmjGx7pbNz5SR2/eVWE3F5MxmtEdexZonwq4GKiwF7QrJGUMcMZhR2XxXp0D/kNj5DiFYDU7iMpizhSYE1GkvNIJuH3EKQxxwpfWiM6lmXBeJJCMNyw9mQyvIGDRn5WO7ljxvHcwzplQpY5o2iNkH2MfzXBFF+d1fWxVkS2ccKauywxsQt4koGObbOBLDEMD3RJEcbxSu/msQBzUskcQYOjExbFbYvGjVIiiZRUjZ6qI65qeNrW43jXEgypjz88a56Y4VDUaOXdiHywjH6AoE5XEUuduRr59jg95amXcVHI0PQEqXEcRKqlrNpcQy3Ns8IZLi3k7BBeuNtezaxDqmtZv8AHJBdxsK9rNyl6jLrrjZpMKzW2G8P9OeWbaW4EVpB4xOTktdsxgkzYW6EkukNs2DXDGAceCKcOWUijjX7ihP8XtnlNFhH+FuzvclzGcw+aABya1LVwW6Lk/481HIADUwk448TRmOAMLWEQJ236pAAhouqomrXfpexyV6yANcEf+JonDkkTNrq0c5j6rltthtDMy4ECX00Gi3ENxbTKrU8tlnUhQ/UbL2NgixpkpLCQANDmrq9EBCo7vcMC8f9PWpY0eNgkSSwHyDE4osfJQXcKaMty58kt4nOZNeuiyilRnlBJjjjGo26rBPYQ7PWok5Y6WMRRKWiQhmkdfuMlSIN4Vqc8SvmOP8AZmdIQFM84d8LnNJkml07VgvepKByQHifAYB5FHkkq0AvzUVzPB1G06zqQkXp0k1pvSO2wS4juJhsFS8H/OSexaQRsDECeD2Uk085lME0DGre4GcmVuXyQa0P+6YAzUZYcEsHT4Grmk5P0sbMTlTFHtTyLhS0l1s2gyieQ3xotJKrTSGnU6mpgOTFcupGrfZYOZiJ0cLgBs0qcshZikK9141cRiKQYdttTUmQgKkNlTTQPPFtGysjalkzSkrSnIpEEsipUW+Aj3UAlQmpGZXFG7mA0o3E6fNxcQMIuKzCquDcTRxN39qQhguwNaN1tjAzR3I6VX/QHIDS7fbVTI6fnzFwK0LHNCPjAMmoA6kLXMmiiN9nCRW+obLZ7JllBJasknLST4HcMvHBq5LCGU0v41bHEOa2p7fkiWSlHbRkE4wY91fV7ZsO6C9t9/uqy/uiuaAGKs7F2TIht2t1Ja79RtIVZaS6iOy1mw2xS+w+V0ttTSTIDqiiId1vECKR+s0D1mrq/EBxR9WnhJSluvUbzprW2jSPJjDf8FgiUhn3to8Gk9kSpXkjwBW2a8KklEUfVtcPLvvc3e2qIASVAaMQ/lMzzSACNXcJieZOJUpWZ02DqEiiSsf9ANrrVzb8kQmiKCSMyKq5wDCi7grkoae1jl7E9k8fag4pXZCKcu355HQopEfkRxMvkLeMjIEUuPFYFT5W3GqZeKKJGkq6ultwNmvr9/xtYJleWeWxhGCWtINZ9i2+TqWuj0GS5/Ztnb5/05H/ACEVvanrlmfsMs3yziT9wbKZDQVFIWOExw5ap5TKxqOHLE0wZ9axaq1KrOQ8jyZOa99KOqkgNu+DEVT5uons5eWONI3jPGG418op45ExKUkjNDEgK1NYO717IlcPF6dhsGW1GdJBZftjZxn4SziXGeOOEq1CaP5KzyOftx5nUiR9bi9lIsbdNW2ksEYClsFVyaydTkTwSU95dguBH6rdq2Kin5Iw1FmNJGFxj/6eT9OmPzZ8+EQjI+TSRl2wJOCOPyJ9z5usltDlFL6qRU0jq4A4pKIDghnR4ZChDDQKXsk5A8POVYLc8HHgiNPgQ6zD5DTUVuPmvcnRwWy2gT7NwAEeIurZ0AGKWNGGKFlg7vAoRSRLnditr6cYZGzbRrErqIvul6PVYfYmvtRx8i+3kP4w2hGMrFCRiuHXNSuII6zxqgDNM3Q4MYaVnz0O6SMyNipJBAVijEGuzyyzPKSKHa5o7SYMZCwZA9vPQ+Kuv7ixqP4uBSD7Qqb+wmr08n20lXAA+PmJDT/BpPyqb+rVuBhDUf8AcwVekixlx/hWiSNMRktKuV+BT/3jVH20WbgkWUhGADipPwFD91c/ilRfRPmoCfKr3+saPylW3yauPy+l0SIah+TVsBrMacBpcMPzFKAVSvUukuMemqvtWamJya//xAA+EQABAwIEAwUFBgQGAwEAAAABAAIRITEDEkFRImFxEDKBkaFCUrHB0RMgYnLh8CNDgvEEFDBAkrIzU4Oi/9oACAEDAQk/Acrmu0mqMFgJjfksoBdEaeIUspwmaeKaBOcWqIREsDfoeqa0MH8zMTObTLqpGc5numuUX/5LU15qmtdE8nkDVZWh3eLnQnh78O0amLK5mBa2ieWho1r0+Cx2tH4/1lYoLdctI60ogA0mJm6PBAgx6zosfEEnSi+0dI7xHbfT/aOu4mDpOiEByP8AMDfACU6jT4k6+SILg1sHctm6YQ85ZB7pqm2luUCIcrBgJJ1PNNAxXDyAE0RERLnHdWN/7LMf/m4iFhhsCRN/0TtM0X8lGhe9t4GiD8xh2cfrdYbzmiXOdBpsAsJobuGtBlYWIMJzpM6/onBrGnu6lYebDHA4RtqF3TohH+1wi3MZbnGn6IxO9SjmImw9F1cDsea/h4bRe0mazKyHCyOBM05KMlaGDqjIeeGKioqEZyiEAQQB5LuYQLiN+iww3LJ5jxTW0aDhsJr4pjMNsBucCa7f3WQnNfcC8p9A3cx5IZnuNAsJpf0TKAyVBdlylrLLM95NcoMBANPxQn/ZCnbYSSPy0ATauINPRNdlzlo3Lv3quIh1A23isPEj2cm/UyFjDmIzJpdwZRSVPemafJW0Vy4u+Svkg6poIj5LKHupO0LKMz5mJWSHudTUTzCdlEw2lV7BoqD3rT+idmfqTonlp6BYrj1Rn78U3snMHT/QbJKdmfy0Q7QVNMNkxzJkqRHwrdAuIdqaGdR5q78mUU9rmsQ5g8simp0K4WgCCKUWbM+wn6ppjQ/uFA1hHqVqfNR3IG0gJtxPn2d1xqFLiAfQLX1XsioThJT3F4vFliFp0Dh9Ew+FR6fep1omh3NyeC1w8uX3gZQJI2TRhg3Iq4+P3tRhR0TnZcRtcv71RgNAc1v4WyiQ1+A1zTtBr8Uc8Pod81YTQyGBs9E6SQQPEqcpnpDShA5I53C+X9U9jSZj2neEJriNTy1VQKJp5IkmafVHhIAfBgiNVbMSFbdGHajQo8esWTIcNbShMjl85WEBTU/RZp5O/ugRAit+3XsPA4Q76oy02P3BfVGv0p/oe3A6EKeGsXH72TyTjyBqA76LDiCS5xtQFkBMh7SD6yrAzT8UoD2q6bhal/mDPyRnYfvqsGXummx8N0JAME6uNqBNc04gy1NGg6xuqCaKOi4cPCJIrchM7+Y+tlmpodlMnZODet0DibigWA5cDgYHMHQqQ11KVynVO/K4K57wV1i4bv6ggQU6Xajbs9nEeOwUF+y+i0H+gKfaODBuG0nxTxelYMwnRdndu4jT4oH+E8M7ugTYhkGl3IywudA5IgFonpCNCwOvFCEe7AM9FmiAQdBFKKYgu5cVYTYE3bpAlAHmytecJ2LXSoRIkyOg1KHCCHDYOXcrPJOA6CChmeTDBosOOQWFlHRXVC4yAdICtMrvfFMfBMU1WFladXEBGOh7b/aE4Y5Hfso5wEHotDHkjQCv3bfcmW5WA/lEKQ1hAM/uyDsw4t1UvLoncXdKv6mUIyM9VHC0+JjVSYaLD0RGXgPO6Aylk+NVfBq07sOikSBbUIGJ4i0p+YtwzLoieFN1yzyCxGxMmT3ecLEzcMjomxKPA03RhOhoodeqblHLvHxR0Ej1TIRArVOdXiaxpgun91WGGbCZPxT3tP5GJ41oWAn0lOGYclwtvmcaK2icaeVd13cy37SB1VvujiDRJ6oB7/tcxdGgsPDZUbhiDvMoQ1uWWitDRNDWVLuqh1yNsqcT9o7ijWNFett/7qvHNYoBZcI15ZLoRGESaxZ2YKxBc3SJpPmjmBofqjxfaB9RBywrHRYhECXYX03WBhEdKnzlAMdqDRZOrjCeHYpsQjQvc88xb5IxPdCFHTYWHNPkea7nx5Bd7Er/AE/qs0+6z5oZMMakaokYfvWlOxD0TsQ9T2UYPVdT0FUNfvtTCnFwc57muIt+gQkd5g6mqdwOc2h1gVcE3vOmDyCzS1t9AUNGtHlmRnK23iiXZLawShAi430Kc4Nw2QZ2mSeiBH2k03NPgjR3dj3BQR1WBmaQAPwwjxNbXyhHhB0VwZQpQjo6vZKu4xOy7goOY0+NUOIAR41lYmRrdtYTcrWiXH4BUzvy+CADzQcmhA5PMnqsPCOEPbrPqSgPwjRPdiu9zQA800YGGNCh9q7a6cQywbpC7+KMrByNz2hHi+HbZYl6RFk70CMQXmf0RnKC0ZrRz5oCPtcsjyUlsUzXqrwtTTyK9nDAv1RJdmB6wIVy2PIqgc2J2mDPRN48HvjcG8I2wwyn4bHxCeQx0kxyUgACd1UoRrCt9mI+C7vYKkZQetyo2aNeSaA6C0H97IywcTvCw8Su8eI9ShYlxXuR42+S1YSmDO8CSVhgua6M5i/KU8YmLcQJqeaL3vc6RhxI6lFuYfy2/om5GTAHJf8AjDA1u1B2WXecJd02+5q0q7spIFhH7r2PaGuGZzdv3sjlw84PFYHmi2S45o7qbFbbKlfh/dD2eHkbK2VqdEPCplyGl/3ROzRiuwynRxhvMZga+iZLLsc3Tpt0Ty+KdOqAb0tVAeGibakp4+0DfQq+3YViEeDU1xn2tUDmJ1ugPs2WrdWP/VakDzqfiv8A1x5p0ZBpus0HvPNZPJNoBI3oiMR7qikf2WFhgcgmNA/DzTDlJk8zzJ7Bc2Wpn7jo4wOocIT7MBg2lTHQKXDLI0NCIr8UScxDmef6rCxAS6ATbKWIEuAaae8byrOqPmhMMeBX2mKoeMnQio81GTEYOk6ShUCrTcidECA52f1lUxBbnGiMjXWOqa7Cxh7Q16oDlFPgrnVOlusp5GWcqbO3ZeECXEgUMEJ7Rt7SxcTEdcaT4CqZ0BqfIUCMchdZWt2FTVWFhuVeS4/JCrQG0ThN2ibbKw0+55p7iD+GFo4jsqgvZyed/kqxALo0CaO6E5zoOa0a2TczcRoaCK6SnEnDqJBIGTpoq52/aYc+7FfEI8TNIrQbo0NY/MPqhLTBzT3RN43RPF3mASK1lHjbEjcIyBBC9hxy/l0Q8UzNzbRwTuGIyn5JtNcsg9eaxWnNegT77VUxuUD2CQKx0ssVwbs1Nikmfmml0X0aChE6NRry+pTmA++8z+/BBxaDmJIgvPyaiAdfmVaaBN8AuLE7bA03KxvsuQgLGDnX5pmTrZFvmv30XeM0vX9FOaZcRqv8wBNIfTwonSXOcMs1od0AP4j/AAOZOIL5a+p9U7M/BOfDdFK1LSpOE7kQhJ108UcuOya3lDJHFGjuSGV0T/ZNl0X3AQggAA+9FOx0qJ0TAchg7+qwm/1LBYelLeCaGg6SSUewd4p3ePlROy8Uc/7oQ0UaPmnUrQi3khNN5jlVVc4cOrvFUcfdKDn4uIOI7IPnnDR800DohUpwaOanFdsAny/UtoByCqiVBH4kP8M124wzPonEvNMxv/SNOqGQxlA5LjcO4wUpugPMqIMeaweNxJB0E/RYgeP4bhWJNrc1jPa7DqQTMu6FMe/MOGsiNuULDlxxIGyjcbhd03HzRJ2M+nVRPkoruvMI6z2NNdQsXDc380FDxTMw5Gh6LFjkan0UnmhGg8VZqEEXPRcDDugYBAHiblcXFraiE8UT6o8UmT0XeN/ymqlNKbC0C4RrSPPtFboADc/3CxQByn6lYknTKJKGVnu+1G5RdloJuSExO4gCBrINCqmJRaZGTKRMgu+MrAzYpObNmgAFCYkt5g19FOUNIw55qftDvqmig315ozJnzR/qj/sEwO6G/hosOPymUAfRCvmsRvxUOI0ypn2YhBjvIFYjW/hbErGf++ifX3jp5pud51TMrG2B15wmy82bsOaqSY2C6qrZbfqjXMVoXfspuQXg1RIYmx6n1srM4R2DssaFAjKbXKklANCBMVhCQ3QXPLsMOFlTTxTiw7cysZ4DpDXnU7LCDXE58HEJ7uW9aqM7dfdI06IVBsUeL1Vt05nMREouafwmqdnbWTFR5Ij99FKYPigAnGN1LyR1TWgxxCKrhrJgfVYjWn8TU7CyxWCsRoH4LlUJ80Dl/wCK43H/AIhOqNoWHkzEQ03KdXNTmTRVXs1PU0R2qhII4hvCPY0lcW4boqEvnoOa90n1p2etvFAUEmNUHxPJWnyV/iEYI56J9Q7um1dYNE5xGX2DEErDo9vDsQsQMeLtcYgrKea1oi5p9FisPgsp8ITW4c3y6p/RHTp8FjvZoKyscvA81hN8p+KZAOyIJpbaVXRYDADvdMA6BNzHb+yZAnRt+qdlHug/uU3NO6NDUxy2W1F3W1K/mPB8FaCY6K4TnW3Kfm0A+q7zgQuHi4uieWEkQImuyHG+r+v6LUIzdUIdvMgrGIraLIyF3dtlE+hQy5jNLKMtxPNOltoOx80HYdph2u6xs4dcEwfNYRLI71ZPmiQDYQU8ArEBjTXyKEwfFMEDQG6cByKqoL+a7oMgc118k3vboUKNd0XOd5AeKyVqYB+qxGNbybKxi869VGUaIQrj0Xd9rny7NK+S9payPNVDGW6K+1gAoA0CHdM+ZVYBJUEuAtYDknhpOpUZJ0+Sa3yVDqE3sFRWPpunmbeSaDSKIr0oViuy+66o9U77J1zh6E7tTuN4nqN0wkimoPoh/mMPSXQ8cua/wuOwTBdEgKHU70T6r/E/Z17r6sPmuHm2xXEJ0+iaerUesIrRbS7ki9ye5vimtI3H1CZQ8ka76I/qoECjU2Wn0Xu/FGPonVDgOVY7LBvqmgGYnmU7MWkSNkQeJs8gVER6J8UuUXE9I+qwz/yKrCMzqh1VHTTqE2eM06gIVV+0xPospIbILaAxemiHEBIRImzvqngzeiAxBrQELC+yxHGKDKIR70dKIBxiwTX4bk0fmCbfdeCZRMKuFR8JldD80T5Jknc0lUHIKAOWqY7hdUAxHNNl01cbQmgcV94W3p9V5arWaKJd8keJ5DjyRA/hQJ3Qv5quY0jUcysDDUcQb5qnyPYb1Rp/5I60KHUfcY1zjZ02Rl5udAsYFzqUrAXGwunK4QfBNxBzRPmQrbp72t60TjVCE9wHUfJCd6oHExT3WdU7PjC4aIY36rFcJI7hIKxYxSfbMOHKqdmNs3shcbx7RMINGkyi2W24t05vxQpuaL0EKJ0CNq+C3orkwEcztuwNysAGZ1qb79E4ZRUvN3HUoUJIZPx7HU/IjShHVXF/ov6xtsey8dlOXZREtPkEXO/NxINPmgR0qsdgjlVY+H8Pinhw/C6UF1VY05lcWIROX6pgaNIE/FOMhh81Um561TAC0X68lXwKZ4whKw/VN+KbJ6ymLP6oHxXux5pskXKhzyInQdOygRaxnvEf9QmPxH+yXnMfBBwO0oUT/wDupdhu7vPl1VQ6/wBVVjr6ggoyNW+0xDo9QD73sn6Lu9jCoPyT+HTcJvRw1CcSFIPr5IE8imwZPih4bpspsHPVVGcgeFELGie4N1kLFGUiMqNSb8kaM0hfZ0Md1YeG7oITcp6optd9UU8eRWImlHwHZ47BTlbWdECG2aOQ1Tj/AE1kqjbkanqoLjYfVZfNyq03CJcIkc27jmNUA9jv3RYhY4JmUn+YLHqEAW9aeBWKQfdP0sUGeLfogweafPTL9E0ZrDT0VctfPRNyP93RHp1CeHfH1WE5/kUBht53VJt0R4teqrMnMjUX5BBuQUmdduSIWUoZCfiq1k80GDxlGSraLvOV04lHwQAGw7AcurvomSYsi3K2xrDf1VMKZFKlHKzSyaQD7Tj9U6cZ1JP7sv8AFf8A5HZ+JblbLR4R/mN+KpxBbdvuhCv6Ln8Fu349hiiM9nvL3ijXhXL4dvP7h27Pd+5uvcCv9oxVEEwVsfkv/V8lo4AdEBmm/it1/8QAJRABAQACAwEBAQADAQEBAQEAAREAITFBUWFxgZGhwbHREPDh/9oACAEBAAE/ELQJTVaHDR066p9fU4TEJQCkOTSJ0fM5TIQk7J4YFMroCD7Dr9Mikjs6j7bcWRUpsD+8nkTWPZvdSvCq8fmJ17bq/Oow6oEBGhR04V6c4CJYtETKgavrtwcUECsoX1+GGDhs26NHtyEAyV4DIit3qpC/ONuaiUM01eOgd3lzVQAcKHZ6xeVq8QwLeBkNnI1PzY/uDgiyAlipR8LiQrVwlT/WB2B8lz9acbzpUdfmEKhCUi6jAGnaL7Mfqg261OPjhyLowKxP3gFRIEpifR7eMowvilOquV+POXZ1gCU/gRxHYy1GBtggAkZ/O/uMiQeSK6wsUjpUw5ghBln4YbFyHoryA04aixx2r8GHcOKyn7lchBXzaS8Ybay0UodcYzeS7u4fPXEgsZrajJlwyK2O/wAcJvBhHCWAhrgxeFXuXKKgjUP9mBZx4/cGQKp/iZpvH8HpPzFJOBe0dJgNEruO0/mC3YWl37OsJZAnIis7SQ0EE/xMjQCB01d3IDBa140TnNYaaBS2QehMMgDsobX1xOADBfzgcm07xkPuNusPf9ccQ6n5iEnzCFMLMXaDsffR+ZomTOCvY+Zou1x6fMAEcsJnAc0wMPaTBWO/vWQBd94lHKGcwLNphVDnHIins0mLzQB2mahK0F5xYA5zK2UhkUQAdWm+OPmHhXdQHN3s6mIilVjovJxfaTD30LhMHKOHfS4E7Jv5joZBoJogGJbx0dOgfsxVA2OJelDsOvcYcWJQHJPbgiVpAtBevFLMpPvXZsUqYhXlRVH3/kMASJoAAA28bgenBDEHI+YOJIBwrRPmAcHCVH493q8ZCAECXak+QIGG0uOpqOF79XgxwBBU6JqLAbQacx7OjG4mpUg8BxhBHUqb9SJilaKRp0gvGAmDxWB/4ZuACCHN8zpu684LAhp4FQ/RjpEaoiF/qhfjnNsL8Dx6rDLU3eCS8KFXpMLs6UVNdhcOA27lIPgK/wCXEqAIprR2kdvcDNa7BiRz4hJ+ImJstEV39arl+WtRTxTj+q5N5vveuKiI7QVD8+YKgnNwWBl+w6Vrg9SJsRPwV25HUoTU/pj0k6euNNKvXeDqSnjpxQAMHA41waaTF+KQLGWlOzHmsTAAFETqen5iBCRHHqxMXUIAiof6cf6vN2467jYfHI2u0kwVqsxiPSq1uAjlZ2//AJFVu7ozWpDg4C+GVVK+DAwatz9cWM18d5R6Sfpxg0P6XQZo0K91x/XFfy4QxylUt0AGEv0qj50mBAyaGunAAXHGHM8/cgK8GIlcWL+wTnB6Nck7w5Lba4kKwHQe/cZ2XfOHoQQeQj3+4MgSBojwHo+9YTY2Mr179rLjEC0A7VUf1Yrrj5VeBxx4DhWOGeOPSJQrpIVLpO67xNiIG1Io7O44kQAuNNpuHdw4bUA7fHxxDiBUVOb8Mci0SpKZ+kx2iGXh6p4FZcnY0yLKD8YN2gHxFvQ+GARjyNVAH3HkCKJlXbX/AEGJBkASH4vh7hhkUEB/OjxDbjArgE2D33F+uLk2gK1etzg0pQFE7hKPpgYgS9Q3rnT0DxhuiJE06UbhEA3KkHAIYPw3lfqon/NlXaBilBzrS0Y1gYfgKgAbJ9gMWhoRQEL+gMfgqBSn/AOEQKRQhzG0/ccSOiIpVL2cdXiSwl94H1c3VKgzeiShwA/cKMeH2OBH6DEyAQ6d6SwxgTSAIxYhHZ9MruAWlf29YmShQi0WqveIeQvKRjRO8RCChqA70msPPzTEJ/X9MTrIcmxPR8/2YNKR7HZkjBAors93ig8Es2I4VT5LxT3JiLRidJ9+Y+BHEOD4GOtCRBZs9PmFUFBcUO2px+Z7iRjgbwvarZpgrgLigIDpefzzHMoHpHGnJnAyDQ35vHZU4Ohx63AxJgcGpoOr64Sxagq/1yKQBtnLgAgQxQLoP8vwy+IqXkDCtMurvaC/V3gBOvX35nFJ/rAZZPOMIig5QlfYcYqG+vHnV+5WHVTi547cYd8ZKl4Gic5aMVi/XHTArFPMkURCj163rEISfjh9YxqNTaD09cBSKAzu+TgwoEIEd7p6bkjwoqkdGPIxuT8VgFSqR1xLgByvKFl2EeYOD4qkFCGy7ceEbhFXuve1wGZyrIi6U8dJ1j0qKGxOG3HdwK66W8iLO8qYOzYhLl/TBVTlnsx5joXAIH1QcJyq0GoEF4e97pk7QShCpUvxDesn/dU4Z/8AWYAxZBOEcR/4ZFFVDGoEO2423BIB5ETlG04pWTZRAnAB23FBB0FNFdpXjA8hoAoKZKkMRG8aRU2fjfRjka4VSsel2xeI4WcPN4jL+DQown9P11h+SmwE9+AhWGa2pggzYpt6rjTl4FFlBPgExTpgayLU99QMcfQjCicccZUvIWKOlcNc1XpPTxwGQJRH2PnusklvIMHiJswU8KRFT2Yq/WimjgdANCCu4Hf57kYRWiCvSNGNJiA+n6XTgWAC1ofLjXRwk3ehxsZXwH6YZjXtDmfDFUqq93mY3+I5Uh1TbEJBbC0AJane9axcXNGOPHHpPLoMEAq6AykArwKaPYPf7iKqtXl7cDLgJ5BOLgTBLheT8cQ0H0dYVFEj2YqxCpxhsUWgALvq+H3FYn5lxynJjsJE4cERcTbcUao+u9YSGwVeHM4tBZcqtDUxNnY0wwKRNJjQ13i4Wd4tH1xEHrN5rRsAXQPeGFFloM61vGKOh4e8Vi04mPZCBTdD7c7Yat2/T3Pw5Bg2A1ptTElDxIRHoO1yogs70d/g5uJslEgFVeV5nauCTNaIEhAEbO9Zb3AQEqOgeOO4CYNosJ+YrYClpeBW9rMEKgFRAdDqGIUhqwK7dpOL0YQaCXMqKXpHtxLBCYvKmKnCfuseoaBkSIp+4m4kLPtXJ9ERzRpkgIhK2C8JoxnVTAaWAJ2Dz2YYOAGBEmjPdcOJqHisRersw9ZCjADQGPyBp1ekHuaSFfIwgUVgA5/ZjTFJo1fBtTDceaBUm+Xgw4xgFKpx/NTIsgLuztv33bimjgBGynvxcM+20FXbrp8wnE3QYuhDzDQIYRgTQ+uOeKFt1pLjsgRg5CGoeYKhVXe1n7hYoHArMBRQ8gqZvtJp43honA4K/PuM4JwGUnL8wvhRCBP2bcNLyB5ORyRBSjquXSEVQez3AtY1Xa+Ge5DkxYkAFd7H4ZtGseG3s7w0Ygukyw/MX96/piUwHfBkOfODHa1HZzjdXa7XKNOJHeKQaMRHGLBCI4bbAac2MeTTiTeCVMNA84c0Lp96y5HFpVV4fMGSQLWRyZFVN5nQmFkVEAOWcvzzGIaiiV9L7h1XSH9OTDVU7mc05xeLGzDWKCII8jieG40F0dGGEK7CnHVy8YA3OM51eF9LXERAGiY1E5chDOqCD81x8XIYUnAKgKYFqlIrANq+DzvFuMUUoTh754x5ZKIEHXLBUB03C9+eXAqJNaCL14DquVsAVQoeDNauL0ikoJdCEDJ+lIicOuz/AG4DxSloivhr/gYkYgLKqTbh63rCrzbrJByw/I1ENC1eNZoAFAU7Fqxpyew2A/VtryGNjVItQvVTRdl4xyVYKOQgB7uujAF1K6AtLOgWU0mUWGM6AEgfvpj3INYvDcZ/KtN34XGUKgzNf1FbLtV3xljQkjYLSdXznAtvNkRHHOwF1xjqrB3l4BdhhTsEI9E5tUMVXgxUiClFdOK2ADbZWnsx9IZD+Bwx5on4crMJHA2M49+fmGiBoXRc7feCND4Y6ZDpFf8AwxRoQBFGgd3G92drMlYzGMEfZ0fFriuc7UFPo+fMFDpBimeXRiWTBtODcB8wQgFbXi4ayhZ9vP7gzWbm6G/Xbg2GGH9uByeYCoFfDnAINWdtWCWGKaDkDUriji11TEAh6Hp9/wDzY04ctjk3esIhOAcWI66cIR04zCJl9IBxjYtxeTzz+d4yqSqqF4EbjGqu1wQjgoV4G0X5iBwKVTj+PZghtBZsbQCY90BoZLgBDfZ3iLJEOTvEuJoC+481smiuEMjNRdYAVRdgVuE+gRAIbFHGstcU0Vj9PM4kom+3+dGJUJDZqbwEQbzXkhLTRgd4uf8AT51MoNAW2FoTz0yraFDBHbm/+DBKoLSQDJ2DPDFNAmHSuGPbzvKzQVARNDswk6yw3SjQiSGn7iJQOJAPK+H9wsXKsZOAK5vhziEFDFb1QQaHLbUUyO9KwuxqKAul7MHqJcCBY7m8b2QJm/AxKzgU4bm8NBI7H245FhI1iExHaBNV2sp9K3CgFKLFigOS5DtQTHwLBguxf48ZrZK5kilOZkCFCk0UQq3dFpM2+1ZMFr8ro7ce6jpIOkHC9mRJVR04hToxyKw7Bw/04Z2gD1HmYE0rAQA1UdSYdQAmVA1HKLrDbX86MEYyiIc1ujKJWMByq5DQHHavg9+4NsuoBH1a4+KRtn9LpjNd6WJPMqiB4BA/m8Rm4dnMyPzekVP3fOC4QiCC3IxAITY51iSLwAy/rkWq/wD4rTnLkGlBUNe4tQIdYm3BnZQveVs8vGcIYg1AVn8xQ7xVx3x3xgcVqAiv35M3SIlkPMTgBdjlGuOBxRTkAneCjw4xRTuwwbSplRdPEwr3F6Gk8Pn3NGx7gQHRO39zcEptXj+B3nNUZs7mJz94yiIKEj2T04MUREgAQ8pgmw2cAPVMV60OlYGK49qjBC76VHkwxWLwvK4mFEGWk+Vzfut2jr4L5krBtVg7fccaaH8mBkdf7xgQaPUc+7AHQAR3WTS+c4zzFkdA/fMsgEVdK7HDgCGaIagcu3eXKDCYihC22cNryzQdZOFOvVHq/DIo70QQDh5lGLwm+MBuqdpxeMFU2wUD5KDQTtZkoE4qSz2Bo/VykJ6Y1ZxDv94zdUWQgz04wJY2oawdKHHUIapfpFp+vOMiRTsI7v3vWpnAYsTQCCvq8HmSNEQera3FfIiO/h+zG/YBqOjHzGVoDWibL3gHmgjGDQvmt40a8M3j/Jwu7dRLl2hIfHhw2ozyBwCdHHmSYcuthJ1M72WB+42HQAYj1fRychq8j0D2YB36X1BanuNR0MaObAXAm39nbhz4RhwF2YQfKPgrjufJ5+vryYgiIDOA+X7l0pOA4+QyEBLwJM5lm9oY0SB0lGmJenuFy1Yh2uk+4q7zfCY2QC3uyYHxjpVfnWBsSHRjE1KhqmOBypiXCwD8zkXAhjMHBrFuAtbA5XgxWDZtVDHQipA1zQ7MX1svSGFkEKgSL9/MYxAbBKuLq4NGFNuXmPOEWbLiFYolKB0z39wEVqiq71MSpF8Cw4sxykQwVUfnRgwLCgzn8cGqkCdq61hn0CmwEur+4a0ASHZYP3CoECiSPPz71i4DV1eTBWHRDl++D65APdXe3Yez7haGBK5+w6wOXys2N6V5MUpeQ8OVyiu7xrwx56B224hEdHUO8BAiR6wTOBGFpBRV7Rn8ZcboEQV54XEfaNBZfVvONx5AIpcI+VMgAHGP3BxBJlCgNRaOL8w001OLrf5DrrFGoQayCUzmr1zjUhVQ3V7P3X8MjG8HM033tV5cb1LVtbtfP1w8XFtP+6GAAp22rgkqBs+YrsA2gQdj8yGPdi3CGBdIAPw7cmorLyt9/wAffNGBMIW8C9vwMAVQDxR0C8VzcGMIkPmGQBABwfhmsgIBpBDCLwR9tX0xzG+SlvQ4H4YImF5BFHz7gQi/mIdn0mkfnmOmtaUDj6YSCqACrYv/AGdmJ3DDv+lfnDgNDnWvB/TxMZcDRHiOMS8xAD7wmKYBARPI1ri6ciO83lBCNoPTox3TgxWhs2LEcf0rQIj3DVxioYdx/kWeSB64gfb15g3BwCax00XAlFFUeMJcAgcqfXN/lswPmoIPPXC3YR2vuJTF0/MdDktdoFZ5jALwfwPz1+5ITB3vzHhG4BYeUj2Na4wriCr8ShimgSYrkB7TnNnFcqBN3WSUgnXZnK9f+/MSqb1/MRQ8vLw6MENnZwm8W81zr/2YaGqco1/E6wABNABOn4MWBeAySe9+Uw5EFkDd6TG+iEhwTdOvcaRBwSAe0tyVTzzafr3+cGCTEdC7mN8A8e40oi/ffBwGIMV04giwcK5f/mLgEZHsTHijjlDHMkHRb/5fuUZEjuo36xag4VAUVV/0GKIAgJAehd/picQqyKnaD0bu8c5Lig7Kn+JkPRIlbHLXWPwVT4SqHGcg5LFWJPI4BjLJVHKp29QauF7RhEACQHu95b3BMWAbDzBAAMATbRcRoEFNVWX7xccLMgFWViBn4xrpUiQDpV4c1GoIxR2FQ8uOLkIWVzjs+ayMQBpHqJ0ZdthFHF6PwywCer5jsgAC7fZ9zUSZxQDydc2YypAZonCD0cRwsToXkH3JRHByOHr7gCSan7/cCceMgx4j4jcZqJ1ql8HxesHYURWwtSPCPTjYNmxSKdphpHtSnoHv0wLYUiaq9HmVAwSvZPZ7kyXQWg9fHCbQUUYmOaYqp9y58DFwaCqV+lc545aJHtjLx4aNU+AJ/RxZyO1EfwP9BwEQFFWH47OJMZfpM/EdIDxkiK/HWCogXhdgeuBRVDVeV7U6/MKJWi2ThMapUVmUM3FMW4125qcq/Xr8yZMGgYTJsOC8ZbpXU+fmaGHR5dntHw4wRWKadi+j/wATHdC+Uf8Ae8V1afgGI5d9VwDlgRtwWmEu9BtfmC0hL5/3vGX9uKAOIL1vEpilJVAB9XWIIgiio5S72fZgQnkbgP6c4ZyqqUSdihiioTR0X68uF7VvKlWaxaNV25JU/BwxAKVQ4vbkQKadGEOTEKv/AOFOVyFaSH7ilY3g7hQJtV5bimKrRplXDDeyCNoHqma6EJoC6b1vrnJDC6d3Rqnm0wiB4LIWQcKFNcdpbqGDToLFKIg/y3gzd26bR5x91MedBsNiofi1mstEaqYC7Em1xnCBowMNnmbCSQRTkB81RwkkNSkXH41wtERdKACB9/HCEBHoUS/5++YWt2AFocMpqmUPCNIQ9A4PMYQiUDtdV/nbhPsXa9cRgvRFT8O8twUqsOj19XC4jgl1h1XZ2Brb9XHbctkBSNpzhtO3BQrgQ2RA62c4lmuhoSPcd/uEjm9jzMdyVApCr724H0lEEbNjW0zszqvK0M+hc3UiooyY0oaaPA/44Rjc6ccgHc4Th/uAq78gsfew+OK3NDoOtOoHBnFAPDyP35lwRrGxLrGyl535dHZiiUWilPdgiY/A4CD+jHb9g1/AMF+3KZ/6ZvHyIX9ThZTCIKAdPJrAcwAKL4PPOlxOEUqcDNLPxMjnEaUmONWTk5/z5je0DCONHOECzGvS7C/8+4kkLk79H0xlCWQQqAv5inHJAQhyq/twLRUHWNHRs2ODEUB6NXJKQN05twMEIKwwBS/vmV4JQgA1pXg6rg4w0gvRvvNXtwZ97COQ4UEwOlUFXBeRfcZAhai9vL/ecpuzZOjNx/AXBH+QG8RmxD9MALf3GHHBgq4zbgm7hizijjhFs/8AMn3JcqyAAICD2Xe8KQ6aHzYzIm2F0BxjFw9WkG4/o4r0QEgUEAp0nrFFyWmgu2Z3cBa6XaPs3hrgUrqOmvzhxpyCqaO0SPZcd20AUMADorW5r03gGbA+NuSAaJFqHXyXGAJ1EvY5xg4BqJBO3oYTgER68mGdUkyUX/BhiFaBe04DqBkBzOkDuvCVGKTIqKV6HXQMEzTIIiclgfgZ0cofwjjFqBOs7OY4ltEAQ691yjSiQImL8BijgsNvNUwTJ4E0roHIVLoLi36cn22AHuX4TRfb4YgDxR8bA+5PGxCqjwnJ/cnkUZYKnJ+4LYlGiJz1vNoEXV3PxwYjQ1/8/cmbVwA1kQKXloE6MZQCugicI9ORymh7YoOJaNdmGAAhwpx/esZj0zpvA+/HTiLADIK/xLz8y2F2hMvWsd/LsEMQFg80pjU3KjAnvIOFjCgJDYGEQkRmrjrHE2enn744bRw6/vjjLTM1yN0E6xGuQT6cY1CEICW17cGoBVsyCRp7mrPARZS0R9xMcSQGz3BoLDhxEQgcLwk6xbSxNQ4vuB3NGHYKAojggPCcd68xUFo8Ju7w+QKsKD87PzC0EdpqnPOC1CKJ7hapoIPmD8xxHLmzCWHD05HLdmO2BUxbo57xHLfA+Nwm1vNrjzQH3nL9f5yHoi0fT69MBK3K+I4XgOWw3l7M5BBWhrlA5xYjgUwq1RmumuMdQMRXV+vcDhZziDB+5VVaj2RwPhiyiRPSXt8OsPZQu5Mm09hMGaNjuIAcY9IYj6Lfox8vhTbyODK+BABN/V8yx1tXa7gfzjHOSNAqon/CZecsIbyCriNlZXZfS63O8n3g0t4s0vxYYAahCKz3uO3jN8akLg8jy+XFovRAQF8Hb9BM3Mxtlj6gMQurJwDtQ4V6xIihVeeXFI/MB6kg9MF4jAchTl59yvRABOh+GUMIARk3ozqN/UpYcMkQKAaRmm9ZIwULqM4fjjSA2ISx2THlFeOrhLSuFdD7jxSibO31c77Q14GKEBzhQcKcuUAdqVxrWjWnBgdrx1l5AvQ+YJLVIoUF0oc9vTL8BoNI8T0ebhaQkg65OB/TJRAFtYjfMZIAogg+vuVFtKNs1h/SZvfnaYABi0DGFCCAOXsh6c4kUIxDhORPkxVYcXg8/cVUwcvQclzo5yvAX7zgmLE2nGQwBU4wxjBV8bozborEOnATTYdnWJpcNEMSKZzhLxPkxyIgo/t5mFUKt28XJeZVPkyRKgZoo1D7M2Fqo1Ii/HCHTfM4A+4CbZd6OPmUZGxxT3jmtwvnmKV4rzhFV1gpWx5fXwO3CBHgDy/XIESOAaK5+TAgagtQTKvXEGw4ECIuB+TrGY3QKOxsI9fvWP8AtcTTAullO+caERsFK7T387yAJEHqN0BweJhXFpWlWqCfuaJFoDHlV94kwWoyQEI4V2JoHDhyNKh2iNLhFha801C2zQd4JddTht2P3rDIJA3QeF7yZQaS09/g9u8MUQSTmQMaZO1nIILXBSBjU5pFBAKVqx1ckKjmeQdZugIAwNUHdaXrEgIxsXH8h3gUByVUQ/2q8GMLVy6nlCNA6MDegHV8Tnb5nWGL2xi3qJozXyMDwIZKwQKA6uTZawiAgC6BNmPbqAcrwAYg7AJyCmv3kZJREEcg/M3nLonAfE6/cvhUeRVD2Hf7gcFQrocm09BZkiuFQuAwYdw2vr5kdoNLsHonvzlyPA1YJ6AQd+uKQSaMr8M2IMdIorhU7QhBMGBwnFC9HBilnrPAdV7cSImI9pn+TZgJI4RCRyI4OKjIvd+/cAlvL99MDgwWHj6vfneMRER2JxghAq6tOMdJVLk9P8MHoAgCn5ZieAScgwx0mHQ7fB7MEQhIjVUOMrKUKRb0eGXwQEPZe3CXAC6Si+TGLe2xwWajQmmiYIcFag64xiQrdiaTCM0R3mzN9VtSb0gPDEDgTxvCQBxr20Xll878M3HColGM6XtDWEKdK4oSH9XKQvGLplc2bM5vFcsH+4kgKeHBZzeDo/XCVBQ0cDAAyLcbX/8AA0hsRVoIvTN74wDCgA0T0ODHNQVd6ORHHQrq0nQGxPcoUajJzwHJ3MTBZqgguFfCA8vQBefmRCjSVRuUemDtRAXSUk7Xm5ogmDZRtBhCuoum+jv8wtAsosOFfhD9uFwLKy+T+GLTHHCin41jjI8gCpQnwbjODCBTihyvVovDudHACaTdSzhsqdmEyyCouDDoHNLBLq0DlviXFZTQCV35EcIRrNDKwvs73zhViiCo4qHluFApjGiOkdxwVk2C6fxn+njKAiJym8iC1f4YqEruiD5bly0SBsIv/RcPNBq0qjT+uaeisCKcbfTWJhUExK9zzq8XGzEYdBiImCAVOhd14/PvWQN92hR/ExKNA2n3qu8qxUCnJ0B9wGhdjtOz695OIZSvg/Sr3msYdobmEIiL2hMHDp2W8ONvYPuB61WgCoYGEBxzYifcRcrva1pxjhaBfuOLcUD8xzKIxR4ZpPmbmqsDy/ExaaEnXDPh7gBFUZf+XDXn+zWH2YEQkxrUslOJ+Ywsh2By41g88XIYIAbUuVxSJE4fjhimm5gvM0J44jS8y4k0o7Q3+H3CM5VCWxyexyCNUAvNnhjqQ8Lwdq4axXhZo/McpBajvfGORTbwfMHdmanOLcywLhnnbiqu15XDY0u1XQeuMMxcLyf/AC8MZa8uJMmjpeB5xG4jdc//AIDJFS7AK7/4DgWaIoNhy/2TKnnsdEoj6eGJjBA6omn6DquXqIlpDwD1w3JRPdLlf4cYRgIbLqiAGbhLAo6tWjtwGKJOhRQ/ROM0MNx5Cg5uqhQA5mAEAGjkRqetmSoYE7RNCdwt8yJQiQWcsH9zfSITK4AfDE8QBUUHyHXGMYgimV/zX7m/lU9IoTrjjEWx9STiHjleu8hYHbPibneDUECNA0L/AIJgeQoHG+jEiVsaIQVdXm4Iymoqjx9cveyiUNCg8WYdYJWXh30fM3MIWrPwDbmk5QJfAYaQSBlQ5p2jaGjFxFLOukV956ya5kHB6j7jZiQIQ1BybaUGp6MFYc0f2xxYZvDDZSlChs8ccb4LX3B6BWTSgyuHBCmlUfj04sKFO1YPln7QwBZT0bi7uPPcdjrerGYiliAvaXj09eGaz6R9V1MlRVb9uj9+YFXwcP5iXmul+YEgvK4fp9wgxHChjpuO0BoY2ehy4HszSNH+oZugRQQs/wA85O7EeKY9BKyG5mlQQE2M/MNqPA4Z1sNn/wBcr0s6Cc4lmjyrWeB7guCDB+cucc0EP8YJWJWpNaxLQlh+hcckDsQ/5PMcRAkF0apfBcAiIVTlBKDjZ7KSD0I9PuBwCd6aP4+YkTy6cJlesZMoYGF2sDwzRr3lYNpuGMp2aPK24V15WrgSJrEJJkB43m3nDd/w/wD4VkpQmhCg+XmYhsdbVRVt184JkgQ6RWj1S3NYRIj0Flep17kGkFDROz9y64FyaU/9OzKOFwZByp65aDa/GiyvkMfSm1LVG1+fmC3Koa7/APbhlIeXTrq9dq5tsK6NamdksyfQiYFiJ5PeHBCEsTYuVQ0zbiGNTt0AEnLODHYme1DVEOcYqBRzvYL2GK2w0aV/7sU/dwdIBvwEM1yMEFUgj/o9YGgBUyt4pxhtYRg0Ra1Lj0UZhwJHk6TI01rqXEdh3eTCmhosg5VDs7y8UU9q7w74jC4YVjAgKJEPU69zjBK5UaiwGACChtIDphPhhqETSmgceLFIKixiJRRGxCjyUdeuRfqgiD2ryYkFSS8u9qYFrQ8iUcfBtKBBxazaJvnCBAsBxCy4q2xQlXXL5iymq2rtwpsFoOcNM9iHCfDvBqSDlkH8PPvebSFHL6MIYKlovpOh8OsMzVv8vVw5aBwkD9/cbm6F5/37hjjEmJSqjaOAYqqeeuU+G8BjbpqPTt/eM7misMT3yySkHdP9hiSyvAlf8rgQNacEzuqqqoJ8W8Ymbk0gTeMhXRGVH93vK7QFBJHtMAQ7eWXWDoSvAHe+DOLhlR0r3MROxdn35g2PMLjvRAqv47I8uRwgKPxGJ8cdIdAp7JrEjUAoAcSAZCr6jxcFdH9M5+1/nAWBZAhp4jvGzBGTCBIp2+X5lmWGHmKHN3jAVkbknLn4yGMRCGcBrn69uA4AHkEEEOFwUhJRFaNw7e5hoRwSugdg6ZvEnQEFrQ4GIdqqYyjJQVVF5PXu5py0uiEbBveUTWqp6pz+OsO2GqQhJx9+9uImWRVSifxeXzGNElyUpUwz8NJNPG/gdd4JOMheWwLgDWBPm62V03DDZSQKNyc/3CgFauYC8qzYCdDmh5PHHnU2JQWV6NJesa9Ai7u7B5Qy7kJNVDgfcmYKas5/RPMUEdTsBBLs7+YdTbpBjA9ibxq+7V314coUDRAsTez/AGGH4qWwhvI9PeLgjPBIm55fuXTHdL1v+646CVWJUhsO3AxULBCvD5j9CBQReBwnAgRNN9nf6OKxuE0rpwZOxZ5XZx7iSItNPmdWoa8xxiLVR1mtCV6V9fmbxsqvFe0+YplbSeD8yaIDLYyG3113gOhEe/o5IiTkDr5ffuJpir4mFSWAJ2sDhoY9pwMc/uXkgeC0wzXbBDQdQy6KgKerhiNsllfl6nFyd9wgASB8yYPQDRUd+FYvScZGy4gv9KgvwIY8OWpS+u7P0cf9okL8cRQJKLANi7Hs4MYIwQCD+FxJTh5AsLoRWgfzWDlPt2QmnG+0/ub2b79fT5hhNxscQwLSCk4AdXFCCE8dCXgHCmCvcWNaQh8AmKHkET7gikVg/JiuvQHk+nzEc4rz4ZcD8r97DDvEhz59w5CryTWFpJNI25qAUyPCmKoKXTyvCzrN8yv/AOARXR/MQcAGW93DBLzn8M3aIUFGtD19cmIDtkPau17isIWgkvV+LzvAtUFHkTie3EQ8hYgTRfTHxqggK6KCdHGDDZVSeb57rlwfgoxQgQPzl7xRAUAxGtt6NSONVViNi7o6AJgROzUIB4R5mtqQoc26B/ZgKkeg2Dwe5dyM8AXfwPmOwmg8HodV4uIPaoEjpS9mIFU0FQvKdBzlqlAwBwk4Tx1MaBK5o77Xtw+lEgiR5HGkHKCSSrp4NXHSAYSov/Z04hKgSDLxCcmCWPDgFD+YSSzcI+Dx6pznt6v10r4O8MUohtFfO7JlEaCPTGYusE93AIokQ0+f0xQmujpHtTlMe0LsKKfEmzPwIQIdkOMlToiSfDfJl8KO0FM25Af3IOIxuwPK7XwM6VuOCuriiSDbwnz9c56QQhwFDNAFWnhN6T+GRHgavrhwCrp6HwO2YO9mQch1cSEGOHpgON3pudYL2VcXdF4m3HSg6KFXrTBS0Cryr/1yJsceX/8Ak8MV6LtCHnAP1xvMbR3RIApxDtmCFIMFSBhQgvJtL3csQPJDD7xgXEZpAF+EYjqY+ucsW9bG24aVHji/mHA4OBA/mBCC6rzfi49tINOAnbjxUeXknaY0kMHkLYeOAO7bnsun7msUs5Ka7PMVUB0HsygntJ+Y0YGTAqdKPODQIH+DHU1HnGKPCD9Njg2fbMIAwQLrlx7hwZxnVUPMscX6YAxMuCFVDe9SnDiGIwuFgUdOACKfoGwF7esFQHUiKo8HwybQEldtUOejHxKB5jYhO835EhEFKP3FUVOawARHvXeFkSVoj6vX4c4gUCe0Ghj4IEhREOx7PveHTQBXh02H3dwC0PBErv8AfmMOEzpKVbziFQqHi+BhNFWCEQKPONaF3UPQnAOcL+JCim8+PjgxARCAAmrmNQyGkEWDYVPC5VNJF2U0HwNfXD5ph0FiF+Y94gYjIwrtecuENjkq1Xs8cBOaxA2ifndxWhC2Ffo7mEFKsuBOBPKUuGuEg7Ww4oRegeVfcLFrSQF+zr8wNjQ08R8cNONahwLyidR/HC8jhCbfHZlm0bq0npvnB4I+Sv8AnbDgg9jBxZVLlCb+uKflpZ9DFClBUbHy4CDwB9G4XdsgTwIpgAtNQ8O1+4nBQlvZdv7iCDXEFB0QPN9xBUEq1F/p1moBF76yytR28GGzZNIT/By4d6moPIvT9edGAoU/t8fmIaOAjZ6/uckHckB8P+uLpU7NvibxhotB9OlDWnpcZlmKD6KGq8x2K9hVcAN3gyADwLsMmmygUoP07/MsAXitXG8QnCysGsvp4/bggKmwC4SgbykRP9/mJxULsB74MkwW2bRRL4QuBQUitHyc/mVYK0nwAYf1mOa20HmYALgNv/rgrxAAPh5l3h2wyrj2xyR0ImKXzarAJtcDnbok1rgw2hhgvucnAG3CBIKdXhOi4eQFUCbfYeYpdjuIZMHGEohSPg478xB2Xy72xtxqfeMaJvd0+e4xqlIaDwcE4gIDjgGY6YaBAEBsnWGRAYiAqN8y8maSKRFe9F1o3cSyHREWnHuVPXMmGvXx0YWuavmQFT3CLii1KIgjvGoFgth6AfcP3NM5kYVXUkAc3hVeDWKdhakE5cKsB3LvR6sDGiINBB8neRoWWkDa+LnWOFxxVDYrbScTsw8ingQHj08ZyTamBzG6DNGgaG3iDDOAk1ZF+oPe3DERD4IQJhYBLUYmgE8xF4UCwQIg/HEHwhxBOZjNgluFtCnDgJsO44/DNy4QmPEYGJ8q4TqQpTyoMUdYKKBXIlMk3J2CBU9picFYagl+fcewB1TeSTmeVa46iaGvd8MBzYJnC0F/zIA1NnAc8dveJHnISI616+GgzjOQGX6h0eY1xAdS0Old/vuacqRHT+9uFZ0BX6bZmyYNVCDlQm3AghbJXsqd6OcOnGsCCtDiiQUB2ViXN1o1CTul/XbgBK0cgvgd+b1gVSki+Hi/8LmqTnYAxBpUVpztxgHAGgNA7x6aQFS/8GGKhUQHPoeDi5/CEC+zhg9Ml6LwMIwjjuvwLisWRBEcVAGsHn2/4GDsVPTL4O3643ZB1DjR0fcG8GoVvYHR9weky1crUepozfB3pO76uLG8ucipaug6nuFcFuawC8DS47Ar4dfri/QQE4Dz9cKCuXbiImBCZyclG8UrgrgFX/R+mASxGdwTl+vnWOWLgGODGv8ATjhFdYooAE2uLcAsXj8Xs8wLBQPDCMZV+Byj0uMqoo61Wi++4ClpjWrz/I8GpgVQCGbpqj15xDE0haKjzkmVcDZvrq/McEL1AjQR2Lgn3VIvAoZ3xhFxCBr0y4XaHibDpj0zvKc9itBJfPcvXFCCqsB4nLhMFm9qbPr9cPFUAohik4hlhIBVyAt4OVAnq4HAJBo2wHvfbswIAmRQ1gTXBDF1AwaA6AOXNzC7Mbe09DDYCB8LeQ9V5ejFgWyKhWgD0BoDEokaKwZoPde40rDyPL3nnJjRAVf4O8ucylQD1MKBtA8Ih/tsw2lIfMML7nNnIB60hn5Mv8WOVoMNUNGMxNrhwciNq8kwfDpypziImJgEu64j0rjyjP8Ablv0gdttQvtcA41EDq2B+YXdBRFFXanejjNFHlMDz8MUV2a6XwHztxeqZQWB6TgPrgCNqJ5fg6+nIrjElgA5x3kyCntu18wQCpoC3WPBlUGyeGBsNkF6rzkkDYC8S8B6RtejGIiGFE9+/wDriOuhFAVqZ0zcwoPBR1r51x+8zGRVtIAHmmt805MFnIaJvxXwOsHghAqabAfX/RhIL1EIf+rgJC+GiezAh5b2/wCGLXvyhGeDjnHgOv4HbhoADh5T3wx9ptV4MKDQC9Wv0/DhwLXx8j3/AHAaQBC+5Q9pw4hWcveKlTlpmsa3o4xeOhqwvVffmPJRqAaX18P9uPRGjgODEFMn0AOxuz59xgQxVcq3wbV9wUJBaTa7qh5gPi+kkJ0j/Tsx0CQTazJhXKVg0J3fbgQHhKk7j5cIjKaBBvC4dEHSq3tp24TUgIpiQJ1zmpMiG7WOEwegaBYBy+gp6Dk1+nE2bUrj+AUACA1r24EAKzJ0EX/ONYQYqMVh5vLljPtYI4gIXfdV5DEUoiPAPFdC8uSNBL3VV+rhqg2hDRH8MZsiBWtufZivocYIUdP2tuPh2hDZ1BHnOWRQEUeC+BLHHQK5goIm3wUyT3ZH1BH9NYSZIj1cj9xMPYLwmhX1xWwSgcrs42/caAsSFQF+cjnMijZqHxV3/oYXxo0DRlL86zhP6vBk1NXZ44BPQ5xAdiivKGuaWcK/9wPFKzevpiTgjtPmKkGf7ch0B9a5boPrgtqBXZG29uJV4H8SAvzCyUceLzj4OKJoGmUWmRa0soByvBP9uESaCqauhy+PliDRQ/A4x2gMFIKQXFKi9IHZA7X+jJnS19nL5AkMM2JQOmKYfUVPgVmVZgAnjnUwt4C5XlQAx03oROkwLC+kbSCj3BzoDZA4ZLvUiBeD/gpko00htfEXWXTIAfgJ3fcfE1QQhWmYFpU0K2uXxW2REilxiLlBsPXwy0al2pzg6nQDTPh3gvg/uw5VfhvE7TEutyvU2YcNi1Xthj1CHRg7K+9Zo6v1yC6efzGyABVegKuBQRlB7uA/2XOBwbcXFXBE/wD4ai8d+5ocKV/8h9zVy+2bBxXAtK8wV5uutYphLsOWdDn6MsaigTDaq9F3c8grVoOUxaiqNmxlfrJdi65EcEeNbuORp5sEGqPMO7SqaEtGflLknzW4RYB9rcKxQtES7fHU3mp2tk6ZVHzrNEqv9NMbQlyGqAN+1wLCCITWUj27uXISZeNNuW4BBdBGjxMEWgAeg8f1uHeBUm5oXuDYFD4fE9rMJcMnR1BFcYoKDTmFdCmOdgVbA9ffpiX0GrQdctbd3Cr6BzIgJ9GYMREAmCsH7i0qLW5dxTCRFTdmnanD1ic7QGUllfed4gHQNQ0rXl/DHDCIJVlsTy7uNFSjw0mS4Uczg/XrDbjsDSuvr+6zezkN0HEHRgRNgEfy5KuRr/vB2ElwlNGTIl77cTmc+u8eoF0q0vdesabgXsE0YJaDCnHqvuBdVRJwf73tXCflSDApqp13iDWgQRF9Q6Lhd3ax2vD/AK+YaskGwqDDya3k86yLKd/mNkaQrVA4A+YavVvkdU1lrtKrPBSZAv2fQAmAUAYcB0UwUFAibLyOPJyRHd7MdDUouzirMgpSRsRQFE56+ZrAFLpVYB4YEgHlj6Osd21VIfTZrAVUQBIHdYtbvsSDyOjEmKQARy7/AMTEgdQS36iLMMFqSiX1XKkLaEYfD5hiaIJ2LXq427KrURp7GPITHvK2g8MmxOtuMeQ05TsxnGzKvGJzvlZjIqHiFDC8rvDCuVVf7i7/APwEUpPIopvADwG/3CC4qP2GFG5SMv4ySnKXH9cv10g0PmvadGRHYJ9xty5w+AiERF3PuJJABJwTwr93Jj0lUXA7D6mNVJCoBjb5+ZcVAEGU4HKnsoK7uT8pixDdRNG8YxqalBF5TmuAwlYkgCHxnnBGI19DS7cfJSARVGqM2K5bUgEBsB242lqi1X4+5zkJRADtvN1U6xjhXqMEBoH067yfNCwJAkMGtRqJphVJsFymNarDNX8VlxOEgVJ0cunzB1JhSD1X719cF5XJGQKrZMQMNFLNgfikvecR4DwngLvArwUk02bV98wrOpqiA5Q+g1cf7lAQj7O8eq+VS/MWaF9hzkEOTUfcTiByvf5cGWttIp6E0YQBDyOxOwe8SlCqFk5A4fAGsEp8x6kgbcdcygjJrm9Y5JCBVD6vmFXqkhfo8jEvQqB/YMSmfJBt9rEOMQfQ/pz/ADGMNRp0U4/mVj6O5ADsesEdWiel7fDowkbh7i8N3AZCXhcdGU1KljimGDa3WXiTAbHlafG467tgc95ck2GdaOMcjuCH4BjFwHc+yB1zkiWRLG7aO3BGjU+BwGGKsGhKt8piykwCKIRCaD8yE+Qxp64NuoYyoCup8PQnFdDFyiN1oThANYpCEEFs+hjUlBibH4v/AK5MCQBYOule/esNlYEj4NXOFYaXb8gLzhvR94eH/YOI1UKJ17k1C7gaHzHd2mOwQFSgJyubqIwyRNlHUbDrEHAArm5tUIM/HsfuSaxAbijtu6w3XrFZmrnxWC4OjAD0rE/cN4Qo+AggMTqBKKw/c4yThxg1RDdycGtcc4LSUgAUEk+uuVxY0AFRd+ufzKILMJtHbvtzlFjR8Q7cPSBRdJX+6MwSYG27NxL53hmaoDFChC7MdUUaI3mBiYQEhVHioHF/swNUfZVkH8TrrDcxIiLboTo1M1BUCBtQ4enGeGMXR0RxgwDeL8fn3FYKI2BwGKzrvCNXMHfqnR9cfo4BiJWC3TjrbHKQkcHqqRA6oNax+IOcok0J24FFeIh4todBzOsPePYA+MXU6FORPV2/MbaKgra+uSecBQgmrjqvBFn8YXCbyDS8bO8mUEImzjqWPLpxbEG1yneM1YgHM+HmB6EEeUcoyHUHSPHz96weUVEUt+zvFKjpHQGEe86Q/SX3HIaMX/wYEs1CfXlPk3leHBoDgyaAFeHo/cPJUiSJ7nuPCK0E/wAzzIukJpi+Pj83jpWKih+zt63lbr2qh/RxZGFsF/APcBTN0cAPV6V3MdgoJQBo4J1H9cDpTyMfP+B24MS6A+TCXsZcACrcruBo4a1CfkMT2oAH7yuAwd3Hoyt2mXtm3IiIiaJ4crWEBGIOBfnEuF7b3knMPeOMTt7LQ9K8LwRCRYKElVO364PtvN7jgvmPAUlUWj4/cgmgxnL9PcnmA0Bf1ybBnEgY7L+aI4CAA8Agv0wA2zQvJgInhum38+4Ag4hgniDpxgIjDsYUTEiVXt8us3R9tHN7+LiqBF1PcMrxrWOC4F7wKfAVcUaRYo7FcjgIagJay6MU8MgSDO/rzvD0BVlHnImHVIF0G8cqECdhnT2fE1gNonaEEark6iwh0XiOE7PMvKMELW/4KHOQqIKFbQ5V6L0Y20mQvCaP9OGLqMQND1A+u8ao1pZGhX5keY9tKgUcuhDls2NIdneXcAhNbSB9wkg0FU1DU8u8A9EkgDT34i84DEFReRfcM4SgS0JD5+ayjmgUFzJumGMrTWojQ8QJggZiACTbdhG03cN9hnIq6TDMUlKkLgWmlAdJwx9xHgFwU45H067ymo1xyj09MSVWavabpPHFv0I4p8nJchDpjdOmg0/uJ3CUIUe3BowcGoeie4qL2kIXeChV66yAZq7HiZbFOLQeovnT7ikQtVBuuwe/cYo1mo7fMUWc23+DiKTBY7B9DGN2uFD9Dtjaqradq+rl2KZAVXFfmbzYO/xwFsQJPSYnCgKUB74uXYy6BWftaxxl2WFPwwNsxQgO1pz8N4GEuVG3u0w1tdbCA+VSHwwJs+HQ/ilX8MQhAmsqHk6X1bjCU2jVPV7jII86Aw78gAEWPKcg+85JtVFX1OVx6BroffX81gsatl4DYxF4rHpHBxEVVA2h2njgkZuGw86DNE/Ii8B/yU0YZw6oyrrbwZIlNYdSNswS9PT3Mv03jDnBqp1pDcfML1jtpz9TzKvHPNuCo4t09Ppg+Aa39Zp+ZaLGCDe/MUwkMo7HLq8BVYjxASqh0wMqcRkDpLsHDL/jgoPRONCnNxCh4I/XLEplNX9ziE1kuxRs41NGKigAuxgnx+YT3Eh7PDF1NCp5RzQM+14j7jrRtNYdiuurjc3u4VA/oOcoUcOEp/5e/cK/qABBO1O8RdR1rXLn9zgYEvKjx93ziwKWQIT0D3iHeNulkHBtmw9HAT3OzHdO0811h462ErYAeO8ZqBoUUd7OXGXc1KIDSvVMfUHIsZrSfKTNDijEp2r0Y3zdTBGw2+NxmIpXNWgHYnnGTsEAtPa+dzvIsSeAHKPB2GL2QpCrvL0yNqIuwt6DzIDbGpxq4CZCIqOyF1e1Zqz0y/ECL8hyLko2B6Dn1lkiZ0vGELo2jtOqevmWjSFYnlRv9HFtBi7qfB6x6XNRmibfzHSiCL0hjlDVo8j6+Ypa0RWOfcdiDYDgcoxSFHCfhkLUXF4fDCMDnl7xJDYc4K5VA+G8i/p3vOa7tytRQFy6I6FNGEIpOFYwJFXaADGod8Cl/esWikogn0JB9cuQPLy+11gH0fSi/wBPB+YQKhOdXy8rjEVjzqOIcRHQtfvOARE22r/6+5rBVdQKv/8Anw1jFIFqROOD2+vBgDqA6IcF53e3BcsEeP5/MWRAq4A85TsqzmJdH58wQApNFDQsm0EG1Gmvn64W2BbHgHETABSBSbZjoNgC8Gcv3DNVDauq4/L/AIOMJVODnzGLOXCjYTJJycpjrhCDKjdcsqEbVB2FAMbbJAdLpTBQipLOFGOJFWnWSKgGpzrEMXQ4KE4woPSXBmnBsDjL05K4F8BtCuG/XDdpOYV18MN0PLUUW9GR8UNXQnmCrhsFKLVfepkR6WKEhj/Uy9OLhzKlnzWCoFhB8/d63cFiKFjxo4H7iolHj02z+OLPYQOG7uNnmLE0l2DggIYDtNhfTq4WUQ2YcJv6PfOH0Ii2co+8d4WAyAig/lMdgmEKhCEwud0e8v8AOzvlwoqa12u1abW7HCLRIGn1W5NBiiUcCAyiz+gc4pJgCEQ6wrMAwiKqHvW+DEGa1F89F/pi7GGk8LllLrSfcjjhoDThZdWtXvhx/PeSP38/jjhwumP+LjrWaQreSOmkmSyelar4gHGBpiLNh6GFgggnAxjUKEQg8IY/IduyxPE7PmGBCsaA46UCVCf5fDAZaTTU9/DC7BEcxFuK2AIB5TlmIEGDgnhoGTGr+wdHmIRwCuMLDm2VSr4Hu4ekRqigYbXDspnxVwxHOqNHweDHd1lW1+4CiAIXD+ptfmEHvSGPF5c4j+hQA8v/ANcSQqtRd/XFhYnSCp+vGDdMOBdn0M9w+6fhyMaZOS6fxMk02Irdu047bIlxPv3HmQAM9kJg0kmv4d474Qp7OrAgH6fcMQhRzJ3ffzAQXUqpL8DLmrYdU9XzEGIU4mw+fuVLphyED7rEmqLlnWDMVJDnf5gs5foLJhDp0gecz+sMCHgDIn4OzCIPUB/8fcj3TOo6HxxNjzSefMIcn/5lTKa6tcZIhApvc7cbx1u3SOJfK/OFQHbuZuMgAn+rGUrZ1O0vBlmF1Hhy6SknoW7j8esYQSpCWsfOsX3OG5Vv4nf0y9WoQ3Vsoed/DLDlLGC36c4Qhw6T+2XDvxKDAcw/pg9hsSKzhMhXnQPDevS5SQIInAN3/wDx9zfcDS1fj2YfJAS4cDhYFO2gN7/XwwEIGwkfVxboqOrRYMIw2hRskA+4JPpAKO0Jv96wB9SgopvPdXRgdbLlgGdV0YTwAIeKCKL84wi0GjwdmNgeOvj/APMcpyNXNwFfJyOFRp2Fo/uSpD7hR7i3IGlbXpccwRBSlxxEtBA3Tja0NEfTPMWcSPNTt119yCSjwL123L/bQI/jjYMPFRcAwDUAj+BjCEXSgAD6Y4vJXqriJjs2e3oxrr/9XNN1j8UgZfQg6CG07/MTNxatB76ffnBnGA0FtPg9Zv4JIg8D/rhFnyKuj199pwZASpuTSnr4eY6BulAD7cBO0WReQef4YYK4A0D6+P3Dky0Ii50PZs9F4fRyaIGyR/Q4xVSDTH8AwYqTLKFf73+GGw3VRu/V7hzBE2R3xiG4Uh2D9VwAVJU9va/cF4EiQ/kD3AaKaocL4fM6e8ztwE0zRujr9fOsPUCNGBtFTbu6xCgjyJu+3EkFT/eG5MIgtAPOCAbc0AOjbB85y8Vpq4rjR1gxU11E/hE3jaq0OzHoMxkKRQqL2mBjBFCh/d7MPUJPin/PxxcAj1pMWYlsF4BU+B3hRbbMWedj8Mk2NnGHeSs8QR5K+yWxxCQ7MJHnePxy4j4SgBR5/r24YBkXSxnANl6RKlwuxr0pp0fHqOGwUYTt3D9xRNuagOlYNLAihdT2ytnRXyl2ONFRVfBgAulQfeUc7MFAFBNqd44gCxLK6cVIpURIDcyuhwJsn+QbXThOoKypUFTpjjIQEm0ldePOAhLBvJa8/wDGG0iw1V3AcjjMqAmuuEGOCmEI/wAXI8iQCQ8/zrNZKoolCkQdmSsQM+JpMOI20slfQy7OjYvnmCPi9f8ATEQdiuHbQNE0j6eY9ng0Yr9xRaFOqXhPcBlmxoK5NSVJzXv7mxwFRr+GBZ2AgqJ8cX9iUK03VV1gHQCFfDANAwEvu7r4YcFJpReyduUdx0Af6cN1h0LcXgKMXocX45OA/MlDtA/WgZqTkJ+STCW6lG5G4LqFUNE+5QBrx1B6fr50Y9ANrbW4p2f+uIAoOA5XQfMPoiRYPV9fmKVpyrH/AD0Zao1tAqfHr9cCFbascIdZUiMNMoxVOOgaDDImLGl2vKwcrki0j0HB+4EgSSEDe19wmoBv4f10ZpLQChtXVuOzOcE1SEoopMCn4VeBkK0ES9eHmD3hGCAN6JiWpvAImEf3f33N7wHLjPC4thNGjlwdZaXaer0Y7k9XI/PHG+UZR9THdYffPwzbNLw5GrBg8lBESUTsTzBwXbE3gax22Nlj8AY0S05IX/CYb6R/tUFwRVCIZ4q3BtSbz31gegiLKGIt6Ob24xqRKR5xgUh2elR4PDDLyiAbe1sNX3ORW40GFyTxynhy7MhkKAu32HOMcDjREImEabKKCdh6mOs26BkRcPyiMrCqe0xlGggQeg7eK3AYREOEvB8up1gUEXL6TU+mrgrGhAEQnHpOMdxauGfW+PzzLv2xIuD+plJI9gx7PvdyLKBNC90bPpj3bNWJfWusi54hR+9v65ESiQKp1Hf82YkkJAsSdKOvuIdgCjpHsxowkKd75mLcgiCFyXVeup/fH9zfjsNemAMRNL6+4J5aHF5wBprs5cBmHnxuER7GlXAEEQAWcpfep1lVuwQeckqBoXgeKmbjx0w7+utYq2gDWtWBj5ZACD09P9mWtDoA4O1MRyNAJj96vFVw+H9eMOA597wEbb87yhYJuvF6Y7XcvICz+VuQC8BD1TMSZgr14ZXJdldA7b7gmhABtAhjBhJVSw9f/neDdaqXn0fuCSAU5UmF8CwDVwnZbrNQAUjs4M+9HgMRJKoGoAD1cQJgaPA9t79+4WxE2aVQH3D2ju1Qm48xNWitaH0OsZud4V+B24SJDYcr6nT+pha3+GP4YnDcAKs9vTkECaEFXxXgwMLwAAMd7w8drkCK3kJd42jYDn9ug9wtWK0in5cKDL5RS+BN4kBDo7NmlPPrgt3qwSndYlEA6Dt9cDMI4exwICn/AOQHYD/OAGiuiGnNZ+zEPaTw3TEoEtSYoIwMg3o8uSIJrdo6ro8DRkjXSKHpvDJskUYS8ZUOsJ1D2euEpDVYW5T3MCEBSCCiL2pzhH6qur6c6ZmlhHexVI/ccx2HoCRX5kaldnqVwSRoTyREOamIEI8DEPp6BsTgvsza0Nhytv8AXFdB5ifh/wDThoQWqqJomHIV2IxPbx+4gFQdnSvLHp+d4h0GTK3r9/vOHza9Pu9llucnjX1eJ/sy9hqLKI8L2ZJEN28IvB2vTjBK6WvK6R7PpiwDY3rv86xqk4HVM1Qjt4QY7Y6IqH11+YbgGppidBwbcgBDY52D6DwYbQXXZiQKd5Q4Dhdm0X6YwiUQ7mFyAJ/MdAgvPSOFSroizC5gtUp9eh8cRREDvF9nJ+YDAPAMT9M42jyJgQKg9r1irQ9q4D1xSKlFct3H6+dGMERY8AedGbhmi9U4xwqpQeW8L53kKoAqQqi/blJMO42IFVfMsuToDEcGTDWgS1eB3l0KrXR8vcyiBSAsP/GAuAPo1Q1x0V7hcU2AiNguB+auREwgHAif99wwDRTsAYYgoKCwIeB1ihRRfROH7hHA7oNsd/MmoUA6Lqr/AOdhgOnWxBwaAY6IYEqF7FjjIJDQGLWqgBZ1heyLXpwSoGS9FVcNGANWA+uJ2kO9ih1FeceJQ1Qq+pcch1ka0TBJKCqcBZXOc2BtecADHQGOVs2yxD8vB+7wpXa2/wBY6jHbUdifqU48YvQYZeGxLCD6oOdnFuinLaYd2QAkD9Nrghh4ui/Xo8Bhdj1SgZsG7w7iaWy89e5cGgVPAT/b8y6KPNGbaZOSCteDpu4ro6XBepbGuMK3EfEHVV5w77ADmNxy9XRJDkg6/XDmtFj2cc9OCcqRvw2ZQAF32KN2J1HvCoQgWNhMTgUaKpoAfekcVglunc3AcHXLJOeBp97phBwo26eNj6d4/wBpyJA8XEbMmdg3vx4yGAkEYsC9p/swiOGwtwf+s7RX3h4PmEUG0LBPxznYzbxv0cKBooax8e8I1DYZEuCROOLzgk1TXpMRtLgQpZ4Nv68wJGPiIw4YJ6p/daxcmdKjXxyaBBNG/F9f3EYs0iT8IGDu4Kqo2kU/j7ldbDVT/Qy0Q8Hh8fTGly7B/wA2L1oOQ/wig4gK44K3/LivAQsKTBwTbFS/wNH7zg4bKquj79V/riQgg3GloE43yYOQql0XlXr524Aq0pJAEDGMXRU6HtxwApKoNbPRhogaqFXk6fri6o20pv4vX4YDyl2Bvfs6+HlxJoyjzHGFS2pBT0Os1JNATQL/AO4pofAfWcYjRu7Ein8pxjOcsBxcg3ABx0QwPEOnigHlOMEYCHbxoerkcXKg5Q0QeMUwoglDbvl9w7NKYEbV9DjFscgTOHhzoNrh08IDwvs7hjl2HYXeMN3+u3BEU61N5+K8marHAbkGTkJtMdaQOKVGLFcF4wwhagCreInONtH2tWewkwaOhIgThOMQiQAAP8C84vgBdsH9AwcOo3Jk3YC7e19X/riuDFdEC8L2ZPTbxxf4dfuPM/lLx4B1mmst6wgcAxP0OFx7y2ux0jghgdjUQjTz7kdquKrZeMZZakPUK6+zBAVA0t70rjHoEsGhUFPl3iawryKDWPl6/Z8yGhgIsrkHtUCK6XJrgW+N0ySwgwqYcuboyXQq0OOzCxULHh8Bg27izH8DjuhwthNl7fhxhps3igeX7j+k8G7MntXSr8hx+mV4u8J+lOPePAtN9Umri4WDtDbgsKHk/COSxUo2IdXAIOzRC5IoKhumNygZJbQlBSJkpPOJkxdjpZzxpwm41rUyAxcggBNBvacvV4wcKgJjfLyYzAXyNBPjxg9BOUXX9mL0SfNf5cDQHPCgA/ciaV/YY+AjfK82Gl8ND0OD9zvgypBfjv8AusUgrUOYOV7c3JgIKQGLwsBPFs1kmtoK16pndnilOxOuHhy4o5uppA+AaHw24K5W1Kr4OjNcE7HQEW3JvsT3Qq/uy4DjKWhfiHuQu6QPd8DvE7BSe1YZMyqiehtyVn+ZzFw7ckM4a2/vWbRfnNjV9qwzxrpkHAEWPnePMwSg9h+4WCIafmIEDcAmMRPFCqXhhkuR2KrvED0oIUezgeAf+4caZxBgirfnWagcLDFVOCmD0GtwugvThlUFcyDfjBRwEoSL25V5IRTQgYbVtyNg+a5yUAPcj+GB4A5lrhoUO4cj1ej64bsFq8H+t+bxZgnXbo/r38wsCwoaHjg4QTwViMEjXPoZWg6Gh7/V3MNgQSpGLUZIhViPcTHejyBRNxcmQVBXIq4t3BqcyCPp9wecau0OdnmIL9xD7iwCzsUDIm8MS16X5m5Yt4URED0S42q8bE7qYrhNK3E1Iv7zgtlEVq81H5g6goNIa0nSeYppYNbf+jgGoGuF10vvmPSGhiV4O8vqm3dXqefmcEPjSvkcAb3QzDOTEKTyamHAZJPaX284lpBoVnidPzzLWOAhGJqgxDhnqTk5MbcbgCDEDOQLUdRMQ2RCFPfRxSHbMhL+mD4E/ByyAvAPuKSUHOB79dn6eYpUHtXh/OMvExTgS+u9/mNEBIU0XoGjoAwre3RKHWsSQNIhj6CawaLZKAsOQKQCAHq2BlYohoTbo4h8GHFEqAUPxxmlRthqfvr/AEYWsiEdoOPhm5KHg8fnvrM1MYA3C8GNBBLR/Eev15cQJBB5TbO2YKjHKRAyf4opWDpOJ0LjqGR5UKlxaiFBdXlJ7+8Y81VceQC/rBWq8R8KhgLXYeg8z2r7xnP7RlR88GJFHQgJBST3N7LygIuxjjqq0dC8AZWcQUGwsH5XhziARVOVR2D111zlcgIkDcVDBo8r3yuOiBzg1xhgDs44cVw9YgQK3CRadL7mql6tlhvD6aYC0OR5whvKugNT8fMqEo5+XZl9gvTIzHMG+DGgG2zfx+4WFKr8rBlLuKF3mnjUWN9fMtCWF2dC+/MbMi9EWfciVFYzZOn+mSr5xNt7T7MZ+hpIkeT29XJoRBCienpw9mmQ2fG4gLVUFKHS4HABRGXzW/R7wiCUIHl6X38esMagipybk/ctwgNQo0p0/MGdQUF1+vuGAekAaGbyNDRT2seUTZ5mcj9Hmi7D4PTjINjgR6TpMZQh2u79Q0/TjNxT4Kp+vJh9BaOhiQaKQT1eQ/TDOFoz8B7+94EUpEZAcjLBpdKeH/DkbAApqXz1jqCGwRr01zlhMskNd6XmGYORzbh+Xw0UXOcQqC5+ucxhDDqeJwsNJIgmLYIPBMsC7G5TG8p2Cf8Atx8S1VAmLrafqf6wT6ntJBTJ4HTQr1rjANQkUVx3EdHk+31MgPwAVHuPqvVYL9HjAsoJNhQ/McjQKgx7rjNd3EHU909wPo3YgH2VLitgD0QJ1X/4YSAkcjFeQvRgm1nDGX6vOMQp1IseM6DJXqsQb/DJSQ1wTyHo4CwUEhUE+kv0MVYMMBJvA8p94wwGENR7qe+GMGgkBsdjBusc4CsD+BzvBelEaNqHxcaRQqpQTiwXKiNVV5W9fmHiBKOLeXC6iB5e32cOIFVFLwi/DquQCRsobHZR70/xw4QCR+sH8DA+8oJvTo/ocY08fY4TpMVYuDe8MwI3wYlyl6OXKVo4PVxMSE3xG4su35iuCa8yds9wTdtURjcMO1IAr2fTJDpTrHvMYE74rVQQDl4AZxAa9ViNgUbHd8fDGQ5AKh8V25slHUW1+mLoQRGER4VMpNOfM1jXSIA+Fgj73i2buPN9+/M1cVQdB6+e4a3pQTlf9JiJ2Kt1U8nswfiB2u3Z2Zw4AB7EQMaxEoBQzd6cLZYBDsvDDFhXdIBp2ecNNUoKoOsLzMC8pR4z0CYqB6T5lO2GyuchyTvFIXhfAYgxUQoqgR6p5kR9iSByekwmqIXg72mUwmYEU+nYYLACcgs/OcZBBgTCdnp+4eUANu0ej0feTEMhEaoWDfcmcGeKZWh9Ax7PNkQep0uKNDjgzFo0Q5xPnuIag0JF+3jNqRBIU3MHReOnYNLhwl3Doe0iHFQFi8F9PHLJS2tTLoenY3KYXkZXEBzW3qmj9HvATqtPeyGFfVIHWHoY4EV/Cf8ARxAEE9DrEoa8A/zHGMCoolO34wCYPXB+xcRBAkOT/HrLEESNQKZx6lV0Ht9fmQUaLpD6kM2gIIi6vytvzgy+o6BsD1eBPC5IkDdnrcO34YOiACKD745PAQGU9+B9VchjaprOe/D64V9KCVFF2rl6XhMQzRCAHhrA5n8+UUPLiIEaodavONayI/xM1QNJ9miuLLFQAq3HyUG0IlRfNCY5C+mMdk9M1/QfN1TGhDqKwXt6MaAgRUo9Qaf0wdEb6byICmDcAUAqsNQW8H6XHYJggv6eju4kHVQGr6oV60YGk4AFF7TXGLYl2Ai+L25KDUVUr9ej69YbYi6aivgZ5MP4NXI3Nv8A11jhlZV6KuSz+9xx0grrblSrhWAYIEdj/RgFdNJwpQBwcBCznFEFGdoM2ePEPe9E8TBioWOEeT/DjugOiFibD7mkoVTlHkTzDcI4kACcDwMaCyHpVASdZLNwIVzKhw4JIQvVen3H6AaZXwHZlaQ2lF9B8nmTpFwMl45zkUqkOMNytbAm94e3dFoYOAcyVzcuJ0FIBXl4J9MExYpBRN33+Y8WAs5U+B0/MLABbVvhiOAxgBofji4UTjXm/mCnApU4Ph1ldQhNCul8MaVGGrAq8HGF3ZAhT3E+DIA0/Q9yPELy8/8AnxxmZCAH1THEDAAqXfpzeVzaqNoi4jjqipNWXDiRYThb0rtMTsx0rX1c0oK3vDOoaYo/HpwiDWG+ci8P6YFP3QeFOk+4gQRRvp3gCDpnyiYYQXpPD2Y0ojo5ZZowlUjwoHHyYOeE5cFzgVf9GJbsNKKX9ZhvcekJnyHCRI8jTDMdmgk/duA2oBgPqpc1pQNUTgV7wth3kbl6Ag4n8AVBoy0otovJpTo+LhNWYHTbX/UMv5KUOh/Q68Bh7o0PmoHjBnQxXgBj1UOQUy/NJKcO8dzSFejWT83IGmuMFpSrOAGPLsU2Z6OxV714YP1l7o4roXwFYDk1HKhThXYTB9ChKwJzVpXbgrA3kUXESzUAI9RujFONJcO/9Pe80OwOD6fmOHKUawZs8OLecoFebK8eXnANQXbYD3fR7ivFr3Vl1tOZvJYNUBIdfXAjKEDap0YhBaoFQ7fzB9hA47rkATmkJHo5XRalRZ2PGPJKSGmJDtguhQQaiIH485AxJH+ax8kLA7EeTHKvd0303GPOEJeaDvJOLBDXmGEljBNsX/I61xl38o6pcBgsIDeu09fTCW6MnN4omGyiYO4H33D40wUFXj0zpwtxDh/wp1i9VCHlufsnmBKAiFKIto9XneBAgQCPgt04o1aplAiKL/65W2sxtmKcfcJ7TCDD2zowUKshi92iOpgws0FWnnscKhCEQP8AV6ycMdqhn3UyciDwuo3tHN8M0QKtzfLSqAzjQAD+evrhykLLNYmSVLs4PfueJZRajGFBBDgk4TDJ4aD1iZfcUGF4Lx+4q24Igt30zAgAvRR/qYOBTk8D1yp1stTDg9uQI4Q0t9Om6wbUiHsfV7gLNEJ0ocE8xcAYKcJdv7nBCgL83miG10PZgJUBjwAu/wAwsBmKQxyGL70dgCTtXeTFnVQUknOv5hMNAiRDwOjBYZSgS91wdTgKkZ8PDFAMVFUc9ixHxDbND4Y6BUFDS8CHP51lvDUI1HUThx3g9GIcPQxTjyKK7JNDvCQCcCpOFLZy4gzSECDOAfMZDCBuKYMmAA9rSKvD5h3cd7KJ2hkUCCX4IrhBdlHCk1+GDhABwDsj6+ZaQRKaV1cJBSMioCIU/NTBGaYPoOKzC1WgLD/cck1QKWCHP6xjrIWqeAOf1mPwDhsJ6uOwYtVCwAx3GwIIb0r3hjSlUCQCcszsXiIdE8+Y2U7g5F6zjaN8Fbx8rjvlSa+3kXEsg1AIAOMqkh/2JyZLsiioi6PgchmnJq+A6zmbAIu/muzGUKOPHCMC2RdgOUMaIUBRmupj1HJHESoCU26+YYKAJHhw4gAmkE38ne+81vtVeat6uu2sBYW3CC7E8x9GPVEjaPcnWsoqytDi5d4KoAIsEGk+OQAAgCa+9XNuYpdbCnKqJPQr7jgw9JTnSvBHE6FwSNyJ/wAEcMkpCJIhUup5gRFBy1R/nB6w4iHaH2I4xUNytVAyPRkeSo2gQJeEZTdYAIidL2YoB7H6FQcgX/UxoHm1n+zDvEn/ANLB2Z4FW/2MigNSoz4BRcaoE4Bzh6im0eGHJTkSn5MNnE5DtyMAHtEP64dRXLyqxiNc38CDqySogFQPVg1oCucETEACqsJXtcZU5d/FzTlwBA6R6e3HB0QFv1nDnecgCJen7iCbhxdM9wEGcmx4TL52gPCizVtgUhjOAeTA0LtFAnpj5UNEsp7i0RaFi81vN4d4Go+I7GG3vZeL0BGPwQkAroQHn7hgAbSH6u19XLuxhkG+9uckNQBfH1xi8cmLbxcG0uLtRIj6nJdHggqefXBSFuwC9r2YKE4xDp/Y25eKKK68K9GFIVpnK+QeHuBBlEi5V7XA2BgrV/O2d46ENF93nKJRHv3/AAcTlKDkq7b9Kaf241aB/DTisOUAvAjT7go60PKRwf1nmGtSoHY8KHf64QAJ6a3dLr9c5yFCzwTlHeAgjUKRGmYotF3jvVHqycbYEi0gO44uWglO3FgIWEVXI8QmxBhlTIPR5+g5XAzqHOm+g9YdslAFAY5NqK81mP6tqsGrHuAByUdLl9fDnKEBbHhPTNZqkMenAKXaZpvvpmwEAKIP0cIOIIJX8XuPKmsah/QmNJcGyi8aGuOMHtSKbI7qm/zH0XFyvNkOMdVhFUaMkBVVZPPbyYvBAjC0t7pvFkINCBQ9g456i9P0UacCw+JR5Tgf0MZBkIivEhigJCWw2qKfzZkHQypP6uEyaoa8gvo3HUQKg29h5iS9UR1/tzMA3V5CJhoA+kGGATwQKY+BAiaQwZJapPX75iUwNrD/AEwaRiqShkfQAiEcugPAtHxHWAi5CtAn3EVt6726MsEIVqt0idT/ACYk1QaztOof8cLgoGkaYbEa0PGsSZQJQtVxhK7iho/74jyY0oqsqnsTz4OsByxyPI4WMSfDBBmxylbT/wDhwzGjFQU2qiH8ByywICp8DN/ddS9WQ5Z7OLWeXCQG6pL+HJwbktKAbw+Py4ZsdrAL9RuNywaNjIyE4d49gpHguJRqqp2EXAJ0ALFXJqQyoHBZxk5T8DpODzEO1NxK1T14mbVwd3ZHP5+GCehyLvogdLggQIGo84QRw7h05JunT1iTkZvroY1bX07ozJXbFuPdkT5CoyI2uTtA3jgwgCugs3hxA8By16r3j6ZAJK2gXww2JHVKy23lV55wZVAIhF7fv93k/FYnHYG6wHFazglpX85uXkkAF9Tnf4YBrBEYhzeGmSBZ2fw+OGmVgEa8GHkGwaBfSu6YiAzCFg9piiYlv/ACYqAXt1f4U8QxNUYNQXAeuTZp8zceqeGcDiKKSgovSE1jKRpzzcOGUIlreB8eL1gmDaGgnSG/0wjiYi68OKWRgBDxTFUIJKotDXIPC4Q4hoLpOEuMQakJEzb6wCjwXdpwnCfMGF3QUr0MVpLSgD6XJQSIkg9+mJFgRFGnamGIVgqIHsHf9y7QxB8UHZiYANSBI7USfjrHHlqIL4y2rswWgKRqm/LTJ0Faqanq11gqIqIgKDaT2bwVAoDYjw8L05HoRE/oPXCC8E9BUrMKaQEDhz45YHHiiK/uPCL4Jz84ZeyzYB5HL3BVgPp1TDSgQiK32CMitEI4h7XsGHwuKEvaAOMXG0IpPh8GEwKkQL/XmCCKIgtDeryfHGSgKqOlPx2YVgKECovWNc3ypMBUnYp/yXeHoicb04Qj+JjHjsMbnDLwJePzrAieGvk1jihYoB5e2OvRRsj+Ld4N1iBA7tHnHVxqAdf6lcfBM2gq+h2ZbSAlQLg0HCkBIcg7wKcQqJDqZWcaclS62Fw7qdKFizr9W4YiAiFo127dcuCBLGMJ6vmFIodkAeR7XBEHksEzoF4+uB6o1TYeX8MunmFTgPS4EE5m3GvtcqwcfdDtcT2jq4r19GbcVR1D/e8VpAgGyPC4+cqchpCnlIzL/wB+x5QwQoXgOyeExwMRgkBtOc2VBOiqv16Md2phs0u3lfuORKChX4XCY3Gi3L6J33TLwgMgIHfpioCQwPFq+4tALaFAD3zxPTCZsTK8GV4AxW4Fh00OcMIUUXhYp7h6CUQdQ1bx1HjCHR0VgX/P9OcbgKlCEVwdS3TQf1TP4YFf6pjPxKp3qF/8mHxRo3TTSZoaCdOWATsEWR+J1+4CwUi1+jyONuoRXaJpxQG8KLyYE4XVVMOzJCKq0mGoAml5x6oI0NLjjCcm38DhjcGxqphCIAiaHhrWMgglcL8b24SyqHQPDfAphywqb0ZsXjAtgBAvEhHt104HR6BUl8Zv8c58tDkHhxMC4bDQHCQk4hpo0uOeXC79ThMszvkog4vT8w+EhRW3phiWadWdjgnyCpDNEgDbPwVxQEtFkDC1SQUJ6nLo2VugXp3iVXGj8w0pg9CAUGUQjvBPsBMAmlY2IYOldP14mEgAo2p+B9wo5Arp/j0YSUCoS4MdnOPOWpV4a9O4588zOLMsRWNku7zcY10cjgMIlPr65dtap4NBveIkGmujQcvRqrh3pnioPA9z1wyrGnYPgpn15yXFwAI8L4Yx1BAh9djw9Ux02MsB85DEAoe/+uwfBhIvBGz85cnRoqhfyNa9cFkgIgh5fMSi3Woq9qXHyYFFFTw4c+MorAm1do6MmYAMAROBdBhlW296bd/6GUbC6N43wUB1r19cRGqgWL9TDNo6JvkL694IEBVTj05HVGw5MFygMXYhlwhEyU4w/wDpham4o81zjRBB8Ie17xN+notURPdmPxZIT64hpAtRpetuIArIBtPCnmWYGgQg/McIEEVf1Lzi8aKAoDoXjKYxLHfjXbm0ZT03E4aBQ7DzIWmJtJCAhoEfDDCFKHACaV+/XG1oA/yHCBZYuERDUQl8Fz2J/mNwaU+T6ZB8dAcel446dJH5Dxe/3nEfXQr/AADDx5B1R3sOspjXU4pWg9mRFbofTHbDwdJiuNADoYcdVQFVE1e5lfiQFRboGVwbJY+t7xeEg6qfocNgNDY10DhIycA46H9wcF0DyB5B8wNKhqRT7e/3HyAa0A5wWwBwNBwSeM0EN6Xx1R7yieaDV2MPpET+jgQsi1N4B7Jw1LvCqE0oA6DhXjiijFvYO3Hkt0IN8VOsjlyBhOoTI4vAWuGLbAq0vGA7CgUAwULAYqxfb0YJqDQ4QY9jcG2wLWPmEJCKBuk4wNPEFFw9bNVGI8V7MYGqed34Ob4SoVidKw3FCCcL/wAfmA9qDlu8Vjp8TDkQDacH64z3VUSrPD97dGDrC7dPvZ+cYgUINCQPwxcQLh5xMXFEgFwMoSJ6CauLOWx2/P8Aub1qlKgVpTr40woHWjDz8gfcaa2ZJa8eQ4ekCGsYMmZoQFxqqqEoQ6d/uaZdrSnp+91wYqYQMQ7cTKNpFsfA5MCxHQDNT8VIT8MGjI4VMN1jIID89cbHsIILt/M3kJpTbwA9PeJuICbjeQMNtUvInZd9HgZdiEFUOq9Xo7wFinS9waP14x2TUjYc8P6y4LgA9VLzhOIUL4YFU05Nnp1cKhUkXimnJ0UW8MoG14DcLKsG4vQ7wrjKBAE6O1MHda4x4QLsME/Vj4NVw9AhgyxYP3EMhtn2/wCAZPwysG0gzshLl0EUoxvPb3+5EkcG6gREgB0JjhWG15d7f3A+AUAb4Q+HWEUizPr1WbuwErgeBcOypCFQfn06mWqQKJ0peZinLE7+mFd9J9EplIjpUOcfHPozEkIm05j5gDF4NuERmAhhIL0vWNMKgCRirq94T1RAKB/nYYqcG6c/hl5Ypp/447Vy85Fu0WXl7E6wAE9gI6df+mxx6gVfVoOH1RL8RxCjAHsyVfEHGJ0+Pj1k1tw0PlOT6ZXHQgKR5p/unGDQDQixKDgSkT6f44bsU0FTE9YptX9fz64MkgrNpXOIkBLcUenrjo5gCKN5tDE9hiQh2pwcGEvIEBhOMeBq6EhcReCoMAfDwJijIMq9DwTvEWB0wUk/XWIlK6C1fwYfNF4JUfg6MU0hTyfXo/u8VU0BB5DgXLAAAx0WaMdHcFDpm5jM6cLtxfuidR+v/DGublIL0TzCy0IKLo118xJgTaDSYyiBbSvK8YaqVJSyaOBeh6xZtYCIg+ojkKHrkveMNJIgJewbv8cD8UosTxArghg5SanlesfRr2imBVyIaTnb8yUlQoA8+friT/1b+DGgISGUevmNqqp0IOmY7whFTb4x0mlRY/j7+CmFpTEIzrSgNa6OtcGBORLsouH6eZ5jkaWdH8PF4+GIBhPFDTTP/O8Jgbnt1Tz53hyu+kKzzoPMFjBFhyjFxnZrBHO5wyZACE6A4X3GntSCpQAPOXBMzYppSxddfMeUEaVWCB2YnAECs+Xxca4WR2WEHHWCUBQDx8a3CdJmbCrW6DEj/wATNLQQMVuIcV5rmnD6GX7uJPSYGvi0NJ/0MCc2UXlOn/GENUQAHjY1wparaqiPsxro6q9+YwaQ72Byx6hUCF24xE6cB90LDy+YJGd6Hkx0AQIHnHWNWtVHweYQbDgC5EXqx7c5JkNFM4KhpwXoC0LEfaUcraRdMkk1yXlZX6utdKqqv7gISqMO7HRhgVqHheT0yZUJRQTDkxTn2fPT6YR2B47xWURwvJjOW7HNP7gpCRVShvzt+GLrZA47JFxdhBRBV7HfGMdVyIZeaZ/RxkPEISfAd4beapFP/D+by9QVOi+4pbNQKI8t8/AxYsE2JH7sxOKpeFJmcu6LFqdrQB9cHIvQrXoFNvwLiVQXldv/AHr9d4OMHK8uKFS8mzj75ipNhDoPVeDHKgB2qnuByZQANU0JfLhQ9nqGHuxaRNV0O9/mJXVSrAB4/jjaIKiVpOvHHUACwQmhMC6wqHlf8MmyQRXGDQFCQ0vrxg8QwWgPq7x4lCRp8b9MICdoBrrjnEEMCApR99cLMxwgDCUtCE7xe1y7a6XkMNDByKDPpd5JkUU/1RQx8gYDo/p585cenhxA8uPL685eEPTb4CYBsdj2h8rzm6pBTYh0p253wYVgLArp7I9rvIsAHDAA2gUPQYyVCckS+vBhDgUpOCuDo+8uAD5y5s3hIGNCqgPD4FXBjKoQNKbHl+8GMqKUYv49YWqHRbXtHXtcbhUwRiVXAOqOrDgNr8xTkWNKPS42lwhUuuE7cDhIq1n+YlIDgG6+zojk2NoHkeExU1dz0lH+m8V6xG8bWwZSiHxOxwGEgHAB6+4CGjA6nhPcDiVABN8oa0YbWn0qx6hbxrBE/wDydLaO3sPp7+Yo6jhjUpbT3E7c0I9XDEVJ/TL4BkKUXpH30w1o6AZ/XHEBFaq8bF1jWydu1n1drk+odJL+CrP8CGD8tcfFwSiOkRAJqGjF8ykQVuasitBe2HSc6ZjtGYpKe/MOygaqtwYApqlk7ZePuORSHAc/q3f7ieLVh0H396xqIOzifCY6QsaAg/HvLATIuib0XeKF4Gi7i+x1Rg9RfPmHw5BbR/e3BpPTuZg090Qf4DgBD6qETxFMcxTAIfIOnBwEF2GLbKurzvw+4p13IXr1+5vDQO1Phk3bACsvq8GAiKdBoS5y4BVOB3jKWyhP19ZojZxAPiuId4FVAYQuPKTv/wDG3A8A/Mh/k/2OILd8H/AME1CuUtMBWx6W/wA4wjaB0KY2JM9zB3duBOsWrM5gXGKaEhfzoYuYcup4MD4N7t38uC6k0Ba/eJ/XDVPAsT86j4YeoBANGiE+YCryATzFEcCEKkCAeuEgoFQinp9OXYNmeGS50gPbkOBKktXvL9xbTw/nWKUKiK5V3x0Y8SsR28C/M5W7NH5+LiujJH3tbbv/AOOHykIUHEHadrjojWmEbzDnNRX01rQp72rgqmEOKQWObsgapaeN40xoNBiNv7WY6UKnmuLdTsCxO39xZCTaHg/cJ5PQ4AKr6JTJnuh/SiHmEIaBjw8JhRYpXx9P/EwmyOrer2T0x00qituTJICEBkuILEcXBbz/ANwbgv0HIc4FU1yU4X6YNy5NPSfHADZJyhpwHZs5TmYnMfU8MpLZwlBhAI5QUHxDLxQ5Ao/3jyc3ULEto7kX+nFdIURa5bsbxiLbsQfheMRc2eEdcPmGF6U0ryPRgrQdJaHOJNKHqvXV+YKgAHRUPxMUIyUFT9/+uMgT2y9kHj96wTfHSxOcVgCFCFnaYoJIC2z0BxNgFMhP9OKVAqKJpyB39maxB0LX2Xo61m2wQANfXBFLkKAG9uX2JeK4WCUNKg+aO8R1pwBD8M5HCVujGVAUAWcbcdWoL0/Q7y4hAeEuNlIgrRqrx1xoOcNqyVF3PzeGKg9CwmniOT+cv648BpyMT+TeIGwrGpr3BEIdJ48xzsX8TEdUekbi8F/DERYHNZmGkLPBCvwlysGnL/4dHDgFSKCv1yMQ0AS4BwPX5gIKmCLz/lyOgiQOSYkREkWtnmDp4Db1kAfdX7looofFhgAUCqkv294i7KaTW389yFAdg8p4HbiqqjSgev3H+6uXneFS8MaAijPMZqqZGugXoXam5g4AA5APFOg8yBQZoSidOn13koSJuV8xeAsAyX29YwLIsqq4BduPYxIsq8qYZ0A1grp20dg4WmzFE55X+4YPUCiAv3B6z5l+U+czHELG2g8FDT8yHVEz3HgcEyNg4HkTxwNrROn7fzGQIJf8C/6TNLzsNrxuzN/pzTjdX3y4pQKrdU7PmTIIcPGm8YTjhwUw5pkXJFxCRPg+/PMeUfo8n78+4luLcNXufMRCA7hxg+Iv+HJ4PSmlzXn8EB7hSAnQ2DLluogKzmElEMJOEAMnumz6YpAJRCvunHkMuxQO0TkzipIQTlO3BEqYRWLFTBGZzU6DrS8YKNIlYMOaczuOKyyANN9zVror1ZWZxFFDdtQj4XWB4dSgVMBSgTyjP3JsFP6TPd1b03GVCGg5Xwx8BGlzzA7cHCa6KYaAhyMn8sx8Ws1eF6mGyrC/Ogw3LEASvh7cLLKADkfT0nWV0Edmqnp1iVm7road/OtB0YNDBY8FsWsKooNGH/3AgEOABxQgpTS0/WZNOYgI9wTOWmRFgz/Dl+UfAU5HH3gOvwecWpyaRB/oxaI8gpb/AJcPFE7QE9FxDYPL6GOlgNCGav8ARRwaRP4A/wC5iUSg8MmRIKLVptxCQTwYf1ckagNHzLLNEefH8MthTaeD6uPhoVWlxbqNlIGGxfTIv4dGCJdTgM5EgceZqbUbEf8AM4LnUAUfj3i+MEgzbcahcpOnmAgQhB0R7ccW5zF3iDbjsVRUKTlO1we7XiWHk4PcUDJEbHSqk5wGm80Lei9jztyHcXac41lOpd08/neuHDIgaKxHc9zRlrR0Ho/Ex8oz3YNE9Uf0xqQMmz2HzvBDQoO/WemEoqvlTh8MrH2EOHhDzE6gulYHpv8A5gEkyrpfF0/cXWx0OCSscGCroxTWEZ8c8JgmGtnw9mBpgperiLpYSznAhw/CNMdjsNjyfnuXSd4NwODTwDT4e4rfjdSD9P8ApgSSABtEm12ZBhq1ktwvXYwLnSWawWQWAon/AJvHaCPaC/XEwkkIfoHJnM2mwje3P7kTpDUQWJMuWCACpmvpLyFOL2cJxcMNyVWBey4qIQJRrs8jhstDx4oRM2K6NzDiABDkUIuGsetV1649RAmmX4uQmHzN/UbVfM21jAyh4OKWFKIIp6/MMUK6GfEemGFohFKOlOky+uEhBFX9KTXWB0qwbqw8PbkVuwf6rwYy2gWIL/wxBZoUNHJXBCRHo5MfroVge5tAQvMcR2nVtsfRoVip/rNgF5GG+94KSNlKJj0KXRqZCPxChi/QHs5cZQgHDBMEFYWCWOWYifEwKbE7RmPqrqy/wyqImL5fT/o8ZrJu06O1e8PJHVRE7fhjhADbsDgbURwdH4dZWAh1jt4msID3Pj1xiEYgc+4fXtjiwEgbX0M2xoQdp64/r5h0DAkN9nr6Y9cGVVU6A89eXBEDFdniu0wl2HbP1tzoXQgl6Bc7/s41AkCIOw9i7uTSHKptADTqu+8RYpfLvEZhZXwfMvVOrk/fcD4wisAnE7b2Y0CZZt0ePwxVGSOUC8nj09OPgTANjwiZyNwC4no+/TeJUoJJUP8AKPpkgFah2O19nzAMXQ7oo/7/ABTGYUqm7PQ5PmTgR5L/AC4uwhiPI+JjAnDimMRHh1iCJDgrxHjrACCEwIAZHodsoKwXp4cMhEjCs/V1kJDhQLPPHGIALDQJY/uDRAdCNPC9f3F6UgkFegC1yVwcSxjK12dQvoNL+Ya7bsEX96/pgEWoKfbgKBZFNHYDiwEkEVOETkfMXIAXc0O4Dn9zSwWBCj8uaglwpf8A64pEukNDHd/wqiPD8iRHjNQJNo77/ccY7UF0ahjg3oOXN8cgdLpNPTjkSPIcutrPezk+aS6wXlQTIEEUGj6GsvCPCjB/cfEQ2gi/TlhEOIJg/mddDSJo7KLhVCJIx+LWXFsXkHA5K+YY5RSlhzrFWafHvEMeGrY4BCBo8v0/MNBUVzrer5k1XAkGYA0n1mGgSif5MZAF5O3AFAKJV/X34YlFACNF4EwaAaSUv04ZJN75gYQi+NwfSngFB/XFFDTmBH14MdqbpUg/e/4MfXNHf+P9W4HoHwXb9cJwgGgNYV1jVwFVYBl8QtPc9z0fXL0CqDYuk9+nBhAihaj2HWNU1WptvPAw+RMCsPv68YCwmrSvgxT2seO/Uq/mjF6hbBRv7U+rhzEmJPIn+wuLEEBCHZh5wuVTqIC3h6YLqCPgvv50YIgS6x3cgUpOMPOiTrHf/wBGKRwKDQ3Kl3Rx1ivoMAND+9rke8PG6/MOqGLHAHT9Ho+8mCFDkiw9+n0x7SVh0n08zWiW8bvTx+mOR0VCMejwPpvE3CDCp78MW+30Nt8Oh8cMJMtQPQ1hWPABNKCMGB6mbiGfDCNKM3BL5pwpi71c06j2JYNKcZETiiIOgKlwYq8KFPzFTGmmd+YA+JB44cTQUrI88HOaWwg77+mKqGjpGr+dYqlhsTTO83hI2H/t0OEDb7MD75j7UQ6H5A/3gyXKCIH29YlFTSo8uPjA+kAru+K4/ccAqv4f+GbnilI7MaDONBIAI4wKV3Hn+JjpUIUKC+uBwhq52eBxpm2VMYqSHtbhPpqYE1aHI9F0GKNbluJVluRj9xvF9wJPqhgoVpKjCwVMo1XgGxwOmfBBvVxfdslJdARMb/dCm8JgZEIhYM4MVi0xPFvk6ziiF5eZ/MHa8CGt+vR8wdQScHBm4uHg4TD3gmkcZGIVQNfcpx4Z6/DHHoAA1+f3rK5V+wPgYSKAHlUBkmp8BxqxHTolgJX5oPWD5V46mBiILdlO1cElvWBE7JVw17pWujBNA7XQ/R3+ZqRaOWl/MUuyaEaj+Jz9xahCi71Ih75gN8amxvIDawwTdHQfRfO3K7qAF7ZJo6rxjLTLcU1XlZVqN2D2qGjwcWGA0GNEioNM9bMNUhaAtHnGz85w8Wg0g89+BmkkG+x8nb9zYiryuDci35Zh/HGnERstj5gDCw61xWwOsL9o79nXJglwcpyJ6Pby2Odiv6j1/NmTwAaOF6Bi6AhP+mTaNQOd3SHZjKnYeA/VzgGkAo0CTkevwmCUAlErXg6xTdcQD38ysi7Sp9So4AELtJF8dXeMYwewmcNP1qYLUTsi2fomDLG2iBzicoqqiFnZxp+5ImpP1XIdeYAEAA0QxiwudCPA6MKAC4KI4gJVweA5nweLxcduK0t1LtXI2w4Xq9v5keJkCFA24zXQIjS83gjRNoZTBa5mxDIiodJMeRNKVAbwmoDKQfY4b2yK+b5X3DNK8q4KgAMAbhYLtvi/o+/HnGpg8HJel7PxyyAvQbV+9Hrzj9DJcF6h4NDjn+8Ej0b7wrxOk1bNnWDlKsgi8XDQHrdUf4Bhwm+LU/Fx31IiJ4jpxqChIHeuRh1hTvB7PfmT1FQg7Rkr97whJi3SHs7y+WHldaxz8xQpS8fcAADT/bBckHSB2/XGVCrXsI8OO7BVKjvDFKuU87cInA/0wr4af1eB4BqC4PUoKlofM1wBc+GNeJXj/RiSorYfPQw/Dwx5skRR2nZjogTxTGZptt1fZhoYdoz+uGUC0iuB78MFykJI9p6MXb3ZxQ8HYYSgE5FouwuhN73lAjPZHg+4dUAoVV6X68M2kTtkA59K/gYaQRCLB215yEkVK1UdX1zhAotFeXOIAFEBNYpkXFIvYJ0+c5q4ug6B0/3E1AnXGf7mP/uf/wBztZvG2jKSR+A5z8cEQqo402qFzshDt9zjuV/oyr30T9uI9q6n640rjWOP1hkxq0uOlNuccoKY0K89eEKiivZgVT2hphtpe2AHODf9ze3vFZbvNn5V+6wUMbPC+cJWlLvtJHHUiYs2kh4kdTAVOLJrr5m+TNK94YBfRij+VgTjqsQM08GJ2cXMC1nXY26PlKYBBtpr8w8RwmawX0BXfBsdkKkRozhy/wCXOn57e/uKtaO8ajodXOP7n6usMbRJ4HHAjnvHfvN1uFTWFpOn/uITTvJlKVkunhxgKwSY5RUAMOzjj/8A23w1Ag0xI2QrjcmPKmbi7dYd/uInGf8AnnmRYuGUD15Xeix+4IWuoCdMYNDR299wwCDT3nJCA3qGGBmz+EHC3UA8Os5/gmBIQZcdArngvBgGUnX44iO1bkwuqukVrlu5QghWuf/EACcRAQACAgICAQUBAQEBAQAAAAEAESExQVFhcYEQkaGxwdHh8CDx/9oACAECAQE/ELlMBV1ipUFY99VzEspJa83R5jaFEfN7L3Ly9AR03GBJZ/BZXW5vyzFQlN9I6WAUeRj4jlI96q+ImW0mrMC+NrFeqPKk/coJvpAXI0mD4fiYyvBb3fMzrn1B6tlkk5t+6qLnHAyv1sYCFNpmqlKhbNlunRXMqlO5yrxATCnWOok2tyRBNxvm6fEvQJ2RzK7mowWlBEGyb1MqcMwXSEqFJcGoMWQnyxreoUN1LWXhjANF0ytCzchS+g0hADJuijopqIB44Jo1xKyURBRwKtm6G4dG8RyBsdqazL2nKvARTNiVVZX2spYPkg3EKB3ao2f9hQo5y1LdLouzRfMHKjdsAxg0C/ustCM+aK6qDNN0BxLjc4GhZjbEN+xh5yhjt7mdBlGxgAo0fRzZDBUcxKlwy5gKoYm4HyZ+yMtQi6+gVBsZ+i+Fov2/y4AmS2sCxuVKVd/lAIPSM59RS8qNbodAEHbht+RlCto2DDdcTAVSQDh3h+TDAAHKz2yqZUiPa/8A5CHW4R0LEUkkDmhvBiA5dgij4uAQbZWzWOGOh1WK6XBBVasn38xs4FlilJ+/oilYqURAFWBtIsWCwrljhbxQdEr26l4Tl/8ArT9Fl7u5d/EpJD2lpCKbTbt/kLnG5Z1FVNKHTdYArBW/zctx0voWvmVgUckzR1KWAO7cvgEVi64VpLcBsbq46utwF3+QiAjdWkCvgKPWYBIwquKYv6OTV4LEKrI5b5Me1rAzEtACK6KdDAISMtuLjGTBbgYL4bV/rGQEeqyJA30PmL0epNfKgR39DP0rdK9G5i/kYrqpdMp1cYQWIoRVAoIZeZcFixL+gZNZVPgAIDq+3nF15olDAFwGSsI16gNGsjx4S/gBvrkRKpSt+4lOcl59FVPWTZqoHOzxbvxDgjig5r/WGeB+CZgo3zTAKzpqVYwnQWPrMopsS/FvMBpcfiAjRcMDKKNQblNXuVLXOWChD04fsxpKb6jkjv6LpaIjgjK0Kru/JAgVPPMIol0XpMDGBgJVdCUI019bZbue8C+dSgVFoi66/EVGi5PAo/yYwiILrBRb0pEoLd30xIG8s2vhlQYBZfVQtKqU+bgpFTXeozsLJcrVsCqHPmB0EyH4Fd1uMWTKrGiAeZUlKAz1EJdHNixHiJTgAfQoUAVrxGhrf5kcolx18RO1QNaf5UIZMuD/AFlDbTyK/wAm6DecQ08x0SAoDolw6A6H+S7sqk2QZiQiU781GmxMRaIv0r6V5+gkg1XlH+y0J5htOygVUvejmPa1gA8paWt80+xVR5TbgfCQa71hzqowS2HyCV98yqAKFW+f9IChwWXafPUQG9ABM2s58RdAVqFScWyzfuswhbenUwimrrUJNCPeNwgDWTNTHVTQbpX+wArtd7igC4Qqha52dRKssycA4jDD8nUqD9kaL1EQs/lKAU2RfjwfoA5yaDKCjeh3G0MH48xKXzGVCGiLKuVLpZufV5r4JQxKrcXRf3mZNtUFwBaTzqLajPhlbGhCjsaBXxvUY3KNj5lsCje1sTgZt0vNhCFgCwPcQEtYO7XmOvAbSjNasM26yFtlGtVawx4uKTRO0f0yp4tcMF8EPF10rthRFGh5JlScbWyIlQWtMso7NwVbDPRTf4FKc2qoKq9hUdWPWKbLAvOyN00DQLB7F8kK5QbZReUR0WOoO/cL2aQ4rC5iJYIOepQ1EwzAzFkmlXby/wDwHUKVD2mUiwpXH/YNORwqETUBIdLVEaoPYwQliXl8EwzcGTgHjzKlIC0W+NwizgXeIhS2yi+KJgJwaPR2zGV0q3wnknPF1gPxDpUUtqIBZw/IxUTZGnvxcVehdFIQsqhBbDUdKM/gm01LKPNH3gel4F/EbYArlT6xHdlHziTAeJRhjSOwp+c6i8C73gH4mMkvITDFVYVM+xCwsrpWZN21U3fmC0KWU9y8QDq09SksqPF1LsHUaZUa6lhYcn6+nx9b48kD1CgKSLaVpfnuJStp8Kq/5LV1SOQuMqgQt1cfgqkvcZtClTh6xT1TtfiUQoAIs5XcFXdaUYXWHq3SDy3S1uW7fhr7QuBVWP5E2Qtg2UY4XgbrmNADpku3V9MaAngAB8AhKdiu4NfdBMVrYUy4hk8A7/AwlO6zAzjsQt8RsBLlhpp/NeWX33B7ffqUagc479E/JDZqKGccNE1hPChjD7SAQqUbawnj3AZV4r5cQqjePoIjtDLoPicxa+phmAIhw1/WMqLFSq0YiUdgWZpUwwcuFLOLYDyTXZPUv7kIqKaLeCokBW3xYdTtro8Gz8VCXyITtKA8ytCcS+BmFUdrPW7PqMdo27HcIdUfIVubkuFjDIwKZaS6KfOEES4TqCL4BfLFLgQr7zf6xMoAr+RogkqnC3h/W5YBhf0/EpNhVgXqrsL3BTo3ovqE3echXzgKgQM0y7hV964WBaM2cf0wTWd18zkN2txHCO3yaItpogwU2lL8xYR5hT0u73PBC5C0vnuIQC3svhFqi4V14ZdcBg01iDE9IZcIN/cuU9m0uISkBaV1bcqU2ctaEyCt34asrwxAU+OBoZgmrfydj6jpEFUvccGZH1Gm5eS8VAfm9/OZag5Y14+8KbmYHrRCXoZXFZvMqsEoDz/rDAqomHLtPRO3Aodh/O4rYYCdSi2vwOf7CetVPLKfWSYUYKO63k8kqtxLXjDwdy9TS1rY4ckx2Q0A/OYs7h5TtYqTuzttjTMytwXPSovlOYxa+jYG38CWeVcXPPCdCUOXr47lNAbJ3ro81C4AyIN2DR7qZTsNzqS7b8kFha4bNXaI0+ki3p4i0hFgOrg5guOvCAY1MH+u/cTlC3j+Ru8xlF548wjHkCNQpb7JEAacPErIwqlr80EXNiPcBGANaBDJsHGos029qZWN1+XmNF9F/YAMvfNK/AYTVd4ykLGOh2wR1LdPWdsOBEBtuUQs+YRyL0yqMyCBwXAL+YVmAZwRiti0S0xLPwRjSveTqBAUpvLuVQIo8mCOJjeAPk1/kbEBZNrP1jtgGGTgyVGQTCX34hRrQ/ZIaLh+4OH7RzJFNG66Jd16HpiWQh/GoTaVPh7gBSnjpgvmBs9QsFw9/wB6howOoLhNipY9Z/2TCCuTmKCWHWX3gQpVwbQk5EwLNNIX+RUM+e0wPy5YaBflGo7RyEUYl4NuF0TOGqB6mMuIVxZdHxUI1hkWsM1HbEFnMMq3zCgGpaZI+NTjtDQOEl2NTTn6LYGT1cNa1zR5nIN9wZuTK74wxjiIg7yhBWADTSC/LmXFNCOWvhuBoYLm+PCKfQcd5lOhYg2rJcE1HhtNHEcU02emZHSiMGgyF+5TRL2pccjkyUArLbu41Xkss9eIk0zpWfzDqj78TJB1R53CiCYRyw63QXocs92kLY8Wtgcq/RBxl1i1ig2U5RYlSHH/AAh5UmifyWgKaGzze4UmXbXrAhFdVcLRlS1TZ81NUI2lBqFxD7RT4xUMCWg6IGgxHMK6IzLBA9Dn5lWAEDlquiDgql2ucGmgOjJGmbR/g47ZhYnEPxG0abuSsECdJx2KnnzHA9dePCxlohBNJA5aXDiny/7FbW9ez5mctmz3KCmy1fCwncDFSXvqUhZ7wpJKiGyA3S8KiWNSryN+bmawb4CYqBEW2GiDVT83iFKa2/LdFsO2tq1R4PB4hmQ2ODxCYXQGWVYpse6C3sCPORVwLiA2xzB3Q620Yv1Dtfxble0HsqoABxBKCaYstDyrFKEXRkvlnGl2wmPB8V/RjXcdKSiKAZoyfLz6lMFku4gbVy2vT6ZS4bLxzUvWoDTLTLlws1GjZbEEdURkkUOPCm/7cCCgspuiOto6SrOUynFw8+ogWDZX59S0Qp1vEGHRx3LWtcMD4KiDWDrhi5YR+bpilXelVcWjPacShZsqvJ48kwWDswfmLwK8P9iQlqz0sigiTiyyOr7mRxYo0e5miVInFC0T3DjshiKGhecTodFHvmIzBTQ4pFOpsEamLEDoNssjdso7ljiVkrYBynj/AIMpAj5T+hHlPItB/UtDbFdjQHRK2lIpwXxzF1ZWYdKPVVGz4LlQhWAaqiazAWRUmoioeCYjPTZGvhm0wA44fPmZtsrx/GVSAUB9QRYj5tfdBuCrg5+XPzNLNIYW+IuyTyWRDhS/UBiy+aTLAx7R2hJTnfciL53CmTVH5/MXtOiswAoOIVuXQfq4KJTM6W9EcCAqy19LY0YsgKqAOLThC+KxoLoaV/zzBCkbVZpmaqrdXuGDYn2IKOTfxCN1HuhdtlzTeD9f2EyXTwKlqDNogbEXKYxALxeCq1LeWjz9MbWmI4tn/IoYDhepkfVDmnZMpkiG701DMRW9I/2E6cYBgvuHocudyUOi5cyw6xxbCXAR4UxL4GwBsT5jKkeg8kCGUrKH7kUM1NGY1urdGLhHTa8qAgtLWgqHzW43bzzTJr8GjFBse1QfBAF0UzdfglhdrBiDVmryuWzZ316lSMbKaPEETHYvQWsVzVAorL+wzFJViolHQI4YHEQ6QwLBAKADFKzABsMnd7qKhtAeaVwX1YGCKfeEO62h6mEx1FdcpfCscQzJd/JcahuXTeOLMynAaa2IQWDbq2xWVVryAuVESLyJCyops7PiXSxe4OWnvCTFrJWWU0sDW9uItmy/D+5UYbm6SiE3jier7ZH4htFg2MPAhlnurgjgNL9iMC62rEerl7slvIP7K8uzVL/cKhCsuEfAQS93wv8A4RGrWOFK2rQwTCsMh6XbbHqtAARhqJW6sMsTRkyWpKsHTN7wW9mmAhQeQtPXiBq4vzHF1yQ2S4FX+SApTQ3qj/kRhb7LMSZ0RsAQEqMC/QwSBgfvEzNHaFihr8kEQu0PmDVnBTomZw2s7JlWytWcPEtWt0Qs+SKlhdNERCIcuYgQHkcRGOHtKfclpkvlV+5Zq7dgVCqn0nsHqVA3X4YJrZu2M5hk+GWRxol5IBlmZY2FqQYRwWKfRCxHyQQ9UygeUXUqKYZcBH2JNi/yFs9mxk9mL9XZeUsiyboGvKG2xsOYwXSkY6lP5C/JE5bFvickzfIOicaTkytS51nSAUsyarQreCKW6b6uMgm9jZXaxJuH4+0IbXU3mU8w4cwrGyNpcoq2GUNNjceBr6KoDUzB9BhjA4ddJ0J6rEcuqgqKC3htSoc4ylvJiKsHaxopdMF8qrzNFTV8X2Req9VtR3BqLbDctoIvGkEFmml4uJ0+SHDslRWQUPtwQPQVd1FcrDdZX4WBBZ/81cXytrVMjoyN/bKdVpQDHu9wtA2qB1omvHVyvUCnLUqthdxTnMAe4Ijlb5FfqoDyEg+zEdq20+IhTULWyiIxJYTlKGK2wvVO0/5BIrnD5YQc88S8qij25nn/ABLS0XCBQVXEHNSgvXPqDqV8+aUgNjEEmGC0Wiho7qVhjgV9hvmItl10t0yyqaaHnxB0sHSG8elLcPohy23Ej2feZtiF3XUo7dJccZNdcPTFnc1utEaOSXs5YKQxxWOIDVj8xrM2A3LG5y6YDpsXb8RVanguviUJIcFOURUqPLL4tDGyo6Gne6/BBFVVnK/MshsmNb4gTVa157PiZlwbitOkqn+TeHeK0mjQu78zAg3Za1Nle/7LBlQyOh8H0h1jj7iXoZv8z1AWVqXqyHPo2TcoG4UhlS1K0oNiOYjMl6yx9KsFVpF0KQFjY+5vW+IFwaJnJXPdKgWg151LjUeSa976Wbgw8H66mcIV8moEYbSr/wACUlERUFHmWqV7u+xD1YOm3+RCmgbpll55qkSB17qpuoPeoYW46BcW6TpgrOl/AdE3kam4SsE2S9HD7eCDNNL7ykU7oi8mev8AYwPQDitEK1KFsyD1BedlHf3/AORNxzke5mTDtClyZXfZ7IsMVB1eIAxzSOefqtgyAleh6ATHb+4PAfxLCLfnEQw/DkmbKXaVFGG8AldZer8SqmRb8EQ0TX/EXtR5aIbqkFeOY6NA44qOLbFXRhBWEGisCXb4H/CBaD5hmEnlqOTteMsDu9fZDir9QmqQe5VN3T8MmW7EbLSqaro3BDuGVp0lLXeyjn5fyVVceqfLMhBxuu+CL+HxPd9otFEFOvPqUwZZ248RQKL6RNMTxBda/wCDHLH3OwpzyPUCJT46qWQ8MsKI51yoKxlyJZA0QcrhiFFUyvqv/cx9iMRzoEPjmdYusPUTM0eeWWVxr95k1CFeoQYywGVllQXikiiCQ3bUtKFFS9qubbhGxRWtmtGOIMJFZ3ZmvuqR38gxKQYGMtkhsAV4jQQe0/s4l8ZlOEeI2/Y7me4kE3rk/wDIS6squa/kF0sdvl6gowOKXoPEGKadLVuo7m0P3ep5fyf7D70IAAlrwdnh4ltS8jrw9kMRLiuGa2wOzJ6YUtkHjPpGNrANcH9CcYPVv3G68/n/ACAmqPKf6iSAyUenFwWbTH8QWs5Qmrfw9y1yP0ftGuRvb/kzKKnWoz2Dcv0As6H+ysTxBO0cjApv7TOumQGfVyhyvtLMLO2iHnFQXqDtanzPCtFS8r1ipkiQafCXOXWoTVrn2wQeZgnA9oUzavb9GoOm1eWVri+6ZdAdg0+nohQ1ppaHiOgZW4Xol6OPMuqoZqeX95/BPx0/GxJW8/oT/wBTqZo7bGfmxoKfrpp7ftPxCEbzS/ITnEH2/Uz9cJQGikA3n/hlgpoC+CAGhHb4n/o8v1tJuT9bP/M7mh9YC7BxPycaUYil1WxrHBP2/wBYkX/3c2+Wz5bYkKtWP6lAy6n/xAAnEQEAAgICAgIDAQEBAQEBAAABABEhMUFRYXGBkaGxwRDh0fHwIP/aAAgBAwEBPxDUckUtvpsl8ubBtyGOeIKrrs/oQDC5UJVcURMHFHiEe1qU66pQiZIFSyD5VkatiCbdLRJ5WBBScbXkQoNb0sjZbFWiiLbA4ILZqW2Q95AWIoDLxPC8hiLEEIP2ZYL5fMDL5GJUPYvt5PhzBtby00ygAtqoGcBA/BRK+JZE1Kl1ckMEVsXFsvLdvkguwXRKTaRY6OCJcCXyN3cu1gdL4hDTWHjUVcRtcaHlbqYKJSNJKCkE6YD0o+YCpV1AqMygNGWVJTCyxtt2QFYP+Y/wKuVAMaguLMQimdtxsq69xkue5mMPUpBWxLQ2L7cxBBKGzY9hmHQNmt0auy6IsdLgC00Vh0WyvagBHQvK7EzNCFCNFsx0tGeFgOWcbVNFwNQ3IdFdGl+bYmJy0SA6TMDA1yuT7XDpCrgNMFvZnPgMLenDl/DmOhYpfizC1xBt06wOgwRwZFBJmxBb+I9EJzl141hCxbXYDPqojpeqHwB8RKapqv4v9MdEquSowp8y1yq2XcNjKlCaRiSqlIhGX9sSAP7GhB2f7UYg+ZeVXXr/AIgZsyYegx5wTurAXUwXB1fTbVo5Fj1BvCtlhbGeZjI5eVBKVoB6l9lVGd67YmxaBqSg20eLIDe8sgA+ByY5nCy55CvtQ1yzqCoqgCX5zLAXmkDQPcsVCqq+RLZhaydTZ1TnMaZK0ErYBGjMYNoLfJFAuiiV5rijAVcejuF4JEWqXxzH3FgBDtWNyW6hg8yzjRn146IQeBso99cstXhR2LuW0j9HqYXczP1Qiv8AKr/DU/xLiYhDQ0Sg1pg3/lnRGlYWUvnEBJUMuLGbR/oLKm2YAuhKBb4iA3Gl5DlFBpaRjsaO7OerZU4gWws8MhcYirSFhVAX46IFDDFVKL3efmEy1BrXsLPcVqUlPTTDIUH3q7EM7yCURw/OLJehqvGXK7qnMV4SABD2qW3wZFOLpYgdSAA6Aq87OahJUpGYDm3gq2NUGvwzzLit9N7Lu+OnLAuZ7iK8XKhEdQINxvJY8WAD/Faq8Kf4P+lkKZL+yCsDmqH1/wCQirLtmZo7hr5mLQqRNhfAdrwEpmpzfC6rfyzMQBf+Eo7/AMljK1vD504lKiSxdJQ9C2NhPGELIR4qEaAay0UVaOBHfMGkIXQZ8G9wgQRkFTBn4uAeT2lAO2jRCFrnY39kAukC3/uAg0b4FOPRLoEDBymCGhjPlzzzMWmtbRHQLcS1alLkG8X01dzPFfUCuoLDOI6uylXig2fJN6oUN3zDG/dmYylwayq9KtywNf8AhXdv4j8x83Sru7EDifqP7XxAGg3U2lSiCFt2KHzDMzhsb9BValmYCZFmFXAYEM/5hrApVdAZma42pV3ziwILACgrR7WLtzY+Cr+Sq/3DieJljygAHe8ZijGSFF2t/QaXNQpWMTV0W48/MOOuS98B2F6gBLjhKesW6idgX8ryAdVZFABlDRezxkzF5hAcWQX7IhRbFUtXAXz8xduAeD5aQEHKYJAmRFu8No5JbXRdUEBkAATkOfmFVKb6MdUaIS34TP8AqDJ0NXYkJgLRChFwniWhujQ4gJIZd1B/GOKCyRXwrR0QwguWH2aYhQK0zq90yid02DQ/gRU6WgIHjaKU6hMAWO65l0Q1uC5ajIG1OIzu0r8xsVBSZrF1yDyMG4btYg004YkpcSUSwBQoPLuiIl7CjkOgeXcsldrb7Zb/AIMZaUy3FXx5CU/EAKgKa4wDPWWGlEa7Hwxm6fAxNGkDthyo2xhlJHtB9kQNBVyhYTXwx1tgh92jDUyYpw3NMXotR8G+IrAVnmyLFWqo4XJ8GbYEZbaWBwDi+d9SvfqgbmrkajEyWaeBiC7wImHu0mWFn2WxI3IOay08Edql83DDXrUWIwrC7jXmtr9KOZiidiD6Iw6lwBdfbDV4EseQA6jnblmQcD+kLaZd4Vzl9D5OU8P4hW2sPVc34rcVUA8A/mFCo5xUPWa8wOMnPiG6qIsAKjhbRE/x1YotdTuCsFrHv/8AJYLVUFQi1/gLolEVlPcapUEq2Zl7RqjxK0Rg+sZh303hR2emi4vgaBWGuuhCVuGGso2vnV3BcDlFddT7wcQVHzzgyXMjMuJZRv5uC2V3LVA+8bgLMnuBY8ggoWRlcsllt89VFtgqA0AsvFXhgzDbmw6G0PLmQD9hBFigu2233OCUYVws0EPZGB3Wk2lgnlgJ9lNxRnIAFUd7gNOBeuENXJZbjxO9gHLDa2pptNvth7oo8LKmD3q0EZ0YGkOnuKBOA+gi3Fr7KtM84YqcTSCcRv2agw9yokgi59molItFTZeEaWlThVKzmXLuVhxy9BFvRQ0df/xSYAiGQcOrpUm5u2W2uQLVdwpEaucMOAdHFGAlu6QqWhbD8S+t8BbczPaRHJaDiCiOAbqydMdzIpRrcmmg8SuAaBVWBt6QqAvIaK3lQxtxKymTzjUWtEFk78CI+IIWEGfayNdnTDdXgpqyWPVRkVZqYOGBdvVSx4MXFMMzG6tovPM9pRyEp5qhtlI/Kuq5fET1op2KBDfQlwAevQPntoiPHU+TlPOZVrKm5ZLguYLNkSmUaaKzAbLFKcfjN3oK35tlrdXDDTV2aSyIBVoObzcq82DYdkFhUtJ5CYbHBLpeXrwQZob0pszsHkOGG3ZsjGsXFPMYKN5sGC5V+Xk6X/KSz/ECVhnVa5X8vZKGkq0WAjdmTt1LnxIjpF56sxCVBtKlLl90ThwiOt67xLLYNbBwAfnErliLqtgquLSDCbRfljgPOgSpouaJHEcUXQMJAHlq2B+huBW9voGO+KLCcCYisrfuQOCk+lSkCc3mFNU5CwAUPJUdkrJnZXs6Oe4c2HQBg29XZD/M9tT2o4IpQQ+Lwx4vMxRf9jaldhq+beuKlNcTeRqvyweAMe0NGOLjK18GaMDSP/AIIB5Qj0U/ZywbMB8zjXlRSq3Mld2C2X6Trsg/0+pQRYERbtRwRoKnOcCKOBklhXfgvR6irhavIzhjWNDk6Kz9QR6FmoyolTqOuAeuYBA1bXqKWJUDakn/AMGbJ6gJssqxTnaQYtQYjSTXFwPoQdlz9Bzupifi/AZV7QWIK9B22LqWZzVs5R0dFkLwB2l0tnZEdoqOjN9vh6mLRgaCl0eW4gIsfIBF3lQsbbzAN96uU+iOlR0FS4a2A4Rb4QEBXDHVMtHLY1is68EDSWAqx9MTyjCHWTR9BFZ1B8YdDRMkAGtBagFxc4ND9soGK07sVrcE3ytKZs6wABGmBkGXHyLuWWKEBw2Ld+D4ncOoYxB+AuLR4zgAHKU+iM3lFVrwWljiu0aUOLS4272hh+UXD8OgVGUdaHEkwjMp6dAmwNmpg/8AkTBku47FvFHME2BGgyLteUnTFiZ4eT1EYDUe/uN+Z/8Al/5xq+DVpAMvSWXCM4MbPcDUFnsO/ld3juHW2A8qK/0R/UuzkfGmIAckfIg91iap0xcbvCiXApnxh9wWQrARW+o7CE1wmltBI54NS4W4D2FF7BuXPS60pKZ1J2ilIKBt7VmcdpKz76jlQpo2rHqXwr1nMKLL6iw1NYVPmUT8OCAyh6DVih9Rsq3Ju6hQOg2y7UALrs8DHuUFyhdG98CniASo92+a3z0QePlWVo2sQe2ic5Rl9wcwS9ldJSOwusfmPg9uw7vRxCFM5IV8qjEv0hvnb6/XEd7LdwU8FbsUV6hNCAoKi0goKLDnnmW0Pk6blfpTY4WvnzLuZQMIbMVawO/6BZKgKHtiAoC+YCBKS5YFvBc9oo71SBY2RdBBtwrm5dWN2lPhswbOomM2lsZHeI6Nq4B0D+whmiyA5bjP5TmzvbKAq5oL2I+eJvVVAhoFvStxSBJ2rTQ/RdQrXXsuQZPAiGm3thVlvP8AZh9xETB1T4SiocP5RK0XBbS4oYKhdT4pl0ggK28H4jHjLmmYhR1hlQEfAr9wixqcNiHuqIxQgHJV6M+gqWZlrDKG0BTaWNyqXDV9UpmIF+TSB6wmThGPK0JTKW5dNe7j+oqkO0FeO5QzkjlIsPKu+ICzKujis8JlVGqS+YGqFeaGdsoxWBk8WQhkavgIJwPEAbRAR30e4sClsm6OreppKpQkpIr9KHvD9x2iPLSSYPhii87HRH3rxboUjBUywLEYdYCuT2+oFYPOV0AHa5GXGggqqgVNnCQaNndUFHC2DTUCNkq09kcfD3pPyh0wXKCvfegWrcl2Si7FlacvRit6Iw5nrgraMsTmjbuDx3CxCW1CnIheuhtCydmAk6VDD8SgqlEpkVD2XZ0+YGoGlv8ALMwAUQhbmjOviIBw2uK82YiZxdlMHauPxEWzAaduB7H4l4VqzSL7PZFXPyoL+9fF1xFETiDeQ+3lhpha03xAQ7c+TR7QAlz5woyHzdxHP9BXy0SDLysOUD6A7TRFdAVZeG4NiaYakgoULgnMtMxfkWyI8U/UMq1BjWqoV6IUwRo+1r9ISZud/wAKDljkVWxRtxLif0XwiBW1I+QMwBSR4eRgKHKIdHVrWr6lylL6RTypkij3UabEMDu8QeBRyBgs33TMSKcGAu1yIeSNwwCMC8A5BBwckuOq8mZBC9NYlmEKE67r0yxTQF2s/hLyC+BhPqCUk0n4tXEq6cIWedESawCisI6wcOyoQP5gs9UUzwUylH5dwkEYleg0+2NaFsIqzQELC5+5ofkzfUnTjodvxFATRSyWX5LFytaPuE5mHpbdXvAEco+yL/HRETgJgj5f/wA6iwEKwdxh0dsyAjLXu2DJs1Y5qBlm3Oi+2JbVLoyDHbtXAamZDBEF3AtPHgjHhl0ifKtsSB3La/u4rGrsZSvdR6ESpDaHd+KbZbhbXFZKK8lMvbDdjBIvaxqwvUELCqGA66JgL08IFfpCWjRbMX0Xo88S7cuXaH8ViVrLpo2+WpbOpigXNE55pqcYVd5DsHMaYYjTUpTZXZL7OKJXsFhl6ldwE033y9kdACB04HzEoyyrAKfMwwcNPiUSWVpNxqpxlxSeYvVVQaudAI+LS4uX9Axv4S7vcexRqOUlqxfLxDZGvD6IiyVD1i2K2okDuhZo76hhHlz7Ndq9y9fepOV7lhQvZwAGXIt6iURIyFEBeVtQwWcWae1v0GI28WZikqlFgcpeVZR15P8Ak2jMbNmj6UJnU09BG84qqFohwsH+sSzQKdHu5I4KU7i2VGVkfpuofLDDxhOKJi6BRspA5c7Q+Kkm0KVogQJq4PnvsihWPGU/k79BXV8q51eL6zAfVeuA0idqJsMWrs265Kw9QUDmvmKR4CNCQlsnpQqpLeXk6+QhglWa0psM4xDNRB6vQOIfUdVmzOX4PMLWC1e1nHh8RKcrXShe5llvd2f+xqrpwNL7lJkvGRpPJAiHbfjSk8SEop9csVMNamT3KAAzdp7EDTBcLxKPmFqA75fgLzHYMPsf+t1tgrue72mpQ7X8orxMCcy908EajTicqgeSoF60NVBZUWy5iyDwOUIpHlVUwdR1TOL5oBj3hieUrWorREhkMsXyJAlXlIFvCMpKvmaxAuOVng0ejuYM9p/i5Itcysg2Txi+JBYYQggJBLaU1AOtOCI6L4gQ4nmNihorA8nISywNXhDI+zMzheOGiaqgoDosDRBEnULGTNHmz9Q62eNMIKss5WT0eOCDOrE2tNg4YsQUfGdK+sQdeHghuuzCkzIwZYGdr9IAKSLdXHepfq1cNvplDAFWBtmWDgl0CyuwgVJSUV+TrMCiWCsXbzjmIJXj+BwxaBhhjADBvwH3aZoF9lekLip5Wl80ZZbFQdtDlf0xDMvm4vCCSbygA9HggiYNj8efbDw2OFLEv44iwFrqdt5/UZC1KVVLby4rcYaqM2wfBBQELaxiAED81j7cPozcLpOW+4uAErMMEgQ0974nOPqOBN5/JzcvqA314CosBk4MsFsTAXnz2zOXSWuqsiDg5+iJgwOfDG4qbXgNIzPorS4KC3ru+GMAO/SrFllzBdlsClLYziF+VwM2um1Dl3KS19J+HbHwTmOL9NdQIZGfCGD4pVX5bcnZFnwEfhuF2VolWOxAjDQbZun4tIMNAFnD3qb4OxCxGxVxy5M/ES2YPgfbRLCQG0fgqUhWaCWIWZe4C+jQtIkd1zPyMQwPAaeKdgxy4cG/kdEzfxKX7NQkCJ5t9BiA3ohQtHyY83OdNB92eagJ1g0TOdYHdxdoasFPScHcDmfT3KbazM7xvjMFDC6HYl1h/wBRZ5IyA8nJ/gFsXC6KJZI0tCvi3m17h9aK8GvgEPShJ1dflhjjyLfiDbDFYHmtoSZrLFlHCd3OQorw+pTEwsh+UNhcynjyR5VVMIyamRlCqxWgWe0y6S3axiXs7y0A6aPLEVUIAg4GVyLOaLdfELQBoq0pHpiQ+OpsTTC8ofqZBveKPmArIcUp5RVMuTl7HiAFC8EKUcaTouKdVdJKzsoNvDlog8KiF1f9EOEJhtVcOdJGthXpojpIsB2qEtbQFZHdERFRowvyjDHY7VjfWMUg0KDEOxKUyjIuEqV8b+UzRDek/Kgv5cQyZEFF0DXZYxioO7SilUHYTBKDY5Kl9RFysPMIqCwxptIUnRqOQGfHd2P7IYkaI7muZYI2LRtD28Qsy5RrJFmQLoc5UswBwNelYPctF7XfoeNAmtqyOEwMAVAyvzEktxw4GmynSTJXtYVLqIEVW/HnxNDnIOz5eIpkKKdOBjFZ9geAIU5oSA2je8Yi4MJxaeqynudfSDDQaNqFxQmwaezih3mNJKtL+Bwg4LZE9kOWnRVP05lwhWS0PcloYdADzwRoGzaFD0czF/SsD6SaVeFO7hJoLKYqL+UAN0FgtchN0vkNcQjZyOCQ3tqa6iKMNBZMeYJN+VEL52fiUeK4FFfdGJ23OLK/TM5ksO3yY58O47fdb9QoRo1frFAx1GpCmgp+WIBbJZbwzTx3LCurVbQ5i6hUoftHsvAV9uZWHWF1S6+GUaA15WtaiBorRlllphQNHncl78sekJY5MB57SFWu4KiCoMXoLQXWbuZCO8DXfiHsGmxV0UFqvu4pKIORcomGRv29nuHiKNWIX559yk4ShxnXMZJkpc1y9EAQXbi0mj9MOAJ/0Y5lKxj9FOJYUDnCvouVtB3di1hMc0lWmptnnxAKswC7sie3Ywh8S2D7WLFxyQJaZZTRis1cjNNbxiEjwHW8V0YLLSg76Dp7GAYTZSGS6RrJF4orVh8/8SoGPkL5eiYVgURlZyP4lpjLkY6KaWIhpBQ9b1yuI1iBtu5rETGxEGVvGxAMdPIyeXEd2CYoJ9Qilbza5fg3XqYQAnJ5YA0xlunKs1qJ1GyqurFUX7gHbWVxwHn2RzIq15gQ+1lMTCXjku0JSKmwWXaiKYgQU6IKnoTijbo1yx1IlYvTPth6Qk6ETbeqLgbzW3OCPX5PA16tTwU4/wDlAP2U2deycGNFu+BefcTsQLXV9Si8DscNxL7bXAwW/q4zp9INsaLcC7ORmS0dRpIOhC23RZKl80cFQK2OoLit9hsl7VN+M6cvDEgNXIOqTKMWtpsgPx/ZTrkQ2u0w5lJZddBuX4XmEhjg1ZallAmWqEe5nCh9r7FilhtYwt9GVl0VIcDH9uJNmV55Xnn7VlBsvOI7NOibSu6liCyinNQ8EKNR8YSkjYy5X50QzJnyq9PUEJa1SV8plgXRfSn+2AnDfAPK7uMo1RBXwuGxpCst4EPHEa1TC+AufcVmchW2EviLSeiyrCBL4cGoLgXMAAIp26j1JVsEQlNeGKzVcHpUr93Uyek12CjQN1FKv6P/ACZqDZDjU/dVHNswW+SKIU2mcZ5GWmBbDhOSLVDPAoA+NxkXkkwUyRJNczGi8sgg+7E7CC4JWsLuraiNFWzuehzF0pSwK3lK/kK19Qbm6MB96m8HURdfncb1pxaL9Ic62+9rE8p1YjmmPUd/QfCoNs5KTb7dv4IENRLsWqLriGxGQ7xu0SqLiBg6rZiNT3DbgV2TLcHyUeXl8EsGpNz6BFKPCmyruoiARaJzk7YKxw1Yr9wQXFnlHQGa/E0oLHZUXtW8y9YVAaF5e2IHMS119IFUNpXaGb8Euqax28sTsRMUwRC7b3wEHDdgfJ7pwIJgJYtnPBi2NWAzgt0HpCvejA745uZ5VWkCJB2KzyDyHp/cHmBTkTKjs2RmuQR2/S6XuWbjYhf6fmGW430gBDtTknLd3sRehTqXs2rwwo9cqTNdCqkDVY9V+NpKih7rn+GPaRXYzPvU8GPNr6pLmpLjkeOCEVwK5QOoIGoaXpm00gWxZ/JntUA6O1wQEGGAq+MpcwIK5XoYa/p5M2AW83CzwmxnC1c1FgEmFyXKJNV/wyxWK3Sx05+xUXYPFECMXw4PiNKz7F/UUgKuyO9fCABy/niH3ASioDL5XgjORFuvqEBYVC4Lg9AcCEA4HflY01jQinkQPQcYNcsRnjGgN9ARW0FYoHX01LvGN605XR/JD1TTueNE7OSHxCNK5QeRjI29Mp65JelDePMGFwz+RNoR15Vd+mN5pJYyy5RlQYdMWXlQ0nZhm2ii41HLKLCjjB8yzLxsMIryzUCQjoSruuIFzLIt01ubkQR7eT0RIJ1qgfuCoGg/ADAHrku6VH6IFWWhLYFViy1hI5zKB9Mq7lQN1ALGhpQCsFVGEAhQW5TbdWs2eeybgB2HF36svJLsdF6lxU1oPMWnxGgUWmlu4Xxe/wDyGLk9dav1tlO27Tjzf9gAee/Hy8sQYD4nRly/Y9xXUgsEE++WESx8EtKrXeOpeZqxGJO3hO9EJgsrIacHgTNgQejlbRPdXnJ/IX4v/odJwxwT6jdxabSGbFg18vh7I/I0WkR9H5qASh03OS1e6NHYanezbN+lkmXYfIL4zImj6X9LOQDrQeky9eCINqbtV1EQC1V5NP4hYDeq4CkUMvBlJkd3mw+mEzJKpssPQwuyrkvi3BcFls8MNVLioqFyeXhlrWwH5jEGx5q9h3FSBWhyo5RtEo/4H9mSV8GRb8EukwrQAo9R0V3NdnLLndun+BNerk/kLiXYtXK8aEvkOWL2uFeO2KPr1xdgTq0vuMOsyom+BhYA/BfiBHvwXj0RmsO7tq7zlgB0xXEtHkuMU1sAQ45s0eoiw0OJ8C3LQqhzmdpXD/N/sf8AGBgYKz7hLoK5vxM15QPTcXcsc3YhOBSmsVHLZU5f8H6pt8o+7ZiZaxeaVPtV+ERGSNVnTFDYDgg9zLprmHbCzbc/UmpwsfJCUQ3ZfhiOAFUw7IUIACgeRAaOJtH5/wC81jtiRU8RRZPt4jW54P8AB/Jn65zMAUjEOCsiEAoL5qIiCFkBtzMidW18RYANNL7lt5WHcdDxFqZcGdIDO7T/2Q==";
const fond4 = "data:image/jpeg;base64,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";
const chip = "data:image/png;base64,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";
const fond = {
  "1": fond1,
  "2": fond2,
  "3": fond3,
  "4": fond4
  // '5' : fond5,
  // '6' : fond6,
  // '7' : fond7,
  // '8' : fond8,
  // '9' : fond9,
  // '10' : fond10,
  // '11' : fond11,
  // '12' : fond12,
  // '13' : fond13,
  // '14' : fond14,
  // '15' : fond15,
  // '16' : fond16,
  // '17' : fond17,
  // '18' : fond18,
  // '19' : fond19,
  // '20' : fond20,
  // '21' : fond21,
  // '22' : fond22,
  // '23' : fond23,
  // '24' : fond24,
  // '25' : fond25
};
const chipimage = {
  "chip": chip
};
var cardItem = "nf81a31";
var smallCard = "nf81a32";
var mediumCard = "nf81a33";
var bigCard = "nf81a34";
var cardItemChip = "nf81a35";
var cardItemTop = "nf81a36";
var cardItemTopChip = "nf81a37";
var cardItemName = "nf81a3a";
var cardItemNumber = "nf81a3b";
var cardItemNumberItem = "nf81a3c";
var cardItemWrapper = "nf81a3d";
var cardItemContent = "nf81a3e";
var active = "nf81a3j";
var cardItemSide = "nf81a3k";
var cardItemSideBack = "nf81a3l";
var cardItemSideFront = "nf81a3m";
var cardItemBg = "nf81a3n";
var cardItemCover = "nf81a3o";
var showButton = "nf81a3t";
var showButtonLabel = "nf81a3u";
var showButtonIcon = "nf81a3v";
var seeMoreBtn = "nf81a3w";
var informationCardWrapper = "nf81a3x";
var informationCardNumber = "nf81a3y";
var informationCardNumberButton = "nf81a3z";
var informationCardNumberNumber = "nf81a310";
var informationCardExpiration = "nf81a311";
var informationCardCVV = "nf81a312";
var copybutton = "nf81a313";
var WebankPassCard = "nf81a314";
var webankPassCardImage = "nf81a315";
const webankPassimage = "data:image/svg+xml,%3csvg%20width='148'%20height='115'%20viewBox='0%200%20148%20115'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_2265_12282)'%3e%3cpath%20d='M103.303%20113.289L101.074%20113.289L100.014%20105.591L103.304%20105.591L103.303%20113.289Z'%20fill='%23FFB6B6'/%3e%3cpath%20d='M95.6656%20113.244C95.5962%20113.349%2095.5596%20113.687%2095.5596%20113.808C95.5596%20114.183%2095.8983%20114.486%2096.3162%20114.486H103.22C103.505%20114.486%20103.736%20114.279%20103.736%20114.024V113.766C103.736%20113.766%20104.078%20112.993%20103.375%20112.04C103.375%20112.04%20102.501%20112.786%20101.195%20111.617L100.81%20110.992L98.0223%20112.818L96.4772%20112.988C96.1392%20113.025%2095.8395%20112.982%2095.6656%20113.244Z'%20fill='%232F2E41'/%3e%3cpath%20d='M126.837%20110.793L124.8%20111.603L120.338%20104.955L123.345%20103.758L126.837%20110.793Z'%20fill='%23FFB6B6'/%3e%3cpath%20d='M119.837%20113.529C119.821%20113.65%20119.941%20113.972%20119.996%20114.084C120.166%20114.425%20120.613%20114.579%20120.995%20114.427L127.304%20111.916C127.564%20111.813%20127.682%20111.54%20127.566%20111.306L127.449%20111.071C127.449%20111.071%20127.41%20110.24%20126.335%20109.625C126.335%20109.625%20125.875%20110.625%20124.151%20110.031L123.516%20109.601L121.797%20112.282L120.463%20113C120.171%20113.157%20119.877%20113.227%20119.837%20113.529Z'%20fill='%232F2E41'/%3e%3cpath%20d='M98.4586%2065.1187L96.4766%2068.8452L99.8461%20107.53H104.06L105.792%2082.1541L120.916%20107.53H126.085L118.28%2089.4296L112.928%2065.8285L98.4586%2065.1187Z'%20fill='%232F2E41'/%3e%3cpath%20d='M109.071%2041.2202H103.845L101.928%2043.913L97.6045%2045.7643L98.5444%2057.3768L98.0729%2065.8439L98.719%2065.827C103.332%2065.7065%20107.942%2066.3782%20112.223%2067.9213C113.321%2068.3172%20114.472%2068.538%20115.463%2068.3162C115.463%2068.3162%20115.087%2066.9698%20114.711%2066.6332C114.335%2066.2966%20114.147%2066.0183%20114.335%2065.8209C114.523%2065.6234%20114.899%2065.4551%20114.523%2065.1185C114.147%2064.782%20114.147%2064.3579%20114.147%2064.3579L113.019%2056.8719L115.275%2046.2692L110.575%2043.913L109.071%2041.2202Z'%20fill='%2331859D'/%3e%3cpath%20d='M118.053%2055.901L117.911%2065.8325L115.15%2074.6858L112.944%2073.949L113.924%2065.834L113.795%2054.8523L118.053%2055.901Z'%20fill='%23FFB6B6'/%3e%3cpath%20d='M115.141%2076.1135C115.4%2074.8404%20114.925%2073.6969%20114.081%2073.5592C113.237%2073.4216%20112.342%2074.3421%20112.084%2075.6151C111.825%2076.8882%20112.299%2078.0317%20113.143%2078.1694C113.988%2078.307%20114.882%2077.3865%20115.141%2076.1135Z'%20fill='%23FFB6B6'/%3e%3cpath%20d='M114.147%2045.7643C114.147%2045.7643%20117.261%2046.1963%20117.302%2048.589C117.343%2050.9816%20120.35%2054.8524%20118.471%2057.8818L113.583%2058.555L110.951%2049.9718L113.959%2045.4277'%20fill='%2331859D'/%3e%3cpath%20d='M99.9324%2054.152L93.726%2062.3847L85.9921%2068.43L84.5991%2066.73L90.392%2060.4272L97.0153%2051.1833L99.9324%2054.152Z'%20fill='%23FFB6B6'/%3e%3cpath%20d='M85.1089%2069.6189C86.1057%2068.6819%2086.4099%2067.4927%2085.7884%2066.9629C85.1669%2066.4331%2083.8551%2066.7632%2082.8584%2067.7003C81.8617%2068.6373%2081.5575%2069.8265%2082.179%2070.3563C82.8004%2070.8861%2084.1122%2070.556%2085.1089%2069.6189Z'%20fill='%23FFB6B6'/%3e%3cpath%20d='M102.88%2043.759C102.88%2043.759%20105.219%2045.6501%20103.786%2047.6703C102.354%2049.6906%20102.496%2054.4042%2099.0674%2056.0132L94.5688%2054.1748C94.9478%2050.8559%2095.1689%2047.4149%2097.6295%2045.7064L102.929%2043.3853'%20fill='%2331859D'/%3e%3cpath%20d='M105.647%2040.5266C108.23%2040.5266%20110.324%2038.652%20110.324%2036.3397C110.324%2034.0274%20108.23%2032.1528%20105.647%2032.1528C103.064%2032.1528%20100.971%2034.0274%20100.971%2036.3397C100.971%2038.652%20103.064%2040.5266%20105.647%2040.5266Z'%20fill='%23FFB6B6'/%3e%3cpath%20d='M109.082%2039.7799C109.34%2039.8192%20109.642%2039.2602%20109.931%2038.7157C110.536%2037.5761%20110.92%2036.8515%20110.95%2035.8274C110.975%2034.9546%20110.704%2035.1837%20110.44%2033.2432C110.353%2032.6031%20109.132%2032.6044%20108.883%2032.3005C108.464%2031.7871%20109.108%2031.5754%20108.063%2031.267C106.106%2030.6893%20105.222%2031.5867%20103.979%2031.664C103.947%2031.6659%20103.331%2032.2053%20102.987%2032.2332C102.385%2032.2821%20101.515%2032.198%20101.125%2031.3757C100.761%2030.6069%20100.519%2032.8536%20100.845%2033.1316C101.122%2033.3677%20101.599%2033.9602%20101.611%2034.0033C101.625%2034.052%20100.476%2032.9131%20100.285%2033.3824C100.147%2033.7202%20100.581%2035.4581%20100.932%2035.5234C101.225%2035.578%20101.943%2034.7123%20101.781%2035.0674C101.405%2035.8908%20103.663%2036.4162%20106.365%2034.7633C106.461%2034.7047%20106.37%2034.7982%20106.705%2035.5234C107.126%2036.4381%20107.222%2036.4876%20107.214%2036.7395C107.198%2037.2849%20106.741%2037.4455%20106.875%2037.8037C106.983%2038.0938%20107.406%2038.3184%20107.724%2038.2597C108.082%2038.1935%20108.143%2037.7966%20108.403%2037.8037C108.625%2037.8097%20108.889%2038.1093%20108.912%2038.4117C108.962%2039.0488%20107.908%2039.224%20107.724%2040.0839C107.619%2040.5692%20108.845%2039.7437%20109.082%2039.7799Z'%20fill='%232F2E41'/%3e%3cpath%20d='M72.0601%20114.676H31.8759C25.8488%20114.676%2020.9453%20110.286%2020.9453%20104.89V9.78596C20.9453%204.38999%2025.8488%200%2031.8759%200H72.0601C78.0871%200%2082.9906%204.38999%2082.9906%209.78596C83.7386%2047.9769%2085.0142%2090.7448%2082.9906%20104.89C82.9906%20110.286%2078.0871%20114.676%2072.0601%20114.676Z'%20fill='%233F3D56'/%3e%3cpath%20d='M83.5513%2034.9824C83.2963%2034.9824%2083.0889%2035.1681%2083.0889%2035.3964V48.6442C83.0889%2048.8725%2083.2963%2049.0582%2083.5513%2049.0582C83.8063%2049.0582%2084.0137%2048.8725%2084.0137%2048.6442V35.3964C84.0137%2035.1681%2083.8063%2034.9824%2083.5513%2034.9824Z'%20fill='%233F3D56'/%3e%3cpath%20d='M81.9502%209.78598V104.889C81.9502%20109.585%2077.8671%20113.427%2072.7042%20113.725H72.7019C72.6256%20113.729%2072.5493%20113.734%2072.4707%20113.736C72.3343%20113.742%2072.1979%20113.744%2072.0591%20113.744C72.0591%20113.744%2071.5505%20113.711%2070.621%20113.649C69.6823%20113.587%2068.3159%20113.493%2066.6118%20113.371C66.1009%20113.336%2065.5622%20113.297%2064.9934%20113.255C63.8605%20113.173%2062.6166%20113.082%2061.2825%20112.978C60.7507%20112.939%2060.2004%20112.895%2059.6386%20112.852C56.767%20112.63%2053.5509%20112.372%2050.159%20112.078C49.5856%20112.03%2049.0076%20111.98%2048.425%20111.929C48.2724%20111.914%2021.9858%20105.998%2021.9858%20104.889V9.78598C21.9858%204.89466%2026.4135%200.930664%2031.877%200.930664H37.782C38.7254%200.930664%2039.4837%201.58891%2039.5647%202.43139C39.5716%202.48729%2039.5785%202.54316%2039.5901%202.59906C39.7612%203.44568%2040.6282%204.03562%2041.59%204.03562H62.3461C63.3079%204.03562%2064.1749%203.44568%2064.346%202.59906C64.3576%202.54316%2064.3645%202.48729%2064.3714%202.43139C64.4524%201.58891%2065.2107%200.930664%2066.1541%200.930664H72.0591C77.5226%200.930664%2081.9502%204.89466%2081.9502%209.78598Z'%20fill='white'/%3e%3cpath%20d='M20.7144%2025.0466C20.4593%2025.0466%2020.252%2025.2323%2020.252%2025.4606V28.7726C20.252%2029.0009%2020.4593%2029.1866%2020.7144%2029.1866C20.9694%2029.1866%2021.1768%2029.0009%2021.1768%2028.7726V25.4606C21.1768%2025.2323%2020.9694%2025.0466%2020.7144%2025.0466Z'%20fill='%233F3D56'/%3e%3cpath%20d='M20.7144%2034.9824C20.4593%2034.9824%2020.252%2035.1681%2020.252%2035.3964V41.8133C20.252%2042.0416%2020.4593%2042.2273%2020.7144%2042.2273C20.9694%2042.2273%2021.1768%2042.0416%2021.1768%2041.8133V35.3964C21.1768%2035.1681%2020.9694%2034.9824%2020.7144%2034.9824Z'%20fill='%233F3D56'/%3e%3cpath%20d='M20.7144%2044.0903C20.4593%2044.0903%2020.252%2044.276%2020.252%2044.5043V50.9212C20.252%2051.1496%2020.4593%2051.3352%2020.7144%2051.3352C20.9694%2051.3352%2021.1768%2051.1496%2021.1768%2050.9212V44.5043C21.1768%2044.276%2020.9694%2044.0903%2020.7144%2044.0903Z'%20fill='%233F3D56'/%3e%3cpath%20d='M37.6212%202.38062H28.7778C28.7298%202.38062%2028.6909%202.41545%2028.6909%202.45843V3.33779C28.6909%203.38076%2028.7298%203.4156%2028.7778%203.4156H37.6212C37.6692%203.4156%2037.7081%203.38076%2037.7081%203.33779V2.45843C37.7081%202.41545%2037.6692%202.38062%2037.6212%202.38062Z'%20fill='%23E6E6E6'/%3e%3cpath%20d='M67.6153%203.4155C68.126%203.4155%2068.5401%203.04479%2068.5401%202.58751C68.5401%202.13022%2068.126%201.75952%2067.6153%201.75952C67.1045%201.75952%2066.6904%202.13022%2066.6904%202.58751C66.6904%203.04479%2067.1045%203.4155%2067.6153%203.4155Z'%20fill='%23E6E6E6'/%3e%3cpath%20d='M70.1587%203.4155C70.6695%203.4155%2071.0836%203.04479%2071.0836%202.58751C71.0836%202.13022%2070.6695%201.75952%2070.1587%201.75952C69.6479%201.75952%2069.2339%202.13022%2069.2339%202.58751C69.2339%203.04479%2069.6479%203.4155%2070.1587%203.4155Z'%20fill='%23E6E6E6'/%3e%3cpath%20d='M72.7022%203.4155C73.213%203.4155%2073.627%203.04479%2073.627%202.58751C73.627%202.13022%2073.213%201.75952%2072.7022%201.75952C72.1914%201.75952%2071.7773%202.13022%2071.7773%202.58751C71.7773%203.04479%2072.1914%203.4155%2072.7022%203.4155Z'%20fill='%23E6E6E6'/%3e%3cpath%20d='M72.9959%2076.1854C72.9959%2066.7476%2064.0861%2061.5558%2053.9085%2059.0967C40.8599%2055.9441%2031.3033%2062.3236%2034.821%2076.1854C37.1566%2085.3886%2049.0115%2099.1233%2053.9085%2090.7656C59.512%2081.2021%2072.9959%2085.6231%2072.9959%2076.1854Z'%20fill='%23F2F2F2'/%3e%3cpath%20d='M0.5%20114.702C0.5%20114.867%200.648502%20115%200.833426%20115H147.167C147.351%20115%20147.5%20114.867%20147.5%20114.702C147.5%20114.536%20147.351%20114.403%20147.167%20114.403H0.833426C0.648502%20114.403%200.5%20114.536%200.5%20114.702Z'%20fill='%23CCCCCC'/%3e%3cpath%20d='M34.3907%2068.6677C33.1122%2068.6677%2031.8862%2069.1208%2030.9822%2069.9273C30.0782%2070.7339%2029.5703%2071.8278%2029.5703%2072.9684C29.5703%2074.109%2030.0782%2075.2028%2030.9822%2076.0094C31.8862%2076.8159%2033.1122%2077.269%2034.3907%2077.269H70.3138C71.5922%2077.269%2072.8183%2076.8159%2073.7223%2076.0094C74.6263%2075.2028%2075.1341%2074.109%2075.1341%2072.9684C75.1341%2071.8278%2074.6263%2070.7339%2073.7223%2069.9273C72.8183%2069.1208%2071.5922%2068.6677%2070.3138%2068.6677H34.3907Z'%20fill='%23E5E5E5'/%3e%3cpath%20d='M34.3782%2069.5278C33.3578%2069.5278%2032.3792%2069.8903%2031.6576%2070.5355C30.9361%2071.1808%2030.5308%2072.0559%2030.5308%2072.9683C30.5308%2073.8808%2030.9361%2074.7559%2031.6576%2075.4011C32.3792%2076.0464%2033.3578%2076.4088%2034.3782%2076.4088H70.3258C71.3462%2076.4088%2072.3248%2076.0464%2073.0463%2075.4011C73.7678%2074.7559%2074.1732%2073.8808%2074.1732%2072.9683C74.1732%2072.0559%2073.7678%2071.1808%2073.0463%2070.5355C72.3248%2069.8903%2071.3462%2069.5278%2070.3258%2069.5278H34.3782Z'%20fill='white'/%3e%3cpath%20d='M42.3019%2075.0573H35.2315C35.2091%2075.0575%2035.1868%2075.0529%2035.166%2075.0437C35.1452%2075.0345%2035.1263%2075.0209%2035.1103%2075.0038C35.0944%2074.9867%2035.0818%2074.9663%2035.0731%2074.9439C35.0645%2074.9214%2035.0601%2074.8973%2035.0601%2074.873C35.0601%2074.8487%2035.0645%2074.8247%2035.0731%2074.8022C35.0818%2074.7798%2035.0944%2074.7594%2035.1103%2074.7423C35.1263%2074.7251%2035.1452%2074.7116%2035.166%2074.7024C35.1868%2074.6932%2035.2091%2074.6886%2035.2315%2074.6887H42.3019C42.3469%2074.6891%2042.3899%2074.7086%2042.4216%2074.7431C42.4533%2074.7777%2042.471%2074.8244%2042.471%2074.873C42.471%2074.9217%2042.4533%2074.9684%2042.4216%2075.0029C42.3899%2075.0374%2042.3469%2075.057%2042.3019%2075.0573Z'%20fill='%2331859D'/%3e%3cpath%20d='M51.3572%2075.0573H44.2891C44.2666%2075.0574%2044.2444%2075.0543%2044.2236%2075.0482C44.2028%2075.042%2044.1839%2075.033%2044.168%2075.0216C44.152%2075.0102%2044.1394%2074.9966%2044.1307%2074.9816C44.1221%2074.9667%2044.1177%2074.9506%2044.1177%2074.9344C44.1177%2074.9182%2044.1221%2074.9021%2044.1307%2074.8872C44.1394%2074.8722%2044.152%2074.8586%2044.168%2074.8472C44.1839%2074.8358%2044.2028%2074.8268%2044.2236%2074.8206C44.2444%2074.8145%2044.2666%2074.8114%2044.2891%2074.8115H51.3572C51.3797%2074.8114%2051.402%2074.8145%2051.4228%2074.8206C51.4435%2074.8268%2051.4624%2074.8358%2051.4784%2074.8472C51.4943%2074.8586%2051.507%2074.8722%2051.5156%2074.8872C51.5242%2074.9021%2051.5287%2074.9182%2051.5287%2074.9344C51.5287%2074.9506%2051.5242%2074.9667%2051.5156%2074.9816C51.507%2074.9966%2051.4943%2075.0102%2051.4784%2075.0216C51.4624%2075.033%2051.4435%2075.042%2051.4228%2075.0482C51.402%2075.0543%2051.3797%2075.0574%2051.3572%2075.0573Z'%20fill='%2331859D'/%3e%3cpath%20d='M60.4153%2075.1801H53.3449C53.3%2075.1798%2053.2569%2075.1602%2053.2253%2075.1257C53.1936%2075.0912%2053.1758%2075.0445%2053.1758%2074.9958C53.1758%2074.9472%2053.1936%2074.9005%2053.2253%2074.8659C53.2569%2074.8314%2053.3%2074.8119%2053.3449%2074.8115H60.4153C60.4378%2074.8114%2060.46%2074.816%2060.4808%2074.8252C60.5016%2074.8344%2060.5205%2074.8479%2060.5365%2074.8651C60.5524%2074.8822%2060.5651%2074.9026%2060.5737%2074.925C60.5823%2074.9475%2060.5868%2074.9715%2060.5868%2074.9958C60.5868%2075.0201%2060.5823%2075.0442%2060.5737%2075.0667C60.5651%2075.0891%2060.5524%2075.1095%2060.5365%2075.1266C60.5205%2075.1437%2060.5016%2075.1573%2060.4808%2075.1665C60.46%2075.1757%2060.4378%2075.1803%2060.4153%2075.1801Z'%20fill='%2331859D'/%3e%3cpath%20d='M69.4752%2075.1801H62.4026C62.3576%2075.1799%2062.3146%2075.1668%2062.2829%2075.1438C62.2512%2075.1208%2062.2334%2075.0896%2062.2334%2075.0572C62.2334%2075.0248%2062.2512%2074.9936%2062.2829%2074.9706C62.3146%2074.9476%2062.3576%2074.9345%2062.4026%2074.9343H69.4752C69.5202%2074.9345%2069.5632%2074.9476%2069.5949%2074.9706C69.6266%2074.9936%2069.6444%2075.0248%2069.6444%2075.0572C69.6444%2075.0896%2069.6266%2075.1208%2069.5949%2075.1438C69.5632%2075.1668%2069.5202%2075.1799%2069.4752%2075.1801Z'%20fill='%2331859D'/%3e%3cpath%20d='M38.6968%2073.5827C39.4169%2073.5827%2040.0006%2073.06%2040.0006%2072.4154C40.0006%2071.7707%2039.4169%2071.248%2038.6968%2071.248C37.9768%2071.248%2037.3931%2071.7707%2037.3931%2072.4154C37.3931%2073.06%2037.9768%2073.5827%2038.6968%2073.5827Z'%20fill='%2331859D'/%3e%3cpath%20d='M47.8917%2073.5827C48.6117%2073.5827%2049.1955%2073.06%2049.1955%2072.4154C49.1955%2071.7707%2048.6117%2071.248%2047.8917%2071.248C47.1716%2071.248%2046.5879%2071.7707%2046.5879%2072.4154C46.5879%2073.06%2047.1716%2073.5827%2047.8917%2073.5827Z'%20fill='%2331859D'/%3e%3cpath%20d='M56.9498%2073.5827C57.6698%2073.5827%2058.2536%2073.06%2058.2536%2072.4154C58.2536%2071.7707%2057.6698%2071.248%2056.9498%2071.248C56.2297%2071.248%2055.646%2071.7707%2055.646%2072.4154C55.646%2073.06%2056.2297%2073.5827%2056.9498%2073.5827Z'%20fill='%2331859D'/%3e%3cpath%20d='M66.1451%2073.5827C66.8652%2073.5827%2067.4489%2073.06%2067.4489%2072.4154C67.4489%2071.7707%2066.8652%2071.248%2066.1451%2071.248C65.425%2071.248%2064.8413%2071.7707%2064.8413%2072.4154C64.8413%2073.06%2065.425%2073.5827%2066.1451%2073.5827Z'%20fill='%2331859D'/%3e%3cpath%20d='M51.9398%2043.3789C58.0316%2043.3789%2062.97%2038.9574%2062.97%2033.5033C62.97%2028.0491%2058.0316%2023.6277%2051.9398%2023.6277C45.848%2023.6277%2040.9097%2028.0491%2040.9097%2033.5033C40.9097%2038.9574%2045.848%2043.3789%2051.9398%2043.3789Z'%20fill='%2331859D'/%3e%3cpath%20d='M56.5098%2037.8062H47.3705C47.2034%2037.806%2047.0432%2037.7465%2046.925%2037.6407C46.8069%2037.5349%2046.7404%2037.3915%2046.7402%2037.2419V32.3041C46.7404%2032.1544%2046.8069%2032.011%2046.925%2031.9052C47.0432%2031.7994%2047.2034%2031.7399%2047.3705%2031.7397H56.5098C56.6769%2031.7399%2056.8371%2031.7994%2056.9553%2031.9052C57.0735%2032.011%2057.1399%2032.1544%2057.1401%2032.3041V37.2419C57.1399%2037.3915%2057.0735%2037.5349%2056.9553%2037.6407C56.8371%2037.7465%2056.6769%2037.806%2056.5098%2037.8062ZM47.3705%2032.3041V37.2419H56.5103L56.5098%2032.3041L47.3705%2032.3041Z'%20fill='white'/%3e%3cpath%20d='M54.7767%2032.304H49.104V30.0467C49.104%2028.4117%2050.2969%2027.2251%2051.9403%2027.2251C53.5838%2027.2251%2054.7767%2028.4117%2054.7767%2030.0467L54.7767%2032.304ZM49.7343%2031.7397H54.1464V30.0467C54.1464%2028.7177%2053.2392%2027.7894%2051.9403%2027.7894C50.6414%2027.7894%2049.7343%2028.7177%2049.7343%2030.0467L49.7343%2031.7397Z'%20fill='white'/%3e%3cpath%20d='M51.9394%2035.1963C52.2875%2035.1963%2052.5697%2034.9436%2052.5697%2034.6319C52.5697%2034.3203%2052.2875%2034.0676%2051.9394%2034.0676C51.5913%2034.0676%2051.3091%2034.3203%2051.3091%2034.6319C51.3091%2034.9436%2051.5913%2035.1963%2051.9394%2035.1963Z'%20fill='white'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_2265_12282'%3e%3crect%20width='147'%20height='115'%20fill='white'%20transform='translate(0.5)'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e";
const cardSize = {
  "small": smallCard,
  "medium": mediumCard,
  "big": bigCard
};
const CardSeeMoreButton = (props) => {
  return /* @__PURE__ */ React__default.createElement("button", { onClick: props.onClick, className: seeMoreBtn }, /* @__PURE__ */ React__default.createElement(Icon$2, { icon: "Voir", size: 16 }), /* @__PURE__ */ React__default.createElement("span", null, props.label));
};
const CardPreview = ({
  etat,
  holderName,
  expirationDate,
  cardNumber,
  cvv,
  background,
  size: size2 = "medium",
  showNumberButton = /* @__PURE__ */ React__default.createElement(CardSeeMoreButton, { label: "voir" }),
  copyButtonHandler,
  cardNumberLabel = "Numéro",
  expirationDateLabel = "Date d'éxpiration",
  CvvLabel = "CVV",
  waitingLabel = "Waiting Approval"
}) => {
  var _a2, _b2;
  cardNumber = cardNumber.slice(0, 16);
  expirationDate = new Date(expirationDate);
  const handleCopyClick = () => {
    copyButtonHandler == null ? void 0 : copyButtonHandler();
  };
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("div", { className: `${cardItem} ${etat == "default" ? "" : active} ${cardSize[size2]}` }, /* @__PURE__ */ React__default.createElement("div", { className: `${cardItemSide} ${cardItemSideFront}` }, /* @__PURE__ */ React__default.createElement("div", { className: cardItemCover }, background && /* @__PURE__ */ React__default.createElement(
    "img",
    {
      src: fond[background],
      className: cardItemBg,
      alt: ""
    }
  )), /* @__PURE__ */ React__default.createElement("div", { className: cardItemWrapper }, /* @__PURE__ */ React__default.createElement("div", { className: cardItemTop }, /* @__PURE__ */ React__default.createElement("div", { className: cardItemTopChip }, "WeBank", /* @__PURE__ */ React__default.createElement("img", { src: chipimage.chip, className: cardItemChip, alt: "" })), showNumberButton), /* @__PURE__ */ React__default.createElement("div", { className: cardItemNumber }, (_a2 = cardNumber.match(/.{1,4}/g)) == null ? void 0 : _a2.map((word) => /* @__PURE__ */ React__default.createElement("div", { key: word, className: cardItemNumberItem }, word))), /* @__PURE__ */ React__default.createElement("div", { className: cardItemContent }, /* @__PURE__ */ React__default.createElement("div", { className: cardItemName }, holderName)))), etat == "waiting" ? /* @__PURE__ */ React__default.createElement("div", { className: `${cardItemSide} ${cardItemSideBack}` }, /* @__PURE__ */ React__default.createElement("div", { className: WebankPassCard }, /* @__PURE__ */ React__default.createElement("img", { className: webankPassCardImage, src: webankPassimage, alt: "WebankPass Image" }), /* @__PURE__ */ React__default.createElement("p", null, waitingLabel))) : /* @__PURE__ */ React__default.createElement("div", { className: `${cardItemSide} ${cardItemSideBack}` }, /* @__PURE__ */ React__default.createElement("div", { className: cardItemCover }, background && /* @__PURE__ */ React__default.createElement("img", { src: fond[background], className: cardItemBg, alt: "" })), /* @__PURE__ */ React__default.createElement("div", { className: informationCardWrapper }, /* @__PURE__ */ React__default.createElement("div", { className: informationCardNumberButton }, showNumberButton), /* @__PURE__ */ React__default.createElement("div", { className: informationCardNumber }, /* @__PURE__ */ React__default.createElement("div", { className: "text-wrapper-2" }, cardNumberLabel), /* @__PURE__ */ React__default.createElement("div", { className: informationCardNumberNumber }, (_b2 = cardNumber.match(/.{1,4}/g)) == null ? void 0 : _b2.map((word) => /* @__PURE__ */ React__default.createElement("div", { key: word, className: cardItemNumberItem }, word)), /* @__PURE__ */ React__default.createElement(TooltipUI, { text: "copy" }, /* @__PURE__ */ React__default.createElement("button", { onClick: handleCopyClick, className: copybutton }, /* @__PURE__ */ React__default.createElement(
    Icon$2,
    {
      icon: "Copier",
      size: 25
    }
  ))))), /* @__PURE__ */ React__default.createElement("div", { className: informationCardExpiration }, /* @__PURE__ */ React__default.createElement("div", null, expirationDateLabel), /* @__PURE__ */ React__default.createElement("div", { className: "div-wrapper" }, /* @__PURE__ */ React__default.createElement(
    "div",
    {
      className: cardItemNumberItem
    },
    new Intl.DateTimeFormat("en-US", { month: "2-digit" }).format(expirationDate),
    "/",
    new Intl.DateTimeFormat("en-US", { year: "2-digit" }).format(expirationDate)
  ))), /* @__PURE__ */ React__default.createElement("div", { className: informationCardCVV }, /* @__PURE__ */ React__default.createElement("div", null, CvvLabel), /* @__PURE__ */ React__default.createElement("div", { className: "div-wrapper" }, /* @__PURE__ */ React__default.createElement("div", { className: cardItemNumberItem }, cvv)))))));
};
var Loader0 = "_19uimxt3";
var Loader1 = "_19uimxt4";
var Loader2 = "_19uimxt5";
const LoaderType = {
  "Loader0": Loader0,
  "Loader1": Loader1,
  "Loader2": Loader2
};
const Loader = (props) => {
  return /* @__PURE__ */ React__default.createElement("div", { "aria-busy": true, className: LoaderType[props.type] });
};
var DocumentPreviewWrapper = "_2zjut00";
var DocumentPreviewWrapperSmall = "_2zjut01";
var DocumentPreviewWrapperMedium = "_2zjut02";
var DocumentPreviewWrapperLarge = "_2zjut03";
var DocumentPreviewImgWrapper = "_2zjut04";
var DocumentPreviewImg = "_2zjut05";
var DocumentPreviewLoader = "_2zjut06";
var DocumentPreviewDescriptionWrapper = "_2zjut07";
var DocumentPreviewDescriptionHeader = "_2zjut08";
var DocumentPreviewDescriptionHeaderItemName = "_2zjut09";
var DocumentPreviewDescriptionHeaderItemDescription = "_2zjut0a";
var DocumentPreviewDescriptionHeaderItemDate = "_2zjut0b";
var DocumentPreviewOptionBtn = "_2zjut0c";
var DocumentPreviewOptionWrapper = "_2zjut0d";
const DocumentSize = {
  "xs": DocumentPreviewWrapperSmall,
  "md": DocumentPreviewWrapperMedium,
  "lg": DocumentPreviewWrapperLarge
};
const DocumentPreview = (props) => {
  const [isLoading, setIsLoading] = useState(true);
  const { size: size2 = "lg" } = props;
  return /* @__PURE__ */ React__default.createElement("div", { className: classNames$1(DocumentPreviewWrapper, DocumentSize[size2]) }, /* @__PURE__ */ React__default.createElement("div", { className: DocumentPreviewImgWrapper }, isLoading && /* @__PURE__ */ React__default.createElement("div", { className: DocumentPreviewLoader }, /* @__PURE__ */ React__default.createElement(Loader, { type: "Loader1" })), /* @__PURE__ */ React__default.createElement("img", { alt: "document preview", style: !isLoading ? {} : { display: "none" }, className: DocumentPreviewImg, src: props.previewImgUrl, onLoad: () => setIsLoading(false) })), /* @__PURE__ */ React__default.createElement("div", { className: DocumentPreviewDescriptionWrapper }, /* @__PURE__ */ React__default.createElement("div", { className: DocumentPreviewDescriptionHeader }, /* @__PURE__ */ React__default.createElement("p", { className: DocumentPreviewDescriptionHeaderItemName }, props.name), /* @__PURE__ */ React__default.createElement("p", { className: DocumentPreviewDescriptionHeaderItemDescription }, props.description), /* @__PURE__ */ React__default.createElement("p", { className: DocumentPreviewDescriptionHeaderItemDate }, props.date.toLocaleDateString())), /* @__PURE__ */ React__default.createElement("div", { className: DocumentPreviewOptionWrapper }, /* @__PURE__ */ React__default.createElement(TooltipUI, null, /* @__PURE__ */ React__default.createElement(
    "span",
    {
      "aria-label": "preview",
      onClick: () => {
        var _a2;
        return (_a2 = props.preview) == null ? void 0 : _a2.call(props);
      },
      className: DocumentPreviewOptionBtn
    },
    /* @__PURE__ */ React__default.createElement(Icon$2, { icon: "Voir", size: 16 })
  )), /* @__PURE__ */ React__default.createElement(TooltipUI, null, /* @__PURE__ */ React__default.createElement(
    "span",
    {
      "aria-label": "download",
      onClick: () => {
        var _a2;
        return (_a2 = props.download) == null ? void 0 : _a2.call(props);
      },
      className: DocumentPreviewOptionBtn
    },
    /* @__PURE__ */ React__default.createElement(Icon$2, { icon: "Telechargement", size: 16 })
  )))));
};
var build = {};
var browser_min = { exports: {} };
(function(module, exports) {
  !function(t2, e2) {
    module.exports = e2(ReactDOM__default, React__default);
  }(commonjsGlobal, function(t2, e2) {
    function r2(t3) {
      return t3 && "object" == typeof t3 && "default" in t3 ? t3 : { default: t3 };
    }
    var n2 = r2(e2);
    function o2(t3, e3) {
      var r3 = Object.keys(t3);
      if (Object.getOwnPropertySymbols) {
        var n3 = Object.getOwnPropertySymbols(t3);
        e3 && (n3 = n3.filter(function(e4) {
          return Object.getOwnPropertyDescriptor(t3, e4).enumerable;
        })), r3.push.apply(r3, n3);
      }
      return r3;
    }
    function i(t3) {
      for (var e3 = 1; e3 < arguments.length; e3++) {
        var r3 = null != arguments[e3] ? arguments[e3] : {};
        e3 % 2 ? o2(Object(r3), true).forEach(function(e4) {
          a2(t3, e4, r3[e4]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t3, Object.getOwnPropertyDescriptors(r3)) : o2(Object(r3)).forEach(function(e4) {
          Object.defineProperty(t3, e4, Object.getOwnPropertyDescriptor(r3, e4));
        });
      }
      return t3;
    }
    function a2(t3, e3, r3) {
      return e3 in t3 ? Object.defineProperty(t3, e3, { value: r3, enumerable: true, configurable: true, writable: true }) : t3[e3] = r3, t3;
    }
    function l2(t3, e3) {
      return function(t4) {
        if (Array.isArray(t4)) return t4;
      }(t3) || function(t4, e4) {
        var r3 = null == t4 ? null : "undefined" != typeof Symbol && t4[Symbol.iterator] || t4["@@iterator"];
        if (null == r3) return;
        var n3, o3, i2 = [], a3 = true, l3 = false;
        try {
          for (r3 = r3.call(t4); !(a3 = (n3 = r3.next()).done) && (i2.push(n3.value), !e4 || i2.length !== e4); a3 = true) ;
        } catch (t5) {
          l3 = true, o3 = t5;
        } finally {
          try {
            a3 || null == r3.return || r3.return();
          } finally {
            if (l3) throw o3;
          }
        }
        return i2;
      }(t3, e3) || function(t4, e4) {
        if (!t4) return;
        if ("string" == typeof t4) return c4(t4, e4);
        var r3 = Object.prototype.toString.call(t4).slice(8, -1);
        "Object" === r3 && t4.constructor && (r3 = t4.constructor.name);
        if ("Map" === r3 || "Set" === r3) return Array.from(t4);
        if ("Arguments" === r3 || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r3)) return c4(t4, e4);
      }(t3, e3) || function() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }
    function c4(t3, e3) {
      (null == e3 || e3 > t3.length) && (e3 = t3.length);
      for (var r3 = 0, n3 = new Array(e3); r3 < e3; r3++) n3[r3] = t3[r3];
      return n3;
    }
    function u2(r3, o3) {
      var a3 = r3.element, l3 = r3.popper, c5 = r3.position, u3 = void 0 === c5 ? "bottom-center" : c5, s3 = r3.containerStyle, d3 = r3.containerClassName, p3 = void 0 === d3 ? "" : d3, h3 = r3.arrow, m3 = r3.arrowStyle, v2 = void 0 === m3 ? {} : m3, b2 = r3.arrowClassName, y2 = void 0 === b2 ? "" : b2, g2 = r3.fixMainPosition, w2 = r3.fixRelativePosition, O2 = r3.offsetY, E2 = r3.offsetX, P2 = r3.animations, x2 = r3.zIndex, j = void 0 === x2 ? 0 : x2, M2 = r3.popperShadow, T2 = r3.onChange, S2 = r3.active, C2 = void 0 === S2 || S2, N2 = r3.portal, L2 = r3.portalTarget, R2 = "undefined" != typeof window, A2 = R2 && L2 instanceof HTMLElement, z2 = true === h3, I2 = l3 && true === C2, X = e2.useRef(), D2 = e2.useRef(), H2 = e2.useRef(), Y2 = e2.useRef(), k2 = e2.useMemo(function() {
        return { position: u3, fixMainPosition: g2, fixRelativePosition: w2, offsetY: O2, offsetX: E2, defaultArrow: z2, animations: P2, zIndex: j, onChange: T2 };
      }, [u3, g2, w2, O2, E2, z2, P2, T2, j]), V2 = e2.useCallback(function() {
        H2.current && (H2.current.style.transition = ""), D2.current && (D2.current.parentNode.style.transition = "");
      }, []), W2 = { element: i({ display: "inline-block", height: "max-content" }, s3), arrow: i({ visibility: "hidden", left: "0", top: "0", position: "absolute" }, v2), popper: { position: "absolute", left: "0", top: "0", willChange: "transform", visibility: "hidden", zIndex: j } };
      R2 && !Y2.current && (Y2.current = document.createElement("div"), Y2.current.data = { portal: N2, isValidPortalTarget: A2 }), e2.useEffect(function() {
        if (N2 && !A2) {
          var t3 = Y2.current;
          return document.body.appendChild(t3), function() {
            return document.body.removeChild(t3);
          };
        }
      }, [N2, A2]), e2.useEffect(function() {
        if (!I2) return V2(), D2.current.parentNode.style.visibility = "hidden", void (H2.current && (H2.current.style.visibility = "hidden"));
        function t3(t4) {
          t4 && "resize" !== t4.type && !t4.target.contains(X.current) || (t4 && V2(), f2(X, D2, H2, k2, t4));
        }
        return t3(), document.addEventListener("scroll", t3, true), window.addEventListener("resize", t3), function() {
          document.removeEventListener("scroll", t3, true), window.removeEventListener("resize", t3);
        };
      }, [I2, k2, V2]), e2.useEffect(function() {
        var t3 = { portal: N2, isValidPortalTarget: A2 }, e3 = Y2.current.data;
        JSON.stringify(t3) !== JSON.stringify(e3) && (Y2.current.data = t3, X.current.refreshPosition());
      }, [N2, A2]);
      var q = n2.default.createElement(n2.default.Fragment, null, function() {
        if (!h3 || !I2) return null;
        var t3 = n2.default.createElement("div", { ref: H2, style: W2.arrow }), r4 = e2.isValidElement(h3) ? { children: h3 } : { className: "ep-arrow ".concat(M2 ? "ep-shadow" : "", " ").concat(y2) };
        return e2.cloneElement(t3, r4);
      }(), n2.default.createElement("div", { className: M2 ? "ep-popper-shadow" : "", style: W2.popper }, n2.default.createElement("div", { ref: D2 }, l3)));
      return n2.default.createElement("div", { ref: function(t3) {
        t3 && (t3.removeTransition = V2, t3.refreshPosition = function() {
          return setTimeout(function() {
            return f2(X, D2, H2, k2, {});
          }, 10);
        });
        if (X.current = t3, o3 instanceof Function) return o3(t3);
        o3 && (o3.current = t3);
      }, className: p3, style: W2.element }, a3, N2 && R2 ? t2.createPortal(q, A2 ? L2 : Y2.current) : q);
    }
    function f2(t3, e3, r3, n3, o3) {
      var a3 = n3.position, c5 = n3.fixMainPosition, u3 = n3.fixRelativePosition, f3 = n3.offsetY, h3 = void 0 === f3 ? 0 : f3, m3 = n3.offsetX, v2 = void 0 === m3 ? 0 : m3, b2 = n3.defaultArrow, y2 = n3.animations, g2 = void 0 === y2 ? [] : y2, w2 = n3.zIndex, O2 = n3.onChange;
      if (t3.current && e3.current) {
        var E2, P2, x2, j, M2 = (P2 = void 0 !== window.pageXOffset, x2 = "CSS1Compat" === (document.compatMode || ""), { scrollLeft: P2 ? window.pageXOffset : x2 ? document.documentElement.scrollLeft : document.body.scrollLeft, scrollTop: P2 ? window.pageYOffset : x2 ? document.documentElement.scrollTop : document.body.scrollTop }), T2 = M2.scrollLeft, S2 = M2.scrollTop, C2 = s2(t3.current, T2, S2), N2 = C2.top, L2 = C2.left, R2 = C2.height, A2 = C2.width, z2 = C2.right, I2 = C2.bottom, X = s2(e3.current, T2, S2), D2 = X.top, H2 = X.left, Y2 = X.height, k2 = X.width, V2 = document.documentElement, W2 = V2.clientHeight, q = V2.clientWidth, F2 = e3.current.parentNode, J2 = function(t4) {
          if (!t4) return [0, 0];
          var e4 = l2((t4.style.transform.match(/translate\((.*?)px,\s(.*?)px\)/) || []).map(function(t5) {
            return Number(t5);
          }), 3), r4 = e4[1], n4 = void 0 === r4 ? 0 : r4, o4 = e4[2];
          return [n4, void 0 === o4 ? 0 : o4];
        }(F2), B2 = l2(J2, 2), U2 = B2[0], $2 = B2[1], G = function(t4) {
          var e4 = l2(t4.split("-"), 2), r4 = e4[0], n4 = void 0 === r4 ? "bottom" : r4, o4 = e4[1], i2 = void 0 === o4 ? "center" : o4;
          "auto" === n4 && (n4 = "bottom");
          "auto" === i2 && (i2 = "center");
          var a4 = "top" === n4 || "bottom" === n4, c6 = "left" === n4 || "right" === n4;
          c6 && ("start" === i2 && (i2 = "top"), "end" === i2 && (i2 = "bottom"));
          a4 && ("start" === i2 && (i2 = "left"), "end" === i2 && (i2 = "right"));
          return [n4, i2, a4, c6];
        }(a3), K = l2(G, 4), Q = K[0], Z = K[1], _2 = K[2], tt = K[3], et = Q, rt = function(t4, e4) {
          return "translate(".concat(t4, "px, ").concat(e4, "px)");
        }, nt = A2 - k2, ot = R2 - Y2, it = "left" === Z ? 0 : "right" === Z ? nt : nt / 2, at = nt - it, lt = "top" === Z ? 0 : "bottom" === Z ? ot : ot / 2, ct = ot - lt, ut = L2 - H2 + U2, ft = N2 - D2 + $2, st = 0, dt = 0, pt = d2(t3.current), ht = [], mt = r3.current, vt = s2(mt, T2, S2) || {}, bt = vt.height, yt = void 0 === bt ? 0 : bt, gt = vt.width, wt = void 0 === gt ? 0 : gt, Ot = ut, Et3 = ft, Pt = { top: "bottom", bottom: "top", left: "right", right: "left" };
        for (_2 && (ut += it, ft += "top" === Q ? -Y2 : R2, b2 && (yt = 11, wt = 20)), tt && (ut += "left" === Q ? -k2 : A2, ft += lt, b2 && (yt = 20, wt = 11)); pt; ) ht.push(pt), jt(s2(pt, T2, S2)), pt = d2(pt.parentNode);
        if (jt({ top: S2, bottom: S2 + W2, left: T2, right: T2 + q, height: W2, width: q }), _2 && (ft += "bottom" === et ? h3 : -h3), tt && (ut += "right" === et ? v2 : -v2), ut -= st, ft -= dt, E2 = Pt[et], mt) _2 && ((j = A2 < k2) ? Ot += A2 / 2 : Ot = ut + k2 / 2, Ot -= wt / 2, "bottom" === et && (Et3 = ft, ft += yt), "top" === et && (Et3 = (ft -= yt) + Y2), st < 0 && st - it < 0 && (j ? Ot += (it - st) / 2 : A2 - it + st < k2 && (Ot += (A2 - it + st - k2) / 2)), st > 0 && st + at > 0 && (j ? Ot -= (st + at) / 2 : A2 - st - at < k2 && (Ot -= (A2 - st - at - k2) / 2))), tt && ((j = R2 < Y2) ? Et3 += R2 / 2 : Et3 = ft + Y2 / 2, Et3 -= yt / 2, "left" === et && (Ot = (ut -= wt) + k2), "right" === et && (Ot = ut, ut += wt), dt < 0 && dt - lt < 0 && (j ? Et3 += (lt - dt) / 2 : R2 - lt + dt < Y2 && (Et3 += (R2 - lt + dt - Y2) / 2)), dt > 0 && dt + ct > 0 && (j ? Et3 -= (dt + ct) / 2 : R2 - dt - ct < Y2 && (Et3 -= (R2 - dt - ct - Y2) / 2))), mt.setAttribute("direction", E2), mt.style.height = yt + "px", mt.style.width = wt + "px", mt.style.transform = rt(Ot, Et3), mt.style.visibility = "visible", mt.style.zIndex = w2 + 1;
        F2.style.transform = rt(ut, ft);
        var xt = { popper: { top: ft, bottom: ft + Y2, left: ut, right: ut + k2, height: Y2, width: k2 }, element: { top: N2, bottom: I2, left: L2, right: z2, height: R2, width: A2 }, arrow: { top: Et3, bottom: Et3 + yt, left: Ot, right: Ot + wt, height: yt, width: wt, direction: E2 }, position: et + "-" + (0 !== st ? "auto" : Z), scroll: { scrollLeft: T2, scrollTop: S2 }, scrollableParents: ht, event: o3 };
        o3 || g2.forEach(function(t4) {
          t4({ popper: F2, arrow: mt, data: i(i({}, xt), {}, { getTransform: rt, mirror: Pt }) });
        }), F2.style.visibility = "visible", "function" == typeof O2 && O2(xt);
      }
      function jt(t4) {
        var e4 = t4.top, r4 = t4.bottom, n4 = t4.left, o4 = t4.right, i2 = t4.height, a4 = t4.width;
        if (_2) {
          var l3 = Math.round(N2 - e4 + R2 / 2), f4 = Math.round(i2 / 2);
          c5 || (N2 - (Y2 + h3 + yt) < e4 && l3 <= f4 && "top" === et ? (ft += Y2 + R2, et = "bottom") : I2 + Y2 + h3 + yt > i2 + e4 && l3 >= f4 && "bottom" === et && (ft -= Y2 + R2, et = "top")), u3 || (L2 + it < n4 && (st = p2(z2 - wt > n4 ? L2 + it - n4 : -A2 + it + wt, st)), z2 - at > o4 && (st = p2(L2 + wt < o4 ? z2 - at - o4 : A2 - at - wt, st)));
        }
        if (tt) {
          var s3 = Math.round(L2 - n4 + A2 / 2), d3 = Math.round(a4 / 2);
          c5 || (L2 - (k2 + v2 + wt) < n4 && s3 < d3 && "left" === et ? (ut += A2 + k2, et = "right") : z2 + k2 + v2 + wt > o4 && s3 > d3 && "right" === et && (ut -= A2 + k2, et = "left")), u3 || (N2 + lt < e4 && (dt = p2(I2 - yt > e4 ? N2 + lt - e4 : -R2 + lt + yt, dt)), I2 - ct > r4 && (dt = p2(N2 + yt < r4 ? I2 - ct - r4 : R2 - ct - yt, dt)));
        }
      }
    }
    function s2(t3, e3, r3) {
      if (t3) {
        var n3 = t3.getBoundingClientRect(), o3 = n3.top, i2 = n3.left, a3 = n3.width, l3 = n3.height, c5 = o3 + r3, u3 = i2 + e3;
        return { top: c5, bottom: c5 + l3, left: u3, right: u3 + a3, width: a3, height: l3 };
      }
    }
    function d2(t3) {
      if (t3 && "HTML" !== t3.tagName) {
        var e3 = window.getComputedStyle(t3), r3 = function(t4) {
          return ["auto", "scroll"].includes(t4);
        };
        return t3.clientHeight < t3.scrollHeight && r3(e3.overflowX) || t3.clientWidth < t3.scrollWidth && r3(e3.overflowY) ? t3 : d2(t3.parentNode);
      }
    }
    function p2(t3, e3) {
      return Math.round(Math.abs(t3)) > Math.round(Math.abs(e3)) ? t3 : e3;
    }
    return e2.forwardRef(u2);
  });
})(browser_min);
var browser_minExports = browser_min.exports;
function t(e2) {
  return t = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t2) {
    return typeof t2;
  } : function(t2) {
    return t2 && "function" == typeof Symbol && t2.constructor === Symbol && t2 !== Symbol.prototype ? "symbol" : typeof t2;
  }, t(e2);
}
function e(t2) {
  return function(t3) {
    if (Array.isArray(t3)) return c$1(t3);
  }(t2) || n$3(t2) || h(t2) || function() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function n$3(t2) {
  if ("undefined" != typeof Symbol && null != t2[Symbol.iterator] || null != t2["@@iterator"]) return Array.from(t2);
}
function r(t2, e2) {
  var n2 = "undefined" != typeof Symbol && t2[Symbol.iterator] || t2["@@iterator"];
  if (!n2) {
    if (Array.isArray(t2) || (n2 = h(t2)) || e2 && t2 && "number" == typeof t2.length) {
      n2 && (t2 = n2);
      var r2 = 0, i = function() {
      };
      return { s: i, n: function() {
        return r2 >= t2.length ? { done: true } : { done: false, value: t2[r2++] };
      }, e: function(t3) {
        throw t3;
      }, f: i };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var a2, s2 = true, u2 = false;
  return { s: function() {
    n2 = n2.call(t2);
  }, n: function() {
    var t3 = n2.next();
    return s2 = t3.done, t3;
  }, e: function(t3) {
    u2 = true, a2 = t3;
  }, f: function() {
    try {
      s2 || null == n2.return || n2.return();
    } finally {
      if (u2) throw a2;
    }
  } };
}
function i$1(t2, e2) {
  var n2 = Object.keys(t2);
  if (Object.getOwnPropertySymbols) {
    var r2 = Object.getOwnPropertySymbols(t2);
    e2 && (r2 = r2.filter(function(e3) {
      return Object.getOwnPropertyDescriptor(t2, e3).enumerable;
    })), n2.push.apply(n2, r2);
  }
  return n2;
}
function a$1(t2) {
  for (var e2 = 1; e2 < arguments.length; e2++) {
    var n2 = null != arguments[e2] ? arguments[e2] : {};
    e2 % 2 ? i$1(Object(n2), true).forEach(function(e3) {
      s$1(t2, e3, n2[e3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t2, Object.getOwnPropertyDescriptors(n2)) : i$1(Object(n2)).forEach(function(e3) {
      Object.defineProperty(t2, e3, Object.getOwnPropertyDescriptor(n2, e3));
    });
  }
  return t2;
}
function s$1(t2, e2, n2) {
  return (e2 = y(e2)) in t2 ? Object.defineProperty(t2, e2, { value: n2, enumerable: true, configurable: true, writable: true }) : t2[e2] = n2, t2;
}
function u(t2, e2) {
  return l$1(t2) || function(t3, e3) {
    var n2 = null == t3 ? null : "undefined" != typeof Symbol && t3[Symbol.iterator] || t3["@@iterator"];
    if (null != n2) {
      var r2, i, a2, s2, u2 = [], o2 = true, h3 = false;
      try {
        if (a2 = (n2 = n2.call(t3)).next, 0 === e3) {
          if (Object(n2) !== n2) return;
          o2 = false;
        } else for (; !(o2 = (r2 = a2.call(n2)).done) && (u2.push(r2.value), u2.length !== e3); o2 = true) ;
      } catch (t4) {
        h3 = true, i = t4;
      } finally {
        try {
          if (!o2 && null != n2.return && (s2 = n2.return(), Object(s2) !== s2)) return;
        } finally {
          if (h3) throw i;
        }
      }
      return u2;
    }
  }(t2, e2) || h(t2, e2) || o();
}
function o() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function h(t2, e2) {
  if (t2) {
    if ("string" == typeof t2) return c$1(t2, e2);
    var n2 = Object.prototype.toString.call(t2).slice(8, -1);
    return "Object" === n2 && t2.constructor && (n2 = t2.constructor.name), "Map" === n2 || "Set" === n2 ? Array.from(t2) : "Arguments" === n2 || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2) ? c$1(t2, e2) : void 0;
  }
}
function c$1(t2, e2) {
  (null == e2 || e2 > t2.length) && (e2 = t2.length);
  for (var n2 = 0, r2 = new Array(e2); n2 < e2; n2++) r2[n2] = t2[n2];
  return r2;
}
function l$1(t2) {
  if (Array.isArray(t2)) return t2;
}
function f(t2, e2) {
  for (var n2 = 0; n2 < e2.length; n2++) {
    var r2 = e2[n2];
    r2.enumerable = r2.enumerable || false, r2.configurable = true, "value" in r2 && (r2.writable = true), Object.defineProperty(t2, y(r2.key), r2);
  }
}
function y(e2) {
  var n2 = function(e3, n3) {
    if ("object" !== t(e3) || null === e3) return e3;
    var r2 = e3[Symbol.toPrimitive];
    if (void 0 !== r2) {
      var i = r2.call(e3, n3 || "default");
      if ("object" !== t(i)) return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === n3 ? String : Number)(e3);
  }(e2, "string");
  return "symbol" === t(n2) ? n2 : String(n2);
}
function d$1(t2, e2, n2) {
  !function(t3, e3) {
    if (e3.has(t3)) throw new TypeError("Cannot initialize the same private elements twice on an object");
  }(t2, e2), e2.set(t2, n2);
}
function m$1(t2, e2) {
  return function(t3, e3) {
    if (e3.get) return e3.get.call(t3);
    return e3.value;
  }(t2, g$1(t2, e2, "get"));
}
function v(t2, e2, n2) {
  return function(t3, e3, n3) {
    if (e3.set) e3.set.call(t3, n3);
    else {
      if (!e3.writable) throw new TypeError("attempted to set read only private field");
      e3.value = n3;
    }
  }(t2, g$1(t2, e2, "set"), n2), n2;
}
function g$1(t2, e2, n2) {
  if (!e2.has(t2)) throw new TypeError("attempted to " + n2 + " private field on non-instance");
  return e2.get(t2);
}
function p$1(t2) {
  return t2 && t2.__esModule && Object.prototype.hasOwnProperty.call(t2, "default") ? t2.default : t2;
}
function k(t2) {
  return t2 && t2.__esModule && Object.prototype.hasOwnProperty.call(t2, "default") ? t2.default : t2;
}
var b$2 = { name: "gregorian_en", months: [["January", "Jan"], ["February", "Feb"], ["March", "Mar"], ["April", "Apr"], ["May", "May"], ["June", "Jun"], ["July", "Jul"], ["August", "Aug"], ["September", "Sep"], ["October", "Oct"], ["November", "Nov"], ["December", "Dec"]], weekDays: [["Saturday", "Sat"], ["Sunday", "Sun"], ["Monday", "Mon"], ["Tuesday", "Tue"], ["Wednesday", "Wed"], ["Thursday", "Thu"], ["Friday", "Fri"]], digits: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"], meridiems: [["AM", "am"], ["PM", "pm"]] }, w$1 = { name: "gregorian", startYear: 1, yearLength: 365, epoch: 1721424, century: 20, weekStartDayIndex: 1, getMonthLengths: function(t2) {
  return [31, t2 ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
}, isLeap: function(t2) {
  return t2 % 4 == 0 && t2 % 100 != 0 || t2 % 400 == 0;
}, getLeaps: function(t2) {
  if (0 !== t2) {
    for (var e2 = t2 > 0 ? 1 : -1, n2 = []; t2 > 0 ? e2 <= t2 : t2 <= e2; ) this.isLeap(e2) && n2.push(e2), t2 > 0 ? e2++ : e2--;
    return n2;
  }
}, getDayOfYear: function(t2) {
  for (var e2 = t2.year, n2 = t2.month, r2 = t2.day, i = this.getMonthLengths(this.isLeap(e2)), a2 = 0; a2 < n2.index; a2++) r2 += i[a2];
  return r2;
}, getAllDays: function(t2) {
  var e2 = t2.year;
  return this.yearLength * (e2 - 1) + this.leapsLength(e2) + this.getDayOfYear(t2);
}, leapsLength: function(t2) {
  return ((t2 - 1) / 4 | 0) + (-(t2 - 1) / 100 | 0) + ((t2 - 1) / 400 | 0);
}, guessYear: function(t2, e2) {
  return ~~(t2 / 365.24) + (e2 > 0 ? 1 : -1);
} };
function D(t2) {
  return t2 && t2.constructor === Object;
}
function M(t2) {
  if (!isNaN(t2)) return parseInt(t2);
}
function O(t2) {
  return Array.isArray(t2);
}
function S(t2, e2, n2) {
  return void 0 === t2 || t2 < e2 || t2 > n2;
}
var Y = /* @__PURE__ */ new WeakMap(), L = /* @__PURE__ */ new WeakMap(), W = /* @__PURE__ */ new WeakMap(), j$1 = /* @__PURE__ */ new WeakMap(), x = /* @__PURE__ */ new WeakMap(), N = /* @__PURE__ */ new WeakMap(), A$1 = /* @__PURE__ */ new WeakMap(), I = /* @__PURE__ */ new WeakMap(), P = /* @__PURE__ */ new WeakMap(), T = /* @__PURE__ */ new WeakMap(), F = /* @__PURE__ */ new WeakMap(), E = /* @__PURE__ */ new WeakMap(), H = /* @__PURE__ */ new WeakMap(), V = /* @__PURE__ */ new WeakMap(), J = /* @__PURE__ */ new WeakMap(), _ = /* @__PURE__ */ new WeakMap(), C$1 = /* @__PURE__ */ new WeakMap(), U = /* @__PURE__ */ new WeakMap(), R = /* @__PURE__ */ new WeakMap(), z = function() {
  function i(t2) {
    var e2 = this;
    !function(t3, e3) {
      if (!(t3 instanceof e3)) throw new TypeError("Cannot call a class as a function");
    }(this, i), d$1(this, Y, { writable: true, value: void 0 }), d$1(this, L, { writable: true, value: void 0 }), d$1(this, W, { writable: true, value: void 0 }), d$1(this, j$1, { writable: true, value: void 0 }), d$1(this, x, { writable: true, value: void 0 }), d$1(this, N, { writable: true, value: void 0 }), d$1(this, A$1, { writable: true, value: void 0 }), d$1(this, I, { writable: true, value: void 0 }), d$1(this, P, { writable: true, value: b$2 }), d$1(this, T, { writable: true, value: w$1 }), d$1(this, F, { writable: true, value: false }), d$1(this, E, { writable: true, value: {} }), d$1(this, H, { writable: true, value: /^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d\.\d\d\dZ$/ }), d$1(this, V, { writable: true, value: [] }), d$1(this, J, { writable: true, value: true }), d$1(this, _, { writable: true, value: function(t3, n3) {
      switch (t3) {
        case "YYYY":
          return ["year", n3];
        case "YY":
          return ["year", "".concat(m$1(e2, T).century).concat(n3)];
        case "MMMM":
        case "MMM":
          return ["month", e2.months.findIndex(function(t4) {
            var e3 = t4.name, r4 = t4.shortName;
            return new RegExp(n3, "i").test(e3 + r4);
          }) + 1];
        case "MM":
        case "M":
          return ["month", n3];
        case "DD":
        case "D":
          return ["day", n3];
        case "HH":
        case "H":
          return ["hour", n3];
        case "hh":
        case "h":
          var r3 = M(n3);
          return ["hour", r3 > 12 ? r3 - 12 : r3];
        case "mm":
        case "m":
          return ["minute", n3];
        case "ss":
        case "s":
          return ["second", n3];
        case "SSS":
        case "SS":
        case "S":
          return ["millisecond", n3];
        default:
          return [];
      }
    } }), d$1(this, C$1, { writable: true, value: function() {
      return 0 === m$1(e2, Y) && 0 !== m$1(e2, T).startYear;
    } }), d$1(this, U, { writable: true, value: function() {
      if (m$1(e2, J) && e2.isValid) {
        var t3 = Math.floor, n3 = function(e3, n4) {
          return [(a3 = e3, (a3 < 0 ? -1 : 1) * Math.abs(t3(e3 / n4))), (r4 = e3, i3 = n4, (r4 < 0 && -0 !== t3(r4 % i3) ? i3 : 0) + t3(e3 % n4))];
          var r4, i3, a3;
        }, r3 = function() {
          if (m$1(e2, L) < 0 || m$1(e2, L) > 11) {
            var t4 = m$1(e2, L) < 0 ? -1 : 1, r4 = u(n3(m$1(e2, L), 12), 2), i3 = r4[0], a3 = r4[1];
            v(e2, Y, m$1(e2, Y) + i3), v(e2, L, a3), m$1(e2, C$1).call(e2) && v(e2, Y, t4);
          }
        };
        for (v(e2, J, false), [["millisecond", "second", 1e3], ["second", "minute", 60], ["minute", "hour", 60], ["hour", "day", 24]].forEach(function(t4) {
          var r4 = u(t4, 3), i3 = r4[0], a3 = r4[1], s5 = r4[2];
          if (function(t5, e3) {
            return t5 >= e3 || t5 < 0;
          }(e2[i3], s5)) {
            var o3 = u(n3(e2[i3], s5), 2), h3 = o3[0], c5 = o3[1];
            e2[a3] += h3, e2[i3] = c5;
          }
        }), v(e2, J, true), r3(); m$1(e2, W) < -m$1(e2, T).yearLength || m$1(e2, W) > m$1(e2, T).yearLength; ) {
          if (m$1(e2, L) > 0) {
            for (var i2 = m$1(e2, T).getMonthLengths(e2.isLeap), a2 = 0; a2 < m$1(e2, L); a2++) v(e2, W, m$1(e2, W) + i2[a2]);
            v(e2, L, 0);
          }
          var s4 = e2.isLeap ? e2.calendar.yearLength + 1 : e2.calendar.yearLength;
          v(e2, W, m$1(e2, W) + s4 * (m$1(e2, W) < 0 ? 1 : -1)), v(e2, Y, m$1(e2, Y) + (m$1(e2, W) < 0 ? -1 : 1));
        }
        for (; ; ) {
          var o2;
          for (r3(); m$1(e2, W) < 1; ) v(e2, L, m$1(e2, L) - 1), r3(), v(e2, W, e2.month.length + m$1(e2, W));
          if (m$1(e2, W) <= e2.month.length || isNaN(m$1(e2, W))) break;
          v(e2, W, m$1(e2, W) - e2.month.length), v(e2, L, (o2 = m$1(e2, L), o2++, o2));
        }
        m$1(e2, j$1) || v(e2, j$1, 0), m$1(e2, x) || v(e2, x, 0), m$1(e2, N) || v(e2, N, 0), m$1(e2, A$1) || v(e2, A$1, 0);
      }
    } }), d$1(this, R, { writable: true, value: function() {
      return (m$1(e2, E).weekDays || m$1(e2, P).weekDays).map(function(t3, n3) {
        var r3 = u(t3, 2), i2 = r3[0], a2 = r3[1], s4 = n3 - e2.weekStartDayIndex;
        return s4 < 0 && (s4 += 7), { name: i2, shortName: a2, index: s4, number: s4 + 1, toString: function() {
          return this.number.toString();
        }, valueOf: function() {
          return this.number;
        } };
      });
    } });
    var n2 = D(t2) ? a$1({}, t2) : t2, r2 = true;
    if (n2 && "boolean" != typeof n2 || (n2 = { date: /* @__PURE__ */ new Date() }), D(n2) || (n2 = { date: n2 }), 0 !== Object.keys(n2).length) {
      for (var s3 in D(n2.calendar) && v(this, T, n2.calendar), D(n2.locale) && v(this, P, n2.locale), isNaN(n2.year) && isNaN(n2.month) && isNaN(n2.day) && !n2.date && (n2.date = /* @__PURE__ */ new Date()), n2.date && ("string" == typeof n2.date && n2.format && v(this, I, n2.format), this.setDate(n2.date), n2.calendar && this.convert(n2.calendar), r2 = false), delete n2.calendar, delete n2.locale, delete n2.date, n2) this.set(s3, n2[s3]);
      m$1(this, C$1).call(this) && v(this, Y, -1), r2 && m$1(this, U).call(this);
    }
  }
  var s2, c4;
  return s2 = i, c4 = [{ key: "parse", value: function(t2) {
    if (!t2) return this;
    var i2, a2, s3 = m$1(this, I), c5 = m$1(this, P).digits, f2 = r(c5);
    try {
      for (f2.s(); !(i2 = f2.n()).done; ) {
        var y2 = i2.value;
        t2 = t2.replace(new RegExp(y2, "g"), c5.indexOf(y2));
      }
    } catch (t3) {
      f2.e(t3);
    } finally {
      f2.f();
    }
    if (s3) for (var d2 = s3.split(/[^\w\u0600-\u06FF]/), g2 = t2.split(/[^\w\u0600-\u06FF]/), p2 = 0; p2 < d2.length; p2++) this.set.apply(this, e(m$1(this, _).call(this, d2[p2], g2[p2])));
    else {
      var k2 = t2.match(/(-?\d{2,4})?\W?([A-z]{3,9}|\d{1,2})?\W?(\d{1,2})?\W?(\d{1,2})?\W?(\d{1,2})?\W?(\d{1,2})?\W?(\d{1,3})?\W?(am|pm)?/), b2 = (l$1(a2 = k2) || n$3(a2) || h(a2) || o()).slice(1), w2 = b2[1];
      w2 && (w2 = /\d+/.test(w2) ? M(w2) - 1 : this.months.findIndex(function(t3) {
        return new RegExp(w2, "i").test(t3.name);
      })), b2[1] = w2;
      var D2 = u(b2.map(M), 7), O2 = D2[0], S2 = D2[1], T2 = D2[2], F2 = D2[3], E2 = D2[4], H2 = D2[5], V2 = D2[6];
      v(this, Y, O2), v(this, L, S2), v(this, W, T2), v(this, j$1, F2), v(this, x, E2), v(this, N, H2), v(this, A$1, V2);
    }
    var J2 = u(m$1(this, P).meridiems[1], 2), C2 = J2[0], R2 = J2[1];
    return m$1(this, j$1) < 12 && (t2.includes(C2) || t2.includes(R2)) && v(this, j$1, m$1(this, j$1) + 12), m$1(this, U).call(this), this;
  } }, { key: "convert", value: function() {
    var t2 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : w$1, e2 = arguments.length > 1 ? arguments[1] : void 0;
    if (D(e2) && v(this, P, e2), !D(t2) || t2.name === m$1(this, T).name) return this;
    var n2 = this.toJulianDay() - t2.epoch, r2 = new i({ calendar: t2, year: t2.guessYear(n2, m$1(this, Y)), month: 1, day: 1 });
    return r2.day += n2 - r2.toDays(), v(this, Y, r2.year), v(this, L, r2.month.index), v(this, W, r2.day), v(this, T, t2), this;
  } }, { key: "format", value: function(e2, n2) {
    if (!this.isValid || e2 && "string" != typeof e2) return "";
    e2 || (e2 = m$1(this, I) || "YYYY/MM/DD"), O(n2) || (n2 = []), n2 = (n2 = n2.concat(m$1(this, V))).filter(function(e3) {
      return "string" == typeof e3 || (console.warn("type of all items in the ignore list must be string, found", t(e3)), false);
    }).map(function(t2) {
      return t2.replace(/[*/+\-()[\]{}\s$^]/g, function(t3) {
        return "\\" + t3;
      });
    });
    var i2, a2 = new RegExp("".concat(n2.join("|")).concat(n2.length > 0 ? "|" : "", "YYYY|YY|MMMM|MMM|MM|M|WW|W|DDDD|DDD|DD|D|dddd|ddd|dd|d|HH|H|hh|h|mm|m|ss|s|SSS|SS|S|A|a|."), "g"), s3 = "", u2 = r(e2.match(a2) || []);
    try {
      for (u2.s(); !(i2 = u2.n()).done; ) {
        var o2 = i2.value, h3 = this.getValue(o2);
        s3 += n2.includes(o2) ? o2 : 0 === h3 ? h3 : h3 || o2;
      }
    } catch (t2) {
      u2.e(t2);
    } finally {
      u2.f();
    }
    var c5 = this.digits;
    return s3.replace(/[0-9]/g, function(t2) {
      return c5[t2];
    });
  } }, { key: "getProperty", value: function(t2) {
    return this.getValue(t2);
  } }, { key: "getValue", value: function(t2) {
    var e2 = function(t3) {
      return t3 < 10 ? "0" + t3 : t3;
    };
    switch (t2) {
      case "YYYY":
        return this.year;
      case "YY":
        return this.year.toString().substring(2, 4);
      case "MMMM":
        return this.month.name;
      case "MMM":
        return this.month.shortName;
      case "MM":
        return e2(this.month.number);
      case "M":
        return this.month.number;
      case "WW":
        return e2(this.weekOfYear);
      case "W":
        return this.weekOfYear;
      case "DDDD":
      case "DDD":
        return this.dayOfYear;
      case "DD":
        return e2(this.day);
      case "D":
        return this.day;
      case "HH":
        return e2(this.hour);
      case "H":
        return this.hour;
      case "dddd":
        return this.weekDay.name;
      case "ddd":
        return this.weekDay.shortName;
      case "dd":
        return e2(this.weekDay.number);
      case "d":
        return this.weekDay.number;
      case "hh":
        return e2(this.hour > 12 ? this.hour - 12 : this.hour || 12);
      case "h":
        return this.hour > 12 ? this.hour - 12 : this.hour || 12;
      case "mm":
        return e2(this.minute);
      case "m":
        return this.minute;
      case "ss":
        return e2(this.second);
      case "s":
        return this.second;
      case "SSS":
        return m$1(this, A$1) < 10 ? "00".concat(m$1(this, A$1)) : m$1(this, A$1) < 100 ? "0".concat(m$1(this, A$1)) : m$1(this, A$1);
      case "SS":
        return m$1(this, A$1) < 10 ? "00" : m$1(this, A$1) < 100 ? ("0" + m$1(this, A$1)).substring(2, 0) : m$1(this, A$1).toString().substring(0, 2);
      case "S":
        return m$1(this, A$1) < 10 || m$1(this, A$1) < 100 ? "0" : m$1(this, A$1).toString().substring(0, 1);
      case "a":
        return this.hour >= 12 ? m$1(this, P).meridiems[1][1] : m$1(this, P).meridiems[0][1];
      case "A":
        return this.hour >= 12 ? m$1(this, P).meridiems[1][0] : m$1(this, P).meridiems[0][0];
      default:
        return "";
    }
  } }, { key: "setYear", value: function(t2) {
    return this.year = t2, this;
  } }, { key: "setMonths", value: function(t2) {
    return this.months = t2, this;
  } }, { key: "setMonth", value: function(t2) {
    return this.month = t2, this;
  } }, { key: "setWeekDays", value: function(t2) {
    return this.weekDays = t2, this;
  } }, { key: "setDigits", value: function(t2) {
    return this.digits = t2, this;
  } }, { key: "setDay", value: function(t2) {
    return this.day = t2, this;
  } }, { key: "setHour", value: function(t2) {
    return this.hour = t2, this;
  } }, { key: "setMinute", value: function(t2) {
    return this.minute = t2, this;
  } }, { key: "setSecond", value: function(t2) {
    return this.second = t2, this;
  } }, { key: "setMillisecond", value: function(t2) {
    return this.millisecond = t2, this;
  } }, { key: "setFormat", value: function(t2) {
    return v(this, I, t2), this;
  } }, { key: "setLocale", value: function(t2) {
    return this.locale = t2, this;
  } }, { key: "setCalendar", value: function(t2) {
    return this.calendar = t2, this;
  } }, { key: "setDate", value: function(t2) {
    if ("string" == typeof t2) {
      if (!m$1(this, H).test(t2)) return this.parse(t2);
      t2 = new Date(t2);
    }
    return "number" == typeof t2 && (t2 = new Date(t2)), t2 instanceof Date && (v(this, T, w$1), v(this, Y, t2.getFullYear()), v(this, L, t2.getMonth()), v(this, W, t2.getDate()), v(this, j$1, t2.getHours()), v(this, x, t2.getMinutes()), v(this, N, t2.getSeconds()), v(this, A$1, t2.getMilliseconds()), v(this, F, false)), t2 instanceof i && (v(this, Y, t2.year), v(this, L, t2.month.index), v(this, W, t2.day), v(this, j$1, t2.hour), v(this, x, t2.minute), v(this, N, t2.second), v(this, A$1, t2.millisecond), v(this, P, t2.locale), v(this, I, t2._format), v(this, T, t2.calendar), v(this, F, t2.isUTC), v(this, V, t2.ignoreList), v(this, E, t2.custom)), this;
  } }, { key: "setIgnoreList", value: function(t2) {
    return this.ignoreList = t2, this;
  } }, { key: "set", value: function(t2, e2) {
    if (null == t2) return this;
    if (D(t2)) {
      var n2 = a$1({}, t2);
      for (var r2 in n2.date && (this.setDate(n2.date), delete n2.date), n2.calendar && (this.convert(n2.calendar), delete n2.calendar), n2.locale && (this.setLocale(n2.locale), delete n2.locale), v(this, J, false), n2) this.set(r2, n2[r2]);
      return v(this, J, true), m$1(this, U).call(this), this;
    }
    "format" === t2 && (t2 = "_format");
    try {
      this[t2] = e2;
    } catch (t3) {
    }
    return this;
  } }, { key: "add", value: function(t2, e2) {
    if (!(t2 = M(t2)) || !e2) return this;
    switch (e2) {
      case "years":
      case "y":
        e2 = "year";
        break;
      case "months":
      case "M":
        e2 = "month";
        break;
      case "days":
      case "d":
        e2 = "day";
        break;
      case "hours":
      case "h":
        e2 = "hour";
        break;
      case "minutes":
      case "m":
        e2 = "minute";
        break;
      case "seconds":
      case "s":
        e2 = "second";
        break;
      case "milliseconds":
      case "ms":
        e2 = "millisecond";
    }
    return this[e2] += t2, this;
  } }, { key: "subtract", value: function(t2, e2) {
    return this.add(-t2, e2);
  } }, { key: "toFirstOfYear", value: function() {
    return this.month = 1, this.day = 1, this;
  } }, { key: "toLastOfYear", value: function() {
    return this.day >= 29 && (this.day = 29), this.month = 12, this.toLastOfMonth(), this;
  } }, { key: "toFirstOfMonth", value: function() {
    return v(this, W, 1), this;
  } }, { key: "toLastOfMonth", value: function() {
    return v(this, W, 0), v(this, L, m$1(this, L) + 1), m$1(this, U).call(this), this;
  } }, { key: "toFirstOfWeek", value: function() {
    return this.day -= this.weekDay.index, this;
  } }, { key: "toLastOfWeek", value: function() {
    return this.day += 6 - this.weekDay.index, this;
  } }, { key: "toFirstWeekOfYear", value: function() {
    return this.toFirstOfYear(), 0 === this.weekDay.index ? this : this.toLastOfWeek().setDay(this.day + 1);
  } }, { key: "toLastWeekOfYear", value: function() {
    return this.toLastOfYear().toFirstOfWeek();
  } }, { key: "toString", value: function() {
    return this.format();
  } }, { key: "toDate", value: function() {
    var t2 = new i(this);
    return "gregorian" !== m$1(this, T).name && t2.convert(w$1), new Date(t2.year, t2.month.index, t2.day, t2.hour, t2.minute, t2.second, t2.millisecond);
  } }, { key: "toUTC", value: function() {
    return m$1(this, F) || (this.minute += this.toDate().getTimezoneOffset(), v(this, F, true)), this;
  } }, { key: "toUnix", value: function() {
    return this.unix;
  } }, { key: "toJulianDay", value: function() {
    return this.toDays() + m$1(this, T).epoch;
  } }, { key: "toObject", value: function() {
    return { year: m$1(this, Y), month: this.month, day: m$1(this, W), weekDay: this.weekDay, hour: m$1(this, j$1), minute: m$1(this, x), second: m$1(this, N), millisecond: m$1(this, A$1), weekOfYear: this.weekOfYear, dayOfYear: this.dayOfYear, daysLeft: this.daysLeft, calendar: m$1(this, T), locale: m$1(this, P), format: m$1(this, I) || "YYYY/MM/DD", ignoreList: m$1(this, V) };
  } }, { key: "toJSON", value: function() {
    return this.valueOf();
  } }, { key: "valueOf", value: function() {
    return this.toDate().valueOf();
  } }, { key: "toDays", value: function() {
    if (this.isValid) return m$1(this, T).getAllDays(this);
  } }, { key: "dayOfBeginning", get: function() {
    return this.toDays();
  } }, { key: "dayOfYear", get: function() {
    if (this.isValid) return m$1(this, T).getDayOfYear(this);
  } }, { key: "weekOfYear", get: function() {
    if (this.isValid) return 1 + ~~(this.dayOfYear / 7);
  } }, { key: "daysLeft", get: function() {
    if (this.isValid) {
      var t2 = m$1(this, T).yearLength;
      return (this.isLeap ? t2 + 1 : t2) - this.dayOfYear;
    }
  } }, { key: "year", get: function() {
    return m$1(this, Y);
  }, set: function(t2) {
    v(this, Y, M(t2)), m$1(this, U).call(this);
  } }, { key: "month", get: function() {
    return this.months[m$1(this, L)] || {};
  }, set: function(t2) {
    var e2;
    t2 = null !== (e2 = M(t2.valueOf()) - 1) && void 0 !== e2 ? e2 : void 0, v(this, L, t2), S(t2, 0, 11) && m$1(this, U).call(this);
  } }, { key: "monthIndex", get: function() {
    return m$1(this, L);
  } }, { key: "day", get: function() {
    return m$1(this, W);
  }, set: function(t2) {
    t2 = M(t2), v(this, W, t2), S(t2, 1, 28) && m$1(this, U).call(this);
  } }, { key: "weekDay", get: function() {
    if (!this.isValid) return {};
    var t2 = (this.toJulianDay() + 3) % 7;
    return m$1(this, R).call(this)[t2];
  } }, { key: "hour", get: function() {
    return m$1(this, j$1);
  }, set: function(t2) {
    t2 = M(t2), v(this, j$1, t2), S(t2, 0, 23) && m$1(this, U).call(this);
  } }, { key: "minute", get: function() {
    return m$1(this, x);
  }, set: function(t2) {
    t2 = M(t2), v(this, x, t2), S(t2, 0, 59) && m$1(this, U).call(this);
  } }, { key: "second", get: function() {
    return m$1(this, N);
  }, set: function(t2) {
    t2 = M(t2), v(this, N, t2), S(t2, 0, 59) && m$1(this, U).call(this);
  } }, { key: "millisecond", get: function() {
    return m$1(this, A$1);
  }, set: function(t2) {
    t2 = M(t2), v(this, A$1, t2), S(t2, 0, 999) && m$1(this, U).call(this);
  } }, { key: "months", get: function() {
    var t2 = m$1(this, T).getMonthLengths(this.isLeap), e2 = (m$1(this, E).months || m$1(this, P).months).map(function(e3, n2) {
      var r2 = u(e3, 2);
      return { name: r2[0], shortName: r2[1], length: t2[n2], index: n2, number: n2 + 1, toString: function() {
        return this.number.toString();
      }, valueOf: function() {
        return this.number;
      } };
    });
    return e2;
  }, set: function(t2) {
    if (!t2) return delete m$1(this, E).months;
    O(t2) && 12 === t2.length && t2.every(function(t3) {
      return O(t3) && 2 === t3.length && t3.every(function(t4) {
        return "string" == typeof t4;
      });
    }) && (m$1(this, E).months = t2);
  } }, { key: "weekDays", get: function() {
    return m$1(this, R).call(this).sort(function(t2, e2) {
      return t2.index - e2.index;
    });
  }, set: function(t2) {
    if (!t2) return delete m$1(this, E).weekDays;
    O(t2) && 7 === t2.length && t2.every(function(t3) {
      return O(t3) && 2 === t3.length && t3.every(function(t4) {
        return "string" == typeof t4;
      });
    }) && (m$1(this, E).weekDays = t2);
  } }, { key: "leaps", get: function() {
    return m$1(this, T).getLeaps(m$1(this, Y));
  } }, { key: "calendar", get: function() {
    return m$1(this, T);
  }, set: function(t2) {
    this.convert(t2);
  } }, { key: "locale", get: function() {
    return m$1(this, P);
  }, set: function() {
    var t2 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : b$2;
    D(t2) && v(this, P, t2);
  } }, { key: "custom", get: function() {
    return m$1(this, E);
  } }, { key: "meridiems", get: function() {
    return m$1(this, P).meridiems;
  } }, { key: "digits", get: function() {
    return m$1(this, E).digits || m$1(this, P).digits;
  }, set: function(t2) {
    if (!t2) return delete m$1(this, E).digits;
    O(t2) && 10 === t2.length && (m$1(this, E).digits = t2);
  } }, { key: "_format", get: function() {
    return m$1(this, I);
  }, set: function(t2) {
    "string" == typeof t2 && v(this, I, t2);
  } }, { key: "isLeap", get: function() {
    return m$1(this, T).isLeap(m$1(this, Y));
  } }, { key: "isValid", get: function() {
    return !isNaN(m$1(this, Y)) && !isNaN(m$1(this, L)) && !isNaN(m$1(this, W));
  } }, { key: "isUTC", get: function() {
    return m$1(this, F);
  } }, { key: "unix", get: function() {
    return (this.valueOf() - this.millisecond) / 1e3;
  } }, { key: "ignoreList", get: function() {
    return m$1(this, V);
  }, set: function(t2) {
    O(t2) && v(this, V, t2);
  } }, { key: "weekStartDayIndex", get: function() {
    return m$1(this, T).weekStartDayIndex;
  }, set: function(t2) {
    void 0 !== (t2 = M(t2)) && (m$1(this, T).weekStartDayIndex = Math.abs(t2) % 7);
  } }, { key: "date", set: function(t2) {
    this.setDate(t2);
  } }], c4 && f(s2.prototype, c4), Object.defineProperty(s2, "prototype", { writable: false }), i;
}(), $ = p$1(k(z));
const index_module = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: $
}, Symbol.toStringTag, { value: "Module" }));
const require$$2 = /* @__PURE__ */ getAugmentedNamespace(index_module);
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var e2 = React__default, r2 = browser_minExports, t2 = require$$2;
  function n2(e3) {
    return e3 && "object" == typeof e3 && "default" in e3 ? e3 : { default: e3 };
  }
  var a2 = n2(e2), o2 = n2(r2), i = n2(t2);
  function d2(e3, r3) {
    var t3 = Object.keys(e3);
    if (Object.getOwnPropertySymbols) {
      var n3 = Object.getOwnPropertySymbols(e3);
      r3 && (n3 = n3.filter(function(r4) {
        return Object.getOwnPropertyDescriptor(e3, r4).enumerable;
      })), t3.push.apply(t3, n3);
    }
    return t3;
  }
  function l2(e3) {
    for (var r3 = 1; r3 < arguments.length; r3++) {
      var t3 = null != arguments[r3] ? arguments[r3] : {};
      r3 % 2 ? d2(Object(t3), true).forEach(function(r4) {
        u2(e3, r4, t3[r4]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : d2(Object(t3)).forEach(function(r4) {
        Object.defineProperty(e3, r4, Object.getOwnPropertyDescriptor(t3, r4));
      });
    }
    return e3;
  }
  function u2(e3, r3, t3) {
    return (r3 = function(e4) {
      var r4 = function(e5, r5) {
        if ("object" != typeof e5 || null === e5) return e5;
        var t4 = e5[Symbol.toPrimitive];
        if (void 0 !== t4) {
          var n3 = t4.call(e5, r5 || "default");
          if ("object" != typeof n3) return n3;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return ("string" === r5 ? String : Number)(e5);
      }(e4, "string");
      return "symbol" == typeof r4 ? r4 : String(r4);
    }(r3)) in e3 ? Object.defineProperty(e3, r3, { value: t3, enumerable: true, configurable: true, writable: true }) : e3[r3] = t3, e3;
  }
  function c4() {
    return c4 = Object.assign ? Object.assign.bind() : function(e3) {
      for (var r3 = 1; r3 < arguments.length; r3++) {
        var t3 = arguments[r3];
        for (var n3 in t3) Object.prototype.hasOwnProperty.call(t3, n3) && (e3[n3] = t3[n3]);
      }
      return e3;
    }, c4.apply(this, arguments);
  }
  function s2(e3, r3) {
    if (null == e3) return {};
    var t3, n3, a3 = function(e4, r4) {
      if (null == e4) return {};
      var t4, n4, a4 = {}, o4 = Object.keys(e4);
      for (n4 = 0; n4 < o4.length; n4++) t4 = o4[n4], r4.indexOf(t4) >= 0 || (a4[t4] = e4[t4]);
      return a4;
    }(e3, r3);
    if (Object.getOwnPropertySymbols) {
      var o3 = Object.getOwnPropertySymbols(e3);
      for (n3 = 0; n3 < o3.length; n3++) t3 = o3[n3], r3.indexOf(t3) >= 0 || Object.prototype.propertyIsEnumerable.call(e3, t3) && (a3[t3] = e3[t3]);
    }
    return a3;
  }
  function f2(e3, r3) {
    return function(e4) {
      if (Array.isArray(e4)) return e4;
    }(e3) || function(e4, r4) {
      var t3 = null == e4 ? null : "undefined" != typeof Symbol && e4[Symbol.iterator] || e4["@@iterator"];
      if (null != t3) {
        var n3, a3, o3, i2, d3 = [], l3 = true, u3 = false;
        try {
          if (o3 = (t3 = t3.call(e4)).next, 0 === r4) {
            if (Object(t3) !== t3) return;
            l3 = false;
          } else for (; !(l3 = (n3 = o3.call(t3)).done) && (d3.push(n3.value), d3.length !== r4); l3 = true) ;
        } catch (e5) {
          u3 = true, a3 = e5;
        } finally {
          try {
            if (!l3 && null != t3.return && (i2 = t3.return(), Object(i2) !== i2)) return;
          } finally {
            if (u3) throw a3;
          }
        }
        return d3;
      }
    }(e3, r3) || m3(e3, r3) || function() {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }
  function p2(e3) {
    return function(e4) {
      if (Array.isArray(e4)) return h3(e4);
    }(e3) || function(e4) {
      if ("undefined" != typeof Symbol && null != e4[Symbol.iterator] || null != e4["@@iterator"]) return Array.from(e4);
    }(e3) || m3(e3) || function() {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }
  function m3(e3, r3) {
    if (e3) {
      if ("string" == typeof e3) return h3(e3, r3);
      var t3 = Object.prototype.toString.call(e3).slice(8, -1);
      return "Object" === t3 && e3.constructor && (t3 = e3.constructor.name), "Map" === t3 || "Set" === t3 ? Array.from(e3) : "Arguments" === t3 || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t3) ? h3(e3, r3) : void 0;
    }
  }
  function h3(e3, r3) {
    (null == r3 || r3 > e3.length) && (r3 = e3.length);
    for (var t3 = 0, n3 = new Array(r3); t3 < r3; t3++) n3[t3] = e3[t3];
    return n3;
  }
  function y2(e3, r3) {
    var t3 = "undefined" != typeof Symbol && e3[Symbol.iterator] || e3["@@iterator"];
    if (!t3) {
      if (Array.isArray(e3) || (t3 = m3(e3)) || r3 && e3 && "number" == typeof e3.length) {
        t3 && (e3 = t3);
        var n3 = 0, a3 = function() {
        };
        return { s: a3, n: function() {
          return n3 >= e3.length ? { done: true } : { done: false, value: e3[n3++] };
        }, e: function(e4) {
          throw e4;
        }, f: a3 };
      }
      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o3, i2 = true, d3 = false;
    return { s: function() {
      t3 = t3.call(e3);
    }, n: function() {
      var e4 = t3.next();
      return i2 = e4.done, e4;
    }, e: function(e4) {
      d3 = true, o3 = e4;
    }, f: function() {
      try {
        i2 || null == t3.return || t3.return();
      } finally {
        if (d3) throw o3;
      }
    } };
  }
  function g2(e3) {
    return Array.isArray(e3);
  }
  function v2(r3) {
    var t3 = r3.state.date, n3 = t3.calendar, o3 = t3.locale, d3 = r3.customWeekDays, l3 = r3.weekStartDayIndex, u3 = r3.displayWeekNumbers, c5 = r3.weekNumber, s3 = e2.useMemo(function() {
      var e3 = d3;
      return g2(e3) && e3.length >= 7 ? (e3.length = 7, e3 = e3.map(function(e4) {
        return g2(e4) & e4.length > 1 ? e4 = e4[1] : g2(e4) && (e4 = e4[0]), e4;
      })) : e3 = new i.default({ year: 1, calendar: n3, locale: o3 }).weekDays.map(function(e4) {
        return e4.shortName;
      }), e3;
    }, [n3, o3, d3]);
    return s3 = p2(s3).slice(l3).concat(p2(s3).splice(0, l3)), a2.default.createElement("div", { className: "rmdp-week" }, u3 && a2.default.createElement("div", { className: "rmdp-week-day" }, c5), s3.map(function(e3, r4) {
      return a2.default.createElement("div", { key: r4, className: "rmdp-week-day" }, e3);
    }));
  }
  function b2(e3, r3) {
    var t3 = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], n3 = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
    if (!e3 || !r3) return false;
    if (e3.year === r3.year) {
      if (n3) return true;
      if (e3.monthIndex === r3.monthIndex) return !!t3 || e3.day === r3.day;
    }
  }
  function x2(e3) {
    var r3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "YYYY/MM/DD";
    return e3.format(r3);
  }
  function w2(e3, r3, t3) {
    var n3 = t3.multiple, a3 = t3.range, o3 = t3.selectedDate, d3 = t3.onlyMonthPicker, l3 = t3.onlyYearPicker, u3 = t3.format, c5 = t3.focused, s3 = t3.weekPicker;
    e3.setFormat(u3);
    var m4 = new i.default(e3);
    return o3 = n3 && a3 ? function() {
      var e4 = true;
      g2(o3) || (o3 = [[o3]]);
      var r4 = o3.find(function(e5) {
        return 1 === e5.length;
      }), t4 = d3 ? "YYYY/MM" : "YYYY/MM/DD", n4 = o3;
      if (r4) {
        var a4 = r4[0];
        n4 = n4.filter(function(e5) {
          if (1 === e5.length) return true;
          var r5 = f2(e5, 2), n5 = r5[0], o4 = r5[1], i2 = f2([a4, m4].sort(function(e6, r6) {
            return e6 - r6;
          }), 2), d4 = [n5, o4, i2[0], i2[1]].map(function(e6) {
            return x2(e6, t4);
          }), l4 = f2(d4, 4), u4 = l4[0], c6 = l4[1], s4 = l4[2], p3 = l4[3];
          return !(s4 <= u4 && p3 >= c6 || s4 >= u4 && p3 >= c6 && s4 <= c6 || s4 <= u4 && p3 <= c6 && p3 >= u4);
        });
      } else n4 = n4.filter(function(e5) {
        if (!g2(e5)) return true;
        if (0 === e5.length) return false;
        var r5 = f2(e5, 2), n5 = [r5[0], r5[1], m4].map(function(e6) {
          return x2(e6, t4);
        }), a5 = f2(n5, 3), o4 = a5[0], i2 = a5[1], d4 = a5[2];
        return !(d4 >= o4 && d4 <= i2);
      });
      n4 = n4.map(function(r5) {
        var t5;
        return g2(r5) ? 1 === r5.length ? (e4 = false, t5 = r5.concat(m4)) : t5 = r5 : (e4 = false, t5 = [r5, m4]), t5.sort(function(e5, r6) {
          return e5 - r6;
        });
      }), e4 && (n4 = [].concat(p2(n4), [[m4]]));
      return n4;
    }() : n3 ? function() {
      var t4 = o3.filter(function(r4) {
        return !b2(e3, r4, d3, l3);
      });
      t4.length === o3.length ? t4.push(m4) : m4 = t4.find(function(e4) {
        return b2(e4, c5);
      });
      r3 && t4.sort(function(e4, r4) {
        return e4 - r4;
      });
      return t4;
    }() : a3 ? function() {
      if (s3) return [new i.default(m4).toFirstOfWeek(), new i.default(m4).toLastOfWeek()];
      if (2 === o3.length || 0 === o3.length) return [m4];
      if (1 === o3.length) return [o3[0], m4].sort(function(e4, r4) {
        return e4 - r4;
      });
    }() : m4, [o3, m4];
  }
  function k2(e3, r3, t3, n3) {
    var a3 = [], o3 = t3 ? "YYYY/MM" : "YYYY/MM/DD", i2 = x2(e3, o3);
    function d3(r4) {
      var n4 = r4[0], d4 = r4[1];
      if (1 === r4.length) b2(e3, n4, t3) && a3.push("rmdp-range");
      else if (2 === r4.length) {
        var l3 = [n4, d4].map(function(e4) {
          return x2(e4, o3);
        }), u3 = f2(l3, 2), c5 = u3[0], s3 = u3[1];
        i2 >= c5 && i2 <= s3 && a3.push("rmdp-range"), i2 === c5 && a3.push("start"), i2 === s3 && a3.push("end");
      }
    }
    return n3 ? (g2(r3) ? r3 : [[r3]]).forEach(d3) : d3(r3), a3.join(" ");
  }
  function D2(e3, r3, t3, n3) {
    var a3 = arguments.length > 5 ? arguments[5] : void 0, o3 = [];
    if (n3 && t3) {
      var i2, d3 = "day" === (arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : "day") ? "YYYY/MM/DD" : "YYYY/MM", l3 = t3.format(d3), u3 = e3.format(d3);
      if (a3 || 1 !== (null == r3 ? void 0 : r3.length)) {
        if (a3 && g2(r3)) {
          var c5, s3 = y2(r3);
          try {
            for (s3.s(); !(c5 = s3.n()).done; ) {
              var f3 = c5.value;
              if (g2(f3) && 1 === f3.length) {
                i2 = f3[0].format(d3);
                break;
              }
            }
          } catch (e4) {
            s3.e(e4);
          } finally {
            s3.f();
          }
        }
      } else i2 = r3[0].format(d3);
      (u3 > i2 && u3 <= l3 || u3 < i2 && u3 >= l3) && (o3.push("rmdp-range-hover"), u3 === l3 && o3.push(l3 > i2 ? "end" : "start"), g2(r3) && r3.flat().some(function(e4) {
        return e4.format(d3) === u3;
      }) && o3.push("force"));
    }
    return o3;
  }
  var O2, E2 = "dddd MMMM DD of YYYY";
  function Y2(r3) {
    var t3 = r3.state, n3 = r3.setState, o3 = r3.onChange, d3 = r3.showOtherDays, s3 = void 0 !== d3 && d3, p3 = r3.mapDays, m4 = r3.onlyShowInRangeDates, h4 = r3.customWeekDays, y3 = r3.sort, g3 = r3.numberOfMonths, x3 = r3.isRTL, Y3 = r3.weekStartDayIndex, M3 = r3.handleFocusedDate, P4 = r3.hideWeekDays, N3 = r3.fullYear, S3 = f2(r3.monthAndYears, 1)[0], C3 = r3.displayWeekNumbers, I3 = r3.weekNumber, j2 = void 0 === I3 ? "" : I3, T3 = r3.rangeHover, A3 = r3.highlightToday, R3 = e2.useRef({}), L3 = e2.useRef(), F3 = t3.today, V3 = t3.minDate, W3 = t3.maxDate, B3 = t3.range, _3 = t3.multiple, z3 = t3.date, H3 = t3.selectedDate, q2 = t3.onlyMonthPicker, J3 = t3.onlyYearPicker, K2 = !q2 && !J3, U3 = f2(e2.useState(), 2), $3 = U3[0], G2 = U3[1], Q2 = _3 || B3 ? (null == H3 ? void 0 : H3.length) > 0 : !!H3;
    R3.current.date = z3;
    var X2 = e2.useMemo(function() {
      return K2 ? function(e3, r4, t4, n4) {
        if (!e3) return [];
        for (var a3 = [], o4 = 0; o4 < t4; o4++) {
          var d4 = (e3 = new i.default(e3).toFirstOfMonth()).monthIndex, l3 = [];
          e3.toFirstOfWeek().add(n4, "day"), e3.monthIndex === d4 && e3.day > 1 && e3.subtract(7, "days");
          for (var u3 = 0; u3 < 6; u3++) {
            for (var c5 = [], s4 = 0; s4 < 7; s4++) c5.push({ date: new i.default(e3), day: e3.format("D"), current: e3.monthIndex === d4 }), e3.day += 1;
            if (l3.push(c5), u3 > 2 && e3.monthIndex !== d4 && !r4) break;
          }
          a3.push(l3);
        }
        return a3;
      }(R3.current.date, s3, g3, Y3) : [];
    }, [z3.monthIndex, z3.year, z3.calendar, z3.locale, K2, s3, g3, Y3]);
    return K2 && a2.default.createElement("div", { ref: L3, className: "rmdp-day-picker ".concat(N3 ? "rmdp-full-year" : ""), style: { display: N3 ? "grid" : "flex" }, onMouseLeave: function() {
      return T3 && G2();
    } }, X2.map(function(e3, r4) {
      return a2.default.createElement("div", { key: r4, style: u2({}, x3 ? "marginLeft" : "marginRight", r4 + (N3 ? 0 : 1) < g3 ? "10px" : "") }, N3 && a2.default.createElement("div", { className: "rmdp-month-name" }, S3[r4]), !P4 && a2.default.createElement(v2, { state: t3, customWeekDays: h4, weekStartDayIndex: Y3, displayWeekNumbers: C3, weekNumber: j2 }), e3.map(function(e4, d4) {
        return a2.default.createElement("div", { key: d4, className: "rmdp-week" }, C3 && a2.default.createElement("div", { className: "rmdp-day rmdp-disabled" }, a2.default.createElement("span", null, e4[0].date.format("WW"))), e4.map(function(e5, d5) {
          var u3 = function(e6) {
            if (!e6.current && !s3) return {};
            var r5 = {};
            return p3.forEach(function(n4) {
              var a3, o4 = n4({ date: e6.date, today: F3, currentMonth: t3.date.month, selectedDate: t3.selectedDate, isSameDate: b2 });
              (null === (a3 = o4) || void 0 === a3 ? void 0 : a3.constructor) !== Object && (o4 = {}), (o4.disabled || o4.hidden) && (e6.disabled = true), o4.hidden && (e6.hidden = true), r5 = l2(l2({}, r5), o4);
            }), delete r5.disabled, delete r5.hidden, r5;
          }(e5 = { date: e5.date, day: e5.day, current: e5.current }), h5 = Z2(e5) && !e5.disabled, v3 = "".concat(h5 ? "sd" : ""), x4 = u3.children;
          h5 && (v3 = "".concat(v3, " ").concat(u3.className || "")), delete u3.className, delete u3.children;
          var Y4 = function(e6, r5) {
            var t4 = ["rmdp-day"], n4 = e6.date, a3 = e6.hidden, o4 = e6.current;
            if (!Z2(e6) || a3) t4.push("rmdp-day-hidden");
            else {
              (V3 && n4 < V3 || W3 && n4 > W3 || e6.disabled) && (t4.push("rmdp-disabled"), e6.disabled || (e6.disabled = true)), o4 || t4.push("rmdp-deactive");
              var i2 = r5 > 1 && o4 || 1 === r5;
              e6.disabled && m4 || (b2(n4, F3) && A3 && t4.push("rmdp-today"), d6 = n4, [].concat(H3).some(function(e7) {
                return b2(e7, d6);
              }) && i2 && !B3 && t4.push("rmdp-selected")), B3 && !e6.disabled && i2 && (t4.push(k2(n4, H3, void 0, _3)), t4 = t4.concat(D2(n4, H3, $3, T3, void 0, _3)));
            }
            var d6;
            return t4.join(" ");
          }(e5, g3);
          (e5.hidden || e5.disabled) && (v3 = v3.replace("sd", ""));
          var P5 = Q2 ? Y4.includes("selected") || Y4.includes("range") : Y4.includes("today");
          return a2.default.createElement("div", { key: d5, tabIndex: P5 ? 0 : -1, "aria-label": "Choose ".concat(e5.date.format(E2)), className: Y4, onMouseEnter: function() {
            return T3 && G2(e5.date);
          }, onKeyDown: function(r5) {
            return function(e6, r6) {
              var a3 = e6.currentTarget, o4 = e6.key, d6 = e6.code, u4 = { ArrowRight: 1, ArrowLeft: -1, ArrowUp: -7, ArrowDown: 7 };
              if ("Space" === d6 || " " === o4) e6.preventDefault(), a3.click();
              else if (Object.keys(u4).includes(o4)) {
                var c5 = function(e7) {
                  if (!e7) return s4();
                  var r7 = e7.getAttribute("class");
                  r7.includes("hidden") || r7.includes("disabled") ? s4() : e7.focus();
                }, s4 = function() {
                  n3(l2(l2({}, t3), {}, { date: p4 })), clearTimeout(O2), O2 = setTimeout(function() {
                    return c5(ee(p4));
                  }, 100);
                };
                e6.preventDefault();
                var f3 = u4[o4], p4 = new i.default(r6.date).add(f3, "day"), m5 = ee(p4);
                c5(m5);
              }
            }(r5, e5);
          }, onClick: function() {
            Z2(e5) && !e5.disabled && function(e6, r5, n4) {
              var a3, d6, u4, c5 = e6.date, s4 = e6.current, p4 = t3.selectedDate, m5 = t3.focused, h6 = t3.date, g4 = h6, v4 = g4.hour, b3 = g4.minute, x5 = g4.second;
              c5.set({ hour: (null === (a3 = p4) || void 0 === a3 ? void 0 : a3.hour) || v4, minute: (null === (d6 = p4) || void 0 === d6 ? void 0 : d6.minute) || b3, second: (null === (u4 = p4) || void 0 === u4 ? void 0 : u4.second) || x5 }), 1 !== n4 || s4 ? n4 > 1 && !s4 && (0 === r5 && c5 < h6 && (h6 = new i.default(h6).toFirstOfMonth()), r5 > 0 && c5.monthIndex > h6.monthIndex + r5 && r5 + 1 === n4 && (h6 = new i.default(h6).toFirstOfMonth().add(1, "month"))) : h6 = new i.default(h6).toFirstOfMonth();
              var k3 = f2(w2(c5, y3, t3), 2);
              p4 = k3[0], m5 = k3[1], o3(p4, l2(l2({}, t3), {}, { date: h6, focused: m5, selectedDate: p4 })), M3(m5, c5);
            }(e5, r4, g3);
          } }, a2.default.createElement("span", c4({ className: v3 }, u3), Z2(e5) && !e5.hidden ? null != x4 ? x4 : e5.day : ""));
        }));
      }));
    }));
    function Z2(e3) {
      return !!e3.current || s3;
    }
    function ee(e3) {
      return L3.current.querySelector("[aria-label*='".concat(e3.format(E2), "']"));
    }
  }
  function M2(e3) {
    var r3 = e3.direction, t3 = e3.onClick, n3 = e3.disabled;
    return a2.default.createElement("button", { type: "button", className: "rmdp-arrow-container ".concat(r3, " ").concat(n3 ? "disabled" : ""), onClick: t3, "aria-roledescription": "button to navigate ".concat(r3.replace("rmdp-", "")) }, a2.default.createElement("i", { className: "rmdp-arrow" }));
  }
  function P2(r3) {
    var t3 = r3.state, n3 = r3.setState, o3 = r3.disableYearPicker, i2 = r3.disableMonthPicker, d3 = r3.buttons, u3 = r3.renderButton, c5 = r3.handleMonthChange, s3 = r3.disabled, p3 = r3.hideMonth, m4 = r3.hideYear, h4 = r3.isRTL, y3 = r3.fullYear, g3 = f2(r3.monthAndYears, 2), v3 = g3[0], b3 = g3[1], x3 = r3.monthYearSeparator, w3 = r3.formatMonth, k3 = r3.formatYear, D3 = r3.headerOrder, O3 = {}, E3 = t3.date, Y3 = t3.onlyMonthPicker, P4 = t3.onlyYearPicker, N3 = t3.mustShowYearPicker, S3 = t3.minDate, C3 = t3.maxDate, I3 = t3.year, j2 = t3.today, T3 = S3 && E3.year <= S3.year && S3.monthIndex > E3.monthIndex - 1, A3 = C3 && E3.year >= C3.year && C3.monthIndex < E3.monthIndex + 1, R3 = j2.year + 7;
    if (R3 -= 12 * Math.floor((R3 - I3) / 12), (p3 || y3) && m4 && !d3) return null;
    if ((Y3 || y3) && (S3 && S3.year >= E3.year && (T3 = true), C3 && C3.year <= E3.year && (A3 = true)), N3 || P4) {
      var L3 = R3 - 11;
      T3 = S3 && S3.year > L3, A3 = C3 && C3.year < R3;
    }
    return s3 && (T3 = true, A3 = true), a2.default.createElement("div", { className: "rmdp-header" }, a2.default.createElement("div", { style: { position: "relative", display: "flex", alignItems: "center" } }, Array.from(new Set(D3)).map(function(r4, t4) {
      return a2.default.createElement(e2.Fragment, { key: t4 }, function(r5) {
        switch (r5) {
          case "LEFT_BUTTON":
            return d3 && V3("left");
          case "RIGHT_BUTTON":
            return d3 && V3("right");
          case "MONTH_YEAR":
          case "YEAR_MONTH":
            if (y3) return a2.default.createElement("div", { className: "rmdp-header-values", style: O3 }, !m4 && E3.format("YYYY"));
            var t5 = r5.split("_").filter(function(e3) {
              return "MONTH" === e3 && !p3 || "YEAR" === e3 && !m4;
            });
            return t5.length > 1 && (t5 = [t5[0], F3(), t5[1]]), v3.map(function(r6, n4) {
              return a2.default.createElement("div", { key: n4, className: "rmdp-header-values", style: O3 }, t5.map(function(t6, d4) {
                return a2.default.createElement(e2.Fragment, { key: d4 }, function(e3, r7, t7) {
                  switch (e3) {
                    case "MONTH":
                      return a2.default.createElement("span", { style: { cursor: s3 || i2 || Y3 ? "default" : "pointer" }, onClick: function() {
                        return !i2 && B3("mustShowMonthPicker");
                      } }, function(e4, r8) {
                        return "function" == typeof w3 ? w3(e4, r8) : e4;
                      }(r7, b3[t7]));
                    case "YEAR":
                      return a2.default.createElement("span", { style: { cursor: s3 || o3 || P4 ? "default" : "pointer" }, onClick: function() {
                        return !o3 && B3("mustShowYearPicker");
                      } }, function(e4, r8) {
                        return "function" == typeof w3 ? k3(e4, r8) : e4;
                      }(b3[t7], r7));
                    default:
                      return e3;
                  }
                }(t6, r6, n4));
              }));
            });
          default:
            return;
        }
      }(r4));
    })));
    function F3() {
      return x3 ? a2.default.createElement("span", null, x3) : h4 ? "،" : ",";
    }
    function V3(r4) {
      var t4 = function(e3) {
        e3.preventDefault(), W3("right" === r4 ? 1 : -1), function(e4) {
          setTimeout(function() {
            var r5 = e4.target.closest(".rmdp-calendar");
            if (r5) {
              var t5 = r5.querySelector("div[tabindex='0']");
              t5 && t5.getAttribute("class").includes("hidden") && (t5.setAttribute("tabindex", "-1"), t5 = void 0), t5 || (t5 = r5.querySelector("div[tabindex='-1']:not(.rmdp-day-hidden)")) && t5.setAttribute("tabindex", "0");
            }
          }, 200);
        }(e3);
      }, n4 = "left" === r4 && T3 || "right" === r4 && A3;
      return u3 instanceof Function ? u3(r4, t4, n4) : e2.isValidElement(u3) ? e2.cloneElement(u3, { direction: r4, handleClick: t4, disabled: n4 }) : a2.default.createElement(M2, { direction: "rmdp-".concat(r4), onClick: t4, disabled: n4 });
    }
    function W3(e3) {
      s3 || e3 < 0 && T3 || e3 > 0 && A3 || (y3 ? E3.year += e3 : N3 || P4 ? (I3 += 12 * e3, e3 < 0 && S3 && I3 < S3.year && (I3 = S3.year), e3 > 0 && C3 && I3 > C3.year && (I3 = C3.year)) : (E3.toFirstOfMonth(), Y3 ? E3.year += e3 : (E3.month += e3, c5(E3))), n3(l2(l2({}, t3), {}, { date: E3, year: I3 })));
    }
    function B3(e3) {
      if (!s3) {
        var r4 = { mustShowMonthPicker: false, mustShowYearPicker: false };
        r4[e3] = !t3[e3], n3(l2(l2({}, t3), r4));
      }
    }
  }
  function N2(e3) {
    return g2(e3) || (e3 = []), JSON.stringify(e3);
  }
  function S2(r3) {
    var t3 = r3.state, n3 = r3.onChange, o3 = r3.customMonths, d3 = r3.sort, u3 = r3.handleMonthChange, c5 = r3.handleFocusedDate, s3 = r3.rangeHover, p3 = r3.highlightToday, m4 = r3.numberOfMonths, h4 = t3.date, y3 = t3.today, v3 = t3.minDate, x3 = t3.maxDate, O3 = t3.calendar, E3 = t3.locale, Y3 = t3.onlyMonthPicker, M3 = t3.onlyYearPicker, P4 = t3.range, S3 = t3.onlyShowInRangeDates, C3 = (t3.mustShowMonthPicker || Y3) && !M3, I3 = f2(e2.useState(), 2), j2 = I3[0], T3 = I3[1];
    o3 = o3 && N2(o3);
    var A3 = e2.useMemo(function() {
      var e3 = [], r4 = Y3 ? m4 : 1, n4 = o3 && JSON.parse(o3), a3 = new i.default({ calendar: O3, locale: E3, format: t3.date._format, year: t3.date.year, month: 1, day: 1 });
      g2(n4) && n4.length >= 12 ? (n4.length = 12, n4 = n4.map(function(e4) {
        return g2(e4) ? e4[0] : e4;
      })) : n4 = a3.locale.months.map(function(e4) {
        return f2(e4, 1)[0];
      });
      for (var d4 = 0; d4 < r4; d4++) {
        for (var l3 = [], u4 = 0, c6 = 0; c6 < 4; c6++) {
          for (var s4 = [], p4 = 0; p4 < 3; p4++) s4.push({ date: new i.default(a3), name: n4[u4] }), u4++, a3.add(1, "month");
          l3.push(s4);
        }
        e3.push(l3);
      }
      return e3;
    }, [O3, E3, o3, t3.date.year, t3.date._format, m4, Y3]);
    return a2.default.createElement("div", { className: "".concat(Y3 ? "only " : "", "rmdp-month-picker"), style: { display: C3 ? "flex" : "none" }, onMouseLeave: function() {
      return s3 && T3();
    } }, A3.map(function(e3, r4) {
      return a2.default.createElement("div", { key: r4, style: { margin: "0 5px", flex: 1 } }, e3.map(function(e4, r5) {
        return a2.default.createElement("div", { key: r5, className: "rmdp-ym" }, e4.map(function(e5, r6) {
          var t4 = e5.date, n4 = e5.name;
          return a2.default.createElement("div", { key: r6, className: L3(t4), onClick: function() {
            return R3(t4);
          }, onMouseEnter: function() {
            return s3 && T3(t4);
          } }, a2.default.createElement("span", { className: Y3 ? "sd" : "" }, n4));
        }));
      }));
    }));
    function R3(e3) {
      var r4 = t3.selectedDate, a3 = t3.focused, o4 = e3.year, i2 = e3.monthIndex;
      if (!(v3 && o4 <= v3.year && i2 < v3.monthIndex || x3 && o4 >= x3.year && i2 > x3.monthIndex)) {
        if (h4.setMonth(i2 + 1), Y3) {
          var s4 = f2(w2(e3, d3, t3), 2);
          r4 = s4[0], a3 = s4[1];
        } else u3(h4);
        n3(Y3 ? r4 : void 0, l2(l2({}, t3), {}, { date: h4, focused: a3, selectedDate: r4, mustShowMonthPicker: false })), Y3 && c5(a3, e3);
      }
    }
    function L3(e3) {
      var r4 = ["rmdp-day"], n4 = e3.year, a3 = e3.monthIndex, o4 = t3.selectedDate, i2 = t3.multiple;
      if ((v3 && (n4 < v3.year || n4 === v3.year && a3 < v3.monthIndex) || x3 && (n4 > x3.year || n4 === x3.year && a3 > x3.monthIndex)) && r4.push("rmdp-disabled"), !r4.includes("rmdp-disabled") || !S3) return b2(y3, e3, true) && p3 && r4.push("rmdp-today"), Y3 ? P4 ? (r4.push(k2(e3, o4, true, i2)), r4 = r4.concat(D2(e3, o4, j2, s3, "month", i2))) : [].concat(o4).some(function(r5) {
        return b2(r5, e3, true);
      }) && r4.push("rmdp-selected") : h4.monthIndex === a3 && r4.push("rmdp-selected"), r4.join(" ");
    }
  }
  function C2(e3, r3) {
    return e3.replace(/[0-9]/g, function(e4) {
      return r3[e4];
    });
  }
  function I2(r3) {
    var t3 = r3.state, n3 = r3.onChange, o3 = r3.sort, d3 = r3.handleFocusedDate, u3 = r3.onYearChange, c5 = r3.rangeHover, s3 = r3.highlightToday, p3 = t3.date, m4 = t3.today, h4 = t3.minDate, y3 = t3.maxDate, v3 = t3.onlyYearPicker, b3 = t3.range, x3 = t3.onlyShowInRangeDates, k3 = t3.year, D3 = t3.mustShowYearPicker || v3, O3 = p3.digits, E3 = f2(e2.useState(), 2), Y3 = E3[0], M3 = E3[1], P4 = m4.year - 4;
    P4 -= 12 * Math.ceil((P4 - k3) / 12);
    var N3 = e2.useMemo(function() {
      for (var e3 = [], r4 = P4, t4 = 0; t4 < 4; t4++) {
        for (var n4 = [], a3 = 0; a3 < 3; a3++) n4.push(r4), r4++;
        e3.push(n4);
      }
      return e3;
    }, [P4]);
    return a2.default.createElement("div", { className: "".concat(v3 ? "only " : "", "rmdp-year-picker"), style: { display: D3 ? "block" : "none" } }, N3.map(function(e3, r4) {
      return a2.default.createElement("div", { key: r4, className: "rmdp-ym", onMouseLeave: function() {
        return c5 && M3();
      } }, e3.map(function(e4, r5) {
        return a2.default.createElement("div", { key: r5, className: S3(e4), onClick: function() {
          return function(e5) {
            if (I3(e5)) return;
            var r6 = new i.default(t3.date).setYear(e5), a3 = t3.selectedDate, c6 = t3.focused;
            if (v3) {
              var s4 = f2(w2(r6, o3, t3), 2);
              a3 = s4[0], c6 = s4[1];
            } else h4 && r6.monthIndex < h4.monthIndex ? r6 = r6.setMonth(h4.monthIndex + 1) : y3 && r6.monthIndex > y3.monthIndex && (r6 = r6.setMonth(y3.monthIndex + 1)), null == u3 || u3(r6);
            n3(v3 ? a3 : void 0, l2(l2({}, t3), {}, { date: r6, focused: c6, selectedDate: a3, mustShowYearPicker: false })), v3 && d3(c6, r6);
          }(e4);
        }, onMouseEnter: function() {
          return c5 && M3(e4);
        } }, a2.default.createElement("span", { className: v3 ? "sd" : "" }, C2(e4.toString(), O3)));
      }));
    }));
    function S3(e3) {
      var r4 = ["rmdp-day"], n4 = t3.date, a3 = t3.selectedDate, o4 = t3.multiple;
      if (I3(e3) && r4.push("rmdp-disabled"), !r4.includes("rmdp-disabled") || !x3) {
        if (m4.year === e3 && s3 && r4.push("rmdp-today"), v3) if (b3) {
          var i2 = function(t4) {
            var n5 = t4[0], a4 = t4[1];
            if (1 === t4.length) {
              if (e3 === n5.year && r4.push("rmdp-range"), c5) {
                var o5 = t4[0].year;
                (e3 > o5 && e3 <= Y3 || e3 < o5 && e3 >= Y3) && (r4.push("rmdp-range-hover"), e3 === Y3 && r4.push(Y3 > o5 ? "end" : "start"));
              }
            } else 2 === t4.length && (e3 >= n5.year && e3 <= a4.year && r4.push("rmdp-range"), e3 === n5.year && r4.push("start"), e3 === a4.year && r4.push("end"));
          };
          o4 ? (g2(a3) ? a3 : [[a3]]).forEach(function(e4) {
            return i2(e4);
          }) : i2(a3);
        } else [].concat(a3).some(function(r5) {
          return r5 && r5.year === e3;
        }) && r4.push("rmdp-selected");
        else e3 === n4.year && r4.push("rmdp-selected");
        return r4.join(" ");
      }
    }
    function I3(e3) {
      return h4 && e3 < h4.year || y3 && e3 > y3.year;
    }
  }
  function j(e3, r3, t3) {
    return t3 || (e3 ? "MM/YYYY" : r3 ? "YYYY" : "YYYY/MM/DD");
  }
  function T2(e3, r3) {
    var t3 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "YYYY/MM/DD";
    return e3 instanceof i.default ? e3.set({ calendar: r3, format: t3 }) : e3 = new i.default({ date: e3, calendar: r3, format: t3 }), e3;
  }
  function A2(e3) {
    "_self" in a2.default.createElement("div") && console.warn(e3.join("\n"));
  }
  var R2 = new i.default(), L2 = R2.calendar, F2 = R2.locale;
  function V2(e3, r3) {
    return e3 && e3.constructor !== Object && (A2(W2("calendar")), e3 = void 0), r3 && r3.constructor !== Object && (A2(W2("locale")), r3 = void 0), [e3 || L2, r3 || F2];
  }
  function W2(e3) {
    return ["".concat(e3, " must be an object"), "https://shahabyazdi.github.io/react-multi-date-picker/calendars/"];
  }
  function B2(e3) {
    return e3 && e3.name ? e3.name.split("_")[1] : "";
  }
  function _2(e3) {
    return ["fa", "ar"].includes(B2(e3));
  }
  function z2(e3, r3) {
    void 0 === r3 && (r3 = {});
    var t3 = r3.insertAt;
    if (e3 && "undefined" != typeof document) {
      var n3 = document.head || document.getElementsByTagName("head")[0], a3 = document.createElement("style");
      a3.type = "text/css", "top" === t3 && n3.firstChild ? n3.insertBefore(a3, n3.firstChild) : n3.appendChild(a3), a3.styleSheet ? a3.styleSheet.cssText = e3 : a3.appendChild(document.createTextNode(e3));
    }
  }
  z2(".rmdp-wrapper{background-color:#fff;border-radius:5px;direction:ltr;text-align:center;width:max-content}.rmdp-shadow{box-shadow:0 0 5px #8798ad}.rmdp-border{border:1px solid #cfd8e2}.rmdp-calendar{height:max-content;padding:4px}.rmdp-border-top{border-top:1px solid #cfd8e2}.rmdp-border-bottom{border-bottom:1px solid #cfd8e2}.rmdp-border-left{border-left:1px solid #cfd8e2}.rmdp-border-right{border-right:1px solid #cfd8e2}.rmdp-week,.rmdp-ym{display:flex;justify-content:space-between}.rmdp-ym{height:25%}.rmdp-day,.rmdp-week-day{color:#000;cursor:pointer;height:34px;position:relative;width:34px}.rmdp-week-day{color:#0074d9;cursor:default;font-size:13px;font-weight:500}.rmdp-day span,.rmdp-week-day{display:flex;flex-direction:column;justify-content:center}.rmdp-day span{border-radius:50%;bottom:3px;font-size:14px;left:3px;position:absolute;right:3px;top:3px}.rmdp-day.rmdp-today span{background-color:#7fdbff;color:#fff}.rmdp-day.rmdp-selected span:not(.highlight){background-color:#0074d9;box-shadow:0 0 3px #8798ad;color:#fff}.rmdp-day.rmdp-deactive,.rmdp-day.rmdp-disabled{color:#8798ad}.rmdp-day.rmdp-deactive.rmdp-selected span{background-color:#4ca6f5;box-shadow:0 0 3px #bac5d3}.rmdp-ym .rmdp-day{flex:1;margin:auto}.rmdp-ym .rmdp-day span{border-radius:12px;padding:2px 0}.rmdp-range{background-color:#0074d9;box-shadow:0 0 3px #8798ad;color:#fff}.rmdp-range-hover{background-color:#7ea6f0;color:#fff}.rmdp-range-hover.start:not(.force),.rmdp-range.start:not(.force){border-bottom-left-radius:50%;border-top-left-radius:50%}.rmdp-range-hover.end:not(.force),.rmdp-range.end:not(.force){border-bottom-right-radius:50%;border-top-right-radius:50%}.rmdp-ym .rmdp-range-hover.start:not(.force),.rmdp-ym .rmdp-range.start:not(.force){border-bottom-left-radius:15px;border-top-left-radius:15px}.rmdp-ym .rmdp-range-hover.end:not(.force),.rmdp-ym .rmdp-range.end:not(.force){border-bottom-right-radius:15px;border-top-right-radius:15px}@media (hover:hover){.rmdp-day:not(.rmdp-disabled,.rmdp-day-hidden) span:hover{background-color:#7ea6f0;color:#fff}}.rmdp-day-picker{padding:5px}.rmdp-header{font-size:14px;margin-top:5px;padding:9px 0}.rmdp-month-picker,.rmdp-year-picker{background-color:#fff;border-radius:0 0 5px 5px;bottom:2px;left:2px;position:absolute;right:2px;top:2px}.only.rmdp-month-picker,.only.rmdp-year-picker{height:240px;position:static;width:240px}.rmdp-header-values{color:#000;margin:auto}.rmdp-header-values span{padding:0 0 0 5px}.rmdp-arrow{border:solid #0074d9;border-width:0 2px 2px 0;display:inline-block;height:3px;margin-top:5px;padding:2px;width:3px}.rmdp-right i{margin-right:3px;transform:rotate(-45deg);-webkit-transform:rotate(-45deg)}.rmdp-left i{margin-left:3px;transform:rotate(135deg);-webkit-transform:rotate(135deg)}.rmdp-left{left:0}.rmdp-right{right:0}.rmdp-arrow-container{background:transparent;border:none;border-radius:50%;cursor:pointer;display:flex;height:20px;justify-content:center;margin:0 5px;padding:0;width:20px}.rmdp-arrow-container:hover{background-color:#0074d9;box-shadow:0 0 3px #8798ad}.rmdp-arrow-container:hover .rmdp-arrow{border:solid #fff;border-width:0 2px 2px 0}.rmdp-arrow-container.disabled{cursor:default}.rmdp-arrow-container.disabled:hover{background-color:inherit;box-shadow:inherit}.rmdp-arrow-container.disabled .rmdp-arrow,.rmdp-arrow-container.disabled:hover .rmdp-arrow{border:solid gray;border-width:0 2px 2px 0}.rmdp-rtl{direction:rtl}.rmdp-rtl .rmdp-left i{margin-left:0;margin-right:3px;transform:rotate(-45deg);-webkit-transform:rotate(-45deg)}.rmdp-rtl .rmdp-right i{margin-left:3px;margin-right:0;transform:rotate(135deg);-webkit-transform:rotate(135deg)}.rmdp-rtl .rmdp-right{left:0;right:auto}.rmdp-rtl .rmdp-left{left:auto;right:0}.rmdp-rtl .rmdp-range-hover.start:not(.force),.rmdp-rtl .rmdp-range.start:not(.force){border-bottom-left-radius:unset;border-bottom-right-radius:50%;border-top-left-radius:unset;border-top-right-radius:50%}.rmdp-rtl .rmdp-range-hover.end:not(.force),.rmdp-rtl .rmdp-range.end:not(.force){border-bottom-left-radius:50%;border-bottom-right-radius:unset;border-top-left-radius:50%;border-top-right-radius:unset}.rmdp-rtl .rmdp-range.start.end:not(.force){border-radius:50%}.rmdp-rtl .rmdp-ym .rmdp-range-hover.start:not(.force),.rmdp-rtl .rmdp-ym .rmdp-range.start:not(.force){border-bottom-right-radius:15px;border-top-right-radius:15px}.rmdp-rtl .rmdp-ym .rmdp-range-hover.end:not(.force),.rmdp-rtl .rmdp-ym .rmdp-range.end:not(.force){border-bottom-left-radius:15px;border-top-left-radius:15px}.rmdp-day-hidden,.rmdp-day.rmdp-disabled{cursor:default}.rmdp-selected .highlight{box-shadow:0 0 3px #8798ad}.rmdp-day:not(.rmdp-disabled):not(.rmdp-day-hidden) .highlight-red:hover{background-color:#ff6687}.rmdp-day:not(.rmdp-deactive) .highlight-red{color:#cc0303}.rmdp-day.rmdp-deactive .highlight-red{color:#e08e8e}.rmdp-day.rmdp-selected .highlight-red{background-color:#ea0034;color:#fff}.rmdp-day.rmdp-deactive.rmdp-selected .highlight-red{background-color:#e4b0ba;color:#fff}.rmdp-day:not(.rmdp-disabled):not(.rmdp-day-hidden) .highlight-green:hover{background-color:#4db6ac}.rmdp-day:not(.rmdp-deactive) .highlight-green{color:#00796b}.rmdp-day.rmdp-deactive .highlight-green{color:#7ab3ac}.rmdp-day.rmdp-selected .highlight-green{background-color:#009688;color:#fff}.rmdp-day.rmdp-deactive.rmdp-selected .highlight-green{background-color:#749c98;color:#fff}.rmdp-day-hidden,.rmdp-day-hidden:hover span{background-color:unset;color:transparent}.rmdp-month-name{cursor:default;font-size:14px;margin:3px 0}.rmdp-full-year{grid-template-columns:1fr 1fr 1fr}@media (max-height:450px),(max-width:450px){.rmdp-day,.rmdp-week-day{height:28px;width:28px}.rmdp-day span{font-size:12px;padding-left:.5px}.only.rmdp-month-picker,.only.rmdp-year-picker{height:200px;width:230px}.rmdp-header{padding:3px 0 0}.rmdp-header,.rmdp-month-name{font-size:12px}.rmdp-full-year{grid-template-columns:1fr 1fr}}");
  var H2 = ["datePickerProps", "DatePicker"];
  function q(r3, t3) {
    var n3, o3 = r3.value, d3 = r3.calendar, u3 = r3.locale, p3 = r3.format, m4 = r3.onlyMonthPicker, h4 = r3.onlyYearPicker, y3 = r3.range, v3 = void 0 !== y3 && y3, b3 = r3.multiple, x3 = void 0 !== b3 && b3, w3 = r3.className, k3 = r3.role, D3 = r3.weekDays, O3 = r3.months, E3 = r3.children, M3 = r3.onChange, A3 = r3.showOtherDays, R3 = r3.minDate, L3 = r3.maxDate, F3 = r3.mapDays, W3 = r3.disableMonthPicker, B3 = r3.disableYearPicker, z3 = r3.formattingIgnoreList, q2 = r3.onReady, J3 = r3.onlyShowInRangeDates, U3 = void 0 === J3 || J3, $3 = r3.zIndex, G2 = void 0 === $3 ? 100 : $3, Q2 = r3.plugins, X2 = void 0 === Q2 ? [] : Q2, Z2 = r3.sort, ee = r3.numberOfMonths, re = void 0 === ee ? 1 : ee, te = r3.currentDate, ne = r3.digits, ae = r3.buttons, oe = void 0 === ae || ae, ie = r3.renderButton, de = r3.weekStartDayIndex, le = void 0 === de ? 0 : de, ue = r3.disableDayPicker, ce = r3.onPropsChange, se = r3.onMonthChange, fe = r3.onYearChange, pe = r3.onFocusedDateChange, me = r3.readOnly, he = r3.disabled, ye = r3.hideMonth, ge = r3.hideYear, ve = r3.hideWeekDays, be = r3.shadow, xe = void 0 === be || be, we = r3.fullYear, ke = r3.displayWeekNumbers, De = r3.weekNumber, Oe = r3.weekPicker, Ee = r3.rangeHover, Ye = r3.monthYearSeparator, Me = r3.formatMonth, Pe = r3.formatYear, Ne = r3.highlightToday, Se = void 0 === Ne || Ne, Ce = r3.headerOrder, Ie = void 0 === Ce ? ["LEFT_BUTTON", "MONTH_YEAR", "RIGHT_BUTTON"] : Ce, je = r3.style, Te = void 0 === je ? {} : je;
    !te || te instanceof i.default || (console.warn("currentDate must be instance of DateObject"), te = void 0), ("number" != typeof le || le < 0 || le > 6) && (le = 0), ("number" != typeof re || re < 1 || h4) && (re = 1), !(x3 || v3 || g2(o3)) || v3 || x3 || (x3 = true), Oe && (v3 = true, x3 = false), we && (re = 12, m4 = false, h4 = false), h4 && !ye && (ye = true);
    var Ae = f2(V2(d3, u3), 2);
    d3 = Ae[0], u3 = Ae[1], p3 = j(m4, h4, p3), z3 = N2(z3), F3 = [].concat(F3).filter(Boolean), X2 = [].concat.apply([], X2);
    var Re = f2(e2.useState({}), 2), Le = Re[0], Fe = Re[1], Ve = {}, We = e2.useRef({ mustCallOnReady: true, currentDate: te });
    e2.useEffect(function() {
      Fe(function(e3) {
        var r4 = We.current.currentDate, t4 = e3.date, n4 = e3.selectedDate, a3 = e3.initialValue, c5 = e3.focused, s3 = e3.mustSortDates;
        function f3(e4) {
          if (e4) return e4.calendar.name !== d3.name && e4.setCalendar(d3), e4.locale.name !== u3.name && e4.setLocale(u3), e4._format !== p3 && e4.setFormat(p3), e4.digits = ne, e4.ignoreList = JSON.parse(z3), e4;
        }
        function y4(e4) {
          return new i.default(r4 || e4);
        }
        if (o3) if (g2(n4 = K(o3, d3, u3, p3))) t4 || (t4 = y4(n4.flat()[0]));
        else if (t4 && 1 !== re) {
          var b4 = new i.default(t4).toFirstOfMonth(), w4 = new i.default(t4).add(re - 1, m4 ? "years" : "months").toLastOfMonth();
          (n4 < b4 || n4 > w4) && (t4 = new i.default(n4));
        } else t4 = y4(n4);
        else t4 || (t4 = y4({ calendar: d3, locale: u3, format: p3 })), a3 && (n4 = void 0);
        if ([].concat(n4).flat().forEach(f3), f3(t4), x3 || v3 || g2(o3)) {
          if (n4 || (n4 = []), g2(n4) || (n4 = x3 && v3 ? [[n4]] : [n4]), v3 && !x3 && n4.length > 2) {
            var k4 = n4[n4.length - 1];
            n4 = [n4[0], k4], c5 = k4;
          }
          x3 && !v3 && Z2 && !s3 ? (s3 = true, n4.sort(function(e4, r5) {
            return e4 - r5;
          })) : v3 && !x3 && n4.sort(function(e4, r5) {
            return e4 - r5;
          });
        } else g2(n4) && (n4 = n4.flat()[n4.length - 1]);
        return we && t4.toFirstOfYear(), delete We.current.currentDate, l2(l2({}, e3), {}, { date: t4, selectedDate: n4, multiple: x3, range: v3, onlyMonthPicker: m4, onlyYearPicker: h4, initialValue: e3.initialValue || o3, value: o3, focused: c5, calendar: d3, locale: u3, format: p3, mustSortDates: s3, year: t4.year, today: f3(e3.today) || new i.default({ calendar: d3 }), weekPicker: Oe });
      });
    }, [o3, d3, u3, p3, m4, h4, v3, x3, Z2, re, ne, z3, we, Oe]), e2.useEffect(function() {
      (R3 || L3) && Fe(function(e3) {
        var r4 = e3.calendar, t4 = e3.locale, n4 = e3.format, a3 = function(e4, r5, t5, n5, a4) {
          r5 && (r5 = T2(r5, n5, a4).set({ hour: 0, minute: 0, second: 0, millisecond: 0 }));
          t5 && (t5 = T2(t5, n5, a4).set({ hour: 23, minute: 59, second: 59, millisecond: 999 }));
          g2(e4) && (e4 = e4.filter(function(e5) {
            return !(r5 && e5 < r5) && !(t5 && e5 > t5);
          }));
          return [e4, r5, t5];
        }(K(o3, r4, t4, n4), R3, L3, r4, n4), i2 = f2(a3, 3), d4 = i2[0], u4 = i2[1], c5 = i2[2];
        return l2(l2({}, e3), {}, { inRangeDates: U3 ? d4 : e3.selectedDate, minDate: u4, maxDate: c5 });
      });
    }, [R3, L3, U3, o3]), Le.today && !We.current.isReady && (We.current.isReady = true), e2.useEffect(function() {
      We.current.isReady && We.current.mustCallOnReady && q2 instanceof Function && (We.current.mustCallOnReady = false, q2());
    }, [We.current.isReady, q2]);
    var Be = "rmdp-top-class " + Ze(["top", "bottom"]), _e = { top: [], bottom: [], left: [], right: [] }, ze = _2(null === (n3 = Le.date) || void 0 === n3 ? void 0 : n3.locale), He = { state: Le, setState: Fe, onChange: $e, sort: Z2, handleFocusedDate: Qe, isRTL: ze, fullYear: we, monthAndYears: function() {
      var e3 = Le.date;
      if (!e3) return [];
      for (var r4 = [], t4 = [], n4 = e3.digits, a3 = 0; a3 < re; a3++) {
        var o4 = void 0, i2 = e3.year, d4 = e3.monthIndex + a3;
        if (m4 && (i2 += a3), d4 > 11 && (d4 -= 12, m4 || i2++), g2(O3) && O3.length >= 12) {
          var l3 = O3[d4];
          o4 = g2(l3) ? l3[0] : l3;
        } else o4 = e3.months[d4].name;
        i2 = C2(i2.toString(), n4), r4.push(o4), t4.push(i2);
      }
      return [r4, t4];
    }(), rangeHover: Ee, highlightToday: Se, numberOfMonths: re }, qe = arguments[0], Je = qe.datePickerProps, Ke = qe.DatePicker, Ue = s2(qe, H2);
    return function() {
      if (!We.current.isReady || !g2(X2)) return;
      var r4 = { state: Le, setState: Fe, registerListener: er, calendarProps: Ue, datePickerProps: Je, handleChange: $e, Calendar: We.current.Calendar, DatePicker: Ke, handlePropsChange: Ge, handleFocusedDate: function(e3) {
        return Qe(e3);
      }, minDate: R3, maxDate: L3 }, t4 = function(e3) {
        return ue ? "bottom" : e3.props.position || "right";
      };
      X2.forEach(function(n4, a3) {
        if ("string" != typeof n4.type) {
          var o4 = {}, i2 = t4(n4);
          if (_e[i2] && !n4.props.disabled) {
            for (var d4 = 0; d4 < X2.length; d4++) if ("string" != typeof X2[d4].type && !X2[d4].props.disabled) {
              if (4 === Object.keys(o4).length) break;
              var u4 = t4(X2[d4]);
              ["top", "bottom"].includes(i2) ? (u4 === i2 && d4 > a3 && (o4.bottom = true), u4 === i2 && d4 < a3 && (o4.top = true)) : (Be.includes("border-top") && (o4.top = true), Be.includes("border-bottom") && (o4.bottom = true), u4 === i2 && d4 > a3 && (o4.right = true), u4 === i2 && d4 < a3 && (o4.left = true));
            }
            _e[i2].push(e2.cloneElement(n4, l2({ key: a3, position: i2, nodes: o4 }, r4)));
          }
        } else "mapDays" === n4.type && F3.push(n4.fn(r4));
      });
    }(), Le.today ? a2.default.createElement("div", { ref: function(e3) {
      e3 && (e3.date = Le.date, e3.set = function(e4, r4) {
        he || Fe(l2(l2({}, Le), {}, { date: new i.default(Le.date.set(e4, r4)) }));
      });
      if (We.current.Calendar = e3, t3 instanceof Function) return t3(e3);
      t3 && (t3.current = e3);
    }, role: k3 || "dialog", className: "rmdp-wrapper rmdp-".concat(xe ? "shadow" : "border", " ").concat(w3 || ""), style: l2({ zIndex: G2 }, Te) }, _e.top, a2.default.createElement("div", { style: { display: "flex" }, className: Be }, _e.left, !ue && a2.default.createElement("div", { className: "rmdp-calendar ".concat(ze ? "rmdp-rtl" : "", " ").concat(Ze(["left", "right"])) }, a2.default.createElement(P2, l2(l2({}, He), {}, { disableYearPicker: B3, disableMonthPicker: W3, buttons: oe, renderButton: ie, handleMonthChange: Xe, disabled: he, hideMonth: ye, hideYear: ge, monthYearSeparator: Ye, formatMonth: Me, formatYear: Pe, headerOrder: Ie })), a2.default.createElement("div", { style: { position: "relative" } }, a2.default.createElement(Y2, l2(l2({}, He), {}, { showOtherDays: A3, mapDays: F3, onlyShowInRangeDates: U3, customWeekDays: D3, weekStartDayIndex: le, hideWeekDays: ve, displayWeekNumbers: ke, weekNumber: De })), !we && a2.default.createElement(a2.default.Fragment, null, !W3 && a2.default.createElement(S2, c4({}, He, { customMonths: O3, handleMonthChange: Xe })), !B3 && a2.default.createElement(I2, c4({}, He, { onYearChange: fe }))))), _e.right), _e.bottom, E3) : null;
    function $e(e3, r4) {
      if (e3 instanceof i.default && (e3 = new i.default(e3)), !he) {
        if (e3 || null === e3) {
          if (me) return;
          Ve.change && Ve.change.forEach(function(r5) {
            return r5(e3);
          });
        }
        if (e3 || null === e3) {
          var t4 = null == M3 ? void 0 : M3(e3);
          r4 && false !== t4 && Fe(r4);
        } else r4 && Fe(r4);
        Ge({ value: e3 });
      }
    }
    function Ge() {
      var e3, r4 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
      if (!me && !he) {
        var t4 = l2(l2(l2(l2({}, Ue), Je), r4), {}, { value: null !== (e3 = r4.value) && void 0 !== e3 ? e3 : Le.selectedDate });
        delete t4.onPropsChange, null == ce || ce(t4);
      }
    }
    function Qe(e3, r4) {
      me || he || null == pe || pe(e3, r4);
    }
    function Xe(e3) {
      null == se || se(e3);
    }
    function Ze(e3) {
      return ue || !g2(X2) ? "" : Array.from(new Set(X2.map(function(r4) {
        if (!r4.props) return "";
        var t4 = r4.props.position || "right";
        return e3.includes(t4) && !r4.props.disabled ? "rmdp-border-" + t4 : "";
      }))).join(" ");
    }
    function er(e3, r4) {
      Ve[e3] || (Ve[e3] = []), Ve[e3].push(r4);
    }
  }
  var J2 = e2.forwardRef(q);
  function K(e3, r3, t3, n3) {
    var a3 = [].concat(e3).map(function(e4) {
      return g2(e4) ? e4.map(o3).filter(d3) : o3(e4);
    }).filter(d3);
    return g2(e3) ? a3 : a3.flat()[0];
    function o3(e4) {
      return e4 ? e4 instanceof i.default ? e4 : new i.default({ date: e4, calendar: r3, locale: t3, format: n3 }) : {};
    }
    function d3(e4) {
      return g2(e4) || e4.isValid;
    }
  }
  z2('.rmdp-visible{visibility:visible}.rmdp-invisible{visibility:hidden}.rmdp-input{border:1px solid #c0c4d6;border-radius:5px;height:22px;margin:1px 0;padding:2px 5px}.rmdp-input:focus{border:1px solid #a4b3c5;box-shadow:0 0 2px #a4b3c5;outline:none!important}.rmdp-button{background-color:#0074d9;border:none;border-radius:5px;color:#fff;cursor:pointer;display:inline-block;padding:7px 16px;text-align:center;text-decoration:none;transition:.3s}.rmdp-button:hover{background-color:#143ac5;transition:.4s}.rmdp-button:disabled{background-color:#8798ad}.rmdp-action-button{border-radius:unset;color:#2682d3;float:right;font-weight:700;margin:15px 10px 15px 0}.rmdp-action-button,.rmdp-action-button:hover{background-color:transparent}.rmdp-ep-arrow{overflow:hidden;will-change:transform}.rmdp-ep-arrow:after{background-color:#fff;content:"";height:12px;position:absolute;transform:rotate(45deg);width:12px}.rmdp-ep-shadow:after{box-shadow:0 0 6px #8798ad}.rmdp-ep-border:after{border:1px solid #cfd8e2}.rmdp-ep-arrow[direction=top]{border-bottom:1px solid #fff}.rmdp-ep-arrow[direction=left]{border-right:1px solid #fff}.rmdp-ep-arrow[direction=right]{border-left:1px solid #fff;margin-left:-1px}.rmdp-ep-arrow[direction=bottom]{border-top:1px solid #fff;margin-top:-1.5px}.rmdp-ep-arrow[direction=top]:after{left:4px;top:5px}.rmdp-ep-arrow[direction=bottom]:after{left:4px;top:-6px}.rmdp-ep-arrow[direction=left]:after{left:5px;top:3px}.rmdp-ep-arrow[direction=right]:after{left:-6px;top:3px}');
  var U2 = ["value", "calendar", "locale", "format", "onlyMonthPicker", "onlyYearPicker", "onChange", "range", "multiple", "name", "id", "title", "placeholder", "required", "style", "className", "inputClass", "disabled", "render", "weekDays", "months", "children", "inputMode", "scrollSensitive", "hideOnScroll", "minDate", "maxDate", "formattingIgnoreList", "containerClassName", "calendarPosition", "editable", "onOpen", "onClose", "arrowClassName", "zIndex", "arrow", "fixMainPosition", "onPositionChange", "onPropsChange", "digits", "readOnly", "shadow", "onFocusedDateChange", "type", "weekPicker", "mobileLabels", "onOpenPickNewDate", "mobileButtons", "dateSeparator", "multipleRangeSeparator", "typingTimeout"], $2 = ["label"];
  function G(r3, t3) {
    var n3 = r3.value, d3 = r3.calendar, u3 = r3.locale, p3 = r3.format, m4 = r3.onlyMonthPicker, h4 = r3.onlyYearPicker, v3 = r3.onChange, b3 = r3.range, x3 = void 0 !== b3 && b3, w3 = r3.multiple, k3 = void 0 !== w3 && w3, D3 = r3.name, O3 = r3.id, E3 = r3.title, Y3 = r3.placeholder, M3 = r3.required, P4 = r3.style, S3 = void 0 === P4 ? {} : P4, I3 = r3.className, A3 = void 0 === I3 ? "" : I3, R3 = r3.inputClass, L3 = r3.disabled, F3 = r3.render, W3 = r3.weekDays, z3 = r3.months, H3 = r3.children, q2 = r3.inputMode, K2 = r3.scrollSensitive, G2 = void 0 === K2 || K2, Q2 = r3.hideOnScroll, ee = r3.minDate, re = r3.maxDate, te = r3.formattingIgnoreList, ne = r3.containerClassName, ae = void 0 === ne ? "" : ne, oe = r3.calendarPosition, ie = void 0 === oe ? "bottom-left" : oe, de = r3.editable, le = void 0 === de || de, ue = r3.onOpen, ce = r3.onClose, se = r3.arrowClassName, fe = void 0 === se ? "" : se, pe = r3.zIndex, me = void 0 === pe ? 100 : pe, he = r3.arrow, ye = void 0 === he || he, ge = r3.fixMainPosition, ve = r3.onPositionChange, be = r3.onPropsChange, xe = r3.digits, we = r3.readOnly, ke = r3.shadow, De = void 0 === ke || ke, Oe = r3.onFocusedDateChange, Ee = r3.type, Ye = r3.weekPicker, Me = r3.mobileLabels, Pe = r3.onOpenPickNewDate, Ne = void 0 === Pe || Pe, Se = r3.mobileButtons, Ce = void 0 === Se ? [] : Se, Ie = r3.dateSeparator, je = r3.multipleRangeSeparator, Te = void 0 === je ? "," : je, Ae = r3.typingTimeout, Re = void 0 === Ae ? 700 : Ae, Le = s2(r3, U2), Fe = f2(e2.useState(), 2), Ve = Fe[0], We = Fe[1], Be = f2(e2.useState(), 2), _e = Be[0], ze = Be[1], He = f2(e2.useState(""), 2), qe = He[0], Je = He[1], Ke = f2(e2.useState(false), 2), Ue = Ke[0], $e = Ke[1], Ge = f2(e2.useState(false), 2), Qe = Ge[0], Xe = Ge[1], Ze = e2.useRef(), er = e2.useRef(), rr = e2.useRef(), tr = e2.useRef({ isTyping: false }), nr = Ie || (x3 || Ye ? " ~ " : ", "), ar = arguments[0], or = "string" == typeof A3 && A3.includes("rmdp-mobile"), ir = e2.useCallback(function() {
      if (false !== (null == ce ? void 0 : ce())) {
        var e3 = Z(er);
        if (e3 && e3.forEach(function(e4) {
          return e4.blur();
        }), tr.current.mobile) {
          var r4 = rr.current.parentNode.parentNode;
          r4.classList.remove("rmdp-calendar-container-mobile"), r4.style.position = "absolute", r4.style.visibility = "hidden";
        }
        void 0 !== tr.current.validInputValue && (Je(tr.current.validInputValue), tr.current.validInputValue = void 0), $e(false), Xe(false);
      }
    }, [ce]), dr = [{ type: "button", className: "rmdp-button rmdp-action-button", onClick: function() {
      ze(void 0), ir();
    }, label: cr("CANCEL") }, { type: "button", className: "rmdp-button rmdp-action-button", onClick: function() {
      _e && (pr(_e, true), ze(void 0)), ir();
    }, label: cr("OK") }];
    or && !tr.current.mobile && (tr.current = l2(l2({}, tr.current), {}, { mobile: true })), !or && tr.current.mobile && (tr.current = l2(l2({}, tr.current), {}, { mobile: false })), te = N2(te), p3 = j(m4, h4, p3);
    var lr, ur = f2(V2(d3, u3), 2);
    return d3 = ur[0], u3 = ur[1], e2.useEffect(function() {
      function e3(e4) {
        if (Ue && !tr.current.mobile) {
          var r5 = [];
          if ([er.current, rr.current].forEach(function(t4) {
            var n4, a3;
            !t4 || t4.contains(e4.target) || e4.target.classList.contains("b-deselect") || null !== (n4 = e4.target.parentNode) && void 0 !== n4 && null !== (n4 = n4.classList) && void 0 !== n4 && null !== (a3 = n4.contains) && void 0 !== a3 && a3.call(n4, "b-deselect") || r5.push(t4);
          }), 2 === r5.length) return ir();
          rr.current && rr.current.contains(e4.target) && (Ze.current.removeTransition(), Ze.current.refreshPosition());
        }
      }
      function r4() {
        Q2 && Ue && ir();
      }
      return document.addEventListener("click", e3, false), document.addEventListener("scroll", r4, true), function() {
        document.removeEventListener("click", e3, false), document.removeEventListener("scroll", r4, true);
      };
    }, [ir, t3, Ue, Q2]), e2.useEffect(function() {
      var e3 = n3, r4 = tr.current, t4 = r4.date, a3 = r4.initialValue, o3 = function() {
        return e3[e3.length - 1];
      };
      function c5(e4) {
        if (e4) return e4 instanceof i.default || (e4 = new i.default({ date: e4, calendar: d3, locale: u3, format: p3 })), e4.calendar !== d3 && e4.setCalendar(d3), e4.set({ weekDays: W3, months: z3, digits: xe, locale: u3, format: p3, ignoreList: JSON.parse(te) }), e4;
      }
      n3 || a3 || !t4 ? a3 && !n3 && (a3 = void 0) : e3 = t4;
      var s3 = "";
      if (x3 || k3 || g2(e3)) {
        var m5 = function(e4) {
          return e4 = e4.map(c5).filter(function(e5) {
            return void 0 !== e5;
          }), x3 && e4.length > 2 && (e4 = [e4[0], o3()]), [e4, X(e4, nr)];
        };
        if (g2(e3) || (e3 = x3 && k3 ? e3 ? [[e3]] : [] : [e3]), k3 && x3) e3 = e3.map(function(r5, t5) {
          var n4 = f2(m5(g2(r5) ? r5 : [r5]), 2), a4 = n4[0], o4 = n4[1];
          return s3 += o4 + (t5 < e3.length - 1 ? " ".concat(Te, " ") : ""), a4;
        });
        else {
          var h5 = f2(m5(e3), 2);
          e3 = h5[0], s3 = h5[1];
        }
        s3 = s3.toString().replace(/\s,\s$/, "");
      } else g2(e3) && (e3 = o3()), (e3 = c5(e3)) && (s3 = e3.format());
      tr.current.isTyping || Je(s3), tr.current = l2(l2({}, tr.current), {}, { date: e3, separator: nr, initialValue: a3 || n3 }), tr.current.mobile && Ze.current.isOpen ? ze(e3) : We(e3);
    }, [n3, d3, u3, p3, x3, k3, nr, m4, h4, W3, z3, xe, te]), e2.useEffect(function() {
      var e3 = tr.current.selection;
      if (e3) {
        var r4 = Z(er);
        0 !== r4.length && (r4.forEach(function(r5) {
          document.activeElement === r5 && (r5.setSelectionRange(e3, e3), tr.current.selection = void 0);
        }), Ze.current.refreshPosition());
      }
    }, [qe]), (k3 || x3 || g2(Ve) || !le) && (q2 = "none"), a2.default.createElement(o2.default, c4({ ref: function(e3) {
      e3 && (e3.openCalendar = function() {
        return setTimeout(function() {
          return sr();
        }, 10);
      }, e3.closeCalendar = ir, e3.isOpen = Ue && Qe);
      if (Ze.current = e3, t3 instanceof Function) return t3(e3);
      t3 && (t3.current = e3);
    }, element: F3 ? a2.default.createElement("div", { ref: er }, e2.isValidElement(F3) ? e2.cloneElement(F3, { value: qe, openCalendar: sr, onFocus: sr, handleValueChange: mr, onChange: mr, locale: u3, separator: nr }) : F3 instanceof Function ? F3(qe, sr, mr, u3, nr) : null) : a2.default.createElement("input", { ref: er, type: Ee || "text", name: D3, id: O3, title: E3, required: M3, onFocus: sr, className: R3 || "rmdp-input", placeholder: Y3, value: qe, onChange: mr, style: S3, autoComplete: "off", disabled: !!L3, inputMode: q2 || (or ? "none" : void 0), readOnly: we }), popper: Ue && a2.default.createElement(J2, c4({ ref: rr, value: _e || Ve, onChange: pr, range: x3, multiple: k3, calendar: d3, locale: u3, format: p3, onlyMonthPicker: m4, onlyYearPicker: h4, className: A3 + (or ? " rmdp-mobile" : ""), weekDays: W3, months: z3, digits: xe, minDate: ee, maxDate: re, formattingIgnoreList: JSON.parse(te), onPropsChange: be, shadow: De, onReady: hr, DatePicker: Ze.current, datePickerProps: ar, onFocusedDateChange: yr, weekPicker: Ye }, Le), H3, or && (lr = [].concat.apply([], ar.plugins || []).some(function(e3) {
      var r4 = e3.props;
      return !(void 0 === r4 ? {} : r4).disabled;
    }), g2(Ce) && a2.default.createElement("div", { className: "rmdp-action-buttons ".concat(_2(u3) ? "rmdp-rtl" : "", " ").concat(lr ? "rmdp-border-top" : "") }, Ce.concat(dr).map(function(e3, r4) {
      var t4 = e3.label, n4 = s2(e3, $2);
      return a2.default.createElement("button", c4({ key: r4 }, n4), t4);
    })))), active: !or && Qe, position: ie, arrow: !or && ye, fixMainPosition: !G2 || ge, zIndex: me, onChange: !or && ve, containerClassName: "rmdp-container ".concat(ae), arrowClassName: ["rmdp-ep-arrow", "rmdp-ep-".concat(De ? "shadow" : "border"), A3, fe].join(" ") }, Le));
    function cr(e3) {
      var r4, t4 = u3 || new i.default().locale;
      if ("string" != typeof t4.name) return e3;
      return (null == Me ? void 0 : Me[e3]) || (null === (r4 = { en: { OK: "OK", CANCEL: "CANCEL" }, fa: { OK: "تأیید", CANCEL: "لغو" }, ar: { OK: "تأكيد", CANCEL: "الغاء" }, hi: { OK: "पुष्टि", CANCEL: "रद्द करें" } }[B2(t4)]) || void 0 === r4 ? void 0 : r4[e3]) || e3;
    }
    function sr() {
      if (!L3 && !we && false !== (null == ue ? void 0 : ue())) {
        if (Ne && !n3 && !tr.current.date && !x3 && !k3 && !or) {
          var e3 = new i.default({ calendar: d3, locale: u3, format: p3, months: z3, weekDays: W3, digits: xe, ignoreList: JSON.parse(te) });
          (!ee || e3 > T2(ee, d3, p3)) && (!re || e3 < T2(re, d3, p3)) && (pr(e3), null == be || be(l2(l2({}, ar), {}, { value: e3 })), tr.current.date = e3);
        }
        var r4 = Z(er);
        or && r4.length > 0 && r4.forEach(function(e4) {
          return e4.blur();
        }), r4.length > 0 || !Ue ? $e(true) : ir();
      }
    }
    function fr(e3) {
      var r4 = "";
      return e3 && (r4 = k3 && x3 && g2(e3) ? e3.map(function(e4) {
        return X(e4, nr);
      }).join(" ".concat(Te, " ")) : X(e3, nr)), r4;
    }
    function pr(e3, r4, t4) {
      if (or && !r4) return ze(e3);
      var a3 = fr(e3), o3 = t4 || a3.toString().replace(/\s,\s$/, "");
      return e3 && [].concat(e3).flat().some(function(e4) {
        return ee && e4 < T2(ee, d3, p3) || re && e4 > T2(re, d3, p3);
      }) ? (tr.current.validInputValue = fr(n3 || tr.current.date), Je(o3)) : (tr.current.validInputValue = a3, false === (null == v3 ? void 0 : v3(e3, { validatedValue: a3, input: er.current, isTyping: !!t4 })) ? (Je(qe), false) : (We(e3), Je(o3), void (tr.current = l2(l2({}, tr.current), {}, { date: e3 }))));
    }
    function mr(e3) {
      if (le) {
        tr.current.isTyping = true, setTimeout(function() {
          tr.current.isTyping = false;
        }, Re), tr.current.selection = e3.target.selectionStart;
        var r4 = e3.target.value, t4 = { calendar: d3, locale: u3, format: p3, ignoreList: JSON.parse(te) };
        if (xe = g2(xe) ? xe : u3.digits, !r4) return Je(""), pr(null);
        if (xe) {
          var n4, a3, o3 = y2(xe);
          try {
            for (o3.s(); !(n4 = o3.n()).done; ) {
              var c5 = n4.value;
              r4 = r4.replace(new RegExp(c5, "g"), xe.indexOf(c5));
            }
          } catch (e4) {
            o3.e(e4);
          } finally {
            o3.f();
          }
          a3 = g2(Ve) ? k3 && x3 ? (r4 || "").split(Te).filter(Boolean).map(f3) : f3(r4) : s3(r4), pr(g2(Ve) || a3.isValid ? a3 : null, void 0, C2(r4, xe));
        }
      }
      function s3(e4) {
        return /(?=.*Y)(?=.*M)(?=.*D)/.test(p3) ? new i.default(l2(l2({}, t4), {}, { date: e4 })) : new i.default(t4).parse(e4);
      }
      function f3(e4) {
        return (e4 || "").split(nr).filter(Boolean).map(function(e5) {
          return s3(e5.trim());
        });
      }
    }
    function hr() {
      if (Xe(true), or) {
        var e3 = rr.current.parentNode.parentNode;
        e3.className = "rmdp-calendar-container-mobile", e3.style.position = "fixed", e3.style.transform = "", setTimeout(function() {
          e3.style.visibility = "visible";
        }, 50);
      }
    }
    function yr(e3, r4) {
      g2(tr.current.date) || !r4 || or || ir(), null == Oe || Oe(e3, r4);
    }
  }
  var Q = e2.forwardRef(G);
  function X(e3, r3) {
    var t3 = [].concat(e3).map(function(e4) {
      return null != e4 && e4.isValid ? e4.format() : "";
    });
    return t3.toString = function() {
      return this.filter(Boolean).join(r3);
    }, t3;
  }
  function Z(e3) {
    return e3.current ? "INPUT" === e3.current.tagName ? [e3.current] : Array.from(e3.current.querySelectorAll("input")) : [];
  }
  Object.defineProperty(exports, "DateObject", { enumerable: true, get: function() {
    return i.default;
  } }), exports.Calendar = J2, exports.default = Q, exports.getAllDatesInRange = function() {
    var e3 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], r3 = arguments.length > 1 ? arguments[1] : void 0;
    if (!Array.isArray(e3)) return [];
    var t3 = e3[0], n3 = e3[e3.length - 1], a3 = [];
    if (!(t3 instanceof i.default && n3 instanceof i.default && t3.isValid && n3.isValid && !(t3 > n3))) return [];
    for (t3 = new i.default(t3), n3 = new i.default(n3); t3 <= n3; t3.day++) a3.push(r3 ? t3.toDate() : new i.default(t3));
    return a3;
  }, exports.toDateObject = T2;
})(build);
const DatePicker = /* @__PURE__ */ getDefaultExportFromCjs(build);
const classType$1 = {
  "default": inputDefault$2,
  "correct": inputCorrect$2,
  "error": inputError$2
};
function DatePickerInput({ name, label, placeholder, value, onChange: onChange2, typeClass = "default", format = "dd/MM/YYYY", error, options: options2, disabled = false }) {
  const CorrectedTypeClass = error ? classType$1.error : classType$1[typeClass];
  return /* @__PURE__ */ React__default.createElement(
    DatePicker,
    {
      ...options2,
      value,
      onChange: (date) => {
        var _a2;
        if (!Array.isArray(date))
          onChange2 == null ? void 0 : onChange2((date == null ? void 0 : date.isValid) ? date.format(format) : "");
        else
          onChange2 == null ? void 0 : onChange2(((_a2 = date[0]) == null ? void 0 : _a2.isValid) ? date[0].format(format) : "");
      },
      disabled,
      format,
      render: (valueDate, openCalendar, handleValueChange) => {
        return /* @__PURE__ */ React__default.createElement("div", { className: box$2 }, /* @__PURE__ */ React__default.createElement("div", { className: frameWrapper$2 }, /* @__PURE__ */ React__default.createElement("div", { className: classNames$1(frame$2, CorrectedTypeClass), onClick: openCalendar }, /* @__PURE__ */ React__default.createElement("div", { className: textWrapper$2 }, label), /* @__PURE__ */ React__default.createElement(
          "input",
          {
            placeholder,
            type: "text",
            id: "input" + name,
            className: classNames$1(inputBox$2, disabled && disabledInput),
            value: valueDate,
            onChange: handleValueChange,
            disabled
          }
        ), /* @__PURE__ */ React__default.createElement(Icon$2, { icon: "Calendrier2", size: 20, className: inputIcon$1 })), error && /* @__PURE__ */ React__default.createElement("span", { className: inputError$2 }, error)));
      },
      containerClassName: datePickerWrapper$1
    }
  );
}
const useEffectOnce = (effect) => {
  const effectFn = useRef(effect);
  const destroyFn = useRef();
  const effectCalled = useRef(false);
  const rendered = useRef(false);
  const [, setVal] = useState(0);
  if (effectCalled.current) {
    rendered.current = true;
  }
  useEffect(() => {
    if (!effectCalled.current) {
      destroyFn.current = effectFn.current();
      effectCalled.current = true;
    }
    setVal((val) => val + 1);
    return () => {
      if (!rendered.current) {
        return;
      }
      if (destroyFn.current) {
        destroyFn.current();
      }
    };
  }, []);
};
const useForwardRef = (ref, initialValue = null) => {
  const targetRef = useRef(initialValue);
  useEffect(() => {
    if (!ref) return;
    if (typeof ref === "function") {
      ref(targetRef.current);
    } else {
      ref.current = targetRef.current;
    }
  }, [ref]);
  return targetRef;
};
var Type = "_15iy4n01";
const DEFAULT_SPEED = 40;
const OP_CODE_DELETION = "DELETE";
const OP_CODE_WRITING = "WRITING";
async function type$1(node2, splitter, speed, deletionSpeed, omitDeletionAnimation, ...args) {
  for (const arg of args) {
    switch (typeof arg) {
      case "string":
        await edit(node2, splitter, arg, speed, deletionSpeed, omitDeletionAnimation);
        break;
      case "number":
        await wait(arg);
        break;
      case "function":
        await arg(node2, splitter, speed, deletionSpeed, omitDeletionAnimation, ...args);
        break;
    }
  }
}
async function edit(node2, splitter, text, speed, deletionSpeed, omitDeletionAnimation) {
  const nodeContent = node2.textContent || "";
  const overlap = getOverlap(nodeContent, text);
  await perform(
    node2,
    [...deleter(nodeContent, splitter, overlap), ...writer(text, splitter, overlap)],
    speed,
    deletionSpeed,
    omitDeletionAnimation
  );
}
async function wait(ms) {
  await new Promise((resolve2) => setTimeout(resolve2, ms));
}
async function perform(node2, edits, speed, deletionSpeed, omitDeletionAnimation) {
  let filteredEdits = edits;
  if (omitDeletionAnimation) {
    let slicePoint = 0;
    for (let i = 1; i < edits.length; i++) {
      const [prev2, curr] = [edits[i - 1], edits[i]];
      if (curr.length > prev2.length || curr === "") {
        slicePoint = i;
        break;
      }
    }
    filteredEdits = edits.slice(slicePoint, edits.length);
  }
  for (const op of editor(filteredEdits)) {
    const waitingTime = op.opCode(node2) === OP_CODE_WRITING ? speed + speed * (Math.random() - 0.5) : deletionSpeed + deletionSpeed * (Math.random() - 0.5);
    op.op(node2);
    await wait(waitingTime);
  }
}
function* editor(edits) {
  for (const snippet of edits) {
    yield {
      op: (node2) => requestAnimationFrame(() => node2.textContent = snippet),
      opCode: (node2) => {
        const nodeContent = node2.textContent || "";
        return snippet === "" || nodeContent.length > snippet.length ? OP_CODE_DELETION : OP_CODE_WRITING;
      }
    };
  }
}
function* writer(text, splitter, startIndex = 0) {
  const splitText = splitter(text);
  const endIndex = splitText.length;
  while (startIndex < endIndex) {
    yield splitText.slice(0, ++startIndex).join("");
  }
}
function* deleter(text, splitter, startIndex = 0) {
  const splitText = splitter(text);
  let endIndex = splitText.length;
  while (endIndex > startIndex) {
    yield splitText.slice(0, --endIndex).join("");
  }
}
function getOverlap(start, [...end]) {
  return [...start, NaN].findIndex((char2, i) => end[i] !== char2);
}
const TypeAnimation = forwardRef(
  ({
    sequence,
    repeat,
    className,
    speed = DEFAULT_SPEED,
    deletionSpeed,
    omitDeletionAnimation = false,
    preRenderFirstString = false,
    wrapper: wrapper2 = "span",
    splitter = (text) => [...text],
    cursor: cursor2 = true,
    style,
    ...rest
  }, ref) => {
    const { "aria-label": ariaLabel, "aria-hidden": ariaHidden, role } = rest;
    if (!deletionSpeed) {
      deletionSpeed = speed;
    }
    const normalizedSpeeds = new Array(2).fill(DEFAULT_SPEED);
    [speed, deletionSpeed].forEach((s2, i) => {
      switch (typeof s2) {
        case "number":
          normalizedSpeeds[i] = Math.abs(s2 - 100);
          break;
        case "object": {
          const { type: speedType, value } = s2;
          if (speedType === "keyStrokeDelayInMs") {
            normalizedSpeeds[i] = value;
          }
          break;
        }
      }
    });
    const keyStrokeDelayTyping = normalizedSpeeds[0];
    const keyStrokeDelayDeleting = normalizedSpeeds[1];
    const typeRef = useForwardRef(ref);
    const baseStyle = Type;
    let finalClassName;
    if (className) {
      finalClassName = `${cursor2 ? baseStyle + " " : ""}${className}`;
    } else {
      finalClassName = cursor2 ? baseStyle : "";
    }
    useEffectOnce(() => {
      let seq = sequence;
      let tl;
      if (repeat === Infinity) {
        tl = type$1;
      } else if (typeof repeat === "number") {
        seq = Array(1 + repeat).fill(sequence).flat();
      }
      const restArgs = tl ? [...seq, tl] : [...seq];
      type$1(
        typeRef.current,
        splitter,
        keyStrokeDelayTyping,
        keyStrokeDelayDeleting,
        omitDeletionAnimation,
        ...restArgs
      );
      return () => {
        return typeRef.current;
      };
    });
    const WrapperEl = wrapper2;
    const preRenderedChildren = preRenderFirstString ? sequence.find((el) => typeof el === "string") || "" : null;
    return /* @__PURE__ */ React__default.createElement(
      WrapperEl,
      {
        "aria-hidden": ariaHidden,
        "aria-label": ariaLabel,
        role,
        style,
        className: finalClassName,
        children: ariaLabel ? /* @__PURE__ */ React__default.createElement(
          "span",
          {
            "aria-hidden": "true",
            ref: typeRef,
            children: preRenderedChildren
          }
        ) : preRenderedChildren,
        ref: ariaLabel ? void 0 : typeRef
      }
    );
  }
);
const TypeAnimation$1 = memo(TypeAnimation, (_2, __) => {
  return true;
});
var Slider$1 = "rxz2mw1";
var Slide = "rxz2mw2";
var SlideTrack = "rxz2mw3";
const Carousel = ({ children }) => {
  let duplicate = Math.floor(14 / children.length);
  let nodes = children;
  for (let i = 0; i < duplicate; i++) {
    nodes = nodes.concat(children.map((c4) => {
      return cloneElement(c4, { key: c4.key + "d" + i, ...c4.props });
    }));
  }
  return /* @__PURE__ */ React__default.createElement("div", { className: Slider$1 }, /* @__PURE__ */ React__default.createElement("div", { className: SlideTrack }, nodes.map((item) => {
    return /* @__PURE__ */ React__default.createElement("div", { className: Slide, key: item == null ? void 0 : item.key }, item);
  })));
};
/*!
 * @kurkle/color v0.3.2
 * https://github.com/kurkle/color#readme
 * (c) 2023 Jukka Kurkela
 * Released under the MIT License
 */
function round$1(v2) {
  return v2 + 0.5 | 0;
}
const lim = (v2, l2, h3) => Math.max(Math.min(v2, h3), l2);
function p2b(v2) {
  return lim(round$1(v2 * 2.55), 0, 255);
}
function n2b(v2) {
  return lim(round$1(v2 * 255), 0, 255);
}
function b2n(v2) {
  return lim(round$1(v2 / 2.55) / 100, 0, 1);
}
function n2p(v2) {
  return lim(round$1(v2 * 100), 0, 100);
}
const map$1 = { 0: 0, 1: 1, 2: 2, 3: 3, 4: 4, 5: 5, 6: 6, 7: 7, 8: 8, 9: 9, A: 10, B: 11, C: 12, D: 13, E: 14, F: 15, a: 10, b: 11, c: 12, d: 13, e: 14, f: 15 };
const hex = [..."0123456789ABCDEF"];
const h1 = (b2) => hex[b2 & 15];
const h2 = (b2) => hex[(b2 & 240) >> 4] + hex[b2 & 15];
const eq = (b2) => (b2 & 240) >> 4 === (b2 & 15);
const isShort = (v2) => eq(v2.r) && eq(v2.g) && eq(v2.b) && eq(v2.a);
function hexParse(str) {
  var len = str.length;
  var ret;
  if (str[0] === "#") {
    if (len === 4 || len === 5) {
      ret = {
        r: 255 & map$1[str[1]] * 17,
        g: 255 & map$1[str[2]] * 17,
        b: 255 & map$1[str[3]] * 17,
        a: len === 5 ? map$1[str[4]] * 17 : 255
      };
    } else if (len === 7 || len === 9) {
      ret = {
        r: map$1[str[1]] << 4 | map$1[str[2]],
        g: map$1[str[3]] << 4 | map$1[str[4]],
        b: map$1[str[5]] << 4 | map$1[str[6]],
        a: len === 9 ? map$1[str[7]] << 4 | map$1[str[8]] : 255
      };
    }
  }
  return ret;
}
const alpha = (a2, f2) => a2 < 255 ? f2(a2) : "";
function hexString(v2) {
  var f2 = isShort(v2) ? h1 : h2;
  return v2 ? "#" + f2(v2.r) + f2(v2.g) + f2(v2.b) + alpha(v2.a, f2) : void 0;
}
const HUE_RE = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function hsl2rgbn(h3, s2, l2) {
  const a2 = s2 * Math.min(l2, 1 - l2);
  const f2 = (n2, k2 = (n2 + h3 / 30) % 12) => l2 - a2 * Math.max(Math.min(k2 - 3, 9 - k2, 1), -1);
  return [f2(0), f2(8), f2(4)];
}
function hsv2rgbn(h3, s2, v2) {
  const f2 = (n2, k2 = (n2 + h3 / 60) % 6) => v2 - v2 * s2 * Math.max(Math.min(k2, 4 - k2, 1), 0);
  return [f2(5), f2(3), f2(1)];
}
function hwb2rgbn(h3, w2, b2) {
  const rgb = hsl2rgbn(h3, 1, 0.5);
  let i;
  if (w2 + b2 > 1) {
    i = 1 / (w2 + b2);
    w2 *= i;
    b2 *= i;
  }
  for (i = 0; i < 3; i++) {
    rgb[i] *= 1 - w2 - b2;
    rgb[i] += w2;
  }
  return rgb;
}
function hueValue(r2, g2, b2, d2, max2) {
  if (r2 === max2) {
    return (g2 - b2) / d2 + (g2 < b2 ? 6 : 0);
  }
  if (g2 === max2) {
    return (b2 - r2) / d2 + 2;
  }
  return (r2 - g2) / d2 + 4;
}
function rgb2hsl(v2) {
  const range2 = 255;
  const r2 = v2.r / range2;
  const g2 = v2.g / range2;
  const b2 = v2.b / range2;
  const max2 = Math.max(r2, g2, b2);
  const min2 = Math.min(r2, g2, b2);
  const l2 = (max2 + min2) / 2;
  let h3, s2, d2;
  if (max2 !== min2) {
    d2 = max2 - min2;
    s2 = l2 > 0.5 ? d2 / (2 - max2 - min2) : d2 / (max2 + min2);
    h3 = hueValue(r2, g2, b2, d2, max2);
    h3 = h3 * 60 + 0.5;
  }
  return [h3 | 0, s2 || 0, l2];
}
function calln(f2, a2, b2, c4) {
  return (Array.isArray(a2) ? f2(a2[0], a2[1], a2[2]) : f2(a2, b2, c4)).map(n2b);
}
function hsl2rgb(h3, s2, l2) {
  return calln(hsl2rgbn, h3, s2, l2);
}
function hwb2rgb(h3, w2, b2) {
  return calln(hwb2rgbn, h3, w2, b2);
}
function hsv2rgb(h3, s2, v2) {
  return calln(hsv2rgbn, h3, s2, v2);
}
function hue(h3) {
  return (h3 % 360 + 360) % 360;
}
function hueParse(str) {
  const m3 = HUE_RE.exec(str);
  let a2 = 255;
  let v2;
  if (!m3) {
    return;
  }
  if (m3[5] !== v2) {
    a2 = m3[6] ? p2b(+m3[5]) : n2b(+m3[5]);
  }
  const h3 = hue(+m3[2]);
  const p1 = +m3[3] / 100;
  const p2 = +m3[4] / 100;
  if (m3[1] === "hwb") {
    v2 = hwb2rgb(h3, p1, p2);
  } else if (m3[1] === "hsv") {
    v2 = hsv2rgb(h3, p1, p2);
  } else {
    v2 = hsl2rgb(h3, p1, p2);
  }
  return {
    r: v2[0],
    g: v2[1],
    b: v2[2],
    a: a2
  };
}
function rotate(v2, deg) {
  var h3 = rgb2hsl(v2);
  h3[0] = hue(h3[0] + deg);
  h3 = hsl2rgb(h3);
  v2.r = h3[0];
  v2.g = h3[1];
  v2.b = h3[2];
}
function hslString(v2) {
  if (!v2) {
    return;
  }
  const a2 = rgb2hsl(v2);
  const h3 = a2[0];
  const s2 = n2p(a2[1]);
  const l2 = n2p(a2[2]);
  return v2.a < 255 ? `hsla(${h3}, ${s2}%, ${l2}%, ${b2n(v2.a)})` : `hsl(${h3}, ${s2}%, ${l2}%)`;
}
const map$2 = {
  x: "dark",
  Z: "light",
  Y: "re",
  X: "blu",
  W: "gr",
  V: "medium",
  U: "slate",
  A: "ee",
  T: "ol",
  S: "or",
  B: "ra",
  C: "lateg",
  D: "ights",
  R: "in",
  Q: "turquois",
  E: "hi",
  P: "ro",
  O: "al",
  N: "le",
  M: "de",
  L: "yello",
  F: "en",
  K: "ch",
  G: "arks",
  H: "ea",
  I: "ightg",
  J: "wh"
};
const names$1 = {
  OiceXe: "f0f8ff",
  antiquewEte: "faebd7",
  aqua: "ffff",
  aquamarRe: "7fffd4",
  azuY: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "0",
  blanKedOmond: "ffebcd",
  Xe: "ff",
  XeviTet: "8a2be2",
  bPwn: "a52a2a",
  burlywood: "deb887",
  caMtXe: "5f9ea0",
  KartYuse: "7fff00",
  KocTate: "d2691e",
  cSO: "ff7f50",
  cSnflowerXe: "6495ed",
  cSnsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "ffff",
  xXe: "8b",
  xcyan: "8b8b",
  xgTMnPd: "b8860b",
  xWay: "a9a9a9",
  xgYF: "6400",
  xgYy: "a9a9a9",
  xkhaki: "bdb76b",
  xmagFta: "8b008b",
  xTivegYF: "556b2f",
  xSange: "ff8c00",
  xScEd: "9932cc",
  xYd: "8b0000",
  xsOmon: "e9967a",
  xsHgYF: "8fbc8f",
  xUXe: "483d8b",
  xUWay: "2f4f4f",
  xUgYy: "2f4f4f",
  xQe: "ced1",
  xviTet: "9400d3",
  dAppRk: "ff1493",
  dApskyXe: "bfff",
  dimWay: "696969",
  dimgYy: "696969",
  dodgerXe: "1e90ff",
  fiYbrick: "b22222",
  flSOwEte: "fffaf0",
  foYstWAn: "228b22",
  fuKsia: "ff00ff",
  gaRsbSo: "dcdcdc",
  ghostwEte: "f8f8ff",
  gTd: "ffd700",
  gTMnPd: "daa520",
  Way: "808080",
  gYF: "8000",
  gYFLw: "adff2f",
  gYy: "808080",
  honeyMw: "f0fff0",
  hotpRk: "ff69b4",
  RdianYd: "cd5c5c",
  Rdigo: "4b0082",
  ivSy: "fffff0",
  khaki: "f0e68c",
  lavFMr: "e6e6fa",
  lavFMrXsh: "fff0f5",
  lawngYF: "7cfc00",
  NmoncEffon: "fffacd",
  ZXe: "add8e6",
  ZcSO: "f08080",
  Zcyan: "e0ffff",
  ZgTMnPdLw: "fafad2",
  ZWay: "d3d3d3",
  ZgYF: "90ee90",
  ZgYy: "d3d3d3",
  ZpRk: "ffb6c1",
  ZsOmon: "ffa07a",
  ZsHgYF: "20b2aa",
  ZskyXe: "87cefa",
  ZUWay: "778899",
  ZUgYy: "778899",
  ZstAlXe: "b0c4de",
  ZLw: "ffffe0",
  lime: "ff00",
  limegYF: "32cd32",
  lRF: "faf0e6",
  magFta: "ff00ff",
  maPon: "800000",
  VaquamarRe: "66cdaa",
  VXe: "cd",
  VScEd: "ba55d3",
  VpurpN: "9370db",
  VsHgYF: "3cb371",
  VUXe: "7b68ee",
  VsprRggYF: "fa9a",
  VQe: "48d1cc",
  VviTetYd: "c71585",
  midnightXe: "191970",
  mRtcYam: "f5fffa",
  mistyPse: "ffe4e1",
  moccasR: "ffe4b5",
  navajowEte: "ffdead",
  navy: "80",
  Tdlace: "fdf5e6",
  Tive: "808000",
  TivedBb: "6b8e23",
  Sange: "ffa500",
  SangeYd: "ff4500",
  ScEd: "da70d6",
  pOegTMnPd: "eee8aa",
  pOegYF: "98fb98",
  pOeQe: "afeeee",
  pOeviTetYd: "db7093",
  papayawEp: "ffefd5",
  pHKpuff: "ffdab9",
  peru: "cd853f",
  pRk: "ffc0cb",
  plum: "dda0dd",
  powMrXe: "b0e0e6",
  purpN: "800080",
  YbeccapurpN: "663399",
  Yd: "ff0000",
  Psybrown: "bc8f8f",
  PyOXe: "4169e1",
  saddNbPwn: "8b4513",
  sOmon: "fa8072",
  sandybPwn: "f4a460",
  sHgYF: "2e8b57",
  sHshell: "fff5ee",
  siFna: "a0522d",
  silver: "c0c0c0",
  skyXe: "87ceeb",
  UXe: "6a5acd",
  UWay: "708090",
  UgYy: "708090",
  snow: "fffafa",
  sprRggYF: "ff7f",
  stAlXe: "4682b4",
  tan: "d2b48c",
  teO: "8080",
  tEstN: "d8bfd8",
  tomato: "ff6347",
  Qe: "40e0d0",
  viTet: "ee82ee",
  JHt: "f5deb3",
  wEte: "ffffff",
  wEtesmoke: "f5f5f5",
  Lw: "ffff00",
  LwgYF: "9acd32"
};
function unpack() {
  const unpacked = {};
  const keys = Object.keys(names$1);
  const tkeys = Object.keys(map$2);
  let i, j, k2, ok, nk;
  for (i = 0; i < keys.length; i++) {
    ok = nk = keys[i];
    for (j = 0; j < tkeys.length; j++) {
      k2 = tkeys[j];
      nk = nk.replace(k2, map$2[k2]);
    }
    k2 = parseInt(names$1[ok], 16);
    unpacked[nk] = [k2 >> 16 & 255, k2 >> 8 & 255, k2 & 255];
  }
  return unpacked;
}
let names;
function nameParse(str) {
  if (!names) {
    names = unpack();
    names.transparent = [0, 0, 0, 0];
  }
  const a2 = names[str.toLowerCase()];
  return a2 && {
    r: a2[0],
    g: a2[1],
    b: a2[2],
    a: a2.length === 4 ? a2[3] : 255
  };
}
const RGB_RE = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function rgbParse(str) {
  const m3 = RGB_RE.exec(str);
  let a2 = 255;
  let r2, g2, b2;
  if (!m3) {
    return;
  }
  if (m3[7] !== r2) {
    const v2 = +m3[7];
    a2 = m3[8] ? p2b(v2) : lim(v2 * 255, 0, 255);
  }
  r2 = +m3[1];
  g2 = +m3[3];
  b2 = +m3[5];
  r2 = 255 & (m3[2] ? p2b(r2) : lim(r2, 0, 255));
  g2 = 255 & (m3[4] ? p2b(g2) : lim(g2, 0, 255));
  b2 = 255 & (m3[6] ? p2b(b2) : lim(b2, 0, 255));
  return {
    r: r2,
    g: g2,
    b: b2,
    a: a2
  };
}
function rgbString(v2) {
  return v2 && (v2.a < 255 ? `rgba(${v2.r}, ${v2.g}, ${v2.b}, ${b2n(v2.a)})` : `rgb(${v2.r}, ${v2.g}, ${v2.b})`);
}
const to$1 = (v2) => v2 <= 31308e-7 ? v2 * 12.92 : Math.pow(v2, 1 / 2.4) * 1.055 - 0.055;
const from$1 = (v2) => v2 <= 0.04045 ? v2 / 12.92 : Math.pow((v2 + 0.055) / 1.055, 2.4);
function interpolate$2(rgb1, rgb2, t2) {
  const r2 = from$1(b2n(rgb1.r));
  const g2 = from$1(b2n(rgb1.g));
  const b2 = from$1(b2n(rgb1.b));
  return {
    r: n2b(to$1(r2 + t2 * (from$1(b2n(rgb2.r)) - r2))),
    g: n2b(to$1(g2 + t2 * (from$1(b2n(rgb2.g)) - g2))),
    b: n2b(to$1(b2 + t2 * (from$1(b2n(rgb2.b)) - b2))),
    a: rgb1.a + t2 * (rgb2.a - rgb1.a)
  };
}
function modHSL(v2, i, ratio) {
  if (v2) {
    let tmp = rgb2hsl(v2);
    tmp[i] = Math.max(0, Math.min(tmp[i] + tmp[i] * ratio, i === 0 ? 360 : 1));
    tmp = hsl2rgb(tmp);
    v2.r = tmp[0];
    v2.g = tmp[1];
    v2.b = tmp[2];
  }
}
function clone$4(v2, proto) {
  return v2 ? Object.assign(proto || {}, v2) : v2;
}
function fromObject(input) {
  var v2 = { r: 0, g: 0, b: 0, a: 255 };
  if (Array.isArray(input)) {
    if (input.length >= 3) {
      v2 = { r: input[0], g: input[1], b: input[2], a: 255 };
      if (input.length > 3) {
        v2.a = n2b(input[3]);
      }
    }
  } else {
    v2 = clone$4(input, { r: 0, g: 0, b: 0, a: 1 });
    v2.a = n2b(v2.a);
  }
  return v2;
}
function functionParse(str) {
  if (str.charAt(0) === "r") {
    return rgbParse(str);
  }
  return hueParse(str);
}
let Color$1 = class Color {
  constructor(input) {
    if (input instanceof Color) {
      return input;
    }
    const type2 = typeof input;
    let v2;
    if (type2 === "object") {
      v2 = fromObject(input);
    } else if (type2 === "string") {
      v2 = hexParse(input) || nameParse(input) || functionParse(input);
    }
    this._rgb = v2;
    this._valid = !!v2;
  }
  get valid() {
    return this._valid;
  }
  get rgb() {
    var v2 = clone$4(this._rgb);
    if (v2) {
      v2.a = b2n(v2.a);
    }
    return v2;
  }
  set rgb(obj) {
    this._rgb = fromObject(obj);
  }
  rgbString() {
    return this._valid ? rgbString(this._rgb) : void 0;
  }
  hexString() {
    return this._valid ? hexString(this._rgb) : void 0;
  }
  hslString() {
    return this._valid ? hslString(this._rgb) : void 0;
  }
  mix(color2, weight) {
    if (color2) {
      const c12 = this.rgb;
      const c22 = color2.rgb;
      let w2;
      const p2 = weight === w2 ? 0.5 : weight;
      const w3 = 2 * p2 - 1;
      const a2 = c12.a - c22.a;
      const w1 = ((w3 * a2 === -1 ? w3 : (w3 + a2) / (1 + w3 * a2)) + 1) / 2;
      w2 = 1 - w1;
      c12.r = 255 & w1 * c12.r + w2 * c22.r + 0.5;
      c12.g = 255 & w1 * c12.g + w2 * c22.g + 0.5;
      c12.b = 255 & w1 * c12.b + w2 * c22.b + 0.5;
      c12.a = p2 * c12.a + (1 - p2) * c22.a;
      this.rgb = c12;
    }
    return this;
  }
  interpolate(color2, t2) {
    if (color2) {
      this._rgb = interpolate$2(this._rgb, color2._rgb, t2);
    }
    return this;
  }
  clone() {
    return new Color(this.rgb);
  }
  alpha(a2) {
    this._rgb.a = n2b(a2);
    return this;
  }
  clearer(ratio) {
    const rgb = this._rgb;
    rgb.a *= 1 - ratio;
    return this;
  }
  greyscale() {
    const rgb = this._rgb;
    const val = round$1(rgb.r * 0.3 + rgb.g * 0.59 + rgb.b * 0.11);
    rgb.r = rgb.g = rgb.b = val;
    return this;
  }
  opaquer(ratio) {
    const rgb = this._rgb;
    rgb.a *= 1 + ratio;
    return this;
  }
  negate() {
    const v2 = this._rgb;
    v2.r = 255 - v2.r;
    v2.g = 255 - v2.g;
    v2.b = 255 - v2.b;
    return this;
  }
  lighten(ratio) {
    modHSL(this._rgb, 2, ratio);
    return this;
  }
  darken(ratio) {
    modHSL(this._rgb, 2, -ratio);
    return this;
  }
  saturate(ratio) {
    modHSL(this._rgb, 1, ratio);
    return this;
  }
  desaturate(ratio) {
    modHSL(this._rgb, 1, -ratio);
    return this;
  }
  rotate(deg) {
    rotate(this._rgb, deg);
    return this;
  }
};
/*!
 * Chart.js v4.4.3
 * https://www.chartjs.org
 * (c) 2024 Chart.js Contributors
 * Released under the MIT License
 */
function noop$2() {
}
const uid = /* @__PURE__ */ (() => {
  let id = 0;
  return () => id++;
})();
function isNullOrUndef(value) {
  return value === null || typeof value === "undefined";
}
function isArray$1(value) {
  if (Array.isArray && Array.isArray(value)) {
    return true;
  }
  const type2 = Object.prototype.toString.call(value);
  if (type2.slice(0, 7) === "[object" && type2.slice(-6) === "Array]") {
    return true;
  }
  return false;
}
function isObject(value) {
  return value !== null && Object.prototype.toString.call(value) === "[object Object]";
}
function isNumberFinite(value) {
  return (typeof value === "number" || value instanceof Number) && isFinite(+value);
}
function finiteOrDefault(value, defaultValue) {
  return isNumberFinite(value) ? value : defaultValue;
}
function valueOrDefault(value, defaultValue) {
  return typeof value === "undefined" ? defaultValue : value;
}
const toPercentage = (value, dimension) => typeof value === "string" && value.endsWith("%") ? parseFloat(value) / 100 : +value / dimension;
const toDimension = (value, dimension) => typeof value === "string" && value.endsWith("%") ? parseFloat(value) / 100 * dimension : +value;
function callback(fn, args, thisArg) {
  if (fn && typeof fn.call === "function") {
    return fn.apply(thisArg, args);
  }
}
function each$1(loopable, fn, thisArg, reverse) {
  let i, len, keys;
  if (isArray$1(loopable)) {
    len = loopable.length;
    if (reverse) {
      for (i = len - 1; i >= 0; i--) {
        fn.call(thisArg, loopable[i], i);
      }
    } else {
      for (i = 0; i < len; i++) {
        fn.call(thisArg, loopable[i], i);
      }
    }
  } else if (isObject(loopable)) {
    keys = Object.keys(loopable);
    len = keys.length;
    for (i = 0; i < len; i++) {
      fn.call(thisArg, loopable[keys[i]], keys[i]);
    }
  }
}
function _elementsEqual(a0, a1) {
  let i, ilen, v0, v1;
  if (!a0 || !a1 || a0.length !== a1.length) {
    return false;
  }
  for (i = 0, ilen = a0.length; i < ilen; ++i) {
    v0 = a0[i];
    v1 = a1[i];
    if (v0.datasetIndex !== v1.datasetIndex || v0.index !== v1.index) {
      return false;
    }
  }
  return true;
}
function clone$3(source) {
  if (isArray$1(source)) {
    return source.map(clone$3);
  }
  if (isObject(source)) {
    const target = /* @__PURE__ */ Object.create(null);
    const keys = Object.keys(source);
    const klen = keys.length;
    let k2 = 0;
    for (; k2 < klen; ++k2) {
      target[keys[k2]] = clone$3(source[keys[k2]]);
    }
    return target;
  }
  return source;
}
function isValidKey(key) {
  return [
    "__proto__",
    "prototype",
    "constructor"
  ].indexOf(key) === -1;
}
function _merger(key, target, source, options2) {
  if (!isValidKey(key)) {
    return;
  }
  const tval = target[key];
  const sval = source[key];
  if (isObject(tval) && isObject(sval)) {
    merge$2(tval, sval, options2);
  } else {
    target[key] = clone$3(sval);
  }
}
function merge$2(target, source, options2) {
  const sources = isArray$1(source) ? source : [
    source
  ];
  const ilen = sources.length;
  if (!isObject(target)) {
    return target;
  }
  options2 = options2 || {};
  const merger = options2.merger || _merger;
  let current;
  for (let i = 0; i < ilen; ++i) {
    current = sources[i];
    if (!isObject(current)) {
      continue;
    }
    const keys = Object.keys(current);
    for (let k2 = 0, klen = keys.length; k2 < klen; ++k2) {
      merger(keys[k2], target, current, options2);
    }
  }
  return target;
}
function mergeIf(target, source) {
  return merge$2(target, source, {
    merger: _mergerIf
  });
}
function _mergerIf(key, target, source) {
  if (!isValidKey(key)) {
    return;
  }
  const tval = target[key];
  const sval = source[key];
  if (isObject(tval) && isObject(sval)) {
    mergeIf(tval, sval);
  } else if (!Object.prototype.hasOwnProperty.call(target, key)) {
    target[key] = clone$3(sval);
  }
}
const keyResolvers = {
  // Chart.helpers.core resolveObjectKey should resolve empty key to root object
  "": (v2) => v2,
  // default resolvers
  x: (o2) => o2.x,
  y: (o2) => o2.y
};
function _splitKey(key) {
  const parts = key.split(".");
  const keys = [];
  let tmp = "";
  for (const part of parts) {
    tmp += part;
    if (tmp.endsWith("\\")) {
      tmp = tmp.slice(0, -1) + ".";
    } else {
      keys.push(tmp);
      tmp = "";
    }
  }
  return keys;
}
function _getKeyResolver(key) {
  const keys = _splitKey(key);
  return (obj) => {
    for (const k2 of keys) {
      if (k2 === "") {
        break;
      }
      obj = obj && obj[k2];
    }
    return obj;
  };
}
function resolveObjectKey(obj, key) {
  const resolver = keyResolvers[key] || (keyResolvers[key] = _getKeyResolver(key));
  return resolver(obj);
}
function _capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
const defined = (value) => typeof value !== "undefined";
const isFunction = (value) => typeof value === "function";
const setsEqual = (a2, b2) => {
  if (a2.size !== b2.size) {
    return false;
  }
  for (const item of a2) {
    if (!b2.has(item)) {
      return false;
    }
  }
  return true;
};
function _isClickEvent(e2) {
  return e2.type === "mouseup" || e2.type === "click" || e2.type === "contextmenu";
}
const PI = Math.PI;
const TAU = 2 * PI;
const PITAU = TAU + PI;
const INFINITY = Number.POSITIVE_INFINITY;
const RAD_PER_DEG = PI / 180;
const HALF_PI = PI / 2;
const QUARTER_PI = PI / 4;
const TWO_THIRDS_PI = PI * 2 / 3;
const log10 = Math.log10;
const sign = Math.sign;
function almostEquals(x2, y2, epsilon) {
  return Math.abs(x2 - y2) < epsilon;
}
function niceNum(range2) {
  const roundedRange = Math.round(range2);
  range2 = almostEquals(range2, roundedRange, range2 / 1e3) ? roundedRange : range2;
  const niceRange = Math.pow(10, Math.floor(log10(range2)));
  const fraction = range2 / niceRange;
  const niceFraction = fraction <= 1 ? 1 : fraction <= 2 ? 2 : fraction <= 5 ? 5 : 10;
  return niceFraction * niceRange;
}
function _factorize(value) {
  const result = [];
  const sqrt = Math.sqrt(value);
  let i;
  for (i = 1; i < sqrt; i++) {
    if (value % i === 0) {
      result.push(i);
      result.push(value / i);
    }
  }
  if (sqrt === (sqrt | 0)) {
    result.push(sqrt);
  }
  result.sort((a2, b2) => a2 - b2).pop();
  return result;
}
function isNumber$1(n2) {
  return !isNaN(parseFloat(n2)) && isFinite(n2);
}
function almostWhole(x2, epsilon) {
  const rounded = Math.round(x2);
  return rounded - epsilon <= x2 && rounded + epsilon >= x2;
}
function _setMinAndMaxByKey(array, target, property) {
  let i, ilen, value;
  for (i = 0, ilen = array.length; i < ilen; i++) {
    value = array[i][property];
    if (!isNaN(value)) {
      target.min = Math.min(target.min, value);
      target.max = Math.max(target.max, value);
    }
  }
}
function toRadians(degrees) {
  return degrees * (PI / 180);
}
function toDegrees(radians) {
  return radians * (180 / PI);
}
function _decimalPlaces(x2) {
  if (!isNumberFinite(x2)) {
    return;
  }
  let e2 = 1;
  let p2 = 0;
  while (Math.round(x2 * e2) / e2 !== x2) {
    e2 *= 10;
    p2++;
  }
  return p2;
}
function getAngleFromPoint(centrePoint, anglePoint) {
  const distanceFromXCenter = anglePoint.x - centrePoint.x;
  const distanceFromYCenter = anglePoint.y - centrePoint.y;
  const radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
  let angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
  if (angle < -0.5 * PI) {
    angle += TAU;
  }
  return {
    angle,
    distance: radialDistanceFromCenter
  };
}
function distanceBetweenPoints(pt1, pt2) {
  return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
}
function _angleDiff(a2, b2) {
  return (a2 - b2 + PITAU) % TAU - PI;
}
function _normalizeAngle(a2) {
  return (a2 % TAU + TAU) % TAU;
}
function _angleBetween(angle, start, end, sameAngleIsFullCircle) {
  const a2 = _normalizeAngle(angle);
  const s2 = _normalizeAngle(start);
  const e2 = _normalizeAngle(end);
  const angleToStart = _normalizeAngle(s2 - a2);
  const angleToEnd = _normalizeAngle(e2 - a2);
  const startToAngle = _normalizeAngle(a2 - s2);
  const endToAngle = _normalizeAngle(a2 - e2);
  return a2 === s2 || a2 === e2 || sameAngleIsFullCircle && s2 === e2 || angleToStart > angleToEnd && startToAngle < endToAngle;
}
function _limitValue(value, min2, max2) {
  return Math.max(min2, Math.min(max2, value));
}
function _int16Range(value) {
  return _limitValue(value, -32768, 32767);
}
function _isBetween(value, start, end, epsilon = 1e-6) {
  return value >= Math.min(start, end) - epsilon && value <= Math.max(start, end) + epsilon;
}
function _lookup(table, value, cmp) {
  cmp = cmp || ((index2) => table[index2] < value);
  let hi = table.length - 1;
  let lo = 0;
  let mid;
  while (hi - lo > 1) {
    mid = lo + hi >> 1;
    if (cmp(mid)) {
      lo = mid;
    } else {
      hi = mid;
    }
  }
  return {
    lo,
    hi
  };
}
const _lookupByKey = (table, key, value, last2) => _lookup(table, value, last2 ? (index2) => {
  const ti = table[index2][key];
  return ti < value || ti === value && table[index2 + 1][key] === value;
} : (index2) => table[index2][key] < value);
const _rlookupByKey = (table, key, value) => _lookup(table, value, (index2) => table[index2][key] >= value);
function _filterBetween(values2, min2, max2) {
  let start = 0;
  let end = values2.length;
  while (start < end && values2[start] < min2) {
    start++;
  }
  while (end > start && values2[end - 1] > max2) {
    end--;
  }
  return start > 0 || end < values2.length ? values2.slice(start, end) : values2;
}
const arrayEvents = [
  "push",
  "pop",
  "shift",
  "splice",
  "unshift"
];
function listenArrayEvents(array, listener) {
  if (array._chartjs) {
    array._chartjs.listeners.push(listener);
    return;
  }
  Object.defineProperty(array, "_chartjs", {
    configurable: true,
    enumerable: false,
    value: {
      listeners: [
        listener
      ]
    }
  });
  arrayEvents.forEach((key) => {
    const method = "_onData" + _capitalize(key);
    const base = array[key];
    Object.defineProperty(array, key, {
      configurable: true,
      enumerable: false,
      value(...args) {
        const res = base.apply(this, args);
        array._chartjs.listeners.forEach((object) => {
          if (typeof object[method] === "function") {
            object[method](...args);
          }
        });
        return res;
      }
    });
  });
}
function unlistenArrayEvents(array, listener) {
  const stub = array._chartjs;
  if (!stub) {
    return;
  }
  const listeners = stub.listeners;
  const index2 = listeners.indexOf(listener);
  if (index2 !== -1) {
    listeners.splice(index2, 1);
  }
  if (listeners.length > 0) {
    return;
  }
  arrayEvents.forEach((key) => {
    delete array[key];
  });
  delete array._chartjs;
}
function _arrayUnique(items) {
  const set2 = new Set(items);
  if (set2.size === items.length) {
    return items;
  }
  return Array.from(set2);
}
const requestAnimFrame = function() {
  if (typeof window === "undefined") {
    return function(callback2) {
      return callback2();
    };
  }
  return window.requestAnimationFrame;
}();
function throttled(fn, thisArg) {
  let argsToUse = [];
  let ticking = false;
  return function(...args) {
    argsToUse = args;
    if (!ticking) {
      ticking = true;
      requestAnimFrame.call(window, () => {
        ticking = false;
        fn.apply(thisArg, argsToUse);
      });
    }
  };
}
function debounce$1(fn, delay) {
  let timeout2;
  return function(...args) {
    if (delay) {
      clearTimeout(timeout2);
      timeout2 = setTimeout(fn, delay, args);
    } else {
      fn.apply(this, args);
    }
    return delay;
  };
}
const _toLeftRightCenter = (align) => align === "start" ? "left" : align === "end" ? "right" : "center";
const _alignStartEnd = (align, start, end) => align === "start" ? start : align === "end" ? end : (start + end) / 2;
const _textX = (align, left, right, rtl) => {
  const check = rtl ? "left" : "right";
  return align === check ? right : align === "center" ? (left + right) / 2 : left;
};
function _getStartAndCountOfVisiblePoints(meta, points, animationsDisabled) {
  const pointCount = points.length;
  let start = 0;
  let count = pointCount;
  if (meta._sorted) {
    const { iScale, _parsed } = meta;
    const axis = iScale.axis;
    const { min: min2, max: max2, minDefined, maxDefined } = iScale.getUserBounds();
    if (minDefined) {
      start = _limitValue(Math.min(
        // @ts-expect-error Need to type _parsed
        _lookupByKey(_parsed, axis, min2).lo,
        // @ts-expect-error Need to fix types on _lookupByKey
        animationsDisabled ? pointCount : _lookupByKey(points, axis, iScale.getPixelForValue(min2)).lo
      ), 0, pointCount - 1);
    }
    if (maxDefined) {
      count = _limitValue(Math.max(
        // @ts-expect-error Need to type _parsed
        _lookupByKey(_parsed, iScale.axis, max2, true).hi + 1,
        // @ts-expect-error Need to fix types on _lookupByKey
        animationsDisabled ? 0 : _lookupByKey(points, axis, iScale.getPixelForValue(max2), true).hi + 1
      ), start, pointCount) - start;
    } else {
      count = pointCount - start;
    }
  }
  return {
    start,
    count
  };
}
function _scaleRangesChanged(meta) {
  const { xScale, yScale, _scaleRanges } = meta;
  const newRanges = {
    xmin: xScale.min,
    xmax: xScale.max,
    ymin: yScale.min,
    ymax: yScale.max
  };
  if (!_scaleRanges) {
    meta._scaleRanges = newRanges;
    return true;
  }
  const changed = _scaleRanges.xmin !== xScale.min || _scaleRanges.xmax !== xScale.max || _scaleRanges.ymin !== yScale.min || _scaleRanges.ymax !== yScale.max;
  Object.assign(_scaleRanges, newRanges);
  return changed;
}
const atEdge = (t2) => t2 === 0 || t2 === 1;
const elasticIn = (t2, s2, p2) => -(Math.pow(2, 10 * (t2 -= 1)) * Math.sin((t2 - s2) * TAU / p2));
const elasticOut = (t2, s2, p2) => Math.pow(2, -10 * t2) * Math.sin((t2 - s2) * TAU / p2) + 1;
const effects = {
  linear: (t2) => t2,
  easeInQuad: (t2) => t2 * t2,
  easeOutQuad: (t2) => -t2 * (t2 - 2),
  easeInOutQuad: (t2) => (t2 /= 0.5) < 1 ? 0.5 * t2 * t2 : -0.5 * (--t2 * (t2 - 2) - 1),
  easeInCubic: (t2) => t2 * t2 * t2,
  easeOutCubic: (t2) => (t2 -= 1) * t2 * t2 + 1,
  easeInOutCubic: (t2) => (t2 /= 0.5) < 1 ? 0.5 * t2 * t2 * t2 : 0.5 * ((t2 -= 2) * t2 * t2 + 2),
  easeInQuart: (t2) => t2 * t2 * t2 * t2,
  easeOutQuart: (t2) => -((t2 -= 1) * t2 * t2 * t2 - 1),
  easeInOutQuart: (t2) => (t2 /= 0.5) < 1 ? 0.5 * t2 * t2 * t2 * t2 : -0.5 * ((t2 -= 2) * t2 * t2 * t2 - 2),
  easeInQuint: (t2) => t2 * t2 * t2 * t2 * t2,
  easeOutQuint: (t2) => (t2 -= 1) * t2 * t2 * t2 * t2 + 1,
  easeInOutQuint: (t2) => (t2 /= 0.5) < 1 ? 0.5 * t2 * t2 * t2 * t2 * t2 : 0.5 * ((t2 -= 2) * t2 * t2 * t2 * t2 + 2),
  easeInSine: (t2) => -Math.cos(t2 * HALF_PI) + 1,
  easeOutSine: (t2) => Math.sin(t2 * HALF_PI),
  easeInOutSine: (t2) => -0.5 * (Math.cos(PI * t2) - 1),
  easeInExpo: (t2) => t2 === 0 ? 0 : Math.pow(2, 10 * (t2 - 1)),
  easeOutExpo: (t2) => t2 === 1 ? 1 : -Math.pow(2, -10 * t2) + 1,
  easeInOutExpo: (t2) => atEdge(t2) ? t2 : t2 < 0.5 ? 0.5 * Math.pow(2, 10 * (t2 * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (t2 * 2 - 1)) + 2),
  easeInCirc: (t2) => t2 >= 1 ? t2 : -(Math.sqrt(1 - t2 * t2) - 1),
  easeOutCirc: (t2) => Math.sqrt(1 - (t2 -= 1) * t2),
  easeInOutCirc: (t2) => (t2 /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - t2 * t2) - 1) : 0.5 * (Math.sqrt(1 - (t2 -= 2) * t2) + 1),
  easeInElastic: (t2) => atEdge(t2) ? t2 : elasticIn(t2, 0.075, 0.3),
  easeOutElastic: (t2) => atEdge(t2) ? t2 : elasticOut(t2, 0.075, 0.3),
  easeInOutElastic(t2) {
    const s2 = 0.1125;
    const p2 = 0.45;
    return atEdge(t2) ? t2 : t2 < 0.5 ? 0.5 * elasticIn(t2 * 2, s2, p2) : 0.5 + 0.5 * elasticOut(t2 * 2 - 1, s2, p2);
  },
  easeInBack(t2) {
    const s2 = 1.70158;
    return t2 * t2 * ((s2 + 1) * t2 - s2);
  },
  easeOutBack(t2) {
    const s2 = 1.70158;
    return (t2 -= 1) * t2 * ((s2 + 1) * t2 + s2) + 1;
  },
  easeInOutBack(t2) {
    let s2 = 1.70158;
    if ((t2 /= 0.5) < 1) {
      return 0.5 * (t2 * t2 * (((s2 *= 1.525) + 1) * t2 - s2));
    }
    return 0.5 * ((t2 -= 2) * t2 * (((s2 *= 1.525) + 1) * t2 + s2) + 2);
  },
  easeInBounce: (t2) => 1 - effects.easeOutBounce(1 - t2),
  easeOutBounce(t2) {
    const m3 = 7.5625;
    const d2 = 2.75;
    if (t2 < 1 / d2) {
      return m3 * t2 * t2;
    }
    if (t2 < 2 / d2) {
      return m3 * (t2 -= 1.5 / d2) * t2 + 0.75;
    }
    if (t2 < 2.5 / d2) {
      return m3 * (t2 -= 2.25 / d2) * t2 + 0.9375;
    }
    return m3 * (t2 -= 2.625 / d2) * t2 + 0.984375;
  },
  easeInOutBounce: (t2) => t2 < 0.5 ? effects.easeInBounce(t2 * 2) * 0.5 : effects.easeOutBounce(t2 * 2 - 1) * 0.5 + 0.5
};
function isPatternOrGradient(value) {
  if (value && typeof value === "object") {
    const type2 = value.toString();
    return type2 === "[object CanvasPattern]" || type2 === "[object CanvasGradient]";
  }
  return false;
}
function color(value) {
  return isPatternOrGradient(value) ? value : new Color$1(value);
}
function getHoverColor(value) {
  return isPatternOrGradient(value) ? value : new Color$1(value).saturate(0.5).darken(0.1).hexString();
}
const numbers = [
  "x",
  "y",
  "borderWidth",
  "radius",
  "tension"
];
const colors$1 = [
  "color",
  "borderColor",
  "backgroundColor"
];
function applyAnimationsDefaults(defaults2) {
  defaults2.set("animation", {
    delay: void 0,
    duration: 1e3,
    easing: "easeOutQuart",
    fn: void 0,
    from: void 0,
    loop: void 0,
    to: void 0,
    type: void 0
  });
  defaults2.describe("animation", {
    _fallback: false,
    _indexable: false,
    _scriptable: (name) => name !== "onProgress" && name !== "onComplete" && name !== "fn"
  });
  defaults2.set("animations", {
    colors: {
      type: "color",
      properties: colors$1
    },
    numbers: {
      type: "number",
      properties: numbers
    }
  });
  defaults2.describe("animations", {
    _fallback: "animation"
  });
  defaults2.set("transitions", {
    active: {
      animation: {
        duration: 400
      }
    },
    resize: {
      animation: {
        duration: 0
      }
    },
    show: {
      animations: {
        colors: {
          from: "transparent"
        },
        visible: {
          type: "boolean",
          duration: 0
        }
      }
    },
    hide: {
      animations: {
        colors: {
          to: "transparent"
        },
        visible: {
          type: "boolean",
          easing: "linear",
          fn: (v2) => v2 | 0
        }
      }
    }
  });
}
function applyLayoutsDefaults(defaults2) {
  defaults2.set("layout", {
    autoPadding: true,
    padding: {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    }
  });
}
const intlCache = /* @__PURE__ */ new Map();
function getNumberFormat(locale, options2) {
  options2 = options2 || {};
  const cacheKey = locale + JSON.stringify(options2);
  let formatter = intlCache.get(cacheKey);
  if (!formatter) {
    formatter = new Intl.NumberFormat(locale, options2);
    intlCache.set(cacheKey, formatter);
  }
  return formatter;
}
function formatNumber(num, locale, options2) {
  return getNumberFormat(locale, options2).format(num);
}
const formatters = {
  values(value) {
    return isArray$1(value) ? value : "" + value;
  },
  numeric(tickValue, index2, ticks) {
    if (tickValue === 0) {
      return "0";
    }
    const locale = this.chart.options.locale;
    let notation;
    let delta = tickValue;
    if (ticks.length > 1) {
      const maxTick = Math.max(Math.abs(ticks[0].value), Math.abs(ticks[ticks.length - 1].value));
      if (maxTick < 1e-4 || maxTick > 1e15) {
        notation = "scientific";
      }
      delta = calculateDelta(tickValue, ticks);
    }
    const logDelta = log10(Math.abs(delta));
    const numDecimal = isNaN(logDelta) ? 1 : Math.max(Math.min(-1 * Math.floor(logDelta), 20), 0);
    const options2 = {
      notation,
      minimumFractionDigits: numDecimal,
      maximumFractionDigits: numDecimal
    };
    Object.assign(options2, this.options.ticks.format);
    return formatNumber(tickValue, locale, options2);
  },
  logarithmic(tickValue, index2, ticks) {
    if (tickValue === 0) {
      return "0";
    }
    const remain = ticks[index2].significand || tickValue / Math.pow(10, Math.floor(log10(tickValue)));
    if ([
      1,
      2,
      3,
      5,
      10,
      15
    ].includes(remain) || index2 > 0.8 * ticks.length) {
      return formatters.numeric.call(this, tickValue, index2, ticks);
    }
    return "";
  }
};
function calculateDelta(tickValue, ticks) {
  let delta = ticks.length > 3 ? ticks[2].value - ticks[1].value : ticks[1].value - ticks[0].value;
  if (Math.abs(delta) >= 1 && tickValue !== Math.floor(tickValue)) {
    delta = tickValue - Math.floor(tickValue);
  }
  return delta;
}
var Ticks = {
  formatters
};
function applyScaleDefaults(defaults2) {
  defaults2.set("scale", {
    display: true,
    offset: false,
    reverse: false,
    beginAtZero: false,
    bounds: "ticks",
    clip: true,
    grace: 0,
    grid: {
      display: true,
      lineWidth: 1,
      drawOnChartArea: true,
      drawTicks: true,
      tickLength: 8,
      tickWidth: (_ctx, options2) => options2.lineWidth,
      tickColor: (_ctx, options2) => options2.color,
      offset: false
    },
    border: {
      display: true,
      dash: [],
      dashOffset: 0,
      width: 1
    },
    title: {
      display: false,
      text: "",
      padding: {
        top: 4,
        bottom: 4
      }
    },
    ticks: {
      minRotation: 0,
      maxRotation: 50,
      mirror: false,
      textStrokeWidth: 0,
      textStrokeColor: "",
      padding: 3,
      display: true,
      autoSkip: true,
      autoSkipPadding: 3,
      labelOffset: 0,
      callback: Ticks.formatters.values,
      minor: {},
      major: {},
      align: "center",
      crossAlign: "near",
      showLabelBackdrop: false,
      backdropColor: "rgba(255, 255, 255, 0.75)",
      backdropPadding: 2
    }
  });
  defaults2.route("scale.ticks", "color", "", "color");
  defaults2.route("scale.grid", "color", "", "borderColor");
  defaults2.route("scale.border", "color", "", "borderColor");
  defaults2.route("scale.title", "color", "", "color");
  defaults2.describe("scale", {
    _fallback: false,
    _scriptable: (name) => !name.startsWith("before") && !name.startsWith("after") && name !== "callback" && name !== "parser",
    _indexable: (name) => name !== "borderDash" && name !== "tickBorderDash" && name !== "dash"
  });
  defaults2.describe("scales", {
    _fallback: "scale"
  });
  defaults2.describe("scale.ticks", {
    _scriptable: (name) => name !== "backdropPadding" && name !== "callback",
    _indexable: (name) => name !== "backdropPadding"
  });
}
const overrides = /* @__PURE__ */ Object.create(null);
const descriptors = /* @__PURE__ */ Object.create(null);
function getScope$1(node2, key) {
  if (!key) {
    return node2;
  }
  const keys = key.split(".");
  for (let i = 0, n2 = keys.length; i < n2; ++i) {
    const k2 = keys[i];
    node2 = node2[k2] || (node2[k2] = /* @__PURE__ */ Object.create(null));
  }
  return node2;
}
function set$1(root, scope, values2) {
  if (typeof scope === "string") {
    return merge$2(getScope$1(root, scope), values2);
  }
  return merge$2(getScope$1(root, ""), scope);
}
class Defaults {
  constructor(_descriptors2, _appliers) {
    this.animation = void 0;
    this.backgroundColor = "rgba(0,0,0,0.1)";
    this.borderColor = "rgba(0,0,0,0.1)";
    this.color = "#666";
    this.datasets = {};
    this.devicePixelRatio = (context) => context.chart.platform.getDevicePixelRatio();
    this.elements = {};
    this.events = [
      "mousemove",
      "mouseout",
      "click",
      "touchstart",
      "touchmove"
    ];
    this.font = {
      family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
      size: 12,
      style: "normal",
      lineHeight: 1.2,
      weight: null
    };
    this.hover = {};
    this.hoverBackgroundColor = (ctx, options2) => getHoverColor(options2.backgroundColor);
    this.hoverBorderColor = (ctx, options2) => getHoverColor(options2.borderColor);
    this.hoverColor = (ctx, options2) => getHoverColor(options2.color);
    this.indexAxis = "x";
    this.interaction = {
      mode: "nearest",
      intersect: true,
      includeInvisible: false
    };
    this.maintainAspectRatio = true;
    this.onHover = null;
    this.onClick = null;
    this.parsing = true;
    this.plugins = {};
    this.responsive = true;
    this.scale = void 0;
    this.scales = {};
    this.showLine = true;
    this.drawActiveElementsOnTop = true;
    this.describe(_descriptors2);
    this.apply(_appliers);
  }
  set(scope, values2) {
    return set$1(this, scope, values2);
  }
  get(scope) {
    return getScope$1(this, scope);
  }
  describe(scope, values2) {
    return set$1(descriptors, scope, values2);
  }
  override(scope, values2) {
    return set$1(overrides, scope, values2);
  }
  route(scope, name, targetScope, targetName) {
    const scopeObject = getScope$1(this, scope);
    const targetScopeObject = getScope$1(this, targetScope);
    const privateName = "_" + name;
    Object.defineProperties(scopeObject, {
      [privateName]: {
        value: scopeObject[name],
        writable: true
      },
      [name]: {
        enumerable: true,
        get() {
          const local = this[privateName];
          const target = targetScopeObject[targetName];
          if (isObject(local)) {
            return Object.assign({}, target, local);
          }
          return valueOrDefault(local, target);
        },
        set(value) {
          this[privateName] = value;
        }
      }
    });
  }
  apply(appliers) {
    appliers.forEach((apply) => apply(this));
  }
}
var defaults$3 = /* @__PURE__ */ new Defaults({
  _scriptable: (name) => !name.startsWith("on"),
  _indexable: (name) => name !== "events",
  hover: {
    _fallback: "interaction"
  },
  interaction: {
    _scriptable: false,
    _indexable: false
  }
}, [
  applyAnimationsDefaults,
  applyLayoutsDefaults,
  applyScaleDefaults
]);
function toFontString(font) {
  if (!font || isNullOrUndef(font.size) || isNullOrUndef(font.family)) {
    return null;
  }
  return (font.style ? font.style + " " : "") + (font.weight ? font.weight + " " : "") + font.size + "px " + font.family;
}
function _measureText(ctx, data2, gc, longest, string) {
  let textWidth = data2[string];
  if (!textWidth) {
    textWidth = data2[string] = ctx.measureText(string).width;
    gc.push(string);
  }
  if (textWidth > longest) {
    longest = textWidth;
  }
  return longest;
}
function _longestText(ctx, font, arrayOfThings, cache) {
  cache = cache || {};
  let data2 = cache.data = cache.data || {};
  let gc = cache.garbageCollect = cache.garbageCollect || [];
  if (cache.font !== font) {
    data2 = cache.data = {};
    gc = cache.garbageCollect = [];
    cache.font = font;
  }
  ctx.save();
  ctx.font = font;
  let longest = 0;
  const ilen = arrayOfThings.length;
  let i, j, jlen, thing, nestedThing;
  for (i = 0; i < ilen; i++) {
    thing = arrayOfThings[i];
    if (thing !== void 0 && thing !== null && !isArray$1(thing)) {
      longest = _measureText(ctx, data2, gc, longest, thing);
    } else if (isArray$1(thing)) {
      for (j = 0, jlen = thing.length; j < jlen; j++) {
        nestedThing = thing[j];
        if (nestedThing !== void 0 && nestedThing !== null && !isArray$1(nestedThing)) {
          longest = _measureText(ctx, data2, gc, longest, nestedThing);
        }
      }
    }
  }
  ctx.restore();
  const gcLen = gc.length / 2;
  if (gcLen > arrayOfThings.length) {
    for (i = 0; i < gcLen; i++) {
      delete data2[gc[i]];
    }
    gc.splice(0, gcLen);
  }
  return longest;
}
function _alignPixel(chart, pixel, width) {
  const devicePixelRatio = chart.currentDevicePixelRatio;
  const halfWidth = width !== 0 ? Math.max(width / 2, 0.5) : 0;
  return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
}
function clearCanvas(canvas, ctx) {
  if (!ctx && !canvas) {
    return;
  }
  ctx = ctx || canvas.getContext("2d");
  ctx.save();
  ctx.resetTransform();
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  ctx.restore();
}
function drawPoint(ctx, options2, x2, y2) {
  drawPointLegend(ctx, options2, x2, y2, null);
}
function drawPointLegend(ctx, options2, x2, y2, w2) {
  let type2, xOffset, yOffset, size2, cornerRadius, width, xOffsetW, yOffsetW;
  const style = options2.pointStyle;
  const rotation = options2.rotation;
  const radius = options2.radius;
  let rad = (rotation || 0) * RAD_PER_DEG;
  if (style && typeof style === "object") {
    type2 = style.toString();
    if (type2 === "[object HTMLImageElement]" || type2 === "[object HTMLCanvasElement]") {
      ctx.save();
      ctx.translate(x2, y2);
      ctx.rotate(rad);
      ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
      ctx.restore();
      return;
    }
  }
  if (isNaN(radius) || radius <= 0) {
    return;
  }
  ctx.beginPath();
  switch (style) {
    default:
      if (w2) {
        ctx.ellipse(x2, y2, w2 / 2, radius, 0, 0, TAU);
      } else {
        ctx.arc(x2, y2, radius, 0, TAU);
      }
      ctx.closePath();
      break;
    case "triangle":
      width = w2 ? w2 / 2 : radius;
      ctx.moveTo(x2 + Math.sin(rad) * width, y2 - Math.cos(rad) * radius);
      rad += TWO_THIRDS_PI;
      ctx.lineTo(x2 + Math.sin(rad) * width, y2 - Math.cos(rad) * radius);
      rad += TWO_THIRDS_PI;
      ctx.lineTo(x2 + Math.sin(rad) * width, y2 - Math.cos(rad) * radius);
      ctx.closePath();
      break;
    case "rectRounded":
      cornerRadius = radius * 0.516;
      size2 = radius - cornerRadius;
      xOffset = Math.cos(rad + QUARTER_PI) * size2;
      xOffsetW = Math.cos(rad + QUARTER_PI) * (w2 ? w2 / 2 - cornerRadius : size2);
      yOffset = Math.sin(rad + QUARTER_PI) * size2;
      yOffsetW = Math.sin(rad + QUARTER_PI) * (w2 ? w2 / 2 - cornerRadius : size2);
      ctx.arc(x2 - xOffsetW, y2 - yOffset, cornerRadius, rad - PI, rad - HALF_PI);
      ctx.arc(x2 + yOffsetW, y2 - xOffset, cornerRadius, rad - HALF_PI, rad);
      ctx.arc(x2 + xOffsetW, y2 + yOffset, cornerRadius, rad, rad + HALF_PI);
      ctx.arc(x2 - yOffsetW, y2 + xOffset, cornerRadius, rad + HALF_PI, rad + PI);
      ctx.closePath();
      break;
    case "rect":
      if (!rotation) {
        size2 = Math.SQRT1_2 * radius;
        width = w2 ? w2 / 2 : size2;
        ctx.rect(x2 - width, y2 - size2, 2 * width, 2 * size2);
        break;
      }
      rad += QUARTER_PI;
    case "rectRot":
      xOffsetW = Math.cos(rad) * (w2 ? w2 / 2 : radius);
      xOffset = Math.cos(rad) * radius;
      yOffset = Math.sin(rad) * radius;
      yOffsetW = Math.sin(rad) * (w2 ? w2 / 2 : radius);
      ctx.moveTo(x2 - xOffsetW, y2 - yOffset);
      ctx.lineTo(x2 + yOffsetW, y2 - xOffset);
      ctx.lineTo(x2 + xOffsetW, y2 + yOffset);
      ctx.lineTo(x2 - yOffsetW, y2 + xOffset);
      ctx.closePath();
      break;
    case "crossRot":
      rad += QUARTER_PI;
    case "cross":
      xOffsetW = Math.cos(rad) * (w2 ? w2 / 2 : radius);
      xOffset = Math.cos(rad) * radius;
      yOffset = Math.sin(rad) * radius;
      yOffsetW = Math.sin(rad) * (w2 ? w2 / 2 : radius);
      ctx.moveTo(x2 - xOffsetW, y2 - yOffset);
      ctx.lineTo(x2 + xOffsetW, y2 + yOffset);
      ctx.moveTo(x2 + yOffsetW, y2 - xOffset);
      ctx.lineTo(x2 - yOffsetW, y2 + xOffset);
      break;
    case "star":
      xOffsetW = Math.cos(rad) * (w2 ? w2 / 2 : radius);
      xOffset = Math.cos(rad) * radius;
      yOffset = Math.sin(rad) * radius;
      yOffsetW = Math.sin(rad) * (w2 ? w2 / 2 : radius);
      ctx.moveTo(x2 - xOffsetW, y2 - yOffset);
      ctx.lineTo(x2 + xOffsetW, y2 + yOffset);
      ctx.moveTo(x2 + yOffsetW, y2 - xOffset);
      ctx.lineTo(x2 - yOffsetW, y2 + xOffset);
      rad += QUARTER_PI;
      xOffsetW = Math.cos(rad) * (w2 ? w2 / 2 : radius);
      xOffset = Math.cos(rad) * radius;
      yOffset = Math.sin(rad) * radius;
      yOffsetW = Math.sin(rad) * (w2 ? w2 / 2 : radius);
      ctx.moveTo(x2 - xOffsetW, y2 - yOffset);
      ctx.lineTo(x2 + xOffsetW, y2 + yOffset);
      ctx.moveTo(x2 + yOffsetW, y2 - xOffset);
      ctx.lineTo(x2 - yOffsetW, y2 + xOffset);
      break;
    case "line":
      xOffset = w2 ? w2 / 2 : Math.cos(rad) * radius;
      yOffset = Math.sin(rad) * radius;
      ctx.moveTo(x2 - xOffset, y2 - yOffset);
      ctx.lineTo(x2 + xOffset, y2 + yOffset);
      break;
    case "dash":
      ctx.moveTo(x2, y2);
      ctx.lineTo(x2 + Math.cos(rad) * (w2 ? w2 / 2 : radius), y2 + Math.sin(rad) * radius);
      break;
    case false:
      ctx.closePath();
      break;
  }
  ctx.fill();
  if (options2.borderWidth > 0) {
    ctx.stroke();
  }
}
function _isPointInArea(point, area, margin) {
  margin = margin || 0.5;
  return !area || point && point.x > area.left - margin && point.x < area.right + margin && point.y > area.top - margin && point.y < area.bottom + margin;
}
function clipArea(ctx, area) {
  ctx.save();
  ctx.beginPath();
  ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
  ctx.clip();
}
function unclipArea(ctx) {
  ctx.restore();
}
function _steppedLineTo(ctx, previous, target, flip2, mode) {
  if (!previous) {
    return ctx.lineTo(target.x, target.y);
  }
  if (mode === "middle") {
    const midpoint = (previous.x + target.x) / 2;
    ctx.lineTo(midpoint, previous.y);
    ctx.lineTo(midpoint, target.y);
  } else if (mode === "after" !== !!flip2) {
    ctx.lineTo(previous.x, target.y);
  } else {
    ctx.lineTo(target.x, previous.y);
  }
  ctx.lineTo(target.x, target.y);
}
function _bezierCurveTo(ctx, previous, target, flip2) {
  if (!previous) {
    return ctx.lineTo(target.x, target.y);
  }
  ctx.bezierCurveTo(flip2 ? previous.cp1x : previous.cp2x, flip2 ? previous.cp1y : previous.cp2y, flip2 ? target.cp2x : target.cp1x, flip2 ? target.cp2y : target.cp1y, target.x, target.y);
}
function setRenderOpts(ctx, opts) {
  if (opts.translation) {
    ctx.translate(opts.translation[0], opts.translation[1]);
  }
  if (!isNullOrUndef(opts.rotation)) {
    ctx.rotate(opts.rotation);
  }
  if (opts.color) {
    ctx.fillStyle = opts.color;
  }
  if (opts.textAlign) {
    ctx.textAlign = opts.textAlign;
  }
  if (opts.textBaseline) {
    ctx.textBaseline = opts.textBaseline;
  }
}
function decorateText(ctx, x2, y2, line2, opts) {
  if (opts.strikethrough || opts.underline) {
    const metrics = ctx.measureText(line2);
    const left = x2 - metrics.actualBoundingBoxLeft;
    const right = x2 + metrics.actualBoundingBoxRight;
    const top = y2 - metrics.actualBoundingBoxAscent;
    const bottom = y2 + metrics.actualBoundingBoxDescent;
    const yDecoration = opts.strikethrough ? (top + bottom) / 2 : bottom;
    ctx.strokeStyle = ctx.fillStyle;
    ctx.beginPath();
    ctx.lineWidth = opts.decorationWidth || 2;
    ctx.moveTo(left, yDecoration);
    ctx.lineTo(right, yDecoration);
    ctx.stroke();
  }
}
function drawBackdrop(ctx, opts) {
  const oldColor = ctx.fillStyle;
  ctx.fillStyle = opts.color;
  ctx.fillRect(opts.left, opts.top, opts.width, opts.height);
  ctx.fillStyle = oldColor;
}
function renderText(ctx, text, x2, y2, font, opts = {}) {
  const lines = isArray$1(text) ? text : [
    text
  ];
  const stroke = opts.strokeWidth > 0 && opts.strokeColor !== "";
  let i, line2;
  ctx.save();
  ctx.font = font.string;
  setRenderOpts(ctx, opts);
  for (i = 0; i < lines.length; ++i) {
    line2 = lines[i];
    if (opts.backdrop) {
      drawBackdrop(ctx, opts.backdrop);
    }
    if (stroke) {
      if (opts.strokeColor) {
        ctx.strokeStyle = opts.strokeColor;
      }
      if (!isNullOrUndef(opts.strokeWidth)) {
        ctx.lineWidth = opts.strokeWidth;
      }
      ctx.strokeText(line2, x2, y2, opts.maxWidth);
    }
    ctx.fillText(line2, x2, y2, opts.maxWidth);
    decorateText(ctx, x2, y2, line2, opts);
    y2 += Number(font.lineHeight);
  }
  ctx.restore();
}
function addRoundedRectPath(ctx, rect) {
  const { x: x2, y: y2, w: w2, h: h3, radius } = rect;
  ctx.arc(x2 + radius.topLeft, y2 + radius.topLeft, radius.topLeft, 1.5 * PI, PI, true);
  ctx.lineTo(x2, y2 + h3 - radius.bottomLeft);
  ctx.arc(x2 + radius.bottomLeft, y2 + h3 - radius.bottomLeft, radius.bottomLeft, PI, HALF_PI, true);
  ctx.lineTo(x2 + w2 - radius.bottomRight, y2 + h3);
  ctx.arc(x2 + w2 - radius.bottomRight, y2 + h3 - radius.bottomRight, radius.bottomRight, HALF_PI, 0, true);
  ctx.lineTo(x2 + w2, y2 + radius.topRight);
  ctx.arc(x2 + w2 - radius.topRight, y2 + radius.topRight, radius.topRight, 0, -HALF_PI, true);
  ctx.lineTo(x2 + radius.topLeft, y2);
}
const LINE_HEIGHT = /^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/;
const FONT_STYLE = /^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/;
function toLineHeight(value, size2) {
  const matches = ("" + value).match(LINE_HEIGHT);
  if (!matches || matches[1] === "normal") {
    return size2 * 1.2;
  }
  value = +matches[2];
  switch (matches[3]) {
    case "px":
      return value;
    case "%":
      value /= 100;
      break;
  }
  return size2 * value;
}
const numberOrZero = (v2) => +v2 || 0;
function _readValueToProps(value, props) {
  const ret = {};
  const objProps = isObject(props);
  const keys = objProps ? Object.keys(props) : props;
  const read = isObject(value) ? objProps ? (prop) => valueOrDefault(value[prop], value[props[prop]]) : (prop) => value[prop] : () => value;
  for (const prop of keys) {
    ret[prop] = numberOrZero(read(prop));
  }
  return ret;
}
function toTRBL(value) {
  return _readValueToProps(value, {
    top: "y",
    right: "x",
    bottom: "y",
    left: "x"
  });
}
function toTRBLCorners(value) {
  return _readValueToProps(value, [
    "topLeft",
    "topRight",
    "bottomLeft",
    "bottomRight"
  ]);
}
function toPadding(value) {
  const obj = toTRBL(value);
  obj.width = obj.left + obj.right;
  obj.height = obj.top + obj.bottom;
  return obj;
}
function toFont(options2, fallback) {
  options2 = options2 || {};
  fallback = fallback || defaults$3.font;
  let size2 = valueOrDefault(options2.size, fallback.size);
  if (typeof size2 === "string") {
    size2 = parseInt(size2, 10);
  }
  let style = valueOrDefault(options2.style, fallback.style);
  if (style && !("" + style).match(FONT_STYLE)) {
    console.warn('Invalid font style specified: "' + style + '"');
    style = void 0;
  }
  const font = {
    family: valueOrDefault(options2.family, fallback.family),
    lineHeight: toLineHeight(valueOrDefault(options2.lineHeight, fallback.lineHeight), size2),
    size: size2,
    style,
    weight: valueOrDefault(options2.weight, fallback.weight),
    string: ""
  };
  font.string = toFontString(font);
  return font;
}
function resolve(inputs, context, index2, info) {
  let cacheable = true;
  let i, ilen, value;
  for (i = 0, ilen = inputs.length; i < ilen; ++i) {
    value = inputs[i];
    if (value === void 0) {
      continue;
    }
    if (context !== void 0 && typeof value === "function") {
      value = value(context);
      cacheable = false;
    }
    if (index2 !== void 0 && isArray$1(value)) {
      value = value[index2 % value.length];
      cacheable = false;
    }
    if (value !== void 0) {
      if (info && !cacheable) {
        info.cacheable = false;
      }
      return value;
    }
  }
}
function _addGrace(minmax, grace, beginAtZero) {
  const { min: min2, max: max2 } = minmax;
  const change = toDimension(grace, (max2 - min2) / 2);
  const keepZero = (value, add) => beginAtZero && value === 0 ? 0 : value + add;
  return {
    min: keepZero(min2, -Math.abs(change)),
    max: keepZero(max2, change)
  };
}
function createContext(parentContext, context) {
  return Object.assign(Object.create(parentContext), context);
}
function _createResolver(scopes, prefixes = [
  ""
], rootScopes, fallback, getTarget = () => scopes[0]) {
  const finalRootScopes = rootScopes || scopes;
  if (typeof fallback === "undefined") {
    fallback = _resolve("_fallback", scopes);
  }
  const cache = {
    [Symbol.toStringTag]: "Object",
    _cacheable: true,
    _scopes: scopes,
    _rootScopes: finalRootScopes,
    _fallback: fallback,
    _getTarget: getTarget,
    override: (scope) => _createResolver([
      scope,
      ...scopes
    ], prefixes, finalRootScopes, fallback)
  };
  return new Proxy(cache, {
    /**
    * A trap for the delete operator.
    */
    deleteProperty(target, prop) {
      delete target[prop];
      delete target._keys;
      delete scopes[0][prop];
      return true;
    },
    /**
    * A trap for getting property values.
    */
    get(target, prop) {
      return _cached(target, prop, () => _resolveWithPrefixes(prop, prefixes, scopes, target));
    },
    /**
    * A trap for Object.getOwnPropertyDescriptor.
    * Also used by Object.hasOwnProperty.
    */
    getOwnPropertyDescriptor(target, prop) {
      return Reflect.getOwnPropertyDescriptor(target._scopes[0], prop);
    },
    /**
    * A trap for Object.getPrototypeOf.
    */
    getPrototypeOf() {
      return Reflect.getPrototypeOf(scopes[0]);
    },
    /**
    * A trap for the in operator.
    */
    has(target, prop) {
      return getKeysFromAllScopes(target).includes(prop);
    },
    /**
    * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
    */
    ownKeys(target) {
      return getKeysFromAllScopes(target);
    },
    /**
    * A trap for setting property values.
    */
    set(target, prop, value) {
      const storage = target._storage || (target._storage = getTarget());
      target[prop] = storage[prop] = value;
      delete target._keys;
      return true;
    }
  });
}
function _attachContext(proxy, context, subProxy, descriptorDefaults) {
  const cache = {
    _cacheable: false,
    _proxy: proxy,
    _context: context,
    _subProxy: subProxy,
    _stack: /* @__PURE__ */ new Set(),
    _descriptors: _descriptors(proxy, descriptorDefaults),
    setContext: (ctx) => _attachContext(proxy, ctx, subProxy, descriptorDefaults),
    override: (scope) => _attachContext(proxy.override(scope), context, subProxy, descriptorDefaults)
  };
  return new Proxy(cache, {
    /**
    * A trap for the delete operator.
    */
    deleteProperty(target, prop) {
      delete target[prop];
      delete proxy[prop];
      return true;
    },
    /**
    * A trap for getting property values.
    */
    get(target, prop, receiver) {
      return _cached(target, prop, () => _resolveWithContext(target, prop, receiver));
    },
    /**
    * A trap for Object.getOwnPropertyDescriptor.
    * Also used by Object.hasOwnProperty.
    */
    getOwnPropertyDescriptor(target, prop) {
      return target._descriptors.allKeys ? Reflect.has(proxy, prop) ? {
        enumerable: true,
        configurable: true
      } : void 0 : Reflect.getOwnPropertyDescriptor(proxy, prop);
    },
    /**
    * A trap for Object.getPrototypeOf.
    */
    getPrototypeOf() {
      return Reflect.getPrototypeOf(proxy);
    },
    /**
    * A trap for the in operator.
    */
    has(target, prop) {
      return Reflect.has(proxy, prop);
    },
    /**
    * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
    */
    ownKeys() {
      return Reflect.ownKeys(proxy);
    },
    /**
    * A trap for setting property values.
    */
    set(target, prop, value) {
      proxy[prop] = value;
      delete target[prop];
      return true;
    }
  });
}
function _descriptors(proxy, defaults2 = {
  scriptable: true,
  indexable: true
}) {
  const { _scriptable = defaults2.scriptable, _indexable = defaults2.indexable, _allKeys = defaults2.allKeys } = proxy;
  return {
    allKeys: _allKeys,
    scriptable: _scriptable,
    indexable: _indexable,
    isScriptable: isFunction(_scriptable) ? _scriptable : () => _scriptable,
    isIndexable: isFunction(_indexable) ? _indexable : () => _indexable
  };
}
const readKey = (prefix2, name) => prefix2 ? prefix2 + _capitalize(name) : name;
const needsSubResolver = (prop, value) => isObject(value) && prop !== "adapters" && (Object.getPrototypeOf(value) === null || value.constructor === Object);
function _cached(target, prop, resolve2) {
  if (Object.prototype.hasOwnProperty.call(target, prop) || prop === "constructor") {
    return target[prop];
  }
  const value = resolve2();
  target[prop] = value;
  return value;
}
function _resolveWithContext(target, prop, receiver) {
  const { _proxy, _context, _subProxy, _descriptors: descriptors2 } = target;
  let value = _proxy[prop];
  if (isFunction(value) && descriptors2.isScriptable(prop)) {
    value = _resolveScriptable(prop, value, target, receiver);
  }
  if (isArray$1(value) && value.length) {
    value = _resolveArray(prop, value, target, descriptors2.isIndexable);
  }
  if (needsSubResolver(prop, value)) {
    value = _attachContext(value, _context, _subProxy && _subProxy[prop], descriptors2);
  }
  return value;
}
function _resolveScriptable(prop, getValue, target, receiver) {
  const { _proxy, _context, _subProxy, _stack } = target;
  if (_stack.has(prop)) {
    throw new Error("Recursion detected: " + Array.from(_stack).join("->") + "->" + prop);
  }
  _stack.add(prop);
  let value = getValue(_context, _subProxy || receiver);
  _stack.delete(prop);
  if (needsSubResolver(prop, value)) {
    value = createSubResolver(_proxy._scopes, _proxy, prop, value);
  }
  return value;
}
function _resolveArray(prop, value, target, isIndexable) {
  const { _proxy, _context, _subProxy, _descriptors: descriptors2 } = target;
  if (typeof _context.index !== "undefined" && isIndexable(prop)) {
    return value[_context.index % value.length];
  } else if (isObject(value[0])) {
    const arr = value;
    const scopes = _proxy._scopes.filter((s2) => s2 !== arr);
    value = [];
    for (const item of arr) {
      const resolver = createSubResolver(scopes, _proxy, prop, item);
      value.push(_attachContext(resolver, _context, _subProxy && _subProxy[prop], descriptors2));
    }
  }
  return value;
}
function resolveFallback(fallback, prop, value) {
  return isFunction(fallback) ? fallback(prop, value) : fallback;
}
const getScope = (key, parent) => key === true ? parent : typeof key === "string" ? resolveObjectKey(parent, key) : void 0;
function addScopes(set2, parentScopes, key, parentFallback, value) {
  for (const parent of parentScopes) {
    const scope = getScope(key, parent);
    if (scope) {
      set2.add(scope);
      const fallback = resolveFallback(scope._fallback, key, value);
      if (typeof fallback !== "undefined" && fallback !== key && fallback !== parentFallback) {
        return fallback;
      }
    } else if (scope === false && typeof parentFallback !== "undefined" && key !== parentFallback) {
      return null;
    }
  }
  return false;
}
function createSubResolver(parentScopes, resolver, prop, value) {
  const rootScopes = resolver._rootScopes;
  const fallback = resolveFallback(resolver._fallback, prop, value);
  const allScopes = [
    ...parentScopes,
    ...rootScopes
  ];
  const set2 = /* @__PURE__ */ new Set();
  set2.add(value);
  let key = addScopesFromKey(set2, allScopes, prop, fallback || prop, value);
  if (key === null) {
    return false;
  }
  if (typeof fallback !== "undefined" && fallback !== prop) {
    key = addScopesFromKey(set2, allScopes, fallback, key, value);
    if (key === null) {
      return false;
    }
  }
  return _createResolver(Array.from(set2), [
    ""
  ], rootScopes, fallback, () => subGetTarget(resolver, prop, value));
}
function addScopesFromKey(set2, allScopes, key, fallback, item) {
  while (key) {
    key = addScopes(set2, allScopes, key, fallback, item);
  }
  return key;
}
function subGetTarget(resolver, prop, value) {
  const parent = resolver._getTarget();
  if (!(prop in parent)) {
    parent[prop] = {};
  }
  const target = parent[prop];
  if (isArray$1(target) && isObject(value)) {
    return value;
  }
  return target || {};
}
function _resolveWithPrefixes(prop, prefixes, scopes, proxy) {
  let value;
  for (const prefix2 of prefixes) {
    value = _resolve(readKey(prefix2, prop), scopes);
    if (typeof value !== "undefined") {
      return needsSubResolver(prop, value) ? createSubResolver(scopes, proxy, prop, value) : value;
    }
  }
}
function _resolve(key, scopes) {
  for (const scope of scopes) {
    if (!scope) {
      continue;
    }
    const value = scope[key];
    if (typeof value !== "undefined") {
      return value;
    }
  }
}
function getKeysFromAllScopes(target) {
  let keys = target._keys;
  if (!keys) {
    keys = target._keys = resolveKeysFromAllScopes(target._scopes);
  }
  return keys;
}
function resolveKeysFromAllScopes(scopes) {
  const set2 = /* @__PURE__ */ new Set();
  for (const scope of scopes) {
    for (const key of Object.keys(scope).filter((k2) => !k2.startsWith("_"))) {
      set2.add(key);
    }
  }
  return Array.from(set2);
}
function _parseObjectDataRadialScale(meta, data2, start, count) {
  const { iScale } = meta;
  const { key = "r" } = this._parsing;
  const parsed = new Array(count);
  let i, ilen, index2, item;
  for (i = 0, ilen = count; i < ilen; ++i) {
    index2 = i + start;
    item = data2[index2];
    parsed[i] = {
      r: iScale.parse(resolveObjectKey(item, key), index2)
    };
  }
  return parsed;
}
const EPSILON = Number.EPSILON || 1e-14;
const getPoint = (points, i) => i < points.length && !points[i].skip && points[i];
const getValueAxis = (indexAxis) => indexAxis === "x" ? "y" : "x";
function splineCurve(firstPoint, middlePoint, afterPoint, t2) {
  const previous = firstPoint.skip ? middlePoint : firstPoint;
  const current = middlePoint;
  const next2 = afterPoint.skip ? middlePoint : afterPoint;
  const d01 = distanceBetweenPoints(current, previous);
  const d12 = distanceBetweenPoints(next2, current);
  let s01 = d01 / (d01 + d12);
  let s12 = d12 / (d01 + d12);
  s01 = isNaN(s01) ? 0 : s01;
  s12 = isNaN(s12) ? 0 : s12;
  const fa = t2 * s01;
  const fb = t2 * s12;
  return {
    previous: {
      x: current.x - fa * (next2.x - previous.x),
      y: current.y - fa * (next2.y - previous.y)
    },
    next: {
      x: current.x + fb * (next2.x - previous.x),
      y: current.y + fb * (next2.y - previous.y)
    }
  };
}
function monotoneAdjust(points, deltaK, mK) {
  const pointsLen = points.length;
  let alphaK, betaK, tauK, squaredMagnitude, pointCurrent;
  let pointAfter = getPoint(points, 0);
  for (let i = 0; i < pointsLen - 1; ++i) {
    pointCurrent = pointAfter;
    pointAfter = getPoint(points, i + 1);
    if (!pointCurrent || !pointAfter) {
      continue;
    }
    if (almostEquals(deltaK[i], 0, EPSILON)) {
      mK[i] = mK[i + 1] = 0;
      continue;
    }
    alphaK = mK[i] / deltaK[i];
    betaK = mK[i + 1] / deltaK[i];
    squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
    if (squaredMagnitude <= 9) {
      continue;
    }
    tauK = 3 / Math.sqrt(squaredMagnitude);
    mK[i] = alphaK * tauK * deltaK[i];
    mK[i + 1] = betaK * tauK * deltaK[i];
  }
}
function monotoneCompute(points, mK, indexAxis = "x") {
  const valueAxis = getValueAxis(indexAxis);
  const pointsLen = points.length;
  let delta, pointBefore, pointCurrent;
  let pointAfter = getPoint(points, 0);
  for (let i = 0; i < pointsLen; ++i) {
    pointBefore = pointCurrent;
    pointCurrent = pointAfter;
    pointAfter = getPoint(points, i + 1);
    if (!pointCurrent) {
      continue;
    }
    const iPixel = pointCurrent[indexAxis];
    const vPixel = pointCurrent[valueAxis];
    if (pointBefore) {
      delta = (iPixel - pointBefore[indexAxis]) / 3;
      pointCurrent[`cp1${indexAxis}`] = iPixel - delta;
      pointCurrent[`cp1${valueAxis}`] = vPixel - delta * mK[i];
    }
    if (pointAfter) {
      delta = (pointAfter[indexAxis] - iPixel) / 3;
      pointCurrent[`cp2${indexAxis}`] = iPixel + delta;
      pointCurrent[`cp2${valueAxis}`] = vPixel + delta * mK[i];
    }
  }
}
function splineCurveMonotone(points, indexAxis = "x") {
  const valueAxis = getValueAxis(indexAxis);
  const pointsLen = points.length;
  const deltaK = Array(pointsLen).fill(0);
  const mK = Array(pointsLen);
  let i, pointBefore, pointCurrent;
  let pointAfter = getPoint(points, 0);
  for (i = 0; i < pointsLen; ++i) {
    pointBefore = pointCurrent;
    pointCurrent = pointAfter;
    pointAfter = getPoint(points, i + 1);
    if (!pointCurrent) {
      continue;
    }
    if (pointAfter) {
      const slopeDelta = pointAfter[indexAxis] - pointCurrent[indexAxis];
      deltaK[i] = slopeDelta !== 0 ? (pointAfter[valueAxis] - pointCurrent[valueAxis]) / slopeDelta : 0;
    }
    mK[i] = !pointBefore ? deltaK[i] : !pointAfter ? deltaK[i - 1] : sign(deltaK[i - 1]) !== sign(deltaK[i]) ? 0 : (deltaK[i - 1] + deltaK[i]) / 2;
  }
  monotoneAdjust(points, deltaK, mK);
  monotoneCompute(points, mK, indexAxis);
}
function capControlPoint(pt, min2, max2) {
  return Math.max(Math.min(pt, max2), min2);
}
function capBezierPoints(points, area) {
  let i, ilen, point, inArea, inAreaPrev;
  let inAreaNext = _isPointInArea(points[0], area);
  for (i = 0, ilen = points.length; i < ilen; ++i) {
    inAreaPrev = inArea;
    inArea = inAreaNext;
    inAreaNext = i < ilen - 1 && _isPointInArea(points[i + 1], area);
    if (!inArea) {
      continue;
    }
    point = points[i];
    if (inAreaPrev) {
      point.cp1x = capControlPoint(point.cp1x, area.left, area.right);
      point.cp1y = capControlPoint(point.cp1y, area.top, area.bottom);
    }
    if (inAreaNext) {
      point.cp2x = capControlPoint(point.cp2x, area.left, area.right);
      point.cp2y = capControlPoint(point.cp2y, area.top, area.bottom);
    }
  }
}
function _updateBezierControlPoints(points, options2, area, loop, indexAxis) {
  let i, ilen, point, controlPoints;
  if (options2.spanGaps) {
    points = points.filter((pt) => !pt.skip);
  }
  if (options2.cubicInterpolationMode === "monotone") {
    splineCurveMonotone(points, indexAxis);
  } else {
    let prev2 = loop ? points[points.length - 1] : points[0];
    for (i = 0, ilen = points.length; i < ilen; ++i) {
      point = points[i];
      controlPoints = splineCurve(prev2, point, points[Math.min(i + 1, ilen - (loop ? 0 : 1)) % ilen], options2.tension);
      point.cp1x = controlPoints.previous.x;
      point.cp1y = controlPoints.previous.y;
      point.cp2x = controlPoints.next.x;
      point.cp2y = controlPoints.next.y;
      prev2 = point;
    }
  }
  if (options2.capBezierPoints) {
    capBezierPoints(points, area);
  }
}
function _isDomSupported() {
  return typeof window !== "undefined" && typeof document !== "undefined";
}
function _getParentNode(domNode) {
  let parent = domNode.parentNode;
  if (parent && parent.toString() === "[object ShadowRoot]") {
    parent = parent.host;
  }
  return parent;
}
function parseMaxStyle(styleValue, node2, parentProperty) {
  let valueInPixels;
  if (typeof styleValue === "string") {
    valueInPixels = parseInt(styleValue, 10);
    if (styleValue.indexOf("%") !== -1) {
      valueInPixels = valueInPixels / 100 * node2.parentNode[parentProperty];
    }
  } else {
    valueInPixels = styleValue;
  }
  return valueInPixels;
}
const getComputedStyle$1 = (element) => element.ownerDocument.defaultView.getComputedStyle(element, null);
function getStyle(el, property) {
  return getComputedStyle$1(el).getPropertyValue(property);
}
const positions = [
  "top",
  "right",
  "bottom",
  "left"
];
function getPositionedStyle(styles, style, suffix) {
  const result = {};
  suffix = suffix ? "-" + suffix : "";
  for (let i = 0; i < 4; i++) {
    const pos = positions[i];
    result[pos] = parseFloat(styles[style + "-" + pos + suffix]) || 0;
  }
  result.width = result.left + result.right;
  result.height = result.top + result.bottom;
  return result;
}
const useOffsetPos = (x2, y2, target) => (x2 > 0 || y2 > 0) && (!target || !target.shadowRoot);
function getCanvasPosition(e2, canvas) {
  const touches = e2.touches;
  const source = touches && touches.length ? touches[0] : e2;
  const { offsetX, offsetY } = source;
  let box2 = false;
  let x2, y2;
  if (useOffsetPos(offsetX, offsetY, e2.target)) {
    x2 = offsetX;
    y2 = offsetY;
  } else {
    const rect = canvas.getBoundingClientRect();
    x2 = source.clientX - rect.left;
    y2 = source.clientY - rect.top;
    box2 = true;
  }
  return {
    x: x2,
    y: y2,
    box: box2
  };
}
function getRelativePosition(event, chart) {
  if ("native" in event) {
    return event;
  }
  const { canvas, currentDevicePixelRatio } = chart;
  const style = getComputedStyle$1(canvas);
  const borderBox = style.boxSizing === "border-box";
  const paddings = getPositionedStyle(style, "padding");
  const borders = getPositionedStyle(style, "border", "width");
  const { x: x2, y: y2, box: box2 } = getCanvasPosition(event, canvas);
  const xOffset = paddings.left + (box2 && borders.left);
  const yOffset = paddings.top + (box2 && borders.top);
  let { width, height: height2 } = chart;
  if (borderBox) {
    width -= paddings.width + borders.width;
    height2 -= paddings.height + borders.height;
  }
  return {
    x: Math.round((x2 - xOffset) / width * canvas.width / currentDevicePixelRatio),
    y: Math.round((y2 - yOffset) / height2 * canvas.height / currentDevicePixelRatio)
  };
}
function getContainerSize(canvas, width, height2) {
  let maxWidth, maxHeight;
  if (width === void 0 || height2 === void 0) {
    const container = canvas && _getParentNode(canvas);
    if (!container) {
      width = canvas.clientWidth;
      height2 = canvas.clientHeight;
    } else {
      const rect = container.getBoundingClientRect();
      const containerStyle2 = getComputedStyle$1(container);
      const containerBorder = getPositionedStyle(containerStyle2, "border", "width");
      const containerPadding = getPositionedStyle(containerStyle2, "padding");
      width = rect.width - containerPadding.width - containerBorder.width;
      height2 = rect.height - containerPadding.height - containerBorder.height;
      maxWidth = parseMaxStyle(containerStyle2.maxWidth, container, "clientWidth");
      maxHeight = parseMaxStyle(containerStyle2.maxHeight, container, "clientHeight");
    }
  }
  return {
    width,
    height: height2,
    maxWidth: maxWidth || INFINITY,
    maxHeight: maxHeight || INFINITY
  };
}
const round1 = (v2) => Math.round(v2 * 10) / 10;
function getMaximumSize(canvas, bbWidth, bbHeight, aspectRatio) {
  const style = getComputedStyle$1(canvas);
  const margins = getPositionedStyle(style, "margin");
  const maxWidth = parseMaxStyle(style.maxWidth, canvas, "clientWidth") || INFINITY;
  const maxHeight = parseMaxStyle(style.maxHeight, canvas, "clientHeight") || INFINITY;
  const containerSize = getContainerSize(canvas, bbWidth, bbHeight);
  let { width, height: height2 } = containerSize;
  if (style.boxSizing === "content-box") {
    const borders = getPositionedStyle(style, "border", "width");
    const paddings = getPositionedStyle(style, "padding");
    width -= paddings.width + borders.width;
    height2 -= paddings.height + borders.height;
  }
  width = Math.max(0, width - margins.width);
  height2 = Math.max(0, aspectRatio ? width / aspectRatio : height2 - margins.height);
  width = round1(Math.min(width, maxWidth, containerSize.maxWidth));
  height2 = round1(Math.min(height2, maxHeight, containerSize.maxHeight));
  if (width && !height2) {
    height2 = round1(width / 2);
  }
  const maintainHeight = bbWidth !== void 0 || bbHeight !== void 0;
  if (maintainHeight && aspectRatio && containerSize.height && height2 > containerSize.height) {
    height2 = containerSize.height;
    width = round1(Math.floor(height2 * aspectRatio));
  }
  return {
    width,
    height: height2
  };
}
function retinaScale(chart, forceRatio, forceStyle) {
  const pixelRatio = forceRatio || 1;
  const deviceHeight = Math.floor(chart.height * pixelRatio);
  const deviceWidth = Math.floor(chart.width * pixelRatio);
  chart.height = Math.floor(chart.height);
  chart.width = Math.floor(chart.width);
  const canvas = chart.canvas;
  if (canvas.style && (forceStyle || !canvas.style.height && !canvas.style.width)) {
    canvas.style.height = `${chart.height}px`;
    canvas.style.width = `${chart.width}px`;
  }
  if (chart.currentDevicePixelRatio !== pixelRatio || canvas.height !== deviceHeight || canvas.width !== deviceWidth) {
    chart.currentDevicePixelRatio = pixelRatio;
    canvas.height = deviceHeight;
    canvas.width = deviceWidth;
    chart.ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
    return true;
  }
  return false;
}
const supportsEventListenerOptions = function() {
  let passiveSupported2 = false;
  try {
    const options2 = {
      get passive() {
        passiveSupported2 = true;
        return false;
      }
    };
    if (_isDomSupported()) {
      window.addEventListener("test", null, options2);
      window.removeEventListener("test", null, options2);
    }
  } catch (e2) {
  }
  return passiveSupported2;
}();
function readUsedSize(element, property) {
  const value = getStyle(element, property);
  const matches = value && value.match(/^(\d+)(\.\d+)?px$/);
  return matches ? +matches[1] : void 0;
}
function _pointInLine(p1, p2, t2, mode) {
  return {
    x: p1.x + t2 * (p2.x - p1.x),
    y: p1.y + t2 * (p2.y - p1.y)
  };
}
function _steppedInterpolation(p1, p2, t2, mode) {
  return {
    x: p1.x + t2 * (p2.x - p1.x),
    y: mode === "middle" ? t2 < 0.5 ? p1.y : p2.y : mode === "after" ? t2 < 1 ? p1.y : p2.y : t2 > 0 ? p2.y : p1.y
  };
}
function _bezierInterpolation(p1, p2, t2, mode) {
  const cp1 = {
    x: p1.cp2x,
    y: p1.cp2y
  };
  const cp2 = {
    x: p2.cp1x,
    y: p2.cp1y
  };
  const a2 = _pointInLine(p1, cp1, t2);
  const b2 = _pointInLine(cp1, cp2, t2);
  const c4 = _pointInLine(cp2, p2, t2);
  const d2 = _pointInLine(a2, b2, t2);
  const e2 = _pointInLine(b2, c4, t2);
  return _pointInLine(d2, e2, t2);
}
const getRightToLeftAdapter = function(rectX, width) {
  return {
    x(x2) {
      return rectX + rectX + width - x2;
    },
    setWidth(w2) {
      width = w2;
    },
    textAlign(align) {
      if (align === "center") {
        return align;
      }
      return align === "right" ? "left" : "right";
    },
    xPlus(x2, value) {
      return x2 - value;
    },
    leftForLtr(x2, itemWidth) {
      return x2 - itemWidth;
    }
  };
};
const getLeftToRightAdapter = function() {
  return {
    x(x2) {
      return x2;
    },
    setWidth(w2) {
    },
    textAlign(align) {
      return align;
    },
    xPlus(x2, value) {
      return x2 + value;
    },
    leftForLtr(x2, _itemWidth) {
      return x2;
    }
  };
};
function getRtlAdapter(rtl, rectX, width) {
  return rtl ? getRightToLeftAdapter(rectX, width) : getLeftToRightAdapter();
}
function overrideTextDirection(ctx, direction) {
  let style, original;
  if (direction === "ltr" || direction === "rtl") {
    style = ctx.canvas.style;
    original = [
      style.getPropertyValue("direction"),
      style.getPropertyPriority("direction")
    ];
    style.setProperty("direction", direction, "important");
    ctx.prevTextDirection = original;
  }
}
function restoreTextDirection(ctx, original) {
  if (original !== void 0) {
    delete ctx.prevTextDirection;
    ctx.canvas.style.setProperty("direction", original[0], original[1]);
  }
}
function propertyFn(property) {
  if (property === "angle") {
    return {
      between: _angleBetween,
      compare: _angleDiff,
      normalize: _normalizeAngle
    };
  }
  return {
    between: _isBetween,
    compare: (a2, b2) => a2 - b2,
    normalize: (x2) => x2
  };
}
function normalizeSegment({ start, end, count, loop, style }) {
  return {
    start: start % count,
    end: end % count,
    loop: loop && (end - start + 1) % count === 0,
    style
  };
}
function getSegment(segment, points, bounds) {
  const { property, start: startBound, end: endBound } = bounds;
  const { between, normalize } = propertyFn(property);
  const count = points.length;
  let { start, end, loop } = segment;
  let i, ilen;
  if (loop) {
    start += count;
    end += count;
    for (i = 0, ilen = count; i < ilen; ++i) {
      if (!between(normalize(points[start % count][property]), startBound, endBound)) {
        break;
      }
      start--;
      end--;
    }
    start %= count;
    end %= count;
  }
  if (end < start) {
    end += count;
  }
  return {
    start,
    end,
    loop,
    style: segment.style
  };
}
function _boundSegment(segment, points, bounds) {
  if (!bounds) {
    return [
      segment
    ];
  }
  const { property, start: startBound, end: endBound } = bounds;
  const count = points.length;
  const { compare, between, normalize } = propertyFn(property);
  const { start, end, loop, style } = getSegment(segment, points, bounds);
  const result = [];
  let inside = false;
  let subStart = null;
  let value, point, prevValue;
  const startIsBefore = () => between(startBound, prevValue, value) && compare(startBound, prevValue) !== 0;
  const endIsBefore = () => compare(endBound, value) === 0 || between(endBound, prevValue, value);
  const shouldStart = () => inside || startIsBefore();
  const shouldStop = () => !inside || endIsBefore();
  for (let i = start, prev2 = start; i <= end; ++i) {
    point = points[i % count];
    if (point.skip) {
      continue;
    }
    value = normalize(point[property]);
    if (value === prevValue) {
      continue;
    }
    inside = between(value, startBound, endBound);
    if (subStart === null && shouldStart()) {
      subStart = compare(value, startBound) === 0 ? i : prev2;
    }
    if (subStart !== null && shouldStop()) {
      result.push(normalizeSegment({
        start: subStart,
        end: i,
        loop,
        count,
        style
      }));
      subStart = null;
    }
    prev2 = i;
    prevValue = value;
  }
  if (subStart !== null) {
    result.push(normalizeSegment({
      start: subStart,
      end,
      loop,
      count,
      style
    }));
  }
  return result;
}
function _boundSegments(line2, bounds) {
  const result = [];
  const segments = line2.segments;
  for (let i = 0; i < segments.length; i++) {
    const sub = _boundSegment(segments[i], line2.points, bounds);
    if (sub.length) {
      result.push(...sub);
    }
  }
  return result;
}
function findStartAndEnd(points, count, loop, spanGaps) {
  let start = 0;
  let end = count - 1;
  if (loop && !spanGaps) {
    while (start < count && !points[start].skip) {
      start++;
    }
  }
  while (start < count && points[start].skip) {
    start++;
  }
  start %= count;
  if (loop) {
    end += start;
  }
  while (end > start && points[end % count].skip) {
    end--;
  }
  end %= count;
  return {
    start,
    end
  };
}
function solidSegments(points, start, max2, loop) {
  const count = points.length;
  const result = [];
  let last2 = start;
  let prev2 = points[start];
  let end;
  for (end = start + 1; end <= max2; ++end) {
    const cur = points[end % count];
    if (cur.skip || cur.stop) {
      if (!prev2.skip) {
        loop = false;
        result.push({
          start: start % count,
          end: (end - 1) % count,
          loop
        });
        start = last2 = cur.stop ? end : null;
      }
    } else {
      last2 = end;
      if (prev2.skip) {
        start = end;
      }
    }
    prev2 = cur;
  }
  if (last2 !== null) {
    result.push({
      start: start % count,
      end: last2 % count,
      loop
    });
  }
  return result;
}
function _computeSegments(line2, segmentOptions) {
  const points = line2.points;
  const spanGaps = line2.options.spanGaps;
  const count = points.length;
  if (!count) {
    return [];
  }
  const loop = !!line2._loop;
  const { start, end } = findStartAndEnd(points, count, loop, spanGaps);
  if (spanGaps === true) {
    return splitByStyles(line2, [
      {
        start,
        end,
        loop
      }
    ], points, segmentOptions);
  }
  const max2 = end < start ? end + count : end;
  const completeLoop = !!line2._fullLoop && start === 0 && end === count - 1;
  return splitByStyles(line2, solidSegments(points, start, max2, completeLoop), points, segmentOptions);
}
function splitByStyles(line2, segments, points, segmentOptions) {
  if (!segmentOptions || !segmentOptions.setContext || !points) {
    return segments;
  }
  return doSplitByStyles(line2, segments, points, segmentOptions);
}
function doSplitByStyles(line2, segments, points, segmentOptions) {
  const chartContext = line2._chart.getContext();
  const baseStyle = readStyle(line2.options);
  const { _datasetIndex: datasetIndex, options: { spanGaps } } = line2;
  const count = points.length;
  const result = [];
  let prevStyle = baseStyle;
  let start = segments[0].start;
  let i = start;
  function addStyle(s2, e2, l2, st) {
    const dir = spanGaps ? -1 : 1;
    if (s2 === e2) {
      return;
    }
    s2 += count;
    while (points[s2 % count].skip) {
      s2 -= dir;
    }
    while (points[e2 % count].skip) {
      e2 += dir;
    }
    if (s2 % count !== e2 % count) {
      result.push({
        start: s2 % count,
        end: e2 % count,
        loop: l2,
        style: st
      });
      prevStyle = st;
      start = e2 % count;
    }
  }
  for (const segment of segments) {
    start = spanGaps ? start : segment.start;
    let prev2 = points[start % count];
    let style;
    for (i = start + 1; i <= segment.end; i++) {
      const pt = points[i % count];
      style = readStyle(segmentOptions.setContext(createContext(chartContext, {
        type: "segment",
        p0: prev2,
        p1: pt,
        p0DataIndex: (i - 1) % count,
        p1DataIndex: i % count,
        datasetIndex
      })));
      if (styleChanged(style, prevStyle)) {
        addStyle(start, i - 1, segment.loop, prevStyle);
      }
      prev2 = pt;
      prevStyle = style;
    }
    if (start < i - 1) {
      addStyle(start, i - 1, segment.loop, prevStyle);
    }
  }
  return result;
}
function readStyle(options2) {
  return {
    backgroundColor: options2.backgroundColor,
    borderCapStyle: options2.borderCapStyle,
    borderDash: options2.borderDash,
    borderDashOffset: options2.borderDashOffset,
    borderJoinStyle: options2.borderJoinStyle,
    borderWidth: options2.borderWidth,
    borderColor: options2.borderColor
  };
}
function styleChanged(style, prevStyle) {
  if (!prevStyle) {
    return false;
  }
  const cache = [];
  const replacer = function(key, value) {
    if (!isPatternOrGradient(value)) {
      return value;
    }
    if (!cache.includes(value)) {
      cache.push(value);
    }
    return cache.indexOf(value);
  };
  return JSON.stringify(style, replacer) !== JSON.stringify(prevStyle, replacer);
}
/*!
 * Chart.js v4.4.3
 * https://www.chartjs.org
 * (c) 2024 Chart.js Contributors
 * Released under the MIT License
 */
class Animator {
  constructor() {
    this._request = null;
    this._charts = /* @__PURE__ */ new Map();
    this._running = false;
    this._lastDate = void 0;
  }
  _notify(chart, anims, date, type2) {
    const callbacks = anims.listeners[type2];
    const numSteps = anims.duration;
    callbacks.forEach((fn) => fn({
      chart,
      initial: anims.initial,
      numSteps,
      currentStep: Math.min(date - anims.start, numSteps)
    }));
  }
  _refresh() {
    if (this._request) {
      return;
    }
    this._running = true;
    this._request = requestAnimFrame.call(window, () => {
      this._update();
      this._request = null;
      if (this._running) {
        this._refresh();
      }
    });
  }
  _update(date = Date.now()) {
    let remaining = 0;
    this._charts.forEach((anims, chart) => {
      if (!anims.running || !anims.items.length) {
        return;
      }
      const items = anims.items;
      let i = items.length - 1;
      let draw2 = false;
      let item;
      for (; i >= 0; --i) {
        item = items[i];
        if (item._active) {
          if (item._total > anims.duration) {
            anims.duration = item._total;
          }
          item.tick(date);
          draw2 = true;
        } else {
          items[i] = items[items.length - 1];
          items.pop();
        }
      }
      if (draw2) {
        chart.draw();
        this._notify(chart, anims, date, "progress");
      }
      if (!items.length) {
        anims.running = false;
        this._notify(chart, anims, date, "complete");
        anims.initial = false;
      }
      remaining += items.length;
    });
    this._lastDate = date;
    if (remaining === 0) {
      this._running = false;
    }
  }
  _getAnims(chart) {
    const charts = this._charts;
    let anims = charts.get(chart);
    if (!anims) {
      anims = {
        running: false,
        initial: true,
        items: [],
        listeners: {
          complete: [],
          progress: []
        }
      };
      charts.set(chart, anims);
    }
    return anims;
  }
  listen(chart, event, cb) {
    this._getAnims(chart).listeners[event].push(cb);
  }
  add(chart, items) {
    if (!items || !items.length) {
      return;
    }
    this._getAnims(chart).items.push(...items);
  }
  has(chart) {
    return this._getAnims(chart).items.length > 0;
  }
  start(chart) {
    const anims = this._charts.get(chart);
    if (!anims) {
      return;
    }
    anims.running = true;
    anims.start = Date.now();
    anims.duration = anims.items.reduce((acc, cur) => Math.max(acc, cur._duration), 0);
    this._refresh();
  }
  running(chart) {
    if (!this._running) {
      return false;
    }
    const anims = this._charts.get(chart);
    if (!anims || !anims.running || !anims.items.length) {
      return false;
    }
    return true;
  }
  stop(chart) {
    const anims = this._charts.get(chart);
    if (!anims || !anims.items.length) {
      return;
    }
    const items = anims.items;
    let i = items.length - 1;
    for (; i >= 0; --i) {
      items[i].cancel();
    }
    anims.items = [];
    this._notify(chart, anims, Date.now(), "complete");
  }
  remove(chart) {
    return this._charts.delete(chart);
  }
}
var animator = /* @__PURE__ */ new Animator();
const transparent = "transparent";
const interpolators = {
  boolean(from2, to2, factor) {
    return factor > 0.5 ? to2 : from2;
  },
  color(from2, to2, factor) {
    const c0 = color(from2 || transparent);
    const c12 = c0.valid && color(to2 || transparent);
    return c12 && c12.valid ? c12.mix(c0, factor).hexString() : to2;
  },
  number(from2, to2, factor) {
    return from2 + (to2 - from2) * factor;
  }
};
class Animation {
  constructor(cfg, target, prop, to2) {
    const currentValue = target[prop];
    to2 = resolve([
      cfg.to,
      to2,
      currentValue,
      cfg.from
    ]);
    const from2 = resolve([
      cfg.from,
      currentValue,
      to2
    ]);
    this._active = true;
    this._fn = cfg.fn || interpolators[cfg.type || typeof from2];
    this._easing = effects[cfg.easing] || effects.linear;
    this._start = Math.floor(Date.now() + (cfg.delay || 0));
    this._duration = this._total = Math.floor(cfg.duration);
    this._loop = !!cfg.loop;
    this._target = target;
    this._prop = prop;
    this._from = from2;
    this._to = to2;
    this._promises = void 0;
  }
  active() {
    return this._active;
  }
  update(cfg, to2, date) {
    if (this._active) {
      this._notify(false);
      const currentValue = this._target[this._prop];
      const elapsed = date - this._start;
      const remain = this._duration - elapsed;
      this._start = date;
      this._duration = Math.floor(Math.max(remain, cfg.duration));
      this._total += elapsed;
      this._loop = !!cfg.loop;
      this._to = resolve([
        cfg.to,
        to2,
        currentValue,
        cfg.from
      ]);
      this._from = resolve([
        cfg.from,
        currentValue,
        to2
      ]);
    }
  }
  cancel() {
    if (this._active) {
      this.tick(Date.now());
      this._active = false;
      this._notify(false);
    }
  }
  tick(date) {
    const elapsed = date - this._start;
    const duration = this._duration;
    const prop = this._prop;
    const from2 = this._from;
    const loop = this._loop;
    const to2 = this._to;
    let factor;
    this._active = from2 !== to2 && (loop || elapsed < duration);
    if (!this._active) {
      this._target[prop] = to2;
      this._notify(true);
      return;
    }
    if (elapsed < 0) {
      this._target[prop] = from2;
      return;
    }
    factor = elapsed / duration % 2;
    factor = loop && factor > 1 ? 2 - factor : factor;
    factor = this._easing(Math.min(1, Math.max(0, factor)));
    this._target[prop] = this._fn(from2, to2, factor);
  }
  wait() {
    const promises = this._promises || (this._promises = []);
    return new Promise((res, rej) => {
      promises.push({
        res,
        rej
      });
    });
  }
  _notify(resolved) {
    const method = resolved ? "res" : "rej";
    const promises = this._promises || [];
    for (let i = 0; i < promises.length; i++) {
      promises[i][method]();
    }
  }
}
class Animations {
  constructor(chart, config2) {
    this._chart = chart;
    this._properties = /* @__PURE__ */ new Map();
    this.configure(config2);
  }
  configure(config2) {
    if (!isObject(config2)) {
      return;
    }
    const animationOptions = Object.keys(defaults$3.animation);
    const animatedProps = this._properties;
    Object.getOwnPropertyNames(config2).forEach((key) => {
      const cfg = config2[key];
      if (!isObject(cfg)) {
        return;
      }
      const resolved = {};
      for (const option2 of animationOptions) {
        resolved[option2] = cfg[option2];
      }
      (isArray$1(cfg.properties) && cfg.properties || [
        key
      ]).forEach((prop) => {
        if (prop === key || !animatedProps.has(prop)) {
          animatedProps.set(prop, resolved);
        }
      });
    });
  }
  _animateOptions(target, values2) {
    const newOptions = values2.options;
    const options2 = resolveTargetOptions(target, newOptions);
    if (!options2) {
      return [];
    }
    const animations = this._createAnimations(options2, newOptions);
    if (newOptions.$shared) {
      awaitAll(target.options.$animations, newOptions).then(() => {
        target.options = newOptions;
      }, () => {
      });
    }
    return animations;
  }
  _createAnimations(target, values2) {
    const animatedProps = this._properties;
    const animations = [];
    const running = target.$animations || (target.$animations = {});
    const props = Object.keys(values2);
    const date = Date.now();
    let i;
    for (i = props.length - 1; i >= 0; --i) {
      const prop = props[i];
      if (prop.charAt(0) === "$") {
        continue;
      }
      if (prop === "options") {
        animations.push(...this._animateOptions(target, values2));
        continue;
      }
      const value = values2[prop];
      let animation = running[prop];
      const cfg = animatedProps.get(prop);
      if (animation) {
        if (cfg && animation.active()) {
          animation.update(cfg, value, date);
          continue;
        } else {
          animation.cancel();
        }
      }
      if (!cfg || !cfg.duration) {
        target[prop] = value;
        continue;
      }
      running[prop] = animation = new Animation(cfg, target, prop, value);
      animations.push(animation);
    }
    return animations;
  }
  update(target, values2) {
    if (this._properties.size === 0) {
      Object.assign(target, values2);
      return;
    }
    const animations = this._createAnimations(target, values2);
    if (animations.length) {
      animator.add(this._chart, animations);
      return true;
    }
  }
}
function awaitAll(animations, properties) {
  const running = [];
  const keys = Object.keys(properties);
  for (let i = 0; i < keys.length; i++) {
    const anim = animations[keys[i]];
    if (anim && anim.active()) {
      running.push(anim.wait());
    }
  }
  return Promise.all(running);
}
function resolveTargetOptions(target, newOptions) {
  if (!newOptions) {
    return;
  }
  let options2 = target.options;
  if (!options2) {
    target.options = newOptions;
    return;
  }
  if (options2.$shared) {
    target.options = options2 = Object.assign({}, options2, {
      $shared: false,
      $animations: {}
    });
  }
  return options2;
}
function scaleClip(scale2, allowedOverflow) {
  const opts = scale2 && scale2.options || {};
  const reverse = opts.reverse;
  const min2 = opts.min === void 0 ? allowedOverflow : 0;
  const max2 = opts.max === void 0 ? allowedOverflow : 0;
  return {
    start: reverse ? max2 : min2,
    end: reverse ? min2 : max2
  };
}
function defaultClip(xScale, yScale, allowedOverflow) {
  if (allowedOverflow === false) {
    return false;
  }
  const x2 = scaleClip(xScale, allowedOverflow);
  const y2 = scaleClip(yScale, allowedOverflow);
  return {
    top: y2.end,
    right: x2.end,
    bottom: y2.start,
    left: x2.start
  };
}
function toClip(value) {
  let t2, r2, b2, l2;
  if (isObject(value)) {
    t2 = value.top;
    r2 = value.right;
    b2 = value.bottom;
    l2 = value.left;
  } else {
    t2 = r2 = b2 = l2 = value;
  }
  return {
    top: t2,
    right: r2,
    bottom: b2,
    left: l2,
    disabled: value === false
  };
}
function getSortedDatasetIndices(chart, filterVisible) {
  const keys = [];
  const metasets = chart._getSortedDatasetMetas(filterVisible);
  let i, ilen;
  for (i = 0, ilen = metasets.length; i < ilen; ++i) {
    keys.push(metasets[i].index);
  }
  return keys;
}
function applyStack(stack, value, dsIndex, options2 = {}) {
  const keys = stack.keys;
  const singleMode = options2.mode === "single";
  let i, ilen, datasetIndex, otherValue;
  if (value === null) {
    return;
  }
  for (i = 0, ilen = keys.length; i < ilen; ++i) {
    datasetIndex = +keys[i];
    if (datasetIndex === dsIndex) {
      if (options2.all) {
        continue;
      }
      break;
    }
    otherValue = stack.values[datasetIndex];
    if (isNumberFinite(otherValue) && (singleMode || value === 0 || sign(value) === sign(otherValue))) {
      value += otherValue;
    }
  }
  return value;
}
function convertObjectDataToArray(data2, meta) {
  const { iScale, vScale } = meta;
  const iAxisKey = iScale.axis === "x" ? "x" : "y";
  const vAxisKey = vScale.axis === "x" ? "x" : "y";
  const keys = Object.keys(data2);
  const adata = new Array(keys.length);
  let i, ilen, key;
  for (i = 0, ilen = keys.length; i < ilen; ++i) {
    key = keys[i];
    adata[i] = {
      [iAxisKey]: key,
      [vAxisKey]: data2[key]
    };
  }
  return adata;
}
function isStacked(scale2, meta) {
  const stacked = scale2 && scale2.options.stacked;
  return stacked || stacked === void 0 && meta.stack !== void 0;
}
function getStackKey(indexScale, valueScale, meta) {
  return `${indexScale.id}.${valueScale.id}.${meta.stack || meta.type}`;
}
function getUserBounds(scale2) {
  const { min: min2, max: max2, minDefined, maxDefined } = scale2.getUserBounds();
  return {
    min: minDefined ? min2 : Number.NEGATIVE_INFINITY,
    max: maxDefined ? max2 : Number.POSITIVE_INFINITY
  };
}
function getOrCreateStack(stacks, stackKey, indexValue) {
  const subStack = stacks[stackKey] || (stacks[stackKey] = {});
  return subStack[indexValue] || (subStack[indexValue] = {});
}
function getLastIndexInStack(stack, vScale, positive2, type2) {
  for (const meta of vScale.getMatchingVisibleMetas(type2).reverse()) {
    const value = stack[meta.index];
    if (positive2 && value > 0 || !positive2 && value < 0) {
      return meta.index;
    }
  }
  return null;
}
function updateStacks(controller, parsed) {
  const { chart, _cachedMeta: meta } = controller;
  const stacks = chart._stacks || (chart._stacks = {});
  const { iScale, vScale, index: datasetIndex } = meta;
  const iAxis = iScale.axis;
  const vAxis = vScale.axis;
  const key = getStackKey(iScale, vScale, meta);
  const ilen = parsed.length;
  let stack;
  for (let i = 0; i < ilen; ++i) {
    const item = parsed[i];
    const { [iAxis]: index2, [vAxis]: value } = item;
    const itemStacks = item._stacks || (item._stacks = {});
    stack = itemStacks[vAxis] = getOrCreateStack(stacks, key, index2);
    stack[datasetIndex] = value;
    stack._top = getLastIndexInStack(stack, vScale, true, meta.type);
    stack._bottom = getLastIndexInStack(stack, vScale, false, meta.type);
    const visualValues = stack._visualValues || (stack._visualValues = {});
    visualValues[datasetIndex] = value;
  }
}
function getFirstScaleId(chart, axis) {
  const scales2 = chart.scales;
  return Object.keys(scales2).filter((key) => scales2[key].axis === axis).shift();
}
function createDatasetContext(parent, index2) {
  return createContext(parent, {
    active: false,
    dataset: void 0,
    datasetIndex: index2,
    index: index2,
    mode: "default",
    type: "dataset"
  });
}
function createDataContext(parent, index2, element) {
  return createContext(parent, {
    active: false,
    dataIndex: index2,
    parsed: void 0,
    raw: void 0,
    element,
    index: index2,
    mode: "default",
    type: "data"
  });
}
function clearStacks(meta, items) {
  const datasetIndex = meta.controller.index;
  const axis = meta.vScale && meta.vScale.axis;
  if (!axis) {
    return;
  }
  items = items || meta._parsed;
  for (const parsed of items) {
    const stacks = parsed._stacks;
    if (!stacks || stacks[axis] === void 0 || stacks[axis][datasetIndex] === void 0) {
      return;
    }
    delete stacks[axis][datasetIndex];
    if (stacks[axis]._visualValues !== void 0 && stacks[axis]._visualValues[datasetIndex] !== void 0) {
      delete stacks[axis]._visualValues[datasetIndex];
    }
  }
}
const isDirectUpdateMode = (mode) => mode === "reset" || mode === "none";
const cloneIfNotShared = (cached, shared) => shared ? cached : Object.assign({}, cached);
const createStack = (canStack, meta, chart) => canStack && !meta.hidden && meta._stacked && {
  keys: getSortedDatasetIndices(chart, true),
  values: null
};
class DatasetController {
  constructor(chart, datasetIndex) {
    this.chart = chart;
    this._ctx = chart.ctx;
    this.index = datasetIndex;
    this._cachedDataOpts = {};
    this._cachedMeta = this.getMeta();
    this._type = this._cachedMeta.type;
    this.options = void 0;
    this._parsing = false;
    this._data = void 0;
    this._objectData = void 0;
    this._sharedOptions = void 0;
    this._drawStart = void 0;
    this._drawCount = void 0;
    this.enableOptionSharing = false;
    this.supportsDecimation = false;
    this.$context = void 0;
    this._syncList = [];
    this.datasetElementType = new.target.datasetElementType;
    this.dataElementType = new.target.dataElementType;
    this.initialize();
  }
  initialize() {
    const meta = this._cachedMeta;
    this.configure();
    this.linkScales();
    meta._stacked = isStacked(meta.vScale, meta);
    this.addElements();
    if (this.options.fill && !this.chart.isPluginEnabled("filler")) {
      console.warn("Tried to use the 'fill' option without the 'Filler' plugin enabled. Please import and register the 'Filler' plugin and make sure it is not disabled in the options");
    }
  }
  updateIndex(datasetIndex) {
    if (this.index !== datasetIndex) {
      clearStacks(this._cachedMeta);
    }
    this.index = datasetIndex;
  }
  linkScales() {
    const chart = this.chart;
    const meta = this._cachedMeta;
    const dataset = this.getDataset();
    const chooseId = (axis, x2, y2, r2) => axis === "x" ? x2 : axis === "r" ? r2 : y2;
    const xid = meta.xAxisID = valueOrDefault(dataset.xAxisID, getFirstScaleId(chart, "x"));
    const yid = meta.yAxisID = valueOrDefault(dataset.yAxisID, getFirstScaleId(chart, "y"));
    const rid = meta.rAxisID = valueOrDefault(dataset.rAxisID, getFirstScaleId(chart, "r"));
    const indexAxis = meta.indexAxis;
    const iid = meta.iAxisID = chooseId(indexAxis, xid, yid, rid);
    const vid = meta.vAxisID = chooseId(indexAxis, yid, xid, rid);
    meta.xScale = this.getScaleForId(xid);
    meta.yScale = this.getScaleForId(yid);
    meta.rScale = this.getScaleForId(rid);
    meta.iScale = this.getScaleForId(iid);
    meta.vScale = this.getScaleForId(vid);
  }
  getDataset() {
    return this.chart.data.datasets[this.index];
  }
  getMeta() {
    return this.chart.getDatasetMeta(this.index);
  }
  getScaleForId(scaleID) {
    return this.chart.scales[scaleID];
  }
  _getOtherScale(scale2) {
    const meta = this._cachedMeta;
    return scale2 === meta.iScale ? meta.vScale : meta.iScale;
  }
  reset() {
    this._update("reset");
  }
  _destroy() {
    const meta = this._cachedMeta;
    if (this._data) {
      unlistenArrayEvents(this._data, this);
    }
    if (meta._stacked) {
      clearStacks(meta);
    }
  }
  _dataCheck() {
    const dataset = this.getDataset();
    const data2 = dataset.data || (dataset.data = []);
    const _data = this._data;
    if (isObject(data2)) {
      const meta = this._cachedMeta;
      this._data = convertObjectDataToArray(data2, meta);
    } else if (_data !== data2) {
      if (_data) {
        unlistenArrayEvents(_data, this);
        const meta = this._cachedMeta;
        clearStacks(meta);
        meta._parsed = [];
      }
      if (data2 && Object.isExtensible(data2)) {
        listenArrayEvents(data2, this);
      }
      this._syncList = [];
      this._data = data2;
    }
  }
  addElements() {
    const meta = this._cachedMeta;
    this._dataCheck();
    if (this.datasetElementType) {
      meta.dataset = new this.datasetElementType();
    }
  }
  buildOrUpdateElements(resetNewElements) {
    const meta = this._cachedMeta;
    const dataset = this.getDataset();
    let stackChanged = false;
    this._dataCheck();
    const oldStacked = meta._stacked;
    meta._stacked = isStacked(meta.vScale, meta);
    if (meta.stack !== dataset.stack) {
      stackChanged = true;
      clearStacks(meta);
      meta.stack = dataset.stack;
    }
    this._resyncElements(resetNewElements);
    if (stackChanged || oldStacked !== meta._stacked) {
      updateStacks(this, meta._parsed);
    }
  }
  configure() {
    const config2 = this.chart.config;
    const scopeKeys = config2.datasetScopeKeys(this._type);
    const scopes = config2.getOptionScopes(this.getDataset(), scopeKeys, true);
    this.options = config2.createResolver(scopes, this.getContext());
    this._parsing = this.options.parsing;
    this._cachedDataOpts = {};
  }
  parse(start, count) {
    const { _cachedMeta: meta, _data: data2 } = this;
    const { iScale, _stacked } = meta;
    const iAxis = iScale.axis;
    let sorted = start === 0 && count === data2.length ? true : meta._sorted;
    let prev2 = start > 0 && meta._parsed[start - 1];
    let i, cur, parsed;
    if (this._parsing === false) {
      meta._parsed = data2;
      meta._sorted = true;
      parsed = data2;
    } else {
      if (isArray$1(data2[start])) {
        parsed = this.parseArrayData(meta, data2, start, count);
      } else if (isObject(data2[start])) {
        parsed = this.parseObjectData(meta, data2, start, count);
      } else {
        parsed = this.parsePrimitiveData(meta, data2, start, count);
      }
      const isNotInOrderComparedToPrev = () => cur[iAxis] === null || prev2 && cur[iAxis] < prev2[iAxis];
      for (i = 0; i < count; ++i) {
        meta._parsed[i + start] = cur = parsed[i];
        if (sorted) {
          if (isNotInOrderComparedToPrev()) {
            sorted = false;
          }
          prev2 = cur;
        }
      }
      meta._sorted = sorted;
    }
    if (_stacked) {
      updateStacks(this, parsed);
    }
  }
  parsePrimitiveData(meta, data2, start, count) {
    const { iScale, vScale } = meta;
    const iAxis = iScale.axis;
    const vAxis = vScale.axis;
    const labels = iScale.getLabels();
    const singleScale = iScale === vScale;
    const parsed = new Array(count);
    let i, ilen, index2;
    for (i = 0, ilen = count; i < ilen; ++i) {
      index2 = i + start;
      parsed[i] = {
        [iAxis]: singleScale || iScale.parse(labels[index2], index2),
        [vAxis]: vScale.parse(data2[index2], index2)
      };
    }
    return parsed;
  }
  parseArrayData(meta, data2, start, count) {
    const { xScale, yScale } = meta;
    const parsed = new Array(count);
    let i, ilen, index2, item;
    for (i = 0, ilen = count; i < ilen; ++i) {
      index2 = i + start;
      item = data2[index2];
      parsed[i] = {
        x: xScale.parse(item[0], index2),
        y: yScale.parse(item[1], index2)
      };
    }
    return parsed;
  }
  parseObjectData(meta, data2, start, count) {
    const { xScale, yScale } = meta;
    const { xAxisKey = "x", yAxisKey = "y" } = this._parsing;
    const parsed = new Array(count);
    let i, ilen, index2, item;
    for (i = 0, ilen = count; i < ilen; ++i) {
      index2 = i + start;
      item = data2[index2];
      parsed[i] = {
        x: xScale.parse(resolveObjectKey(item, xAxisKey), index2),
        y: yScale.parse(resolveObjectKey(item, yAxisKey), index2)
      };
    }
    return parsed;
  }
  getParsed(index2) {
    return this._cachedMeta._parsed[index2];
  }
  getDataElement(index2) {
    return this._cachedMeta.data[index2];
  }
  applyStack(scale2, parsed, mode) {
    const chart = this.chart;
    const meta = this._cachedMeta;
    const value = parsed[scale2.axis];
    const stack = {
      keys: getSortedDatasetIndices(chart, true),
      values: parsed._stacks[scale2.axis]._visualValues
    };
    return applyStack(stack, value, meta.index, {
      mode
    });
  }
  updateRangeFromParsed(range2, scale2, parsed, stack) {
    const parsedValue = parsed[scale2.axis];
    let value = parsedValue === null ? NaN : parsedValue;
    const values2 = stack && parsed._stacks[scale2.axis];
    if (stack && values2) {
      stack.values = values2;
      value = applyStack(stack, parsedValue, this._cachedMeta.index);
    }
    range2.min = Math.min(range2.min, value);
    range2.max = Math.max(range2.max, value);
  }
  getMinMax(scale2, canStack) {
    const meta = this._cachedMeta;
    const _parsed = meta._parsed;
    const sorted = meta._sorted && scale2 === meta.iScale;
    const ilen = _parsed.length;
    const otherScale = this._getOtherScale(scale2);
    const stack = createStack(canStack, meta, this.chart);
    const range2 = {
      min: Number.POSITIVE_INFINITY,
      max: Number.NEGATIVE_INFINITY
    };
    const { min: otherMin, max: otherMax } = getUserBounds(otherScale);
    let i, parsed;
    function _skip() {
      parsed = _parsed[i];
      const otherValue = parsed[otherScale.axis];
      return !isNumberFinite(parsed[scale2.axis]) || otherMin > otherValue || otherMax < otherValue;
    }
    for (i = 0; i < ilen; ++i) {
      if (_skip()) {
        continue;
      }
      this.updateRangeFromParsed(range2, scale2, parsed, stack);
      if (sorted) {
        break;
      }
    }
    if (sorted) {
      for (i = ilen - 1; i >= 0; --i) {
        if (_skip()) {
          continue;
        }
        this.updateRangeFromParsed(range2, scale2, parsed, stack);
        break;
      }
    }
    return range2;
  }
  getAllParsedValues(scale2) {
    const parsed = this._cachedMeta._parsed;
    const values2 = [];
    let i, ilen, value;
    for (i = 0, ilen = parsed.length; i < ilen; ++i) {
      value = parsed[i][scale2.axis];
      if (isNumberFinite(value)) {
        values2.push(value);
      }
    }
    return values2;
  }
  getMaxOverflow() {
    return false;
  }
  getLabelAndValue(index2) {
    const meta = this._cachedMeta;
    const iScale = meta.iScale;
    const vScale = meta.vScale;
    const parsed = this.getParsed(index2);
    return {
      label: iScale ? "" + iScale.getLabelForValue(parsed[iScale.axis]) : "",
      value: vScale ? "" + vScale.getLabelForValue(parsed[vScale.axis]) : ""
    };
  }
  _update(mode) {
    const meta = this._cachedMeta;
    this.update(mode || "default");
    meta._clip = toClip(valueOrDefault(this.options.clip, defaultClip(meta.xScale, meta.yScale, this.getMaxOverflow())));
  }
  update(mode) {
  }
  draw() {
    const ctx = this._ctx;
    const chart = this.chart;
    const meta = this._cachedMeta;
    const elements2 = meta.data || [];
    const area = chart.chartArea;
    const active2 = [];
    const start = this._drawStart || 0;
    const count = this._drawCount || elements2.length - start;
    const drawActiveElementsOnTop = this.options.drawActiveElementsOnTop;
    let i;
    if (meta.dataset) {
      meta.dataset.draw(ctx, area, start, count);
    }
    for (i = start; i < start + count; ++i) {
      const element = elements2[i];
      if (element.hidden) {
        continue;
      }
      if (element.active && drawActiveElementsOnTop) {
        active2.push(element);
      } else {
        element.draw(ctx, area);
      }
    }
    for (i = 0; i < active2.length; ++i) {
      active2[i].draw(ctx, area);
    }
  }
  getStyle(index2, active2) {
    const mode = active2 ? "active" : "default";
    return index2 === void 0 && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(mode) : this.resolveDataElementOptions(index2 || 0, mode);
  }
  getContext(index2, active2, mode) {
    const dataset = this.getDataset();
    let context;
    if (index2 >= 0 && index2 < this._cachedMeta.data.length) {
      const element = this._cachedMeta.data[index2];
      context = element.$context || (element.$context = createDataContext(this.getContext(), index2, element));
      context.parsed = this.getParsed(index2);
      context.raw = dataset.data[index2];
      context.index = context.dataIndex = index2;
    } else {
      context = this.$context || (this.$context = createDatasetContext(this.chart.getContext(), this.index));
      context.dataset = dataset;
      context.index = context.datasetIndex = this.index;
    }
    context.active = !!active2;
    context.mode = mode;
    return context;
  }
  resolveDatasetElementOptions(mode) {
    return this._resolveElementOptions(this.datasetElementType.id, mode);
  }
  resolveDataElementOptions(index2, mode) {
    return this._resolveElementOptions(this.dataElementType.id, mode, index2);
  }
  _resolveElementOptions(elementType, mode = "default", index2) {
    const active2 = mode === "active";
    const cache = this._cachedDataOpts;
    const cacheKey = elementType + "-" + mode;
    const cached = cache[cacheKey];
    const sharing = this.enableOptionSharing && defined(index2);
    if (cached) {
      return cloneIfNotShared(cached, sharing);
    }
    const config2 = this.chart.config;
    const scopeKeys = config2.datasetElementScopeKeys(this._type, elementType);
    const prefixes = active2 ? [
      `${elementType}Hover`,
      "hover",
      elementType,
      ""
    ] : [
      elementType,
      ""
    ];
    const scopes = config2.getOptionScopes(this.getDataset(), scopeKeys);
    const names2 = Object.keys(defaults$3.elements[elementType]);
    const context = () => this.getContext(index2, active2, mode);
    const values2 = config2.resolveNamedOptions(scopes, names2, context, prefixes);
    if (values2.$shared) {
      values2.$shared = sharing;
      cache[cacheKey] = Object.freeze(cloneIfNotShared(values2, sharing));
    }
    return values2;
  }
  _resolveAnimations(index2, transition, active2) {
    const chart = this.chart;
    const cache = this._cachedDataOpts;
    const cacheKey = `animation-${transition}`;
    const cached = cache[cacheKey];
    if (cached) {
      return cached;
    }
    let options2;
    if (chart.options.animation !== false) {
      const config2 = this.chart.config;
      const scopeKeys = config2.datasetAnimationScopeKeys(this._type, transition);
      const scopes = config2.getOptionScopes(this.getDataset(), scopeKeys);
      options2 = config2.createResolver(scopes, this.getContext(index2, active2, transition));
    }
    const animations = new Animations(chart, options2 && options2.animations);
    if (options2 && options2._cacheable) {
      cache[cacheKey] = Object.freeze(animations);
    }
    return animations;
  }
  getSharedOptions(options2) {
    if (!options2.$shared) {
      return;
    }
    return this._sharedOptions || (this._sharedOptions = Object.assign({}, options2));
  }
  includeOptions(mode, sharedOptions) {
    return !sharedOptions || isDirectUpdateMode(mode) || this.chart._animationsDisabled;
  }
  _getSharedOptions(start, mode) {
    const firstOpts = this.resolveDataElementOptions(start, mode);
    const previouslySharedOptions = this._sharedOptions;
    const sharedOptions = this.getSharedOptions(firstOpts);
    const includeOptions = this.includeOptions(mode, sharedOptions) || sharedOptions !== previouslySharedOptions;
    this.updateSharedOptions(sharedOptions, mode, firstOpts);
    return {
      sharedOptions,
      includeOptions
    };
  }
  updateElement(element, index2, properties, mode) {
    if (isDirectUpdateMode(mode)) {
      Object.assign(element, properties);
    } else {
      this._resolveAnimations(index2, mode).update(element, properties);
    }
  }
  updateSharedOptions(sharedOptions, mode, newOptions) {
    if (sharedOptions && !isDirectUpdateMode(mode)) {
      this._resolveAnimations(void 0, mode).update(sharedOptions, newOptions);
    }
  }
  _setStyle(element, index2, mode, active2) {
    element.active = active2;
    const options2 = this.getStyle(index2, active2);
    this._resolveAnimations(index2, mode, active2).update(element, {
      options: !active2 && this.getSharedOptions(options2) || options2
    });
  }
  removeHoverStyle(element, datasetIndex, index2) {
    this._setStyle(element, index2, "active", false);
  }
  setHoverStyle(element, datasetIndex, index2) {
    this._setStyle(element, index2, "active", true);
  }
  _removeDatasetHoverStyle() {
    const element = this._cachedMeta.dataset;
    if (element) {
      this._setStyle(element, void 0, "active", false);
    }
  }
  _setDatasetHoverStyle() {
    const element = this._cachedMeta.dataset;
    if (element) {
      this._setStyle(element, void 0, "active", true);
    }
  }
  _resyncElements(resetNewElements) {
    const data2 = this._data;
    const elements2 = this._cachedMeta.data;
    for (const [method, arg1, arg2] of this._syncList) {
      this[method](arg1, arg2);
    }
    this._syncList = [];
    const numMeta = elements2.length;
    const numData = data2.length;
    const count = Math.min(numData, numMeta);
    if (count) {
      this.parse(0, count);
    }
    if (numData > numMeta) {
      this._insertElements(numMeta, numData - numMeta, resetNewElements);
    } else if (numData < numMeta) {
      this._removeElements(numData, numMeta - numData);
    }
  }
  _insertElements(start, count, resetNewElements = true) {
    const meta = this._cachedMeta;
    const data2 = meta.data;
    const end = start + count;
    let i;
    const move = (arr) => {
      arr.length += count;
      for (i = arr.length - 1; i >= end; i--) {
        arr[i] = arr[i - count];
      }
    };
    move(data2);
    for (i = start; i < end; ++i) {
      data2[i] = new this.dataElementType();
    }
    if (this._parsing) {
      move(meta._parsed);
    }
    this.parse(start, count);
    if (resetNewElements) {
      this.updateElements(data2, start, count, "reset");
    }
  }
  updateElements(element, start, count, mode) {
  }
  _removeElements(start, count) {
    const meta = this._cachedMeta;
    if (this._parsing) {
      const removed = meta._parsed.splice(start, count);
      if (meta._stacked) {
        clearStacks(meta, removed);
      }
    }
    meta.data.splice(start, count);
  }
  _sync(args) {
    if (this._parsing) {
      this._syncList.push(args);
    } else {
      const [method, arg1, arg2] = args;
      this[method](arg1, arg2);
    }
    this.chart._dataChanges.push([
      this.index,
      ...args
    ]);
  }
  _onDataPush() {
    const count = arguments.length;
    this._sync([
      "_insertElements",
      this.getDataset().data.length - count,
      count
    ]);
  }
  _onDataPop() {
    this._sync([
      "_removeElements",
      this._cachedMeta.data.length - 1,
      1
    ]);
  }
  _onDataShift() {
    this._sync([
      "_removeElements",
      0,
      1
    ]);
  }
  _onDataSplice(start, count) {
    if (count) {
      this._sync([
        "_removeElements",
        start,
        count
      ]);
    }
    const newCount = arguments.length - 2;
    if (newCount) {
      this._sync([
        "_insertElements",
        start,
        newCount
      ]);
    }
  }
  _onDataUnshift() {
    this._sync([
      "_insertElements",
      0,
      arguments.length
    ]);
  }
}
__publicField(DatasetController, "defaults", {});
__publicField(DatasetController, "datasetElementType", null);
__publicField(DatasetController, "dataElementType", null);
function getAllScaleValues(scale2, type2) {
  if (!scale2._cache.$bar) {
    const visibleMetas = scale2.getMatchingVisibleMetas(type2);
    let values2 = [];
    for (let i = 0, ilen = visibleMetas.length; i < ilen; i++) {
      values2 = values2.concat(visibleMetas[i].controller.getAllParsedValues(scale2));
    }
    scale2._cache.$bar = _arrayUnique(values2.sort((a2, b2) => a2 - b2));
  }
  return scale2._cache.$bar;
}
function computeMinSampleSize(meta) {
  const scale2 = meta.iScale;
  const values2 = getAllScaleValues(scale2, meta.type);
  let min2 = scale2._length;
  let i, ilen, curr, prev2;
  const updateMinAndPrev = () => {
    if (curr === 32767 || curr === -32768) {
      return;
    }
    if (defined(prev2)) {
      min2 = Math.min(min2, Math.abs(curr - prev2) || min2);
    }
    prev2 = curr;
  };
  for (i = 0, ilen = values2.length; i < ilen; ++i) {
    curr = scale2.getPixelForValue(values2[i]);
    updateMinAndPrev();
  }
  prev2 = void 0;
  for (i = 0, ilen = scale2.ticks.length; i < ilen; ++i) {
    curr = scale2.getPixelForTick(i);
    updateMinAndPrev();
  }
  return min2;
}
function computeFitCategoryTraits(index2, ruler, options2, stackCount) {
  const thickness = options2.barThickness;
  let size2, ratio;
  if (isNullOrUndef(thickness)) {
    size2 = ruler.min * options2.categoryPercentage;
    ratio = options2.barPercentage;
  } else {
    size2 = thickness * stackCount;
    ratio = 1;
  }
  return {
    chunk: size2 / stackCount,
    ratio,
    start: ruler.pixels[index2] - size2 / 2
  };
}
function computeFlexCategoryTraits(index2, ruler, options2, stackCount) {
  const pixels = ruler.pixels;
  const curr = pixels[index2];
  let prev2 = index2 > 0 ? pixels[index2 - 1] : null;
  let next2 = index2 < pixels.length - 1 ? pixels[index2 + 1] : null;
  const percent = options2.categoryPercentage;
  if (prev2 === null) {
    prev2 = curr - (next2 === null ? ruler.end - ruler.start : next2 - curr);
  }
  if (next2 === null) {
    next2 = curr + curr - prev2;
  }
  const start = curr - (curr - Math.min(prev2, next2)) / 2 * percent;
  const size2 = Math.abs(next2 - prev2) / 2 * percent;
  return {
    chunk: size2 / stackCount,
    ratio: options2.barPercentage,
    start
  };
}
function parseFloatBar(entry, item, vScale, i) {
  const startValue = vScale.parse(entry[0], i);
  const endValue = vScale.parse(entry[1], i);
  const min2 = Math.min(startValue, endValue);
  const max2 = Math.max(startValue, endValue);
  let barStart = min2;
  let barEnd = max2;
  if (Math.abs(min2) > Math.abs(max2)) {
    barStart = max2;
    barEnd = min2;
  }
  item[vScale.axis] = barEnd;
  item._custom = {
    barStart,
    barEnd,
    start: startValue,
    end: endValue,
    min: min2,
    max: max2
  };
}
function parseValue(entry, item, vScale, i) {
  if (isArray$1(entry)) {
    parseFloatBar(entry, item, vScale, i);
  } else {
    item[vScale.axis] = vScale.parse(entry, i);
  }
  return item;
}
function parseArrayOrPrimitive(meta, data2, start, count) {
  const iScale = meta.iScale;
  const vScale = meta.vScale;
  const labels = iScale.getLabels();
  const singleScale = iScale === vScale;
  const parsed = [];
  let i, ilen, item, entry;
  for (i = start, ilen = start + count; i < ilen; ++i) {
    entry = data2[i];
    item = {};
    item[iScale.axis] = singleScale || iScale.parse(labels[i], i);
    parsed.push(parseValue(entry, item, vScale, i));
  }
  return parsed;
}
function isFloatBar(custom) {
  return custom && custom.barStart !== void 0 && custom.barEnd !== void 0;
}
function barSign(size2, vScale, actualBase) {
  if (size2 !== 0) {
    return sign(size2);
  }
  return (vScale.isHorizontal() ? 1 : -1) * (vScale.min >= actualBase ? 1 : -1);
}
function borderProps(properties) {
  let reverse, start, end, top, bottom;
  if (properties.horizontal) {
    reverse = properties.base > properties.x;
    start = "left";
    end = "right";
  } else {
    reverse = properties.base < properties.y;
    start = "bottom";
    end = "top";
  }
  if (reverse) {
    top = "end";
    bottom = "start";
  } else {
    top = "start";
    bottom = "end";
  }
  return {
    start,
    end,
    reverse,
    top,
    bottom
  };
}
function setBorderSkipped(properties, options2, stack, index2) {
  let edge = options2.borderSkipped;
  const res = {};
  if (!edge) {
    properties.borderSkipped = res;
    return;
  }
  if (edge === true) {
    properties.borderSkipped = {
      top: true,
      right: true,
      bottom: true,
      left: true
    };
    return;
  }
  const { start, end, reverse, top, bottom } = borderProps(properties);
  if (edge === "middle" && stack) {
    properties.enableBorderRadius = true;
    if ((stack._top || 0) === index2) {
      edge = top;
    } else if ((stack._bottom || 0) === index2) {
      edge = bottom;
    } else {
      res[parseEdge(bottom, start, end, reverse)] = true;
      edge = top;
    }
  }
  res[parseEdge(edge, start, end, reverse)] = true;
  properties.borderSkipped = res;
}
function parseEdge(edge, a2, b2, reverse) {
  if (reverse) {
    edge = swap(edge, a2, b2);
    edge = startEnd(edge, b2, a2);
  } else {
    edge = startEnd(edge, a2, b2);
  }
  return edge;
}
function swap(orig, v1, v2) {
  return orig === v1 ? v2 : orig === v2 ? v1 : orig;
}
function startEnd(v2, start, end) {
  return v2 === "start" ? start : v2 === "end" ? end : v2;
}
function setInflateAmount(properties, { inflateAmount }, ratio) {
  properties.inflateAmount = inflateAmount === "auto" ? ratio === 1 ? 0.33 : 0 : inflateAmount;
}
class BarController extends DatasetController {
  parsePrimitiveData(meta, data2, start, count) {
    return parseArrayOrPrimitive(meta, data2, start, count);
  }
  parseArrayData(meta, data2, start, count) {
    return parseArrayOrPrimitive(meta, data2, start, count);
  }
  parseObjectData(meta, data2, start, count) {
    const { iScale, vScale } = meta;
    const { xAxisKey = "x", yAxisKey = "y" } = this._parsing;
    const iAxisKey = iScale.axis === "x" ? xAxisKey : yAxisKey;
    const vAxisKey = vScale.axis === "x" ? xAxisKey : yAxisKey;
    const parsed = [];
    let i, ilen, item, obj;
    for (i = start, ilen = start + count; i < ilen; ++i) {
      obj = data2[i];
      item = {};
      item[iScale.axis] = iScale.parse(resolveObjectKey(obj, iAxisKey), i);
      parsed.push(parseValue(resolveObjectKey(obj, vAxisKey), item, vScale, i));
    }
    return parsed;
  }
  updateRangeFromParsed(range2, scale2, parsed, stack) {
    super.updateRangeFromParsed(range2, scale2, parsed, stack);
    const custom = parsed._custom;
    if (custom && scale2 === this._cachedMeta.vScale) {
      range2.min = Math.min(range2.min, custom.min);
      range2.max = Math.max(range2.max, custom.max);
    }
  }
  getMaxOverflow() {
    return 0;
  }
  getLabelAndValue(index2) {
    const meta = this._cachedMeta;
    const { iScale, vScale } = meta;
    const parsed = this.getParsed(index2);
    const custom = parsed._custom;
    const value = isFloatBar(custom) ? "[" + custom.start + ", " + custom.end + "]" : "" + vScale.getLabelForValue(parsed[vScale.axis]);
    return {
      label: "" + iScale.getLabelForValue(parsed[iScale.axis]),
      value
    };
  }
  initialize() {
    this.enableOptionSharing = true;
    super.initialize();
    const meta = this._cachedMeta;
    meta.stack = this.getDataset().stack;
  }
  update(mode) {
    const meta = this._cachedMeta;
    this.updateElements(meta.data, 0, meta.data.length, mode);
  }
  updateElements(bars, start, count, mode) {
    const reset = mode === "reset";
    const { index: index2, _cachedMeta: { vScale } } = this;
    const base = vScale.getBasePixel();
    const horizontal = vScale.isHorizontal();
    const ruler = this._getRuler();
    const { sharedOptions, includeOptions } = this._getSharedOptions(start, mode);
    for (let i = start; i < start + count; i++) {
      const parsed = this.getParsed(i);
      const vpixels = reset || isNullOrUndef(parsed[vScale.axis]) ? {
        base,
        head: base
      } : this._calculateBarValuePixels(i);
      const ipixels = this._calculateBarIndexPixels(i, ruler);
      const stack = (parsed._stacks || {})[vScale.axis];
      const properties = {
        horizontal,
        base: vpixels.base,
        enableBorderRadius: !stack || isFloatBar(parsed._custom) || index2 === stack._top || index2 === stack._bottom,
        x: horizontal ? vpixels.head : ipixels.center,
        y: horizontal ? ipixels.center : vpixels.head,
        height: horizontal ? ipixels.size : Math.abs(vpixels.size),
        width: horizontal ? Math.abs(vpixels.size) : ipixels.size
      };
      if (includeOptions) {
        properties.options = sharedOptions || this.resolveDataElementOptions(i, bars[i].active ? "active" : mode);
      }
      const options2 = properties.options || bars[i].options;
      setBorderSkipped(properties, options2, stack, index2);
      setInflateAmount(properties, options2, ruler.ratio);
      this.updateElement(bars[i], i, properties, mode);
    }
  }
  _getStacks(last2, dataIndex) {
    const { iScale } = this._cachedMeta;
    const metasets = iScale.getMatchingVisibleMetas(this._type).filter((meta) => meta.controller.options.grouped);
    const stacked = iScale.options.stacked;
    const stacks = [];
    const skipNull = (meta) => {
      const parsed = meta.controller.getParsed(dataIndex);
      const val = parsed && parsed[meta.vScale.axis];
      if (isNullOrUndef(val) || isNaN(val)) {
        return true;
      }
    };
    for (const meta of metasets) {
      if (dataIndex !== void 0 && skipNull(meta)) {
        continue;
      }
      if (stacked === false || stacks.indexOf(meta.stack) === -1 || stacked === void 0 && meta.stack === void 0) {
        stacks.push(meta.stack);
      }
      if (meta.index === last2) {
        break;
      }
    }
    if (!stacks.length) {
      stacks.push(void 0);
    }
    return stacks;
  }
  _getStackCount(index2) {
    return this._getStacks(void 0, index2).length;
  }
  _getStackIndex(datasetIndex, name, dataIndex) {
    const stacks = this._getStacks(datasetIndex, dataIndex);
    const index2 = name !== void 0 ? stacks.indexOf(name) : -1;
    return index2 === -1 ? stacks.length - 1 : index2;
  }
  _getRuler() {
    const opts = this.options;
    const meta = this._cachedMeta;
    const iScale = meta.iScale;
    const pixels = [];
    let i, ilen;
    for (i = 0, ilen = meta.data.length; i < ilen; ++i) {
      pixels.push(iScale.getPixelForValue(this.getParsed(i)[iScale.axis], i));
    }
    const barThickness = opts.barThickness;
    const min2 = barThickness || computeMinSampleSize(meta);
    return {
      min: min2,
      pixels,
      start: iScale._startPixel,
      end: iScale._endPixel,
      stackCount: this._getStackCount(),
      scale: iScale,
      grouped: opts.grouped,
      ratio: barThickness ? 1 : opts.categoryPercentage * opts.barPercentage
    };
  }
  _calculateBarValuePixels(index2) {
    const { _cachedMeta: { vScale, _stacked, index: datasetIndex }, options: { base: baseValue, minBarLength } } = this;
    const actualBase = baseValue || 0;
    const parsed = this.getParsed(index2);
    const custom = parsed._custom;
    const floating = isFloatBar(custom);
    let value = parsed[vScale.axis];
    let start = 0;
    let length2 = _stacked ? this.applyStack(vScale, parsed, _stacked) : value;
    let head, size2;
    if (length2 !== value) {
      start = length2 - value;
      length2 = value;
    }
    if (floating) {
      value = custom.barStart;
      length2 = custom.barEnd - custom.barStart;
      if (value !== 0 && sign(value) !== sign(custom.barEnd)) {
        start = 0;
      }
      start += value;
    }
    const startValue = !isNullOrUndef(baseValue) && !floating ? baseValue : start;
    let base = vScale.getPixelForValue(startValue);
    if (this.chart.getDataVisibility(index2)) {
      head = vScale.getPixelForValue(start + length2);
    } else {
      head = base;
    }
    size2 = head - base;
    if (Math.abs(size2) < minBarLength) {
      size2 = barSign(size2, vScale, actualBase) * minBarLength;
      if (value === actualBase) {
        base -= size2 / 2;
      }
      const startPixel = vScale.getPixelForDecimal(0);
      const endPixel = vScale.getPixelForDecimal(1);
      const min2 = Math.min(startPixel, endPixel);
      const max2 = Math.max(startPixel, endPixel);
      base = Math.max(Math.min(base, max2), min2);
      head = base + size2;
      if (_stacked && !floating) {
        parsed._stacks[vScale.axis]._visualValues[datasetIndex] = vScale.getValueForPixel(head) - vScale.getValueForPixel(base);
      }
    }
    if (base === vScale.getPixelForValue(actualBase)) {
      const halfGrid = sign(size2) * vScale.getLineWidthForValue(actualBase) / 2;
      base += halfGrid;
      size2 -= halfGrid;
    }
    return {
      size: size2,
      base,
      head,
      center: head + size2 / 2
    };
  }
  _calculateBarIndexPixels(index2, ruler) {
    const scale2 = ruler.scale;
    const options2 = this.options;
    const skipNull = options2.skipNull;
    const maxBarThickness = valueOrDefault(options2.maxBarThickness, Infinity);
    let center, size2;
    if (ruler.grouped) {
      const stackCount = skipNull ? this._getStackCount(index2) : ruler.stackCount;
      const range2 = options2.barThickness === "flex" ? computeFlexCategoryTraits(index2, ruler, options2, stackCount) : computeFitCategoryTraits(index2, ruler, options2, stackCount);
      const stackIndex = this._getStackIndex(this.index, this._cachedMeta.stack, skipNull ? index2 : void 0);
      center = range2.start + range2.chunk * stackIndex + range2.chunk / 2;
      size2 = Math.min(maxBarThickness, range2.chunk * range2.ratio);
    } else {
      center = scale2.getPixelForValue(this.getParsed(index2)[scale2.axis], index2);
      size2 = Math.min(maxBarThickness, ruler.min * ruler.ratio);
    }
    return {
      base: center - size2 / 2,
      head: center + size2 / 2,
      center,
      size: size2
    };
  }
  draw() {
    const meta = this._cachedMeta;
    const vScale = meta.vScale;
    const rects = meta.data;
    const ilen = rects.length;
    let i = 0;
    for (; i < ilen; ++i) {
      if (this.getParsed(i)[vScale.axis] !== null && !rects[i].hidden) {
        rects[i].draw(this._ctx);
      }
    }
  }
}
__publicField(BarController, "id", "bar");
__publicField(BarController, "defaults", {
  datasetElementType: false,
  dataElementType: "bar",
  categoryPercentage: 0.8,
  barPercentage: 0.9,
  grouped: true,
  animations: {
    numbers: {
      type: "number",
      properties: [
        "x",
        "y",
        "base",
        "width",
        "height"
      ]
    }
  }
});
__publicField(BarController, "overrides", {
  scales: {
    _index_: {
      type: "category",
      offset: true,
      grid: {
        offset: true
      }
    },
    _value_: {
      type: "linear",
      beginAtZero: true
    }
  }
});
class BubbleController extends DatasetController {
  initialize() {
    this.enableOptionSharing = true;
    super.initialize();
  }
  parsePrimitiveData(meta, data2, start, count) {
    const parsed = super.parsePrimitiveData(meta, data2, start, count);
    for (let i = 0; i < parsed.length; i++) {
      parsed[i]._custom = this.resolveDataElementOptions(i + start).radius;
    }
    return parsed;
  }
  parseArrayData(meta, data2, start, count) {
    const parsed = super.parseArrayData(meta, data2, start, count);
    for (let i = 0; i < parsed.length; i++) {
      const item = data2[start + i];
      parsed[i]._custom = valueOrDefault(item[2], this.resolveDataElementOptions(i + start).radius);
    }
    return parsed;
  }
  parseObjectData(meta, data2, start, count) {
    const parsed = super.parseObjectData(meta, data2, start, count);
    for (let i = 0; i < parsed.length; i++) {
      const item = data2[start + i];
      parsed[i]._custom = valueOrDefault(item && item.r && +item.r, this.resolveDataElementOptions(i + start).radius);
    }
    return parsed;
  }
  getMaxOverflow() {
    const data2 = this._cachedMeta.data;
    let max2 = 0;
    for (let i = data2.length - 1; i >= 0; --i) {
      max2 = Math.max(max2, data2[i].size(this.resolveDataElementOptions(i)) / 2);
    }
    return max2 > 0 && max2;
  }
  getLabelAndValue(index2) {
    const meta = this._cachedMeta;
    const labels = this.chart.data.labels || [];
    const { xScale, yScale } = meta;
    const parsed = this.getParsed(index2);
    const x2 = xScale.getLabelForValue(parsed.x);
    const y2 = yScale.getLabelForValue(parsed.y);
    const r2 = parsed._custom;
    return {
      label: labels[index2] || "",
      value: "(" + x2 + ", " + y2 + (r2 ? ", " + r2 : "") + ")"
    };
  }
  update(mode) {
    const points = this._cachedMeta.data;
    this.updateElements(points, 0, points.length, mode);
  }
  updateElements(points, start, count, mode) {
    const reset = mode === "reset";
    const { iScale, vScale } = this._cachedMeta;
    const { sharedOptions, includeOptions } = this._getSharedOptions(start, mode);
    const iAxis = iScale.axis;
    const vAxis = vScale.axis;
    for (let i = start; i < start + count; i++) {
      const point = points[i];
      const parsed = !reset && this.getParsed(i);
      const properties = {};
      const iPixel = properties[iAxis] = reset ? iScale.getPixelForDecimal(0.5) : iScale.getPixelForValue(parsed[iAxis]);
      const vPixel = properties[vAxis] = reset ? vScale.getBasePixel() : vScale.getPixelForValue(parsed[vAxis]);
      properties.skip = isNaN(iPixel) || isNaN(vPixel);
      if (includeOptions) {
        properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? "active" : mode);
        if (reset) {
          properties.options.radius = 0;
        }
      }
      this.updateElement(point, i, properties, mode);
    }
  }
  resolveDataElementOptions(index2, mode) {
    const parsed = this.getParsed(index2);
    let values2 = super.resolveDataElementOptions(index2, mode);
    if (values2.$shared) {
      values2 = Object.assign({}, values2, {
        $shared: false
      });
    }
    const radius = values2.radius;
    if (mode !== "active") {
      values2.radius = 0;
    }
    values2.radius += valueOrDefault(parsed && parsed._custom, radius);
    return values2;
  }
}
__publicField(BubbleController, "id", "bubble");
__publicField(BubbleController, "defaults", {
  datasetElementType: false,
  dataElementType: "point",
  animations: {
    numbers: {
      type: "number",
      properties: [
        "x",
        "y",
        "borderWidth",
        "radius"
      ]
    }
  }
});
__publicField(BubbleController, "overrides", {
  scales: {
    x: {
      type: "linear"
    },
    y: {
      type: "linear"
    }
  }
});
function getRatioAndOffset(rotation, circumference, cutout) {
  let ratioX = 1;
  let ratioY = 1;
  let offsetX = 0;
  let offsetY = 0;
  if (circumference < TAU) {
    const startAngle = rotation;
    const endAngle = startAngle + circumference;
    const startX = Math.cos(startAngle);
    const startY = Math.sin(startAngle);
    const endX = Math.cos(endAngle);
    const endY = Math.sin(endAngle);
    const calcMax = (angle, a2, b2) => _angleBetween(angle, startAngle, endAngle, true) ? 1 : Math.max(a2, a2 * cutout, b2, b2 * cutout);
    const calcMin = (angle, a2, b2) => _angleBetween(angle, startAngle, endAngle, true) ? -1 : Math.min(a2, a2 * cutout, b2, b2 * cutout);
    const maxX = calcMax(0, startX, endX);
    const maxY = calcMax(HALF_PI, startY, endY);
    const minX = calcMin(PI, startX, endX);
    const minY = calcMin(PI + HALF_PI, startY, endY);
    ratioX = (maxX - minX) / 2;
    ratioY = (maxY - minY) / 2;
    offsetX = -(maxX + minX) / 2;
    offsetY = -(maxY + minY) / 2;
  }
  return {
    ratioX,
    ratioY,
    offsetX,
    offsetY
  };
}
class DoughnutController extends DatasetController {
  constructor(chart, datasetIndex) {
    super(chart, datasetIndex);
    this.enableOptionSharing = true;
    this.innerRadius = void 0;
    this.outerRadius = void 0;
    this.offsetX = void 0;
    this.offsetY = void 0;
  }
  linkScales() {
  }
  parse(start, count) {
    const data2 = this.getDataset().data;
    const meta = this._cachedMeta;
    if (this._parsing === false) {
      meta._parsed = data2;
    } else {
      let getter = (i2) => +data2[i2];
      if (isObject(data2[start])) {
        const { key = "value" } = this._parsing;
        getter = (i2) => +resolveObjectKey(data2[i2], key);
      }
      let i, ilen;
      for (i = start, ilen = start + count; i < ilen; ++i) {
        meta._parsed[i] = getter(i);
      }
    }
  }
  _getRotation() {
    return toRadians(this.options.rotation - 90);
  }
  _getCircumference() {
    return toRadians(this.options.circumference);
  }
  _getRotationExtents() {
    let min2 = TAU;
    let max2 = -TAU;
    for (let i = 0; i < this.chart.data.datasets.length; ++i) {
      if (this.chart.isDatasetVisible(i) && this.chart.getDatasetMeta(i).type === this._type) {
        const controller = this.chart.getDatasetMeta(i).controller;
        const rotation = controller._getRotation();
        const circumference = controller._getCircumference();
        min2 = Math.min(min2, rotation);
        max2 = Math.max(max2, rotation + circumference);
      }
    }
    return {
      rotation: min2,
      circumference: max2 - min2
    };
  }
  update(mode) {
    const chart = this.chart;
    const { chartArea } = chart;
    const meta = this._cachedMeta;
    const arcs = meta.data;
    const spacing2 = this.getMaxBorderWidth() + this.getMaxOffset(arcs) + this.options.spacing;
    const maxSize = Math.max((Math.min(chartArea.width, chartArea.height) - spacing2) / 2, 0);
    const cutout = Math.min(toPercentage(this.options.cutout, maxSize), 1);
    const chartWeight = this._getRingWeight(this.index);
    const { circumference, rotation } = this._getRotationExtents();
    const { ratioX, ratioY, offsetX, offsetY } = getRatioAndOffset(rotation, circumference, cutout);
    const maxWidth = (chartArea.width - spacing2) / ratioX;
    const maxHeight = (chartArea.height - spacing2) / ratioY;
    const maxRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
    const outerRadius = toDimension(this.options.radius, maxRadius);
    const innerRadius = Math.max(outerRadius * cutout, 0);
    const radiusLength = (outerRadius - innerRadius) / this._getVisibleDatasetWeightTotal();
    this.offsetX = offsetX * outerRadius;
    this.offsetY = offsetY * outerRadius;
    meta.total = this.calculateTotal();
    this.outerRadius = outerRadius - radiusLength * this._getRingWeightOffset(this.index);
    this.innerRadius = Math.max(this.outerRadius - radiusLength * chartWeight, 0);
    this.updateElements(arcs, 0, arcs.length, mode);
  }
  _circumference(i, reset) {
    const opts = this.options;
    const meta = this._cachedMeta;
    const circumference = this._getCircumference();
    if (reset && opts.animation.animateRotate || !this.chart.getDataVisibility(i) || meta._parsed[i] === null || meta.data[i].hidden) {
      return 0;
    }
    return this.calculateCircumference(meta._parsed[i] * circumference / TAU);
  }
  updateElements(arcs, start, count, mode) {
    const reset = mode === "reset";
    const chart = this.chart;
    const chartArea = chart.chartArea;
    const opts = chart.options;
    const animationOpts = opts.animation;
    const centerX = (chartArea.left + chartArea.right) / 2;
    const centerY = (chartArea.top + chartArea.bottom) / 2;
    const animateScale = reset && animationOpts.animateScale;
    const innerRadius = animateScale ? 0 : this.innerRadius;
    const outerRadius = animateScale ? 0 : this.outerRadius;
    const { sharedOptions, includeOptions } = this._getSharedOptions(start, mode);
    let startAngle = this._getRotation();
    let i;
    for (i = 0; i < start; ++i) {
      startAngle += this._circumference(i, reset);
    }
    for (i = start; i < start + count; ++i) {
      const circumference = this._circumference(i, reset);
      const arc = arcs[i];
      const properties = {
        x: centerX + this.offsetX,
        y: centerY + this.offsetY,
        startAngle,
        endAngle: startAngle + circumference,
        circumference,
        outerRadius,
        innerRadius
      };
      if (includeOptions) {
        properties.options = sharedOptions || this.resolveDataElementOptions(i, arc.active ? "active" : mode);
      }
      startAngle += circumference;
      this.updateElement(arc, i, properties, mode);
    }
  }
  calculateTotal() {
    const meta = this._cachedMeta;
    const metaData = meta.data;
    let total = 0;
    let i;
    for (i = 0; i < metaData.length; i++) {
      const value = meta._parsed[i];
      if (value !== null && !isNaN(value) && this.chart.getDataVisibility(i) && !metaData[i].hidden) {
        total += Math.abs(value);
      }
    }
    return total;
  }
  calculateCircumference(value) {
    const total = this._cachedMeta.total;
    if (total > 0 && !isNaN(value)) {
      return TAU * (Math.abs(value) / total);
    }
    return 0;
  }
  getLabelAndValue(index2) {
    const meta = this._cachedMeta;
    const chart = this.chart;
    const labels = chart.data.labels || [];
    const value = formatNumber(meta._parsed[index2], chart.options.locale);
    return {
      label: labels[index2] || "",
      value
    };
  }
  getMaxBorderWidth(arcs) {
    let max2 = 0;
    const chart = this.chart;
    let i, ilen, meta, controller, options2;
    if (!arcs) {
      for (i = 0, ilen = chart.data.datasets.length; i < ilen; ++i) {
        if (chart.isDatasetVisible(i)) {
          meta = chart.getDatasetMeta(i);
          arcs = meta.data;
          controller = meta.controller;
          break;
        }
      }
    }
    if (!arcs) {
      return 0;
    }
    for (i = 0, ilen = arcs.length; i < ilen; ++i) {
      options2 = controller.resolveDataElementOptions(i);
      if (options2.borderAlign !== "inner") {
        max2 = Math.max(max2, options2.borderWidth || 0, options2.hoverBorderWidth || 0);
      }
    }
    return max2;
  }
  getMaxOffset(arcs) {
    let max2 = 0;
    for (let i = 0, ilen = arcs.length; i < ilen; ++i) {
      const options2 = this.resolveDataElementOptions(i);
      max2 = Math.max(max2, options2.offset || 0, options2.hoverOffset || 0);
    }
    return max2;
  }
  _getRingWeightOffset(datasetIndex) {
    let ringWeightOffset = 0;
    for (let i = 0; i < datasetIndex; ++i) {
      if (this.chart.isDatasetVisible(i)) {
        ringWeightOffset += this._getRingWeight(i);
      }
    }
    return ringWeightOffset;
  }
  _getRingWeight(datasetIndex) {
    return Math.max(valueOrDefault(this.chart.data.datasets[datasetIndex].weight, 1), 0);
  }
  _getVisibleDatasetWeightTotal() {
    return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
  }
}
__publicField(DoughnutController, "id", "doughnut");
__publicField(DoughnutController, "defaults", {
  datasetElementType: false,
  dataElementType: "arc",
  animation: {
    animateRotate: true,
    animateScale: false
  },
  animations: {
    numbers: {
      type: "number",
      properties: [
        "circumference",
        "endAngle",
        "innerRadius",
        "outerRadius",
        "startAngle",
        "x",
        "y",
        "offset",
        "borderWidth",
        "spacing"
      ]
    }
  },
  cutout: "50%",
  rotation: 0,
  circumference: 360,
  radius: "100%",
  spacing: 0,
  indexAxis: "r"
});
__publicField(DoughnutController, "descriptors", {
  _scriptable: (name) => name !== "spacing",
  _indexable: (name) => name !== "spacing" && !name.startsWith("borderDash") && !name.startsWith("hoverBorderDash")
});
__publicField(DoughnutController, "overrides", {
  aspectRatio: 1,
  plugins: {
    legend: {
      labels: {
        generateLabels(chart) {
          const data2 = chart.data;
          if (data2.labels.length && data2.datasets.length) {
            const { labels: { pointStyle, color: color2 } } = chart.legend.options;
            return data2.labels.map((label, i) => {
              const meta = chart.getDatasetMeta(0);
              const style = meta.controller.getStyle(i);
              return {
                text: label,
                fillStyle: style.backgroundColor,
                strokeStyle: style.borderColor,
                fontColor: color2,
                lineWidth: style.borderWidth,
                pointStyle,
                hidden: !chart.getDataVisibility(i),
                index: i
              };
            });
          }
          return [];
        }
      },
      onClick(e2, legendItem, legend) {
        legend.chart.toggleDataVisibility(legendItem.index);
        legend.chart.update();
      }
    }
  }
});
class LineController extends DatasetController {
  initialize() {
    this.enableOptionSharing = true;
    this.supportsDecimation = true;
    super.initialize();
  }
  update(mode) {
    const meta = this._cachedMeta;
    const { dataset: line2, data: points = [], _dataset } = meta;
    const animationsDisabled = this.chart._animationsDisabled;
    let { start, count } = _getStartAndCountOfVisiblePoints(meta, points, animationsDisabled);
    this._drawStart = start;
    this._drawCount = count;
    if (_scaleRangesChanged(meta)) {
      start = 0;
      count = points.length;
    }
    line2._chart = this.chart;
    line2._datasetIndex = this.index;
    line2._decimated = !!_dataset._decimated;
    line2.points = points;
    const options2 = this.resolveDatasetElementOptions(mode);
    if (!this.options.showLine) {
      options2.borderWidth = 0;
    }
    options2.segment = this.options.segment;
    this.updateElement(line2, void 0, {
      animated: !animationsDisabled,
      options: options2
    }, mode);
    this.updateElements(points, start, count, mode);
  }
  updateElements(points, start, count, mode) {
    const reset = mode === "reset";
    const { iScale, vScale, _stacked, _dataset } = this._cachedMeta;
    const { sharedOptions, includeOptions } = this._getSharedOptions(start, mode);
    const iAxis = iScale.axis;
    const vAxis = vScale.axis;
    const { spanGaps, segment } = this.options;
    const maxGapLength = isNumber$1(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
    const directUpdate = this.chart._animationsDisabled || reset || mode === "none";
    const end = start + count;
    const pointsCount = points.length;
    let prevParsed = start > 0 && this.getParsed(start - 1);
    for (let i = 0; i < pointsCount; ++i) {
      const point = points[i];
      const properties = directUpdate ? point : {};
      if (i < start || i >= end) {
        properties.skip = true;
        continue;
      }
      const parsed = this.getParsed(i);
      const nullData = isNullOrUndef(parsed[vAxis]);
      const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
      const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
      properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
      properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
      if (segment) {
        properties.parsed = parsed;
        properties.raw = _dataset.data[i];
      }
      if (includeOptions) {
        properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? "active" : mode);
      }
      if (!directUpdate) {
        this.updateElement(point, i, properties, mode);
      }
      prevParsed = parsed;
    }
  }
  getMaxOverflow() {
    const meta = this._cachedMeta;
    const dataset = meta.dataset;
    const border = dataset.options && dataset.options.borderWidth || 0;
    const data2 = meta.data || [];
    if (!data2.length) {
      return border;
    }
    const firstPoint = data2[0].size(this.resolveDataElementOptions(0));
    const lastPoint = data2[data2.length - 1].size(this.resolveDataElementOptions(data2.length - 1));
    return Math.max(border, firstPoint, lastPoint) / 2;
  }
  draw() {
    const meta = this._cachedMeta;
    meta.dataset.updateControlPoints(this.chart.chartArea, meta.iScale.axis);
    super.draw();
  }
}
__publicField(LineController, "id", "line");
__publicField(LineController, "defaults", {
  datasetElementType: "line",
  dataElementType: "point",
  showLine: true,
  spanGaps: false
});
__publicField(LineController, "overrides", {
  scales: {
    _index_: {
      type: "category"
    },
    _value_: {
      type: "linear"
    }
  }
});
class PolarAreaController extends DatasetController {
  constructor(chart, datasetIndex) {
    super(chart, datasetIndex);
    this.innerRadius = void 0;
    this.outerRadius = void 0;
  }
  getLabelAndValue(index2) {
    const meta = this._cachedMeta;
    const chart = this.chart;
    const labels = chart.data.labels || [];
    const value = formatNumber(meta._parsed[index2].r, chart.options.locale);
    return {
      label: labels[index2] || "",
      value
    };
  }
  parseObjectData(meta, data2, start, count) {
    return _parseObjectDataRadialScale.bind(this)(meta, data2, start, count);
  }
  update(mode) {
    const arcs = this._cachedMeta.data;
    this._updateRadius();
    this.updateElements(arcs, 0, arcs.length, mode);
  }
  getMinMax() {
    const meta = this._cachedMeta;
    const range2 = {
      min: Number.POSITIVE_INFINITY,
      max: Number.NEGATIVE_INFINITY
    };
    meta.data.forEach((element, index2) => {
      const parsed = this.getParsed(index2).r;
      if (!isNaN(parsed) && this.chart.getDataVisibility(index2)) {
        if (parsed < range2.min) {
          range2.min = parsed;
        }
        if (parsed > range2.max) {
          range2.max = parsed;
        }
      }
    });
    return range2;
  }
  _updateRadius() {
    const chart = this.chart;
    const chartArea = chart.chartArea;
    const opts = chart.options;
    const minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
    const outerRadius = Math.max(minSize / 2, 0);
    const innerRadius = Math.max(opts.cutoutPercentage ? outerRadius / 100 * opts.cutoutPercentage : 1, 0);
    const radiusLength = (outerRadius - innerRadius) / chart.getVisibleDatasetCount();
    this.outerRadius = outerRadius - radiusLength * this.index;
    this.innerRadius = this.outerRadius - radiusLength;
  }
  updateElements(arcs, start, count, mode) {
    const reset = mode === "reset";
    const chart = this.chart;
    const opts = chart.options;
    const animationOpts = opts.animation;
    const scale2 = this._cachedMeta.rScale;
    const centerX = scale2.xCenter;
    const centerY = scale2.yCenter;
    const datasetStartAngle = scale2.getIndexAngle(0) - 0.5 * PI;
    let angle = datasetStartAngle;
    let i;
    const defaultAngle = 360 / this.countVisibleElements();
    for (i = 0; i < start; ++i) {
      angle += this._computeAngle(i, mode, defaultAngle);
    }
    for (i = start; i < start + count; i++) {
      const arc = arcs[i];
      let startAngle = angle;
      let endAngle = angle + this._computeAngle(i, mode, defaultAngle);
      let outerRadius = chart.getDataVisibility(i) ? scale2.getDistanceFromCenterForValue(this.getParsed(i).r) : 0;
      angle = endAngle;
      if (reset) {
        if (animationOpts.animateScale) {
          outerRadius = 0;
        }
        if (animationOpts.animateRotate) {
          startAngle = endAngle = datasetStartAngle;
        }
      }
      const properties = {
        x: centerX,
        y: centerY,
        innerRadius: 0,
        outerRadius,
        startAngle,
        endAngle,
        options: this.resolveDataElementOptions(i, arc.active ? "active" : mode)
      };
      this.updateElement(arc, i, properties, mode);
    }
  }
  countVisibleElements() {
    const meta = this._cachedMeta;
    let count = 0;
    meta.data.forEach((element, index2) => {
      if (!isNaN(this.getParsed(index2).r) && this.chart.getDataVisibility(index2)) {
        count++;
      }
    });
    return count;
  }
  _computeAngle(index2, mode, defaultAngle) {
    return this.chart.getDataVisibility(index2) ? toRadians(this.resolveDataElementOptions(index2, mode).angle || defaultAngle) : 0;
  }
}
__publicField(PolarAreaController, "id", "polarArea");
__publicField(PolarAreaController, "defaults", {
  dataElementType: "arc",
  animation: {
    animateRotate: true,
    animateScale: true
  },
  animations: {
    numbers: {
      type: "number",
      properties: [
        "x",
        "y",
        "startAngle",
        "endAngle",
        "innerRadius",
        "outerRadius"
      ]
    }
  },
  indexAxis: "r",
  startAngle: 0
});
__publicField(PolarAreaController, "overrides", {
  aspectRatio: 1,
  plugins: {
    legend: {
      labels: {
        generateLabels(chart) {
          const data2 = chart.data;
          if (data2.labels.length && data2.datasets.length) {
            const { labels: { pointStyle, color: color2 } } = chart.legend.options;
            return data2.labels.map((label, i) => {
              const meta = chart.getDatasetMeta(0);
              const style = meta.controller.getStyle(i);
              return {
                text: label,
                fillStyle: style.backgroundColor,
                strokeStyle: style.borderColor,
                fontColor: color2,
                lineWidth: style.borderWidth,
                pointStyle,
                hidden: !chart.getDataVisibility(i),
                index: i
              };
            });
          }
          return [];
        }
      },
      onClick(e2, legendItem, legend) {
        legend.chart.toggleDataVisibility(legendItem.index);
        legend.chart.update();
      }
    }
  },
  scales: {
    r: {
      type: "radialLinear",
      angleLines: {
        display: false
      },
      beginAtZero: true,
      grid: {
        circular: true
      },
      pointLabels: {
        display: false
      },
      startAngle: 0
    }
  }
});
class PieController extends DoughnutController {
}
__publicField(PieController, "id", "pie");
__publicField(PieController, "defaults", {
  cutout: 0,
  rotation: 0,
  circumference: 360,
  radius: "100%"
});
class RadarController extends DatasetController {
  getLabelAndValue(index2) {
    const vScale = this._cachedMeta.vScale;
    const parsed = this.getParsed(index2);
    return {
      label: vScale.getLabels()[index2],
      value: "" + vScale.getLabelForValue(parsed[vScale.axis])
    };
  }
  parseObjectData(meta, data2, start, count) {
    return _parseObjectDataRadialScale.bind(this)(meta, data2, start, count);
  }
  update(mode) {
    const meta = this._cachedMeta;
    const line2 = meta.dataset;
    const points = meta.data || [];
    const labels = meta.iScale.getLabels();
    line2.points = points;
    if (mode !== "resize") {
      const options2 = this.resolveDatasetElementOptions(mode);
      if (!this.options.showLine) {
        options2.borderWidth = 0;
      }
      const properties = {
        _loop: true,
        _fullLoop: labels.length === points.length,
        options: options2
      };
      this.updateElement(line2, void 0, properties, mode);
    }
    this.updateElements(points, 0, points.length, mode);
  }
  updateElements(points, start, count, mode) {
    const scale2 = this._cachedMeta.rScale;
    const reset = mode === "reset";
    for (let i = start; i < start + count; i++) {
      const point = points[i];
      const options2 = this.resolveDataElementOptions(i, point.active ? "active" : mode);
      const pointPosition = scale2.getPointPositionForValue(i, this.getParsed(i).r);
      const x2 = reset ? scale2.xCenter : pointPosition.x;
      const y2 = reset ? scale2.yCenter : pointPosition.y;
      const properties = {
        x: x2,
        y: y2,
        angle: pointPosition.angle,
        skip: isNaN(x2) || isNaN(y2),
        options: options2
      };
      this.updateElement(point, i, properties, mode);
    }
  }
}
__publicField(RadarController, "id", "radar");
__publicField(RadarController, "defaults", {
  datasetElementType: "line",
  dataElementType: "point",
  indexAxis: "r",
  showLine: true,
  elements: {
    line: {
      fill: "start"
    }
  }
});
__publicField(RadarController, "overrides", {
  aspectRatio: 1,
  scales: {
    r: {
      type: "radialLinear"
    }
  }
});
class ScatterController extends DatasetController {
  getLabelAndValue(index2) {
    const meta = this._cachedMeta;
    const labels = this.chart.data.labels || [];
    const { xScale, yScale } = meta;
    const parsed = this.getParsed(index2);
    const x2 = xScale.getLabelForValue(parsed.x);
    const y2 = yScale.getLabelForValue(parsed.y);
    return {
      label: labels[index2] || "",
      value: "(" + x2 + ", " + y2 + ")"
    };
  }
  update(mode) {
    const meta = this._cachedMeta;
    const { data: points = [] } = meta;
    const animationsDisabled = this.chart._animationsDisabled;
    let { start, count } = _getStartAndCountOfVisiblePoints(meta, points, animationsDisabled);
    this._drawStart = start;
    this._drawCount = count;
    if (_scaleRangesChanged(meta)) {
      start = 0;
      count = points.length;
    }
    if (this.options.showLine) {
      if (!this.datasetElementType) {
        this.addElements();
      }
      const { dataset: line2, _dataset } = meta;
      line2._chart = this.chart;
      line2._datasetIndex = this.index;
      line2._decimated = !!_dataset._decimated;
      line2.points = points;
      const options2 = this.resolveDatasetElementOptions(mode);
      options2.segment = this.options.segment;
      this.updateElement(line2, void 0, {
        animated: !animationsDisabled,
        options: options2
      }, mode);
    } else if (this.datasetElementType) {
      delete meta.dataset;
      this.datasetElementType = false;
    }
    this.updateElements(points, start, count, mode);
  }
  addElements() {
    const { showLine } = this.options;
    if (!this.datasetElementType && showLine) {
      this.datasetElementType = this.chart.registry.getElement("line");
    }
    super.addElements();
  }
  updateElements(points, start, count, mode) {
    const reset = mode === "reset";
    const { iScale, vScale, _stacked, _dataset } = this._cachedMeta;
    const firstOpts = this.resolveDataElementOptions(start, mode);
    const sharedOptions = this.getSharedOptions(firstOpts);
    const includeOptions = this.includeOptions(mode, sharedOptions);
    const iAxis = iScale.axis;
    const vAxis = vScale.axis;
    const { spanGaps, segment } = this.options;
    const maxGapLength = isNumber$1(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
    const directUpdate = this.chart._animationsDisabled || reset || mode === "none";
    let prevParsed = start > 0 && this.getParsed(start - 1);
    for (let i = start; i < start + count; ++i) {
      const point = points[i];
      const parsed = this.getParsed(i);
      const properties = directUpdate ? point : {};
      const nullData = isNullOrUndef(parsed[vAxis]);
      const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
      const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
      properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
      properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
      if (segment) {
        properties.parsed = parsed;
        properties.raw = _dataset.data[i];
      }
      if (includeOptions) {
        properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? "active" : mode);
      }
      if (!directUpdate) {
        this.updateElement(point, i, properties, mode);
      }
      prevParsed = parsed;
    }
    this.updateSharedOptions(sharedOptions, mode, firstOpts);
  }
  getMaxOverflow() {
    const meta = this._cachedMeta;
    const data2 = meta.data || [];
    if (!this.options.showLine) {
      let max2 = 0;
      for (let i = data2.length - 1; i >= 0; --i) {
        max2 = Math.max(max2, data2[i].size(this.resolveDataElementOptions(i)) / 2);
      }
      return max2 > 0 && max2;
    }
    const dataset = meta.dataset;
    const border = dataset.options && dataset.options.borderWidth || 0;
    if (!data2.length) {
      return border;
    }
    const firstPoint = data2[0].size(this.resolveDataElementOptions(0));
    const lastPoint = data2[data2.length - 1].size(this.resolveDataElementOptions(data2.length - 1));
    return Math.max(border, firstPoint, lastPoint) / 2;
  }
}
__publicField(ScatterController, "id", "scatter");
__publicField(ScatterController, "defaults", {
  datasetElementType: false,
  dataElementType: "point",
  showLine: false,
  fill: false
});
__publicField(ScatterController, "overrides", {
  interaction: {
    mode: "point"
  },
  scales: {
    x: {
      type: "linear"
    },
    y: {
      type: "linear"
    }
  }
});
var controllers = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  BarController,
  BubbleController,
  DoughnutController,
  LineController,
  PieController,
  PolarAreaController,
  RadarController,
  ScatterController
});
function abstract() {
  throw new Error("This method is not implemented: Check that a complete date adapter is provided.");
}
class DateAdapterBase {
  constructor(options2) {
    __publicField(this, "options");
    this.options = options2 || {};
  }
  /**
  * Override default date adapter methods.
  * Accepts type parameter to define options type.
  * @example
  * Chart._adapters._date.override<{myAdapterOption: string}>({
  *   init() {
  *     console.log(this.options.myAdapterOption);
  *   }
  * })
  */
  static override(members) {
    Object.assign(DateAdapterBase.prototype, members);
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  init() {
  }
  formats() {
    return abstract();
  }
  parse() {
    return abstract();
  }
  format() {
    return abstract();
  }
  add() {
    return abstract();
  }
  diff() {
    return abstract();
  }
  startOf() {
    return abstract();
  }
  endOf() {
    return abstract();
  }
}
var adapters = {
  _date: DateAdapterBase
};
function binarySearch(metaset, axis, value, intersect) {
  const { controller, data: data2, _sorted } = metaset;
  const iScale = controller._cachedMeta.iScale;
  if (iScale && axis === iScale.axis && axis !== "r" && _sorted && data2.length) {
    const lookupMethod = iScale._reversePixels ? _rlookupByKey : _lookupByKey;
    if (!intersect) {
      return lookupMethod(data2, axis, value);
    } else if (controller._sharedOptions) {
      const el = data2[0];
      const range2 = typeof el.getRange === "function" && el.getRange(axis);
      if (range2) {
        const start = lookupMethod(data2, axis, value - range2);
        const end = lookupMethod(data2, axis, value + range2);
        return {
          lo: start.lo,
          hi: end.hi
        };
      }
    }
  }
  return {
    lo: 0,
    hi: data2.length - 1
  };
}
function evaluateInteractionItems(chart, axis, position2, handler, intersect) {
  const metasets = chart.getSortedVisibleDatasetMetas();
  const value = position2[axis];
  for (let i = 0, ilen = metasets.length; i < ilen; ++i) {
    const { index: index2, data: data2 } = metasets[i];
    const { lo, hi } = binarySearch(metasets[i], axis, value, intersect);
    for (let j = lo; j <= hi; ++j) {
      const element = data2[j];
      if (!element.skip) {
        handler(element, index2, j);
      }
    }
  }
}
function getDistanceMetricForAxis(axis) {
  const useX = axis.indexOf("x") !== -1;
  const useY = axis.indexOf("y") !== -1;
  return function(pt1, pt2) {
    const deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
    const deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
    return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
  };
}
function getIntersectItems(chart, position2, axis, useFinalPosition, includeInvisible) {
  const items = [];
  if (!includeInvisible && !chart.isPointInArea(position2)) {
    return items;
  }
  const evaluationFunc = function(element, datasetIndex, index2) {
    if (!includeInvisible && !_isPointInArea(element, chart.chartArea, 0)) {
      return;
    }
    if (element.inRange(position2.x, position2.y, useFinalPosition)) {
      items.push({
        element,
        datasetIndex,
        index: index2
      });
    }
  };
  evaluateInteractionItems(chart, axis, position2, evaluationFunc, true);
  return items;
}
function getNearestRadialItems(chart, position2, axis, useFinalPosition) {
  let items = [];
  function evaluationFunc(element, datasetIndex, index2) {
    const { startAngle, endAngle } = element.getProps([
      "startAngle",
      "endAngle"
    ], useFinalPosition);
    const { angle } = getAngleFromPoint(element, {
      x: position2.x,
      y: position2.y
    });
    if (_angleBetween(angle, startAngle, endAngle)) {
      items.push({
        element,
        datasetIndex,
        index: index2
      });
    }
  }
  evaluateInteractionItems(chart, axis, position2, evaluationFunc);
  return items;
}
function getNearestCartesianItems(chart, position2, axis, intersect, useFinalPosition, includeInvisible) {
  let items = [];
  const distanceMetric = getDistanceMetricForAxis(axis);
  let minDistance = Number.POSITIVE_INFINITY;
  function evaluationFunc(element, datasetIndex, index2) {
    const inRange2 = element.inRange(position2.x, position2.y, useFinalPosition);
    if (intersect && !inRange2) {
      return;
    }
    const center = element.getCenterPoint(useFinalPosition);
    const pointInArea = !!includeInvisible || chart.isPointInArea(center);
    if (!pointInArea && !inRange2) {
      return;
    }
    const distance2 = distanceMetric(position2, center);
    if (distance2 < minDistance) {
      items = [
        {
          element,
          datasetIndex,
          index: index2
        }
      ];
      minDistance = distance2;
    } else if (distance2 === minDistance) {
      items.push({
        element,
        datasetIndex,
        index: index2
      });
    }
  }
  evaluateInteractionItems(chart, axis, position2, evaluationFunc);
  return items;
}
function getNearestItems(chart, position2, axis, intersect, useFinalPosition, includeInvisible) {
  if (!includeInvisible && !chart.isPointInArea(position2)) {
    return [];
  }
  return axis === "r" && !intersect ? getNearestRadialItems(chart, position2, axis, useFinalPosition) : getNearestCartesianItems(chart, position2, axis, intersect, useFinalPosition, includeInvisible);
}
function getAxisItems(chart, position2, axis, intersect, useFinalPosition) {
  const items = [];
  const rangeMethod = axis === "x" ? "inXRange" : "inYRange";
  let intersectsItem = false;
  evaluateInteractionItems(chart, axis, position2, (element, datasetIndex, index2) => {
    if (element[rangeMethod](position2[axis], useFinalPosition)) {
      items.push({
        element,
        datasetIndex,
        index: index2
      });
      intersectsItem = intersectsItem || element.inRange(position2.x, position2.y, useFinalPosition);
    }
  });
  if (intersect && !intersectsItem) {
    return [];
  }
  return items;
}
var Interaction = {
  evaluateInteractionItems,
  modes: {
    index(chart, e2, options2, useFinalPosition) {
      const position2 = getRelativePosition(e2, chart);
      const axis = options2.axis || "x";
      const includeInvisible = options2.includeInvisible || false;
      const items = options2.intersect ? getIntersectItems(chart, position2, axis, useFinalPosition, includeInvisible) : getNearestItems(chart, position2, axis, false, useFinalPosition, includeInvisible);
      const elements2 = [];
      if (!items.length) {
        return [];
      }
      chart.getSortedVisibleDatasetMetas().forEach((meta) => {
        const index2 = items[0].index;
        const element = meta.data[index2];
        if (element && !element.skip) {
          elements2.push({
            element,
            datasetIndex: meta.index,
            index: index2
          });
        }
      });
      return elements2;
    },
    dataset(chart, e2, options2, useFinalPosition) {
      const position2 = getRelativePosition(e2, chart);
      const axis = options2.axis || "xy";
      const includeInvisible = options2.includeInvisible || false;
      let items = options2.intersect ? getIntersectItems(chart, position2, axis, useFinalPosition, includeInvisible) : getNearestItems(chart, position2, axis, false, useFinalPosition, includeInvisible);
      if (items.length > 0) {
        const datasetIndex = items[0].datasetIndex;
        const data2 = chart.getDatasetMeta(datasetIndex).data;
        items = [];
        for (let i = 0; i < data2.length; ++i) {
          items.push({
            element: data2[i],
            datasetIndex,
            index: i
          });
        }
      }
      return items;
    },
    point(chart, e2, options2, useFinalPosition) {
      const position2 = getRelativePosition(e2, chart);
      const axis = options2.axis || "xy";
      const includeInvisible = options2.includeInvisible || false;
      return getIntersectItems(chart, position2, axis, useFinalPosition, includeInvisible);
    },
    nearest(chart, e2, options2, useFinalPosition) {
      const position2 = getRelativePosition(e2, chart);
      const axis = options2.axis || "xy";
      const includeInvisible = options2.includeInvisible || false;
      return getNearestItems(chart, position2, axis, options2.intersect, useFinalPosition, includeInvisible);
    },
    x(chart, e2, options2, useFinalPosition) {
      const position2 = getRelativePosition(e2, chart);
      return getAxisItems(chart, position2, "x", options2.intersect, useFinalPosition);
    },
    y(chart, e2, options2, useFinalPosition) {
      const position2 = getRelativePosition(e2, chart);
      return getAxisItems(chart, position2, "y", options2.intersect, useFinalPosition);
    }
  }
};
const STATIC_POSITIONS = [
  "left",
  "top",
  "right",
  "bottom"
];
function filterByPosition(array, position2) {
  return array.filter((v2) => v2.pos === position2);
}
function filterDynamicPositionByAxis(array, axis) {
  return array.filter((v2) => STATIC_POSITIONS.indexOf(v2.pos) === -1 && v2.box.axis === axis);
}
function sortByWeight(array, reverse) {
  return array.sort((a2, b2) => {
    const v0 = reverse ? b2 : a2;
    const v1 = reverse ? a2 : b2;
    return v0.weight === v1.weight ? v0.index - v1.index : v0.weight - v1.weight;
  });
}
function wrapBoxes(boxes) {
  const layoutBoxes = [];
  let i, ilen, box2, pos, stack, stackWeight;
  for (i = 0, ilen = (boxes || []).length; i < ilen; ++i) {
    box2 = boxes[i];
    ({ position: pos, options: { stack, stackWeight = 1 } } = box2);
    layoutBoxes.push({
      index: i,
      box: box2,
      pos,
      horizontal: box2.isHorizontal(),
      weight: box2.weight,
      stack: stack && pos + stack,
      stackWeight
    });
  }
  return layoutBoxes;
}
function buildStacks(layouts2) {
  const stacks = {};
  for (const wrap of layouts2) {
    const { stack, pos, stackWeight } = wrap;
    if (!stack || !STATIC_POSITIONS.includes(pos)) {
      continue;
    }
    const _stack = stacks[stack] || (stacks[stack] = {
      count: 0,
      placed: 0,
      weight: 0,
      size: 0
    });
    _stack.count++;
    _stack.weight += stackWeight;
  }
  return stacks;
}
function setLayoutDims(layouts2, params) {
  const stacks = buildStacks(layouts2);
  const { vBoxMaxWidth, hBoxMaxHeight } = params;
  let i, ilen, layout;
  for (i = 0, ilen = layouts2.length; i < ilen; ++i) {
    layout = layouts2[i];
    const { fullSize } = layout.box;
    const stack = stacks[layout.stack];
    const factor = stack && layout.stackWeight / stack.weight;
    if (layout.horizontal) {
      layout.width = factor ? factor * vBoxMaxWidth : fullSize && params.availableWidth;
      layout.height = hBoxMaxHeight;
    } else {
      layout.width = vBoxMaxWidth;
      layout.height = factor ? factor * hBoxMaxHeight : fullSize && params.availableHeight;
    }
  }
  return stacks;
}
function buildLayoutBoxes(boxes) {
  const layoutBoxes = wrapBoxes(boxes);
  const fullSize = sortByWeight(layoutBoxes.filter((wrap) => wrap.box.fullSize), true);
  const left = sortByWeight(filterByPosition(layoutBoxes, "left"), true);
  const right = sortByWeight(filterByPosition(layoutBoxes, "right"));
  const top = sortByWeight(filterByPosition(layoutBoxes, "top"), true);
  const bottom = sortByWeight(filterByPosition(layoutBoxes, "bottom"));
  const centerHorizontal = filterDynamicPositionByAxis(layoutBoxes, "x");
  const centerVertical = filterDynamicPositionByAxis(layoutBoxes, "y");
  return {
    fullSize,
    leftAndTop: left.concat(top),
    rightAndBottom: right.concat(centerVertical).concat(bottom).concat(centerHorizontal),
    chartArea: filterByPosition(layoutBoxes, "chartArea"),
    vertical: left.concat(right).concat(centerVertical),
    horizontal: top.concat(bottom).concat(centerHorizontal)
  };
}
function getCombinedMax(maxPadding, chartArea, a2, b2) {
  return Math.max(maxPadding[a2], chartArea[a2]) + Math.max(maxPadding[b2], chartArea[b2]);
}
function updateMaxPadding(maxPadding, boxPadding) {
  maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
  maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
  maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
  maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
}
function updateDims(chartArea, params, layout, stacks) {
  const { pos, box: box2 } = layout;
  const maxPadding = chartArea.maxPadding;
  if (!isObject(pos)) {
    if (layout.size) {
      chartArea[pos] -= layout.size;
    }
    const stack = stacks[layout.stack] || {
      size: 0,
      count: 1
    };
    stack.size = Math.max(stack.size, layout.horizontal ? box2.height : box2.width);
    layout.size = stack.size / stack.count;
    chartArea[pos] += layout.size;
  }
  if (box2.getPadding) {
    updateMaxPadding(maxPadding, box2.getPadding());
  }
  const newWidth = Math.max(0, params.outerWidth - getCombinedMax(maxPadding, chartArea, "left", "right"));
  const newHeight = Math.max(0, params.outerHeight - getCombinedMax(maxPadding, chartArea, "top", "bottom"));
  const widthChanged = newWidth !== chartArea.w;
  const heightChanged = newHeight !== chartArea.h;
  chartArea.w = newWidth;
  chartArea.h = newHeight;
  return layout.horizontal ? {
    same: widthChanged,
    other: heightChanged
  } : {
    same: heightChanged,
    other: widthChanged
  };
}
function handleMaxPadding(chartArea) {
  const maxPadding = chartArea.maxPadding;
  function updatePos(pos) {
    const change = Math.max(maxPadding[pos] - chartArea[pos], 0);
    chartArea[pos] += change;
    return change;
  }
  chartArea.y += updatePos("top");
  chartArea.x += updatePos("left");
  updatePos("right");
  updatePos("bottom");
}
function getMargins(horizontal, chartArea) {
  const maxPadding = chartArea.maxPadding;
  function marginForPositions(positions2) {
    const margin = {
      left: 0,
      top: 0,
      right: 0,
      bottom: 0
    };
    positions2.forEach((pos) => {
      margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
    });
    return margin;
  }
  return horizontal ? marginForPositions([
    "left",
    "right"
  ]) : marginForPositions([
    "top",
    "bottom"
  ]);
}
function fitBoxes(boxes, chartArea, params, stacks) {
  const refitBoxes = [];
  let i, ilen, layout, box2, refit, changed;
  for (i = 0, ilen = boxes.length, refit = 0; i < ilen; ++i) {
    layout = boxes[i];
    box2 = layout.box;
    box2.update(layout.width || chartArea.w, layout.height || chartArea.h, getMargins(layout.horizontal, chartArea));
    const { same, other } = updateDims(chartArea, params, layout, stacks);
    refit |= same && refitBoxes.length;
    changed = changed || other;
    if (!box2.fullSize) {
      refitBoxes.push(layout);
    }
  }
  return refit && fitBoxes(refitBoxes, chartArea, params, stacks) || changed;
}
function setBoxDims(box2, left, top, width, height2) {
  box2.top = top;
  box2.left = left;
  box2.right = left + width;
  box2.bottom = top + height2;
  box2.width = width;
  box2.height = height2;
}
function placeBoxes(boxes, chartArea, params, stacks) {
  const userPadding = params.padding;
  let { x: x2, y: y2 } = chartArea;
  for (const layout of boxes) {
    const box2 = layout.box;
    const stack = stacks[layout.stack] || {
      count: 1,
      placed: 0,
      weight: 1
    };
    const weight = layout.stackWeight / stack.weight || 1;
    if (layout.horizontal) {
      const width = chartArea.w * weight;
      const height2 = stack.size || box2.height;
      if (defined(stack.start)) {
        y2 = stack.start;
      }
      if (box2.fullSize) {
        setBoxDims(box2, userPadding.left, y2, params.outerWidth - userPadding.right - userPadding.left, height2);
      } else {
        setBoxDims(box2, chartArea.left + stack.placed, y2, width, height2);
      }
      stack.start = y2;
      stack.placed += width;
      y2 = box2.bottom;
    } else {
      const height2 = chartArea.h * weight;
      const width = stack.size || box2.width;
      if (defined(stack.start)) {
        x2 = stack.start;
      }
      if (box2.fullSize) {
        setBoxDims(box2, x2, userPadding.top, width, params.outerHeight - userPadding.bottom - userPadding.top);
      } else {
        setBoxDims(box2, x2, chartArea.top + stack.placed, width, height2);
      }
      stack.start = x2;
      stack.placed += height2;
      x2 = box2.right;
    }
  }
  chartArea.x = x2;
  chartArea.y = y2;
}
var layouts = {
  addBox(chart, item) {
    if (!chart.boxes) {
      chart.boxes = [];
    }
    item.fullSize = item.fullSize || false;
    item.position = item.position || "top";
    item.weight = item.weight || 0;
    item._layers = item._layers || function() {
      return [
        {
          z: 0,
          draw(chartArea) {
            item.draw(chartArea);
          }
        }
      ];
    };
    chart.boxes.push(item);
  },
  removeBox(chart, layoutItem) {
    const index2 = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
    if (index2 !== -1) {
      chart.boxes.splice(index2, 1);
    }
  },
  configure(chart, item, options2) {
    item.fullSize = options2.fullSize;
    item.position = options2.position;
    item.weight = options2.weight;
  },
  update(chart, width, height2, minPadding) {
    if (!chart) {
      return;
    }
    const padding = toPadding(chart.options.layout.padding);
    const availableWidth = Math.max(width - padding.width, 0);
    const availableHeight = Math.max(height2 - padding.height, 0);
    const boxes = buildLayoutBoxes(chart.boxes);
    const verticalBoxes = boxes.vertical;
    const horizontalBoxes = boxes.horizontal;
    each$1(chart.boxes, (box2) => {
      if (typeof box2.beforeLayout === "function") {
        box2.beforeLayout();
      }
    });
    const visibleVerticalBoxCount = verticalBoxes.reduce((total, wrap) => wrap.box.options && wrap.box.options.display === false ? total : total + 1, 0) || 1;
    const params = Object.freeze({
      outerWidth: width,
      outerHeight: height2,
      padding,
      availableWidth,
      availableHeight,
      vBoxMaxWidth: availableWidth / 2 / visibleVerticalBoxCount,
      hBoxMaxHeight: availableHeight / 2
    });
    const maxPadding = Object.assign({}, padding);
    updateMaxPadding(maxPadding, toPadding(minPadding));
    const chartArea = Object.assign({
      maxPadding,
      w: availableWidth,
      h: availableHeight,
      x: padding.left,
      y: padding.top
    }, padding);
    const stacks = setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);
    fitBoxes(boxes.fullSize, chartArea, params, stacks);
    fitBoxes(verticalBoxes, chartArea, params, stacks);
    if (fitBoxes(horizontalBoxes, chartArea, params, stacks)) {
      fitBoxes(verticalBoxes, chartArea, params, stacks);
    }
    handleMaxPadding(chartArea);
    placeBoxes(boxes.leftAndTop, chartArea, params, stacks);
    chartArea.x += chartArea.w;
    chartArea.y += chartArea.h;
    placeBoxes(boxes.rightAndBottom, chartArea, params, stacks);
    chart.chartArea = {
      left: chartArea.left,
      top: chartArea.top,
      right: chartArea.left + chartArea.w,
      bottom: chartArea.top + chartArea.h,
      height: chartArea.h,
      width: chartArea.w
    };
    each$1(boxes.chartArea, (layout) => {
      const box2 = layout.box;
      Object.assign(box2, chart.chartArea);
      box2.update(chartArea.w, chartArea.h, {
        left: 0,
        top: 0,
        right: 0,
        bottom: 0
      });
    });
  }
};
class BasePlatform {
  acquireContext(canvas, aspectRatio) {
  }
  releaseContext(context) {
    return false;
  }
  addEventListener(chart, type2, listener) {
  }
  removeEventListener(chart, type2, listener) {
  }
  getDevicePixelRatio() {
    return 1;
  }
  getMaximumSize(element, width, height2, aspectRatio) {
    width = Math.max(0, width || element.width);
    height2 = height2 || element.height;
    return {
      width,
      height: Math.max(0, aspectRatio ? Math.floor(width / aspectRatio) : height2)
    };
  }
  isAttached(canvas) {
    return true;
  }
  updateConfig(config2) {
  }
}
class BasicPlatform extends BasePlatform {
  acquireContext(item) {
    return item && item.getContext && item.getContext("2d") || null;
  }
  updateConfig(config2) {
    config2.options.animation = false;
  }
}
const EXPANDO_KEY = "$chartjs";
const EVENT_TYPES = {
  touchstart: "mousedown",
  touchmove: "mousemove",
  touchend: "mouseup",
  pointerenter: "mouseenter",
  pointerdown: "mousedown",
  pointermove: "mousemove",
  pointerup: "mouseup",
  pointerleave: "mouseout",
  pointerout: "mouseout"
};
const isNullOrEmpty = (value) => value === null || value === "";
function initCanvas(canvas, aspectRatio) {
  const style = canvas.style;
  const renderHeight = canvas.getAttribute("height");
  const renderWidth = canvas.getAttribute("width");
  canvas[EXPANDO_KEY] = {
    initial: {
      height: renderHeight,
      width: renderWidth,
      style: {
        display: style.display,
        height: style.height,
        width: style.width
      }
    }
  };
  style.display = style.display || "block";
  style.boxSizing = style.boxSizing || "border-box";
  if (isNullOrEmpty(renderWidth)) {
    const displayWidth = readUsedSize(canvas, "width");
    if (displayWidth !== void 0) {
      canvas.width = displayWidth;
    }
  }
  if (isNullOrEmpty(renderHeight)) {
    if (canvas.style.height === "") {
      canvas.height = canvas.width / (aspectRatio || 2);
    } else {
      const displayHeight = readUsedSize(canvas, "height");
      if (displayHeight !== void 0) {
        canvas.height = displayHeight;
      }
    }
  }
  return canvas;
}
const eventListenerOptions = supportsEventListenerOptions ? {
  passive: true
} : false;
function addListener(node2, type2, listener) {
  if (node2) {
    node2.addEventListener(type2, listener, eventListenerOptions);
  }
}
function removeListener(chart, type2, listener) {
  if (chart && chart.canvas) {
    chart.canvas.removeEventListener(type2, listener, eventListenerOptions);
  }
}
function fromNativeEvent(event, chart) {
  const type2 = EVENT_TYPES[event.type] || event.type;
  const { x: x2, y: y2 } = getRelativePosition(event, chart);
  return {
    type: type2,
    chart,
    native: event,
    x: x2 !== void 0 ? x2 : null,
    y: y2 !== void 0 ? y2 : null
  };
}
function nodeListContains(nodeList, canvas) {
  for (const node2 of nodeList) {
    if (node2 === canvas || node2.contains(canvas)) {
      return true;
    }
  }
}
function createAttachObserver(chart, type2, listener) {
  const canvas = chart.canvas;
  const observer = new MutationObserver((entries) => {
    let trigger = false;
    for (const entry of entries) {
      trigger = trigger || nodeListContains(entry.addedNodes, canvas);
      trigger = trigger && !nodeListContains(entry.removedNodes, canvas);
    }
    if (trigger) {
      listener();
    }
  });
  observer.observe(document, {
    childList: true,
    subtree: true
  });
  return observer;
}
function createDetachObserver(chart, type2, listener) {
  const canvas = chart.canvas;
  const observer = new MutationObserver((entries) => {
    let trigger = false;
    for (const entry of entries) {
      trigger = trigger || nodeListContains(entry.removedNodes, canvas);
      trigger = trigger && !nodeListContains(entry.addedNodes, canvas);
    }
    if (trigger) {
      listener();
    }
  });
  observer.observe(document, {
    childList: true,
    subtree: true
  });
  return observer;
}
const drpListeningCharts = /* @__PURE__ */ new Map();
let oldDevicePixelRatio = 0;
function onWindowResize() {
  const dpr = window.devicePixelRatio;
  if (dpr === oldDevicePixelRatio) {
    return;
  }
  oldDevicePixelRatio = dpr;
  drpListeningCharts.forEach((resize, chart) => {
    if (chart.currentDevicePixelRatio !== dpr) {
      resize();
    }
  });
}
function listenDevicePixelRatioChanges(chart, resize) {
  if (!drpListeningCharts.size) {
    window.addEventListener("resize", onWindowResize);
  }
  drpListeningCharts.set(chart, resize);
}
function unlistenDevicePixelRatioChanges(chart) {
  drpListeningCharts.delete(chart);
  if (!drpListeningCharts.size) {
    window.removeEventListener("resize", onWindowResize);
  }
}
function createResizeObserver(chart, type2, listener) {
  const canvas = chart.canvas;
  const container = canvas && _getParentNode(canvas);
  if (!container) {
    return;
  }
  const resize = throttled((width, height2) => {
    const w2 = container.clientWidth;
    listener(width, height2);
    if (w2 < container.clientWidth) {
      listener();
    }
  }, window);
  const observer = new ResizeObserver((entries) => {
    const entry = entries[0];
    const width = entry.contentRect.width;
    const height2 = entry.contentRect.height;
    if (width === 0 && height2 === 0) {
      return;
    }
    resize(width, height2);
  });
  observer.observe(container);
  listenDevicePixelRatioChanges(chart, resize);
  return observer;
}
function releaseObserver(chart, type2, observer) {
  if (observer) {
    observer.disconnect();
  }
  if (type2 === "resize") {
    unlistenDevicePixelRatioChanges(chart);
  }
}
function createProxyAndListen(chart, type2, listener) {
  const canvas = chart.canvas;
  const proxy = throttled((event) => {
    if (chart.ctx !== null) {
      listener(fromNativeEvent(event, chart));
    }
  }, chart);
  addListener(canvas, type2, proxy);
  return proxy;
}
class DomPlatform extends BasePlatform {
  acquireContext(canvas, aspectRatio) {
    const context = canvas && canvas.getContext && canvas.getContext("2d");
    if (context && context.canvas === canvas) {
      initCanvas(canvas, aspectRatio);
      return context;
    }
    return null;
  }
  releaseContext(context) {
    const canvas = context.canvas;
    if (!canvas[EXPANDO_KEY]) {
      return false;
    }
    const initial = canvas[EXPANDO_KEY].initial;
    [
      "height",
      "width"
    ].forEach((prop) => {
      const value = initial[prop];
      if (isNullOrUndef(value)) {
        canvas.removeAttribute(prop);
      } else {
        canvas.setAttribute(prop, value);
      }
    });
    const style = initial.style || {};
    Object.keys(style).forEach((key) => {
      canvas.style[key] = style[key];
    });
    canvas.width = canvas.width;
    delete canvas[EXPANDO_KEY];
    return true;
  }
  addEventListener(chart, type2, listener) {
    this.removeEventListener(chart, type2);
    const proxies = chart.$proxies || (chart.$proxies = {});
    const handlers = {
      attach: createAttachObserver,
      detach: createDetachObserver,
      resize: createResizeObserver
    };
    const handler = handlers[type2] || createProxyAndListen;
    proxies[type2] = handler(chart, type2, listener);
  }
  removeEventListener(chart, type2) {
    const proxies = chart.$proxies || (chart.$proxies = {});
    const proxy = proxies[type2];
    if (!proxy) {
      return;
    }
    const handlers = {
      attach: releaseObserver,
      detach: releaseObserver,
      resize: releaseObserver
    };
    const handler = handlers[type2] || removeListener;
    handler(chart, type2, proxy);
    proxies[type2] = void 0;
  }
  getDevicePixelRatio() {
    return window.devicePixelRatio;
  }
  getMaximumSize(canvas, width, height2, aspectRatio) {
    return getMaximumSize(canvas, width, height2, aspectRatio);
  }
  isAttached(canvas) {
    const container = canvas && _getParentNode(canvas);
    return !!(container && container.isConnected);
  }
}
function _detectPlatform(canvas) {
  if (!_isDomSupported() || typeof OffscreenCanvas !== "undefined" && canvas instanceof OffscreenCanvas) {
    return BasicPlatform;
  }
  return DomPlatform;
}
let Element$1 = (_a = class {
  constructor() {
    __publicField(this, "x");
    __publicField(this, "y");
    __publicField(this, "active", false);
    __publicField(this, "options");
    __publicField(this, "$animations");
  }
  tooltipPosition(useFinalPosition) {
    const { x: x2, y: y2 } = this.getProps([
      "x",
      "y"
    ], useFinalPosition);
    return {
      x: x2,
      y: y2
    };
  }
  hasValue() {
    return isNumber$1(this.x) && isNumber$1(this.y);
  }
  getProps(props, final) {
    const anims = this.$animations;
    if (!final || !anims) {
      return this;
    }
    const ret = {};
    props.forEach((prop) => {
      ret[prop] = anims[prop] && anims[prop].active() ? anims[prop]._to : this[prop];
    });
    return ret;
  }
}, __publicField(_a, "defaults", {}), __publicField(_a, "defaultRoutes"), _a);
function autoSkip(scale2, ticks) {
  const tickOpts = scale2.options.ticks;
  const determinedMaxTicks = determineMaxTicks(scale2);
  const ticksLimit = Math.min(tickOpts.maxTicksLimit || determinedMaxTicks, determinedMaxTicks);
  const majorIndices = tickOpts.major.enabled ? getMajorIndices(ticks) : [];
  const numMajorIndices = majorIndices.length;
  const first = majorIndices[0];
  const last2 = majorIndices[numMajorIndices - 1];
  const newTicks = [];
  if (numMajorIndices > ticksLimit) {
    skipMajors(ticks, newTicks, majorIndices, numMajorIndices / ticksLimit);
    return newTicks;
  }
  const spacing2 = calculateSpacing(majorIndices, ticks, ticksLimit);
  if (numMajorIndices > 0) {
    let i, ilen;
    const avgMajorSpacing = numMajorIndices > 1 ? Math.round((last2 - first) / (numMajorIndices - 1)) : null;
    skip(ticks, newTicks, spacing2, isNullOrUndef(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
    for (i = 0, ilen = numMajorIndices - 1; i < ilen; i++) {
      skip(ticks, newTicks, spacing2, majorIndices[i], majorIndices[i + 1]);
    }
    skip(ticks, newTicks, spacing2, last2, isNullOrUndef(avgMajorSpacing) ? ticks.length : last2 + avgMajorSpacing);
    return newTicks;
  }
  skip(ticks, newTicks, spacing2);
  return newTicks;
}
function determineMaxTicks(scale2) {
  const offset2 = scale2.options.offset;
  const tickLength = scale2._tickSize();
  const maxScale = scale2._length / tickLength + (offset2 ? 0 : 1);
  const maxChart = scale2._maxLength / tickLength;
  return Math.floor(Math.min(maxScale, maxChart));
}
function calculateSpacing(majorIndices, ticks, ticksLimit) {
  const evenMajorSpacing = getEvenSpacing(majorIndices);
  const spacing2 = ticks.length / ticksLimit;
  if (!evenMajorSpacing) {
    return Math.max(spacing2, 1);
  }
  const factors = _factorize(evenMajorSpacing);
  for (let i = 0, ilen = factors.length - 1; i < ilen; i++) {
    const factor = factors[i];
    if (factor > spacing2) {
      return factor;
    }
  }
  return Math.max(spacing2, 1);
}
function getMajorIndices(ticks) {
  const result = [];
  let i, ilen;
  for (i = 0, ilen = ticks.length; i < ilen; i++) {
    if (ticks[i].major) {
      result.push(i);
    }
  }
  return result;
}
function skipMajors(ticks, newTicks, majorIndices, spacing2) {
  let count = 0;
  let next2 = majorIndices[0];
  let i;
  spacing2 = Math.ceil(spacing2);
  for (i = 0; i < ticks.length; i++) {
    if (i === next2) {
      newTicks.push(ticks[i]);
      count++;
      next2 = majorIndices[count * spacing2];
    }
  }
}
function skip(ticks, newTicks, spacing2, majorStart, majorEnd) {
  const start = valueOrDefault(majorStart, 0);
  const end = Math.min(valueOrDefault(majorEnd, ticks.length), ticks.length);
  let count = 0;
  let length2, i, next2;
  spacing2 = Math.ceil(spacing2);
  if (majorEnd) {
    length2 = majorEnd - majorStart;
    spacing2 = length2 / Math.floor(length2 / spacing2);
  }
  next2 = start;
  while (next2 < 0) {
    count++;
    next2 = Math.round(start + count * spacing2);
  }
  for (i = Math.max(start, 0); i < end; i++) {
    if (i === next2) {
      newTicks.push(ticks[i]);
      count++;
      next2 = Math.round(start + count * spacing2);
    }
  }
}
function getEvenSpacing(arr) {
  const len = arr.length;
  let i, diff2;
  if (len < 2) {
    return false;
  }
  for (diff2 = arr[0], i = 1; i < len; ++i) {
    if (arr[i] - arr[i - 1] !== diff2) {
      return false;
    }
  }
  return diff2;
}
const reverseAlign = (align) => align === "left" ? "right" : align === "right" ? "left" : align;
const offsetFromEdge = (scale2, edge, offset2) => edge === "top" || edge === "left" ? scale2[edge] + offset2 : scale2[edge] - offset2;
const getTicksLimit = (ticksLength, maxTicksLimit) => Math.min(maxTicksLimit || ticksLength, ticksLength);
function sample(arr, numItems) {
  const result = [];
  const increment = arr.length / numItems;
  const len = arr.length;
  let i = 0;
  for (; i < len; i += increment) {
    result.push(arr[Math.floor(i)]);
  }
  return result;
}
function getPixelForGridLine(scale2, index2, offsetGridLines) {
  const length2 = scale2.ticks.length;
  const validIndex2 = Math.min(index2, length2 - 1);
  const start = scale2._startPixel;
  const end = scale2._endPixel;
  const epsilon = 1e-6;
  let lineValue = scale2.getPixelForTick(validIndex2);
  let offset2;
  if (offsetGridLines) {
    if (length2 === 1) {
      offset2 = Math.max(lineValue - start, end - lineValue);
    } else if (index2 === 0) {
      offset2 = (scale2.getPixelForTick(1) - lineValue) / 2;
    } else {
      offset2 = (lineValue - scale2.getPixelForTick(validIndex2 - 1)) / 2;
    }
    lineValue += validIndex2 < index2 ? offset2 : -offset2;
    if (lineValue < start - epsilon || lineValue > end + epsilon) {
      return;
    }
  }
  return lineValue;
}
function garbageCollect(caches, length2) {
  each$1(caches, (cache) => {
    const gc = cache.gc;
    const gcLen = gc.length / 2;
    let i;
    if (gcLen > length2) {
      for (i = 0; i < gcLen; ++i) {
        delete cache.data[gc[i]];
      }
      gc.splice(0, gcLen);
    }
  });
}
function getTickMarkLength(options2) {
  return options2.drawTicks ? options2.tickLength : 0;
}
function getTitleHeight(options2, fallback) {
  if (!options2.display) {
    return 0;
  }
  const font = toFont(options2.font, fallback);
  const padding = toPadding(options2.padding);
  const lines = isArray$1(options2.text) ? options2.text.length : 1;
  return lines * font.lineHeight + padding.height;
}
function createScaleContext(parent, scale2) {
  return createContext(parent, {
    scale: scale2,
    type: "scale"
  });
}
function createTickContext(parent, index2, tick) {
  return createContext(parent, {
    tick,
    index: index2,
    type: "tick"
  });
}
function titleAlign(align, position2, reverse) {
  let ret = _toLeftRightCenter(align);
  if (reverse && position2 !== "right" || !reverse && position2 === "right") {
    ret = reverseAlign(ret);
  }
  return ret;
}
function titleArgs(scale2, offset2, position2, align) {
  const { top, left, bottom, right, chart } = scale2;
  const { chartArea, scales: scales2 } = chart;
  let rotation = 0;
  let maxWidth, titleX, titleY;
  const height2 = bottom - top;
  const width = right - left;
  if (scale2.isHorizontal()) {
    titleX = _alignStartEnd(align, left, right);
    if (isObject(position2)) {
      const positionAxisID = Object.keys(position2)[0];
      const value = position2[positionAxisID];
      titleY = scales2[positionAxisID].getPixelForValue(value) + height2 - offset2;
    } else if (position2 === "center") {
      titleY = (chartArea.bottom + chartArea.top) / 2 + height2 - offset2;
    } else {
      titleY = offsetFromEdge(scale2, position2, offset2);
    }
    maxWidth = right - left;
  } else {
    if (isObject(position2)) {
      const positionAxisID = Object.keys(position2)[0];
      const value = position2[positionAxisID];
      titleX = scales2[positionAxisID].getPixelForValue(value) - width + offset2;
    } else if (position2 === "center") {
      titleX = (chartArea.left + chartArea.right) / 2 - width + offset2;
    } else {
      titleX = offsetFromEdge(scale2, position2, offset2);
    }
    titleY = _alignStartEnd(align, bottom, top);
    rotation = position2 === "left" ? -HALF_PI : HALF_PI;
  }
  return {
    titleX,
    titleY,
    maxWidth,
    rotation
  };
}
class Scale extends Element$1 {
  constructor(cfg) {
    super();
    this.id = cfg.id;
    this.type = cfg.type;
    this.options = void 0;
    this.ctx = cfg.ctx;
    this.chart = cfg.chart;
    this.top = void 0;
    this.bottom = void 0;
    this.left = void 0;
    this.right = void 0;
    this.width = void 0;
    this.height = void 0;
    this._margins = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    };
    this.maxWidth = void 0;
    this.maxHeight = void 0;
    this.paddingTop = void 0;
    this.paddingBottom = void 0;
    this.paddingLeft = void 0;
    this.paddingRight = void 0;
    this.axis = void 0;
    this.labelRotation = void 0;
    this.min = void 0;
    this.max = void 0;
    this._range = void 0;
    this.ticks = [];
    this._gridLineItems = null;
    this._labelItems = null;
    this._labelSizes = null;
    this._length = 0;
    this._maxLength = 0;
    this._longestTextCache = {};
    this._startPixel = void 0;
    this._endPixel = void 0;
    this._reversePixels = false;
    this._userMax = void 0;
    this._userMin = void 0;
    this._suggestedMax = void 0;
    this._suggestedMin = void 0;
    this._ticksLength = 0;
    this._borderValue = 0;
    this._cache = {};
    this._dataLimitsCached = false;
    this.$context = void 0;
  }
  init(options2) {
    this.options = options2.setContext(this.getContext());
    this.axis = options2.axis;
    this._userMin = this.parse(options2.min);
    this._userMax = this.parse(options2.max);
    this._suggestedMin = this.parse(options2.suggestedMin);
    this._suggestedMax = this.parse(options2.suggestedMax);
  }
  parse(raw, index2) {
    return raw;
  }
  getUserBounds() {
    let { _userMin, _userMax, _suggestedMin, _suggestedMax } = this;
    _userMin = finiteOrDefault(_userMin, Number.POSITIVE_INFINITY);
    _userMax = finiteOrDefault(_userMax, Number.NEGATIVE_INFINITY);
    _suggestedMin = finiteOrDefault(_suggestedMin, Number.POSITIVE_INFINITY);
    _suggestedMax = finiteOrDefault(_suggestedMax, Number.NEGATIVE_INFINITY);
    return {
      min: finiteOrDefault(_userMin, _suggestedMin),
      max: finiteOrDefault(_userMax, _suggestedMax),
      minDefined: isNumberFinite(_userMin),
      maxDefined: isNumberFinite(_userMax)
    };
  }
  getMinMax(canStack) {
    let { min: min2, max: max2, minDefined, maxDefined } = this.getUserBounds();
    let range2;
    if (minDefined && maxDefined) {
      return {
        min: min2,
        max: max2
      };
    }
    const metas = this.getMatchingVisibleMetas();
    for (let i = 0, ilen = metas.length; i < ilen; ++i) {
      range2 = metas[i].controller.getMinMax(this, canStack);
      if (!minDefined) {
        min2 = Math.min(min2, range2.min);
      }
      if (!maxDefined) {
        max2 = Math.max(max2, range2.max);
      }
    }
    min2 = maxDefined && min2 > max2 ? max2 : min2;
    max2 = minDefined && min2 > max2 ? min2 : max2;
    return {
      min: finiteOrDefault(min2, finiteOrDefault(max2, min2)),
      max: finiteOrDefault(max2, finiteOrDefault(min2, max2))
    };
  }
  getPadding() {
    return {
      left: this.paddingLeft || 0,
      top: this.paddingTop || 0,
      right: this.paddingRight || 0,
      bottom: this.paddingBottom || 0
    };
  }
  getTicks() {
    return this.ticks;
  }
  getLabels() {
    const data2 = this.chart.data;
    return this.options.labels || (this.isHorizontal() ? data2.xLabels : data2.yLabels) || data2.labels || [];
  }
  getLabelItems(chartArea = this.chart.chartArea) {
    const items = this._labelItems || (this._labelItems = this._computeLabelItems(chartArea));
    return items;
  }
  beforeLayout() {
    this._cache = {};
    this._dataLimitsCached = false;
  }
  beforeUpdate() {
    callback(this.options.beforeUpdate, [
      this
    ]);
  }
  update(maxWidth, maxHeight, margins) {
    const { beginAtZero, grace, ticks: tickOpts } = this.options;
    const sampleSize = tickOpts.sampleSize;
    this.beforeUpdate();
    this.maxWidth = maxWidth;
    this.maxHeight = maxHeight;
    this._margins = margins = Object.assign({
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, margins);
    this.ticks = null;
    this._labelSizes = null;
    this._gridLineItems = null;
    this._labelItems = null;
    this.beforeSetDimensions();
    this.setDimensions();
    this.afterSetDimensions();
    this._maxLength = this.isHorizontal() ? this.width + margins.left + margins.right : this.height + margins.top + margins.bottom;
    if (!this._dataLimitsCached) {
      this.beforeDataLimits();
      this.determineDataLimits();
      this.afterDataLimits();
      this._range = _addGrace(this, grace, beginAtZero);
      this._dataLimitsCached = true;
    }
    this.beforeBuildTicks();
    this.ticks = this.buildTicks() || [];
    this.afterBuildTicks();
    const samplingEnabled = sampleSize < this.ticks.length;
    this._convertTicksToLabels(samplingEnabled ? sample(this.ticks, sampleSize) : this.ticks);
    this.configure();
    this.beforeCalculateLabelRotation();
    this.calculateLabelRotation();
    this.afterCalculateLabelRotation();
    if (tickOpts.display && (tickOpts.autoSkip || tickOpts.source === "auto")) {
      this.ticks = autoSkip(this, this.ticks);
      this._labelSizes = null;
      this.afterAutoSkip();
    }
    if (samplingEnabled) {
      this._convertTicksToLabels(this.ticks);
    }
    this.beforeFit();
    this.fit();
    this.afterFit();
    this.afterUpdate();
  }
  configure() {
    let reversePixels = this.options.reverse;
    let startPixel, endPixel;
    if (this.isHorizontal()) {
      startPixel = this.left;
      endPixel = this.right;
    } else {
      startPixel = this.top;
      endPixel = this.bottom;
      reversePixels = !reversePixels;
    }
    this._startPixel = startPixel;
    this._endPixel = endPixel;
    this._reversePixels = reversePixels;
    this._length = endPixel - startPixel;
    this._alignToPixels = this.options.alignToPixels;
  }
  afterUpdate() {
    callback(this.options.afterUpdate, [
      this
    ]);
  }
  beforeSetDimensions() {
    callback(this.options.beforeSetDimensions, [
      this
    ]);
  }
  setDimensions() {
    if (this.isHorizontal()) {
      this.width = this.maxWidth;
      this.left = 0;
      this.right = this.width;
    } else {
      this.height = this.maxHeight;
      this.top = 0;
      this.bottom = this.height;
    }
    this.paddingLeft = 0;
    this.paddingTop = 0;
    this.paddingRight = 0;
    this.paddingBottom = 0;
  }
  afterSetDimensions() {
    callback(this.options.afterSetDimensions, [
      this
    ]);
  }
  _callHooks(name) {
    this.chart.notifyPlugins(name, this.getContext());
    callback(this.options[name], [
      this
    ]);
  }
  beforeDataLimits() {
    this._callHooks("beforeDataLimits");
  }
  determineDataLimits() {
  }
  afterDataLimits() {
    this._callHooks("afterDataLimits");
  }
  beforeBuildTicks() {
    this._callHooks("beforeBuildTicks");
  }
  buildTicks() {
    return [];
  }
  afterBuildTicks() {
    this._callHooks("afterBuildTicks");
  }
  beforeTickToLabelConversion() {
    callback(this.options.beforeTickToLabelConversion, [
      this
    ]);
  }
  generateTickLabels(ticks) {
    const tickOpts = this.options.ticks;
    let i, ilen, tick;
    for (i = 0, ilen = ticks.length; i < ilen; i++) {
      tick = ticks[i];
      tick.label = callback(tickOpts.callback, [
        tick.value,
        i,
        ticks
      ], this);
    }
  }
  afterTickToLabelConversion() {
    callback(this.options.afterTickToLabelConversion, [
      this
    ]);
  }
  beforeCalculateLabelRotation() {
    callback(this.options.beforeCalculateLabelRotation, [
      this
    ]);
  }
  calculateLabelRotation() {
    const options2 = this.options;
    const tickOpts = options2.ticks;
    const numTicks = getTicksLimit(this.ticks.length, options2.ticks.maxTicksLimit);
    const minRotation = tickOpts.minRotation || 0;
    const maxRotation = tickOpts.maxRotation;
    let labelRotation = minRotation;
    let tickWidth, maxHeight, maxLabelDiagonal;
    if (!this._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !this.isHorizontal()) {
      this.labelRotation = minRotation;
      return;
    }
    const labelSizes = this._getLabelSizes();
    const maxLabelWidth = labelSizes.widest.width;
    const maxLabelHeight = labelSizes.highest.height;
    const maxWidth = _limitValue(this.chart.width - maxLabelWidth, 0, this.maxWidth);
    tickWidth = options2.offset ? this.maxWidth / numTicks : maxWidth / (numTicks - 1);
    if (maxLabelWidth + 6 > tickWidth) {
      tickWidth = maxWidth / (numTicks - (options2.offset ? 0.5 : 1));
      maxHeight = this.maxHeight - getTickMarkLength(options2.grid) - tickOpts.padding - getTitleHeight(options2.title, this.chart.options.font);
      maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
      labelRotation = toDegrees(Math.min(Math.asin(_limitValue((labelSizes.highest.height + 6) / tickWidth, -1, 1)), Math.asin(_limitValue(maxHeight / maxLabelDiagonal, -1, 1)) - Math.asin(_limitValue(maxLabelHeight / maxLabelDiagonal, -1, 1))));
      labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
    }
    this.labelRotation = labelRotation;
  }
  afterCalculateLabelRotation() {
    callback(this.options.afterCalculateLabelRotation, [
      this
    ]);
  }
  afterAutoSkip() {
  }
  beforeFit() {
    callback(this.options.beforeFit, [
      this
    ]);
  }
  fit() {
    const minSize = {
      width: 0,
      height: 0
    };
    const { chart, options: { ticks: tickOpts, title: titleOpts, grid: gridOpts } } = this;
    const display2 = this._isVisible();
    const isHorizontal = this.isHorizontal();
    if (display2) {
      const titleHeight = getTitleHeight(titleOpts, chart.options.font);
      if (isHorizontal) {
        minSize.width = this.maxWidth;
        minSize.height = getTickMarkLength(gridOpts) + titleHeight;
      } else {
        minSize.height = this.maxHeight;
        minSize.width = getTickMarkLength(gridOpts) + titleHeight;
      }
      if (tickOpts.display && this.ticks.length) {
        const { first, last: last2, widest, highest } = this._getLabelSizes();
        const tickPadding = tickOpts.padding * 2;
        const angleRadians = toRadians(this.labelRotation);
        const cos = Math.cos(angleRadians);
        const sin = Math.sin(angleRadians);
        if (isHorizontal) {
          const labelHeight = tickOpts.mirror ? 0 : sin * widest.width + cos * highest.height;
          minSize.height = Math.min(this.maxHeight, minSize.height + labelHeight + tickPadding);
        } else {
          const labelWidth = tickOpts.mirror ? 0 : cos * widest.width + sin * highest.height;
          minSize.width = Math.min(this.maxWidth, minSize.width + labelWidth + tickPadding);
        }
        this._calculatePadding(first, last2, sin, cos);
      }
    }
    this._handleMargins();
    if (isHorizontal) {
      this.width = this._length = chart.width - this._margins.left - this._margins.right;
      this.height = minSize.height;
    } else {
      this.width = minSize.width;
      this.height = this._length = chart.height - this._margins.top - this._margins.bottom;
    }
  }
  _calculatePadding(first, last2, sin, cos) {
    const { ticks: { align, padding }, position: position2 } = this.options;
    const isRotated = this.labelRotation !== 0;
    const labelsBelowTicks = position2 !== "top" && this.axis === "x";
    if (this.isHorizontal()) {
      const offsetLeft = this.getPixelForTick(0) - this.left;
      const offsetRight = this.right - this.getPixelForTick(this.ticks.length - 1);
      let paddingLeft = 0;
      let paddingRight = 0;
      if (isRotated) {
        if (labelsBelowTicks) {
          paddingLeft = cos * first.width;
          paddingRight = sin * last2.height;
        } else {
          paddingLeft = sin * first.height;
          paddingRight = cos * last2.width;
        }
      } else if (align === "start") {
        paddingRight = last2.width;
      } else if (align === "end") {
        paddingLeft = first.width;
      } else if (align !== "inner") {
        paddingLeft = first.width / 2;
        paddingRight = last2.width / 2;
      }
      this.paddingLeft = Math.max((paddingLeft - offsetLeft + padding) * this.width / (this.width - offsetLeft), 0);
      this.paddingRight = Math.max((paddingRight - offsetRight + padding) * this.width / (this.width - offsetRight), 0);
    } else {
      let paddingTop = last2.height / 2;
      let paddingBottom = first.height / 2;
      if (align === "start") {
        paddingTop = 0;
        paddingBottom = first.height;
      } else if (align === "end") {
        paddingTop = last2.height;
        paddingBottom = 0;
      }
      this.paddingTop = paddingTop + padding;
      this.paddingBottom = paddingBottom + padding;
    }
  }
  _handleMargins() {
    if (this._margins) {
      this._margins.left = Math.max(this.paddingLeft, this._margins.left);
      this._margins.top = Math.max(this.paddingTop, this._margins.top);
      this._margins.right = Math.max(this.paddingRight, this._margins.right);
      this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom);
    }
  }
  afterFit() {
    callback(this.options.afterFit, [
      this
    ]);
  }
  isHorizontal() {
    const { axis, position: position2 } = this.options;
    return position2 === "top" || position2 === "bottom" || axis === "x";
  }
  isFullSize() {
    return this.options.fullSize;
  }
  _convertTicksToLabels(ticks) {
    this.beforeTickToLabelConversion();
    this.generateTickLabels(ticks);
    let i, ilen;
    for (i = 0, ilen = ticks.length; i < ilen; i++) {
      if (isNullOrUndef(ticks[i].label)) {
        ticks.splice(i, 1);
        ilen--;
        i--;
      }
    }
    this.afterTickToLabelConversion();
  }
  _getLabelSizes() {
    let labelSizes = this._labelSizes;
    if (!labelSizes) {
      const sampleSize = this.options.ticks.sampleSize;
      let ticks = this.ticks;
      if (sampleSize < ticks.length) {
        ticks = sample(ticks, sampleSize);
      }
      this._labelSizes = labelSizes = this._computeLabelSizes(ticks, ticks.length, this.options.ticks.maxTicksLimit);
    }
    return labelSizes;
  }
  _computeLabelSizes(ticks, length2, maxTicksLimit) {
    const { ctx, _longestTextCache: caches } = this;
    const widths = [];
    const heights = [];
    const increment = Math.floor(length2 / getTicksLimit(length2, maxTicksLimit));
    let widestLabelSize = 0;
    let highestLabelSize = 0;
    let i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height2, nestedLabel;
    for (i = 0; i < length2; i += increment) {
      label = ticks[i].label;
      tickFont = this._resolveTickFontOptions(i);
      ctx.font = fontString = tickFont.string;
      cache = caches[fontString] = caches[fontString] || {
        data: {},
        gc: []
      };
      lineHeight = tickFont.lineHeight;
      width = height2 = 0;
      if (!isNullOrUndef(label) && !isArray$1(label)) {
        width = _measureText(ctx, cache.data, cache.gc, width, label);
        height2 = lineHeight;
      } else if (isArray$1(label)) {
        for (j = 0, jlen = label.length; j < jlen; ++j) {
          nestedLabel = label[j];
          if (!isNullOrUndef(nestedLabel) && !isArray$1(nestedLabel)) {
            width = _measureText(ctx, cache.data, cache.gc, width, nestedLabel);
            height2 += lineHeight;
          }
        }
      }
      widths.push(width);
      heights.push(height2);
      widestLabelSize = Math.max(width, widestLabelSize);
      highestLabelSize = Math.max(height2, highestLabelSize);
    }
    garbageCollect(caches, length2);
    const widest = widths.indexOf(widestLabelSize);
    const highest = heights.indexOf(highestLabelSize);
    const valueAt = (idx) => ({
      width: widths[idx] || 0,
      height: heights[idx] || 0
    });
    return {
      first: valueAt(0),
      last: valueAt(length2 - 1),
      widest: valueAt(widest),
      highest: valueAt(highest),
      widths,
      heights
    };
  }
  getLabelForValue(value) {
    return value;
  }
  getPixelForValue(value, index2) {
    return NaN;
  }
  getValueForPixel(pixel) {
  }
  getPixelForTick(index2) {
    const ticks = this.ticks;
    if (index2 < 0 || index2 > ticks.length - 1) {
      return null;
    }
    return this.getPixelForValue(ticks[index2].value);
  }
  getPixelForDecimal(decimal) {
    if (this._reversePixels) {
      decimal = 1 - decimal;
    }
    const pixel = this._startPixel + decimal * this._length;
    return _int16Range(this._alignToPixels ? _alignPixel(this.chart, pixel, 0) : pixel);
  }
  getDecimalForPixel(pixel) {
    const decimal = (pixel - this._startPixel) / this._length;
    return this._reversePixels ? 1 - decimal : decimal;
  }
  getBasePixel() {
    return this.getPixelForValue(this.getBaseValue());
  }
  getBaseValue() {
    const { min: min2, max: max2 } = this;
    return min2 < 0 && max2 < 0 ? max2 : min2 > 0 && max2 > 0 ? min2 : 0;
  }
  getContext(index2) {
    const ticks = this.ticks || [];
    if (index2 >= 0 && index2 < ticks.length) {
      const tick = ticks[index2];
      return tick.$context || (tick.$context = createTickContext(this.getContext(), index2, tick));
    }
    return this.$context || (this.$context = createScaleContext(this.chart.getContext(), this));
  }
  _tickSize() {
    const optionTicks = this.options.ticks;
    const rot = toRadians(this.labelRotation);
    const cos = Math.abs(Math.cos(rot));
    const sin = Math.abs(Math.sin(rot));
    const labelSizes = this._getLabelSizes();
    const padding = optionTicks.autoSkipPadding || 0;
    const w2 = labelSizes ? labelSizes.widest.width + padding : 0;
    const h3 = labelSizes ? labelSizes.highest.height + padding : 0;
    return this.isHorizontal() ? h3 * cos > w2 * sin ? w2 / cos : h3 / sin : h3 * sin < w2 * cos ? h3 / cos : w2 / sin;
  }
  _isVisible() {
    const display2 = this.options.display;
    if (display2 !== "auto") {
      return !!display2;
    }
    return this.getMatchingVisibleMetas().length > 0;
  }
  _computeGridLineItems(chartArea) {
    const axis = this.axis;
    const chart = this.chart;
    const options2 = this.options;
    const { grid, position: position2, border } = options2;
    const offset2 = grid.offset;
    const isHorizontal = this.isHorizontal();
    const ticks = this.ticks;
    const ticksLength = ticks.length + (offset2 ? 1 : 0);
    const tl = getTickMarkLength(grid);
    const items = [];
    const borderOpts = border.setContext(this.getContext());
    const axisWidth = borderOpts.display ? borderOpts.width : 0;
    const axisHalfWidth = axisWidth / 2;
    const alignBorderValue = function(pixel) {
      return _alignPixel(chart, pixel, axisWidth);
    };
    let borderValue, i, lineValue, alignedLineValue;
    let tx1, ty1, tx2, ty2, x1, y1, x2, y2;
    if (position2 === "top") {
      borderValue = alignBorderValue(this.bottom);
      ty1 = this.bottom - tl;
      ty2 = borderValue - axisHalfWidth;
      y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
      y2 = chartArea.bottom;
    } else if (position2 === "bottom") {
      borderValue = alignBorderValue(this.top);
      y1 = chartArea.top;
      y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
      ty1 = borderValue + axisHalfWidth;
      ty2 = this.top + tl;
    } else if (position2 === "left") {
      borderValue = alignBorderValue(this.right);
      tx1 = this.right - tl;
      tx2 = borderValue - axisHalfWidth;
      x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
      x2 = chartArea.right;
    } else if (position2 === "right") {
      borderValue = alignBorderValue(this.left);
      x1 = chartArea.left;
      x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
      tx1 = borderValue + axisHalfWidth;
      tx2 = this.left + tl;
    } else if (axis === "x") {
      if (position2 === "center") {
        borderValue = alignBorderValue((chartArea.top + chartArea.bottom) / 2 + 0.5);
      } else if (isObject(position2)) {
        const positionAxisID = Object.keys(position2)[0];
        const value = position2[positionAxisID];
        borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
      }
      y1 = chartArea.top;
      y2 = chartArea.bottom;
      ty1 = borderValue + axisHalfWidth;
      ty2 = ty1 + tl;
    } else if (axis === "y") {
      if (position2 === "center") {
        borderValue = alignBorderValue((chartArea.left + chartArea.right) / 2);
      } else if (isObject(position2)) {
        const positionAxisID = Object.keys(position2)[0];
        const value = position2[positionAxisID];
        borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
      }
      tx1 = borderValue - axisHalfWidth;
      tx2 = tx1 - tl;
      x1 = chartArea.left;
      x2 = chartArea.right;
    }
    const limit = valueOrDefault(options2.ticks.maxTicksLimit, ticksLength);
    const step = Math.max(1, Math.ceil(ticksLength / limit));
    for (i = 0; i < ticksLength; i += step) {
      const context = this.getContext(i);
      const optsAtIndex = grid.setContext(context);
      const optsAtIndexBorder = border.setContext(context);
      const lineWidth = optsAtIndex.lineWidth;
      const lineColor = optsAtIndex.color;
      const borderDash = optsAtIndexBorder.dash || [];
      const borderDashOffset = optsAtIndexBorder.dashOffset;
      const tickWidth = optsAtIndex.tickWidth;
      const tickColor = optsAtIndex.tickColor;
      const tickBorderDash = optsAtIndex.tickBorderDash || [];
      const tickBorderDashOffset = optsAtIndex.tickBorderDashOffset;
      lineValue = getPixelForGridLine(this, i, offset2);
      if (lineValue === void 0) {
        continue;
      }
      alignedLineValue = _alignPixel(chart, lineValue, lineWidth);
      if (isHorizontal) {
        tx1 = tx2 = x1 = x2 = alignedLineValue;
      } else {
        ty1 = ty2 = y1 = y2 = alignedLineValue;
      }
      items.push({
        tx1,
        ty1,
        tx2,
        ty2,
        x1,
        y1,
        x2,
        y2,
        width: lineWidth,
        color: lineColor,
        borderDash,
        borderDashOffset,
        tickWidth,
        tickColor,
        tickBorderDash,
        tickBorderDashOffset
      });
    }
    this._ticksLength = ticksLength;
    this._borderValue = borderValue;
    return items;
  }
  _computeLabelItems(chartArea) {
    const axis = this.axis;
    const options2 = this.options;
    const { position: position2, ticks: optionTicks } = options2;
    const isHorizontal = this.isHorizontal();
    const ticks = this.ticks;
    const { align, crossAlign, padding, mirror } = optionTicks;
    const tl = getTickMarkLength(options2.grid);
    const tickAndPadding = tl + padding;
    const hTickAndPadding = mirror ? -padding : tickAndPadding;
    const rotation = -toRadians(this.labelRotation);
    const items = [];
    let i, ilen, tick, label, x2, y2, textAlign, pixel, font, lineHeight, lineCount, textOffset;
    let textBaseline = "middle";
    if (position2 === "top") {
      y2 = this.bottom - hTickAndPadding;
      textAlign = this._getXAxisLabelAlignment();
    } else if (position2 === "bottom") {
      y2 = this.top + hTickAndPadding;
      textAlign = this._getXAxisLabelAlignment();
    } else if (position2 === "left") {
      const ret = this._getYAxisLabelAlignment(tl);
      textAlign = ret.textAlign;
      x2 = ret.x;
    } else if (position2 === "right") {
      const ret = this._getYAxisLabelAlignment(tl);
      textAlign = ret.textAlign;
      x2 = ret.x;
    } else if (axis === "x") {
      if (position2 === "center") {
        y2 = (chartArea.top + chartArea.bottom) / 2 + tickAndPadding;
      } else if (isObject(position2)) {
        const positionAxisID = Object.keys(position2)[0];
        const value = position2[positionAxisID];
        y2 = this.chart.scales[positionAxisID].getPixelForValue(value) + tickAndPadding;
      }
      textAlign = this._getXAxisLabelAlignment();
    } else if (axis === "y") {
      if (position2 === "center") {
        x2 = (chartArea.left + chartArea.right) / 2 - tickAndPadding;
      } else if (isObject(position2)) {
        const positionAxisID = Object.keys(position2)[0];
        const value = position2[positionAxisID];
        x2 = this.chart.scales[positionAxisID].getPixelForValue(value);
      }
      textAlign = this._getYAxisLabelAlignment(tl).textAlign;
    }
    if (axis === "y") {
      if (align === "start") {
        textBaseline = "top";
      } else if (align === "end") {
        textBaseline = "bottom";
      }
    }
    const labelSizes = this._getLabelSizes();
    for (i = 0, ilen = ticks.length; i < ilen; ++i) {
      tick = ticks[i];
      label = tick.label;
      const optsAtIndex = optionTicks.setContext(this.getContext(i));
      pixel = this.getPixelForTick(i) + optionTicks.labelOffset;
      font = this._resolveTickFontOptions(i);
      lineHeight = font.lineHeight;
      lineCount = isArray$1(label) ? label.length : 1;
      const halfCount = lineCount / 2;
      const color2 = optsAtIndex.color;
      const strokeColor = optsAtIndex.textStrokeColor;
      const strokeWidth = optsAtIndex.textStrokeWidth;
      let tickTextAlign = textAlign;
      if (isHorizontal) {
        x2 = pixel;
        if (textAlign === "inner") {
          if (i === ilen - 1) {
            tickTextAlign = !this.options.reverse ? "right" : "left";
          } else if (i === 0) {
            tickTextAlign = !this.options.reverse ? "left" : "right";
          } else {
            tickTextAlign = "center";
          }
        }
        if (position2 === "top") {
          if (crossAlign === "near" || rotation !== 0) {
            textOffset = -lineCount * lineHeight + lineHeight / 2;
          } else if (crossAlign === "center") {
            textOffset = -labelSizes.highest.height / 2 - halfCount * lineHeight + lineHeight;
          } else {
            textOffset = -labelSizes.highest.height + lineHeight / 2;
          }
        } else {
          if (crossAlign === "near" || rotation !== 0) {
            textOffset = lineHeight / 2;
          } else if (crossAlign === "center") {
            textOffset = labelSizes.highest.height / 2 - halfCount * lineHeight;
          } else {
            textOffset = labelSizes.highest.height - lineCount * lineHeight;
          }
        }
        if (mirror) {
          textOffset *= -1;
        }
        if (rotation !== 0 && !optsAtIndex.showLabelBackdrop) {
          x2 += lineHeight / 2 * Math.sin(rotation);
        }
      } else {
        y2 = pixel;
        textOffset = (1 - lineCount) * lineHeight / 2;
      }
      let backdrop2;
      if (optsAtIndex.showLabelBackdrop) {
        const labelPadding = toPadding(optsAtIndex.backdropPadding);
        const height2 = labelSizes.heights[i];
        const width = labelSizes.widths[i];
        let top = textOffset - labelPadding.top;
        let left = 0 - labelPadding.left;
        switch (textBaseline) {
          case "middle":
            top -= height2 / 2;
            break;
          case "bottom":
            top -= height2;
            break;
        }
        switch (textAlign) {
          case "center":
            left -= width / 2;
            break;
          case "right":
            left -= width;
            break;
          case "inner":
            if (i === ilen - 1) {
              left -= width;
            } else if (i > 0) {
              left -= width / 2;
            }
            break;
        }
        backdrop2 = {
          left,
          top,
          width: width + labelPadding.width,
          height: height2 + labelPadding.height,
          color: optsAtIndex.backdropColor
        };
      }
      items.push({
        label,
        font,
        textOffset,
        options: {
          rotation,
          color: color2,
          strokeColor,
          strokeWidth,
          textAlign: tickTextAlign,
          textBaseline,
          translation: [
            x2,
            y2
          ],
          backdrop: backdrop2
        }
      });
    }
    return items;
  }
  _getXAxisLabelAlignment() {
    const { position: position2, ticks } = this.options;
    const rotation = -toRadians(this.labelRotation);
    if (rotation) {
      return position2 === "top" ? "left" : "right";
    }
    let align = "center";
    if (ticks.align === "start") {
      align = "left";
    } else if (ticks.align === "end") {
      align = "right";
    } else if (ticks.align === "inner") {
      align = "inner";
    }
    return align;
  }
  _getYAxisLabelAlignment(tl) {
    const { position: position2, ticks: { crossAlign, mirror, padding } } = this.options;
    const labelSizes = this._getLabelSizes();
    const tickAndPadding = tl + padding;
    const widest = labelSizes.widest.width;
    let textAlign;
    let x2;
    if (position2 === "left") {
      if (mirror) {
        x2 = this.right + padding;
        if (crossAlign === "near") {
          textAlign = "left";
        } else if (crossAlign === "center") {
          textAlign = "center";
          x2 += widest / 2;
        } else {
          textAlign = "right";
          x2 += widest;
        }
      } else {
        x2 = this.right - tickAndPadding;
        if (crossAlign === "near") {
          textAlign = "right";
        } else if (crossAlign === "center") {
          textAlign = "center";
          x2 -= widest / 2;
        } else {
          textAlign = "left";
          x2 = this.left;
        }
      }
    } else if (position2 === "right") {
      if (mirror) {
        x2 = this.left + padding;
        if (crossAlign === "near") {
          textAlign = "right";
        } else if (crossAlign === "center") {
          textAlign = "center";
          x2 -= widest / 2;
        } else {
          textAlign = "left";
          x2 -= widest;
        }
      } else {
        x2 = this.left + tickAndPadding;
        if (crossAlign === "near") {
          textAlign = "left";
        } else if (crossAlign === "center") {
          textAlign = "center";
          x2 += widest / 2;
        } else {
          textAlign = "right";
          x2 = this.right;
        }
      }
    } else {
      textAlign = "right";
    }
    return {
      textAlign,
      x: x2
    };
  }
  _computeLabelArea() {
    if (this.options.ticks.mirror) {
      return;
    }
    const chart = this.chart;
    const position2 = this.options.position;
    if (position2 === "left" || position2 === "right") {
      return {
        top: 0,
        left: this.left,
        bottom: chart.height,
        right: this.right
      };
    }
    if (position2 === "top" || position2 === "bottom") {
      return {
        top: this.top,
        left: 0,
        bottom: this.bottom,
        right: chart.width
      };
    }
  }
  drawBackground() {
    const { ctx, options: { backgroundColor }, left, top, width, height: height2 } = this;
    if (backgroundColor) {
      ctx.save();
      ctx.fillStyle = backgroundColor;
      ctx.fillRect(left, top, width, height2);
      ctx.restore();
    }
  }
  getLineWidthForValue(value) {
    const grid = this.options.grid;
    if (!this._isVisible() || !grid.display) {
      return 0;
    }
    const ticks = this.ticks;
    const index2 = ticks.findIndex((t2) => t2.value === value);
    if (index2 >= 0) {
      const opts = grid.setContext(this.getContext(index2));
      return opts.lineWidth;
    }
    return 0;
  }
  drawGrid(chartArea) {
    const grid = this.options.grid;
    const ctx = this.ctx;
    const items = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(chartArea));
    let i, ilen;
    const drawLine = (p1, p2, style) => {
      if (!style.width || !style.color) {
        return;
      }
      ctx.save();
      ctx.lineWidth = style.width;
      ctx.strokeStyle = style.color;
      ctx.setLineDash(style.borderDash || []);
      ctx.lineDashOffset = style.borderDashOffset;
      ctx.beginPath();
      ctx.moveTo(p1.x, p1.y);
      ctx.lineTo(p2.x, p2.y);
      ctx.stroke();
      ctx.restore();
    };
    if (grid.display) {
      for (i = 0, ilen = items.length; i < ilen; ++i) {
        const item = items[i];
        if (grid.drawOnChartArea) {
          drawLine({
            x: item.x1,
            y: item.y1
          }, {
            x: item.x2,
            y: item.y2
          }, item);
        }
        if (grid.drawTicks) {
          drawLine({
            x: item.tx1,
            y: item.ty1
          }, {
            x: item.tx2,
            y: item.ty2
          }, {
            color: item.tickColor,
            width: item.tickWidth,
            borderDash: item.tickBorderDash,
            borderDashOffset: item.tickBorderDashOffset
          });
        }
      }
    }
  }
  drawBorder() {
    const { chart, ctx, options: { border, grid } } = this;
    const borderOpts = border.setContext(this.getContext());
    const axisWidth = border.display ? borderOpts.width : 0;
    if (!axisWidth) {
      return;
    }
    const lastLineWidth = grid.setContext(this.getContext(0)).lineWidth;
    const borderValue = this._borderValue;
    let x1, x2, y1, y2;
    if (this.isHorizontal()) {
      x1 = _alignPixel(chart, this.left, axisWidth) - axisWidth / 2;
      x2 = _alignPixel(chart, this.right, lastLineWidth) + lastLineWidth / 2;
      y1 = y2 = borderValue;
    } else {
      y1 = _alignPixel(chart, this.top, axisWidth) - axisWidth / 2;
      y2 = _alignPixel(chart, this.bottom, lastLineWidth) + lastLineWidth / 2;
      x1 = x2 = borderValue;
    }
    ctx.save();
    ctx.lineWidth = borderOpts.width;
    ctx.strokeStyle = borderOpts.color;
    ctx.beginPath();
    ctx.moveTo(x1, y1);
    ctx.lineTo(x2, y2);
    ctx.stroke();
    ctx.restore();
  }
  drawLabels(chartArea) {
    const optionTicks = this.options.ticks;
    if (!optionTicks.display) {
      return;
    }
    const ctx = this.ctx;
    const area = this._computeLabelArea();
    if (area) {
      clipArea(ctx, area);
    }
    const items = this.getLabelItems(chartArea);
    for (const item of items) {
      const renderTextOptions = item.options;
      const tickFont = item.font;
      const label = item.label;
      const y2 = item.textOffset;
      renderText(ctx, label, 0, y2, tickFont, renderTextOptions);
    }
    if (area) {
      unclipArea(ctx);
    }
  }
  drawTitle() {
    const { ctx, options: { position: position2, title: title2, reverse } } = this;
    if (!title2.display) {
      return;
    }
    const font = toFont(title2.font);
    const padding = toPadding(title2.padding);
    const align = title2.align;
    let offset2 = font.lineHeight / 2;
    if (position2 === "bottom" || position2 === "center" || isObject(position2)) {
      offset2 += padding.bottom;
      if (isArray$1(title2.text)) {
        offset2 += font.lineHeight * (title2.text.length - 1);
      }
    } else {
      offset2 += padding.top;
    }
    const { titleX, titleY, maxWidth, rotation } = titleArgs(this, offset2, position2, align);
    renderText(ctx, title2.text, 0, 0, font, {
      color: title2.color,
      maxWidth,
      rotation,
      textAlign: titleAlign(align, position2, reverse),
      textBaseline: "middle",
      translation: [
        titleX,
        titleY
      ]
    });
  }
  draw(chartArea) {
    if (!this._isVisible()) {
      return;
    }
    this.drawBackground();
    this.drawGrid(chartArea);
    this.drawBorder();
    this.drawTitle();
    this.drawLabels(chartArea);
  }
  _layers() {
    const opts = this.options;
    const tz = opts.ticks && opts.ticks.z || 0;
    const gz = valueOrDefault(opts.grid && opts.grid.z, -1);
    const bz = valueOrDefault(opts.border && opts.border.z, 0);
    if (!this._isVisible() || this.draw !== Scale.prototype.draw) {
      return [
        {
          z: tz,
          draw: (chartArea) => {
            this.draw(chartArea);
          }
        }
      ];
    }
    return [
      {
        z: gz,
        draw: (chartArea) => {
          this.drawBackground();
          this.drawGrid(chartArea);
          this.drawTitle();
        }
      },
      {
        z: bz,
        draw: () => {
          this.drawBorder();
        }
      },
      {
        z: tz,
        draw: (chartArea) => {
          this.drawLabels(chartArea);
        }
      }
    ];
  }
  getMatchingVisibleMetas(type2) {
    const metas = this.chart.getSortedVisibleDatasetMetas();
    const axisID = this.axis + "AxisID";
    const result = [];
    let i, ilen;
    for (i = 0, ilen = metas.length; i < ilen; ++i) {
      const meta = metas[i];
      if (meta[axisID] === this.id && (!type2 || meta.type === type2)) {
        result.push(meta);
      }
    }
    return result;
  }
  _resolveTickFontOptions(index2) {
    const opts = this.options.ticks.setContext(this.getContext(index2));
    return toFont(opts.font);
  }
  _maxDigits() {
    const fontSize = this._resolveTickFontOptions(0).lineHeight;
    return (this.isHorizontal() ? this.width : this.height) / fontSize;
  }
}
class TypedRegistry {
  constructor(type2, scope, override) {
    this.type = type2;
    this.scope = scope;
    this.override = override;
    this.items = /* @__PURE__ */ Object.create(null);
  }
  isForType(type2) {
    return Object.prototype.isPrototypeOf.call(this.type.prototype, type2.prototype);
  }
  register(item) {
    const proto = Object.getPrototypeOf(item);
    let parentScope;
    if (isIChartComponent(proto)) {
      parentScope = this.register(proto);
    }
    const items = this.items;
    const id = item.id;
    const scope = this.scope + "." + id;
    if (!id) {
      throw new Error("class does not have id: " + item);
    }
    if (id in items) {
      return scope;
    }
    items[id] = item;
    registerDefaults(item, scope, parentScope);
    if (this.override) {
      defaults$3.override(item.id, item.overrides);
    }
    return scope;
  }
  get(id) {
    return this.items[id];
  }
  unregister(item) {
    const items = this.items;
    const id = item.id;
    const scope = this.scope;
    if (id in items) {
      delete items[id];
    }
    if (scope && id in defaults$3[scope]) {
      delete defaults$3[scope][id];
      if (this.override) {
        delete overrides[id];
      }
    }
  }
}
function registerDefaults(item, scope, parentScope) {
  const itemDefaults = merge$2(/* @__PURE__ */ Object.create(null), [
    parentScope ? defaults$3.get(parentScope) : {},
    defaults$3.get(scope),
    item.defaults
  ]);
  defaults$3.set(scope, itemDefaults);
  if (item.defaultRoutes) {
    routeDefaults(scope, item.defaultRoutes);
  }
  if (item.descriptors) {
    defaults$3.describe(scope, item.descriptors);
  }
}
function routeDefaults(scope, routes) {
  Object.keys(routes).forEach((property) => {
    const propertyParts = property.split(".");
    const sourceName = propertyParts.pop();
    const sourceScope = [
      scope
    ].concat(propertyParts).join(".");
    const parts = routes[property].split(".");
    const targetName = parts.pop();
    const targetScope = parts.join(".");
    defaults$3.route(sourceScope, sourceName, targetScope, targetName);
  });
}
function isIChartComponent(proto) {
  return "id" in proto && "defaults" in proto;
}
class Registry {
  constructor() {
    this.controllers = new TypedRegistry(DatasetController, "datasets", true);
    this.elements = new TypedRegistry(Element$1, "elements");
    this.plugins = new TypedRegistry(Object, "plugins");
    this.scales = new TypedRegistry(Scale, "scales");
    this._typedRegistries = [
      this.controllers,
      this.scales,
      this.elements
    ];
  }
  add(...args) {
    this._each("register", args);
  }
  remove(...args) {
    this._each("unregister", args);
  }
  addControllers(...args) {
    this._each("register", args, this.controllers);
  }
  addElements(...args) {
    this._each("register", args, this.elements);
  }
  addPlugins(...args) {
    this._each("register", args, this.plugins);
  }
  addScales(...args) {
    this._each("register", args, this.scales);
  }
  getController(id) {
    return this._get(id, this.controllers, "controller");
  }
  getElement(id) {
    return this._get(id, this.elements, "element");
  }
  getPlugin(id) {
    return this._get(id, this.plugins, "plugin");
  }
  getScale(id) {
    return this._get(id, this.scales, "scale");
  }
  removeControllers(...args) {
    this._each("unregister", args, this.controllers);
  }
  removeElements(...args) {
    this._each("unregister", args, this.elements);
  }
  removePlugins(...args) {
    this._each("unregister", args, this.plugins);
  }
  removeScales(...args) {
    this._each("unregister", args, this.scales);
  }
  _each(method, args, typedRegistry) {
    [
      ...args
    ].forEach((arg) => {
      const reg = typedRegistry || this._getRegistryForType(arg);
      if (typedRegistry || reg.isForType(arg) || reg === this.plugins && arg.id) {
        this._exec(method, reg, arg);
      } else {
        each$1(arg, (item) => {
          const itemReg = typedRegistry || this._getRegistryForType(item);
          this._exec(method, itemReg, item);
        });
      }
    });
  }
  _exec(method, registry2, component) {
    const camelMethod = _capitalize(method);
    callback(component["before" + camelMethod], [], component);
    registry2[method](component);
    callback(component["after" + camelMethod], [], component);
  }
  _getRegistryForType(type2) {
    for (let i = 0; i < this._typedRegistries.length; i++) {
      const reg = this._typedRegistries[i];
      if (reg.isForType(type2)) {
        return reg;
      }
    }
    return this.plugins;
  }
  _get(id, typedRegistry, type2) {
    const item = typedRegistry.get(id);
    if (item === void 0) {
      throw new Error('"' + id + '" is not a registered ' + type2 + ".");
    }
    return item;
  }
}
var registry = /* @__PURE__ */ new Registry();
class PluginService {
  constructor() {
    this._init = [];
  }
  notify(chart, hook, args, filter) {
    if (hook === "beforeInit") {
      this._init = this._createDescriptors(chart, true);
      this._notify(this._init, chart, "install");
    }
    const descriptors2 = filter ? this._descriptors(chart).filter(filter) : this._descriptors(chart);
    const result = this._notify(descriptors2, chart, hook, args);
    if (hook === "afterDestroy") {
      this._notify(descriptors2, chart, "stop");
      this._notify(this._init, chart, "uninstall");
    }
    return result;
  }
  _notify(descriptors2, chart, hook, args) {
    args = args || {};
    for (const descriptor of descriptors2) {
      const plugin2 = descriptor.plugin;
      const method = plugin2[hook];
      const params = [
        chart,
        args,
        descriptor.options
      ];
      if (callback(method, params, plugin2) === false && args.cancelable) {
        return false;
      }
    }
    return true;
  }
  invalidate() {
    if (!isNullOrUndef(this._cache)) {
      this._oldCache = this._cache;
      this._cache = void 0;
    }
  }
  _descriptors(chart) {
    if (this._cache) {
      return this._cache;
    }
    const descriptors2 = this._cache = this._createDescriptors(chart);
    this._notifyStateChanges(chart);
    return descriptors2;
  }
  _createDescriptors(chart, all) {
    const config2 = chart && chart.config;
    const options2 = valueOrDefault(config2.options && config2.options.plugins, {});
    const plugins2 = allPlugins(config2);
    return options2 === false && !all ? [] : createDescriptors(chart, plugins2, options2, all);
  }
  _notifyStateChanges(chart) {
    const previousDescriptors = this._oldCache || [];
    const descriptors2 = this._cache;
    const diff2 = (a2, b2) => a2.filter((x2) => !b2.some((y2) => x2.plugin.id === y2.plugin.id));
    this._notify(diff2(previousDescriptors, descriptors2), chart, "stop");
    this._notify(diff2(descriptors2, previousDescriptors), chart, "start");
  }
}
function allPlugins(config2) {
  const localIds = {};
  const plugins2 = [];
  const keys = Object.keys(registry.plugins.items);
  for (let i = 0; i < keys.length; i++) {
    plugins2.push(registry.getPlugin(keys[i]));
  }
  const local = config2.plugins || [];
  for (let i = 0; i < local.length; i++) {
    const plugin2 = local[i];
    if (plugins2.indexOf(plugin2) === -1) {
      plugins2.push(plugin2);
      localIds[plugin2.id] = true;
    }
  }
  return {
    plugins: plugins2,
    localIds
  };
}
function getOpts(options2, all) {
  if (!all && options2 === false) {
    return null;
  }
  if (options2 === true) {
    return {};
  }
  return options2;
}
function createDescriptors(chart, { plugins: plugins2, localIds }, options2, all) {
  const result = [];
  const context = chart.getContext();
  for (const plugin2 of plugins2) {
    const id = plugin2.id;
    const opts = getOpts(options2[id], all);
    if (opts === null) {
      continue;
    }
    result.push({
      plugin: plugin2,
      options: pluginOpts(chart.config, {
        plugin: plugin2,
        local: localIds[id]
      }, opts, context)
    });
  }
  return result;
}
function pluginOpts(config2, { plugin: plugin2, local }, opts, context) {
  const keys = config2.pluginScopeKeys(plugin2);
  const scopes = config2.getOptionScopes(opts, keys);
  if (local && plugin2.defaults) {
    scopes.push(plugin2.defaults);
  }
  return config2.createResolver(scopes, context, [
    ""
  ], {
    scriptable: false,
    indexable: false,
    allKeys: true
  });
}
function getIndexAxis(type2, options2) {
  const datasetDefaults = defaults$3.datasets[type2] || {};
  const datasetOptions = (options2.datasets || {})[type2] || {};
  return datasetOptions.indexAxis || options2.indexAxis || datasetDefaults.indexAxis || "x";
}
function getAxisFromDefaultScaleID(id, indexAxis) {
  let axis = id;
  if (id === "_index_") {
    axis = indexAxis;
  } else if (id === "_value_") {
    axis = indexAxis === "x" ? "y" : "x";
  }
  return axis;
}
function getDefaultScaleIDFromAxis(axis, indexAxis) {
  return axis === indexAxis ? "_index_" : "_value_";
}
function idMatchesAxis(id) {
  if (id === "x" || id === "y" || id === "r") {
    return id;
  }
}
function axisFromPosition(position2) {
  if (position2 === "top" || position2 === "bottom") {
    return "x";
  }
  if (position2 === "left" || position2 === "right") {
    return "y";
  }
}
function determineAxis(id, ...scaleOptions) {
  if (idMatchesAxis(id)) {
    return id;
  }
  for (const opts of scaleOptions) {
    const axis = opts.axis || axisFromPosition(opts.position) || id.length > 1 && idMatchesAxis(id[0].toLowerCase());
    if (axis) {
      return axis;
    }
  }
  throw new Error(`Cannot determine type of '${id}' axis. Please provide 'axis' or 'position' option.`);
}
function getAxisFromDataset(id, axis, dataset) {
  if (dataset[axis + "AxisID"] === id) {
    return {
      axis
    };
  }
}
function retrieveAxisFromDatasets(id, config2) {
  if (config2.data && config2.data.datasets) {
    const boundDs = config2.data.datasets.filter((d2) => d2.xAxisID === id || d2.yAxisID === id);
    if (boundDs.length) {
      return getAxisFromDataset(id, "x", boundDs[0]) || getAxisFromDataset(id, "y", boundDs[0]);
    }
  }
  return {};
}
function mergeScaleConfig(config2, options2) {
  const chartDefaults = overrides[config2.type] || {
    scales: {}
  };
  const configScales = options2.scales || {};
  const chartIndexAxis = getIndexAxis(config2.type, options2);
  const scales2 = /* @__PURE__ */ Object.create(null);
  Object.keys(configScales).forEach((id) => {
    const scaleConf = configScales[id];
    if (!isObject(scaleConf)) {
      return console.error(`Invalid scale configuration for scale: ${id}`);
    }
    if (scaleConf._proxy) {
      return console.warn(`Ignoring resolver passed as options for scale: ${id}`);
    }
    const axis = determineAxis(id, scaleConf, retrieveAxisFromDatasets(id, config2), defaults$3.scales[scaleConf.type]);
    const defaultId = getDefaultScaleIDFromAxis(axis, chartIndexAxis);
    const defaultScaleOptions = chartDefaults.scales || {};
    scales2[id] = mergeIf(/* @__PURE__ */ Object.create(null), [
      {
        axis
      },
      scaleConf,
      defaultScaleOptions[axis],
      defaultScaleOptions[defaultId]
    ]);
  });
  config2.data.datasets.forEach((dataset) => {
    const type2 = dataset.type || config2.type;
    const indexAxis = dataset.indexAxis || getIndexAxis(type2, options2);
    const datasetDefaults = overrides[type2] || {};
    const defaultScaleOptions = datasetDefaults.scales || {};
    Object.keys(defaultScaleOptions).forEach((defaultID) => {
      const axis = getAxisFromDefaultScaleID(defaultID, indexAxis);
      const id = dataset[axis + "AxisID"] || axis;
      scales2[id] = scales2[id] || /* @__PURE__ */ Object.create(null);
      mergeIf(scales2[id], [
        {
          axis
        },
        configScales[id],
        defaultScaleOptions[defaultID]
      ]);
    });
  });
  Object.keys(scales2).forEach((key) => {
    const scale2 = scales2[key];
    mergeIf(scale2, [
      defaults$3.scales[scale2.type],
      defaults$3.scale
    ]);
  });
  return scales2;
}
function initOptions(config2) {
  const options2 = config2.options || (config2.options = {});
  options2.plugins = valueOrDefault(options2.plugins, {});
  options2.scales = mergeScaleConfig(config2, options2);
}
function initData(data2) {
  data2 = data2 || {};
  data2.datasets = data2.datasets || [];
  data2.labels = data2.labels || [];
  return data2;
}
function initConfig(config2) {
  config2 = config2 || {};
  config2.data = initData(config2.data);
  initOptions(config2);
  return config2;
}
const keyCache = /* @__PURE__ */ new Map();
const keysCached = /* @__PURE__ */ new Set();
function cachedKeys(cacheKey, generate) {
  let keys = keyCache.get(cacheKey);
  if (!keys) {
    keys = generate();
    keyCache.set(cacheKey, keys);
    keysCached.add(keys);
  }
  return keys;
}
const addIfFound = (set2, obj, key) => {
  const opts = resolveObjectKey(obj, key);
  if (opts !== void 0) {
    set2.add(opts);
  }
};
class Config {
  constructor(config2) {
    this._config = initConfig(config2);
    this._scopeCache = /* @__PURE__ */ new Map();
    this._resolverCache = /* @__PURE__ */ new Map();
  }
  get platform() {
    return this._config.platform;
  }
  get type() {
    return this._config.type;
  }
  set type(type2) {
    this._config.type = type2;
  }
  get data() {
    return this._config.data;
  }
  set data(data2) {
    this._config.data = initData(data2);
  }
  get options() {
    return this._config.options;
  }
  set options(options2) {
    this._config.options = options2;
  }
  get plugins() {
    return this._config.plugins;
  }
  update() {
    const config2 = this._config;
    this.clearCache();
    initOptions(config2);
  }
  clearCache() {
    this._scopeCache.clear();
    this._resolverCache.clear();
  }
  datasetScopeKeys(datasetType) {
    return cachedKeys(datasetType, () => [
      [
        `datasets.${datasetType}`,
        ""
      ]
    ]);
  }
  datasetAnimationScopeKeys(datasetType, transition) {
    return cachedKeys(`${datasetType}.transition.${transition}`, () => [
      [
        `datasets.${datasetType}.transitions.${transition}`,
        `transitions.${transition}`
      ],
      [
        `datasets.${datasetType}`,
        ""
      ]
    ]);
  }
  datasetElementScopeKeys(datasetType, elementType) {
    return cachedKeys(`${datasetType}-${elementType}`, () => [
      [
        `datasets.${datasetType}.elements.${elementType}`,
        `datasets.${datasetType}`,
        `elements.${elementType}`,
        ""
      ]
    ]);
  }
  pluginScopeKeys(plugin2) {
    const id = plugin2.id;
    const type2 = this.type;
    return cachedKeys(`${type2}-plugin-${id}`, () => [
      [
        `plugins.${id}`,
        ...plugin2.additionalOptionScopes || []
      ]
    ]);
  }
  _cachedScopes(mainScope, resetCache) {
    const _scopeCache = this._scopeCache;
    let cache = _scopeCache.get(mainScope);
    if (!cache || resetCache) {
      cache = /* @__PURE__ */ new Map();
      _scopeCache.set(mainScope, cache);
    }
    return cache;
  }
  getOptionScopes(mainScope, keyLists, resetCache) {
    const { options: options2, type: type2 } = this;
    const cache = this._cachedScopes(mainScope, resetCache);
    const cached = cache.get(keyLists);
    if (cached) {
      return cached;
    }
    const scopes = /* @__PURE__ */ new Set();
    keyLists.forEach((keys) => {
      if (mainScope) {
        scopes.add(mainScope);
        keys.forEach((key) => addIfFound(scopes, mainScope, key));
      }
      keys.forEach((key) => addIfFound(scopes, options2, key));
      keys.forEach((key) => addIfFound(scopes, overrides[type2] || {}, key));
      keys.forEach((key) => addIfFound(scopes, defaults$3, key));
      keys.forEach((key) => addIfFound(scopes, descriptors, key));
    });
    const array = Array.from(scopes);
    if (array.length === 0) {
      array.push(/* @__PURE__ */ Object.create(null));
    }
    if (keysCached.has(keyLists)) {
      cache.set(keyLists, array);
    }
    return array;
  }
  chartOptionScopes() {
    const { options: options2, type: type2 } = this;
    return [
      options2,
      overrides[type2] || {},
      defaults$3.datasets[type2] || {},
      {
        type: type2
      },
      defaults$3,
      descriptors
    ];
  }
  resolveNamedOptions(scopes, names2, context, prefixes = [
    ""
  ]) {
    const result = {
      $shared: true
    };
    const { resolver, subPrefixes } = getResolver(this._resolverCache, scopes, prefixes);
    let options2 = resolver;
    if (needContext(resolver, names2)) {
      result.$shared = false;
      context = isFunction(context) ? context() : context;
      const subResolver = this.createResolver(scopes, context, subPrefixes);
      options2 = _attachContext(resolver, context, subResolver);
    }
    for (const prop of names2) {
      result[prop] = options2[prop];
    }
    return result;
  }
  createResolver(scopes, context, prefixes = [
    ""
  ], descriptorDefaults) {
    const { resolver } = getResolver(this._resolverCache, scopes, prefixes);
    return isObject(context) ? _attachContext(resolver, context, void 0, descriptorDefaults) : resolver;
  }
}
function getResolver(resolverCache, scopes, prefixes) {
  let cache = resolverCache.get(scopes);
  if (!cache) {
    cache = /* @__PURE__ */ new Map();
    resolverCache.set(scopes, cache);
  }
  const cacheKey = prefixes.join();
  let cached = cache.get(cacheKey);
  if (!cached) {
    const resolver = _createResolver(scopes, prefixes);
    cached = {
      resolver,
      subPrefixes: prefixes.filter((p2) => !p2.toLowerCase().includes("hover"))
    };
    cache.set(cacheKey, cached);
  }
  return cached;
}
const hasFunction = (value) => isObject(value) && Object.getOwnPropertyNames(value).some((key) => isFunction(value[key]));
function needContext(proxy, names2) {
  const { isScriptable, isIndexable } = _descriptors(proxy);
  for (const prop of names2) {
    const scriptable = isScriptable(prop);
    const indexable = isIndexable(prop);
    const value = (indexable || scriptable) && proxy[prop];
    if (scriptable && (isFunction(value) || hasFunction(value)) || indexable && isArray$1(value)) {
      return true;
    }
  }
  return false;
}
var version$1 = "4.4.3";
const KNOWN_POSITIONS = [
  "top",
  "bottom",
  "left",
  "right",
  "chartArea"
];
function positionIsHorizontal(position2, axis) {
  return position2 === "top" || position2 === "bottom" || KNOWN_POSITIONS.indexOf(position2) === -1 && axis === "x";
}
function compare2Level(l1, l2) {
  return function(a2, b2) {
    return a2[l1] === b2[l1] ? a2[l2] - b2[l2] : a2[l1] - b2[l1];
  };
}
function onAnimationsComplete(context) {
  const chart = context.chart;
  const animationOptions = chart.options.animation;
  chart.notifyPlugins("afterRender");
  callback(animationOptions && animationOptions.onComplete, [
    context
  ], chart);
}
function onAnimationProgress(context) {
  const chart = context.chart;
  const animationOptions = chart.options.animation;
  callback(animationOptions && animationOptions.onProgress, [
    context
  ], chart);
}
function getCanvas(item) {
  if (_isDomSupported() && typeof item === "string") {
    item = document.getElementById(item);
  } else if (item && item.length) {
    item = item[0];
  }
  if (item && item.canvas) {
    item = item.canvas;
  }
  return item;
}
const instances = {};
const getChart = (key) => {
  const canvas = getCanvas(key);
  return Object.values(instances).filter((c4) => c4.canvas === canvas).pop();
};
function moveNumericKeys(obj, start, move) {
  const keys = Object.keys(obj);
  for (const key of keys) {
    const intKey = +key;
    if (intKey >= start) {
      const value = obj[key];
      delete obj[key];
      if (move > 0 || intKey > start) {
        obj[intKey + move] = value;
      }
    }
  }
}
function determineLastEvent(e2, lastEvent, inChartArea, isClick) {
  if (!inChartArea || e2.type === "mouseout") {
    return null;
  }
  if (isClick) {
    return lastEvent;
  }
  return e2;
}
function getSizeForArea(scale2, chartArea, field) {
  return scale2.options.clip ? scale2[field] : chartArea[field];
}
function getDatasetArea(meta, chartArea) {
  const { xScale, yScale } = meta;
  if (xScale && yScale) {
    return {
      left: getSizeForArea(xScale, chartArea, "left"),
      right: getSizeForArea(xScale, chartArea, "right"),
      top: getSizeForArea(yScale, chartArea, "top"),
      bottom: getSizeForArea(yScale, chartArea, "bottom")
    };
  }
  return chartArea;
}
let Chart$1 = (_b = class {
  static register(...items) {
    registry.add(...items);
    invalidatePlugins();
  }
  static unregister(...items) {
    registry.remove(...items);
    invalidatePlugins();
  }
  constructor(item, userConfig) {
    const config2 = this.config = new Config(userConfig);
    const initialCanvas = getCanvas(item);
    const existingChart = getChart(initialCanvas);
    if (existingChart) {
      throw new Error("Canvas is already in use. Chart with ID '" + existingChart.id + "' must be destroyed before the canvas with ID '" + existingChart.canvas.id + "' can be reused.");
    }
    const options2 = config2.createResolver(config2.chartOptionScopes(), this.getContext());
    this.platform = new (config2.platform || _detectPlatform(initialCanvas))();
    this.platform.updateConfig(config2);
    const context = this.platform.acquireContext(initialCanvas, options2.aspectRatio);
    const canvas = context && context.canvas;
    const height2 = canvas && canvas.height;
    const width = canvas && canvas.width;
    this.id = uid();
    this.ctx = context;
    this.canvas = canvas;
    this.width = width;
    this.height = height2;
    this._options = options2;
    this._aspectRatio = this.aspectRatio;
    this._layers = [];
    this._metasets = [];
    this._stacks = void 0;
    this.boxes = [];
    this.currentDevicePixelRatio = void 0;
    this.chartArea = void 0;
    this._active = [];
    this._lastEvent = void 0;
    this._listeners = {};
    this._responsiveListeners = void 0;
    this._sortedMetasets = [];
    this.scales = {};
    this._plugins = new PluginService();
    this.$proxies = {};
    this._hiddenIndices = {};
    this.attached = false;
    this._animationsDisabled = void 0;
    this.$context = void 0;
    this._doResize = debounce$1((mode) => this.update(mode), options2.resizeDelay || 0);
    this._dataChanges = [];
    instances[this.id] = this;
    if (!context || !canvas) {
      console.error("Failed to create chart: can't acquire context from the given item");
      return;
    }
    animator.listen(this, "complete", onAnimationsComplete);
    animator.listen(this, "progress", onAnimationProgress);
    this._initialize();
    if (this.attached) {
      this.update();
    }
  }
  get aspectRatio() {
    const { options: { aspectRatio, maintainAspectRatio }, width, height: height2, _aspectRatio } = this;
    if (!isNullOrUndef(aspectRatio)) {
      return aspectRatio;
    }
    if (maintainAspectRatio && _aspectRatio) {
      return _aspectRatio;
    }
    return height2 ? width / height2 : null;
  }
  get data() {
    return this.config.data;
  }
  set data(data2) {
    this.config.data = data2;
  }
  get options() {
    return this._options;
  }
  set options(options2) {
    this.config.options = options2;
  }
  get registry() {
    return registry;
  }
  _initialize() {
    this.notifyPlugins("beforeInit");
    if (this.options.responsive) {
      this.resize();
    } else {
      retinaScale(this, this.options.devicePixelRatio);
    }
    this.bindEvents();
    this.notifyPlugins("afterInit");
    return this;
  }
  clear() {
    clearCanvas(this.canvas, this.ctx);
    return this;
  }
  stop() {
    animator.stop(this);
    return this;
  }
  resize(width, height2) {
    if (!animator.running(this)) {
      this._resize(width, height2);
    } else {
      this._resizeBeforeDraw = {
        width,
        height: height2
      };
    }
  }
  _resize(width, height2) {
    const options2 = this.options;
    const canvas = this.canvas;
    const aspectRatio = options2.maintainAspectRatio && this.aspectRatio;
    const newSize = this.platform.getMaximumSize(canvas, width, height2, aspectRatio);
    const newRatio = options2.devicePixelRatio || this.platform.getDevicePixelRatio();
    const mode = this.width ? "resize" : "attach";
    this.width = newSize.width;
    this.height = newSize.height;
    this._aspectRatio = this.aspectRatio;
    if (!retinaScale(this, newRatio, true)) {
      return;
    }
    this.notifyPlugins("resize", {
      size: newSize
    });
    callback(options2.onResize, [
      this,
      newSize
    ], this);
    if (this.attached) {
      if (this._doResize(mode)) {
        this.render();
      }
    }
  }
  ensureScalesHaveIDs() {
    const options2 = this.options;
    const scalesOptions = options2.scales || {};
    each$1(scalesOptions, (axisOptions, axisID) => {
      axisOptions.id = axisID;
    });
  }
  buildOrUpdateScales() {
    const options2 = this.options;
    const scaleOpts = options2.scales;
    const scales2 = this.scales;
    const updated = Object.keys(scales2).reduce((obj, id) => {
      obj[id] = false;
      return obj;
    }, {});
    let items = [];
    if (scaleOpts) {
      items = items.concat(Object.keys(scaleOpts).map((id) => {
        const scaleOptions = scaleOpts[id];
        const axis = determineAxis(id, scaleOptions);
        const isRadial = axis === "r";
        const isHorizontal = axis === "x";
        return {
          options: scaleOptions,
          dposition: isRadial ? "chartArea" : isHorizontal ? "bottom" : "left",
          dtype: isRadial ? "radialLinear" : isHorizontal ? "category" : "linear"
        };
      }));
    }
    each$1(items, (item) => {
      const scaleOptions = item.options;
      const id = scaleOptions.id;
      const axis = determineAxis(id, scaleOptions);
      const scaleType = valueOrDefault(scaleOptions.type, item.dtype);
      if (scaleOptions.position === void 0 || positionIsHorizontal(scaleOptions.position, axis) !== positionIsHorizontal(item.dposition)) {
        scaleOptions.position = item.dposition;
      }
      updated[id] = true;
      let scale2 = null;
      if (id in scales2 && scales2[id].type === scaleType) {
        scale2 = scales2[id];
      } else {
        const scaleClass = registry.getScale(scaleType);
        scale2 = new scaleClass({
          id,
          type: scaleType,
          ctx: this.ctx,
          chart: this
        });
        scales2[scale2.id] = scale2;
      }
      scale2.init(scaleOptions, options2);
    });
    each$1(updated, (hasUpdated, id) => {
      if (!hasUpdated) {
        delete scales2[id];
      }
    });
    each$1(scales2, (scale2) => {
      layouts.configure(this, scale2, scale2.options);
      layouts.addBox(this, scale2);
    });
  }
  _updateMetasets() {
    const metasets = this._metasets;
    const numData = this.data.datasets.length;
    const numMeta = metasets.length;
    metasets.sort((a2, b2) => a2.index - b2.index);
    if (numMeta > numData) {
      for (let i = numData; i < numMeta; ++i) {
        this._destroyDatasetMeta(i);
      }
      metasets.splice(numData, numMeta - numData);
    }
    this._sortedMetasets = metasets.slice(0).sort(compare2Level("order", "index"));
  }
  _removeUnreferencedMetasets() {
    const { _metasets: metasets, data: { datasets } } = this;
    if (metasets.length > datasets.length) {
      delete this._stacks;
    }
    metasets.forEach((meta, index2) => {
      if (datasets.filter((x2) => x2 === meta._dataset).length === 0) {
        this._destroyDatasetMeta(index2);
      }
    });
  }
  buildOrUpdateControllers() {
    const newControllers = [];
    const datasets = this.data.datasets;
    let i, ilen;
    this._removeUnreferencedMetasets();
    for (i = 0, ilen = datasets.length; i < ilen; i++) {
      const dataset = datasets[i];
      let meta = this.getDatasetMeta(i);
      const type2 = dataset.type || this.config.type;
      if (meta.type && meta.type !== type2) {
        this._destroyDatasetMeta(i);
        meta = this.getDatasetMeta(i);
      }
      meta.type = type2;
      meta.indexAxis = dataset.indexAxis || getIndexAxis(type2, this.options);
      meta.order = dataset.order || 0;
      meta.index = i;
      meta.label = "" + dataset.label;
      meta.visible = this.isDatasetVisible(i);
      if (meta.controller) {
        meta.controller.updateIndex(i);
        meta.controller.linkScales();
      } else {
        const ControllerClass = registry.getController(type2);
        const { datasetElementType, dataElementType } = defaults$3.datasets[type2];
        Object.assign(ControllerClass, {
          dataElementType: registry.getElement(dataElementType),
          datasetElementType: datasetElementType && registry.getElement(datasetElementType)
        });
        meta.controller = new ControllerClass(this, i);
        newControllers.push(meta.controller);
      }
    }
    this._updateMetasets();
    return newControllers;
  }
  _resetElements() {
    each$1(this.data.datasets, (dataset, datasetIndex) => {
      this.getDatasetMeta(datasetIndex).controller.reset();
    }, this);
  }
  reset() {
    this._resetElements();
    this.notifyPlugins("reset");
  }
  update(mode) {
    const config2 = this.config;
    config2.update();
    const options2 = this._options = config2.createResolver(config2.chartOptionScopes(), this.getContext());
    const animsDisabled = this._animationsDisabled = !options2.animation;
    this._updateScales();
    this._checkEventBindings();
    this._updateHiddenIndices();
    this._plugins.invalidate();
    if (this.notifyPlugins("beforeUpdate", {
      mode,
      cancelable: true
    }) === false) {
      return;
    }
    const newControllers = this.buildOrUpdateControllers();
    this.notifyPlugins("beforeElementsUpdate");
    let minPadding = 0;
    for (let i = 0, ilen = this.data.datasets.length; i < ilen; i++) {
      const { controller } = this.getDatasetMeta(i);
      const reset = !animsDisabled && newControllers.indexOf(controller) === -1;
      controller.buildOrUpdateElements(reset);
      minPadding = Math.max(+controller.getMaxOverflow(), minPadding);
    }
    minPadding = this._minPadding = options2.layout.autoPadding ? minPadding : 0;
    this._updateLayout(minPadding);
    if (!animsDisabled) {
      each$1(newControllers, (controller) => {
        controller.reset();
      });
    }
    this._updateDatasets(mode);
    this.notifyPlugins("afterUpdate", {
      mode
    });
    this._layers.sort(compare2Level("z", "_idx"));
    const { _active, _lastEvent } = this;
    if (_lastEvent) {
      this._eventHandler(_lastEvent, true);
    } else if (_active.length) {
      this._updateHoverStyles(_active, _active, true);
    }
    this.render();
  }
  _updateScales() {
    each$1(this.scales, (scale2) => {
      layouts.removeBox(this, scale2);
    });
    this.ensureScalesHaveIDs();
    this.buildOrUpdateScales();
  }
  _checkEventBindings() {
    const options2 = this.options;
    const existingEvents = new Set(Object.keys(this._listeners));
    const newEvents = new Set(options2.events);
    if (!setsEqual(existingEvents, newEvents) || !!this._responsiveListeners !== options2.responsive) {
      this.unbindEvents();
      this.bindEvents();
    }
  }
  _updateHiddenIndices() {
    const { _hiddenIndices } = this;
    const changes = this._getUniformDataChanges() || [];
    for (const { method, start, count } of changes) {
      const move = method === "_removeElements" ? -count : count;
      moveNumericKeys(_hiddenIndices, start, move);
    }
  }
  _getUniformDataChanges() {
    const _dataChanges = this._dataChanges;
    if (!_dataChanges || !_dataChanges.length) {
      return;
    }
    this._dataChanges = [];
    const datasetCount = this.data.datasets.length;
    const makeSet = (idx) => new Set(_dataChanges.filter((c4) => c4[0] === idx).map((c4, i) => i + "," + c4.splice(1).join(",")));
    const changeSet = makeSet(0);
    for (let i = 1; i < datasetCount; i++) {
      if (!setsEqual(changeSet, makeSet(i))) {
        return;
      }
    }
    return Array.from(changeSet).map((c4) => c4.split(",")).map((a2) => ({
      method: a2[1],
      start: +a2[2],
      count: +a2[3]
    }));
  }
  _updateLayout(minPadding) {
    if (this.notifyPlugins("beforeLayout", {
      cancelable: true
    }) === false) {
      return;
    }
    layouts.update(this, this.width, this.height, minPadding);
    const area = this.chartArea;
    const noArea = area.width <= 0 || area.height <= 0;
    this._layers = [];
    each$1(this.boxes, (box2) => {
      if (noArea && box2.position === "chartArea") {
        return;
      }
      if (box2.configure) {
        box2.configure();
      }
      this._layers.push(...box2._layers());
    }, this);
    this._layers.forEach((item, index2) => {
      item._idx = index2;
    });
    this.notifyPlugins("afterLayout");
  }
  _updateDatasets(mode) {
    if (this.notifyPlugins("beforeDatasetsUpdate", {
      mode,
      cancelable: true
    }) === false) {
      return;
    }
    for (let i = 0, ilen = this.data.datasets.length; i < ilen; ++i) {
      this.getDatasetMeta(i).controller.configure();
    }
    for (let i = 0, ilen = this.data.datasets.length; i < ilen; ++i) {
      this._updateDataset(i, isFunction(mode) ? mode({
        datasetIndex: i
      }) : mode);
    }
    this.notifyPlugins("afterDatasetsUpdate", {
      mode
    });
  }
  _updateDataset(index2, mode) {
    const meta = this.getDatasetMeta(index2);
    const args = {
      meta,
      index: index2,
      mode,
      cancelable: true
    };
    if (this.notifyPlugins("beforeDatasetUpdate", args) === false) {
      return;
    }
    meta.controller._update(mode);
    args.cancelable = false;
    this.notifyPlugins("afterDatasetUpdate", args);
  }
  render() {
    if (this.notifyPlugins("beforeRender", {
      cancelable: true
    }) === false) {
      return;
    }
    if (animator.has(this)) {
      if (this.attached && !animator.running(this)) {
        animator.start(this);
      }
    } else {
      this.draw();
      onAnimationsComplete({
        chart: this
      });
    }
  }
  draw() {
    let i;
    if (this._resizeBeforeDraw) {
      const { width, height: height2 } = this._resizeBeforeDraw;
      this._resize(width, height2);
      this._resizeBeforeDraw = null;
    }
    this.clear();
    if (this.width <= 0 || this.height <= 0) {
      return;
    }
    if (this.notifyPlugins("beforeDraw", {
      cancelable: true
    }) === false) {
      return;
    }
    const layers = this._layers;
    for (i = 0; i < layers.length && layers[i].z <= 0; ++i) {
      layers[i].draw(this.chartArea);
    }
    this._drawDatasets();
    for (; i < layers.length; ++i) {
      layers[i].draw(this.chartArea);
    }
    this.notifyPlugins("afterDraw");
  }
  _getSortedDatasetMetas(filterVisible) {
    const metasets = this._sortedMetasets;
    const result = [];
    let i, ilen;
    for (i = 0, ilen = metasets.length; i < ilen; ++i) {
      const meta = metasets[i];
      if (!filterVisible || meta.visible) {
        result.push(meta);
      }
    }
    return result;
  }
  getSortedVisibleDatasetMetas() {
    return this._getSortedDatasetMetas(true);
  }
  _drawDatasets() {
    if (this.notifyPlugins("beforeDatasetsDraw", {
      cancelable: true
    }) === false) {
      return;
    }
    const metasets = this.getSortedVisibleDatasetMetas();
    for (let i = metasets.length - 1; i >= 0; --i) {
      this._drawDataset(metasets[i]);
    }
    this.notifyPlugins("afterDatasetsDraw");
  }
  _drawDataset(meta) {
    const ctx = this.ctx;
    const clip = meta._clip;
    const useClip = !clip.disabled;
    const area = getDatasetArea(meta, this.chartArea);
    const args = {
      meta,
      index: meta.index,
      cancelable: true
    };
    if (this.notifyPlugins("beforeDatasetDraw", args) === false) {
      return;
    }
    if (useClip) {
      clipArea(ctx, {
        left: clip.left === false ? 0 : area.left - clip.left,
        right: clip.right === false ? this.width : area.right + clip.right,
        top: clip.top === false ? 0 : area.top - clip.top,
        bottom: clip.bottom === false ? this.height : area.bottom + clip.bottom
      });
    }
    meta.controller.draw();
    if (useClip) {
      unclipArea(ctx);
    }
    args.cancelable = false;
    this.notifyPlugins("afterDatasetDraw", args);
  }
  isPointInArea(point) {
    return _isPointInArea(point, this.chartArea, this._minPadding);
  }
  getElementsAtEventForMode(e2, mode, options2, useFinalPosition) {
    const method = Interaction.modes[mode];
    if (typeof method === "function") {
      return method(this, e2, options2, useFinalPosition);
    }
    return [];
  }
  getDatasetMeta(datasetIndex) {
    const dataset = this.data.datasets[datasetIndex];
    const metasets = this._metasets;
    let meta = metasets.filter((x2) => x2 && x2._dataset === dataset).pop();
    if (!meta) {
      meta = {
        type: null,
        data: [],
        dataset: null,
        controller: null,
        hidden: null,
        xAxisID: null,
        yAxisID: null,
        order: dataset && dataset.order || 0,
        index: datasetIndex,
        _dataset: dataset,
        _parsed: [],
        _sorted: false
      };
      metasets.push(meta);
    }
    return meta;
  }
  getContext() {
    return this.$context || (this.$context = createContext(null, {
      chart: this,
      type: "chart"
    }));
  }
  getVisibleDatasetCount() {
    return this.getSortedVisibleDatasetMetas().length;
  }
  isDatasetVisible(datasetIndex) {
    const dataset = this.data.datasets[datasetIndex];
    if (!dataset) {
      return false;
    }
    const meta = this.getDatasetMeta(datasetIndex);
    return typeof meta.hidden === "boolean" ? !meta.hidden : !dataset.hidden;
  }
  setDatasetVisibility(datasetIndex, visible) {
    const meta = this.getDatasetMeta(datasetIndex);
    meta.hidden = !visible;
  }
  toggleDataVisibility(index2) {
    this._hiddenIndices[index2] = !this._hiddenIndices[index2];
  }
  getDataVisibility(index2) {
    return !this._hiddenIndices[index2];
  }
  _updateVisibility(datasetIndex, dataIndex, visible) {
    const mode = visible ? "show" : "hide";
    const meta = this.getDatasetMeta(datasetIndex);
    const anims = meta.controller._resolveAnimations(void 0, mode);
    if (defined(dataIndex)) {
      meta.data[dataIndex].hidden = !visible;
      this.update();
    } else {
      this.setDatasetVisibility(datasetIndex, visible);
      anims.update(meta, {
        visible
      });
      this.update((ctx) => ctx.datasetIndex === datasetIndex ? mode : void 0);
    }
  }
  hide(datasetIndex, dataIndex) {
    this._updateVisibility(datasetIndex, dataIndex, false);
  }
  show(datasetIndex, dataIndex) {
    this._updateVisibility(datasetIndex, dataIndex, true);
  }
  _destroyDatasetMeta(datasetIndex) {
    const meta = this._metasets[datasetIndex];
    if (meta && meta.controller) {
      meta.controller._destroy();
    }
    delete this._metasets[datasetIndex];
  }
  _stop() {
    let i, ilen;
    this.stop();
    animator.remove(this);
    for (i = 0, ilen = this.data.datasets.length; i < ilen; ++i) {
      this._destroyDatasetMeta(i);
    }
  }
  destroy() {
    this.notifyPlugins("beforeDestroy");
    const { canvas, ctx } = this;
    this._stop();
    this.config.clearCache();
    if (canvas) {
      this.unbindEvents();
      clearCanvas(canvas, ctx);
      this.platform.releaseContext(ctx);
      this.canvas = null;
      this.ctx = null;
    }
    delete instances[this.id];
    this.notifyPlugins("afterDestroy");
  }
  toBase64Image(...args) {
    return this.canvas.toDataURL(...args);
  }
  bindEvents() {
    this.bindUserEvents();
    if (this.options.responsive) {
      this.bindResponsiveEvents();
    } else {
      this.attached = true;
    }
  }
  bindUserEvents() {
    const listeners = this._listeners;
    const platform2 = this.platform;
    const _add = (type2, listener2) => {
      platform2.addEventListener(this, type2, listener2);
      listeners[type2] = listener2;
    };
    const listener = (e2, x2, y2) => {
      e2.offsetX = x2;
      e2.offsetY = y2;
      this._eventHandler(e2);
    };
    each$1(this.options.events, (type2) => _add(type2, listener));
  }
  bindResponsiveEvents() {
    if (!this._responsiveListeners) {
      this._responsiveListeners = {};
    }
    const listeners = this._responsiveListeners;
    const platform2 = this.platform;
    const _add = (type2, listener2) => {
      platform2.addEventListener(this, type2, listener2);
      listeners[type2] = listener2;
    };
    const _remove = (type2, listener2) => {
      if (listeners[type2]) {
        platform2.removeEventListener(this, type2, listener2);
        delete listeners[type2];
      }
    };
    const listener = (width, height2) => {
      if (this.canvas) {
        this.resize(width, height2);
      }
    };
    let detached;
    const attached = () => {
      _remove("attach", attached);
      this.attached = true;
      this.resize();
      _add("resize", listener);
      _add("detach", detached);
    };
    detached = () => {
      this.attached = false;
      _remove("resize", listener);
      this._stop();
      this._resize(0, 0);
      _add("attach", attached);
    };
    if (platform2.isAttached(this.canvas)) {
      attached();
    } else {
      detached();
    }
  }
  unbindEvents() {
    each$1(this._listeners, (listener, type2) => {
      this.platform.removeEventListener(this, type2, listener);
    });
    this._listeners = {};
    each$1(this._responsiveListeners, (listener, type2) => {
      this.platform.removeEventListener(this, type2, listener);
    });
    this._responsiveListeners = void 0;
  }
  updateHoverStyle(items, mode, enabled) {
    const prefix2 = enabled ? "set" : "remove";
    let meta, item, i, ilen;
    if (mode === "dataset") {
      meta = this.getDatasetMeta(items[0].datasetIndex);
      meta.controller["_" + prefix2 + "DatasetHoverStyle"]();
    }
    for (i = 0, ilen = items.length; i < ilen; ++i) {
      item = items[i];
      const controller = item && this.getDatasetMeta(item.datasetIndex).controller;
      if (controller) {
        controller[prefix2 + "HoverStyle"](item.element, item.datasetIndex, item.index);
      }
    }
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(activeElements) {
    const lastActive = this._active || [];
    const active2 = activeElements.map(({ datasetIndex, index: index2 }) => {
      const meta = this.getDatasetMeta(datasetIndex);
      if (!meta) {
        throw new Error("No dataset found at index " + datasetIndex);
      }
      return {
        datasetIndex,
        element: meta.data[index2],
        index: index2
      };
    });
    const changed = !_elementsEqual(active2, lastActive);
    if (changed) {
      this._active = active2;
      this._lastEvent = null;
      this._updateHoverStyles(active2, lastActive);
    }
  }
  notifyPlugins(hook, args, filter) {
    return this._plugins.notify(this, hook, args, filter);
  }
  isPluginEnabled(pluginId) {
    return this._plugins._cache.filter((p2) => p2.plugin.id === pluginId).length === 1;
  }
  _updateHoverStyles(active2, lastActive, replay) {
    const hoverOptions = this.options.hover;
    const diff2 = (a2, b2) => a2.filter((x2) => !b2.some((y2) => x2.datasetIndex === y2.datasetIndex && x2.index === y2.index));
    const deactivated = diff2(lastActive, active2);
    const activated = replay ? active2 : diff2(active2, lastActive);
    if (deactivated.length) {
      this.updateHoverStyle(deactivated, hoverOptions.mode, false);
    }
    if (activated.length && hoverOptions.mode) {
      this.updateHoverStyle(activated, hoverOptions.mode, true);
    }
  }
  _eventHandler(e2, replay) {
    const args = {
      event: e2,
      replay,
      cancelable: true,
      inChartArea: this.isPointInArea(e2)
    };
    const eventFilter = (plugin2) => (plugin2.options.events || this.options.events).includes(e2.native.type);
    if (this.notifyPlugins("beforeEvent", args, eventFilter) === false) {
      return;
    }
    const changed = this._handleEvent(e2, replay, args.inChartArea);
    args.cancelable = false;
    this.notifyPlugins("afterEvent", args, eventFilter);
    if (changed || args.changed) {
      this.render();
    }
    return this;
  }
  _handleEvent(e2, replay, inChartArea) {
    const { _active: lastActive = [], options: options2 } = this;
    const useFinalPosition = replay;
    const active2 = this._getActiveElements(e2, lastActive, inChartArea, useFinalPosition);
    const isClick = _isClickEvent(e2);
    const lastEvent = determineLastEvent(e2, this._lastEvent, inChartArea, isClick);
    if (inChartArea) {
      this._lastEvent = null;
      callback(options2.onHover, [
        e2,
        active2,
        this
      ], this);
      if (isClick) {
        callback(options2.onClick, [
          e2,
          active2,
          this
        ], this);
      }
    }
    const changed = !_elementsEqual(active2, lastActive);
    if (changed || replay) {
      this._active = active2;
      this._updateHoverStyles(active2, lastActive, replay);
    }
    this._lastEvent = lastEvent;
    return changed;
  }
  _getActiveElements(e2, lastActive, inChartArea, useFinalPosition) {
    if (e2.type === "mouseout") {
      return [];
    }
    if (!inChartArea) {
      return lastActive;
    }
    const hoverOptions = this.options.hover;
    return this.getElementsAtEventForMode(e2, hoverOptions.mode, hoverOptions, useFinalPosition);
  }
}, __publicField(_b, "defaults", defaults$3), __publicField(_b, "instances", instances), __publicField(_b, "overrides", overrides), __publicField(_b, "registry", registry), __publicField(_b, "version", version$1), __publicField(_b, "getChart", getChart), _b);
function invalidatePlugins() {
  return each$1(Chart$1.instances, (chart) => chart._plugins.invalidate());
}
function clipArc(ctx, element, endAngle) {
  const { startAngle, pixelMargin, x: x2, y: y2, outerRadius, innerRadius } = element;
  let angleMargin = pixelMargin / outerRadius;
  ctx.beginPath();
  ctx.arc(x2, y2, outerRadius, startAngle - angleMargin, endAngle + angleMargin);
  if (innerRadius > pixelMargin) {
    angleMargin = pixelMargin / innerRadius;
    ctx.arc(x2, y2, innerRadius, endAngle + angleMargin, startAngle - angleMargin, true);
  } else {
    ctx.arc(x2, y2, pixelMargin, endAngle + HALF_PI, startAngle - HALF_PI);
  }
  ctx.closePath();
  ctx.clip();
}
function toRadiusCorners(value) {
  return _readValueToProps(value, [
    "outerStart",
    "outerEnd",
    "innerStart",
    "innerEnd"
  ]);
}
function parseBorderRadius$1(arc, innerRadius, outerRadius, angleDelta) {
  const o2 = toRadiusCorners(arc.options.borderRadius);
  const halfThickness = (outerRadius - innerRadius) / 2;
  const innerLimit = Math.min(halfThickness, angleDelta * innerRadius / 2);
  const computeOuterLimit = (val) => {
    const outerArcLimit = (outerRadius - Math.min(halfThickness, val)) * angleDelta / 2;
    return _limitValue(val, 0, Math.min(halfThickness, outerArcLimit));
  };
  return {
    outerStart: computeOuterLimit(o2.outerStart),
    outerEnd: computeOuterLimit(o2.outerEnd),
    innerStart: _limitValue(o2.innerStart, 0, innerLimit),
    innerEnd: _limitValue(o2.innerEnd, 0, innerLimit)
  };
}
function rThetaToXY(r2, theta, x2, y2) {
  return {
    x: x2 + r2 * Math.cos(theta),
    y: y2 + r2 * Math.sin(theta)
  };
}
function pathArc(ctx, element, offset2, spacing2, end, circular) {
  const { x: x2, y: y2, startAngle: start, pixelMargin, innerRadius: innerR } = element;
  const outerRadius = Math.max(element.outerRadius + spacing2 + offset2 - pixelMargin, 0);
  const innerRadius = innerR > 0 ? innerR + spacing2 + offset2 + pixelMargin : 0;
  let spacingOffset = 0;
  const alpha2 = end - start;
  if (spacing2) {
    const noSpacingInnerRadius = innerR > 0 ? innerR - spacing2 : 0;
    const noSpacingOuterRadius = outerRadius > 0 ? outerRadius - spacing2 : 0;
    const avNogSpacingRadius = (noSpacingInnerRadius + noSpacingOuterRadius) / 2;
    const adjustedAngle = avNogSpacingRadius !== 0 ? alpha2 * avNogSpacingRadius / (avNogSpacingRadius + spacing2) : alpha2;
    spacingOffset = (alpha2 - adjustedAngle) / 2;
  }
  const beta = Math.max(1e-3, alpha2 * outerRadius - offset2 / PI) / outerRadius;
  const angleOffset = (alpha2 - beta) / 2;
  const startAngle = start + angleOffset + spacingOffset;
  const endAngle = end - angleOffset - spacingOffset;
  const { outerStart, outerEnd, innerStart, innerEnd } = parseBorderRadius$1(element, innerRadius, outerRadius, endAngle - startAngle);
  const outerStartAdjustedRadius = outerRadius - outerStart;
  const outerEndAdjustedRadius = outerRadius - outerEnd;
  const outerStartAdjustedAngle = startAngle + outerStart / outerStartAdjustedRadius;
  const outerEndAdjustedAngle = endAngle - outerEnd / outerEndAdjustedRadius;
  const innerStartAdjustedRadius = innerRadius + innerStart;
  const innerEndAdjustedRadius = innerRadius + innerEnd;
  const innerStartAdjustedAngle = startAngle + innerStart / innerStartAdjustedRadius;
  const innerEndAdjustedAngle = endAngle - innerEnd / innerEndAdjustedRadius;
  ctx.beginPath();
  if (circular) {
    const outerMidAdjustedAngle = (outerStartAdjustedAngle + outerEndAdjustedAngle) / 2;
    ctx.arc(x2, y2, outerRadius, outerStartAdjustedAngle, outerMidAdjustedAngle);
    ctx.arc(x2, y2, outerRadius, outerMidAdjustedAngle, outerEndAdjustedAngle);
    if (outerEnd > 0) {
      const pCenter = rThetaToXY(outerEndAdjustedRadius, outerEndAdjustedAngle, x2, y2);
      ctx.arc(pCenter.x, pCenter.y, outerEnd, outerEndAdjustedAngle, endAngle + HALF_PI);
    }
    const p4 = rThetaToXY(innerEndAdjustedRadius, endAngle, x2, y2);
    ctx.lineTo(p4.x, p4.y);
    if (innerEnd > 0) {
      const pCenter = rThetaToXY(innerEndAdjustedRadius, innerEndAdjustedAngle, x2, y2);
      ctx.arc(pCenter.x, pCenter.y, innerEnd, endAngle + HALF_PI, innerEndAdjustedAngle + Math.PI);
    }
    const innerMidAdjustedAngle = (endAngle - innerEnd / innerRadius + (startAngle + innerStart / innerRadius)) / 2;
    ctx.arc(x2, y2, innerRadius, endAngle - innerEnd / innerRadius, innerMidAdjustedAngle, true);
    ctx.arc(x2, y2, innerRadius, innerMidAdjustedAngle, startAngle + innerStart / innerRadius, true);
    if (innerStart > 0) {
      const pCenter = rThetaToXY(innerStartAdjustedRadius, innerStartAdjustedAngle, x2, y2);
      ctx.arc(pCenter.x, pCenter.y, innerStart, innerStartAdjustedAngle + Math.PI, startAngle - HALF_PI);
    }
    const p8 = rThetaToXY(outerStartAdjustedRadius, startAngle, x2, y2);
    ctx.lineTo(p8.x, p8.y);
    if (outerStart > 0) {
      const pCenter = rThetaToXY(outerStartAdjustedRadius, outerStartAdjustedAngle, x2, y2);
      ctx.arc(pCenter.x, pCenter.y, outerStart, startAngle - HALF_PI, outerStartAdjustedAngle);
    }
  } else {
    ctx.moveTo(x2, y2);
    const outerStartX = Math.cos(outerStartAdjustedAngle) * outerRadius + x2;
    const outerStartY = Math.sin(outerStartAdjustedAngle) * outerRadius + y2;
    ctx.lineTo(outerStartX, outerStartY);
    const outerEndX = Math.cos(outerEndAdjustedAngle) * outerRadius + x2;
    const outerEndY = Math.sin(outerEndAdjustedAngle) * outerRadius + y2;
    ctx.lineTo(outerEndX, outerEndY);
  }
  ctx.closePath();
}
function drawArc(ctx, element, offset2, spacing2, circular) {
  const { fullCircles, startAngle, circumference } = element;
  let endAngle = element.endAngle;
  if (fullCircles) {
    pathArc(ctx, element, offset2, spacing2, endAngle, circular);
    for (let i = 0; i < fullCircles; ++i) {
      ctx.fill();
    }
    if (!isNaN(circumference)) {
      endAngle = startAngle + (circumference % TAU || TAU);
    }
  }
  pathArc(ctx, element, offset2, spacing2, endAngle, circular);
  ctx.fill();
  return endAngle;
}
function drawBorder(ctx, element, offset2, spacing2, circular) {
  const { fullCircles, startAngle, circumference, options: options2 } = element;
  const { borderWidth, borderJoinStyle, borderDash, borderDashOffset } = options2;
  const inner = options2.borderAlign === "inner";
  if (!borderWidth) {
    return;
  }
  ctx.setLineDash(borderDash || []);
  ctx.lineDashOffset = borderDashOffset;
  if (inner) {
    ctx.lineWidth = borderWidth * 2;
    ctx.lineJoin = borderJoinStyle || "round";
  } else {
    ctx.lineWidth = borderWidth;
    ctx.lineJoin = borderJoinStyle || "bevel";
  }
  let endAngle = element.endAngle;
  if (fullCircles) {
    pathArc(ctx, element, offset2, spacing2, endAngle, circular);
    for (let i = 0; i < fullCircles; ++i) {
      ctx.stroke();
    }
    if (!isNaN(circumference)) {
      endAngle = startAngle + (circumference % TAU || TAU);
    }
  }
  if (inner) {
    clipArc(ctx, element, endAngle);
  }
  if (!fullCircles) {
    pathArc(ctx, element, offset2, spacing2, endAngle, circular);
    ctx.stroke();
  }
}
class ArcElement extends Element$1 {
  constructor(cfg) {
    super();
    __publicField(this, "circumference");
    __publicField(this, "endAngle");
    __publicField(this, "fullCircles");
    __publicField(this, "innerRadius");
    __publicField(this, "outerRadius");
    __publicField(this, "pixelMargin");
    __publicField(this, "startAngle");
    this.options = void 0;
    this.circumference = void 0;
    this.startAngle = void 0;
    this.endAngle = void 0;
    this.innerRadius = void 0;
    this.outerRadius = void 0;
    this.pixelMargin = 0;
    this.fullCircles = 0;
    if (cfg) {
      Object.assign(this, cfg);
    }
  }
  inRange(chartX, chartY, useFinalPosition) {
    const point = this.getProps([
      "x",
      "y"
    ], useFinalPosition);
    const { angle, distance: distance2 } = getAngleFromPoint(point, {
      x: chartX,
      y: chartY
    });
    const { startAngle, endAngle, innerRadius, outerRadius, circumference } = this.getProps([
      "startAngle",
      "endAngle",
      "innerRadius",
      "outerRadius",
      "circumference"
    ], useFinalPosition);
    const rAdjust = (this.options.spacing + this.options.borderWidth) / 2;
    const _circumference = valueOrDefault(circumference, endAngle - startAngle);
    const betweenAngles = _circumference >= TAU || _angleBetween(angle, startAngle, endAngle);
    const withinRadius = _isBetween(distance2, innerRadius + rAdjust, outerRadius + rAdjust);
    return betweenAngles && withinRadius;
  }
  getCenterPoint(useFinalPosition) {
    const { x: x2, y: y2, startAngle, endAngle, innerRadius, outerRadius } = this.getProps([
      "x",
      "y",
      "startAngle",
      "endAngle",
      "innerRadius",
      "outerRadius"
    ], useFinalPosition);
    const { offset: offset2, spacing: spacing2 } = this.options;
    const halfAngle = (startAngle + endAngle) / 2;
    const halfRadius = (innerRadius + outerRadius + spacing2 + offset2) / 2;
    return {
      x: x2 + Math.cos(halfAngle) * halfRadius,
      y: y2 + Math.sin(halfAngle) * halfRadius
    };
  }
  tooltipPosition(useFinalPosition) {
    return this.getCenterPoint(useFinalPosition);
  }
  draw(ctx) {
    const { options: options2, circumference } = this;
    const offset2 = (options2.offset || 0) / 4;
    const spacing2 = (options2.spacing || 0) / 2;
    const circular = options2.circular;
    this.pixelMargin = options2.borderAlign === "inner" ? 0.33 : 0;
    this.fullCircles = circumference > TAU ? Math.floor(circumference / TAU) : 0;
    if (circumference === 0 || this.innerRadius < 0 || this.outerRadius < 0) {
      return;
    }
    ctx.save();
    const halfAngle = (this.startAngle + this.endAngle) / 2;
    ctx.translate(Math.cos(halfAngle) * offset2, Math.sin(halfAngle) * offset2);
    const fix = 1 - Math.sin(Math.min(PI, circumference || 0));
    const radiusOffset = offset2 * fix;
    ctx.fillStyle = options2.backgroundColor;
    ctx.strokeStyle = options2.borderColor;
    drawArc(ctx, this, radiusOffset, spacing2, circular);
    drawBorder(ctx, this, radiusOffset, spacing2, circular);
    ctx.restore();
  }
}
__publicField(ArcElement, "id", "arc");
__publicField(ArcElement, "defaults", {
  borderAlign: "center",
  borderColor: "#fff",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: void 0,
  borderRadius: 0,
  borderWidth: 2,
  offset: 0,
  spacing: 0,
  angle: void 0,
  circular: true
});
__publicField(ArcElement, "defaultRoutes", {
  backgroundColor: "backgroundColor"
});
__publicField(ArcElement, "descriptors", {
  _scriptable: true,
  _indexable: (name) => name !== "borderDash"
});
function setStyle(ctx, options2, style = options2) {
  ctx.lineCap = valueOrDefault(style.borderCapStyle, options2.borderCapStyle);
  ctx.setLineDash(valueOrDefault(style.borderDash, options2.borderDash));
  ctx.lineDashOffset = valueOrDefault(style.borderDashOffset, options2.borderDashOffset);
  ctx.lineJoin = valueOrDefault(style.borderJoinStyle, options2.borderJoinStyle);
  ctx.lineWidth = valueOrDefault(style.borderWidth, options2.borderWidth);
  ctx.strokeStyle = valueOrDefault(style.borderColor, options2.borderColor);
}
function lineTo(ctx, previous, target) {
  ctx.lineTo(target.x, target.y);
}
function getLineMethod(options2) {
  if (options2.stepped) {
    return _steppedLineTo;
  }
  if (options2.tension || options2.cubicInterpolationMode === "monotone") {
    return _bezierCurveTo;
  }
  return lineTo;
}
function pathVars(points, segment, params = {}) {
  const count = points.length;
  const { start: paramsStart = 0, end: paramsEnd = count - 1 } = params;
  const { start: segmentStart, end: segmentEnd } = segment;
  const start = Math.max(paramsStart, segmentStart);
  const end = Math.min(paramsEnd, segmentEnd);
  const outside = paramsStart < segmentStart && paramsEnd < segmentStart || paramsStart > segmentEnd && paramsEnd > segmentEnd;
  return {
    count,
    start,
    loop: segment.loop,
    ilen: end < start && !outside ? count + end - start : end - start
  };
}
function pathSegment(ctx, line2, segment, params) {
  const { points, options: options2 } = line2;
  const { count, start, loop, ilen } = pathVars(points, segment, params);
  const lineMethod = getLineMethod(options2);
  let { move = true, reverse } = params || {};
  let i, point, prev2;
  for (i = 0; i <= ilen; ++i) {
    point = points[(start + (reverse ? ilen - i : i)) % count];
    if (point.skip) {
      continue;
    } else if (move) {
      ctx.moveTo(point.x, point.y);
      move = false;
    } else {
      lineMethod(ctx, prev2, point, reverse, options2.stepped);
    }
    prev2 = point;
  }
  if (loop) {
    point = points[(start + (reverse ? ilen : 0)) % count];
    lineMethod(ctx, prev2, point, reverse, options2.stepped);
  }
  return !!loop;
}
function fastPathSegment(ctx, line2, segment, params) {
  const points = line2.points;
  const { count, start, ilen } = pathVars(points, segment, params);
  const { move = true, reverse } = params || {};
  let avgX = 0;
  let countX = 0;
  let i, point, prevX, minY, maxY, lastY;
  const pointIndex = (index2) => (start + (reverse ? ilen - index2 : index2)) % count;
  const drawX = () => {
    if (minY !== maxY) {
      ctx.lineTo(avgX, maxY);
      ctx.lineTo(avgX, minY);
      ctx.lineTo(avgX, lastY);
    }
  };
  if (move) {
    point = points[pointIndex(0)];
    ctx.moveTo(point.x, point.y);
  }
  for (i = 0; i <= ilen; ++i) {
    point = points[pointIndex(i)];
    if (point.skip) {
      continue;
    }
    const x2 = point.x;
    const y2 = point.y;
    const truncX = x2 | 0;
    if (truncX === prevX) {
      if (y2 < minY) {
        minY = y2;
      } else if (y2 > maxY) {
        maxY = y2;
      }
      avgX = (countX * avgX + x2) / ++countX;
    } else {
      drawX();
      ctx.lineTo(x2, y2);
      prevX = truncX;
      countX = 0;
      minY = maxY = y2;
    }
    lastY = y2;
  }
  drawX();
}
function _getSegmentMethod(line2) {
  const opts = line2.options;
  const borderDash = opts.borderDash && opts.borderDash.length;
  const useFastPath = !line2._decimated && !line2._loop && !opts.tension && opts.cubicInterpolationMode !== "monotone" && !opts.stepped && !borderDash;
  return useFastPath ? fastPathSegment : pathSegment;
}
function _getInterpolationMethod(options2) {
  if (options2.stepped) {
    return _steppedInterpolation;
  }
  if (options2.tension || options2.cubicInterpolationMode === "monotone") {
    return _bezierInterpolation;
  }
  return _pointInLine;
}
function strokePathWithCache(ctx, line2, start, count) {
  let path = line2._path;
  if (!path) {
    path = line2._path = new Path2D();
    if (line2.path(path, start, count)) {
      path.closePath();
    }
  }
  setStyle(ctx, line2.options);
  ctx.stroke(path);
}
function strokePathDirect(ctx, line2, start, count) {
  const { segments, options: options2 } = line2;
  const segmentMethod = _getSegmentMethod(line2);
  for (const segment of segments) {
    setStyle(ctx, options2, segment.style);
    ctx.beginPath();
    if (segmentMethod(ctx, line2, segment, {
      start,
      end: start + count - 1
    })) {
      ctx.closePath();
    }
    ctx.stroke();
  }
}
const usePath2D = typeof Path2D === "function";
function draw$1(ctx, line2, start, count) {
  if (usePath2D && !line2.options.segment) {
    strokePathWithCache(ctx, line2, start, count);
  } else {
    strokePathDirect(ctx, line2, start, count);
  }
}
class LineElement extends Element$1 {
  constructor(cfg) {
    super();
    this.animated = true;
    this.options = void 0;
    this._chart = void 0;
    this._loop = void 0;
    this._fullLoop = void 0;
    this._path = void 0;
    this._points = void 0;
    this._segments = void 0;
    this._decimated = false;
    this._pointsUpdated = false;
    this._datasetIndex = void 0;
    if (cfg) {
      Object.assign(this, cfg);
    }
  }
  updateControlPoints(chartArea, indexAxis) {
    const options2 = this.options;
    if ((options2.tension || options2.cubicInterpolationMode === "monotone") && !options2.stepped && !this._pointsUpdated) {
      const loop = options2.spanGaps ? this._loop : this._fullLoop;
      _updateBezierControlPoints(this._points, options2, chartArea, loop, indexAxis);
      this._pointsUpdated = true;
    }
  }
  set points(points) {
    this._points = points;
    delete this._segments;
    delete this._path;
    this._pointsUpdated = false;
  }
  get points() {
    return this._points;
  }
  get segments() {
    return this._segments || (this._segments = _computeSegments(this, this.options.segment));
  }
  first() {
    const segments = this.segments;
    const points = this.points;
    return segments.length && points[segments[0].start];
  }
  last() {
    const segments = this.segments;
    const points = this.points;
    const count = segments.length;
    return count && points[segments[count - 1].end];
  }
  interpolate(point, property) {
    const options2 = this.options;
    const value = point[property];
    const points = this.points;
    const segments = _boundSegments(this, {
      property,
      start: value,
      end: value
    });
    if (!segments.length) {
      return;
    }
    const result = [];
    const _interpolate = _getInterpolationMethod(options2);
    let i, ilen;
    for (i = 0, ilen = segments.length; i < ilen; ++i) {
      const { start, end } = segments[i];
      const p1 = points[start];
      const p2 = points[end];
      if (p1 === p2) {
        result.push(p1);
        continue;
      }
      const t2 = Math.abs((value - p1[property]) / (p2[property] - p1[property]));
      const interpolated = _interpolate(p1, p2, t2, options2.stepped);
      interpolated[property] = point[property];
      result.push(interpolated);
    }
    return result.length === 1 ? result[0] : result;
  }
  pathSegment(ctx, segment, params) {
    const segmentMethod = _getSegmentMethod(this);
    return segmentMethod(ctx, this, segment, params);
  }
  path(ctx, start, count) {
    const segments = this.segments;
    const segmentMethod = _getSegmentMethod(this);
    let loop = this._loop;
    start = start || 0;
    count = count || this.points.length - start;
    for (const segment of segments) {
      loop &= segmentMethod(ctx, this, segment, {
        start,
        end: start + count - 1
      });
    }
    return !!loop;
  }
  draw(ctx, chartArea, start, count) {
    const options2 = this.options || {};
    const points = this.points || [];
    if (points.length && options2.borderWidth) {
      ctx.save();
      draw$1(ctx, this, start, count);
      ctx.restore();
    }
    if (this.animated) {
      this._pointsUpdated = false;
      this._path = void 0;
    }
  }
}
__publicField(LineElement, "id", "line");
__publicField(LineElement, "defaults", {
  borderCapStyle: "butt",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: "miter",
  borderWidth: 3,
  capBezierPoints: true,
  cubicInterpolationMode: "default",
  fill: false,
  spanGaps: false,
  stepped: false,
  tension: 0
});
__publicField(LineElement, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
});
__publicField(LineElement, "descriptors", {
  _scriptable: true,
  _indexable: (name) => name !== "borderDash" && name !== "fill"
});
function inRange$1(el, pos, axis, useFinalPosition) {
  const options2 = el.options;
  const { [axis]: value } = el.getProps([
    axis
  ], useFinalPosition);
  return Math.abs(pos - value) < options2.radius + options2.hitRadius;
}
class PointElement extends Element$1 {
  constructor(cfg) {
    super();
    __publicField(this, "parsed");
    __publicField(this, "skip");
    __publicField(this, "stop");
    this.options = void 0;
    this.parsed = void 0;
    this.skip = void 0;
    this.stop = void 0;
    if (cfg) {
      Object.assign(this, cfg);
    }
  }
  inRange(mouseX, mouseY, useFinalPosition) {
    const options2 = this.options;
    const { x: x2, y: y2 } = this.getProps([
      "x",
      "y"
    ], useFinalPosition);
    return Math.pow(mouseX - x2, 2) + Math.pow(mouseY - y2, 2) < Math.pow(options2.hitRadius + options2.radius, 2);
  }
  inXRange(mouseX, useFinalPosition) {
    return inRange$1(this, mouseX, "x", useFinalPosition);
  }
  inYRange(mouseY, useFinalPosition) {
    return inRange$1(this, mouseY, "y", useFinalPosition);
  }
  getCenterPoint(useFinalPosition) {
    const { x: x2, y: y2 } = this.getProps([
      "x",
      "y"
    ], useFinalPosition);
    return {
      x: x2,
      y: y2
    };
  }
  size(options2) {
    options2 = options2 || this.options || {};
    let radius = options2.radius || 0;
    radius = Math.max(radius, radius && options2.hoverRadius || 0);
    const borderWidth = radius && options2.borderWidth || 0;
    return (radius + borderWidth) * 2;
  }
  draw(ctx, area) {
    const options2 = this.options;
    if (this.skip || options2.radius < 0.1 || !_isPointInArea(this, area, this.size(options2) / 2)) {
      return;
    }
    ctx.strokeStyle = options2.borderColor;
    ctx.lineWidth = options2.borderWidth;
    ctx.fillStyle = options2.backgroundColor;
    drawPoint(ctx, options2, this.x, this.y);
  }
  getRange() {
    const options2 = this.options || {};
    return options2.radius + options2.hitRadius;
  }
}
__publicField(PointElement, "id", "point");
/**
* @type {any}
*/
__publicField(PointElement, "defaults", {
  borderWidth: 1,
  hitRadius: 1,
  hoverBorderWidth: 1,
  hoverRadius: 4,
  pointStyle: "circle",
  radius: 3,
  rotation: 0
});
/**
* @type {any}
*/
__publicField(PointElement, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
});
function getBarBounds$1(bar, useFinalPosition) {
  const { x: x2, y: y2, base, width, height: height2 } = bar.getProps([
    "x",
    "y",
    "base",
    "width",
    "height"
  ], useFinalPosition);
  let left, right, top, bottom, half;
  if (bar.horizontal) {
    half = height2 / 2;
    left = Math.min(x2, base);
    right = Math.max(x2, base);
    top = y2 - half;
    bottom = y2 + half;
  } else {
    half = width / 2;
    left = x2 - half;
    right = x2 + half;
    top = Math.min(y2, base);
    bottom = Math.max(y2, base);
  }
  return {
    left,
    top,
    right,
    bottom
  };
}
function skipOrLimit(skip2, value, min2, max2) {
  return skip2 ? 0 : _limitValue(value, min2, max2);
}
function parseBorderWidth(bar, maxW, maxH) {
  const value = bar.options.borderWidth;
  const skip2 = bar.borderSkipped;
  const o2 = toTRBL(value);
  return {
    t: skipOrLimit(skip2.top, o2.top, 0, maxH),
    r: skipOrLimit(skip2.right, o2.right, 0, maxW),
    b: skipOrLimit(skip2.bottom, o2.bottom, 0, maxH),
    l: skipOrLimit(skip2.left, o2.left, 0, maxW)
  };
}
function parseBorderRadius(bar, maxW, maxH) {
  const { enableBorderRadius } = bar.getProps([
    "enableBorderRadius"
  ]);
  const value = bar.options.borderRadius;
  const o2 = toTRBLCorners(value);
  const maxR = Math.min(maxW, maxH);
  const skip2 = bar.borderSkipped;
  const enableBorder = enableBorderRadius || isObject(value);
  return {
    topLeft: skipOrLimit(!enableBorder || skip2.top || skip2.left, o2.topLeft, 0, maxR),
    topRight: skipOrLimit(!enableBorder || skip2.top || skip2.right, o2.topRight, 0, maxR),
    bottomLeft: skipOrLimit(!enableBorder || skip2.bottom || skip2.left, o2.bottomLeft, 0, maxR),
    bottomRight: skipOrLimit(!enableBorder || skip2.bottom || skip2.right, o2.bottomRight, 0, maxR)
  };
}
function boundingRects(bar) {
  const bounds = getBarBounds$1(bar);
  const width = bounds.right - bounds.left;
  const height2 = bounds.bottom - bounds.top;
  const border = parseBorderWidth(bar, width / 2, height2 / 2);
  const radius = parseBorderRadius(bar, width / 2, height2 / 2);
  return {
    outer: {
      x: bounds.left,
      y: bounds.top,
      w: width,
      h: height2,
      radius
    },
    inner: {
      x: bounds.left + border.l,
      y: bounds.top + border.t,
      w: width - border.l - border.r,
      h: height2 - border.t - border.b,
      radius: {
        topLeft: Math.max(0, radius.topLeft - Math.max(border.t, border.l)),
        topRight: Math.max(0, radius.topRight - Math.max(border.t, border.r)),
        bottomLeft: Math.max(0, radius.bottomLeft - Math.max(border.b, border.l)),
        bottomRight: Math.max(0, radius.bottomRight - Math.max(border.b, border.r))
      }
    }
  };
}
function inRange$2(bar, x2, y2, useFinalPosition) {
  const skipX = x2 === null;
  const skipY = y2 === null;
  const skipBoth = skipX && skipY;
  const bounds = bar && !skipBoth && getBarBounds$1(bar, useFinalPosition);
  return bounds && (skipX || _isBetween(x2, bounds.left, bounds.right)) && (skipY || _isBetween(y2, bounds.top, bounds.bottom));
}
function hasRadius(radius) {
  return radius.topLeft || radius.topRight || radius.bottomLeft || radius.bottomRight;
}
function addNormalRectPath(ctx, rect) {
  ctx.rect(rect.x, rect.y, rect.w, rect.h);
}
function inflateRect(rect, amount, refRect = {}) {
  const x2 = rect.x !== refRect.x ? -amount : 0;
  const y2 = rect.y !== refRect.y ? -amount : 0;
  const w2 = (rect.x + rect.w !== refRect.x + refRect.w ? amount : 0) - x2;
  const h3 = (rect.y + rect.h !== refRect.y + refRect.h ? amount : 0) - y2;
  return {
    x: rect.x + x2,
    y: rect.y + y2,
    w: rect.w + w2,
    h: rect.h + h3,
    radius: rect.radius
  };
}
class BarElement extends Element$1 {
  constructor(cfg) {
    super();
    this.options = void 0;
    this.horizontal = void 0;
    this.base = void 0;
    this.width = void 0;
    this.height = void 0;
    this.inflateAmount = void 0;
    if (cfg) {
      Object.assign(this, cfg);
    }
  }
  draw(ctx) {
    const { inflateAmount, options: { borderColor, backgroundColor } } = this;
    const { inner, outer } = boundingRects(this);
    const addRectPath = hasRadius(outer.radius) ? addRoundedRectPath : addNormalRectPath;
    ctx.save();
    if (outer.w !== inner.w || outer.h !== inner.h) {
      ctx.beginPath();
      addRectPath(ctx, inflateRect(outer, inflateAmount, inner));
      ctx.clip();
      addRectPath(ctx, inflateRect(inner, -inflateAmount, outer));
      ctx.fillStyle = borderColor;
      ctx.fill("evenodd");
    }
    ctx.beginPath();
    addRectPath(ctx, inflateRect(inner, inflateAmount));
    ctx.fillStyle = backgroundColor;
    ctx.fill();
    ctx.restore();
  }
  inRange(mouseX, mouseY, useFinalPosition) {
    return inRange$2(this, mouseX, mouseY, useFinalPosition);
  }
  inXRange(mouseX, useFinalPosition) {
    return inRange$2(this, mouseX, null, useFinalPosition);
  }
  inYRange(mouseY, useFinalPosition) {
    return inRange$2(this, null, mouseY, useFinalPosition);
  }
  getCenterPoint(useFinalPosition) {
    const { x: x2, y: y2, base, horizontal } = this.getProps([
      "x",
      "y",
      "base",
      "horizontal"
    ], useFinalPosition);
    return {
      x: horizontal ? (x2 + base) / 2 : x2,
      y: horizontal ? y2 : (y2 + base) / 2
    };
  }
  getRange(axis) {
    return axis === "x" ? this.width / 2 : this.height / 2;
  }
}
__publicField(BarElement, "id", "bar");
__publicField(BarElement, "defaults", {
  borderSkipped: "start",
  borderWidth: 0,
  borderRadius: 0,
  inflateAmount: "auto",
  pointStyle: void 0
});
__publicField(BarElement, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
});
var elements = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ArcElement,
  BarElement,
  LineElement,
  PointElement
});
const BORDER_COLORS = [
  "rgb(54, 162, 235)",
  "rgb(255, 99, 132)",
  "rgb(255, 159, 64)",
  "rgb(255, 205, 86)",
  "rgb(75, 192, 192)",
  "rgb(153, 102, 255)",
  "rgb(201, 203, 207)"
  // grey
];
const BACKGROUND_COLORS = /* @__PURE__ */ BORDER_COLORS.map((color2) => color2.replace("rgb(", "rgba(").replace(")", ", 0.5)"));
function getBorderColor(i) {
  return BORDER_COLORS[i % BORDER_COLORS.length];
}
function getBackgroundColor(i) {
  return BACKGROUND_COLORS[i % BACKGROUND_COLORS.length];
}
function colorizeDefaultDataset(dataset, i) {
  dataset.borderColor = getBorderColor(i);
  dataset.backgroundColor = getBackgroundColor(i);
  return ++i;
}
function colorizeDoughnutDataset(dataset, i) {
  dataset.backgroundColor = dataset.data.map(() => getBorderColor(i++));
  return i;
}
function colorizePolarAreaDataset(dataset, i) {
  dataset.backgroundColor = dataset.data.map(() => getBackgroundColor(i++));
  return i;
}
function getColorizer(chart) {
  let i = 0;
  return (dataset, datasetIndex) => {
    const controller = chart.getDatasetMeta(datasetIndex).controller;
    if (controller instanceof DoughnutController) {
      i = colorizeDoughnutDataset(dataset, i);
    } else if (controller instanceof PolarAreaController) {
      i = colorizePolarAreaDataset(dataset, i);
    } else if (controller) {
      i = colorizeDefaultDataset(dataset, i);
    }
  };
}
function containsColorsDefinitions(descriptors2) {
  let k2;
  for (k2 in descriptors2) {
    if (descriptors2[k2].borderColor || descriptors2[k2].backgroundColor) {
      return true;
    }
  }
  return false;
}
function containsColorsDefinition(descriptor) {
  return descriptor && (descriptor.borderColor || descriptor.backgroundColor);
}
var plugin_colors = {
  id: "colors",
  defaults: {
    enabled: true,
    forceOverride: false
  },
  beforeLayout(chart, _args, options2) {
    if (!options2.enabled) {
      return;
    }
    const { data: { datasets }, options: chartOptions } = chart.config;
    const { elements: elements2 } = chartOptions;
    if (!options2.forceOverride && (containsColorsDefinitions(datasets) || containsColorsDefinition(chartOptions) || elements2 && containsColorsDefinitions(elements2))) {
      return;
    }
    const colorizer = getColorizer(chart);
    datasets.forEach(colorizer);
  }
};
function lttbDecimation(data2, start, count, availableWidth, options2) {
  const samples = options2.samples || availableWidth;
  if (samples >= count) {
    return data2.slice(start, start + count);
  }
  const decimated = [];
  const bucketWidth = (count - 2) / (samples - 2);
  let sampledIndex = 0;
  const endIndex = start + count - 1;
  let a2 = start;
  let i, maxAreaPoint, maxArea, area, nextA;
  decimated[sampledIndex++] = data2[a2];
  for (i = 0; i < samples - 2; i++) {
    let avgX = 0;
    let avgY = 0;
    let j;
    const avgRangeStart = Math.floor((i + 1) * bucketWidth) + 1 + start;
    const avgRangeEnd = Math.min(Math.floor((i + 2) * bucketWidth) + 1, count) + start;
    const avgRangeLength = avgRangeEnd - avgRangeStart;
    for (j = avgRangeStart; j < avgRangeEnd; j++) {
      avgX += data2[j].x;
      avgY += data2[j].y;
    }
    avgX /= avgRangeLength;
    avgY /= avgRangeLength;
    const rangeOffs = Math.floor(i * bucketWidth) + 1 + start;
    const rangeTo = Math.min(Math.floor((i + 1) * bucketWidth) + 1, count) + start;
    const { x: pointAx, y: pointAy } = data2[a2];
    maxArea = area = -1;
    for (j = rangeOffs; j < rangeTo; j++) {
      area = 0.5 * Math.abs((pointAx - avgX) * (data2[j].y - pointAy) - (pointAx - data2[j].x) * (avgY - pointAy));
      if (area > maxArea) {
        maxArea = area;
        maxAreaPoint = data2[j];
        nextA = j;
      }
    }
    decimated[sampledIndex++] = maxAreaPoint;
    a2 = nextA;
  }
  decimated[sampledIndex++] = data2[endIndex];
  return decimated;
}
function minMaxDecimation(data2, start, count, availableWidth) {
  let avgX = 0;
  let countX = 0;
  let i, point, x2, y2, prevX, minIndex, maxIndex, startIndex, minY, maxY;
  const decimated = [];
  const endIndex = start + count - 1;
  const xMin = data2[start].x;
  const xMax = data2[endIndex].x;
  const dx = xMax - xMin;
  for (i = start; i < start + count; ++i) {
    point = data2[i];
    x2 = (point.x - xMin) / dx * availableWidth;
    y2 = point.y;
    const truncX = x2 | 0;
    if (truncX === prevX) {
      if (y2 < minY) {
        minY = y2;
        minIndex = i;
      } else if (y2 > maxY) {
        maxY = y2;
        maxIndex = i;
      }
      avgX = (countX * avgX + point.x) / ++countX;
    } else {
      const lastIndex = i - 1;
      if (!isNullOrUndef(minIndex) && !isNullOrUndef(maxIndex)) {
        const intermediateIndex1 = Math.min(minIndex, maxIndex);
        const intermediateIndex2 = Math.max(minIndex, maxIndex);
        if (intermediateIndex1 !== startIndex && intermediateIndex1 !== lastIndex) {
          decimated.push({
            ...data2[intermediateIndex1],
            x: avgX
          });
        }
        if (intermediateIndex2 !== startIndex && intermediateIndex2 !== lastIndex) {
          decimated.push({
            ...data2[intermediateIndex2],
            x: avgX
          });
        }
      }
      if (i > 0 && lastIndex !== startIndex) {
        decimated.push(data2[lastIndex]);
      }
      decimated.push(point);
      prevX = truncX;
      countX = 0;
      minY = maxY = y2;
      minIndex = maxIndex = startIndex = i;
    }
  }
  return decimated;
}
function cleanDecimatedDataset(dataset) {
  if (dataset._decimated) {
    const data2 = dataset._data;
    delete dataset._decimated;
    delete dataset._data;
    Object.defineProperty(dataset, "data", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: data2
    });
  }
}
function cleanDecimatedData(chart) {
  chart.data.datasets.forEach((dataset) => {
    cleanDecimatedDataset(dataset);
  });
}
function getStartAndCountOfVisiblePointsSimplified(meta, points) {
  const pointCount = points.length;
  let start = 0;
  let count;
  const { iScale } = meta;
  const { min: min2, max: max2, minDefined, maxDefined } = iScale.getUserBounds();
  if (minDefined) {
    start = _limitValue(_lookupByKey(points, iScale.axis, min2).lo, 0, pointCount - 1);
  }
  if (maxDefined) {
    count = _limitValue(_lookupByKey(points, iScale.axis, max2).hi + 1, start, pointCount) - start;
  } else {
    count = pointCount - start;
  }
  return {
    start,
    count
  };
}
var plugin_decimation = {
  id: "decimation",
  defaults: {
    algorithm: "min-max",
    enabled: false
  },
  beforeElementsUpdate: (chart, args, options2) => {
    if (!options2.enabled) {
      cleanDecimatedData(chart);
      return;
    }
    const availableWidth = chart.width;
    chart.data.datasets.forEach((dataset, datasetIndex) => {
      const { _data, indexAxis } = dataset;
      const meta = chart.getDatasetMeta(datasetIndex);
      const data2 = _data || dataset.data;
      if (resolve([
        indexAxis,
        chart.options.indexAxis
      ]) === "y") {
        return;
      }
      if (!meta.controller.supportsDecimation) {
        return;
      }
      const xAxis = chart.scales[meta.xAxisID];
      if (xAxis.type !== "linear" && xAxis.type !== "time") {
        return;
      }
      if (chart.options.parsing) {
        return;
      }
      let { start, count } = getStartAndCountOfVisiblePointsSimplified(meta, data2);
      const threshold = options2.threshold || 4 * availableWidth;
      if (count <= threshold) {
        cleanDecimatedDataset(dataset);
        return;
      }
      if (isNullOrUndef(_data)) {
        dataset._data = data2;
        delete dataset.data;
        Object.defineProperty(dataset, "data", {
          configurable: true,
          enumerable: true,
          get: function() {
            return this._decimated;
          },
          set: function(d2) {
            this._data = d2;
          }
        });
      }
      let decimated;
      switch (options2.algorithm) {
        case "lttb":
          decimated = lttbDecimation(data2, start, count, availableWidth, options2);
          break;
        case "min-max":
          decimated = minMaxDecimation(data2, start, count, availableWidth);
          break;
        default:
          throw new Error(`Unsupported decimation algorithm '${options2.algorithm}'`);
      }
      dataset._decimated = decimated;
    });
  },
  destroy(chart) {
    cleanDecimatedData(chart);
  }
};
function _segments(line2, target, property) {
  const segments = line2.segments;
  const points = line2.points;
  const tpoints = target.points;
  const parts = [];
  for (const segment of segments) {
    let { start, end } = segment;
    end = _findSegmentEnd(start, end, points);
    const bounds = _getBounds(property, points[start], points[end], segment.loop);
    if (!target.segments) {
      parts.push({
        source: segment,
        target: bounds,
        start: points[start],
        end: points[end]
      });
      continue;
    }
    const targetSegments = _boundSegments(target, bounds);
    for (const tgt of targetSegments) {
      const subBounds = _getBounds(property, tpoints[tgt.start], tpoints[tgt.end], tgt.loop);
      const fillSources = _boundSegment(segment, points, subBounds);
      for (const fillSource of fillSources) {
        parts.push({
          source: fillSource,
          target: tgt,
          start: {
            [property]: _getEdge(bounds, subBounds, "start", Math.max)
          },
          end: {
            [property]: _getEdge(bounds, subBounds, "end", Math.min)
          }
        });
      }
    }
  }
  return parts;
}
function _getBounds(property, first, last2, loop) {
  if (loop) {
    return;
  }
  let start = first[property];
  let end = last2[property];
  if (property === "angle") {
    start = _normalizeAngle(start);
    end = _normalizeAngle(end);
  }
  return {
    property,
    start,
    end
  };
}
function _pointsFromSegments(boundary, line2) {
  const { x: x2 = null, y: y2 = null } = boundary || {};
  const linePoints = line2.points;
  const points = [];
  line2.segments.forEach(({ start, end }) => {
    end = _findSegmentEnd(start, end, linePoints);
    const first = linePoints[start];
    const last2 = linePoints[end];
    if (y2 !== null) {
      points.push({
        x: first.x,
        y: y2
      });
      points.push({
        x: last2.x,
        y: y2
      });
    } else if (x2 !== null) {
      points.push({
        x: x2,
        y: first.y
      });
      points.push({
        x: x2,
        y: last2.y
      });
    }
  });
  return points;
}
function _findSegmentEnd(start, end, points) {
  for (; end > start; end--) {
    const point = points[end];
    if (!isNaN(point.x) && !isNaN(point.y)) {
      break;
    }
  }
  return end;
}
function _getEdge(a2, b2, prop, fn) {
  if (a2 && b2) {
    return fn(a2[prop], b2[prop]);
  }
  return a2 ? a2[prop] : b2 ? b2[prop] : 0;
}
function _createBoundaryLine(boundary, line2) {
  let points = [];
  let _loop = false;
  if (isArray$1(boundary)) {
    _loop = true;
    points = boundary;
  } else {
    points = _pointsFromSegments(boundary, line2);
  }
  return points.length ? new LineElement({
    points,
    options: {
      tension: 0
    },
    _loop,
    _fullLoop: _loop
  }) : null;
}
function _shouldApplyFill(source) {
  return source && source.fill !== false;
}
function _resolveTarget(sources, index2, propagate) {
  const source = sources[index2];
  let fill2 = source.fill;
  const visited = [
    index2
  ];
  let target;
  if (!propagate) {
    return fill2;
  }
  while (fill2 !== false && visited.indexOf(fill2) === -1) {
    if (!isNumberFinite(fill2)) {
      return fill2;
    }
    target = sources[fill2];
    if (!target) {
      return false;
    }
    if (target.visible) {
      return fill2;
    }
    visited.push(fill2);
    fill2 = target.fill;
  }
  return false;
}
function _decodeFill(line2, index2, count) {
  const fill2 = parseFillOption(line2);
  if (isObject(fill2)) {
    return isNaN(fill2.value) ? false : fill2;
  }
  let target = parseFloat(fill2);
  if (isNumberFinite(target) && Math.floor(target) === target) {
    return decodeTargetIndex(fill2[0], index2, target, count);
  }
  return [
    "origin",
    "start",
    "end",
    "stack",
    "shape"
  ].indexOf(fill2) >= 0 && fill2;
}
function decodeTargetIndex(firstCh, index2, target, count) {
  if (firstCh === "-" || firstCh === "+") {
    target = index2 + target;
  }
  if (target === index2 || target < 0 || target >= count) {
    return false;
  }
  return target;
}
function _getTargetPixel(fill2, scale2) {
  let pixel = null;
  if (fill2 === "start") {
    pixel = scale2.bottom;
  } else if (fill2 === "end") {
    pixel = scale2.top;
  } else if (isObject(fill2)) {
    pixel = scale2.getPixelForValue(fill2.value);
  } else if (scale2.getBasePixel) {
    pixel = scale2.getBasePixel();
  }
  return pixel;
}
function _getTargetValue(fill2, scale2, startValue) {
  let value;
  if (fill2 === "start") {
    value = startValue;
  } else if (fill2 === "end") {
    value = scale2.options.reverse ? scale2.min : scale2.max;
  } else if (isObject(fill2)) {
    value = fill2.value;
  } else {
    value = scale2.getBaseValue();
  }
  return value;
}
function parseFillOption(line2) {
  const options2 = line2.options;
  const fillOption = options2.fill;
  let fill2 = valueOrDefault(fillOption && fillOption.target, fillOption);
  if (fill2 === void 0) {
    fill2 = !!options2.backgroundColor;
  }
  if (fill2 === false || fill2 === null) {
    return false;
  }
  if (fill2 === true) {
    return "origin";
  }
  return fill2;
}
function _buildStackLine(source) {
  const { scale: scale2, index: index2, line: line2 } = source;
  const points = [];
  const segments = line2.segments;
  const sourcePoints = line2.points;
  const linesBelow = getLinesBelow(scale2, index2);
  linesBelow.push(_createBoundaryLine({
    x: null,
    y: scale2.bottom
  }, line2));
  for (let i = 0; i < segments.length; i++) {
    const segment = segments[i];
    for (let j = segment.start; j <= segment.end; j++) {
      addPointsBelow(points, sourcePoints[j], linesBelow);
    }
  }
  return new LineElement({
    points,
    options: {}
  });
}
function getLinesBelow(scale2, index2) {
  const below = [];
  const metas = scale2.getMatchingVisibleMetas("line");
  for (let i = 0; i < metas.length; i++) {
    const meta = metas[i];
    if (meta.index === index2) {
      break;
    }
    if (!meta.hidden) {
      below.unshift(meta.dataset);
    }
  }
  return below;
}
function addPointsBelow(points, sourcePoint, linesBelow) {
  const postponed = [];
  for (let j = 0; j < linesBelow.length; j++) {
    const line2 = linesBelow[j];
    const { first, last: last2, point } = findPoint(line2, sourcePoint, "x");
    if (!point || first && last2) {
      continue;
    }
    if (first) {
      postponed.unshift(point);
    } else {
      points.push(point);
      if (!last2) {
        break;
      }
    }
  }
  points.push(...postponed);
}
function findPoint(line2, sourcePoint, property) {
  const point = line2.interpolate(sourcePoint, property);
  if (!point) {
    return {};
  }
  const pointValue = point[property];
  const segments = line2.segments;
  const linePoints = line2.points;
  let first = false;
  let last2 = false;
  for (let i = 0; i < segments.length; i++) {
    const segment = segments[i];
    const firstValue = linePoints[segment.start][property];
    const lastValue = linePoints[segment.end][property];
    if (_isBetween(pointValue, firstValue, lastValue)) {
      first = pointValue === firstValue;
      last2 = pointValue === lastValue;
      break;
    }
  }
  return {
    first,
    last: last2,
    point
  };
}
class simpleArc {
  constructor(opts) {
    this.x = opts.x;
    this.y = opts.y;
    this.radius = opts.radius;
  }
  pathSegment(ctx, bounds, opts) {
    const { x: x2, y: y2, radius } = this;
    bounds = bounds || {
      start: 0,
      end: TAU
    };
    ctx.arc(x2, y2, radius, bounds.end, bounds.start, true);
    return !opts.bounds;
  }
  interpolate(point) {
    const { x: x2, y: y2, radius } = this;
    const angle = point.angle;
    return {
      x: x2 + Math.cos(angle) * radius,
      y: y2 + Math.sin(angle) * radius,
      angle
    };
  }
}
function _getTarget(source) {
  const { chart, fill: fill2, line: line2 } = source;
  if (isNumberFinite(fill2)) {
    return getLineByIndex(chart, fill2);
  }
  if (fill2 === "stack") {
    return _buildStackLine(source);
  }
  if (fill2 === "shape") {
    return true;
  }
  const boundary = computeBoundary(source);
  if (boundary instanceof simpleArc) {
    return boundary;
  }
  return _createBoundaryLine(boundary, line2);
}
function getLineByIndex(chart, index2) {
  const meta = chart.getDatasetMeta(index2);
  const visible = meta && chart.isDatasetVisible(index2);
  return visible ? meta.dataset : null;
}
function computeBoundary(source) {
  const scale2 = source.scale || {};
  if (scale2.getPointPositionForValue) {
    return computeCircularBoundary(source);
  }
  return computeLinearBoundary(source);
}
function computeLinearBoundary(source) {
  const { scale: scale2 = {}, fill: fill2 } = source;
  const pixel = _getTargetPixel(fill2, scale2);
  if (isNumberFinite(pixel)) {
    const horizontal = scale2.isHorizontal();
    return {
      x: horizontal ? pixel : null,
      y: horizontal ? null : pixel
    };
  }
  return null;
}
function computeCircularBoundary(source) {
  const { scale: scale2, fill: fill2 } = source;
  const options2 = scale2.options;
  const length2 = scale2.getLabels().length;
  const start = options2.reverse ? scale2.max : scale2.min;
  const value = _getTargetValue(fill2, scale2, start);
  const target = [];
  if (options2.grid.circular) {
    const center = scale2.getPointPositionForValue(0, start);
    return new simpleArc({
      x: center.x,
      y: center.y,
      radius: scale2.getDistanceFromCenterForValue(value)
    });
  }
  for (let i = 0; i < length2; ++i) {
    target.push(scale2.getPointPositionForValue(i, value));
  }
  return target;
}
function _drawfill(ctx, source, area) {
  const target = _getTarget(source);
  const { line: line2, scale: scale2, axis } = source;
  const lineOpts = line2.options;
  const fillOption = lineOpts.fill;
  const color2 = lineOpts.backgroundColor;
  const { above = color2, below = color2 } = fillOption || {};
  if (target && line2.points.length) {
    clipArea(ctx, area);
    doFill(ctx, {
      line: line2,
      target,
      above,
      below,
      area,
      scale: scale2,
      axis
    });
    unclipArea(ctx);
  }
}
function doFill(ctx, cfg) {
  const { line: line2, target, above, below, area, scale: scale2 } = cfg;
  const property = line2._loop ? "angle" : cfg.axis;
  ctx.save();
  if (property === "x" && below !== above) {
    clipVertical(ctx, target, area.top);
    fill(ctx, {
      line: line2,
      target,
      color: above,
      scale: scale2,
      property
    });
    ctx.restore();
    ctx.save();
    clipVertical(ctx, target, area.bottom);
  }
  fill(ctx, {
    line: line2,
    target,
    color: below,
    scale: scale2,
    property
  });
  ctx.restore();
}
function clipVertical(ctx, target, clipY) {
  const { segments, points } = target;
  let first = true;
  let lineLoop = false;
  ctx.beginPath();
  for (const segment of segments) {
    const { start, end } = segment;
    const firstPoint = points[start];
    const lastPoint = points[_findSegmentEnd(start, end, points)];
    if (first) {
      ctx.moveTo(firstPoint.x, firstPoint.y);
      first = false;
    } else {
      ctx.lineTo(firstPoint.x, clipY);
      ctx.lineTo(firstPoint.x, firstPoint.y);
    }
    lineLoop = !!target.pathSegment(ctx, segment, {
      move: lineLoop
    });
    if (lineLoop) {
      ctx.closePath();
    } else {
      ctx.lineTo(lastPoint.x, clipY);
    }
  }
  ctx.lineTo(target.first().x, clipY);
  ctx.closePath();
  ctx.clip();
}
function fill(ctx, cfg) {
  const { line: line2, target, property, color: color2, scale: scale2 } = cfg;
  const segments = _segments(line2, target, property);
  for (const { source: src2, target: tgt, start, end } of segments) {
    const { style: { backgroundColor = color2 } = {} } = src2;
    const notShape = target !== true;
    ctx.save();
    ctx.fillStyle = backgroundColor;
    clipBounds(ctx, scale2, notShape && _getBounds(property, start, end));
    ctx.beginPath();
    const lineLoop = !!line2.pathSegment(ctx, src2);
    let loop;
    if (notShape) {
      if (lineLoop) {
        ctx.closePath();
      } else {
        interpolatedLineTo(ctx, target, end, property);
      }
      const targetLoop = !!target.pathSegment(ctx, tgt, {
        move: lineLoop,
        reverse: true
      });
      loop = lineLoop && targetLoop;
      if (!loop) {
        interpolatedLineTo(ctx, target, start, property);
      }
    }
    ctx.closePath();
    ctx.fill(loop ? "evenodd" : "nonzero");
    ctx.restore();
  }
}
function clipBounds(ctx, scale2, bounds) {
  const { top, bottom } = scale2.chart.chartArea;
  const { property, start, end } = bounds || {};
  if (property === "x") {
    ctx.beginPath();
    ctx.rect(start, top, end - start, bottom - top);
    ctx.clip();
  }
}
function interpolatedLineTo(ctx, target, point, property) {
  const interpolatedPoint = target.interpolate(point, property);
  if (interpolatedPoint) {
    ctx.lineTo(interpolatedPoint.x, interpolatedPoint.y);
  }
}
var index$3 = {
  id: "filler",
  afterDatasetsUpdate(chart, _args, options2) {
    const count = (chart.data.datasets || []).length;
    const sources = [];
    let meta, i, line2, source;
    for (i = 0; i < count; ++i) {
      meta = chart.getDatasetMeta(i);
      line2 = meta.dataset;
      source = null;
      if (line2 && line2.options && line2 instanceof LineElement) {
        source = {
          visible: chart.isDatasetVisible(i),
          index: i,
          fill: _decodeFill(line2, i, count),
          chart,
          axis: meta.controller.options.indexAxis,
          scale: meta.vScale,
          line: line2
        };
      }
      meta.$filler = source;
      sources.push(source);
    }
    for (i = 0; i < count; ++i) {
      source = sources[i];
      if (!source || source.fill === false) {
        continue;
      }
      source.fill = _resolveTarget(sources, i, options2.propagate);
    }
  },
  beforeDraw(chart, _args, options2) {
    const draw2 = options2.drawTime === "beforeDraw";
    const metasets = chart.getSortedVisibleDatasetMetas();
    const area = chart.chartArea;
    for (let i = metasets.length - 1; i >= 0; --i) {
      const source = metasets[i].$filler;
      if (!source) {
        continue;
      }
      source.line.updateControlPoints(area, source.axis);
      if (draw2 && source.fill) {
        _drawfill(chart.ctx, source, area);
      }
    }
  },
  beforeDatasetsDraw(chart, _args, options2) {
    if (options2.drawTime !== "beforeDatasetsDraw") {
      return;
    }
    const metasets = chart.getSortedVisibleDatasetMetas();
    for (let i = metasets.length - 1; i >= 0; --i) {
      const source = metasets[i].$filler;
      if (_shouldApplyFill(source)) {
        _drawfill(chart.ctx, source, chart.chartArea);
      }
    }
  },
  beforeDatasetDraw(chart, args, options2) {
    const source = args.meta.$filler;
    if (!_shouldApplyFill(source) || options2.drawTime !== "beforeDatasetDraw") {
      return;
    }
    _drawfill(chart.ctx, source, chart.chartArea);
  },
  defaults: {
    propagate: true,
    drawTime: "beforeDatasetDraw"
  }
};
const getBoxSize = (labelOpts, fontSize) => {
  let { boxHeight = fontSize, boxWidth = fontSize } = labelOpts;
  if (labelOpts.usePointStyle) {
    boxHeight = Math.min(boxHeight, fontSize);
    boxWidth = labelOpts.pointStyleWidth || Math.min(boxWidth, fontSize);
  }
  return {
    boxWidth,
    boxHeight,
    itemHeight: Math.max(fontSize, boxHeight)
  };
};
const itemsEqual = (a2, b2) => a2 !== null && b2 !== null && a2.datasetIndex === b2.datasetIndex && a2.index === b2.index;
let Legend$1 = class Legend extends Element$1 {
  constructor(config2) {
    super();
    this._added = false;
    this.legendHitBoxes = [];
    this._hoveredItem = null;
    this.doughnutMode = false;
    this.chart = config2.chart;
    this.options = config2.options;
    this.ctx = config2.ctx;
    this.legendItems = void 0;
    this.columnSizes = void 0;
    this.lineWidths = void 0;
    this.maxHeight = void 0;
    this.maxWidth = void 0;
    this.top = void 0;
    this.bottom = void 0;
    this.left = void 0;
    this.right = void 0;
    this.height = void 0;
    this.width = void 0;
    this._margins = void 0;
    this.position = void 0;
    this.weight = void 0;
    this.fullSize = void 0;
  }
  update(maxWidth, maxHeight, margins) {
    this.maxWidth = maxWidth;
    this.maxHeight = maxHeight;
    this._margins = margins;
    this.setDimensions();
    this.buildLabels();
    this.fit();
  }
  setDimensions() {
    if (this.isHorizontal()) {
      this.width = this.maxWidth;
      this.left = this._margins.left;
      this.right = this.width;
    } else {
      this.height = this.maxHeight;
      this.top = this._margins.top;
      this.bottom = this.height;
    }
  }
  buildLabels() {
    const labelOpts = this.options.labels || {};
    let legendItems = callback(labelOpts.generateLabels, [
      this.chart
    ], this) || [];
    if (labelOpts.filter) {
      legendItems = legendItems.filter((item) => labelOpts.filter(item, this.chart.data));
    }
    if (labelOpts.sort) {
      legendItems = legendItems.sort((a2, b2) => labelOpts.sort(a2, b2, this.chart.data));
    }
    if (this.options.reverse) {
      legendItems.reverse();
    }
    this.legendItems = legendItems;
  }
  fit() {
    const { options: options2, ctx } = this;
    if (!options2.display) {
      this.width = this.height = 0;
      return;
    }
    const labelOpts = options2.labels;
    const labelFont = toFont(labelOpts.font);
    const fontSize = labelFont.size;
    const titleHeight = this._computeTitleHeight();
    const { boxWidth, itemHeight } = getBoxSize(labelOpts, fontSize);
    let width, height2;
    ctx.font = labelFont.string;
    if (this.isHorizontal()) {
      width = this.maxWidth;
      height2 = this._fitRows(titleHeight, fontSize, boxWidth, itemHeight) + 10;
    } else {
      height2 = this.maxHeight;
      width = this._fitCols(titleHeight, labelFont, boxWidth, itemHeight) + 10;
    }
    this.width = Math.min(width, options2.maxWidth || this.maxWidth);
    this.height = Math.min(height2, options2.maxHeight || this.maxHeight);
  }
  _fitRows(titleHeight, fontSize, boxWidth, itemHeight) {
    const { ctx, maxWidth, options: { labels: { padding } } } = this;
    const hitboxes = this.legendHitBoxes = [];
    const lineWidths = this.lineWidths = [
      0
    ];
    const lineHeight = itemHeight + padding;
    let totalHeight = titleHeight;
    ctx.textAlign = "left";
    ctx.textBaseline = "middle";
    let row2 = -1;
    let top = -lineHeight;
    this.legendItems.forEach((legendItem, i) => {
      const itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
      if (i === 0 || lineWidths[lineWidths.length - 1] + itemWidth + 2 * padding > maxWidth) {
        totalHeight += lineHeight;
        lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
        top += lineHeight;
        row2++;
      }
      hitboxes[i] = {
        left: 0,
        top,
        row: row2,
        width: itemWidth,
        height: itemHeight
      };
      lineWidths[lineWidths.length - 1] += itemWidth + padding;
    });
    return totalHeight;
  }
  _fitCols(titleHeight, labelFont, boxWidth, _itemHeight) {
    const { ctx, maxHeight, options: { labels: { padding } } } = this;
    const hitboxes = this.legendHitBoxes = [];
    const columnSizes = this.columnSizes = [];
    const heightLimit = maxHeight - titleHeight;
    let totalWidth = padding;
    let currentColWidth = 0;
    let currentColHeight = 0;
    let left = 0;
    let col = 0;
    this.legendItems.forEach((legendItem, i) => {
      const { itemWidth, itemHeight } = calculateItemSize(boxWidth, labelFont, ctx, legendItem, _itemHeight);
      if (i > 0 && currentColHeight + itemHeight + 2 * padding > heightLimit) {
        totalWidth += currentColWidth + padding;
        columnSizes.push({
          width: currentColWidth,
          height: currentColHeight
        });
        left += currentColWidth + padding;
        col++;
        currentColWidth = currentColHeight = 0;
      }
      hitboxes[i] = {
        left,
        top: currentColHeight,
        col,
        width: itemWidth,
        height: itemHeight
      };
      currentColWidth = Math.max(currentColWidth, itemWidth);
      currentColHeight += itemHeight + padding;
    });
    totalWidth += currentColWidth;
    columnSizes.push({
      width: currentColWidth,
      height: currentColHeight
    });
    return totalWidth;
  }
  adjustHitBoxes() {
    if (!this.options.display) {
      return;
    }
    const titleHeight = this._computeTitleHeight();
    const { legendHitBoxes: hitboxes, options: { align, labels: { padding }, rtl } } = this;
    const rtlHelper = getRtlAdapter(rtl, this.left, this.width);
    if (this.isHorizontal()) {
      let row2 = 0;
      let left = _alignStartEnd(align, this.left + padding, this.right - this.lineWidths[row2]);
      for (const hitbox of hitboxes) {
        if (row2 !== hitbox.row) {
          row2 = hitbox.row;
          left = _alignStartEnd(align, this.left + padding, this.right - this.lineWidths[row2]);
        }
        hitbox.top += this.top + titleHeight + padding;
        hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(left), hitbox.width);
        left += hitbox.width + padding;
      }
    } else {
      let col = 0;
      let top = _alignStartEnd(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
      for (const hitbox of hitboxes) {
        if (hitbox.col !== col) {
          col = hitbox.col;
          top = _alignStartEnd(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
        }
        hitbox.top = top;
        hitbox.left += this.left + padding;
        hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(hitbox.left), hitbox.width);
        top += hitbox.height + padding;
      }
    }
  }
  isHorizontal() {
    return this.options.position === "top" || this.options.position === "bottom";
  }
  draw() {
    if (this.options.display) {
      const ctx = this.ctx;
      clipArea(ctx, this);
      this._draw();
      unclipArea(ctx);
    }
  }
  _draw() {
    const { options: opts, columnSizes, lineWidths, ctx } = this;
    const { align, labels: labelOpts } = opts;
    const defaultColor = defaults$3.color;
    const rtlHelper = getRtlAdapter(opts.rtl, this.left, this.width);
    const labelFont = toFont(labelOpts.font);
    const { padding } = labelOpts;
    const fontSize = labelFont.size;
    const halfFontSize = fontSize / 2;
    let cursor2;
    this.drawTitle();
    ctx.textAlign = rtlHelper.textAlign("left");
    ctx.textBaseline = "middle";
    ctx.lineWidth = 0.5;
    ctx.font = labelFont.string;
    const { boxWidth, boxHeight, itemHeight } = getBoxSize(labelOpts, fontSize);
    const drawLegendBox = function(x2, y2, legendItem) {
      if (isNaN(boxWidth) || boxWidth <= 0 || isNaN(boxHeight) || boxHeight < 0) {
        return;
      }
      ctx.save();
      const lineWidth = valueOrDefault(legendItem.lineWidth, 1);
      ctx.fillStyle = valueOrDefault(legendItem.fillStyle, defaultColor);
      ctx.lineCap = valueOrDefault(legendItem.lineCap, "butt");
      ctx.lineDashOffset = valueOrDefault(legendItem.lineDashOffset, 0);
      ctx.lineJoin = valueOrDefault(legendItem.lineJoin, "miter");
      ctx.lineWidth = lineWidth;
      ctx.strokeStyle = valueOrDefault(legendItem.strokeStyle, defaultColor);
      ctx.setLineDash(valueOrDefault(legendItem.lineDash, []));
      if (labelOpts.usePointStyle) {
        const drawOptions = {
          radius: boxHeight * Math.SQRT2 / 2,
          pointStyle: legendItem.pointStyle,
          rotation: legendItem.rotation,
          borderWidth: lineWidth
        };
        const centerX = rtlHelper.xPlus(x2, boxWidth / 2);
        const centerY = y2 + halfFontSize;
        drawPointLegend(ctx, drawOptions, centerX, centerY, labelOpts.pointStyleWidth && boxWidth);
      } else {
        const yBoxTop = y2 + Math.max((fontSize - boxHeight) / 2, 0);
        const xBoxLeft = rtlHelper.leftForLtr(x2, boxWidth);
        const borderRadius2 = toTRBLCorners(legendItem.borderRadius);
        ctx.beginPath();
        if (Object.values(borderRadius2).some((v2) => v2 !== 0)) {
          addRoundedRectPath(ctx, {
            x: xBoxLeft,
            y: yBoxTop,
            w: boxWidth,
            h: boxHeight,
            radius: borderRadius2
          });
        } else {
          ctx.rect(xBoxLeft, yBoxTop, boxWidth, boxHeight);
        }
        ctx.fill();
        if (lineWidth !== 0) {
          ctx.stroke();
        }
      }
      ctx.restore();
    };
    const fillText = function(x2, y2, legendItem) {
      renderText(ctx, legendItem.text, x2, y2 + itemHeight / 2, labelFont, {
        strikethrough: legendItem.hidden,
        textAlign: rtlHelper.textAlign(legendItem.textAlign)
      });
    };
    const isHorizontal = this.isHorizontal();
    const titleHeight = this._computeTitleHeight();
    if (isHorizontal) {
      cursor2 = {
        x: _alignStartEnd(align, this.left + padding, this.right - lineWidths[0]),
        y: this.top + padding + titleHeight,
        line: 0
      };
    } else {
      cursor2 = {
        x: this.left + padding,
        y: _alignStartEnd(align, this.top + titleHeight + padding, this.bottom - columnSizes[0].height),
        line: 0
      };
    }
    overrideTextDirection(this.ctx, opts.textDirection);
    const lineHeight = itemHeight + padding;
    this.legendItems.forEach((legendItem, i) => {
      ctx.strokeStyle = legendItem.fontColor;
      ctx.fillStyle = legendItem.fontColor;
      const textWidth = ctx.measureText(legendItem.text).width;
      const textAlign = rtlHelper.textAlign(legendItem.textAlign || (legendItem.textAlign = labelOpts.textAlign));
      const width = boxWidth + halfFontSize + textWidth;
      let x2 = cursor2.x;
      let y2 = cursor2.y;
      rtlHelper.setWidth(this.width);
      if (isHorizontal) {
        if (i > 0 && x2 + width + padding > this.right) {
          y2 = cursor2.y += lineHeight;
          cursor2.line++;
          x2 = cursor2.x = _alignStartEnd(align, this.left + padding, this.right - lineWidths[cursor2.line]);
        }
      } else if (i > 0 && y2 + lineHeight > this.bottom) {
        x2 = cursor2.x = x2 + columnSizes[cursor2.line].width + padding;
        cursor2.line++;
        y2 = cursor2.y = _alignStartEnd(align, this.top + titleHeight + padding, this.bottom - columnSizes[cursor2.line].height);
      }
      const realX = rtlHelper.x(x2);
      drawLegendBox(realX, y2, legendItem);
      x2 = _textX(textAlign, x2 + boxWidth + halfFontSize, isHorizontal ? x2 + width : this.right, opts.rtl);
      fillText(rtlHelper.x(x2), y2, legendItem);
      if (isHorizontal) {
        cursor2.x += width + padding;
      } else if (typeof legendItem.text !== "string") {
        const fontLineHeight = labelFont.lineHeight;
        cursor2.y += calculateLegendItemHeight(legendItem, fontLineHeight) + padding;
      } else {
        cursor2.y += lineHeight;
      }
    });
    restoreTextDirection(this.ctx, opts.textDirection);
  }
  drawTitle() {
    const opts = this.options;
    const titleOpts = opts.title;
    const titleFont = toFont(titleOpts.font);
    const titlePadding = toPadding(titleOpts.padding);
    if (!titleOpts.display) {
      return;
    }
    const rtlHelper = getRtlAdapter(opts.rtl, this.left, this.width);
    const ctx = this.ctx;
    const position2 = titleOpts.position;
    const halfFontSize = titleFont.size / 2;
    const topPaddingPlusHalfFontSize = titlePadding.top + halfFontSize;
    let y2;
    let left = this.left;
    let maxWidth = this.width;
    if (this.isHorizontal()) {
      maxWidth = Math.max(...this.lineWidths);
      y2 = this.top + topPaddingPlusHalfFontSize;
      left = _alignStartEnd(opts.align, left, this.right - maxWidth);
    } else {
      const maxHeight = this.columnSizes.reduce((acc, size2) => Math.max(acc, size2.height), 0);
      y2 = topPaddingPlusHalfFontSize + _alignStartEnd(opts.align, this.top, this.bottom - maxHeight - opts.labels.padding - this._computeTitleHeight());
    }
    const x2 = _alignStartEnd(position2, left, left + maxWidth);
    ctx.textAlign = rtlHelper.textAlign(_toLeftRightCenter(position2));
    ctx.textBaseline = "middle";
    ctx.strokeStyle = titleOpts.color;
    ctx.fillStyle = titleOpts.color;
    ctx.font = titleFont.string;
    renderText(ctx, titleOpts.text, x2, y2, titleFont);
  }
  _computeTitleHeight() {
    const titleOpts = this.options.title;
    const titleFont = toFont(titleOpts.font);
    const titlePadding = toPadding(titleOpts.padding);
    return titleOpts.display ? titleFont.lineHeight + titlePadding.height : 0;
  }
  _getLegendItemAt(x2, y2) {
    let i, hitBox, lh;
    if (_isBetween(x2, this.left, this.right) && _isBetween(y2, this.top, this.bottom)) {
      lh = this.legendHitBoxes;
      for (i = 0; i < lh.length; ++i) {
        hitBox = lh[i];
        if (_isBetween(x2, hitBox.left, hitBox.left + hitBox.width) && _isBetween(y2, hitBox.top, hitBox.top + hitBox.height)) {
          return this.legendItems[i];
        }
      }
    }
    return null;
  }
  handleEvent(e2) {
    const opts = this.options;
    if (!isListened(e2.type, opts)) {
      return;
    }
    const hoveredItem = this._getLegendItemAt(e2.x, e2.y);
    if (e2.type === "mousemove" || e2.type === "mouseout") {
      const previous = this._hoveredItem;
      const sameItem = itemsEqual(previous, hoveredItem);
      if (previous && !sameItem) {
        callback(opts.onLeave, [
          e2,
          previous,
          this
        ], this);
      }
      this._hoveredItem = hoveredItem;
      if (hoveredItem && !sameItem) {
        callback(opts.onHover, [
          e2,
          hoveredItem,
          this
        ], this);
      }
    } else if (hoveredItem) {
      callback(opts.onClick, [
        e2,
        hoveredItem,
        this
      ], this);
    }
  }
};
function calculateItemSize(boxWidth, labelFont, ctx, legendItem, _itemHeight) {
  const itemWidth = calculateItemWidth(legendItem, boxWidth, labelFont, ctx);
  const itemHeight = calculateItemHeight(_itemHeight, legendItem, labelFont.lineHeight);
  return {
    itemWidth,
    itemHeight
  };
}
function calculateItemWidth(legendItem, boxWidth, labelFont, ctx) {
  let legendItemText = legendItem.text;
  if (legendItemText && typeof legendItemText !== "string") {
    legendItemText = legendItemText.reduce((a2, b2) => a2.length > b2.length ? a2 : b2);
  }
  return boxWidth + labelFont.size / 2 + ctx.measureText(legendItemText).width;
}
function calculateItemHeight(_itemHeight, legendItem, fontLineHeight) {
  let itemHeight = _itemHeight;
  if (typeof legendItem.text !== "string") {
    itemHeight = calculateLegendItemHeight(legendItem, fontLineHeight);
  }
  return itemHeight;
}
function calculateLegendItemHeight(legendItem, fontLineHeight) {
  const labelHeight = legendItem.text ? legendItem.text.length : 0;
  return fontLineHeight * labelHeight;
}
function isListened(type2, opts) {
  if ((type2 === "mousemove" || type2 === "mouseout") && (opts.onHover || opts.onLeave)) {
    return true;
  }
  if (opts.onClick && (type2 === "click" || type2 === "mouseup")) {
    return true;
  }
  return false;
}
var plugin_legend = {
  id: "legend",
  _element: Legend$1,
  start(chart, _args, options2) {
    const legend = chart.legend = new Legend$1({
      ctx: chart.ctx,
      options: options2,
      chart
    });
    layouts.configure(chart, legend, options2);
    layouts.addBox(chart, legend);
  },
  stop(chart) {
    layouts.removeBox(chart, chart.legend);
    delete chart.legend;
  },
  beforeUpdate(chart, _args, options2) {
    const legend = chart.legend;
    layouts.configure(chart, legend, options2);
    legend.options = options2;
  },
  afterUpdate(chart) {
    const legend = chart.legend;
    legend.buildLabels();
    legend.adjustHitBoxes();
  },
  afterEvent(chart, args) {
    if (!args.replay) {
      chart.legend.handleEvent(args.event);
    }
  },
  defaults: {
    display: true,
    position: "top",
    align: "center",
    fullSize: true,
    reverse: false,
    weight: 1e3,
    onClick(e2, legendItem, legend) {
      const index2 = legendItem.datasetIndex;
      const ci = legend.chart;
      if (ci.isDatasetVisible(index2)) {
        ci.hide(index2);
        legendItem.hidden = true;
      } else {
        ci.show(index2);
        legendItem.hidden = false;
      }
    },
    onHover: null,
    onLeave: null,
    labels: {
      color: (ctx) => ctx.chart.options.color,
      boxWidth: 40,
      padding: 10,
      generateLabels(chart) {
        const datasets = chart.data.datasets;
        const { labels: { usePointStyle, pointStyle, textAlign, color: color2, useBorderRadius, borderRadius: borderRadius2 } } = chart.legend.options;
        return chart._getSortedDatasetMetas().map((meta) => {
          const style = meta.controller.getStyle(usePointStyle ? 0 : void 0);
          const borderWidth = toPadding(style.borderWidth);
          return {
            text: datasets[meta.index].label,
            fillStyle: style.backgroundColor,
            fontColor: color2,
            hidden: !meta.visible,
            lineCap: style.borderCapStyle,
            lineDash: style.borderDash,
            lineDashOffset: style.borderDashOffset,
            lineJoin: style.borderJoinStyle,
            lineWidth: (borderWidth.width + borderWidth.height) / 4,
            strokeStyle: style.borderColor,
            pointStyle: pointStyle || style.pointStyle,
            rotation: style.rotation,
            textAlign: textAlign || style.textAlign,
            borderRadius: useBorderRadius && (borderRadius2 || style.borderRadius),
            datasetIndex: meta.index
          };
        }, this);
      }
    },
    title: {
      color: (ctx) => ctx.chart.options.color,
      display: false,
      position: "center",
      text: ""
    }
  },
  descriptors: {
    _scriptable: (name) => !name.startsWith("on"),
    labels: {
      _scriptable: (name) => ![
        "generateLabels",
        "filter",
        "sort"
      ].includes(name)
    }
  }
};
let Title$1 = class Title extends Element$1 {
  constructor(config2) {
    super();
    this.chart = config2.chart;
    this.options = config2.options;
    this.ctx = config2.ctx;
    this._padding = void 0;
    this.top = void 0;
    this.bottom = void 0;
    this.left = void 0;
    this.right = void 0;
    this.width = void 0;
    this.height = void 0;
    this.position = void 0;
    this.weight = void 0;
    this.fullSize = void 0;
  }
  update(maxWidth, maxHeight) {
    const opts = this.options;
    this.left = 0;
    this.top = 0;
    if (!opts.display) {
      this.width = this.height = this.right = this.bottom = 0;
      return;
    }
    this.width = this.right = maxWidth;
    this.height = this.bottom = maxHeight;
    const lineCount = isArray$1(opts.text) ? opts.text.length : 1;
    this._padding = toPadding(opts.padding);
    const textSize = lineCount * toFont(opts.font).lineHeight + this._padding.height;
    if (this.isHorizontal()) {
      this.height = textSize;
    } else {
      this.width = textSize;
    }
  }
  isHorizontal() {
    const pos = this.options.position;
    return pos === "top" || pos === "bottom";
  }
  _drawArgs(offset2) {
    const { top, left, bottom, right, options: options2 } = this;
    const align = options2.align;
    let rotation = 0;
    let maxWidth, titleX, titleY;
    if (this.isHorizontal()) {
      titleX = _alignStartEnd(align, left, right);
      titleY = top + offset2;
      maxWidth = right - left;
    } else {
      if (options2.position === "left") {
        titleX = left + offset2;
        titleY = _alignStartEnd(align, bottom, top);
        rotation = PI * -0.5;
      } else {
        titleX = right - offset2;
        titleY = _alignStartEnd(align, top, bottom);
        rotation = PI * 0.5;
      }
      maxWidth = bottom - top;
    }
    return {
      titleX,
      titleY,
      maxWidth,
      rotation
    };
  }
  draw() {
    const ctx = this.ctx;
    const opts = this.options;
    if (!opts.display) {
      return;
    }
    const fontOpts = toFont(opts.font);
    const lineHeight = fontOpts.lineHeight;
    const offset2 = lineHeight / 2 + this._padding.top;
    const { titleX, titleY, maxWidth, rotation } = this._drawArgs(offset2);
    renderText(ctx, opts.text, 0, 0, fontOpts, {
      color: opts.color,
      maxWidth,
      rotation,
      textAlign: _toLeftRightCenter(opts.align),
      textBaseline: "middle",
      translation: [
        titleX,
        titleY
      ]
    });
  }
};
function createTitle(chart, titleOpts) {
  const title2 = new Title$1({
    ctx: chart.ctx,
    options: titleOpts,
    chart
  });
  layouts.configure(chart, title2, titleOpts);
  layouts.addBox(chart, title2);
  chart.titleBlock = title2;
}
var plugin_title = {
  id: "title",
  _element: Title$1,
  start(chart, _args, options2) {
    createTitle(chart, options2);
  },
  stop(chart) {
    const titleBlock = chart.titleBlock;
    layouts.removeBox(chart, titleBlock);
    delete chart.titleBlock;
  },
  beforeUpdate(chart, _args, options2) {
    const title2 = chart.titleBlock;
    layouts.configure(chart, title2, options2);
    title2.options = options2;
  },
  defaults: {
    align: "center",
    display: false,
    font: {
      weight: "bold"
    },
    fullSize: true,
    padding: 10,
    position: "top",
    text: "",
    weight: 2e3
  },
  defaultRoutes: {
    color: "color"
  },
  descriptors: {
    _scriptable: true,
    _indexable: false
  }
};
const map = /* @__PURE__ */ new WeakMap();
var plugin_subtitle = {
  id: "subtitle",
  start(chart, _args, options2) {
    const title2 = new Title$1({
      ctx: chart.ctx,
      options: options2,
      chart
    });
    layouts.configure(chart, title2, options2);
    layouts.addBox(chart, title2);
    map.set(chart, title2);
  },
  stop(chart) {
    layouts.removeBox(chart, map.get(chart));
    map.delete(chart);
  },
  beforeUpdate(chart, _args, options2) {
    const title2 = map.get(chart);
    layouts.configure(chart, title2, options2);
    title2.options = options2;
  },
  defaults: {
    align: "center",
    display: false,
    font: {
      weight: "normal"
    },
    fullSize: true,
    padding: 0,
    position: "top",
    text: "",
    weight: 1500
  },
  defaultRoutes: {
    color: "color"
  },
  descriptors: {
    _scriptable: true,
    _indexable: false
  }
};
const positioners = {
  average(items) {
    if (!items.length) {
      return false;
    }
    let i, len;
    let xSet = /* @__PURE__ */ new Set();
    let y2 = 0;
    let count = 0;
    for (i = 0, len = items.length; i < len; ++i) {
      const el = items[i].element;
      if (el && el.hasValue()) {
        const pos = el.tooltipPosition();
        xSet.add(pos.x);
        y2 += pos.y;
        ++count;
      }
    }
    const xAverage = [
      ...xSet
    ].reduce((a2, b2) => a2 + b2) / xSet.size;
    return {
      x: xAverage,
      y: y2 / count
    };
  },
  nearest(items, eventPosition) {
    if (!items.length) {
      return false;
    }
    let x2 = eventPosition.x;
    let y2 = eventPosition.y;
    let minDistance = Number.POSITIVE_INFINITY;
    let i, len, nearestElement;
    for (i = 0, len = items.length; i < len; ++i) {
      const el = items[i].element;
      if (el && el.hasValue()) {
        const center = el.getCenterPoint();
        const d2 = distanceBetweenPoints(eventPosition, center);
        if (d2 < minDistance) {
          minDistance = d2;
          nearestElement = el;
        }
      }
    }
    if (nearestElement) {
      const tp = nearestElement.tooltipPosition();
      x2 = tp.x;
      y2 = tp.y;
    }
    return {
      x: x2,
      y: y2
    };
  }
};
function pushOrConcat(base, toPush) {
  if (toPush) {
    if (isArray$1(toPush)) {
      Array.prototype.push.apply(base, toPush);
    } else {
      base.push(toPush);
    }
  }
  return base;
}
function splitNewlines(str) {
  if ((typeof str === "string" || str instanceof String) && str.indexOf("\n") > -1) {
    return str.split("\n");
  }
  return str;
}
function createTooltipItem(chart, item) {
  const { element, datasetIndex, index: index2 } = item;
  const controller = chart.getDatasetMeta(datasetIndex).controller;
  const { label, value } = controller.getLabelAndValue(index2);
  return {
    chart,
    label,
    parsed: controller.getParsed(index2),
    raw: chart.data.datasets[datasetIndex].data[index2],
    formattedValue: value,
    dataset: controller.getDataset(),
    dataIndex: index2,
    datasetIndex,
    element
  };
}
function getTooltipSize(tooltip, options2) {
  const ctx = tooltip.chart.ctx;
  const { body, footer, title: title2 } = tooltip;
  const { boxWidth, boxHeight } = options2;
  const bodyFont = toFont(options2.bodyFont);
  const titleFont = toFont(options2.titleFont);
  const footerFont = toFont(options2.footerFont);
  const titleLineCount = title2.length;
  const footerLineCount = footer.length;
  const bodyLineItemCount = body.length;
  const padding = toPadding(options2.padding);
  let height2 = padding.height;
  let width = 0;
  let combinedBodyLength = body.reduce((count, bodyItem) => count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length, 0);
  combinedBodyLength += tooltip.beforeBody.length + tooltip.afterBody.length;
  if (titleLineCount) {
    height2 += titleLineCount * titleFont.lineHeight + (titleLineCount - 1) * options2.titleSpacing + options2.titleMarginBottom;
  }
  if (combinedBodyLength) {
    const bodyLineHeight = options2.displayColors ? Math.max(boxHeight, bodyFont.lineHeight) : bodyFont.lineHeight;
    height2 += bodyLineItemCount * bodyLineHeight + (combinedBodyLength - bodyLineItemCount) * bodyFont.lineHeight + (combinedBodyLength - 1) * options2.bodySpacing;
  }
  if (footerLineCount) {
    height2 += options2.footerMarginTop + footerLineCount * footerFont.lineHeight + (footerLineCount - 1) * options2.footerSpacing;
  }
  let widthPadding = 0;
  const maxLineWidth = function(line2) {
    width = Math.max(width, ctx.measureText(line2).width + widthPadding);
  };
  ctx.save();
  ctx.font = titleFont.string;
  each$1(tooltip.title, maxLineWidth);
  ctx.font = bodyFont.string;
  each$1(tooltip.beforeBody.concat(tooltip.afterBody), maxLineWidth);
  widthPadding = options2.displayColors ? boxWidth + 2 + options2.boxPadding : 0;
  each$1(body, (bodyItem) => {
    each$1(bodyItem.before, maxLineWidth);
    each$1(bodyItem.lines, maxLineWidth);
    each$1(bodyItem.after, maxLineWidth);
  });
  widthPadding = 0;
  ctx.font = footerFont.string;
  each$1(tooltip.footer, maxLineWidth);
  ctx.restore();
  width += padding.width;
  return {
    width,
    height: height2
  };
}
function determineYAlign(chart, size2) {
  const { y: y2, height: height2 } = size2;
  if (y2 < height2 / 2) {
    return "top";
  } else if (y2 > chart.height - height2 / 2) {
    return "bottom";
  }
  return "center";
}
function doesNotFitWithAlign(xAlign, chart, options2, size2) {
  const { x: x2, width } = size2;
  const caret2 = options2.caretSize + options2.caretPadding;
  if (xAlign === "left" && x2 + width + caret2 > chart.width) {
    return true;
  }
  if (xAlign === "right" && x2 - width - caret2 < 0) {
    return true;
  }
}
function determineXAlign(chart, options2, size2, yAlign) {
  const { x: x2, width } = size2;
  const { width: chartWidth, chartArea: { left, right } } = chart;
  let xAlign = "center";
  if (yAlign === "center") {
    xAlign = x2 <= (left + right) / 2 ? "left" : "right";
  } else if (x2 <= width / 2) {
    xAlign = "left";
  } else if (x2 >= chartWidth - width / 2) {
    xAlign = "right";
  }
  if (doesNotFitWithAlign(xAlign, chart, options2, size2)) {
    xAlign = "center";
  }
  return xAlign;
}
function determineAlignment(chart, options2, size2) {
  const yAlign = size2.yAlign || options2.yAlign || determineYAlign(chart, size2);
  return {
    xAlign: size2.xAlign || options2.xAlign || determineXAlign(chart, options2, size2, yAlign),
    yAlign
  };
}
function alignX(size2, xAlign) {
  let { x: x2, width } = size2;
  if (xAlign === "right") {
    x2 -= width;
  } else if (xAlign === "center") {
    x2 -= width / 2;
  }
  return x2;
}
function alignY(size2, yAlign, paddingAndSize) {
  let { y: y2, height: height2 } = size2;
  if (yAlign === "top") {
    y2 += paddingAndSize;
  } else if (yAlign === "bottom") {
    y2 -= height2 + paddingAndSize;
  } else {
    y2 -= height2 / 2;
  }
  return y2;
}
function getBackgroundPoint(options2, size2, alignment, chart) {
  const { caretSize, caretPadding, cornerRadius } = options2;
  const { xAlign, yAlign } = alignment;
  const paddingAndSize = caretSize + caretPadding;
  const { topLeft, topRight, bottomLeft, bottomRight } = toTRBLCorners(cornerRadius);
  let x2 = alignX(size2, xAlign);
  const y2 = alignY(size2, yAlign, paddingAndSize);
  if (yAlign === "center") {
    if (xAlign === "left") {
      x2 += paddingAndSize;
    } else if (xAlign === "right") {
      x2 -= paddingAndSize;
    }
  } else if (xAlign === "left") {
    x2 -= Math.max(topLeft, bottomLeft) + caretSize;
  } else if (xAlign === "right") {
    x2 += Math.max(topRight, bottomRight) + caretSize;
  }
  return {
    x: _limitValue(x2, 0, chart.width - size2.width),
    y: _limitValue(y2, 0, chart.height - size2.height)
  };
}
function getAlignedX(tooltip, align, options2) {
  const padding = toPadding(options2.padding);
  return align === "center" ? tooltip.x + tooltip.width / 2 : align === "right" ? tooltip.x + tooltip.width - padding.right : tooltip.x + padding.left;
}
function getBeforeAfterBodyLines(callback2) {
  return pushOrConcat([], splitNewlines(callback2));
}
function createTooltipContext(parent, tooltip, tooltipItems) {
  return createContext(parent, {
    tooltip,
    tooltipItems,
    type: "tooltip"
  });
}
function overrideCallbacks(callbacks, context) {
  const override = context && context.dataset && context.dataset.tooltip && context.dataset.tooltip.callbacks;
  return override ? callbacks.override(override) : callbacks;
}
const defaultCallbacks = {
  beforeTitle: noop$2,
  title(tooltipItems) {
    if (tooltipItems.length > 0) {
      const item = tooltipItems[0];
      const labels = item.chart.data.labels;
      const labelCount = labels ? labels.length : 0;
      if (this && this.options && this.options.mode === "dataset") {
        return item.dataset.label || "";
      } else if (item.label) {
        return item.label;
      } else if (labelCount > 0 && item.dataIndex < labelCount) {
        return labels[item.dataIndex];
      }
    }
    return "";
  },
  afterTitle: noop$2,
  beforeBody: noop$2,
  beforeLabel: noop$2,
  label(tooltipItem) {
    if (this && this.options && this.options.mode === "dataset") {
      return tooltipItem.label + ": " + tooltipItem.formattedValue || tooltipItem.formattedValue;
    }
    let label = tooltipItem.dataset.label || "";
    if (label) {
      label += ": ";
    }
    const value = tooltipItem.formattedValue;
    if (!isNullOrUndef(value)) {
      label += value;
    }
    return label;
  },
  labelColor(tooltipItem) {
    const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
    const options2 = meta.controller.getStyle(tooltipItem.dataIndex);
    return {
      borderColor: options2.borderColor,
      backgroundColor: options2.backgroundColor,
      borderWidth: options2.borderWidth,
      borderDash: options2.borderDash,
      borderDashOffset: options2.borderDashOffset,
      borderRadius: 0
    };
  },
  labelTextColor() {
    return this.options.bodyColor;
  },
  labelPointStyle(tooltipItem) {
    const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
    const options2 = meta.controller.getStyle(tooltipItem.dataIndex);
    return {
      pointStyle: options2.pointStyle,
      rotation: options2.rotation
    };
  },
  afterLabel: noop$2,
  afterBody: noop$2,
  beforeFooter: noop$2,
  footer: noop$2,
  afterFooter: noop$2
};
function invokeCallbackWithFallback(callbacks, name, ctx, arg) {
  const result = callbacks[name].call(ctx, arg);
  if (typeof result === "undefined") {
    return defaultCallbacks[name].call(ctx, arg);
  }
  return result;
}
class Tooltip extends Element$1 {
  constructor(config2) {
    super();
    this.opacity = 0;
    this._active = [];
    this._eventPosition = void 0;
    this._size = void 0;
    this._cachedAnimations = void 0;
    this._tooltipItems = [];
    this.$animations = void 0;
    this.$context = void 0;
    this.chart = config2.chart;
    this.options = config2.options;
    this.dataPoints = void 0;
    this.title = void 0;
    this.beforeBody = void 0;
    this.body = void 0;
    this.afterBody = void 0;
    this.footer = void 0;
    this.xAlign = void 0;
    this.yAlign = void 0;
    this.x = void 0;
    this.y = void 0;
    this.height = void 0;
    this.width = void 0;
    this.caretX = void 0;
    this.caretY = void 0;
    this.labelColors = void 0;
    this.labelPointStyles = void 0;
    this.labelTextColors = void 0;
  }
  initialize(options2) {
    this.options = options2;
    this._cachedAnimations = void 0;
    this.$context = void 0;
  }
  _resolveAnimations() {
    const cached = this._cachedAnimations;
    if (cached) {
      return cached;
    }
    const chart = this.chart;
    const options2 = this.options.setContext(this.getContext());
    const opts = options2.enabled && chart.options.animation && options2.animations;
    const animations = new Animations(this.chart, opts);
    if (opts._cacheable) {
      this._cachedAnimations = Object.freeze(animations);
    }
    return animations;
  }
  getContext() {
    return this.$context || (this.$context = createTooltipContext(this.chart.getContext(), this, this._tooltipItems));
  }
  getTitle(context, options2) {
    const { callbacks } = options2;
    const beforeTitle = invokeCallbackWithFallback(callbacks, "beforeTitle", this, context);
    const title2 = invokeCallbackWithFallback(callbacks, "title", this, context);
    const afterTitle = invokeCallbackWithFallback(callbacks, "afterTitle", this, context);
    let lines = [];
    lines = pushOrConcat(lines, splitNewlines(beforeTitle));
    lines = pushOrConcat(lines, splitNewlines(title2));
    lines = pushOrConcat(lines, splitNewlines(afterTitle));
    return lines;
  }
  getBeforeBody(tooltipItems, options2) {
    return getBeforeAfterBodyLines(invokeCallbackWithFallback(options2.callbacks, "beforeBody", this, tooltipItems));
  }
  getBody(tooltipItems, options2) {
    const { callbacks } = options2;
    const bodyItems = [];
    each$1(tooltipItems, (context) => {
      const bodyItem = {
        before: [],
        lines: [],
        after: []
      };
      const scoped = overrideCallbacks(callbacks, context);
      pushOrConcat(bodyItem.before, splitNewlines(invokeCallbackWithFallback(scoped, "beforeLabel", this, context)));
      pushOrConcat(bodyItem.lines, invokeCallbackWithFallback(scoped, "label", this, context));
      pushOrConcat(bodyItem.after, splitNewlines(invokeCallbackWithFallback(scoped, "afterLabel", this, context)));
      bodyItems.push(bodyItem);
    });
    return bodyItems;
  }
  getAfterBody(tooltipItems, options2) {
    return getBeforeAfterBodyLines(invokeCallbackWithFallback(options2.callbacks, "afterBody", this, tooltipItems));
  }
  getFooter(tooltipItems, options2) {
    const { callbacks } = options2;
    const beforeFooter = invokeCallbackWithFallback(callbacks, "beforeFooter", this, tooltipItems);
    const footer = invokeCallbackWithFallback(callbacks, "footer", this, tooltipItems);
    const afterFooter = invokeCallbackWithFallback(callbacks, "afterFooter", this, tooltipItems);
    let lines = [];
    lines = pushOrConcat(lines, splitNewlines(beforeFooter));
    lines = pushOrConcat(lines, splitNewlines(footer));
    lines = pushOrConcat(lines, splitNewlines(afterFooter));
    return lines;
  }
  _createItems(options2) {
    const active2 = this._active;
    const data2 = this.chart.data;
    const labelColors = [];
    const labelPointStyles = [];
    const labelTextColors = [];
    let tooltipItems = [];
    let i, len;
    for (i = 0, len = active2.length; i < len; ++i) {
      tooltipItems.push(createTooltipItem(this.chart, active2[i]));
    }
    if (options2.filter) {
      tooltipItems = tooltipItems.filter((element, index2, array) => options2.filter(element, index2, array, data2));
    }
    if (options2.itemSort) {
      tooltipItems = tooltipItems.sort((a2, b2) => options2.itemSort(a2, b2, data2));
    }
    each$1(tooltipItems, (context) => {
      const scoped = overrideCallbacks(options2.callbacks, context);
      labelColors.push(invokeCallbackWithFallback(scoped, "labelColor", this, context));
      labelPointStyles.push(invokeCallbackWithFallback(scoped, "labelPointStyle", this, context));
      labelTextColors.push(invokeCallbackWithFallback(scoped, "labelTextColor", this, context));
    });
    this.labelColors = labelColors;
    this.labelPointStyles = labelPointStyles;
    this.labelTextColors = labelTextColors;
    this.dataPoints = tooltipItems;
    return tooltipItems;
  }
  update(changed, replay) {
    const options2 = this.options.setContext(this.getContext());
    const active2 = this._active;
    let properties;
    let tooltipItems = [];
    if (!active2.length) {
      if (this.opacity !== 0) {
        properties = {
          opacity: 0
        };
      }
    } else {
      const position2 = positioners[options2.position].call(this, active2, this._eventPosition);
      tooltipItems = this._createItems(options2);
      this.title = this.getTitle(tooltipItems, options2);
      this.beforeBody = this.getBeforeBody(tooltipItems, options2);
      this.body = this.getBody(tooltipItems, options2);
      this.afterBody = this.getAfterBody(tooltipItems, options2);
      this.footer = this.getFooter(tooltipItems, options2);
      const size2 = this._size = getTooltipSize(this, options2);
      const positionAndSize = Object.assign({}, position2, size2);
      const alignment = determineAlignment(this.chart, options2, positionAndSize);
      const backgroundPoint = getBackgroundPoint(options2, positionAndSize, alignment, this.chart);
      this.xAlign = alignment.xAlign;
      this.yAlign = alignment.yAlign;
      properties = {
        opacity: 1,
        x: backgroundPoint.x,
        y: backgroundPoint.y,
        width: size2.width,
        height: size2.height,
        caretX: position2.x,
        caretY: position2.y
      };
    }
    this._tooltipItems = tooltipItems;
    this.$context = void 0;
    if (properties) {
      this._resolveAnimations().update(this, properties);
    }
    if (changed && options2.external) {
      options2.external.call(this, {
        chart: this.chart,
        tooltip: this,
        replay
      });
    }
  }
  drawCaret(tooltipPoint, ctx, size2, options2) {
    const caretPosition = this.getCaretPosition(tooltipPoint, size2, options2);
    ctx.lineTo(caretPosition.x1, caretPosition.y1);
    ctx.lineTo(caretPosition.x2, caretPosition.y2);
    ctx.lineTo(caretPosition.x3, caretPosition.y3);
  }
  getCaretPosition(tooltipPoint, size2, options2) {
    const { xAlign, yAlign } = this;
    const { caretSize, cornerRadius } = options2;
    const { topLeft, topRight, bottomLeft, bottomRight } = toTRBLCorners(cornerRadius);
    const { x: ptX, y: ptY } = tooltipPoint;
    const { width, height: height2 } = size2;
    let x1, x2, x3, y1, y2, y3;
    if (yAlign === "center") {
      y2 = ptY + height2 / 2;
      if (xAlign === "left") {
        x1 = ptX;
        x2 = x1 - caretSize;
        y1 = y2 + caretSize;
        y3 = y2 - caretSize;
      } else {
        x1 = ptX + width;
        x2 = x1 + caretSize;
        y1 = y2 - caretSize;
        y3 = y2 + caretSize;
      }
      x3 = x1;
    } else {
      if (xAlign === "left") {
        x2 = ptX + Math.max(topLeft, bottomLeft) + caretSize;
      } else if (xAlign === "right") {
        x2 = ptX + width - Math.max(topRight, bottomRight) - caretSize;
      } else {
        x2 = this.caretX;
      }
      if (yAlign === "top") {
        y1 = ptY;
        y2 = y1 - caretSize;
        x1 = x2 - caretSize;
        x3 = x2 + caretSize;
      } else {
        y1 = ptY + height2;
        y2 = y1 + caretSize;
        x1 = x2 + caretSize;
        x3 = x2 - caretSize;
      }
      y3 = y1;
    }
    return {
      x1,
      x2,
      x3,
      y1,
      y2,
      y3
    };
  }
  drawTitle(pt, ctx, options2) {
    const title2 = this.title;
    const length2 = title2.length;
    let titleFont, titleSpacing, i;
    if (length2) {
      const rtlHelper = getRtlAdapter(options2.rtl, this.x, this.width);
      pt.x = getAlignedX(this, options2.titleAlign, options2);
      ctx.textAlign = rtlHelper.textAlign(options2.titleAlign);
      ctx.textBaseline = "middle";
      titleFont = toFont(options2.titleFont);
      titleSpacing = options2.titleSpacing;
      ctx.fillStyle = options2.titleColor;
      ctx.font = titleFont.string;
      for (i = 0; i < length2; ++i) {
        ctx.fillText(title2[i], rtlHelper.x(pt.x), pt.y + titleFont.lineHeight / 2);
        pt.y += titleFont.lineHeight + titleSpacing;
        if (i + 1 === length2) {
          pt.y += options2.titleMarginBottom - titleSpacing;
        }
      }
    }
  }
  _drawColorBox(ctx, pt, i, rtlHelper, options2) {
    const labelColor = this.labelColors[i];
    const labelPointStyle = this.labelPointStyles[i];
    const { boxHeight, boxWidth } = options2;
    const bodyFont = toFont(options2.bodyFont);
    const colorX = getAlignedX(this, "left", options2);
    const rtlColorX = rtlHelper.x(colorX);
    const yOffSet = boxHeight < bodyFont.lineHeight ? (bodyFont.lineHeight - boxHeight) / 2 : 0;
    const colorY = pt.y + yOffSet;
    if (options2.usePointStyle) {
      const drawOptions = {
        radius: Math.min(boxWidth, boxHeight) / 2,
        pointStyle: labelPointStyle.pointStyle,
        rotation: labelPointStyle.rotation,
        borderWidth: 1
      };
      const centerX = rtlHelper.leftForLtr(rtlColorX, boxWidth) + boxWidth / 2;
      const centerY = colorY + boxHeight / 2;
      ctx.strokeStyle = options2.multiKeyBackground;
      ctx.fillStyle = options2.multiKeyBackground;
      drawPoint(ctx, drawOptions, centerX, centerY);
      ctx.strokeStyle = labelColor.borderColor;
      ctx.fillStyle = labelColor.backgroundColor;
      drawPoint(ctx, drawOptions, centerX, centerY);
    } else {
      ctx.lineWidth = isObject(labelColor.borderWidth) ? Math.max(...Object.values(labelColor.borderWidth)) : labelColor.borderWidth || 1;
      ctx.strokeStyle = labelColor.borderColor;
      ctx.setLineDash(labelColor.borderDash || []);
      ctx.lineDashOffset = labelColor.borderDashOffset || 0;
      const outerX = rtlHelper.leftForLtr(rtlColorX, boxWidth);
      const innerX = rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), boxWidth - 2);
      const borderRadius2 = toTRBLCorners(labelColor.borderRadius);
      if (Object.values(borderRadius2).some((v2) => v2 !== 0)) {
        ctx.beginPath();
        ctx.fillStyle = options2.multiKeyBackground;
        addRoundedRectPath(ctx, {
          x: outerX,
          y: colorY,
          w: boxWidth,
          h: boxHeight,
          radius: borderRadius2
        });
        ctx.fill();
        ctx.stroke();
        ctx.fillStyle = labelColor.backgroundColor;
        ctx.beginPath();
        addRoundedRectPath(ctx, {
          x: innerX,
          y: colorY + 1,
          w: boxWidth - 2,
          h: boxHeight - 2,
          radius: borderRadius2
        });
        ctx.fill();
      } else {
        ctx.fillStyle = options2.multiKeyBackground;
        ctx.fillRect(outerX, colorY, boxWidth, boxHeight);
        ctx.strokeRect(outerX, colorY, boxWidth, boxHeight);
        ctx.fillStyle = labelColor.backgroundColor;
        ctx.fillRect(innerX, colorY + 1, boxWidth - 2, boxHeight - 2);
      }
    }
    ctx.fillStyle = this.labelTextColors[i];
  }
  drawBody(pt, ctx, options2) {
    const { body } = this;
    const { bodySpacing, bodyAlign, displayColors, boxHeight, boxWidth, boxPadding } = options2;
    const bodyFont = toFont(options2.bodyFont);
    let bodyLineHeight = bodyFont.lineHeight;
    let xLinePadding = 0;
    const rtlHelper = getRtlAdapter(options2.rtl, this.x, this.width);
    const fillLineOfText = function(line2) {
      ctx.fillText(line2, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyLineHeight / 2);
      pt.y += bodyLineHeight + bodySpacing;
    };
    const bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);
    let bodyItem, textColor, lines, i, j, ilen, jlen;
    ctx.textAlign = bodyAlign;
    ctx.textBaseline = "middle";
    ctx.font = bodyFont.string;
    pt.x = getAlignedX(this, bodyAlignForCalculation, options2);
    ctx.fillStyle = options2.bodyColor;
    each$1(this.beforeBody, fillLineOfText);
    xLinePadding = displayColors && bodyAlignForCalculation !== "right" ? bodyAlign === "center" ? boxWidth / 2 + boxPadding : boxWidth + 2 + boxPadding : 0;
    for (i = 0, ilen = body.length; i < ilen; ++i) {
      bodyItem = body[i];
      textColor = this.labelTextColors[i];
      ctx.fillStyle = textColor;
      each$1(bodyItem.before, fillLineOfText);
      lines = bodyItem.lines;
      if (displayColors && lines.length) {
        this._drawColorBox(ctx, pt, i, rtlHelper, options2);
        bodyLineHeight = Math.max(bodyFont.lineHeight, boxHeight);
      }
      for (j = 0, jlen = lines.length; j < jlen; ++j) {
        fillLineOfText(lines[j]);
        bodyLineHeight = bodyFont.lineHeight;
      }
      each$1(bodyItem.after, fillLineOfText);
    }
    xLinePadding = 0;
    bodyLineHeight = bodyFont.lineHeight;
    each$1(this.afterBody, fillLineOfText);
    pt.y -= bodySpacing;
  }
  drawFooter(pt, ctx, options2) {
    const footer = this.footer;
    const length2 = footer.length;
    let footerFont, i;
    if (length2) {
      const rtlHelper = getRtlAdapter(options2.rtl, this.x, this.width);
      pt.x = getAlignedX(this, options2.footerAlign, options2);
      pt.y += options2.footerMarginTop;
      ctx.textAlign = rtlHelper.textAlign(options2.footerAlign);
      ctx.textBaseline = "middle";
      footerFont = toFont(options2.footerFont);
      ctx.fillStyle = options2.footerColor;
      ctx.font = footerFont.string;
      for (i = 0; i < length2; ++i) {
        ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFont.lineHeight / 2);
        pt.y += footerFont.lineHeight + options2.footerSpacing;
      }
    }
  }
  drawBackground(pt, ctx, tooltipSize, options2) {
    const { xAlign, yAlign } = this;
    const { x: x2, y: y2 } = pt;
    const { width, height: height2 } = tooltipSize;
    const { topLeft, topRight, bottomLeft, bottomRight } = toTRBLCorners(options2.cornerRadius);
    ctx.fillStyle = options2.backgroundColor;
    ctx.strokeStyle = options2.borderColor;
    ctx.lineWidth = options2.borderWidth;
    ctx.beginPath();
    ctx.moveTo(x2 + topLeft, y2);
    if (yAlign === "top") {
      this.drawCaret(pt, ctx, tooltipSize, options2);
    }
    ctx.lineTo(x2 + width - topRight, y2);
    ctx.quadraticCurveTo(x2 + width, y2, x2 + width, y2 + topRight);
    if (yAlign === "center" && xAlign === "right") {
      this.drawCaret(pt, ctx, tooltipSize, options2);
    }
    ctx.lineTo(x2 + width, y2 + height2 - bottomRight);
    ctx.quadraticCurveTo(x2 + width, y2 + height2, x2 + width - bottomRight, y2 + height2);
    if (yAlign === "bottom") {
      this.drawCaret(pt, ctx, tooltipSize, options2);
    }
    ctx.lineTo(x2 + bottomLeft, y2 + height2);
    ctx.quadraticCurveTo(x2, y2 + height2, x2, y2 + height2 - bottomLeft);
    if (yAlign === "center" && xAlign === "left") {
      this.drawCaret(pt, ctx, tooltipSize, options2);
    }
    ctx.lineTo(x2, y2 + topLeft);
    ctx.quadraticCurveTo(x2, y2, x2 + topLeft, y2);
    ctx.closePath();
    ctx.fill();
    if (options2.borderWidth > 0) {
      ctx.stroke();
    }
  }
  _updateAnimationTarget(options2) {
    const chart = this.chart;
    const anims = this.$animations;
    const animX = anims && anims.x;
    const animY = anims && anims.y;
    if (animX || animY) {
      const position2 = positioners[options2.position].call(this, this._active, this._eventPosition);
      if (!position2) {
        return;
      }
      const size2 = this._size = getTooltipSize(this, options2);
      const positionAndSize = Object.assign({}, position2, this._size);
      const alignment = determineAlignment(chart, options2, positionAndSize);
      const point = getBackgroundPoint(options2, positionAndSize, alignment, chart);
      if (animX._to !== point.x || animY._to !== point.y) {
        this.xAlign = alignment.xAlign;
        this.yAlign = alignment.yAlign;
        this.width = size2.width;
        this.height = size2.height;
        this.caretX = position2.x;
        this.caretY = position2.y;
        this._resolveAnimations().update(this, point);
      }
    }
  }
  _willRender() {
    return !!this.opacity;
  }
  draw(ctx) {
    const options2 = this.options.setContext(this.getContext());
    let opacity = this.opacity;
    if (!opacity) {
      return;
    }
    this._updateAnimationTarget(options2);
    const tooltipSize = {
      width: this.width,
      height: this.height
    };
    const pt = {
      x: this.x,
      y: this.y
    };
    opacity = Math.abs(opacity) < 1e-3 ? 0 : opacity;
    const padding = toPadding(options2.padding);
    const hasTooltipContent = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
    if (options2.enabled && hasTooltipContent) {
      ctx.save();
      ctx.globalAlpha = opacity;
      this.drawBackground(pt, ctx, tooltipSize, options2);
      overrideTextDirection(ctx, options2.textDirection);
      pt.y += padding.top;
      this.drawTitle(pt, ctx, options2);
      this.drawBody(pt, ctx, options2);
      this.drawFooter(pt, ctx, options2);
      restoreTextDirection(ctx, options2.textDirection);
      ctx.restore();
    }
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(activeElements, eventPosition) {
    const lastActive = this._active;
    const active2 = activeElements.map(({ datasetIndex, index: index2 }) => {
      const meta = this.chart.getDatasetMeta(datasetIndex);
      if (!meta) {
        throw new Error("Cannot find a dataset at index " + datasetIndex);
      }
      return {
        datasetIndex,
        element: meta.data[index2],
        index: index2
      };
    });
    const changed = !_elementsEqual(lastActive, active2);
    const positionChanged = this._positionChanged(active2, eventPosition);
    if (changed || positionChanged) {
      this._active = active2;
      this._eventPosition = eventPosition;
      this._ignoreReplayEvents = true;
      this.update(true);
    }
  }
  handleEvent(e2, replay, inChartArea = true) {
    if (replay && this._ignoreReplayEvents) {
      return false;
    }
    this._ignoreReplayEvents = false;
    const options2 = this.options;
    const lastActive = this._active || [];
    const active2 = this._getActiveElements(e2, lastActive, replay, inChartArea);
    const positionChanged = this._positionChanged(active2, e2);
    const changed = replay || !_elementsEqual(active2, lastActive) || positionChanged;
    if (changed) {
      this._active = active2;
      if (options2.enabled || options2.external) {
        this._eventPosition = {
          x: e2.x,
          y: e2.y
        };
        this.update(true, replay);
      }
    }
    return changed;
  }
  _getActiveElements(e2, lastActive, replay, inChartArea) {
    const options2 = this.options;
    if (e2.type === "mouseout") {
      return [];
    }
    if (!inChartArea) {
      return lastActive.filter((i) => this.chart.data.datasets[i.datasetIndex] && this.chart.getDatasetMeta(i.datasetIndex).controller.getParsed(i.index) !== void 0);
    }
    const active2 = this.chart.getElementsAtEventForMode(e2, options2.mode, options2, replay);
    if (options2.reverse) {
      active2.reverse();
    }
    return active2;
  }
  _positionChanged(active2, e2) {
    const { caretX, caretY, options: options2 } = this;
    const position2 = positioners[options2.position].call(this, active2, e2);
    return position2 !== false && (caretX !== position2.x || caretY !== position2.y);
  }
}
__publicField(Tooltip, "positioners", positioners);
var plugin_tooltip = {
  id: "tooltip",
  _element: Tooltip,
  positioners,
  afterInit(chart, _args, options2) {
    if (options2) {
      chart.tooltip = new Tooltip({
        chart,
        options: options2
      });
    }
  },
  beforeUpdate(chart, _args, options2) {
    if (chart.tooltip) {
      chart.tooltip.initialize(options2);
    }
  },
  reset(chart, _args, options2) {
    if (chart.tooltip) {
      chart.tooltip.initialize(options2);
    }
  },
  afterDraw(chart) {
    const tooltip = chart.tooltip;
    if (tooltip && tooltip._willRender()) {
      const args = {
        tooltip
      };
      if (chart.notifyPlugins("beforeTooltipDraw", {
        ...args,
        cancelable: true
      }) === false) {
        return;
      }
      tooltip.draw(chart.ctx);
      chart.notifyPlugins("afterTooltipDraw", args);
    }
  },
  afterEvent(chart, args) {
    if (chart.tooltip) {
      const useFinalPosition = args.replay;
      if (chart.tooltip.handleEvent(args.event, useFinalPosition, args.inChartArea)) {
        args.changed = true;
      }
    }
  },
  defaults: {
    enabled: true,
    external: null,
    position: "average",
    backgroundColor: "rgba(0,0,0,0.8)",
    titleColor: "#fff",
    titleFont: {
      weight: "bold"
    },
    titleSpacing: 2,
    titleMarginBottom: 6,
    titleAlign: "left",
    bodyColor: "#fff",
    bodySpacing: 2,
    bodyFont: {},
    bodyAlign: "left",
    footerColor: "#fff",
    footerSpacing: 2,
    footerMarginTop: 6,
    footerFont: {
      weight: "bold"
    },
    footerAlign: "left",
    padding: 6,
    caretPadding: 2,
    caretSize: 5,
    cornerRadius: 6,
    boxHeight: (ctx, opts) => opts.bodyFont.size,
    boxWidth: (ctx, opts) => opts.bodyFont.size,
    multiKeyBackground: "#fff",
    displayColors: true,
    boxPadding: 0,
    borderColor: "rgba(0,0,0,0)",
    borderWidth: 0,
    animation: {
      duration: 400,
      easing: "easeOutQuart"
    },
    animations: {
      numbers: {
        type: "number",
        properties: [
          "x",
          "y",
          "width",
          "height",
          "caretX",
          "caretY"
        ]
      },
      opacity: {
        easing: "linear",
        duration: 200
      }
    },
    callbacks: defaultCallbacks
  },
  defaultRoutes: {
    bodyFont: "font",
    footerFont: "font",
    titleFont: "font"
  },
  descriptors: {
    _scriptable: (name) => name !== "filter" && name !== "itemSort" && name !== "external",
    _indexable: false,
    callbacks: {
      _scriptable: false,
      _indexable: false
    },
    animation: {
      _fallback: false
    },
    animations: {
      _fallback: "animation"
    }
  },
  additionalOptionScopes: [
    "interaction"
  ]
};
var plugins = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  Colors: plugin_colors,
  Decimation: plugin_decimation,
  Filler: index$3,
  Legend: plugin_legend,
  SubTitle: plugin_subtitle,
  Title: plugin_title,
  Tooltip: plugin_tooltip
});
const addIfString = (labels, raw, index2, addedLabels) => {
  if (typeof raw === "string") {
    index2 = labels.push(raw) - 1;
    addedLabels.unshift({
      index: index2,
      label: raw
    });
  } else if (isNaN(raw)) {
    index2 = null;
  }
  return index2;
};
function findOrAddLabel(labels, raw, index2, addedLabels) {
  const first = labels.indexOf(raw);
  if (first === -1) {
    return addIfString(labels, raw, index2, addedLabels);
  }
  const last2 = labels.lastIndexOf(raw);
  return first !== last2 ? index2 : first;
}
const validIndex = (index2, max2) => index2 === null ? null : _limitValue(Math.round(index2), 0, max2);
function _getLabelForValue(value) {
  const labels = this.getLabels();
  if (value >= 0 && value < labels.length) {
    return labels[value];
  }
  return value;
}
class CategoryScale extends Scale {
  constructor(cfg) {
    super(cfg);
    this._startValue = void 0;
    this._valueRange = 0;
    this._addedLabels = [];
  }
  init(scaleOptions) {
    const added = this._addedLabels;
    if (added.length) {
      const labels = this.getLabels();
      for (const { index: index2, label } of added) {
        if (labels[index2] === label) {
          labels.splice(index2, 1);
        }
      }
      this._addedLabels = [];
    }
    super.init(scaleOptions);
  }
  parse(raw, index2) {
    if (isNullOrUndef(raw)) {
      return null;
    }
    const labels = this.getLabels();
    index2 = isFinite(index2) && labels[index2] === raw ? index2 : findOrAddLabel(labels, raw, valueOrDefault(index2, raw), this._addedLabels);
    return validIndex(index2, labels.length - 1);
  }
  determineDataLimits() {
    const { minDefined, maxDefined } = this.getUserBounds();
    let { min: min2, max: max2 } = this.getMinMax(true);
    if (this.options.bounds === "ticks") {
      if (!minDefined) {
        min2 = 0;
      }
      if (!maxDefined) {
        max2 = this.getLabels().length - 1;
      }
    }
    this.min = min2;
    this.max = max2;
  }
  buildTicks() {
    const min2 = this.min;
    const max2 = this.max;
    const offset2 = this.options.offset;
    const ticks = [];
    let labels = this.getLabels();
    labels = min2 === 0 && max2 === labels.length - 1 ? labels : labels.slice(min2, max2 + 1);
    this._valueRange = Math.max(labels.length - (offset2 ? 0 : 1), 1);
    this._startValue = this.min - (offset2 ? 0.5 : 0);
    for (let value = min2; value <= max2; value++) {
      ticks.push({
        value
      });
    }
    return ticks;
  }
  getLabelForValue(value) {
    return _getLabelForValue.call(this, value);
  }
  configure() {
    super.configure();
    if (!this.isHorizontal()) {
      this._reversePixels = !this._reversePixels;
    }
  }
  getPixelForValue(value) {
    if (typeof value !== "number") {
      value = this.parse(value);
    }
    return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
  }
  getPixelForTick(index2) {
    const ticks = this.ticks;
    if (index2 < 0 || index2 > ticks.length - 1) {
      return null;
    }
    return this.getPixelForValue(ticks[index2].value);
  }
  getValueForPixel(pixel) {
    return Math.round(this._startValue + this.getDecimalForPixel(pixel) * this._valueRange);
  }
  getBasePixel() {
    return this.bottom;
  }
}
__publicField(CategoryScale, "id", "category");
__publicField(CategoryScale, "defaults", {
  ticks: {
    callback: _getLabelForValue
  }
});
function generateTicks$1(generationOptions, dataRange) {
  const ticks = [];
  const MIN_SPACING = 1e-14;
  const { bounds, step, min: min2, max: max2, precision, count, maxTicks, maxDigits, includeBounds } = generationOptions;
  const unit = step || 1;
  const maxSpaces = maxTicks - 1;
  const { min: rmin, max: rmax } = dataRange;
  const minDefined = !isNullOrUndef(min2);
  const maxDefined = !isNullOrUndef(max2);
  const countDefined = !isNullOrUndef(count);
  const minSpacing = (rmax - rmin) / (maxDigits + 1);
  let spacing2 = niceNum((rmax - rmin) / maxSpaces / unit) * unit;
  let factor, niceMin, niceMax, numSpaces;
  if (spacing2 < MIN_SPACING && !minDefined && !maxDefined) {
    return [
      {
        value: rmin
      },
      {
        value: rmax
      }
    ];
  }
  numSpaces = Math.ceil(rmax / spacing2) - Math.floor(rmin / spacing2);
  if (numSpaces > maxSpaces) {
    spacing2 = niceNum(numSpaces * spacing2 / maxSpaces / unit) * unit;
  }
  if (!isNullOrUndef(precision)) {
    factor = Math.pow(10, precision);
    spacing2 = Math.ceil(spacing2 * factor) / factor;
  }
  if (bounds === "ticks") {
    niceMin = Math.floor(rmin / spacing2) * spacing2;
    niceMax = Math.ceil(rmax / spacing2) * spacing2;
  } else {
    niceMin = rmin;
    niceMax = rmax;
  }
  if (minDefined && maxDefined && step && almostWhole((max2 - min2) / step, spacing2 / 1e3)) {
    numSpaces = Math.round(Math.min((max2 - min2) / spacing2, maxTicks));
    spacing2 = (max2 - min2) / numSpaces;
    niceMin = min2;
    niceMax = max2;
  } else if (countDefined) {
    niceMin = minDefined ? min2 : niceMin;
    niceMax = maxDefined ? max2 : niceMax;
    numSpaces = count - 1;
    spacing2 = (niceMax - niceMin) / numSpaces;
  } else {
    numSpaces = (niceMax - niceMin) / spacing2;
    if (almostEquals(numSpaces, Math.round(numSpaces), spacing2 / 1e3)) {
      numSpaces = Math.round(numSpaces);
    } else {
      numSpaces = Math.ceil(numSpaces);
    }
  }
  const decimalPlaces = Math.max(_decimalPlaces(spacing2), _decimalPlaces(niceMin));
  factor = Math.pow(10, isNullOrUndef(precision) ? decimalPlaces : precision);
  niceMin = Math.round(niceMin * factor) / factor;
  niceMax = Math.round(niceMax * factor) / factor;
  let j = 0;
  if (minDefined) {
    if (includeBounds && niceMin !== min2) {
      ticks.push({
        value: min2
      });
      if (niceMin < min2) {
        j++;
      }
      if (almostEquals(Math.round((niceMin + j * spacing2) * factor) / factor, min2, relativeLabelSize(min2, minSpacing, generationOptions))) {
        j++;
      }
    } else if (niceMin < min2) {
      j++;
    }
  }
  for (; j < numSpaces; ++j) {
    const tickValue = Math.round((niceMin + j * spacing2) * factor) / factor;
    if (maxDefined && tickValue > max2) {
      break;
    }
    ticks.push({
      value: tickValue
    });
  }
  if (maxDefined && includeBounds && niceMax !== max2) {
    if (ticks.length && almostEquals(ticks[ticks.length - 1].value, max2, relativeLabelSize(max2, minSpacing, generationOptions))) {
      ticks[ticks.length - 1].value = max2;
    } else {
      ticks.push({
        value: max2
      });
    }
  } else if (!maxDefined || niceMax === max2) {
    ticks.push({
      value: niceMax
    });
  }
  return ticks;
}
function relativeLabelSize(value, minSpacing, { horizontal, minRotation }) {
  const rad = toRadians(minRotation);
  const ratio = (horizontal ? Math.sin(rad) : Math.cos(rad)) || 1e-3;
  const length2 = 0.75 * minSpacing * ("" + value).length;
  return Math.min(minSpacing / ratio, length2);
}
class LinearScaleBase extends Scale {
  constructor(cfg) {
    super(cfg);
    this.start = void 0;
    this.end = void 0;
    this._startValue = void 0;
    this._endValue = void 0;
    this._valueRange = 0;
  }
  parse(raw, index2) {
    if (isNullOrUndef(raw)) {
      return null;
    }
    if ((typeof raw === "number" || raw instanceof Number) && !isFinite(+raw)) {
      return null;
    }
    return +raw;
  }
  handleTickRangeOptions() {
    const { beginAtZero } = this.options;
    const { minDefined, maxDefined } = this.getUserBounds();
    let { min: min2, max: max2 } = this;
    const setMin = (v2) => min2 = minDefined ? min2 : v2;
    const setMax = (v2) => max2 = maxDefined ? max2 : v2;
    if (beginAtZero) {
      const minSign = sign(min2);
      const maxSign = sign(max2);
      if (minSign < 0 && maxSign < 0) {
        setMax(0);
      } else if (minSign > 0 && maxSign > 0) {
        setMin(0);
      }
    }
    if (min2 === max2) {
      let offset2 = max2 === 0 ? 1 : Math.abs(max2 * 0.05);
      setMax(max2 + offset2);
      if (!beginAtZero) {
        setMin(min2 - offset2);
      }
    }
    this.min = min2;
    this.max = max2;
  }
  getTickLimit() {
    const tickOpts = this.options.ticks;
    let { maxTicksLimit, stepSize } = tickOpts;
    let maxTicks;
    if (stepSize) {
      maxTicks = Math.ceil(this.max / stepSize) - Math.floor(this.min / stepSize) + 1;
      if (maxTicks > 1e3) {
        console.warn(`scales.${this.id}.ticks.stepSize: ${stepSize} would result generating up to ${maxTicks} ticks. Limiting to 1000.`);
        maxTicks = 1e3;
      }
    } else {
      maxTicks = this.computeTickLimit();
      maxTicksLimit = maxTicksLimit || 11;
    }
    if (maxTicksLimit) {
      maxTicks = Math.min(maxTicksLimit, maxTicks);
    }
    return maxTicks;
  }
  computeTickLimit() {
    return Number.POSITIVE_INFINITY;
  }
  buildTicks() {
    const opts = this.options;
    const tickOpts = opts.ticks;
    let maxTicks = this.getTickLimit();
    maxTicks = Math.max(2, maxTicks);
    const numericGeneratorOptions = {
      maxTicks,
      bounds: opts.bounds,
      min: opts.min,
      max: opts.max,
      precision: tickOpts.precision,
      step: tickOpts.stepSize,
      count: tickOpts.count,
      maxDigits: this._maxDigits(),
      horizontal: this.isHorizontal(),
      minRotation: tickOpts.minRotation || 0,
      includeBounds: tickOpts.includeBounds !== false
    };
    const dataRange = this._range || this;
    const ticks = generateTicks$1(numericGeneratorOptions, dataRange);
    if (opts.bounds === "ticks") {
      _setMinAndMaxByKey(ticks, this, "value");
    }
    if (opts.reverse) {
      ticks.reverse();
      this.start = this.max;
      this.end = this.min;
    } else {
      this.start = this.min;
      this.end = this.max;
    }
    return ticks;
  }
  configure() {
    const ticks = this.ticks;
    let start = this.min;
    let end = this.max;
    super.configure();
    if (this.options.offset && ticks.length) {
      const offset2 = (end - start) / Math.max(ticks.length - 1, 1) / 2;
      start -= offset2;
      end += offset2;
    }
    this._startValue = start;
    this._endValue = end;
    this._valueRange = end - start;
  }
  getLabelForValue(value) {
    return formatNumber(value, this.chart.options.locale, this.options.ticks.format);
  }
}
class LinearScale extends LinearScaleBase {
  determineDataLimits() {
    const { min: min2, max: max2 } = this.getMinMax(true);
    this.min = isNumberFinite(min2) ? min2 : 0;
    this.max = isNumberFinite(max2) ? max2 : 1;
    this.handleTickRangeOptions();
  }
  computeTickLimit() {
    const horizontal = this.isHorizontal();
    const length2 = horizontal ? this.width : this.height;
    const minRotation = toRadians(this.options.ticks.minRotation);
    const ratio = (horizontal ? Math.sin(minRotation) : Math.cos(minRotation)) || 1e-3;
    const tickFont = this._resolveTickFontOptions(0);
    return Math.ceil(length2 / Math.min(40, tickFont.lineHeight / ratio));
  }
  getPixelForValue(value) {
    return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
  }
  getValueForPixel(pixel) {
    return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
  }
}
__publicField(LinearScale, "id", "linear");
__publicField(LinearScale, "defaults", {
  ticks: {
    callback: Ticks.formatters.numeric
  }
});
const log10Floor = (v2) => Math.floor(log10(v2));
const changeExponent = (v2, m3) => Math.pow(10, log10Floor(v2) + m3);
function isMajor(tickVal) {
  const remain = tickVal / Math.pow(10, log10Floor(tickVal));
  return remain === 1;
}
function steps$1(min2, max2, rangeExp) {
  const rangeStep = Math.pow(10, rangeExp);
  const start = Math.floor(min2 / rangeStep);
  const end = Math.ceil(max2 / rangeStep);
  return end - start;
}
function startExp(min2, max2) {
  const range2 = max2 - min2;
  let rangeExp = log10Floor(range2);
  while (steps$1(min2, max2, rangeExp) > 10) {
    rangeExp++;
  }
  while (steps$1(min2, max2, rangeExp) < 10) {
    rangeExp--;
  }
  return Math.min(rangeExp, log10Floor(min2));
}
function generateTicks(generationOptions, { min: min2, max: max2 }) {
  min2 = finiteOrDefault(generationOptions.min, min2);
  const ticks = [];
  const minExp = log10Floor(min2);
  let exp = startExp(min2, max2);
  let precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;
  const stepSize = Math.pow(10, exp);
  const base = minExp > exp ? Math.pow(10, minExp) : 0;
  const start = Math.round((min2 - base) * precision) / precision;
  const offset2 = Math.floor((min2 - base) / stepSize / 10) * stepSize * 10;
  let significand = Math.floor((start - offset2) / Math.pow(10, exp));
  let value = finiteOrDefault(generationOptions.min, Math.round((base + offset2 + significand * Math.pow(10, exp)) * precision) / precision);
  while (value < max2) {
    ticks.push({
      value,
      major: isMajor(value),
      significand
    });
    if (significand >= 10) {
      significand = significand < 15 ? 15 : 20;
    } else {
      significand++;
    }
    if (significand >= 20) {
      exp++;
      significand = 2;
      precision = exp >= 0 ? 1 : precision;
    }
    value = Math.round((base + offset2 + significand * Math.pow(10, exp)) * precision) / precision;
  }
  const lastTick = finiteOrDefault(generationOptions.max, value);
  ticks.push({
    value: lastTick,
    major: isMajor(lastTick),
    significand
  });
  return ticks;
}
class LogarithmicScale extends Scale {
  constructor(cfg) {
    super(cfg);
    this.start = void 0;
    this.end = void 0;
    this._startValue = void 0;
    this._valueRange = 0;
  }
  parse(raw, index2) {
    const value = LinearScaleBase.prototype.parse.apply(this, [
      raw,
      index2
    ]);
    if (value === 0) {
      this._zero = true;
      return void 0;
    }
    return isNumberFinite(value) && value > 0 ? value : null;
  }
  determineDataLimits() {
    const { min: min2, max: max2 } = this.getMinMax(true);
    this.min = isNumberFinite(min2) ? Math.max(0, min2) : null;
    this.max = isNumberFinite(max2) ? Math.max(0, max2) : null;
    if (this.options.beginAtZero) {
      this._zero = true;
    }
    if (this._zero && this.min !== this._suggestedMin && !isNumberFinite(this._userMin)) {
      this.min = min2 === changeExponent(this.min, 0) ? changeExponent(this.min, -1) : changeExponent(this.min, 0);
    }
    this.handleTickRangeOptions();
  }
  handleTickRangeOptions() {
    const { minDefined, maxDefined } = this.getUserBounds();
    let min2 = this.min;
    let max2 = this.max;
    const setMin = (v2) => min2 = minDefined ? min2 : v2;
    const setMax = (v2) => max2 = maxDefined ? max2 : v2;
    if (min2 === max2) {
      if (min2 <= 0) {
        setMin(1);
        setMax(10);
      } else {
        setMin(changeExponent(min2, -1));
        setMax(changeExponent(max2, 1));
      }
    }
    if (min2 <= 0) {
      setMin(changeExponent(max2, -1));
    }
    if (max2 <= 0) {
      setMax(changeExponent(min2, 1));
    }
    this.min = min2;
    this.max = max2;
  }
  buildTicks() {
    const opts = this.options;
    const generationOptions = {
      min: this._userMin,
      max: this._userMax
    };
    const ticks = generateTicks(generationOptions, this);
    if (opts.bounds === "ticks") {
      _setMinAndMaxByKey(ticks, this, "value");
    }
    if (opts.reverse) {
      ticks.reverse();
      this.start = this.max;
      this.end = this.min;
    } else {
      this.start = this.min;
      this.end = this.max;
    }
    return ticks;
  }
  getLabelForValue(value) {
    return value === void 0 ? "0" : formatNumber(value, this.chart.options.locale, this.options.ticks.format);
  }
  configure() {
    const start = this.min;
    super.configure();
    this._startValue = log10(start);
    this._valueRange = log10(this.max) - log10(start);
  }
  getPixelForValue(value) {
    if (value === void 0 || value === 0) {
      value = this.min;
    }
    if (value === null || isNaN(value)) {
      return NaN;
    }
    return this.getPixelForDecimal(value === this.min ? 0 : (log10(value) - this._startValue) / this._valueRange);
  }
  getValueForPixel(pixel) {
    const decimal = this.getDecimalForPixel(pixel);
    return Math.pow(10, this._startValue + decimal * this._valueRange);
  }
}
__publicField(LogarithmicScale, "id", "logarithmic");
__publicField(LogarithmicScale, "defaults", {
  ticks: {
    callback: Ticks.formatters.logarithmic,
    major: {
      enabled: true
    }
  }
});
function getTickBackdropHeight(opts) {
  const tickOpts = opts.ticks;
  if (tickOpts.display && opts.display) {
    const padding = toPadding(tickOpts.backdropPadding);
    return valueOrDefault(tickOpts.font && tickOpts.font.size, defaults$3.font.size) + padding.height;
  }
  return 0;
}
function measureLabelSize(ctx, font, label) {
  label = isArray$1(label) ? label : [
    label
  ];
  return {
    w: _longestText(ctx, font.string, label),
    h: label.length * font.lineHeight
  };
}
function determineLimits(angle, pos, size2, min2, max2) {
  if (angle === min2 || angle === max2) {
    return {
      start: pos - size2 / 2,
      end: pos + size2 / 2
    };
  } else if (angle < min2 || angle > max2) {
    return {
      start: pos - size2,
      end: pos
    };
  }
  return {
    start: pos,
    end: pos + size2
  };
}
function fitWithPointLabels(scale2) {
  const orig = {
    l: scale2.left + scale2._padding.left,
    r: scale2.right - scale2._padding.right,
    t: scale2.top + scale2._padding.top,
    b: scale2.bottom - scale2._padding.bottom
  };
  const limits = Object.assign({}, orig);
  const labelSizes = [];
  const padding = [];
  const valueCount = scale2._pointLabels.length;
  const pointLabelOpts = scale2.options.pointLabels;
  const additionalAngle = pointLabelOpts.centerPointLabels ? PI / valueCount : 0;
  for (let i = 0; i < valueCount; i++) {
    const opts = pointLabelOpts.setContext(scale2.getPointLabelContext(i));
    padding[i] = opts.padding;
    const pointPosition = scale2.getPointPosition(i, scale2.drawingArea + padding[i], additionalAngle);
    const plFont = toFont(opts.font);
    const textSize = measureLabelSize(scale2.ctx, plFont, scale2._pointLabels[i]);
    labelSizes[i] = textSize;
    const angleRadians = _normalizeAngle(scale2.getIndexAngle(i) + additionalAngle);
    const angle = Math.round(toDegrees(angleRadians));
    const hLimits = determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
    const vLimits = determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
    updateLimits(limits, orig, angleRadians, hLimits, vLimits);
  }
  scale2.setCenterPoint(orig.l - limits.l, limits.r - orig.r, orig.t - limits.t, limits.b - orig.b);
  scale2._pointLabelItems = buildPointLabelItems(scale2, labelSizes, padding);
}
function updateLimits(limits, orig, angle, hLimits, vLimits) {
  const sin = Math.abs(Math.sin(angle));
  const cos = Math.abs(Math.cos(angle));
  let x2 = 0;
  let y2 = 0;
  if (hLimits.start < orig.l) {
    x2 = (orig.l - hLimits.start) / sin;
    limits.l = Math.min(limits.l, orig.l - x2);
  } else if (hLimits.end > orig.r) {
    x2 = (hLimits.end - orig.r) / sin;
    limits.r = Math.max(limits.r, orig.r + x2);
  }
  if (vLimits.start < orig.t) {
    y2 = (orig.t - vLimits.start) / cos;
    limits.t = Math.min(limits.t, orig.t - y2);
  } else if (vLimits.end > orig.b) {
    y2 = (vLimits.end - orig.b) / cos;
    limits.b = Math.max(limits.b, orig.b + y2);
  }
}
function createPointLabelItem(scale2, index2, itemOpts) {
  const outerDistance = scale2.drawingArea;
  const { extra, additionalAngle, padding, size: size2 } = itemOpts;
  const pointLabelPosition = scale2.getPointPosition(index2, outerDistance + extra + padding, additionalAngle);
  const angle = Math.round(toDegrees(_normalizeAngle(pointLabelPosition.angle + HALF_PI)));
  const y2 = yForAngle(pointLabelPosition.y, size2.h, angle);
  const textAlign = getTextAlignForAngle(angle);
  const left = leftForTextAlign(pointLabelPosition.x, size2.w, textAlign);
  return {
    visible: true,
    x: pointLabelPosition.x,
    y: y2,
    textAlign,
    left,
    top: y2,
    right: left + size2.w,
    bottom: y2 + size2.h
  };
}
function isNotOverlapped(item, area) {
  if (!area) {
    return true;
  }
  const { left, top, right, bottom } = item;
  const apexesInArea = _isPointInArea({
    x: left,
    y: top
  }, area) || _isPointInArea({
    x: left,
    y: bottom
  }, area) || _isPointInArea({
    x: right,
    y: top
  }, area) || _isPointInArea({
    x: right,
    y: bottom
  }, area);
  return !apexesInArea;
}
function buildPointLabelItems(scale2, labelSizes, padding) {
  const items = [];
  const valueCount = scale2._pointLabels.length;
  const opts = scale2.options;
  const { centerPointLabels, display: display2 } = opts.pointLabels;
  const itemOpts = {
    extra: getTickBackdropHeight(opts) / 2,
    additionalAngle: centerPointLabels ? PI / valueCount : 0
  };
  let area;
  for (let i = 0; i < valueCount; i++) {
    itemOpts.padding = padding[i];
    itemOpts.size = labelSizes[i];
    const item = createPointLabelItem(scale2, i, itemOpts);
    items.push(item);
    if (display2 === "auto") {
      item.visible = isNotOverlapped(item, area);
      if (item.visible) {
        area = item;
      }
    }
  }
  return items;
}
function getTextAlignForAngle(angle) {
  if (angle === 0 || angle === 180) {
    return "center";
  } else if (angle < 180) {
    return "left";
  }
  return "right";
}
function leftForTextAlign(x2, w2, align) {
  if (align === "right") {
    x2 -= w2;
  } else if (align === "center") {
    x2 -= w2 / 2;
  }
  return x2;
}
function yForAngle(y2, h3, angle) {
  if (angle === 90 || angle === 270) {
    y2 -= h3 / 2;
  } else if (angle > 270 || angle < 90) {
    y2 -= h3;
  }
  return y2;
}
function drawPointLabelBox(ctx, opts, item) {
  const { left, top, right, bottom } = item;
  const { backdropColor } = opts;
  if (!isNullOrUndef(backdropColor)) {
    const borderRadius2 = toTRBLCorners(opts.borderRadius);
    const padding = toPadding(opts.backdropPadding);
    ctx.fillStyle = backdropColor;
    const backdropLeft = left - padding.left;
    const backdropTop = top - padding.top;
    const backdropWidth = right - left + padding.width;
    const backdropHeight = bottom - top + padding.height;
    if (Object.values(borderRadius2).some((v2) => v2 !== 0)) {
      ctx.beginPath();
      addRoundedRectPath(ctx, {
        x: backdropLeft,
        y: backdropTop,
        w: backdropWidth,
        h: backdropHeight,
        radius: borderRadius2
      });
      ctx.fill();
    } else {
      ctx.fillRect(backdropLeft, backdropTop, backdropWidth, backdropHeight);
    }
  }
}
function drawPointLabels(scale2, labelCount) {
  const { ctx, options: { pointLabels } } = scale2;
  for (let i = labelCount - 1; i >= 0; i--) {
    const item = scale2._pointLabelItems[i];
    if (!item.visible) {
      continue;
    }
    const optsAtIndex = pointLabels.setContext(scale2.getPointLabelContext(i));
    drawPointLabelBox(ctx, optsAtIndex, item);
    const plFont = toFont(optsAtIndex.font);
    const { x: x2, y: y2, textAlign } = item;
    renderText(ctx, scale2._pointLabels[i], x2, y2 + plFont.lineHeight / 2, plFont, {
      color: optsAtIndex.color,
      textAlign,
      textBaseline: "middle"
    });
  }
}
function pathRadiusLine(scale2, radius, circular, labelCount) {
  const { ctx } = scale2;
  if (circular) {
    ctx.arc(scale2.xCenter, scale2.yCenter, radius, 0, TAU);
  } else {
    let pointPosition = scale2.getPointPosition(0, radius);
    ctx.moveTo(pointPosition.x, pointPosition.y);
    for (let i = 1; i < labelCount; i++) {
      pointPosition = scale2.getPointPosition(i, radius);
      ctx.lineTo(pointPosition.x, pointPosition.y);
    }
  }
}
function drawRadiusLine(scale2, gridLineOpts, radius, labelCount, borderOpts) {
  const ctx = scale2.ctx;
  const circular = gridLineOpts.circular;
  const { color: color2, lineWidth } = gridLineOpts;
  if (!circular && !labelCount || !color2 || !lineWidth || radius < 0) {
    return;
  }
  ctx.save();
  ctx.strokeStyle = color2;
  ctx.lineWidth = lineWidth;
  ctx.setLineDash(borderOpts.dash);
  ctx.lineDashOffset = borderOpts.dashOffset;
  ctx.beginPath();
  pathRadiusLine(scale2, radius, circular, labelCount);
  ctx.closePath();
  ctx.stroke();
  ctx.restore();
}
function createPointLabelContext(parent, index2, label) {
  return createContext(parent, {
    label,
    index: index2,
    type: "pointLabel"
  });
}
class RadialLinearScale extends LinearScaleBase {
  constructor(cfg) {
    super(cfg);
    this.xCenter = void 0;
    this.yCenter = void 0;
    this.drawingArea = void 0;
    this._pointLabels = [];
    this._pointLabelItems = [];
  }
  setDimensions() {
    const padding = this._padding = toPadding(getTickBackdropHeight(this.options) / 2);
    const w2 = this.width = this.maxWidth - padding.width;
    const h3 = this.height = this.maxHeight - padding.height;
    this.xCenter = Math.floor(this.left + w2 / 2 + padding.left);
    this.yCenter = Math.floor(this.top + h3 / 2 + padding.top);
    this.drawingArea = Math.floor(Math.min(w2, h3) / 2);
  }
  determineDataLimits() {
    const { min: min2, max: max2 } = this.getMinMax(false);
    this.min = isNumberFinite(min2) && !isNaN(min2) ? min2 : 0;
    this.max = isNumberFinite(max2) && !isNaN(max2) ? max2 : 0;
    this.handleTickRangeOptions();
  }
  computeTickLimit() {
    return Math.ceil(this.drawingArea / getTickBackdropHeight(this.options));
  }
  generateTickLabels(ticks) {
    LinearScaleBase.prototype.generateTickLabels.call(this, ticks);
    this._pointLabels = this.getLabels().map((value, index2) => {
      const label = callback(this.options.pointLabels.callback, [
        value,
        index2
      ], this);
      return label || label === 0 ? label : "";
    }).filter((v2, i) => this.chart.getDataVisibility(i));
  }
  fit() {
    const opts = this.options;
    if (opts.display && opts.pointLabels.display) {
      fitWithPointLabels(this);
    } else {
      this.setCenterPoint(0, 0, 0, 0);
    }
  }
  setCenterPoint(leftMovement, rightMovement, topMovement, bottomMovement) {
    this.xCenter += Math.floor((leftMovement - rightMovement) / 2);
    this.yCenter += Math.floor((topMovement - bottomMovement) / 2);
    this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(leftMovement, rightMovement, topMovement, bottomMovement));
  }
  getIndexAngle(index2) {
    const angleMultiplier = TAU / (this._pointLabels.length || 1);
    const startAngle = this.options.startAngle || 0;
    return _normalizeAngle(index2 * angleMultiplier + toRadians(startAngle));
  }
  getDistanceFromCenterForValue(value) {
    if (isNullOrUndef(value)) {
      return NaN;
    }
    const scalingFactor = this.drawingArea / (this.max - this.min);
    if (this.options.reverse) {
      return (this.max - value) * scalingFactor;
    }
    return (value - this.min) * scalingFactor;
  }
  getValueForDistanceFromCenter(distance2) {
    if (isNullOrUndef(distance2)) {
      return NaN;
    }
    const scaledDistance = distance2 / (this.drawingArea / (this.max - this.min));
    return this.options.reverse ? this.max - scaledDistance : this.min + scaledDistance;
  }
  getPointLabelContext(index2) {
    const pointLabels = this._pointLabels || [];
    if (index2 >= 0 && index2 < pointLabels.length) {
      const pointLabel = pointLabels[index2];
      return createPointLabelContext(this.getContext(), index2, pointLabel);
    }
  }
  getPointPosition(index2, distanceFromCenter, additionalAngle = 0) {
    const angle = this.getIndexAngle(index2) - HALF_PI + additionalAngle;
    return {
      x: Math.cos(angle) * distanceFromCenter + this.xCenter,
      y: Math.sin(angle) * distanceFromCenter + this.yCenter,
      angle
    };
  }
  getPointPositionForValue(index2, value) {
    return this.getPointPosition(index2, this.getDistanceFromCenterForValue(value));
  }
  getBasePosition(index2) {
    return this.getPointPositionForValue(index2 || 0, this.getBaseValue());
  }
  getPointLabelPosition(index2) {
    const { left, top, right, bottom } = this._pointLabelItems[index2];
    return {
      left,
      top,
      right,
      bottom
    };
  }
  drawBackground() {
    const { backgroundColor, grid: { circular } } = this.options;
    if (backgroundColor) {
      const ctx = this.ctx;
      ctx.save();
      ctx.beginPath();
      pathRadiusLine(this, this.getDistanceFromCenterForValue(this._endValue), circular, this._pointLabels.length);
      ctx.closePath();
      ctx.fillStyle = backgroundColor;
      ctx.fill();
      ctx.restore();
    }
  }
  drawGrid() {
    const ctx = this.ctx;
    const opts = this.options;
    const { angleLines, grid, border } = opts;
    const labelCount = this._pointLabels.length;
    let i, offset2, position2;
    if (opts.pointLabels.display) {
      drawPointLabels(this, labelCount);
    }
    if (grid.display) {
      this.ticks.forEach((tick, index2) => {
        if (index2 !== 0 || index2 === 0 && this.min < 0) {
          offset2 = this.getDistanceFromCenterForValue(tick.value);
          const context = this.getContext(index2);
          const optsAtIndex = grid.setContext(context);
          const optsAtIndexBorder = border.setContext(context);
          drawRadiusLine(this, optsAtIndex, offset2, labelCount, optsAtIndexBorder);
        }
      });
    }
    if (angleLines.display) {
      ctx.save();
      for (i = labelCount - 1; i >= 0; i--) {
        const optsAtIndex = angleLines.setContext(this.getPointLabelContext(i));
        const { color: color2, lineWidth } = optsAtIndex;
        if (!lineWidth || !color2) {
          continue;
        }
        ctx.lineWidth = lineWidth;
        ctx.strokeStyle = color2;
        ctx.setLineDash(optsAtIndex.borderDash);
        ctx.lineDashOffset = optsAtIndex.borderDashOffset;
        offset2 = this.getDistanceFromCenterForValue(opts.ticks.reverse ? this.min : this.max);
        position2 = this.getPointPosition(i, offset2);
        ctx.beginPath();
        ctx.moveTo(this.xCenter, this.yCenter);
        ctx.lineTo(position2.x, position2.y);
        ctx.stroke();
      }
      ctx.restore();
    }
  }
  drawBorder() {
  }
  drawLabels() {
    const ctx = this.ctx;
    const opts = this.options;
    const tickOpts = opts.ticks;
    if (!tickOpts.display) {
      return;
    }
    const startAngle = this.getIndexAngle(0);
    let offset2, width;
    ctx.save();
    ctx.translate(this.xCenter, this.yCenter);
    ctx.rotate(startAngle);
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    this.ticks.forEach((tick, index2) => {
      if (index2 === 0 && this.min >= 0 && !opts.reverse) {
        return;
      }
      const optsAtIndex = tickOpts.setContext(this.getContext(index2));
      const tickFont = toFont(optsAtIndex.font);
      offset2 = this.getDistanceFromCenterForValue(this.ticks[index2].value);
      if (optsAtIndex.showLabelBackdrop) {
        ctx.font = tickFont.string;
        width = ctx.measureText(tick.label).width;
        ctx.fillStyle = optsAtIndex.backdropColor;
        const padding = toPadding(optsAtIndex.backdropPadding);
        ctx.fillRect(-width / 2 - padding.left, -offset2 - tickFont.size / 2 - padding.top, width + padding.width, tickFont.size + padding.height);
      }
      renderText(ctx, tick.label, 0, -offset2, tickFont, {
        color: optsAtIndex.color,
        strokeColor: optsAtIndex.textStrokeColor,
        strokeWidth: optsAtIndex.textStrokeWidth
      });
    });
    ctx.restore();
  }
  drawTitle() {
  }
}
__publicField(RadialLinearScale, "id", "radialLinear");
__publicField(RadialLinearScale, "defaults", {
  display: true,
  animate: true,
  position: "chartArea",
  angleLines: {
    display: true,
    lineWidth: 1,
    borderDash: [],
    borderDashOffset: 0
  },
  grid: {
    circular: false
  },
  startAngle: 0,
  ticks: {
    showLabelBackdrop: true,
    callback: Ticks.formatters.numeric
  },
  pointLabels: {
    backdropColor: void 0,
    backdropPadding: 2,
    display: true,
    font: {
      size: 10
    },
    callback(label) {
      return label;
    },
    padding: 5,
    centerPointLabels: false
  }
});
__publicField(RadialLinearScale, "defaultRoutes", {
  "angleLines.color": "borderColor",
  "pointLabels.color": "color",
  "ticks.color": "color"
});
__publicField(RadialLinearScale, "descriptors", {
  angleLines: {
    _fallback: "grid"
  }
});
const INTERVALS = {
  millisecond: {
    common: true,
    size: 1,
    steps: 1e3
  },
  second: {
    common: true,
    size: 1e3,
    steps: 60
  },
  minute: {
    common: true,
    size: 6e4,
    steps: 60
  },
  hour: {
    common: true,
    size: 36e5,
    steps: 24
  },
  day: {
    common: true,
    size: 864e5,
    steps: 30
  },
  week: {
    common: false,
    size: 6048e5,
    steps: 4
  },
  month: {
    common: true,
    size: 2628e6,
    steps: 12
  },
  quarter: {
    common: false,
    size: 7884e6,
    steps: 4
  },
  year: {
    common: true,
    size: 3154e7
  }
};
const UNITS = /* @__PURE__ */ Object.keys(INTERVALS);
function sorter(a2, b2) {
  return a2 - b2;
}
function parse$3(scale2, input) {
  if (isNullOrUndef(input)) {
    return null;
  }
  const adapter = scale2._adapter;
  const { parser, round: round2, isoWeekday } = scale2._parseOpts;
  let value = input;
  if (typeof parser === "function") {
    value = parser(value);
  }
  if (!isNumberFinite(value)) {
    value = typeof parser === "string" ? adapter.parse(value, parser) : adapter.parse(value);
  }
  if (value === null) {
    return null;
  }
  if (round2) {
    value = round2 === "week" && (isNumber$1(isoWeekday) || isoWeekday === true) ? adapter.startOf(value, "isoWeek", isoWeekday) : adapter.startOf(value, round2);
  }
  return +value;
}
function determineUnitForAutoTicks(minUnit, min2, max2, capacity) {
  const ilen = UNITS.length;
  for (let i = UNITS.indexOf(minUnit); i < ilen - 1; ++i) {
    const interval = INTERVALS[UNITS[i]];
    const factor = interval.steps ? interval.steps : Number.MAX_SAFE_INTEGER;
    if (interval.common && Math.ceil((max2 - min2) / (factor * interval.size)) <= capacity) {
      return UNITS[i];
    }
  }
  return UNITS[ilen - 1];
}
function determineUnitForFormatting(scale2, numTicks, minUnit, min2, max2) {
  for (let i = UNITS.length - 1; i >= UNITS.indexOf(minUnit); i--) {
    const unit = UNITS[i];
    if (INTERVALS[unit].common && scale2._adapter.diff(max2, min2, unit) >= numTicks - 1) {
      return unit;
    }
  }
  return UNITS[minUnit ? UNITS.indexOf(minUnit) : 0];
}
function determineMajorUnit(unit) {
  for (let i = UNITS.indexOf(unit) + 1, ilen = UNITS.length; i < ilen; ++i) {
    if (INTERVALS[UNITS[i]].common) {
      return UNITS[i];
    }
  }
}
function addTick(ticks, time, timestamps) {
  if (!timestamps) {
    ticks[time] = true;
  } else if (timestamps.length) {
    const { lo, hi } = _lookup(timestamps, time);
    const timestamp = timestamps[lo] >= time ? timestamps[lo] : timestamps[hi];
    ticks[timestamp] = true;
  }
}
function setMajorTicks(scale2, ticks, map2, majorUnit) {
  const adapter = scale2._adapter;
  const first = +adapter.startOf(ticks[0].value, majorUnit);
  const last2 = ticks[ticks.length - 1].value;
  let major, index2;
  for (major = first; major <= last2; major = +adapter.add(major, 1, majorUnit)) {
    index2 = map2[major];
    if (index2 >= 0) {
      ticks[index2].major = true;
    }
  }
  return ticks;
}
function ticksFromTimestamps(scale2, values2, majorUnit) {
  const ticks = [];
  const map2 = {};
  const ilen = values2.length;
  let i, value;
  for (i = 0; i < ilen; ++i) {
    value = values2[i];
    map2[value] = i;
    ticks.push({
      value,
      major: false
    });
  }
  return ilen === 0 || !majorUnit ? ticks : setMajorTicks(scale2, ticks, map2, majorUnit);
}
class TimeScale extends Scale {
  constructor(props) {
    super(props);
    this._cache = {
      data: [],
      labels: [],
      all: []
    };
    this._unit = "day";
    this._majorUnit = void 0;
    this._offsets = {};
    this._normalized = false;
    this._parseOpts = void 0;
  }
  init(scaleOpts, opts = {}) {
    const time = scaleOpts.time || (scaleOpts.time = {});
    const adapter = this._adapter = new adapters._date(scaleOpts.adapters.date);
    adapter.init(opts);
    mergeIf(time.displayFormats, adapter.formats());
    this._parseOpts = {
      parser: time.parser,
      round: time.round,
      isoWeekday: time.isoWeekday
    };
    super.init(scaleOpts);
    this._normalized = opts.normalized;
  }
  parse(raw, index2) {
    if (raw === void 0) {
      return null;
    }
    return parse$3(this, raw);
  }
  beforeLayout() {
    super.beforeLayout();
    this._cache = {
      data: [],
      labels: [],
      all: []
    };
  }
  determineDataLimits() {
    const options2 = this.options;
    const adapter = this._adapter;
    const unit = options2.time.unit || "day";
    let { min: min2, max: max2, minDefined, maxDefined } = this.getUserBounds();
    function _applyBounds(bounds) {
      if (!minDefined && !isNaN(bounds.min)) {
        min2 = Math.min(min2, bounds.min);
      }
      if (!maxDefined && !isNaN(bounds.max)) {
        max2 = Math.max(max2, bounds.max);
      }
    }
    if (!minDefined || !maxDefined) {
      _applyBounds(this._getLabelBounds());
      if (options2.bounds !== "ticks" || options2.ticks.source !== "labels") {
        _applyBounds(this.getMinMax(false));
      }
    }
    min2 = isNumberFinite(min2) && !isNaN(min2) ? min2 : +adapter.startOf(Date.now(), unit);
    max2 = isNumberFinite(max2) && !isNaN(max2) ? max2 : +adapter.endOf(Date.now(), unit) + 1;
    this.min = Math.min(min2, max2 - 1);
    this.max = Math.max(min2 + 1, max2);
  }
  _getLabelBounds() {
    const arr = this.getLabelTimestamps();
    let min2 = Number.POSITIVE_INFINITY;
    let max2 = Number.NEGATIVE_INFINITY;
    if (arr.length) {
      min2 = arr[0];
      max2 = arr[arr.length - 1];
    }
    return {
      min: min2,
      max: max2
    };
  }
  buildTicks() {
    const options2 = this.options;
    const timeOpts = options2.time;
    const tickOpts = options2.ticks;
    const timestamps = tickOpts.source === "labels" ? this.getLabelTimestamps() : this._generate();
    if (options2.bounds === "ticks" && timestamps.length) {
      this.min = this._userMin || timestamps[0];
      this.max = this._userMax || timestamps[timestamps.length - 1];
    }
    const min2 = this.min;
    const max2 = this.max;
    const ticks = _filterBetween(timestamps, min2, max2);
    this._unit = timeOpts.unit || (tickOpts.autoSkip ? determineUnitForAutoTicks(timeOpts.minUnit, this.min, this.max, this._getLabelCapacity(min2)) : determineUnitForFormatting(this, ticks.length, timeOpts.minUnit, this.min, this.max));
    this._majorUnit = !tickOpts.major.enabled || this._unit === "year" ? void 0 : determineMajorUnit(this._unit);
    this.initOffsets(timestamps);
    if (options2.reverse) {
      ticks.reverse();
    }
    return ticksFromTimestamps(this, ticks, this._majorUnit);
  }
  afterAutoSkip() {
    if (this.options.offsetAfterAutoskip) {
      this.initOffsets(this.ticks.map((tick) => +tick.value));
    }
  }
  initOffsets(timestamps = []) {
    let start = 0;
    let end = 0;
    let first, last2;
    if (this.options.offset && timestamps.length) {
      first = this.getDecimalForValue(timestamps[0]);
      if (timestamps.length === 1) {
        start = 1 - first;
      } else {
        start = (this.getDecimalForValue(timestamps[1]) - first) / 2;
      }
      last2 = this.getDecimalForValue(timestamps[timestamps.length - 1]);
      if (timestamps.length === 1) {
        end = last2;
      } else {
        end = (last2 - this.getDecimalForValue(timestamps[timestamps.length - 2])) / 2;
      }
    }
    const limit = timestamps.length < 3 ? 0.5 : 0.25;
    start = _limitValue(start, 0, limit);
    end = _limitValue(end, 0, limit);
    this._offsets = {
      start,
      end,
      factor: 1 / (start + 1 + end)
    };
  }
  _generate() {
    const adapter = this._adapter;
    const min2 = this.min;
    const max2 = this.max;
    const options2 = this.options;
    const timeOpts = options2.time;
    const minor = timeOpts.unit || determineUnitForAutoTicks(timeOpts.minUnit, min2, max2, this._getLabelCapacity(min2));
    const stepSize = valueOrDefault(options2.ticks.stepSize, 1);
    const weekday = minor === "week" ? timeOpts.isoWeekday : false;
    const hasWeekday = isNumber$1(weekday) || weekday === true;
    const ticks = {};
    let first = min2;
    let time, count;
    if (hasWeekday) {
      first = +adapter.startOf(first, "isoWeek", weekday);
    }
    first = +adapter.startOf(first, hasWeekday ? "day" : minor);
    if (adapter.diff(max2, min2, minor) > 1e5 * stepSize) {
      throw new Error(min2 + " and " + max2 + " are too far apart with stepSize of " + stepSize + " " + minor);
    }
    const timestamps = options2.ticks.source === "data" && this.getDataTimestamps();
    for (time = first, count = 0; time < max2; time = +adapter.add(time, stepSize, minor), count++) {
      addTick(ticks, time, timestamps);
    }
    if (time === max2 || options2.bounds === "ticks" || count === 1) {
      addTick(ticks, time, timestamps);
    }
    return Object.keys(ticks).sort(sorter).map((x2) => +x2);
  }
  getLabelForValue(value) {
    const adapter = this._adapter;
    const timeOpts = this.options.time;
    if (timeOpts.tooltipFormat) {
      return adapter.format(value, timeOpts.tooltipFormat);
    }
    return adapter.format(value, timeOpts.displayFormats.datetime);
  }
  format(value, format) {
    const options2 = this.options;
    const formats = options2.time.displayFormats;
    const unit = this._unit;
    const fmt = format || formats[unit];
    return this._adapter.format(value, fmt);
  }
  _tickFormatFunction(time, index2, ticks, format) {
    const options2 = this.options;
    const formatter = options2.ticks.callback;
    if (formatter) {
      return callback(formatter, [
        time,
        index2,
        ticks
      ], this);
    }
    const formats = options2.time.displayFormats;
    const unit = this._unit;
    const majorUnit = this._majorUnit;
    const minorFormat = unit && formats[unit];
    const majorFormat = majorUnit && formats[majorUnit];
    const tick = ticks[index2];
    const major = majorUnit && majorFormat && tick && tick.major;
    return this._adapter.format(time, format || (major ? majorFormat : minorFormat));
  }
  generateTickLabels(ticks) {
    let i, ilen, tick;
    for (i = 0, ilen = ticks.length; i < ilen; ++i) {
      tick = ticks[i];
      tick.label = this._tickFormatFunction(tick.value, i, ticks);
    }
  }
  getDecimalForValue(value) {
    return value === null ? NaN : (value - this.min) / (this.max - this.min);
  }
  getPixelForValue(value) {
    const offsets = this._offsets;
    const pos = this.getDecimalForValue(value);
    return this.getPixelForDecimal((offsets.start + pos) * offsets.factor);
  }
  getValueForPixel(pixel) {
    const offsets = this._offsets;
    const pos = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
    return this.min + pos * (this.max - this.min);
  }
  _getLabelSize(label) {
    const ticksOpts = this.options.ticks;
    const tickLabelWidth = this.ctx.measureText(label).width;
    const angle = toRadians(this.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
    const cosRotation = Math.cos(angle);
    const sinRotation = Math.sin(angle);
    const tickFontSize = this._resolveTickFontOptions(0).size;
    return {
      w: tickLabelWidth * cosRotation + tickFontSize * sinRotation,
      h: tickLabelWidth * sinRotation + tickFontSize * cosRotation
    };
  }
  _getLabelCapacity(exampleTime) {
    const timeOpts = this.options.time;
    const displayFormats = timeOpts.displayFormats;
    const format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
    const exampleLabel = this._tickFormatFunction(exampleTime, 0, ticksFromTimestamps(this, [
      exampleTime
    ], this._majorUnit), format);
    const size2 = this._getLabelSize(exampleLabel);
    const capacity = Math.floor(this.isHorizontal() ? this.width / size2.w : this.height / size2.h) - 1;
    return capacity > 0 ? capacity : 1;
  }
  getDataTimestamps() {
    let timestamps = this._cache.data || [];
    let i, ilen;
    if (timestamps.length) {
      return timestamps;
    }
    const metas = this.getMatchingVisibleMetas();
    if (this._normalized && metas.length) {
      return this._cache.data = metas[0].controller.getAllParsedValues(this);
    }
    for (i = 0, ilen = metas.length; i < ilen; ++i) {
      timestamps = timestamps.concat(metas[i].controller.getAllParsedValues(this));
    }
    return this._cache.data = this.normalize(timestamps);
  }
  getLabelTimestamps() {
    const timestamps = this._cache.labels || [];
    let i, ilen;
    if (timestamps.length) {
      return timestamps;
    }
    const labels = this.getLabels();
    for (i = 0, ilen = labels.length; i < ilen; ++i) {
      timestamps.push(parse$3(this, labels[i]));
    }
    return this._cache.labels = this._normalized ? timestamps : this.normalize(timestamps);
  }
  normalize(values2) {
    return _arrayUnique(values2.sort(sorter));
  }
}
__publicField(TimeScale, "id", "time");
__publicField(TimeScale, "defaults", {
  bounds: "data",
  adapters: {},
  time: {
    parser: false,
    unit: false,
    round: false,
    isoWeekday: false,
    minUnit: "millisecond",
    displayFormats: {}
  },
  ticks: {
    source: "auto",
    callback: false,
    major: {
      enabled: false
    }
  }
});
function interpolate$1(table, val, reverse) {
  let lo = 0;
  let hi = table.length - 1;
  let prevSource, nextSource, prevTarget, nextTarget;
  if (reverse) {
    if (val >= table[lo].pos && val <= table[hi].pos) {
      ({ lo, hi } = _lookupByKey(table, "pos", val));
    }
    ({ pos: prevSource, time: prevTarget } = table[lo]);
    ({ pos: nextSource, time: nextTarget } = table[hi]);
  } else {
    if (val >= table[lo].time && val <= table[hi].time) {
      ({ lo, hi } = _lookupByKey(table, "time", val));
    }
    ({ time: prevSource, pos: prevTarget } = table[lo]);
    ({ time: nextSource, pos: nextTarget } = table[hi]);
  }
  const span = nextSource - prevSource;
  return span ? prevTarget + (nextTarget - prevTarget) * (val - prevSource) / span : prevTarget;
}
class TimeSeriesScale extends TimeScale {
  constructor(props) {
    super(props);
    this._table = [];
    this._minPos = void 0;
    this._tableRange = void 0;
  }
  initOffsets() {
    const timestamps = this._getTimestampsForTable();
    const table = this._table = this.buildLookupTable(timestamps);
    this._minPos = interpolate$1(table, this.min);
    this._tableRange = interpolate$1(table, this.max) - this._minPos;
    super.initOffsets(timestamps);
  }
  buildLookupTable(timestamps) {
    const { min: min2, max: max2 } = this;
    const items = [];
    const table = [];
    let i, ilen, prev2, curr, next2;
    for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
      curr = timestamps[i];
      if (curr >= min2 && curr <= max2) {
        items.push(curr);
      }
    }
    if (items.length < 2) {
      return [
        {
          time: min2,
          pos: 0
        },
        {
          time: max2,
          pos: 1
        }
      ];
    }
    for (i = 0, ilen = items.length; i < ilen; ++i) {
      next2 = items[i + 1];
      prev2 = items[i - 1];
      curr = items[i];
      if (Math.round((next2 + prev2) / 2) !== curr) {
        table.push({
          time: curr,
          pos: i / (ilen - 1)
        });
      }
    }
    return table;
  }
  _generate() {
    const min2 = this.min;
    const max2 = this.max;
    let timestamps = super.getDataTimestamps();
    if (!timestamps.includes(min2) || !timestamps.length) {
      timestamps.splice(0, 0, min2);
    }
    if (!timestamps.includes(max2) || timestamps.length === 1) {
      timestamps.push(max2);
    }
    return timestamps.sort((a2, b2) => a2 - b2);
  }
  _getTimestampsForTable() {
    let timestamps = this._cache.all || [];
    if (timestamps.length) {
      return timestamps;
    }
    const data2 = this.getDataTimestamps();
    const label = this.getLabelTimestamps();
    if (data2.length && label.length) {
      timestamps = this.normalize(data2.concat(label));
    } else {
      timestamps = data2.length ? data2 : label;
    }
    timestamps = this._cache.all = timestamps;
    return timestamps;
  }
  getDecimalForValue(value) {
    return (interpolate$1(this._table, value) - this._minPos) / this._tableRange;
  }
  getValueForPixel(pixel) {
    const offsets = this._offsets;
    const decimal = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
    return interpolate$1(this._table, decimal * this._tableRange + this._minPos, true);
  }
}
__publicField(TimeSeriesScale, "id", "timeseries");
__publicField(TimeSeriesScale, "defaults", TimeScale.defaults);
var scales = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  CategoryScale,
  LinearScale,
  LogarithmicScale,
  RadialLinearScale,
  TimeScale,
  TimeSeriesScale
});
const registerables = [
  controllers,
  elements,
  plugins,
  scales
];
Chart$1.register(...registerables);
const defaultDatasetIdKey = "label";
function reforwardRef(ref, value) {
  if (typeof ref === "function") {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
}
function setOptions(chart, nextOptions) {
  const options2 = chart.options;
  if (options2 && nextOptions) {
    Object.assign(options2, nextOptions);
  }
}
function setLabels(currentData, nextLabels) {
  currentData.labels = nextLabels;
}
function setDatasets(currentData, nextDatasets, datasetIdKey = defaultDatasetIdKey) {
  const addedDatasets = [];
  currentData.datasets = nextDatasets.map(
    (nextDataset) => {
      const currentDataset = currentData.datasets.find(
        (dataset) => dataset[datasetIdKey] === nextDataset[datasetIdKey]
      );
      if (!currentDataset || !nextDataset.data || addedDatasets.includes(currentDataset)) {
        return { ...nextDataset };
      }
      addedDatasets.push(currentDataset);
      Object.assign(currentDataset, nextDataset);
      return currentDataset;
    }
  );
}
function cloneData(data2, datasetIdKey = defaultDatasetIdKey) {
  const nextData = {
    labels: [],
    datasets: []
  };
  setLabels(nextData, data2.labels);
  setDatasets(nextData, data2.datasets, datasetIdKey);
  return nextData;
}
function getElementAtEvent(chart, event) {
  return chart === void 0 ? null : chart.getElementsAtEventForMode(
    event.nativeEvent,
    "nearest",
    { intersect: true },
    false
  );
}
function ChartComponent(props, ref) {
  const {
    height: height2 = 150,
    width = 300,
    redraw = false,
    datasetIdKey,
    type: type2,
    data: data2,
    options: options2,
    plugins: plugins2 = [],
    fallbackContent,
    updateMode,
    ...canvasProps
  } = props;
  const canvasRef = useRef(null);
  const chartRef = useRef();
  const renderChart = () => {
    if (!canvasRef.current) return;
    chartRef.current = new Chart$1(canvasRef.current, {
      type: type2,
      data: cloneData(data2, datasetIdKey),
      options: options2 && { ...options2 },
      plugins: plugins2
    });
    reforwardRef(ref, chartRef.current);
  };
  const destroyChart = () => {
    reforwardRef(ref, null);
    if (chartRef.current) {
      chartRef.current.destroy();
      chartRef.current = null;
    }
  };
  useEffect(() => {
    if (!redraw && chartRef.current && options2) {
      setOptions(chartRef.current, options2);
    }
  }, [redraw, options2]);
  useEffect(() => {
    if (!redraw && chartRef.current) {
      setLabels(chartRef.current.config.data, data2.labels);
    }
  }, [redraw, data2.labels]);
  useEffect(() => {
    if (!redraw && chartRef.current && data2.datasets) {
      setDatasets(chartRef.current.config.data, data2.datasets, datasetIdKey);
    }
  }, [redraw, data2.datasets]);
  useEffect(() => {
    if (!chartRef.current) return;
    if (redraw) {
      destroyChart();
      setTimeout(renderChart);
    } else {
      chartRef.current.update(updateMode);
    }
  }, [redraw, options2, data2.labels, data2.datasets, updateMode]);
  useEffect(() => {
    if (!chartRef.current) return;
    destroyChart();
    setTimeout(renderChart);
  }, [type2]);
  useEffect(() => {
    renderChart();
    return () => destroyChart();
  }, []);
  return /* @__PURE__ */ React__default.createElement(
    "canvas",
    {
      ref: canvasRef,
      role: "img",
      height: height2,
      width,
      ...canvasProps
    },
    fallbackContent
  );
}
const Chart = forwardRef(ChartComponent);
function createTypedChart(type2, registerables2) {
  Chart$1.register(registerables2);
  return forwardRef(
    (props, ref) => /* @__PURE__ */ React__default.createElement(Chart, { ...props, ref, type: type2 })
  );
}
const Line$1 = /* @__PURE__ */ createTypedChart("line", LineController);
const Bar = /* @__PURE__ */ createTypedChart("bar", BarController);
const Doughnut = /* @__PURE__ */ createTypedChart(
  "doughnut",
  DoughnutController
);
var AreaComponent = "_1yr11kl0";
var AreaTitle = "_1yr11kl1";
const AreaChart = ({ chartName, data: data2, color: color2 = "#31859D", backgroundColor = "#FFFFFF", hasPoints = false }) => {
  const mappedData = {
    labels: data2.map((el) => el.label),
    datasets: [
      {
        data: data2.map((el) => el.value),
        tension: 0.5,
        fill: "start",
        borderColor: color2,
        backgroundColor: (context) => {
          if (!context.chart.chartArea) {
            return;
          }
          const { ctx, chartArea: { top, bottom } } = context.chart;
          const gradientBg = ctx.createLinearGradient(0, top, 0, bottom);
          gradientBg.addColorStop(0, color2);
          gradientBg.addColorStop(1, backgroundColor);
          return gradientBg;
        },
        pointBackgroundColor: "#ffffff",
        pointBorderColor: color2,
        pointRadius: hasPoints ? 5 : 0
      }
    ]
  };
  const options2 = {
    plugins: {
      legend: {
        display: false
      }
    },
    scales: {
      y: {
        offset: true,
        min: Math.min.apply(null, data2.map((el) => el.value)) - Math.max.apply(null, data2.map((el) => el.value)) / 5,
        grid: {
          display: false
        },
        ticks: {
          color: "#898A8D",
          callback: function(val, index2) {
            return index2 !== 0 ? val : "";
          }
        }
      },
      x: {
        grid: {
          display: false
        },
        ticks: {
          callback: function(val, index2) {
            return index2 !== 0 ? data2[val].label : "";
          },
          maxRotation: 0,
          minRotation: 0,
          color: "#898A8D"
        }
      }
    },
    maintainAspectRatio: false
  };
  return /* @__PURE__ */ React__default.createElement("div", { className: AreaComponent }, /* @__PURE__ */ React__default.createElement("h2", { className: AreaTitle }, chartName), /* @__PURE__ */ React__default.createElement(
    Line$1,
    {
      data: mappedData,
      options: options2
    }
  ));
};
var DoughnutComponent = "_18gk6hq0";
var DoughnutTitle = "_18gk6hq1";
var DoughnutSubTitle = "_18gk6hq2";
var TitleDiv = "_18gk6hq3";
var DoughnutGraphWithLegend = "_18gk6hq4";
var DoughnutGraph = "_18gk6hq5";
var HoverName = "_18gk6hq6";
var HoverValue = "_18gk6hq7";
var HoverDiv = "_18gk6hq8";
var LabelNbrTotal = "_18gk6hq9";
var ValueNbrTotal = "_18gk6hqa";
var LegendGrid = "_1yjdb2u0";
var LegendItem = "_1yjdb2u1";
var ColorBlock = "_1yjdb2u2";
var ColorDiv = "_1yjdb2u3";
var NoWrapText = "_1yjdb2u4";
const Legend2 = (props) => {
  return /* @__PURE__ */ React__default.createElement("div", { className: LegendGrid }, props.data.map(
    (el) => {
      return /* @__PURE__ */ React__default.createElement("div", { key: el.label + el.value, className: LegendItem }, /* @__PURE__ */ React__default.createElement("div", { className: ColorDiv }, /* @__PURE__ */ React__default.createElement("div", { className: ColorBlock, style: { backgroundColor: el.color } })), /* @__PURE__ */ React__default.createElement("span", { className: NoWrapText }, el.value, "% - ", el.label));
    }
  ));
};
const SingleDoughnut = ({ setArcName, setArcValue, data: data2, actionTriggering, hoverOffset = 0 }) => {
  const chartRef = useRef();
  const totalValue = data2.map((el) => el.value).reduce((total, current) => total + current);
  const mappedData = {
    labels: data2.map((el) => el.label.toUpperCase()),
    datasets: [
      {
        backgroundColor: data2.map((el) => el.color),
        data: data2.map((el) => totalValue > 0 ? Math.round(el.value / totalValue * 100) : 0),
        hoverOffset
      }
    ]
  };
  const options2 = {
    layout: {
      padding: 30
    },
    plugins: {
      tooltip: {
        enabled: false
      },
      legend: {
        display: false
      }
    },
    responsive: true,
    maintainAspectRatio: false
  };
  const onActionDoughnut = (event) => {
    var _a2, _b2, _c, _d;
    if (setArcValue && setArcName) {
      const element = getElementAtEvent(chartRef.current !== void 0 ? chartRef.current : void 0, event);
      if (null === element) {
        return;
      } else if (void 0 === element[0]) {
        setArcName("");
        setArcValue("");
      } else {
        setArcName((_b2 = data2[(_a2 = element[0]) == null ? void 0 : _a2.index]) == null ? void 0 : _b2.label);
        setArcValue(totalValue > 0 ? Math.round(((_d = data2[(_c = element[0]) == null ? void 0 : _c.index]) == null ? void 0 : _d.value) / totalValue * 100) + "%" : "0");
      }
    }
  };
  return /* @__PURE__ */ React__default.createElement(
    Doughnut,
    {
      ref: chartRef,
      data: mappedData,
      onClick: actionTriggering === "click" ? onActionDoughnut : () => {
      },
      onMouseMove: actionTriggering === "hover" ? onActionDoughnut : () => {
      },
      options: options2,
      style: { width: "100%", height: "100%" }
    }
  );
};
const DoughnutChart = (props) => {
  const [arcName, setArcName] = useState("");
  const [arcValue, setArcValue] = useState("");
  const nbrTotalComptes = props.data.map((el) => el.value).reduce((total, current) => total + current);
  return /* @__PURE__ */ React__default.createElement("div", { className: DoughnutComponent }, /* @__PURE__ */ React__default.createElement("div", { className: TitleDiv }, /* @__PURE__ */ React__default.createElement("span", { className: DoughnutTitle }, props.chartName), /* @__PURE__ */ React__default.createElement("span", { className: DoughnutSubTitle }, props.subTitle)), /* @__PURE__ */ React__default.createElement("div", { className: DoughnutGraphWithLegend }, /* @__PURE__ */ React__default.createElement("div", { className: DoughnutGraph }, /* @__PURE__ */ React__default.createElement("div", { className: HoverDiv }, /* @__PURE__ */ React__default.createElement("span", { className: HoverName }, arcName), /* @__PURE__ */ React__default.createElement("span", { className: HoverValue }, arcValue)), /* @__PURE__ */ React__default.createElement(SingleDoughnut, { data: props.data, actionTriggering: props.actionTriggering, hoverOffset: props.hoverOffset, setArcName, setArcValue })), /* @__PURE__ */ React__default.createElement("div", { className: LabelNbrTotal }, props.montantLabel ? props.montantLabel + " :" : "", /* @__PURE__ */ React__default.createElement("span", { className: ValueNbrTotal }, props.formater ? props.formater(nbrTotalComptes) : "")), /* @__PURE__ */ React__default.createElement(
    Legend2,
    {
      data: props.data.map(
        (el) => {
          return { label: el.label, value: nbrTotalComptes > 0 ? Math.round(el.value / nbrTotalComptes * 100) : 0, color: el.color };
        }
      )
    }
  )));
};
const BarChart = (props) => {
  const chartRef = useRef();
  const options2 = {
    layout: {
      padding: 30
    },
    plugins: {
      tooltip: {
        enabled: false
      },
      legend: {
        display: false
      }
    },
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        stacked: true,
        grid: {
          color: props.gridColor
        }
      },
      y: {
        stacked: true,
        grid: {
          color: props.gridColor
        }
      }
    }
  };
  return /* @__PURE__ */ React__default.createElement(
    Bar,
    {
      ref: chartRef,
      data: props.data,
      options: options2,
      style: { width: "100%", height: "100%" }
    }
  );
};
/*!
 * @license
 * chartjs-chart-financial
 * http://chartjs.org/
 * Version: 0.2.1
 *
 * Copyright 2024 Chart.js Contributors
 * Released under the MIT license
 * https://github.com/chartjs/chartjs-chart-financial/blob/master/LICENSE.md
 */
function getBarBounds(bar, useFinalPosition) {
  const { x: x2, y: y2, base, width, height: height2 } = bar.getProps(["x", "low", "high", "width", "height"], useFinalPosition);
  let left, right, top, bottom, half;
  if (bar.horizontal) {
    half = height2 / 2;
    left = Math.min(x2, base);
    right = Math.max(x2, base);
    top = y2 - half;
    bottom = y2 + half;
  } else {
    half = width / 2;
    left = x2 - half;
    right = x2 + half;
    top = Math.min(y2, base);
    bottom = Math.max(y2, base);
  }
  return { left, top, right, bottom };
}
function inRange(bar, x2, y2, useFinalPosition) {
  const skipX = x2 === null;
  const skipY = y2 === null;
  const bounds = !bar || skipX && skipY ? false : getBarBounds(bar, useFinalPosition);
  return bounds && (skipX || x2 >= bounds.left && x2 <= bounds.right) && (skipY || y2 >= bounds.top && y2 <= bounds.bottom);
}
class FinancialElement extends BarElement {
  height() {
    return this.base - this.y;
  }
  inRange(mouseX, mouseY, useFinalPosition) {
    return inRange(this, mouseX, mouseY, useFinalPosition);
  }
  inXRange(mouseX, useFinalPosition) {
    return inRange(this, mouseX, null, useFinalPosition);
  }
  inYRange(mouseY, useFinalPosition) {
    return inRange(this, null, mouseY, useFinalPosition);
  }
  getRange(axis) {
    return axis === "x" ? this.width / 2 : this.height / 2;
  }
  getCenterPoint(useFinalPosition) {
    const { x: x2, low, high } = this.getProps(["x", "low", "high"], useFinalPosition);
    return {
      x: x2,
      y: (high + low) / 2
    };
  }
  tooltipPosition(useFinalPosition) {
    const { x: x2, open, close } = this.getProps(["x", "open", "close"], useFinalPosition);
    return {
      x: x2,
      y: (open + close) / 2
    };
  }
}
__publicField(FinancialElement, "defaults", {
  backgroundColors: {
    up: "rgba(75, 192, 192, 0.5)",
    down: "rgba(255, 99, 132, 0.5)",
    unchanged: "rgba(201, 203, 207, 0.5)"
  },
  borderColors: {
    up: "rgb(75, 192, 192)",
    down: "rgb(255, 99, 132)",
    unchanged: "rgb(201, 203, 207)"
  }
});
const defaults$2 = Chart$1.defaults;
class OhlcElement extends FinancialElement {
  draw(ctx) {
    const me = this;
    const { x: x2, open, high, low, close } = me;
    const armLengthRatio = valueOrDefault(me.armLengthRatio, defaults$2.elements.ohlc.armLengthRatio);
    let armLength = valueOrDefault(me.armLength, defaults$2.elements.ohlc.armLength);
    if (armLength === null) {
      armLength = me.width * armLengthRatio * 0.5;
    }
    if (close < open) {
      ctx.strokeStyle = valueOrDefault(me.options.borderColors ? me.options.borderColors.up : void 0, defaults$2.elements.ohlc.borderColors.up);
    } else if (close > open) {
      ctx.strokeStyle = valueOrDefault(me.options.borderColors ? me.options.borderColors.down : void 0, defaults$2.elements.ohlc.borderColors.down);
    } else {
      ctx.strokeStyle = valueOrDefault(me.options.borderColors ? me.options.borderColors.unchanged : void 0, defaults$2.elements.ohlc.borderColors.unchanged);
    }
    ctx.lineWidth = valueOrDefault(me.lineWidth, defaults$2.elements.ohlc.lineWidth);
    ctx.beginPath();
    ctx.moveTo(x2, high);
    ctx.lineTo(x2, low);
    ctx.moveTo(x2 - armLength, open);
    ctx.lineTo(x2, open);
    ctx.moveTo(x2 + armLength, close);
    ctx.lineTo(x2, close);
    ctx.stroke();
  }
}
__publicField(OhlcElement, "id", "ohlc");
__publicField(OhlcElement, "defaults", {
  ...FinancialElement.defaults,
  lineWidth: 2,
  armLength: null,
  armLengthRatio: 0.8
});
class FinancialController extends BarController {
  getLabelAndValue(index2) {
    const me = this;
    const parsed = me.getParsed(index2);
    const axis = me._cachedMeta.iScale.axis;
    const { o: o2, h: h3, l: l2, c: c4 } = parsed;
    const value = `O: ${o2}  H: ${h3}  L: ${l2}  C: ${c4}`;
    return {
      label: `${me._cachedMeta.iScale.getLabelForValue(parsed[axis])}`,
      value
    };
  }
  getUserBounds(scale2) {
    const { min: min2, max: max2, minDefined, maxDefined } = scale2.getUserBounds();
    return {
      min: minDefined ? min2 : Number.NEGATIVE_INFINITY,
      max: maxDefined ? max2 : Number.POSITIVE_INFINITY
    };
  }
  /**
   * Implement this ourselves since it doesn't handle high and low values
   * https://github.com/chartjs/Chart.js/issues/7328
   * @protected
   */
  getMinMax(scale2) {
    const meta = this._cachedMeta;
    const _parsed = meta._parsed;
    const axis = meta.iScale.axis;
    const otherScale = this._getOtherScale(scale2);
    const { min: otherMin, max: otherMax } = this.getUserBounds(otherScale);
    if (_parsed.length < 2) {
      return { min: 0, max: 1 };
    }
    if (scale2 === meta.iScale) {
      return { min: _parsed[0][axis], max: _parsed[_parsed.length - 1][axis] };
    }
    const newParsedData = _parsed.filter(({ x: x2 }) => x2 >= otherMin && x2 < otherMax);
    let min2 = Number.POSITIVE_INFINITY;
    let max2 = Number.NEGATIVE_INFINITY;
    for (let i = 0; i < newParsedData.length; i++) {
      const data2 = newParsedData[i];
      min2 = Math.min(min2, data2.l);
      max2 = Math.max(max2, data2.h);
    }
    return { min: min2, max: max2 };
  }
  /**
   * @protected
   */
  calculateElementProperties(index2, ruler, reset, options2) {
    const me = this;
    const vscale = me._cachedMeta.vScale;
    const base = vscale.getBasePixel();
    const ipixels = me._calculateBarIndexPixels(index2, ruler, options2);
    const data2 = me.chart.data.datasets[me.index].data[index2];
    const open = vscale.getPixelForValue(data2.o);
    const high = vscale.getPixelForValue(data2.h);
    const low = vscale.getPixelForValue(data2.l);
    const close = vscale.getPixelForValue(data2.c);
    return {
      base: reset ? base : low,
      x: ipixels.center,
      y: (low + high) / 2,
      width: ipixels.size,
      open,
      high,
      low,
      close
    };
  }
  draw() {
    const me = this;
    const chart = me.chart;
    const rects = me._cachedMeta.data;
    clipArea(chart.ctx, chart.chartArea);
    for (let i = 0; i < rects.length; ++i) {
      rects[i].draw(me._ctx);
    }
    unclipArea(chart.ctx);
  }
}
__publicField(FinancialController, "overrides", {
  label: "",
  parsing: false,
  hover: {
    mode: "label"
  },
  animations: {
    numbers: {
      type: "number",
      properties: ["x", "y", "base", "width", "open", "high", "low", "close"]
    }
  },
  scales: {
    x: {
      type: "timeseries",
      offset: true,
      ticks: {
        major: {
          enabled: true
        },
        source: "data",
        maxRotation: 0,
        autoSkip: true,
        autoSkipPadding: 75,
        sampleSize: 100
      }
    },
    y: {
      type: "linear"
    }
  },
  plugins: {
    tooltip: {
      intersect: false,
      mode: "index",
      callbacks: {
        label(ctx) {
          const point = ctx.parsed;
          if (!isNullOrUndef(point.y)) {
            return defaults$3.plugins.tooltip.callbacks.label(ctx);
          }
          const { o: o2, h: h3, l: l2, c: c4 } = point;
          return `O: ${o2}  H: ${h3}  L: ${l2}  C: ${c4}`;
        }
      }
    }
  }
});
class OhlcController extends FinancialController {
  updateElements(elements2, start, count, mode) {
    const reset = mode === "reset";
    const ruler = this._getRuler();
    const { sharedOptions, includeOptions } = this._getSharedOptions(start, mode);
    for (let i = start; i < start + count; i++) {
      const options2 = sharedOptions || this.resolveDataElementOptions(i, mode);
      const baseProperties = this.calculateElementProperties(i, ruler, reset, options2);
      if (includeOptions) {
        baseProperties.options = options2;
      }
      this.updateElement(elements2[i], i, baseProperties, mode);
    }
  }
}
__publicField(OhlcController, "id", "ohlc");
__publicField(OhlcController, "defaults", {
  ...FinancialController.defaults,
  dataElementType: OhlcElement.id,
  datasets: {
    barPercentage: 1,
    categoryPercentage: 1
  }
});
class CandlestickElement extends FinancialElement {
  draw(ctx) {
    const me = this;
    const { x: x2, open, high, low, close } = me;
    let borderColors = me.options.borderColors;
    if (typeof borderColors === "string") {
      borderColors = {
        up: borderColors,
        down: borderColors,
        unchanged: borderColors
      };
    }
    const direction = close < open ? "up" : close > open ? "down" : "unchanged";
    const borderColor = valueOrDefault(borderColors ? borderColors[direction] : void 0, defaults$3.elements.candlestick.borderColors[direction]);
    ctx.fillStyle = valueOrDefault(me.options.backgroundColors ? me.options.backgroundColors[direction] : void 0, defaults$3.elements.candlestick.backgroundColors[direction]);
    ctx.lineWidth = valueOrDefault(me.options.borderWidth, defaults$3.elements.candlestick.borderWidth);
    ctx.strokeStyle = borderColor;
    ctx.beginPath();
    ctx.moveTo(x2, high);
    ctx.lineTo(x2, Math.min(open, close));
    ctx.moveTo(x2, low);
    ctx.lineTo(x2, Math.max(open, close));
    ctx.stroke();
    ctx.fillRect(x2 - me.width / 2, close, me.width, open - close);
    ctx.strokeRect(x2 - me.width / 2, close, me.width, open - close);
    ctx.closePath();
  }
}
__publicField(CandlestickElement, "id", "candlestick");
__publicField(CandlestickElement, "defaults", {
  ...FinancialElement.defaults,
  borderWidth: 1
});
class CandlestickController extends FinancialController {
  updateElements(elements2, start, count, mode) {
    const reset = mode === "reset";
    const ruler = this._getRuler();
    const { sharedOptions, includeOptions } = this._getSharedOptions(start, mode);
    for (let i = start; i < start + count; i++) {
      const options2 = sharedOptions || this.resolveDataElementOptions(i, mode);
      const baseProperties = this.calculateElementProperties(i, ruler, reset, options2);
      if (includeOptions) {
        baseProperties.options = options2;
      }
      this.updateElement(elements2[i], i, baseProperties, mode);
    }
  }
}
__publicField(CandlestickController, "id", "candlestick");
__publicField(CandlestickController, "defaults", {
  ...FinancialController.defaults,
  dataElementType: CandlestickElement.id
});
__publicField(CandlestickController, "defaultRoutes", BarController.defaultRoutes);
class LuxonError extends Error {
}
class InvalidDateTimeError extends LuxonError {
  constructor(reason) {
    super(`Invalid DateTime: ${reason.toMessage()}`);
  }
}
class InvalidIntervalError extends LuxonError {
  constructor(reason) {
    super(`Invalid Interval: ${reason.toMessage()}`);
  }
}
class InvalidDurationError extends LuxonError {
  constructor(reason) {
    super(`Invalid Duration: ${reason.toMessage()}`);
  }
}
class ConflictingSpecificationError extends LuxonError {
}
class InvalidUnitError extends LuxonError {
  constructor(unit) {
    super(`Invalid unit ${unit}`);
  }
}
class InvalidArgumentError extends LuxonError {
}
class ZoneIsAbstractError extends LuxonError {
  constructor() {
    super("Zone is an abstract class");
  }
}
const n$2 = "numeric", s = "short", l = "long";
const DATE_SHORT = {
  year: n$2,
  month: n$2,
  day: n$2
};
const DATE_MED = {
  year: n$2,
  month: s,
  day: n$2
};
const DATE_MED_WITH_WEEKDAY = {
  year: n$2,
  month: s,
  day: n$2,
  weekday: s
};
const DATE_FULL = {
  year: n$2,
  month: l,
  day: n$2
};
const DATE_HUGE = {
  year: n$2,
  month: l,
  day: n$2,
  weekday: l
};
const TIME_SIMPLE = {
  hour: n$2,
  minute: n$2
};
const TIME_WITH_SECONDS = {
  hour: n$2,
  minute: n$2,
  second: n$2
};
const TIME_WITH_SHORT_OFFSET = {
  hour: n$2,
  minute: n$2,
  second: n$2,
  timeZoneName: s
};
const TIME_WITH_LONG_OFFSET = {
  hour: n$2,
  minute: n$2,
  second: n$2,
  timeZoneName: l
};
const TIME_24_SIMPLE = {
  hour: n$2,
  minute: n$2,
  hourCycle: "h23"
};
const TIME_24_WITH_SECONDS = {
  hour: n$2,
  minute: n$2,
  second: n$2,
  hourCycle: "h23"
};
const TIME_24_WITH_SHORT_OFFSET = {
  hour: n$2,
  minute: n$2,
  second: n$2,
  hourCycle: "h23",
  timeZoneName: s
};
const TIME_24_WITH_LONG_OFFSET = {
  hour: n$2,
  minute: n$2,
  second: n$2,
  hourCycle: "h23",
  timeZoneName: l
};
const DATETIME_SHORT = {
  year: n$2,
  month: n$2,
  day: n$2,
  hour: n$2,
  minute: n$2
};
const DATETIME_SHORT_WITH_SECONDS = {
  year: n$2,
  month: n$2,
  day: n$2,
  hour: n$2,
  minute: n$2,
  second: n$2
};
const DATETIME_MED = {
  year: n$2,
  month: s,
  day: n$2,
  hour: n$2,
  minute: n$2
};
const DATETIME_MED_WITH_SECONDS = {
  year: n$2,
  month: s,
  day: n$2,
  hour: n$2,
  minute: n$2,
  second: n$2
};
const DATETIME_MED_WITH_WEEKDAY = {
  year: n$2,
  month: s,
  day: n$2,
  weekday: s,
  hour: n$2,
  minute: n$2
};
const DATETIME_FULL = {
  year: n$2,
  month: l,
  day: n$2,
  hour: n$2,
  minute: n$2,
  timeZoneName: s
};
const DATETIME_FULL_WITH_SECONDS = {
  year: n$2,
  month: l,
  day: n$2,
  hour: n$2,
  minute: n$2,
  second: n$2,
  timeZoneName: s
};
const DATETIME_HUGE = {
  year: n$2,
  month: l,
  day: n$2,
  weekday: l,
  hour: n$2,
  minute: n$2,
  timeZoneName: l
};
const DATETIME_HUGE_WITH_SECONDS = {
  year: n$2,
  month: l,
  day: n$2,
  weekday: l,
  hour: n$2,
  minute: n$2,
  second: n$2,
  timeZoneName: l
};
class Zone {
  /**
   * The type of zone
   * @abstract
   * @type {string}
   */
  get type() {
    throw new ZoneIsAbstractError();
  }
  /**
   * The name of this zone.
   * @abstract
   * @type {string}
   */
  get name() {
    throw new ZoneIsAbstractError();
  }
  get ianaName() {
    return this.name;
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year.
   * @abstract
   * @type {boolean}
   */
  get isUniversal() {
    throw new ZoneIsAbstractError();
  }
  /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */
  offsetName(ts, opts) {
    throw new ZoneIsAbstractError();
  }
  /**
   * Returns the offset's value as a string
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(ts, format) {
    throw new ZoneIsAbstractError();
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */
  offset(ts) {
    throw new ZoneIsAbstractError();
  }
  /**
   * Return whether this Zone is equal to another zone
   * @abstract
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(otherZone) {
    throw new ZoneIsAbstractError();
  }
  /**
   * Return whether this Zone is valid.
   * @abstract
   * @type {boolean}
   */
  get isValid() {
    throw new ZoneIsAbstractError();
  }
}
let singleton$1 = null;
class SystemZone extends Zone {
  /**
   * Get a singleton instance of the local zone
   * @return {SystemZone}
   */
  static get instance() {
    if (singleton$1 === null) {
      singleton$1 = new SystemZone();
    }
    return singleton$1;
  }
  /** @override **/
  get type() {
    return "system";
  }
  /** @override **/
  get name() {
    return new Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
  /** @override **/
  get isUniversal() {
    return false;
  }
  /** @override **/
  offsetName(ts, { format, locale }) {
    return parseZoneInfo(ts, format, locale);
  }
  /** @override **/
  formatOffset(ts, format) {
    return formatOffset(this.offset(ts), format);
  }
  /** @override **/
  offset(ts) {
    return -new Date(ts).getTimezoneOffset();
  }
  /** @override **/
  equals(otherZone) {
    return otherZone.type === "system";
  }
  /** @override **/
  get isValid() {
    return true;
  }
}
let dtfCache = {};
function makeDTF(zone) {
  if (!dtfCache[zone]) {
    dtfCache[zone] = new Intl.DateTimeFormat("en-US", {
      hour12: false,
      timeZone: zone,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      era: "short"
    });
  }
  return dtfCache[zone];
}
const typeToPos = {
  year: 0,
  month: 1,
  day: 2,
  era: 3,
  hour: 4,
  minute: 5,
  second: 6
};
function hackyOffset(dtf, date) {
  const formatted = dtf.format(date).replace(/\u200E/g, ""), parsed = /(\d+)\/(\d+)\/(\d+) (AD|BC),? (\d+):(\d+):(\d+)/.exec(formatted), [, fMonth, fDay, fYear, fadOrBc, fHour, fMinute, fSecond] = parsed;
  return [fYear, fMonth, fDay, fadOrBc, fHour, fMinute, fSecond];
}
function partsOffset(dtf, date) {
  const formatted = dtf.formatToParts(date);
  const filled = [];
  for (let i = 0; i < formatted.length; i++) {
    const { type: type2, value } = formatted[i];
    const pos = typeToPos[type2];
    if (type2 === "era") {
      filled[pos] = value;
    } else if (!isUndefined(pos)) {
      filled[pos] = parseInt(value, 10);
    }
  }
  return filled;
}
let ianaZoneCache = {};
class IANAZone extends Zone {
  /**
   * @param {string} name - Zone name
   * @return {IANAZone}
   */
  static create(name) {
    if (!ianaZoneCache[name]) {
      ianaZoneCache[name] = new IANAZone(name);
    }
    return ianaZoneCache[name];
  }
  /**
   * Reset local caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCache() {
    ianaZoneCache = {};
    dtfCache = {};
  }
  /**
   * Returns whether the provided string is a valid specifier. This only checks the string's format, not that the specifier identifies a known zone; see isValidZone for that.
   * @param {string} s - The string to check validity on
   * @example IANAZone.isValidSpecifier("America/New_York") //=> true
   * @example IANAZone.isValidSpecifier("Sport~~blorp") //=> false
   * @deprecated This method returns false for some valid IANA names. Use isValidZone instead.
   * @return {boolean}
   */
  static isValidSpecifier(s2) {
    return this.isValidZone(s2);
  }
  /**
   * Returns whether the provided string identifies a real zone
   * @param {string} zone - The string to check
   * @example IANAZone.isValidZone("America/New_York") //=> true
   * @example IANAZone.isValidZone("Fantasia/Castle") //=> false
   * @example IANAZone.isValidZone("Sport~~blorp") //=> false
   * @return {boolean}
   */
  static isValidZone(zone) {
    if (!zone) {
      return false;
    }
    try {
      new Intl.DateTimeFormat("en-US", { timeZone: zone }).format();
      return true;
    } catch (e2) {
      return false;
    }
  }
  constructor(name) {
    super();
    this.zoneName = name;
    this.valid = IANAZone.isValidZone(name);
  }
  /** @override **/
  get type() {
    return "iana";
  }
  /** @override **/
  get name() {
    return this.zoneName;
  }
  /** @override **/
  get isUniversal() {
    return false;
  }
  /** @override **/
  offsetName(ts, { format, locale }) {
    return parseZoneInfo(ts, format, locale, this.name);
  }
  /** @override **/
  formatOffset(ts, format) {
    return formatOffset(this.offset(ts), format);
  }
  /** @override **/
  offset(ts) {
    const date = new Date(ts);
    if (isNaN(date)) return NaN;
    const dtf = makeDTF(this.name);
    let [year, month, day, adOrBc, hour, minute, second] = dtf.formatToParts ? partsOffset(dtf, date) : hackyOffset(dtf, date);
    if (adOrBc === "BC") {
      year = -Math.abs(year) + 1;
    }
    const adjustedHour = hour === 24 ? 0 : hour;
    const asUTC = objToLocalTS({
      year,
      month,
      day,
      hour: adjustedHour,
      minute,
      second,
      millisecond: 0
    });
    let asTS = +date;
    const over = asTS % 1e3;
    asTS -= over >= 0 ? over : 1e3 + over;
    return (asUTC - asTS) / (60 * 1e3);
  }
  /** @override **/
  equals(otherZone) {
    return otherZone.type === "iana" && otherZone.name === this.name;
  }
  /** @override **/
  get isValid() {
    return this.valid;
  }
}
let intlLFCache = {};
function getCachedLF(locString, opts = {}) {
  const key = JSON.stringify([locString, opts]);
  let dtf = intlLFCache[key];
  if (!dtf) {
    dtf = new Intl.ListFormat(locString, opts);
    intlLFCache[key] = dtf;
  }
  return dtf;
}
let intlDTCache = {};
function getCachedDTF(locString, opts = {}) {
  const key = JSON.stringify([locString, opts]);
  let dtf = intlDTCache[key];
  if (!dtf) {
    dtf = new Intl.DateTimeFormat(locString, opts);
    intlDTCache[key] = dtf;
  }
  return dtf;
}
let intlNumCache = {};
function getCachedINF(locString, opts = {}) {
  const key = JSON.stringify([locString, opts]);
  let inf = intlNumCache[key];
  if (!inf) {
    inf = new Intl.NumberFormat(locString, opts);
    intlNumCache[key] = inf;
  }
  return inf;
}
let intlRelCache = {};
function getCachedRTF(locString, opts = {}) {
  const { base, ...cacheKeyOpts } = opts;
  const key = JSON.stringify([locString, cacheKeyOpts]);
  let inf = intlRelCache[key];
  if (!inf) {
    inf = new Intl.RelativeTimeFormat(locString, opts);
    intlRelCache[key] = inf;
  }
  return inf;
}
let sysLocaleCache = null;
function systemLocale() {
  if (sysLocaleCache) {
    return sysLocaleCache;
  } else {
    sysLocaleCache = new Intl.DateTimeFormat().resolvedOptions().locale;
    return sysLocaleCache;
  }
}
let weekInfoCache = {};
function getCachedWeekInfo(locString) {
  let data2 = weekInfoCache[locString];
  if (!data2) {
    const locale = new Intl.Locale(locString);
    data2 = "getWeekInfo" in locale ? locale.getWeekInfo() : locale.weekInfo;
    weekInfoCache[locString] = data2;
  }
  return data2;
}
function parseLocaleString(localeStr) {
  const xIndex = localeStr.indexOf("-x-");
  if (xIndex !== -1) {
    localeStr = localeStr.substring(0, xIndex);
  }
  const uIndex = localeStr.indexOf("-u-");
  if (uIndex === -1) {
    return [localeStr];
  } else {
    let options2;
    let selectedStr;
    try {
      options2 = getCachedDTF(localeStr).resolvedOptions();
      selectedStr = localeStr;
    } catch (e2) {
      const smaller = localeStr.substring(0, uIndex);
      options2 = getCachedDTF(smaller).resolvedOptions();
      selectedStr = smaller;
    }
    const { numberingSystem, calendar } = options2;
    return [selectedStr, numberingSystem, calendar];
  }
}
function intlConfigString(localeStr, numberingSystem, outputCalendar) {
  if (outputCalendar || numberingSystem) {
    if (!localeStr.includes("-u-")) {
      localeStr += "-u";
    }
    if (outputCalendar) {
      localeStr += `-ca-${outputCalendar}`;
    }
    if (numberingSystem) {
      localeStr += `-nu-${numberingSystem}`;
    }
    return localeStr;
  } else {
    return localeStr;
  }
}
function mapMonths(f2) {
  const ms = [];
  for (let i = 1; i <= 12; i++) {
    const dt = DateTime.utc(2009, i, 1);
    ms.push(f2(dt));
  }
  return ms;
}
function mapWeekdays(f2) {
  const ms = [];
  for (let i = 1; i <= 7; i++) {
    const dt = DateTime.utc(2016, 11, 13 + i);
    ms.push(f2(dt));
  }
  return ms;
}
function listStuff(loc, length2, englishFn, intlFn) {
  const mode = loc.listingMode();
  if (mode === "error") {
    return null;
  } else if (mode === "en") {
    return englishFn(length2);
  } else {
    return intlFn(length2);
  }
}
function supportsFastNumbers(loc) {
  if (loc.numberingSystem && loc.numberingSystem !== "latn") {
    return false;
  } else {
    return loc.numberingSystem === "latn" || !loc.locale || loc.locale.startsWith("en") || new Intl.DateTimeFormat(loc.intl).resolvedOptions().numberingSystem === "latn";
  }
}
class PolyNumberFormatter {
  constructor(intl, forceSimple, opts) {
    this.padTo = opts.padTo || 0;
    this.floor = opts.floor || false;
    const { padTo, floor: floor2, ...otherOpts } = opts;
    if (!forceSimple || Object.keys(otherOpts).length > 0) {
      const intlOpts = { useGrouping: false, ...opts };
      if (opts.padTo > 0) intlOpts.minimumIntegerDigits = opts.padTo;
      this.inf = getCachedINF(intl, intlOpts);
    }
  }
  format(i) {
    if (this.inf) {
      const fixed = this.floor ? Math.floor(i) : i;
      return this.inf.format(fixed);
    } else {
      const fixed = this.floor ? Math.floor(i) : roundTo(i, 3);
      return padStart(fixed, this.padTo);
    }
  }
}
class PolyDateFormatter {
  constructor(dt, intl, opts) {
    this.opts = opts;
    this.originalZone = void 0;
    let z2 = void 0;
    if (this.opts.timeZone) {
      this.dt = dt;
    } else if (dt.zone.type === "fixed") {
      const gmtOffset = -1 * (dt.offset / 60);
      const offsetZ = gmtOffset >= 0 ? `Etc/GMT+${gmtOffset}` : `Etc/GMT${gmtOffset}`;
      if (dt.offset !== 0 && IANAZone.create(offsetZ).valid) {
        z2 = offsetZ;
        this.dt = dt;
      } else {
        z2 = "UTC";
        this.dt = dt.offset === 0 ? dt : dt.setZone("UTC").plus({ minutes: dt.offset });
        this.originalZone = dt.zone;
      }
    } else if (dt.zone.type === "system") {
      this.dt = dt;
    } else if (dt.zone.type === "iana") {
      this.dt = dt;
      z2 = dt.zone.name;
    } else {
      z2 = "UTC";
      this.dt = dt.setZone("UTC").plus({ minutes: dt.offset });
      this.originalZone = dt.zone;
    }
    const intlOpts = { ...this.opts };
    intlOpts.timeZone = intlOpts.timeZone || z2;
    this.dtf = getCachedDTF(intl, intlOpts);
  }
  format() {
    if (this.originalZone) {
      return this.formatToParts().map(({ value }) => value).join("");
    }
    return this.dtf.format(this.dt.toJSDate());
  }
  formatToParts() {
    const parts = this.dtf.formatToParts(this.dt.toJSDate());
    if (this.originalZone) {
      return parts.map((part) => {
        if (part.type === "timeZoneName") {
          const offsetName = this.originalZone.offsetName(this.dt.ts, {
            locale: this.dt.locale,
            format: this.opts.timeZoneName
          });
          return {
            ...part,
            value: offsetName
          };
        } else {
          return part;
        }
      });
    }
    return parts;
  }
  resolvedOptions() {
    return this.dtf.resolvedOptions();
  }
}
class PolyRelFormatter {
  constructor(intl, isEnglish, opts) {
    this.opts = { style: "long", ...opts };
    if (!isEnglish && hasRelative()) {
      this.rtf = getCachedRTF(intl, opts);
    }
  }
  format(count, unit) {
    if (this.rtf) {
      return this.rtf.format(count, unit);
    } else {
      return formatRelativeTime(unit, count, this.opts.numeric, this.opts.style !== "long");
    }
  }
  formatToParts(count, unit) {
    if (this.rtf) {
      return this.rtf.formatToParts(count, unit);
    } else {
      return [];
    }
  }
}
const fallbackWeekSettings = {
  firstDay: 1,
  minimalDays: 4,
  weekend: [6, 7]
};
class Locale {
  static fromOpts(opts) {
    return Locale.create(
      opts.locale,
      opts.numberingSystem,
      opts.outputCalendar,
      opts.weekSettings,
      opts.defaultToEN
    );
  }
  static create(locale, numberingSystem, outputCalendar, weekSettings, defaultToEN = false) {
    const specifiedLocale = locale || Settings.defaultLocale;
    const localeR = specifiedLocale || (defaultToEN ? "en-US" : systemLocale());
    const numberingSystemR = numberingSystem || Settings.defaultNumberingSystem;
    const outputCalendarR = outputCalendar || Settings.defaultOutputCalendar;
    const weekSettingsR = validateWeekSettings(weekSettings) || Settings.defaultWeekSettings;
    return new Locale(localeR, numberingSystemR, outputCalendarR, weekSettingsR, specifiedLocale);
  }
  static resetCache() {
    sysLocaleCache = null;
    intlDTCache = {};
    intlNumCache = {};
    intlRelCache = {};
  }
  static fromObject({ locale, numberingSystem, outputCalendar, weekSettings } = {}) {
    return Locale.create(locale, numberingSystem, outputCalendar, weekSettings);
  }
  constructor(locale, numbering, outputCalendar, weekSettings, specifiedLocale) {
    const [parsedLocale, parsedNumberingSystem, parsedOutputCalendar] = parseLocaleString(locale);
    this.locale = parsedLocale;
    this.numberingSystem = numbering || parsedNumberingSystem || null;
    this.outputCalendar = outputCalendar || parsedOutputCalendar || null;
    this.weekSettings = weekSettings;
    this.intl = intlConfigString(this.locale, this.numberingSystem, this.outputCalendar);
    this.weekdaysCache = { format: {}, standalone: {} };
    this.monthsCache = { format: {}, standalone: {} };
    this.meridiemCache = null;
    this.eraCache = {};
    this.specifiedLocale = specifiedLocale;
    this.fastNumbersCached = null;
  }
  get fastNumbers() {
    if (this.fastNumbersCached == null) {
      this.fastNumbersCached = supportsFastNumbers(this);
    }
    return this.fastNumbersCached;
  }
  listingMode() {
    const isActuallyEn = this.isEnglish();
    const hasNoWeirdness = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");
    return isActuallyEn && hasNoWeirdness ? "en" : "intl";
  }
  clone(alts) {
    if (!alts || Object.getOwnPropertyNames(alts).length === 0) {
      return this;
    } else {
      return Locale.create(
        alts.locale || this.specifiedLocale,
        alts.numberingSystem || this.numberingSystem,
        alts.outputCalendar || this.outputCalendar,
        validateWeekSettings(alts.weekSettings) || this.weekSettings,
        alts.defaultToEN || false
      );
    }
  }
  redefaultToEN(alts = {}) {
    return this.clone({ ...alts, defaultToEN: true });
  }
  redefaultToSystem(alts = {}) {
    return this.clone({ ...alts, defaultToEN: false });
  }
  months(length2, format = false) {
    return listStuff(this, length2, months, () => {
      const intl = format ? { month: length2, day: "numeric" } : { month: length2 }, formatStr = format ? "format" : "standalone";
      if (!this.monthsCache[formatStr][length2]) {
        this.monthsCache[formatStr][length2] = mapMonths((dt) => this.extract(dt, intl, "month"));
      }
      return this.monthsCache[formatStr][length2];
    });
  }
  weekdays(length2, format = false) {
    return listStuff(this, length2, weekdays, () => {
      const intl = format ? { weekday: length2, year: "numeric", month: "long", day: "numeric" } : { weekday: length2 }, formatStr = format ? "format" : "standalone";
      if (!this.weekdaysCache[formatStr][length2]) {
        this.weekdaysCache[formatStr][length2] = mapWeekdays(
          (dt) => this.extract(dt, intl, "weekday")
        );
      }
      return this.weekdaysCache[formatStr][length2];
    });
  }
  meridiems() {
    return listStuff(
      this,
      void 0,
      () => meridiems,
      () => {
        if (!this.meridiemCache) {
          const intl = { hour: "numeric", hourCycle: "h12" };
          this.meridiemCache = [DateTime.utc(2016, 11, 13, 9), DateTime.utc(2016, 11, 13, 19)].map(
            (dt) => this.extract(dt, intl, "dayperiod")
          );
        }
        return this.meridiemCache;
      }
    );
  }
  eras(length2) {
    return listStuff(this, length2, eras, () => {
      const intl = { era: length2 };
      if (!this.eraCache[length2]) {
        this.eraCache[length2] = [DateTime.utc(-40, 1, 1), DateTime.utc(2017, 1, 1)].map(
          (dt) => this.extract(dt, intl, "era")
        );
      }
      return this.eraCache[length2];
    });
  }
  extract(dt, intlOpts, field) {
    const df = this.dtFormatter(dt, intlOpts), results = df.formatToParts(), matching = results.find((m3) => m3.type.toLowerCase() === field);
    return matching ? matching.value : null;
  }
  numberFormatter(opts = {}) {
    return new PolyNumberFormatter(this.intl, opts.forceSimple || this.fastNumbers, opts);
  }
  dtFormatter(dt, intlOpts = {}) {
    return new PolyDateFormatter(dt, this.intl, intlOpts);
  }
  relFormatter(opts = {}) {
    return new PolyRelFormatter(this.intl, this.isEnglish(), opts);
  }
  listFormatter(opts = {}) {
    return getCachedLF(this.intl, opts);
  }
  isEnglish() {
    return this.locale === "en" || this.locale.toLowerCase() === "en-us" || new Intl.DateTimeFormat(this.intl).resolvedOptions().locale.startsWith("en-us");
  }
  getWeekSettings() {
    if (this.weekSettings) {
      return this.weekSettings;
    } else if (!hasLocaleWeekInfo()) {
      return fallbackWeekSettings;
    } else {
      return getCachedWeekInfo(this.locale);
    }
  }
  getStartOfWeek() {
    return this.getWeekSettings().firstDay;
  }
  getMinDaysInFirstWeek() {
    return this.getWeekSettings().minimalDays;
  }
  getWeekendDays() {
    return this.getWeekSettings().weekend;
  }
  equals(other) {
    return this.locale === other.locale && this.numberingSystem === other.numberingSystem && this.outputCalendar === other.outputCalendar;
  }
}
let singleton = null;
class FixedOffsetZone extends Zone {
  /**
   * Get a singleton instance of UTC
   * @return {FixedOffsetZone}
   */
  static get utcInstance() {
    if (singleton === null) {
      singleton = new FixedOffsetZone(0);
    }
    return singleton;
  }
  /**
   * Get an instance with a specified offset
   * @param {number} offset - The offset in minutes
   * @return {FixedOffsetZone}
   */
  static instance(offset2) {
    return offset2 === 0 ? FixedOffsetZone.utcInstance : new FixedOffsetZone(offset2);
  }
  /**
   * Get an instance of FixedOffsetZone from a UTC offset string, like "UTC+6"
   * @param {string} s - The offset string to parse
   * @example FixedOffsetZone.parseSpecifier("UTC+6")
   * @example FixedOffsetZone.parseSpecifier("UTC+06")
   * @example FixedOffsetZone.parseSpecifier("UTC-6:00")
   * @return {FixedOffsetZone}
   */
  static parseSpecifier(s2) {
    if (s2) {
      const r2 = s2.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
      if (r2) {
        return new FixedOffsetZone(signedOffset(r2[1], r2[2]));
      }
    }
    return null;
  }
  constructor(offset2) {
    super();
    this.fixed = offset2;
  }
  /** @override **/
  get type() {
    return "fixed";
  }
  /** @override **/
  get name() {
    return this.fixed === 0 ? "UTC" : `UTC${formatOffset(this.fixed, "narrow")}`;
  }
  get ianaName() {
    if (this.fixed === 0) {
      return "Etc/UTC";
    } else {
      return `Etc/GMT${formatOffset(-this.fixed, "narrow")}`;
    }
  }
  /** @override **/
  offsetName() {
    return this.name;
  }
  /** @override **/
  formatOffset(ts, format) {
    return formatOffset(this.fixed, format);
  }
  /** @override **/
  get isUniversal() {
    return true;
  }
  /** @override **/
  offset() {
    return this.fixed;
  }
  /** @override **/
  equals(otherZone) {
    return otherZone.type === "fixed" && otherZone.fixed === this.fixed;
  }
  /** @override **/
  get isValid() {
    return true;
  }
}
class InvalidZone extends Zone {
  constructor(zoneName) {
    super();
    this.zoneName = zoneName;
  }
  /** @override **/
  get type() {
    return "invalid";
  }
  /** @override **/
  get name() {
    return this.zoneName;
  }
  /** @override **/
  get isUniversal() {
    return false;
  }
  /** @override **/
  offsetName() {
    return null;
  }
  /** @override **/
  formatOffset() {
    return "";
  }
  /** @override **/
  offset() {
    return NaN;
  }
  /** @override **/
  equals() {
    return false;
  }
  /** @override **/
  get isValid() {
    return false;
  }
}
function normalizeZone(input, defaultZone2) {
  if (isUndefined(input) || input === null) {
    return defaultZone2;
  } else if (input instanceof Zone) {
    return input;
  } else if (isString$1(input)) {
    const lowered = input.toLowerCase();
    if (lowered === "default") return defaultZone2;
    else if (lowered === "local" || lowered === "system") return SystemZone.instance;
    else if (lowered === "utc" || lowered === "gmt") return FixedOffsetZone.utcInstance;
    else return FixedOffsetZone.parseSpecifier(lowered) || IANAZone.create(input);
  } else if (isNumber(input)) {
    return FixedOffsetZone.instance(input);
  } else if (typeof input === "object" && "offset" in input && typeof input.offset === "function") {
    return input;
  } else {
    return new InvalidZone(input);
  }
}
let now$1 = () => Date.now(), defaultZone = "system", defaultLocale = null, defaultNumberingSystem = null, defaultOutputCalendar = null, twoDigitCutoffYear = 60, throwOnInvalid, defaultWeekSettings = null;
class Settings {
  /**
   * Get the callback for returning the current timestamp.
   * @type {function}
   */
  static get now() {
    return now$1;
  }
  /**
   * Set the callback for returning the current timestamp.
   * The function should return a number, which will be interpreted as an Epoch millisecond count
   * @type {function}
   * @example Settings.now = () => Date.now() + 3000 // pretend it is 3 seconds in the future
   * @example Settings.now = () => 0 // always pretend it's Jan 1, 1970 at midnight in UTC time
   */
  static set now(n2) {
    now$1 = n2;
  }
  /**
   * Set the default time zone to create DateTimes in. Does not affect existing instances.
   * Use the value "system" to reset this value to the system's time zone.
   * @type {string}
   */
  static set defaultZone(zone) {
    defaultZone = zone;
  }
  /**
   * Get the default time zone object currently used to create DateTimes. Does not affect existing instances.
   * The default value is the system's time zone (the one set on the machine that runs this code).
   * @type {Zone}
   */
  static get defaultZone() {
    return normalizeZone(defaultZone, SystemZone.instance);
  }
  /**
   * Get the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultLocale() {
    return defaultLocale;
  }
  /**
   * Set the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultLocale(locale) {
    defaultLocale = locale;
  }
  /**
   * Get the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultNumberingSystem() {
    return defaultNumberingSystem;
  }
  /**
   * Set the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultNumberingSystem(numberingSystem) {
    defaultNumberingSystem = numberingSystem;
  }
  /**
   * Get the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultOutputCalendar() {
    return defaultOutputCalendar;
  }
  /**
   * Set the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultOutputCalendar(outputCalendar) {
    defaultOutputCalendar = outputCalendar;
  }
  /**
   * @typedef {Object} WeekSettings
   * @property {number} firstDay
   * @property {number} minimalDays
   * @property {number[]} weekend
   */
  /**
   * @return {WeekSettings|null}
   */
  static get defaultWeekSettings() {
    return defaultWeekSettings;
  }
  /**
   * Allows overriding the default locale week settings, i.e. the start of the week, the weekend and
   * how many days are required in the first week of a year.
   * Does not affect existing instances.
   *
   * @param {WeekSettings|null} weekSettings
   */
  static set defaultWeekSettings(weekSettings) {
    defaultWeekSettings = validateWeekSettings(weekSettings);
  }
  /**
   * Get the cutoff year after which a string encoding a year as two digits is interpreted to occur in the current century.
   * @type {number}
   */
  static get twoDigitCutoffYear() {
    return twoDigitCutoffYear;
  }
  /**
   * Set the cutoff year after which a string encoding a year as two digits is interpreted to occur in the current century.
   * @type {number}
   * @example Settings.twoDigitCutoffYear = 0 // cut-off year is 0, so all 'yy' are interpreted as current century
   * @example Settings.twoDigitCutoffYear = 50 // '49' -> 1949; '50' -> 2050
   * @example Settings.twoDigitCutoffYear = 1950 // interpreted as 50
   * @example Settings.twoDigitCutoffYear = 2050 // ALSO interpreted as 50
   */
  static set twoDigitCutoffYear(cutoffYear) {
    twoDigitCutoffYear = cutoffYear % 100;
  }
  /**
   * Get whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static get throwOnInvalid() {
    return throwOnInvalid;
  }
  /**
   * Set whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static set throwOnInvalid(t2) {
    throwOnInvalid = t2;
  }
  /**
   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCaches() {
    Locale.resetCache();
    IANAZone.resetCache();
  }
}
class Invalid {
  constructor(reason, explanation) {
    this.reason = reason;
    this.explanation = explanation;
  }
  toMessage() {
    if (this.explanation) {
      return `${this.reason}: ${this.explanation}`;
    } else {
      return this.reason;
    }
  }
}
const nonLeapLadder = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334], leapLadder = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335];
function unitOutOfRange(unit, value) {
  return new Invalid(
    "unit out of range",
    `you specified ${value} (of type ${typeof value}) as a ${unit}, which is invalid`
  );
}
function dayOfWeek(year, month, day) {
  const d2 = new Date(Date.UTC(year, month - 1, day));
  if (year < 100 && year >= 0) {
    d2.setUTCFullYear(d2.getUTCFullYear() - 1900);
  }
  const js = d2.getUTCDay();
  return js === 0 ? 7 : js;
}
function computeOrdinal(year, month, day) {
  return day + (isLeapYear(year) ? leapLadder : nonLeapLadder)[month - 1];
}
function uncomputeOrdinal(year, ordinal) {
  const table = isLeapYear(year) ? leapLadder : nonLeapLadder, month0 = table.findIndex((i) => i < ordinal), day = ordinal - table[month0];
  return { month: month0 + 1, day };
}
function isoWeekdayToLocal(isoWeekday, startOfWeek) {
  return (isoWeekday - startOfWeek + 7) % 7 + 1;
}
function gregorianToWeek(gregObj, minDaysInFirstWeek = 4, startOfWeek = 1) {
  const { year, month, day } = gregObj, ordinal = computeOrdinal(year, month, day), weekday = isoWeekdayToLocal(dayOfWeek(year, month, day), startOfWeek);
  let weekNumber = Math.floor((ordinal - weekday + 14 - minDaysInFirstWeek) / 7), weekYear;
  if (weekNumber < 1) {
    weekYear = year - 1;
    weekNumber = weeksInWeekYear(weekYear, minDaysInFirstWeek, startOfWeek);
  } else if (weekNumber > weeksInWeekYear(year, minDaysInFirstWeek, startOfWeek)) {
    weekYear = year + 1;
    weekNumber = 1;
  } else {
    weekYear = year;
  }
  return { weekYear, weekNumber, weekday, ...timeObject(gregObj) };
}
function weekToGregorian(weekData, minDaysInFirstWeek = 4, startOfWeek = 1) {
  const { weekYear, weekNumber, weekday } = weekData, weekdayOfJan4 = isoWeekdayToLocal(dayOfWeek(weekYear, 1, minDaysInFirstWeek), startOfWeek), yearInDays = daysInYear(weekYear);
  let ordinal = weekNumber * 7 + weekday - weekdayOfJan4 - 7 + minDaysInFirstWeek, year;
  if (ordinal < 1) {
    year = weekYear - 1;
    ordinal += daysInYear(year);
  } else if (ordinal > yearInDays) {
    year = weekYear + 1;
    ordinal -= daysInYear(weekYear);
  } else {
    year = weekYear;
  }
  const { month, day } = uncomputeOrdinal(year, ordinal);
  return { year, month, day, ...timeObject(weekData) };
}
function gregorianToOrdinal(gregData) {
  const { year, month, day } = gregData;
  const ordinal = computeOrdinal(year, month, day);
  return { year, ordinal, ...timeObject(gregData) };
}
function ordinalToGregorian(ordinalData) {
  const { year, ordinal } = ordinalData;
  const { month, day } = uncomputeOrdinal(year, ordinal);
  return { year, month, day, ...timeObject(ordinalData) };
}
function usesLocalWeekValues(obj, loc) {
  const hasLocaleWeekData = !isUndefined(obj.localWeekday) || !isUndefined(obj.localWeekNumber) || !isUndefined(obj.localWeekYear);
  if (hasLocaleWeekData) {
    const hasIsoWeekData = !isUndefined(obj.weekday) || !isUndefined(obj.weekNumber) || !isUndefined(obj.weekYear);
    if (hasIsoWeekData) {
      throw new ConflictingSpecificationError(
        "Cannot mix locale-based week fields with ISO-based week fields"
      );
    }
    if (!isUndefined(obj.localWeekday)) obj.weekday = obj.localWeekday;
    if (!isUndefined(obj.localWeekNumber)) obj.weekNumber = obj.localWeekNumber;
    if (!isUndefined(obj.localWeekYear)) obj.weekYear = obj.localWeekYear;
    delete obj.localWeekday;
    delete obj.localWeekNumber;
    delete obj.localWeekYear;
    return {
      minDaysInFirstWeek: loc.getMinDaysInFirstWeek(),
      startOfWeek: loc.getStartOfWeek()
    };
  } else {
    return { minDaysInFirstWeek: 4, startOfWeek: 1 };
  }
}
function hasInvalidWeekData(obj, minDaysInFirstWeek = 4, startOfWeek = 1) {
  const validYear = isInteger(obj.weekYear), validWeek = integerBetween(
    obj.weekNumber,
    1,
    weeksInWeekYear(obj.weekYear, minDaysInFirstWeek, startOfWeek)
  ), validWeekday = integerBetween(obj.weekday, 1, 7);
  if (!validYear) {
    return unitOutOfRange("weekYear", obj.weekYear);
  } else if (!validWeek) {
    return unitOutOfRange("week", obj.weekNumber);
  } else if (!validWeekday) {
    return unitOutOfRange("weekday", obj.weekday);
  } else return false;
}
function hasInvalidOrdinalData(obj) {
  const validYear = isInteger(obj.year), validOrdinal = integerBetween(obj.ordinal, 1, daysInYear(obj.year));
  if (!validYear) {
    return unitOutOfRange("year", obj.year);
  } else if (!validOrdinal) {
    return unitOutOfRange("ordinal", obj.ordinal);
  } else return false;
}
function hasInvalidGregorianData(obj) {
  const validYear = isInteger(obj.year), validMonth = integerBetween(obj.month, 1, 12), validDay = integerBetween(obj.day, 1, daysInMonth(obj.year, obj.month));
  if (!validYear) {
    return unitOutOfRange("year", obj.year);
  } else if (!validMonth) {
    return unitOutOfRange("month", obj.month);
  } else if (!validDay) {
    return unitOutOfRange("day", obj.day);
  } else return false;
}
function hasInvalidTimeData(obj) {
  const { hour, minute, second, millisecond } = obj;
  const validHour = integerBetween(hour, 0, 23) || hour === 24 && minute === 0 && second === 0 && millisecond === 0, validMinute = integerBetween(minute, 0, 59), validSecond = integerBetween(second, 0, 59), validMillisecond = integerBetween(millisecond, 0, 999);
  if (!validHour) {
    return unitOutOfRange("hour", hour);
  } else if (!validMinute) {
    return unitOutOfRange("minute", minute);
  } else if (!validSecond) {
    return unitOutOfRange("second", second);
  } else if (!validMillisecond) {
    return unitOutOfRange("millisecond", millisecond);
  } else return false;
}
function isUndefined(o2) {
  return typeof o2 === "undefined";
}
function isNumber(o2) {
  return typeof o2 === "number";
}
function isInteger(o2) {
  return typeof o2 === "number" && o2 % 1 === 0;
}
function isString$1(o2) {
  return typeof o2 === "string";
}
function isDate(o2) {
  return Object.prototype.toString.call(o2) === "[object Date]";
}
function hasRelative() {
  try {
    return typeof Intl !== "undefined" && !!Intl.RelativeTimeFormat;
  } catch (e2) {
    return false;
  }
}
function hasLocaleWeekInfo() {
  try {
    return typeof Intl !== "undefined" && !!Intl.Locale && ("weekInfo" in Intl.Locale.prototype || "getWeekInfo" in Intl.Locale.prototype);
  } catch (e2) {
    return false;
  }
}
function maybeArray(thing) {
  return Array.isArray(thing) ? thing : [thing];
}
function bestBy(arr, by, compare) {
  if (arr.length === 0) {
    return void 0;
  }
  return arr.reduce((best, next2) => {
    const pair = [by(next2), next2];
    if (!best) {
      return pair;
    } else if (compare(best[0], pair[0]) === best[0]) {
      return best;
    } else {
      return pair;
    }
  }, null)[1];
}
function pick(obj, keys) {
  return keys.reduce((a2, k2) => {
    a2[k2] = obj[k2];
    return a2;
  }, {});
}
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}
function validateWeekSettings(settings) {
  if (settings == null) {
    return null;
  } else if (typeof settings !== "object") {
    throw new InvalidArgumentError("Week settings must be an object");
  } else {
    if (!integerBetween(settings.firstDay, 1, 7) || !integerBetween(settings.minimalDays, 1, 7) || !Array.isArray(settings.weekend) || settings.weekend.some((v2) => !integerBetween(v2, 1, 7))) {
      throw new InvalidArgumentError("Invalid week settings");
    }
    return {
      firstDay: settings.firstDay,
      minimalDays: settings.minimalDays,
      weekend: Array.from(settings.weekend)
    };
  }
}
function integerBetween(thing, bottom, top) {
  return isInteger(thing) && thing >= bottom && thing <= top;
}
function floorMod(x2, n2) {
  return x2 - n2 * Math.floor(x2 / n2);
}
function padStart(input, n2 = 2) {
  const isNeg = input < 0;
  let padded;
  if (isNeg) {
    padded = "-" + ("" + -input).padStart(n2, "0");
  } else {
    padded = ("" + input).padStart(n2, "0");
  }
  return padded;
}
function parseInteger(string) {
  if (isUndefined(string) || string === null || string === "") {
    return void 0;
  } else {
    return parseInt(string, 10);
  }
}
function parseFloating(string) {
  if (isUndefined(string) || string === null || string === "") {
    return void 0;
  } else {
    return parseFloat(string);
  }
}
function parseMillis(fraction) {
  if (isUndefined(fraction) || fraction === null || fraction === "") {
    return void 0;
  } else {
    const f2 = parseFloat("0." + fraction) * 1e3;
    return Math.floor(f2);
  }
}
function roundTo(number, digits, towardZero = false) {
  const factor = 10 ** digits, rounder = towardZero ? Math.trunc : Math.round;
  return rounder(number * factor) / factor;
}
function isLeapYear(year) {
  return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
function daysInYear(year) {
  return isLeapYear(year) ? 366 : 365;
}
function daysInMonth(year, month) {
  const modMonth = floorMod(month - 1, 12) + 1, modYear = year + (month - modMonth) / 12;
  if (modMonth === 2) {
    return isLeapYear(modYear) ? 29 : 28;
  } else {
    return [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][modMonth - 1];
  }
}
function objToLocalTS(obj) {
  let d2 = Date.UTC(
    obj.year,
    obj.month - 1,
    obj.day,
    obj.hour,
    obj.minute,
    obj.second,
    obj.millisecond
  );
  if (obj.year < 100 && obj.year >= 0) {
    d2 = new Date(d2);
    d2.setUTCFullYear(obj.year, obj.month - 1, obj.day);
  }
  return +d2;
}
function firstWeekOffset(year, minDaysInFirstWeek, startOfWeek) {
  const fwdlw = isoWeekdayToLocal(dayOfWeek(year, 1, minDaysInFirstWeek), startOfWeek);
  return -fwdlw + minDaysInFirstWeek - 1;
}
function weeksInWeekYear(weekYear, minDaysInFirstWeek = 4, startOfWeek = 1) {
  const weekOffset = firstWeekOffset(weekYear, minDaysInFirstWeek, startOfWeek);
  const weekOffsetNext = firstWeekOffset(weekYear + 1, minDaysInFirstWeek, startOfWeek);
  return (daysInYear(weekYear) - weekOffset + weekOffsetNext) / 7;
}
function untruncateYear(year) {
  if (year > 99) {
    return year;
  } else return year > Settings.twoDigitCutoffYear ? 1900 + year : 2e3 + year;
}
function parseZoneInfo(ts, offsetFormat, locale, timeZone = null) {
  const date = new Date(ts), intlOpts = {
    hourCycle: "h23",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit"
  };
  if (timeZone) {
    intlOpts.timeZone = timeZone;
  }
  const modified = { timeZoneName: offsetFormat, ...intlOpts };
  const parsed = new Intl.DateTimeFormat(locale, modified).formatToParts(date).find((m3) => m3.type.toLowerCase() === "timezonename");
  return parsed ? parsed.value : null;
}
function signedOffset(offHourStr, offMinuteStr) {
  let offHour = parseInt(offHourStr, 10);
  if (Number.isNaN(offHour)) {
    offHour = 0;
  }
  const offMin = parseInt(offMinuteStr, 10) || 0, offMinSigned = offHour < 0 || Object.is(offHour, -0) ? -offMin : offMin;
  return offHour * 60 + offMinSigned;
}
function asNumber(value) {
  const numericValue = Number(value);
  if (typeof value === "boolean" || value === "" || Number.isNaN(numericValue))
    throw new InvalidArgumentError(`Invalid unit value ${value}`);
  return numericValue;
}
function normalizeObject(obj, normalizer) {
  const normalized = {};
  for (const u2 in obj) {
    if (hasOwnProperty(obj, u2)) {
      const v2 = obj[u2];
      if (v2 === void 0 || v2 === null) continue;
      normalized[normalizer(u2)] = asNumber(v2);
    }
  }
  return normalized;
}
function formatOffset(offset2, format) {
  const hours = Math.trunc(Math.abs(offset2 / 60)), minutes = Math.trunc(Math.abs(offset2 % 60)), sign2 = offset2 >= 0 ? "+" : "-";
  switch (format) {
    case "short":
      return `${sign2}${padStart(hours, 2)}:${padStart(minutes, 2)}`;
    case "narrow":
      return `${sign2}${hours}${minutes > 0 ? `:${minutes}` : ""}`;
    case "techie":
      return `${sign2}${padStart(hours, 2)}${padStart(minutes, 2)}`;
    default:
      throw new RangeError(`Value format ${format} is out of range for property format`);
  }
}
function timeObject(obj) {
  return pick(obj, ["hour", "minute", "second", "millisecond"]);
}
const monthsLong = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
];
const monthsShort = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
];
const monthsNarrow = ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"];
function months(length2) {
  switch (length2) {
    case "narrow":
      return [...monthsNarrow];
    case "short":
      return [...monthsShort];
    case "long":
      return [...monthsLong];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
    case "2-digit":
      return ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
    default:
      return null;
  }
}
const weekdaysLong = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday"
];
const weekdaysShort = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
const weekdaysNarrow = ["M", "T", "W", "T", "F", "S", "S"];
function weekdays(length2) {
  switch (length2) {
    case "narrow":
      return [...weekdaysNarrow];
    case "short":
      return [...weekdaysShort];
    case "long":
      return [...weekdaysLong];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7"];
    default:
      return null;
  }
}
const meridiems = ["AM", "PM"];
const erasLong = ["Before Christ", "Anno Domini"];
const erasShort = ["BC", "AD"];
const erasNarrow = ["B", "A"];
function eras(length2) {
  switch (length2) {
    case "narrow":
      return [...erasNarrow];
    case "short":
      return [...erasShort];
    case "long":
      return [...erasLong];
    default:
      return null;
  }
}
function meridiemForDateTime(dt) {
  return meridiems[dt.hour < 12 ? 0 : 1];
}
function weekdayForDateTime(dt, length2) {
  return weekdays(length2)[dt.weekday - 1];
}
function monthForDateTime(dt, length2) {
  return months(length2)[dt.month - 1];
}
function eraForDateTime(dt, length2) {
  return eras(length2)[dt.year < 0 ? 0 : 1];
}
function formatRelativeTime(unit, count, numeric = "always", narrow = false) {
  const units = {
    years: ["year", "yr."],
    quarters: ["quarter", "qtr."],
    months: ["month", "mo."],
    weeks: ["week", "wk."],
    days: ["day", "day", "days"],
    hours: ["hour", "hr."],
    minutes: ["minute", "min."],
    seconds: ["second", "sec."]
  };
  const lastable = ["hours", "minutes", "seconds"].indexOf(unit) === -1;
  if (numeric === "auto" && lastable) {
    const isDay = unit === "days";
    switch (count) {
      case 1:
        return isDay ? "tomorrow" : `next ${units[unit][0]}`;
      case -1:
        return isDay ? "yesterday" : `last ${units[unit][0]}`;
      case 0:
        return isDay ? "today" : `this ${units[unit][0]}`;
    }
  }
  const isInPast = Object.is(count, -0) || count < 0, fmtValue = Math.abs(count), singular = fmtValue === 1, lilUnits = units[unit], fmtUnit = narrow ? singular ? lilUnits[1] : lilUnits[2] || lilUnits[1] : singular ? units[unit][0] : unit;
  return isInPast ? `${fmtValue} ${fmtUnit} ago` : `in ${fmtValue} ${fmtUnit}`;
}
function stringifyTokens(splits, tokenToString) {
  let s2 = "";
  for (const token2 of splits) {
    if (token2.literal) {
      s2 += token2.val;
    } else {
      s2 += tokenToString(token2.val);
    }
  }
  return s2;
}
const macroTokenToFormatOpts = {
  D: DATE_SHORT,
  DD: DATE_MED,
  DDD: DATE_FULL,
  DDDD: DATE_HUGE,
  t: TIME_SIMPLE,
  tt: TIME_WITH_SECONDS,
  ttt: TIME_WITH_SHORT_OFFSET,
  tttt: TIME_WITH_LONG_OFFSET,
  T: TIME_24_SIMPLE,
  TT: TIME_24_WITH_SECONDS,
  TTT: TIME_24_WITH_SHORT_OFFSET,
  TTTT: TIME_24_WITH_LONG_OFFSET,
  f: DATETIME_SHORT,
  ff: DATETIME_MED,
  fff: DATETIME_FULL,
  ffff: DATETIME_HUGE,
  F: DATETIME_SHORT_WITH_SECONDS,
  FF: DATETIME_MED_WITH_SECONDS,
  FFF: DATETIME_FULL_WITH_SECONDS,
  FFFF: DATETIME_HUGE_WITH_SECONDS
};
class Formatter {
  static create(locale, opts = {}) {
    return new Formatter(locale, opts);
  }
  static parseFormat(fmt) {
    let current = null, currentFull = "", bracketed = false;
    const splits = [];
    for (let i = 0; i < fmt.length; i++) {
      const c4 = fmt.charAt(i);
      if (c4 === "'") {
        if (currentFull.length > 0) {
          splits.push({ literal: bracketed || /^\s+$/.test(currentFull), val: currentFull });
        }
        current = null;
        currentFull = "";
        bracketed = !bracketed;
      } else if (bracketed) {
        currentFull += c4;
      } else if (c4 === current) {
        currentFull += c4;
      } else {
        if (currentFull.length > 0) {
          splits.push({ literal: /^\s+$/.test(currentFull), val: currentFull });
        }
        currentFull = c4;
        current = c4;
      }
    }
    if (currentFull.length > 0) {
      splits.push({ literal: bracketed || /^\s+$/.test(currentFull), val: currentFull });
    }
    return splits;
  }
  static macroTokenToFormatOpts(token2) {
    return macroTokenToFormatOpts[token2];
  }
  constructor(locale, formatOpts) {
    this.opts = formatOpts;
    this.loc = locale;
    this.systemLoc = null;
  }
  formatWithSystemDefault(dt, opts) {
    if (this.systemLoc === null) {
      this.systemLoc = this.loc.redefaultToSystem();
    }
    const df = this.systemLoc.dtFormatter(dt, { ...this.opts, ...opts });
    return df.format();
  }
  dtFormatter(dt, opts = {}) {
    return this.loc.dtFormatter(dt, { ...this.opts, ...opts });
  }
  formatDateTime(dt, opts) {
    return this.dtFormatter(dt, opts).format();
  }
  formatDateTimeParts(dt, opts) {
    return this.dtFormatter(dt, opts).formatToParts();
  }
  formatInterval(interval, opts) {
    const df = this.dtFormatter(interval.start, opts);
    return df.dtf.formatRange(interval.start.toJSDate(), interval.end.toJSDate());
  }
  resolvedOptions(dt, opts) {
    return this.dtFormatter(dt, opts).resolvedOptions();
  }
  num(n2, p2 = 0) {
    if (this.opts.forceSimple) {
      return padStart(n2, p2);
    }
    const opts = { ...this.opts };
    if (p2 > 0) {
      opts.padTo = p2;
    }
    return this.loc.numberFormatter(opts).format(n2);
  }
  formatDateTimeFromString(dt, fmt) {
    const knownEnglish = this.loc.listingMode() === "en", useDateTimeFormatter = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory", string = (opts, extract) => this.loc.extract(dt, opts, extract), formatOffset2 = (opts) => {
      if (dt.isOffsetFixed && dt.offset === 0 && opts.allowZ) {
        return "Z";
      }
      return dt.isValid ? dt.zone.formatOffset(dt.ts, opts.format) : "";
    }, meridiem = () => knownEnglish ? meridiemForDateTime(dt) : string({ hour: "numeric", hourCycle: "h12" }, "dayperiod"), month = (length2, standalone) => knownEnglish ? monthForDateTime(dt, length2) : string(standalone ? { month: length2 } : { month: length2, day: "numeric" }, "month"), weekday = (length2, standalone) => knownEnglish ? weekdayForDateTime(dt, length2) : string(
      standalone ? { weekday: length2 } : { weekday: length2, month: "long", day: "numeric" },
      "weekday"
    ), maybeMacro = (token2) => {
      const formatOpts = Formatter.macroTokenToFormatOpts(token2);
      if (formatOpts) {
        return this.formatWithSystemDefault(dt, formatOpts);
      } else {
        return token2;
      }
    }, era = (length2) => knownEnglish ? eraForDateTime(dt, length2) : string({ era: length2 }, "era"), tokenToString = (token2) => {
      switch (token2) {
        case "S":
          return this.num(dt.millisecond);
        case "u":
        case "SSS":
          return this.num(dt.millisecond, 3);
        case "s":
          return this.num(dt.second);
        case "ss":
          return this.num(dt.second, 2);
        case "uu":
          return this.num(Math.floor(dt.millisecond / 10), 2);
        case "uuu":
          return this.num(Math.floor(dt.millisecond / 100));
        case "m":
          return this.num(dt.minute);
        case "mm":
          return this.num(dt.minute, 2);
        case "h":
          return this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12);
        case "hh":
          return this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12, 2);
        case "H":
          return this.num(dt.hour);
        case "HH":
          return this.num(dt.hour, 2);
        case "Z":
          return formatOffset2({ format: "narrow", allowZ: this.opts.allowZ });
        case "ZZ":
          return formatOffset2({ format: "short", allowZ: this.opts.allowZ });
        case "ZZZ":
          return formatOffset2({ format: "techie", allowZ: this.opts.allowZ });
        case "ZZZZ":
          return dt.zone.offsetName(dt.ts, { format: "short", locale: this.loc.locale });
        case "ZZZZZ":
          return dt.zone.offsetName(dt.ts, { format: "long", locale: this.loc.locale });
        case "z":
          return dt.zoneName;
        case "a":
          return meridiem();
        case "d":
          return useDateTimeFormatter ? string({ day: "numeric" }, "day") : this.num(dt.day);
        case "dd":
          return useDateTimeFormatter ? string({ day: "2-digit" }, "day") : this.num(dt.day, 2);
        case "c":
          return this.num(dt.weekday);
        case "ccc":
          return weekday("short", true);
        case "cccc":
          return weekday("long", true);
        case "ccccc":
          return weekday("narrow", true);
        case "E":
          return this.num(dt.weekday);
        case "EEE":
          return weekday("short", false);
        case "EEEE":
          return weekday("long", false);
        case "EEEEE":
          return weekday("narrow", false);
        case "L":
          return useDateTimeFormatter ? string({ month: "numeric", day: "numeric" }, "month") : this.num(dt.month);
        case "LL":
          return useDateTimeFormatter ? string({ month: "2-digit", day: "numeric" }, "month") : this.num(dt.month, 2);
        case "LLL":
          return month("short", true);
        case "LLLL":
          return month("long", true);
        case "LLLLL":
          return month("narrow", true);
        case "M":
          return useDateTimeFormatter ? string({ month: "numeric" }, "month") : this.num(dt.month);
        case "MM":
          return useDateTimeFormatter ? string({ month: "2-digit" }, "month") : this.num(dt.month, 2);
        case "MMM":
          return month("short", false);
        case "MMMM":
          return month("long", false);
        case "MMMMM":
          return month("narrow", false);
        case "y":
          return useDateTimeFormatter ? string({ year: "numeric" }, "year") : this.num(dt.year);
        case "yy":
          return useDateTimeFormatter ? string({ year: "2-digit" }, "year") : this.num(dt.year.toString().slice(-2), 2);
        case "yyyy":
          return useDateTimeFormatter ? string({ year: "numeric" }, "year") : this.num(dt.year, 4);
        case "yyyyyy":
          return useDateTimeFormatter ? string({ year: "numeric" }, "year") : this.num(dt.year, 6);
        case "G":
          return era("short");
        case "GG":
          return era("long");
        case "GGGGG":
          return era("narrow");
        case "kk":
          return this.num(dt.weekYear.toString().slice(-2), 2);
        case "kkkk":
          return this.num(dt.weekYear, 4);
        case "W":
          return this.num(dt.weekNumber);
        case "WW":
          return this.num(dt.weekNumber, 2);
        case "n":
          return this.num(dt.localWeekNumber);
        case "nn":
          return this.num(dt.localWeekNumber, 2);
        case "ii":
          return this.num(dt.localWeekYear.toString().slice(-2), 2);
        case "iiii":
          return this.num(dt.localWeekYear, 4);
        case "o":
          return this.num(dt.ordinal);
        case "ooo":
          return this.num(dt.ordinal, 3);
        case "q":
          return this.num(dt.quarter);
        case "qq":
          return this.num(dt.quarter, 2);
        case "X":
          return this.num(Math.floor(dt.ts / 1e3));
        case "x":
          return this.num(dt.ts);
        default:
          return maybeMacro(token2);
      }
    };
    return stringifyTokens(Formatter.parseFormat(fmt), tokenToString);
  }
  formatDurationFromString(dur, fmt) {
    const tokenToField = (token2) => {
      switch (token2[0]) {
        case "S":
          return "millisecond";
        case "s":
          return "second";
        case "m":
          return "minute";
        case "h":
          return "hour";
        case "d":
          return "day";
        case "w":
          return "week";
        case "M":
          return "month";
        case "y":
          return "year";
        default:
          return null;
      }
    }, tokenToString = (lildur) => (token2) => {
      const mapped = tokenToField(token2);
      if (mapped) {
        return this.num(lildur.get(mapped), token2.length);
      } else {
        return token2;
      }
    }, tokens = Formatter.parseFormat(fmt), realTokens = tokens.reduce(
      (found, { literal, val }) => literal ? found : found.concat(val),
      []
    ), collapsed2 = dur.shiftTo(...realTokens.map(tokenToField).filter((t2) => t2));
    return stringifyTokens(tokens, tokenToString(collapsed2));
  }
}
const ianaRegex = /[A-Za-z_+-]{1,256}(?::?\/[A-Za-z0-9_+-]{1,256}(?:\/[A-Za-z0-9_+-]{1,256})?)?/;
function combineRegexes(...regexes) {
  const full = regexes.reduce((f2, r2) => f2 + r2.source, "");
  return RegExp(`^${full}$`);
}
function combineExtractors(...extractors) {
  return (m3) => extractors.reduce(
    ([mergedVals, mergedZone, cursor2], ex) => {
      const [val, zone, next2] = ex(m3, cursor2);
      return [{ ...mergedVals, ...val }, zone || mergedZone, next2];
    },
    [{}, null, 1]
  ).slice(0, 2);
}
function parse$2(s2, ...patterns) {
  if (s2 == null) {
    return [null, null];
  }
  for (const [regex, extractor] of patterns) {
    const m3 = regex.exec(s2);
    if (m3) {
      return extractor(m3);
    }
  }
  return [null, null];
}
function simpleParse(...keys) {
  return (match2, cursor2) => {
    const ret = {};
    let i;
    for (i = 0; i < keys.length; i++) {
      ret[keys[i]] = parseInteger(match2[cursor2 + i]);
    }
    return [ret, null, cursor2 + i];
  };
}
const offsetRegex = /(?:(Z)|([+-]\d\d)(?::?(\d\d))?)/;
const isoExtendedZone = `(?:${offsetRegex.source}?(?:\\[(${ianaRegex.source})\\])?)?`;
const isoTimeBaseRegex = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/;
const isoTimeRegex = RegExp(`${isoTimeBaseRegex.source}${isoExtendedZone}`);
const isoTimeExtensionRegex = RegExp(`(?:T${isoTimeRegex.source})?`);
const isoYmdRegex = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/;
const isoWeekRegex = /(\d{4})-?W(\d\d)(?:-?(\d))?/;
const isoOrdinalRegex = /(\d{4})-?(\d{3})/;
const extractISOWeekData = simpleParse("weekYear", "weekNumber", "weekDay");
const extractISOOrdinalData = simpleParse("year", "ordinal");
const sqlYmdRegex = /(\d{4})-(\d\d)-(\d\d)/;
const sqlTimeRegex = RegExp(
  `${isoTimeBaseRegex.source} ?(?:${offsetRegex.source}|(${ianaRegex.source}))?`
);
const sqlTimeExtensionRegex = RegExp(`(?: ${sqlTimeRegex.source})?`);
function int(match2, pos, fallback) {
  const m3 = match2[pos];
  return isUndefined(m3) ? fallback : parseInteger(m3);
}
function extractISOYmd(match2, cursor2) {
  const item = {
    year: int(match2, cursor2),
    month: int(match2, cursor2 + 1, 1),
    day: int(match2, cursor2 + 2, 1)
  };
  return [item, null, cursor2 + 3];
}
function extractISOTime(match2, cursor2) {
  const item = {
    hours: int(match2, cursor2, 0),
    minutes: int(match2, cursor2 + 1, 0),
    seconds: int(match2, cursor2 + 2, 0),
    milliseconds: parseMillis(match2[cursor2 + 3])
  };
  return [item, null, cursor2 + 4];
}
function extractISOOffset(match2, cursor2) {
  const local = !match2[cursor2] && !match2[cursor2 + 1], fullOffset = signedOffset(match2[cursor2 + 1], match2[cursor2 + 2]), zone = local ? null : FixedOffsetZone.instance(fullOffset);
  return [{}, zone, cursor2 + 3];
}
function extractIANAZone(match2, cursor2) {
  const zone = match2[cursor2] ? IANAZone.create(match2[cursor2]) : null;
  return [{}, zone, cursor2 + 1];
}
const isoTimeOnly = RegExp(`^T?${isoTimeBaseRegex.source}$`);
const isoDuration = /^-?P(?:(?:(-?\d{1,20}(?:\.\d{1,20})?)Y)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20}(?:\.\d{1,20})?)W)?(?:(-?\d{1,20}(?:\.\d{1,20})?)D)?(?:T(?:(-?\d{1,20}(?:\.\d{1,20})?)H)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,20}))?S)?)?)$/;
function extractISODuration(match2) {
  const [s2, yearStr, monthStr, weekStr, dayStr, hourStr, minuteStr, secondStr, millisecondsStr] = match2;
  const hasNegativePrefix = s2[0] === "-";
  const negativeSeconds = secondStr && secondStr[0] === "-";
  const maybeNegate = (num, force = false) => num !== void 0 && (force || num && hasNegativePrefix) ? -num : num;
  return [
    {
      years: maybeNegate(parseFloating(yearStr)),
      months: maybeNegate(parseFloating(monthStr)),
      weeks: maybeNegate(parseFloating(weekStr)),
      days: maybeNegate(parseFloating(dayStr)),
      hours: maybeNegate(parseFloating(hourStr)),
      minutes: maybeNegate(parseFloating(minuteStr)),
      seconds: maybeNegate(parseFloating(secondStr), secondStr === "-0"),
      milliseconds: maybeNegate(parseMillis(millisecondsStr), negativeSeconds)
    }
  ];
}
const obsOffsets = {
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
  const result = {
    year: yearStr.length === 2 ? untruncateYear(parseInteger(yearStr)) : parseInteger(yearStr),
    month: monthsShort.indexOf(monthStr) + 1,
    day: parseInteger(dayStr),
    hour: parseInteger(hourStr),
    minute: parseInteger(minuteStr)
  };
  if (secondStr) result.second = parseInteger(secondStr);
  if (weekdayStr) {
    result.weekday = weekdayStr.length > 3 ? weekdaysLong.indexOf(weekdayStr) + 1 : weekdaysShort.indexOf(weekdayStr) + 1;
  }
  return result;
}
const rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;
function extractRFC2822(match2) {
  const [
    ,
    weekdayStr,
    dayStr,
    monthStr,
    yearStr,
    hourStr,
    minuteStr,
    secondStr,
    obsOffset,
    milOffset,
    offHourStr,
    offMinuteStr
  ] = match2, result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
  let offset2;
  if (obsOffset) {
    offset2 = obsOffsets[obsOffset];
  } else if (milOffset) {
    offset2 = 0;
  } else {
    offset2 = signedOffset(offHourStr, offMinuteStr);
  }
  return [result, new FixedOffsetZone(offset2)];
}
function preprocessRFC2822(s2) {
  return s2.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
}
const rfc1123 = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/, rfc850 = /^(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/, ascii = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;
function extractRFC1123Or850(match2) {
  const [, weekdayStr, dayStr, monthStr, yearStr, hourStr, minuteStr, secondStr] = match2, result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
  return [result, FixedOffsetZone.utcInstance];
}
function extractASCII(match2) {
  const [, weekdayStr, monthStr, dayStr, hourStr, minuteStr, secondStr, yearStr] = match2, result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
  return [result, FixedOffsetZone.utcInstance];
}
const isoYmdWithTimeExtensionRegex = combineRegexes(isoYmdRegex, isoTimeExtensionRegex);
const isoWeekWithTimeExtensionRegex = combineRegexes(isoWeekRegex, isoTimeExtensionRegex);
const isoOrdinalWithTimeExtensionRegex = combineRegexes(isoOrdinalRegex, isoTimeExtensionRegex);
const isoTimeCombinedRegex = combineRegexes(isoTimeRegex);
const extractISOYmdTimeAndOffset = combineExtractors(
  extractISOYmd,
  extractISOTime,
  extractISOOffset,
  extractIANAZone
);
const extractISOWeekTimeAndOffset = combineExtractors(
  extractISOWeekData,
  extractISOTime,
  extractISOOffset,
  extractIANAZone
);
const extractISOOrdinalDateAndTime = combineExtractors(
  extractISOOrdinalData,
  extractISOTime,
  extractISOOffset,
  extractIANAZone
);
const extractISOTimeAndOffset = combineExtractors(
  extractISOTime,
  extractISOOffset,
  extractIANAZone
);
function parseISODate(s2) {
  return parse$2(
    s2,
    [isoYmdWithTimeExtensionRegex, extractISOYmdTimeAndOffset],
    [isoWeekWithTimeExtensionRegex, extractISOWeekTimeAndOffset],
    [isoOrdinalWithTimeExtensionRegex, extractISOOrdinalDateAndTime],
    [isoTimeCombinedRegex, extractISOTimeAndOffset]
  );
}
function parseRFC2822Date(s2) {
  return parse$2(preprocessRFC2822(s2), [rfc2822, extractRFC2822]);
}
function parseHTTPDate(s2) {
  return parse$2(
    s2,
    [rfc1123, extractRFC1123Or850],
    [rfc850, extractRFC1123Or850],
    [ascii, extractASCII]
  );
}
function parseISODuration(s2) {
  return parse$2(s2, [isoDuration, extractISODuration]);
}
const extractISOTimeOnly = combineExtractors(extractISOTime);
function parseISOTimeOnly(s2) {
  return parse$2(s2, [isoTimeOnly, extractISOTimeOnly]);
}
const sqlYmdWithTimeExtensionRegex = combineRegexes(sqlYmdRegex, sqlTimeExtensionRegex);
const sqlTimeCombinedRegex = combineRegexes(sqlTimeRegex);
const extractISOTimeOffsetAndIANAZone = combineExtractors(
  extractISOTime,
  extractISOOffset,
  extractIANAZone
);
function parseSQL(s2) {
  return parse$2(
    s2,
    [sqlYmdWithTimeExtensionRegex, extractISOYmdTimeAndOffset],
    [sqlTimeCombinedRegex, extractISOTimeOffsetAndIANAZone]
  );
}
const INVALID$2 = "Invalid Duration";
const lowOrderMatrix = {
  weeks: {
    days: 7,
    hours: 7 * 24,
    minutes: 7 * 24 * 60,
    seconds: 7 * 24 * 60 * 60,
    milliseconds: 7 * 24 * 60 * 60 * 1e3
  },
  days: {
    hours: 24,
    minutes: 24 * 60,
    seconds: 24 * 60 * 60,
    milliseconds: 24 * 60 * 60 * 1e3
  },
  hours: { minutes: 60, seconds: 60 * 60, milliseconds: 60 * 60 * 1e3 },
  minutes: { seconds: 60, milliseconds: 60 * 1e3 },
  seconds: { milliseconds: 1e3 }
}, casualMatrix = {
  years: {
    quarters: 4,
    months: 12,
    weeks: 52,
    days: 365,
    hours: 365 * 24,
    minutes: 365 * 24 * 60,
    seconds: 365 * 24 * 60 * 60,
    milliseconds: 365 * 24 * 60 * 60 * 1e3
  },
  quarters: {
    months: 3,
    weeks: 13,
    days: 91,
    hours: 91 * 24,
    minutes: 91 * 24 * 60,
    seconds: 91 * 24 * 60 * 60,
    milliseconds: 91 * 24 * 60 * 60 * 1e3
  },
  months: {
    weeks: 4,
    days: 30,
    hours: 30 * 24,
    minutes: 30 * 24 * 60,
    seconds: 30 * 24 * 60 * 60,
    milliseconds: 30 * 24 * 60 * 60 * 1e3
  },
  ...lowOrderMatrix
}, daysInYearAccurate = 146097 / 400, daysInMonthAccurate = 146097 / 4800, accurateMatrix = {
  years: {
    quarters: 4,
    months: 12,
    weeks: daysInYearAccurate / 7,
    days: daysInYearAccurate,
    hours: daysInYearAccurate * 24,
    minutes: daysInYearAccurate * 24 * 60,
    seconds: daysInYearAccurate * 24 * 60 * 60,
    milliseconds: daysInYearAccurate * 24 * 60 * 60 * 1e3
  },
  quarters: {
    months: 3,
    weeks: daysInYearAccurate / 28,
    days: daysInYearAccurate / 4,
    hours: daysInYearAccurate * 24 / 4,
    minutes: daysInYearAccurate * 24 * 60 / 4,
    seconds: daysInYearAccurate * 24 * 60 * 60 / 4,
    milliseconds: daysInYearAccurate * 24 * 60 * 60 * 1e3 / 4
  },
  months: {
    weeks: daysInMonthAccurate / 7,
    days: daysInMonthAccurate,
    hours: daysInMonthAccurate * 24,
    minutes: daysInMonthAccurate * 24 * 60,
    seconds: daysInMonthAccurate * 24 * 60 * 60,
    milliseconds: daysInMonthAccurate * 24 * 60 * 60 * 1e3
  },
  ...lowOrderMatrix
};
const orderedUnits$1 = [
  "years",
  "quarters",
  "months",
  "weeks",
  "days",
  "hours",
  "minutes",
  "seconds",
  "milliseconds"
];
const reverseUnits = orderedUnits$1.slice(0).reverse();
function clone$2(dur, alts, clear = false) {
  const conf = {
    values: clear ? alts.values : { ...dur.values, ...alts.values || {} },
    loc: dur.loc.clone(alts.loc),
    conversionAccuracy: alts.conversionAccuracy || dur.conversionAccuracy,
    matrix: alts.matrix || dur.matrix
  };
  return new Duration(conf);
}
function durationToMillis(matrix, vals) {
  let sum = vals.milliseconds ?? 0;
  for (const unit of reverseUnits.slice(1)) {
    if (vals[unit]) {
      sum += vals[unit] * matrix[unit]["milliseconds"];
    }
  }
  return sum;
}
function normalizeValues(matrix, vals) {
  const factor = durationToMillis(matrix, vals) < 0 ? -1 : 1;
  orderedUnits$1.reduceRight((previous, current) => {
    if (!isUndefined(vals[current])) {
      if (previous) {
        const previousVal = vals[previous] * factor;
        const conv = matrix[current][previous];
        const rollUp = Math.floor(previousVal / conv);
        vals[current] += rollUp * factor;
        vals[previous] -= rollUp * conv * factor;
      }
      return current;
    } else {
      return previous;
    }
  }, null);
  orderedUnits$1.reduce((previous, current) => {
    if (!isUndefined(vals[current])) {
      if (previous) {
        const fraction = vals[previous] % 1;
        vals[previous] -= fraction;
        vals[current] += fraction * matrix[previous][current];
      }
      return current;
    } else {
      return previous;
    }
  }, null);
}
function removeZeroes(vals) {
  const newVals = {};
  for (const [key, value] of Object.entries(vals)) {
    if (value !== 0) {
      newVals[key] = value;
    }
  }
  return newVals;
}
class Duration {
  /**
   * @private
   */
  constructor(config2) {
    const accurate = config2.conversionAccuracy === "longterm" || false;
    let matrix = accurate ? accurateMatrix : casualMatrix;
    if (config2.matrix) {
      matrix = config2.matrix;
    }
    this.values = config2.values;
    this.loc = config2.loc || Locale.create();
    this.conversionAccuracy = accurate ? "longterm" : "casual";
    this.invalid = config2.invalid || null;
    this.matrix = matrix;
    this.isLuxonDuration = true;
  }
  /**
   * Create Duration from a number of milliseconds.
   * @param {number} count of milliseconds
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  static fromMillis(count, opts) {
    return Duration.fromObject({ milliseconds: count }, opts);
  }
  /**
   * Create a Duration from a JavaScript object with keys like 'years' and 'hours'.
   * If this object is empty then a zero milliseconds duration is returned.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.years
   * @param {number} obj.quarters
   * @param {number} obj.months
   * @param {number} obj.weeks
   * @param {number} obj.days
   * @param {number} obj.hours
   * @param {number} obj.minutes
   * @param {number} obj.seconds
   * @param {number} obj.milliseconds
   * @param {Object} [opts=[]] - options for creating this Duration
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the custom conversion system to use
   * @return {Duration}
   */
  static fromObject(obj, opts = {}) {
    if (obj == null || typeof obj !== "object") {
      throw new InvalidArgumentError(
        `Duration.fromObject: argument expected to be an object, got ${obj === null ? "null" : typeof obj}`
      );
    }
    return new Duration({
      values: normalizeObject(obj, Duration.normalizeUnit),
      loc: Locale.fromObject(opts),
      conversionAccuracy: opts.conversionAccuracy,
      matrix: opts.matrix
    });
  }
  /**
   * Create a Duration from DurationLike.
   *
   * @param {Object | number | Duration} durationLike
   * One of:
   * - object with keys like 'years' and 'hours'.
   * - number representing milliseconds
   * - Duration instance
   * @return {Duration}
   */
  static fromDurationLike(durationLike) {
    if (isNumber(durationLike)) {
      return Duration.fromMillis(durationLike);
    } else if (Duration.isDuration(durationLike)) {
      return durationLike;
    } else if (typeof durationLike === "object") {
      return Duration.fromObject(durationLike);
    } else {
      throw new InvalidArgumentError(
        `Unknown duration argument ${durationLike} of type ${typeof durationLike}`
      );
    }
  }
  /**
   * Create a Duration from an ISO 8601 duration string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the preset conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromISO('P3Y6M1W4DT12H30M5S').toObject() //=> { years: 3, months: 6, weeks: 1, days: 4, hours: 12, minutes: 30, seconds: 5 }
   * @example Duration.fromISO('PT23H').toObject() //=> { hours: 23 }
   * @example Duration.fromISO('P5Y3M').toObject() //=> { years: 5, months: 3 }
   * @return {Duration}
   */
  static fromISO(text, opts) {
    const [parsed] = parseISODuration(text);
    if (parsed) {
      return Duration.fromObject(parsed, opts);
    } else {
      return Duration.invalid("unparsable", `the input "${text}" can't be parsed as ISO 8601`);
    }
  }
  /**
   * Create a Duration from an ISO 8601 time string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @example Duration.fromISOTime('11:22:33.444').toObject() //=> { hours: 11, minutes: 22, seconds: 33, milliseconds: 444 }
   * @example Duration.fromISOTime('11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @return {Duration}
   */
  static fromISOTime(text, opts) {
    const [parsed] = parseISOTimeOnly(text);
    if (parsed) {
      return Duration.fromObject(parsed, opts);
    } else {
      return Duration.invalid("unparsable", `the input "${text}" can't be parsed as ISO 8601`);
    }
  }
  /**
   * Create an invalid Duration.
   * @param {string} reason - simple string of why this datetime is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Duration}
   */
  static invalid(reason, explanation = null) {
    if (!reason) {
      throw new InvalidArgumentError("need to specify a reason the Duration is invalid");
    }
    const invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);
    if (Settings.throwOnInvalid) {
      throw new InvalidDurationError(invalid);
    } else {
      return new Duration({ invalid });
    }
  }
  /**
   * @private
   */
  static normalizeUnit(unit) {
    const normalized = {
      year: "years",
      years: "years",
      quarter: "quarters",
      quarters: "quarters",
      month: "months",
      months: "months",
      week: "weeks",
      weeks: "weeks",
      day: "days",
      days: "days",
      hour: "hours",
      hours: "hours",
      minute: "minutes",
      minutes: "minutes",
      second: "seconds",
      seconds: "seconds",
      millisecond: "milliseconds",
      milliseconds: "milliseconds"
    }[unit ? unit.toLowerCase() : unit];
    if (!normalized) throw new InvalidUnitError(unit);
    return normalized;
  }
  /**
   * Check if an object is a Duration. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDuration(o2) {
    return o2 && o2.isLuxonDuration || false;
  }
  /**
   * Get  the locale of a Duration, such 'en-GB'
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  /**
   * Get the numbering system of a Duration, such 'beng'. The numbering system is used when formatting the Duration
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  /**
   * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
   * * `S` for milliseconds
   * * `s` for seconds
   * * `m` for minutes
   * * `h` for hours
   * * `d` for days
   * * `w` for weeks
   * * `M` for months
   * * `y` for years
   * Notes:
   * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
   * * Tokens can be escaped by wrapping with single quotes.
   * * The duration will be converted to the set of units in the format string using {@link Duration#shiftTo} and the Durations's conversion accuracy setting.
   * @param {string} fmt - the format string
   * @param {Object} opts - options
   * @param {boolean} [opts.floor=true] - floor numerical values
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
   * @return {string}
   */
  toFormat(fmt, opts = {}) {
    const fmtOpts = {
      ...opts,
      floor: opts.round !== false && opts.floor !== false
    };
    return this.isValid ? Formatter.create(this.loc, fmtOpts).formatDurationFromString(this, fmt) : INVALID$2;
  }
  /**
   * Returns a string representation of a Duration with all units included.
   * To modify its behavior, use `listStyle` and any Intl.NumberFormat option, though `unitDisplay` is especially relevant.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#options
   * @param {Object} opts - Formatting options. Accepts the same keys as the options parameter of the native `Intl.NumberFormat` constructor, as well as `listStyle`.
   * @param {string} [opts.listStyle='narrow'] - How to format the merged list. Corresponds to the `style` property of the options parameter of the native `Intl.ListFormat` constructor.
   * @example
   * ```js
   * var dur = Duration.fromObject({ days: 1, hours: 5, minutes: 6 })
   * dur.toHuman() //=> '1 day, 5 hours, 6 minutes'
   * dur.toHuman({ listStyle: "long" }) //=> '1 day, 5 hours, and 6 minutes'
   * dur.toHuman({ unitDisplay: "short" }) //=> '1 day, 5 hr, 6 min'
   * ```
   */
  toHuman(opts = {}) {
    if (!this.isValid) return INVALID$2;
    const l2 = orderedUnits$1.map((unit) => {
      const val = this.values[unit];
      if (isUndefined(val)) {
        return null;
      }
      return this.loc.numberFormatter({ style: "unit", unitDisplay: "long", ...opts, unit: unit.slice(0, -1) }).format(val);
    }).filter((n2) => n2);
    return this.loc.listFormatter({ type: "conjunction", style: opts.listStyle || "narrow", ...opts }).format(l2);
  }
  /**
   * Returns a JavaScript object with this Duration's values.
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toObject() //=> { years: 1, days: 6, seconds: 2 }
   * @return {Object}
   */
  toObject() {
    if (!this.isValid) return {};
    return { ...this.values };
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Duration.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromObject({ years: 3, seconds: 45 }).toISO() //=> 'P3YT45S'
   * @example Duration.fromObject({ months: 4, seconds: 45 }).toISO() //=> 'P4MT45S'
   * @example Duration.fromObject({ months: 5 }).toISO() //=> 'P5M'
   * @example Duration.fromObject({ minutes: 5 }).toISO() //=> 'PT5M'
   * @example Duration.fromObject({ milliseconds: 6 }).toISO() //=> 'PT0.006S'
   * @return {string}
   */
  toISO() {
    if (!this.isValid) return null;
    let s2 = "P";
    if (this.years !== 0) s2 += this.years + "Y";
    if (this.months !== 0 || this.quarters !== 0) s2 += this.months + this.quarters * 3 + "M";
    if (this.weeks !== 0) s2 += this.weeks + "W";
    if (this.days !== 0) s2 += this.days + "D";
    if (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0)
      s2 += "T";
    if (this.hours !== 0) s2 += this.hours + "H";
    if (this.minutes !== 0) s2 += this.minutes + "M";
    if (this.seconds !== 0 || this.milliseconds !== 0)
      s2 += roundTo(this.seconds + this.milliseconds / 1e3, 3) + "S";
    if (s2 === "P") s2 += "T0S";
    return s2;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Duration, formatted as a time of day.
   * Note that this will return null if the duration is invalid, negative, or equal to or greater than 24 hours.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example Duration.fromObject({ hours: 11 }).toISOTime() //=> '11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressMilliseconds: true }) //=> '11:00:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressSeconds: true }) //=> '11:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ includePrefix: true }) //=> 'T11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ format: 'basic' }) //=> '110000.000'
   * @return {string}
   */
  toISOTime(opts = {}) {
    if (!this.isValid) return null;
    const millis = this.toMillis();
    if (millis < 0 || millis >= 864e5) return null;
    opts = {
      suppressMilliseconds: false,
      suppressSeconds: false,
      includePrefix: false,
      format: "extended",
      ...opts,
      includeOffset: false
    };
    const dateTime = DateTime.fromMillis(millis, { zone: "UTC" });
    return dateTime.toISOTime(opts);
  }
  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }
  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in debugging.
   * @return {string}
   */
  toString() {
    return this.toISO();
  }
  /**
   * Returns a string representation of this Duration appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    if (this.isValid) {
      return `Duration { values: ${JSON.stringify(this.values)} }`;
    } else {
      return `Duration { Invalid, reason: ${this.invalidReason} }`;
    }
  }
  /**
   * Returns an milliseconds value of this Duration.
   * @return {number}
   */
  toMillis() {
    if (!this.isValid) return NaN;
    return durationToMillis(this.matrix, this.values);
  }
  /**
   * Returns an milliseconds value of this Duration. Alias of {@link toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }
  /**
   * Make this Duration longer by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  plus(duration) {
    if (!this.isValid) return this;
    const dur = Duration.fromDurationLike(duration), result = {};
    for (const k2 of orderedUnits$1) {
      if (hasOwnProperty(dur.values, k2) || hasOwnProperty(this.values, k2)) {
        result[k2] = dur.get(k2) + this.get(k2);
      }
    }
    return clone$2(this, { values: result }, true);
  }
  /**
   * Make this Duration shorter by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  minus(duration) {
    if (!this.isValid) return this;
    const dur = Duration.fromDurationLike(duration);
    return this.plus(dur.negate());
  }
  /**
   * Scale this Duration by the specified amount. Return a newly-constructed Duration.
   * @param {function} fn - The function to apply to each unit. Arity is 1 or 2: the value of the unit and, optionally, the unit name. Must return a number.
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits(x => x * 2) //=> { hours: 2, minutes: 60 }
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits((x, u) => u === "hours" ? x * 2 : x) //=> { hours: 2, minutes: 30 }
   * @return {Duration}
   */
  mapUnits(fn) {
    if (!this.isValid) return this;
    const result = {};
    for (const k2 of Object.keys(this.values)) {
      result[k2] = asNumber(fn(this.values[k2], k2));
    }
    return clone$2(this, { values: result }, true);
  }
  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example Duration.fromObject({years: 2, days: 3}).get('years') //=> 2
   * @example Duration.fromObject({years: 2, days: 3}).get('months') //=> 0
   * @example Duration.fromObject({years: 2, days: 3}).get('days') //=> 3
   * @return {number}
   */
  get(unit) {
    return this[Duration.normalizeUnit(unit)];
  }
  /**
   * "Set" the values of specified units. Return a newly-constructed Duration.
   * @param {Object} values - a mapping of units to numbers
   * @example dur.set({ years: 2017 })
   * @example dur.set({ hours: 8, minutes: 30 })
   * @return {Duration}
   */
  set(values2) {
    if (!this.isValid) return this;
    const mixed = { ...this.values, ...normalizeObject(values2, Duration.normalizeUnit) };
    return clone$2(this, { values: mixed });
  }
  /**
   * "Set" the locale and/or numberingSystem.  Returns a newly-constructed Duration.
   * @example dur.reconfigure({ locale: 'en-GB' })
   * @return {Duration}
   */
  reconfigure({ locale, numberingSystem, conversionAccuracy, matrix } = {}) {
    const loc = this.loc.clone({ locale, numberingSystem });
    const opts = { loc, matrix, conversionAccuracy };
    return clone$2(this, opts);
  }
  /**
   * Return the length of the duration in the specified unit.
   * @param {string} unit - a unit such as 'minutes' or 'days'
   * @example Duration.fromObject({years: 1}).as('days') //=> 365
   * @example Duration.fromObject({years: 1}).as('months') //=> 12
   * @example Duration.fromObject({hours: 60}).as('days') //=> 2.5
   * @return {number}
   */
  as(unit) {
    return this.isValid ? this.shiftTo(unit).get(unit) : NaN;
  }
  /**
   * Reduce this Duration to its canonical representation in its current units.
   * Assuming the overall value of the Duration is positive, this means:
   * - excessive values for lower-order units are converted to higher-order units (if possible, see first and second example)
   * - negative lower-order units are converted to higher order units (there must be such a higher order unit, otherwise
   *   the overall value would be negative, see third example)
   * - fractional values for higher-order units are converted to lower-order units (if possible, see fourth example)
   *
   * If the overall value is negative, the result of this method is equivalent to `this.negate().normalize().negate()`.
   * @example Duration.fromObject({ years: 2, days: 5000 }).normalize().toObject() //=> { years: 15, days: 255 }
   * @example Duration.fromObject({ days: 5000 }).normalize().toObject() //=> { days: 5000 }
   * @example Duration.fromObject({ hours: 12, minutes: -45 }).normalize().toObject() //=> { hours: 11, minutes: 15 }
   * @example Duration.fromObject({ years: 2.5, days: 0, hours: 0 }).normalize().toObject() //=> { years: 2, days: 182, hours: 12 }
   * @return {Duration}
   */
  normalize() {
    if (!this.isValid) return this;
    const vals = this.toObject();
    normalizeValues(this.matrix, vals);
    return clone$2(this, { values: vals }, true);
  }
  /**
   * Rescale units to its largest representation
   * @example Duration.fromObject({ milliseconds: 90000 }).rescale().toObject() //=> { minutes: 1, seconds: 30 }
   * @return {Duration}
   */
  rescale() {
    if (!this.isValid) return this;
    const vals = removeZeroes(this.normalize().shiftToAll().toObject());
    return clone$2(this, { values: vals }, true);
  }
  /**
   * Convert this Duration into its representation in a different set of units.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).shiftTo('minutes', 'milliseconds').toObject() //=> { minutes: 60, milliseconds: 30000 }
   * @return {Duration}
   */
  shiftTo(...units) {
    if (!this.isValid) return this;
    if (units.length === 0) {
      return this;
    }
    units = units.map((u2) => Duration.normalizeUnit(u2));
    const built = {}, accumulated = {}, vals = this.toObject();
    let lastUnit;
    for (const k2 of orderedUnits$1) {
      if (units.indexOf(k2) >= 0) {
        lastUnit = k2;
        let own = 0;
        for (const ak in accumulated) {
          own += this.matrix[ak][k2] * accumulated[ak];
          accumulated[ak] = 0;
        }
        if (isNumber(vals[k2])) {
          own += vals[k2];
        }
        const i = Math.trunc(own);
        built[k2] = i;
        accumulated[k2] = (own * 1e3 - i * 1e3) / 1e3;
      } else if (isNumber(vals[k2])) {
        accumulated[k2] = vals[k2];
      }
    }
    for (const key in accumulated) {
      if (accumulated[key] !== 0) {
        built[lastUnit] += key === lastUnit ? accumulated[key] : accumulated[key] / this.matrix[lastUnit][key];
      }
    }
    normalizeValues(this.matrix, built);
    return clone$2(this, { values: built }, true);
  }
  /**
   * Shift this Duration to all available units.
   * Same as shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds")
   * @return {Duration}
   */
  shiftToAll() {
    if (!this.isValid) return this;
    return this.shiftTo(
      "years",
      "months",
      "weeks",
      "days",
      "hours",
      "minutes",
      "seconds",
      "milliseconds"
    );
  }
  /**
   * Return the negative of this Duration.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).negate().toObject() //=> { hours: -1, seconds: -30 }
   * @return {Duration}
   */
  negate() {
    if (!this.isValid) return this;
    const negated = {};
    for (const k2 of Object.keys(this.values)) {
      negated[k2] = this.values[k2] === 0 ? 0 : -this.values[k2];
    }
    return clone$2(this, { values: negated }, true);
  }
  /**
   * Get the years.
   * @type {number}
   */
  get years() {
    return this.isValid ? this.values.years || 0 : NaN;
  }
  /**
   * Get the quarters.
   * @type {number}
   */
  get quarters() {
    return this.isValid ? this.values.quarters || 0 : NaN;
  }
  /**
   * Get the months.
   * @type {number}
   */
  get months() {
    return this.isValid ? this.values.months || 0 : NaN;
  }
  /**
   * Get the weeks
   * @type {number}
   */
  get weeks() {
    return this.isValid ? this.values.weeks || 0 : NaN;
  }
  /**
   * Get the days.
   * @type {number}
   */
  get days() {
    return this.isValid ? this.values.days || 0 : NaN;
  }
  /**
   * Get the hours.
   * @type {number}
   */
  get hours() {
    return this.isValid ? this.values.hours || 0 : NaN;
  }
  /**
   * Get the minutes.
   * @type {number}
   */
  get minutes() {
    return this.isValid ? this.values.minutes || 0 : NaN;
  }
  /**
   * Get the seconds.
   * @return {number}
   */
  get seconds() {
    return this.isValid ? this.values.seconds || 0 : NaN;
  }
  /**
   * Get the milliseconds.
   * @return {number}
   */
  get milliseconds() {
    return this.isValid ? this.values.milliseconds || 0 : NaN;
  }
  /**
   * Returns whether the Duration is invalid. Invalid durations are returned by diff operations
   * on invalid DateTimes or Intervals.
   * @return {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }
  /**
   * Returns an error code if this Duration became invalid, or null if the Duration is valid
   * @return {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this Duration became invalid, or null if the Duration is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Equality check
   * Two Durations are equal iff they have the same units and the same values for each unit.
   * @param {Duration} other
   * @return {boolean}
   */
  equals(other) {
    if (!this.isValid || !other.isValid) {
      return false;
    }
    if (!this.loc.equals(other.loc)) {
      return false;
    }
    function eq2(v1, v2) {
      if (v1 === void 0 || v1 === 0) return v2 === void 0 || v2 === 0;
      return v1 === v2;
    }
    for (const u2 of orderedUnits$1) {
      if (!eq2(this.values[u2], other.values[u2])) {
        return false;
      }
    }
    return true;
  }
}
const INVALID$1 = "Invalid Interval";
function validateStartEnd(start, end) {
  if (!start || !start.isValid) {
    return Interval.invalid("missing or invalid start");
  } else if (!end || !end.isValid) {
    return Interval.invalid("missing or invalid end");
  } else if (end < start) {
    return Interval.invalid(
      "end before start",
      `The end of an interval must be after its start, but you had start=${start.toISO()} and end=${end.toISO()}`
    );
  } else {
    return null;
  }
}
class Interval {
  /**
   * @private
   */
  constructor(config2) {
    this.s = config2.start;
    this.e = config2.end;
    this.invalid = config2.invalid || null;
    this.isLuxonInterval = true;
  }
  /**
   * Create an invalid Interval.
   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Interval}
   */
  static invalid(reason, explanation = null) {
    if (!reason) {
      throw new InvalidArgumentError("need to specify a reason the Interval is invalid");
    }
    const invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);
    if (Settings.throwOnInvalid) {
      throw new InvalidIntervalError(invalid);
    } else {
      return new Interval({ invalid });
    }
  }
  /**
   * Create an Interval from a start DateTime and an end DateTime. Inclusive of the start but not the end.
   * @param {DateTime|Date|Object} start
   * @param {DateTime|Date|Object} end
   * @return {Interval}
   */
  static fromDateTimes(start, end) {
    const builtStart = friendlyDateTime(start), builtEnd = friendlyDateTime(end);
    const validateError = validateStartEnd(builtStart, builtEnd);
    if (validateError == null) {
      return new Interval({
        start: builtStart,
        end: builtEnd
      });
    } else {
      return validateError;
    }
  }
  /**
   * Create an Interval from a start DateTime and a Duration to extend to.
   * @param {DateTime|Date|Object} start
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static after(start, duration) {
    const dur = Duration.fromDurationLike(duration), dt = friendlyDateTime(start);
    return Interval.fromDateTimes(dt, dt.plus(dur));
  }
  /**
   * Create an Interval from an end DateTime and a Duration to extend backwards to.
   * @param {DateTime|Date|Object} end
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static before(end, duration) {
    const dur = Duration.fromDurationLike(duration), dt = friendlyDateTime(end);
    return Interval.fromDateTimes(dt.minus(dur), dt);
  }
  /**
   * Create an Interval from an ISO 8601 string.
   * Accepts `<start>/<end>`, `<start>/<duration>`, and `<duration>/<end>` formats.
   * @param {string} text - the ISO string to parse
   * @param {Object} [opts] - options to pass {@link DateTime#fromISO} and optionally {@link Duration#fromISO}
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {Interval}
   */
  static fromISO(text, opts) {
    const [s2, e2] = (text || "").split("/", 2);
    if (s2 && e2) {
      let start, startIsValid;
      try {
        start = DateTime.fromISO(s2, opts);
        startIsValid = start.isValid;
      } catch (e3) {
        startIsValid = false;
      }
      let end, endIsValid;
      try {
        end = DateTime.fromISO(e2, opts);
        endIsValid = end.isValid;
      } catch (e3) {
        endIsValid = false;
      }
      if (startIsValid && endIsValid) {
        return Interval.fromDateTimes(start, end);
      }
      if (startIsValid) {
        const dur = Duration.fromISO(e2, opts);
        if (dur.isValid) {
          return Interval.after(start, dur);
        }
      } else if (endIsValid) {
        const dur = Duration.fromISO(s2, opts);
        if (dur.isValid) {
          return Interval.before(end, dur);
        }
      }
    }
    return Interval.invalid("unparsable", `the input "${text}" can't be parsed as ISO 8601`);
  }
  /**
   * Check if an object is an Interval. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isInterval(o2) {
    return o2 && o2.isLuxonInterval || false;
  }
  /**
   * Returns the start of the Interval
   * @type {DateTime}
   */
  get start() {
    return this.isValid ? this.s : null;
  }
  /**
   * Returns the end of the Interval
   * @type {DateTime}
   */
  get end() {
    return this.isValid ? this.e : null;
  }
  /**
   * Returns whether this Interval's end is at least its start, meaning that the Interval isn't 'backwards'.
   * @type {boolean}
   */
  get isValid() {
    return this.invalidReason === null;
  }
  /**
   * Returns an error code if this Interval is invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this Interval became invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Returns the length of the Interval in the specified unit.
   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
   * @return {number}
   */
  length(unit = "milliseconds") {
    return this.isValid ? this.toDuration(...[unit]).get(unit) : NaN;
  }
  /**
   * Returns the count of minutes, hours, days, months, or years included in the Interval, even in part.
   * Unlike {@link Interval#length} this counts sections of the calendar, not periods of time, e.g. specifying 'day'
   * asks 'what dates are included in this interval?', not 'how many days long is this interval?'
   * @param {string} [unit='milliseconds'] - the unit of time to count.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; this operation will always use the locale of the start DateTime
   * @return {number}
   */
  count(unit = "milliseconds", opts) {
    if (!this.isValid) return NaN;
    const start = this.start.startOf(unit, opts);
    let end;
    if (opts == null ? void 0 : opts.useLocaleWeeks) {
      end = this.end.reconfigure({ locale: start.locale });
    } else {
      end = this.end;
    }
    end = end.startOf(unit, opts);
    return Math.floor(end.diff(start, unit).get(unit)) + (end.valueOf() !== this.end.valueOf());
  }
  /**
   * Returns whether this Interval's start and end are both in the same unit of time
   * @param {string} unit - the unit of time to check sameness on
   * @return {boolean}
   */
  hasSame(unit) {
    return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, unit) : false;
  }
  /**
   * Return whether this Interval has the same start and end DateTimes.
   * @return {boolean}
   */
  isEmpty() {
    return this.s.valueOf() === this.e.valueOf();
  }
  /**
   * Return whether this Interval's start is after the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isAfter(dateTime) {
    if (!this.isValid) return false;
    return this.s > dateTime;
  }
  /**
   * Return whether this Interval's end is before the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isBefore(dateTime) {
    if (!this.isValid) return false;
    return this.e <= dateTime;
  }
  /**
   * Return whether this Interval contains the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  contains(dateTime) {
    if (!this.isValid) return false;
    return this.s <= dateTime && this.e > dateTime;
  }
  /**
   * "Sets" the start and/or end dates. Returns a newly-constructed Interval.
   * @param {Object} values - the values to set
   * @param {DateTime} values.start - the starting DateTime
   * @param {DateTime} values.end - the ending DateTime
   * @return {Interval}
   */
  set({ start, end } = {}) {
    if (!this.isValid) return this;
    return Interval.fromDateTimes(start || this.s, end || this.e);
  }
  /**
   * Split this Interval at each of the specified DateTimes
   * @param {...DateTime} dateTimes - the unit of time to count.
   * @return {Array}
   */
  splitAt(...dateTimes) {
    if (!this.isValid) return [];
    const sorted = dateTimes.map(friendlyDateTime).filter((d2) => this.contains(d2)).sort((a2, b2) => a2.toMillis() - b2.toMillis()), results = [];
    let { s: s2 } = this, i = 0;
    while (s2 < this.e) {
      const added = sorted[i] || this.e, next2 = +added > +this.e ? this.e : added;
      results.push(Interval.fromDateTimes(s2, next2));
      s2 = next2;
      i += 1;
    }
    return results;
  }
  /**
   * Split this Interval into smaller Intervals, each of the specified length.
   * Left over time is grouped into a smaller interval
   * @param {Duration|Object|number} duration - The length of each resulting interval.
   * @return {Array}
   */
  splitBy(duration) {
    const dur = Duration.fromDurationLike(duration);
    if (!this.isValid || !dur.isValid || dur.as("milliseconds") === 0) {
      return [];
    }
    let { s: s2 } = this, idx = 1, next2;
    const results = [];
    while (s2 < this.e) {
      const added = this.start.plus(dur.mapUnits((x2) => x2 * idx));
      next2 = +added > +this.e ? this.e : added;
      results.push(Interval.fromDateTimes(s2, next2));
      s2 = next2;
      idx += 1;
    }
    return results;
  }
  /**
   * Split this Interval into the specified number of smaller intervals.
   * @param {number} numberOfParts - The number of Intervals to divide the Interval into.
   * @return {Array}
   */
  divideEqually(numberOfParts) {
    if (!this.isValid) return [];
    return this.splitBy(this.length() / numberOfParts).slice(0, numberOfParts);
  }
  /**
   * Return whether this Interval overlaps with the specified Interval
   * @param {Interval} other
   * @return {boolean}
   */
  overlaps(other) {
    return this.e > other.s && this.s < other.e;
  }
  /**
   * Return whether this Interval's end is adjacent to the specified Interval's start.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsStart(other) {
    if (!this.isValid) return false;
    return +this.e === +other.s;
  }
  /**
   * Return whether this Interval's start is adjacent to the specified Interval's end.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsEnd(other) {
    if (!this.isValid) return false;
    return +other.e === +this.s;
  }
  /**
   * Return whether this Interval engulfs the start and end of the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */
  engulfs(other) {
    if (!this.isValid) return false;
    return this.s <= other.s && this.e >= other.e;
  }
  /**
   * Return whether this Interval has the same start and end as the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */
  equals(other) {
    if (!this.isValid || !other.isValid) {
      return false;
    }
    return this.s.equals(other.s) && this.e.equals(other.e);
  }
  /**
   * Return an Interval representing the intersection of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the maximum start time and the minimum end time of the two Intervals.
   * Returns null if the intersection is empty, meaning, the intervals don't intersect.
   * @param {Interval} other
   * @return {Interval}
   */
  intersection(other) {
    if (!this.isValid) return this;
    const s2 = this.s > other.s ? this.s : other.s, e2 = this.e < other.e ? this.e : other.e;
    if (s2 >= e2) {
      return null;
    } else {
      return Interval.fromDateTimes(s2, e2);
    }
  }
  /**
   * Return an Interval representing the union of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the minimum start time and the maximum end time of the two Intervals.
   * @param {Interval} other
   * @return {Interval}
   */
  union(other) {
    if (!this.isValid) return this;
    const s2 = this.s < other.s ? this.s : other.s, e2 = this.e > other.e ? this.e : other.e;
    return Interval.fromDateTimes(s2, e2);
  }
  /**
   * Merge an array of Intervals into a equivalent minimal set of Intervals.
   * Combines overlapping and adjacent Intervals.
   * @param {Array} intervals
   * @return {Array}
   */
  static merge(intervals) {
    const [found, final] = intervals.sort((a2, b2) => a2.s - b2.s).reduce(
      ([sofar, current], item) => {
        if (!current) {
          return [sofar, item];
        } else if (current.overlaps(item) || current.abutsStart(item)) {
          return [sofar, current.union(item)];
        } else {
          return [sofar.concat([current]), item];
        }
      },
      [[], null]
    );
    if (final) {
      found.push(final);
    }
    return found;
  }
  /**
   * Return an array of Intervals representing the spans of time that only appear in one of the specified Intervals.
   * @param {Array} intervals
   * @return {Array}
   */
  static xor(intervals) {
    let start = null, currentCount = 0;
    const results = [], ends = intervals.map((i) => [
      { time: i.s, type: "s" },
      { time: i.e, type: "e" }
    ]), flattened = Array.prototype.concat(...ends), arr = flattened.sort((a2, b2) => a2.time - b2.time);
    for (const i of arr) {
      currentCount += i.type === "s" ? 1 : -1;
      if (currentCount === 1) {
        start = i.time;
      } else {
        if (start && +start !== +i.time) {
          results.push(Interval.fromDateTimes(start, i.time));
        }
        start = null;
      }
    }
    return Interval.merge(results);
  }
  /**
   * Return an Interval representing the span of time in this Interval that doesn't overlap with any of the specified Intervals.
   * @param {...Interval} intervals
   * @return {Array}
   */
  difference(...intervals) {
    return Interval.xor([this].concat(intervals)).map((i) => this.intersection(i)).filter((i) => i && !i.isEmpty());
  }
  /**
   * Returns a string representation of this Interval appropriate for debugging.
   * @return {string}
   */
  toString() {
    if (!this.isValid) return INVALID$1;
    return `[${this.s.toISO()} – ${this.e.toISO()})`;
  }
  /**
   * Returns a string representation of this Interval appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    if (this.isValid) {
      return `Interval { start: ${this.s.toISO()}, end: ${this.e.toISO()} }`;
    } else {
      return `Interval { Invalid, reason: ${this.invalidReason} }`;
    }
  }
  /**
   * Returns a localized string representing this Interval. Accepts the same options as the
   * Intl.DateTimeFormat constructor and any presets defined by Luxon, such as
   * {@link DateTime.DATE_FULL} or {@link DateTime.TIME_SIMPLE}. The exact behavior of this method
   * is browser-specific, but in general it will return an appropriate representation of the
   * Interval in the assigned locale. Defaults to the system's locale if no locale has been
   * specified.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {Object} [formatOpts=DateTime.DATE_SHORT] - Either a DateTime preset or
   * Intl.DateTimeFormat constructor options.
   * @param {Object} opts - Options to override the configuration of the start DateTime.
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(); //=> 11/7/2022 – 11/8/2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL); //=> November 7 – 8, 2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL, { locale: 'fr-FR' }); //=> 7–8 novembre 2022
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString(DateTime.TIME_SIMPLE); //=> 6:00 – 8:00 PM
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> Mon, Nov 07, 6:00 – 8:00 p
   * @return {string}
   */
  toLocaleString(formatOpts = DATE_SHORT, opts = {}) {
    return this.isValid ? Formatter.create(this.s.loc.clone(opts), formatOpts).formatInterval(this) : INVALID$1;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Interval.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISO(opts) {
    if (!this.isValid) return INVALID$1;
    return `${this.s.toISO(opts)}/${this.e.toISO(opts)}`;
  }
  /**
   * Returns an ISO 8601-compliant string representation of date of this Interval.
   * The time components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {string}
   */
  toISODate() {
    if (!this.isValid) return INVALID$1;
    return `${this.s.toISODate()}/${this.e.toISODate()}`;
  }
  /**
   * Returns an ISO 8601-compliant string representation of time of this Interval.
   * The date components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISOTime(opts) {
    if (!this.isValid) return INVALID$1;
    return `${this.s.toISOTime(opts)}/${this.e.toISOTime(opts)}`;
  }
  /**
   * Returns a string representation of this Interval formatted according to the specified format
   * string. **You may not want this.** See {@link Interval#toLocaleString} for a more flexible
   * formatting tool.
   * @param {string} dateFormat - The format string. This string formats the start and end time.
   * See {@link DateTime#toFormat} for details.
   * @param {Object} opts - Options.
   * @param {string} [opts.separator =  ' – '] - A separator to place between the start and end
   * representations.
   * @return {string}
   */
  toFormat(dateFormat, { separator: separator2 = " – " } = {}) {
    if (!this.isValid) return INVALID$1;
    return `${this.s.toFormat(dateFormat)}${separator2}${this.e.toFormat(dateFormat)}`;
  }
  /**
   * Return a Duration representing the time spanned by this interval.
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example Interval.fromDateTimes(dt1, dt2).toDuration().toObject() //=> { milliseconds: 88489257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('days').toObject() //=> { days: 1.0241812152777778 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes']).toObject() //=> { hours: 24, minutes: 34.82095 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes', 'seconds']).toObject() //=> { hours: 24, minutes: 34, seconds: 49.257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('seconds').toObject() //=> { seconds: 88489.257 }
   * @return {Duration}
   */
  toDuration(unit, opts) {
    if (!this.isValid) {
      return Duration.invalid(this.invalidReason);
    }
    return this.e.diff(this.s, unit, opts);
  }
  /**
   * Run mapFn on the interval start and end, returning a new Interval from the resulting DateTimes
   * @param {function} mapFn
   * @return {Interval}
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.toUTC())
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.plus({ hours: 2 }))
   */
  mapEndpoints(mapFn) {
    return Interval.fromDateTimes(mapFn(this.s), mapFn(this.e));
  }
}
class Info {
  /**
   * Return whether the specified zone contains a DST.
   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
   * @return {boolean}
   */
  static hasDST(zone = Settings.defaultZone) {
    const proto = DateTime.now().setZone(zone).set({ month: 12 });
    return !zone.isUniversal && proto.offset !== proto.set({ month: 6 }).offset;
  }
  /**
   * Return whether the specified zone is a valid IANA specifier.
   * @param {string} zone - Zone to check
   * @return {boolean}
   */
  static isValidIANAZone(zone) {
    return IANAZone.isValidZone(zone);
  }
  /**
   * Converts the input into a {@link Zone} instance.
   *
   * * If `input` is already a Zone instance, it is returned unchanged.
   * * If `input` is a string containing a valid time zone name, a Zone instance
   *   with that name is returned.
   * * If `input` is a string that doesn't refer to a known time zone, a Zone
   *   instance with {@link Zone#isValid} == false is returned.
   * * If `input is a number, a Zone instance with the specified fixed offset
   *   in minutes is returned.
   * * If `input` is `null` or `undefined`, the default zone is returned.
   * @param {string|Zone|number} [input] - the value to be converted
   * @return {Zone}
   */
  static normalizeZone(input) {
    return normalizeZone(input, Settings.defaultZone);
  }
  /**
   * Get the weekday on which the week starts according to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number} the start of the week, 1 for Monday through 7 for Sunday
   */
  static getStartOfWeek({ locale = null, locObj = null } = {}) {
    return (locObj || Locale.create(locale)).getStartOfWeek();
  }
  /**
   * Get the minimum number of days necessary in a week before it is considered part of the next year according
   * to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number}
   */
  static getMinimumDaysInFirstWeek({ locale = null, locObj = null } = {}) {
    return (locObj || Locale.create(locale)).getMinDaysInFirstWeek();
  }
  /**
   * Get the weekdays, which are considered the weekend according to the given locale
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number[]} an array of weekdays, 1 for Monday through 7 for Sunday
   */
  static getWeekendWeekdays({ locale = null, locObj = null } = {}) {
    return (locObj || Locale.create(locale)).getWeekendDays().slice();
  }
  /**
   * Return an array of standalone month names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @example Info.months()[0] //=> 'January'
   * @example Info.months('short')[0] //=> 'Jan'
   * @example Info.months('numeric')[0] //=> '1'
   * @example Info.months('short', { locale: 'fr-CA' } )[0] //=> 'janv.'
   * @example Info.months('numeric', { locale: 'ar' })[0] //=> '١'
   * @example Info.months('long', { outputCalendar: 'islamic' })[0] //=> 'Rabiʻ I'
   * @return {Array}
   */
  static months(length2 = "long", { locale = null, numberingSystem = null, locObj = null, outputCalendar = "gregory" } = {}) {
    return (locObj || Locale.create(locale, numberingSystem, outputCalendar)).months(length2);
  }
  /**
   * Return an array of format month names.
   * Format months differ from standalone months in that they're meant to appear next to the day of the month. In some languages, that
   * changes the string.
   * See {@link Info#months}
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @return {Array}
   */
  static monthsFormat(length2 = "long", { locale = null, numberingSystem = null, locObj = null, outputCalendar = "gregory" } = {}) {
    return (locObj || Locale.create(locale, numberingSystem, outputCalendar)).months(length2, true);
  }
  /**
   * Return an array of standalone week names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the weekday representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @example Info.weekdays()[0] //=> 'Monday'
   * @example Info.weekdays('short')[0] //=> 'Mon'
   * @example Info.weekdays('short', { locale: 'fr-CA' })[0] //=> 'lun.'
   * @example Info.weekdays('short', { locale: 'ar' })[0] //=> 'الاثنين'
   * @return {Array}
   */
  static weekdays(length2 = "long", { locale = null, numberingSystem = null, locObj = null } = {}) {
    return (locObj || Locale.create(locale, numberingSystem, null)).weekdays(length2);
  }
  /**
   * Return an array of format week names.
   * Format weekdays differ from standalone weekdays in that they're meant to appear next to more date information. In some languages, that
   * changes the string.
   * See {@link Info#weekdays}
   * @param {string} [length='long'] - the length of the month representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale=null] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @return {Array}
   */
  static weekdaysFormat(length2 = "long", { locale = null, numberingSystem = null, locObj = null } = {}) {
    return (locObj || Locale.create(locale, numberingSystem, null)).weekdays(length2, true);
  }
  /**
   * Return an array of meridiems.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.meridiems() //=> [ 'AM', 'PM' ]
   * @example Info.meridiems({ locale: 'my' }) //=> [ 'နံနက်', 'ညနေ' ]
   * @return {Array}
   */
  static meridiems({ locale = null } = {}) {
    return Locale.create(locale).meridiems();
  }
  /**
   * Return an array of eras, such as ['BC', 'AD']. The locale can be specified, but the calendar system is always Gregorian.
   * @param {string} [length='short'] - the length of the era representation, such as "short" or "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.eras() //=> [ 'BC', 'AD' ]
   * @example Info.eras('long') //=> [ 'Before Christ', 'Anno Domini' ]
   * @example Info.eras('long', { locale: 'fr' }) //=> [ 'avant Jésus-Christ', 'après Jésus-Christ' ]
   * @return {Array}
   */
  static eras(length2 = "short", { locale = null } = {}) {
    return Locale.create(locale, null, "gregory").eras(length2);
  }
  /**
   * Return the set of available features in this environment.
   * Some features of Luxon are not available in all environments. For example, on older browsers, relative time formatting support is not available. Use this function to figure out if that's the case.
   * Keys:
   * * `relative`: whether this environment supports relative time formatting
   * * `localeWeek`: whether this environment supports different weekdays for the start of the week based on the locale
   * @example Info.features() //=> { relative: false, localeWeek: true }
   * @return {Object}
   */
  static features() {
    return { relative: hasRelative(), localeWeek: hasLocaleWeekInfo() };
  }
}
function dayDiff(earlier, later) {
  const utcDayStart = (dt) => dt.toUTC(0, { keepLocalTime: true }).startOf("day").valueOf(), ms = utcDayStart(later) - utcDayStart(earlier);
  return Math.floor(Duration.fromMillis(ms).as("days"));
}
function highOrderDiffs(cursor2, later, units) {
  const differs = [
    ["years", (a2, b2) => b2.year - a2.year],
    ["quarters", (a2, b2) => b2.quarter - a2.quarter + (b2.year - a2.year) * 4],
    ["months", (a2, b2) => b2.month - a2.month + (b2.year - a2.year) * 12],
    [
      "weeks",
      (a2, b2) => {
        const days = dayDiff(a2, b2);
        return (days - days % 7) / 7;
      }
    ],
    ["days", dayDiff]
  ];
  const results = {};
  const earlier = cursor2;
  let lowestOrder, highWater;
  for (const [unit, differ] of differs) {
    if (units.indexOf(unit) >= 0) {
      lowestOrder = unit;
      results[unit] = differ(cursor2, later);
      highWater = earlier.plus(results);
      if (highWater > later) {
        results[unit]--;
        cursor2 = earlier.plus(results);
        if (cursor2 > later) {
          highWater = cursor2;
          results[unit]--;
          cursor2 = earlier.plus(results);
        }
      } else {
        cursor2 = highWater;
      }
    }
  }
  return [cursor2, results, highWater, lowestOrder];
}
function diff(earlier, later, units, opts) {
  let [cursor2, results, highWater, lowestOrder] = highOrderDiffs(earlier, later, units);
  const remainingMillis = later - cursor2;
  const lowerOrderUnits = units.filter(
    (u2) => ["hours", "minutes", "seconds", "milliseconds"].indexOf(u2) >= 0
  );
  if (lowerOrderUnits.length === 0) {
    if (highWater < later) {
      highWater = cursor2.plus({ [lowestOrder]: 1 });
    }
    if (highWater !== cursor2) {
      results[lowestOrder] = (results[lowestOrder] || 0) + remainingMillis / (highWater - cursor2);
    }
  }
  const duration = Duration.fromObject(results, opts);
  if (lowerOrderUnits.length > 0) {
    return Duration.fromMillis(remainingMillis, opts).shiftTo(...lowerOrderUnits).plus(duration);
  } else {
    return duration;
  }
}
const numberingSystems = {
  arab: "[٠-٩]",
  arabext: "[۰-۹]",
  bali: "[᭐-᭙]",
  beng: "[০-৯]",
  deva: "[०-९]",
  fullwide: "[０-９]",
  gujr: "[૦-૯]",
  hanidec: "[〇|一|二|三|四|五|六|七|八|九]",
  khmr: "[០-៩]",
  knda: "[೦-೯]",
  laoo: "[໐-໙]",
  limb: "[᥆-᥏]",
  mlym: "[൦-൯]",
  mong: "[᠐-᠙]",
  mymr: "[၀-၉]",
  orya: "[୦-୯]",
  tamldec: "[௦-௯]",
  telu: "[౦-౯]",
  thai: "[๐-๙]",
  tibt: "[༠-༩]",
  latn: "\\d"
};
const numberingSystemsUTF16 = {
  arab: [1632, 1641],
  arabext: [1776, 1785],
  bali: [6992, 7001],
  beng: [2534, 2543],
  deva: [2406, 2415],
  fullwide: [65296, 65303],
  gujr: [2790, 2799],
  khmr: [6112, 6121],
  knda: [3302, 3311],
  laoo: [3792, 3801],
  limb: [6470, 6479],
  mlym: [3430, 3439],
  mong: [6160, 6169],
  mymr: [4160, 4169],
  orya: [2918, 2927],
  tamldec: [3046, 3055],
  telu: [3174, 3183],
  thai: [3664, 3673],
  tibt: [3872, 3881]
};
const hanidecChars = numberingSystems.hanidec.replace(/[\[|\]]/g, "").split("");
function parseDigits(str) {
  let value = parseInt(str, 10);
  if (isNaN(value)) {
    value = "";
    for (let i = 0; i < str.length; i++) {
      const code = str.charCodeAt(i);
      if (str[i].search(numberingSystems.hanidec) !== -1) {
        value += hanidecChars.indexOf(str[i]);
      } else {
        for (const key in numberingSystemsUTF16) {
          const [min2, max2] = numberingSystemsUTF16[key];
          if (code >= min2 && code <= max2) {
            value += code - min2;
          }
        }
      }
    }
    return parseInt(value, 10);
  } else {
    return value;
  }
}
function digitRegex({ numberingSystem }, append2 = "") {
  return new RegExp(`${numberingSystems[numberingSystem || "latn"]}${append2}`);
}
const MISSING_FTP = "missing Intl.DateTimeFormat.formatToParts support";
function intUnit(regex, post = (i) => i) {
  return { regex, deser: ([s2]) => post(parseDigits(s2)) };
}
const NBSP = String.fromCharCode(160);
const spaceOrNBSP = `[ ${NBSP}]`;
const spaceOrNBSPRegExp = new RegExp(spaceOrNBSP, "g");
function fixListRegex(s2) {
  return s2.replace(/\./g, "\\.?").replace(spaceOrNBSPRegExp, spaceOrNBSP);
}
function stripInsensitivities(s2) {
  return s2.replace(/\./g, "").replace(spaceOrNBSPRegExp, " ").toLowerCase();
}
function oneOf(strings, startIndex) {
  if (strings === null) {
    return null;
  } else {
    return {
      regex: RegExp(strings.map(fixListRegex).join("|")),
      deser: ([s2]) => strings.findIndex((i) => stripInsensitivities(s2) === stripInsensitivities(i)) + startIndex
    };
  }
}
function offset(regex, groups) {
  return { regex, deser: ([, h3, m3]) => signedOffset(h3, m3), groups };
}
function simple(regex) {
  return { regex, deser: ([s2]) => s2 };
}
function escapeToken(value) {
  return value.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}
function unitForToken(token2, loc) {
  const one = digitRegex(loc), two = digitRegex(loc, "{2}"), three = digitRegex(loc, "{3}"), four = digitRegex(loc, "{4}"), six = digitRegex(loc, "{6}"), oneOrTwo = digitRegex(loc, "{1,2}"), oneToThree = digitRegex(loc, "{1,3}"), oneToSix = digitRegex(loc, "{1,6}"), oneToNine = digitRegex(loc, "{1,9}"), twoToFour = digitRegex(loc, "{2,4}"), fourToSix = digitRegex(loc, "{4,6}"), literal = (t2) => ({ regex: RegExp(escapeToken(t2.val)), deser: ([s2]) => s2, literal: true }), unitate = (t2) => {
    if (token2.literal) {
      return literal(t2);
    }
    switch (t2.val) {
      case "G":
        return oneOf(loc.eras("short"), 0);
      case "GG":
        return oneOf(loc.eras("long"), 0);
      case "y":
        return intUnit(oneToSix);
      case "yy":
        return intUnit(twoToFour, untruncateYear);
      case "yyyy":
        return intUnit(four);
      case "yyyyy":
        return intUnit(fourToSix);
      case "yyyyyy":
        return intUnit(six);
      case "M":
        return intUnit(oneOrTwo);
      case "MM":
        return intUnit(two);
      case "MMM":
        return oneOf(loc.months("short", true), 1);
      case "MMMM":
        return oneOf(loc.months("long", true), 1);
      case "L":
        return intUnit(oneOrTwo);
      case "LL":
        return intUnit(two);
      case "LLL":
        return oneOf(loc.months("short", false), 1);
      case "LLLL":
        return oneOf(loc.months("long", false), 1);
      case "d":
        return intUnit(oneOrTwo);
      case "dd":
        return intUnit(two);
      case "o":
        return intUnit(oneToThree);
      case "ooo":
        return intUnit(three);
      case "HH":
        return intUnit(two);
      case "H":
        return intUnit(oneOrTwo);
      case "hh":
        return intUnit(two);
      case "h":
        return intUnit(oneOrTwo);
      case "mm":
        return intUnit(two);
      case "m":
        return intUnit(oneOrTwo);
      case "q":
        return intUnit(oneOrTwo);
      case "qq":
        return intUnit(two);
      case "s":
        return intUnit(oneOrTwo);
      case "ss":
        return intUnit(two);
      case "S":
        return intUnit(oneToThree);
      case "SSS":
        return intUnit(three);
      case "u":
        return simple(oneToNine);
      case "uu":
        return simple(oneOrTwo);
      case "uuu":
        return intUnit(one);
      case "a":
        return oneOf(loc.meridiems(), 0);
      case "kkkk":
        return intUnit(four);
      case "kk":
        return intUnit(twoToFour, untruncateYear);
      case "W":
        return intUnit(oneOrTwo);
      case "WW":
        return intUnit(two);
      case "E":
      case "c":
        return intUnit(one);
      case "EEE":
        return oneOf(loc.weekdays("short", false), 1);
      case "EEEE":
        return oneOf(loc.weekdays("long", false), 1);
      case "ccc":
        return oneOf(loc.weekdays("short", true), 1);
      case "cccc":
        return oneOf(loc.weekdays("long", true), 1);
      case "Z":
      case "ZZ":
        return offset(new RegExp(`([+-]${oneOrTwo.source})(?::(${two.source}))?`), 2);
      case "ZZZ":
        return offset(new RegExp(`([+-]${oneOrTwo.source})(${two.source})?`), 2);
      case "z":
        return simple(/[a-z_+-/]{1,256}?/i);
      case " ":
        return simple(/[^\S\n\r]/);
      default:
        return literal(t2);
    }
  };
  const unit = unitate(token2) || {
    invalidReason: MISSING_FTP
  };
  unit.token = token2;
  return unit;
}
const partTypeStyleToTokenVal = {
  year: {
    "2-digit": "yy",
    numeric: "yyyyy"
  },
  month: {
    numeric: "M",
    "2-digit": "MM",
    short: "MMM",
    long: "MMMM"
  },
  day: {
    numeric: "d",
    "2-digit": "dd"
  },
  weekday: {
    short: "EEE",
    long: "EEEE"
  },
  dayperiod: "a",
  dayPeriod: "a",
  hour12: {
    numeric: "h",
    "2-digit": "hh"
  },
  hour24: {
    numeric: "H",
    "2-digit": "HH"
  },
  minute: {
    numeric: "m",
    "2-digit": "mm"
  },
  second: {
    numeric: "s",
    "2-digit": "ss"
  },
  timeZoneName: {
    long: "ZZZZZ",
    short: "ZZZ"
  }
};
function tokenForPart(part, formatOpts, resolvedOpts) {
  const { type: type2, value } = part;
  if (type2 === "literal") {
    const isSpace = /^\s+$/.test(value);
    return {
      literal: !isSpace,
      val: isSpace ? " " : value
    };
  }
  const style = formatOpts[type2];
  let actualType = type2;
  if (type2 === "hour") {
    if (formatOpts.hour12 != null) {
      actualType = formatOpts.hour12 ? "hour12" : "hour24";
    } else if (formatOpts.hourCycle != null) {
      if (formatOpts.hourCycle === "h11" || formatOpts.hourCycle === "h12") {
        actualType = "hour12";
      } else {
        actualType = "hour24";
      }
    } else {
      actualType = resolvedOpts.hour12 ? "hour12" : "hour24";
    }
  }
  let val = partTypeStyleToTokenVal[actualType];
  if (typeof val === "object") {
    val = val[style];
  }
  if (val) {
    return {
      literal: false,
      val
    };
  }
  return void 0;
}
function buildRegex(units) {
  const re = units.map((u2) => u2.regex).reduce((f2, r2) => `${f2}(${r2.source})`, "");
  return [`^${re}$`, units];
}
function match$1(input, regex, handlers) {
  const matches = input.match(regex);
  if (matches) {
    const all = {};
    let matchIndex = 1;
    for (const i in handlers) {
      if (hasOwnProperty(handlers, i)) {
        const h3 = handlers[i], groups = h3.groups ? h3.groups + 1 : 1;
        if (!h3.literal && h3.token) {
          all[h3.token.val[0]] = h3.deser(matches.slice(matchIndex, matchIndex + groups));
        }
        matchIndex += groups;
      }
    }
    return [matches, all];
  } else {
    return [matches, {}];
  }
}
function dateTimeFromMatches(matches) {
  const toField = (token2) => {
    switch (token2) {
      case "S":
        return "millisecond";
      case "s":
        return "second";
      case "m":
        return "minute";
      case "h":
      case "H":
        return "hour";
      case "d":
        return "day";
      case "o":
        return "ordinal";
      case "L":
      case "M":
        return "month";
      case "y":
        return "year";
      case "E":
      case "c":
        return "weekday";
      case "W":
        return "weekNumber";
      case "k":
        return "weekYear";
      case "q":
        return "quarter";
      default:
        return null;
    }
  };
  let zone = null;
  let specificOffset;
  if (!isUndefined(matches.z)) {
    zone = IANAZone.create(matches.z);
  }
  if (!isUndefined(matches.Z)) {
    if (!zone) {
      zone = new FixedOffsetZone(matches.Z);
    }
    specificOffset = matches.Z;
  }
  if (!isUndefined(matches.q)) {
    matches.M = (matches.q - 1) * 3 + 1;
  }
  if (!isUndefined(matches.h)) {
    if (matches.h < 12 && matches.a === 1) {
      matches.h += 12;
    } else if (matches.h === 12 && matches.a === 0) {
      matches.h = 0;
    }
  }
  if (matches.G === 0 && matches.y) {
    matches.y = -matches.y;
  }
  if (!isUndefined(matches.u)) {
    matches.S = parseMillis(matches.u);
  }
  const vals = Object.keys(matches).reduce((r2, k2) => {
    const f2 = toField(k2);
    if (f2) {
      r2[f2] = matches[k2];
    }
    return r2;
  }, {});
  return [vals, zone, specificOffset];
}
let dummyDateTimeCache = null;
function getDummyDateTime() {
  if (!dummyDateTimeCache) {
    dummyDateTimeCache = DateTime.fromMillis(1555555555555);
  }
  return dummyDateTimeCache;
}
function maybeExpandMacroToken(token2, locale) {
  if (token2.literal) {
    return token2;
  }
  const formatOpts = Formatter.macroTokenToFormatOpts(token2.val);
  const tokens = formatOptsToTokens(formatOpts, locale);
  if (tokens == null || tokens.includes(void 0)) {
    return token2;
  }
  return tokens;
}
function expandMacroTokens(tokens, locale) {
  return Array.prototype.concat(...tokens.map((t2) => maybeExpandMacroToken(t2, locale)));
}
function explainFromTokens(locale, input, format) {
  const tokens = expandMacroTokens(Formatter.parseFormat(format), locale), units = tokens.map((t2) => unitForToken(t2, locale)), disqualifyingUnit = units.find((t2) => t2.invalidReason);
  if (disqualifyingUnit) {
    return { input, tokens, invalidReason: disqualifyingUnit.invalidReason };
  } else {
    const [regexString, handlers] = buildRegex(units), regex = RegExp(regexString, "i"), [rawMatches, matches] = match$1(input, regex, handlers), [result, zone, specificOffset] = matches ? dateTimeFromMatches(matches) : [null, null, void 0];
    if (hasOwnProperty(matches, "a") && hasOwnProperty(matches, "H")) {
      throw new ConflictingSpecificationError(
        "Can't include meridiem when specifying 24-hour format"
      );
    }
    return { input, tokens, regex, rawMatches, matches, result, zone, specificOffset };
  }
}
function parseFromTokens(locale, input, format) {
  const { result, zone, specificOffset, invalidReason } = explainFromTokens(locale, input, format);
  return [result, zone, specificOffset, invalidReason];
}
function formatOptsToTokens(formatOpts, locale) {
  if (!formatOpts) {
    return null;
  }
  const formatter = Formatter.create(locale, formatOpts);
  const df = formatter.dtFormatter(getDummyDateTime());
  const parts = df.formatToParts();
  const resolvedOpts = df.resolvedOptions();
  return parts.map((p2) => tokenForPart(p2, formatOpts, resolvedOpts));
}
const INVALID = "Invalid DateTime";
const MAX_DATE = 864e13;
function unsupportedZone(zone) {
  return new Invalid("unsupported zone", `the zone "${zone.name}" is not supported`);
}
function possiblyCachedWeekData(dt) {
  if (dt.weekData === null) {
    dt.weekData = gregorianToWeek(dt.c);
  }
  return dt.weekData;
}
function possiblyCachedLocalWeekData(dt) {
  if (dt.localWeekData === null) {
    dt.localWeekData = gregorianToWeek(
      dt.c,
      dt.loc.getMinDaysInFirstWeek(),
      dt.loc.getStartOfWeek()
    );
  }
  return dt.localWeekData;
}
function clone$1(inst, alts) {
  const current = {
    ts: inst.ts,
    zone: inst.zone,
    c: inst.c,
    o: inst.o,
    loc: inst.loc,
    invalid: inst.invalid
  };
  return new DateTime({ ...current, ...alts, old: current });
}
function fixOffset(localTS, o2, tz) {
  let utcGuess = localTS - o2 * 60 * 1e3;
  const o22 = tz.offset(utcGuess);
  if (o2 === o22) {
    return [utcGuess, o2];
  }
  utcGuess -= (o22 - o2) * 60 * 1e3;
  const o3 = tz.offset(utcGuess);
  if (o22 === o3) {
    return [utcGuess, o22];
  }
  return [localTS - Math.min(o22, o3) * 60 * 1e3, Math.max(o22, o3)];
}
function tsToObj(ts, offset2) {
  ts += offset2 * 60 * 1e3;
  const d2 = new Date(ts);
  return {
    year: d2.getUTCFullYear(),
    month: d2.getUTCMonth() + 1,
    day: d2.getUTCDate(),
    hour: d2.getUTCHours(),
    minute: d2.getUTCMinutes(),
    second: d2.getUTCSeconds(),
    millisecond: d2.getUTCMilliseconds()
  };
}
function objToTS(obj, offset2, zone) {
  return fixOffset(objToLocalTS(obj), offset2, zone);
}
function adjustTime(inst, dur) {
  const oPre = inst.o, year = inst.c.year + Math.trunc(dur.years), month = inst.c.month + Math.trunc(dur.months) + Math.trunc(dur.quarters) * 3, c4 = {
    ...inst.c,
    year,
    month,
    day: Math.min(inst.c.day, daysInMonth(year, month)) + Math.trunc(dur.days) + Math.trunc(dur.weeks) * 7
  }, millisToAdd = Duration.fromObject({
    years: dur.years - Math.trunc(dur.years),
    quarters: dur.quarters - Math.trunc(dur.quarters),
    months: dur.months - Math.trunc(dur.months),
    weeks: dur.weeks - Math.trunc(dur.weeks),
    days: dur.days - Math.trunc(dur.days),
    hours: dur.hours,
    minutes: dur.minutes,
    seconds: dur.seconds,
    milliseconds: dur.milliseconds
  }).as("milliseconds"), localTS = objToLocalTS(c4);
  let [ts, o2] = fixOffset(localTS, oPre, inst.zone);
  if (millisToAdd !== 0) {
    ts += millisToAdd;
    o2 = inst.zone.offset(ts);
  }
  return { ts, o: o2 };
}
function parseDataToDateTime(parsed, parsedZone, opts, format, text, specificOffset) {
  const { setZone, zone } = opts;
  if (parsed && Object.keys(parsed).length !== 0 || parsedZone) {
    const interpretationZone = parsedZone || zone, inst = DateTime.fromObject(parsed, {
      ...opts,
      zone: interpretationZone,
      specificOffset
    });
    return setZone ? inst : inst.setZone(zone);
  } else {
    return DateTime.invalid(
      new Invalid("unparsable", `the input "${text}" can't be parsed as ${format}`)
    );
  }
}
function toTechFormat(dt, format, allowZ = true) {
  return dt.isValid ? Formatter.create(Locale.create("en-US"), {
    allowZ,
    forceSimple: true
  }).formatDateTimeFromString(dt, format) : null;
}
function toISODate(o2, extended) {
  const longFormat = o2.c.year > 9999 || o2.c.year < 0;
  let c4 = "";
  if (longFormat && o2.c.year >= 0) c4 += "+";
  c4 += padStart(o2.c.year, longFormat ? 6 : 4);
  if (extended) {
    c4 += "-";
    c4 += padStart(o2.c.month);
    c4 += "-";
    c4 += padStart(o2.c.day);
  } else {
    c4 += padStart(o2.c.month);
    c4 += padStart(o2.c.day);
  }
  return c4;
}
function toISOTime(o2, extended, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone) {
  let c4 = padStart(o2.c.hour);
  if (extended) {
    c4 += ":";
    c4 += padStart(o2.c.minute);
    if (o2.c.millisecond !== 0 || o2.c.second !== 0 || !suppressSeconds) {
      c4 += ":";
    }
  } else {
    c4 += padStart(o2.c.minute);
  }
  if (o2.c.millisecond !== 0 || o2.c.second !== 0 || !suppressSeconds) {
    c4 += padStart(o2.c.second);
    if (o2.c.millisecond !== 0 || !suppressMilliseconds) {
      c4 += ".";
      c4 += padStart(o2.c.millisecond, 3);
    }
  }
  if (includeOffset) {
    if (o2.isOffsetFixed && o2.offset === 0 && !extendedZone) {
      c4 += "Z";
    } else if (o2.o < 0) {
      c4 += "-";
      c4 += padStart(Math.trunc(-o2.o / 60));
      c4 += ":";
      c4 += padStart(Math.trunc(-o2.o % 60));
    } else {
      c4 += "+";
      c4 += padStart(Math.trunc(o2.o / 60));
      c4 += ":";
      c4 += padStart(Math.trunc(o2.o % 60));
    }
  }
  if (extendedZone) {
    c4 += "[" + o2.zone.ianaName + "]";
  }
  return c4;
}
const defaultUnitValues = {
  month: 1,
  day: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, defaultWeekUnitValues = {
  weekNumber: 1,
  weekday: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, defaultOrdinalUnitValues = {
  ordinal: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
};
const orderedUnits = ["year", "month", "day", "hour", "minute", "second", "millisecond"], orderedWeekUnits = [
  "weekYear",
  "weekNumber",
  "weekday",
  "hour",
  "minute",
  "second",
  "millisecond"
], orderedOrdinalUnits = ["year", "ordinal", "hour", "minute", "second", "millisecond"];
function normalizeUnit(unit) {
  const normalized = {
    year: "year",
    years: "year",
    month: "month",
    months: "month",
    day: "day",
    days: "day",
    hour: "hour",
    hours: "hour",
    minute: "minute",
    minutes: "minute",
    quarter: "quarter",
    quarters: "quarter",
    second: "second",
    seconds: "second",
    millisecond: "millisecond",
    milliseconds: "millisecond",
    weekday: "weekday",
    weekdays: "weekday",
    weeknumber: "weekNumber",
    weeksnumber: "weekNumber",
    weeknumbers: "weekNumber",
    weekyear: "weekYear",
    weekyears: "weekYear",
    ordinal: "ordinal"
  }[unit.toLowerCase()];
  if (!normalized) throw new InvalidUnitError(unit);
  return normalized;
}
function normalizeUnitWithLocalWeeks(unit) {
  switch (unit.toLowerCase()) {
    case "localweekday":
    case "localweekdays":
      return "localWeekday";
    case "localweeknumber":
    case "localweeknumbers":
      return "localWeekNumber";
    case "localweekyear":
    case "localweekyears":
      return "localWeekYear";
    default:
      return normalizeUnit(unit);
  }
}
function quickDT(obj, opts) {
  const zone = normalizeZone(opts.zone, Settings.defaultZone), loc = Locale.fromObject(opts), tsNow = Settings.now();
  let ts, o2;
  if (!isUndefined(obj.year)) {
    for (const u2 of orderedUnits) {
      if (isUndefined(obj[u2])) {
        obj[u2] = defaultUnitValues[u2];
      }
    }
    const invalid = hasInvalidGregorianData(obj) || hasInvalidTimeData(obj);
    if (invalid) {
      return DateTime.invalid(invalid);
    }
    const offsetProvis = zone.offset(tsNow);
    [ts, o2] = objToTS(obj, offsetProvis, zone);
  } else {
    ts = tsNow;
  }
  return new DateTime({ ts, zone, loc, o: o2 });
}
function diffRelative(start, end, opts) {
  const round2 = isUndefined(opts.round) ? true : opts.round, format = (c4, unit) => {
    c4 = roundTo(c4, round2 || opts.calendary ? 0 : 2, true);
    const formatter = end.loc.clone(opts).relFormatter(opts);
    return formatter.format(c4, unit);
  }, differ = (unit) => {
    if (opts.calendary) {
      if (!end.hasSame(start, unit)) {
        return end.startOf(unit).diff(start.startOf(unit), unit).get(unit);
      } else return 0;
    } else {
      return end.diff(start, unit).get(unit);
    }
  };
  if (opts.unit) {
    return format(differ(opts.unit), opts.unit);
  }
  for (const unit of opts.units) {
    const count = differ(unit);
    if (Math.abs(count) >= 1) {
      return format(count, unit);
    }
  }
  return format(start > end ? -0 : 0, opts.units[opts.units.length - 1]);
}
function lastOpts(argList) {
  let opts = {}, args;
  if (argList.length > 0 && typeof argList[argList.length - 1] === "object") {
    opts = argList[argList.length - 1];
    args = Array.from(argList).slice(0, argList.length - 1);
  } else {
    args = Array.from(argList);
  }
  return [opts, args];
}
class DateTime {
  /**
   * @access private
   */
  constructor(config2) {
    const zone = config2.zone || Settings.defaultZone;
    let invalid = config2.invalid || (Number.isNaN(config2.ts) ? new Invalid("invalid input") : null) || (!zone.isValid ? unsupportedZone(zone) : null);
    this.ts = isUndefined(config2.ts) ? Settings.now() : config2.ts;
    let c4 = null, o2 = null;
    if (!invalid) {
      const unchanged = config2.old && config2.old.ts === this.ts && config2.old.zone.equals(zone);
      if (unchanged) {
        [c4, o2] = [config2.old.c, config2.old.o];
      } else {
        const ot = zone.offset(this.ts);
        c4 = tsToObj(this.ts, ot);
        invalid = Number.isNaN(c4.year) ? new Invalid("invalid input") : null;
        c4 = invalid ? null : c4;
        o2 = invalid ? null : ot;
      }
    }
    this._zone = zone;
    this.loc = config2.loc || Locale.create();
    this.invalid = invalid;
    this.weekData = null;
    this.localWeekData = null;
    this.c = c4;
    this.o = o2;
    this.isLuxonDateTime = true;
  }
  // CONSTRUCT
  /**
   * Create a DateTime for the current instant, in the system's time zone.
   *
   * Use Settings to override these default values if needed.
   * @example DateTime.now().toISO() //~> now in the ISO format
   * @return {DateTime}
   */
  static now() {
    return new DateTime({});
  }
  /**
   * Create a local DateTime
   * @param {number} [year] - The calendar year. If omitted (as in, call `local()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month, 1-indexed
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @example DateTime.local()                                  //~> now
   * @example DateTime.local({ zone: "America/New_York" })      //~> now, in US east coast time
   * @example DateTime.local(2017)                              //~> 2017-01-01T00:00:00
   * @example DateTime.local(2017, 3)                           //~> 2017-03-01T00:00:00
   * @example DateTime.local(2017, 3, 12, { locale: "fr" })     //~> 2017-03-12T00:00:00, with a French locale
   * @example DateTime.local(2017, 3, 12, 5)                    //~> 2017-03-12T05:00:00
   * @example DateTime.local(2017, 3, 12, 5, { zone: "utc" })   //~> 2017-03-12T05:00:00, in UTC
   * @example DateTime.local(2017, 3, 12, 5, 45)                //~> 2017-03-12T05:45:00
   * @example DateTime.local(2017, 3, 12, 5, 45, 10)            //~> 2017-03-12T05:45:10
   * @example DateTime.local(2017, 3, 12, 5, 45, 10, 765)       //~> 2017-03-12T05:45:10.765
   * @return {DateTime}
   */
  static local() {
    const [opts, args] = lastOpts(arguments), [year, month, day, hour, minute, second, millisecond] = args;
    return quickDT({ year, month, day, hour, minute, second, millisecond }, opts);
  }
  /**
   * Create a DateTime in UTC
   * @param {number} [year] - The calendar year. If omitted (as in, call `utc()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @param {Object} options - configuration options for the DateTime
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} [options.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [options.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @example DateTime.utc()                                              //~> now
   * @example DateTime.utc(2017)                                          //~> 2017-01-01T00:00:00Z
   * @example DateTime.utc(2017, 3)                                       //~> 2017-03-01T00:00:00Z
   * @example DateTime.utc(2017, 3, 12)                                   //~> 2017-03-12T00:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5)                                //~> 2017-03-12T05:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45)                            //~> 2017-03-12T05:45:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, { locale: "fr" })          //~> 2017-03-12T05:45:00Z with a French locale
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10)                        //~> 2017-03-12T05:45:10Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10, 765, { locale: "fr" }) //~> 2017-03-12T05:45:10.765Z with a French locale
   * @return {DateTime}
   */
  static utc() {
    const [opts, args] = lastOpts(arguments), [year, month, day, hour, minute, second, millisecond] = args;
    opts.zone = FixedOffsetZone.utcInstance;
    return quickDT({ year, month, day, hour, minute, second, millisecond }, opts);
  }
  /**
   * Create a DateTime from a JavaScript Date object. Uses the default zone.
   * @param {Date} date - a JavaScript Date object
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @return {DateTime}
   */
  static fromJSDate(date, options2 = {}) {
    const ts = isDate(date) ? date.valueOf() : NaN;
    if (Number.isNaN(ts)) {
      return DateTime.invalid("invalid input");
    }
    const zoneToUse = normalizeZone(options2.zone, Settings.defaultZone);
    if (!zoneToUse.isValid) {
      return DateTime.invalid(unsupportedZone(zoneToUse));
    }
    return new DateTime({
      ts,
      zone: zoneToUse,
      loc: Locale.fromObject(options2)
    });
  }
  /**
   * Create a DateTime from a number of milliseconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} milliseconds - a number of milliseconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromMillis(milliseconds, options2 = {}) {
    if (!isNumber(milliseconds)) {
      throw new InvalidArgumentError(
        `fromMillis requires a numerical input, but received a ${typeof milliseconds} with value ${milliseconds}`
      );
    } else if (milliseconds < -MAX_DATE || milliseconds > MAX_DATE) {
      return DateTime.invalid("Timestamp out of range");
    } else {
      return new DateTime({
        ts: milliseconds,
        zone: normalizeZone(options2.zone, Settings.defaultZone),
        loc: Locale.fromObject(options2)
      });
    }
  }
  /**
   * Create a DateTime from a number of seconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} seconds - a number of seconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromSeconds(seconds, options2 = {}) {
    if (!isNumber(seconds)) {
      throw new InvalidArgumentError("fromSeconds requires a numerical input");
    } else {
      return new DateTime({
        ts: seconds * 1e3,
        zone: normalizeZone(options2.zone, Settings.defaultZone),
        loc: Locale.fromObject(options2)
      });
    }
  }
  /**
   * Create a DateTime from a JavaScript object with keys like 'year' and 'hour' with reasonable defaults.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.year - a year, such as 1987
   * @param {number} obj.month - a month, 1-12
   * @param {number} obj.day - a day of the month, 1-31, depending on the month
   * @param {number} obj.ordinal - day of the year, 1-365 or 366
   * @param {number} obj.weekYear - an ISO week year
   * @param {number} obj.weekNumber - an ISO week number, between 1 and 52 or 53, depending on the year
   * @param {number} obj.weekday - an ISO weekday, 1-7, where 1 is Monday and 7 is Sunday
   * @param {number} obj.localWeekYear - a week year, according to the locale
   * @param {number} obj.localWeekNumber - a week number, between 1 and 52 or 53, depending on the year, according to the locale
   * @param {number} obj.localWeekday - a weekday, 1-7, where 1 is the first and 7 is the last day of the week, according to the locale
   * @param {number} obj.hour - hour of the day, 0-23
   * @param {number} obj.minute - minute of the hour, 0-59
   * @param {number} obj.second - second of the minute, 0-59
   * @param {number} obj.millisecond - millisecond of the second, 0-999
   * @param {Object} opts - options for creating this DateTime
   * @param {string|Zone} [opts.zone='local'] - interpret the numbers in the context of a particular zone. Can take any value taken as the first argument to setZone()
   * @param {string} [opts.locale='system\'s locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromObject({ year: 1982, month: 5, day: 25}).toISODate() //=> '1982-05-25'
   * @example DateTime.fromObject({ year: 1982 }).toISODate() //=> '1982-01-01'
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }) //~> today at 10:26:06
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'utc' }),
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'local' })
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'America/New_York' })
   * @example DateTime.fromObject({ weekYear: 2016, weekNumber: 2, weekday: 3 }).toISODate() //=> '2016-01-13'
   * @example DateTime.fromObject({ localWeekYear: 2022, localWeekNumber: 1, localWeekday: 1 }, { locale: "en-US" }).toISODate() //=> '2021-12-26'
   * @return {DateTime}
   */
  static fromObject(obj, opts = {}) {
    obj = obj || {};
    const zoneToUse = normalizeZone(opts.zone, Settings.defaultZone);
    if (!zoneToUse.isValid) {
      return DateTime.invalid(unsupportedZone(zoneToUse));
    }
    const loc = Locale.fromObject(opts);
    const normalized = normalizeObject(obj, normalizeUnitWithLocalWeeks);
    const { minDaysInFirstWeek, startOfWeek } = usesLocalWeekValues(normalized, loc);
    const tsNow = Settings.now(), offsetProvis = !isUndefined(opts.specificOffset) ? opts.specificOffset : zoneToUse.offset(tsNow), containsOrdinal = !isUndefined(normalized.ordinal), containsGregorYear = !isUndefined(normalized.year), containsGregorMD = !isUndefined(normalized.month) || !isUndefined(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber;
    if ((containsGregor || containsOrdinal) && definiteWeekDef) {
      throw new ConflictingSpecificationError(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    }
    if (containsGregorMD && containsOrdinal) {
      throw new ConflictingSpecificationError("Can't mix ordinal dates with month/day");
    }
    const useWeekData = definiteWeekDef || normalized.weekday && !containsGregor;
    let units, defaultValues, objNow = tsToObj(tsNow, offsetProvis);
    if (useWeekData) {
      units = orderedWeekUnits;
      defaultValues = defaultWeekUnitValues;
      objNow = gregorianToWeek(objNow, minDaysInFirstWeek, startOfWeek);
    } else if (containsOrdinal) {
      units = orderedOrdinalUnits;
      defaultValues = defaultOrdinalUnitValues;
      objNow = gregorianToOrdinal(objNow);
    } else {
      units = orderedUnits;
      defaultValues = defaultUnitValues;
    }
    let foundFirst = false;
    for (const u2 of units) {
      const v2 = normalized[u2];
      if (!isUndefined(v2)) {
        foundFirst = true;
      } else if (foundFirst) {
        normalized[u2] = defaultValues[u2];
      } else {
        normalized[u2] = objNow[u2];
      }
    }
    const higherOrderInvalid = useWeekData ? hasInvalidWeekData(normalized, minDaysInFirstWeek, startOfWeek) : containsOrdinal ? hasInvalidOrdinalData(normalized) : hasInvalidGregorianData(normalized), invalid = higherOrderInvalid || hasInvalidTimeData(normalized);
    if (invalid) {
      return DateTime.invalid(invalid);
    }
    const gregorian = useWeekData ? weekToGregorian(normalized, minDaysInFirstWeek, startOfWeek) : containsOrdinal ? ordinalToGregorian(normalized) : normalized, [tsFinal, offsetFinal] = objToTS(gregorian, offsetProvis, zoneToUse), inst = new DateTime({
      ts: tsFinal,
      zone: zoneToUse,
      o: offsetFinal,
      loc
    });
    if (normalized.weekday && containsGregor && obj.weekday !== inst.weekday) {
      return DateTime.invalid(
        "mismatched weekday",
        `you can't specify both a weekday of ${normalized.weekday} and a date of ${inst.toISO()}`
      );
    }
    return inst;
  }
  /**
   * Create a DateTime from an ISO 8601 string
   * @param {string} text - the ISO string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the time to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} [opts.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [opts.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromISO('2016-05-25T09:08:34.123')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00', {setZone: true})
   * @example DateTime.fromISO('2016-05-25T09:08:34.123', {zone: 'utc'})
   * @example DateTime.fromISO('2016-W05-4')
   * @return {DateTime}
   */
  static fromISO(text, opts = {}) {
    const [vals, parsedZone] = parseISODate(text);
    return parseDataToDateTime(vals, parsedZone, opts, "ISO 8601", text);
  }
  /**
   * Create a DateTime from an RFC 2822 string
   * @param {string} text - the RFC 2822 string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since the offset is always specified in the string itself, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23:12 GMT')
   * @example DateTime.fromRFC2822('Fri, 25 Nov 2016 13:23:12 +0600')
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23 Z')
   * @return {DateTime}
   */
  static fromRFC2822(text, opts = {}) {
    const [vals, parsedZone] = parseRFC2822Date(text);
    return parseDataToDateTime(vals, parsedZone, opts, "RFC 2822", text);
  }
  /**
   * Create a DateTime from an HTTP header date
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @param {string} text - the HTTP header date
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since HTTP dates are always in UTC, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with the fixed-offset zone specified in the string. For HTTP dates, this is always UTC, so this option is equivalent to setting the `zone` option to 'utc', but this option is included for consistency with similar methods.
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromHTTP('Sun, 06 Nov 1994 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sunday, 06-Nov-94 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sun Nov  6 08:49:37 1994')
   * @return {DateTime}
   */
  static fromHTTP(text, opts = {}) {
    const [vals, parsedZone] = parseHTTPDate(text);
    return parseDataToDateTime(vals, parsedZone, opts, "HTTP", opts);
  }
  /**
   * Create a DateTime from an input string and format string.
   * Defaults to en-US if no locale has been specified, regardless of the system's locale. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/parsing?id=table-of-tokens).
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see the link below for the formats)
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromFormat(text, fmt, opts = {}) {
    if (isUndefined(text) || isUndefined(fmt)) {
      throw new InvalidArgumentError("fromFormat requires an input string and a format");
    }
    const { locale = null, numberingSystem = null } = opts, localeToUse = Locale.fromOpts({
      locale,
      numberingSystem,
      defaultToEN: true
    }), [vals, parsedZone, specificOffset, invalid] = parseFromTokens(localeToUse, text, fmt);
    if (invalid) {
      return DateTime.invalid(invalid);
    } else {
      return parseDataToDateTime(vals, parsedZone, opts, `format ${fmt}`, text, specificOffset);
    }
  }
  /**
   * @deprecated use fromFormat instead
   */
  static fromString(text, fmt, opts = {}) {
    return DateTime.fromFormat(text, fmt, opts);
  }
  /**
   * Create a DateTime from a SQL date, time, or datetime
   * Defaults to en-US if no locale has been specified, regardless of the system's locale
   * @param {string} text - the string to parse
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @example DateTime.fromSQL('2017-05-15')
   * @example DateTime.fromSQL('2017-05-15 09:12:34')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342+06:00')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles', { setZone: true })
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342', { zone: 'America/Los_Angeles' })
   * @example DateTime.fromSQL('09:12:34.342')
   * @return {DateTime}
   */
  static fromSQL(text, opts = {}) {
    const [vals, parsedZone] = parseSQL(text);
    return parseDataToDateTime(vals, parsedZone, opts, "SQL", text);
  }
  /**
   * Create an invalid DateTime.
   * @param {string} reason - simple string of why this DateTime is invalid. Should not contain parameters or anything else data-dependent.
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {DateTime}
   */
  static invalid(reason, explanation = null) {
    if (!reason) {
      throw new InvalidArgumentError("need to specify a reason the DateTime is invalid");
    }
    const invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);
    if (Settings.throwOnInvalid) {
      throw new InvalidDateTimeError(invalid);
    } else {
      return new DateTime({ invalid });
    }
  }
  /**
   * Check if an object is an instance of DateTime. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDateTime(o2) {
    return o2 && o2.isLuxonDateTime || false;
  }
  /**
   * Produce the format string for a set of options
   * @param formatOpts
   * @param localeOpts
   * @returns {string}
   */
  static parseFormatForOpts(formatOpts, localeOpts = {}) {
    const tokenList = formatOptsToTokens(formatOpts, Locale.fromObject(localeOpts));
    return !tokenList ? null : tokenList.map((t2) => t2 ? t2.val : null).join("");
  }
  /**
   * Produce the the fully expanded format token for the locale
   * Does NOT quote characters, so quoted tokens will not round trip correctly
   * @param fmt
   * @param localeOpts
   * @returns {string}
   */
  static expandFormat(fmt, localeOpts = {}) {
    const expanded2 = expandMacroTokens(Formatter.parseFormat(fmt), Locale.fromObject(localeOpts));
    return expanded2.map((t2) => t2.val).join("");
  }
  // INFO
  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example DateTime.local(2017, 7, 4).get('month'); //=> 7
   * @example DateTime.local(2017, 7, 4).get('day'); //=> 4
   * @return {number}
   */
  get(unit) {
    return this[unit];
  }
  /**
   * Returns whether the DateTime is valid. Invalid DateTimes occur when:
   * * The DateTime was created from invalid calendar information, such as the 13th month or February 30
   * * The DateTime was created by an operation on another invalid date
   * @type {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }
  /**
   * Returns an error code if this DateTime is invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this DateTime became invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Get the locale of a DateTime, such 'en-GB'. The locale is used when formatting the DateTime
   *
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  /**
   * Get the numbering system of a DateTime, such 'beng'. The numbering system is used when formatting the DateTime
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  /**
   * Get the output calendar of a DateTime, such 'islamic'. The output calendar is used when formatting the DateTime
   *
   * @type {string}
   */
  get outputCalendar() {
    return this.isValid ? this.loc.outputCalendar : null;
  }
  /**
   * Get the time zone associated with this DateTime.
   * @type {Zone}
   */
  get zone() {
    return this._zone;
  }
  /**
   * Get the name of the time zone.
   * @type {string}
   */
  get zoneName() {
    return this.isValid ? this.zone.name : null;
  }
  /**
   * Get the year
   * @example DateTime.local(2017, 5, 25).year //=> 2017
   * @type {number}
   */
  get year() {
    return this.isValid ? this.c.year : NaN;
  }
  /**
   * Get the quarter
   * @example DateTime.local(2017, 5, 25).quarter //=> 2
   * @type {number}
   */
  get quarter() {
    return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
  }
  /**
   * Get the month (1-12).
   * @example DateTime.local(2017, 5, 25).month //=> 5
   * @type {number}
   */
  get month() {
    return this.isValid ? this.c.month : NaN;
  }
  /**
   * Get the day of the month (1-30ish).
   * @example DateTime.local(2017, 5, 25).day //=> 25
   * @type {number}
   */
  get day() {
    return this.isValid ? this.c.day : NaN;
  }
  /**
   * Get the hour of the day (0-23).
   * @example DateTime.local(2017, 5, 25, 9).hour //=> 9
   * @type {number}
   */
  get hour() {
    return this.isValid ? this.c.hour : NaN;
  }
  /**
   * Get the minute of the hour (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30).minute //=> 30
   * @type {number}
   */
  get minute() {
    return this.isValid ? this.c.minute : NaN;
  }
  /**
   * Get the second of the minute (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52).second //=> 52
   * @type {number}
   */
  get second() {
    return this.isValid ? this.c.second : NaN;
  }
  /**
   * Get the millisecond of the second (0-999).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52, 654).millisecond //=> 654
   * @type {number}
   */
  get millisecond() {
    return this.isValid ? this.c.millisecond : NaN;
  }
  /**
   * Get the week year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 12, 31).weekYear //=> 2015
   * @type {number}
   */
  get weekYear() {
    return this.isValid ? possiblyCachedWeekData(this).weekYear : NaN;
  }
  /**
   * Get the week number of the week year (1-52ish).
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2017, 5, 25).weekNumber //=> 21
   * @type {number}
   */
  get weekNumber() {
    return this.isValid ? possiblyCachedWeekData(this).weekNumber : NaN;
  }
  /**
   * Get the day of the week.
   * 1 is Monday and 7 is Sunday
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 11, 31).weekday //=> 4
   * @type {number}
   */
  get weekday() {
    return this.isValid ? possiblyCachedWeekData(this).weekday : NaN;
  }
  /**
   * Returns true if this date is on a weekend according to the locale, false otherwise
   * @returns {boolean}
   */
  get isWeekend() {
    return this.isValid && this.loc.getWeekendDays().includes(this.weekday);
  }
  /**
   * Get the day of the week according to the locale.
   * 1 is the first day of the week and 7 is the last day of the week.
   * If the locale assigns Sunday as the first day of the week, then a date which is a Sunday will return 1,
   * @returns {number}
   */
  get localWeekday() {
    return this.isValid ? possiblyCachedLocalWeekData(this).weekday : NaN;
  }
  /**
   * Get the week number of the week year according to the locale. Different locales assign week numbers differently,
   * because the week can start on different days of the week (see localWeekday) and because a different number of days
   * is required for a week to count as the first week of a year.
   * @returns {number}
   */
  get localWeekNumber() {
    return this.isValid ? possiblyCachedLocalWeekData(this).weekNumber : NaN;
  }
  /**
   * Get the week year according to the locale. Different locales assign week numbers (and therefor week years)
   * differently, see localWeekNumber.
   * @returns {number}
   */
  get localWeekYear() {
    return this.isValid ? possiblyCachedLocalWeekData(this).weekYear : NaN;
  }
  /**
   * Get the ordinal (meaning the day of the year)
   * @example DateTime.local(2017, 5, 25).ordinal //=> 145
   * @type {number|DateTime}
   */
  get ordinal() {
    return this.isValid ? gregorianToOrdinal(this.c).ordinal : NaN;
  }
  /**
   * Get the human readable short month name, such as 'Oct'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthShort //=> Oct
   * @type {string}
   */
  get monthShort() {
    return this.isValid ? Info.months("short", { locObj: this.loc })[this.month - 1] : null;
  }
  /**
   * Get the human readable long month name, such as 'October'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthLong //=> October
   * @type {string}
   */
  get monthLong() {
    return this.isValid ? Info.months("long", { locObj: this.loc })[this.month - 1] : null;
  }
  /**
   * Get the human readable short weekday, such as 'Mon'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayShort //=> Mon
   * @type {string}
   */
  get weekdayShort() {
    return this.isValid ? Info.weekdays("short", { locObj: this.loc })[this.weekday - 1] : null;
  }
  /**
   * Get the human readable long weekday, such as 'Monday'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayLong //=> Monday
   * @type {string}
   */
  get weekdayLong() {
    return this.isValid ? Info.weekdays("long", { locObj: this.loc })[this.weekday - 1] : null;
  }
  /**
   * Get the UTC offset of this DateTime in minutes
   * @example DateTime.now().offset //=> -240
   * @example DateTime.utc().offset //=> 0
   * @type {number}
   */
  get offset() {
    return this.isValid ? +this.o : NaN;
  }
  /**
   * Get the short human name for the zone's current offset, for example "EST" or "EDT".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameShort() {
    if (this.isValid) {
      return this.zone.offsetName(this.ts, {
        format: "short",
        locale: this.locale
      });
    } else {
      return null;
    }
  }
  /**
   * Get the long human name for the zone's current offset, for example "Eastern Standard Time" or "Eastern Daylight Time".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameLong() {
    if (this.isValid) {
      return this.zone.offsetName(this.ts, {
        format: "long",
        locale: this.locale
      });
    } else {
      return null;
    }
  }
  /**
   * Get whether this zone's offset ever changes, as in a DST.
   * @type {boolean}
   */
  get isOffsetFixed() {
    return this.isValid ? this.zone.isUniversal : null;
  }
  /**
   * Get whether the DateTime is in a DST.
   * @type {boolean}
   */
  get isInDST() {
    if (this.isOffsetFixed) {
      return false;
    } else {
      return this.offset > this.set({ month: 1, day: 1 }).offset || this.offset > this.set({ month: 5 }).offset;
    }
  }
  /**
   * Get those DateTimes which have the same local time as this DateTime, but a different offset from UTC
   * in this DateTime's zone. During DST changes local time can be ambiguous, for example
   * `2023-10-29T02:30:00` in `Europe/Berlin` can have offset `+01:00` or `+02:00`.
   * This method will return both possible DateTimes if this DateTime's local time is ambiguous.
   * @returns {DateTime[]}
   */
  getPossibleOffsets() {
    if (!this.isValid || this.isOffsetFixed) {
      return [this];
    }
    const dayMs = 864e5;
    const minuteMs = 6e4;
    const localTS = objToLocalTS(this.c);
    const oEarlier = this.zone.offset(localTS - dayMs);
    const oLater = this.zone.offset(localTS + dayMs);
    const o1 = this.zone.offset(localTS - oEarlier * minuteMs);
    const o2 = this.zone.offset(localTS - oLater * minuteMs);
    if (o1 === o2) {
      return [this];
    }
    const ts1 = localTS - o1 * minuteMs;
    const ts2 = localTS - o2 * minuteMs;
    const c12 = tsToObj(ts1, o1);
    const c22 = tsToObj(ts2, o2);
    if (c12.hour === c22.hour && c12.minute === c22.minute && c12.second === c22.second && c12.millisecond === c22.millisecond) {
      return [clone$1(this, { ts: ts1 }), clone$1(this, { ts: ts2 })];
    }
    return [this];
  }
  /**
   * Returns true if this DateTime is in a leap year, false otherwise
   * @example DateTime.local(2016).isInLeapYear //=> true
   * @example DateTime.local(2013).isInLeapYear //=> false
   * @type {boolean}
   */
  get isInLeapYear() {
    return isLeapYear(this.year);
  }
  /**
   * Returns the number of days in this DateTime's month
   * @example DateTime.local(2016, 2).daysInMonth //=> 29
   * @example DateTime.local(2016, 3).daysInMonth //=> 31
   * @type {number}
   */
  get daysInMonth() {
    return daysInMonth(this.year, this.month);
  }
  /**
   * Returns the number of days in this DateTime's year
   * @example DateTime.local(2016).daysInYear //=> 366
   * @example DateTime.local(2013).daysInYear //=> 365
   * @type {number}
   */
  get daysInYear() {
    return this.isValid ? daysInYear(this.year) : NaN;
  }
  /**
   * Returns the number of weeks in this DateTime's year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2004).weeksInWeekYear //=> 53
   * @example DateTime.local(2013).weeksInWeekYear //=> 52
   * @type {number}
   */
  get weeksInWeekYear() {
    return this.isValid ? weeksInWeekYear(this.weekYear) : NaN;
  }
  /**
   * Returns the number of weeks in this DateTime's local week year
   * @example DateTime.local(2020, 6, {locale: 'en-US'}).weeksInLocalWeekYear //=> 52
   * @example DateTime.local(2020, 6, {locale: 'de-DE'}).weeksInLocalWeekYear //=> 53
   * @type {number}
   */
  get weeksInLocalWeekYear() {
    return this.isValid ? weeksInWeekYear(
      this.localWeekYear,
      this.loc.getMinDaysInFirstWeek(),
      this.loc.getStartOfWeek()
    ) : NaN;
  }
  /**
   * Returns the resolved Intl options for this DateTime.
   * This is useful in understanding the behavior of formatting methods
   * @param {Object} opts - the same options as toLocaleString
   * @return {Object}
   */
  resolvedLocaleOptions(opts = {}) {
    const { locale, numberingSystem, calendar } = Formatter.create(
      this.loc.clone(opts),
      opts
    ).resolvedOptions(this);
    return { locale, numberingSystem, outputCalendar: calendar };
  }
  // TRANSFORM
  /**
   * "Set" the DateTime's zone to UTC. Returns a newly-constructed DateTime.
   *
   * Equivalent to {@link DateTime#setZone}('utc')
   * @param {number} [offset=0] - optionally, an offset from UTC in minutes
   * @param {Object} [opts={}] - options to pass to `setZone()`
   * @return {DateTime}
   */
  toUTC(offset2 = 0, opts = {}) {
    return this.setZone(FixedOffsetZone.instance(offset2), opts);
  }
  /**
   * "Set" the DateTime's zone to the host's local zone. Returns a newly-constructed DateTime.
   *
   * Equivalent to `setZone('local')`
   * @return {DateTime}
   */
  toLocal() {
    return this.setZone(Settings.defaultZone);
  }
  /**
   * "Set" the DateTime's zone to specified zone. Returns a newly-constructed DateTime.
   *
   * By default, the setter keeps the underlying time the same (as in, the same timestamp), but the new instance will report different local times and consider DSTs when making computations, as with {@link DateTime#plus}. You may wish to use {@link DateTime#toLocal} and {@link DateTime#toUTC} which provide simple convenience wrappers for commonly used zones.
   * @param {string|Zone} [zone='local'] - a zone identifier. As a string, that can be any IANA zone supported by the host environment, or a fixed-offset name of the form 'UTC+3', or the strings 'local' or 'utc'. You may also supply an instance of a {@link DateTime#Zone} class.
   * @param {Object} opts - options
   * @param {boolean} [opts.keepLocalTime=false] - If true, adjust the underlying time so that the local time stays the same, but in the target zone. You should rarely need this.
   * @return {DateTime}
   */
  setZone(zone, { keepLocalTime = false, keepCalendarTime = false } = {}) {
    zone = normalizeZone(zone, Settings.defaultZone);
    if (zone.equals(this.zone)) {
      return this;
    } else if (!zone.isValid) {
      return DateTime.invalid(unsupportedZone(zone));
    } else {
      let newTS = this.ts;
      if (keepLocalTime || keepCalendarTime) {
        const offsetGuess = zone.offset(this.ts);
        const asObj = this.toObject();
        [newTS] = objToTS(asObj, offsetGuess, zone);
      }
      return clone$1(this, { ts: newTS, zone });
    }
  }
  /**
   * "Set" the locale, numberingSystem, or outputCalendar. Returns a newly-constructed DateTime.
   * @param {Object} properties - the properties to set
   * @example DateTime.local(2017, 5, 25).reconfigure({ locale: 'en-GB' })
   * @return {DateTime}
   */
  reconfigure({ locale, numberingSystem, outputCalendar } = {}) {
    const loc = this.loc.clone({ locale, numberingSystem, outputCalendar });
    return clone$1(this, { loc });
  }
  /**
   * "Set" the locale. Returns a newly-constructed DateTime.
   * Just a convenient alias for reconfigure({ locale })
   * @example DateTime.local(2017, 5, 25).setLocale('en-GB')
   * @return {DateTime}
   */
  setLocale(locale) {
    return this.reconfigure({ locale });
  }
  /**
   * "Set" the values of specified units. Returns a newly-constructed DateTime.
   * You can only set units with this method; for "setting" metadata, see {@link DateTime#reconfigure} and {@link DateTime#setZone}.
   *
   * This method also supports setting locale-based week units, i.e. `localWeekday`, `localWeekNumber` and `localWeekYear`.
   * They cannot be mixed with ISO-week units like `weekday`.
   * @param {Object} values - a mapping of units to numbers
   * @example dt.set({ year: 2017 })
   * @example dt.set({ hour: 8, minute: 30 })
   * @example dt.set({ weekday: 5 })
   * @example dt.set({ year: 2005, ordinal: 234 })
   * @return {DateTime}
   */
  set(values2) {
    if (!this.isValid) return this;
    const normalized = normalizeObject(values2, normalizeUnitWithLocalWeeks);
    const { minDaysInFirstWeek, startOfWeek } = usesLocalWeekValues(normalized, this.loc);
    const settingWeekStuff = !isUndefined(normalized.weekYear) || !isUndefined(normalized.weekNumber) || !isUndefined(normalized.weekday), containsOrdinal = !isUndefined(normalized.ordinal), containsGregorYear = !isUndefined(normalized.year), containsGregorMD = !isUndefined(normalized.month) || !isUndefined(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber;
    if ((containsGregor || containsOrdinal) && definiteWeekDef) {
      throw new ConflictingSpecificationError(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    }
    if (containsGregorMD && containsOrdinal) {
      throw new ConflictingSpecificationError("Can't mix ordinal dates with month/day");
    }
    let mixed;
    if (settingWeekStuff) {
      mixed = weekToGregorian(
        { ...gregorianToWeek(this.c, minDaysInFirstWeek, startOfWeek), ...normalized },
        minDaysInFirstWeek,
        startOfWeek
      );
    } else if (!isUndefined(normalized.ordinal)) {
      mixed = ordinalToGregorian({ ...gregorianToOrdinal(this.c), ...normalized });
    } else {
      mixed = { ...this.toObject(), ...normalized };
      if (isUndefined(normalized.day)) {
        mixed.day = Math.min(daysInMonth(mixed.year, mixed.month), mixed.day);
      }
    }
    const [ts, o2] = objToTS(mixed, this.o, this.zone);
    return clone$1(this, { ts, o: o2 });
  }
  /**
   * Add a period of time to this DateTime and return the resulting DateTime
   *
   * Adding hours, minutes, seconds, or milliseconds increases the timestamp by the right number of milliseconds. Adding days, months, or years shifts the calendar, accounting for DSTs and leap years along the way. Thus, `dt.plus({ hours: 24 })` may result in a different time than `dt.plus({ days: 1 })` if there's a DST shift in between.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @example DateTime.now().plus(123) //~> in 123 milliseconds
   * @example DateTime.now().plus({ minutes: 15 }) //~> in 15 minutes
   * @example DateTime.now().plus({ days: 1 }) //~> this time tomorrow
   * @example DateTime.now().plus({ days: -1 }) //~> this time yesterday
   * @example DateTime.now().plus({ hours: 3, minutes: 13 }) //~> in 3 hr, 13 min
   * @example DateTime.now().plus(Duration.fromObject({ hours: 3, minutes: 13 })) //~> in 3 hr, 13 min
   * @return {DateTime}
   */
  plus(duration) {
    if (!this.isValid) return this;
    const dur = Duration.fromDurationLike(duration);
    return clone$1(this, adjustTime(this, dur));
  }
  /**
   * Subtract a period of time to this DateTime and return the resulting DateTime
   * See {@link DateTime#plus}
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   @return {DateTime}
   */
  minus(duration) {
    if (!this.isValid) return this;
    const dur = Duration.fromDurationLike(duration).negate();
    return clone$1(this, adjustTime(this, dur));
  }
  /**
   * "Set" this DateTime to the beginning of a unit of time.
   * @param {string} unit - The unit to go to the beginning of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).startOf('month').toISODate(); //=> '2014-03-01'
   * @example DateTime.local(2014, 3, 3).startOf('year').toISODate(); //=> '2014-01-01'
   * @example DateTime.local(2014, 3, 3).startOf('week').toISODate(); //=> '2014-03-03', weeks always start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('day').toISOTime(); //=> '00:00.000-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('hour').toISOTime(); //=> '05:00:00.000-05:00'
   * @return {DateTime}
   */
  startOf(unit, { useLocaleWeeks = false } = {}) {
    if (!this.isValid) return this;
    const o2 = {}, normalizedUnit = Duration.normalizeUnit(unit);
    switch (normalizedUnit) {
      case "years":
        o2.month = 1;
      case "quarters":
      case "months":
        o2.day = 1;
      case "weeks":
      case "days":
        o2.hour = 0;
      case "hours":
        o2.minute = 0;
      case "minutes":
        o2.second = 0;
      case "seconds":
        o2.millisecond = 0;
        break;
    }
    if (normalizedUnit === "weeks") {
      if (useLocaleWeeks) {
        const startOfWeek = this.loc.getStartOfWeek();
        const { weekday } = this;
        if (weekday < startOfWeek) {
          o2.weekNumber = this.weekNumber - 1;
        }
        o2.weekday = startOfWeek;
      } else {
        o2.weekday = 1;
      }
    }
    if (normalizedUnit === "quarters") {
      const q = Math.ceil(this.month / 3);
      o2.month = (q - 1) * 3 + 1;
    }
    return this.set(o2);
  }
  /**
   * "Set" this DateTime to the end (meaning the last millisecond) of a unit of time
   * @param {string} unit - The unit to go to the end of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).endOf('month').toISO(); //=> '2014-03-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('year').toISO(); //=> '2014-12-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('week').toISO(); // => '2014-03-09T23:59:59.999-05:00', weeks start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('day').toISO(); //=> '2014-03-03T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('hour').toISO(); //=> '2014-03-03T05:59:59.999-05:00'
   * @return {DateTime}
   */
  endOf(unit, opts) {
    return this.isValid ? this.plus({ [unit]: 1 }).startOf(unit, opts).minus(1) : this;
  }
  // OUTPUT
  /**
   * Returns a string representation of this DateTime formatted according to the specified format string.
   * **You may not want this.** See {@link DateTime#toLocaleString} for a more flexible formatting tool. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/formatting?id=table-of-tokens).
   * Defaults to en-US if no locale has been specified, regardless of the system's locale.
   * @param {string} fmt - the format string
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toFormat('yyyy LLL dd') //=> '2017 Apr 22'
   * @example DateTime.now().setLocale('fr').toFormat('yyyy LLL dd') //=> '2017 avr. 22'
   * @example DateTime.now().toFormat('yyyy LLL dd', { locale: "fr" }) //=> '2017 avr. 22'
   * @example DateTime.now().toFormat("HH 'hours and' mm 'minutes'") //=> '20 hours and 55 minutes'
   * @return {string}
   */
  toFormat(fmt, opts = {}) {
    return this.isValid ? Formatter.create(this.loc.redefaultToEN(opts)).formatDateTimeFromString(this, fmt) : INVALID;
  }
  /**
   * Returns a localized string representing this date. Accepts the same options as the Intl.DateTimeFormat constructor and any presets defined by Luxon, such as `DateTime.DATE_FULL` or `DateTime.TIME_SIMPLE`.
   * The exact behavior of this method is browser-specific, but in general it will return an appropriate representation
   * of the DateTime in the assigned locale.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param formatOpts {Object} - Intl.DateTimeFormat constructor options and configuration options
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toLocaleString(); //=> 4/20/2017
   * @example DateTime.now().setLocale('en-gb').toLocaleString(); //=> '20/04/2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL); //=> 'April 20, 2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL, { locale: 'fr' }); //=> '28 août 2022'
   * @example DateTime.now().toLocaleString(DateTime.TIME_SIMPLE); //=> '11:32 AM'
   * @example DateTime.now().toLocaleString(DateTime.DATETIME_SHORT); //=> '4/20/2017, 11:32 AM'
   * @example DateTime.now().toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' }); //=> 'Thursday, April 20'
   * @example DateTime.now().toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> 'Thu, Apr 20, 11:27 AM'
   * @example DateTime.now().toLocaleString({ hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }); //=> '11:32'
   * @return {string}
   */
  toLocaleString(formatOpts = DATE_SHORT, opts = {}) {
    return this.isValid ? Formatter.create(this.loc.clone(opts), formatOpts).formatDateTime(this) : INVALID;
  }
  /**
   * Returns an array of format "parts", meaning individual tokens along with metadata. This is allows callers to post-process individual sections of the formatted output.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat/formatToParts
   * @param opts {Object} - Intl.DateTimeFormat constructor options, same as `toLocaleString`.
   * @example DateTime.now().toLocaleParts(); //=> [
   *                                   //=>   { type: 'day', value: '25' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'month', value: '05' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'year', value: '1982' }
   *                                   //=> ]
   */
  toLocaleParts(opts = {}) {
    return this.isValid ? Formatter.create(this.loc.clone(opts), opts).formatDateTimeParts(this) : [];
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=false] - add the time zone format extension
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1983, 5, 25).toISO() //=> '1982-05-25T00:00:00.000Z'
   * @example DateTime.now().toISO() //=> '2017-04-22T20:47:05.335-04:00'
   * @example DateTime.now().toISO({ includeOffset: false }) //=> '2017-04-22T20:47:05.335'
   * @example DateTime.now().toISO({ format: 'basic' }) //=> '20170422T204705.335-0400'
   * @return {string}
   */
  toISO({
    format = "extended",
    suppressSeconds = false,
    suppressMilliseconds = false,
    includeOffset = true,
    extendedZone = false
  } = {}) {
    if (!this.isValid) {
      return null;
    }
    const ext = format === "extended";
    let c4 = toISODate(this, ext);
    c4 += "T";
    c4 += toISOTime(this, ext, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone);
    return c4;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's date component
   * @param {Object} opts - options
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1982, 5, 25).toISODate() //=> '1982-05-25'
   * @example DateTime.utc(1982, 5, 25).toISODate({ format: 'basic' }) //=> '19820525'
   * @return {string}
   */
  toISODate({ format = "extended" } = {}) {
    if (!this.isValid) {
      return null;
    }
    return toISODate(this, format === "extended");
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's week date
   * @example DateTime.utc(1982, 5, 25).toISOWeekDate() //=> '1982-W21-2'
   * @return {string}
   */
  toISOWeekDate() {
    return toTechFormat(this, "kkkk-'W'WW-c");
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's time component
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=true] - add the time zone format extension
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime() //=> '07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, seconds: 0, milliseconds: 0 }).toISOTime({ suppressSeconds: true }) //=> '07:34Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ format: 'basic' }) //=> '073419.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ includePrefix: true }) //=> 'T07:34:19.361Z'
   * @return {string}
   */
  toISOTime({
    suppressMilliseconds = false,
    suppressSeconds = false,
    includeOffset = true,
    includePrefix = false,
    extendedZone = false,
    format = "extended"
  } = {}) {
    if (!this.isValid) {
      return null;
    }
    let c4 = includePrefix ? "T" : "";
    return c4 + toISOTime(
      this,
      format === "extended",
      suppressSeconds,
      suppressMilliseconds,
      includeOffset,
      extendedZone
    );
  }
  /**
   * Returns an RFC 2822-compatible string representation of this DateTime
   * @example DateTime.utc(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 +0000'
   * @example DateTime.local(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 -0400'
   * @return {string}
   */
  toRFC2822() {
    return toTechFormat(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", false);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in HTTP headers. The output is always expressed in GMT.
   * Specifically, the string conforms to RFC 1123.
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @example DateTime.utc(2014, 7, 13).toHTTP() //=> 'Sun, 13 Jul 2014 00:00:00 GMT'
   * @example DateTime.utc(2014, 7, 13, 19).toHTTP() //=> 'Sun, 13 Jul 2014 19:00:00 GMT'
   * @return {string}
   */
  toHTTP() {
    return toTechFormat(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Date
   * @example DateTime.utc(2014, 7, 13).toSQLDate() //=> '2014-07-13'
   * @return {string}
   */
  toSQLDate() {
    if (!this.isValid) {
      return null;
    }
    return toISODate(this, true);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Time
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc().toSQL() //=> '05:15:16.345'
   * @example DateTime.now().toSQL() //=> '05:15:16.345 -04:00'
   * @example DateTime.now().toSQL({ includeOffset: false }) //=> '05:15:16.345'
   * @example DateTime.now().toSQL({ includeZone: false }) //=> '05:15:16.345 America/New_York'
   * @return {string}
   */
  toSQLTime({ includeOffset = true, includeZone = false, includeOffsetSpace = true } = {}) {
    let fmt = "HH:mm:ss.SSS";
    if (includeZone || includeOffset) {
      if (includeOffsetSpace) {
        fmt += " ";
      }
      if (includeZone) {
        fmt += "z";
      } else if (includeOffset) {
        fmt += "ZZ";
      }
    }
    return toTechFormat(this, fmt, true);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 Z'
   * @example DateTime.local(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 -04:00'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeOffset: false }) //=> '2014-07-13 00:00:00.000'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeZone: true }) //=> '2014-07-13 00:00:00.000 America/New_York'
   * @return {string}
   */
  toSQL(opts = {}) {
    if (!this.isValid) {
      return null;
    }
    return `${this.toSQLDate()} ${this.toSQLTime(opts)}`;
  }
  /**
   * Returns a string representation of this DateTime appropriate for debugging
   * @return {string}
   */
  toString() {
    return this.isValid ? this.toISO() : INVALID;
  }
  /**
   * Returns a string representation of this DateTime appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    if (this.isValid) {
      return `DateTime { ts: ${this.toISO()}, zone: ${this.zone.name}, locale: ${this.locale} }`;
    } else {
      return `DateTime { Invalid, reason: ${this.invalidReason} }`;
    }
  }
  /**
   * Returns the epoch milliseconds of this DateTime. Alias of {@link DateTime#toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }
  /**
   * Returns the epoch milliseconds of this DateTime.
   * @return {number}
   */
  toMillis() {
    return this.isValid ? this.ts : NaN;
  }
  /**
   * Returns the epoch seconds of this DateTime.
   * @return {number}
   */
  toSeconds() {
    return this.isValid ? this.ts / 1e3 : NaN;
  }
  /**
   * Returns the epoch seconds (as a whole number) of this DateTime.
   * @return {number}
   */
  toUnixInteger() {
    return this.isValid ? Math.floor(this.ts / 1e3) : NaN;
  }
  /**
   * Returns an ISO 8601 representation of this DateTime appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }
  /**
   * Returns a BSON serializable equivalent to this DateTime.
   * @return {Date}
   */
  toBSON() {
    return this.toJSDate();
  }
  /**
   * Returns a JavaScript object with this DateTime's year, month, day, and so on.
   * @param opts - options for generating the object
   * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
   * @example DateTime.now().toObject() //=> { year: 2017, month: 4, day: 22, hour: 20, minute: 49, second: 42, millisecond: 268 }
   * @return {Object}
   */
  toObject(opts = {}) {
    if (!this.isValid) return {};
    const base = { ...this.c };
    if (opts.includeConfig) {
      base.outputCalendar = this.outputCalendar;
      base.numberingSystem = this.loc.numberingSystem;
      base.locale = this.loc.locale;
    }
    return base;
  }
  /**
   * Returns a JavaScript Date equivalent to this DateTime.
   * @return {Date}
   */
  toJSDate() {
    return new Date(this.isValid ? this.ts : NaN);
  }
  // COMPARE
  /**
   * Return the difference between two DateTimes as a Duration.
   * @param {DateTime} otherDateTime - the DateTime to compare this one to
   * @param {string|string[]} [unit=['milliseconds']] - the unit or array of units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example
   * var i1 = DateTime.fromISO('1982-05-25T09:45'),
   *     i2 = DateTime.fromISO('1983-10-14T10:30');
   * i2.diff(i1).toObject() //=> { milliseconds: 43807500000 }
   * i2.diff(i1, 'hours').toObject() //=> { hours: 12168.75 }
   * i2.diff(i1, ['months', 'days']).toObject() //=> { months: 16, days: 19.03125 }
   * i2.diff(i1, ['months', 'days', 'hours']).toObject() //=> { months: 16, days: 19, hours: 0.75 }
   * @return {Duration}
   */
  diff(otherDateTime, unit = "milliseconds", opts = {}) {
    if (!this.isValid || !otherDateTime.isValid) {
      return Duration.invalid("created by diffing an invalid DateTime");
    }
    const durOpts = { locale: this.locale, numberingSystem: this.numberingSystem, ...opts };
    const units = maybeArray(unit).map(Duration.normalizeUnit), otherIsLater = otherDateTime.valueOf() > this.valueOf(), earlier = otherIsLater ? this : otherDateTime, later = otherIsLater ? otherDateTime : this, diffed = diff(earlier, later, units, durOpts);
    return otherIsLater ? diffed.negate() : diffed;
  }
  /**
   * Return the difference between this DateTime and right now.
   * See {@link DateTime#diff}
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units units (such as 'hours' or 'days') to include in the duration
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  diffNow(unit = "milliseconds", opts = {}) {
    return this.diff(DateTime.now(), unit, opts);
  }
  /**
   * Return an Interval spanning between this DateTime and another DateTime
   * @param {DateTime} otherDateTime - the other end point of the Interval
   * @return {Interval}
   */
  until(otherDateTime) {
    return this.isValid ? Interval.fromDateTimes(this, otherDateTime) : this;
  }
  /**
   * Return whether this DateTime is in the same unit of time as another DateTime.
   * Higher-order units must also be identical for this function to return `true`.
   * Note that time zones are **ignored** in this comparison, which compares the **local** calendar time. Use {@link DateTime#setZone} to convert one of the dates if needed.
   * @param {DateTime} otherDateTime - the other DateTime
   * @param {string} unit - the unit of time to check sameness on
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; only the locale of this DateTime is used
   * @example DateTime.now().hasSame(otherDT, 'day'); //~> true if otherDT is in the same current calendar day
   * @return {boolean}
   */
  hasSame(otherDateTime, unit, opts) {
    if (!this.isValid) return false;
    const inputMs = otherDateTime.valueOf();
    const adjustedToZone = this.setZone(otherDateTime.zone, { keepLocalTime: true });
    return adjustedToZone.startOf(unit, opts) <= inputMs && inputMs <= adjustedToZone.endOf(unit, opts);
  }
  /**
   * Equality check
   * Two DateTimes are equal if and only if they represent the same millisecond, have the same zone and location, and are both valid.
   * To compare just the millisecond values, use `+dt1 === +dt2`.
   * @param {DateTime} other - the other DateTime
   * @return {boolean}
   */
  equals(other) {
    return this.isValid && other.isValid && this.valueOf() === other.valueOf() && this.zone.equals(other.zone) && this.loc.equals(other.loc);
  }
  /**
   * Returns a string representation of a this time relative to now, such as "in two days". Can only internationalize if your
   * platform supports Intl.RelativeTimeFormat. Rounds down by default.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} [options.style="long"] - the style of units, must be "long", "short", or "narrow"
   * @param {string|string[]} options.unit - use a specific unit or array of units; if omitted, or an array, the method will pick the best unit. Use an array or one of "years", "quarters", "months", "weeks", "days", "hours", "minutes", or "seconds"
   * @param {boolean} [options.round=true] - whether to round the numbers in the output.
   * @param {number} [options.padding=0] - padding in milliseconds. This allows you to round up the result if it fits inside the threshold. Don't use in combination with {round: false} because the decimal output will include the padding.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelative() //=> "in 1 day"
   * @example DateTime.now().setLocale("es").toRelative({ days: 1 }) //=> "dentro de 1 día"
   * @example DateTime.now().plus({ days: 1 }).toRelative({ locale: "fr" }) //=> "dans 23 heures"
   * @example DateTime.now().minus({ days: 2 }).toRelative() //=> "2 days ago"
   * @example DateTime.now().minus({ days: 2 }).toRelative({ unit: "hours" }) //=> "48 hours ago"
   * @example DateTime.now().minus({ hours: 36 }).toRelative({ round: false }) //=> "1.5 days ago"
   */
  toRelative(options2 = {}) {
    if (!this.isValid) return null;
    const base = options2.base || DateTime.fromObject({}, { zone: this.zone }), padding = options2.padding ? this < base ? -options2.padding : options2.padding : 0;
    let units = ["years", "months", "days", "hours", "minutes", "seconds"];
    let unit = options2.unit;
    if (Array.isArray(options2.unit)) {
      units = options2.unit;
      unit = void 0;
    }
    return diffRelative(base, this.plus(padding), {
      ...options2,
      numeric: "always",
      units,
      unit
    });
  }
  /**
   * Returns a string representation of this date relative to today, such as "yesterday" or "next month".
   * Only internationalizes on platforms that supports Intl.RelativeTimeFormat.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.unit - use a specific unit; if omitted, the method will pick the unit. Use one of "years", "quarters", "months", "weeks", or "days"
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar() //=> "tomorrow"
   * @example DateTime.now().setLocale("es").plus({ days: 1 }).toRelative() //=> ""mañana"
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar({ locale: "fr" }) //=> "demain"
   * @example DateTime.now().minus({ days: 2 }).toRelativeCalendar() //=> "2 days ago"
   */
  toRelativeCalendar(options2 = {}) {
    if (!this.isValid) return null;
    return diffRelative(options2.base || DateTime.fromObject({}, { zone: this.zone }), this, {
      ...options2,
      numeric: "auto",
      units: ["years", "months", "days"],
      calendary: true
    });
  }
  /**
   * Return the min of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the minimum
   * @return {DateTime} the min DateTime, or undefined if called with no argument
   */
  static min(...dateTimes) {
    if (!dateTimes.every(DateTime.isDateTime)) {
      throw new InvalidArgumentError("min requires all arguments be DateTimes");
    }
    return bestBy(dateTimes, (i) => i.valueOf(), Math.min);
  }
  /**
   * Return the max of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the maximum
   * @return {DateTime} the max DateTime, or undefined if called with no argument
   */
  static max(...dateTimes) {
    if (!dateTimes.every(DateTime.isDateTime)) {
      throw new InvalidArgumentError("max requires all arguments be DateTimes");
    }
    return bestBy(dateTimes, (i) => i.valueOf(), Math.max);
  }
  // MISC
  /**
   * Explain how a string would be parsed by fromFormat()
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see description)
   * @param {Object} options - options taken by fromFormat()
   * @return {Object}
   */
  static fromFormatExplain(text, fmt, options2 = {}) {
    const { locale = null, numberingSystem = null } = options2, localeToUse = Locale.fromOpts({
      locale,
      numberingSystem,
      defaultToEN: true
    });
    return explainFromTokens(localeToUse, text, fmt);
  }
  /**
   * @deprecated use fromFormatExplain instead
   */
  static fromStringExplain(text, fmt, options2 = {}) {
    return DateTime.fromFormatExplain(text, fmt, options2);
  }
  // FORMAT PRESETS
  /**
   * {@link DateTime#toLocaleString} format like 10/14/1983
   * @type {Object}
   */
  static get DATE_SHORT() {
    return DATE_SHORT;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED() {
    return DATE_MED;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Fri, Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED_WITH_WEEKDAY() {
    return DATE_MED_WITH_WEEKDAY;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983'
   * @type {Object}
   */
  static get DATE_FULL() {
    return DATE_FULL;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Tuesday, October 14, 1983'
   * @type {Object}
   */
  static get DATE_HUGE() {
    return DATE_HUGE;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_SIMPLE() {
    return TIME_SIMPLE;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SECONDS() {
    return TIME_WITH_SECONDS;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SHORT_OFFSET() {
    return TIME_WITH_SHORT_OFFSET;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_LONG_OFFSET() {
    return TIME_WITH_LONG_OFFSET;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_SIMPLE() {
    return TIME_24_SIMPLE;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SECONDS() {
    return TIME_24_WITH_SECONDS;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 EDT', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SHORT_OFFSET() {
    return TIME_24_WITH_SHORT_OFFSET;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 Eastern Daylight Time', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_LONG_OFFSET() {
    return TIME_24_WITH_LONG_OFFSET;
  }
  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT() {
    return DATETIME_SHORT;
  }
  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT_WITH_SECONDS() {
    return DATETIME_SHORT_WITH_SECONDS;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED() {
    return DATETIME_MED;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_SECONDS() {
    return DATETIME_MED_WITH_SECONDS;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Fri, 14 Oct 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_WEEKDAY() {
    return DATETIME_MED_WITH_WEEKDAY;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL() {
    return DATETIME_FULL;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30:33 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL_WITH_SECONDS() {
    return DATETIME_FULL_WITH_SECONDS;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE() {
    return DATETIME_HUGE;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30:33 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE_WITH_SECONDS() {
    return DATETIME_HUGE_WITH_SECONDS;
  }
}
function friendlyDateTime(dateTimeish) {
  if (DateTime.isDateTime(dateTimeish)) {
    return dateTimeish;
  } else if (dateTimeish && dateTimeish.valueOf && isNumber(dateTimeish.valueOf())) {
    return DateTime.fromJSDate(dateTimeish);
  } else if (dateTimeish && typeof dateTimeish === "object") {
    return DateTime.fromObject(dateTimeish);
  } else {
    throw new InvalidArgumentError(
      `Unknown datetime argument: ${dateTimeish}, of type ${typeof dateTimeish}`
    );
  }
}
/*!
 * chartjs-adapter-luxon v1.3.1
 * https://www.chartjs.org
 * (c) 2023 chartjs-adapter-luxon Contributors
 * Released under the MIT license
 */
const FORMATS = {
  datetime: DateTime.DATETIME_MED_WITH_SECONDS,
  millisecond: "h:mm:ss.SSS a",
  second: DateTime.TIME_WITH_SECONDS,
  minute: DateTime.TIME_SIMPLE,
  hour: { hour: "numeric" },
  day: { day: "numeric", month: "short" },
  week: "DD",
  month: { month: "short", year: "numeric" },
  quarter: "'Q'q - yyyy",
  year: { year: "numeric" }
};
adapters._date.override({
  _id: "luxon",
  // DEBUG
  /**
   * @private
   */
  _create: function(time) {
    return DateTime.fromMillis(time, this.options);
  },
  init(chartOptions) {
    if (!this.options.locale) {
      this.options.locale = chartOptions.locale;
    }
  },
  formats: function() {
    return FORMATS;
  },
  parse: function(value, format) {
    const options2 = this.options;
    const type2 = typeof value;
    if (value === null || type2 === "undefined") {
      return null;
    }
    if (type2 === "number") {
      value = this._create(value);
    } else if (type2 === "string") {
      if (typeof format === "string") {
        value = DateTime.fromFormat(value, format, options2);
      } else {
        value = DateTime.fromISO(value, options2);
      }
    } else if (value instanceof Date) {
      value = DateTime.fromJSDate(value, options2);
    } else if (type2 === "object" && !(value instanceof DateTime)) {
      value = DateTime.fromObject(value, options2);
    }
    return value.isValid ? value.valueOf() : null;
  },
  format: function(time, format) {
    const datetime = this._create(time);
    return typeof format === "string" ? datetime.toFormat(format) : datetime.toLocaleString(format);
  },
  add: function(time, amount, unit) {
    const args = {};
    args[unit] = amount;
    return this._create(time).plus(args).valueOf();
  },
  diff: function(max2, min2, unit) {
    return this._create(max2).diff(this._create(min2)).as(unit).valueOf();
  },
  startOf: function(time, unit, weekday) {
    if (unit === "isoWeek") {
      weekday = Math.trunc(Math.min(Math.max(0, weekday), 6));
      const dateTime = this._create(time);
      return dateTime.minus({ days: (dateTime.weekday - weekday + 7) % 7 }).startOf("day").valueOf();
    }
    return unit ? this._create(time).startOf(unit).valueOf() : time;
  },
  endOf: function(time, unit) {
    return this._create(time).endOf(unit).valueOf();
  }
});
/*! Hammer.JS - v2.0.17-rc - 2019-12-16
 * http://naver.github.io/egjs
 *
 * Forked By Naver egjs
 * Copyright (c) hammerjs
 * Licensed under the MIT license */
function _extends() {
  _extends = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _inheritsLoose$1(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}
function _assertThisInitialized$1(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
var assign$1;
if (typeof Object.assign !== "function") {
  assign$1 = function assign2(target) {
    if (target === void 0 || target === null) {
      throw new TypeError("Cannot convert undefined or null to object");
    }
    var output = Object(target);
    for (var index2 = 1; index2 < arguments.length; index2++) {
      var source = arguments[index2];
      if (source !== void 0 && source !== null) {
        for (var nextKey in source) {
          if (source.hasOwnProperty(nextKey)) {
            output[nextKey] = source[nextKey];
          }
        }
      }
    }
    return output;
  };
} else {
  assign$1 = Object.assign;
}
var assign$1$1 = assign$1;
var VENDOR_PREFIXES = ["", "webkit", "Moz", "MS", "ms", "o"];
var TEST_ELEMENT = typeof document === "undefined" ? {
  style: {}
} : document.createElement("div");
var TYPE_FUNCTION = "function";
var round = Math.round, abs$1 = Math.abs;
var now = Date.now;
function prefixed(obj, property) {
  var prefix2;
  var prop;
  var camelProp = property[0].toUpperCase() + property.slice(1);
  var i = 0;
  while (i < VENDOR_PREFIXES.length) {
    prefix2 = VENDOR_PREFIXES[i];
    prop = prefix2 ? prefix2 + camelProp : property;
    if (prop in obj) {
      return prop;
    }
    i++;
  }
  return void 0;
}
var win;
if (typeof window === "undefined") {
  win = {};
} else {
  win = window;
}
var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, "touchAction");
var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== void 0;
function getTouchActionProps() {
  if (!NATIVE_TOUCH_ACTION) {
    return false;
  }
  var touchMap = {};
  var cssSupports = win.CSS && win.CSS.supports;
  ["auto", "manipulation", "pan-y", "pan-x", "pan-x pan-y", "none"].forEach(function(val) {
    return touchMap[val] = cssSupports ? win.CSS.supports("touch-action", val) : true;
  });
  return touchMap;
}
var TOUCH_ACTION_COMPUTE = "compute";
var TOUCH_ACTION_AUTO = "auto";
var TOUCH_ACTION_MANIPULATION = "manipulation";
var TOUCH_ACTION_NONE = "none";
var TOUCH_ACTION_PAN_X = "pan-x";
var TOUCH_ACTION_PAN_Y = "pan-y";
var TOUCH_ACTION_MAP = getTouchActionProps();
var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;
var SUPPORT_TOUCH = "ontouchstart" in win;
var SUPPORT_POINTER_EVENTS = prefixed(win, "PointerEvent") !== void 0;
var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);
var INPUT_TYPE_TOUCH = "touch";
var INPUT_TYPE_PEN = "pen";
var INPUT_TYPE_MOUSE = "mouse";
var INPUT_TYPE_KINECT = "kinect";
var COMPUTE_INTERVAL = 25;
var INPUT_START = 1;
var INPUT_MOVE = 2;
var INPUT_END = 4;
var INPUT_CANCEL = 8;
var DIRECTION_NONE = 1;
var DIRECTION_LEFT = 2;
var DIRECTION_RIGHT = 4;
var DIRECTION_UP = 8;
var DIRECTION_DOWN = 16;
var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;
var PROPS_XY = ["x", "y"];
var PROPS_CLIENT_XY = ["clientX", "clientY"];
function each(obj, iterator, context) {
  var i;
  if (!obj) {
    return;
  }
  if (obj.forEach) {
    obj.forEach(iterator, context);
  } else if (obj.length !== void 0) {
    i = 0;
    while (i < obj.length) {
      iterator.call(context, obj[i], i, obj);
      i++;
    }
  } else {
    for (i in obj) {
      obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
    }
  }
}
function boolOrFn(val, args) {
  if (typeof val === TYPE_FUNCTION) {
    return val.apply(args ? args[0] || void 0 : void 0, args);
  }
  return val;
}
function inStr(str, find) {
  return str.indexOf(find) > -1;
}
function cleanTouchActions(actions) {
  if (inStr(actions, TOUCH_ACTION_NONE)) {
    return TOUCH_ACTION_NONE;
  }
  var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
  var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);
  if (hasPanX && hasPanY) {
    return TOUCH_ACTION_NONE;
  }
  if (hasPanX || hasPanY) {
    return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
  }
  if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
    return TOUCH_ACTION_MANIPULATION;
  }
  return TOUCH_ACTION_AUTO;
}
var TouchAction = /* @__PURE__ */ function() {
  function TouchAction2(manager, value) {
    this.manager = manager;
    this.set(value);
  }
  var _proto = TouchAction2.prototype;
  _proto.set = function set2(value) {
    if (value === TOUCH_ACTION_COMPUTE) {
      value = this.compute();
    }
    if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
      this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
    }
    this.actions = value.toLowerCase().trim();
  };
  _proto.update = function update() {
    this.set(this.manager.options.touchAction);
  };
  _proto.compute = function compute() {
    var actions = [];
    each(this.manager.recognizers, function(recognizer) {
      if (boolOrFn(recognizer.options.enable, [recognizer])) {
        actions = actions.concat(recognizer.getTouchAction());
      }
    });
    return cleanTouchActions(actions.join(" "));
  };
  _proto.preventDefaults = function preventDefaults(input) {
    var srcEvent = input.srcEvent;
    var direction = input.offsetDirection;
    if (this.manager.session.prevented) {
      srcEvent.preventDefault();
      return;
    }
    var actions = this.actions;
    var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];
    if (hasNone) {
      var isTapPointer = input.pointers.length === 1;
      var isTapMovement = input.distance < 2;
      var isTapTouchTime = input.deltaTime < 250;
      if (isTapPointer && isTapMovement && isTapTouchTime) {
        return;
      }
    }
    if (hasPanX && hasPanY) {
      return;
    }
    if (hasNone || hasPanY && direction & DIRECTION_HORIZONTAL || hasPanX && direction & DIRECTION_VERTICAL) {
      return this.preventSrc(srcEvent);
    }
  };
  _proto.preventSrc = function preventSrc(srcEvent) {
    this.manager.session.prevented = true;
    srcEvent.preventDefault();
  };
  return TouchAction2;
}();
function hasParent(node2, parent) {
  while (node2) {
    if (node2 === parent) {
      return true;
    }
    node2 = node2.parentNode;
  }
  return false;
}
function getCenter$1(pointers) {
  var pointersLength = pointers.length;
  if (pointersLength === 1) {
    return {
      x: round(pointers[0].clientX),
      y: round(pointers[0].clientY)
    };
  }
  var x2 = 0;
  var y2 = 0;
  var i = 0;
  while (i < pointersLength) {
    x2 += pointers[i].clientX;
    y2 += pointers[i].clientY;
    i++;
  }
  return {
    x: round(x2 / pointersLength),
    y: round(y2 / pointersLength)
  };
}
function simpleCloneInputData(input) {
  var pointers = [];
  var i = 0;
  while (i < input.pointers.length) {
    pointers[i] = {
      clientX: round(input.pointers[i].clientX),
      clientY: round(input.pointers[i].clientY)
    };
    i++;
  }
  return {
    timeStamp: now(),
    pointers,
    center: getCenter$1(pointers),
    deltaX: input.deltaX,
    deltaY: input.deltaY
  };
}
function getDistance(p1, p2, props) {
  if (!props) {
    props = PROPS_XY;
  }
  var x2 = p2[props[0]] - p1[props[0]];
  var y2 = p2[props[1]] - p1[props[1]];
  return Math.sqrt(x2 * x2 + y2 * y2);
}
function getAngle(p1, p2, props) {
  if (!props) {
    props = PROPS_XY;
  }
  var x2 = p2[props[0]] - p1[props[0]];
  var y2 = p2[props[1]] - p1[props[1]];
  return Math.atan2(y2, x2) * 180 / Math.PI;
}
function getDirection(x2, y2) {
  if (x2 === y2) {
    return DIRECTION_NONE;
  }
  if (abs$1(x2) >= abs$1(y2)) {
    return x2 < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
  }
  return y2 < 0 ? DIRECTION_UP : DIRECTION_DOWN;
}
function computeDeltaXY(session, input) {
  var center = input.center;
  var offset2 = session.offsetDelta || {};
  var prevDelta = session.prevDelta || {};
  var prevInput = session.prevInput || {};
  if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
    prevDelta = session.prevDelta = {
      x: prevInput.deltaX || 0,
      y: prevInput.deltaY || 0
    };
    offset2 = session.offsetDelta = {
      x: center.x,
      y: center.y
    };
  }
  input.deltaX = prevDelta.x + (center.x - offset2.x);
  input.deltaY = prevDelta.y + (center.y - offset2.y);
}
function getVelocity(deltaTime, x2, y2) {
  return {
    x: x2 / deltaTime || 0,
    y: y2 / deltaTime || 0
  };
}
function getScale(start, end) {
  return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
}
function getRotation(start, end) {
  return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
}
function computeIntervalInputData(session, input) {
  var last2 = session.lastInterval || input;
  var deltaTime = input.timeStamp - last2.timeStamp;
  var velocity;
  var velocityX;
  var velocityY;
  var direction;
  if (input.eventType !== INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last2.velocity === void 0)) {
    var deltaX = input.deltaX - last2.deltaX;
    var deltaY = input.deltaY - last2.deltaY;
    var v2 = getVelocity(deltaTime, deltaX, deltaY);
    velocityX = v2.x;
    velocityY = v2.y;
    velocity = abs$1(v2.x) > abs$1(v2.y) ? v2.x : v2.y;
    direction = getDirection(deltaX, deltaY);
    session.lastInterval = input;
  } else {
    velocity = last2.velocity;
    velocityX = last2.velocityX;
    velocityY = last2.velocityY;
    direction = last2.direction;
  }
  input.velocity = velocity;
  input.velocityX = velocityX;
  input.velocityY = velocityY;
  input.direction = direction;
}
function computeInputData(manager, input) {
  var session = manager.session;
  var pointers = input.pointers;
  var pointersLength = pointers.length;
  if (!session.firstInput) {
    session.firstInput = simpleCloneInputData(input);
  }
  if (pointersLength > 1 && !session.firstMultiple) {
    session.firstMultiple = simpleCloneInputData(input);
  } else if (pointersLength === 1) {
    session.firstMultiple = false;
  }
  var firstInput = session.firstInput, firstMultiple = session.firstMultiple;
  var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;
  var center = input.center = getCenter$1(pointers);
  input.timeStamp = now();
  input.deltaTime = input.timeStamp - firstInput.timeStamp;
  input.angle = getAngle(offsetCenter, center);
  input.distance = getDistance(offsetCenter, center);
  computeDeltaXY(session, input);
  input.offsetDirection = getDirection(input.deltaX, input.deltaY);
  var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
  input.overallVelocityX = overallVelocity.x;
  input.overallVelocityY = overallVelocity.y;
  input.overallVelocity = abs$1(overallVelocity.x) > abs$1(overallVelocity.y) ? overallVelocity.x : overallVelocity.y;
  input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
  input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;
  input.maxPointers = !session.prevInput ? input.pointers.length : input.pointers.length > session.prevInput.maxPointers ? input.pointers.length : session.prevInput.maxPointers;
  computeIntervalInputData(session, input);
  var target = manager.element;
  var srcEvent = input.srcEvent;
  var srcEventTarget;
  if (srcEvent.composedPath) {
    srcEventTarget = srcEvent.composedPath()[0];
  } else if (srcEvent.path) {
    srcEventTarget = srcEvent.path[0];
  } else {
    srcEventTarget = srcEvent.target;
  }
  if (hasParent(srcEventTarget, target)) {
    target = srcEventTarget;
  }
  input.target = target;
}
function inputHandler(manager, eventType, input) {
  var pointersLen = input.pointers.length;
  var changedPointersLen = input.changedPointers.length;
  var isFirst = eventType & INPUT_START && pointersLen - changedPointersLen === 0;
  var isFinal = eventType & (INPUT_END | INPUT_CANCEL) && pointersLen - changedPointersLen === 0;
  input.isFirst = !!isFirst;
  input.isFinal = !!isFinal;
  if (isFirst) {
    manager.session = {};
  }
  input.eventType = eventType;
  computeInputData(manager, input);
  manager.emit("hammer.input", input);
  manager.recognize(input);
  manager.session.prevInput = input;
}
function splitStr(str) {
  return str.trim().split(/\s+/g);
}
function addEventListeners(target, types, handler) {
  each(splitStr(types), function(type2) {
    target.addEventListener(type2, handler, false);
  });
}
function removeEventListeners(target, types, handler) {
  each(splitStr(types), function(type2) {
    target.removeEventListener(type2, handler, false);
  });
}
function getWindowForElement(element) {
  var doc = element.ownerDocument || element;
  return doc.defaultView || doc.parentWindow || window;
}
var Input$2 = /* @__PURE__ */ function() {
  function Input3(manager, callback2) {
    var self2 = this;
    this.manager = manager;
    this.callback = callback2;
    this.element = manager.element;
    this.target = manager.options.inputTarget;
    this.domHandler = function(ev) {
      if (boolOrFn(manager.options.enable, [manager])) {
        self2.handler(ev);
      }
    };
    this.init();
  }
  var _proto = Input3.prototype;
  _proto.handler = function handler() {
  };
  _proto.init = function init() {
    this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
    this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
    this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
  };
  _proto.destroy = function destroy() {
    this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
    this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
    this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
  };
  return Input3;
}();
function inArray(src2, find, findByKey) {
  if (src2.indexOf && !findByKey) {
    return src2.indexOf(find);
  } else {
    var i = 0;
    while (i < src2.length) {
      if (findByKey && src2[i][findByKey] == find || !findByKey && src2[i] === find) {
        return i;
      }
      i++;
    }
    return -1;
  }
}
var POINTER_INPUT_MAP = {
  pointerdown: INPUT_START,
  pointermove: INPUT_MOVE,
  pointerup: INPUT_END,
  pointercancel: INPUT_CANCEL,
  pointerout: INPUT_CANCEL
};
var IE10_POINTER_TYPE_ENUM = {
  2: INPUT_TYPE_TOUCH,
  3: INPUT_TYPE_PEN,
  4: INPUT_TYPE_MOUSE,
  5: INPUT_TYPE_KINECT
  // see https://twitter.com/jacobrossi/status/480596438489890816
};
var POINTER_ELEMENT_EVENTS = "pointerdown";
var POINTER_WINDOW_EVENTS = "pointermove pointerup pointercancel";
if (win.MSPointerEvent && !win.PointerEvent) {
  POINTER_ELEMENT_EVENTS = "MSPointerDown";
  POINTER_WINDOW_EVENTS = "MSPointerMove MSPointerUp MSPointerCancel";
}
var PointerEventInput = /* @__PURE__ */ function(_Input) {
  _inheritsLoose$1(PointerEventInput2, _Input);
  function PointerEventInput2() {
    var _this;
    var proto = PointerEventInput2.prototype;
    proto.evEl = POINTER_ELEMENT_EVENTS;
    proto.evWin = POINTER_WINDOW_EVENTS;
    _this = _Input.apply(this, arguments) || this;
    _this.store = _this.manager.session.pointerEvents = [];
    return _this;
  }
  var _proto = PointerEventInput2.prototype;
  _proto.handler = function handler(ev) {
    var store = this.store;
    var removePointer = false;
    var eventTypeNormalized = ev.type.toLowerCase().replace("ms", "");
    var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
    var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;
    var isTouch = pointerType === INPUT_TYPE_TOUCH;
    var storeIndex = inArray(store, ev.pointerId, "pointerId");
    if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
      if (storeIndex < 0) {
        store.push(ev);
        storeIndex = store.length - 1;
      }
    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
      removePointer = true;
    }
    if (storeIndex < 0) {
      return;
    }
    store[storeIndex] = ev;
    this.callback(this.manager, eventType, {
      pointers: store,
      changedPointers: [ev],
      pointerType,
      srcEvent: ev
    });
    if (removePointer) {
      store.splice(storeIndex, 1);
    }
  };
  return PointerEventInput2;
}(Input$2);
function toArray(obj) {
  return Array.prototype.slice.call(obj, 0);
}
function uniqueArray(src2, key, sort) {
  var results = [];
  var values2 = [];
  var i = 0;
  while (i < src2.length) {
    var val = key ? src2[i][key] : src2[i];
    if (inArray(values2, val) < 0) {
      results.push(src2[i]);
    }
    values2[i] = val;
    i++;
  }
  if (sort) {
    if (!key) {
      results = results.sort();
    } else {
      results = results.sort(function(a2, b2) {
        return a2[key] > b2[key];
      });
    }
  }
  return results;
}
var TOUCH_INPUT_MAP = {
  touchstart: INPUT_START,
  touchmove: INPUT_MOVE,
  touchend: INPUT_END,
  touchcancel: INPUT_CANCEL
};
var TOUCH_TARGET_EVENTS = "touchstart touchmove touchend touchcancel";
var TouchInput = /* @__PURE__ */ function(_Input) {
  _inheritsLoose$1(TouchInput2, _Input);
  function TouchInput2() {
    var _this;
    TouchInput2.prototype.evTarget = TOUCH_TARGET_EVENTS;
    _this = _Input.apply(this, arguments) || this;
    _this.targetIds = {};
    return _this;
  }
  var _proto = TouchInput2.prototype;
  _proto.handler = function handler(ev) {
    var type2 = TOUCH_INPUT_MAP[ev.type];
    var touches = getTouches.call(this, ev, type2);
    if (!touches) {
      return;
    }
    this.callback(this.manager, type2, {
      pointers: touches[0],
      changedPointers: touches[1],
      pointerType: INPUT_TYPE_TOUCH,
      srcEvent: ev
    });
  };
  return TouchInput2;
}(Input$2);
function getTouches(ev, type2) {
  var allTouches = toArray(ev.touches);
  var targetIds = this.targetIds;
  if (type2 & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
    targetIds[allTouches[0].identifier] = true;
    return [allTouches, allTouches];
  }
  var i;
  var targetTouches;
  var changedTouches = toArray(ev.changedTouches);
  var changedTargetTouches = [];
  var target = this.target;
  targetTouches = allTouches.filter(function(touch) {
    return hasParent(touch.target, target);
  });
  if (type2 === INPUT_START) {
    i = 0;
    while (i < targetTouches.length) {
      targetIds[targetTouches[i].identifier] = true;
      i++;
    }
  }
  i = 0;
  while (i < changedTouches.length) {
    if (targetIds[changedTouches[i].identifier]) {
      changedTargetTouches.push(changedTouches[i]);
    }
    if (type2 & (INPUT_END | INPUT_CANCEL)) {
      delete targetIds[changedTouches[i].identifier];
    }
    i++;
  }
  if (!changedTargetTouches.length) {
    return;
  }
  return [
    // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
    uniqueArray(targetTouches.concat(changedTargetTouches), "identifier", true),
    changedTargetTouches
  ];
}
var MOUSE_INPUT_MAP = {
  mousedown: INPUT_START,
  mousemove: INPUT_MOVE,
  mouseup: INPUT_END
};
var MOUSE_ELEMENT_EVENTS = "mousedown";
var MOUSE_WINDOW_EVENTS = "mousemove mouseup";
var MouseInput = /* @__PURE__ */ function(_Input) {
  _inheritsLoose$1(MouseInput2, _Input);
  function MouseInput2() {
    var _this;
    var proto = MouseInput2.prototype;
    proto.evEl = MOUSE_ELEMENT_EVENTS;
    proto.evWin = MOUSE_WINDOW_EVENTS;
    _this = _Input.apply(this, arguments) || this;
    _this.pressed = false;
    return _this;
  }
  var _proto = MouseInput2.prototype;
  _proto.handler = function handler(ev) {
    var eventType = MOUSE_INPUT_MAP[ev.type];
    if (eventType & INPUT_START && ev.button === 0) {
      this.pressed = true;
    }
    if (eventType & INPUT_MOVE && ev.which !== 1) {
      eventType = INPUT_END;
    }
    if (!this.pressed) {
      return;
    }
    if (eventType & INPUT_END) {
      this.pressed = false;
    }
    this.callback(this.manager, eventType, {
      pointers: [ev],
      changedPointers: [ev],
      pointerType: INPUT_TYPE_MOUSE,
      srcEvent: ev
    });
  };
  return MouseInput2;
}(Input$2);
var DEDUP_TIMEOUT = 2500;
var DEDUP_DISTANCE = 25;
function setLastTouch(eventData) {
  var _eventData$changedPoi = eventData.changedPointers, touch = _eventData$changedPoi[0];
  if (touch.identifier === this.primaryTouch) {
    var lastTouch = {
      x: touch.clientX,
      y: touch.clientY
    };
    var lts = this.lastTouches;
    this.lastTouches.push(lastTouch);
    var removeLastTouch = function removeLastTouch2() {
      var i = lts.indexOf(lastTouch);
      if (i > -1) {
        lts.splice(i, 1);
      }
    };
    setTimeout(removeLastTouch, DEDUP_TIMEOUT);
  }
}
function recordTouches(eventType, eventData) {
  if (eventType & INPUT_START) {
    this.primaryTouch = eventData.changedPointers[0].identifier;
    setLastTouch.call(this, eventData);
  } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
    setLastTouch.call(this, eventData);
  }
}
function isSyntheticEvent(eventData) {
  var x2 = eventData.srcEvent.clientX;
  var y2 = eventData.srcEvent.clientY;
  for (var i = 0; i < this.lastTouches.length; i++) {
    var t2 = this.lastTouches[i];
    var dx = Math.abs(x2 - t2.x);
    var dy = Math.abs(y2 - t2.y);
    if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
      return true;
    }
  }
  return false;
}
var TouchMouseInput = /* @__PURE__ */ function() {
  var TouchMouseInput2 = /* @__PURE__ */ function(_Input) {
    _inheritsLoose$1(TouchMouseInput3, _Input);
    function TouchMouseInput3(_manager, callback2) {
      var _this;
      _this = _Input.call(this, _manager, callback2) || this;
      _this.handler = function(manager, inputEvent, inputData) {
        var isTouch = inputData.pointerType === INPUT_TYPE_TOUCH;
        var isMouse = inputData.pointerType === INPUT_TYPE_MOUSE;
        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
          return;
        }
        if (isTouch) {
          recordTouches.call(_assertThisInitialized$1(_assertThisInitialized$1(_this)), inputEvent, inputData);
        } else if (isMouse && isSyntheticEvent.call(_assertThisInitialized$1(_assertThisInitialized$1(_this)), inputData)) {
          return;
        }
        _this.callback(manager, inputEvent, inputData);
      };
      _this.touch = new TouchInput(_this.manager, _this.handler);
      _this.mouse = new MouseInput(_this.manager, _this.handler);
      _this.primaryTouch = null;
      _this.lastTouches = [];
      return _this;
    }
    var _proto = TouchMouseInput3.prototype;
    _proto.destroy = function destroy() {
      this.touch.destroy();
      this.mouse.destroy();
    };
    return TouchMouseInput3;
  }(Input$2);
  return TouchMouseInput2;
}();
function createInputInstance(manager) {
  var Type2;
  var inputClass = manager.options.inputClass;
  if (inputClass) {
    Type2 = inputClass;
  } else if (SUPPORT_POINTER_EVENTS) {
    Type2 = PointerEventInput;
  } else if (SUPPORT_ONLY_TOUCH) {
    Type2 = TouchInput;
  } else if (!SUPPORT_TOUCH) {
    Type2 = MouseInput;
  } else {
    Type2 = TouchMouseInput;
  }
  return new Type2(manager, inputHandler);
}
function invokeArrayArg(arg, fn, context) {
  if (Array.isArray(arg)) {
    each(arg, context[fn], context);
    return true;
  }
  return false;
}
var STATE_POSSIBLE = 1;
var STATE_BEGAN = 2;
var STATE_CHANGED = 4;
var STATE_ENDED = 8;
var STATE_RECOGNIZED = STATE_ENDED;
var STATE_CANCELLED = 16;
var STATE_FAILED = 32;
var _uniqueId = 1;
function uniqueId() {
  return _uniqueId++;
}
function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
  var manager = recognizer.manager;
  if (manager) {
    return manager.get(otherRecognizer);
  }
  return otherRecognizer;
}
function stateStr(state) {
  if (state & STATE_CANCELLED) {
    return "cancel";
  } else if (state & STATE_ENDED) {
    return "end";
  } else if (state & STATE_CHANGED) {
    return "move";
  } else if (state & STATE_BEGAN) {
    return "start";
  }
  return "";
}
var Recognizer = /* @__PURE__ */ function() {
  function Recognizer2(options2) {
    if (options2 === void 0) {
      options2 = {};
    }
    this.options = _extends({
      enable: true
    }, options2);
    this.id = uniqueId();
    this.manager = null;
    this.state = STATE_POSSIBLE;
    this.simultaneous = {};
    this.requireFail = [];
  }
  var _proto = Recognizer2.prototype;
  _proto.set = function set2(options2) {
    assign$1$1(this.options, options2);
    this.manager && this.manager.touchAction.update();
    return this;
  };
  _proto.recognizeWith = function recognizeWith(otherRecognizer) {
    if (invokeArrayArg(otherRecognizer, "recognizeWith", this)) {
      return this;
    }
    var simultaneous = this.simultaneous;
    otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
    if (!simultaneous[otherRecognizer.id]) {
      simultaneous[otherRecognizer.id] = otherRecognizer;
      otherRecognizer.recognizeWith(this);
    }
    return this;
  };
  _proto.dropRecognizeWith = function dropRecognizeWith(otherRecognizer) {
    if (invokeArrayArg(otherRecognizer, "dropRecognizeWith", this)) {
      return this;
    }
    otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
    delete this.simultaneous[otherRecognizer.id];
    return this;
  };
  _proto.requireFailure = function requireFailure(otherRecognizer) {
    if (invokeArrayArg(otherRecognizer, "requireFailure", this)) {
      return this;
    }
    var requireFail = this.requireFail;
    otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
    if (inArray(requireFail, otherRecognizer) === -1) {
      requireFail.push(otherRecognizer);
      otherRecognizer.requireFailure(this);
    }
    return this;
  };
  _proto.dropRequireFailure = function dropRequireFailure(otherRecognizer) {
    if (invokeArrayArg(otherRecognizer, "dropRequireFailure", this)) {
      return this;
    }
    otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
    var index2 = inArray(this.requireFail, otherRecognizer);
    if (index2 > -1) {
      this.requireFail.splice(index2, 1);
    }
    return this;
  };
  _proto.hasRequireFailures = function hasRequireFailures() {
    return this.requireFail.length > 0;
  };
  _proto.canRecognizeWith = function canRecognizeWith(otherRecognizer) {
    return !!this.simultaneous[otherRecognizer.id];
  };
  _proto.emit = function emit(input) {
    var self2 = this;
    var state = this.state;
    function emit2(event) {
      self2.manager.emit(event, input);
    }
    if (state < STATE_ENDED) {
      emit2(self2.options.event + stateStr(state));
    }
    emit2(self2.options.event);
    if (input.additionalEvent) {
      emit2(input.additionalEvent);
    }
    if (state >= STATE_ENDED) {
      emit2(self2.options.event + stateStr(state));
    }
  };
  _proto.tryEmit = function tryEmit(input) {
    if (this.canEmit()) {
      return this.emit(input);
    }
    this.state = STATE_FAILED;
  };
  _proto.canEmit = function canEmit() {
    var i = 0;
    while (i < this.requireFail.length) {
      if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
        return false;
      }
      i++;
    }
    return true;
  };
  _proto.recognize = function recognize(inputData) {
    var inputDataClone = assign$1$1({}, inputData);
    if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
      this.reset();
      this.state = STATE_FAILED;
      return;
    }
    if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
      this.state = STATE_POSSIBLE;
    }
    this.state = this.process(inputDataClone);
    if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
      this.tryEmit(inputDataClone);
    }
  };
  _proto.process = function process2(inputData) {
  };
  _proto.getTouchAction = function getTouchAction() {
  };
  _proto.reset = function reset() {
  };
  return Recognizer2;
}();
var TapRecognizer = /* @__PURE__ */ function(_Recognizer) {
  _inheritsLoose$1(TapRecognizer2, _Recognizer);
  function TapRecognizer2(options2) {
    var _this;
    if (options2 === void 0) {
      options2 = {};
    }
    _this = _Recognizer.call(this, _extends({
      event: "tap",
      pointers: 1,
      taps: 1,
      interval: 300,
      // max time between the multi-tap taps
      time: 250,
      // max time of the pointer to be down (like finger on the screen)
      threshold: 9,
      // a minimal movement is ok, but keep it low
      posThreshold: 10
    }, options2)) || this;
    _this.pTime = false;
    _this.pCenter = false;
    _this._timer = null;
    _this._input = null;
    _this.count = 0;
    return _this;
  }
  var _proto = TapRecognizer2.prototype;
  _proto.getTouchAction = function getTouchAction() {
    return [TOUCH_ACTION_MANIPULATION];
  };
  _proto.process = function process2(input) {
    var _this2 = this;
    var options2 = this.options;
    var validPointers = input.pointers.length === options2.pointers;
    var validMovement = input.distance < options2.threshold;
    var validTouchTime = input.deltaTime < options2.time;
    this.reset();
    if (input.eventType & INPUT_START && this.count === 0) {
      return this.failTimeout();
    }
    if (validMovement && validTouchTime && validPointers) {
      if (input.eventType !== INPUT_END) {
        return this.failTimeout();
      }
      var validInterval = this.pTime ? input.timeStamp - this.pTime < options2.interval : true;
      var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options2.posThreshold;
      this.pTime = input.timeStamp;
      this.pCenter = input.center;
      if (!validMultiTap || !validInterval) {
        this.count = 1;
      } else {
        this.count += 1;
      }
      this._input = input;
      var tapCount = this.count % options2.taps;
      if (tapCount === 0) {
        if (!this.hasRequireFailures()) {
          return STATE_RECOGNIZED;
        } else {
          this._timer = setTimeout(function() {
            _this2.state = STATE_RECOGNIZED;
            _this2.tryEmit();
          }, options2.interval);
          return STATE_BEGAN;
        }
      }
    }
    return STATE_FAILED;
  };
  _proto.failTimeout = function failTimeout() {
    var _this3 = this;
    this._timer = setTimeout(function() {
      _this3.state = STATE_FAILED;
    }, this.options.interval);
    return STATE_FAILED;
  };
  _proto.reset = function reset() {
    clearTimeout(this._timer);
  };
  _proto.emit = function emit() {
    if (this.state === STATE_RECOGNIZED) {
      this._input.tapCount = this.count;
      this.manager.emit(this.options.event, this._input);
    }
  };
  return TapRecognizer2;
}(Recognizer);
var AttrRecognizer = /* @__PURE__ */ function(_Recognizer) {
  _inheritsLoose$1(AttrRecognizer2, _Recognizer);
  function AttrRecognizer2(options2) {
    if (options2 === void 0) {
      options2 = {};
    }
    return _Recognizer.call(this, _extends({
      pointers: 1
    }, options2)) || this;
  }
  var _proto = AttrRecognizer2.prototype;
  _proto.attrTest = function attrTest(input) {
    var optionPointers = this.options.pointers;
    return optionPointers === 0 || input.pointers.length === optionPointers;
  };
  _proto.process = function process2(input) {
    var state = this.state;
    var eventType = input.eventType;
    var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
    var isValid = this.attrTest(input);
    if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
      return state | STATE_CANCELLED;
    } else if (isRecognized || isValid) {
      if (eventType & INPUT_END) {
        return state | STATE_ENDED;
      } else if (!(state & STATE_BEGAN)) {
        return STATE_BEGAN;
      }
      return state | STATE_CHANGED;
    }
    return STATE_FAILED;
  };
  return AttrRecognizer2;
}(Recognizer);
function directionStr(direction) {
  if (direction === DIRECTION_DOWN) {
    return "down";
  } else if (direction === DIRECTION_UP) {
    return "up";
  } else if (direction === DIRECTION_LEFT) {
    return "left";
  } else if (direction === DIRECTION_RIGHT) {
    return "right";
  }
  return "";
}
var PanRecognizer = /* @__PURE__ */ function(_AttrRecognizer) {
  _inheritsLoose$1(PanRecognizer2, _AttrRecognizer);
  function PanRecognizer2(options2) {
    var _this;
    if (options2 === void 0) {
      options2 = {};
    }
    _this = _AttrRecognizer.call(this, _extends({
      event: "pan",
      threshold: 10,
      pointers: 1,
      direction: DIRECTION_ALL
    }, options2)) || this;
    _this.pX = null;
    _this.pY = null;
    return _this;
  }
  var _proto = PanRecognizer2.prototype;
  _proto.getTouchAction = function getTouchAction() {
    var direction = this.options.direction;
    var actions = [];
    if (direction & DIRECTION_HORIZONTAL) {
      actions.push(TOUCH_ACTION_PAN_Y);
    }
    if (direction & DIRECTION_VERTICAL) {
      actions.push(TOUCH_ACTION_PAN_X);
    }
    return actions;
  };
  _proto.directionTest = function directionTest(input) {
    var options2 = this.options;
    var hasMoved = true;
    var distance2 = input.distance;
    var direction = input.direction;
    var x2 = input.deltaX;
    var y2 = input.deltaY;
    if (!(direction & options2.direction)) {
      if (options2.direction & DIRECTION_HORIZONTAL) {
        direction = x2 === 0 ? DIRECTION_NONE : x2 < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
        hasMoved = x2 !== this.pX;
        distance2 = Math.abs(input.deltaX);
      } else {
        direction = y2 === 0 ? DIRECTION_NONE : y2 < 0 ? DIRECTION_UP : DIRECTION_DOWN;
        hasMoved = y2 !== this.pY;
        distance2 = Math.abs(input.deltaY);
      }
    }
    input.direction = direction;
    return hasMoved && distance2 > options2.threshold && direction & options2.direction;
  };
  _proto.attrTest = function attrTest(input) {
    return AttrRecognizer.prototype.attrTest.call(this, input) && // replace with a super call
    (this.state & STATE_BEGAN || !(this.state & STATE_BEGAN) && this.directionTest(input));
  };
  _proto.emit = function emit(input) {
    this.pX = input.deltaX;
    this.pY = input.deltaY;
    var direction = directionStr(input.direction);
    if (direction) {
      input.additionalEvent = this.options.event + direction;
    }
    _AttrRecognizer.prototype.emit.call(this, input);
  };
  return PanRecognizer2;
}(AttrRecognizer);
var SwipeRecognizer = /* @__PURE__ */ function(_AttrRecognizer) {
  _inheritsLoose$1(SwipeRecognizer2, _AttrRecognizer);
  function SwipeRecognizer2(options2) {
    if (options2 === void 0) {
      options2 = {};
    }
    return _AttrRecognizer.call(this, _extends({
      event: "swipe",
      threshold: 10,
      velocity: 0.3,
      direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
      pointers: 1
    }, options2)) || this;
  }
  var _proto = SwipeRecognizer2.prototype;
  _proto.getTouchAction = function getTouchAction() {
    return PanRecognizer.prototype.getTouchAction.call(this);
  };
  _proto.attrTest = function attrTest(input) {
    var direction = this.options.direction;
    var velocity;
    if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
      velocity = input.overallVelocity;
    } else if (direction & DIRECTION_HORIZONTAL) {
      velocity = input.overallVelocityX;
    } else if (direction & DIRECTION_VERTICAL) {
      velocity = input.overallVelocityY;
    }
    return _AttrRecognizer.prototype.attrTest.call(this, input) && direction & input.offsetDirection && input.distance > this.options.threshold && input.maxPointers === this.options.pointers && abs$1(velocity) > this.options.velocity && input.eventType & INPUT_END;
  };
  _proto.emit = function emit(input) {
    var direction = directionStr(input.offsetDirection);
    if (direction) {
      this.manager.emit(this.options.event + direction, input);
    }
    this.manager.emit(this.options.event, input);
  };
  return SwipeRecognizer2;
}(AttrRecognizer);
var PinchRecognizer = /* @__PURE__ */ function(_AttrRecognizer) {
  _inheritsLoose$1(PinchRecognizer2, _AttrRecognizer);
  function PinchRecognizer2(options2) {
    if (options2 === void 0) {
      options2 = {};
    }
    return _AttrRecognizer.call(this, _extends({
      event: "pinch",
      threshold: 0,
      pointers: 2
    }, options2)) || this;
  }
  var _proto = PinchRecognizer2.prototype;
  _proto.getTouchAction = function getTouchAction() {
    return [TOUCH_ACTION_NONE];
  };
  _proto.attrTest = function attrTest(input) {
    return _AttrRecognizer.prototype.attrTest.call(this, input) && (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
  };
  _proto.emit = function emit(input) {
    if (input.scale !== 1) {
      var inOut = input.scale < 1 ? "in" : "out";
      input.additionalEvent = this.options.event + inOut;
    }
    _AttrRecognizer.prototype.emit.call(this, input);
  };
  return PinchRecognizer2;
}(AttrRecognizer);
var RotateRecognizer = /* @__PURE__ */ function(_AttrRecognizer) {
  _inheritsLoose$1(RotateRecognizer2, _AttrRecognizer);
  function RotateRecognizer2(options2) {
    if (options2 === void 0) {
      options2 = {};
    }
    return _AttrRecognizer.call(this, _extends({
      event: "rotate",
      threshold: 0,
      pointers: 2
    }, options2)) || this;
  }
  var _proto = RotateRecognizer2.prototype;
  _proto.getTouchAction = function getTouchAction() {
    return [TOUCH_ACTION_NONE];
  };
  _proto.attrTest = function attrTest(input) {
    return _AttrRecognizer.prototype.attrTest.call(this, input) && (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
  };
  return RotateRecognizer2;
}(AttrRecognizer);
var PressRecognizer = /* @__PURE__ */ function(_Recognizer) {
  _inheritsLoose$1(PressRecognizer2, _Recognizer);
  function PressRecognizer2(options2) {
    var _this;
    if (options2 === void 0) {
      options2 = {};
    }
    _this = _Recognizer.call(this, _extends({
      event: "press",
      pointers: 1,
      time: 251,
      // minimal time of the pointer to be pressed
      threshold: 9
    }, options2)) || this;
    _this._timer = null;
    _this._input = null;
    return _this;
  }
  var _proto = PressRecognizer2.prototype;
  _proto.getTouchAction = function getTouchAction() {
    return [TOUCH_ACTION_AUTO];
  };
  _proto.process = function process2(input) {
    var _this2 = this;
    var options2 = this.options;
    var validPointers = input.pointers.length === options2.pointers;
    var validMovement = input.distance < options2.threshold;
    var validTime = input.deltaTime > options2.time;
    this._input = input;
    if (!validMovement || !validPointers || input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime) {
      this.reset();
    } else if (input.eventType & INPUT_START) {
      this.reset();
      this._timer = setTimeout(function() {
        _this2.state = STATE_RECOGNIZED;
        _this2.tryEmit();
      }, options2.time);
    } else if (input.eventType & INPUT_END) {
      return STATE_RECOGNIZED;
    }
    return STATE_FAILED;
  };
  _proto.reset = function reset() {
    clearTimeout(this._timer);
  };
  _proto.emit = function emit(input) {
    if (this.state !== STATE_RECOGNIZED) {
      return;
    }
    if (input && input.eventType & INPUT_END) {
      this.manager.emit(this.options.event + "up", input);
    } else {
      this._input.timeStamp = now();
      this.manager.emit(this.options.event, this._input);
    }
  };
  return PressRecognizer2;
}(Recognizer);
var defaults$1 = {
  /**
   * @private
   * set if DOM events are being triggered.
   * But this is slower and unused by simple implementations, so disabled by default.
   * @type {Boolean}
   * @default false
   */
  domEvents: false,
  /**
   * @private
   * The value for the touchAction property/fallback.
   * When set to `compute` it will magically set the correct value based on the added recognizers.
   * @type {String}
   * @default compute
   */
  touchAction: TOUCH_ACTION_COMPUTE,
  /**
   * @private
   * @type {Boolean}
   * @default true
   */
  enable: true,
  /**
   * @private
   * EXPERIMENTAL FEATURE -- can be removed/changed
   * Change the parent input target element.
   * If Null, then it is being set the to main element.
   * @type {Null|EventTarget}
   * @default null
   */
  inputTarget: null,
  /**
   * @private
   * force an input class
   * @type {Null|Function}
   * @default null
   */
  inputClass: null,
  /**
   * @private
   * Some CSS properties can be used to improve the working of Hammer.
   * Add them to this method and they will be set when creating a new Manager.
   * @namespace
   */
  cssProps: {
    /**
     * @private
     * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
     * @type {String}
     * @default 'none'
     */
    userSelect: "none",
    /**
     * @private
     * Disable the Windows Phone grippers when pressing an element.
     * @type {String}
     * @default 'none'
     */
    touchSelect: "none",
    /**
     * @private
     * Disables the default callout shown when you touch and hold a touch target.
     * On iOS, when you touch and hold a touch target such as a link, Safari displays
     * a callout containing information about the link. This property allows you to disable that callout.
     * @type {String}
     * @default 'none'
     */
    touchCallout: "none",
    /**
     * @private
     * Specifies whether zooming is enabled. Used by IE10>
     * @type {String}
     * @default 'none'
     */
    contentZooming: "none",
    /**
     * @private
     * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
     * @type {String}
     * @default 'none'
     */
    userDrag: "none",
    /**
     * @private
     * Overrides the highlight color shown when the user taps a link or a JavaScript
     * clickable element in iOS. This property obeys the alpha value, if specified.
     * @type {String}
     * @default 'rgba(0,0,0,0)'
     */
    tapHighlightColor: "rgba(0,0,0,0)"
  }
};
var preset = [[RotateRecognizer, {
  enable: false
}], [PinchRecognizer, {
  enable: false
}, ["rotate"]], [SwipeRecognizer, {
  direction: DIRECTION_HORIZONTAL
}], [PanRecognizer, {
  direction: DIRECTION_HORIZONTAL
}, ["swipe"]], [TapRecognizer], [TapRecognizer, {
  event: "doubletap",
  taps: 2
}, ["tap"]], [PressRecognizer]];
var STOP = 1;
var FORCED_STOP = 2;
function toggleCssProps(manager, add) {
  var element = manager.element;
  if (!element.style) {
    return;
  }
  var prop;
  each(manager.options.cssProps, function(value, name) {
    prop = prefixed(element.style, name);
    if (add) {
      manager.oldCssProps[prop] = element.style[prop];
      element.style[prop] = value;
    } else {
      element.style[prop] = manager.oldCssProps[prop] || "";
    }
  });
  if (!add) {
    manager.oldCssProps = {};
  }
}
function triggerDomEvent(event, data2) {
  var gestureEvent = document.createEvent("Event");
  gestureEvent.initEvent(event, true, true);
  gestureEvent.gesture = data2;
  data2.target.dispatchEvent(gestureEvent);
}
var Manager = /* @__PURE__ */ function() {
  function Manager2(element, options2) {
    var _this = this;
    this.options = assign$1$1({}, defaults$1, options2 || {});
    this.options.inputTarget = this.options.inputTarget || element;
    this.handlers = {};
    this.session = {};
    this.recognizers = [];
    this.oldCssProps = {};
    this.element = element;
    this.input = createInputInstance(this);
    this.touchAction = new TouchAction(this, this.options.touchAction);
    toggleCssProps(this, true);
    each(this.options.recognizers, function(item) {
      var recognizer = _this.add(new item[0](item[1]));
      item[2] && recognizer.recognizeWith(item[2]);
      item[3] && recognizer.requireFailure(item[3]);
    }, this);
  }
  var _proto = Manager2.prototype;
  _proto.set = function set2(options2) {
    assign$1$1(this.options, options2);
    if (options2.touchAction) {
      this.touchAction.update();
    }
    if (options2.inputTarget) {
      this.input.destroy();
      this.input.target = options2.inputTarget;
      this.input.init();
    }
    return this;
  };
  _proto.stop = function stop(force) {
    this.session.stopped = force ? FORCED_STOP : STOP;
  };
  _proto.recognize = function recognize(inputData) {
    var session = this.session;
    if (session.stopped) {
      return;
    }
    this.touchAction.preventDefaults(inputData);
    var recognizer;
    var recognizers = this.recognizers;
    var curRecognizer = session.curRecognizer;
    if (!curRecognizer || curRecognizer && curRecognizer.state & STATE_RECOGNIZED) {
      session.curRecognizer = null;
      curRecognizer = null;
    }
    var i = 0;
    while (i < recognizers.length) {
      recognizer = recognizers[i];
      if (session.stopped !== FORCED_STOP && // 1
      (!curRecognizer || recognizer === curRecognizer || // 2
      recognizer.canRecognizeWith(curRecognizer))) {
        recognizer.recognize(inputData);
      } else {
        recognizer.reset();
      }
      if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
        session.curRecognizer = recognizer;
        curRecognizer = recognizer;
      }
      i++;
    }
  };
  _proto.get = function get2(recognizer) {
    if (recognizer instanceof Recognizer) {
      return recognizer;
    }
    var recognizers = this.recognizers;
    for (var i = 0; i < recognizers.length; i++) {
      if (recognizers[i].options.event === recognizer) {
        return recognizers[i];
      }
    }
    return null;
  };
  _proto.add = function add(recognizer) {
    if (invokeArrayArg(recognizer, "add", this)) {
      return this;
    }
    var existing = this.get(recognizer.options.event);
    if (existing) {
      this.remove(existing);
    }
    this.recognizers.push(recognizer);
    recognizer.manager = this;
    this.touchAction.update();
    return recognizer;
  };
  _proto.remove = function remove(recognizer) {
    if (invokeArrayArg(recognizer, "remove", this)) {
      return this;
    }
    var targetRecognizer = this.get(recognizer);
    if (recognizer) {
      var recognizers = this.recognizers;
      var index2 = inArray(recognizers, targetRecognizer);
      if (index2 !== -1) {
        recognizers.splice(index2, 1);
        this.touchAction.update();
      }
    }
    return this;
  };
  _proto.on = function on(events, handler) {
    if (events === void 0 || handler === void 0) {
      return this;
    }
    var handlers = this.handlers;
    each(splitStr(events), function(event) {
      handlers[event] = handlers[event] || [];
      handlers[event].push(handler);
    });
    return this;
  };
  _proto.off = function off(events, handler) {
    if (events === void 0) {
      return this;
    }
    var handlers = this.handlers;
    each(splitStr(events), function(event) {
      if (!handler) {
        delete handlers[event];
      } else {
        handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
      }
    });
    return this;
  };
  _proto.emit = function emit(event, data2) {
    if (this.options.domEvents) {
      triggerDomEvent(event, data2);
    }
    var handlers = this.handlers[event] && this.handlers[event].slice();
    if (!handlers || !handlers.length) {
      return;
    }
    data2.type = event;
    data2.preventDefault = function() {
      data2.srcEvent.preventDefault();
    };
    var i = 0;
    while (i < handlers.length) {
      handlers[i](data2);
      i++;
    }
  };
  _proto.destroy = function destroy() {
    this.element && toggleCssProps(this, false);
    this.handlers = {};
    this.session = {};
    this.input.destroy();
    this.element = null;
  };
  return Manager2;
}();
var SINGLE_TOUCH_INPUT_MAP = {
  touchstart: INPUT_START,
  touchmove: INPUT_MOVE,
  touchend: INPUT_END,
  touchcancel: INPUT_CANCEL
};
var SINGLE_TOUCH_TARGET_EVENTS = "touchstart";
var SINGLE_TOUCH_WINDOW_EVENTS = "touchstart touchmove touchend touchcancel";
var SingleTouchInput = /* @__PURE__ */ function(_Input) {
  _inheritsLoose$1(SingleTouchInput2, _Input);
  function SingleTouchInput2() {
    var _this;
    var proto = SingleTouchInput2.prototype;
    proto.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
    proto.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
    _this = _Input.apply(this, arguments) || this;
    _this.started = false;
    return _this;
  }
  var _proto = SingleTouchInput2.prototype;
  _proto.handler = function handler(ev) {
    var type2 = SINGLE_TOUCH_INPUT_MAP[ev.type];
    if (type2 === INPUT_START) {
      this.started = true;
    }
    if (!this.started) {
      return;
    }
    var touches = normalizeSingleTouches.call(this, ev, type2);
    if (type2 & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
      this.started = false;
    }
    this.callback(this.manager, type2, {
      pointers: touches[0],
      changedPointers: touches[1],
      pointerType: INPUT_TYPE_TOUCH,
      srcEvent: ev
    });
  };
  return SingleTouchInput2;
}(Input$2);
function normalizeSingleTouches(ev, type2) {
  var all = toArray(ev.touches);
  var changed = toArray(ev.changedTouches);
  if (type2 & (INPUT_END | INPUT_CANCEL)) {
    all = uniqueArray(all.concat(changed), "identifier", true);
  }
  return [all, changed];
}
function deprecate(method, name, message2) {
  var deprecationMessage = "DEPRECATED METHOD: " + name + "\n" + message2 + " AT \n";
  return function() {
    var e2 = new Error("get-stack-trace");
    var stack = e2 && e2.stack ? e2.stack.replace(/^[^\(]+?[\n$]/gm, "").replace(/^\s+at\s+/gm, "").replace(/^Object.<anonymous>\s*\(/gm, "{anonymous}()@") : "Unknown Stack Trace";
    var log = window.console && (window.console.warn || window.console.log);
    if (log) {
      log.call(window.console, deprecationMessage, stack);
    }
    return method.apply(this, arguments);
  };
}
var extend = deprecate(function(dest, src2, merge2) {
  var keys = Object.keys(src2);
  var i = 0;
  while (i < keys.length) {
    if (!merge2 || merge2 && dest[keys[i]] === void 0) {
      dest[keys[i]] = src2[keys[i]];
    }
    i++;
  }
  return dest;
}, "extend", "Use `assign`.");
var merge$1 = deprecate(function(dest, src2) {
  return extend(dest, src2, true);
}, "merge", "Use `assign`.");
function inherit(child, base, properties) {
  var baseP = base.prototype;
  var childP;
  childP = child.prototype = Object.create(baseP);
  childP.constructor = child;
  childP._super = baseP;
  if (properties) {
    assign$1$1(childP, properties);
  }
}
function bindFn(fn, context) {
  return function boundFn() {
    return fn.apply(context, arguments);
  };
}
var Hammer = /* @__PURE__ */ function() {
  var Hammer2 = (
    /**
      * @private
      * @const {string}
      */
    function Hammer3(element, options2) {
      if (options2 === void 0) {
        options2 = {};
      }
      return new Manager(element, _extends({
        recognizers: preset.concat()
      }, options2));
    }
  );
  Hammer2.VERSION = "2.0.17-rc";
  Hammer2.DIRECTION_ALL = DIRECTION_ALL;
  Hammer2.DIRECTION_DOWN = DIRECTION_DOWN;
  Hammer2.DIRECTION_LEFT = DIRECTION_LEFT;
  Hammer2.DIRECTION_RIGHT = DIRECTION_RIGHT;
  Hammer2.DIRECTION_UP = DIRECTION_UP;
  Hammer2.DIRECTION_HORIZONTAL = DIRECTION_HORIZONTAL;
  Hammer2.DIRECTION_VERTICAL = DIRECTION_VERTICAL;
  Hammer2.DIRECTION_NONE = DIRECTION_NONE;
  Hammer2.DIRECTION_DOWN = DIRECTION_DOWN;
  Hammer2.INPUT_START = INPUT_START;
  Hammer2.INPUT_MOVE = INPUT_MOVE;
  Hammer2.INPUT_END = INPUT_END;
  Hammer2.INPUT_CANCEL = INPUT_CANCEL;
  Hammer2.STATE_POSSIBLE = STATE_POSSIBLE;
  Hammer2.STATE_BEGAN = STATE_BEGAN;
  Hammer2.STATE_CHANGED = STATE_CHANGED;
  Hammer2.STATE_ENDED = STATE_ENDED;
  Hammer2.STATE_RECOGNIZED = STATE_RECOGNIZED;
  Hammer2.STATE_CANCELLED = STATE_CANCELLED;
  Hammer2.STATE_FAILED = STATE_FAILED;
  Hammer2.Manager = Manager;
  Hammer2.Input = Input$2;
  Hammer2.TouchAction = TouchAction;
  Hammer2.TouchInput = TouchInput;
  Hammer2.MouseInput = MouseInput;
  Hammer2.PointerEventInput = PointerEventInput;
  Hammer2.TouchMouseInput = TouchMouseInput;
  Hammer2.SingleTouchInput = SingleTouchInput;
  Hammer2.Recognizer = Recognizer;
  Hammer2.AttrRecognizer = AttrRecognizer;
  Hammer2.Tap = TapRecognizer;
  Hammer2.Pan = PanRecognizer;
  Hammer2.Swipe = SwipeRecognizer;
  Hammer2.Pinch = PinchRecognizer;
  Hammer2.Rotate = RotateRecognizer;
  Hammer2.Press = PressRecognizer;
  Hammer2.on = addEventListeners;
  Hammer2.off = removeEventListeners;
  Hammer2.each = each;
  Hammer2.merge = merge$1;
  Hammer2.extend = extend;
  Hammer2.bindFn = bindFn;
  Hammer2.assign = assign$1$1;
  Hammer2.inherit = inherit;
  Hammer2.bindFn = bindFn;
  Hammer2.prefixed = prefixed;
  Hammer2.toArray = toArray;
  Hammer2.inArray = inArray;
  Hammer2.uniqueArray = uniqueArray;
  Hammer2.splitStr = splitStr;
  Hammer2.boolOrFn = boolOrFn;
  Hammer2.hasParent = hasParent;
  Hammer2.addEventListeners = addEventListeners;
  Hammer2.removeEventListeners = removeEventListeners;
  Hammer2.defaults = assign$1$1({}, defaults$1, {
    preset
  });
  return Hammer2;
}();
/*!
* chartjs-plugin-zoom v2.0.1
* undefined
 * (c) 2016-2023 chartjs-plugin-zoom Contributors
 * Released under the MIT License
 */
const getModifierKey = (opts) => opts && opts.enabled && opts.modifierKey;
const keyPressed = (key, event) => key && event[key + "Key"];
const keyNotPressed = (key, event) => key && !event[key + "Key"];
function directionEnabled(mode, dir, chart) {
  if (mode === void 0) {
    return true;
  } else if (typeof mode === "string") {
    return mode.indexOf(dir) !== -1;
  } else if (typeof mode === "function") {
    return mode({ chart }).indexOf(dir) !== -1;
  }
  return false;
}
function directionsEnabled(mode, chart) {
  if (typeof mode === "function") {
    mode = mode({ chart });
  }
  if (typeof mode === "string") {
    return { x: mode.indexOf("x") !== -1, y: mode.indexOf("y") !== -1 };
  }
  return { x: false, y: false };
}
function debounce(fn, delay) {
  let timeout2;
  return function() {
    clearTimeout(timeout2);
    timeout2 = setTimeout(fn, delay);
    return delay;
  };
}
function getScaleUnderPoint({ x: x2, y: y2 }, chart) {
  const scales2 = chart.scales;
  const scaleIds = Object.keys(scales2);
  for (let i = 0; i < scaleIds.length; i++) {
    const scale2 = scales2[scaleIds[i]];
    if (y2 >= scale2.top && y2 <= scale2.bottom && x2 >= scale2.left && x2 <= scale2.right) {
      return scale2;
    }
  }
  return null;
}
function getEnabledScalesByPoint(options2, point, chart) {
  const { mode = "xy", scaleMode, overScaleMode } = options2 || {};
  const scale2 = getScaleUnderPoint(point, chart);
  const enabled = directionsEnabled(mode, chart);
  const scaleEnabled = directionsEnabled(scaleMode, chart);
  if (overScaleMode) {
    const overScaleEnabled = directionsEnabled(overScaleMode, chart);
    for (const axis of ["x", "y"]) {
      if (overScaleEnabled[axis]) {
        scaleEnabled[axis] = enabled[axis];
        enabled[axis] = false;
      }
    }
  }
  if (scale2 && scaleEnabled[scale2.axis]) {
    return [scale2];
  }
  const enabledScales = [];
  each$1(chart.scales, function(scaleItem) {
    if (enabled[scaleItem.axis]) {
      enabledScales.push(scaleItem);
    }
  });
  return enabledScales;
}
const chartStates = /* @__PURE__ */ new WeakMap();
function getState(chart) {
  let state = chartStates.get(chart);
  if (!state) {
    state = {
      originalScaleLimits: {},
      updatedScaleLimits: {},
      handlers: {},
      panDelta: {}
    };
    chartStates.set(chart, state);
  }
  return state;
}
function removeState(chart) {
  chartStates.delete(chart);
}
function zoomDelta(scale2, zoom2, center) {
  const range2 = scale2.max - scale2.min;
  const newRange = range2 * (zoom2 - 1);
  const centerPoint = scale2.isHorizontal() ? center.x : center.y;
  const minPercent = Math.max(0, Math.min(
    1,
    (scale2.getValueForPixel(centerPoint) - scale2.min) / range2 || 0
  ));
  const maxPercent = 1 - minPercent;
  return {
    min: newRange * minPercent,
    max: newRange * maxPercent
  };
}
function getLimit(state, scale2, scaleLimits, prop, fallback) {
  let limit = scaleLimits[prop];
  if (limit === "original") {
    const original = state.originalScaleLimits[scale2.id][prop];
    limit = valueOrDefault(original.options, original.scale);
  }
  return valueOrDefault(limit, fallback);
}
function getRange(scale2, pixel0, pixel1) {
  const v0 = scale2.getValueForPixel(pixel0);
  const v1 = scale2.getValueForPixel(pixel1);
  return {
    min: Math.min(v0, v1),
    max: Math.max(v0, v1)
  };
}
function updateRange(scale2, { min: min2, max: max2 }, limits, zoom2 = false) {
  const state = getState(scale2.chart);
  const { id, axis, options: scaleOpts } = scale2;
  const scaleLimits = limits && (limits[id] || limits[axis]) || {};
  const { minRange = 0 } = scaleLimits;
  const minLimit = getLimit(state, scale2, scaleLimits, "min", -Infinity);
  const maxLimit = getLimit(state, scale2, scaleLimits, "max", Infinity);
  const range2 = zoom2 ? Math.max(max2 - min2, minRange) : scale2.max - scale2.min;
  const offset2 = (range2 - max2 + min2) / 2;
  min2 -= offset2;
  max2 += offset2;
  if (min2 < minLimit) {
    min2 = minLimit;
    max2 = Math.min(minLimit + range2, maxLimit);
  } else if (max2 > maxLimit) {
    max2 = maxLimit;
    min2 = Math.max(maxLimit - range2, minLimit);
  }
  scaleOpts.min = min2;
  scaleOpts.max = max2;
  state.updatedScaleLimits[scale2.id] = { min: min2, max: max2 };
  return scale2.parse(min2) !== scale2.min || scale2.parse(max2) !== scale2.max;
}
function zoomNumericalScale(scale2, zoom2, center, limits) {
  const delta = zoomDelta(scale2, zoom2, center);
  const newRange = { min: scale2.min + delta.min, max: scale2.max - delta.max };
  return updateRange(scale2, newRange, limits, true);
}
function zoomRectNumericalScale(scale2, from2, to2, limits) {
  updateRange(scale2, getRange(scale2, from2, to2), limits, true);
}
const integerChange = (v2) => v2 === 0 || isNaN(v2) ? 0 : v2 < 0 ? Math.min(Math.round(v2), -1) : Math.max(Math.round(v2), 1);
function existCategoryFromMaxZoom(scale2) {
  const labels = scale2.getLabels();
  const maxIndex = labels.length - 1;
  if (scale2.min > 0) {
    scale2.min -= 1;
  }
  if (scale2.max < maxIndex) {
    scale2.max += 1;
  }
}
function zoomCategoryScale(scale2, zoom2, center, limits) {
  const delta = zoomDelta(scale2, zoom2, center);
  if (scale2.min === scale2.max && zoom2 < 1) {
    existCategoryFromMaxZoom(scale2);
  }
  const newRange = { min: scale2.min + integerChange(delta.min), max: scale2.max - integerChange(delta.max) };
  return updateRange(scale2, newRange, limits, true);
}
function scaleLength(scale2) {
  return scale2.isHorizontal() ? scale2.width : scale2.height;
}
function panCategoryScale(scale2, delta, limits) {
  const labels = scale2.getLabels();
  const lastLabelIndex = labels.length - 1;
  let { min: min2, max: max2 } = scale2;
  const range2 = Math.max(max2 - min2, 1);
  const stepDelta = Math.round(scaleLength(scale2) / Math.max(range2, 10));
  const stepSize = Math.round(Math.abs(delta / stepDelta));
  let applied;
  if (delta < -stepDelta) {
    max2 = Math.min(max2 + stepSize, lastLabelIndex);
    min2 = range2 === 1 ? max2 : max2 - range2;
    applied = max2 === lastLabelIndex;
  } else if (delta > stepDelta) {
    min2 = Math.max(0, min2 - stepSize);
    max2 = range2 === 1 ? min2 : min2 + range2;
    applied = min2 === 0;
  }
  return updateRange(scale2, { min: min2, max: max2 }, limits) || applied;
}
const OFFSETS = {
  second: 500,
  // 500 ms
  minute: 30 * 1e3,
  // 30 s
  hour: 30 * 60 * 1e3,
  // 30 m
  day: 12 * 60 * 60 * 1e3,
  // 12 h
  week: 3.5 * 24 * 60 * 60 * 1e3,
  // 3.5 d
  month: 15 * 24 * 60 * 60 * 1e3,
  // 15 d
  quarter: 60 * 24 * 60 * 60 * 1e3,
  // 60 d
  year: 182 * 24 * 60 * 60 * 1e3
  // 182 d
};
function panNumericalScale(scale2, delta, limits, canZoom = false) {
  const { min: prevStart, max: prevEnd, options: options2 } = scale2;
  const round2 = options2.time && options2.time.round;
  const offset2 = OFFSETS[round2] || 0;
  const newMin = scale2.getValueForPixel(scale2.getPixelForValue(prevStart + offset2) - delta);
  const newMax = scale2.getValueForPixel(scale2.getPixelForValue(prevEnd + offset2) - delta);
  const { min: minLimit = -Infinity, max: maxLimit = Infinity } = canZoom && limits && limits[scale2.axis] || {};
  if (isNaN(newMin) || isNaN(newMax) || newMin < minLimit || newMax > maxLimit) {
    return true;
  }
  return updateRange(scale2, { min: newMin, max: newMax }, limits, canZoom);
}
function panNonLinearScale(scale2, delta, limits) {
  return panNumericalScale(scale2, delta, limits, true);
}
const zoomFunctions = {
  category: zoomCategoryScale,
  default: zoomNumericalScale
};
const zoomRectFunctions = {
  default: zoomRectNumericalScale
};
const panFunctions = {
  category: panCategoryScale,
  default: panNumericalScale,
  logarithmic: panNonLinearScale,
  timeseries: panNonLinearScale
};
function shouldUpdateScaleLimits(scale2, originalScaleLimits, updatedScaleLimits) {
  const { id, options: { min: min2, max: max2 } } = scale2;
  if (!originalScaleLimits[id] || !updatedScaleLimits[id]) {
    return true;
  }
  const previous = updatedScaleLimits[id];
  return previous.min !== min2 || previous.max !== max2;
}
function removeMissingScales(limits, scales2) {
  each$1(limits, (opt, key) => {
    if (!scales2[key]) {
      delete limits[key];
    }
  });
}
function storeOriginalScaleLimits(chart, state) {
  const { scales: scales2 } = chart;
  const { originalScaleLimits, updatedScaleLimits } = state;
  each$1(scales2, function(scale2) {
    if (shouldUpdateScaleLimits(scale2, originalScaleLimits, updatedScaleLimits)) {
      originalScaleLimits[scale2.id] = {
        min: { scale: scale2.min, options: scale2.options.min },
        max: { scale: scale2.max, options: scale2.options.max }
      };
    }
  });
  removeMissingScales(originalScaleLimits, scales2);
  removeMissingScales(updatedScaleLimits, scales2);
  return originalScaleLimits;
}
function doZoom(scale2, amount, center, limits) {
  const fn = zoomFunctions[scale2.type] || zoomFunctions.default;
  callback(fn, [scale2, amount, center, limits]);
}
function doZoomRect(scale2, amount, from2, to2, limits) {
  const fn = zoomRectFunctions[scale2.type] || zoomRectFunctions.default;
  callback(fn, [scale2, amount, from2, to2, limits]);
}
function getCenter(chart) {
  const ca = chart.chartArea;
  return {
    x: (ca.left + ca.right) / 2,
    y: (ca.top + ca.bottom) / 2
  };
}
function zoom(chart, amount, transition = "none") {
  const { x: x2 = 1, y: y2 = 1, focalPoint = getCenter(chart) } = typeof amount === "number" ? { x: amount, y: amount } : amount;
  const state = getState(chart);
  const { options: { limits, zoom: zoomOptions } } = state;
  storeOriginalScaleLimits(chart, state);
  const xEnabled = x2 !== 1;
  const yEnabled = y2 !== 1;
  const enabledScales = getEnabledScalesByPoint(zoomOptions, focalPoint, chart);
  each$1(enabledScales || chart.scales, function(scale2) {
    if (scale2.isHorizontal() && xEnabled) {
      doZoom(scale2, x2, focalPoint, limits);
    } else if (!scale2.isHorizontal() && yEnabled) {
      doZoom(scale2, y2, focalPoint, limits);
    }
  });
  chart.update(transition);
  callback(zoomOptions.onZoom, [{ chart }]);
}
function zoomRect(chart, p0, p1, transition = "none") {
  const state = getState(chart);
  const { options: { limits, zoom: zoomOptions } } = state;
  const { mode = "xy" } = zoomOptions;
  storeOriginalScaleLimits(chart, state);
  const xEnabled = directionEnabled(mode, "x", chart);
  const yEnabled = directionEnabled(mode, "y", chart);
  each$1(chart.scales, function(scale2) {
    if (scale2.isHorizontal() && xEnabled) {
      doZoomRect(scale2, p0.x, p1.x, limits);
    } else if (!scale2.isHorizontal() && yEnabled) {
      doZoomRect(scale2, p0.y, p1.y, limits);
    }
  });
  chart.update(transition);
  callback(zoomOptions.onZoom, [{ chart }]);
}
function zoomScale(chart, scaleId, range2, transition = "none") {
  storeOriginalScaleLimits(chart, getState(chart));
  const scale2 = chart.scales[scaleId];
  updateRange(scale2, range2, void 0, true);
  chart.update(transition);
}
function resetZoom(chart, transition = "default") {
  const state = getState(chart);
  const originalScaleLimits = storeOriginalScaleLimits(chart, state);
  each$1(chart.scales, function(scale2) {
    const scaleOptions = scale2.options;
    if (originalScaleLimits[scale2.id]) {
      scaleOptions.min = originalScaleLimits[scale2.id].min.options;
      scaleOptions.max = originalScaleLimits[scale2.id].max.options;
    } else {
      delete scaleOptions.min;
      delete scaleOptions.max;
    }
  });
  chart.update(transition);
  callback(state.options.zoom.onZoomComplete, [{ chart }]);
}
function getOriginalRange(state, scaleId) {
  const original = state.originalScaleLimits[scaleId];
  if (!original) {
    return;
  }
  const { min: min2, max: max2 } = original;
  return valueOrDefault(max2.options, max2.scale) - valueOrDefault(min2.options, min2.scale);
}
function getZoomLevel(chart) {
  const state = getState(chart);
  let min2 = 1;
  let max2 = 1;
  each$1(chart.scales, function(scale2) {
    const origRange = getOriginalRange(state, scale2.id);
    if (origRange) {
      const level = Math.round(origRange / (scale2.max - scale2.min) * 100) / 100;
      min2 = Math.min(min2, level);
      max2 = Math.max(max2, level);
    }
  });
  return min2 < 1 ? min2 : max2;
}
function panScale(scale2, delta, limits, state) {
  const { panDelta } = state;
  const storedDelta = panDelta[scale2.id] || 0;
  if (sign(storedDelta) === sign(delta)) {
    delta += storedDelta;
  }
  const fn = panFunctions[scale2.type] || panFunctions.default;
  if (callback(fn, [scale2, delta, limits])) {
    panDelta[scale2.id] = 0;
  } else {
    panDelta[scale2.id] = delta;
  }
}
function pan(chart, delta, enabledScales, transition = "none") {
  const { x: x2 = 0, y: y2 = 0 } = typeof delta === "number" ? { x: delta, y: delta } : delta;
  const state = getState(chart);
  const { options: { pan: panOptions, limits } } = state;
  const { onPan } = panOptions || {};
  storeOriginalScaleLimits(chart, state);
  const xEnabled = x2 !== 0;
  const yEnabled = y2 !== 0;
  each$1(enabledScales || chart.scales, function(scale2) {
    if (scale2.isHorizontal() && xEnabled) {
      panScale(scale2, x2, limits, state);
    } else if (!scale2.isHorizontal() && yEnabled) {
      panScale(scale2, y2, limits, state);
    }
  });
  chart.update(transition);
  callback(onPan, [{ chart }]);
}
function getInitialScaleBounds(chart) {
  const state = getState(chart);
  storeOriginalScaleLimits(chart, state);
  const scaleBounds = {};
  for (const scaleId of Object.keys(chart.scales)) {
    const { min: min2, max: max2 } = state.originalScaleLimits[scaleId] || { min: {}, max: {} };
    scaleBounds[scaleId] = { min: min2.scale, max: max2.scale };
  }
  return scaleBounds;
}
function isZoomedOrPanned(chart) {
  const scaleBounds = getInitialScaleBounds(chart);
  for (const scaleId of Object.keys(chart.scales)) {
    const { min: originalMin, max: originalMax } = scaleBounds[scaleId];
    if (originalMin !== void 0 && chart.scales[scaleId].min !== originalMin) {
      return true;
    }
    if (originalMax !== void 0 && chart.scales[scaleId].max !== originalMax) {
      return true;
    }
  }
  return false;
}
function removeHandler(chart, type2) {
  const { handlers } = getState(chart);
  const handler = handlers[type2];
  if (handler && handler.target) {
    handler.target.removeEventListener(type2, handler);
    delete handlers[type2];
  }
}
function addHandler(chart, target, type2, handler) {
  const { handlers, options: options2 } = getState(chart);
  const oldHandler = handlers[type2];
  if (oldHandler && oldHandler.target === target) {
    return;
  }
  removeHandler(chart, type2);
  handlers[type2] = (event) => handler(chart, event, options2);
  handlers[type2].target = target;
  target.addEventListener(type2, handlers[type2]);
}
function mouseMove(chart, event) {
  const state = getState(chart);
  if (state.dragStart) {
    state.dragging = true;
    state.dragEnd = event;
    chart.update("none");
  }
}
function keyDown(chart, event) {
  const state = getState(chart);
  if (!state.dragStart || event.key !== "Escape") {
    return;
  }
  removeHandler(chart, "keydown");
  state.dragging = false;
  state.dragStart = state.dragEnd = null;
  chart.update("none");
}
function zoomStart(chart, event, zoomOptions) {
  const { onZoomStart, onZoomRejected } = zoomOptions;
  if (onZoomStart) {
    const point = getRelativePosition(event, chart);
    if (callback(onZoomStart, [{ chart, event, point }]) === false) {
      callback(onZoomRejected, [{ chart, event }]);
      return false;
    }
  }
}
function mouseDown(chart, event) {
  const state = getState(chart);
  const { pan: panOptions, zoom: zoomOptions = {} } = state.options;
  if (event.button !== 0 || keyPressed(getModifierKey(panOptions), event) || keyNotPressed(getModifierKey(zoomOptions.drag), event)) {
    return callback(zoomOptions.onZoomRejected, [{ chart, event }]);
  }
  if (zoomStart(chart, event, zoomOptions) === false) {
    return;
  }
  state.dragStart = event;
  addHandler(chart, chart.canvas, "mousemove", mouseMove);
  addHandler(chart, window == null ? void 0 : window.document, "keydown", keyDown);
}
function computeDragRect(chart, mode, beginPointEvent, endPointEvent) {
  const xEnabled = directionEnabled(mode, "x", chart);
  const yEnabled = directionEnabled(mode, "y", chart);
  let { top, left, right, bottom, width: chartWidth, height: chartHeight } = chart.chartArea;
  const beginPoint = getRelativePosition(beginPointEvent, chart);
  const endPoint = getRelativePosition(endPointEvent, chart);
  if (xEnabled) {
    left = Math.min(beginPoint.x, endPoint.x);
    right = Math.max(beginPoint.x, endPoint.x);
  }
  if (yEnabled) {
    top = Math.min(beginPoint.y, endPoint.y);
    bottom = Math.max(beginPoint.y, endPoint.y);
  }
  const width = right - left;
  const height2 = bottom - top;
  return {
    left,
    top,
    right,
    bottom,
    width,
    height: height2,
    zoomX: xEnabled && width ? 1 + (chartWidth - width) / chartWidth : 1,
    zoomY: yEnabled && height2 ? 1 + (chartHeight - height2) / chartHeight : 1
  };
}
function mouseUp(chart, event) {
  const state = getState(chart);
  if (!state.dragStart) {
    return;
  }
  removeHandler(chart, "mousemove");
  const { mode, onZoomComplete, drag: { threshold = 0 } } = state.options.zoom;
  const rect = computeDragRect(chart, mode, state.dragStart, event);
  const distanceX = directionEnabled(mode, "x", chart) ? rect.width : 0;
  const distanceY = directionEnabled(mode, "y", chart) ? rect.height : 0;
  const distance2 = Math.sqrt(distanceX * distanceX + distanceY * distanceY);
  state.dragStart = state.dragEnd = null;
  if (distance2 <= threshold) {
    state.dragging = false;
    chart.update("none");
    return;
  }
  zoomRect(chart, { x: rect.left, y: rect.top }, { x: rect.right, y: rect.bottom }, "zoom");
  setTimeout(() => state.dragging = false, 500);
  callback(onZoomComplete, [{ chart }]);
}
function wheelPreconditions(chart, event, zoomOptions) {
  if (keyNotPressed(getModifierKey(zoomOptions.wheel), event)) {
    callback(zoomOptions.onZoomRejected, [{ chart, event }]);
    return;
  }
  if (zoomStart(chart, event, zoomOptions) === false) {
    return;
  }
  if (event.cancelable) {
    event.preventDefault();
  }
  if (event.deltaY === void 0) {
    return;
  }
  return true;
}
function wheel(chart, event) {
  const { handlers: { onZoomComplete }, options: { zoom: zoomOptions } } = getState(chart);
  if (!wheelPreconditions(chart, event, zoomOptions)) {
    return;
  }
  const rect = event.target.getBoundingClientRect();
  const speed = 1 + (event.deltaY >= 0 ? -zoomOptions.wheel.speed : zoomOptions.wheel.speed);
  const amount = {
    x: speed,
    y: speed,
    focalPoint: {
      x: event.clientX - rect.left,
      y: event.clientY - rect.top
    }
  };
  zoom(chart, amount);
  if (onZoomComplete) {
    onZoomComplete();
  }
}
function addDebouncedHandler(chart, name, handler, delay) {
  if (handler) {
    getState(chart).handlers[name] = debounce(() => callback(handler, [{ chart }]), delay);
  }
}
function addListeners(chart, options2) {
  const canvas = chart.canvas;
  const { wheel: wheelOptions, drag: dragOptions, onZoomComplete } = options2.zoom;
  if (wheelOptions.enabled) {
    addHandler(chart, canvas, "wheel", wheel);
    addDebouncedHandler(chart, "onZoomComplete", onZoomComplete, 250);
  } else {
    removeHandler(chart, "wheel");
  }
  if (dragOptions.enabled) {
    addHandler(chart, canvas, "mousedown", mouseDown);
    addHandler(chart, canvas.ownerDocument, "mouseup", mouseUp);
  } else {
    removeHandler(chart, "mousedown");
    removeHandler(chart, "mousemove");
    removeHandler(chart, "mouseup");
    removeHandler(chart, "keydown");
  }
}
function removeListeners(chart) {
  removeHandler(chart, "mousedown");
  removeHandler(chart, "mousemove");
  removeHandler(chart, "mouseup");
  removeHandler(chart, "wheel");
  removeHandler(chart, "click");
  removeHandler(chart, "keydown");
}
function createEnabler(chart, state) {
  return function(recognizer, event) {
    const { pan: panOptions, zoom: zoomOptions = {} } = state.options;
    if (!panOptions || !panOptions.enabled) {
      return false;
    }
    const srcEvent = event && event.srcEvent;
    if (!srcEvent) {
      return true;
    }
    if (!state.panning && event.pointerType === "mouse" && (keyNotPressed(getModifierKey(panOptions), srcEvent) || keyPressed(getModifierKey(zoomOptions.drag), srcEvent))) {
      callback(panOptions.onPanRejected, [{ chart, event }]);
      return false;
    }
    return true;
  };
}
function pinchAxes(p0, p1) {
  const pinchX = Math.abs(p0.clientX - p1.clientX);
  const pinchY = Math.abs(p0.clientY - p1.clientY);
  const p2 = pinchX / pinchY;
  let x2, y2;
  if (p2 > 0.3 && p2 < 1.7) {
    x2 = y2 = true;
  } else if (pinchX > pinchY) {
    x2 = true;
  } else {
    y2 = true;
  }
  return { x: x2, y: y2 };
}
function handlePinch(chart, state, e2) {
  if (state.scale) {
    const { center, pointers } = e2;
    const zoomPercent = 1 / state.scale * e2.scale;
    const rect = e2.target.getBoundingClientRect();
    const pinch = pinchAxes(pointers[0], pointers[1]);
    const mode = state.options.zoom.mode;
    const amount = {
      x: pinch.x && directionEnabled(mode, "x", chart) ? zoomPercent : 1,
      y: pinch.y && directionEnabled(mode, "y", chart) ? zoomPercent : 1,
      focalPoint: {
        x: center.x - rect.left,
        y: center.y - rect.top
      }
    };
    zoom(chart, amount);
    state.scale = e2.scale;
  }
}
function startPinch(chart, state) {
  if (state.options.zoom.pinch.enabled) {
    state.scale = 1;
  }
}
function endPinch(chart, state, e2) {
  if (state.scale) {
    handlePinch(chart, state, e2);
    state.scale = null;
    callback(state.options.zoom.onZoomComplete, [{ chart }]);
  }
}
function handlePan(chart, state, e2) {
  const delta = state.delta;
  if (delta) {
    state.panning = true;
    pan(chart, { x: e2.deltaX - delta.x, y: e2.deltaY - delta.y }, state.panScales);
    state.delta = { x: e2.deltaX, y: e2.deltaY };
  }
}
function startPan(chart, state, event) {
  const { enabled, onPanStart, onPanRejected } = state.options.pan;
  if (!enabled) {
    return;
  }
  const rect = event.target.getBoundingClientRect();
  const point = {
    x: event.center.x - rect.left,
    y: event.center.y - rect.top
  };
  if (callback(onPanStart, [{ chart, event, point }]) === false) {
    return callback(onPanRejected, [{ chart, event }]);
  }
  state.panScales = getEnabledScalesByPoint(state.options.pan, point, chart);
  state.delta = { x: 0, y: 0 };
  clearTimeout(state.panEndTimeout);
  handlePan(chart, state, event);
}
function endPan(chart, state) {
  state.delta = null;
  if (state.panning) {
    state.panEndTimeout = setTimeout(() => state.panning = false, 500);
    callback(state.options.pan.onPanComplete, [{ chart }]);
  }
}
const hammers = /* @__PURE__ */ new WeakMap();
function startHammer(chart, options2) {
  const state = getState(chart);
  const canvas = chart.canvas;
  const { pan: panOptions, zoom: zoomOptions } = options2;
  const mc = new Hammer.Manager(canvas);
  if (zoomOptions && zoomOptions.pinch.enabled) {
    mc.add(new Hammer.Pinch());
    mc.on("pinchstart", () => startPinch(chart, state));
    mc.on("pinch", (e2) => handlePinch(chart, state, e2));
    mc.on("pinchend", (e2) => endPinch(chart, state, e2));
  }
  if (panOptions && panOptions.enabled) {
    mc.add(new Hammer.Pan({
      threshold: panOptions.threshold,
      enable: createEnabler(chart, state)
    }));
    mc.on("panstart", (e2) => startPan(chart, state, e2));
    mc.on("panmove", (e2) => handlePan(chart, state, e2));
    mc.on("panend", () => endPan(chart, state));
  }
  hammers.set(chart, mc);
}
function stopHammer(chart) {
  const mc = hammers.get(chart);
  if (mc) {
    mc.remove("pinchstart");
    mc.remove("pinch");
    mc.remove("pinchend");
    mc.remove("panstart");
    mc.remove("pan");
    mc.remove("panend");
    mc.destroy();
    hammers.delete(chart);
  }
}
var version = "2.0.1";
function draw(chart, caller, options2) {
  const dragOptions = options2.zoom.drag;
  const { dragStart, dragEnd } = getState(chart);
  if (dragOptions.drawTime !== caller || !dragEnd) {
    return;
  }
  const { left, top, width, height: height2 } = computeDragRect(chart, options2.zoom.mode, dragStart, dragEnd);
  const ctx = chart.ctx;
  ctx.save();
  ctx.beginPath();
  ctx.fillStyle = dragOptions.backgroundColor || "rgba(225,225,225,0.3)";
  ctx.fillRect(left, top, width, height2);
  if (dragOptions.borderWidth > 0) {
    ctx.lineWidth = dragOptions.borderWidth;
    ctx.strokeStyle = dragOptions.borderColor || "rgba(225,225,225)";
    ctx.strokeRect(left, top, width, height2);
  }
  ctx.restore();
}
var plugin = {
  id: "zoom",
  version,
  defaults: {
    pan: {
      enabled: false,
      mode: "xy",
      threshold: 10,
      modifierKey: null
    },
    zoom: {
      wheel: {
        enabled: false,
        speed: 0.1,
        modifierKey: null
      },
      drag: {
        enabled: false,
        drawTime: "beforeDatasetsDraw",
        modifierKey: null
      },
      pinch: {
        enabled: false
      },
      mode: "xy"
    }
  },
  start: function(chart, _args, options2) {
    const state = getState(chart);
    state.options = options2;
    if (Object.prototype.hasOwnProperty.call(options2.zoom, "enabled")) {
      console.warn("The option `zoom.enabled` is no longer supported. Please use `zoom.wheel.enabled`, `zoom.drag.enabled`, or `zoom.pinch.enabled`.");
    }
    if (Object.prototype.hasOwnProperty.call(options2.zoom, "overScaleMode") || Object.prototype.hasOwnProperty.call(options2.pan, "overScaleMode")) {
      console.warn("The option `overScaleMode` is deprecated. Please use `scaleMode` instead (and update `mode` as desired).");
    }
    if (Hammer) {
      startHammer(chart, options2);
    }
    chart.pan = (delta, panScales, transition) => pan(chart, delta, panScales, transition);
    chart.zoom = (args, transition) => zoom(chart, args, transition);
    chart.zoomRect = (p0, p1, transition) => zoomRect(chart, p0, p1, transition);
    chart.zoomScale = (id, range2, transition) => zoomScale(chart, id, range2, transition);
    chart.resetZoom = (transition) => resetZoom(chart, transition);
    chart.getZoomLevel = () => getZoomLevel(chart);
    chart.getInitialScaleBounds = () => getInitialScaleBounds(chart);
    chart.isZoomedOrPanned = () => isZoomedOrPanned(chart);
  },
  beforeEvent(chart) {
    const state = getState(chart);
    if (state.panning || state.dragging) {
      return false;
    }
  },
  beforeUpdate: function(chart, args, options2) {
    const state = getState(chart);
    state.options = options2;
    addListeners(chart, options2);
  },
  beforeDatasetsDraw(chart, _args, options2) {
    draw(chart, "beforeDatasetsDraw", options2);
  },
  afterDatasetsDraw(chart, _args, options2) {
    draw(chart, "afterDatasetsDraw", options2);
  },
  beforeDraw(chart, _args, options2) {
    draw(chart, "beforeDraw", options2);
  },
  afterDraw(chart, _args, options2) {
    draw(chart, "afterDraw", options2);
  },
  stop: function(chart) {
    removeListeners(chart);
    if (Hammer) {
      stopHammer(chart);
    }
    removeState(chart);
  },
  panFunctions,
  zoomFunctions,
  zoomRectFunctions
};
const FinancialChart = ({ data: data2, fontColor, gridColor }) => {
  Chart$1.register(OhlcElement, OhlcController, CandlestickElement, CandlestickController);
  Chart$1.register(plugin);
  const ref = useRef(null);
  useEffect(() => {
    const myChart = new Chart$1(ref.current, {
      // @ts-ignore
      type: "candlestick",
      data: {
        datasets: data2
      },
      options: {
        scales: {
          y: {
            ticks: {
              color: fontColor
            },
            grid: {
              color: gridColor
            }
          },
          x: {
            ticks: {
              color: fontColor
            },
            grid: {
              color: gridColor
            }
          }
        },
        plugins: {
          zoom: {
            zoom: {
              wheel: {
                enabled: true
              },
              pinch: {
                enabled: true
              },
              mode: "x"
            },
            pan: {
              enabled: true,
              mode: "x"
            },
            limits: {
              x: {
                minRange: 3
              }
            }
          }
        },
        responsive: true,
        maintainAspectRatio: false
      }
    });
    return () => myChart.destroy();
  }, [ref]);
  return /* @__PURE__ */ React__default.createElement("canvas", { ref });
};
var tabContainer = "_6nlxhl0";
var tabElem = "_6nlxhl1";
var tabSelected = "_6nlxhl2";
var tabUnselected = "_6nlxhl3";
const Tabs = ({ tabs, defaultTab = 0 }) => {
  const [tabActif, setTabActif] = useState(defaultTab);
  const changerTab = (index2) => {
    setTabActif(index2);
    tabs[index2].callback();
  };
  return /* @__PURE__ */ React__default.createElement("div", { className: tabContainer }, tabs.map((tab, index2) => /* @__PURE__ */ React__default.createElement(
    "button",
    {
      type: "button",
      key: tab.id,
      className: `${tabElem} ${index2 === tabActif ? tabSelected : tabUnselected}`,
      onClick: () => index2 !== tabActif && changerTab(index2),
      "aria-label": "Onglet " + index2
    },
    tab.icon,
    tab.texte
  )));
};
var title$1 = "_1fj03ct0";
var Table$1 = "_1fj03ct1";
var Cell = "_1fj03ct2";
var blueText = "_1fj03ct3";
var currencyFlag = "_1fj03ct4";
const def = "data:image/svg+xml,%3c!--%20Uploaded%20to:%20SVG%20Repo,%20www.svgrepo.com,%20Generator:%20SVG%20Repo%20Mixer%20Tools%20--%3e%3csvg%20height='800px'%20width='800px'%20version='1.1'%20id='Layer_1'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%20viewBox='0%200%20291.764%20291.764'%20xml:space='preserve'%3e%3cg%3e%3cpath%20style='fill:%23EFC75E;'%20d='M145.882,0c80.573,0,145.882,65.319,145.882,145.882s-65.31,145.882-145.882,145.882%20S0,226.446,0,145.882S65.31,0,145.882,0z'/%3e%3cpath%20style='fill:%23CC9933;'%20d='M145.882,27.353c-65.465,0-118.529,53.065-118.529,118.529s53.065,118.529,118.529,118.529%20s118.529-53.065,118.529-118.529S211.347,27.353,145.882,27.353z%20M145.882,246.176c-55.39,0-100.294-44.904-100.294-100.294%20S90.493,45.588,145.882,45.588s100.294,44.904,100.294,100.294S201.281,246.176,145.882,246.176z%20M158.009,138.269%20c-5.452-2.289-25.493-5.452-25.493-14.214c0-6.464,7.495-8.334,11.99-8.334c4.094,0,8.999,1.295,11.589,3.875%20c1.641,1.577,2.316,2.726,2.854,4.313c0.684,1.869,1.094,3.875,3.684,3.875h13.357c3.136,0,3.957-0.574,3.957-4.021%20c0-14.789-11.589-23.122-24.809-25.994V86.28c0-2.58-0.821-4.167-3.957-4.167h-10.64c-3.136,0-3.957,1.577-3.957,4.167v11.051%20c-14.178,2.726-26.031,11.634-26.031,27.718c0,18.235,12.683,23.979,26.441,28.566c11.589,3.884,23.724,4.021,23.724,12.063%20s-5.99,9.765-13.357,9.765c-5.051,0-10.631-1.304-13.366-4.741c-1.769-2.152-2.453-4.021-2.58-5.89%20c-0.274-3.592-1.769-4.021-4.914-4.021H113.28c-3.136,0-3.957,0.729-3.957,4.021c0,16.366,13.093,26.286,27.262,29.441v11.206%20c0,2.58,0.821,4.167,3.957,4.167h10.64c3.136,0,3.957-1.586,3.957-4.167v-10.905c16.084-2.453,27.125-12.209,27.125-29.441%20C182.28,145.591,167.829,141.424,158.009,138.269z'/%3e%3c/g%3e%3c/svg%3e";
const eu = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%20id='flag-icons-eu'%20viewBox='0%200%20512%20512'%3e%3cdefs%3e%3cg%20id='eu-d'%3e%3cg%20id='eu-b'%3e%3cpath%20id='eu-a'%20d='m0-1-.3%201%20.5.1z'/%3e%3cuse%20xlink:href='%23eu-a'%20transform='scale(-1%201)'/%3e%3c/g%3e%3cg%20id='eu-c'%3e%3cuse%20xlink:href='%23eu-b'%20transform='rotate(72)'/%3e%3cuse%20xlink:href='%23eu-b'%20transform='rotate(144)'/%3e%3c/g%3e%3cuse%20xlink:href='%23eu-c'%20transform='scale(-1%201)'/%3e%3c/g%3e%3c/defs%3e%3cpath%20fill='%23039'%20d='M0%200h512v512H0z'/%3e%3cg%20fill='%23fc0'%20transform='translate(256%20258.4)%20scale(25.28395)'%3e%3cuse%20xlink:href='%23eu-d'%20width='100%25'%20height='100%25'%20y='-6'/%3e%3cuse%20xlink:href='%23eu-d'%20width='100%25'%20height='100%25'%20y='6'/%3e%3cg%20id='eu-e'%3e%3cuse%20xlink:href='%23eu-d'%20width='100%25'%20height='100%25'%20x='-6'/%3e%3cuse%20xlink:href='%23eu-d'%20width='100%25'%20height='100%25'%20transform='rotate(-144%20-2.3%20-2.1)'/%3e%3cuse%20xlink:href='%23eu-d'%20width='100%25'%20height='100%25'%20transform='rotate(144%20-2.1%20-2.3)'/%3e%3cuse%20xlink:href='%23eu-d'%20width='100%25'%20height='100%25'%20transform='rotate(72%20-4.7%20-2)'/%3e%3cuse%20xlink:href='%23eu-d'%20width='100%25'%20height='100%25'%20transform='rotate(72%20-5%20.5)'/%3e%3c/g%3e%3cuse%20xlink:href='%23eu-e'%20width='100%25'%20height='100%25'%20transform='scale(-1%201)'/%3e%3c/g%3e%3c/svg%3e";
const gb = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20id='flag-icons-gb'%20viewBox='0%200%20512%20512'%3e%3cpath%20fill='%23012169'%20d='M0%200h512v512H0z'/%3e%3cpath%20fill='%23FFF'%20d='M512%200v64L322%20256l190%20187v69h-67L254%20324%2068%20512H0v-68l186-187L0%2074V0h62l192%20188L440%200z'/%3e%3cpath%20fill='%23C8102E'%20d='m184%20324%2011%2034L42%20512H0v-3l184-185zm124-12%2054%208%20150%20147v45L308%20312zM512%200%20320%20196l-4-44L466%200h46zM0%201l193%20189-59-8L0%2049V1z'/%3e%3cpath%20fill='%23FFF'%20d='M176%200v512h160V0H176zM0%20176v160h512V176H0z'/%3e%3cpath%20fill='%23C8102E'%20d='M0%20208v96h512v-96H0zM208%200v512h96V0h-96z'/%3e%3c/svg%3e";
const jp = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20id='flag-icons-jp'%20viewBox='0%200%20512%20512'%3e%3cdefs%3e%3cclipPath%20id='jp-a'%3e%3cpath%20fill-opacity='.7'%20d='M177.2%200h708.6v708.7H177.2z'/%3e%3c/clipPath%3e%3c/defs%3e%3cg%20fill-rule='evenodd'%20stroke-width='1pt'%20clip-path='url(%23jp-a)'%20transform='translate(-128)%20scale(.72249)'%3e%3cpath%20fill='%23fff'%20d='M0%200h1063v708.7H0z'/%3e%3ccircle%20cx='523.1'%20cy='344.1'%20r='194.9'%20fill='%23bc002d'%20transform='translate(-59.7%20-34.5)%20scale(1.1302)'/%3e%3c/g%3e%3c/svg%3e";
const us = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20id='flag-icons-us'%20viewBox='0%200%20512%20512'%3e%3cpath%20fill='%23bd3d44'%20d='M0%200h512v512H0'/%3e%3cpath%20stroke='%23fff'%20stroke-width='40'%20d='M0%2058h512M0%20137h512M0%20216h512M0%20295h512M0%20374h512M0%20453h512'/%3e%3cpath%20fill='%23192f5d'%20d='M0%200h390v275H0z'/%3e%3cmarker%20id='us-a'%20markerHeight='30'%20markerWidth='30'%3e%3cpath%20fill='%23fff'%20d='m15%200%209.3%2028.6L0%2011h30L5.7%2028.6'/%3e%3c/marker%3e%3cpath%20fill='none'%20marker-mid='url(%23us-a)'%20d='m0%200%2018%2011h65%2065%2065%2065%2066L51%2039h65%2065%2065%2065L18%2066h65%2065%2065%2065%2066L51%2094h65%2065%2065%2065L18%20121h65%2065%2065%2065%2066L51%20149h65%2065%2065%2065L18%20177h65%2065%2065%2065%2066L51%20205h65%2065%2065%2065L18%20232h65%2065%2065%2065%2066L0%200'/%3e%3c/svg%3e";
const currencyFlagImage = (code) => {
  switch (code) {
    case "EUR":
      return eu;
    case "USD":
      return us;
    case "JPY":
      return jp;
    case "GBP":
      return gb;
    default:
      return def;
  }
};
const CurrencyTab = ({ items, tabTitle }) => {
  return /* @__PURE__ */ React__default.createElement(Card, { hoverEffect: false }, /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("div", { className: title$1 }, tabTitle), /* @__PURE__ */ React__default.createElement("table", { className: Table$1 }, /* @__PURE__ */ React__default.createElement("thead", null, /* @__PURE__ */ React__default.createElement("tr", { className: Cell }, /* @__PURE__ */ React__default.createElement("td", { className: Cell }), items.map((currency) => /* @__PURE__ */ React__default.createElement("td", { className: Cell, key: currency.code }, /* @__PURE__ */ React__default.createElement("img", { src: currencyFlagImage(currency.code), className: currencyFlag, alt: "" }), currency.code)))), /* @__PURE__ */ React__default.createElement("tbody", null, items.map(
    (l2) => /* @__PURE__ */ React__default.createElement("tr", { className: Cell, key: l2.code }, [
      /* @__PURE__ */ React__default.createElement("td", { className: Cell, key: l2.code }, /* @__PURE__ */ React__default.createElement("img", { src: currencyFlagImage(l2.code), className: currencyFlag, alt: "" }), l2.code),
      items.map((c4) => {
        let value = c4.value / l2.value;
        return /* @__PURE__ */ React__default.createElement("td", { className: classNames$1(Cell, value == 1 ? "" : blueText), key: l2.code + c4.code }, value.toFixed(4));
      })
    ])
  )))));
};
var counter = "fzuuj00";
var backgroundIcon = "fzuuj01";
var circle = "fzuuj03";
var title = "fzuuj04";
var header = "fzuuj05";
const OrdersToSignNumber = ({ remainingOrders, tabTitle }) => {
  return /* @__PURE__ */ React__default.createElement(Card, { hoverEffect: false }, /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("div", { className: header }, /* @__PURE__ */ React__default.createElement("div", { className: title }, tabTitle)), /* @__PURE__ */ React__default.createElement("div", { className: circle }, /* @__PURE__ */ React__default.createElement("div", { className: backgroundIcon }, /* @__PURE__ */ React__default.createElement(Icon$2, { size: 95, icon: "Signature", color: theme.colours.brand.color4 })), /* @__PURE__ */ React__default.createElement("div", { className: counter }, remainingOrders ? remainingOrders : "0"))));
};
var linkStyle = "_104fr2w0";
var separatorStyle = "_104fr2w1";
const Breadcrumbs = ({ links, separator: separator2 = "/" }) => {
  return /* @__PURE__ */ React__default.createElement("div", { className: "" }, links && links.map((link, index2) => {
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, { key: link.id }, link.link ? /* @__PURE__ */ React__default.createElement(Link$1, { to: link.link, key: link.id, className: linkStyle }, link.label) : /* @__PURE__ */ React__default.createElement("span", { key: link.id }, link.label), index2 !== links.length - 1 ? /* @__PURE__ */ React__default.createElement("span", { className: separatorStyle }, " ", " " + separator2 + " ", " ") : "");
  }));
};
const $409067139f391064$var$COLLAPSIBLE_NAME = "Collapsible";
const [$409067139f391064$var$createCollapsibleContext, $409067139f391064$export$952b32dcbe73087a] = $c512c27ab02ef895$export$50c7b4e9d9f19c1($409067139f391064$var$COLLAPSIBLE_NAME);
const [$409067139f391064$var$CollapsibleProvider, $409067139f391064$var$useCollapsibleContext] = $409067139f391064$var$createCollapsibleContext($409067139f391064$var$COLLAPSIBLE_NAME);
const $409067139f391064$export$6eb0f7ddcda6131f = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeCollapsible, open: openProp, defaultOpen, disabled, onOpenChange, ...collapsibleProps } = props;
  const [open = false, setOpen] = $71cd76cc60e0454e$export$6f32135080cb4c3({
    prop: openProp,
    defaultProp: defaultOpen,
    onChange: onOpenChange
  });
  return /* @__PURE__ */ createElement($409067139f391064$var$CollapsibleProvider, {
    scope: __scopeCollapsible,
    disabled,
    contentId: $1746a345f3d73bb7$export$f680877a34711e37(),
    open,
    onOpenToggle: useCallback(
      () => setOpen(
        (prevOpen) => !prevOpen
      ),
      [
        setOpen
      ]
    )
  }, /* @__PURE__ */ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.div, _extends$1({
    "data-state": $409067139f391064$var$getState(open),
    "data-disabled": disabled ? "" : void 0
  }, collapsibleProps, {
    ref: forwardedRef
  })));
});
const $409067139f391064$var$TRIGGER_NAME = "CollapsibleTrigger";
const $409067139f391064$export$c135dce7b15bbbdc = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeCollapsible, ...triggerProps } = props;
  const context = $409067139f391064$var$useCollapsibleContext($409067139f391064$var$TRIGGER_NAME, __scopeCollapsible);
  return /* @__PURE__ */ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.button, _extends$1({
    type: "button",
    "aria-controls": context.contentId,
    "aria-expanded": context.open || false,
    "data-state": $409067139f391064$var$getState(context.open),
    "data-disabled": context.disabled ? "" : void 0,
    disabled: context.disabled
  }, triggerProps, {
    ref: forwardedRef,
    onClick: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onClick, context.onOpenToggle)
  }));
});
const $409067139f391064$var$CONTENT_NAME = "CollapsibleContent";
const $409067139f391064$export$aadde00976f34151 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { forceMount, ...contentProps } = props;
  const context = $409067139f391064$var$useCollapsibleContext($409067139f391064$var$CONTENT_NAME, props.__scopeCollapsible);
  return /* @__PURE__ */ createElement(
    $921a889cee6df7e8$export$99c2b779aa4e8b8b,
    {
      present: forceMount || context.open
    },
    ({ present }) => /* @__PURE__ */ createElement($409067139f391064$var$CollapsibleContentImpl, _extends$1({}, contentProps, {
      ref: forwardedRef,
      present
    }))
  );
});
const $409067139f391064$var$CollapsibleContentImpl = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeCollapsible, present, children, ...contentProps } = props;
  const context = $409067139f391064$var$useCollapsibleContext($409067139f391064$var$CONTENT_NAME, __scopeCollapsible);
  const [isPresent, setIsPresent] = useState(present);
  const ref = useRef(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, ref);
  const heightRef = useRef(0);
  const height2 = heightRef.current;
  const widthRef = useRef(0);
  const width = widthRef.current;
  const isOpen = context.open || isPresent;
  const isMountAnimationPreventedRef = useRef(isOpen);
  const originalStylesRef = useRef();
  useEffect(() => {
    const rAF = requestAnimationFrame(
      () => isMountAnimationPreventedRef.current = false
    );
    return () => cancelAnimationFrame(rAF);
  }, []);
  $9f79659886946c16$export$e5c5a5f917a5871c(() => {
    const node2 = ref.current;
    if (node2) {
      originalStylesRef.current = originalStylesRef.current || {
        transitionDuration: node2.style.transitionDuration,
        animationName: node2.style.animationName
      };
      node2.style.transitionDuration = "0s";
      node2.style.animationName = "none";
      const rect = node2.getBoundingClientRect();
      heightRef.current = rect.height;
      widthRef.current = rect.width;
      if (!isMountAnimationPreventedRef.current) {
        node2.style.transitionDuration = originalStylesRef.current.transitionDuration;
        node2.style.animationName = originalStylesRef.current.animationName;
      }
      setIsPresent(present);
    }
  }, [
    context.open,
    present
  ]);
  return /* @__PURE__ */ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.div, _extends$1({
    "data-state": $409067139f391064$var$getState(context.open),
    "data-disabled": context.disabled ? "" : void 0,
    id: context.contentId,
    hidden: !isOpen
  }, contentProps, {
    ref: composedRefs,
    style: {
      [`--radix-collapsible-content-height`]: height2 ? `${height2}px` : void 0,
      [`--radix-collapsible-content-width`]: width ? `${width}px` : void 0,
      ...props.style
    }
  }), isOpen && children);
});
function $409067139f391064$var$getState(open) {
  return open ? "open" : "closed";
}
const $409067139f391064$export$be92b6f5f03c0fe9 = $409067139f391064$export$6eb0f7ddcda6131f;
const $409067139f391064$export$41fb9f06171c75f4 = $409067139f391064$export$c135dce7b15bbbdc;
const $409067139f391064$export$7c6e2c02157bb7d2 = $409067139f391064$export$aadde00976f34151;
const $1bf158f521e1b1b4$var$ACCORDION_NAME = "Accordion";
const $1bf158f521e1b1b4$var$ACCORDION_KEYS = [
  "Home",
  "End",
  "ArrowDown",
  "ArrowUp",
  "ArrowLeft",
  "ArrowRight"
];
const [$1bf158f521e1b1b4$var$Collection, $1bf158f521e1b1b4$var$useCollection, $1bf158f521e1b1b4$var$createCollectionScope] = $e02a7d9cb1dc128c$export$c74125a8e3af6bb2($1bf158f521e1b1b4$var$ACCORDION_NAME);
const [$1bf158f521e1b1b4$var$createAccordionContext, $1bf158f521e1b1b4$export$9748edc328a73be1] = $c512c27ab02ef895$export$50c7b4e9d9f19c1($1bf158f521e1b1b4$var$ACCORDION_NAME, [
  $1bf158f521e1b1b4$var$createCollectionScope,
  $409067139f391064$export$952b32dcbe73087a
]);
const $1bf158f521e1b1b4$var$useCollapsibleScope = $409067139f391064$export$952b32dcbe73087a();
const $1bf158f521e1b1b4$export$a766cd26d0d69044 = /* @__PURE__ */ React__default.forwardRef((props, forwardedRef) => {
  const { type: type2, ...accordionProps } = props;
  const singleProps = accordionProps;
  const multipleProps = accordionProps;
  return /* @__PURE__ */ React__default.createElement($1bf158f521e1b1b4$var$Collection.Provider, {
    scope: props.__scopeAccordion
  }, type2 === "multiple" ? /* @__PURE__ */ React__default.createElement($1bf158f521e1b1b4$var$AccordionImplMultiple, _extends$1({}, multipleProps, {
    ref: forwardedRef
  })) : /* @__PURE__ */ React__default.createElement($1bf158f521e1b1b4$var$AccordionImplSingle, _extends$1({}, singleProps, {
    ref: forwardedRef
  })));
});
$1bf158f521e1b1b4$export$a766cd26d0d69044.propTypes = {
  type(props) {
    const value = props.value || props.defaultValue;
    if (props.type && ![
      "single",
      "multiple"
    ].includes(props.type)) return new Error("Invalid prop `type` supplied to `Accordion`. Expected one of `single | multiple`.");
    if (props.type === "multiple" && typeof value === "string") return new Error("Invalid prop `type` supplied to `Accordion`. Expected `single` when `defaultValue` or `value` is type `string`.");
    if (props.type === "single" && Array.isArray(value)) return new Error("Invalid prop `type` supplied to `Accordion`. Expected `multiple` when `defaultValue` or `value` is type `string[]`.");
    return null;
  }
};
const [$1bf158f521e1b1b4$var$AccordionValueProvider, $1bf158f521e1b1b4$var$useAccordionValueContext] = $1bf158f521e1b1b4$var$createAccordionContext($1bf158f521e1b1b4$var$ACCORDION_NAME);
const [$1bf158f521e1b1b4$var$AccordionCollapsibleProvider, $1bf158f521e1b1b4$var$useAccordionCollapsibleContext] = $1bf158f521e1b1b4$var$createAccordionContext($1bf158f521e1b1b4$var$ACCORDION_NAME, {
  collapsible: false
});
const $1bf158f521e1b1b4$var$AccordionImplSingle = /* @__PURE__ */ React__default.forwardRef((props, forwardedRef) => {
  const { value: valueProp, defaultValue, onValueChange = () => {
  }, collapsible = false, ...accordionSingleProps } = props;
  const [value, setValue] = $71cd76cc60e0454e$export$6f32135080cb4c3({
    prop: valueProp,
    defaultProp: defaultValue,
    onChange: onValueChange
  });
  return /* @__PURE__ */ React__default.createElement($1bf158f521e1b1b4$var$AccordionValueProvider, {
    scope: props.__scopeAccordion,
    value: value ? [
      value
    ] : [],
    onItemOpen: setValue,
    onItemClose: React__default.useCallback(
      () => collapsible && setValue(""),
      [
        collapsible,
        setValue
      ]
    )
  }, /* @__PURE__ */ React__default.createElement($1bf158f521e1b1b4$var$AccordionCollapsibleProvider, {
    scope: props.__scopeAccordion,
    collapsible
  }, /* @__PURE__ */ React__default.createElement($1bf158f521e1b1b4$var$AccordionImpl, _extends$1({}, accordionSingleProps, {
    ref: forwardedRef
  }))));
});
const $1bf158f521e1b1b4$var$AccordionImplMultiple = /* @__PURE__ */ React__default.forwardRef((props, forwardedRef) => {
  const { value: valueProp, defaultValue, onValueChange = () => {
  }, ...accordionMultipleProps } = props;
  const [value1 = [], setValue] = $71cd76cc60e0454e$export$6f32135080cb4c3({
    prop: valueProp,
    defaultProp: defaultValue,
    onChange: onValueChange
  });
  const handleItemOpen = React__default.useCallback(
    (itemValue) => setValue(
      (prevValue = []) => [
        ...prevValue,
        itemValue
      ]
    ),
    [
      setValue
    ]
  );
  const handleItemClose = React__default.useCallback(
    (itemValue) => setValue(
      (prevValue = []) => prevValue.filter(
        (value) => value !== itemValue
      )
    ),
    [
      setValue
    ]
  );
  return /* @__PURE__ */ React__default.createElement($1bf158f521e1b1b4$var$AccordionValueProvider, {
    scope: props.__scopeAccordion,
    value: value1,
    onItemOpen: handleItemOpen,
    onItemClose: handleItemClose
  }, /* @__PURE__ */ React__default.createElement($1bf158f521e1b1b4$var$AccordionCollapsibleProvider, {
    scope: props.__scopeAccordion,
    collapsible: true
  }, /* @__PURE__ */ React__default.createElement($1bf158f521e1b1b4$var$AccordionImpl, _extends$1({}, accordionMultipleProps, {
    ref: forwardedRef
  }))));
});
const [$1bf158f521e1b1b4$var$AccordionImplProvider, $1bf158f521e1b1b4$var$useAccordionContext] = $1bf158f521e1b1b4$var$createAccordionContext($1bf158f521e1b1b4$var$ACCORDION_NAME);
const $1bf158f521e1b1b4$var$AccordionImpl = /* @__PURE__ */ React__default.forwardRef((props, forwardedRef) => {
  const { __scopeAccordion, disabled, dir, orientation = "vertical", ...accordionProps } = props;
  const accordionRef = React__default.useRef(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(accordionRef, forwardedRef);
  const getItems = $1bf158f521e1b1b4$var$useCollection(__scopeAccordion);
  const direction = $f631663db3294ace$export$b39126d51d94e6f3(dir);
  const isDirectionLTR = direction === "ltr";
  const handleKeyDown = $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onKeyDown, (event) => {
    var _triggerCollection$cl;
    if (!$1bf158f521e1b1b4$var$ACCORDION_KEYS.includes(event.key)) return;
    const target = event.target;
    const triggerCollection = getItems().filter((item) => {
      var _item$ref$current;
      return !((_item$ref$current = item.ref.current) !== null && _item$ref$current !== void 0 && _item$ref$current.disabled);
    });
    const triggerIndex = triggerCollection.findIndex(
      (item) => item.ref.current === target
    );
    const triggerCount = triggerCollection.length;
    if (triggerIndex === -1) return;
    event.preventDefault();
    let nextIndex = triggerIndex;
    const homeIndex = 0;
    const endIndex = triggerCount - 1;
    const moveNext = () => {
      nextIndex = triggerIndex + 1;
      if (nextIndex > endIndex) nextIndex = homeIndex;
    };
    const movePrev = () => {
      nextIndex = triggerIndex - 1;
      if (nextIndex < homeIndex) nextIndex = endIndex;
    };
    switch (event.key) {
      case "Home":
        nextIndex = homeIndex;
        break;
      case "End":
        nextIndex = endIndex;
        break;
      case "ArrowRight":
        if (orientation === "horizontal") {
          if (isDirectionLTR) moveNext();
          else movePrev();
        }
        break;
      case "ArrowDown":
        if (orientation === "vertical") moveNext();
        break;
      case "ArrowLeft":
        if (orientation === "horizontal") {
          if (isDirectionLTR) movePrev();
          else moveNext();
        }
        break;
      case "ArrowUp":
        if (orientation === "vertical") movePrev();
        break;
    }
    const clampedIndex = nextIndex % triggerCount;
    (_triggerCollection$cl = triggerCollection[clampedIndex].ref.current) === null || _triggerCollection$cl === void 0 || _triggerCollection$cl.focus();
  });
  return /* @__PURE__ */ React__default.createElement($1bf158f521e1b1b4$var$AccordionImplProvider, {
    scope: __scopeAccordion,
    disabled,
    direction: dir,
    orientation
  }, /* @__PURE__ */ React__default.createElement($1bf158f521e1b1b4$var$Collection.Slot, {
    scope: __scopeAccordion
  }, /* @__PURE__ */ React__default.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.div, _extends$1({}, accordionProps, {
    "data-orientation": orientation,
    ref: composedRefs,
    onKeyDown: disabled ? void 0 : handleKeyDown
  }))));
});
const $1bf158f521e1b1b4$var$ITEM_NAME = "AccordionItem";
const [$1bf158f521e1b1b4$var$AccordionItemProvider, $1bf158f521e1b1b4$var$useAccordionItemContext] = $1bf158f521e1b1b4$var$createAccordionContext($1bf158f521e1b1b4$var$ITEM_NAME);
const $1bf158f521e1b1b4$export$d99097c13d4dac9f = /* @__PURE__ */ React__default.forwardRef((props, forwardedRef) => {
  const { __scopeAccordion, value, ...accordionItemProps } = props;
  const accordionContext = $1bf158f521e1b1b4$var$useAccordionContext($1bf158f521e1b1b4$var$ITEM_NAME, __scopeAccordion);
  const valueContext = $1bf158f521e1b1b4$var$useAccordionValueContext($1bf158f521e1b1b4$var$ITEM_NAME, __scopeAccordion);
  const collapsibleScope = $1bf158f521e1b1b4$var$useCollapsibleScope(__scopeAccordion);
  const triggerId = $1746a345f3d73bb7$export$f680877a34711e37();
  const open1 = value && valueContext.value.includes(value) || false;
  const disabled = accordionContext.disabled || props.disabled;
  return /* @__PURE__ */ React__default.createElement($1bf158f521e1b1b4$var$AccordionItemProvider, {
    scope: __scopeAccordion,
    open: open1,
    disabled,
    triggerId
  }, /* @__PURE__ */ React__default.createElement($409067139f391064$export$be92b6f5f03c0fe9, _extends$1({
    "data-orientation": accordionContext.orientation,
    "data-state": $1bf158f521e1b1b4$var$getState(open1)
  }, collapsibleScope, accordionItemProps, {
    ref: forwardedRef,
    disabled,
    open: open1,
    onOpenChange: (open) => {
      if (open) valueContext.onItemOpen(value);
      else valueContext.onItemClose(value);
    }
  })));
});
const $1bf158f521e1b1b4$var$HEADER_NAME = "AccordionHeader";
const $1bf158f521e1b1b4$export$5e3e5deaaf81ee41 = /* @__PURE__ */ React__default.forwardRef((props, forwardedRef) => {
  const { __scopeAccordion, ...headerProps } = props;
  const accordionContext = $1bf158f521e1b1b4$var$useAccordionContext($1bf158f521e1b1b4$var$ACCORDION_NAME, __scopeAccordion);
  const itemContext = $1bf158f521e1b1b4$var$useAccordionItemContext($1bf158f521e1b1b4$var$HEADER_NAME, __scopeAccordion);
  return /* @__PURE__ */ React__default.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.h3, _extends$1({
    "data-orientation": accordionContext.orientation,
    "data-state": $1bf158f521e1b1b4$var$getState(itemContext.open),
    "data-disabled": itemContext.disabled ? "" : void 0
  }, headerProps, {
    ref: forwardedRef
  }));
});
const $1bf158f521e1b1b4$var$TRIGGER_NAME = "AccordionTrigger";
const $1bf158f521e1b1b4$export$94e939b1f85bdd73 = /* @__PURE__ */ React__default.forwardRef((props, forwardedRef) => {
  const { __scopeAccordion, ...triggerProps } = props;
  const accordionContext = $1bf158f521e1b1b4$var$useAccordionContext($1bf158f521e1b1b4$var$ACCORDION_NAME, __scopeAccordion);
  const itemContext = $1bf158f521e1b1b4$var$useAccordionItemContext($1bf158f521e1b1b4$var$TRIGGER_NAME, __scopeAccordion);
  const collapsibleContext = $1bf158f521e1b1b4$var$useAccordionCollapsibleContext($1bf158f521e1b1b4$var$TRIGGER_NAME, __scopeAccordion);
  const collapsibleScope = $1bf158f521e1b1b4$var$useCollapsibleScope(__scopeAccordion);
  return /* @__PURE__ */ React__default.createElement($1bf158f521e1b1b4$var$Collection.ItemSlot, {
    scope: __scopeAccordion
  }, /* @__PURE__ */ React__default.createElement($409067139f391064$export$41fb9f06171c75f4, _extends$1({
    "aria-disabled": itemContext.open && !collapsibleContext.collapsible || void 0,
    "data-orientation": accordionContext.orientation,
    id: itemContext.triggerId
  }, collapsibleScope, triggerProps, {
    ref: forwardedRef
  })));
});
const $1bf158f521e1b1b4$var$CONTENT_NAME = "AccordionContent";
const $1bf158f521e1b1b4$export$985b9a77379b54a0 = /* @__PURE__ */ React__default.forwardRef((props, forwardedRef) => {
  const { __scopeAccordion, ...contentProps } = props;
  const accordionContext = $1bf158f521e1b1b4$var$useAccordionContext($1bf158f521e1b1b4$var$ACCORDION_NAME, __scopeAccordion);
  const itemContext = $1bf158f521e1b1b4$var$useAccordionItemContext($1bf158f521e1b1b4$var$CONTENT_NAME, __scopeAccordion);
  const collapsibleScope = $1bf158f521e1b1b4$var$useCollapsibleScope(__scopeAccordion);
  return /* @__PURE__ */ React__default.createElement($409067139f391064$export$7c6e2c02157bb7d2, _extends$1({
    role: "region",
    "aria-labelledby": itemContext.triggerId,
    "data-orientation": accordionContext.orientation
  }, collapsibleScope, contentProps, {
    ref: forwardedRef,
    style: {
      ["--radix-accordion-content-height"]: "var(--radix-collapsible-content-height)",
      ["--radix-accordion-content-width"]: "var(--radix-collapsible-content-width)",
      ...props.style
    }
  }));
});
function $1bf158f521e1b1b4$var$getState(open) {
  return open ? "open" : "closed";
}
const $1bf158f521e1b1b4$export$be92b6f5f03c0fe9 = $1bf158f521e1b1b4$export$a766cd26d0d69044;
const $1bf158f521e1b1b4$export$6d08773d2e66f8f2 = $1bf158f521e1b1b4$export$d99097c13d4dac9f;
const $1bf158f521e1b1b4$export$8b251419efc915eb = $1bf158f521e1b1b4$export$5e3e5deaaf81ee41;
const $1bf158f521e1b1b4$export$41fb9f06171c75f4 = $1bf158f521e1b1b4$export$94e939b1f85bdd73;
const $1bf158f521e1b1b4$export$7c6e2c02157bb7d2 = $1bf158f521e1b1b4$export$985b9a77379b54a0;
var AccordionItem = "_1ktevk90";
var AccordionHeader = "_1ktevk91";
var AccordionRoot = "_1ktevk92";
var AccordionTriggerClass = "_1ktevk93";
var AccordionChevron = "_1ktevk94";
var AccordionContentClass = "_1ktevk97";
var AccordionContentItem = "_1ktevk98";
var AccordionHeaderHelperClass = "_1ktevk99";
var AccordionItemWrapper = "_1ktevk9a";
var AccordionItemTitle = "_1ktevk9b";
var AccordionItemValue = "_1ktevk9c";
const AccordionPanel = ({ title: title2, children, defaultOpen = false }) => {
  return /* @__PURE__ */ React__default.createElement($1bf158f521e1b1b4$export$be92b6f5f03c0fe9, { className: AccordionRoot, type: "single", collapsible: true, defaultValue: defaultOpen ? "item1" : "" }, /* @__PURE__ */ React__default.createElement($1bf158f521e1b1b4$export$6d08773d2e66f8f2, { className: AccordionItem, value: "item1" }, /* @__PURE__ */ React__default.createElement(AccordionTrigger, { className: AccordionTriggerClass }, title2), /* @__PURE__ */ React__default.createElement(AccordionContent, { className: "" }, children)));
};
const AccordionTrigger = React__default.forwardRef(({ children, className, ...props }, forwardedRef) => /* @__PURE__ */ React__default.createElement($1bf158f521e1b1b4$export$8b251419efc915eb, { className: AccordionHeader, asChild: true }, /* @__PURE__ */ React__default.createElement("h2", null, /* @__PURE__ */ React__default.createElement(
  $1bf158f521e1b1b4$export$41fb9f06171c75f4,
  {
    className: classNames$1("AccordionTrigger", className),
    ...props,
    ref: forwardedRef
  },
  children,
  /* @__PURE__ */ React__default.createElement(Icon$2, { icon: "Chevron", className: AccordionChevron, size: 16, "aria-hidden": true })
))));
const AccordionContent = React__default.forwardRef(({ children, className, ...props }, forwardedRef) => /* @__PURE__ */ React__default.createElement(
  $1bf158f521e1b1b4$export$7c6e2c02157bb7d2,
  {
    className: classNames$1(AccordionContentClass, className),
    ...props,
    ref: forwardedRef
  },
  /* @__PURE__ */ React__default.createElement("div", { className: AccordionContentItem }, " ", children)
));
const AccordionHeaderHelper = (props) => {
  return /* @__PURE__ */ React__default.createElement("div", { className: AccordionHeaderHelperClass }, props.children);
};
AccordionPanel.AccordionHeaderHelper = AccordionHeaderHelper;
const AccordionHeaderItemHelper = (props) => {
  return /* @__PURE__ */ React__default.createElement("div", { className: AccordionItemWrapper }, /* @__PURE__ */ React__default.createElement("span", { className: AccordionItemTitle }, props.title), /* @__PURE__ */ React__default.createElement("span", { className: AccordionItemValue }, props.value));
};
AccordionPanel.AccordionHeaderItemHelper = AccordionHeaderItemHelper;
var HelloClientContainer = "_1546gab0";
var TextContainer = "_1546gab1";
var Icon = "_1546gab2";
var TextHeader = "_1546gab3";
const HelloClient = ({ name, hello, description }) => {
  return /* @__PURE__ */ React__default.createElement("div", { className: HelloClientContainer }, /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("span", { className: Icon }, "👋")), /* @__PURE__ */ React__default.createElement("div", { className: TextContainer }, /* @__PURE__ */ React__default.createElement("span", { className: TextHeader }, hello), /* @__PURE__ */ React__default.createElement("span", { className: TextHeader }, name, ","), /* @__PURE__ */ React__default.createElement("span", null, description)));
};
function _typeof(o2) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o3) {
    return typeof o3;
  } : function(o3) {
    return o3 && "function" == typeof Symbol && o3.constructor === Symbol && o3 !== Symbol.prototype ? "symbol" : typeof o3;
  }, _typeof(o2);
}
function toPrimitive(t2, r2) {
  if ("object" != _typeof(t2) || !t2) return t2;
  var e2 = t2[Symbol.toPrimitive];
  if (void 0 !== e2) {
    var i = e2.call(t2, r2 || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t2);
}
function toPropertyKey(t2) {
  var i = toPrimitive(t2, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _defineProperty(obj, key, value) {
  key = toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function ownKeys(e2, r2) {
  var t2 = Object.keys(e2);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e2);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e2, r3).enumerable;
    })), t2.push.apply(t2, o2);
  }
  return t2;
}
function _objectSpread2(e2) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t2 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys(Object(t2), true).forEach(function(r3) {
      _defineProperty(e2, r3, t2[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e2, Object.getOwnPropertyDescriptors(t2)) : ownKeys(Object(t2)).forEach(function(r3) {
      Object.defineProperty(e2, r3, Object.getOwnPropertyDescriptor(t2, r3));
    });
  }
  return e2;
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(r2, l2) {
  var t2 = null == r2 ? null : "undefined" != typeof Symbol && r2[Symbol.iterator] || r2["@@iterator"];
  if (null != t2) {
    var e2, n2, i, u2, a2 = [], f2 = true, o2 = false;
    try {
      if (i = (t2 = t2.call(r2)).next, 0 === l2) {
        if (Object(t2) !== t2) return;
        f2 = false;
      } else for (; !(f2 = (e2 = i.call(t2)).done) && (a2.push(e2.value), a2.length !== l2); f2 = true) ;
    } catch (r3) {
      o2 = true, n2 = r3;
    } finally {
      try {
        if (!f2 && null != t2["return"] && (u2 = t2["return"](), Object(u2) !== u2)) return;
      } finally {
        if (o2) throw n2;
      }
    }
    return a2;
  }
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _unsupportedIterableToArray(o2, minLen) {
  if (!o2) return;
  if (typeof o2 === "string") return _arrayLikeToArray(o2, minLen);
  var n2 = Object.prototype.toString.call(o2).slice(8, -1);
  if (n2 === "Object" && o2.constructor) n2 = o2.constructor.name;
  if (n2 === "Map" || n2 === "Set") return Array.from(o2);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2)) return _arrayLikeToArray(o2, minLen);
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$1(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
var _excluded$7 = ["defaultInputValue", "defaultMenuIsOpen", "defaultValue", "inputValue", "menuIsOpen", "onChange", "onInputChange", "onMenuClose", "onMenuOpen", "value"];
function useStateManager(_ref3) {
  var _ref$defaultInputValu = _ref3.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? "" : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref3.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref3.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref3.inputValue, propsMenuIsOpen = _ref3.menuIsOpen, propsOnChange = _ref3.onChange, propsOnInputChange = _ref3.onInputChange, propsOnMenuClose = _ref3.onMenuClose, propsOnMenuOpen = _ref3.onMenuOpen, propsValue = _ref3.value, restSelectProps = _objectWithoutProperties(_ref3, _excluded$7);
  var _useState = useState(propsInputValue !== void 0 ? propsInputValue : defaultInputValue), _useState2 = _slicedToArray(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
  var _useState3 = useState(propsMenuIsOpen !== void 0 ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = _slicedToArray(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
  var _useState5 = useState(propsValue !== void 0 ? propsValue : defaultValue), _useState6 = _slicedToArray(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
  var onChange2 = useCallback(function(value2, actionMeta) {
    if (typeof propsOnChange === "function") {
      propsOnChange(value2, actionMeta);
    }
    setStateValue(value2);
  }, [propsOnChange]);
  var onInputChange = useCallback(function(value2, actionMeta) {
    var newValue;
    if (typeof propsOnInputChange === "function") {
      newValue = propsOnInputChange(value2, actionMeta);
    }
    setStateInputValue(newValue !== void 0 ? newValue : value2);
  }, [propsOnInputChange]);
  var onMenuOpen = useCallback(function() {
    if (typeof propsOnMenuOpen === "function") {
      propsOnMenuOpen();
    }
    setStateMenuIsOpen(true);
  }, [propsOnMenuOpen]);
  var onMenuClose = useCallback(function() {
    if (typeof propsOnMenuClose === "function") {
      propsOnMenuClose();
    }
    setStateMenuIsOpen(false);
  }, [propsOnMenuClose]);
  var inputValue = propsInputValue !== void 0 ? propsInputValue : stateInputValue;
  var menuIsOpen = propsMenuIsOpen !== void 0 ? propsMenuIsOpen : stateMenuIsOpen;
  var value = propsValue !== void 0 ? propsValue : stateValue;
  return _objectSpread2(_objectSpread2({}, restSelectProps), {}, {
    inputValue,
    menuIsOpen,
    onChange: onChange2,
    onInputChange,
    onMenuClose,
    onMenuOpen,
    value
  });
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _setPrototypeOf(o2, p2) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o3, p3) {
    o3.__proto__ = p3;
    return o3;
  };
  return _setPrototypeOf(o2, p2);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o2) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o3) {
    return o3.__proto__ || Object.getPrototypeOf(o3);
  };
  return _getPrototypeOf(o2);
}
function _isNativeReflectConstruct() {
  try {
    var t2 = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t3) {
  }
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct2() {
    return !!t2;
  })();
}
function _assertThisInitialized(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _possibleConstructorReturn(self2, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self2);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function sheetForTag(tag) {
  if (tag.sheet) {
    return tag.sheet;
  }
  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      return document.styleSheets[i];
    }
  }
}
function createStyleElement(options2) {
  var tag = document.createElement("style");
  tag.setAttribute("data-emotion", options2.key);
  if (options2.nonce !== void 0) {
    tag.setAttribute("nonce", options2.nonce);
  }
  tag.appendChild(document.createTextNode(""));
  tag.setAttribute("data-s", "");
  return tag;
}
var StyleSheet = /* @__PURE__ */ function() {
  function StyleSheet2(options2) {
    var _this = this;
    this._insertTag = function(tag) {
      var before;
      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }
      _this.container.insertBefore(tag, before);
      _this.tags.push(tag);
    };
    this.isSpeedy = options2.speedy === void 0 ? process.env.NODE_ENV === "production" : options2.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options2.nonce;
    this.key = options2.key;
    this.container = options2.container;
    this.prepend = options2.prepend;
    this.insertionPoint = options2.insertionPoint;
    this.before = null;
  }
  var _proto = StyleSheet2.prototype;
  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };
  _proto.insert = function insert(rule) {
    if (this.ctr % (this.isSpeedy ? 65e3 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }
    var tag = this.tags[this.tags.length - 1];
    if (process.env.NODE_ENV !== "production") {
      var isImportRule3 = rule.charCodeAt(0) === 64 && rule.charCodeAt(1) === 105;
      if (isImportRule3 && this._alreadyInsertedOrderInsensitiveRule) {
        console.error("You're attempting to insert the following rule:\n" + rule + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules.");
      }
      this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !isImportRule3;
    }
    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);
      try {
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e2) {
        if (process.env.NODE_ENV !== "production" && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(rule)) {
          console.error('There was a problem inserting the following rule: "' + rule + '"', e2);
        }
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }
    this.ctr++;
  };
  _proto.flush = function flush() {
    this.tags.forEach(function(tag) {
      return tag.parentNode && tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;
    if (process.env.NODE_ENV !== "production") {
      this._alreadyInsertedOrderInsensitiveRule = false;
    }
  };
  return StyleSheet2;
}();
var MS = "-ms-";
var MOZ = "-moz-";
var WEBKIT = "-webkit-";
var COMMENT = "comm";
var RULESET = "rule";
var DECLARATION = "decl";
var IMPORT = "@import";
var KEYFRAMES = "@keyframes";
var LAYER = "@layer";
var abs = Math.abs;
var from = String.fromCharCode;
var assign = Object.assign;
function hash(value, length2) {
  return charat(value, 0) ^ 45 ? (((length2 << 2 ^ charat(value, 0)) << 2 ^ charat(value, 1)) << 2 ^ charat(value, 2)) << 2 ^ charat(value, 3) : 0;
}
function trim(value) {
  return value.trim();
}
function match(value, pattern) {
  return (value = pattern.exec(value)) ? value[0] : value;
}
function replace(value, pattern, replacement) {
  return value.replace(pattern, replacement);
}
function indexof(value, search) {
  return value.indexOf(search);
}
function charat(value, index2) {
  return value.charCodeAt(index2) | 0;
}
function substr(value, begin, end) {
  return value.slice(begin, end);
}
function strlen(value) {
  return value.length;
}
function sizeof(value) {
  return value.length;
}
function append(value, array) {
  return array.push(value), value;
}
function combine(array, callback2) {
  return array.map(callback2).join("");
}
var line = 1;
var column = 1;
var length = 0;
var position = 0;
var character = 0;
var characters = "";
function node(value, root, parent, type2, props, children, length2) {
  return { value, root, parent, type: type2, props, children, line, column, length: length2, return: "" };
}
function copy(root, props) {
  return assign(node("", null, null, "", null, null, 0), root, { length: -root.length }, props);
}
function char() {
  return character;
}
function prev() {
  character = position > 0 ? charat(characters, --position) : 0;
  if (column--, character === 10)
    column = 1, line--;
  return character;
}
function next() {
  character = position < length ? charat(characters, position++) : 0;
  if (column++, character === 10)
    column = 1, line++;
  return character;
}
function peek() {
  return charat(characters, position);
}
function caret() {
  return position;
}
function slice(begin, end) {
  return substr(characters, begin, end);
}
function token(type2) {
  switch (type2) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function alloc(value) {
  return line = column = 1, length = strlen(characters = value), position = 0, [];
}
function dealloc(value) {
  return characters = "", value;
}
function delimit(type2) {
  return trim(slice(position - 1, delimiter(type2 === 91 ? type2 + 2 : type2 === 40 ? type2 + 1 : type2)));
}
function whitespace(type2) {
  while (character = peek())
    if (character < 33)
      next();
    else
      break;
  return token(type2) > 2 || token(character) > 3 ? "" : " ";
}
function escaping(index2, count) {
  while (--count && next())
    if (character < 48 || character > 102 || character > 57 && character < 65 || character > 70 && character < 97)
      break;
  return slice(index2, caret() + (count < 6 && peek() == 32 && next() == 32));
}
function delimiter(type2) {
  while (next())
    switch (character) {
      case type2:
        return position;
      case 34:
      case 39:
        if (type2 !== 34 && type2 !== 39)
          delimiter(character);
        break;
      case 40:
        if (type2 === 41)
          delimiter(type2);
        break;
      case 92:
        next();
        break;
    }
  return position;
}
function commenter(type2, index2) {
  while (next())
    if (type2 + character === 47 + 10)
      break;
    else if (type2 + character === 42 + 42 && peek() === 47)
      break;
  return "/*" + slice(index2, position - 1) + "*" + from(type2 === 47 ? type2 : next());
}
function identifier(index2) {
  while (!token(peek()))
    next();
  return slice(index2, position);
}
function compile(value) {
  return dealloc(parse$1("", null, null, null, [""], value = alloc(value), 0, [0], value));
}
function parse$1(value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
  var index2 = 0;
  var offset2 = 0;
  var length2 = pseudo;
  var atrule = 0;
  var property = 0;
  var previous = 0;
  var variable = 1;
  var scanning = 1;
  var ampersand = 1;
  var character2 = 0;
  var type2 = "";
  var props = rules;
  var children = rulesets;
  var reference = rule;
  var characters2 = type2;
  while (scanning)
    switch (previous = character2, character2 = next()) {
      case 40:
        if (previous != 108 && charat(characters2, length2 - 1) == 58) {
          if (indexof(characters2 += replace(delimit(character2), "&", "&\f"), "&\f") != -1)
            ampersand = -1;
          break;
        }
      case 34:
      case 39:
      case 91:
        characters2 += delimit(character2);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        characters2 += whitespace(previous);
        break;
      case 92:
        characters2 += escaping(caret() - 1, 7);
        continue;
      case 47:
        switch (peek()) {
          case 42:
          case 47:
            append(comment(commenter(next(), caret()), root, parent), declarations);
            break;
          default:
            characters2 += "/";
        }
        break;
      case 123 * variable:
        points[index2++] = strlen(characters2) * ampersand;
      case 125 * variable:
      case 59:
      case 0:
        switch (character2) {
          case 0:
          case 125:
            scanning = 0;
          case 59 + offset2:
            if (ampersand == -1) characters2 = replace(characters2, /\f/g, "");
            if (property > 0 && strlen(characters2) - length2)
              append(property > 32 ? declaration(characters2 + ";", rule, parent, length2 - 1) : declaration(replace(characters2, " ", "") + ";", rule, parent, length2 - 2), declarations);
            break;
          case 59:
            characters2 += ";";
          default:
            append(reference = ruleset(characters2, root, parent, index2, offset2, rules, points, type2, props = [], children = [], length2), rulesets);
            if (character2 === 123)
              if (offset2 === 0)
                parse$1(characters2, root, reference, reference, props, rulesets, length2, points, children);
              else
                switch (atrule === 99 && charat(characters2, 3) === 110 ? 100 : atrule) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    parse$1(value, reference, reference, rule && append(ruleset(value, reference, reference, 0, 0, rules, points, type2, rules, props = [], length2), children), rules, children, length2, points, rule ? props : children);
                    break;
                  default:
                    parse$1(characters2, reference, reference, reference, [""], children, 0, points, children);
                }
        }
        index2 = offset2 = property = 0, variable = ampersand = 1, type2 = characters2 = "", length2 = pseudo;
        break;
      case 58:
        length2 = 1 + strlen(characters2), property = previous;
      default:
        if (variable < 1) {
          if (character2 == 123)
            --variable;
          else if (character2 == 125 && variable++ == 0 && prev() == 125)
            continue;
        }
        switch (characters2 += from(character2), character2 * variable) {
          case 38:
            ampersand = offset2 > 0 ? 1 : (characters2 += "\f", -1);
            break;
          case 44:
            points[index2++] = (strlen(characters2) - 1) * ampersand, ampersand = 1;
            break;
          case 64:
            if (peek() === 45)
              characters2 += delimit(next());
            atrule = peek(), offset2 = length2 = strlen(type2 = characters2 += identifier(caret())), character2++;
            break;
          case 45:
            if (previous === 45 && strlen(characters2) == 2)
              variable = 0;
        }
    }
  return rulesets;
}
function ruleset(value, root, parent, index2, offset2, rules, points, type2, props, children, length2) {
  var post = offset2 - 1;
  var rule = offset2 === 0 ? rules : [""];
  var size2 = sizeof(rule);
  for (var i = 0, j = 0, k2 = 0; i < index2; ++i)
    for (var x2 = 0, y2 = substr(value, post + 1, post = abs(j = points[i])), z2 = value; x2 < size2; ++x2)
      if (z2 = trim(j > 0 ? rule[x2] + " " + y2 : replace(y2, /&\f/g, rule[x2])))
        props[k2++] = z2;
  return node(value, root, parent, offset2 === 0 ? RULESET : type2, props, children, length2);
}
function comment(value, root, parent) {
  return node(value, root, parent, COMMENT, from(char()), substr(value, 2, -2), 0);
}
function declaration(value, root, parent, length2) {
  return node(value, root, parent, DECLARATION, substr(value, 0, length2), substr(value, length2 + 1, -1), length2);
}
function serialize$1(children, callback2) {
  var output = "";
  var length2 = sizeof(children);
  for (var i = 0; i < length2; i++)
    output += callback2(children[i], i, children, callback2) || "";
  return output;
}
function stringify(element, index2, children, callback2) {
  switch (element.type) {
    case LAYER:
      if (element.children.length) break;
    case IMPORT:
    case DECLARATION:
      return element.return = element.return || element.value;
    case COMMENT:
      return "";
    case KEYFRAMES:
      return element.return = element.value + "{" + serialize$1(element.children, callback2) + "}";
    case RULESET:
      element.value = element.props.join(",");
  }
  return strlen(children = serialize$1(element.children, callback2)) ? element.return = element.value + "{" + children + "}" : "";
}
function middleware(collection) {
  var length2 = sizeof(collection);
  return function(element, index2, children, callback2) {
    var output = "";
    for (var i = 0; i < length2; i++)
      output += collection[i](element, index2, children, callback2) || "";
    return output;
  };
}
function rulesheet(callback2) {
  return function(element) {
    if (!element.root) {
      if (element = element.return)
        callback2(element);
    }
  };
}
function memoize(fn) {
  var cache = /* @__PURE__ */ Object.create(null);
  return function(arg) {
    if (cache[arg] === void 0) cache[arg] = fn(arg);
    return cache[arg];
  };
}
var identifierWithPointTracking = function identifierWithPointTracking2(begin, points, index2) {
  var previous = 0;
  var character2 = 0;
  while (true) {
    previous = character2;
    character2 = peek();
    if (previous === 38 && character2 === 12) {
      points[index2] = 1;
    }
    if (token(character2)) {
      break;
    }
    next();
  }
  return slice(begin, position);
};
var toRules = function toRules2(parsed, points) {
  var index2 = -1;
  var character2 = 44;
  do {
    switch (token(character2)) {
      case 0:
        if (character2 === 38 && peek() === 12) {
          points[index2] = 1;
        }
        parsed[index2] += identifierWithPointTracking(position - 1, points, index2);
        break;
      case 2:
        parsed[index2] += delimit(character2);
        break;
      case 4:
        if (character2 === 44) {
          parsed[++index2] = peek() === 58 ? "&\f" : "";
          points[index2] = parsed[index2].length;
          break;
        }
      default:
        parsed[index2] += from(character2);
    }
  } while (character2 = next());
  return parsed;
};
var getRules = function getRules2(value, points) {
  return dealloc(toRules(alloc(value), points));
};
var fixedElements = /* @__PURE__ */ new WeakMap();
var compat = function compat2(element) {
  if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  element.length < 1) {
    return;
  }
  var value = element.value, parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;
  while (parent.type !== "rule") {
    parent = parent.parent;
    if (!parent) return;
  }
  if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !fixedElements.get(parent)) {
    return;
  }
  if (isImplicitRule) {
    return;
  }
  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent.props;
  for (var i = 0, k2 = 0; i < rules.length; i++) {
    for (var j = 0; j < parentRules.length; j++, k2++) {
      element.props[k2] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
    }
  }
};
var removeLabel = function removeLabel2(element) {
  if (element.type === "decl") {
    var value = element.value;
    if (
      // charcode for l
      value.charCodeAt(0) === 108 && // charcode for b
      value.charCodeAt(2) === 98
    ) {
      element["return"] = "";
      element.value = "";
    }
  }
};
var ignoreFlag = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason";
var isIgnoringComment = function isIgnoringComment2(element) {
  return element.type === "comm" && element.children.indexOf(ignoreFlag) > -1;
};
var createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm2(cache) {
  return function(element, index2, children) {
    if (element.type !== "rule" || cache.compat) return;
    var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
    if (unsafePseudoClasses) {
      var isNested = !!element.parent;
      var commentContainer = isNested ? element.parent.children : (
        // global rule at the root level
        children
      );
      for (var i = commentContainer.length - 1; i >= 0; i--) {
        var node2 = commentContainer[i];
        if (node2.line < element.line) {
          break;
        }
        if (node2.column < element.column) {
          if (isIgnoringComment(node2)) {
            return;
          }
          break;
        }
      }
      unsafePseudoClasses.forEach(function(unsafePseudoClass) {
        console.error('The pseudo class "' + unsafePseudoClass + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + unsafePseudoClass.split("-child")[0] + '-of-type".');
      });
    }
  };
};
var isImportRule = function isImportRule2(element) {
  return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var isPrependedWithRegularRules = function isPrependedWithRegularRules2(index2, children) {
  for (var i = index2 - 1; i >= 0; i--) {
    if (!isImportRule(children[i])) {
      return true;
    }
  }
  return false;
};
var nullifyElement = function nullifyElement2(element) {
  element.type = "";
  element.value = "";
  element["return"] = "";
  element.children = "";
  element.props = "";
};
var incorrectImportAlarm = function incorrectImportAlarm2(element, index2, children) {
  if (!isImportRule(element)) {
    return;
  }
  if (element.parent) {
    console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
    nullifyElement(element);
  } else if (isPrependedWithRegularRules(index2, children)) {
    console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
    nullifyElement(element);
  }
};
function prefix(value, length2) {
  switch (hash(value, length2)) {
    case 5103:
      return WEBKIT + "print-" + value + value;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return WEBKIT + value + value;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return WEBKIT + value + MOZ + value + MS + value + value;
    case 6828:
    case 4268:
      return WEBKIT + value + MS + value + value;
    case 6165:
      return WEBKIT + value + MS + "flex-" + value + value;
    case 5187:
      return WEBKIT + value + replace(value, /(\w+).+(:[^]+)/, WEBKIT + "box-$1$2" + MS + "flex-$1$2") + value;
    case 5443:
      return WEBKIT + value + MS + "flex-item-" + replace(value, /flex-|-self/, "") + value;
    case 4675:
      return WEBKIT + value + MS + "flex-line-pack" + replace(value, /align-content|flex-|-self/, "") + value;
    case 5548:
      return WEBKIT + value + MS + replace(value, "shrink", "negative") + value;
    case 5292:
      return WEBKIT + value + MS + replace(value, "basis", "preferred-size") + value;
    case 6060:
      return WEBKIT + "box-" + replace(value, "-grow", "") + WEBKIT + value + MS + replace(value, "grow", "positive") + value;
    case 4554:
      return WEBKIT + replace(value, /([^-])(transform)/g, "$1" + WEBKIT + "$2") + value;
    case 6187:
      return replace(replace(replace(value, /(zoom-|grab)/, WEBKIT + "$1"), /(image-set)/, WEBKIT + "$1"), value, "") + value;
    case 5495:
    case 3959:
      return replace(value, /(image-set\([^]*)/, WEBKIT + "$1$`$1");
    case 4968:
      return replace(replace(value, /(.+:)(flex-)?(.*)/, WEBKIT + "box-pack:$3" + MS + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + WEBKIT + value + value;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return replace(value, /(.+)-inline(.+)/, WEBKIT + "$1$2") + value;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (strlen(value) - 1 - length2 > 6) switch (charat(value, length2 + 1)) {
        case 109:
          if (charat(value, length2 + 4) !== 45) break;
        case 102:
          return replace(value, /(.+:)(.+)-([^]+)/, "$1" + WEBKIT + "$2-$3$1" + MOZ + (charat(value, length2 + 3) == 108 ? "$3" : "$2-$3")) + value;
        case 115:
          return ~indexof(value, "stretch") ? prefix(replace(value, "stretch", "fill-available"), length2) + value : value;
      }
      break;
    case 4949:
      if (charat(value, length2 + 1) !== 115) break;
    case 6444:
      switch (charat(value, strlen(value) - 3 - (~indexof(value, "!important") && 10))) {
        case 107:
          return replace(value, ":", ":" + WEBKIT) + value;
        case 101:
          return replace(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + WEBKIT + (charat(value, 14) === 45 ? "inline-" : "") + "box$3$1" + WEBKIT + "$2$3$1" + MS + "$2box$3") + value;
      }
      break;
    case 5936:
      switch (charat(value, length2 + 11)) {
        case 114:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
        case 108:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
        case 45:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
      }
      return WEBKIT + value + MS + value + value;
  }
  return value;
}
var prefixer = function prefixer2(element, index2, children, callback2) {
  if (element.length > -1) {
    if (!element["return"]) switch (element.type) {
      case DECLARATION:
        element["return"] = prefix(element.value, element.length);
        break;
      case KEYFRAMES:
        return serialize$1([copy(element, {
          value: replace(element.value, "@", "@" + WEBKIT)
        })], callback2);
      case RULESET:
        if (element.length) return combine(element.props, function(value) {
          switch (match(value, /(::plac\w+|:read-\w+)/)) {
            case ":read-only":
            case ":read-write":
              return serialize$1([copy(element, {
                props: [replace(value, /:(read-\w+)/, ":" + MOZ + "$1")]
              })], callback2);
            case "::placeholder":
              return serialize$1([copy(element, {
                props: [replace(value, /:(plac\w+)/, ":" + WEBKIT + "input-$1")]
              }), copy(element, {
                props: [replace(value, /:(plac\w+)/, ":" + MOZ + "$1")]
              }), copy(element, {
                props: [replace(value, /:(plac\w+)/, MS + "input-$1")]
              })], callback2);
          }
          return "";
        });
    }
  }
};
var defaultStylisPlugins = [prefixer];
var createCache = function createCache2(options2) {
  var key = options2.key;
  if (process.env.NODE_ENV !== "production" && !key) {
    throw new Error("You have to configure `key` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.\nIf multiple caches share the same key they might \"fight\" for each other's style elements.");
  }
  if (key === "css") {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(ssrStyles, function(node2) {
      var dataEmotionAttribute = node2.getAttribute("data-emotion");
      if (dataEmotionAttribute.indexOf(" ") === -1) {
        return;
      }
      document.head.appendChild(node2);
      node2.setAttribute("data-s", "");
    });
  }
  var stylisPlugins = options2.stylisPlugins || defaultStylisPlugins;
  if (process.env.NODE_ENV !== "production") {
    if (/[^a-z-]/.test(key)) {
      throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + key + '" was passed');
    }
  }
  var inserted = {};
  var container;
  var nodesToHydrate = [];
  {
    container = options2.container || document.head;
    Array.prototype.forEach.call(
      // this means we will ignore elements which don't have a space in them which
      // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
      document.querySelectorAll('style[data-emotion^="' + key + ' "]'),
      function(node2) {
        var attrib = node2.getAttribute("data-emotion").split(" ");
        for (var i = 1; i < attrib.length; i++) {
          inserted[attrib[i]] = true;
        }
        nodesToHydrate.push(node2);
      }
    );
  }
  var _insert;
  var omnipresentPlugins = [compat, removeLabel];
  if (process.env.NODE_ENV !== "production") {
    omnipresentPlugins.push(createUnsafeSelectorsAlarm({
      get compat() {
        return cache.compat;
      }
    }), incorrectImportAlarm);
  }
  {
    var currentSheet;
    var finalizingPlugins = [stringify, process.env.NODE_ENV !== "production" ? function(element) {
      if (!element.root) {
        if (element["return"]) {
          currentSheet.insert(element["return"]);
        } else if (element.value && element.type !== COMMENT) {
          currentSheet.insert(element.value + "{}");
        }
      }
    } : rulesheet(function(rule) {
      currentSheet.insert(rule);
    })];
    var serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis2(styles) {
      return serialize$1(compile(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
      currentSheet = sheet;
      if (process.env.NODE_ENV !== "production" && serialized.map !== void 0) {
        currentSheet = {
          insert: function insert2(rule) {
            sheet.insert(rule + serialized.map);
          }
        };
      }
      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
      if (shouldCache) {
        cache.inserted[serialized.name] = true;
      }
    };
  }
  var cache = {
    key,
    sheet: new StyleSheet({
      key,
      container,
      nonce: options2.nonce,
      speedy: options2.speedy,
      prepend: options2.prepend,
      insertionPoint: options2.insertionPoint
    }),
    nonce: options2.nonce,
    inserted,
    registered: {},
    insert: _insert
  };
  cache.sheet.hydrate(nodesToHydrate);
  return cache;
};
var reactIs$2 = { exports: {} };
var reactIs_production_min$1 = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min$1;
function requireReactIs_production_min$1() {
  if (hasRequiredReactIs_production_min$1) return reactIs_production_min$1;
  hasRequiredReactIs_production_min$1 = 1;
  var b2 = "function" === typeof Symbol && Symbol.for, c4 = b2 ? Symbol.for("react.element") : 60103, d2 = b2 ? Symbol.for("react.portal") : 60106, e2 = b2 ? Symbol.for("react.fragment") : 60107, f2 = b2 ? Symbol.for("react.strict_mode") : 60108, g2 = b2 ? Symbol.for("react.profiler") : 60114, h3 = b2 ? Symbol.for("react.provider") : 60109, k2 = b2 ? Symbol.for("react.context") : 60110, l2 = b2 ? Symbol.for("react.async_mode") : 60111, m3 = b2 ? Symbol.for("react.concurrent_mode") : 60111, n2 = b2 ? Symbol.for("react.forward_ref") : 60112, p2 = b2 ? Symbol.for("react.suspense") : 60113, q = b2 ? Symbol.for("react.suspense_list") : 60120, r2 = b2 ? Symbol.for("react.memo") : 60115, t2 = b2 ? Symbol.for("react.lazy") : 60116, v2 = b2 ? Symbol.for("react.block") : 60121, w2 = b2 ? Symbol.for("react.fundamental") : 60117, x2 = b2 ? Symbol.for("react.responder") : 60118, y2 = b2 ? Symbol.for("react.scope") : 60119;
  function z2(a2) {
    if ("object" === typeof a2 && null !== a2) {
      var u2 = a2.$$typeof;
      switch (u2) {
        case c4:
          switch (a2 = a2.type, a2) {
            case l2:
            case m3:
            case e2:
            case g2:
            case f2:
            case p2:
              return a2;
            default:
              switch (a2 = a2 && a2.$$typeof, a2) {
                case k2:
                case n2:
                case t2:
                case r2:
                case h3:
                  return a2;
                default:
                  return u2;
              }
          }
        case d2:
          return u2;
      }
    }
  }
  function A2(a2) {
    return z2(a2) === m3;
  }
  reactIs_production_min$1.AsyncMode = l2;
  reactIs_production_min$1.ConcurrentMode = m3;
  reactIs_production_min$1.ContextConsumer = k2;
  reactIs_production_min$1.ContextProvider = h3;
  reactIs_production_min$1.Element = c4;
  reactIs_production_min$1.ForwardRef = n2;
  reactIs_production_min$1.Fragment = e2;
  reactIs_production_min$1.Lazy = t2;
  reactIs_production_min$1.Memo = r2;
  reactIs_production_min$1.Portal = d2;
  reactIs_production_min$1.Profiler = g2;
  reactIs_production_min$1.StrictMode = f2;
  reactIs_production_min$1.Suspense = p2;
  reactIs_production_min$1.isAsyncMode = function(a2) {
    return A2(a2) || z2(a2) === l2;
  };
  reactIs_production_min$1.isConcurrentMode = A2;
  reactIs_production_min$1.isContextConsumer = function(a2) {
    return z2(a2) === k2;
  };
  reactIs_production_min$1.isContextProvider = function(a2) {
    return z2(a2) === h3;
  };
  reactIs_production_min$1.isElement = function(a2) {
    return "object" === typeof a2 && null !== a2 && a2.$$typeof === c4;
  };
  reactIs_production_min$1.isForwardRef = function(a2) {
    return z2(a2) === n2;
  };
  reactIs_production_min$1.isFragment = function(a2) {
    return z2(a2) === e2;
  };
  reactIs_production_min$1.isLazy = function(a2) {
    return z2(a2) === t2;
  };
  reactIs_production_min$1.isMemo = function(a2) {
    return z2(a2) === r2;
  };
  reactIs_production_min$1.isPortal = function(a2) {
    return z2(a2) === d2;
  };
  reactIs_production_min$1.isProfiler = function(a2) {
    return z2(a2) === g2;
  };
  reactIs_production_min$1.isStrictMode = function(a2) {
    return z2(a2) === f2;
  };
  reactIs_production_min$1.isSuspense = function(a2) {
    return z2(a2) === p2;
  };
  reactIs_production_min$1.isValidElementType = function(a2) {
    return "string" === typeof a2 || "function" === typeof a2 || a2 === e2 || a2 === m3 || a2 === g2 || a2 === f2 || a2 === p2 || a2 === q || "object" === typeof a2 && null !== a2 && (a2.$$typeof === t2 || a2.$$typeof === r2 || a2.$$typeof === h3 || a2.$$typeof === k2 || a2.$$typeof === n2 || a2.$$typeof === w2 || a2.$$typeof === x2 || a2.$$typeof === y2 || a2.$$typeof === v2);
  };
  reactIs_production_min$1.typeOf = z2;
  return reactIs_production_min$1;
}
var reactIs_development$1 = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_development$1;
function requireReactIs_development$1() {
  if (hasRequiredReactIs_development$1) return reactIs_development$1;
  hasRequiredReactIs_development$1 = 1;
  if (process.env.NODE_ENV !== "production") {
    (function() {
      var hasSymbol = typeof Symbol === "function" && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 60103;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 60106;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 60107;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 60108;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 60114;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 60109;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 60110;
      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 60111;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 60111;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 60112;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 60113;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 60120;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 60115;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 60116;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 60121;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 60117;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 60118;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 60119;
      function isValidElementType(type2) {
        return typeof type2 === "string" || typeof type2 === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type2 === REACT_FRAGMENT_TYPE || type2 === REACT_CONCURRENT_MODE_TYPE || type2 === REACT_PROFILER_TYPE || type2 === REACT_STRICT_MODE_TYPE || type2 === REACT_SUSPENSE_TYPE || type2 === REACT_SUSPENSE_LIST_TYPE || typeof type2 === "object" && type2 !== null && (type2.$$typeof === REACT_LAZY_TYPE || type2.$$typeof === REACT_MEMO_TYPE || type2.$$typeof === REACT_PROVIDER_TYPE || type2.$$typeof === REACT_CONTEXT_TYPE || type2.$$typeof === REACT_FORWARD_REF_TYPE || type2.$$typeof === REACT_FUNDAMENTAL_TYPE || type2.$$typeof === REACT_RESPONDER_TYPE || type2.$$typeof === REACT_SCOPE_TYPE || type2.$$typeof === REACT_BLOCK_TYPE);
      }
      function typeOf(object) {
        if (typeof object === "object" && object !== null) {
          var $$typeof = object.$$typeof;
          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type2 = object.type;
              switch (type2) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type2;
                default:
                  var $$typeofType = type2 && type2.$$typeof;
                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;
                    default:
                      return $$typeof;
                  }
              }
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }
        return void 0;
      }
      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element2 = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment2 = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false;
      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true;
            console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
          }
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }
      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }
      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }
      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }
      function isElement2(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }
      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }
      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }
      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }
      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }
      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }
      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }
      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }
      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }
      reactIs_development$1.AsyncMode = AsyncMode;
      reactIs_development$1.ConcurrentMode = ConcurrentMode;
      reactIs_development$1.ContextConsumer = ContextConsumer;
      reactIs_development$1.ContextProvider = ContextProvider;
      reactIs_development$1.Element = Element2;
      reactIs_development$1.ForwardRef = ForwardRef;
      reactIs_development$1.Fragment = Fragment2;
      reactIs_development$1.Lazy = Lazy;
      reactIs_development$1.Memo = Memo;
      reactIs_development$1.Portal = Portal;
      reactIs_development$1.Profiler = Profiler;
      reactIs_development$1.StrictMode = StrictMode;
      reactIs_development$1.Suspense = Suspense;
      reactIs_development$1.isAsyncMode = isAsyncMode;
      reactIs_development$1.isConcurrentMode = isConcurrentMode;
      reactIs_development$1.isContextConsumer = isContextConsumer;
      reactIs_development$1.isContextProvider = isContextProvider;
      reactIs_development$1.isElement = isElement2;
      reactIs_development$1.isForwardRef = isForwardRef;
      reactIs_development$1.isFragment = isFragment;
      reactIs_development$1.isLazy = isLazy;
      reactIs_development$1.isMemo = isMemo;
      reactIs_development$1.isPortal = isPortal;
      reactIs_development$1.isProfiler = isProfiler;
      reactIs_development$1.isStrictMode = isStrictMode;
      reactIs_development$1.isSuspense = isSuspense;
      reactIs_development$1.isValidElementType = isValidElementType;
      reactIs_development$1.typeOf = typeOf;
    })();
  }
  return reactIs_development$1;
}
if (process.env.NODE_ENV === "production") {
  reactIs$2.exports = requireReactIs_production_min$1();
} else {
  reactIs$2.exports = requireReactIs_development$1();
}
var reactIsExports = reactIs$2.exports;
var reactIs$1 = reactIsExports;
var FORWARD_REF_STATICS = {
  "$$typeof": true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  "$$typeof": true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs$1.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs$1.Memo] = MEMO_STATICS;
var isBrowser$1 = true;
function getRegisteredStyles(registered, registeredStyles, classNames2) {
  var rawClassName = "";
  classNames2.split(" ").forEach(function(className) {
    if (registered[className] !== void 0) {
      registeredStyles.push(registered[className] + ";");
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var registerStyles = function registerStyles2(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;
  if (
    // we only need to add the styles to the registered cache if the
    // class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    isBrowser$1 === false) && cache.registered[className] === void 0
  ) {
    cache.registered[className] = serialized.styles;
  }
};
var insertStyles = function insertStyles2(cache, serialized, isStringTag) {
  registerStyles(cache, serialized, isStringTag);
  var className = cache.key + "-" + serialized.name;
  if (cache.inserted[serialized.name] === void 0) {
    var current = serialized;
    do {
      cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
      current = current.next;
    } while (current !== void 0);
  }
};
function murmur2(str) {
  var h3 = 0;
  var k2, i = 0, len = str.length;
  for (; len >= 4; ++i, len -= 4) {
    k2 = str.charCodeAt(i) & 255 | (str.charCodeAt(++i) & 255) << 8 | (str.charCodeAt(++i) & 255) << 16 | (str.charCodeAt(++i) & 255) << 24;
    k2 = /* Math.imul(k, m): */
    (k2 & 65535) * 1540483477 + ((k2 >>> 16) * 59797 << 16);
    k2 ^= /* k >>> r: */
    k2 >>> 24;
    h3 = /* Math.imul(k, m): */
    (k2 & 65535) * 1540483477 + ((k2 >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (h3 & 65535) * 1540483477 + ((h3 >>> 16) * 59797 << 16);
  }
  switch (len) {
    case 3:
      h3 ^= (str.charCodeAt(i + 2) & 255) << 16;
    case 2:
      h3 ^= (str.charCodeAt(i + 1) & 255) << 8;
    case 1:
      h3 ^= str.charCodeAt(i) & 255;
      h3 = /* Math.imul(h, m): */
      (h3 & 65535) * 1540483477 + ((h3 >>> 16) * 59797 << 16);
  }
  h3 ^= h3 >>> 13;
  h3 = /* Math.imul(h, m): */
  (h3 & 65535) * 1540483477 + ((h3 >>> 16) * 59797 << 16);
  return ((h3 ^ h3 >>> 15) >>> 0).toString(36);
}
var unitlessKeys = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
var ILLEGAL_ESCAPE_SEQUENCE_ERROR = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`;
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var isCustomProperty = function isCustomProperty2(property) {
  return property.charCodeAt(1) === 45;
};
var isProcessableValue = function isProcessableValue2(value) {
  return value != null && typeof value !== "boolean";
};
var processStyleName = /* @__PURE__ */ memoize(function(styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, "-$&").toLowerCase();
});
var processStyleValue = function processStyleValue2(key, value) {
  switch (key) {
    case "animation":
    case "animationName": {
      if (typeof value === "string") {
        return value.replace(animationRegex, function(match2, p1, p2) {
          cursor = {
            name: p1,
            styles: p2,
            next: cursor
          };
          return p1;
        });
      }
    }
  }
  if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value === "number" && value !== 0) {
    return value + "px";
  }
  return value;
};
if (process.env.NODE_ENV !== "production") {
  var contentValuePattern = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/;
  var contentValues = ["normal", "none", "initial", "inherit", "unset"];
  var oldProcessStyleValue = processStyleValue;
  var msPattern = /^-ms-/;
  var hyphenPattern = /-(.)/g;
  var hyphenatedCache = {};
  processStyleValue = function processStyleValue3(key, value) {
    if (key === "content") {
      if (typeof value !== "string" || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
        throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
      }
    }
    var processed = oldProcessStyleValue(key, value);
    if (processed !== "" && !isCustomProperty(key) && key.indexOf("-") !== -1 && hyphenatedCache[key] === void 0) {
      hyphenatedCache[key] = true;
      console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace(msPattern, "ms-").replace(hyphenPattern, function(str, _char) {
        return _char.toUpperCase();
      }) + "?");
    }
    return processed;
  };
}
var noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function handleInterpolation(mergedProps, registered, interpolation2) {
  if (interpolation2 == null) {
    return "";
  }
  if (interpolation2.__emotion_styles !== void 0) {
    if (process.env.NODE_ENV !== "production" && interpolation2.toString() === "NO_COMPONENT_SELECTOR") {
      throw new Error(noComponentSelectorMessage);
    }
    return interpolation2;
  }
  switch (typeof interpolation2) {
    case "boolean": {
      return "";
    }
    case "object": {
      if (interpolation2.anim === 1) {
        cursor = {
          name: interpolation2.name,
          styles: interpolation2.styles,
          next: cursor
        };
        return interpolation2.name;
      }
      if (interpolation2.styles !== void 0) {
        var next2 = interpolation2.next;
        if (next2 !== void 0) {
          while (next2 !== void 0) {
            cursor = {
              name: next2.name,
              styles: next2.styles,
              next: cursor
            };
            next2 = next2.next;
          }
        }
        var styles = interpolation2.styles + ";";
        if (process.env.NODE_ENV !== "production" && interpolation2.map !== void 0) {
          styles += interpolation2.map;
        }
        return styles;
      }
      return createStringFromObject(mergedProps, registered, interpolation2);
    }
    case "function": {
      if (mergedProps !== void 0) {
        var previousCursor = cursor;
        var result = interpolation2(mergedProps);
        cursor = previousCursor;
        return handleInterpolation(mergedProps, registered, result);
      } else if (process.env.NODE_ENV !== "production") {
        console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
      }
      break;
    }
    case "string":
      if (process.env.NODE_ENV !== "production") {
        var matched = [];
        var replaced = interpolation2.replace(animationRegex, function(match2, p1, p2) {
          var fakeVarName = "animation" + matched.length;
          matched.push("const " + fakeVarName + " = keyframes`" + p2.replace(/^@keyframes animation-\w+/, "") + "`");
          return "${" + fakeVarName + "}";
        });
        if (matched.length) {
          console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(matched, ["`" + replaced + "`"]).join("\n") + "\n\nYou should wrap it with `css` like this:\n\n" + ("css`" + replaced + "`"));
        }
      }
      break;
  }
  if (registered == null) {
    return interpolation2;
  }
  var cached = registered[interpolation2];
  return cached !== void 0 ? cached : interpolation2;
}
function createStringFromObject(mergedProps, registered, obj) {
  var string = "";
  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];
      if (typeof value !== "object") {
        if (registered != null && registered[value] !== void 0) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === "NO_COMPONENT_SELECTOR" && process.env.NODE_ENV !== "production") {
          throw new Error(noComponentSelectorMessage);
        }
        if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === void 0)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);
          switch (_key) {
            case "animation":
            case "animationName": {
              string += processStyleName(_key) + ":" + interpolated + ";";
              break;
            }
            default: {
              if (process.env.NODE_ENV !== "production" && _key === "undefined") {
                console.error(UNDEFINED_AS_OBJECT_KEY_ERROR);
              }
              string += _key + "{" + interpolated + "}";
            }
          }
        }
      }
    }
  }
  return string;
}
var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var sourceMapPattern;
if (process.env.NODE_ENV !== "production") {
  sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g;
}
var cursor;
var serializeStyles = function serializeStyles2(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== void 0) {
    return args[0];
  }
  var stringMode = true;
  var styles = "";
  cursor = void 0;
  var strings = args[0];
  if (strings == null || strings.raw === void 0) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {
    if (process.env.NODE_ENV !== "production" && strings[0] === void 0) {
      console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
    }
    styles += strings[0];
  }
  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);
    if (stringMode) {
      if (process.env.NODE_ENV !== "production" && strings[i] === void 0) {
        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
      }
      styles += strings[i];
    }
  }
  var sourceMap;
  if (process.env.NODE_ENV !== "production") {
    styles = styles.replace(sourceMapPattern, function(match3) {
      sourceMap = match3;
      return "";
    });
  }
  labelPattern.lastIndex = 0;
  var identifierName = "";
  var match2;
  while ((match2 = labelPattern.exec(styles)) !== null) {
    identifierName += "-" + // $FlowFixMe we know it's not null
    match2[1];
  }
  var name = murmur2(styles) + identifierName;
  if (process.env.NODE_ENV !== "production") {
    return {
      name,
      styles,
      map: sourceMap,
      next: cursor,
      toString: function toString() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
      }
    };
  }
  return {
    name,
    styles,
    next: cursor
  };
};
var syncFallback = function syncFallback2(create) {
  return create();
};
var useInsertionEffect = React["useInsertionEffect"] ? React["useInsertionEffect"] : false;
var useInsertionEffectAlwaysWithSyncFallback = useInsertionEffect || syncFallback;
var useInsertionEffectWithLayoutFallback = useInsertionEffect || React.useLayoutEffect;
var hasOwn = {}.hasOwnProperty;
var EmotionCacheContext = /* @__PURE__ */ React.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement !== "undefined" ? /* @__PURE__ */ createCache({
    key: "css"
  }) : null
);
if (process.env.NODE_ENV !== "production") {
  EmotionCacheContext.displayName = "EmotionCacheContext";
}
EmotionCacheContext.Provider;
var withEmotionCache = function withEmotionCache2(func) {
  return /* @__PURE__ */ forwardRef(function(props, ref) {
    var cache = useContext(EmotionCacheContext);
    return func(props, cache, ref);
  });
};
var ThemeContext = /* @__PURE__ */ React.createContext({});
if (process.env.NODE_ENV !== "production") {
  ThemeContext.displayName = "EmotionThemeContext";
}
var getLastPart = function getLastPart2(functionName) {
  var parts = functionName.split(".");
  return parts[parts.length - 1];
};
var getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine2(line2) {
  var match2 = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line2);
  if (match2) return getLastPart(match2[1]);
  match2 = /^([A-Za-z0-9$.]+)@/.exec(line2);
  if (match2) return getLastPart(match2[1]);
  return void 0;
};
var internalReactFunctionNames = /* @__PURE__ */ new Set(["renderWithHooks", "processChild", "finishClassComponent", "renderToString"]);
var sanitizeIdentifier = function sanitizeIdentifier2(identifier2) {
  return identifier2.replace(/\$/g, "-");
};
var getLabelFromStackTrace = function getLabelFromStackTrace2(stackTrace) {
  if (!stackTrace) return void 0;
  var lines = stackTrace.split("\n");
  for (var i = 0; i < lines.length; i++) {
    var functionName = getFunctionNameFromStackTraceLine(lines[i]);
    if (!functionName) continue;
    if (internalReactFunctionNames.has(functionName)) break;
    if (/^[A-Z]/.test(functionName)) return sanitizeIdentifier(functionName);
  }
  return void 0;
};
var typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var labelPropName = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__";
var createEmotionProps = function createEmotionProps2(type2, props) {
  if (process.env.NODE_ENV !== "production" && typeof props.css === "string" && // check if there is a css declaration
  props.css.indexOf(":") !== -1) {
    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/react' like this: css`" + props.css + "`");
  }
  var newProps = {};
  for (var key in props) {
    if (hasOwn.call(props, key)) {
      newProps[key] = props[key];
    }
  }
  newProps[typePropName] = type2;
  if (process.env.NODE_ENV !== "production" && !!props.css && (typeof props.css !== "object" || typeof props.css.name !== "string" || props.css.name.indexOf("-") === -1)) {
    var label = getLabelFromStackTrace(new Error().stack);
    if (label) newProps[labelPropName] = label;
  }
  return newProps;
};
var Insertion$1 = function Insertion(_ref3) {
  var cache = _ref3.cache, serialized = _ref3.serialized, isStringTag = _ref3.isStringTag;
  registerStyles(cache, serialized, isStringTag);
  useInsertionEffectAlwaysWithSyncFallback(function() {
    return insertStyles(cache, serialized, isStringTag);
  });
  return null;
};
var Emotion = /* @__PURE__ */ withEmotionCache(function(props, cache, ref) {
  var cssProp = props.css;
  if (typeof cssProp === "string" && cache.registered[cssProp] !== void 0) {
    cssProp = cache.registered[cssProp];
  }
  var WrappedComponent = props[typePropName];
  var registeredStyles = [cssProp];
  var className = "";
  if (typeof props.className === "string") {
    className = getRegisteredStyles(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }
  var serialized = serializeStyles(registeredStyles, void 0, React.useContext(ThemeContext));
  if (process.env.NODE_ENV !== "production" && serialized.name.indexOf("-") === -1) {
    var labelFromStack = props[labelPropName];
    if (labelFromStack) {
      serialized = serializeStyles([serialized, "label:" + labelFromStack + ";"]);
    }
  }
  className += cache.key + "-" + serialized.name;
  var newProps = {};
  for (var key in props) {
    if (hasOwn.call(props, key) && key !== "css" && key !== typePropName && (process.env.NODE_ENV === "production" || key !== labelPropName)) {
      newProps[key] = props[key];
    }
  }
  newProps.ref = ref;
  newProps.className = className;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Insertion$1, {
    cache,
    serialized,
    isStringTag: typeof WrappedComponent === "string"
  }), /* @__PURE__ */ React.createElement(WrappedComponent, newProps));
});
if (process.env.NODE_ENV !== "production") {
  Emotion.displayName = "EmotionCssPropInternal";
}
var Emotion$1 = Emotion;
var pkg = {
  name: "@emotion/react",
  version: "11.11.4",
  main: "dist/emotion-react.cjs.js",
  module: "dist/emotion-react.esm.js",
  browser: {
    "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
  },
  exports: {
    ".": {
      module: {
        worker: "./dist/emotion-react.worker.esm.js",
        browser: "./dist/emotion-react.browser.esm.js",
        "default": "./dist/emotion-react.esm.js"
      },
      "import": "./dist/emotion-react.cjs.mjs",
      "default": "./dist/emotion-react.cjs.js"
    },
    "./jsx-runtime": {
      module: {
        worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
        browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
        "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
      },
      "import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
      "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
    },
    "./_isolated-hnrs": {
      module: {
        worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
        browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
        "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
      },
      "import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
      "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
    },
    "./jsx-dev-runtime": {
      module: {
        worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
        browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
        "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
      },
      "import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
      "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
    },
    "./package.json": "./package.json",
    "./types/css-prop": "./types/css-prop.d.ts",
    "./macro": {
      types: {
        "import": "./macro.d.mts",
        "default": "./macro.d.ts"
      },
      "default": "./macro.js"
    }
  },
  types: "types/index.d.ts",
  files: [
    "src",
    "dist",
    "jsx-runtime",
    "jsx-dev-runtime",
    "_isolated-hnrs",
    "types/*.d.ts",
    "macro.*"
  ],
  sideEffects: false,
  author: "Emotion Contributors",
  license: "MIT",
  scripts: {
    "test:typescript": "dtslint types"
  },
  dependencies: {
    "@babel/runtime": "^7.18.3",
    "@emotion/babel-plugin": "^11.11.0",
    "@emotion/cache": "^11.11.0",
    "@emotion/serialize": "^1.1.3",
    "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
    "@emotion/utils": "^1.2.1",
    "@emotion/weak-memoize": "^0.3.1",
    "hoist-non-react-statics": "^3.3.1"
  },
  peerDependencies: {
    react: ">=16.8.0"
  },
  peerDependenciesMeta: {
    "@types/react": {
      optional: true
    }
  },
  devDependencies: {
    "@definitelytyped/dtslint": "0.0.112",
    "@emotion/css": "11.11.2",
    "@emotion/css-prettifier": "1.1.3",
    "@emotion/server": "11.11.0",
    "@emotion/styled": "11.11.0",
    "html-tag-names": "^1.1.2",
    react: "16.14.0",
    "svg-tag-names": "^1.1.1",
    typescript: "^4.5.5"
  },
  repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
  publishConfig: {
    access: "public"
  },
  "umd:main": "dist/emotion-react.umd.min.js",
  preconstruct: {
    entrypoints: [
      "./index.js",
      "./jsx-runtime.js",
      "./jsx-dev-runtime.js",
      "./_isolated-hnrs.js"
    ],
    umdName: "emotionReact",
    exports: {
      envConditions: [
        "browser",
        "worker"
      ],
      extra: {
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
          types: {
            "import": "./macro.d.mts",
            "default": "./macro.d.ts"
          },
          "default": "./macro.js"
        }
      }
    }
  }
};
var jsx = function jsx2(type2, props) {
  var args = arguments;
  if (props == null || !hasOwn.call(props, "css")) {
    return React.createElement.apply(void 0, args);
  }
  var argsLength = args.length;
  var createElementArgArray = new Array(argsLength);
  createElementArgArray[0] = Emotion$1;
  createElementArgArray[1] = createEmotionProps(type2, props);
  for (var i = 2; i < argsLength; i++) {
    createElementArgArray[i] = args[i];
  }
  return React.createElement.apply(null, createElementArgArray);
};
var warnedAboutCssPropForGlobal = false;
var Global = /* @__PURE__ */ withEmotionCache(function(props, cache) {
  if (process.env.NODE_ENV !== "production" && !warnedAboutCssPropForGlobal && // check for className as well since the user is
  // probably using the custom createElement which
  // means it will be turned into a className prop
  // $FlowFixMe I don't really want to add it to the type since it shouldn't be used
  (props.className || props.css)) {
    console.error("It looks like you're using the css prop on Global, did you mean to use the styles prop instead?");
    warnedAboutCssPropForGlobal = true;
  }
  var styles = props.styles;
  var serialized = serializeStyles([styles], void 0, React.useContext(ThemeContext));
  var sheetRef = React.useRef();
  useInsertionEffectWithLayoutFallback(function() {
    var key = cache.key + "-global";
    var sheet = new cache.sheet.constructor({
      key,
      nonce: cache.sheet.nonce,
      container: cache.sheet.container,
      speedy: cache.sheet.isSpeedy
    });
    var rehydrating = false;
    var node2 = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
    if (cache.sheet.tags.length) {
      sheet.before = cache.sheet.tags[0];
    }
    if (node2 !== null) {
      rehydrating = true;
      node2.setAttribute("data-emotion", key);
      sheet.hydrate([node2]);
    }
    sheetRef.current = [sheet, rehydrating];
    return function() {
      sheet.flush();
    };
  }, [cache]);
  useInsertionEffectWithLayoutFallback(function() {
    var sheetRefCurrent = sheetRef.current;
    var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
    if (rehydrating) {
      sheetRefCurrent[1] = false;
      return;
    }
    if (serialized.next !== void 0) {
      insertStyles(cache, serialized.next, true);
    }
    if (sheet.tags.length) {
      var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
      sheet.before = element;
      sheet.flush();
    }
    cache.insert("", serialized, sheet, false);
  }, [cache, serialized.name]);
  return null;
});
if (process.env.NODE_ENV !== "production") {
  Global.displayName = "EmotionGlobal";
}
function css$2() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return serializeStyles(args);
}
var keyframes = function keyframes2() {
  var insertable = css$2.apply(void 0, arguments);
  var name = "animation-" + insertable.name;
  return {
    name,
    styles: "@keyframes " + name + "{" + insertable.styles + "}",
    anim: 1,
    toString: function toString() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
};
var classnames = function classnames2(args) {
  var len = args.length;
  var i = 0;
  var cls = "";
  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;
    switch (typeof arg) {
      case "boolean":
        break;
      case "object": {
        if (Array.isArray(arg)) {
          toAdd = classnames2(arg);
        } else {
          if (process.env.NODE_ENV !== "production" && arg.styles !== void 0 && arg.name !== void 0) {
            console.error("You have passed styles created with `css` from `@emotion/react` package to the `cx`.\n`cx` is meant to compose class names (strings) so you should convert those styles to a class name by passing them to the `css` received from <ClassNames/> component.");
          }
          toAdd = "";
          for (var k2 in arg) {
            if (arg[k2] && k2) {
              toAdd && (toAdd += " ");
              toAdd += k2;
            }
          }
        }
        break;
      }
      default: {
        toAdd = arg;
      }
    }
    if (toAdd) {
      cls && (cls += " ");
      cls += toAdd;
    }
  }
  return cls;
};
function merge(registered, css4, className) {
  var registeredStyles = [];
  var rawClassName = getRegisteredStyles(registered, registeredStyles, className);
  if (registeredStyles.length < 2) {
    return className;
  }
  return rawClassName + css4(registeredStyles);
}
var Insertion2 = function Insertion3(_ref3) {
  var cache = _ref3.cache, serializedArr = _ref3.serializedArr;
  useInsertionEffectAlwaysWithSyncFallback(function() {
    for (var i = 0; i < serializedArr.length; i++) {
      insertStyles(cache, serializedArr[i], false);
    }
  });
  return null;
};
var ClassNames = /* @__PURE__ */ withEmotionCache(function(props, cache) {
  var hasRendered = false;
  var serializedArr = [];
  var css4 = function css5() {
    if (hasRendered && process.env.NODE_ENV !== "production") {
      throw new Error("css can only be used during render");
    }
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var serialized = serializeStyles(args, cache.registered);
    serializedArr.push(serialized);
    registerStyles(cache, serialized, false);
    return cache.key + "-" + serialized.name;
  };
  var cx = function cx2() {
    if (hasRendered && process.env.NODE_ENV !== "production") {
      throw new Error("cx can only be used during render");
    }
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    return merge(cache.registered, css4, classnames(args));
  };
  var content = {
    css: css4,
    cx,
    theme: React.useContext(ThemeContext)
  };
  var ele = props.children(content);
  hasRendered = true;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Insertion2, {
    cache,
    serializedArr
  }), ele);
});
if (process.env.NODE_ENV !== "production") {
  ClassNames.displayName = "EmotionClassNames";
}
if (process.env.NODE_ENV !== "production") {
  var isBrowser = true;
  var isTestEnv = typeof jest !== "undefined" || typeof vi !== "undefined";
  if (isBrowser && !isTestEnv) {
    var globalContext = (
      // $FlowIgnore
      typeof globalThis !== "undefined" ? globalThis : isBrowser ? window : global
    );
    var globalKey = "__EMOTION_REACT_" + pkg.version.split(".")[0] + "__";
    if (globalContext[globalKey]) {
      console.warn("You are loading @emotion/react when it is already loaded. Running multiple instances may cause problems. This can happen if multiple versions are used, or if multiple builds of the same version are used.");
    }
    globalContext[globalKey] = true;
  }
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var index$2 = useLayoutEffect;
var _excluded$4$1 = ["className", "clearValue", "cx", "getStyles", "getClassNames", "getValue", "hasValue", "isMulti", "isRtl", "options", "selectOption", "selectProps", "setValue", "theme"];
var noop$1 = function noop() {
};
function applyPrefixToName(prefix2, name) {
  if (!name) {
    return prefix2;
  } else if (name[0] === "-") {
    return prefix2 + name;
  } else {
    return prefix2 + "__" + name;
  }
}
function classNames(prefix2, state) {
  for (var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    classNameList[_key - 2] = arguments[_key];
  }
  var arr = [].concat(classNameList);
  if (state && prefix2) {
    for (var key in state) {
      if (state.hasOwnProperty(key) && state[key]) {
        arr.push("".concat(applyPrefixToName(prefix2, key)));
      }
    }
  }
  return arr.filter(function(i) {
    return i;
  }).map(function(i) {
    return String(i).trim();
  }).join(" ");
}
var cleanValue = function cleanValue2(value) {
  if (isArray(value)) return value.filter(Boolean);
  if (_typeof(value) === "object" && value !== null) return [value];
  return [];
};
var cleanCommonProps = function cleanCommonProps2(props) {
  props.className;
  props.clearValue;
  props.cx;
  props.getStyles;
  props.getClassNames;
  props.getValue;
  props.hasValue;
  props.isMulti;
  props.isRtl;
  props.options;
  props.selectOption;
  props.selectProps;
  props.setValue;
  props.theme;
  var innerProps = _objectWithoutProperties(props, _excluded$4$1);
  return _objectSpread2({}, innerProps);
};
var getStyleProps = function getStyleProps2(props, name, classNamesState) {
  var cx = props.cx, getStyles2 = props.getStyles, getClassNames = props.getClassNames, className = props.className;
  return {
    css: getStyles2(name, props),
    className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
  };
};
function isDocumentElement(el) {
  return [document.documentElement, document.body, window].indexOf(el) > -1;
}
function normalizedHeight(el) {
  if (isDocumentElement(el)) {
    return window.innerHeight;
  }
  return el.clientHeight;
}
function getScrollTop(el) {
  if (isDocumentElement(el)) {
    return window.pageYOffset;
  }
  return el.scrollTop;
}
function scrollTo(el, top) {
  if (isDocumentElement(el)) {
    window.scrollTo(0, top);
    return;
  }
  el.scrollTop = top;
}
function getScrollParent(element) {
  var style = getComputedStyle(element);
  var excludeStaticParent = style.position === "absolute";
  var overflowRx = /(auto|scroll)/;
  if (style.position === "fixed") return document.documentElement;
  for (var parent = element; parent = parent.parentElement; ) {
    style = getComputedStyle(parent);
    if (excludeStaticParent && style.position === "static") {
      continue;
    }
    if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) {
      return parent;
    }
  }
  return document.documentElement;
}
function easeOutCubic(t2, b2, c4, d2) {
  return c4 * ((t2 = t2 / d2 - 1) * t2 * t2 + 1) + b2;
}
function animatedScrollTo(element, to2) {
  var duration = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 200;
  var callback2 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : noop$1;
  var start = getScrollTop(element);
  var change = to2 - start;
  var increment = 10;
  var currentTime = 0;
  function animateScroll() {
    currentTime += increment;
    var val = easeOutCubic(currentTime, start, change, duration);
    scrollTo(element, val);
    if (currentTime < duration) {
      window.requestAnimationFrame(animateScroll);
    } else {
      callback2(element);
    }
  }
  animateScroll();
}
function scrollIntoView(menuEl, focusedEl) {
  var menuRect = menuEl.getBoundingClientRect();
  var focusedRect = focusedEl.getBoundingClientRect();
  var overScroll = focusedEl.offsetHeight / 3;
  if (focusedRect.bottom + overScroll > menuRect.bottom) {
    scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
  } else if (focusedRect.top - overScroll < menuRect.top) {
    scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
  }
}
function getBoundingClientObj(element) {
  var rect = element.getBoundingClientRect();
  return {
    bottom: rect.bottom,
    height: rect.height,
    left: rect.left,
    right: rect.right,
    top: rect.top,
    width: rect.width
  };
}
function isTouchCapable() {
  try {
    document.createEvent("TouchEvent");
    return true;
  } catch (e2) {
    return false;
  }
}
function isMobileDevice() {
  try {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  } catch (e2) {
    return false;
  }
}
var passiveOptionAccessed = false;
var options = {
  get passive() {
    return passiveOptionAccessed = true;
  }
};
var w = typeof window !== "undefined" ? window : {};
if (w.addEventListener && w.removeEventListener) {
  w.addEventListener("p", noop$1, options);
  w.removeEventListener("p", noop$1, false);
}
var supportsPassiveEvents = passiveOptionAccessed;
function notNullish(item) {
  return item != null;
}
function isArray(arg) {
  return Array.isArray(arg);
}
function valueTernary(isMulti, multiValue2, singleValue) {
  return isMulti ? multiValue2 : singleValue;
}
function singleValueAsValue(singleValue) {
  return singleValue;
}
function multiValueAsValue(multiValue2) {
  return multiValue2;
}
var removeProps = function removeProps2(propsObj) {
  for (var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    properties[_key2 - 1] = arguments[_key2];
  }
  var propsMap = Object.entries(propsObj).filter(function(_ref3) {
    var _ref22 = _slicedToArray(_ref3, 1), key = _ref22[0];
    return !properties.includes(key);
  });
  return propsMap.reduce(function(newProps, _ref3) {
    var _ref4 = _slicedToArray(_ref3, 2), key = _ref4[0], val = _ref4[1];
    newProps[key] = val;
    return newProps;
  }, {});
};
var _excluded$3$1 = ["children", "innerProps"], _excluded2$1 = ["children", "innerProps"];
function getMenuPlacement(_ref3) {
  var preferredMaxHeight = _ref3.maxHeight, menuEl = _ref3.menuEl, minHeight = _ref3.minHeight, preferredPlacement = _ref3.placement, shouldScroll = _ref3.shouldScroll, isFixedPosition = _ref3.isFixedPosition, controlHeight2 = _ref3.controlHeight;
  var scrollParent = getScrollParent(menuEl);
  var defaultState = {
    placement: "bottom",
    maxHeight: preferredMaxHeight
  };
  if (!menuEl || !menuEl.offsetParent) return defaultState;
  var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
  var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
  var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
  var viewHeight = isFixedPosition ? window.innerHeight : normalizedHeight(scrollParent);
  var scrollTop = getScrollTop(scrollParent);
  var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
  var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
  var viewSpaceAbove = containerTop - marginTop;
  var viewSpaceBelow = viewHeight - menuTop;
  var scrollSpaceAbove = viewSpaceAbove + scrollTop;
  var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
  var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
  var scrollUp = scrollTop + menuTop - marginTop;
  var scrollDuration = 160;
  switch (preferredPlacement) {
    case "auto":
    case "bottom":
      if (viewSpaceBelow >= menuHeight) {
        return {
          placement: "bottom",
          maxHeight: preferredMaxHeight
        };
      }
      if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        }
        return {
          placement: "bottom",
          maxHeight: preferredMaxHeight
        };
      }
      if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        }
        var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
        return {
          placement: "bottom",
          maxHeight: constrainedHeight
        };
      }
      if (preferredPlacement === "auto" || isFixedPosition) {
        var _constrainedHeight = preferredMaxHeight;
        var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
        if (spaceAbove >= minHeight) {
          _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight2, preferredMaxHeight);
        }
        return {
          placement: "top",
          maxHeight: _constrainedHeight
        };
      }
      if (preferredPlacement === "bottom") {
        if (shouldScroll) {
          scrollTo(scrollParent, scrollDown);
        }
        return {
          placement: "bottom",
          maxHeight: preferredMaxHeight
        };
      }
      break;
    case "top":
      if (viewSpaceAbove >= menuHeight) {
        return {
          placement: "top",
          maxHeight: preferredMaxHeight
        };
      }
      if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }
        return {
          placement: "top",
          maxHeight: preferredMaxHeight
        };
      }
      if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
        var _constrainedHeight2 = preferredMaxHeight;
        if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
          _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
        }
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }
        return {
          placement: "top",
          maxHeight: _constrainedHeight2
        };
      }
      return {
        placement: "bottom",
        maxHeight: preferredMaxHeight
      };
    default:
      throw new Error('Invalid placement provided "'.concat(preferredPlacement, '".'));
  }
  return defaultState;
}
function alignToControl(placement) {
  var placementToCSSProp = {
    bottom: "top",
    top: "bottom"
  };
  return placement ? placementToCSSProp[placement] : "bottom";
}
var coercePlacement = function coercePlacement2(p2) {
  return p2 === "auto" ? "bottom" : p2;
};
var menuCSS = function menuCSS2(_ref22, unstyled) {
  var _objectSpread2$1;
  var placement = _ref22.placement, _ref2$theme = _ref22.theme, borderRadius2 = _ref2$theme.borderRadius, spacing2 = _ref2$theme.spacing, colors2 = _ref2$theme.colors;
  return _objectSpread2((_objectSpread2$1 = {
    label: "menu"
  }, _defineProperty(_objectSpread2$1, alignToControl(placement), "100%"), _defineProperty(_objectSpread2$1, "position", "absolute"), _defineProperty(_objectSpread2$1, "width", "100%"), _defineProperty(_objectSpread2$1, "zIndex", 1), _objectSpread2$1), unstyled ? {} : {
    backgroundColor: colors2.neutral0,
    borderRadius: borderRadius2,
    boxShadow: "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)",
    marginBottom: spacing2.menuGutter,
    marginTop: spacing2.menuGutter
  });
};
var PortalPlacementContext = /* @__PURE__ */ createContext$1(null);
var MenuPlacer = function MenuPlacer2(props) {
  var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView, theme2 = props.theme;
  var _ref3 = useContext(PortalPlacementContext) || {}, setPortalPlacement = _ref3.setPortalPlacement;
  var ref = useRef(null);
  var _useState = useState(maxMenuHeight), _useState2 = _slicedToArray(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
  var _useState3 = useState(null), _useState4 = _slicedToArray(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
  var controlHeight2 = theme2.spacing.controlHeight;
  index$2(function() {
    var menuEl = ref.current;
    if (!menuEl) return;
    var isFixedPosition = menuPosition === "fixed";
    var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
    var state = getMenuPlacement({
      maxHeight: maxMenuHeight,
      menuEl,
      minHeight: minMenuHeight,
      placement: menuPlacement,
      shouldScroll,
      isFixedPosition,
      controlHeight: controlHeight2
    });
    setMaxHeight(state.maxHeight);
    setPlacement(state.placement);
    setPortalPlacement === null || setPortalPlacement === void 0 ? void 0 : setPortalPlacement(state.placement);
  }, [maxMenuHeight, menuPlacement, menuPosition, menuShouldScrollIntoView, minMenuHeight, setPortalPlacement, controlHeight2]);
  return children({
    ref,
    placerProps: _objectSpread2(_objectSpread2({}, props), {}, {
      placement: placement || coercePlacement(menuPlacement),
      maxHeight
    })
  });
};
var Menu = function Menu2(props) {
  var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps;
  return jsx("div", _extends$1({}, getStyleProps(props, "menu", {
    menu: true
  }), {
    ref: innerRef
  }, innerProps), children);
};
var Menu$1 = Menu;
var menuListCSS = function menuListCSS2(_ref4, unstyled) {
  var maxHeight = _ref4.maxHeight, baseUnit2 = _ref4.theme.spacing.baseUnit;
  return _objectSpread2({
    maxHeight,
    overflowY: "auto",
    position: "relative",
    // required for offset[Height, Top] > keyboard scroll
    WebkitOverflowScrolling: "touch"
  }, unstyled ? {} : {
    paddingBottom: baseUnit2,
    paddingTop: baseUnit2
  });
};
var MenuList = function MenuList2(props) {
  var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
  return jsx("div", _extends$1({}, getStyleProps(props, "menuList", {
    "menu-list": true,
    "menu-list--is-multi": isMulti
  }), {
    ref: innerRef
  }, innerProps), children);
};
var noticeCSS = function noticeCSS2(_ref5, unstyled) {
  var _ref5$theme = _ref5.theme, baseUnit2 = _ref5$theme.spacing.baseUnit, colors2 = _ref5$theme.colors;
  return _objectSpread2({
    textAlign: "center"
  }, unstyled ? {} : {
    color: colors2.neutral40,
    padding: "".concat(baseUnit2 * 2, "px ").concat(baseUnit2 * 3, "px")
  });
};
var noOptionsMessageCSS = noticeCSS;
var loadingMessageCSS = noticeCSS;
var NoOptionsMessage = function NoOptionsMessage2(_ref6) {
  var _ref6$children = _ref6.children, children = _ref6$children === void 0 ? "No options" : _ref6$children, innerProps = _ref6.innerProps, restProps = _objectWithoutProperties(_ref6, _excluded$3$1);
  return jsx("div", _extends$1({}, getStyleProps(_objectSpread2(_objectSpread2({}, restProps), {}, {
    children,
    innerProps
  }), "noOptionsMessage", {
    "menu-notice": true,
    "menu-notice--no-options": true
  }), innerProps), children);
};
var LoadingMessage = function LoadingMessage2(_ref7) {
  var _ref7$children = _ref7.children, children = _ref7$children === void 0 ? "Loading..." : _ref7$children, innerProps = _ref7.innerProps, restProps = _objectWithoutProperties(_ref7, _excluded2$1);
  return jsx("div", _extends$1({}, getStyleProps(_objectSpread2(_objectSpread2({}, restProps), {}, {
    children,
    innerProps
  }), "loadingMessage", {
    "menu-notice": true,
    "menu-notice--loading": true
  }), innerProps), children);
};
var menuPortalCSS = function menuPortalCSS2(_ref8) {
  var rect = _ref8.rect, offset2 = _ref8.offset, position2 = _ref8.position;
  return {
    left: rect.left,
    position: position2,
    top: offset2,
    width: rect.width,
    zIndex: 1
  };
};
var MenuPortal = function MenuPortal2(props) {
  var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition;
  var menuPortalRef = useRef(null);
  var cleanupRef = useRef(null);
  var _useState5 = useState(coercePlacement(menuPlacement)), _useState6 = _slicedToArray(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
  var portalPlacementContext = useMemo(function() {
    return {
      setPortalPlacement
    };
  }, []);
  var _useState7 = useState(null), _useState8 = _slicedToArray(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
  var updateComputedPosition = useCallback(function() {
    if (!controlElement) return;
    var rect = getBoundingClientObj(controlElement);
    var scrollDistance = menuPosition === "fixed" ? 0 : window.pageYOffset;
    var offset2 = rect[placement] + scrollDistance;
    if (offset2 !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) {
      setComputedPosition({
        offset: offset2,
        rect
      });
    }
  }, [controlElement, menuPosition, placement, computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset, computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left, computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width]);
  index$2(function() {
    updateComputedPosition();
  }, [updateComputedPosition]);
  var runAutoUpdate = useCallback(function() {
    if (typeof cleanupRef.current === "function") {
      cleanupRef.current();
      cleanupRef.current = null;
    }
    if (controlElement && menuPortalRef.current) {
      cleanupRef.current = autoUpdate(controlElement, menuPortalRef.current, updateComputedPosition, {
        elementResize: "ResizeObserver" in window
      });
    }
  }, [controlElement, updateComputedPosition]);
  index$2(function() {
    runAutoUpdate();
  }, [runAutoUpdate]);
  var setMenuPortalElement = useCallback(function(menuPortalElement) {
    menuPortalRef.current = menuPortalElement;
    runAutoUpdate();
  }, [runAutoUpdate]);
  if (!appendTo && menuPosition !== "fixed" || !computedPosition) return null;
  var menuWrapper = jsx("div", _extends$1({
    ref: setMenuPortalElement
  }, getStyleProps(_objectSpread2(_objectSpread2({}, props), {}, {
    offset: computedPosition.offset,
    position: menuPosition,
    rect: computedPosition.rect
  }), "menuPortal", {
    "menu-portal": true
  }), innerProps), children);
  return jsx(PortalPlacementContext.Provider, {
    value: portalPlacementContext
  }, appendTo ? /* @__PURE__ */ createPortal(menuWrapper, appendTo) : menuWrapper);
};
var containerCSS = function containerCSS2(_ref3) {
  var isDisabled = _ref3.isDisabled, isRtl = _ref3.isRtl;
  return {
    label: "container",
    direction: isRtl ? "rtl" : void 0,
    pointerEvents: isDisabled ? "none" : void 0,
    // cancel mouse events when disabled
    position: "relative"
  };
};
var SelectContainer = function SelectContainer2(props) {
  var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
  return jsx("div", _extends$1({}, getStyleProps(props, "container", {
    "--is-disabled": isDisabled,
    "--is-rtl": isRtl
  }), innerProps), children);
};
var valueContainerCSS = function valueContainerCSS2(_ref22, unstyled) {
  var spacing2 = _ref22.theme.spacing, isMulti = _ref22.isMulti, hasValue = _ref22.hasValue, controlShouldRenderValue = _ref22.selectProps.controlShouldRenderValue;
  return _objectSpread2({
    alignItems: "center",
    display: isMulti && hasValue && controlShouldRenderValue ? "flex" : "grid",
    flex: 1,
    flexWrap: "wrap",
    WebkitOverflowScrolling: "touch",
    position: "relative",
    overflow: "hidden"
  }, unstyled ? {} : {
    padding: "".concat(spacing2.baseUnit / 2, "px ").concat(spacing2.baseUnit * 2, "px")
  });
};
var ValueContainer = function ValueContainer2(props) {
  var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue;
  return jsx("div", _extends$1({}, getStyleProps(props, "valueContainer", {
    "value-container": true,
    "value-container--is-multi": isMulti,
    "value-container--has-value": hasValue
  }), innerProps), children);
};
var indicatorsContainerCSS = function indicatorsContainerCSS2() {
  return {
    alignItems: "center",
    alignSelf: "stretch",
    display: "flex",
    flexShrink: 0
  };
};
var IndicatorsContainer = function IndicatorsContainer2(props) {
  var children = props.children, innerProps = props.innerProps;
  return jsx("div", _extends$1({}, getStyleProps(props, "indicatorsContainer", {
    indicators: true
  }), innerProps), children);
};
var _templateObject;
var _excluded$2$1 = ["size"], _excluded2$2 = ["innerProps", "isRtl", "size"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$3() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var _ref2$2 = process.env.NODE_ENV === "production" ? {
  name: "8mmkcg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
} : {
  name: "tj5bde-Svg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0;label:Svg;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$3
};
var Svg = function Svg2(_ref3) {
  var size2 = _ref3.size, props = _objectWithoutProperties(_ref3, _excluded$2$1);
  return jsx("svg", _extends$1({
    height: size2,
    width: size2,
    viewBox: "0 0 20 20",
    "aria-hidden": "true",
    focusable: "false",
    css: _ref2$2
  }, props));
};
var CrossIcon = function CrossIcon2(props) {
  return jsx(Svg, _extends$1({
    size: 20
  }, props), jsx("path", {
    d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
  }));
};
var DownChevron = function DownChevron2(props) {
  return jsx(Svg, _extends$1({
    size: 20
  }, props), jsx("path", {
    d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
  }));
};
var baseCSS = function baseCSS2(_ref3, unstyled) {
  var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit2 = _ref3$theme.spacing.baseUnit, colors2 = _ref3$theme.colors;
  return _objectSpread2({
    label: "indicatorContainer",
    display: "flex",
    transition: "color 150ms"
  }, unstyled ? {} : {
    color: isFocused ? colors2.neutral60 : colors2.neutral20,
    padding: baseUnit2 * 2,
    ":hover": {
      color: isFocused ? colors2.neutral80 : colors2.neutral40
    }
  });
};
var dropdownIndicatorCSS = baseCSS;
var DropdownIndicator = function DropdownIndicator2(props) {
  var children = props.children, innerProps = props.innerProps;
  return jsx("div", _extends$1({}, getStyleProps(props, "dropdownIndicator", {
    indicator: true,
    "dropdown-indicator": true
  }), innerProps), children || jsx(DownChevron, null));
};
var clearIndicatorCSS = baseCSS;
var ClearIndicator = function ClearIndicator2(props) {
  var children = props.children, innerProps = props.innerProps;
  return jsx("div", _extends$1({}, getStyleProps(props, "clearIndicator", {
    indicator: true,
    "clear-indicator": true
  }), innerProps), children || jsx(CrossIcon, null));
};
var indicatorSeparatorCSS = function indicatorSeparatorCSS2(_ref4, unstyled) {
  var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit2 = _ref4$theme.spacing.baseUnit, colors2 = _ref4$theme.colors;
  return _objectSpread2({
    label: "indicatorSeparator",
    alignSelf: "stretch",
    width: 1
  }, unstyled ? {} : {
    backgroundColor: isDisabled ? colors2.neutral10 : colors2.neutral20,
    marginBottom: baseUnit2 * 2,
    marginTop: baseUnit2 * 2
  });
};
var IndicatorSeparator = function IndicatorSeparator2(props) {
  var innerProps = props.innerProps;
  return jsx("span", _extends$1({}, innerProps, getStyleProps(props, "indicatorSeparator", {
    "indicator-separator": true
  })));
};
var loadingDotAnimations = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"])));
var loadingIndicatorCSS = function loadingIndicatorCSS2(_ref5, unstyled) {
  var isFocused = _ref5.isFocused, size2 = _ref5.size, _ref5$theme = _ref5.theme, colors2 = _ref5$theme.colors, baseUnit2 = _ref5$theme.spacing.baseUnit;
  return _objectSpread2({
    label: "loadingIndicator",
    display: "flex",
    transition: "color 150ms",
    alignSelf: "center",
    fontSize: size2,
    lineHeight: 1,
    marginRight: size2,
    textAlign: "center",
    verticalAlign: "middle"
  }, unstyled ? {} : {
    color: isFocused ? colors2.neutral60 : colors2.neutral20,
    padding: baseUnit2 * 2
  });
};
var LoadingDot = function LoadingDot2(_ref6) {
  var delay = _ref6.delay, offset2 = _ref6.offset;
  return jsx("span", {
    css: /* @__PURE__ */ css$2({
      animation: "".concat(loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
      backgroundColor: "currentColor",
      borderRadius: "1em",
      display: "inline-block",
      marginLeft: offset2 ? "1em" : void 0,
      height: "1em",
      verticalAlign: "top",
      width: "1em"
    }, process.env.NODE_ENV === "production" ? "" : ";label:LoadingDot;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
  });
};
var LoadingIndicator = function LoadingIndicator2(_ref7) {
  var innerProps = _ref7.innerProps, isRtl = _ref7.isRtl, _ref7$size = _ref7.size, size2 = _ref7$size === void 0 ? 4 : _ref7$size, restProps = _objectWithoutProperties(_ref7, _excluded2$2);
  return jsx("div", _extends$1({}, getStyleProps(_objectSpread2(_objectSpread2({}, restProps), {}, {
    innerProps,
    isRtl,
    size: size2
  }), "loadingIndicator", {
    indicator: true,
    "loading-indicator": true
  }), innerProps), jsx(LoadingDot, {
    delay: 0,
    offset: isRtl
  }), jsx(LoadingDot, {
    delay: 160,
    offset: true
  }), jsx(LoadingDot, {
    delay: 320,
    offset: !isRtl
  }));
};
var css$1 = function css(_ref3, unstyled) {
  var isDisabled = _ref3.isDisabled, isFocused = _ref3.isFocused, _ref$theme = _ref3.theme, colors2 = _ref$theme.colors, borderRadius2 = _ref$theme.borderRadius, spacing2 = _ref$theme.spacing;
  return _objectSpread2({
    label: "control",
    alignItems: "center",
    cursor: "default",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    minHeight: spacing2.controlHeight,
    outline: "0 !important",
    position: "relative",
    transition: "all 100ms"
  }, unstyled ? {} : {
    backgroundColor: isDisabled ? colors2.neutral5 : colors2.neutral0,
    borderColor: isDisabled ? colors2.neutral10 : isFocused ? colors2.primary : colors2.neutral20,
    borderRadius: borderRadius2,
    borderStyle: "solid",
    borderWidth: 1,
    boxShadow: isFocused ? "0 0 0 1px ".concat(colors2.primary) : void 0,
    "&:hover": {
      borderColor: isFocused ? colors2.primary : colors2.neutral30
    }
  });
};
var Control = function Control2(props) {
  var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
  return jsx("div", _extends$1({
    ref: innerRef
  }, getStyleProps(props, "control", {
    control: true,
    "control--is-disabled": isDisabled,
    "control--is-focused": isFocused,
    "control--menu-is-open": menuIsOpen
  }), innerProps, {
    "aria-disabled": isDisabled || void 0
  }), children);
};
var Control$1 = Control;
var _excluded$1$1 = ["data"];
var groupCSS = function groupCSS2(_ref3, unstyled) {
  var spacing2 = _ref3.theme.spacing;
  return unstyled ? {} : {
    paddingBottom: spacing2.baseUnit * 2,
    paddingTop: spacing2.baseUnit * 2
  };
};
var Group = function Group2(props) {
  var children = props.children, cx = props.cx, getStyles2 = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme2 = props.theme, selectProps = props.selectProps;
  return jsx("div", _extends$1({}, getStyleProps(props, "group", {
    group: true
  }), innerProps), jsx(Heading, _extends$1({}, headingProps, {
    selectProps,
    theme: theme2,
    getStyles: getStyles2,
    getClassNames,
    cx
  }), label), jsx("div", null, children));
};
var groupHeadingCSS = function groupHeadingCSS2(_ref22, unstyled) {
  var _ref2$theme = _ref22.theme, colors2 = _ref2$theme.colors, spacing2 = _ref2$theme.spacing;
  return _objectSpread2({
    label: "group",
    cursor: "default",
    display: "block"
  }, unstyled ? {} : {
    color: colors2.neutral40,
    fontSize: "75%",
    fontWeight: 500,
    marginBottom: "0.25em",
    paddingLeft: spacing2.baseUnit * 3,
    paddingRight: spacing2.baseUnit * 3,
    textTransform: "uppercase"
  });
};
var GroupHeading = function GroupHeading2(props) {
  var _cleanCommonProps = cleanCommonProps(props);
  _cleanCommonProps.data;
  var innerProps = _objectWithoutProperties(_cleanCommonProps, _excluded$1$1);
  return jsx("div", _extends$1({}, getStyleProps(props, "groupHeading", {
    "group-heading": true
  }), innerProps));
};
var Group$1 = Group;
var _excluded$6 = ["innerRef", "isDisabled", "isHidden", "inputClassName"];
var inputCSS = function inputCSS2(_ref3, unstyled) {
  var isDisabled = _ref3.isDisabled, value = _ref3.value, _ref$theme = _ref3.theme, spacing2 = _ref$theme.spacing, colors2 = _ref$theme.colors;
  return _objectSpread2(_objectSpread2({
    visibility: isDisabled ? "hidden" : "visible",
    // force css to recompute when value change due to @emotion bug.
    // We can remove it whenever the bug is fixed.
    transform: value ? "translateZ(0)" : ""
  }, containerStyle), unstyled ? {} : {
    margin: spacing2.baseUnit / 2,
    paddingBottom: spacing2.baseUnit / 2,
    paddingTop: spacing2.baseUnit / 2,
    color: colors2.neutral80
  });
};
var spacingStyle = {
  gridArea: "1 / 2",
  font: "inherit",
  minWidth: "2px",
  border: 0,
  margin: 0,
  outline: 0,
  padding: 0
};
var containerStyle = {
  flex: "1 1 auto",
  display: "inline-grid",
  gridArea: "1 / 1 / 2 / 3",
  gridTemplateColumns: "0 min-content",
  "&:after": _objectSpread2({
    content: 'attr(data-value) " "',
    visibility: "hidden",
    whiteSpace: "pre"
  }, spacingStyle)
};
var inputStyle = function inputStyle2(isHidden) {
  return _objectSpread2({
    label: "input",
    color: "inherit",
    background: 0,
    opacity: isHidden ? 0 : 1,
    width: "100%"
  }, spacingStyle);
};
var Input = function Input2(props) {
  var cx = props.cx, value = props.value;
  var _cleanCommonProps = cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, innerProps = _objectWithoutProperties(_cleanCommonProps, _excluded$6);
  return jsx("div", _extends$1({}, getStyleProps(props, "input", {
    "input-container": true
  }), {
    "data-value": value || ""
  }), jsx("input", _extends$1({
    className: cx({
      input: true
    }, inputClassName),
    ref: innerRef,
    style: inputStyle(isHidden),
    disabled: isDisabled
  }, innerProps)));
};
var Input$1 = Input;
var multiValueCSS = function multiValueCSS2(_ref3, unstyled) {
  var _ref$theme = _ref3.theme, spacing2 = _ref$theme.spacing, borderRadius2 = _ref$theme.borderRadius, colors2 = _ref$theme.colors;
  return _objectSpread2({
    label: "multiValue",
    display: "flex",
    minWidth: 0
  }, unstyled ? {} : {
    backgroundColor: colors2.neutral10,
    borderRadius: borderRadius2 / 2,
    margin: spacing2.baseUnit / 2
  });
};
var multiValueLabelCSS = function multiValueLabelCSS2(_ref22, unstyled) {
  var _ref2$theme = _ref22.theme, borderRadius2 = _ref2$theme.borderRadius, colors2 = _ref2$theme.colors, cropWithEllipsis = _ref22.cropWithEllipsis;
  return _objectSpread2({
    overflow: "hidden",
    textOverflow: cropWithEllipsis || cropWithEllipsis === void 0 ? "ellipsis" : void 0,
    whiteSpace: "nowrap"
  }, unstyled ? {} : {
    borderRadius: borderRadius2 / 2,
    color: colors2.neutral80,
    fontSize: "85%",
    padding: 3,
    paddingLeft: 6
  });
};
var multiValueRemoveCSS = function multiValueRemoveCSS2(_ref3, unstyled) {
  var _ref3$theme = _ref3.theme, spacing2 = _ref3$theme.spacing, borderRadius2 = _ref3$theme.borderRadius, colors2 = _ref3$theme.colors, isFocused = _ref3.isFocused;
  return _objectSpread2({
    alignItems: "center",
    display: "flex"
  }, unstyled ? {} : {
    borderRadius: borderRadius2 / 2,
    backgroundColor: isFocused ? colors2.dangerLight : void 0,
    paddingLeft: spacing2.baseUnit,
    paddingRight: spacing2.baseUnit,
    ":hover": {
      backgroundColor: colors2.dangerLight,
      color: colors2.danger
    }
  });
};
var MultiValueGeneric = function MultiValueGeneric2(_ref4) {
  var children = _ref4.children, innerProps = _ref4.innerProps;
  return jsx("div", innerProps, children);
};
var MultiValueContainer = MultiValueGeneric;
var MultiValueLabel = MultiValueGeneric;
function MultiValueRemove(_ref5) {
  var children = _ref5.children, innerProps = _ref5.innerProps;
  return jsx("div", _extends$1({
    role: "button"
  }, innerProps), children || jsx(CrossIcon, {
    size: 14
  }));
}
var MultiValue = function MultiValue2(props) {
  var children = props.children, components2 = props.components, data2 = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps3 = props.removeProps, selectProps = props.selectProps;
  var Container = components2.Container, Label2 = components2.Label, Remove = components2.Remove;
  return jsx(Container, {
    data: data2,
    innerProps: _objectSpread2(_objectSpread2({}, getStyleProps(props, "multiValue", {
      "multi-value": true,
      "multi-value--is-disabled": isDisabled
    })), innerProps),
    selectProps
  }, jsx(Label2, {
    data: data2,
    innerProps: _objectSpread2({}, getStyleProps(props, "multiValueLabel", {
      "multi-value__label": true
    })),
    selectProps
  }, children), jsx(Remove, {
    data: data2,
    innerProps: _objectSpread2(_objectSpread2({}, getStyleProps(props, "multiValueRemove", {
      "multi-value__remove": true
    })), {}, {
      "aria-label": "Remove ".concat(children || "option")
    }, removeProps3),
    selectProps
  }));
};
var MultiValue$1 = MultiValue;
var optionCSS = function optionCSS2(_ref3, unstyled) {
  var isDisabled = _ref3.isDisabled, isFocused = _ref3.isFocused, isSelected = _ref3.isSelected, _ref$theme = _ref3.theme, spacing2 = _ref$theme.spacing, colors2 = _ref$theme.colors;
  return _objectSpread2({
    label: "option",
    cursor: "default",
    display: "block",
    fontSize: "inherit",
    width: "100%",
    userSelect: "none",
    WebkitTapHighlightColor: "rgba(0, 0, 0, 0)"
  }, unstyled ? {} : {
    backgroundColor: isSelected ? colors2.primary : isFocused ? colors2.primary25 : "transparent",
    color: isDisabled ? colors2.neutral20 : isSelected ? colors2.neutral0 : "inherit",
    padding: "".concat(spacing2.baseUnit * 2, "px ").concat(spacing2.baseUnit * 3, "px"),
    // provide some affordance on touch devices
    ":active": {
      backgroundColor: !isDisabled ? isSelected ? colors2.primary : colors2.primary50 : void 0
    }
  });
};
var Option = function Option2(props) {
  var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
  return jsx("div", _extends$1({}, getStyleProps(props, "option", {
    option: true,
    "option--is-disabled": isDisabled,
    "option--is-focused": isFocused,
    "option--is-selected": isSelected
  }), {
    ref: innerRef,
    "aria-disabled": isDisabled
  }, innerProps), children);
};
var Option$1 = Option;
var placeholderCSS = function placeholderCSS2(_ref3, unstyled) {
  var _ref$theme = _ref3.theme, spacing2 = _ref$theme.spacing, colors2 = _ref$theme.colors;
  return _objectSpread2({
    label: "placeholder",
    gridArea: "1 / 1 / 2 / 3"
  }, unstyled ? {} : {
    color: colors2.neutral50,
    marginLeft: spacing2.baseUnit / 2,
    marginRight: spacing2.baseUnit / 2
  });
};
var Placeholder = function Placeholder2(props) {
  var children = props.children, innerProps = props.innerProps;
  return jsx("div", _extends$1({}, getStyleProps(props, "placeholder", {
    placeholder: true
  }), innerProps), children);
};
var Placeholder$1 = Placeholder;
var css2 = function css3(_ref3, unstyled) {
  var isDisabled = _ref3.isDisabled, _ref$theme = _ref3.theme, spacing2 = _ref$theme.spacing, colors2 = _ref$theme.colors;
  return _objectSpread2({
    label: "singleValue",
    gridArea: "1 / 1 / 2 / 3",
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  }, unstyled ? {} : {
    color: isDisabled ? colors2.neutral40 : colors2.neutral80,
    marginLeft: spacing2.baseUnit / 2,
    marginRight: spacing2.baseUnit / 2
  });
};
var SingleValue = function SingleValue2(props) {
  var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps;
  return jsx("div", _extends$1({}, getStyleProps(props, "singleValue", {
    "single-value": true,
    "single-value--is-disabled": isDisabled
  }), innerProps), children);
};
var SingleValue$1 = SingleValue;
var components = {
  ClearIndicator,
  Control: Control$1,
  DropdownIndicator,
  DownChevron,
  CrossIcon,
  Group: Group$1,
  GroupHeading,
  IndicatorsContainer,
  IndicatorSeparator,
  Input: Input$1,
  LoadingIndicator,
  Menu: Menu$1,
  MenuList,
  MenuPortal,
  LoadingMessage,
  NoOptionsMessage,
  MultiValue: MultiValue$1,
  MultiValueContainer,
  MultiValueLabel,
  MultiValueRemove,
  Option: Option$1,
  Placeholder: Placeholder$1,
  SelectContainer,
  SingleValue: SingleValue$1,
  ValueContainer
};
var defaultComponents = function defaultComponents2(props) {
  return _objectSpread2(_objectSpread2({}, components), props.components);
};
var safeIsNaN = Number.isNaN || function ponyfill(value) {
  return typeof value === "number" && value !== value;
};
function isEqual(first, second) {
  if (first === second) {
    return true;
  }
  if (safeIsNaN(first) && safeIsNaN(second)) {
    return true;
  }
  return false;
}
function areInputsEqual(newInputs, lastInputs) {
  if (newInputs.length !== lastInputs.length) {
    return false;
  }
  for (var i = 0; i < newInputs.length; i++) {
    if (!isEqual(newInputs[i], lastInputs[i])) {
      return false;
    }
  }
  return true;
}
function memoizeOne(resultFn, isEqual2) {
  if (isEqual2 === void 0) {
    isEqual2 = areInputsEqual;
  }
  var cache = null;
  function memoized() {
    var newArgs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      newArgs[_i] = arguments[_i];
    }
    if (cache && cache.lastThis === this && isEqual2(newArgs, cache.lastArgs)) {
      return cache.lastResult;
    }
    var lastResult = resultFn.apply(this, newArgs);
    cache = {
      lastResult,
      lastArgs: newArgs,
      lastThis: this
    };
    return lastResult;
  }
  memoized.clear = function clear() {
    cache = null;
  };
  return memoized;
}
function _EMOTION_STRINGIFIED_CSS_ERROR__$2() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var _ref = process.env.NODE_ENV === "production" ? {
  name: "7pg0cj-a11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
} : {
  name: "1f43avz-a11yText-A11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap;label:A11yText;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkExMXlUZXh0LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNSSIsImZpbGUiOiJBMTF5VGV4dC50c3giLCJzb3VyY2VzQ29udGVudCI6WyIvKiogQGpzeCBqc3ggKi9cbmltcG9ydCB7IGpzeCB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcblxuLy8gQXNzaXN0aXZlIHRleHQgdG8gZGVzY3JpYmUgdmlzdWFsIGVsZW1lbnRzLiBIaWRkZW4gZm9yIHNpZ2h0ZWQgdXNlcnMuXG5jb25zdCBBMTF5VGV4dCA9IChwcm9wczogSlNYLkludHJpbnNpY0VsZW1lbnRzWydzcGFuJ10pID0+IChcbiAgPHNwYW5cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAnYTExeVRleHQnLFxuICAgICAgekluZGV4OiA5OTk5LFxuICAgICAgYm9yZGVyOiAwLFxuICAgICAgY2xpcDogJ3JlY3QoMXB4LCAxcHgsIDFweCwgMXB4KScsXG4gICAgICBoZWlnaHQ6IDEsXG4gICAgICB3aWR0aDogMSxcbiAgICAgIHBvc2l0aW9uOiAnYWJzb2x1dGUnLFxuICAgICAgb3ZlcmZsb3c6ICdoaWRkZW4nLFxuICAgICAgcGFkZGluZzogMCxcbiAgICAgIHdoaXRlU3BhY2U6ICdub3dyYXAnLFxuICAgIH19XG4gICAgey4uLnByb3BzfVxuICAvPlxuKTtcblxuZXhwb3J0IGRlZmF1bHQgQTExeVRleHQ7XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$2
};
var A11yText = function A11yText2(props) {
  return jsx("span", _extends$1({
    css: _ref
  }, props));
};
var A11yText$1 = A11yText;
var defaultAriaLiveMessages = {
  guidance: function guidance(props) {
    var isSearchable = props.isSearchable, isMulti = props.isMulti, tabSelectsValue = props.tabSelectsValue, context = props.context, isInitialFocus = props.isInitialFocus;
    switch (context) {
      case "menu":
        return "Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu".concat(tabSelectsValue ? ", press Tab to select the option and exit the menu" : "", ".");
      case "input":
        return isInitialFocus ? "".concat(props["aria-label"] || "Select", " is focused ").concat(isSearchable ? ",type to refine list" : "", ", press Down to open the menu, ").concat(isMulti ? " press left to focus selected values" : "") : "";
      case "value":
        return "Use left and right to toggle between focused values, press Backspace to remove the currently focused value";
      default:
        return "";
    }
  },
  onChange: function onChange(props) {
    var action = props.action, _props$label = props.label, label = _props$label === void 0 ? "" : _props$label, labels = props.labels, isDisabled = props.isDisabled;
    switch (action) {
      case "deselect-option":
      case "pop-value":
      case "remove-value":
        return "option ".concat(label, ", deselected.");
      case "clear":
        return "All selected options have been cleared.";
      case "initial-input-focus":
        return "option".concat(labels.length > 1 ? "s" : "", " ").concat(labels.join(","), ", selected.");
      case "select-option":
        return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
      default:
        return "";
    }
  },
  onFocus: function onFocus(props) {
    var context = props.context, focused = props.focused, options2 = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? "" : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected, isAppleDevice2 = props.isAppleDevice;
    var getArrayIndex = function getArrayIndex2(arr, item) {
      return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : "";
    };
    if (context === "value" && selectValue) {
      return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
    }
    if (context === "menu" && isAppleDevice2) {
      var disabled = isDisabled ? " disabled" : "";
      var status = "".concat(isSelected ? " selected" : "").concat(disabled);
      return "".concat(label).concat(status, ", ").concat(getArrayIndex(options2, focused), ".");
    }
    return "";
  },
  onFilter: function onFilter(props) {
    var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
    return "".concat(resultsMessage).concat(inputValue ? " for search term " + inputValue : "", ".");
  }
};
var LiveRegion = function LiveRegion2(props) {
  var ariaSelection = props.ariaSelection, focusedOption2 = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id, isAppleDevice2 = props.isAppleDevice;
  var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel4 = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled3 = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options2 = selectProps.options, screenReaderStatus2 = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue, isLoading = selectProps.isLoading;
  var ariaLabel = selectProps["aria-label"];
  var ariaLive = selectProps["aria-live"];
  var messages = useMemo(function() {
    return _objectSpread2(_objectSpread2({}, defaultAriaLiveMessages), ariaLiveMessages || {});
  }, [ariaLiveMessages]);
  var ariaSelected = useMemo(function() {
    var message2 = "";
    if (ariaSelection && messages.onChange) {
      var option2 = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
      var asOption = function asOption2(val) {
        return !Array.isArray(val) ? val : null;
      };
      var selected = removedValue || option2 || asOption(value);
      var label = selected ? getOptionLabel4(selected) : "";
      var multiSelected = selectedOptions || removedValues || void 0;
      var labels = multiSelected ? multiSelected.map(getOptionLabel4) : [];
      var onChangeProps = _objectSpread2({
        // multiSelected items are usually items that have already been selected
        // or set by the user as a default value so we assume they are not disabled
        isDisabled: selected && isOptionDisabled3(selected, selectValue),
        label,
        labels
      }, ariaSelection);
      message2 = messages.onChange(onChangeProps);
    }
    return message2;
  }, [ariaSelection, messages, isOptionDisabled3, selectValue, getOptionLabel4]);
  var ariaFocused = useMemo(function() {
    var focusMsg = "";
    var focused = focusedOption2 || focusedValue;
    var isSelected = !!(focusedOption2 && selectValue && selectValue.includes(focusedOption2));
    if (focused && messages.onFocus) {
      var onFocusProps = {
        focused,
        label: getOptionLabel4(focused),
        isDisabled: isOptionDisabled3(focused, selectValue),
        isSelected,
        options: focusableOptions,
        context: focused === focusedOption2 ? "menu" : "value",
        selectValue,
        isAppleDevice: isAppleDevice2
      };
      focusMsg = messages.onFocus(onFocusProps);
    }
    return focusMsg;
  }, [focusedOption2, focusedValue, getOptionLabel4, isOptionDisabled3, messages, focusableOptions, selectValue, isAppleDevice2]);
  var ariaResults = useMemo(function() {
    var resultsMsg = "";
    if (menuIsOpen && options2.length && !isLoading && messages.onFilter) {
      var resultsMessage = screenReaderStatus2({
        count: focusableOptions.length
      });
      resultsMsg = messages.onFilter({
        inputValue,
        resultsMessage
      });
    }
    return resultsMsg;
  }, [focusableOptions, inputValue, menuIsOpen, messages, options2, screenReaderStatus2, isLoading]);
  var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus";
  var ariaGuidance = useMemo(function() {
    var guidanceMsg = "";
    if (messages.guidance) {
      var context = focusedValue ? "value" : menuIsOpen ? "menu" : "input";
      guidanceMsg = messages.guidance({
        "aria-label": ariaLabel,
        context,
        isDisabled: focusedOption2 && isOptionDisabled3(focusedOption2, selectValue),
        isMulti,
        isSearchable,
        tabSelectsValue,
        isInitialFocus
      });
    }
    return guidanceMsg;
  }, [ariaLabel, focusedOption2, focusedValue, isMulti, isOptionDisabled3, isSearchable, menuIsOpen, messages, selectValue, tabSelectsValue, isInitialFocus]);
  var ScreenReaderText = jsx(Fragment, null, jsx("span", {
    id: "aria-selection"
  }, ariaSelected), jsx("span", {
    id: "aria-focused"
  }, ariaFocused), jsx("span", {
    id: "aria-results"
  }, ariaResults), jsx("span", {
    id: "aria-guidance"
  }, ariaGuidance));
  return jsx(Fragment, null, jsx(A11yText$1, {
    id
  }, isInitialFocus && ScreenReaderText), jsx(A11yText$1, {
    "aria-live": ariaLive,
    "aria-atomic": "false",
    "aria-relevant": "additions text",
    role: "log"
  }, isFocused && !isInitialFocus && ScreenReaderText));
};
var LiveRegion$1 = LiveRegion;
var diacritics = [{
  base: "A",
  letters: "AⒶＡÀÁÂẦẤẪẨÃĀĂẰẮẴẲȦǠÄǞẢÅǺǍȀȂẠẬẶḀĄȺⱯ"
}, {
  base: "AA",
  letters: "Ꜳ"
}, {
  base: "AE",
  letters: "ÆǼǢ"
}, {
  base: "AO",
  letters: "Ꜵ"
}, {
  base: "AU",
  letters: "Ꜷ"
}, {
  base: "AV",
  letters: "ꜸꜺ"
}, {
  base: "AY",
  letters: "Ꜽ"
}, {
  base: "B",
  letters: "BⒷＢḂḄḆɃƂƁ"
}, {
  base: "C",
  letters: "CⒸＣĆĈĊČÇḈƇȻꜾ"
}, {
  base: "D",
  letters: "DⒹＤḊĎḌḐḒḎĐƋƊƉꝹ"
}, {
  base: "DZ",
  letters: "ǱǄ"
}, {
  base: "Dz",
  letters: "ǲǅ"
}, {
  base: "E",
  letters: "EⒺＥÈÉÊỀẾỄỂẼĒḔḖĔĖËẺĚȄȆẸỆȨḜĘḘḚƐƎ"
}, {
  base: "F",
  letters: "FⒻＦḞƑꝻ"
}, {
  base: "G",
  letters: "GⒼＧǴĜḠĞĠǦĢǤƓꞠꝽꝾ"
}, {
  base: "H",
  letters: "HⒽＨĤḢḦȞḤḨḪĦⱧⱵꞍ"
}, {
  base: "I",
  letters: "IⒾＩÌÍÎĨĪĬİÏḮỈǏȈȊỊĮḬƗ"
}, {
  base: "J",
  letters: "JⒿＪĴɈ"
}, {
  base: "K",
  letters: "KⓀＫḰǨḲĶḴƘⱩꝀꝂꝄꞢ"
}, {
  base: "L",
  letters: "LⓁＬĿĹĽḶḸĻḼḺŁȽⱢⱠꝈꝆꞀ"
}, {
  base: "LJ",
  letters: "Ǉ"
}, {
  base: "Lj",
  letters: "ǈ"
}, {
  base: "M",
  letters: "MⓂＭḾṀṂⱮƜ"
}, {
  base: "N",
  letters: "NⓃＮǸŃÑṄŇṆŅṊṈȠƝꞐꞤ"
}, {
  base: "NJ",
  letters: "Ǌ"
}, {
  base: "Nj",
  letters: "ǋ"
}, {
  base: "O",
  letters: "OⓄＯÒÓÔỒỐỖỔÕṌȬṎŌṐṒŎȮȰÖȪỎŐǑȌȎƠỜỚỠỞỢỌỘǪǬØǾƆƟꝊꝌ"
}, {
  base: "OI",
  letters: "Ƣ"
}, {
  base: "OO",
  letters: "Ꝏ"
}, {
  base: "OU",
  letters: "Ȣ"
}, {
  base: "P",
  letters: "PⓅＰṔṖƤⱣꝐꝒꝔ"
}, {
  base: "Q",
  letters: "QⓆＱꝖꝘɊ"
}, {
  base: "R",
  letters: "RⓇＲŔṘŘȐȒṚṜŖṞɌⱤꝚꞦꞂ"
}, {
  base: "S",
  letters: "SⓈＳẞŚṤŜṠŠṦṢṨȘŞⱾꞨꞄ"
}, {
  base: "T",
  letters: "TⓉＴṪŤṬȚŢṰṮŦƬƮȾꞆ"
}, {
  base: "TZ",
  letters: "Ꜩ"
}, {
  base: "U",
  letters: "UⓊＵÙÚÛŨṸŪṺŬÜǛǗǕǙỦŮŰǓȔȖƯỪỨỮỬỰỤṲŲṶṴɄ"
}, {
  base: "V",
  letters: "VⓋＶṼṾƲꝞɅ"
}, {
  base: "VY",
  letters: "Ꝡ"
}, {
  base: "W",
  letters: "WⓌＷẀẂŴẆẄẈⱲ"
}, {
  base: "X",
  letters: "XⓍＸẊẌ"
}, {
  base: "Y",
  letters: "YⓎＹỲÝŶỸȲẎŸỶỴƳɎỾ"
}, {
  base: "Z",
  letters: "ZⓏＺŹẐŻŽẒẔƵȤⱿⱫꝢ"
}, {
  base: "a",
  letters: "aⓐａẚàáâầấẫẩãāăằắẵẳȧǡäǟảåǻǎȁȃạậặḁąⱥɐ"
}, {
  base: "aa",
  letters: "ꜳ"
}, {
  base: "ae",
  letters: "æǽǣ"
}, {
  base: "ao",
  letters: "ꜵ"
}, {
  base: "au",
  letters: "ꜷ"
}, {
  base: "av",
  letters: "ꜹꜻ"
}, {
  base: "ay",
  letters: "ꜽ"
}, {
  base: "b",
  letters: "bⓑｂḃḅḇƀƃɓ"
}, {
  base: "c",
  letters: "cⓒｃćĉċčçḉƈȼꜿↄ"
}, {
  base: "d",
  letters: "dⓓｄḋďḍḑḓḏđƌɖɗꝺ"
}, {
  base: "dz",
  letters: "ǳǆ"
}, {
  base: "e",
  letters: "eⓔｅèéêềếễểẽēḕḗĕėëẻěȅȇẹệȩḝęḙḛɇɛǝ"
}, {
  base: "f",
  letters: "fⓕｆḟƒꝼ"
}, {
  base: "g",
  letters: "gⓖｇǵĝḡğġǧģǥɠꞡᵹꝿ"
}, {
  base: "h",
  letters: "hⓗｈĥḣḧȟḥḩḫẖħⱨⱶɥ"
}, {
  base: "hv",
  letters: "ƕ"
}, {
  base: "i",
  letters: "iⓘｉìíîĩīĭïḯỉǐȉȋịįḭɨı"
}, {
  base: "j",
  letters: "jⓙｊĵǰɉ"
}, {
  base: "k",
  letters: "kⓚｋḱǩḳķḵƙⱪꝁꝃꝅꞣ"
}, {
  base: "l",
  letters: "lⓛｌŀĺľḷḹļḽḻſłƚɫⱡꝉꞁꝇ"
}, {
  base: "lj",
  letters: "ǉ"
}, {
  base: "m",
  letters: "mⓜｍḿṁṃɱɯ"
}, {
  base: "n",
  letters: "nⓝｎǹńñṅňṇņṋṉƞɲŉꞑꞥ"
}, {
  base: "nj",
  letters: "ǌ"
}, {
  base: "o",
  letters: "oⓞｏòóôồốỗổõṍȭṏōṑṓŏȯȱöȫỏőǒȍȏơờớỡởợọộǫǭøǿɔꝋꝍɵ"
}, {
  base: "oi",
  letters: "ƣ"
}, {
  base: "ou",
  letters: "ȣ"
}, {
  base: "oo",
  letters: "ꝏ"
}, {
  base: "p",
  letters: "pⓟｐṕṗƥᵽꝑꝓꝕ"
}, {
  base: "q",
  letters: "qⓠｑɋꝗꝙ"
}, {
  base: "r",
  letters: "rⓡｒŕṙřȑȓṛṝŗṟɍɽꝛꞧꞃ"
}, {
  base: "s",
  letters: "sⓢｓßśṥŝṡšṧṣṩșşȿꞩꞅẛ"
}, {
  base: "t",
  letters: "tⓣｔṫẗťṭțţṱṯŧƭʈⱦꞇ"
}, {
  base: "tz",
  letters: "ꜩ"
}, {
  base: "u",
  letters: "uⓤｕùúûũṹūṻŭüǜǘǖǚủůűǔȕȗưừứữửựụṳųṷṵʉ"
}, {
  base: "v",
  letters: "vⓥｖṽṿʋꝟʌ"
}, {
  base: "vy",
  letters: "ꝡ"
}, {
  base: "w",
  letters: "wⓦｗẁẃŵẇẅẘẉⱳ"
}, {
  base: "x",
  letters: "xⓧｘẋẍ"
}, {
  base: "y",
  letters: "yⓨｙỳýŷỹȳẏÿỷẙỵƴɏỿ"
}, {
  base: "z",
  letters: "zⓩｚźẑżžẓẕƶȥɀⱬꝣ"
}];
var anyDiacritic = new RegExp("[" + diacritics.map(function(d2) {
  return d2.letters;
}).join("") + "]", "g");
var diacriticToBase = {};
for (var i = 0; i < diacritics.length; i++) {
  var diacritic = diacritics[i];
  for (var j = 0; j < diacritic.letters.length; j++) {
    diacriticToBase[diacritic.letters[j]] = diacritic.base;
  }
}
var stripDiacritics = function stripDiacritics2(str) {
  return str.replace(anyDiacritic, function(match2) {
    return diacriticToBase[match2];
  });
};
var memoizedStripDiacriticsForInput = memoizeOne(stripDiacritics);
var trimString = function trimString2(str) {
  return str.replace(/^\s+|\s+$/g, "");
};
var defaultStringify = function defaultStringify2(option2) {
  return "".concat(option2.label, " ").concat(option2.value);
};
var createFilter = function createFilter2(config2) {
  return function(option2, rawInput) {
    if (option2.data.__isNew__) return true;
    var _ignoreCase$ignoreAcc = _objectSpread2({
      ignoreCase: true,
      ignoreAccents: true,
      stringify: defaultStringify,
      trim: true,
      matchFrom: "any"
    }, config2), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify2 = _ignoreCase$ignoreAcc.stringify, trim2 = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
    var input = trim2 ? trimString(rawInput) : rawInput;
    var candidate = trim2 ? trimString(stringify2(option2)) : stringify2(option2);
    if (ignoreCase) {
      input = input.toLowerCase();
      candidate = candidate.toLowerCase();
    }
    if (ignoreAccents) {
      input = memoizedStripDiacriticsForInput(input);
      candidate = stripDiacritics(candidate);
    }
    return matchFrom === "start" ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
  };
};
var _excluded$5 = ["innerRef"];
function DummyInput(_ref3) {
  var innerRef = _ref3.innerRef, props = _objectWithoutProperties(_ref3, _excluded$5);
  var filteredProps = removeProps(props, "onExited", "in", "enter", "exit", "appear");
  return jsx("input", _extends$1({
    ref: innerRef
  }, filteredProps, {
    css: /* @__PURE__ */ css$2({
      label: "dummyInput",
      // get rid of any default styles
      background: 0,
      border: 0,
      // important! this hides the flashing cursor
      caretColor: "transparent",
      fontSize: "inherit",
      gridArea: "1 / 1 / 2 / 3",
      outline: 0,
      padding: 0,
      // important! without `width` browsers won't allow focus
      width: 1,
      // remove cursor on desktop
      color: "transparent",
      // remove cursor on mobile whilst maintaining "scroll into view" behaviour
      left: -100,
      opacity: 0,
      position: "relative",
      transform: "scale(.01)"
    }, process.env.NODE_ENV === "production" ? "" : ";label:DummyInput;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkR1bW15SW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXlCTSIsImZpbGUiOiJEdW1teUlucHV0LnRzeCIsInNvdXJjZXNDb250ZW50IjpbIi8qKiBAanN4IGpzeCAqL1xuaW1wb3J0IHsgUmVmIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsganN4IH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHsgcmVtb3ZlUHJvcHMgfSBmcm9tICcuLi91dGlscyc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIER1bW15SW5wdXQoe1xuICBpbm5lclJlZixcbiAgLi4ucHJvcHNcbn06IEpTWC5JbnRyaW5zaWNFbGVtZW50c1snaW5wdXQnXSAmIHtcbiAgcmVhZG9ubHkgaW5uZXJSZWY6IFJlZjxIVE1MSW5wdXRFbGVtZW50Pjtcbn0pIHtcbiAgLy8gUmVtb3ZlIGFuaW1hdGlvbiBwcm9wcyBub3QgbWVhbnQgZm9yIEhUTUwgZWxlbWVudHNcbiAgY29uc3QgZmlsdGVyZWRQcm9wcyA9IHJlbW92ZVByb3BzKFxuICAgIHByb3BzLFxuICAgICdvbkV4aXRlZCcsXG4gICAgJ2luJyxcbiAgICAnZW50ZXInLFxuICAgICdleGl0JyxcbiAgICAnYXBwZWFyJ1xuICApO1xuXG4gIHJldHVybiAoXG4gICAgPGlucHV0XG4gICAgICByZWY9e2lubmVyUmVmfVxuICAgICAgey4uLmZpbHRlcmVkUHJvcHN9XG4gICAgICBjc3M9e3tcbiAgICAgICAgbGFiZWw6ICdkdW1teUlucHV0JyxcbiAgICAgICAgLy8gZ2V0IHJpZCBvZiBhbnkgZGVmYXVsdCBzdHlsZXNcbiAgICAgICAgYmFja2dyb3VuZDogMCxcbiAgICAgICAgYm9yZGVyOiAwLFxuICAgICAgICAvLyBpbXBvcnRhbnQhIHRoaXMgaGlkZXMgdGhlIGZsYXNoaW5nIGN1cnNvclxuICAgICAgICBjYXJldENvbG9yOiAndHJhbnNwYXJlbnQnLFxuICAgICAgICBmb250U2l6ZTogJ2luaGVyaXQnLFxuICAgICAgICBncmlkQXJlYTogJzEgLyAxIC8gMiAvIDMnLFxuICAgICAgICBvdXRsaW5lOiAwLFxuICAgICAgICBwYWRkaW5nOiAwLFxuICAgICAgICAvLyBpbXBvcnRhbnQhIHdpdGhvdXQgYHdpZHRoYCBicm93c2VycyB3b24ndCBhbGxvdyBmb2N1c1xuICAgICAgICB3aWR0aDogMSxcblxuICAgICAgICAvLyByZW1vdmUgY3Vyc29yIG9uIGRlc2t0b3BcbiAgICAgICAgY29sb3I6ICd0cmFuc3BhcmVudCcsXG5cbiAgICAgICAgLy8gcmVtb3ZlIGN1cnNvciBvbiBtb2JpbGUgd2hpbHN0IG1haW50YWluaW5nIFwic2Nyb2xsIGludG8gdmlld1wiIGJlaGF2aW91clxuICAgICAgICBsZWZ0OiAtMTAwLFxuICAgICAgICBvcGFjaXR5OiAwLFxuICAgICAgICBwb3NpdGlvbjogJ3JlbGF0aXZlJyxcbiAgICAgICAgdHJhbnNmb3JtOiAnc2NhbGUoLjAxKScsXG4gICAgICB9fVxuICAgIC8+XG4gICk7XG59XG4iXX0= */")
  }));
}
var cancelScroll = function cancelScroll2(event) {
  if (event.cancelable) event.preventDefault();
  event.stopPropagation();
};
function useScrollCapture(_ref3) {
  var isEnabled = _ref3.isEnabled, onBottomArrive = _ref3.onBottomArrive, onBottomLeave = _ref3.onBottomLeave, onTopArrive = _ref3.onTopArrive, onTopLeave = _ref3.onTopLeave;
  var isBottom = useRef(false);
  var isTop = useRef(false);
  var touchStart = useRef(0);
  var scrollTarget = useRef(null);
  var handleEventDelta = useCallback(function(event, delta) {
    if (scrollTarget.current === null) return;
    var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
    var target = scrollTarget.current;
    var isDeltaPositive = delta > 0;
    var availableScroll = scrollHeight - clientHeight - scrollTop;
    var shouldCancelScroll = false;
    if (availableScroll > delta && isBottom.current) {
      if (onBottomLeave) onBottomLeave(event);
      isBottom.current = false;
    }
    if (isDeltaPositive && isTop.current) {
      if (onTopLeave) onTopLeave(event);
      isTop.current = false;
    }
    if (isDeltaPositive && delta > availableScroll) {
      if (onBottomArrive && !isBottom.current) {
        onBottomArrive(event);
      }
      target.scrollTop = scrollHeight;
      shouldCancelScroll = true;
      isBottom.current = true;
    } else if (!isDeltaPositive && -delta > scrollTop) {
      if (onTopArrive && !isTop.current) {
        onTopArrive(event);
      }
      target.scrollTop = 0;
      shouldCancelScroll = true;
      isTop.current = true;
    }
    if (shouldCancelScroll) {
      cancelScroll(event);
    }
  }, [onBottomArrive, onBottomLeave, onTopArrive, onTopLeave]);
  var onWheel = useCallback(function(event) {
    handleEventDelta(event, event.deltaY);
  }, [handleEventDelta]);
  var onTouchStart = useCallback(function(event) {
    touchStart.current = event.changedTouches[0].clientY;
  }, []);
  var onTouchMove = useCallback(function(event) {
    var deltaY = touchStart.current - event.changedTouches[0].clientY;
    handleEventDelta(event, deltaY);
  }, [handleEventDelta]);
  var startListening = useCallback(function(el) {
    if (!el) return;
    var notPassive = supportsPassiveEvents ? {
      passive: false
    } : false;
    el.addEventListener("wheel", onWheel, notPassive);
    el.addEventListener("touchstart", onTouchStart, notPassive);
    el.addEventListener("touchmove", onTouchMove, notPassive);
  }, [onTouchMove, onTouchStart, onWheel]);
  var stopListening = useCallback(function(el) {
    if (!el) return;
    el.removeEventListener("wheel", onWheel, false);
    el.removeEventListener("touchstart", onTouchStart, false);
    el.removeEventListener("touchmove", onTouchMove, false);
  }, [onTouchMove, onTouchStart, onWheel]);
  useEffect(function() {
    if (!isEnabled) return;
    var element = scrollTarget.current;
    startListening(element);
    return function() {
      stopListening(element);
    };
  }, [isEnabled, startListening, stopListening]);
  return function(element) {
    scrollTarget.current = element;
  };
}
var STYLE_KEYS = ["boxSizing", "height", "overflow", "paddingRight", "position"];
var LOCK_STYLES = {
  boxSizing: "border-box",
  // account for possible declaration `width: 100%;` on body
  overflow: "hidden",
  position: "relative",
  height: "100%"
};
function preventTouchMove(e2) {
  e2.preventDefault();
}
function allowTouchMove(e2) {
  e2.stopPropagation();
}
function preventInertiaScroll() {
  var top = this.scrollTop;
  var totalScroll = this.scrollHeight;
  var currentScroll = top + this.offsetHeight;
  if (top === 0) {
    this.scrollTop = 1;
  } else if (currentScroll === totalScroll) {
    this.scrollTop = top - 1;
  }
}
function isTouchDevice() {
  return "ontouchstart" in window || navigator.maxTouchPoints;
}
var canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
var activeScrollLocks = 0;
var listenerOptions = {
  capture: false,
  passive: false
};
function useScrollLock(_ref3) {
  var isEnabled = _ref3.isEnabled, _ref$accountForScroll = _ref3.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
  var originalStyles = useRef({});
  var scrollTarget = useRef(null);
  var addScrollLock = useCallback(function(touchScrollTarget) {
    if (!canUseDOM) return;
    var target = document.body;
    var targetStyle = target && target.style;
    if (accountForScrollbars) {
      STYLE_KEYS.forEach(function(key) {
        var val = targetStyle && targetStyle[key];
        originalStyles.current[key] = val;
      });
    }
    if (accountForScrollbars && activeScrollLocks < 1) {
      var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
      var clientWidth = document.body ? document.body.clientWidth : 0;
      var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
      Object.keys(LOCK_STYLES).forEach(function(key) {
        var val = LOCK_STYLES[key];
        if (targetStyle) {
          targetStyle[key] = val;
        }
      });
      if (targetStyle) {
        targetStyle.paddingRight = "".concat(adjustedPadding, "px");
      }
    }
    if (target && isTouchDevice()) {
      target.addEventListener("touchmove", preventTouchMove, listenerOptions);
      if (touchScrollTarget) {
        touchScrollTarget.addEventListener("touchstart", preventInertiaScroll, listenerOptions);
        touchScrollTarget.addEventListener("touchmove", allowTouchMove, listenerOptions);
      }
    }
    activeScrollLocks += 1;
  }, [accountForScrollbars]);
  var removeScrollLock = useCallback(function(touchScrollTarget) {
    if (!canUseDOM) return;
    var target = document.body;
    var targetStyle = target && target.style;
    activeScrollLocks = Math.max(activeScrollLocks - 1, 0);
    if (accountForScrollbars && activeScrollLocks < 1) {
      STYLE_KEYS.forEach(function(key) {
        var val = originalStyles.current[key];
        if (targetStyle) {
          targetStyle[key] = val;
        }
      });
    }
    if (target && isTouchDevice()) {
      target.removeEventListener("touchmove", preventTouchMove, listenerOptions);
      if (touchScrollTarget) {
        touchScrollTarget.removeEventListener("touchstart", preventInertiaScroll, listenerOptions);
        touchScrollTarget.removeEventListener("touchmove", allowTouchMove, listenerOptions);
      }
    }
  }, [accountForScrollbars]);
  useEffect(function() {
    if (!isEnabled) return;
    var element = scrollTarget.current;
    addScrollLock(element);
    return function() {
      removeScrollLock(element);
    };
  }, [isEnabled, addScrollLock, removeScrollLock]);
  return function(element) {
    scrollTarget.current = element;
  };
}
function _EMOTION_STRINGIFIED_CSS_ERROR__$1() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var blurSelectInput = function blurSelectInput2(event) {
  var element = event.target;
  return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
var _ref2$1 = process.env.NODE_ENV === "production" ? {
  name: "1kfdb0e",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0"
} : {
  name: "bp8cua-ScrollManager",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0;label:ScrollManager;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1
};
function ScrollManager(_ref3) {
  var children = _ref3.children, lockEnabled = _ref3.lockEnabled, _ref$captureEnabled = _ref3.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref3.onBottomArrive, onBottomLeave = _ref3.onBottomLeave, onTopArrive = _ref3.onTopArrive, onTopLeave = _ref3.onTopLeave;
  var setScrollCaptureTarget = useScrollCapture({
    isEnabled: captureEnabled,
    onBottomArrive,
    onBottomLeave,
    onTopArrive,
    onTopLeave
  });
  var setScrollLockTarget = useScrollLock({
    isEnabled: lockEnabled
  });
  var targetRef = function targetRef2(element) {
    setScrollCaptureTarget(element);
    setScrollLockTarget(element);
  };
  return jsx(Fragment, null, lockEnabled && jsx("div", {
    onClick: blurSelectInput,
    css: _ref2$1
  }), children(targetRef));
}
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "1a0ro4n-requiredInput",
  styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
} : {
  name: "5kkxb2-requiredInput-RequiredInput",
  styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%;label:RequiredInput;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlJlcXVpcmVkSW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWNJIiwiZmlsZSI6IlJlcXVpcmVkSW5wdXQudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiLyoqIEBqc3gganN4ICovXG5pbXBvcnQgeyBGb2N1c0V2ZW50SGFuZGxlciwgRnVuY3Rpb25Db21wb25lbnQgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBqc3ggfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5cbmNvbnN0IFJlcXVpcmVkSW5wdXQ6IEZ1bmN0aW9uQ29tcG9uZW50PHtcbiAgcmVhZG9ubHkgbmFtZT86IHN0cmluZztcbiAgcmVhZG9ubHkgb25Gb2N1czogRm9jdXNFdmVudEhhbmRsZXI8SFRNTElucHV0RWxlbWVudD47XG59PiA9ICh7IG5hbWUsIG9uRm9jdXMgfSkgPT4gKFxuICA8aW5wdXRcbiAgICByZXF1aXJlZFxuICAgIG5hbWU9e25hbWV9XG4gICAgdGFiSW5kZXg9ey0xfVxuICAgIGFyaWEtaGlkZGVuPVwidHJ1ZVwiXG4gICAgb25Gb2N1cz17b25Gb2N1c31cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAncmVxdWlyZWRJbnB1dCcsXG4gICAgICBvcGFjaXR5OiAwLFxuICAgICAgcG9pbnRlckV2ZW50czogJ25vbmUnLFxuICAgICAgcG9zaXRpb246ICdhYnNvbHV0ZScsXG4gICAgICBib3R0b206IDAsXG4gICAgICBsZWZ0OiAwLFxuICAgICAgcmlnaHQ6IDAsXG4gICAgICB3aWR0aDogJzEwMCUnLFxuICAgIH19XG4gICAgLy8gUHJldmVudCBgU3dpdGNoaW5nIGZyb20gdW5jb250cm9sbGVkIHRvIGNvbnRyb2xsZWRgIGVycm9yXG4gICAgdmFsdWU9XCJcIlxuICAgIG9uQ2hhbmdlPXsoKSA9PiB7fX1cbiAgLz5cbik7XG5cbmV4cG9ydCBkZWZhdWx0IFJlcXVpcmVkSW5wdXQ7XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var RequiredInput = function RequiredInput2(_ref3) {
  var name = _ref3.name, onFocus2 = _ref3.onFocus;
  return jsx("input", {
    required: true,
    name,
    tabIndex: -1,
    "aria-hidden": "true",
    onFocus: onFocus2,
    css: _ref2,
    value: "",
    onChange: function onChange2() {
    }
  });
};
var RequiredInput$1 = RequiredInput;
function testPlatform(re) {
  var _window$navigator$use;
  return typeof window !== "undefined" && window.navigator != null ? re.test(((_window$navigator$use = window.navigator["userAgentData"]) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.platform) || window.navigator.platform) : false;
}
function isIPhone() {
  return testPlatform(/^iPhone/i);
}
function isMac() {
  return testPlatform(/^Mac/i);
}
function isIPad() {
  return testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  isMac() && navigator.maxTouchPoints > 1;
}
function isIOS() {
  return isIPhone() || isIPad();
}
function isAppleDevice() {
  return isMac() || isIOS();
}
var formatGroupLabel = function formatGroupLabel2(group) {
  return group.label;
};
var getOptionLabel$1 = function getOptionLabel(option2) {
  return option2.label;
};
var getOptionValue$1 = function getOptionValue(option2) {
  return option2.value;
};
var isOptionDisabled = function isOptionDisabled2(option2) {
  return !!option2.isDisabled;
};
var defaultStyles = {
  clearIndicator: clearIndicatorCSS,
  container: containerCSS,
  control: css$1,
  dropdownIndicator: dropdownIndicatorCSS,
  group: groupCSS,
  groupHeading: groupHeadingCSS,
  indicatorsContainer: indicatorsContainerCSS,
  indicatorSeparator: indicatorSeparatorCSS,
  input: inputCSS,
  loadingIndicator: loadingIndicatorCSS,
  loadingMessage: loadingMessageCSS,
  menu: menuCSS,
  menuList: menuListCSS,
  menuPortal: menuPortalCSS,
  multiValue: multiValueCSS,
  multiValueLabel: multiValueLabelCSS,
  multiValueRemove: multiValueRemoveCSS,
  noOptionsMessage: noOptionsMessageCSS,
  option: optionCSS,
  placeholder: placeholderCSS,
  singleValue: css2,
  valueContainer: valueContainerCSS
};
var colors = {
  primary: "#2684FF",
  primary75: "#4C9AFF",
  primary50: "#B2D4FF",
  primary25: "#DEEBFF",
  danger: "#DE350B",
  dangerLight: "#FFBDAD",
  neutral0: "hsl(0, 0%, 100%)",
  neutral5: "hsl(0, 0%, 95%)",
  neutral10: "hsl(0, 0%, 90%)",
  neutral20: "hsl(0, 0%, 80%)",
  neutral30: "hsl(0, 0%, 70%)",
  neutral40: "hsl(0, 0%, 60%)",
  neutral50: "hsl(0, 0%, 50%)",
  neutral60: "hsl(0, 0%, 40%)",
  neutral70: "hsl(0, 0%, 30%)",
  neutral80: "hsl(0, 0%, 20%)",
  neutral90: "hsl(0, 0%, 10%)"
};
var borderRadius = 4;
var baseUnit = 4;
var controlHeight = 38;
var menuGutter = baseUnit * 2;
var spacing = {
  baseUnit,
  controlHeight,
  menuGutter
};
var defaultTheme = {
  borderRadius,
  colors,
  spacing
};
var defaultProps$1 = {
  "aria-live": "polite",
  backspaceRemovesValue: true,
  blurInputOnSelect: isTouchCapable(),
  captureMenuScroll: !isTouchCapable(),
  classNames: {},
  closeMenuOnSelect: true,
  closeMenuOnScroll: false,
  components: {},
  controlShouldRenderValue: true,
  escapeClearsValue: false,
  filterOption: createFilter(),
  formatGroupLabel,
  getOptionLabel: getOptionLabel$1,
  getOptionValue: getOptionValue$1,
  isDisabled: false,
  isLoading: false,
  isMulti: false,
  isRtl: false,
  isSearchable: true,
  isOptionDisabled,
  loadingMessage: function loadingMessage() {
    return "Loading...";
  },
  maxMenuHeight: 300,
  minMenuHeight: 140,
  menuIsOpen: false,
  menuPlacement: "bottom",
  menuPosition: "absolute",
  menuShouldBlockScroll: false,
  menuShouldScrollIntoView: !isMobileDevice(),
  noOptionsMessage: function noOptionsMessage() {
    return "No options";
  },
  openMenuOnFocus: false,
  openMenuOnClick: true,
  options: [],
  pageSize: 5,
  placeholder: "Select...",
  screenReaderStatus: function screenReaderStatus(_ref3) {
    var count = _ref3.count;
    return "".concat(count, " result").concat(count !== 1 ? "s" : "", " available");
  },
  styles: {},
  tabIndex: 0,
  tabSelectsValue: true,
  unstyled: false
};
function toCategorizedOption(props, option2, selectValue, index2) {
  var isDisabled = _isOptionDisabled(props, option2, selectValue);
  var isSelected = _isOptionSelected(props, option2, selectValue);
  var label = getOptionLabel2(props, option2);
  var value = getOptionValue2(props, option2);
  return {
    type: "option",
    data: option2,
    isDisabled,
    isSelected,
    label,
    value,
    index: index2
  };
}
function buildCategorizedOptions(props, selectValue) {
  return props.options.map(function(groupOrOption, groupOrOptionIndex) {
    if ("options" in groupOrOption) {
      var categorizedOptions = groupOrOption.options.map(function(option2, optionIndex) {
        return toCategorizedOption(props, option2, selectValue, optionIndex);
      }).filter(function(categorizedOption2) {
        return isFocusable(props, categorizedOption2);
      });
      return categorizedOptions.length > 0 ? {
        type: "group",
        data: groupOrOption,
        options: categorizedOptions,
        index: groupOrOptionIndex
      } : void 0;
    }
    var categorizedOption = toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
    return isFocusable(props, categorizedOption) ? categorizedOption : void 0;
  }).filter(notNullish);
}
function buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
  return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
    if (categorizedOption.type === "group") {
      optionsAccumulator.push.apply(optionsAccumulator, _toConsumableArray(categorizedOption.options.map(function(option2) {
        return option2.data;
      })));
    } else {
      optionsAccumulator.push(categorizedOption.data);
    }
    return optionsAccumulator;
  }, []);
}
function buildFocusableOptionsWithIds(categorizedOptions, optionId) {
  return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
    if (categorizedOption.type === "group") {
      optionsAccumulator.push.apply(optionsAccumulator, _toConsumableArray(categorizedOption.options.map(function(option2) {
        return {
          data: option2.data,
          id: "".concat(optionId, "-").concat(categorizedOption.index, "-").concat(option2.index)
        };
      })));
    } else {
      optionsAccumulator.push({
        data: categorizedOption.data,
        id: "".concat(optionId, "-").concat(categorizedOption.index)
      });
    }
    return optionsAccumulator;
  }, []);
}
function buildFocusableOptions(props, selectValue) {
  return buildFocusableOptionsFromCategorizedOptions(buildCategorizedOptions(props, selectValue));
}
function isFocusable(props, categorizedOption) {
  var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? "" : _props$inputValue;
  var data2 = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
  return (!shouldHideSelectedOptions(props) || !isSelected) && _filterOption(props, {
    label,
    value,
    data: data2
  }, inputValue);
}
function getNextFocusedValue(state, nextSelectValue) {
  var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
  var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
  if (lastFocusedIndex > -1) {
    var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
    if (nextFocusedIndex > -1) {
      return focusedValue;
    } else if (lastFocusedIndex < nextSelectValue.length) {
      return nextSelectValue[lastFocusedIndex];
    }
  }
  return null;
}
function getNextFocusedOption(state, options2) {
  var lastFocusedOption = state.focusedOption;
  return lastFocusedOption && options2.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options2[0];
}
var getFocusedOptionId = function getFocusedOptionId2(focusableOptionsWithIds, focusedOption2) {
  var _focusableOptionsWith;
  var focusedOptionId = (_focusableOptionsWith = focusableOptionsWithIds.find(function(option2) {
    return option2.data === focusedOption2;
  })) === null || _focusableOptionsWith === void 0 ? void 0 : _focusableOptionsWith.id;
  return focusedOptionId || null;
};
var getOptionLabel2 = function getOptionLabel3(props, data2) {
  return props.getOptionLabel(data2);
};
var getOptionValue2 = function getOptionValue3(props, data2) {
  return props.getOptionValue(data2);
};
function _isOptionDisabled(props, option2, selectValue) {
  return typeof props.isOptionDisabled === "function" ? props.isOptionDisabled(option2, selectValue) : false;
}
function _isOptionSelected(props, option2, selectValue) {
  if (selectValue.indexOf(option2) > -1) return true;
  if (typeof props.isOptionSelected === "function") {
    return props.isOptionSelected(option2, selectValue);
  }
  var candidate = getOptionValue2(props, option2);
  return selectValue.some(function(i) {
    return getOptionValue2(props, i) === candidate;
  });
}
function _filterOption(props, option2, inputValue) {
  return props.filterOption ? props.filterOption(option2, inputValue) : true;
}
var shouldHideSelectedOptions = function shouldHideSelectedOptions2(props) {
  var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
  if (hideSelectedOptions === void 0) return isMulti;
  return hideSelectedOptions;
};
var instanceId = 1;
var Select = /* @__PURE__ */ function(_Component) {
  _inherits(Select2, _Component);
  var _super = _createSuper(Select2);
  function Select2(_props) {
    var _this;
    _classCallCheck(this, Select2);
    _this = _super.call(this, _props);
    _this.state = {
      ariaSelection: null,
      focusedOption: null,
      focusedOptionId: null,
      focusableOptionsWithIds: [],
      focusedValue: null,
      inputIsHidden: false,
      isFocused: false,
      selectValue: [],
      clearFocusValueOnUpdate: false,
      prevWasFocused: false,
      inputIsHiddenAfterUpdate: void 0,
      prevProps: void 0,
      instancePrefix: ""
    };
    _this.blockOptionHover = false;
    _this.isComposing = false;
    _this.commonProps = void 0;
    _this.initialTouchX = 0;
    _this.initialTouchY = 0;
    _this.openAfterFocus = false;
    _this.scrollToFocusedOptionOnUpdate = false;
    _this.userIsDragging = void 0;
    _this.isAppleDevice = isAppleDevice();
    _this.controlRef = null;
    _this.getControlRef = function(ref) {
      _this.controlRef = ref;
    };
    _this.focusedOptionRef = null;
    _this.getFocusedOptionRef = function(ref) {
      _this.focusedOptionRef = ref;
    };
    _this.menuListRef = null;
    _this.getMenuListRef = function(ref) {
      _this.menuListRef = ref;
    };
    _this.inputRef = null;
    _this.getInputRef = function(ref) {
      _this.inputRef = ref;
    };
    _this.focus = _this.focusInput;
    _this.blur = _this.blurInput;
    _this.onChange = function(newValue, actionMeta) {
      var _this$props = _this.props, onChange2 = _this$props.onChange, name = _this$props.name;
      actionMeta.name = name;
      _this.ariaOnChange(newValue, actionMeta);
      onChange2(newValue, actionMeta);
    };
    _this.setValue = function(newValue, action, option2) {
      var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
      _this.onInputChange("", {
        action: "set-value",
        prevInputValue: inputValue
      });
      if (closeMenuOnSelect) {
        _this.setState({
          inputIsHiddenAfterUpdate: !isMulti
        });
        _this.onMenuClose();
      }
      _this.setState({
        clearFocusValueOnUpdate: true
      });
      _this.onChange(newValue, {
        action,
        option: option2
      });
    };
    _this.selectOption = function(newValue) {
      var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
      var selectValue = _this.state.selectValue;
      var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
      var isDisabled = _this.isOptionDisabled(newValue, selectValue);
      if (deselected) {
        var candidate = _this.getOptionValue(newValue);
        _this.setValue(multiValueAsValue(selectValue.filter(function(i) {
          return _this.getOptionValue(i) !== candidate;
        })), "deselect-option", newValue);
      } else if (!isDisabled) {
        if (isMulti) {
          _this.setValue(multiValueAsValue([].concat(_toConsumableArray(selectValue), [newValue])), "select-option", newValue);
        } else {
          _this.setValue(singleValueAsValue(newValue), "select-option");
        }
      } else {
        _this.ariaOnChange(singleValueAsValue(newValue), {
          action: "select-option",
          option: newValue,
          name
        });
        return;
      }
      if (blurInputOnSelect) {
        _this.blurInput();
      }
    };
    _this.removeValue = function(removedValue) {
      var isMulti = _this.props.isMulti;
      var selectValue = _this.state.selectValue;
      var candidate = _this.getOptionValue(removedValue);
      var newValueArray = selectValue.filter(function(i) {
        return _this.getOptionValue(i) !== candidate;
      });
      var newValue = valueTernary(isMulti, newValueArray, newValueArray[0] || null);
      _this.onChange(newValue, {
        action: "remove-value",
        removedValue
      });
      _this.focusInput();
    };
    _this.clearValue = function() {
      var selectValue = _this.state.selectValue;
      _this.onChange(valueTernary(_this.props.isMulti, [], null), {
        action: "clear",
        removedValues: selectValue
      });
    };
    _this.popValue = function() {
      var isMulti = _this.props.isMulti;
      var selectValue = _this.state.selectValue;
      var lastSelectedValue = selectValue[selectValue.length - 1];
      var newValueArray = selectValue.slice(0, selectValue.length - 1);
      var newValue = valueTernary(isMulti, newValueArray, newValueArray[0] || null);
      _this.onChange(newValue, {
        action: "pop-value",
        removedValue: lastSelectedValue
      });
    };
    _this.getFocusedOptionId = function(focusedOption2) {
      return getFocusedOptionId(_this.state.focusableOptionsWithIds, focusedOption2);
    };
    _this.getFocusableOptionsWithIds = function() {
      return buildFocusableOptionsWithIds(buildCategorizedOptions(_this.props, _this.state.selectValue), _this.getElementId("option"));
    };
    _this.getValue = function() {
      return _this.state.selectValue;
    };
    _this.cx = function() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return classNames.apply(void 0, [_this.props.classNamePrefix].concat(args));
    };
    _this.getOptionLabel = function(data2) {
      return getOptionLabel2(_this.props, data2);
    };
    _this.getOptionValue = function(data2) {
      return getOptionValue2(_this.props, data2);
    };
    _this.getStyles = function(key, props) {
      var unstyled = _this.props.unstyled;
      var base = defaultStyles[key](props, unstyled);
      base.boxSizing = "border-box";
      var custom = _this.props.styles[key];
      return custom ? custom(base, props) : base;
    };
    _this.getClassNames = function(key, props) {
      var _this$props$className, _this$props$className2;
      return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
    };
    _this.getElementId = function(element) {
      return "".concat(_this.state.instancePrefix, "-").concat(element);
    };
    _this.getComponents = function() {
      return defaultComponents(_this.props);
    };
    _this.buildCategorizedOptions = function() {
      return buildCategorizedOptions(_this.props, _this.state.selectValue);
    };
    _this.getCategorizedOptions = function() {
      return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
    };
    _this.buildFocusableOptions = function() {
      return buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
    };
    _this.getFocusableOptions = function() {
      return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
    };
    _this.ariaOnChange = function(value, actionMeta) {
      _this.setState({
        ariaSelection: _objectSpread2({
          value
        }, actionMeta)
      });
    };
    _this.onMenuMouseDown = function(event) {
      if (event.button !== 0) {
        return;
      }
      event.stopPropagation();
      event.preventDefault();
      _this.focusInput();
    };
    _this.onMenuMouseMove = function(event) {
      _this.blockOptionHover = false;
    };
    _this.onControlMouseDown = function(event) {
      if (event.defaultPrevented) {
        return;
      }
      var openMenuOnClick = _this.props.openMenuOnClick;
      if (!_this.state.isFocused) {
        if (openMenuOnClick) {
          _this.openAfterFocus = true;
        }
        _this.focusInput();
      } else if (!_this.props.menuIsOpen) {
        if (openMenuOnClick) {
          _this.openMenu("first");
        }
      } else {
        if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") {
          _this.onMenuClose();
        }
      }
      if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") {
        event.preventDefault();
      }
    };
    _this.onDropdownIndicatorMouseDown = function(event) {
      if (event && event.type === "mousedown" && event.button !== 0) {
        return;
      }
      if (_this.props.isDisabled) return;
      var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
      _this.focusInput();
      if (menuIsOpen) {
        _this.setState({
          inputIsHiddenAfterUpdate: !isMulti
        });
        _this.onMenuClose();
      } else {
        _this.openMenu("first");
      }
      event.preventDefault();
    };
    _this.onClearIndicatorMouseDown = function(event) {
      if (event && event.type === "mousedown" && event.button !== 0) {
        return;
      }
      _this.clearValue();
      event.preventDefault();
      _this.openAfterFocus = false;
      if (event.type === "touchend") {
        _this.focusInput();
      } else {
        setTimeout(function() {
          return _this.focusInput();
        });
      }
    };
    _this.onScroll = function(event) {
      if (typeof _this.props.closeMenuOnScroll === "boolean") {
        if (event.target instanceof HTMLElement && isDocumentElement(event.target)) {
          _this.props.onMenuClose();
        }
      } else if (typeof _this.props.closeMenuOnScroll === "function") {
        if (_this.props.closeMenuOnScroll(event)) {
          _this.props.onMenuClose();
        }
      }
    };
    _this.onCompositionStart = function() {
      _this.isComposing = true;
    };
    _this.onCompositionEnd = function() {
      _this.isComposing = false;
    };
    _this.onTouchStart = function(_ref22) {
      var touches = _ref22.touches;
      var touch = touches && touches.item(0);
      if (!touch) {
        return;
      }
      _this.initialTouchX = touch.clientX;
      _this.initialTouchY = touch.clientY;
      _this.userIsDragging = false;
    };
    _this.onTouchMove = function(_ref3) {
      var touches = _ref3.touches;
      var touch = touches && touches.item(0);
      if (!touch) {
        return;
      }
      var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
      var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
      var moveThreshold = 5;
      _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
    };
    _this.onTouchEnd = function(event) {
      if (_this.userIsDragging) return;
      if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) {
        _this.blurInput();
      }
      _this.initialTouchX = 0;
      _this.initialTouchY = 0;
    };
    _this.onControlTouchEnd = function(event) {
      if (_this.userIsDragging) return;
      _this.onControlMouseDown(event);
    };
    _this.onClearIndicatorTouchEnd = function(event) {
      if (_this.userIsDragging) return;
      _this.onClearIndicatorMouseDown(event);
    };
    _this.onDropdownIndicatorTouchEnd = function(event) {
      if (_this.userIsDragging) return;
      _this.onDropdownIndicatorMouseDown(event);
    };
    _this.handleInputChange = function(event) {
      var prevInputValue = _this.props.inputValue;
      var inputValue = event.currentTarget.value;
      _this.setState({
        inputIsHiddenAfterUpdate: false
      });
      _this.onInputChange(inputValue, {
        action: "input-change",
        prevInputValue
      });
      if (!_this.props.menuIsOpen) {
        _this.onMenuOpen();
      }
    };
    _this.onInputFocus = function(event) {
      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
      _this.setState({
        inputIsHiddenAfterUpdate: false,
        isFocused: true
      });
      if (_this.openAfterFocus || _this.props.openMenuOnFocus) {
        _this.openMenu("first");
      }
      _this.openAfterFocus = false;
    };
    _this.onInputBlur = function(event) {
      var prevInputValue = _this.props.inputValue;
      if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
        _this.inputRef.focus();
        return;
      }
      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }
      _this.onInputChange("", {
        action: "input-blur",
        prevInputValue
      });
      _this.onMenuClose();
      _this.setState({
        focusedValue: null,
        isFocused: false
      });
    };
    _this.onOptionHover = function(focusedOption2) {
      if (_this.blockOptionHover || _this.state.focusedOption === focusedOption2) {
        return;
      }
      var options2 = _this.getFocusableOptions();
      var focusedOptionIndex = options2.indexOf(focusedOption2);
      _this.setState({
        focusedOption: focusedOption2,
        focusedOptionId: focusedOptionIndex > -1 ? _this.getFocusedOptionId(focusedOption2) : null
      });
    };
    _this.shouldHideSelectedOptions = function() {
      return shouldHideSelectedOptions(_this.props);
    };
    _this.onValueInputFocus = function(e2) {
      e2.preventDefault();
      e2.stopPropagation();
      _this.focus();
    };
    _this.onKeyDown = function(event) {
      var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
      var _this$state = _this.state, focusedOption2 = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
      if (isDisabled) return;
      if (typeof onKeyDown === "function") {
        onKeyDown(event);
        if (event.defaultPrevented) {
          return;
        }
      }
      _this.blockOptionHover = true;
      switch (event.key) {
        case "ArrowLeft":
          if (!isMulti || inputValue) return;
          _this.focusValue("previous");
          break;
        case "ArrowRight":
          if (!isMulti || inputValue) return;
          _this.focusValue("next");
          break;
        case "Delete":
        case "Backspace":
          if (inputValue) return;
          if (focusedValue) {
            _this.removeValue(focusedValue);
          } else {
            if (!backspaceRemovesValue) return;
            if (isMulti) {
              _this.popValue();
            } else if (isClearable) {
              _this.clearValue();
            }
          }
          break;
        case "Tab":
          if (_this.isComposing) return;
          if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption2 || // don't capture the event if the menu opens on focus and the focused
          // option is already selected; it breaks the flow of navigation
          openMenuOnFocus && _this.isOptionSelected(focusedOption2, selectValue)) {
            return;
          }
          _this.selectOption(focusedOption2);
          break;
        case "Enter":
          if (event.keyCode === 229) {
            break;
          }
          if (menuIsOpen) {
            if (!focusedOption2) return;
            if (_this.isComposing) return;
            _this.selectOption(focusedOption2);
            break;
          }
          return;
        case "Escape":
          if (menuIsOpen) {
            _this.setState({
              inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange("", {
              action: "menu-close",
              prevInputValue: inputValue
            });
            _this.onMenuClose();
          } else if (isClearable && escapeClearsValue) {
            _this.clearValue();
          }
          break;
        case " ":
          if (inputValue) {
            return;
          }
          if (!menuIsOpen) {
            _this.openMenu("first");
            break;
          }
          if (!focusedOption2) return;
          _this.selectOption(focusedOption2);
          break;
        case "ArrowUp":
          if (menuIsOpen) {
            _this.focusOption("up");
          } else {
            _this.openMenu("last");
          }
          break;
        case "ArrowDown":
          if (menuIsOpen) {
            _this.focusOption("down");
          } else {
            _this.openMenu("first");
          }
          break;
        case "PageUp":
          if (!menuIsOpen) return;
          _this.focusOption("pageup");
          break;
        case "PageDown":
          if (!menuIsOpen) return;
          _this.focusOption("pagedown");
          break;
        case "Home":
          if (!menuIsOpen) return;
          _this.focusOption("first");
          break;
        case "End":
          if (!menuIsOpen) return;
          _this.focusOption("last");
          break;
        default:
          return;
      }
      event.preventDefault();
    };
    _this.state.instancePrefix = "react-select-" + (_this.props.instanceId || ++instanceId);
    _this.state.selectValue = cleanValue(_props.value);
    if (_props.menuIsOpen && _this.state.selectValue.length) {
      var focusableOptionsWithIds = _this.getFocusableOptionsWithIds();
      var focusableOptions = _this.buildFocusableOptions();
      var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
      _this.state.focusableOptionsWithIds = focusableOptionsWithIds;
      _this.state.focusedOption = focusableOptions[optionIndex];
      _this.state.focusedOptionId = getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
    }
    return _this;
  }
  _createClass(Select2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.startListeningComposition();
      this.startListeningToTouch();
      if (this.props.closeMenuOnScroll && document && document.addEventListener) {
        document.addEventListener("scroll", this.onScroll, true);
      }
      if (this.props.autoFocus) {
        this.focusInput();
      }
      if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) {
        scrollIntoView(this.menuListRef, this.focusedOptionRef);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
      var isFocused = this.state.isFocused;
      if (
        // ensure focus is restored correctly when the control becomes enabled
        isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
        isFocused && menuIsOpen && !prevProps.menuIsOpen
      ) {
        this.focusInput();
      }
      if (isFocused && isDisabled && !prevProps.isDisabled) {
        this.setState({
          isFocused: false
        }, this.onMenuClose);
      } else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) {
        this.setState({
          isFocused: true
        });
      }
      if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
        scrollIntoView(this.menuListRef, this.focusedOptionRef);
        this.scrollToFocusedOptionOnUpdate = false;
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.stopListeningComposition();
      this.stopListeningToTouch();
      document.removeEventListener("scroll", this.onScroll, true);
    }
    // ==============================
    // Consumer Handlers
    // ==============================
  }, {
    key: "onMenuOpen",
    value: function onMenuOpen() {
      this.props.onMenuOpen();
    }
  }, {
    key: "onMenuClose",
    value: function onMenuClose() {
      this.onInputChange("", {
        action: "menu-close",
        prevInputValue: this.props.inputValue
      });
      this.props.onMenuClose();
    }
  }, {
    key: "onInputChange",
    value: function onInputChange(newValue, actionMeta) {
      this.props.onInputChange(newValue, actionMeta);
    }
    // ==============================
    // Methods
    // ==============================
  }, {
    key: "focusInput",
    value: function focusInput() {
      if (!this.inputRef) return;
      this.inputRef.focus();
    }
  }, {
    key: "blurInput",
    value: function blurInput() {
      if (!this.inputRef) return;
      this.inputRef.blur();
    }
    // aliased for consumers
  }, {
    key: "openMenu",
    value: function openMenu(focusOption) {
      var _this2 = this;
      var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
      var focusableOptions = this.buildFocusableOptions();
      var openAtIndex = focusOption === "first" ? 0 : focusableOptions.length - 1;
      if (!this.props.isMulti) {
        var selectedIndex = focusableOptions.indexOf(selectValue[0]);
        if (selectedIndex > -1) {
          openAtIndex = selectedIndex;
        }
      }
      this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
      this.setState({
        inputIsHiddenAfterUpdate: false,
        focusedValue: null,
        focusedOption: focusableOptions[openAtIndex],
        focusedOptionId: this.getFocusedOptionId(focusableOptions[openAtIndex])
      }, function() {
        return _this2.onMenuOpen();
      });
    }
  }, {
    key: "focusValue",
    value: function focusValue(direction) {
      var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
      if (!this.props.isMulti) return;
      this.setState({
        focusedOption: null
      });
      var focusedIndex = selectValue.indexOf(focusedValue);
      if (!focusedValue) {
        focusedIndex = -1;
      }
      var lastIndex = selectValue.length - 1;
      var nextFocus = -1;
      if (!selectValue.length) return;
      switch (direction) {
        case "previous":
          if (focusedIndex === 0) {
            nextFocus = 0;
          } else if (focusedIndex === -1) {
            nextFocus = lastIndex;
          } else {
            nextFocus = focusedIndex - 1;
          }
          break;
        case "next":
          if (focusedIndex > -1 && focusedIndex < lastIndex) {
            nextFocus = focusedIndex + 1;
          }
          break;
      }
      this.setState({
        inputIsHidden: nextFocus !== -1,
        focusedValue: selectValue[nextFocus]
      });
    }
  }, {
    key: "focusOption",
    value: function focusOption() {
      var direction = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "first";
      var pageSize = this.props.pageSize;
      var focusedOption2 = this.state.focusedOption;
      var options2 = this.getFocusableOptions();
      if (!options2.length) return;
      var nextFocus = 0;
      var focusedIndex = options2.indexOf(focusedOption2);
      if (!focusedOption2) {
        focusedIndex = -1;
      }
      if (direction === "up") {
        nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options2.length - 1;
      } else if (direction === "down") {
        nextFocus = (focusedIndex + 1) % options2.length;
      } else if (direction === "pageup") {
        nextFocus = focusedIndex - pageSize;
        if (nextFocus < 0) nextFocus = 0;
      } else if (direction === "pagedown") {
        nextFocus = focusedIndex + pageSize;
        if (nextFocus > options2.length - 1) nextFocus = options2.length - 1;
      } else if (direction === "last") {
        nextFocus = options2.length - 1;
      }
      this.scrollToFocusedOptionOnUpdate = true;
      this.setState({
        focusedOption: options2[nextFocus],
        focusedValue: null,
        focusedOptionId: this.getFocusedOptionId(options2[nextFocus])
      });
    }
  }, {
    key: "getTheme",
    value: (
      // ==============================
      // Getters
      // ==============================
      function getTheme() {
        if (!this.props.theme) {
          return defaultTheme;
        }
        if (typeof this.props.theme === "function") {
          return this.props.theme(defaultTheme);
        }
        return _objectSpread2(_objectSpread2({}, defaultTheme), this.props.theme);
      }
    )
  }, {
    key: "getCommonProps",
    value: function getCommonProps() {
      var clearValue = this.clearValue, cx = this.cx, getStyles2 = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
      var isMulti = props.isMulti, isRtl = props.isRtl, options2 = props.options;
      var hasValue = this.hasValue();
      return {
        clearValue,
        cx,
        getStyles: getStyles2,
        getClassNames,
        getValue,
        hasValue,
        isMulti,
        isRtl,
        options: options2,
        selectOption,
        selectProps: props,
        setValue,
        theme: this.getTheme()
      };
    }
  }, {
    key: "hasValue",
    value: function hasValue() {
      var selectValue = this.state.selectValue;
      return selectValue.length > 0;
    }
  }, {
    key: "hasOptions",
    value: function hasOptions() {
      return !!this.getFocusableOptions().length;
    }
  }, {
    key: "isClearable",
    value: function isClearable() {
      var _this$props7 = this.props, isClearable2 = _this$props7.isClearable, isMulti = _this$props7.isMulti;
      if (isClearable2 === void 0) return isMulti;
      return isClearable2;
    }
  }, {
    key: "isOptionDisabled",
    value: function isOptionDisabled3(option2, selectValue) {
      return _isOptionDisabled(this.props, option2, selectValue);
    }
  }, {
    key: "isOptionSelected",
    value: function isOptionSelected(option2, selectValue) {
      return _isOptionSelected(this.props, option2, selectValue);
    }
  }, {
    key: "filterOption",
    value: function filterOption(option2, inputValue) {
      return _filterOption(this.props, option2, inputValue);
    }
  }, {
    key: "formatOptionLabel",
    value: function formatOptionLabel(data2, context) {
      if (typeof this.props.formatOptionLabel === "function") {
        var _inputValue = this.props.inputValue;
        var _selectValue = this.state.selectValue;
        return this.props.formatOptionLabel(data2, {
          context,
          inputValue: _inputValue,
          selectValue: _selectValue
        });
      } else {
        return this.getOptionLabel(data2);
      }
    }
  }, {
    key: "formatGroupLabel",
    value: function formatGroupLabel3(data2) {
      return this.props.formatGroupLabel(data2);
    }
    // ==============================
    // Mouse Handlers
    // ==============================
  }, {
    key: "startListeningComposition",
    value: (
      // ==============================
      // Composition Handlers
      // ==============================
      function startListeningComposition() {
        if (document && document.addEventListener) {
          document.addEventListener("compositionstart", this.onCompositionStart, false);
          document.addEventListener("compositionend", this.onCompositionEnd, false);
        }
      }
    )
  }, {
    key: "stopListeningComposition",
    value: function stopListeningComposition() {
      if (document && document.removeEventListener) {
        document.removeEventListener("compositionstart", this.onCompositionStart);
        document.removeEventListener("compositionend", this.onCompositionEnd);
      }
    }
  }, {
    key: "startListeningToTouch",
    value: (
      // ==============================
      // Touch Handlers
      // ==============================
      function startListeningToTouch() {
        if (document && document.addEventListener) {
          document.addEventListener("touchstart", this.onTouchStart, false);
          document.addEventListener("touchmove", this.onTouchMove, false);
          document.addEventListener("touchend", this.onTouchEnd, false);
        }
      }
    )
  }, {
    key: "stopListeningToTouch",
    value: function stopListeningToTouch() {
      if (document && document.removeEventListener) {
        document.removeEventListener("touchstart", this.onTouchStart);
        document.removeEventListener("touchmove", this.onTouchMove);
        document.removeEventListener("touchend", this.onTouchEnd);
      }
    }
  }, {
    key: "renderInput",
    value: (
      // ==============================
      // Renderers
      // ==============================
      function renderInput() {
        var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required;
        var _this$getComponents = this.getComponents(), Input3 = _this$getComponents.Input;
        var _this$state4 = this.state, inputIsHidden = _this$state4.inputIsHidden, ariaSelection = _this$state4.ariaSelection;
        var commonProps = this.commonProps;
        var id = inputId || this.getElementId("input");
        var ariaAttributes = _objectSpread2(_objectSpread2(_objectSpread2({
          "aria-autocomplete": "list",
          "aria-expanded": menuIsOpen,
          "aria-haspopup": true,
          "aria-errormessage": this.props["aria-errormessage"],
          "aria-invalid": this.props["aria-invalid"],
          "aria-label": this.props["aria-label"],
          "aria-labelledby": this.props["aria-labelledby"],
          "aria-required": required,
          role: "combobox",
          "aria-activedescendant": this.isAppleDevice ? void 0 : this.state.focusedOptionId || ""
        }, menuIsOpen && {
          "aria-controls": this.getElementId("listbox")
        }), !isSearchable && {
          "aria-readonly": true
        }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus" && {
          "aria-describedby": this.getElementId("live-region")
        } : {
          "aria-describedby": this.getElementId("placeholder")
        });
        if (!isSearchable) {
          return /* @__PURE__ */ React.createElement(DummyInput, _extends$1({
            id,
            innerRef: this.getInputRef,
            onBlur: this.onInputBlur,
            onChange: noop$1,
            onFocus: this.onInputFocus,
            disabled: isDisabled,
            tabIndex,
            inputMode: "none",
            form,
            value: ""
          }, ariaAttributes));
        }
        return /* @__PURE__ */ React.createElement(Input3, _extends$1({}, commonProps, {
          autoCapitalize: "none",
          autoComplete: "off",
          autoCorrect: "off",
          id,
          innerRef: this.getInputRef,
          isDisabled,
          isHidden: inputIsHidden,
          onBlur: this.onInputBlur,
          onChange: this.handleInputChange,
          onFocus: this.onInputFocus,
          spellCheck: "false",
          tabIndex,
          form,
          type: "text",
          value: inputValue
        }, ariaAttributes));
      }
    )
  }, {
    key: "renderPlaceholderOrValue",
    value: function renderPlaceholderOrValue() {
      var _this3 = this;
      var _this$getComponents2 = this.getComponents(), MultiValue3 = _this$getComponents2.MultiValue, MultiValueContainer2 = _this$getComponents2.MultiValueContainer, MultiValueLabel2 = _this$getComponents2.MultiValueLabel, MultiValueRemove2 = _this$getComponents2.MultiValueRemove, SingleValue3 = _this$getComponents2.SingleValue, Placeholder3 = _this$getComponents2.Placeholder;
      var commonProps = this.commonProps;
      var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
      var _this$state5 = this.state, selectValue = _this$state5.selectValue, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused;
      if (!this.hasValue() || !controlShouldRenderValue) {
        return inputValue ? null : /* @__PURE__ */ React.createElement(Placeholder3, _extends$1({}, commonProps, {
          key: "placeholder",
          isDisabled,
          isFocused,
          innerProps: {
            id: this.getElementId("placeholder")
          }
        }), placeholder);
      }
      if (isMulti) {
        return selectValue.map(function(opt, index2) {
          var isOptionFocused = opt === focusedValue;
          var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
          return /* @__PURE__ */ React.createElement(MultiValue3, _extends$1({}, commonProps, {
            components: {
              Container: MultiValueContainer2,
              Label: MultiValueLabel2,
              Remove: MultiValueRemove2
            },
            isFocused: isOptionFocused,
            isDisabled,
            key,
            index: index2,
            removeProps: {
              onClick: function onClick() {
                return _this3.removeValue(opt);
              },
              onTouchEnd: function onTouchEnd() {
                return _this3.removeValue(opt);
              },
              onMouseDown: function onMouseDown(e2) {
                e2.preventDefault();
              }
            },
            data: opt
          }), _this3.formatOptionLabel(opt, "value"));
        });
      }
      if (inputValue) {
        return null;
      }
      var singleValue = selectValue[0];
      return /* @__PURE__ */ React.createElement(SingleValue3, _extends$1({}, commonProps, {
        data: singleValue,
        isDisabled
      }), this.formatOptionLabel(singleValue, "value"));
    }
  }, {
    key: "renderClearIndicator",
    value: function renderClearIndicator() {
      var _this$getComponents3 = this.getComponents(), ClearIndicator3 = _this$getComponents3.ClearIndicator;
      var commonProps = this.commonProps;
      var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
      var isFocused = this.state.isFocused;
      if (!this.isClearable() || !ClearIndicator3 || isDisabled || !this.hasValue() || isLoading) {
        return null;
      }
      var innerProps = {
        onMouseDown: this.onClearIndicatorMouseDown,
        onTouchEnd: this.onClearIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ React.createElement(ClearIndicator3, _extends$1({}, commonProps, {
        innerProps,
        isFocused
      }));
    }
  }, {
    key: "renderLoadingIndicator",
    value: function renderLoadingIndicator() {
      var _this$getComponents4 = this.getComponents(), LoadingIndicator3 = _this$getComponents4.LoadingIndicator;
      var commonProps = this.commonProps;
      var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
      var isFocused = this.state.isFocused;
      if (!LoadingIndicator3 || !isLoading) return null;
      var innerProps = {
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ React.createElement(LoadingIndicator3, _extends$1({}, commonProps, {
        innerProps,
        isDisabled,
        isFocused
      }));
    }
  }, {
    key: "renderIndicatorSeparator",
    value: function renderIndicatorSeparator() {
      var _this$getComponents5 = this.getComponents(), DropdownIndicator3 = _this$getComponents5.DropdownIndicator, IndicatorSeparator3 = _this$getComponents5.IndicatorSeparator;
      if (!DropdownIndicator3 || !IndicatorSeparator3) return null;
      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;
      return /* @__PURE__ */ React.createElement(IndicatorSeparator3, _extends$1({}, commonProps, {
        isDisabled,
        isFocused
      }));
    }
  }, {
    key: "renderDropdownIndicator",
    value: function renderDropdownIndicator() {
      var _this$getComponents6 = this.getComponents(), DropdownIndicator3 = _this$getComponents6.DropdownIndicator;
      if (!DropdownIndicator3) return null;
      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;
      var innerProps = {
        onMouseDown: this.onDropdownIndicatorMouseDown,
        onTouchEnd: this.onDropdownIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ React.createElement(DropdownIndicator3, _extends$1({}, commonProps, {
        innerProps,
        isDisabled,
        isFocused
      }));
    }
  }, {
    key: "renderMenu",
    value: function renderMenu() {
      var _this4 = this;
      var _this$getComponents7 = this.getComponents(), Group3 = _this$getComponents7.Group, GroupHeading3 = _this$getComponents7.GroupHeading, Menu3 = _this$getComponents7.Menu, MenuList3 = _this$getComponents7.MenuList, MenuPortal3 = _this$getComponents7.MenuPortal, LoadingMessage3 = _this$getComponents7.LoadingMessage, NoOptionsMessage3 = _this$getComponents7.NoOptionsMessage, Option3 = _this$getComponents7.Option;
      var commonProps = this.commonProps;
      var focusedOption2 = this.state.focusedOption;
      var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage2 = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage2 = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
      if (!menuIsOpen) return null;
      var render = function render2(props, id) {
        var type2 = props.type, data2 = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
        var isFocused = focusedOption2 === data2;
        var onHover = isDisabled ? void 0 : function() {
          return _this4.onOptionHover(data2);
        };
        var onSelect = isDisabled ? void 0 : function() {
          return _this4.selectOption(data2);
        };
        var optionId = "".concat(_this4.getElementId("option"), "-").concat(id);
        var innerProps = {
          id: optionId,
          onClick: onSelect,
          onMouseMove: onHover,
          onMouseOver: onHover,
          tabIndex: -1,
          role: "option",
          "aria-selected": _this4.isAppleDevice ? void 0 : isSelected
          // is not supported on Apple devices
        };
        return /* @__PURE__ */ React.createElement(Option3, _extends$1({}, commonProps, {
          innerProps,
          data: data2,
          isDisabled,
          isSelected,
          key: optionId,
          label,
          type: type2,
          value,
          isFocused,
          innerRef: isFocused ? _this4.getFocusedOptionRef : void 0
        }), _this4.formatOptionLabel(props.data, "menu"));
      };
      var menuUI;
      if (this.hasOptions()) {
        menuUI = this.getCategorizedOptions().map(function(item) {
          if (item.type === "group") {
            var _data = item.data, options2 = item.options, groupIndex = item.index;
            var groupId = "".concat(_this4.getElementId("group"), "-").concat(groupIndex);
            var headingId = "".concat(groupId, "-heading");
            return /* @__PURE__ */ React.createElement(Group3, _extends$1({}, commonProps, {
              key: groupId,
              data: _data,
              options: options2,
              Heading: GroupHeading3,
              headingProps: {
                id: headingId,
                data: item.data
              },
              label: _this4.formatGroupLabel(item.data)
            }), item.options.map(function(option2) {
              return render(option2, "".concat(groupIndex, "-").concat(option2.index));
            }));
          } else if (item.type === "option") {
            return render(item, "".concat(item.index));
          }
        });
      } else if (isLoading) {
        var message2 = loadingMessage2({
          inputValue
        });
        if (message2 === null) return null;
        menuUI = /* @__PURE__ */ React.createElement(LoadingMessage3, commonProps, message2);
      } else {
        var _message = noOptionsMessage2({
          inputValue
        });
        if (_message === null) return null;
        menuUI = /* @__PURE__ */ React.createElement(NoOptionsMessage3, commonProps, _message);
      }
      var menuPlacementProps = {
        minMenuHeight,
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView
      };
      var menuElement = /* @__PURE__ */ React.createElement(MenuPlacer, _extends$1({}, commonProps, menuPlacementProps), function(_ref4) {
        var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
        return /* @__PURE__ */ React.createElement(Menu3, _extends$1({}, commonProps, menuPlacementProps, {
          innerRef: ref,
          innerProps: {
            onMouseDown: _this4.onMenuMouseDown,
            onMouseMove: _this4.onMenuMouseMove
          },
          isLoading,
          placement
        }), /* @__PURE__ */ React.createElement(ScrollManager, {
          captureEnabled: captureMenuScroll,
          onTopArrive: onMenuScrollToTop,
          onBottomArrive: onMenuScrollToBottom,
          lockEnabled: menuShouldBlockScroll
        }, function(scrollTargetRef) {
          return /* @__PURE__ */ React.createElement(MenuList3, _extends$1({}, commonProps, {
            innerRef: function innerRef(instance) {
              _this4.getMenuListRef(instance);
              scrollTargetRef(instance);
            },
            innerProps: {
              role: "listbox",
              "aria-multiselectable": commonProps.isMulti,
              id: _this4.getElementId("listbox")
            },
            isLoading,
            maxHeight,
            focusedOption: focusedOption2
          }), menuUI);
        }));
      });
      return menuPortalTarget || menuPosition === "fixed" ? /* @__PURE__ */ React.createElement(MenuPortal3, _extends$1({}, commonProps, {
        appendTo: menuPortalTarget,
        controlElement: this.controlRef,
        menuPlacement,
        menuPosition
      }), menuElement) : menuElement;
    }
  }, {
    key: "renderFormField",
    value: function renderFormField() {
      var _this5 = this;
      var _this$props13 = this.props, delimiter2 = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name, required = _this$props13.required;
      var selectValue = this.state.selectValue;
      if (required && !this.hasValue() && !isDisabled) {
        return /* @__PURE__ */ React.createElement(RequiredInput$1, {
          name,
          onFocus: this.onValueInputFocus
        });
      }
      if (!name || isDisabled) return;
      if (isMulti) {
        if (delimiter2) {
          var value = selectValue.map(function(opt) {
            return _this5.getOptionValue(opt);
          }).join(delimiter2);
          return /* @__PURE__ */ React.createElement("input", {
            name,
            type: "hidden",
            value
          });
        } else {
          var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
            return /* @__PURE__ */ React.createElement("input", {
              key: "i-".concat(i),
              name,
              type: "hidden",
              value: _this5.getOptionValue(opt)
            });
          }) : /* @__PURE__ */ React.createElement("input", {
            name,
            type: "hidden",
            value: ""
          });
          return /* @__PURE__ */ React.createElement("div", null, input);
        }
      } else {
        var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : "";
        return /* @__PURE__ */ React.createElement("input", {
          name,
          type: "hidden",
          value: _value
        });
      }
    }
  }, {
    key: "renderLiveRegion",
    value: function renderLiveRegion() {
      var commonProps = this.commonProps;
      var _this$state6 = this.state, ariaSelection = _this$state6.ariaSelection, focusedOption2 = _this$state6.focusedOption, focusedValue = _this$state6.focusedValue, isFocused = _this$state6.isFocused, selectValue = _this$state6.selectValue;
      var focusableOptions = this.getFocusableOptions();
      return /* @__PURE__ */ React.createElement(LiveRegion$1, _extends$1({}, commonProps, {
        id: this.getElementId("live-region"),
        ariaSelection,
        focusedOption: focusedOption2,
        focusedValue,
        isFocused,
        selectValue,
        focusableOptions,
        isAppleDevice: this.isAppleDevice
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$getComponents8 = this.getComponents(), Control3 = _this$getComponents8.Control, IndicatorsContainer3 = _this$getComponents8.IndicatorsContainer, SelectContainer3 = _this$getComponents8.SelectContainer, ValueContainer3 = _this$getComponents8.ValueContainer;
      var _this$props14 = this.props, className = _this$props14.className, id = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
      var isFocused = this.state.isFocused;
      var commonProps = this.commonProps = this.getCommonProps();
      return /* @__PURE__ */ React.createElement(SelectContainer3, _extends$1({}, commonProps, {
        className,
        innerProps: {
          id,
          onKeyDown: this.onKeyDown
        },
        isDisabled,
        isFocused
      }), this.renderLiveRegion(), /* @__PURE__ */ React.createElement(Control3, _extends$1({}, commonProps, {
        innerRef: this.getControlRef,
        innerProps: {
          onMouseDown: this.onControlMouseDown,
          onTouchEnd: this.onControlTouchEnd
        },
        isDisabled,
        isFocused,
        menuIsOpen
      }), /* @__PURE__ */ React.createElement(ValueContainer3, _extends$1({}, commonProps, {
        isDisabled
      }), this.renderPlaceholderOrValue(), this.renderInput()), /* @__PURE__ */ React.createElement(IndicatorsContainer3, _extends$1({}, commonProps, {
        isDisabled
      }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused, instancePrefix = state.instancePrefix;
      var options2 = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
      var selectValue = cleanValue(value);
      var newMenuOptionsState = {};
      if (prevProps && (value !== prevProps.value || options2 !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
        var focusableOptions = menuIsOpen ? buildFocusableOptions(props, selectValue) : [];
        var focusableOptionsWithIds = menuIsOpen ? buildFocusableOptionsWithIds(buildCategorizedOptions(props, selectValue), "".concat(instancePrefix, "-option")) : [];
        var focusedValue = clearFocusValueOnUpdate ? getNextFocusedValue(state, selectValue) : null;
        var focusedOption2 = getNextFocusedOption(state, focusableOptions);
        var focusedOptionId = getFocusedOptionId(focusableOptionsWithIds, focusedOption2);
        newMenuOptionsState = {
          selectValue,
          focusedOption: focusedOption2,
          focusedOptionId,
          focusableOptionsWithIds,
          focusedValue,
          clearFocusValueOnUpdate: false
        };
      }
      var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
        inputIsHidden: inputIsHiddenAfterUpdate,
        inputIsHiddenAfterUpdate: void 0
      } : {};
      var newAriaSelection = ariaSelection;
      var hasKeptFocus = isFocused && prevWasFocused;
      if (isFocused && !hasKeptFocus) {
        newAriaSelection = {
          value: valueTernary(isMulti, selectValue, selectValue[0] || null),
          options: selectValue,
          action: "initial-input-focus"
        };
        hasKeptFocus = !prevWasFocused;
      }
      if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus") {
        newAriaSelection = null;
      }
      return _objectSpread2(_objectSpread2(_objectSpread2({}, newMenuOptionsState), newInputIsHiddenState), {}, {
        prevProps: props,
        ariaSelection: newAriaSelection,
        prevWasFocused: hasKeptFocus
      });
    }
  }]);
  return Select2;
}(Component);
Select.defaultProps = defaultProps$1;
var StateManagedSelect = /* @__PURE__ */ forwardRef(function(props, ref) {
  var baseSelectProps = useStateManager(props);
  return /* @__PURE__ */ React.createElement(Select, _extends$1({
    ref
  }, baseSelectProps));
});
var StateManagedSelect$1 = StateManagedSelect;
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}
var propTypes = { exports: {} };
var reactIs = { exports: {} };
var reactIs_production_min = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min;
function requireReactIs_production_min() {
  if (hasRequiredReactIs_production_min) return reactIs_production_min;
  hasRequiredReactIs_production_min = 1;
  var b2 = "function" === typeof Symbol && Symbol.for, c4 = b2 ? Symbol.for("react.element") : 60103, d2 = b2 ? Symbol.for("react.portal") : 60106, e2 = b2 ? Symbol.for("react.fragment") : 60107, f2 = b2 ? Symbol.for("react.strict_mode") : 60108, g2 = b2 ? Symbol.for("react.profiler") : 60114, h3 = b2 ? Symbol.for("react.provider") : 60109, k2 = b2 ? Symbol.for("react.context") : 60110, l2 = b2 ? Symbol.for("react.async_mode") : 60111, m3 = b2 ? Symbol.for("react.concurrent_mode") : 60111, n2 = b2 ? Symbol.for("react.forward_ref") : 60112, p2 = b2 ? Symbol.for("react.suspense") : 60113, q = b2 ? Symbol.for("react.suspense_list") : 60120, r2 = b2 ? Symbol.for("react.memo") : 60115, t2 = b2 ? Symbol.for("react.lazy") : 60116, v2 = b2 ? Symbol.for("react.block") : 60121, w2 = b2 ? Symbol.for("react.fundamental") : 60117, x2 = b2 ? Symbol.for("react.responder") : 60118, y2 = b2 ? Symbol.for("react.scope") : 60119;
  function z2(a2) {
    if ("object" === typeof a2 && null !== a2) {
      var u2 = a2.$$typeof;
      switch (u2) {
        case c4:
          switch (a2 = a2.type, a2) {
            case l2:
            case m3:
            case e2:
            case g2:
            case f2:
            case p2:
              return a2;
            default:
              switch (a2 = a2 && a2.$$typeof, a2) {
                case k2:
                case n2:
                case t2:
                case r2:
                case h3:
                  return a2;
                default:
                  return u2;
              }
          }
        case d2:
          return u2;
      }
    }
  }
  function A2(a2) {
    return z2(a2) === m3;
  }
  reactIs_production_min.AsyncMode = l2;
  reactIs_production_min.ConcurrentMode = m3;
  reactIs_production_min.ContextConsumer = k2;
  reactIs_production_min.ContextProvider = h3;
  reactIs_production_min.Element = c4;
  reactIs_production_min.ForwardRef = n2;
  reactIs_production_min.Fragment = e2;
  reactIs_production_min.Lazy = t2;
  reactIs_production_min.Memo = r2;
  reactIs_production_min.Portal = d2;
  reactIs_production_min.Profiler = g2;
  reactIs_production_min.StrictMode = f2;
  reactIs_production_min.Suspense = p2;
  reactIs_production_min.isAsyncMode = function(a2) {
    return A2(a2) || z2(a2) === l2;
  };
  reactIs_production_min.isConcurrentMode = A2;
  reactIs_production_min.isContextConsumer = function(a2) {
    return z2(a2) === k2;
  };
  reactIs_production_min.isContextProvider = function(a2) {
    return z2(a2) === h3;
  };
  reactIs_production_min.isElement = function(a2) {
    return "object" === typeof a2 && null !== a2 && a2.$$typeof === c4;
  };
  reactIs_production_min.isForwardRef = function(a2) {
    return z2(a2) === n2;
  };
  reactIs_production_min.isFragment = function(a2) {
    return z2(a2) === e2;
  };
  reactIs_production_min.isLazy = function(a2) {
    return z2(a2) === t2;
  };
  reactIs_production_min.isMemo = function(a2) {
    return z2(a2) === r2;
  };
  reactIs_production_min.isPortal = function(a2) {
    return z2(a2) === d2;
  };
  reactIs_production_min.isProfiler = function(a2) {
    return z2(a2) === g2;
  };
  reactIs_production_min.isStrictMode = function(a2) {
    return z2(a2) === f2;
  };
  reactIs_production_min.isSuspense = function(a2) {
    return z2(a2) === p2;
  };
  reactIs_production_min.isValidElementType = function(a2) {
    return "string" === typeof a2 || "function" === typeof a2 || a2 === e2 || a2 === m3 || a2 === g2 || a2 === f2 || a2 === p2 || a2 === q || "object" === typeof a2 && null !== a2 && (a2.$$typeof === t2 || a2.$$typeof === r2 || a2.$$typeof === h3 || a2.$$typeof === k2 || a2.$$typeof === n2 || a2.$$typeof === w2 || a2.$$typeof === x2 || a2.$$typeof === y2 || a2.$$typeof === v2);
  };
  reactIs_production_min.typeOf = z2;
  return reactIs_production_min;
}
var reactIs_development = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_development;
function requireReactIs_development() {
  if (hasRequiredReactIs_development) return reactIs_development;
  hasRequiredReactIs_development = 1;
  if (process.env.NODE_ENV !== "production") {
    (function() {
      var hasSymbol = typeof Symbol === "function" && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 60103;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 60106;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 60107;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 60108;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 60114;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 60109;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 60110;
      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 60111;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 60111;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 60112;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 60113;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 60120;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 60115;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 60116;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 60121;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 60117;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 60118;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 60119;
      function isValidElementType(type2) {
        return typeof type2 === "string" || typeof type2 === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type2 === REACT_FRAGMENT_TYPE || type2 === REACT_CONCURRENT_MODE_TYPE || type2 === REACT_PROFILER_TYPE || type2 === REACT_STRICT_MODE_TYPE || type2 === REACT_SUSPENSE_TYPE || type2 === REACT_SUSPENSE_LIST_TYPE || typeof type2 === "object" && type2 !== null && (type2.$$typeof === REACT_LAZY_TYPE || type2.$$typeof === REACT_MEMO_TYPE || type2.$$typeof === REACT_PROVIDER_TYPE || type2.$$typeof === REACT_CONTEXT_TYPE || type2.$$typeof === REACT_FORWARD_REF_TYPE || type2.$$typeof === REACT_FUNDAMENTAL_TYPE || type2.$$typeof === REACT_RESPONDER_TYPE || type2.$$typeof === REACT_SCOPE_TYPE || type2.$$typeof === REACT_BLOCK_TYPE);
      }
      function typeOf(object) {
        if (typeof object === "object" && object !== null) {
          var $$typeof = object.$$typeof;
          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type2 = object.type;
              switch (type2) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type2;
                default:
                  var $$typeofType = type2 && type2.$$typeof;
                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;
                    default:
                      return $$typeof;
                  }
              }
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }
        return void 0;
      }
      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element2 = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment2 = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false;
      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true;
            console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
          }
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }
      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }
      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }
      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }
      function isElement2(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }
      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }
      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }
      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }
      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }
      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }
      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }
      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }
      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }
      reactIs_development.AsyncMode = AsyncMode;
      reactIs_development.ConcurrentMode = ConcurrentMode;
      reactIs_development.ContextConsumer = ContextConsumer;
      reactIs_development.ContextProvider = ContextProvider;
      reactIs_development.Element = Element2;
      reactIs_development.ForwardRef = ForwardRef;
      reactIs_development.Fragment = Fragment2;
      reactIs_development.Lazy = Lazy;
      reactIs_development.Memo = Memo;
      reactIs_development.Portal = Portal;
      reactIs_development.Profiler = Profiler;
      reactIs_development.StrictMode = StrictMode;
      reactIs_development.Suspense = Suspense;
      reactIs_development.isAsyncMode = isAsyncMode;
      reactIs_development.isConcurrentMode = isConcurrentMode;
      reactIs_development.isContextConsumer = isContextConsumer;
      reactIs_development.isContextProvider = isContextProvider;
      reactIs_development.isElement = isElement2;
      reactIs_development.isForwardRef = isForwardRef;
      reactIs_development.isFragment = isFragment;
      reactIs_development.isLazy = isLazy;
      reactIs_development.isMemo = isMemo;
      reactIs_development.isPortal = isPortal;
      reactIs_development.isProfiler = isProfiler;
      reactIs_development.isStrictMode = isStrictMode;
      reactIs_development.isSuspense = isSuspense;
      reactIs_development.isValidElementType = isValidElementType;
      reactIs_development.typeOf = typeOf;
    })();
  }
  return reactIs_development;
}
var hasRequiredReactIs;
function requireReactIs() {
  if (hasRequiredReactIs) return reactIs.exports;
  hasRequiredReactIs = 1;
  if (process.env.NODE_ENV === "production") {
    reactIs.exports = requireReactIs_production_min();
  } else {
    reactIs.exports = requireReactIs_development();
  }
  return reactIs.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var objectAssign;
var hasRequiredObjectAssign;
function requireObjectAssign() {
  if (hasRequiredObjectAssign) return objectAssign;
  hasRequiredObjectAssign = 1;
  var getOwnPropertySymbols = Object.getOwnPropertySymbols;
  var hasOwnProperty2 = Object.prototype.hasOwnProperty;
  var propIsEnumerable = Object.prototype.propertyIsEnumerable;
  function toObject(val) {
    if (val === null || val === void 0) {
      throw new TypeError("Object.assign cannot be called with null or undefined");
    }
    return Object(val);
  }
  function shouldUseNative() {
    try {
      if (!Object.assign) {
        return false;
      }
      var test1 = new String("abc");
      test1[5] = "de";
      if (Object.getOwnPropertyNames(test1)[0] === "5") {
        return false;
      }
      var test2 = {};
      for (var i = 0; i < 10; i++) {
        test2["_" + String.fromCharCode(i)] = i;
      }
      var order2 = Object.getOwnPropertyNames(test2).map(function(n2) {
        return test2[n2];
      });
      if (order2.join("") !== "0123456789") {
        return false;
      }
      var test3 = {};
      "abcdefghijklmnopqrst".split("").forEach(function(letter) {
        test3[letter] = letter;
      });
      if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
        return false;
      }
      return true;
    } catch (err) {
      return false;
    }
  }
  objectAssign = shouldUseNative() ? Object.assign : function(target, source) {
    var from2;
    var to2 = toObject(target);
    var symbols;
    for (var s2 = 1; s2 < arguments.length; s2++) {
      from2 = Object(arguments[s2]);
      for (var key in from2) {
        if (hasOwnProperty2.call(from2, key)) {
          to2[key] = from2[key];
        }
      }
      if (getOwnPropertySymbols) {
        symbols = getOwnPropertySymbols(from2);
        for (var i = 0; i < symbols.length; i++) {
          if (propIsEnumerable.call(from2, symbols[i])) {
            to2[symbols[i]] = from2[symbols[i]];
          }
        }
      }
    }
    return to2;
  };
  return objectAssign;
}
var ReactPropTypesSecret_1;
var hasRequiredReactPropTypesSecret;
function requireReactPropTypesSecret() {
  if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
  hasRequiredReactPropTypesSecret = 1;
  var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  ReactPropTypesSecret_1 = ReactPropTypesSecret;
  return ReactPropTypesSecret_1;
}
var has;
var hasRequiredHas;
function requireHas() {
  if (hasRequiredHas) return has;
  hasRequiredHas = 1;
  has = Function.call.bind(Object.prototype.hasOwnProperty);
  return has;
}
var checkPropTypes_1;
var hasRequiredCheckPropTypes;
function requireCheckPropTypes() {
  if (hasRequiredCheckPropTypes) return checkPropTypes_1;
  hasRequiredCheckPropTypes = 1;
  var printWarning = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var ReactPropTypesSecret = requireReactPropTypesSecret();
    var loggedTypeFailures = {};
    var has2 = requireHas();
    printWarning = function(text) {
      var message2 = "Warning: " + text;
      if (typeof console !== "undefined") {
        console.error(message2);
      }
      try {
        throw new Error(message2);
      } catch (x2) {
      }
    };
  }
  function checkPropTypes(typeSpecs, values2, location, componentName, getStack) {
    if (process.env.NODE_ENV !== "production") {
      for (var typeSpecName in typeSpecs) {
        if (has2(typeSpecs, typeSpecName)) {
          var error;
          try {
            if (typeof typeSpecs[typeSpecName] !== "function") {
              var err = Error(
                (componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              err.name = "Invariant Violation";
              throw err;
            }
            error = typeSpecs[typeSpecName](values2, typeSpecName, componentName, location, null, ReactPropTypesSecret);
          } catch (ex) {
            error = ex;
          }
          if (error && !(error instanceof Error)) {
            printWarning(
              (componentName || "React class") + ": type specification of " + location + " `" + typeSpecName + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof error + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
            );
          }
          if (error instanceof Error && !(error.message in loggedTypeFailures)) {
            loggedTypeFailures[error.message] = true;
            var stack = getStack ? getStack() : "";
            printWarning(
              "Failed " + location + " type: " + error.message + (stack != null ? stack : "")
            );
          }
        }
      }
    }
  }
  checkPropTypes.resetWarningCache = function() {
    if (process.env.NODE_ENV !== "production") {
      loggedTypeFailures = {};
    }
  };
  checkPropTypes_1 = checkPropTypes;
  return checkPropTypes_1;
}
var factoryWithTypeCheckers;
var hasRequiredFactoryWithTypeCheckers;
function requireFactoryWithTypeCheckers() {
  if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
  hasRequiredFactoryWithTypeCheckers = 1;
  var ReactIs = requireReactIs();
  var assign2 = requireObjectAssign();
  var ReactPropTypesSecret = requireReactPropTypesSecret();
  var has2 = requireHas();
  var checkPropTypes = requireCheckPropTypes();
  var printWarning = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    printWarning = function(text) {
      var message2 = "Warning: " + text;
      if (typeof console !== "undefined") {
        console.error(message2);
      }
      try {
        throw new Error(message2);
      } catch (x2) {
      }
    };
  }
  function emptyFunctionThatReturnsNull() {
    return null;
  }
  factoryWithTypeCheckers = function(isValidElement2, throwOnDirectAccess) {
    var ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator";
    function getIteratorFn(maybeIterable) {
      var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
      if (typeof iteratorFn === "function") {
        return iteratorFn;
      }
    }
    var ANONYMOUS = "<<anonymous>>";
    var ReactPropTypes = {
      array: createPrimitiveTypeChecker("array"),
      bigint: createPrimitiveTypeChecker("bigint"),
      bool: createPrimitiveTypeChecker("boolean"),
      func: createPrimitiveTypeChecker("function"),
      number: createPrimitiveTypeChecker("number"),
      object: createPrimitiveTypeChecker("object"),
      string: createPrimitiveTypeChecker("string"),
      symbol: createPrimitiveTypeChecker("symbol"),
      any: createAnyTypeChecker(),
      arrayOf: createArrayOfTypeChecker,
      element: createElementTypeChecker(),
      elementType: createElementTypeTypeChecker(),
      instanceOf: createInstanceTypeChecker,
      node: createNodeChecker(),
      objectOf: createObjectOfTypeChecker,
      oneOf: createEnumTypeChecker,
      oneOfType: createUnionTypeChecker,
      shape: createShapeTypeChecker,
      exact: createStrictShapeTypeChecker
    };
    function is(x2, y2) {
      if (x2 === y2) {
        return x2 !== 0 || 1 / x2 === 1 / y2;
      } else {
        return x2 !== x2 && y2 !== y2;
      }
    }
    function PropTypeError(message2, data2) {
      this.message = message2;
      this.data = data2 && typeof data2 === "object" ? data2 : {};
      this.stack = "";
    }
    PropTypeError.prototype = Error.prototype;
    function createChainableTypeChecker(validate) {
      if (process.env.NODE_ENV !== "production") {
        var manualPropTypeCallCache = {};
        var manualPropTypeWarningCount = 0;
      }
      function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
        componentName = componentName || ANONYMOUS;
        propFullName = propFullName || propName;
        if (secret !== ReactPropTypesSecret) {
          if (throwOnDirectAccess) {
            var err = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            err.name = "Invariant Violation";
            throw err;
          } else if (process.env.NODE_ENV !== "production" && typeof console !== "undefined") {
            var cacheKey = componentName + ":" + propName;
            if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3) {
              printWarning(
                "You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
              );
              manualPropTypeCallCache[cacheKey] = true;
              manualPropTypeWarningCount++;
            }
          }
        }
        if (props[propName] == null) {
          if (isRequired) {
            if (props[propName] === null) {
              return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required " + ("in `" + componentName + "`, but its value is `null`."));
            }
            return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required in " + ("`" + componentName + "`, but its value is `undefined`."));
          }
          return null;
        } else {
          return validate(props, propName, componentName, location, propFullName);
        }
      }
      var chainedCheckType = checkType.bind(null, false);
      chainedCheckType.isRequired = checkType.bind(null, true);
      return chainedCheckType;
    }
    function createPrimitiveTypeChecker(expectedType) {
      function validate(props, propName, componentName, location, propFullName, secret) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== expectedType) {
          var preciseType = getPreciseType(propValue);
          return new PropTypeError(
            "Invalid " + location + " `" + propFullName + "` of type " + ("`" + preciseType + "` supplied to `" + componentName + "`, expected ") + ("`" + expectedType + "`."),
            { expectedType }
          );
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createAnyTypeChecker() {
      return createChainableTypeChecker(emptyFunctionThatReturnsNull);
    }
    function createArrayOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== "function") {
          return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
        }
        var propValue = props[propName];
        if (!Array.isArray(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an array."));
        }
        for (var i = 0; i < propValue.length; i++) {
          var error = typeChecker(propValue, i, componentName, location, propFullName + "[" + i + "]", ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createElementTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        if (!isValidElement2(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createElementTypeTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        if (!ReactIs.isValidElementType(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createInstanceTypeChecker(expectedClass) {
      function validate(props, propName, componentName, location, propFullName) {
        if (!(props[propName] instanceof expectedClass)) {
          var expectedClassName = expectedClass.name || ANONYMOUS;
          var actualClassName = getClassName(props[propName]);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + actualClassName + "` supplied to `" + componentName + "`, expected ") + ("instance of `" + expectedClassName + "`."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createEnumTypeChecker(expectedValues) {
      if (!Array.isArray(expectedValues)) {
        if (process.env.NODE_ENV !== "production") {
          if (arguments.length > 1) {
            printWarning(
              "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
            );
          } else {
            printWarning("Invalid argument supplied to oneOf, expected an array.");
          }
        }
        return emptyFunctionThatReturnsNull;
      }
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        for (var i = 0; i < expectedValues.length; i++) {
          if (is(propValue, expectedValues[i])) {
            return null;
          }
        }
        var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
          var type2 = getPreciseType(value);
          if (type2 === "symbol") {
            return String(value);
          }
          return value;
        });
        return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + String(propValue) + "` " + ("supplied to `" + componentName + "`, expected one of " + valuesString + "."));
      }
      return createChainableTypeChecker(validate);
    }
    function createObjectOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== "function") {
          return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
        }
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an object."));
        }
        for (var key in propValue) {
          if (has2(propValue, key)) {
            var error = typeChecker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
            if (error instanceof Error) {
              return error;
            }
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createUnionTypeChecker(arrayOfTypeCheckers) {
      if (!Array.isArray(arrayOfTypeCheckers)) {
        process.env.NODE_ENV !== "production" ? printWarning("Invalid argument supplied to oneOfType, expected an instance of array.") : void 0;
        return emptyFunctionThatReturnsNull;
      }
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (typeof checker !== "function") {
          printWarning(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i + "."
          );
          return emptyFunctionThatReturnsNull;
        }
      }
      function validate(props, propName, componentName, location, propFullName) {
        var expectedTypes = [];
        for (var i2 = 0; i2 < arrayOfTypeCheckers.length; i2++) {
          var checker2 = arrayOfTypeCheckers[i2];
          var checkerResult = checker2(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
          if (checkerResult == null) {
            return null;
          }
          if (checkerResult.data && has2(checkerResult.data, "expectedType")) {
            expectedTypes.push(checkerResult.data.expectedType);
          }
        }
        var expectedTypesMessage = expectedTypes.length > 0 ? ", expected one of type [" + expectedTypes.join(", ") + "]" : "";
        return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`" + expectedTypesMessage + "."));
      }
      return createChainableTypeChecker(validate);
    }
    function createNodeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        if (!isNode2(props[propName])) {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`, expected a ReactNode."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function invalidValidatorError(componentName, location, propFullName, key, type2) {
      return new PropTypeError(
        (componentName || "React class") + ": " + location + " type `" + propFullName + "." + key + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + type2 + "`."
      );
    }
    function createShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
        }
        for (var key in shapeTypes) {
          var checker = shapeTypes[key];
          if (typeof checker !== "function") {
            return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
          }
          var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
          if (error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createStrictShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
        }
        var allKeys = assign2({}, props[propName], shapeTypes);
        for (var key in allKeys) {
          var checker = shapeTypes[key];
          if (has2(shapeTypes, key) && typeof checker !== "function") {
            return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
          }
          if (!checker) {
            return new PropTypeError(
              "Invalid " + location + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`.\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  ")
            );
          }
          var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
          if (error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function isNode2(propValue) {
      switch (typeof propValue) {
        case "number":
        case "string":
        case "undefined":
          return true;
        case "boolean":
          return !propValue;
        case "object":
          if (Array.isArray(propValue)) {
            return propValue.every(isNode2);
          }
          if (propValue === null || isValidElement2(propValue)) {
            return true;
          }
          var iteratorFn = getIteratorFn(propValue);
          if (iteratorFn) {
            var iterator = iteratorFn.call(propValue);
            var step;
            if (iteratorFn !== propValue.entries) {
              while (!(step = iterator.next()).done) {
                if (!isNode2(step.value)) {
                  return false;
                }
              }
            } else {
              while (!(step = iterator.next()).done) {
                var entry = step.value;
                if (entry) {
                  if (!isNode2(entry[1])) {
                    return false;
                  }
                }
              }
            }
          } else {
            return false;
          }
          return true;
        default:
          return false;
      }
    }
    function isSymbol(propType, propValue) {
      if (propType === "symbol") {
        return true;
      }
      if (!propValue) {
        return false;
      }
      if (propValue["@@toStringTag"] === "Symbol") {
        return true;
      }
      if (typeof Symbol === "function" && propValue instanceof Symbol) {
        return true;
      }
      return false;
    }
    function getPropType(propValue) {
      var propType = typeof propValue;
      if (Array.isArray(propValue)) {
        return "array";
      }
      if (propValue instanceof RegExp) {
        return "object";
      }
      if (isSymbol(propType, propValue)) {
        return "symbol";
      }
      return propType;
    }
    function getPreciseType(propValue) {
      if (typeof propValue === "undefined" || propValue === null) {
        return "" + propValue;
      }
      var propType = getPropType(propValue);
      if (propType === "object") {
        if (propValue instanceof Date) {
          return "date";
        } else if (propValue instanceof RegExp) {
          return "regexp";
        }
      }
      return propType;
    }
    function getPostfixForTypeWarning(value) {
      var type2 = getPreciseType(value);
      switch (type2) {
        case "array":
        case "object":
          return "an " + type2;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + type2;
        default:
          return type2;
      }
    }
    function getClassName(propValue) {
      if (!propValue.constructor || !propValue.constructor.name) {
        return ANONYMOUS;
      }
      return propValue.constructor.name;
    }
    ReactPropTypes.checkPropTypes = checkPropTypes;
    ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  return factoryWithTypeCheckers;
}
var factoryWithThrowingShims;
var hasRequiredFactoryWithThrowingShims;
function requireFactoryWithThrowingShims() {
  if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
  hasRequiredFactoryWithThrowingShims = 1;
  var ReactPropTypesSecret = requireReactPropTypesSecret();
  function emptyFunction() {
  }
  function emptyFunctionWithReset() {
  }
  emptyFunctionWithReset.resetWarningCache = emptyFunction;
  factoryWithThrowingShims = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
      if (secret === ReactPropTypesSecret) {
        return;
      }
      var err = new Error(
        "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
      );
      err.name = "Invariant Violation";
      throw err;
    }
    shim.isRequired = shim;
    function getShim() {
      return shim;
    }
    var ReactPropTypes = {
      array: shim,
      bigint: shim,
      bool: shim,
      func: shim,
      number: shim,
      object: shim,
      string: shim,
      symbol: shim,
      any: shim,
      arrayOf: getShim,
      element: shim,
      elementType: shim,
      instanceOf: getShim,
      node: shim,
      objectOf: getShim,
      oneOf: getShim,
      oneOfType: getShim,
      shape: getShim,
      exact: getShim,
      checkPropTypes: emptyFunctionWithReset,
      resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  return factoryWithThrowingShims;
}
if (process.env.NODE_ENV !== "production") {
  var ReactIs = requireReactIs();
  var throwOnDirectAccess = true;
  propTypes.exports = requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
} else {
  propTypes.exports = requireFactoryWithThrowingShims()();
}
var propTypesExports = propTypes.exports;
const PropTypes = /* @__PURE__ */ getDefaultExportFromCjs(propTypesExports);
const config = {
  disabled: false
};
var timeoutsShape = process.env.NODE_ENV !== "production" ? PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
  enter: PropTypes.number,
  exit: PropTypes.number,
  appear: PropTypes.number
}).isRequired]) : null;
process.env.NODE_ENV !== "production" ? PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
  enter: PropTypes.string,
  exit: PropTypes.string,
  active: PropTypes.string
}), PropTypes.shape({
  enter: PropTypes.string,
  enterDone: PropTypes.string,
  enterActive: PropTypes.string,
  exit: PropTypes.string,
  exitDone: PropTypes.string,
  exitActive: PropTypes.string
})]) : null;
const TransitionGroupContext = React__default.createContext(null);
var forceReflow = function forceReflow2(node2) {
  return node2.scrollTop;
};
var UNMOUNTED = "unmounted";
var EXITED = "exited";
var ENTERING = "entering";
var ENTERED = "entered";
var EXITING = "exiting";
var Transition = /* @__PURE__ */ function(_React$Component) {
  _inheritsLoose(Transition2, _React$Component);
  function Transition2(props, context) {
    var _this;
    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context;
    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;
    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }
    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }
  Transition2.getDerivedStateFromProps = function getDerivedStateFromProps(_ref3, prevState) {
    var nextIn = _ref3.in;
    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }
    return null;
  };
  var _proto = Transition2.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };
  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;
    if (prevProps !== this.props) {
      var status = this.state.status;
      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }
    this.updateStatus(false, nextStatus);
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };
  _proto.getTimeouts = function getTimeouts() {
    var timeout2 = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout2;
    if (timeout2 != null && typeof timeout2 !== "number") {
      exit = timeout2.exit;
      enter = timeout2.enter;
      appear = timeout2.appear !== void 0 ? timeout2.appear : enter;
    }
    return {
      exit,
      enter,
      appear
    };
  };
  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }
    if (nextStatus !== null) {
      this.cancelNextCallback();
      if (nextStatus === ENTERING) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var node2 = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM__default.findDOMNode(this);
          if (node2) forceReflow(node2);
        }
        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };
  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;
    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;
    var _ref22 = this.props.nodeRef ? [appearing] : [ReactDOM__default.findDOMNode(this), appearing], maybeNode = _ref22[0], maybeAppearing = _ref22[1];
    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter;
    if (!mounting && !enter || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function() {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }
    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function() {
      _this2.props.onEntering(maybeNode, maybeAppearing);
      _this2.onTransitionEnd(enterTimeout, function() {
        _this2.safeSetState({
          status: ENTERED
        }, function() {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };
  _proto.performExit = function performExit() {
    var _this3 = this;
    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? void 0 : ReactDOM__default.findDOMNode(this);
    if (!exit || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function() {
        _this3.props.onExited(maybeNode);
      });
      return;
    }
    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function() {
      _this3.props.onExiting(maybeNode);
      _this3.onTransitionEnd(timeouts.exit, function() {
        _this3.safeSetState({
          status: EXITED
        }, function() {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };
  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };
  _proto.safeSetState = function safeSetState(nextState, callback2) {
    callback2 = this.setNextCallback(callback2);
    this.setState(nextState, callback2);
  };
  _proto.setNextCallback = function setNextCallback(callback2) {
    var _this4 = this;
    var active2 = true;
    this.nextCallback = function(event) {
      if (active2) {
        active2 = false;
        _this4.nextCallback = null;
        callback2(event);
      }
    };
    this.nextCallback.cancel = function() {
      active2 = false;
    };
    return this.nextCallback;
  };
  _proto.onTransitionEnd = function onTransitionEnd(timeout2, handler) {
    this.setNextCallback(handler);
    var node2 = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM__default.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout2 == null && !this.props.addEndListener;
    if (!node2 || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node2, this.nextCallback], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
      this.props.addEndListener(maybeNode, maybeNextCallback);
    }
    if (timeout2 != null) {
      setTimeout(this.nextCallback, timeout2);
    }
  };
  _proto.render = function render() {
    var status = this.state.status;
    if (status === UNMOUNTED) {
      return null;
    }
    var _this$props = this.props, children = _this$props.children;
    _this$props.in;
    _this$props.mountOnEnter;
    _this$props.unmountOnExit;
    _this$props.appear;
    _this$props.enter;
    _this$props.exit;
    _this$props.timeout;
    _this$props.addEndListener;
    _this$props.onEnter;
    _this$props.onEntering;
    _this$props.onEntered;
    _this$props.onExit;
    _this$props.onExiting;
    _this$props.onExited;
    _this$props.nodeRef;
    var childProps = _objectWithoutPropertiesLoose$1(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return (
      // allows for nested Transitions
      /* @__PURE__ */ React__default.createElement(TransitionGroupContext.Provider, {
        value: null
      }, typeof children === "function" ? children(status, childProps) : React__default.cloneElement(React__default.Children.only(children), childProps))
    );
  };
  return Transition2;
}(React__default.Component);
Transition.contextType = TransitionGroupContext;
Transition.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: PropTypes.shape({
    current: typeof Element === "undefined" ? PropTypes.any : function(propValue, key, componentName, location, propFullName, secret) {
      var value = propValue[key];
      return PropTypes.instanceOf(value && "ownerDocument" in value ? value.ownerDocument.defaultView.Element : Element)(propValue, key, componentName, location, propFullName, secret);
    }
  }),
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,
  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,
  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,
  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,
  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: PropTypes.bool,
  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,
  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,
  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    return pt.apply(void 0, [props].concat(args));
  },
  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,
  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,
  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,
  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,
  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,
  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,
  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func
} : {};
function noop2() {
}
Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop2,
  onEntering: noop2,
  onEntered: noop2,
  onExit: noop2,
  onExiting: noop2,
  onExited: noop2
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
const Transition$1 = Transition;
function getChildMapping(children, mapFn) {
  var mapper = function mapper2(child) {
    return mapFn && isValidElement(child) ? mapFn(child) : child;
  };
  var result = /* @__PURE__ */ Object.create(null);
  if (children) Children.map(children, function(c4) {
    return c4;
  }).forEach(function(child) {
    result[child.key] = mapper(child);
  });
  return result;
}
function mergeChildMappings(prev2, next2) {
  prev2 = prev2 || {};
  next2 = next2 || {};
  function getValueForKey(key) {
    return key in next2 ? next2[key] : prev2[key];
  }
  var nextKeysPending = /* @__PURE__ */ Object.create(null);
  var pendingKeys = [];
  for (var prevKey in prev2) {
    if (prevKey in next2) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }
  var i;
  var childMapping = {};
  for (var nextKey in next2) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }
  return childMapping;
}
function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}
function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function(child) {
    return cloneElement(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, "appear", props),
      enter: getProp(child, "enter", props),
      exit: getProp(child, "exit", props)
    });
  });
}
function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function(key) {
    var child = children[key];
    if (!isValidElement(child)) return;
    var hasPrev = key in prevChildMapping;
    var hasNext = key in nextChildMapping;
    var prevChild = prevChildMapping[key];
    var isLeaving = isValidElement(prevChild) && !prevChild.props.in;
    if (hasNext && (!hasPrev || isLeaving)) {
      children[key] = cloneElement(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, "exit", nextProps),
        enter: getProp(child, "enter", nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      children[key] = cloneElement(child, {
        in: false
      });
    } else if (hasNext && hasPrev && isValidElement(prevChild)) {
      children[key] = cloneElement(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, "exit", nextProps),
        enter: getProp(child, "enter", nextProps)
      });
    }
  });
  return children;
}
var values = Object.values || function(obj) {
  return Object.keys(obj).map(function(k2) {
    return obj[k2];
  });
};
var defaultProps = {
  component: "div",
  childFactory: function childFactory(child) {
    return child;
  }
};
var TransitionGroup = /* @__PURE__ */ function(_React$Component) {
  _inheritsLoose(TransitionGroup2, _React$Component);
  function TransitionGroup2(props, context) {
    var _this;
    _this = _React$Component.call(this, props, context) || this;
    var handleExited = _this.handleExited.bind(_assertThisInitialized(_this));
    _this.state = {
      contextValue: {
        isMounting: true
      },
      handleExited,
      firstRender: true
    };
    return _this;
  }
  var _proto = TransitionGroup2.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.mounted = true;
    this.setState({
      contextValue: {
        isMounting: false
      }
    });
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };
  TransitionGroup2.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref3) {
    var prevChildMapping = _ref3.children, handleExited = _ref3.handleExited, firstRender = _ref3.firstRender;
    return {
      children: firstRender ? getInitialChildMapping(nextProps, handleExited) : getNextChildMapping(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  };
  _proto.handleExited = function handleExited(child, node2) {
    var currentChildMapping = getChildMapping(this.props.children);
    if (child.key in currentChildMapping) return;
    if (child.props.onExited) {
      child.props.onExited(node2);
    }
    if (this.mounted) {
      this.setState(function(state) {
        var children = _extends$1({}, state.children);
        delete children[child.key];
        return {
          children
        };
      });
    }
  };
  _proto.render = function render() {
    var _this$props = this.props, Component2 = _this$props.component, childFactory2 = _this$props.childFactory, props = _objectWithoutPropertiesLoose$1(_this$props, ["component", "childFactory"]);
    var contextValue = this.state.contextValue;
    var children = values(this.state.children).map(childFactory2);
    delete props.appear;
    delete props.enter;
    delete props.exit;
    if (Component2 === null) {
      return /* @__PURE__ */ React__default.createElement(TransitionGroupContext.Provider, {
        value: contextValue
      }, children);
    }
    return /* @__PURE__ */ React__default.createElement(TransitionGroupContext.Provider, {
      value: contextValue
    }, /* @__PURE__ */ React__default.createElement(Component2, props, children));
  };
  return TransitionGroup2;
}(React__default.Component);
TransitionGroup.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: PropTypes.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: PropTypes.node,
  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: PropTypes.bool,
  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: PropTypes.bool,
  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: PropTypes.bool,
  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: PropTypes.func
} : {};
TransitionGroup.defaultProps = defaultProps;
const TransitionGroup$1 = TransitionGroup;
var _excluded$4 = ["in", "onExited", "appear", "enter", "exit"];
var AnimatedInput = function AnimatedInput2(WrappedComponent) {
  return function(_ref3) {
    _ref3.in;
    _ref3.onExited;
    _ref3.appear;
    _ref3.enter;
    _ref3.exit;
    var props = _objectWithoutProperties(_ref3, _excluded$4);
    return /* @__PURE__ */ React.createElement(WrappedComponent, props);
  };
};
var AnimatedInput$1 = AnimatedInput;
var _excluded$3 = ["component", "duration", "in", "onExited"];
var Fade = function Fade2(_ref3) {
  var Tag = _ref3.component, _ref$duration = _ref3.duration, duration = _ref$duration === void 0 ? 1 : _ref$duration, inProp = _ref3.in;
  _ref3.onExited;
  var props = _objectWithoutProperties(_ref3, _excluded$3);
  var nodeRef = useRef(null);
  var transition = {
    entering: {
      opacity: 0
    },
    entered: {
      opacity: 1,
      transition: "opacity ".concat(duration, "ms")
    },
    exiting: {
      opacity: 0
    },
    exited: {
      opacity: 0
    }
  };
  return /* @__PURE__ */ React.createElement(Transition$1, {
    mountOnEnter: true,
    unmountOnExit: true,
    in: inProp,
    timeout: duration,
    nodeRef
  }, function(state) {
    var innerProps = {
      style: _objectSpread2({}, transition[state]),
      ref: nodeRef
    };
    return /* @__PURE__ */ React.createElement(Tag, _extends$1({
      innerProps
    }, props));
  });
};
var collapseDuration = 260;
var Collapse = function Collapse2(_ref22) {
  var children = _ref22.children, _in = _ref22.in, _onExited = _ref22.onExited;
  var ref = useRef(null);
  var _useState = useState("auto"), _useState2 = _slicedToArray(_useState, 2), width = _useState2[0], setWidth = _useState2[1];
  useEffect(function() {
    var el = ref.current;
    if (!el) return;
    var rafId = window.requestAnimationFrame(function() {
      return setWidth(el.getBoundingClientRect().width);
    });
    return function() {
      return window.cancelAnimationFrame(rafId);
    };
  }, []);
  var getStyleFromStatus = function getStyleFromStatus2(status) {
    switch (status) {
      default:
        return {
          width
        };
      case "exiting":
        return {
          width: 0,
          transition: "width ".concat(collapseDuration, "ms ease-out")
        };
      case "exited":
        return {
          width: 0
        };
    }
  };
  return /* @__PURE__ */ React.createElement(Transition$1, {
    enter: false,
    mountOnEnter: true,
    unmountOnExit: true,
    in: _in,
    onExited: function onExited() {
      var el = ref.current;
      if (!el) return;
      _onExited === null || _onExited === void 0 ? void 0 : _onExited(el);
    },
    timeout: collapseDuration,
    nodeRef: ref
  }, function(status) {
    return /* @__PURE__ */ React.createElement("div", {
      ref,
      style: _objectSpread2({
        overflow: "hidden",
        whiteSpace: "nowrap"
      }, getStyleFromStatus(status))
    }, children);
  });
};
var _excluded$2 = ["in", "onExited"];
var AnimatedMultiValue = function AnimatedMultiValue2(WrappedComponent) {
  return function(_ref3) {
    var inProp = _ref3.in, onExited = _ref3.onExited, props = _objectWithoutProperties(_ref3, _excluded$2);
    return /* @__PURE__ */ React.createElement(Collapse, {
      in: inProp,
      onExited
    }, /* @__PURE__ */ React.createElement(WrappedComponent, _extends$1({
      cropWithEllipsis: inProp
    }, props)));
  };
};
var AnimatedMultiValue$1 = AnimatedMultiValue;
var AnimatedPlaceholder = function AnimatedPlaceholder2(WrappedComponent) {
  return function(props) {
    return /* @__PURE__ */ React.createElement(Fade, _extends$1({
      component: WrappedComponent,
      duration: props.isMulti ? collapseDuration : 1
    }, props));
  };
};
var AnimatedPlaceholder$1 = AnimatedPlaceholder;
var AnimatedSingleValue = function AnimatedSingleValue2(WrappedComponent) {
  return function(props) {
    return /* @__PURE__ */ React.createElement(Fade, _extends$1({
      component: WrappedComponent
    }, props));
  };
};
var AnimatedSingleValue$1 = AnimatedSingleValue;
var _excluded$1 = ["component"], _excluded2 = ["children"];
var AnimatedValueContainer = function AnimatedValueContainer2(WrappedComponent) {
  return function(props) {
    return props.isMulti ? /* @__PURE__ */ React.createElement(IsMultiValueContainer, _extends$1({
      component: WrappedComponent
    }, props)) : /* @__PURE__ */ React.createElement(TransitionGroup$1, _extends$1({
      component: WrappedComponent
    }, props));
  };
};
var IsMultiValueContainer = function IsMultiValueContainer2(_ref3) {
  var component = _ref3.component, restProps = _objectWithoutProperties(_ref3, _excluded$1);
  var multiProps = useIsMultiValueContainer(restProps);
  return /* @__PURE__ */ React.createElement(TransitionGroup$1, _extends$1({
    component
  }, multiProps));
};
var useIsMultiValueContainer = function useIsMultiValueContainer2(_ref22) {
  var children = _ref22.children, props = _objectWithoutProperties(_ref22, _excluded2);
  var isMulti = props.isMulti, hasValue = props.hasValue, innerProps = props.innerProps, _props$selectProps = props.selectProps, components2 = _props$selectProps.components, controlShouldRenderValue = _props$selectProps.controlShouldRenderValue;
  var _useState = useState(isMulti && controlShouldRenderValue && hasValue), _useState2 = _slicedToArray(_useState, 2), cssDisplayFlex = _useState2[0], setCssDisplayFlex = _useState2[1];
  var _useState3 = useState(false), _useState4 = _slicedToArray(_useState3, 2), removingValue = _useState4[0], setRemovingValue = _useState4[1];
  useEffect(function() {
    if (hasValue && !cssDisplayFlex) {
      setCssDisplayFlex(true);
    }
  }, [hasValue, cssDisplayFlex]);
  useEffect(function() {
    if (removingValue && !hasValue && cssDisplayFlex) {
      setCssDisplayFlex(false);
    }
    setRemovingValue(false);
  }, [removingValue, hasValue, cssDisplayFlex]);
  var onExited = function onExited2() {
    return setRemovingValue(true);
  };
  var childMapper = function childMapper2(child) {
    if (isMulti && /* @__PURE__ */ React.isValidElement(child)) {
      if (child.type === components2.MultiValue) {
        return /* @__PURE__ */ React.cloneElement(child, {
          onExited
        });
      }
      if (child.type === components2.Placeholder && cssDisplayFlex) {
        return null;
      }
    }
    return child;
  };
  var newInnerProps = _objectSpread2(_objectSpread2({}, innerProps), {}, {
    style: _objectSpread2(_objectSpread2({}, innerProps === null || innerProps === void 0 ? void 0 : innerProps.style), {}, {
      display: isMulti && hasValue || cssDisplayFlex ? "flex" : "grid"
    })
  });
  var newProps = _objectSpread2(_objectSpread2({}, props), {}, {
    innerProps: newInnerProps,
    children: React.Children.toArray(children).map(childMapper)
  });
  return newProps;
};
var AnimatedValueContainer$1 = AnimatedValueContainer;
var _excluded = ["Input", "MultiValue", "Placeholder", "SingleValue", "ValueContainer"];
var makeAnimated = function makeAnimated2() {
  var externalComponents = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  var components2 = defaultComponents({
    components: externalComponents
  });
  var Input3 = components2.Input, MultiValue3 = components2.MultiValue, Placeholder3 = components2.Placeholder, SingleValue3 = components2.SingleValue, ValueContainer3 = components2.ValueContainer, rest = _objectWithoutProperties(components2, _excluded);
  return _objectSpread2({
    Input: AnimatedInput$1(Input3),
    MultiValue: AnimatedMultiValue$1(MultiValue3),
    Placeholder: AnimatedPlaceholder$1(Placeholder3),
    SingleValue: AnimatedSingleValue$1(SingleValue3),
    ValueContainer: AnimatedValueContainer$1(ValueContainer3)
  }, rest);
};
var AnimatedComponents = makeAnimated();
AnimatedComponents.Input;
AnimatedComponents.MultiValue;
AnimatedComponents.Placeholder;
AnimatedComponents.SingleValue;
AnimatedComponents.ValueContainer;
var index$1 = memoizeOne(makeAnimated);
const animatedComponents = index$1();
const SelectInput = ({
  name,
  placeholder,
  label,
  value,
  isLoading = false,
  onBlur,
  typeClass = "default",
  options: options2,
  onChange: onChange2,
  error,
  isMulti = false,
  disabled = false
}) => {
  const CorrectedTypeClass = error ? classType$3.error : classType$3[typeClass];
  return /* @__PURE__ */ React__default.createElement("div", { className: box$2 }, /* @__PURE__ */ React__default.createElement("div", { className: frameWrapper$2 }, /* @__PURE__ */ React__default.createElement("div", { className: classNames$1(frame$2, CorrectedTypeClass) }, /* @__PURE__ */ React__default.createElement("div", { className: textWrapper$2 }, label), /* @__PURE__ */ React__default.createElement(
    StateManagedSelect$1,
    {
      name,
      onChange: onChange2,
      options: options2,
      value,
      onBlur,
      isMulti,
      classNames: {
        control: () => classNames$1(inputBox$2, disabled && disabledInput),
        container: () => box$2,
        valueContainer: () => valueContainer,
        option: ({ isDisabled, isFocused, isSelected }) => classNames$1(
          isDisabled && disabledOption,
          isSelected && selectedOption,
          isFocused && focusedOption,
          option
        ),
        indicatorSeparator: () => indicatorDisplayNone,
        menu: () => defaultText,
        menuPortal: () => menuPortal,
        singleValue: () => SingleValue$2,
        multiValue: () => multiValue,
        multiValueLabel: () => multiValueText,
        multiValueRemove: () => multiValueDel,
        placeholder: () => disabled ? disabledplaceholderText : placeholderText
      },
      menuPortalTarget: document.body,
      menuPosition: "fixed",
      components: animatedComponents,
      isLoading,
      placeholder,
      isDisabled: disabled
    }
  )), error && /* @__PURE__ */ React__default.createElement("span", { className: inputError$2 }, error)));
};
var cardOperationContainer = "qvzhog0";
var cardOperationIcon = "qvzhog1";
var cardOperationLabels = "qvzhog2";
var cardOperationName = "qvzhog3";
var cardOperationCategory = "qvzhog4";
var cardOperationAmount = "qvzhog5";
var cardOperationPositiveAmout = "qvzhog6";
const montantFormatUtil = (iso, montant, devise, lang = "fr") => {
  const canFormat = montant && devise;
  if (canFormat)
    try {
      return new Intl.NumberFormat(lang, { style: "currency", currency: devise }).formatToParts(montant).map(({ type: type2, value }) => {
        if (type2 != "currency")
          return value;
        if (iso) {
          return devise;
        }
        return value;
      }).reduce((string, part) => string + part).replace(",", ".");
    } catch (e2) {
      if (lang.startsWith("fr")) {
        return montant.toFixed(2) + " " + devise;
      } else {
        return devise + " " + montant.toFixed(2);
      }
    }
  return "";
};
const CardOperation = ({ icon: icon2, name, category, amount, currency }) => {
  let displayAmount = montantFormatUtil(false, amount, currency, "fr");
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("div", { className: cardOperationContainer }, icon2 && /* @__PURE__ */ React__default.createElement("div", { className: cardOperationIcon }, /* @__PURE__ */ React__default.createElement(Icon$2, { icon: icon2, size: 15 })), /* @__PURE__ */ React__default.createElement("div", { className: cardOperationLabels }, /* @__PURE__ */ React__default.createElement("span", { className: cardOperationName }, name), /* @__PURE__ */ React__default.createElement("span", { className: cardOperationCategory }, category)), /* @__PURE__ */ React__default.createElement("div", { className: amount >= 0 ? cardOperationPositiveAmout : "" }, /* @__PURE__ */ React__default.createElement("span", { className: cardOperationAmount }, displayAmount))));
};
const encours = "data:image/png;base64,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";
const notif = "data:image/svg+xml,%3csvg%20width='64'%20height='76'%20viewBox='0%200%2064%2076'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20id='Group%2022'%3e%3cpath%20id='Vector'%20d='M4.96093%2069.3906L4.6875%2071.7353L13.1484%2073.9611L13.552%2070.5006L4.96093%2069.3906Z'%20fill='%239E616A'/%3e%3cpath%20id='Vector_2'%20d='M6.57676%2068.8204L6.35239%2072.5936L4.82782%2072.3966L2.07611%2075.6559C1.94023%2075.8169%201.75901%2075.928%201.55891%2075.9729C1.35882%2076.0178%201.15033%2075.9942%200.963876%2075.9055C0.777426%2075.8169%200.622783%2075.6678%200.522522%2075.48C0.422261%2075.2923%200.381632%2075.0758%200.406568%2074.862L0.926542%2070.4025L2.5242%2069.8287L1.05116%2069.3337L1.24721%2067.6523L6.57676%2068.8204Z'%20fill='%232F2E41'/%3e%3cpath%20id='Vector_3'%20d='M29.6787%2070.544L31.8562%2071.1152L34.9856%2062.5463L31.7718%2061.7031L29.6787%2070.544Z'%20fill='%239E616A'/%3e%3cpath%20id='Vector_4'%20d='M35.2373%2074.3244L32.4994%2071.0522L32.8712%2069.4829L32.4837%2069.4066H32.4813L30.0621%2068.9314L29.3402%2068.7891L27.5898%2074.2151L29.1519%2074.6256L29.7978%2073.1464L30.0682%2074.5048L30.1442%2074.8848L34.286%2075.9713C34.4844%2076.0233%2034.6935%2076.0073%2034.8826%2075.9254C35.0717%2075.8436%2035.2311%2075.7002%2035.3373%2075.5163C35.4436%2075.3323%2035.4912%2075.1175%2035.4732%2074.903C35.4552%2074.6886%2035.3725%2074.4859%2035.2373%2074.3244Z'%20fill='%232F2E41'/%3e%3cpath%20id='Vector_5'%20d='M11.4088%2069.6543L12.1983%2069.5234C11.3509%2070.4523%2010.5372%2071.0661%209.76465%2071.2567L10.1389%2069.864L11.4088%2069.6543Z'%20fill='%232F2E41'/%3e%3cpath%20id='Vector_6'%20d='M34.4705%2065.4707C33.7232%2067.2294%2033.1848%2068.3553%2033.1848%2068.3553L32.9181%2068.2079L32.2155%2067.8203L30.5423%2066.8965L30.255%2066.7377L30.3371%2065.0577L30.7017%2057.629L30.8562%2054.4979L24.4787%2058.0458L16.9327%2062.2443C16.6237%2062.8111%2016.3166%2063.3626%2016.0116%2063.8988L10.8848%2060.1972L16.0877%2052.2055L19.1201%2050.7137L18.4658%2050.5803C18.6331%2050.3258%2018.8222%2050.088%2019.0308%2049.8699L19.2601%2049.7339C19.2601%2049.7339%2033.6894%2041.3674%2037.8409%2045.6574C38.199%2046.0411%2038.4676%2046.5069%2038.6256%2047.0184C40.0488%2051.3211%2036.4937%2060.7131%2034.4705%2065.4707Z'%20fill='%232F2E41'/%3e%3cpath%20id='Vector_7'%20d='M31.2952%2073.3402C30.9843%2073.8293%2030.5623%2074.229%2030.0675%2074.5029C29.6482%2074.7442%2029.2044%2074.9348%2028.7444%2075.0709C22.6265%2076.9529%209.23771%2073.2131%209.23771%2073.2131L9.76403%2071.2549L10.1383%2069.8622L11.4082%2069.6525L12.1977%2069.5216L21.6402%2067.9624L19.0387%2066.0843L16.0111%2063.8986L10.8843%2060.1969L4.73979%2057.2882C-2.38253%2051.3158%203.5809%2044.619%203.5809%2044.619L7.56699%2041.6454L8.86107%2040.6797L16.8115%2044.9621L19.1196%2050.7134L19.8294%2052.481L24.4783%2058.0456L30.3367%2065.0575L30.3825%2065.1122C30.5519%2065.2475%2030.7113%2065.3962%2030.8594%2065.5569C30.9137%2065.6128%2030.9704%2065.6751%2031.0284%2065.7424C31.5549%2066.3421%2031.9588%2067.0493%2032.215%2067.8201C32.3815%2068.3284%2032.4719%2068.8608%2032.483%2069.3984C32.4836%2069.3993%2032.4839%2069.4004%2032.4839%2069.4015C32.4839%2069.4027%2032.4836%2069.4038%2032.483%2069.4047C32.5096%2070.5242%2032.2042%2071.8445%2031.2952%2073.3402Z'%20fill='%232F2E41'/%3e%3cpath%20id='Vector_8'%20d='M0.856431%2047.4457C0.539372%2047.3449%200.378048%2047.2222%200.348559%2047.0597C0.305318%2046.8212%200.560077%2046.6086%200.855075%2046.3622C1.06078%2046.1905%201.6035%2045.8918%201.40512%2045.7998C-1.60287%2044.4057%205.71012%2024.6129%207.83211%2022.3638C8.26326%2021.9068%208.21187%2020.9791%208.78653%2020.1537C10.3561%2017.8996%2011.7333%2017.4911%2014.4766%2016.6777C14.6993%2016.6117%2014.9313%2016.5425%2015.1727%2016.4702C15.4849%2016.3764%2015.1557%2017.3101%2015.3185%2016.6841C15.4994%2015.9884%2015.6864%2015.2689%2016.1356%2014.9248L16.1649%2014.9023L16.201%2014.9048C17.0323%2014.9627%2019.7464%2015.4423%2021.1385%2016.4769L21.1577%2016.4914L21.1689%2016.5131C21.4255%2017.017%2021.244%2017.7773%2021.0685%2018.5125C20.9243%2019.1161%2021.2711%2018.1612%2021.4091%2018.4714C22.4641%2020.8428%2024.2782%2021.3796%2024.2966%2021.385L24.3867%2021.4107L24.3687%2021.5071C24.8429%2024.0953%2021.5904%2032.114%2020.8873%2037.5136C20.1729%2042.9993%2024.2453%2049.1777%2018.2608%2048.1391C18.2745%2048.1868%2020.4695%2052.9301%2020.4337%2052.9679C19.8896%2053.5415%202.05146%2047.8255%200.856431%2047.4457Z'%20fill='%23E6E6E6'/%3e%3cpath%20id='Vector_9'%20d='M40.4518%2018.3453C40.4951%2018.6046%2040.4838%2018.8708%2040.4187%2019.125C40.3537%2019.3793%2040.2364%2019.6154%2040.0753%2019.8168C39.9142%2020.0182%2039.7131%2020.1799%2039.4861%2020.2907C39.2592%2020.4014%2039.012%2020.4584%2038.7618%2020.4576L36.7525%2026.4983L34.8379%2023.8527L37.0395%2018.5219C37.0685%2018.0797%2037.2507%2017.664%2037.5514%2017.3537C37.8521%2017.0433%2038.2505%2016.8599%2038.6711%2016.8381C39.0918%2016.8164%2039.5053%2016.9578%2039.8335%2017.2355C40.1617%2017.5133%2040.3817%2017.9082%2040.4518%2018.3453Z'%20fill='%239E616A'/%3e%3cpath%20id='Vector_10'%20d='M31.609%2035.1756L27.9669%2034.3466C21.3977%2032.157%2019.1452%2029.4547%2018.4108%2027.5729C17.6272%2025.5651%2018.3413%2024.0955%2018.3722%2024.0341L18.3908%2024.0076L20.7469%2021.594C21.0462%2021.2875%2021.404%2021.0514%2021.7965%2020.9014C22.189%2020.7514%2022.6074%2020.691%2023.0238%2020.7241C23.4402%2020.7572%2023.8452%2020.8831%2024.2118%2021.0935C24.5785%2021.3038%2024.8985%2021.5938%2025.1506%2021.9443L29.9351%2028.5943L32.1505%2025.4347L33.2251%2024.5296L33.8048%2022.8192L36.0279%2020.2734L38.6018%2021.5271L37.6327%2027.683L36.3361%2028.5176L36.2749%2029.4239L36.2536%2029.4504L31.609%2035.1756Z'%20fill='%23E6E6E6'/%3e%3cpath%20id='Vector_11'%20d='M13.3612%2054.4703C13.3432%2054.4703%2013.3252%2054.47%2013.3071%2054.4692C13.0955%2054.4611%2012.8889%2054.3994%2012.7048%2054.2892C12.5208%2054.179%2012.3647%2054.0236%2012.25%2053.8363C11.3904%2052.484%2010.3356%2051.2811%209.12351%2050.2713C8.38978%2049.654%207.62303%2049.08%206.88161%2048.5248C4.96877%2047.0931%203.16738%2045.7447%202.16741%2043.8815C-0.0127997%2039.8187%202.55473%2034.1598%206.22267%2031.622C10.3368%2028.7757%2015.7482%2028.3293%2020.9832%2028.2708C21.5273%2028.2647%2022.0716%2028.2617%2022.6163%2028.2617C32.0486%2028.2655%2041.4611%2029.1715%2050.7377%2030.9684C53.8223%2031.5675%2057.0512%2032.3014%2059.6459%2034.0824C62.2252%2035.8529%2063.7929%2038.6409%2063.64%2041.1856C63.4167%2044.9003%2059.6758%2047.6759%2056.2694%2048.4016C53.0226%2049.0927%2049.6496%2048.6257%2046.0788%2048.1311C45.2904%2048.022%2044.4754%2047.909%2043.6693%2047.8109C34.9094%2046.7451%2018.4532%2050.0303%2017.757%2050.1707L17.0663%2050.3099L14.3863%2053.9403C14.2657%2054.1058%2014.1105%2054.2397%2013.9327%2054.3317C13.7549%2054.4236%2013.5593%2054.4711%2013.3612%2054.4703Z'%20fill='%2331859D'/%3e%3cpath%20id='Vector_12'%20d='M52.3701%2036.3484H15.3446C15.1312%2036.3481%2014.9265%2036.2586%2014.7756%2036.0996C14.6248%2035.9406%2014.54%2035.7251%2014.54%2035.5004C14.54%2035.2756%2014.6248%2035.0601%2014.7756%2034.9011C14.9265%2034.7421%2015.1312%2034.6526%2015.3446%2034.6523H52.3701C52.5835%2034.6526%2052.7882%2034.7421%2052.9391%2034.9011C53.0899%2035.0601%2053.1747%2035.2756%2053.1747%2035.5004C53.1747%2035.7251%2053.0899%2035.9406%2052.9391%2036.0996C52.7882%2036.2586%2052.5835%2036.3481%2052.3701%2036.3484Z'%20fill='white'/%3e%3cpath%20id='Vector_13'%20d='M52.3704%2041.5515H15.345C15.2392%2041.5517%2015.1344%2041.5299%2015.0365%2041.4874C14.9387%2041.445%2014.8498%2041.3826%2014.7748%2041.3039C14.6999%2041.2253%2014.6404%2041.1318%2014.5998%2041.0289C14.5592%2040.9261%2014.5382%2040.8158%2014.5381%2040.7044C14.538%2040.593%2014.5587%2040.4826%2014.5991%2040.3797C14.6395%2040.2767%2014.6988%2040.1831%2014.7736%2040.1043C14.8484%2040.0254%2014.9372%2039.9629%2015.035%2039.9202C15.1327%2039.8775%2015.2375%2039.8555%2015.3433%2039.8555H52.3704C52.5839%2039.8557%2052.7886%2039.9452%2052.9394%2040.1042C53.0903%2040.2632%2053.175%2040.4788%2053.175%2040.7035C53.175%2040.9282%2053.0903%2041.1437%2052.9394%2041.3027C52.7886%2041.4617%2052.5839%2041.5512%2052.3704%2041.5515Z'%20fill='white'/%3e%3cpath%20id='Vector_14'%20d='M19.6594%2046.7585H15.3446C15.1312%2046.7582%2014.9265%2046.6688%2014.7756%2046.5098C14.6248%2046.3508%2014.54%2046.1352%2014.54%2045.9105C14.54%2045.6858%2014.6248%2045.4702%2014.7756%2045.3112C14.9265%2045.1522%2015.1312%2045.0628%2015.3446%2045.0625H19.6594C19.8729%2045.0628%2020.0775%2045.1522%2020.2284%2045.3112C20.3793%2045.4702%2020.464%2045.6858%2020.464%2045.9105C20.464%2046.1352%2020.3793%2046.3508%2020.2284%2046.5098C20.0775%2046.6688%2019.8729%2046.7582%2019.6594%2046.7585Z'%20fill='white'/%3e%3cpath%20id='Vector_15'%20d='M12.1583%2042.8536C11.9115%2042.8106%2011.6767%2042.7112%2011.4704%2042.5624C11.2641%2042.4135%2011.0912%2042.2189%2010.9641%2041.9921C10.837%2041.7653%2010.7586%2041.512%2010.7346%2041.2499C10.7105%2040.9878%2010.7413%2040.7234%2010.8249%2040.4752L6.07617%2036.4782L9.08192%2035.4531L13.1306%2039.4059C13.5173%2039.5813%2013.8296%2039.8999%2014.0081%2040.3014C14.1866%2040.7029%2014.219%2041.1594%2014.0992%2041.5843C13.9793%2042.0093%2013.7156%2042.3732%2013.3579%2042.6072C13.0001%2042.8411%2012.5733%2042.9288%2012.1583%2042.8536Z'%20fill='%239E616A'/%3e%3cpath%20id='Vector_16'%20d='M0%2028.4955L1.9497%2025.1529C6.0888%2019.3538%209.25717%2018.0119%2011.1872%2017.906C13.2465%2017.7929%2014.3271%2018.989%2014.3719%2019.0401L14.3895%2019.0674L15.7722%2022.2071C15.9479%2022.6059%2016.0409%2023.0395%2016.0453%2023.479C16.0497%2023.9186%2015.9653%2024.3541%2015.7976%2024.7567C15.63%2025.1593%2015.3829%2025.5198%2015.0729%2025.8143C14.7629%2026.1088%2014.3969%2026.3305%2013.9993%2026.4648L6.45356%2029.0135L8.55153%2032.2607L9.00679%2033.6279L10.3478%2034.7703L11.8931%2037.8218L9.91659%2039.9628L4.72001%2036.9607L4.40152%2035.3964L3.60948%2035.0354L3.59281%2035.0055L0%2028.4955Z'%20fill='%23E6E6E6'/%3e%3cpath%20id='Path%209'%20d='M26.8483%2015.2522L26.8532%2015.2526C27.114%2015.2763%2027.3731%2015.19%2027.5734%2015.0126C27.7738%2014.8353%2027.899%2014.5814%2027.9215%2014.3068L28.3989%208.53017C28.4854%207.49531%2028.3734%206.45271%2028.0694%205.46435C27.4737%203.53537%2026.1937%201.9228%2024.4964%200.962705C23.62%200.468287%2022.6575%200.165785%2021.6671%200.0734271C17.615%20-0.304415%2016.1407%200.593728%2013.6802%207.11256C11.2197%2013.6314%2013.2021%2012.898%2013.2021%2012.898C13.1904%2013.0372%2013.2055%2013.1775%2013.2465%2013.3105C13.3268%2013.5698%2013.4993%2013.7865%2013.7278%2013.9152C13.8451%2013.981%2013.9738%2014.0214%2014.1062%2014.0339C18.9016%2015.2815%2023.7408%2016.5961%2026.8491%2015.2522L26.8483%2015.2522Z'%20fill='%232F2E41'/%3e%3cpath%20id='Ellipse%201'%20d='M17.8759%205.57018C17.2808%206.51036%2016.9638%207.61508%2016.9648%208.74481C16.9659%209.87454%2017.2849%2010.9786%2017.8817%2011.9176C18.4785%2012.8566%2019.3262%2013.5883%2020.3178%2014.0204C21.3094%2014.4525%2022.4004%2014.5656%2023.4531%2014.3454C24.1499%2014.202%2024.8128%2013.9145%2025.4033%2013.4995C25.9938%2013.0846%2026.5002%2012.5503%2026.8932%2011.9279C27.487%2010.988%2027.8031%209.88411%2027.8018%208.75538C27.8004%207.62665%2027.4816%206.52361%2026.8855%205.58534C26.2895%204.64706%2025.4429%203.91557%2024.4524%203.48309C23.462%203.05061%2022.3721%202.93649%2021.3201%203.15514C20.6227%203.29771%2019.9592%203.58462%2019.3679%203.99922C18.7767%204.41383%2018.2695%204.94787%2017.8759%205.57039L17.8759%205.57018Z'%20fill='%239E616A'/%3e%3cpath%20id='Path%2010'%20d='M30.1001%209.16146C30.1684%208.343%2030.0798%207.51843%2029.8394%206.73675C29.7727%204.82095%2029.2337%203.08903%2027.0139%203.17738C26.3251%202.78917%2025.5692%202.55077%2024.7911%202.47635L23.6932%202.36996C23.6809%202.36876%2023.6686%202.36759%2023.6562%202.36647C22.1201%202.22679%2020.5942%202.73518%2019.4142%203.7798C18.2342%204.82441%2017.4967%206.31968%2017.3641%207.93666L17.3545%208.05237L19.6772%208.27504L20.6621%206.01761L20.6276%208.36661L21.8272%208.48211L22.3239%207.34318L22.3067%208.52754C24.0972%2010.1654%2026.797%2010.233%2030.0895%209.27728L30.1001%209.16146Z'%20fill='%232F2E41'/%3e%3cpath%20id='Path%2013'%20d='M22.7095%2014.6889C22.7304%2014.8789%2022.7003%2015.0714%2022.6225%2015.2443C22.5833%2015.3329%2022.5325%2015.4152%2022.4716%2015.489C22.4195%2015.5518%2022.3605%2015.6079%2022.2959%2015.6561C22.1044%2015.7984%2021.8711%2015.8642%2021.6378%2015.8417C21.6233%2015.8403%2021.6087%2015.8385%2021.5943%2015.8364C21.5798%2015.8344%2021.5653%2015.832%2021.5509%2015.8292C21.5363%2015.8266%2021.5218%2015.8235%2021.5075%2015.8201C21.4931%2015.8166%2021.4787%2015.8128%2021.4642%2015.8088L20.6526%2015.5754L19.7278%2012.9169L19.5344%2015.2568L15.8438%2014.2028L16.6644%204.27344L22.9475%204.88086L22.7764%205.05661C22.2079%205.64683%2021.8051%206.3907%2021.6124%207.20636C21.4212%208.03287%2021.366%208.88776%2021.4491%209.73391C21.5272%2010.5895%2021.6831%2011.4353%2021.9147%2012.2596C22.1165%2012.9895%2022.358%2013.7065%2022.638%2014.4072C22.6743%2014.4971%2022.6983%2014.5919%2022.7095%2014.6889Z'%20fill='%232F2E41'/%3e%3c/g%3e%3c/svg%3e";
const image = {
  "encours": encours,
  "notif": notif
};
var positive = "iqiu410";
var negative = "iqiu411";
var information = "iqiu412";
var rectangle = "iqiu413";
var IconSize = "iqiu414";
var imageItem = "iqiu415";
var message = "iqiu416";
var contentMessage = "iqiu417";
var informationMessageContainer = "iqiu418";
const messageType = {
  "positive": positive,
  "negative": negative,
  "information": information
};
const InformationMessage = ({ title: title2, content, logo, type: type2, icon: icon2 }) => {
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("div", { className: informationMessageContainer }, logo && /* @__PURE__ */ React__default.createElement("div", { className: IconSize }, /* @__PURE__ */ React__default.createElement("img", { src: image[logo], className: imageItem, alt: "" })), /* @__PURE__ */ React__default.createElement("div", { className: classNames$1(rectangle, messageType[type2]) }, /* @__PURE__ */ React__default.createElement("div", { className: message }, icon2 && /* @__PURE__ */ React__default.createElement("div", { className: informationMessageContainer }, /* @__PURE__ */ React__default.createElement(Icon$2, { icon: icon2, size: 30 })), /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("b", null, title2)), /* @__PURE__ */ React__default.createElement("div", { className: contentMessage }, content))))));
};
var CheckBoxWrapper = "uwu5750";
var CheckBoxLabel = "uwu5751";
const Checkbox = (props) => {
  const { name, label, indeterminate = false } = props;
  const cRef = useRef(null);
  useEffect(() => {
    cRef.current && (cRef.current.indeterminate = indeterminate);
  }, [cRef, indeterminate]);
  return /* @__PURE__ */ React__default.createElement("div", { className: CheckBoxWrapper }, /* @__PURE__ */ React__default.createElement("input", { type: "checkbox", id: name, ...props, ref: cRef }), /* @__PURE__ */ React__default.createElement("label", { className: `${CheckBoxLabel} `, htmlFor: name }, /* @__PURE__ */ React__default.createElement("span", null), label));
};
var PrimaryDarkerColor = "d7pru10";
var NoMarginY = "d7pru11";
var RadioBox = "d7pru12";
const Radio = (props) => {
  const inputProps = { ...props };
  return /* @__PURE__ */ React__default.createElement("div", { className: `${RadioBox} ${props.className}` }, /* @__PURE__ */ React__default.createElement(
    "input",
    {
      type: "radio",
      className: NoMarginY,
      ...inputProps
    }
  ), /* @__PURE__ */ React__default.createElement("label", { htmlFor: props.id, className: `${props.labelClassName} ${PrimaryDarkerColor}` }, /* @__PURE__ */ React__default.createElement("strong", null, props.label)));
};
var LineContainer = "o35d240";
var Line = "o35d241";
var GreyLine = "o35d242";
var TextItem = "o35d243";
var ColorLine = "o35d244";
var Circle$1 = "o35d245";
var Box20Px = "o35d246";
var AlignItemsCenter = "o35d247";
var Flex = "o35d248";
var GreyColorBackground = "o35d249";
var JustifyContentCenter = "o35d24a";
var MainColorBackground = "o35d24b";
var FormBackGround = "o35d24d";
var ProgressBox = "o35d24e";
var Margin3px = "o35d24f";
var Flex1 = "o35d24g";
const ProgressStep = ({
  number,
  title: title2,
  isOver,
  isColored,
  steps: steps2,
  actualStep,
  icon: icon2 = "Valider2"
}) => {
  const coloredLineId = `coloredLine${number}`;
  useEffect(() => {
    const coloredLine = document.getElementById(coloredLineId);
    if (!isOver) {
      if (actualStep >= 0) {
        const percent = actualStep / steps2 * 100;
        const newWidth = `${percent}%`;
        if (newWidth) {
          coloredLine.style.width = newWidth;
        }
      } else {
        coloredLine.style.width = "0%";
      }
    } else {
      coloredLine.style.width = "100%";
    }
  }, [actualStep]);
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("div", { className: `${Flex} ${AlignItemsCenter}` }, /* @__PURE__ */ React__default.createElement(
    "div",
    {
      className: `${Circle$1}  ${isColored ? MainColorBackground : GreyColorBackground}`
    },
    isOver ? /* @__PURE__ */ React__default.createElement(Icon$2, { icon: icon2, size: 20 }) : /* @__PURE__ */ React__default.createElement(
      "div",
      {
        className: `${Box20Px} ${Flex} ${AlignItemsCenter} ${JustifyContentCenter} ${Margin3px}`
      },
      number
    )
  ), /* @__PURE__ */ React__default.createElement("div", { className: LineContainer }, /* @__PURE__ */ React__default.createElement("div", { className: `${Line} ${GreyLine}` }), /* @__PURE__ */ React__default.createElement("div", { id: coloredLineId, className: `${Line} ${ColorLine}` }))), /* @__PURE__ */ React__default.createElement("h3", { className: TextItem }, title2));
};
const ProgressBar$1 = (data2) => {
  const { progressionData, progressionState } = data2;
  return /* @__PURE__ */ React__default.createElement("div", { className: `${ProgressBox} ${FormBackGround}` }, progressionData.map((category) => {
    const { number, title: title2, startStep, endStep } = category;
    return /* @__PURE__ */ React__default.createElement("div", { className: Flex1, key: number + title2 }, /* @__PURE__ */ React__default.createElement(
      ProgressStep,
      {
        number,
        title: title2,
        isOver: progressionState >= endStep,
        isColored: progressionState >= startStep,
        steps: endStep - startStep,
        actualStep: progressionState - startStep
      }
    ));
  }));
};
var CarouselWrapper = "gntzdt0";
var CarouselInner = "gntzdt1";
var CarouselItem = "gntzdt2";
var InactiveCarouselItem = "gntzdt3";
var FirstCarouselItem = "gntzdt4";
var LastCarouselItem = "gntzdt5";
var DotsWrapper = "gntzdt6";
var Dot = "gntzdt7";
var ActiveDot = "gntzdt8";
const CarouselMenu = ({ children, onIndexChange, defaultItem = 0, className }) => {
  const [activeIndex, setActiveIndex] = useState(defaultItem);
  const handleIndexChange = (newIndex) => {
    setActiveIndex(newIndex);
    if (onIndexChange) {
      onIndexChange(newIndex);
    }
  };
  const handleNextItem = () => {
    if (activeIndex < Children.count(children) - 1) handleIndexChange(activeIndex + 1);
  };
  const handlePrevItem = () => {
    if (activeIndex > 0) handleIndexChange(activeIndex - 1);
  };
  const mouseStart = useRef(null);
  const [clickedItem, setClickedItem] = useState(-1);
  const handleMouseStart = (e2) => {
    e2.preventDefault();
    if (e2.button === 0) {
      mouseStart.current = e2.clientX;
    }
  };
  const handleMouseMove = (e2) => {
    if (e2.button === 0) {
      e2.preventDefault();
      if (mouseStart.current != null) {
        const delta = mouseStart.current - e2.clientX;
        if (delta > 100) {
          handleNextItem();
          mouseStart.current = e2.clientX;
          setClickedItem(-1);
        } else if (delta < -100) {
          handlePrevItem();
          mouseStart.current = e2.clientX;
          setClickedItem(-1);
        }
      }
    }
  };
  const handleMouseEnd = (e2) => {
    if (e2.button === 0) {
      mouseStart.current = null;
    }
  };
  const handleMouseLeave = () => {
    mouseStart.current = null;
  };
  const handleClickItem = (e2, index2) => {
    if (e2.button === 0) {
      setClickedItem(index2);
    }
  };
  const handleEndClickItem = (e2, index2) => {
    if (e2.button === 0 && index2 === clickedItem) {
      handleIndexChange(index2);
    }
    setClickedItem(-1);
  };
  const handleLeaveItem = () => {
    setClickedItem(-1);
  };
  const touchStart = useRef(null);
  const handleTouchStart = (e2) => {
    touchStart.current = e2.touches[0].clientX;
  };
  const handleTouchMove = (e2) => {
    if (touchStart.current !== null) {
      const delta = touchStart.current - e2.touches[0].clientX;
      if (delta > 100) {
        handleNextItem();
        touchStart.current = e2.touches[0].clientX;
      } else if (delta < -100) {
        handlePrevItem();
        touchStart.current = e2.touches[0].clientX;
      }
    }
  };
  const handleTouchEnd = () => {
    touchStart.current = null;
  };
  return /* @__PURE__ */ React__default.createElement(
    "div",
    {
      className: classNames$1(CarouselWrapper, className),
      onMouseDown: handleMouseStart,
      onMouseMove: handleMouseMove,
      onMouseUp: handleMouseEnd,
      onMouseLeave: handleMouseLeave,
      onTouchStart: handleTouchStart,
      onTouchMove: handleTouchMove,
      onTouchEnd: handleTouchEnd
    },
    /* @__PURE__ */ React__default.createElement(
      "div",
      {
        className: CarouselInner,
        style: { transform: `translateX(-${activeIndex * 50}%)` }
      },
      Children.map(children, (item, index2) => /* @__PURE__ */ React__default.createElement(
        "div",
        {
          key: index2,
          className: `${CarouselItem}
                    ${index2 === activeIndex ? "" : InactiveCarouselItem}
                    ${index2 === 0 ? FirstCarouselItem : ""}
                    ${index2 === Children.count(children) ? LastCarouselItem : ""}`,
          onMouseDown: (e2) => handleClickItem(e2, index2),
          onMouseUp: (e2) => handleEndClickItem(e2, index2),
          onMouseLeave: handleLeaveItem
        },
        item
      ))
    ),
    /* @__PURE__ */ React__default.createElement("div", { className: DotsWrapper }, Children.map(children, (_2, index2) => /* @__PURE__ */ React__default.createElement("span", { key: index2, onClick: () => handleIndexChange(index2), className: `${Dot} ${index2 === activeIndex ? ActiveDot : ""}` })))
  );
};
var Notes = "_3415sj0";
var HorizontalHistory = "_3415sj1";
var MainNoteList = "_3415sj2";
var TimelineEntry = "_3415sj4";
var TimelineEntryInner = "_3415sj5";
var TimelineContent = "_3415sj6";
var LeftDot = "_3415sj7";
const ActionsHistory = ({ actions = [], orientation = "vertical" }) => {
  return /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("ul", { className: classNames$1(Notes, orientation == "horizontal" ? HorizontalHistory : MainNoteList) }, actions.map((item) => {
    return /* @__PURE__ */ React__default.createElement("li", { key: item.id, className: TimelineEntry }, /* @__PURE__ */ React__default.createElement("div", { className: TimelineEntryInner }, /* @__PURE__ */ React__default.createElement("div", { className: LeftDot }), /* @__PURE__ */ React__default.createElement("div", { className: TimelineContent }, item.description)));
  })));
};
const $ea1ef594cf570d83$export$439d29a4e110a164 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  return /* @__PURE__ */ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.span, _extends$1({}, props, {
    ref: forwardedRef,
    style: {
      // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
      position: "absolute",
      border: 0,
      width: 1,
      height: 1,
      padding: 0,
      margin: -1,
      overflow: "hidden",
      clip: "rect(0, 0, 0, 0)",
      whiteSpace: "nowrap",
      wordWrap: "normal",
      ...props.style
    }
  }));
});
const $ea1ef594cf570d83$export$be92b6f5f03c0fe9 = $ea1ef594cf570d83$export$439d29a4e110a164;
const $054eb8030ebde76e$var$PROVIDER_NAME = "ToastProvider";
const [$054eb8030ebde76e$var$Collection, $054eb8030ebde76e$var$useCollection, $054eb8030ebde76e$var$createCollectionScope] = $e02a7d9cb1dc128c$export$c74125a8e3af6bb2("Toast");
const [$054eb8030ebde76e$var$createToastContext, $054eb8030ebde76e$export$8a359da18fbc9073] = $c512c27ab02ef895$export$50c7b4e9d9f19c1("Toast", [
  $054eb8030ebde76e$var$createCollectionScope
]);
const [$054eb8030ebde76e$var$ToastProviderProvider, $054eb8030ebde76e$var$useToastProviderContext] = $054eb8030ebde76e$var$createToastContext($054eb8030ebde76e$var$PROVIDER_NAME);
const $054eb8030ebde76e$export$f5d03d415824e0e = (props) => {
  const { __scopeToast, label = "Notification", duration = 5e3, swipeDirection = "right", swipeThreshold = 50, children } = props;
  const [viewport, setViewport] = useState(null);
  const [toastCount, setToastCount] = useState(0);
  const isFocusedToastEscapeKeyDownRef = useRef(false);
  const isClosePausedRef = useRef(false);
  return /* @__PURE__ */ createElement($054eb8030ebde76e$var$Collection.Provider, {
    scope: __scopeToast
  }, /* @__PURE__ */ createElement($054eb8030ebde76e$var$ToastProviderProvider, {
    scope: __scopeToast,
    label,
    duration,
    swipeDirection,
    swipeThreshold,
    toastCount,
    viewport,
    onViewportChange: setViewport,
    onToastAdd: useCallback(
      () => setToastCount(
        (prevCount) => prevCount + 1
      ),
      []
    ),
    onToastRemove: useCallback(
      () => setToastCount(
        (prevCount) => prevCount - 1
      ),
      []
    ),
    isFocusedToastEscapeKeyDownRef,
    isClosePausedRef
  }, children));
};
$054eb8030ebde76e$export$f5d03d415824e0e.propTypes = {
  label(props) {
    if (props.label && typeof props.label === "string" && !props.label.trim()) {
      const error = `Invalid prop \`label\` supplied to \`${$054eb8030ebde76e$var$PROVIDER_NAME}\`. Expected non-empty \`string\`.`;
      return new Error(error);
    }
    return null;
  }
};
const $054eb8030ebde76e$var$VIEWPORT_NAME = "ToastViewport";
const $054eb8030ebde76e$var$VIEWPORT_DEFAULT_HOTKEY = [
  "F8"
];
const $054eb8030ebde76e$var$VIEWPORT_PAUSE = "toast.viewportPause";
const $054eb8030ebde76e$var$VIEWPORT_RESUME = "toast.viewportResume";
const $054eb8030ebde76e$export$6192c2425ecfd989 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeToast, hotkey = $054eb8030ebde76e$var$VIEWPORT_DEFAULT_HOTKEY, label = "Notifications ({hotkey})", ...viewportProps } = props;
  const context = $054eb8030ebde76e$var$useToastProviderContext($054eb8030ebde76e$var$VIEWPORT_NAME, __scopeToast);
  const getItems = $054eb8030ebde76e$var$useCollection(__scopeToast);
  const wrapperRef = useRef(null);
  const headFocusProxyRef = useRef(null);
  const tailFocusProxyRef = useRef(null);
  const ref = useRef(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, ref, context.onViewportChange);
  const hotkeyLabel = hotkey.join("+").replace(/Key/g, "").replace(/Digit/g, "");
  const hasToasts = context.toastCount > 0;
  useEffect(() => {
    const handleKeyDown = (event) => {
      var _ref$current;
      const isHotkeyPressed = hotkey.every(
        (key) => event[key] || event.code === key
      );
      if (isHotkeyPressed) (_ref$current = ref.current) === null || _ref$current === void 0 || _ref$current.focus();
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [
    hotkey
  ]);
  useEffect(() => {
    const wrapper2 = wrapperRef.current;
    const viewport = ref.current;
    if (hasToasts && wrapper2 && viewport) {
      const handlePause = () => {
        if (!context.isClosePausedRef.current) {
          const pauseEvent = new CustomEvent($054eb8030ebde76e$var$VIEWPORT_PAUSE);
          viewport.dispatchEvent(pauseEvent);
          context.isClosePausedRef.current = true;
        }
      };
      const handleResume = () => {
        if (context.isClosePausedRef.current) {
          const resumeEvent = new CustomEvent($054eb8030ebde76e$var$VIEWPORT_RESUME);
          viewport.dispatchEvent(resumeEvent);
          context.isClosePausedRef.current = false;
        }
      };
      const handleFocusOutResume = (event) => {
        const isFocusMovingOutside = !wrapper2.contains(event.relatedTarget);
        if (isFocusMovingOutside) handleResume();
      };
      const handlePointerLeaveResume = () => {
        const isFocusInside = wrapper2.contains(document.activeElement);
        if (!isFocusInside) handleResume();
      };
      wrapper2.addEventListener("focusin", handlePause);
      wrapper2.addEventListener("focusout", handleFocusOutResume);
      wrapper2.addEventListener("pointermove", handlePause);
      wrapper2.addEventListener("pointerleave", handlePointerLeaveResume);
      window.addEventListener("blur", handlePause);
      window.addEventListener("focus", handleResume);
      return () => {
        wrapper2.removeEventListener("focusin", handlePause);
        wrapper2.removeEventListener("focusout", handleFocusOutResume);
        wrapper2.removeEventListener("pointermove", handlePause);
        wrapper2.removeEventListener("pointerleave", handlePointerLeaveResume);
        window.removeEventListener("blur", handlePause);
        window.removeEventListener("focus", handleResume);
      };
    }
  }, [
    hasToasts,
    context.isClosePausedRef
  ]);
  const getSortedTabbableCandidates = useCallback(({ tabbingDirection }) => {
    const toastItems = getItems();
    const tabbableCandidates = toastItems.map((toastItem) => {
      const toastNode = toastItem.ref.current;
      const toastTabbableCandidates = [
        toastNode,
        ...$054eb8030ebde76e$var$getTabbableCandidates(toastNode)
      ];
      return tabbingDirection === "forwards" ? toastTabbableCandidates : toastTabbableCandidates.reverse();
    });
    return (tabbingDirection === "forwards" ? tabbableCandidates.reverse() : tabbableCandidates).flat();
  }, [
    getItems
  ]);
  useEffect(() => {
    const viewport = ref.current;
    if (viewport) {
      const handleKeyDown = (event) => {
        const isMetaKey = event.altKey || event.ctrlKey || event.metaKey;
        const isTabKey = event.key === "Tab" && !isMetaKey;
        if (isTabKey) {
          const focusedElement = document.activeElement;
          const isTabbingBackwards = event.shiftKey;
          const targetIsViewport = event.target === viewport;
          if (targetIsViewport && isTabbingBackwards) {
            var _headFocusProxyRef$cu;
            (_headFocusProxyRef$cu = headFocusProxyRef.current) === null || _headFocusProxyRef$cu === void 0 || _headFocusProxyRef$cu.focus();
            return;
          }
          const tabbingDirection = isTabbingBackwards ? "backwards" : "forwards";
          const sortedCandidates = getSortedTabbableCandidates({
            tabbingDirection
          });
          const index2 = sortedCandidates.findIndex(
            (candidate) => candidate === focusedElement
          );
          if ($054eb8030ebde76e$var$focusFirst(sortedCandidates.slice(index2 + 1))) event.preventDefault();
          else {
            var _headFocusProxyRef$cu2, _tailFocusProxyRef$cu;
            isTabbingBackwards ? (_headFocusProxyRef$cu2 = headFocusProxyRef.current) === null || _headFocusProxyRef$cu2 === void 0 || _headFocusProxyRef$cu2.focus() : (_tailFocusProxyRef$cu = tailFocusProxyRef.current) === null || _tailFocusProxyRef$cu === void 0 || _tailFocusProxyRef$cu.focus();
          }
        }
      };
      viewport.addEventListener("keydown", handleKeyDown);
      return () => viewport.removeEventListener("keydown", handleKeyDown);
    }
  }, [
    getItems,
    getSortedTabbableCandidates
  ]);
  return /* @__PURE__ */ createElement($5cb92bef7577960e$export$aecb2ddcb55c95be, {
    ref: wrapperRef,
    role: "region",
    "aria-label": label.replace("{hotkey}", hotkeyLabel),
    tabIndex: -1,
    style: {
      pointerEvents: hasToasts ? void 0 : "none"
    }
  }, hasToasts && /* @__PURE__ */ createElement($054eb8030ebde76e$var$FocusProxy, {
    ref: headFocusProxyRef,
    onFocusFromOutsideViewport: () => {
      const tabbableCandidates = getSortedTabbableCandidates({
        tabbingDirection: "forwards"
      });
      $054eb8030ebde76e$var$focusFirst(tabbableCandidates);
    }
  }), /* @__PURE__ */ createElement($054eb8030ebde76e$var$Collection.Slot, {
    scope: __scopeToast
  }, /* @__PURE__ */ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.ol, _extends$1({
    tabIndex: -1
  }, viewportProps, {
    ref: composedRefs
  }))), hasToasts && /* @__PURE__ */ createElement($054eb8030ebde76e$var$FocusProxy, {
    ref: tailFocusProxyRef,
    onFocusFromOutsideViewport: () => {
      const tabbableCandidates = getSortedTabbableCandidates({
        tabbingDirection: "backwards"
      });
      $054eb8030ebde76e$var$focusFirst(tabbableCandidates);
    }
  }));
});
const $054eb8030ebde76e$var$FOCUS_PROXY_NAME = "ToastFocusProxy";
const $054eb8030ebde76e$var$FocusProxy = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeToast, onFocusFromOutsideViewport, ...proxyProps } = props;
  const context = $054eb8030ebde76e$var$useToastProviderContext($054eb8030ebde76e$var$FOCUS_PROXY_NAME, __scopeToast);
  return /* @__PURE__ */ createElement($ea1ef594cf570d83$export$439d29a4e110a164, _extends$1({
    "aria-hidden": true,
    tabIndex: 0
  }, proxyProps, {
    ref: forwardedRef,
    style: {
      position: "fixed"
    },
    onFocus: (event) => {
      var _context$viewport;
      const prevFocusedElement = event.relatedTarget;
      const isFocusFromOutsideViewport = !((_context$viewport = context.viewport) !== null && _context$viewport !== void 0 && _context$viewport.contains(prevFocusedElement));
      if (isFocusFromOutsideViewport) onFocusFromOutsideViewport();
    }
  }));
});
const $054eb8030ebde76e$var$TOAST_NAME = "Toast";
const $054eb8030ebde76e$var$TOAST_SWIPE_START = "toast.swipeStart";
const $054eb8030ebde76e$var$TOAST_SWIPE_MOVE = "toast.swipeMove";
const $054eb8030ebde76e$var$TOAST_SWIPE_CANCEL = "toast.swipeCancel";
const $054eb8030ebde76e$var$TOAST_SWIPE_END = "toast.swipeEnd";
const $054eb8030ebde76e$export$8d8dc7d5f743331b = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { forceMount, open: openProp, defaultOpen, onOpenChange, ...toastProps } = props;
  const [open = true, setOpen] = $71cd76cc60e0454e$export$6f32135080cb4c3({
    prop: openProp,
    defaultProp: defaultOpen,
    onChange: onOpenChange
  });
  return /* @__PURE__ */ createElement($921a889cee6df7e8$export$99c2b779aa4e8b8b, {
    present: forceMount || open
  }, /* @__PURE__ */ createElement($054eb8030ebde76e$var$ToastImpl, _extends$1({
    open
  }, toastProps, {
    ref: forwardedRef,
    onClose: () => setOpen(false),
    onPause: $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(props.onPause),
    onResume: $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(props.onResume),
    onSwipeStart: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onSwipeStart, (event) => {
      event.currentTarget.setAttribute("data-swipe", "start");
    }),
    onSwipeMove: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onSwipeMove, (event) => {
      const { x: x2, y: y2 } = event.detail.delta;
      event.currentTarget.setAttribute("data-swipe", "move");
      event.currentTarget.style.setProperty("--radix-toast-swipe-move-x", `${x2}px`);
      event.currentTarget.style.setProperty("--radix-toast-swipe-move-y", `${y2}px`);
    }),
    onSwipeCancel: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onSwipeCancel, (event) => {
      event.currentTarget.setAttribute("data-swipe", "cancel");
      event.currentTarget.style.removeProperty("--radix-toast-swipe-move-x");
      event.currentTarget.style.removeProperty("--radix-toast-swipe-move-y");
      event.currentTarget.style.removeProperty("--radix-toast-swipe-end-x");
      event.currentTarget.style.removeProperty("--radix-toast-swipe-end-y");
    }),
    onSwipeEnd: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onSwipeEnd, (event) => {
      const { x: x2, y: y2 } = event.detail.delta;
      event.currentTarget.setAttribute("data-swipe", "end");
      event.currentTarget.style.removeProperty("--radix-toast-swipe-move-x");
      event.currentTarget.style.removeProperty("--radix-toast-swipe-move-y");
      event.currentTarget.style.setProperty("--radix-toast-swipe-end-x", `${x2}px`);
      event.currentTarget.style.setProperty("--radix-toast-swipe-end-y", `${y2}px`);
      setOpen(false);
    })
  })));
});
const [$054eb8030ebde76e$var$ToastInteractiveProvider, $054eb8030ebde76e$var$useToastInteractiveContext] = $054eb8030ebde76e$var$createToastContext($054eb8030ebde76e$var$TOAST_NAME, {
  onClose() {
  }
});
const $054eb8030ebde76e$var$ToastImpl = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeToast, type: type2 = "foreground", duration: durationProp, open, onClose, onEscapeKeyDown, onPause, onResume, onSwipeStart, onSwipeMove, onSwipeCancel, onSwipeEnd, ...toastProps } = props;
  const context = $054eb8030ebde76e$var$useToastProviderContext($054eb8030ebde76e$var$TOAST_NAME, __scopeToast);
  const [node1, setNode] = useState(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(
    forwardedRef,
    (node2) => setNode(node2)
  );
  const pointerStartRef = useRef(null);
  const swipeDeltaRef = useRef(null);
  const duration1 = durationProp || context.duration;
  const closeTimerStartTimeRef = useRef(0);
  const closeTimerRemainingTimeRef = useRef(duration1);
  const closeTimerRef = useRef(0);
  const { onToastAdd, onToastRemove } = context;
  const handleClose = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(() => {
    var _context$viewport2;
    const isFocusInToast = node1 === null || node1 === void 0 ? void 0 : node1.contains(document.activeElement);
    if (isFocusInToast) (_context$viewport2 = context.viewport) === null || _context$viewport2 === void 0 || _context$viewport2.focus();
    onClose();
  });
  const startTimer = useCallback((duration) => {
    if (!duration || duration === Infinity) return;
    window.clearTimeout(closeTimerRef.current);
    closeTimerStartTimeRef.current = (/* @__PURE__ */ new Date()).getTime();
    closeTimerRef.current = window.setTimeout(handleClose, duration);
  }, [
    handleClose
  ]);
  useEffect(() => {
    const viewport = context.viewport;
    if (viewport) {
      const handleResume = () => {
        startTimer(closeTimerRemainingTimeRef.current);
        onResume === null || onResume === void 0 || onResume();
      };
      const handlePause = () => {
        const elapsedTime = (/* @__PURE__ */ new Date()).getTime() - closeTimerStartTimeRef.current;
        closeTimerRemainingTimeRef.current = closeTimerRemainingTimeRef.current - elapsedTime;
        window.clearTimeout(closeTimerRef.current);
        onPause === null || onPause === void 0 || onPause();
      };
      viewport.addEventListener($054eb8030ebde76e$var$VIEWPORT_PAUSE, handlePause);
      viewport.addEventListener($054eb8030ebde76e$var$VIEWPORT_RESUME, handleResume);
      return () => {
        viewport.removeEventListener($054eb8030ebde76e$var$VIEWPORT_PAUSE, handlePause);
        viewport.removeEventListener($054eb8030ebde76e$var$VIEWPORT_RESUME, handleResume);
      };
    }
  }, [
    context.viewport,
    duration1,
    onPause,
    onResume,
    startTimer
  ]);
  useEffect(() => {
    if (open && !context.isClosePausedRef.current) startTimer(duration1);
  }, [
    open,
    duration1,
    context.isClosePausedRef,
    startTimer
  ]);
  useEffect(() => {
    onToastAdd();
    return () => onToastRemove();
  }, [
    onToastAdd,
    onToastRemove
  ]);
  const announceTextContent = useMemo(() => {
    return node1 ? $054eb8030ebde76e$var$getAnnounceTextContent(node1) : null;
  }, [
    node1
  ]);
  if (!context.viewport) return null;
  return /* @__PURE__ */ createElement(Fragment, null, announceTextContent && /* @__PURE__ */ createElement($054eb8030ebde76e$var$ToastAnnounce, {
    __scopeToast,
    role: "status",
    "aria-live": type2 === "foreground" ? "assertive" : "polite",
    "aria-atomic": true
  }, announceTextContent), /* @__PURE__ */ createElement($054eb8030ebde76e$var$ToastInteractiveProvider, {
    scope: __scopeToast,
    onClose: handleClose
  }, /* @__PURE__ */ createPortal(/* @__PURE__ */ createElement($054eb8030ebde76e$var$Collection.ItemSlot, {
    scope: __scopeToast
  }, /* @__PURE__ */ createElement($5cb92bef7577960e$export$be92b6f5f03c0fe9, {
    asChild: true,
    onEscapeKeyDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(onEscapeKeyDown, () => {
      if (!context.isFocusedToastEscapeKeyDownRef.current) handleClose();
      context.isFocusedToastEscapeKeyDownRef.current = false;
    })
  }, /* @__PURE__ */ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.li, _extends$1({
    // Ensure toasts are announced as status list or status when focused
    role: "status",
    "aria-live": "off",
    "aria-atomic": true,
    tabIndex: 0,
    "data-state": open ? "open" : "closed",
    "data-swipe-direction": context.swipeDirection
  }, toastProps, {
    ref: composedRefs,
    style: {
      userSelect: "none",
      touchAction: "none",
      ...props.style
    },
    onKeyDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onKeyDown, (event) => {
      if (event.key !== "Escape") return;
      onEscapeKeyDown === null || onEscapeKeyDown === void 0 || onEscapeKeyDown(event.nativeEvent);
      if (!event.nativeEvent.defaultPrevented) {
        context.isFocusedToastEscapeKeyDownRef.current = true;
        handleClose();
      }
    }),
    onPointerDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerDown, (event) => {
      if (event.button !== 0) return;
      pointerStartRef.current = {
        x: event.clientX,
        y: event.clientY
      };
    }),
    onPointerMove: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerMove, (event) => {
      if (!pointerStartRef.current) return;
      const x2 = event.clientX - pointerStartRef.current.x;
      const y2 = event.clientY - pointerStartRef.current.y;
      const hasSwipeMoveStarted = Boolean(swipeDeltaRef.current);
      const isHorizontalSwipe = [
        "left",
        "right"
      ].includes(context.swipeDirection);
      const clamp2 = [
        "left",
        "up"
      ].includes(context.swipeDirection) ? Math.min : Math.max;
      const clampedX = isHorizontalSwipe ? clamp2(0, x2) : 0;
      const clampedY = !isHorizontalSwipe ? clamp2(0, y2) : 0;
      const moveStartBuffer = event.pointerType === "touch" ? 10 : 2;
      const delta = {
        x: clampedX,
        y: clampedY
      };
      const eventDetail = {
        originalEvent: event,
        delta
      };
      if (hasSwipeMoveStarted) {
        swipeDeltaRef.current = delta;
        $054eb8030ebde76e$var$handleAndDispatchCustomEvent($054eb8030ebde76e$var$TOAST_SWIPE_MOVE, onSwipeMove, eventDetail, {
          discrete: false
        });
      } else if ($054eb8030ebde76e$var$isDeltaInDirection(delta, context.swipeDirection, moveStartBuffer)) {
        swipeDeltaRef.current = delta;
        $054eb8030ebde76e$var$handleAndDispatchCustomEvent($054eb8030ebde76e$var$TOAST_SWIPE_START, onSwipeStart, eventDetail, {
          discrete: false
        });
        event.target.setPointerCapture(event.pointerId);
      } else if (Math.abs(x2) > moveStartBuffer || Math.abs(y2) > moveStartBuffer)
        pointerStartRef.current = null;
    }),
    onPointerUp: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerUp, (event1) => {
      const delta = swipeDeltaRef.current;
      const target = event1.target;
      if (target.hasPointerCapture(event1.pointerId)) target.releasePointerCapture(event1.pointerId);
      swipeDeltaRef.current = null;
      pointerStartRef.current = null;
      if (delta) {
        const toast = event1.currentTarget;
        const eventDetail = {
          originalEvent: event1,
          delta
        };
        if ($054eb8030ebde76e$var$isDeltaInDirection(delta, context.swipeDirection, context.swipeThreshold)) $054eb8030ebde76e$var$handleAndDispatchCustomEvent($054eb8030ebde76e$var$TOAST_SWIPE_END, onSwipeEnd, eventDetail, {
          discrete: true
        });
        else $054eb8030ebde76e$var$handleAndDispatchCustomEvent($054eb8030ebde76e$var$TOAST_SWIPE_CANCEL, onSwipeCancel, eventDetail, {
          discrete: true
        });
        toast.addEventListener(
          "click",
          (event) => event.preventDefault(),
          {
            once: true
          }
        );
      }
    })
  })))), context.viewport)));
});
$054eb8030ebde76e$var$ToastImpl.propTypes = {
  type(props) {
    if (props.type && ![
      "foreground",
      "background"
    ].includes(props.type)) {
      const error = `Invalid prop \`type\` supplied to \`${$054eb8030ebde76e$var$TOAST_NAME}\`. Expected \`foreground | background\`.`;
      return new Error(error);
    }
    return null;
  }
};
const $054eb8030ebde76e$var$ToastAnnounce = (props) => {
  const { __scopeToast, children, ...announceProps } = props;
  const context = $054eb8030ebde76e$var$useToastProviderContext($054eb8030ebde76e$var$TOAST_NAME, __scopeToast);
  const [renderAnnounceText, setRenderAnnounceText] = useState(false);
  const [isAnnounced, setIsAnnounced] = useState(false);
  $054eb8030ebde76e$var$useNextFrame(
    () => setRenderAnnounceText(true)
  );
  useEffect(() => {
    const timer = window.setTimeout(
      () => setIsAnnounced(true),
      1e3
    );
    return () => window.clearTimeout(timer);
  }, []);
  return isAnnounced ? null : /* @__PURE__ */ createElement($f1701beae083dbae$export$602eac185826482c, {
    asChild: true
  }, /* @__PURE__ */ createElement($ea1ef594cf570d83$export$439d29a4e110a164, announceProps, renderAnnounceText && /* @__PURE__ */ createElement(Fragment, null, context.label, " ", children)));
};
const $054eb8030ebde76e$export$16d42d7c29b95a4 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeToast, ...titleProps } = props;
  return /* @__PURE__ */ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.div, _extends$1({}, titleProps, {
    ref: forwardedRef
  }));
});
const $054eb8030ebde76e$export$ecddd96c53621d9a = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeToast, ...descriptionProps } = props;
  return /* @__PURE__ */ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.div, _extends$1({}, descriptionProps, {
    ref: forwardedRef
  }));
});
const $054eb8030ebde76e$var$ACTION_NAME = "ToastAction";
const $054eb8030ebde76e$export$3019feecfda683d2 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { altText, ...actionProps } = props;
  if (!altText) return null;
  return /* @__PURE__ */ createElement($054eb8030ebde76e$var$ToastAnnounceExclude, {
    altText,
    asChild: true
  }, /* @__PURE__ */ createElement($054eb8030ebde76e$export$811e70f61c205839, _extends$1({}, actionProps, {
    ref: forwardedRef
  })));
});
$054eb8030ebde76e$export$3019feecfda683d2.propTypes = {
  altText(props) {
    if (!props.altText) return new Error(`Missing prop \`altText\` expected on \`${$054eb8030ebde76e$var$ACTION_NAME}\``);
    return null;
  }
};
const $054eb8030ebde76e$var$CLOSE_NAME = "ToastClose";
const $054eb8030ebde76e$export$811e70f61c205839 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeToast, ...closeProps } = props;
  const interactiveContext = $054eb8030ebde76e$var$useToastInteractiveContext($054eb8030ebde76e$var$CLOSE_NAME, __scopeToast);
  return /* @__PURE__ */ createElement($054eb8030ebde76e$var$ToastAnnounceExclude, {
    asChild: true
  }, /* @__PURE__ */ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.button, _extends$1({
    type: "button"
  }, closeProps, {
    ref: forwardedRef,
    onClick: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onClick, interactiveContext.onClose)
  })));
});
const $054eb8030ebde76e$var$ToastAnnounceExclude = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeToast, altText, ...announceExcludeProps } = props;
  return /* @__PURE__ */ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.div, _extends$1({
    "data-radix-toast-announce-exclude": "",
    "data-radix-toast-announce-alt": altText || void 0
  }, announceExcludeProps, {
    ref: forwardedRef
  }));
});
function $054eb8030ebde76e$var$getAnnounceTextContent(container) {
  const textContent = [];
  const childNodes = Array.from(container.childNodes);
  childNodes.forEach((node2) => {
    if (node2.nodeType === node2.TEXT_NODE && node2.textContent) textContent.push(node2.textContent);
    if ($054eb8030ebde76e$var$isHTMLElement(node2)) {
      const isHidden = node2.ariaHidden || node2.hidden || node2.style.display === "none";
      const isExcluded = node2.dataset.radixToastAnnounceExclude === "";
      if (!isHidden) {
        if (isExcluded) {
          const altText = node2.dataset.radixToastAnnounceAlt;
          if (altText) textContent.push(altText);
        } else textContent.push(...$054eb8030ebde76e$var$getAnnounceTextContent(node2));
      }
    }
  });
  return textContent;
}
function $054eb8030ebde76e$var$handleAndDispatchCustomEvent(name, handler, detail, { discrete }) {
  const currentTarget = detail.originalEvent.currentTarget;
  const event = new CustomEvent(name, {
    bubbles: true,
    cancelable: true,
    detail
  });
  if (handler) currentTarget.addEventListener(name, handler, {
    once: true
  });
  if (discrete) $8927f6f2acc4f386$export$6d1a0317bde7de7f(currentTarget, event);
  else currentTarget.dispatchEvent(event);
}
const $054eb8030ebde76e$var$isDeltaInDirection = (delta, direction, threshold = 0) => {
  const deltaX = Math.abs(delta.x);
  const deltaY = Math.abs(delta.y);
  const isDeltaX = deltaX > deltaY;
  if (direction === "left" || direction === "right") return isDeltaX && deltaX > threshold;
  else return !isDeltaX && deltaY > threshold;
};
function $054eb8030ebde76e$var$useNextFrame(callback2 = () => {
}) {
  const fn = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(callback2);
  $9f79659886946c16$export$e5c5a5f917a5871c(() => {
    let raf1 = 0;
    let raf2 = 0;
    raf1 = window.requestAnimationFrame(
      () => raf2 = window.requestAnimationFrame(fn)
    );
    return () => {
      window.cancelAnimationFrame(raf1);
      window.cancelAnimationFrame(raf2);
    };
  }, [
    fn
  ]);
}
function $054eb8030ebde76e$var$isHTMLElement(node2) {
  return node2.nodeType === node2.ELEMENT_NODE;
}
function $054eb8030ebde76e$var$getTabbableCandidates(container) {
  const nodes = [];
  const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (node2) => {
      const isHiddenInput = node2.tagName === "INPUT" && node2.type === "hidden";
      if (node2.disabled || node2.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP;
      return node2.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  while (walker.nextNode()) nodes.push(walker.currentNode);
  return nodes;
}
function $054eb8030ebde76e$var$focusFirst(candidates) {
  const previouslyFocusedElement = document.activeElement;
  return candidates.some((candidate) => {
    if (candidate === previouslyFocusedElement) return true;
    candidate.focus();
    return document.activeElement !== previouslyFocusedElement;
  });
}
const $054eb8030ebde76e$export$2881499e37b75b9a = $054eb8030ebde76e$export$f5d03d415824e0e;
const $054eb8030ebde76e$export$d5c6c08dc2d3ca7 = $054eb8030ebde76e$export$6192c2425ecfd989;
const $054eb8030ebde76e$export$be92b6f5f03c0fe9 = $054eb8030ebde76e$export$8d8dc7d5f743331b;
const $054eb8030ebde76e$export$f99233281efd08a0 = $054eb8030ebde76e$export$16d42d7c29b95a4;
const $054eb8030ebde76e$export$393edc798c47379d = $054eb8030ebde76e$export$ecddd96c53621d9a;
const $054eb8030ebde76e$export$e19cd5f9376f8cee = $054eb8030ebde76e$export$3019feecfda683d2;
const $054eb8030ebde76e$export$f39c2d165cd861fe = $054eb8030ebde76e$export$811e70f61c205839;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var _excluded$1r = ["color"];
var Cross2Icon = /* @__PURE__ */ forwardRef(function(_ref3, forwardedRef) {
  var _ref$color = _ref3.color, color2 = _ref$color === void 0 ? "currentColor" : _ref$color, props = _objectWithoutPropertiesLoose(_ref3, _excluded$1r);
  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M11.7816 4.03157C12.0062 3.80702 12.0062 3.44295 11.7816 3.2184C11.5571 2.99385 11.193 2.99385 10.9685 3.2184L7.50005 6.68682L4.03164 3.2184C3.80708 2.99385 3.44301 2.99385 3.21846 3.2184C2.99391 3.44295 2.99391 3.80702 3.21846 4.03157L6.68688 7.49999L3.21846 10.9684C2.99391 11.193 2.99391 11.557 3.21846 11.7816C3.44301 12.0061 3.80708 12.0061 4.03164 11.7816L7.50005 8.31316L10.9685 11.7816C11.193 12.0061 11.5571 12.0061 11.7816 11.7816C12.0062 11.557 12.0062 11.193 11.7816 10.9684L8.31322 7.49999L11.7816 4.03157Z",
    fill: color2,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});
function getVarName(variable) {
  var matches = variable.match(/^var\((.*)\)$/);
  if (matches) {
    return matches[1];
  }
  return variable;
}
function get$1(obj, path) {
  var result = obj;
  for (var key of path) {
    if (!(key in result)) {
      throw new Error("Path ".concat(path.join(" -> "), " does not exist in object"));
    }
    result = result[key];
  }
  return result;
}
function walkObject(obj, fn) {
  var path = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
  var clone2 = {};
  for (var key in obj) {
    var _value = obj[key];
    var currentPath = [...path, key];
    if (typeof _value === "string" || typeof _value === "number" || _value == null) {
      clone2[key] = fn(_value, currentPath);
    } else if (typeof _value === "object" && !Array.isArray(_value)) {
      clone2[key] = walkObject(_value, fn, currentPath);
    } else {
      console.warn('Skipping invalid key "'.concat(currentPath.join("."), '". Should be a string, number, null or object. Received: "').concat(Array.isArray(_value) ? "Array" : typeof _value, '"'));
    }
  }
  return clone2;
}
function assignInlineVars(varsOrContract, tokens) {
  var styles = {};
  if (typeof tokens === "object") {
    var _contract = varsOrContract;
    walkObject(tokens, (value2, path) => {
      if (value2 == null) {
        return;
      }
      var varName2 = get$1(_contract, path);
      styles[getVarName(varName2)] = String(value2);
    });
  } else {
    var _vars = varsOrContract;
    for (var varName in _vars) {
      var value = _vars[varName];
      if (value == null) {
        continue;
      }
      styles[getVarName(varName)] = value;
    }
  }
  Object.defineProperty(styles, "toString", {
    value: function value2() {
      return Object.keys(this).map((key) => "".concat(key, ":").concat(this[key])).join(";");
    },
    writable: false
  });
  return styles;
}
var index = "var(--j3sran1)";
var height = "var(--j3sran6)";
var frontHeight = "var(--j3sran7)";
var overOffsetY = "var(--j3sran8)";
var ToastViewport = "j3sranc";
var ToastRoot = "j3srand";
var ToastInner = "j3srane";
var ToastClose = "j3sranf";
var ToastTitle = "j3srang";
var ToastDescription = "j3sranh";
var ToastAction = "j3srani";
const ToastContext = React.createContext({
  success: (payload) => {
  },
  error: (payload) => {
  }
});
const ToastContextImpl = React.createContext({});
const ANIMATION_OUT_DURATION = 350;
const Toasts = ({ children, ...props }) => {
  const [toasts, setToasts] = React.useState(/* @__PURE__ */ new Map());
  const toastElementsMapRef = React.useRef(/* @__PURE__ */ new Map());
  const viewportRef = React.useRef(null);
  const sortToasts = React.useCallback(() => {
    const toastElements = Array.from(toastElementsMapRef.current).reverse();
    const heights = [];
    toastElements.forEach(([, toast], index$12) => {
      if (!toast) return;
      const height$1 = toast.clientHeight;
      heights.push(height$1);
      const frontToastHeight = heights[0];
      const hoverOffsetY = heights.slice(0, index$12).reduce((res, next2) => res + next2, 0);
      toast.style = assignInlineVars({
        [index]: String(index$12),
        [height]: `${height$1}px`,
        [frontHeight]: `${frontToastHeight}px`,
        [overOffsetY]: `-${hoverOffsetY}px`
      });
      toast.setAttribute("data-front", index$12 === 0);
      toast.setAttribute("data-hidden", index$12 > 2);
    });
  }, []);
  const handleAddToast = React.useCallback((toast) => {
    setToasts((currentToasts) => {
      const newMap = new Map(currentToasts);
      newMap.set(String(Date.now()), { ...toast, open: true });
      return newMap;
    });
  }, []);
  const handleRemoveToast = React.useCallback((key) => {
    setToasts((currentToasts) => {
      const newMap = new Map(currentToasts);
      newMap.delete(key);
      return newMap;
    });
  }, []);
  const handleDispatchDefault = React.useCallback(
    (payload) => handleAddToast({ ...payload, status: "default" }),
    [handleAddToast]
  );
  const handleDispatchSuccess = React.useCallback(
    (payload) => handleAddToast({ ...payload, status: "success" }),
    [handleAddToast]
  );
  const handleDispatchError = React.useCallback(
    (payload) => handleAddToast({ ...payload, status: "error" }),
    [handleAddToast]
  );
  React.useEffect(() => {
    const viewport = viewportRef.current;
    if (viewport) {
      const handleFocus = () => {
        toastElementsMapRef.current.forEach((toast) => {
          toast.setAttribute("data-hovering", "true");
        });
      };
      const handleBlur = () => {
        toastElementsMapRef.current.forEach((toast) => {
          toast.setAttribute("data-hovering", "false");
        });
      };
      viewport.addEventListener("pointermove", handleFocus);
      viewport.addEventListener("pointerleave", handleBlur);
      viewport.addEventListener("focusin", handleFocus);
      viewport.addEventListener("focusout", handleBlur);
      return () => {
        viewport.removeEventListener("pointermove", handleFocus);
        viewport.removeEventListener("pointerleave", handleBlur);
        viewport.removeEventListener("focusin", handleFocus);
        viewport.removeEventListener("focusout", handleBlur);
      };
    }
  }, []);
  return /* @__PURE__ */ React.createElement(
    ToastContext.Provider,
    {
      value: React.useMemo(
        () => Object.assign(handleDispatchDefault, {
          success: handleDispatchSuccess,
          error: handleDispatchError
        }),
        [handleDispatchDefault, handleDispatchSuccess, handleDispatchError]
      )
    },
    /* @__PURE__ */ React.createElement(
      ToastContextImpl.Provider,
      {
        value: React.useMemo(
          () => ({
            toastElementsMapRef,
            sortToasts
          }),
          [sortToasts]
        )
      },
      /* @__PURE__ */ React.createElement($054eb8030ebde76e$export$2881499e37b75b9a, { ...props }, children, Array.from(toasts).map(([key, toast]) => /* @__PURE__ */ React.createElement(
        Toast,
        {
          key,
          id: key,
          toast,
          onOpenChange: (open) => {
            if (!open) {
              toastElementsMapRef.current.delete(key);
              sortToasts();
              if (!open) {
                setTimeout(() => {
                  handleRemoveToast(key);
                }, ANIMATION_OUT_DURATION);
              }
            }
          }
        }
      )), /* @__PURE__ */ React.createElement(
        $054eb8030ebde76e$export$d5c6c08dc2d3ca7,
        {
          ref: viewportRef,
          className: ToastViewport
        }
      ))
    )
  );
};
const useToast = () => {
  const context = React.useContext(ToastContext);
  if (context) return context;
  throw new Error("useToast must be used within Toasts");
};
const useToastContext = () => {
  const context = React.useContext(ToastContextImpl);
  if (context) return context;
  throw new Error("useToast must be used within Toasts");
};
const Toast = (props) => {
  const { onOpenChange, toast, id, ...toastProps } = props;
  const ref = React.useRef(null);
  const context = useToastContext();
  const { sortToasts, toastElementsMapRef } = context;
  const toastElementsMap = toastElementsMapRef == null ? void 0 : toastElementsMapRef.current;
  const statustoast = toast.status || "default";
  React.useLayoutEffect(() => {
    if (ref.current) {
      toastElementsMap == null ? void 0 : toastElementsMap.set(id, ref.current);
      sortToasts == null ? void 0 : sortToasts();
    }
  }, [id, sortToasts, toastElementsMap]);
  return /* @__PURE__ */ React.createElement(
    $054eb8030ebde76e$export$be92b6f5f03c0fe9,
    {
      ...toastProps,
      ref,
      type: toast.type,
      duration: toast.duration,
      className: ToastRoot,
      onOpenChange
    },
    /* @__PURE__ */ React.createElement("div", { className: ToastInner, "data-status": toast.status }, /* @__PURE__ */ React.createElement(ToastStatusIcon, { status: statustoast }), /* @__PURE__ */ React.createElement($054eb8030ebde76e$export$f99233281efd08a0, { className: ToastTitle }, /* @__PURE__ */ React.createElement("p", null, toast.title || "")), /* @__PURE__ */ React.createElement($054eb8030ebde76e$export$393edc798c47379d, { className: ToastDescription }, toast.description), toast.onClick && /* @__PURE__ */ React.createElement(
      $054eb8030ebde76e$export$e19cd5f9376f8cee,
      {
        className: ToastAction,
        altText: "Goto schedule to undo",
        onClick: () => {
          var _a2;
          return (_a2 = toast.onClick) == null ? void 0 : _a2.call(toast);
        }
      },
      "Voir"
    ), /* @__PURE__ */ React.createElement($054eb8030ebde76e$export$f39c2d165cd861fe, { "aria-label": "Close", className: ToastClose }, /* @__PURE__ */ React.createElement(Cross2Icon, null)))
  );
};
const ToastStatusIcon = ({ status }) => {
  return status !== "default" ? /* @__PURE__ */ React.createElement("div", { style: { gridArea: "icon", alignSelf: "start" } }, status === "success" && /* @__PURE__ */ React.createElement(Icon$2, { icon: "CheckVert", size: 16, color: "green" }), status === "error" && /* @__PURE__ */ React.createElement(Icon$2, { icon: "Retirer", size: 16, color: "red" })) : null;
};
var TransactionWrapper = "_1kymftr0";
var TransactionHeader = "_1kymftr1";
var Title2 = "_1kymftr2";
var LinkTransaction = "_1kymftr3";
const LastTransactions = ({ transactions, link, title: title2, seeAll }) => {
  return /* @__PURE__ */ React__default.createElement("div", { className: TransactionWrapper }, /* @__PURE__ */ React__default.createElement("div", { className: TransactionHeader }, /* @__PURE__ */ React__default.createElement("div", { className: Title2 }, title2), /* @__PURE__ */ React__default.createElement("a", { className: LinkTransaction, href: link ? link : "" }, seeAll)), transactions.map((transaction, index2) => {
    return /* @__PURE__ */ React__default.createElement(CardOperation, { key: transaction.label + index2, name: transaction.label, category: transaction.type ? transaction.type : "Catégorie", amount: transaction.amount, currency: transaction.currency, icon: "Banque" });
  }));
};
function getSiblingStart(currentPage, siblingCount, numberOfPage, boundaryCount) {
  return Math.max(
    Math.min(
      // Debut
      currentPage - siblingCount,
      // Lower boundary when page is high
      numberOfPage - boundaryCount - siblingCount * 2 - 1
    ),
    // Greater than startPages
    boundaryCount + 2
  );
}
function getSiblingEnd(currentPage, siblingCount, boundaryCount, endPages, numberOfPage) {
  return Math.min(
    Math.max(
      // Natural end
      currentPage + siblingCount,
      // Upper boundary when page is low
      boundaryCount + siblingCount * 2 + 2
    ),
    // Less than endPages
    endPages.length > 0 ? endPages[0] - 2 : numberOfPage - 1
  );
}
function getButtonPage(currentPage, numberOfPage) {
  return (type2) => {
    switch (type2) {
      case "first":
        return 1;
      case "previous":
        return currentPage - 1;
      case "next":
        return currentPage + 1;
      case "last":
        return numberOfPage;
      default:
        return null;
    }
  };
}
function getItem$2(item, handleClick, currentPage, disabled, buttonPage, numberOfPage) {
  return typeof item === "number" ? {
    onClick: () => {
      handleClick(item);
    },
    type: "page",
    page: item,
    selected: item === currentPage,
    disabled,
    "aria-current": item === currentPage ? "true" : void 0
  } : {
    onClick: () => {
      handleClick(buttonPage(item));
    },
    type: item,
    page: buttonPage(item),
    selected: false,
    disabled: disabled || item.indexOf("ellipsis") === -1 && (item === "next" || item === "last" ? currentPage >= numberOfPage : currentPage <= 1)
  };
}
function usePagination(props) {
  const {
    boundaryCount = 1,
    numberOfPage = 1,
    defaultPage = 1,
    currentPage = 1,
    disabled = false,
    hideNextButton = false,
    hidePrevButton = false,
    onChange: handleChange,
    showFirstButton = false,
    showLastButton = false,
    siblingCount = 1,
    ...other
  } = props;
  const handleClick = (value) => {
    if (handleChange && value) {
      handleChange(value);
    }
  };
  const range2 = (start, end) => {
    const length2 = end - start + 1;
    return Array.from({ length: length2 }, (_2, i) => start + i);
  };
  const startPages = range2(1, Math.min(boundaryCount, numberOfPage));
  const endPages = range2(Math.max(numberOfPage - boundaryCount + 1, boundaryCount + 1), numberOfPage);
  const siblingsStart = getSiblingStart(currentPage, siblingCount, numberOfPage, boundaryCount);
  const siblingsEnd = getSiblingEnd(currentPage, siblingCount, boundaryCount, endPages, numberOfPage);
  function getBoundaryStart() {
    return boundaryCount + 1 < numberOfPage - boundaryCount ? [boundaryCount + 1] : [];
  }
  function getBoundaryEnd() {
    return numberOfPage - boundaryCount > boundaryCount ? [numberOfPage - boundaryCount] : [];
  }
  const itemList = [
    ...showFirstButton ? ["first"] : [],
    ...hidePrevButton ? [] : ["previous"],
    ...startPages,
    // debut ellipsis
    ...siblingsStart > boundaryCount + 2 ? ["start-ellipsis"] : getBoundaryStart(),
    // pages voisines
    ...range2(siblingsStart, siblingsEnd),
    // Fin ellipsis
    ...siblingsEnd < numberOfPage - boundaryCount - 1 ? ["end-ellipsis"] : getBoundaryEnd(),
    ...endPages,
    ...hideNextButton ? [] : ["next"],
    ...showLastButton ? ["last"] : []
  ];
  const buttonPage = getButtonPage(currentPage, numberOfPage);
  const items = itemList.map((item) => {
    return getItem$2(item, handleClick, currentPage, disabled, buttonPage, numberOfPage);
  });
  return {
    items,
    ...other
  };
}
var PaginationWrapper = "xj2gm80";
var PaginationSelectedItem = "xj2gm81";
var PaginationItemStyle = "xj2gm82";
const PaginationItem = ({ type: type2, page, selected, disabled, onClick, className }) => {
  switch (type2) {
    case "first":
      return /* @__PURE__ */ React__default.createElement("button", { "aria-label": "First Page", className: classNames$1(className, selected && PaginationSelectedItem), onClick, disabled }, /* @__PURE__ */ React__default.createElement(Icon$2, { size: 22, icon: "ChevronLeft" }), /* @__PURE__ */ React__default.createElement(Icon$2, { size: 24, icon: "ChevronLeft" }));
    case "previous":
      return /* @__PURE__ */ React__default.createElement("button", { "aria-label": "Previous Page", className: classNames$1(className, selected && PaginationSelectedItem), onClick, disabled }, /* @__PURE__ */ React__default.createElement(Icon$2, { size: 22, icon: "ChevronLeft" }));
    case "next":
      return /* @__PURE__ */ React__default.createElement("button", { "aria-label": "Next Page", className: classNames$1(className, selected && PaginationSelectedItem), onClick, disabled }, /* @__PURE__ */ React__default.createElement(Icon$2, { size: 22, icon: "ChevronRight" }));
    case "last":
      return /* @__PURE__ */ React__default.createElement("button", { "aria-label": "Last Page", className: classNames$1(className, selected && PaginationSelectedItem), onClick, disabled }, /* @__PURE__ */ React__default.createElement(Icon$2, { size: 22, icon: "ChevronRight" }), /* @__PURE__ */ React__default.createElement(Icon$2, { size: 24, icon: "ChevronRight" }));
    case "end-ellipsis":
    case "start-ellipsis":
      return /* @__PURE__ */ React__default.createElement("button", { "aria-label": "ellipsis", "aria-disabled": true, className, disabled }, "...");
    default:
      return /* @__PURE__ */ React__default.createElement("button", { "aria-label": "Go to Page " + page, disabled, className: classNames$1(className, selected && PaginationSelectedItem), onClick }, page);
  }
};
const Pagination = (props) => {
  let currentPage = props.currentPage + 1;
  currentPage = currentPage < 1 ? 1 : currentPage;
  currentPage = currentPage >= props.numberOfPage ? props.numberOfPage : currentPage;
  const onChangeCorrected = (val) => {
    var _a2;
    (_a2 = props.onChange) == null ? void 0 : _a2.call(props, val - 1);
  };
  const pagination = usePagination({ ...props, currentPage, onChange: onChangeCorrected });
  return /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("ul", { className: PaginationWrapper }, pagination.items.map((item) => /* @__PURE__ */ React__default.createElement("li", { key: item.type + item.page }, /* @__PURE__ */ React__default.createElement(PaginationItem, { className: PaginationItemStyle, type: item.type, page: item.page, selected: item.selected, disabled: item.disabled, onClick: item.onClick })))));
};
function getItem$1({ item, type: type2, hideDelay, updateCode, value }) {
  return {
    index: item,
    keyDownEventListener: function(event) {
      var _a2;
      const target = event.currentTarget;
      const key = event.key || event.code;
      if (key == "Backspace" || key == "Delete") {
        target.value = "";
        const hasSibling = target.previousElementSibling;
        const hasSiblingInput = hasSibling && ((_a2 = target.previousElementSibling) == null ? void 0 : _a2.nodeName) === "INPUT";
        if (hasSiblingInput) {
          target.previousElementSibling.focus();
        }
      }
      updateCode();
    },
    inputEventListener: function(event) {
      const target = event.target;
      const data2 = event.currentTarget.value;
      target.type = "number";
      data2 && (target.value = data2.replace(/\D/g, "").charAt(0));
      const hasValue = target.value !== "";
      const hasSibling = target.nextElementSibling;
      const hasSiblingInput = hasSibling && target.nextElementSibling.nodeName === "INPUT";
      if (hasValue && hasSiblingInput) {
        target.nextElementSibling.focus();
      }
      console.log("change");
      updateCode();
      setTimeout(function() {
        target.type = "password";
      }, hideDelay);
    },
    inputPasteEventListener: function(event) {
      event.preventDefault();
      event.stopPropagation();
      updateCode(event.clipboardData.getData("text/plain"));
    },
    inputRef: React__default.createRef(),
    type: value ? "password" : type2,
    value
  };
}
function useCode({ length: length2, type: type2, value, hideDelay = 750 }) {
  const itemList = Array.from(Array(length2).keys());
  let items = [];
  const hiddenInput = useRef(null);
  let updateCode = (value2) => {
    var _a2, _b2;
    let newCode = "";
    if (value2) {
      newCode = value2.slice(0, length2);
    } else {
      newCode = items.map((item) => {
        var _a3, _b3;
        return (_b3 = (_a3 = item.inputRef) == null ? void 0 : _a3.current) == null ? void 0 : _b3.value;
      }).join("");
    }
    const nativeInputValueSetter = (_a2 = Object.getOwnPropertyDescriptor(
      window.HTMLInputElement.prototype,
      "value"
    )) == null ? void 0 : _a2.set;
    nativeInputValueSetter == null ? void 0 : nativeInputValueSetter.call(hiddenInput.current, newCode);
    const event = new Event("change", { bubbles: true, cancelable: false });
    (_b2 = hiddenInput.current) == null ? void 0 : _b2.dispatchEvent(event);
  };
  items = itemList.map((item) => {
    return getItem$1({ item, type: type2, value: value == null ? void 0 : value.charAt(item), hideDelay, updateCode });
  });
  return {
    items,
    hiddenInput
  };
}
var InputCode = "_1nacxrm0";
const Code = (props) => {
  const { items, hiddenInput } = useCode(props);
  return /* @__PURE__ */ React__default.createElement("div", null, items.map((item) => {
    return /* @__PURE__ */ React__default.createElement("input", { className: InputCode, key: item.index, value: item.value, type: item.type, onKeyDown: item.keyDownEventListener, onInput: item.inputEventListener, onPaste: item.inputPasteEventListener, ref: item.inputRef });
  }), /* @__PURE__ */ React__default.createElement("input", { type: "text", style: { display: "none" }, onChange: props.onChange, ref: hiddenInput }));
};
function getItem({ item, type: type2, updateCode, maxLength }) {
  return {
    index: item,
    keyDownEventListener: function(event) {
      var _a2;
      const target = event.currentTarget;
      const key = event.key || event.code;
      if (key == "Backspace" || key == "Delete") {
        target.value = "";
        const hasSibling = target.previousElementSibling;
        const hasSiblingInput = hasSibling && ((_a2 = target.previousElementSibling) == null ? void 0 : _a2.nodeName) === "INPUT";
        if (hasSiblingInput) {
          target.previousElementSibling.focus();
        }
      }
      updateCode();
    },
    inputEventListener: function(event) {
      const target = event.target;
      const data2 = event.currentTarget.value;
      const regexp = new RegExp(`([a-zA-Z0-9]{0,${maxLength}})(.*)`);
      console.log(data2);
      console.log(data2.replace(regexp, "$1"));
      data2 && (target.value = data2.replace(regexp, "$1"));
      const hasEnougthValue = target.value !== "" && target.value.length == maxLength;
      const hasSibling = target.nextElementSibling;
      const hasSiblingInput = hasSibling && target.nextElementSibling.nodeName === "INPUT";
      if (hasEnougthValue && hasSiblingInput) {
        target.nextElementSibling.focus();
      }
      updateCode();
    },
    inputRef: React__default.createRef(),
    type: type2
  };
}
function useIban({ length: length2, type: type2 }) {
  const itemList = Array.from(Array(length2).keys());
  let items = [];
  const hiddenInput = useRef(null);
  let updateCode = () => {
    var _a2, _b2;
    let newCode = items.map((item) => {
      var _a3, _b3;
      return (_b3 = (_a3 = item.inputRef) == null ? void 0 : _a3.current) == null ? void 0 : _b3.value;
    }).join("");
    const nativeInputValueSetter = (_a2 = Object.getOwnPropertyDescriptor(
      window.HTMLInputElement.prototype,
      "value"
    )) == null ? void 0 : _a2.set;
    nativeInputValueSetter == null ? void 0 : nativeInputValueSetter.call(hiddenInput.current, newCode);
    const event = new Event("change", { bubbles: true, cancelable: false });
    (_b2 = hiddenInput.current) == null ? void 0 : _b2.dispatchEvent(event);
  };
  items = itemList.map((item) => {
    return getItem({ item, type: type2, maxLength: item == 8 ? 2 : 4, updateCode });
  });
  return {
    items,
    hiddenInput
  };
}
var InputIbanWrapper = "_1hqqlsw0";
var InputIban = "_1hqqlsw1";
const Iban = ({ length: length2 = 9, onChange: onChange2, error, typeClass = "default", label = "Iban", id }) => {
  const CorrectedTypeClass = error ? classType$3.error : classType$3[typeClass];
  const { items, hiddenInput } = useIban({ length: length2, type: "text" });
  return /* @__PURE__ */ React__default.createElement("div", { className: box$2 }, /* @__PURE__ */ React__default.createElement("div", { className: frameWrapper$2 }, /* @__PURE__ */ React__default.createElement("div", { className: classNames$1(frame$2, CorrectedTypeClass) }, /* @__PURE__ */ React__default.createElement("label", { className: textWrapper$2, htmlFor: id }, label), /* @__PURE__ */ React__default.createElement("div", { className: InputIbanWrapper }, items.map((item) => {
    return /* @__PURE__ */ React__default.createElement(
      "input",
      {
        className: classNames$1(InputIban),
        key: item.index,
        onKeyDown: item.keyDownEventListener,
        onInput: item.inputEventListener,
        ref: item.inputRef
      }
    );
  }), /* @__PURE__ */ React__default.createElement("input", { type: "text", style: { display: "none" }, onChange: onChange2, ref: hiddenInput })))));
};
var bankNameDisplay = "_1330w4u0";
const BankDisplay = (props) => {
  return /* @__PURE__ */ React__default.createElement("div", { className: classNames$1(Flex) }, /* @__PURE__ */ React__default.createElement(
    "svg",
    {
      width: "9",
      height: "9",
      viewBox: "0 0 8 8",
      style: { boxShadow: "0 0 4px 1px rgb(200,200,200)", border: "" }
    },
    /* @__PURE__ */ React__default.createElement(
      "rect",
      {
        style: { fill: `${props.color1}` },
        id: "rect1",
        width: "8",
        height: "4",
        x: "0",
        y: "0"
      }
    ),
    /* @__PURE__ */ React__default.createElement(
      "rect",
      {
        style: { fill: `${props.color2}` },
        id: "rect2",
        width: "8",
        height: "4",
        x: "0",
        y: "4"
      }
    )
  ), /* @__PURE__ */ React__default.createElement("span", { className: bankNameDisplay }, props.name));
};
const data = {
  "boursobank": {
    color1: "#FF00C7",
    color2: "#576BB4"
  },
  "caissedepargne": {
    color1: "red",
    color2: "white"
  },
  "lcl": {
    color1: "rgb(33, 56, 138)",
    color2: "yellow"
  },
  "creditagricole": {
    color1: "rgb(0, 70, 82)",
    color2: "rgb(48, 130, 118)"
  },
  "societegeneral": {
    color1: "red",
    color2: "black"
  },
  "delubac": {
    color1: "#873873",
    color2: "white"
  },
  "elcimaibanque": {
    color1: "#31859D",
    color2: "white"
  }
};
const useBankName = (bankName) => {
  if (bankName && data[bankName.trim().toLowerCase().replace(/[^a-z0-9]+/g, "")]) {
    const { color1, color2 } = data[bankName.toLowerCase().replace(/[^a-z0-9]+/g, "")];
    return {
      name: bankName,
      color1,
      color2
    };
  } else {
    return {
      name: "inconnue",
      color1: "gray",
      color2: "black"
    };
  }
};
var SkeletonWrapper = "_1py8yzz1";
var Circle = "_1py8yzz2";
var TableCellSkeleton = "_1py8yzz3";
const Skeleton = ({ lines = 1, circle: circle2 = false }) => {
  const linesBR = [];
  for (let i = 0; i < lines; i++) {
    linesBR.push(/* @__PURE__ */ React__default.createElement("br", { key: i }));
  }
  return /* @__PURE__ */ React__default.createElement("div", { "aria-busy": true, className: classNames$1(SkeletonWrapper, circle2 ? Circle : "") }, linesBR);
};
const TableSkeleton = ({ lines = 1, columns = 1, SkeletonProvider = /* @__PURE__ */ React__default.createElement(Skeleton, null) }) => {
  const table = [];
  for (let i = 0; i < lines; i++) {
    const tds = [];
    for (let j = 0; j < columns; j++) {
      tds.push(/* @__PURE__ */ React__default.createElement("td", { className: TableCellSkeleton, key: j }, SkeletonProvider));
    }
    table.push(/* @__PURE__ */ React__default.createElement(TableRow, { key: i }, tds));
  }
  return /* @__PURE__ */ React__default.createElement(TableBody, null, table);
};
var CellWrapper = "_1j1ww3z0";
var smallAvatar = "_1j1ww3z1";
var infoCell = "_1j1ww3z2";
var infoName = "_1j1ww3z3";
var infoIban = "_1j1ww3z4";
const AccountCell = (props) => {
  const initial = useInitial({ text: props.name });
  const { name, color1, color2 } = useBankName(props.banque);
  return /* @__PURE__ */ React__default.createElement("div", { className: CellWrapper }, /* @__PURE__ */ React__default.createElement("div", { className: smallAvatar }, initial), /* @__PURE__ */ React__default.createElement("div", { className: infoCell }, /* @__PURE__ */ React__default.createElement("span", { className: infoName }, props.name), /* @__PURE__ */ React__default.createElement("span", { className: infoIban }, props.iban), /* @__PURE__ */ React__default.createElement(BankDisplay, { name, color1, color2 })));
};
var montantText = "_7o4erw0";
var montantPositif = "_7o4erw1";
var montantNegatif = "_7o4erw2";
var montantSynthese = "_7o4erw3";
var montantOperation = "_7o4erw4";
var Label = "_7o4erw5";
const CellAmount = ({ montant, lang, devise, iso = false, affichage = "default", label }) => {
  let montantString = "";
  try {
    montantString = new Intl.NumberFormat(lang, { style: "currency", currency: devise }).formatToParts(Math.abs(montant)).map(({ type: type2, value }) => {
      switch (type2) {
        case "currency":
          return iso ? devise + " " : value;
        case "decimal":
          return ["operation", "synthese"].includes(affichage) ? "," : ".";
        default:
          return value;
      }
    }).reduce((string, part) => string + part);
  } catch (e2) {
    if (lang.startsWith("fr")) {
      montantString = Math.abs(montant).toFixed(2) + " " + devise;
    } else {
      montantString = devise + " " + Math.abs(montant).toFixed(2);
    }
  }
  const montantClassName = () => {
    if (["synthese"].includes(affichage))
      return montantSynthese;
    else if (["operation"].includes(affichage))
      return montantOperation;
    else
      return montant < 0 ? montantNegatif : montantPositif;
  };
  const prefix2 = () => {
    if (["operation", "synthese"].includes(affichage))
      return montant < 0 ? "- " : "";
    else
      return montant < 0 ? "- " : "+ ";
  };
  return /* @__PURE__ */ React__default.createElement("div", { className: `${montantText} ${montantClassName()}` }, label && /* @__PURE__ */ React__default.createElement("span", null, label), /* @__PURE__ */ React__default.createElement("span", { className: label ? Label : "" }, `${prefix2()}${montantString}`));
};
var TableWrapper = "qayrpx0";
var TableHeadWrapper = "qayrpx1";
var TableBodyWrapper = "qayrpx2";
var TableRowWrapper = "qayrpx3";
var TableHeaderWrapper = "qayrpx4";
var ClickableHeader = "qayrpx5";
var InnerTableHeader = "qayrpx6";
var tableAllThSortable = "qayrpx7";
var TableCellWrapper = "qayrpx8";
const Table = (props) => {
  return /* @__PURE__ */ React__default.createElement("table", { className: TableWrapper, ...props }, props.children);
};
const TableHead = (props) => {
  return /* @__PURE__ */ React__default.createElement("thead", { className: TableHeadWrapper, ...props }, props.children);
};
const TableBody = (props) => {
  return /* @__PURE__ */ React__default.createElement("tbody", { className: TableBodyWrapper }, props.children);
};
const TableHeader = (props) => {
  const handleSort = () => {
    var _a2;
    (_a2 = props.sort) == null ? void 0 : _a2.call(props);
  };
  const handleKeySort = (event) => {
    var _a2;
    if (event.key === "Enter" || event.code === "Space") {
      event.preventDefault();
      (_a2 = props.sort) == null ? void 0 : _a2.call(props);
    }
  };
  const { sort, order, children, ...cleanedProps } = props;
  return /* @__PURE__ */ React__default.createElement("th", { className: classNames$1(TableHeaderWrapper, props.sort ? ClickableHeader : ""), onClick: () => handleSort(), ...cleanedProps, tabIndex: 0, onKeyDown: handleKeySort }, /* @__PURE__ */ React__default.createElement("div", { className: InnerTableHeader }, /* @__PURE__ */ React__default.createElement("p", null, props.children), props.sort && props.order && /* @__PURE__ */ React__default.createElement("div", { className: tableAllThSortable }, /* @__PURE__ */ React__default.createElement(Icon$2, { size: 21, icon: props.order }))));
};
const TableCell = (props) => {
  return /* @__PURE__ */ React__default.createElement("td", { className: TableCellWrapper, ...props }, props.children);
};
const TableRow = (props) => {
  return /* @__PURE__ */ React__default.createElement("tr", { className: TableRowWrapper, ...props }, props.children);
};
var BadgeWrapper = "_8vs0000";
var LargeBadge = "_8vs0001";
var SmallBadge = "_8vs0002";
var InformationBadge = "_8vs0003";
var PositiveBadge = "_8vs0004";
var PendingBadge = "_8vs0005";
var NewBadge = "_8vs0006";
var CancelBadge = "_8vs0007";
var DispBadge = "_8vs0008";
var SentBadge = "_8vs0009";
var NeutralBadge = "_8vs000a";
const Status = {
  "transfered": { icon: "Valide", class: PositiveBadge },
  "pending": { icon: "Refresh", class: PendingBadge },
  "canceled": { icon: "Supprimer", class: CancelBadge },
  "tosign": { icon: "Signature", class: InformationBadge },
  "new": { icon: "Refresh", class: NewBadge },
  "sent": { icon: "Valide", class: SentBadge },
  "disp": { icon: "Valide", class: DispBadge },
  "aband": { icon: "Valide", class: NeutralBadge }
};
const BadgeStatus = (props) => {
  return /* @__PURE__ */ React__default.createElement("div", { className: classNames$1(BadgeWrapper, props.status.class, props.size == "lg" ? LargeBadge : SmallBadge) }, props.label, props.status.icon && /* @__PURE__ */ React__default.createElement(Icon$2, { icon: props.status.icon, size: props.size == "lg" ? 20 : 16 }));
};
const AlertItem = (props) => {
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("div", { className: AlertItemContainer }, /* @__PURE__ */ React__default.createElement("div", { className: AlertItemLogoContainer }, /* @__PURE__ */ React__default.createElement(Icon$2, { size: 14, icon: props.type })), /* @__PURE__ */ React__default.createElement("div", { className: AlertItemInfoContainer }, /* @__PURE__ */ React__default.createElement("div", { className: AlertItemName }, props.nom), /* @__PURE__ */ React__default.createElement("div", { className: AlertItemTime }, props.description ? props.description : props.time))));
};
const BtnAlert = ({ alerts, mainContainer }) => {
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement($d08ef79370b62062$export$be92b6f5f03c0fe9, null, /* @__PURE__ */ React__default.createElement($d08ef79370b62062$export$41fb9f06171c75f4, { asChild: true, id: "alerteBtn" }, /* @__PURE__ */ React__default.createElement("button", { className: classNames$1(buttonAlerte, alerts.length > 0 && buttonAlerteNew), "aria-label": "Alertes" }, /* @__PURE__ */ React__default.createElement(Icon$2, { icon: "Alertes", size: 20 }))), /* @__PURE__ */ React__default.createElement($d08ef79370b62062$export$602eac185826482c, { container: mainContainer }, /* @__PURE__ */ React__default.createElement($d08ef79370b62062$export$7c6e2c02157bb7d2, { className: SubMenuContent$1 }, alerts.map((subItem) => /* @__PURE__ */ React__default.createElement(AlertItem, { key: subItem.nom, nom: subItem.nom, type: subItem.type, time: subItem.time, description: subItem.description }))))));
};
const BtnLangue = ({ callbackChangeLangue, mainContainer, language }) => {
  const changeLanguageHandler = (lang) => {
    callbackChangeLangue(lang);
  };
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement($d08ef79370b62062$export$be92b6f5f03c0fe9, null, /* @__PURE__ */ React__default.createElement($d08ef79370b62062$export$41fb9f06171c75f4, { asChild: true, id: "langueBtn" }, /* @__PURE__ */ React__default.createElement("button", { className: buttonAlerte, "aria-label": "Langue" }, /* @__PURE__ */ React__default.createElement(Icon$2, { icon: "Langue", size: 20 }))), /* @__PURE__ */ React__default.createElement($d08ef79370b62062$export$602eac185826482c, { container: mainContainer }, /* @__PURE__ */ React__default.createElement($d08ef79370b62062$export$7c6e2c02157bb7d2, { className: SubMenuContent$1 }, language.map((language2) => /* @__PURE__ */ React__default.createElement($d08ef79370b62062$export$6d08773d2e66f8f2, { key: language2.key, className: SubMenuContentItem, onSelect: () => changeLanguageHandler(language2.key) }, language2.label))))));
};
const BtnProfil = ({ user, mainContainer, onProfileNavigation, onLogoutNavigation, onAdviserNavigation }) => {
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement($d08ef79370b62062$export$be92b6f5f03c0fe9, null, /* @__PURE__ */ React__default.createElement($d08ef79370b62062$export$41fb9f06171c75f4, { asChild: true, id: "profileBtn" }, /* @__PURE__ */ React__default.createElement("button", { className: ProfilButtonContainer, "aria-label": "Profile" }, /* @__PURE__ */ React__default.createElement(WeAvatar, { nom: user.Nom, img: "https://i.pravatar.cc/150" }), /* @__PURE__ */ React__default.createElement("div", { className: ProfilIconAvatar, id: "profilBtnLink" }, /* @__PURE__ */ React__default.createElement(Icon$2, { icon: "Chevron", size: 13, color: theme.colours.brand.colorContrast })))), /* @__PURE__ */ React__default.createElement($d08ef79370b62062$export$602eac185826482c, { container: mainContainer }, /* @__PURE__ */ React__default.createElement($d08ef79370b62062$export$7c6e2c02157bb7d2, { className: SubMenuContent$1 }, /* @__PURE__ */ React__default.createElement(Profil, { nom: user.Nom, currentSession: user.currentSession, lastSession: user.lastSession, onProfileNavigation, onAdviserNavigation, onLogoutNavigation })))));
};
var InformationWrapper = "_1kfg1ba0";
var ErrorColor = "_1kfg1ba1";
var PositiveColor = "_1kfg1ba2";
const Information = (props) => {
  return /* @__PURE__ */ React__default.createElement("div", { className: classNames$1(InformationWrapper, props.type === "OK" ? PositiveColor : ErrorColor) }, /* @__PURE__ */ React__default.createElement(Icon$2, { icon: props.type === "OK" ? "Valide" : "Attention", size: 30 }), /* @__PURE__ */ React__default.createElement("span", null, props.texte));
};
var smallNewSelect = "_8155s10";
var NewSelectInput = "_8155s11";
var NoBorderNoPadding = "_8155s12";
var MaxSize = "_8155s13";
var ContentWrapper = "_8155s14";
var SelectContent = "_8155s15";
var SelectLabel = "_8155s16";
const SimpleItemRenderer = (props) => {
  return /* @__PURE__ */ React__default.createElement("div", null, props.item.label + " : " + props.item.value, props.selected ? "selected" : "not selected");
};
const SimpleItemFilter = (item, filter) => {
  if (item.value)
    return item.value.toString().includes(filter);
};
const NewSelectWrapper = (props) => {
  if (props.isSmall) return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, props.children);
  else return /* @__PURE__ */ React__default.createElement(Card, { shadow: true }, props.children);
};
const NewSelect = ({
  label,
  options: options2,
  itemRenderer = SimpleItemRenderer,
  multiple = false,
  itemFilter = SimpleItemFilter,
  onChange: onChange2 = (values2) => {
    return void 0;
  },
  typeClass = "default",
  error,
  placeholder,
  placeholderStyle,
  value,
  size: size2 = "BIG"
}) => {
  const defaultValues = Array.isArray(value) ? multiple ? value : value.slice(0, 1) : value ? [value] : [];
  const [filter, setFilter] = useState("");
  const CorrectedTypeClass = error ? classType$3.error : classType$3[typeClass];
  const canClose = useRef(null);
  const wrapper2 = useRef(null);
  const canClose2 = useRef(null);
  const handleClose = useCallback((event) => {
    var _a2, _b2;
    event.preventDefault();
    if ((_a2 = wrapper2.current) == null ? void 0 : _a2.contains(document.activeElement)) {
      (_b2 = canClose.current) == null ? void 0 : _b2.focus();
    }
  }, []);
  const handleAddOrRemove = (event, item) => {
    var _a2, _b2;
    if (!multiple) {
      (_a2 = canClose2.current) == null ? void 0 : _a2.removeEventListener("mousedown", handleClose, true);
      (_b2 = canClose.current) == null ? void 0 : _b2.focus();
      event.preventDefault();
      setFilter("");
      onChange2(item);
    } else {
      const newList = !defaultValues.includes(item) ? [...defaultValues, item] : defaultValues.filter((itemIn) => itemIn !== item);
      onChange2(newList);
    }
  };
  const handleAddOrRemoveKeyboard = (event, item) => {
    var _a2, _b2;
    if (event.key === "Enter" || event.code === "Space") {
      event.preventDefault();
      if (!multiple) {
        (_a2 = canClose.current) == null ? void 0 : _a2.focus();
        setFilter("");
        (_b2 = canClose2.current) == null ? void 0 : _b2.removeEventListener("mousedown", handleClose, true);
        onChange2(item);
      } else {
        const newList = !defaultValues.includes(item) ? [...defaultValues, item] : defaultValues.filter((itemIn) => itemIn !== item);
        onChange2(newList);
      }
    }
  };
  const keyboardHandler = (event) => {
    var _a2;
    if (event.key === "Escape") {
      (_a2 = canClose.current) == null ? void 0 : _a2.focus();
    }
  };
  const onBlur = (event) => {
    var _a2;
    (_a2 = canClose2.current) == null ? void 0 : _a2.removeEventListener("mousedown", handleClose, true);
    event.stopPropagation();
  };
  const handleSearch = (value2) => {
    setFilter(value2);
  };
  const isSmall = size2 === "SMALL";
  return /* @__PURE__ */ React__default.createElement(NewSelectWrapper, { isSmall }, /* @__PURE__ */ React__default.createElement(
    "div",
    {
      className: classNames$1(MaxSize, CorrectedTypeClass, isSmall && smallNewSelect),
      tabIndex: 0,
      ref: wrapper2,
      onBlur,
      onFocus: () => {
        var _a2;
        (_a2 = canClose2.current) == null ? void 0 : _a2.addEventListener("mousedown", handleClose, true);
      },
      onKeyDown: keyboardHandler
    },
    /* @__PURE__ */ React__default.createElement("p", { className: SelectLabel }, label),
    /* @__PURE__ */ React__default.createElement("div", { tabIndex: 0, className: classNames$1(NewSelectInput, defaultValues.length > 0 ? NoBorderNoPadding : placeholderStyle), ref: canClose2 }, defaultValues.length > 0 ? itemRenderer({ item: defaultValues[0], selected: false, droppable: false }) : placeholder),
    error && /* @__PURE__ */ React__default.createElement("p", null, error),
    /* @__PURE__ */ React__default.createElement("div", { className: ContentWrapper }, /* @__PURE__ */ React__default.createElement(SearchBar, { onSearch: handleSearch }), /* @__PURE__ */ React__default.createElement("div", { className: SelectContent }, options2.filter((item) => itemFilter(item, filter)).map((item, id) => {
      const isSelected = defaultValues.includes(item);
      return /* @__PURE__ */ React__default.createElement("div", { style: { minWidth: 0 }, key: id, tabIndex: 0, onMouseDown: (event) => handleAddOrRemove(event, item), role: "button", onKeyDown: (event) => handleAddOrRemoveKeyboard(event, item) }, itemRenderer({
        item,
        selected: isSelected,
        droppable: isSelected
      }));
    })))
  ), /* @__PURE__ */ React__default.createElement("input", { ref: canClose, style: { opacity: "0", height: 0, width: 0, position: "absolute" }, "aria-label": "notused", "aria-disabled": true }));
};
var SelectedItem = "_1wiaq00";
var Item = "_1wiaq01";
var ItemAmount = "_1wiaq02";
const AccountSelectRenderer = ({ iban, name, bank, amount, selected, droppable }) => {
  return /* @__PURE__ */ React__default.createElement("div", { className: classNames$1(selected ? SelectedItem : "", Item) }, /* @__PURE__ */ React__default.createElement(AccountCell, { name, iban, banque: bank }), /* @__PURE__ */ React__default.createElement("span", { className: ItemAmount }, amount), /* @__PURE__ */ React__default.createElement(Icon$2, { size: 16, icon: droppable ? "Supprimer" : "ChevronRight" }));
};
const [$a093c7e1ec25a057$var$createTooltipContext, $a093c7e1ec25a057$export$1c540a2224f0d865] = $c512c27ab02ef895$export$50c7b4e9d9f19c1("Tooltip", [
  $cf1ac5d9fe0e8206$export$722aac194ae923
]);
const $a093c7e1ec25a057$var$usePopperScope = $cf1ac5d9fe0e8206$export$722aac194ae923();
const $a093c7e1ec25a057$var$PROVIDER_NAME = "TooltipProvider";
const $a093c7e1ec25a057$var$DEFAULT_DELAY_DURATION = 700;
const $a093c7e1ec25a057$var$TOOLTIP_OPEN = "tooltip.open";
const [$a093c7e1ec25a057$var$TooltipProviderContextProvider, $a093c7e1ec25a057$var$useTooltipProviderContext] = $a093c7e1ec25a057$var$createTooltipContext($a093c7e1ec25a057$var$PROVIDER_NAME);
const $a093c7e1ec25a057$export$f78649fb9ca566b8 = (props) => {
  const { __scopeTooltip, delayDuration = $a093c7e1ec25a057$var$DEFAULT_DELAY_DURATION, skipDelayDuration = 300, disableHoverableContent = false, children } = props;
  const [isOpenDelayed, setIsOpenDelayed] = useState(true);
  const isPointerInTransitRef = useRef(false);
  const skipDelayTimerRef = useRef(0);
  useEffect(() => {
    const skipDelayTimer = skipDelayTimerRef.current;
    return () => window.clearTimeout(skipDelayTimer);
  }, []);
  return /* @__PURE__ */ createElement($a093c7e1ec25a057$var$TooltipProviderContextProvider, {
    scope: __scopeTooltip,
    isOpenDelayed,
    delayDuration,
    onOpen: useCallback(() => {
      window.clearTimeout(skipDelayTimerRef.current);
      setIsOpenDelayed(false);
    }, []),
    onClose: useCallback(() => {
      window.clearTimeout(skipDelayTimerRef.current);
      skipDelayTimerRef.current = window.setTimeout(
        () => setIsOpenDelayed(true),
        skipDelayDuration
      );
    }, [
      skipDelayDuration
    ]),
    isPointerInTransitRef,
    onPointerInTransitChange: useCallback((inTransit) => {
      isPointerInTransitRef.current = inTransit;
    }, []),
    disableHoverableContent
  }, children);
};
const $a093c7e1ec25a057$var$TOOLTIP_NAME = "Tooltip";
const [$a093c7e1ec25a057$var$TooltipContextProvider, $a093c7e1ec25a057$var$useTooltipContext] = $a093c7e1ec25a057$var$createTooltipContext($a093c7e1ec25a057$var$TOOLTIP_NAME);
const $a093c7e1ec25a057$export$28c660c63b792dea = (props) => {
  const { __scopeTooltip, children, open: openProp, defaultOpen = false, onOpenChange, disableHoverableContent: disableHoverableContentProp, delayDuration: delayDurationProp } = props;
  const providerContext = $a093c7e1ec25a057$var$useTooltipProviderContext($a093c7e1ec25a057$var$TOOLTIP_NAME, props.__scopeTooltip);
  const popperScope = $a093c7e1ec25a057$var$usePopperScope(__scopeTooltip);
  const [trigger, setTrigger] = useState(null);
  const contentId = $1746a345f3d73bb7$export$f680877a34711e37();
  const openTimerRef = useRef(0);
  const disableHoverableContent = disableHoverableContentProp !== null && disableHoverableContentProp !== void 0 ? disableHoverableContentProp : providerContext.disableHoverableContent;
  const delayDuration = delayDurationProp !== null && delayDurationProp !== void 0 ? delayDurationProp : providerContext.delayDuration;
  const wasOpenDelayedRef = useRef(false);
  const [open1 = false, setOpen] = $71cd76cc60e0454e$export$6f32135080cb4c3({
    prop: openProp,
    defaultProp: defaultOpen,
    onChange: (open) => {
      if (open) {
        providerContext.onOpen();
        document.dispatchEvent(new CustomEvent($a093c7e1ec25a057$var$TOOLTIP_OPEN));
      } else providerContext.onClose();
      onOpenChange === null || onOpenChange === void 0 || onOpenChange(open);
    }
  });
  const stateAttribute = useMemo(() => {
    return open1 ? wasOpenDelayedRef.current ? "delayed-open" : "instant-open" : "closed";
  }, [
    open1
  ]);
  const handleOpen = useCallback(() => {
    window.clearTimeout(openTimerRef.current);
    wasOpenDelayedRef.current = false;
    setOpen(true);
  }, [
    setOpen
  ]);
  const handleClose = useCallback(() => {
    window.clearTimeout(openTimerRef.current);
    setOpen(false);
  }, [
    setOpen
  ]);
  const handleDelayedOpen = useCallback(() => {
    window.clearTimeout(openTimerRef.current);
    openTimerRef.current = window.setTimeout(() => {
      wasOpenDelayedRef.current = true;
      setOpen(true);
    }, delayDuration);
  }, [
    delayDuration,
    setOpen
  ]);
  useEffect(() => {
    return () => window.clearTimeout(openTimerRef.current);
  }, []);
  return /* @__PURE__ */ createElement($cf1ac5d9fe0e8206$export$be92b6f5f03c0fe9, popperScope, /* @__PURE__ */ createElement($a093c7e1ec25a057$var$TooltipContextProvider, {
    scope: __scopeTooltip,
    contentId,
    open: open1,
    stateAttribute,
    trigger,
    onTriggerChange: setTrigger,
    onTriggerEnter: useCallback(() => {
      if (providerContext.isOpenDelayed) handleDelayedOpen();
      else handleOpen();
    }, [
      providerContext.isOpenDelayed,
      handleDelayedOpen,
      handleOpen
    ]),
    onTriggerLeave: useCallback(() => {
      if (disableHoverableContent) handleClose();
      else
        window.clearTimeout(openTimerRef.current);
    }, [
      handleClose,
      disableHoverableContent
    ]),
    onOpen: handleOpen,
    onClose: handleClose,
    disableHoverableContent
  }, children));
};
const $a093c7e1ec25a057$var$TRIGGER_NAME = "TooltipTrigger";
const $a093c7e1ec25a057$export$8c610744efcf8a1d = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeTooltip, ...triggerProps } = props;
  const context = $a093c7e1ec25a057$var$useTooltipContext($a093c7e1ec25a057$var$TRIGGER_NAME, __scopeTooltip);
  const providerContext = $a093c7e1ec25a057$var$useTooltipProviderContext($a093c7e1ec25a057$var$TRIGGER_NAME, __scopeTooltip);
  const popperScope = $a093c7e1ec25a057$var$usePopperScope(__scopeTooltip);
  const ref = useRef(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, ref, context.onTriggerChange);
  const isPointerDownRef = useRef(false);
  const hasPointerMoveOpenedRef = useRef(false);
  const handlePointerUp = useCallback(
    () => isPointerDownRef.current = false,
    []
  );
  useEffect(() => {
    return () => document.removeEventListener("pointerup", handlePointerUp);
  }, [
    handlePointerUp
  ]);
  return /* @__PURE__ */ createElement($cf1ac5d9fe0e8206$export$b688253958b8dfe7, _extends$1({
    asChild: true
  }, popperScope), /* @__PURE__ */ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.button, _extends$1({
    // We purposefully avoid adding `type=button` here because tooltip triggers are also
    // commonly anchors and the anchor `type` attribute signifies MIME type.
    "aria-describedby": context.open ? context.contentId : void 0,
    "data-state": context.stateAttribute
  }, triggerProps, {
    ref: composedRefs,
    onPointerMove: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerMove, (event) => {
      if (event.pointerType === "touch") return;
      if (!hasPointerMoveOpenedRef.current && !providerContext.isPointerInTransitRef.current) {
        context.onTriggerEnter();
        hasPointerMoveOpenedRef.current = true;
      }
    }),
    onPointerLeave: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerLeave, () => {
      context.onTriggerLeave();
      hasPointerMoveOpenedRef.current = false;
    }),
    onPointerDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerDown, () => {
      isPointerDownRef.current = true;
      document.addEventListener("pointerup", handlePointerUp, {
        once: true
      });
    }),
    onFocus: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onFocus, () => {
      if (!isPointerDownRef.current) context.onOpen();
    }),
    onBlur: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onBlur, context.onClose),
    onClick: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onClick, context.onClose)
  })));
});
const $a093c7e1ec25a057$var$PORTAL_NAME = "TooltipPortal";
const [$a093c7e1ec25a057$var$PortalProvider, $a093c7e1ec25a057$var$usePortalContext] = $a093c7e1ec25a057$var$createTooltipContext($a093c7e1ec25a057$var$PORTAL_NAME, {
  forceMount: void 0
});
const $a093c7e1ec25a057$export$7b36b8f925ab7497 = (props) => {
  const { __scopeTooltip, forceMount, children, container } = props;
  const context = $a093c7e1ec25a057$var$useTooltipContext($a093c7e1ec25a057$var$PORTAL_NAME, __scopeTooltip);
  return /* @__PURE__ */ createElement($a093c7e1ec25a057$var$PortalProvider, {
    scope: __scopeTooltip,
    forceMount
  }, /* @__PURE__ */ createElement($921a889cee6df7e8$export$99c2b779aa4e8b8b, {
    present: forceMount || context.open
  }, /* @__PURE__ */ createElement($f1701beae083dbae$export$602eac185826482c, {
    asChild: true,
    container
  }, children)));
};
const $a093c7e1ec25a057$var$CONTENT_NAME = "TooltipContent";
const $a093c7e1ec25a057$export$e9003e2be37ec060 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const portalContext = $a093c7e1ec25a057$var$usePortalContext($a093c7e1ec25a057$var$CONTENT_NAME, props.__scopeTooltip);
  const { forceMount = portalContext.forceMount, side = "top", ...contentProps } = props;
  const context = $a093c7e1ec25a057$var$useTooltipContext($a093c7e1ec25a057$var$CONTENT_NAME, props.__scopeTooltip);
  return /* @__PURE__ */ createElement($921a889cee6df7e8$export$99c2b779aa4e8b8b, {
    present: forceMount || context.open
  }, context.disableHoverableContent ? /* @__PURE__ */ createElement($a093c7e1ec25a057$var$TooltipContentImpl, _extends$1({
    side
  }, contentProps, {
    ref: forwardedRef
  })) : /* @__PURE__ */ createElement($a093c7e1ec25a057$var$TooltipContentHoverable, _extends$1({
    side
  }, contentProps, {
    ref: forwardedRef
  })));
});
const $a093c7e1ec25a057$var$TooltipContentHoverable = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const context = $a093c7e1ec25a057$var$useTooltipContext($a093c7e1ec25a057$var$CONTENT_NAME, props.__scopeTooltip);
  const providerContext = $a093c7e1ec25a057$var$useTooltipProviderContext($a093c7e1ec25a057$var$CONTENT_NAME, props.__scopeTooltip);
  const ref = useRef(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, ref);
  const [pointerGraceArea, setPointerGraceArea] = useState(null);
  const { trigger, onClose } = context;
  const content = ref.current;
  const { onPointerInTransitChange } = providerContext;
  const handleRemoveGraceArea = useCallback(() => {
    setPointerGraceArea(null);
    onPointerInTransitChange(false);
  }, [
    onPointerInTransitChange
  ]);
  const handleCreateGraceArea = useCallback((event, hoverTarget) => {
    const currentTarget = event.currentTarget;
    const exitPoint = {
      x: event.clientX,
      y: event.clientY
    };
    const exitSide = $a093c7e1ec25a057$var$getExitSideFromRect(exitPoint, currentTarget.getBoundingClientRect());
    const paddedExitPoints = $a093c7e1ec25a057$var$getPaddedExitPoints(exitPoint, exitSide);
    const hoverTargetPoints = $a093c7e1ec25a057$var$getPointsFromRect(hoverTarget.getBoundingClientRect());
    const graceArea = $a093c7e1ec25a057$var$getHull([
      ...paddedExitPoints,
      ...hoverTargetPoints
    ]);
    setPointerGraceArea(graceArea);
    onPointerInTransitChange(true);
  }, [
    onPointerInTransitChange
  ]);
  useEffect(() => {
    return () => handleRemoveGraceArea();
  }, [
    handleRemoveGraceArea
  ]);
  useEffect(() => {
    if (trigger && content) {
      const handleTriggerLeave = (event) => handleCreateGraceArea(event, content);
      const handleContentLeave = (event) => handleCreateGraceArea(event, trigger);
      trigger.addEventListener("pointerleave", handleTriggerLeave);
      content.addEventListener("pointerleave", handleContentLeave);
      return () => {
        trigger.removeEventListener("pointerleave", handleTriggerLeave);
        content.removeEventListener("pointerleave", handleContentLeave);
      };
    }
  }, [
    trigger,
    content,
    handleCreateGraceArea,
    handleRemoveGraceArea
  ]);
  useEffect(() => {
    if (pointerGraceArea) {
      const handleTrackPointerGrace = (event) => {
        const target = event.target;
        const pointerPosition = {
          x: event.clientX,
          y: event.clientY
        };
        const hasEnteredTarget = (trigger === null || trigger === void 0 ? void 0 : trigger.contains(target)) || (content === null || content === void 0 ? void 0 : content.contains(target));
        const isPointerOutsideGraceArea = !$a093c7e1ec25a057$var$isPointInPolygon(pointerPosition, pointerGraceArea);
        if (hasEnteredTarget) handleRemoveGraceArea();
        else if (isPointerOutsideGraceArea) {
          handleRemoveGraceArea();
          onClose();
        }
      };
      document.addEventListener("pointermove", handleTrackPointerGrace);
      return () => document.removeEventListener("pointermove", handleTrackPointerGrace);
    }
  }, [
    trigger,
    content,
    pointerGraceArea,
    onClose,
    handleRemoveGraceArea
  ]);
  return /* @__PURE__ */ createElement($a093c7e1ec25a057$var$TooltipContentImpl, _extends$1({}, props, {
    ref: composedRefs
  }));
});
const [$a093c7e1ec25a057$var$VisuallyHiddenContentContextProvider, $a093c7e1ec25a057$var$useVisuallyHiddenContentContext] = $a093c7e1ec25a057$var$createTooltipContext($a093c7e1ec25a057$var$TOOLTIP_NAME, {
  isInside: false
});
const $a093c7e1ec25a057$var$TooltipContentImpl = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeTooltip, children, "aria-label": ariaLabel, onEscapeKeyDown, onPointerDownOutside, ...contentProps } = props;
  const context = $a093c7e1ec25a057$var$useTooltipContext($a093c7e1ec25a057$var$CONTENT_NAME, __scopeTooltip);
  const popperScope = $a093c7e1ec25a057$var$usePopperScope(__scopeTooltip);
  const { onClose } = context;
  useEffect(() => {
    document.addEventListener($a093c7e1ec25a057$var$TOOLTIP_OPEN, onClose);
    return () => document.removeEventListener($a093c7e1ec25a057$var$TOOLTIP_OPEN, onClose);
  }, [
    onClose
  ]);
  useEffect(() => {
    if (context.trigger) {
      const handleScroll2 = (event) => {
        const target = event.target;
        if (target !== null && target !== void 0 && target.contains(context.trigger)) onClose();
      };
      window.addEventListener("scroll", handleScroll2, {
        capture: true
      });
      return () => window.removeEventListener("scroll", handleScroll2, {
        capture: true
      });
    }
  }, [
    context.trigger,
    onClose
  ]);
  return /* @__PURE__ */ createElement($5cb92bef7577960e$export$177fb62ff3ec1f22, {
    asChild: true,
    disableOutsidePointerEvents: false,
    onEscapeKeyDown,
    onPointerDownOutside,
    onFocusOutside: (event) => event.preventDefault(),
    onDismiss: onClose
  }, /* @__PURE__ */ createElement($cf1ac5d9fe0e8206$export$7c6e2c02157bb7d2, _extends$1({
    "data-state": context.stateAttribute
  }, popperScope, contentProps, {
    ref: forwardedRef,
    style: {
      ...contentProps.style,
      "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
      "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
      "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }), /* @__PURE__ */ createElement($5e63c961fc1ce211$export$d9f1ccf0bdb05d45, null, children), /* @__PURE__ */ createElement($a093c7e1ec25a057$var$VisuallyHiddenContentContextProvider, {
    scope: __scopeTooltip,
    isInside: true
  }, /* @__PURE__ */ createElement($ea1ef594cf570d83$export$be92b6f5f03c0fe9, {
    id: context.contentId,
    role: "tooltip"
  }, ariaLabel || children))));
});
const $a093c7e1ec25a057$var$ARROW_NAME = "TooltipArrow";
const $a093c7e1ec25a057$export$c27ee0ad710f7559 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeTooltip, ...arrowProps } = props;
  const popperScope = $a093c7e1ec25a057$var$usePopperScope(__scopeTooltip);
  const visuallyHiddenContentContext = $a093c7e1ec25a057$var$useVisuallyHiddenContentContext($a093c7e1ec25a057$var$ARROW_NAME, __scopeTooltip);
  return visuallyHiddenContentContext.isInside ? null : /* @__PURE__ */ createElement($cf1ac5d9fe0e8206$export$21b07c8f274aebd5, _extends$1({}, popperScope, arrowProps, {
    ref: forwardedRef
  }));
});
function $a093c7e1ec25a057$var$getExitSideFromRect(point, rect) {
  const top = Math.abs(rect.top - point.y);
  const bottom = Math.abs(rect.bottom - point.y);
  const right = Math.abs(rect.right - point.x);
  const left = Math.abs(rect.left - point.x);
  switch (Math.min(top, bottom, right, left)) {
    case left:
      return "left";
    case right:
      return "right";
    case top:
      return "top";
    case bottom:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function $a093c7e1ec25a057$var$getPaddedExitPoints(exitPoint, exitSide, padding = 5) {
  const paddedExitPoints = [];
  switch (exitSide) {
    case "top":
      paddedExitPoints.push({
        x: exitPoint.x - padding,
        y: exitPoint.y + padding
      }, {
        x: exitPoint.x + padding,
        y: exitPoint.y + padding
      });
      break;
    case "bottom":
      paddedExitPoints.push({
        x: exitPoint.x - padding,
        y: exitPoint.y - padding
      }, {
        x: exitPoint.x + padding,
        y: exitPoint.y - padding
      });
      break;
    case "left":
      paddedExitPoints.push({
        x: exitPoint.x + padding,
        y: exitPoint.y - padding
      }, {
        x: exitPoint.x + padding,
        y: exitPoint.y + padding
      });
      break;
    case "right":
      paddedExitPoints.push({
        x: exitPoint.x - padding,
        y: exitPoint.y - padding
      }, {
        x: exitPoint.x - padding,
        y: exitPoint.y + padding
      });
      break;
  }
  return paddedExitPoints;
}
function $a093c7e1ec25a057$var$getPointsFromRect(rect) {
  const { top, right, bottom, left } = rect;
  return [
    {
      x: left,
      y: top
    },
    {
      x: right,
      y: top
    },
    {
      x: right,
      y: bottom
    },
    {
      x: left,
      y: bottom
    }
  ];
}
function $a093c7e1ec25a057$var$isPointInPolygon(point, polygon) {
  const { x: x2, y: y2 } = point;
  let inside = false;
  for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
    const xi = polygon[i].x;
    const yi = polygon[i].y;
    const xj = polygon[j].x;
    const yj = polygon[j].y;
    const intersect = yi > y2 !== yj > y2 && x2 < (xj - xi) * (y2 - yi) / (yj - yi) + xi;
    if (intersect) inside = !inside;
  }
  return inside;
}
function $a093c7e1ec25a057$var$getHull(points) {
  const newPoints = points.slice();
  newPoints.sort((a2, b2) => {
    if (a2.x < b2.x) return -1;
    else if (a2.x > b2.x) return 1;
    else if (a2.y < b2.y) return -1;
    else if (a2.y > b2.y) return 1;
    else return 0;
  });
  return $a093c7e1ec25a057$var$getHullPresorted(newPoints);
}
function $a093c7e1ec25a057$var$getHullPresorted(points) {
  if (points.length <= 1) return points.slice();
  const upperHull = [];
  for (let i = 0; i < points.length; i++) {
    const p2 = points[i];
    while (upperHull.length >= 2) {
      const q = upperHull[upperHull.length - 1];
      const r2 = upperHull[upperHull.length - 2];
      if ((q.x - r2.x) * (p2.y - r2.y) >= (q.y - r2.y) * (p2.x - r2.x)) upperHull.pop();
      else break;
    }
    upperHull.push(p2);
  }
  upperHull.pop();
  const lowerHull = [];
  for (let i1 = points.length - 1; i1 >= 0; i1--) {
    const p2 = points[i1];
    while (lowerHull.length >= 2) {
      const q = lowerHull[lowerHull.length - 1];
      const r2 = lowerHull[lowerHull.length - 2];
      if ((q.x - r2.x) * (p2.y - r2.y) >= (q.y - r2.y) * (p2.x - r2.x)) lowerHull.pop();
      else break;
    }
    lowerHull.push(p2);
  }
  lowerHull.pop();
  if (upperHull.length === 1 && lowerHull.length === 1 && upperHull[0].x === lowerHull[0].x && upperHull[0].y === lowerHull[0].y) return upperHull;
  else return upperHull.concat(lowerHull);
}
const $a093c7e1ec25a057$export$2881499e37b75b9a = $a093c7e1ec25a057$export$f78649fb9ca566b8;
const $a093c7e1ec25a057$export$be92b6f5f03c0fe9 = $a093c7e1ec25a057$export$28c660c63b792dea;
const $a093c7e1ec25a057$export$41fb9f06171c75f4 = $a093c7e1ec25a057$export$8c610744efcf8a1d;
const $a093c7e1ec25a057$export$602eac185826482c = $a093c7e1ec25a057$export$7b36b8f925ab7497;
const $a093c7e1ec25a057$export$7c6e2c02157bb7d2 = $a093c7e1ec25a057$export$e9003e2be37ec060;
const $a093c7e1ec25a057$export$21b07c8f274aebd5 = $a093c7e1ec25a057$export$c27ee0ad710f7559;
var TooltipContent = "_7mw43n4";
var TooltipArrow = "_7mw43n5";
const MyButton$1 = React__default.forwardRef((props, forwardedRef) => /* @__PURE__ */ React__default.createElement("div", { ...props, ref: forwardedRef }, props.children));
const TooltipUI = ({ children, text }) => {
  return /* @__PURE__ */ React__default.createElement($a093c7e1ec25a057$export$2881499e37b75b9a, null, /* @__PURE__ */ React__default.createElement($a093c7e1ec25a057$export$be92b6f5f03c0fe9, null, /* @__PURE__ */ React__default.createElement($a093c7e1ec25a057$export$41fb9f06171c75f4, { className: "", asChild: true }, /* @__PURE__ */ React__default.createElement(MyButton$1, null, children)), /* @__PURE__ */ React__default.createElement($a093c7e1ec25a057$export$602eac185826482c, null, /* @__PURE__ */ React__default.createElement($a093c7e1ec25a057$export$7c6e2c02157bb7d2, { className: TooltipContent }, text, /* @__PURE__ */ React__default.createElement($a093c7e1ec25a057$export$21b07c8f274aebd5, { className: TooltipArrow })))));
};
var ChatBoxWrapper = "_28hky80";
var ChatBoxHeader = "_28hky81";
var ChatBoxBody = "_28hky82";
var ChatBoxBottom = "_28hky83";
var InputBox = "_28hky87";
const ChatBox = (props) => {
  const [message2, setMessage] = useState("");
  const { sendMessage, account, children } = props;
  function handleSendMessageClick(text) {
    const messageToSend = {
      date: Intl.DateTimeFormat("fr-FR", { dateStyle: "short", timeStyle: "short", timeZone: "GMT" }).format(/* @__PURE__ */ new Date()),
      message: text
    };
    sendMessage(messageToSend);
  }
  return /* @__PURE__ */ React__default.createElement("div", { className: ChatBoxWrapper }, /* @__PURE__ */ React__default.createElement("div", { className: ChatBoxHeader }, /* @__PURE__ */ React__default.createElement(AccountCell, { name: account.name, iban: account.iban, banque: account.banque })), /* @__PURE__ */ React__default.createElement("div", { className: ChatBoxBody }, children), /* @__PURE__ */ React__default.createElement("div", { className: ChatBoxBottom }, /* @__PURE__ */ React__default.createElement(
    "input",
    {
      id: "message",
      type: "text",
      className: InputBox,
      placeholder: "Message",
      value: message2,
      onChange: (e2) => setMessage(e2.target.value),
      onKeyDown: (e2) => {
        if (e2.key === "Enter" && message2.length != 0) {
          handleSendMessageClick(message2);
          setMessage("");
        }
      }
    }
  ), /* @__PURE__ */ React__default.createElement(TooltipUI, { text: props.tooltipSend }, /* @__PURE__ */ React__default.createElement(
    Button,
    {
      type: "tertiary",
      label: "",
      onClick: () => {
        if (message2.length != 0) {
          handleSendMessageClick(message2);
          setMessage("");
        }
      },
      icon: "Envoyer"
    }
  ))));
};
var SenderMessageHeader = "lhz4bl0";
var ReceiverMessageHeader = "lhz4bl1";
var SenderMessage = "lhz4bl2";
var ReceiverMessage = "lhz4bl3";
var MessageContent = "lhz4bl4";
var FlexEnd = "lhz4bl5";
const Message = (props) => {
  const { sender, date, message: message2 } = props;
  return /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("div", { className: sender ? ReceiverMessageHeader : SenderMessageHeader }, sender && /* @__PURE__ */ React__default.createElement("h3", null, sender), /* @__PURE__ */ React__default.createElement("p", null, sender && ": ", " ", date.toString())), /* @__PURE__ */ React__default.createElement("div", { className: sender ?? FlexEnd }, /* @__PURE__ */ React__default.createElement("div", { className: sender ? ReceiverMessage : SenderMessage }, /* @__PURE__ */ React__default.createElement("p", { className: MessageContent }, message2))));
};
var box = "_9obiy71";
var datePickerWrapper = "_9obiy72";
var frameWrapper = "_9obiy73";
var frame = "_9obiy74";
var inputDefault = "_9obiy75";
var inputCorrect = "_9obiy76";
var inputError = "_9obiy77";
var textWrapper = "_9obiy78";
var inputBox = "_9obiy79";
var inputIcon = "_9obiy7a";
var secondInputDate = "_9obiy7c";
var separator = "_9obiy7h";
var datepicker = "_9obiy7i";
const classType = {
  "default": inputDefault,
  "correct": inputCorrect,
  "error": inputError
};
const getDateFromRangeString = (format, dates) => {
  if (!dates)
    return [];
  else {
    const splitted = dates.split("~");
    if (splitted.length === 2) {
      const datefrom = new build.DateObject();
      datefrom.setFormat(format);
      datefrom.parse(splitted[0].trim());
      const dateto = new build.DateObject();
      dateto.setFormat(format);
      dateto.parse(splitted[1].trim());
      return [datefrom, dateto];
    } else if (dates) {
      const datefrom = new build.DateObject();
      datefrom.setFormat(format);
      datefrom.parse(dates);
      return [datefrom];
    } else
      return [];
  }
};
function RangeDatePickerInput({ name, label, placeholder, value, onChange: onChange2, typeClass = "default", format = "DD/MM/YYYY", error, options: options2 }) {
  const CorrectedTypeClass = error ? classType.error : classType[typeClass];
  function getDates(date) {
    var _a2, _b2, _c, _d;
    if (!Array.isArray(date)) {
      onChange2 == null ? void 0 : onChange2((date == null ? void 0 : date.isValid) ? date.format(format) : "");
    } else {
      if (((_a2 = date[0]) == null ? void 0 : _a2.isValid) && ((_b2 = date[1]) == null ? void 0 : _b2.isValid)) {
        onChange2 == null ? void 0 : onChange2(date.map((date2, index2) => {
          return date2.format(format);
        }).join("~"));
      } else if ((_c = date[0]) == null ? void 0 : _c.isValid) {
        onChange2 == null ? void 0 : onChange2(((_d = date[0]) == null ? void 0 : _d.isValid) ? date[0].format(format) : "");
      } else {
        onChange2 == null ? void 0 : onChange2("");
      }
    }
  }
  function getInputs(openCalendar, handleValueChange, valueDate) {
    var _a2, _b2;
    const datesFromString = Array.isArray(valueDate) ? getDateFromRangeString(format, valueDate.join("~")) : getDateFromRangeString(format, valueDate);
    return /* @__PURE__ */ React__default.createElement("div", { className: box }, /* @__PURE__ */ React__default.createElement("div", { className: frameWrapper }, /* @__PURE__ */ React__default.createElement("div", { className: classNames$1(frame, CorrectedTypeClass), onClick: openCalendar }, /* @__PURE__ */ React__default.createElement("div", { className: textWrapper }, label), /* @__PURE__ */ React__default.createElement(
      "input",
      {
        placeholder,
        type: "text",
        id: "input" + name,
        role: "input",
        className: classNames$1(inputBox),
        value: ((_a2 = datesFromString[0]) == null ? void 0 : _a2.format(format)) || "",
        onChange: handleValueChange
      }
    ), /* @__PURE__ */ React__default.createElement(Icon$2, { icon: "Calendrier2", size: 20, className: inputIcon })), /* @__PURE__ */ React__default.createElement("div", { className: separator }, /* @__PURE__ */ React__default.createElement(Icon$2, { icon: "ChevronRight", size: 24 })), /* @__PURE__ */ React__default.createElement("div", { className: classNames$1(frame, CorrectedTypeClass), onClick: openCalendar }, /* @__PURE__ */ React__default.createElement(
      "input",
      {
        placeholder,
        type: "text",
        id: "input" + name,
        role: "input",
        className: classNames$1(inputBox, secondInputDate),
        value: ((_b2 = datesFromString[1]) == null ? void 0 : _b2.format(format)) || "",
        onChange: handleValueChange
      }
    ), /* @__PURE__ */ React__default.createElement(Icon$2, { icon: "Calendrier2", size: 20, className: inputIcon })), error && /* @__PURE__ */ React__default.createElement("span", { className: inputError }, error)));
  }
  return /* @__PURE__ */ React__default.createElement(
    DatePicker,
    {
      ...options2,
      range: true,
      numberOfMonths: 2,
      highlightToday: false,
      value: getDateFromRangeString(format, value),
      onChange: (date) => {
        getDates(date);
      },
      format,
      render: (valueDate, openCalendar, handleValueChange) => {
        return getInputs(openCalendar, handleValueChange, valueDate);
      },
      containerClassName: datePickerWrapper,
      className: datepicker
    }
  );
}
const grayDark = {
  gray1: "#111111",
  gray2: "#191919",
  gray3: "#222222",
  gray4: "#2a2a2a",
  gray5: "#313131",
  gray6: "#3a3a3a",
  gray7: "#484848",
  gray8: "#606060",
  gray9: "#6e6e6e",
  gray10: "#7b7b7b",
  gray11: "#b4b4b4",
  gray12: "#eeeeee"
};
const grayDarkA = {
  grayA1: "#00000000",
  grayA2: "#ffffff09",
  grayA3: "#ffffff12",
  grayA4: "#ffffff1b",
  grayA5: "#ffffff22",
  grayA6: "#ffffff2c",
  grayA7: "#ffffff3b",
  grayA8: "#ffffff55",
  grayA9: "#ffffff64",
  grayA10: "#ffffff72",
  grayA11: "#ffffffaf",
  grayA12: "#ffffffed"
};
const grayDarkP3 = {
  gray1: "color(display-p3 0.067 0.067 0.067)",
  gray2: "color(display-p3 0.098 0.098 0.098)",
  gray3: "color(display-p3 0.135 0.135 0.135)",
  gray4: "color(display-p3 0.163 0.163 0.163)",
  gray5: "color(display-p3 0.192 0.192 0.192)",
  gray6: "color(display-p3 0.228 0.228 0.228)",
  gray7: "color(display-p3 0.283 0.283 0.283)",
  gray8: "color(display-p3 0.375 0.375 0.375)",
  gray9: "color(display-p3 0.431 0.431 0.431)",
  gray10: "color(display-p3 0.484 0.484 0.484)",
  gray11: "color(display-p3 0.706 0.706 0.706)",
  gray12: "color(display-p3 0.933 0.933 0.933)"
};
const grayDarkP3A = {
  grayA1: "color(display-p3 0 0 0 / 0)",
  grayA2: "color(display-p3 1 1 1 / 0.034)",
  grayA3: "color(display-p3 1 1 1 / 0.071)",
  grayA4: "color(display-p3 1 1 1 / 0.105)",
  grayA5: "color(display-p3 1 1 1 / 0.134)",
  grayA6: "color(display-p3 1 1 1 / 0.172)",
  grayA7: "color(display-p3 1 1 1 / 0.231)",
  grayA8: "color(display-p3 1 1 1 / 0.332)",
  grayA9: "color(display-p3 1 1 1 / 0.391)",
  grayA10: "color(display-p3 1 1 1 / 0.445)",
  grayA11: "color(display-p3 1 1 1 / 0.685)",
  grayA12: "color(display-p3 1 1 1 / 0.929)"
};
const mauveDark = {
  mauve1: "#121113",
  mauve2: "#1a191b",
  mauve3: "#232225",
  mauve4: "#2b292d",
  mauve5: "#323035",
  mauve6: "#3c393f",
  mauve7: "#49474e",
  mauve8: "#625f69",
  mauve9: "#6f6d78",
  mauve10: "#7c7a85",
  mauve11: "#b5b2bc",
  mauve12: "#eeeef0"
};
const mauveDarkA = {
  mauveA1: "#00000000",
  mauveA2: "#f5f4f609",
  mauveA3: "#ebeaf814",
  mauveA4: "#eee5f81d",
  mauveA5: "#efe6fe25",
  mauveA6: "#f1e6fd30",
  mauveA7: "#eee9ff40",
  mauveA8: "#eee7ff5d",
  mauveA9: "#eae6fd6e",
  mauveA10: "#ece9fd7c",
  mauveA11: "#f5f1ffb7",
  mauveA12: "#fdfdffef"
};
const mauveDarkP3 = {
  mauve1: "color(display-p3 0.07 0.067 0.074)",
  mauve2: "color(display-p3 0.101 0.098 0.105)",
  mauve3: "color(display-p3 0.138 0.134 0.144)",
  mauve4: "color(display-p3 0.167 0.161 0.175)",
  mauve5: "color(display-p3 0.196 0.189 0.206)",
  mauve6: "color(display-p3 0.232 0.225 0.245)",
  mauve7: "color(display-p3 0.286 0.277 0.302)",
  mauve8: "color(display-p3 0.383 0.373 0.408)",
  mauve9: "color(display-p3 0.434 0.428 0.467)",
  mauve10: "color(display-p3 0.487 0.48 0.519)",
  mauve11: "color(display-p3 0.707 0.7 0.735)",
  mauve12: "color(display-p3 0.933 0.933 0.94)"
};
const mauveDarkP3A = {
  mauveA1: "color(display-p3 0 0 0 / 0)",
  mauveA2: "color(display-p3 0.996 0.992 1 / 0.034)",
  mauveA3: "color(display-p3 0.937 0.933 0.992 / 0.077)",
  mauveA4: "color(display-p3 0.957 0.918 0.996 / 0.111)",
  mauveA5: "color(display-p3 0.937 0.906 0.996 / 0.145)",
  mauveA6: "color(display-p3 0.953 0.925 0.996 / 0.183)",
  mauveA7: "color(display-p3 0.945 0.929 1 / 0.246)",
  mauveA8: "color(display-p3 0.937 0.918 1 / 0.361)",
  mauveA9: "color(display-p3 0.933 0.918 1 / 0.424)",
  mauveA10: "color(display-p3 0.941 0.925 1 / 0.479)",
  mauveA11: "color(display-p3 0.965 0.961 1 / 0.712)",
  mauveA12: "color(display-p3 0.992 0.992 1 / 0.937)"
};
const slateDark = {
  slate1: "#111113",
  slate2: "#18191b",
  slate3: "#212225",
  slate4: "#272a2d",
  slate5: "#2e3135",
  slate6: "#363a3f",
  slate7: "#43484e",
  slate8: "#5a6169",
  slate9: "#696e77",
  slate10: "#777b84",
  slate11: "#b0b4ba",
  slate12: "#edeef0"
};
const slateDarkA = {
  slateA1: "#00000000",
  slateA2: "#d8f4f609",
  slateA3: "#ddeaf814",
  slateA4: "#d3edf81d",
  slateA5: "#d9edfe25",
  slateA6: "#d6ebfd30",
  slateA7: "#d9edff40",
  slateA8: "#d9edff5d",
  slateA9: "#dfebfd6d",
  slateA10: "#e5edfd7b",
  slateA11: "#f1f7feb5",
  slateA12: "#fcfdffef"
};
const slateDarkP3 = {
  slate1: "color(display-p3 0.067 0.067 0.074)",
  slate2: "color(display-p3 0.095 0.098 0.105)",
  slate3: "color(display-p3 0.13 0.135 0.145)",
  slate4: "color(display-p3 0.156 0.163 0.176)",
  slate5: "color(display-p3 0.183 0.191 0.206)",
  slate6: "color(display-p3 0.215 0.226 0.244)",
  slate7: "color(display-p3 0.265 0.28 0.302)",
  slate8: "color(display-p3 0.357 0.381 0.409)",
  slate9: "color(display-p3 0.415 0.431 0.463)",
  slate10: "color(display-p3 0.469 0.483 0.514)",
  slate11: "color(display-p3 0.692 0.704 0.728)",
  slate12: "color(display-p3 0.93 0.933 0.94)"
};
const slateDarkP3A = {
  slateA1: "color(display-p3 0 0 0 / 0)",
  slateA2: "color(display-p3 0.875 0.992 1 / 0.034)",
  slateA3: "color(display-p3 0.882 0.933 0.992 / 0.077)",
  slateA4: "color(display-p3 0.882 0.953 0.996 / 0.111)",
  slateA5: "color(display-p3 0.878 0.929 0.996 / 0.145)",
  slateA6: "color(display-p3 0.882 0.949 0.996 / 0.183)",
  slateA7: "color(display-p3 0.882 0.929 1 / 0.246)",
  slateA8: "color(display-p3 0.871 0.937 1 / 0.361)",
  slateA9: "color(display-p3 0.898 0.937 1 / 0.42)",
  slateA10: "color(display-p3 0.918 0.945 1 / 0.475)",
  slateA11: "color(display-p3 0.949 0.969 0.996 / 0.708)",
  slateA12: "color(display-p3 0.988 0.992 1 / 0.937)"
};
const sageDark = {
  sage1: "#101211",
  sage2: "#171918",
  sage3: "#202221",
  sage4: "#272a29",
  sage5: "#2e3130",
  sage6: "#373b39",
  sage7: "#444947",
  sage8: "#5b625f",
  sage9: "#63706b",
  sage10: "#717d79",
  sage11: "#adb5b2",
  sage12: "#eceeed"
};
const sageDarkA = {
  sageA1: "#00000000",
  sageA2: "#f0f2f108",
  sageA3: "#f3f5f412",
  sageA4: "#f2fefd1a",
  sageA5: "#f1fbfa22",
  sageA6: "#edfbf42d",
  sageA7: "#edfcf73c",
  sageA8: "#ebfdf657",
  sageA9: "#dffdf266",
  sageA10: "#e5fdf674",
  sageA11: "#f4fefbb0",
  sageA12: "#fdfffeed"
};
const sageDarkP3 = {
  sage1: "color(display-p3 0.064 0.07 0.067)",
  sage2: "color(display-p3 0.092 0.098 0.094)",
  sage3: "color(display-p3 0.128 0.135 0.131)",
  sage4: "color(display-p3 0.155 0.164 0.159)",
  sage5: "color(display-p3 0.183 0.193 0.188)",
  sage6: "color(display-p3 0.218 0.23 0.224)",
  sage7: "color(display-p3 0.269 0.285 0.277)",
  sage8: "color(display-p3 0.362 0.382 0.373)",
  sage9: "color(display-p3 0.398 0.438 0.421)",
  sage10: "color(display-p3 0.453 0.49 0.474)",
  sage11: "color(display-p3 0.685 0.709 0.697)",
  sage12: "color(display-p3 0.927 0.933 0.93)"
};
const sageDarkP3A = {
  sageA1: "color(display-p3 0 0 0 / 0)",
  sageA2: "color(display-p3 0.976 0.988 0.984 / 0.03)",
  sageA3: "color(display-p3 0.992 0.945 0.941 / 0.072)",
  sageA4: "color(display-p3 0.988 0.996 0.992 / 0.102)",
  sageA5: "color(display-p3 0.992 1 0.996 / 0.131)",
  sageA6: "color(display-p3 0.973 1 0.976 / 0.173)",
  sageA7: "color(display-p3 0.957 1 0.976 / 0.233)",
  sageA8: "color(display-p3 0.957 1 0.984 / 0.334)",
  sageA9: "color(display-p3 0.902 1 0.957 / 0.397)",
  sageA10: "color(display-p3 0.929 1 0.973 / 0.452)",
  sageA11: "color(display-p3 0.969 1 0.988 / 0.688)",
  sageA12: "color(display-p3 0.992 1 0.996 / 0.929)"
};
const oliveDark = {
  olive1: "#111210",
  olive2: "#181917",
  olive3: "#212220",
  olive4: "#282a27",
  olive5: "#2f312e",
  olive6: "#383a36",
  olive7: "#454843",
  olive8: "#5c625b",
  olive9: "#687066",
  olive10: "#767d74",
  olive11: "#afb5ad",
  olive12: "#eceeec"
};
const oliveDarkA = {
  oliveA1: "#00000000",
  oliveA2: "#f1f2f008",
  oliveA3: "#f4f5f312",
  oliveA4: "#f3fef21a",
  oliveA5: "#f2fbf122",
  oliveA6: "#f4faed2c",
  oliveA7: "#f2fced3b",
  oliveA8: "#edfdeb57",
  oliveA9: "#ebfde766",
  oliveA10: "#f0fdec74",
  oliveA11: "#f6fef4b0",
  oliveA12: "#fdfffded"
};
const oliveDarkP3 = {
  olive1: "color(display-p3 0.067 0.07 0.063)",
  olive2: "color(display-p3 0.095 0.098 0.091)",
  olive3: "color(display-p3 0.131 0.135 0.126)",
  olive4: "color(display-p3 0.158 0.163 0.153)",
  olive5: "color(display-p3 0.186 0.192 0.18)",
  olive6: "color(display-p3 0.221 0.229 0.215)",
  olive7: "color(display-p3 0.273 0.284 0.266)",
  olive8: "color(display-p3 0.365 0.382 0.359)",
  olive9: "color(display-p3 0.414 0.438 0.404)",
  olive10: "color(display-p3 0.467 0.49 0.458)",
  olive11: "color(display-p3 0.69 0.709 0.682)",
  olive12: "color(display-p3 0.927 0.933 0.926)"
};
const oliveDarkP3A = {
  oliveA1: "color(display-p3 0 0 0 / 0)",
  oliveA2: "color(display-p3 0.984 0.988 0.976 / 0.03)",
  oliveA3: "color(display-p3 0.992 0.996 0.988 / 0.068)",
  oliveA4: "color(display-p3 0.953 0.996 0.949 / 0.102)",
  oliveA5: "color(display-p3 0.969 1 0.965 / 0.131)",
  oliveA6: "color(display-p3 0.973 1 0.969 / 0.169)",
  oliveA7: "color(display-p3 0.98 1 0.961 / 0.228)",
  oliveA8: "color(display-p3 0.961 1 0.957 / 0.334)",
  oliveA9: "color(display-p3 0.949 1 0.922 / 0.397)",
  oliveA10: "color(display-p3 0.953 1 0.941 / 0.452)",
  oliveA11: "color(display-p3 0.976 1 0.965 / 0.688)",
  oliveA12: "color(display-p3 0.992 1 0.992 / 0.929)"
};
const sandDark = {
  sand1: "#111110",
  sand2: "#191918",
  sand3: "#222221",
  sand4: "#2a2a28",
  sand5: "#31312e",
  sand6: "#3b3a37",
  sand7: "#494844",
  sand8: "#62605b",
  sand9: "#6f6d66",
  sand10: "#7c7b74",
  sand11: "#b5b3ad",
  sand12: "#eeeeec"
};
const sandDarkA = {
  sandA1: "#00000000",
  sandA2: "#f4f4f309",
  sandA3: "#f6f6f513",
  sandA4: "#fefef31b",
  sandA5: "#fbfbeb23",
  sandA6: "#fffaed2d",
  sandA7: "#fffbed3c",
  sandA8: "#fff9eb57",
  sandA9: "#fffae965",
  sandA10: "#fffdee73",
  sandA11: "#fffcf4b0",
  sandA12: "#fffffded"
};
const sandDarkP3 = {
  sand1: "color(display-p3 0.067 0.067 0.063)",
  sand2: "color(display-p3 0.098 0.098 0.094)",
  sand3: "color(display-p3 0.135 0.135 0.129)",
  sand4: "color(display-p3 0.164 0.163 0.156)",
  sand5: "color(display-p3 0.193 0.192 0.183)",
  sand6: "color(display-p3 0.23 0.229 0.217)",
  sand7: "color(display-p3 0.285 0.282 0.267)",
  sand8: "color(display-p3 0.384 0.378 0.357)",
  sand9: "color(display-p3 0.434 0.428 0.403)",
  sand10: "color(display-p3 0.487 0.481 0.456)",
  sand11: "color(display-p3 0.707 0.703 0.68)",
  sand12: "color(display-p3 0.933 0.933 0.926)"
};
const sandDarkP3A = {
  sandA1: "color(display-p3 0 0 0 / 0)",
  sandA2: "color(display-p3 0.992 0.992 0.988 / 0.034)",
  sandA3: "color(display-p3 0.996 0.996 0.992 / 0.072)",
  sandA4: "color(display-p3 0.992 0.992 0.953 / 0.106)",
  sandA5: "color(display-p3 1 1 0.965 / 0.135)",
  sandA6: "color(display-p3 1 0.976 0.929 / 0.177)",
  sandA7: "color(display-p3 1 0.984 0.929 / 0.236)",
  sandA8: "color(display-p3 1 0.976 0.925 / 0.341)",
  sandA9: "color(display-p3 1 0.98 0.925 / 0.395)",
  sandA10: "color(display-p3 1 0.992 0.933 / 0.45)",
  sandA11: "color(display-p3 1 0.996 0.961 / 0.685)",
  sandA12: "color(display-p3 1 1 0.992 / 0.929)"
};
const tomatoDark = {
  tomato1: "#181111",
  tomato2: "#1f1513",
  tomato3: "#391714",
  tomato4: "#4e1511",
  tomato5: "#5e1c16",
  tomato6: "#6e2920",
  tomato7: "#853a2d",
  tomato8: "#ac4d39",
  tomato9: "#e54d2e",
  tomato10: "#ec6142",
  tomato11: "#ff977d",
  tomato12: "#fbd3cb"
};
const tomatoDarkA = {
  tomatoA1: "#f1121208",
  tomatoA2: "#ff55330f",
  tomatoA3: "#ff35232b",
  tomatoA4: "#fd201142",
  tomatoA5: "#fe332153",
  tomatoA6: "#ff4f3864",
  tomatoA7: "#fd644a7d",
  tomatoA8: "#fe6d4ea7",
  tomatoA9: "#fe5431e4",
  tomatoA10: "#ff6847eb",
  tomatoA11: "#ff977d",
  tomatoA12: "#ffd6cefb"
};
const tomatoDarkP3 = {
  tomato1: "color(display-p3 0.09 0.068 0.067)",
  tomato2: "color(display-p3 0.115 0.084 0.076)",
  tomato3: "color(display-p3 0.205 0.097 0.083)",
  tomato4: "color(display-p3 0.282 0.099 0.077)",
  tomato5: "color(display-p3 0.339 0.129 0.101)",
  tomato6: "color(display-p3 0.398 0.179 0.141)",
  tomato7: "color(display-p3 0.487 0.245 0.194)",
  tomato8: "color(display-p3 0.629 0.322 0.248)",
  tomato9: "color(display-p3 0.831 0.345 0.231)",
  tomato10: "color(display-p3 0.862 0.415 0.298)",
  tomato11: "color(display-p3 1 0.585 0.455)",
  tomato12: "color(display-p3 0.959 0.833 0.802)"
};
const tomatoDarkP3A = {
  tomatoA1: "color(display-p3 0.973 0.071 0.071 / 0.026)",
  tomatoA2: "color(display-p3 0.992 0.376 0.224 / 0.051)",
  tomatoA3: "color(display-p3 0.996 0.282 0.176 / 0.148)",
  tomatoA4: "color(display-p3 1 0.204 0.118 / 0.232)",
  tomatoA5: "color(display-p3 1 0.286 0.192 / 0.29)",
  tomatoA6: "color(display-p3 1 0.392 0.278 / 0.353)",
  tomatoA7: "color(display-p3 1 0.459 0.349 / 0.45)",
  tomatoA8: "color(display-p3 1 0.49 0.369 / 0.601)",
  tomatoA9: "color(display-p3 1 0.408 0.267 / 0.82)",
  tomatoA10: "color(display-p3 1 0.478 0.341 / 0.853)",
  tomatoA11: "color(display-p3 1 0.585 0.455)",
  tomatoA12: "color(display-p3 0.959 0.833 0.802)"
};
const redDark = {
  red1: "#191111",
  red2: "#201314",
  red3: "#3b1219",
  red4: "#500f1c",
  red5: "#611623",
  red6: "#72232d",
  red7: "#8c333a",
  red8: "#b54548",
  red9: "#e5484d",
  red10: "#ec5d5e",
  red11: "#ff9592",
  red12: "#ffd1d9"
};
const redDarkA = {
  redA1: "#f4121209",
  redA2: "#f22f3e11",
  redA3: "#ff173f2d",
  redA4: "#fe0a3b44",
  redA5: "#ff204756",
  redA6: "#ff3e5668",
  redA7: "#ff536184",
  redA8: "#ff5d61b0",
  redA9: "#fe4e54e4",
  redA10: "#ff6465eb",
  redA11: "#ff9592",
  redA12: "#ffd1d9"
};
const redDarkP3 = {
  red1: "color(display-p3 0.093 0.068 0.067)",
  red2: "color(display-p3 0.118 0.077 0.079)",
  red3: "color(display-p3 0.211 0.081 0.099)",
  red4: "color(display-p3 0.287 0.079 0.113)",
  red5: "color(display-p3 0.348 0.11 0.142)",
  red6: "color(display-p3 0.414 0.16 0.183)",
  red7: "color(display-p3 0.508 0.224 0.236)",
  red8: "color(display-p3 0.659 0.298 0.297)",
  red9: "color(display-p3 0.83 0.329 0.324)",
  red10: "color(display-p3 0.861 0.403 0.387)",
  red11: "color(display-p3 1 0.57 0.55)",
  red12: "color(display-p3 0.971 0.826 0.852)"
};
const redDarkP3A = {
  redA1: "color(display-p3 0.984 0.071 0.071 / 0.03)",
  redA2: "color(display-p3 0.996 0.282 0.282 / 0.055)",
  redA3: "color(display-p3 1 0.169 0.271 / 0.156)",
  redA4: "color(display-p3 1 0.118 0.267 / 0.236)",
  redA5: "color(display-p3 1 0.212 0.314 / 0.303)",
  redA6: "color(display-p3 1 0.318 0.38 / 0.374)",
  redA7: "color(display-p3 1 0.4 0.424 / 0.475)",
  redA8: "color(display-p3 1 0.431 0.431 / 0.635)",
  redA9: "color(display-p3 1 0.388 0.384 / 0.82)",
  redA10: "color(display-p3 1 0.463 0.447 / 0.853)",
  redA11: "color(display-p3 1 0.57 0.55)",
  redA12: "color(display-p3 0.971 0.826 0.852)"
};
const rubyDark = {
  ruby1: "#191113",
  ruby2: "#1e1517",
  ruby3: "#3a141e",
  ruby4: "#4e1325",
  ruby5: "#5e1a2e",
  ruby6: "#6f2539",
  ruby7: "#883447",
  ruby8: "#b3445a",
  ruby9: "#e54666",
  ruby10: "#ec5a72",
  ruby11: "#ff949d",
  ruby12: "#fed2e1"
};
const rubyDarkA = {
  rubyA1: "#f4124a09",
  rubyA2: "#fe5a7f0e",
  rubyA3: "#ff235d2c",
  rubyA4: "#fd195e42",
  rubyA5: "#fe2d6b53",
  rubyA6: "#ff447665",
  rubyA7: "#ff577d80",
  rubyA8: "#ff5c7cae",
  rubyA9: "#fe4c70e4",
  rubyA10: "#ff617beb",
  rubyA11: "#ff949d",
  rubyA12: "#ffd3e2fe"
};
const rubyDarkP3 = {
  ruby1: "color(display-p3 0.093 0.068 0.074)",
  ruby2: "color(display-p3 0.113 0.083 0.089)",
  ruby3: "color(display-p3 0.208 0.088 0.117)",
  ruby4: "color(display-p3 0.279 0.092 0.147)",
  ruby5: "color(display-p3 0.337 0.12 0.18)",
  ruby6: "color(display-p3 0.401 0.166 0.223)",
  ruby7: "color(display-p3 0.495 0.224 0.281)",
  ruby8: "color(display-p3 0.652 0.295 0.359)",
  ruby9: "color(display-p3 0.83 0.323 0.408)",
  ruby10: "color(display-p3 0.857 0.392 0.455)",
  ruby11: "color(display-p3 1 0.57 0.59)",
  ruby12: "color(display-p3 0.968 0.83 0.88)"
};
const rubyDarkP3A = {
  rubyA1: "color(display-p3 0.984 0.071 0.329 / 0.03)",
  rubyA2: "color(display-p3 0.992 0.376 0.529 / 0.051)",
  rubyA3: "color(display-p3 0.996 0.196 0.404 / 0.152)",
  rubyA4: "color(display-p3 1 0.173 0.416 / 0.227)",
  rubyA5: "color(display-p3 1 0.259 0.459 / 0.29)",
  rubyA6: "color(display-p3 1 0.341 0.506 / 0.358)",
  rubyA7: "color(display-p3 1 0.412 0.541 / 0.458)",
  rubyA8: "color(display-p3 1 0.431 0.537 / 0.627)",
  rubyA9: "color(display-p3 1 0.376 0.482 / 0.82)",
  rubyA10: "color(display-p3 1 0.447 0.522 / 0.849)",
  rubyA11: "color(display-p3 1 0.57 0.59)",
  rubyA12: "color(display-p3 0.968 0.83 0.88)"
};
const crimsonDark = {
  crimson1: "#191114",
  crimson2: "#201318",
  crimson3: "#381525",
  crimson4: "#4d122f",
  crimson5: "#5c1839",
  crimson6: "#6d2545",
  crimson7: "#873356",
  crimson8: "#b0436e",
  crimson9: "#e93d82",
  crimson10: "#ee518a",
  crimson11: "#ff92ad",
  crimson12: "#fdd3e8"
};
const crimsonDarkA = {
  crimsonA1: "#f4126709",
  crimsonA2: "#f22f7a11",
  crimsonA3: "#fe2a8b2a",
  crimsonA4: "#fd158741",
  crimsonA5: "#fd278f51",
  crimsonA6: "#fe459763",
  crimsonA7: "#fd559b7f",
  crimsonA8: "#fe5b9bab",
  crimsonA9: "#fe418de8",
  crimsonA10: "#ff5693ed",
  crimsonA11: "#ff92ad",
  crimsonA12: "#ffd5eafd"
};
const crimsonDarkP3 = {
  crimson1: "color(display-p3 0.093 0.068 0.078)",
  crimson2: "color(display-p3 0.117 0.078 0.095)",
  crimson3: "color(display-p3 0.203 0.091 0.143)",
  crimson4: "color(display-p3 0.277 0.087 0.182)",
  crimson5: "color(display-p3 0.332 0.115 0.22)",
  crimson6: "color(display-p3 0.394 0.162 0.268)",
  crimson7: "color(display-p3 0.489 0.222 0.336)",
  crimson8: "color(display-p3 0.638 0.289 0.429)",
  crimson9: "color(display-p3 0.843 0.298 0.507)",
  crimson10: "color(display-p3 0.864 0.364 0.539)",
  crimson11: "color(display-p3 1 0.56 0.66)",
  crimson12: "color(display-p3 0.966 0.834 0.906)"
};
const crimsonDarkP3A = {
  crimsonA1: "color(display-p3 0.984 0.071 0.463 / 0.03)",
  crimsonA2: "color(display-p3 0.996 0.282 0.569 / 0.055)",
  crimsonA3: "color(display-p3 0.996 0.227 0.573 / 0.148)",
  crimsonA4: "color(display-p3 1 0.157 0.569 / 0.227)",
  crimsonA5: "color(display-p3 1 0.231 0.604 / 0.286)",
  crimsonA6: "color(display-p3 1 0.337 0.643 / 0.349)",
  crimsonA7: "color(display-p3 1 0.416 0.663 / 0.454)",
  crimsonA8: "color(display-p3 0.996 0.427 0.651 / 0.614)",
  crimsonA9: "color(display-p3 1 0.345 0.596 / 0.832)",
  crimsonA10: "color(display-p3 1 0.42 0.62 / 0.853)",
  crimsonA11: "color(display-p3 1 0.56 0.66)",
  crimsonA12: "color(display-p3 0.966 0.834 0.906)"
};
const pinkDark = {
  pink1: "#191117",
  pink2: "#21121d",
  pink3: "#37172f",
  pink4: "#4b143d",
  pink5: "#591c47",
  pink6: "#692955",
  pink7: "#833869",
  pink8: "#a84885",
  pink9: "#d6409f",
  pink10: "#de51a8",
  pink11: "#ff8dcc",
  pink12: "#fdd1ea"
};
const pinkDarkA = {
  pinkA1: "#f412bc09",
  pinkA2: "#f420bb12",
  pinkA3: "#fe37cc29",
  pinkA4: "#fc1ec43f",
  pinkA5: "#fd35c24e",
  pinkA6: "#fd51c75f",
  pinkA7: "#fd62c87b",
  pinkA8: "#ff68c8a2",
  pinkA9: "#fe49bcd4",
  pinkA10: "#ff5cc0dc",
  pinkA11: "#ff8dcc",
  pinkA12: "#ffd3ecfd"
};
const pinkDarkP3 = {
  pink1: "color(display-p3 0.093 0.068 0.089)",
  pink2: "color(display-p3 0.121 0.073 0.11)",
  pink3: "color(display-p3 0.198 0.098 0.179)",
  pink4: "color(display-p3 0.271 0.095 0.231)",
  pink5: "color(display-p3 0.32 0.127 0.273)",
  pink6: "color(display-p3 0.382 0.177 0.326)",
  pink7: "color(display-p3 0.477 0.238 0.405)",
  pink8: "color(display-p3 0.612 0.304 0.51)",
  pink9: "color(display-p3 0.775 0.297 0.61)",
  pink10: "color(display-p3 0.808 0.356 0.645)",
  pink11: "color(display-p3 1 0.535 0.78)",
  pink12: "color(display-p3 0.964 0.826 0.912)"
};
const pinkDarkP3A = {
  pinkA1: "color(display-p3 0.984 0.071 0.855 / 0.03)",
  pinkA2: "color(display-p3 1 0.2 0.8 / 0.059)",
  pinkA3: "color(display-p3 1 0.294 0.886 / 0.139)",
  pinkA4: "color(display-p3 1 0.192 0.82 / 0.219)",
  pinkA5: "color(display-p3 1 0.282 0.827 / 0.274)",
  pinkA6: "color(display-p3 1 0.396 0.835 / 0.337)",
  pinkA7: "color(display-p3 1 0.459 0.831 / 0.442)",
  pinkA8: "color(display-p3 1 0.478 0.827 / 0.585)",
  pinkA9: "color(display-p3 1 0.373 0.784 / 0.761)",
  pinkA10: "color(display-p3 1 0.435 0.792 / 0.795)",
  pinkA11: "color(display-p3 1 0.535 0.78)",
  pinkA12: "color(display-p3 0.964 0.826 0.912)"
};
const plumDark = {
  plum1: "#181118",
  plum2: "#201320",
  plum3: "#351a35",
  plum4: "#451d47",
  plum5: "#512454",
  plum6: "#5e3061",
  plum7: "#734079",
  plum8: "#92549c",
  plum9: "#ab4aba",
  plum10: "#b658c4",
  plum11: "#e796f3",
  plum12: "#f4d4f4"
};
const plumDarkA = {
  plumA1: "#f112f108",
  plumA2: "#f22ff211",
  plumA3: "#fd4cfd27",
  plumA4: "#f646ff3a",
  plumA5: "#f455ff48",
  plumA6: "#f66dff56",
  plumA7: "#f07cfd70",
  plumA8: "#ee84ff95",
  plumA9: "#e961feb6",
  plumA10: "#ed70ffc0",
  plumA11: "#f19cfef3",
  plumA12: "#feddfef4"
};
const plumDarkP3 = {
  plum1: "color(display-p3 0.09 0.068 0.092)",
  plum2: "color(display-p3 0.118 0.077 0.121)",
  plum3: "color(display-p3 0.192 0.105 0.202)",
  plum4: "color(display-p3 0.25 0.121 0.271)",
  plum5: "color(display-p3 0.293 0.152 0.319)",
  plum6: "color(display-p3 0.343 0.198 0.372)",
  plum7: "color(display-p3 0.424 0.262 0.461)",
  plum8: "color(display-p3 0.54 0.341 0.595)",
  plum9: "color(display-p3 0.624 0.313 0.708)",
  plum10: "color(display-p3 0.666 0.365 0.748)",
  plum11: "color(display-p3 0.86 0.602 0.933)",
  plum12: "color(display-p3 0.936 0.836 0.949)"
};
const plumDarkP3A = {
  plumA1: "color(display-p3 0.973 0.071 0.973 / 0.026)",
  plumA2: "color(display-p3 0.933 0.267 1 / 0.059)",
  plumA3: "color(display-p3 0.918 0.333 0.996 / 0.148)",
  plumA4: "color(display-p3 0.91 0.318 1 / 0.219)",
  plumA5: "color(display-p3 0.914 0.388 1 / 0.269)",
  plumA6: "color(display-p3 0.906 0.463 1 / 0.328)",
  plumA7: "color(display-p3 0.906 0.529 1 / 0.425)",
  plumA8: "color(display-p3 0.906 0.553 1 / 0.568)",
  plumA9: "color(display-p3 0.875 0.427 1 / 0.69)",
  plumA10: "color(display-p3 0.886 0.471 0.996 / 0.732)",
  plumA11: "color(display-p3 0.86 0.602 0.933)",
  plumA12: "color(display-p3 0.936 0.836 0.949)"
};
const purpleDark = {
  purple1: "#18111b",
  purple2: "#1e1523",
  purple3: "#301c3b",
  purple4: "#3d224e",
  purple5: "#48295c",
  purple6: "#54346b",
  purple7: "#664282",
  purple8: "#8457aa",
  purple9: "#8e4ec6",
  purple10: "#9a5cd0",
  purple11: "#d19dff",
  purple12: "#ecd9fa"
};
const purpleDarkA = {
  purpleA1: "#b412f90b",
  purpleA2: "#b744f714",
  purpleA3: "#c150ff2d",
  purpleA4: "#bb53fd42",
  purpleA5: "#be5cfd51",
  purpleA6: "#c16dfd61",
  purpleA7: "#c378fd7a",
  purpleA8: "#c47effa4",
  purpleA9: "#b661ffc2",
  purpleA10: "#bc6fffcd",
  purpleA11: "#d19dff",
  purpleA12: "#f1ddfffa"
};
const purpleDarkP3 = {
  purple1: "color(display-p3 0.09 0.068 0.103)",
  purple2: "color(display-p3 0.113 0.082 0.134)",
  purple3: "color(display-p3 0.175 0.112 0.224)",
  purple4: "color(display-p3 0.224 0.137 0.297)",
  purple5: "color(display-p3 0.264 0.167 0.349)",
  purple6: "color(display-p3 0.311 0.208 0.406)",
  purple7: "color(display-p3 0.381 0.266 0.496)",
  purple8: "color(display-p3 0.49 0.349 0.649)",
  purple9: "color(display-p3 0.523 0.318 0.751)",
  purple10: "color(display-p3 0.57 0.373 0.791)",
  purple11: "color(display-p3 0.8 0.62 1)",
  purple12: "color(display-p3 0.913 0.854 0.971)"
};
const purpleDarkP3A = {
  purpleA1: "color(display-p3 0.686 0.071 0.996 / 0.038)",
  purpleA2: "color(display-p3 0.722 0.286 0.996 / 0.072)",
  purpleA3: "color(display-p3 0.718 0.349 0.996 / 0.169)",
  purpleA4: "color(display-p3 0.702 0.353 1 / 0.248)",
  purpleA5: "color(display-p3 0.718 0.404 1 / 0.303)",
  purpleA6: "color(display-p3 0.733 0.455 1 / 0.366)",
  purpleA7: "color(display-p3 0.753 0.506 1 / 0.458)",
  purpleA8: "color(display-p3 0.749 0.522 1 / 0.622)",
  purpleA9: "color(display-p3 0.686 0.408 1 / 0.736)",
  purpleA10: "color(display-p3 0.71 0.459 1 / 0.778)",
  purpleA11: "color(display-p3 0.8 0.62 1)",
  purpleA12: "color(display-p3 0.913 0.854 0.971)"
};
const violetDark = {
  violet1: "#14121f",
  violet2: "#1b1525",
  violet3: "#291f43",
  violet4: "#33255b",
  violet5: "#3c2e69",
  violet6: "#473876",
  violet7: "#56468b",
  violet8: "#6958ad",
  violet9: "#6e56cf",
  violet10: "#7d66d9",
  violet11: "#baa7ff",
  violet12: "#e2ddfe"
};
const violetDarkA = {
  violetA1: "#4422ff0f",
  violetA2: "#853ff916",
  violetA3: "#8354fe36",
  violetA4: "#7d51fd50",
  violetA5: "#845ffd5f",
  violetA6: "#8f6cfd6d",
  violetA7: "#9879ff83",
  violetA8: "#977dfea8",
  violetA9: "#8668ffcc",
  violetA10: "#9176fed7",
  violetA11: "#baa7ff",
  violetA12: "#e3defffe"
};
const violetDarkP3 = {
  violet1: "color(display-p3 0.077 0.071 0.118)",
  violet2: "color(display-p3 0.101 0.084 0.141)",
  violet3: "color(display-p3 0.154 0.123 0.256)",
  violet4: "color(display-p3 0.191 0.148 0.345)",
  violet5: "color(display-p3 0.226 0.182 0.396)",
  violet6: "color(display-p3 0.269 0.223 0.449)",
  violet7: "color(display-p3 0.326 0.277 0.53)",
  violet8: "color(display-p3 0.399 0.346 0.656)",
  violet9: "color(display-p3 0.417 0.341 0.784)",
  violet10: "color(display-p3 0.477 0.402 0.823)",
  violet11: "color(display-p3 0.72 0.65 1)",
  violet12: "color(display-p3 0.883 0.867 0.986)"
};
const violetDarkP3A = {
  violetA1: "color(display-p3 0.282 0.141 0.996 / 0.055)",
  violetA2: "color(display-p3 0.51 0.263 1 / 0.08)",
  violetA3: "color(display-p3 0.494 0.337 0.996 / 0.202)",
  violetA4: "color(display-p3 0.49 0.345 1 / 0.299)",
  violetA5: "color(display-p3 0.525 0.392 1 / 0.353)",
  violetA6: "color(display-p3 0.569 0.455 1 / 0.408)",
  violetA7: "color(display-p3 0.588 0.494 1 / 0.496)",
  violetA8: "color(display-p3 0.596 0.51 1 / 0.631)",
  violetA9: "color(display-p3 0.522 0.424 1 / 0.769)",
  violetA10: "color(display-p3 0.576 0.482 1 / 0.811)",
  violetA11: "color(display-p3 0.72 0.65 1)",
  violetA12: "color(display-p3 0.883 0.867 0.986)"
};
const irisDark = {
  iris1: "#13131e",
  iris2: "#171625",
  iris3: "#202248",
  iris4: "#262a65",
  iris5: "#303374",
  iris6: "#3d3e82",
  iris7: "#4a4a95",
  iris8: "#5958b1",
  iris9: "#5b5bd6",
  iris10: "#6e6ade",
  iris11: "#b1a9ff",
  iris12: "#e0dffe"
};
const irisDarkA = {
  irisA1: "#3636fe0e",
  irisA2: "#564bf916",
  irisA3: "#525bff3b",
  irisA4: "#4d58ff5a",
  irisA5: "#5b62fd6b",
  irisA6: "#6d6ffd7a",
  irisA7: "#7777fe8e",
  irisA8: "#7b7afeac",
  irisA9: "#6a6afed4",
  irisA10: "#7d79ffdc",
  irisA11: "#b1a9ff",
  irisA12: "#e1e0fffe"
};
const irisDarkP3 = {
  iris1: "color(display-p3 0.075 0.075 0.114)",
  iris2: "color(display-p3 0.089 0.086 0.14)",
  iris3: "color(display-p3 0.128 0.134 0.272)",
  iris4: "color(display-p3 0.153 0.165 0.382)",
  iris5: "color(display-p3 0.192 0.201 0.44)",
  iris6: "color(display-p3 0.239 0.241 0.491)",
  iris7: "color(display-p3 0.291 0.289 0.565)",
  iris8: "color(display-p3 0.35 0.345 0.673)",
  iris9: "color(display-p3 0.357 0.357 0.81)",
  iris10: "color(display-p3 0.428 0.416 0.843)",
  iris11: "color(display-p3 0.685 0.662 1)",
  iris12: "color(display-p3 0.878 0.875 0.986)"
};
const irisDarkP3A = {
  irisA1: "color(display-p3 0.224 0.224 0.992 / 0.051)",
  irisA2: "color(display-p3 0.361 0.314 1 / 0.08)",
  irisA3: "color(display-p3 0.357 0.373 1 / 0.219)",
  irisA4: "color(display-p3 0.325 0.361 1 / 0.337)",
  irisA5: "color(display-p3 0.38 0.4 1 / 0.4)",
  irisA6: "color(display-p3 0.447 0.447 1 / 0.454)",
  irisA7: "color(display-p3 0.486 0.486 1 / 0.534)",
  irisA8: "color(display-p3 0.502 0.494 1 / 0.652)",
  irisA9: "color(display-p3 0.431 0.431 1 / 0.799)",
  irisA10: "color(display-p3 0.502 0.486 1 / 0.832)",
  irisA11: "color(display-p3 0.685 0.662 1)",
  irisA12: "color(display-p3 0.878 0.875 0.986)"
};
const indigoDark = {
  indigo1: "#11131f",
  indigo2: "#141726",
  indigo3: "#182449",
  indigo4: "#1d2e62",
  indigo5: "#253974",
  indigo6: "#304384",
  indigo7: "#3a4f97",
  indigo8: "#435db1",
  indigo9: "#3e63dd",
  indigo10: "#5472e4",
  indigo11: "#9eb1ff",
  indigo12: "#d6e1ff"
};
const indigoDarkA = {
  indigoA1: "#1133ff0f",
  indigoA2: "#3354fa17",
  indigoA3: "#2f62ff3c",
  indigoA4: "#3566ff57",
  indigoA5: "#4171fd6b",
  indigoA6: "#5178fd7c",
  indigoA7: "#5a7fff90",
  indigoA8: "#5b81feac",
  indigoA9: "#4671ffdb",
  indigoA10: "#5c7efee3",
  indigoA11: "#9eb1ff",
  indigoA12: "#d6e1ff"
};
const indigoDarkP3 = {
  indigo1: "color(display-p3 0.068 0.074 0.118)",
  indigo2: "color(display-p3 0.081 0.089 0.144)",
  indigo3: "color(display-p3 0.105 0.141 0.275)",
  indigo4: "color(display-p3 0.129 0.18 0.369)",
  indigo5: "color(display-p3 0.163 0.22 0.439)",
  indigo6: "color(display-p3 0.203 0.262 0.5)",
  indigo7: "color(display-p3 0.245 0.309 0.575)",
  indigo8: "color(display-p3 0.285 0.362 0.674)",
  indigo9: "color(display-p3 0.276 0.384 0.837)",
  indigo10: "color(display-p3 0.354 0.445 0.866)",
  indigo11: "color(display-p3 0.63 0.69 1)",
  indigo12: "color(display-p3 0.848 0.881 0.99)"
};
const indigoDarkP3A = {
  indigoA1: "color(display-p3 0.071 0.212 0.996 / 0.055)",
  indigoA2: "color(display-p3 0.251 0.345 0.988 / 0.085)",
  indigoA3: "color(display-p3 0.243 0.404 1 / 0.223)",
  indigoA4: "color(display-p3 0.263 0.42 1 / 0.324)",
  indigoA5: "color(display-p3 0.314 0.451 1 / 0.4)",
  indigoA6: "color(display-p3 0.361 0.49 1 / 0.467)",
  indigoA7: "color(display-p3 0.388 0.51 1 / 0.547)",
  indigoA8: "color(display-p3 0.404 0.518 1 / 0.652)",
  indigoA9: "color(display-p3 0.318 0.451 1 / 0.824)",
  indigoA10: "color(display-p3 0.404 0.506 1 / 0.858)",
  indigoA11: "color(display-p3 0.63 0.69 1)",
  indigoA12: "color(display-p3 0.848 0.881 0.99)"
};
const blueDark = {
  blue1: "#0d1520",
  blue2: "#111927",
  blue3: "#0d2847",
  blue4: "#003362",
  blue5: "#004074",
  blue6: "#104d87",
  blue7: "#205d9e",
  blue8: "#2870bd",
  blue9: "#0090ff",
  blue10: "#3b9eff",
  blue11: "#70b8ff",
  blue12: "#c2e6ff"
};
const blueDarkA = {
  blueA1: "#004df211",
  blueA2: "#1166fb18",
  blueA3: "#0077ff3a",
  blueA4: "#0075ff57",
  blueA5: "#0081fd6b",
  blueA6: "#0f89fd7f",
  blueA7: "#2a91fe98",
  blueA8: "#3094feb9",
  blueA9: "#0090ff",
  blueA10: "#3b9eff",
  blueA11: "#70b8ff",
  blueA12: "#c2e6ff"
};
const blueDarkP3 = {
  blue1: "color(display-p3 0.057 0.081 0.122)",
  blue2: "color(display-p3 0.072 0.098 0.147)",
  blue3: "color(display-p3 0.078 0.154 0.27)",
  blue4: "color(display-p3 0.033 0.197 0.37)",
  blue5: "color(display-p3 0.08 0.245 0.441)",
  blue6: "color(display-p3 0.14 0.298 0.511)",
  blue7: "color(display-p3 0.195 0.361 0.6)",
  blue8: "color(display-p3 0.239 0.434 0.72)",
  blue9: "color(display-p3 0.247 0.556 0.969)",
  blue10: "color(display-p3 0.344 0.612 0.973)",
  blue11: "color(display-p3 0.49 0.72 1)",
  blue12: "color(display-p3 0.788 0.898 0.99)"
};
const blueDarkP3A = {
  blueA1: "color(display-p3 0 0.333 1 / 0.059)",
  blueA2: "color(display-p3 0.114 0.435 0.988 / 0.085)",
  blueA3: "color(display-p3 0.122 0.463 1 / 0.219)",
  blueA4: "color(display-p3 0 0.467 1 / 0.324)",
  blueA5: "color(display-p3 0.098 0.51 1 / 0.4)",
  blueA6: "color(display-p3 0.224 0.557 1 / 0.475)",
  blueA7: "color(display-p3 0.294 0.584 1 / 0.572)",
  blueA8: "color(display-p3 0.314 0.592 1 / 0.702)",
  blueA9: "color(display-p3 0.251 0.573 0.996 / 0.967)",
  blueA10: "color(display-p3 0.357 0.631 1 / 0.971)",
  blueA11: "color(display-p3 0.49 0.72 1)",
  blueA12: "color(display-p3 0.788 0.898 0.99)"
};
const cyanDark = {
  cyan1: "#0b161a",
  cyan2: "#101b20",
  cyan3: "#082c36",
  cyan4: "#003848",
  cyan5: "#004558",
  cyan6: "#045468",
  cyan7: "#12677e",
  cyan8: "#11809c",
  cyan9: "#00a2c7",
  cyan10: "#23afd0",
  cyan11: "#4ccce6",
  cyan12: "#b6ecf7"
};
const cyanDarkA = {
  cyanA1: "#0091f70a",
  cyanA2: "#02a7f211",
  cyanA3: "#00befd28",
  cyanA4: "#00baff3b",
  cyanA5: "#00befd4d",
  cyanA6: "#00c7fd5e",
  cyanA7: "#14cdff75",
  cyanA8: "#11cfff95",
  cyanA9: "#00cfffc3",
  cyanA10: "#28d6ffcd",
  cyanA11: "#52e1fee5",
  cyanA12: "#bbf3fef7"
};
const cyanDarkP3 = {
  cyan1: "color(display-p3 0.053 0.085 0.098)",
  cyan2: "color(display-p3 0.072 0.105 0.122)",
  cyan3: "color(display-p3 0.073 0.168 0.209)",
  cyan4: "color(display-p3 0.063 0.216 0.277)",
  cyan5: "color(display-p3 0.091 0.267 0.336)",
  cyan6: "color(display-p3 0.137 0.324 0.4)",
  cyan7: "color(display-p3 0.186 0.398 0.484)",
  cyan8: "color(display-p3 0.23 0.496 0.6)",
  cyan9: "color(display-p3 0.282 0.627 0.765)",
  cyan10: "color(display-p3 0.331 0.675 0.801)",
  cyan11: "color(display-p3 0.446 0.79 0.887)",
  cyan12: "color(display-p3 0.757 0.919 0.962)"
};
const cyanDarkP3A = {
  cyanA1: "color(display-p3 0 0.647 0.992 / 0.034)",
  cyanA2: "color(display-p3 0.133 0.733 1 / 0.059)",
  cyanA3: "color(display-p3 0.122 0.741 0.996 / 0.152)",
  cyanA4: "color(display-p3 0.051 0.725 1 / 0.227)",
  cyanA5: "color(display-p3 0.149 0.757 1 / 0.29)",
  cyanA6: "color(display-p3 0.267 0.792 1 / 0.358)",
  cyanA7: "color(display-p3 0.333 0.808 1 / 0.446)",
  cyanA8: "color(display-p3 0.357 0.816 1 / 0.572)",
  cyanA9: "color(display-p3 0.357 0.82 1 / 0.748)",
  cyanA10: "color(display-p3 0.4 0.839 1 / 0.786)",
  cyanA11: "color(display-p3 0.446 0.79 0.887)",
  cyanA12: "color(display-p3 0.757 0.919 0.962)"
};
const tealDark = {
  teal1: "#0d1514",
  teal2: "#111c1b",
  teal3: "#0d2d2a",
  teal4: "#023b37",
  teal5: "#084843",
  teal6: "#145750",
  teal7: "#1c6961",
  teal8: "#207e73",
  teal9: "#12a594",
  teal10: "#0eb39e",
  teal11: "#0bd8b6",
  teal12: "#adf0dd"
};
const tealDarkA = {
  tealA1: "#00deab05",
  tealA2: "#12fbe60c",
  tealA3: "#00ffe61e",
  tealA4: "#00ffe92d",
  tealA5: "#00ffea3b",
  tealA6: "#1cffe84b",
  tealA7: "#2efde85f",
  tealA8: "#32ffe775",
  tealA9: "#13ffe49f",
  tealA10: "#0dffe0ae",
  tealA11: "#0afed5d6",
  tealA12: "#b8ffebef"
};
const tealDarkP3 = {
  teal1: "color(display-p3 0.059 0.083 0.079)",
  teal2: "color(display-p3 0.075 0.11 0.107)",
  teal3: "color(display-p3 0.087 0.175 0.165)",
  teal4: "color(display-p3 0.087 0.227 0.214)",
  teal5: "color(display-p3 0.12 0.277 0.261)",
  teal6: "color(display-p3 0.162 0.335 0.314)",
  teal7: "color(display-p3 0.205 0.406 0.379)",
  teal8: "color(display-p3 0.245 0.489 0.453)",
  teal9: "color(display-p3 0.297 0.637 0.581)",
  teal10: "color(display-p3 0.319 0.69 0.62)",
  teal11: "color(display-p3 0.388 0.835 0.719)",
  teal12: "color(display-p3 0.734 0.934 0.87)"
};
const tealDarkP3A = {
  tealA1: "color(display-p3 0 0.992 0.761 / 0.017)",
  tealA2: "color(display-p3 0.235 0.988 0.902 / 0.047)",
  tealA3: "color(display-p3 0.235 1 0.898 / 0.118)",
  tealA4: "color(display-p3 0.18 0.996 0.929 / 0.173)",
  tealA5: "color(display-p3 0.31 1 0.933 / 0.227)",
  tealA6: "color(display-p3 0.396 1 0.933 / 0.286)",
  tealA7: "color(display-p3 0.443 1 0.925 / 0.366)",
  tealA8: "color(display-p3 0.459 1 0.925 / 0.454)",
  tealA9: "color(display-p3 0.443 0.996 0.906 / 0.61)",
  tealA10: "color(display-p3 0.439 0.996 0.89 / 0.669)",
  tealA11: "color(display-p3 0.388 0.835 0.719)",
  tealA12: "color(display-p3 0.734 0.934 0.87)"
};
const jadeDark = {
  jade1: "#0d1512",
  jade2: "#121c18",
  jade3: "#0f2e22",
  jade4: "#0b3b2c",
  jade5: "#114837",
  jade6: "#1b5745",
  jade7: "#246854",
  jade8: "#2a7e68",
  jade9: "#29a383",
  jade10: "#27b08b",
  jade11: "#1fd8a4",
  jade12: "#adf0d4"
};
const jadeDarkA = {
  jadeA1: "#00de4505",
  jadeA2: "#27fba60c",
  jadeA3: "#02f99920",
  jadeA4: "#00ffaa2d",
  jadeA5: "#11ffb63b",
  jadeA6: "#34ffc24b",
  jadeA7: "#45fdc75e",
  jadeA8: "#48ffcf75",
  jadeA9: "#38feca9d",
  jadeA10: "#31fec7ab",
  jadeA11: "#21fec0d6",
  jadeA12: "#b8ffe1ef"
};
const jadeDarkP3 = {
  jade1: "color(display-p3 0.059 0.083 0.071)",
  jade2: "color(display-p3 0.078 0.11 0.094)",
  jade3: "color(display-p3 0.091 0.176 0.138)",
  jade4: "color(display-p3 0.102 0.228 0.177)",
  jade5: "color(display-p3 0.133 0.279 0.221)",
  jade6: "color(display-p3 0.174 0.334 0.273)",
  jade7: "color(display-p3 0.219 0.402 0.335)",
  jade8: "color(display-p3 0.263 0.488 0.411)",
  jade9: "color(display-p3 0.319 0.63 0.521)",
  jade10: "color(display-p3 0.338 0.68 0.555)",
  jade11: "color(display-p3 0.4 0.835 0.656)",
  jade12: "color(display-p3 0.734 0.934 0.838)"
};
const jadeDarkP3A = {
  jadeA1: "color(display-p3 0 0.992 0.298 / 0.017)",
  jadeA2: "color(display-p3 0.318 0.988 0.651 / 0.047)",
  jadeA3: "color(display-p3 0.267 1 0.667 / 0.118)",
  jadeA4: "color(display-p3 0.275 0.996 0.702 / 0.173)",
  jadeA5: "color(display-p3 0.361 1 0.741 / 0.227)",
  jadeA6: "color(display-p3 0.439 1 0.796 / 0.286)",
  jadeA7: "color(display-p3 0.49 1 0.804 / 0.362)",
  jadeA8: "color(display-p3 0.506 1 0.835 / 0.45)",
  jadeA9: "color(display-p3 0.478 0.996 0.816 / 0.606)",
  jadeA10: "color(display-p3 0.478 1 0.816 / 0.656)",
  jadeA11: "color(display-p3 0.4 0.835 0.656)",
  jadeA12: "color(display-p3 0.734 0.934 0.838)"
};
const greenDark = {
  green1: "#0e1512",
  green2: "#121b17",
  green3: "#132d21",
  green4: "#113b29",
  green5: "#174933",
  green6: "#20573e",
  green7: "#28684a",
  green8: "#2f7c57",
  green9: "#30a46c",
  green10: "#33b074",
  green11: "#3dd68c",
  green12: "#b1f1cb"
};
const greenDarkA = {
  greenA1: "#00de4505",
  greenA2: "#29f99d0b",
  greenA3: "#22ff991e",
  greenA4: "#11ff992d",
  greenA5: "#2bffa23c",
  greenA6: "#44ffaa4b",
  greenA7: "#50fdac5e",
  greenA8: "#54ffad73",
  greenA9: "#44ffa49e",
  greenA10: "#43fea4ab",
  greenA11: "#46fea5d4",
  greenA12: "#bbffd7f0"
};
const greenDarkP3 = {
  green1: "color(display-p3 0.062 0.083 0.071)",
  green2: "color(display-p3 0.079 0.106 0.09)",
  green3: "color(display-p3 0.1 0.173 0.133)",
  green4: "color(display-p3 0.115 0.229 0.166)",
  green5: "color(display-p3 0.147 0.282 0.206)",
  green6: "color(display-p3 0.185 0.338 0.25)",
  green7: "color(display-p3 0.227 0.403 0.298)",
  green8: "color(display-p3 0.27 0.479 0.351)",
  green9: "color(display-p3 0.332 0.634 0.442)",
  green10: "color(display-p3 0.357 0.682 0.474)",
  green11: "color(display-p3 0.434 0.828 0.573)",
  green12: "color(display-p3 0.747 0.938 0.807)"
};
const greenDarkP3A = {
  greenA1: "color(display-p3 0 0.992 0.298 / 0.017)",
  greenA2: "color(display-p3 0.341 0.98 0.616 / 0.043)",
  greenA3: "color(display-p3 0.376 0.996 0.655 / 0.114)",
  greenA4: "color(display-p3 0.341 0.996 0.635 / 0.173)",
  greenA5: "color(display-p3 0.408 1 0.678 / 0.232)",
  greenA6: "color(display-p3 0.475 1 0.706 / 0.29)",
  greenA7: "color(display-p3 0.514 1 0.706 / 0.362)",
  greenA8: "color(display-p3 0.529 1 0.718 / 0.442)",
  greenA9: "color(display-p3 0.502 0.996 0.682 / 0.61)",
  greenA10: "color(display-p3 0.506 1 0.682 / 0.66)",
  greenA11: "color(display-p3 0.434 0.828 0.573)",
  greenA12: "color(display-p3 0.747 0.938 0.807)"
};
const grassDark = {
  grass1: "#0e1511",
  grass2: "#141a15",
  grass3: "#1b2a1e",
  grass4: "#1d3a24",
  grass5: "#25482d",
  grass6: "#2d5736",
  grass7: "#366740",
  grass8: "#3e7949",
  grass9: "#46a758",
  grass10: "#53b365",
  grass11: "#71d083",
  grass12: "#c2f0c2"
};
const grassDarkA = {
  grassA1: "#00de1205",
  grassA2: "#5ef7780a",
  grassA3: "#70fe8c1b",
  grassA4: "#57ff802c",
  grassA5: "#68ff8b3b",
  grassA6: "#71ff8f4b",
  grassA7: "#77fd925d",
  grassA8: "#77fd9070",
  grassA9: "#65ff82a1",
  grassA10: "#72ff8dae",
  grassA11: "#89ff9fcd",
  grassA12: "#ceffceef"
};
const grassDarkP3 = {
  grass1: "color(display-p3 0.062 0.083 0.067)",
  grass2: "color(display-p3 0.083 0.103 0.085)",
  grass3: "color(display-p3 0.118 0.163 0.122)",
  grass4: "color(display-p3 0.142 0.225 0.15)",
  grass5: "color(display-p3 0.178 0.279 0.186)",
  grass6: "color(display-p3 0.217 0.337 0.224)",
  grass7: "color(display-p3 0.258 0.4 0.264)",
  grass8: "color(display-p3 0.302 0.47 0.305)",
  grass9: "color(display-p3 0.38 0.647 0.378)",
  grass10: "color(display-p3 0.426 0.694 0.426)",
  grass11: "color(display-p3 0.535 0.807 0.542)",
  grass12: "color(display-p3 0.797 0.936 0.776)"
};
const grassDarkP3A = {
  grassA1: "color(display-p3 0 0.992 0.071 / 0.017)",
  grassA2: "color(display-p3 0.482 0.996 0.584 / 0.038)",
  grassA3: "color(display-p3 0.549 0.992 0.588 / 0.106)",
  grassA4: "color(display-p3 0.51 0.996 0.557 / 0.169)",
  grassA5: "color(display-p3 0.553 1 0.588 / 0.227)",
  grassA6: "color(display-p3 0.584 1 0.608 / 0.29)",
  grassA7: "color(display-p3 0.604 1 0.616 / 0.358)",
  grassA8: "color(display-p3 0.608 1 0.62 / 0.433)",
  grassA9: "color(display-p3 0.573 1 0.569 / 0.622)",
  grassA10: "color(display-p3 0.6 0.996 0.6 / 0.673)",
  grassA11: "color(display-p3 0.535 0.807 0.542)",
  grassA12: "color(display-p3 0.797 0.936 0.776)"
};
const brownDark = {
  brown1: "#12110f",
  brown2: "#1c1816",
  brown3: "#28211d",
  brown4: "#322922",
  brown5: "#3e3128",
  brown6: "#4d3c2f",
  brown7: "#614a39",
  brown8: "#7c5f46",
  brown9: "#ad7f58",
  brown10: "#b88c67",
  brown11: "#dbb594",
  brown12: "#f2e1ca"
};
const brownDarkA = {
  brownA1: "#91110002",
  brownA2: "#fba67c0c",
  brownA3: "#fcb58c19",
  brownA4: "#fbbb8a24",
  brownA5: "#fcb88931",
  brownA6: "#fdba8741",
  brownA7: "#ffbb8856",
  brownA8: "#ffbe8773",
  brownA9: "#feb87da8",
  brownA10: "#ffc18cb3",
  brownA11: "#fed1aad9",
  brownA12: "#feecd4f2"
};
const brownDarkP3 = {
  brown1: "color(display-p3 0.071 0.067 0.059)",
  brown2: "color(display-p3 0.107 0.095 0.087)",
  brown3: "color(display-p3 0.151 0.13 0.115)",
  brown4: "color(display-p3 0.191 0.161 0.138)",
  brown5: "color(display-p3 0.235 0.194 0.162)",
  brown6: "color(display-p3 0.291 0.237 0.192)",
  brown7: "color(display-p3 0.365 0.295 0.232)",
  brown8: "color(display-p3 0.469 0.377 0.287)",
  brown9: "color(display-p3 0.651 0.505 0.368)",
  brown10: "color(display-p3 0.697 0.557 0.423)",
  brown11: "color(display-p3 0.835 0.715 0.597)",
  brown12: "color(display-p3 0.938 0.885 0.802)"
};
const brownDarkP3A = {
  brownA1: "color(display-p3 0.855 0.071 0 / 0.005)",
  brownA2: "color(display-p3 0.98 0.706 0.525 / 0.043)",
  brownA3: "color(display-p3 0.996 0.745 0.576 / 0.093)",
  brownA4: "color(display-p3 1 0.765 0.592 / 0.135)",
  brownA5: "color(display-p3 1 0.761 0.588 / 0.181)",
  brownA6: "color(display-p3 1 0.773 0.592 / 0.24)",
  brownA7: "color(display-p3 0.996 0.776 0.58 / 0.32)",
  brownA8: "color(display-p3 1 0.78 0.573 / 0.433)",
  brownA9: "color(display-p3 1 0.769 0.549 / 0.627)",
  brownA10: "color(display-p3 1 0.792 0.596 / 0.677)",
  brownA11: "color(display-p3 0.835 0.715 0.597)",
  brownA12: "color(display-p3 0.938 0.885 0.802)"
};
const bronzeDark = {
  bronze1: "#141110",
  bronze2: "#1c1917",
  bronze3: "#262220",
  bronze4: "#302a27",
  bronze5: "#3b3330",
  bronze6: "#493e3a",
  bronze7: "#5a4c47",
  bronze8: "#6f5f58",
  bronze9: "#a18072",
  bronze10: "#ae8c7e",
  bronze11: "#d4b3a5",
  bronze12: "#ede0d9"
};
const bronzeDarkA = {
  bronzeA1: "#d1110004",
  bronzeA2: "#fbbc910c",
  bronzeA3: "#faceb817",
  bronzeA4: "#facdb622",
  bronzeA5: "#ffd2c12d",
  bronzeA6: "#ffd1c03c",
  bronzeA7: "#fdd0c04f",
  bronzeA8: "#ffd6c565",
  bronzeA9: "#fec7b09b",
  bronzeA10: "#fecab5a9",
  bronzeA11: "#ffd7c6d1",
  bronzeA12: "#fff1e9ec"
};
const bronzeDarkP3 = {
  bronze1: "color(display-p3 0.076 0.067 0.063)",
  bronze2: "color(display-p3 0.106 0.097 0.093)",
  bronze3: "color(display-p3 0.147 0.132 0.125)",
  bronze4: "color(display-p3 0.185 0.166 0.156)",
  bronze5: "color(display-p3 0.227 0.202 0.19)",
  bronze6: "color(display-p3 0.278 0.246 0.23)",
  bronze7: "color(display-p3 0.343 0.302 0.281)",
  bronze8: "color(display-p3 0.426 0.374 0.347)",
  bronze9: "color(display-p3 0.611 0.507 0.455)",
  bronze10: "color(display-p3 0.66 0.556 0.504)",
  bronze11: "color(display-p3 0.81 0.707 0.655)",
  bronze12: "color(display-p3 0.921 0.88 0.854)"
};
const bronzeDarkP3A = {
  bronzeA1: "color(display-p3 0.941 0.067 0 / 0.009)",
  bronzeA2: "color(display-p3 0.98 0.8 0.706 / 0.043)",
  bronzeA3: "color(display-p3 0.988 0.851 0.761 / 0.085)",
  bronzeA4: "color(display-p3 0.996 0.839 0.78 / 0.127)",
  bronzeA5: "color(display-p3 0.996 0.863 0.773 / 0.173)",
  bronzeA6: "color(display-p3 1 0.863 0.796 / 0.227)",
  bronzeA7: "color(display-p3 1 0.867 0.8 / 0.295)",
  bronzeA8: "color(display-p3 1 0.859 0.788 / 0.387)",
  bronzeA9: "color(display-p3 1 0.82 0.733 / 0.585)",
  bronzeA10: "color(display-p3 1 0.839 0.761 / 0.635)",
  bronzeA11: "color(display-p3 0.81 0.707 0.655)",
  bronzeA12: "color(display-p3 0.921 0.88 0.854)"
};
const goldDark = {
  gold1: "#121211",
  gold2: "#1b1a17",
  gold3: "#24231f",
  gold4: "#2d2b26",
  gold5: "#38352e",
  gold6: "#444039",
  gold7: "#544f46",
  gold8: "#696256",
  gold9: "#978365",
  gold10: "#a39073",
  gold11: "#cbb99f",
  gold12: "#e8e2d9"
};
const goldDarkA = {
  goldA1: "#91911102",
  goldA2: "#f9e29d0b",
  goldA3: "#f8ecbb15",
  goldA4: "#ffeec41e",
  goldA5: "#feecc22a",
  goldA6: "#feebcb37",
  goldA7: "#ffedcd48",
  goldA8: "#fdeaca5f",
  goldA9: "#ffdba690",
  goldA10: "#fedfb09d",
  goldA11: "#fee7c6c8",
  goldA12: "#fef7ede7"
};
const goldDarkP3 = {
  gold1: "color(display-p3 0.071 0.071 0.067)",
  gold2: "color(display-p3 0.104 0.101 0.09)",
  gold3: "color(display-p3 0.141 0.136 0.122)",
  gold4: "color(display-p3 0.177 0.17 0.152)",
  gold5: "color(display-p3 0.217 0.207 0.185)",
  gold6: "color(display-p3 0.265 0.252 0.225)",
  gold7: "color(display-p3 0.327 0.31 0.277)",
  gold8: "color(display-p3 0.407 0.384 0.342)",
  gold9: "color(display-p3 0.579 0.517 0.41)",
  gold10: "color(display-p3 0.628 0.566 0.463)",
  gold11: "color(display-p3 0.784 0.728 0.635)",
  gold12: "color(display-p3 0.906 0.887 0.855)"
};
const goldDarkP3A = {
  goldA1: "color(display-p3 0.855 0.855 0.071 / 0.005)",
  goldA2: "color(display-p3 0.98 0.89 0.616 / 0.043)",
  goldA3: "color(display-p3 1 0.949 0.753 / 0.08)",
  goldA4: "color(display-p3 1 0.933 0.8 / 0.118)",
  goldA5: "color(display-p3 1 0.949 0.804 / 0.16)",
  goldA6: "color(display-p3 1 0.925 0.8 / 0.215)",
  goldA7: "color(display-p3 1 0.945 0.831 / 0.278)",
  goldA8: "color(display-p3 1 0.937 0.82 / 0.366)",
  goldA9: "color(display-p3 0.996 0.882 0.69 / 0.551)",
  goldA10: "color(display-p3 1 0.894 0.725 / 0.601)",
  goldA11: "color(display-p3 0.784 0.728 0.635)",
  goldA12: "color(display-p3 0.906 0.887 0.855)"
};
const skyDark = {
  sky1: "#0d141f",
  sky2: "#111a27",
  sky3: "#112840",
  sky4: "#113555",
  sky5: "#154467",
  sky6: "#1b537b",
  sky7: "#1f6692",
  sky8: "#197cae",
  sky9: "#7ce2fe",
  sky10: "#a8eeff",
  sky11: "#75c7f0",
  sky12: "#c2f3ff"
};
const skyDarkA = {
  skyA1: "#0044ff0f",
  skyA2: "#1171fb18",
  skyA3: "#1184fc33",
  skyA4: "#128fff49",
  skyA5: "#1c9dfd5d",
  skyA6: "#28a5ff72",
  skyA7: "#2badfe8b",
  skyA8: "#1db2fea9",
  skyA9: "#7ce3fffe",
  skyA10: "#a8eeff",
  skyA11: "#7cd3ffef",
  skyA12: "#c2f3ff"
};
const skyDarkP3 = {
  sky1: "color(display-p3 0.056 0.078 0.116)",
  sky2: "color(display-p3 0.075 0.101 0.149)",
  sky3: "color(display-p3 0.089 0.154 0.244)",
  sky4: "color(display-p3 0.106 0.207 0.323)",
  sky5: "color(display-p3 0.135 0.261 0.394)",
  sky6: "color(display-p3 0.17 0.322 0.469)",
  sky7: "color(display-p3 0.205 0.394 0.557)",
  sky8: "color(display-p3 0.232 0.48 0.665)",
  sky9: "color(display-p3 0.585 0.877 0.983)",
  sky10: "color(display-p3 0.718 0.925 0.991)",
  sky11: "color(display-p3 0.536 0.772 0.924)",
  sky12: "color(display-p3 0.799 0.947 0.993)"
};
const skyDarkP3A = {
  skyA1: "color(display-p3 0 0.282 0.996 / 0.055)",
  skyA2: "color(display-p3 0.157 0.467 0.992 / 0.089)",
  skyA3: "color(display-p3 0.192 0.522 0.996 / 0.19)",
  skyA4: "color(display-p3 0.212 0.584 1 / 0.274)",
  skyA5: "color(display-p3 0.259 0.631 1 / 0.349)",
  skyA6: "color(display-p3 0.302 0.655 1 / 0.433)",
  skyA7: "color(display-p3 0.329 0.686 1 / 0.526)",
  skyA8: "color(display-p3 0.325 0.71 1 / 0.643)",
  skyA9: "color(display-p3 0.592 0.894 1 / 0.984)",
  skyA10: "color(display-p3 0.722 0.933 1 / 0.992)",
  skyA11: "color(display-p3 0.536 0.772 0.924)",
  skyA12: "color(display-p3 0.799 0.947 0.993)"
};
const mintDark = {
  mint1: "#0e1515",
  mint2: "#0f1b1b",
  mint3: "#092c2b",
  mint4: "#003a38",
  mint5: "#004744",
  mint6: "#105650",
  mint7: "#1e685f",
  mint8: "#277f70",
  mint9: "#86ead4",
  mint10: "#a8f5e5",
  mint11: "#58d5ba",
  mint12: "#c4f5e1"
};
const mintDarkA = {
  mintA1: "#00dede05",
  mintA2: "#00f9f90b",
  mintA3: "#00fff61d",
  mintA4: "#00fff42c",
  mintA5: "#00fff23a",
  mintA6: "#0effeb4a",
  mintA7: "#34fde55e",
  mintA8: "#41ffdf76",
  mintA9: "#92ffe7e9",
  mintA10: "#aefeedf5",
  mintA11: "#67ffded2",
  mintA12: "#cbfee9f5"
};
const mintDarkP3 = {
  mint1: "color(display-p3 0.059 0.082 0.081)",
  mint2: "color(display-p3 0.068 0.104 0.105)",
  mint3: "color(display-p3 0.077 0.17 0.168)",
  mint4: "color(display-p3 0.068 0.224 0.22)",
  mint5: "color(display-p3 0.104 0.275 0.264)",
  mint6: "color(display-p3 0.154 0.332 0.313)",
  mint7: "color(display-p3 0.207 0.403 0.373)",
  mint8: "color(display-p3 0.258 0.49 0.441)",
  mint9: "color(display-p3 0.62 0.908 0.834)",
  mint10: "color(display-p3 0.725 0.954 0.898)",
  mint11: "color(display-p3 0.482 0.825 0.733)",
  mint12: "color(display-p3 0.807 0.955 0.887)"
};
const mintDarkP3A = {
  mintA1: "color(display-p3 0 0.992 0.992 / 0.017)",
  mintA2: "color(display-p3 0.071 0.98 0.98 / 0.043)",
  mintA3: "color(display-p3 0.176 0.996 0.996 / 0.11)",
  mintA4: "color(display-p3 0.071 0.996 0.973 / 0.169)",
  mintA5: "color(display-p3 0.243 1 0.949 / 0.223)",
  mintA6: "color(display-p3 0.369 1 0.933 / 0.286)",
  mintA7: "color(display-p3 0.459 1 0.914 / 0.362)",
  mintA8: "color(display-p3 0.49 1 0.89 / 0.454)",
  mintA9: "color(display-p3 0.678 0.996 0.914 / 0.904)",
  mintA10: "color(display-p3 0.761 1 0.941 / 0.95)",
  mintA11: "color(display-p3 0.482 0.825 0.733)",
  mintA12: "color(display-p3 0.807 0.955 0.887)"
};
const limeDark = {
  lime1: "#11130c",
  lime2: "#151a10",
  lime3: "#1f2917",
  lime4: "#29371d",
  lime5: "#334423",
  lime6: "#3d522a",
  lime7: "#496231",
  lime8: "#577538",
  lime9: "#bdee63",
  lime10: "#d4ff70",
  lime11: "#bde56c",
  lime12: "#e3f7ba"
};
const limeDarkA = {
  limeA1: "#11bb0003",
  limeA2: "#78f7000a",
  limeA3: "#9bfd4c1a",
  limeA4: "#a7fe5c29",
  limeA5: "#affe6537",
  limeA6: "#b2fe6d46",
  limeA7: "#b6ff6f57",
  limeA8: "#b6fd6d6c",
  limeA9: "#caff69ed",
  limeA10: "#d4ff70",
  limeA11: "#d1fe77e4",
  limeA12: "#e9febff7"
};
const limeDarkP3 = {
  lime1: "color(display-p3 0.067 0.073 0.048)",
  lime2: "color(display-p3 0.086 0.1 0.067)",
  lime3: "color(display-p3 0.13 0.16 0.099)",
  lime4: "color(display-p3 0.172 0.214 0.126)",
  lime5: "color(display-p3 0.213 0.266 0.153)",
  lime6: "color(display-p3 0.257 0.321 0.182)",
  lime7: "color(display-p3 0.307 0.383 0.215)",
  lime8: "color(display-p3 0.365 0.456 0.25)",
  lime9: "color(display-p3 0.78 0.928 0.466)",
  lime10: "color(display-p3 0.865 0.995 0.519)",
  lime11: "color(display-p3 0.771 0.893 0.485)",
  lime12: "color(display-p3 0.905 0.966 0.753)"
};
const limeDarkP3A = {
  limeA1: "color(display-p3 0.067 0.941 0 / 0.009)",
  limeA2: "color(display-p3 0.584 0.996 0.071 / 0.038)",
  limeA3: "color(display-p3 0.69 1 0.38 / 0.101)",
  limeA4: "color(display-p3 0.729 1 0.435 / 0.16)",
  limeA5: "color(display-p3 0.745 1 0.471 / 0.215)",
  limeA6: "color(display-p3 0.769 1 0.482 / 0.274)",
  limeA7: "color(display-p3 0.769 1 0.506 / 0.341)",
  limeA8: "color(display-p3 0.784 1 0.51 / 0.416)",
  limeA9: "color(display-p3 0.839 1 0.502 / 0.925)",
  limeA10: "color(display-p3 0.871 1 0.522 / 0.996)",
  limeA11: "color(display-p3 0.771 0.893 0.485)",
  limeA12: "color(display-p3 0.905 0.966 0.753)"
};
const yellowDark = {
  yellow1: "#14120b",
  yellow2: "#1b180f",
  yellow3: "#2d2305",
  yellow4: "#362b00",
  yellow5: "#433500",
  yellow6: "#524202",
  yellow7: "#665417",
  yellow8: "#836a21",
  yellow9: "#ffe629",
  yellow10: "#ffff57",
  yellow11: "#f5e147",
  yellow12: "#f6eeb4"
};
const yellowDarkA = {
  yellowA1: "#d1510004",
  yellowA2: "#f9b4000b",
  yellowA3: "#ffaa001e",
  yellowA4: "#fdb70028",
  yellowA5: "#febb0036",
  yellowA6: "#fec40046",
  yellowA7: "#fdcb225c",
  yellowA8: "#fdca327b",
  yellowA9: "#ffe629",
  yellowA10: "#ffff57",
  yellowA11: "#fee949f5",
  yellowA12: "#fef6baf6"
};
const yellowDarkP3 = {
  yellow1: "color(display-p3 0.078 0.069 0.047)",
  yellow2: "color(display-p3 0.103 0.094 0.063)",
  yellow3: "color(display-p3 0.168 0.137 0.039)",
  yellow4: "color(display-p3 0.209 0.169 0)",
  yellow5: "color(display-p3 0.255 0.209 0)",
  yellow6: "color(display-p3 0.31 0.261 0.07)",
  yellow7: "color(display-p3 0.389 0.331 0.135)",
  yellow8: "color(display-p3 0.497 0.42 0.182)",
  yellow9: "color(display-p3 1 0.92 0.22)",
  yellow10: "color(display-p3 1 1 0.456)",
  yellow11: "color(display-p3 0.948 0.885 0.392)",
  yellow12: "color(display-p3 0.959 0.934 0.731)"
};
const yellowDarkP3A = {
  yellowA1: "color(display-p3 0.973 0.369 0 / 0.013)",
  yellowA2: "color(display-p3 0.996 0.792 0 / 0.038)",
  yellowA3: "color(display-p3 0.996 0.71 0 / 0.11)",
  yellowA4: "color(display-p3 0.996 0.741 0 / 0.152)",
  yellowA5: "color(display-p3 0.996 0.765 0 / 0.202)",
  yellowA6: "color(display-p3 0.996 0.816 0.082 / 0.261)",
  yellowA7: "color(display-p3 1 0.831 0.263 / 0.345)",
  yellowA8: "color(display-p3 1 0.831 0.314 / 0.463)",
  yellowA9: "color(display-p3 1 0.922 0.22)",
  yellowA10: "color(display-p3 1 1 0.455)",
  yellowA11: "color(display-p3 0.948 0.885 0.392)",
  yellowA12: "color(display-p3 0.959 0.934 0.731)"
};
const amberDark = {
  amber1: "#16120c",
  amber2: "#1d180f",
  amber3: "#302008",
  amber4: "#3f2700",
  amber5: "#4d3000",
  amber6: "#5c3d05",
  amber7: "#714f19",
  amber8: "#8f6424",
  amber9: "#ffc53d",
  amber10: "#ffd60a",
  amber11: "#ffca16",
  amber12: "#ffe7b3"
};
const amberDarkA = {
  amberA1: "#e63c0006",
  amberA2: "#fd9b000d",
  amberA3: "#fa820022",
  amberA4: "#fc820032",
  amberA5: "#fd8b0041",
  amberA6: "#fd9b0051",
  amberA7: "#ffab2567",
  amberA8: "#ffae3587",
  amberA9: "#ffc53d",
  amberA10: "#ffd60a",
  amberA11: "#ffca16",
  amberA12: "#ffe7b3"
};
const amberDarkP3 = {
  amber1: "color(display-p3 0.082 0.07 0.05)",
  amber2: "color(display-p3 0.111 0.094 0.064)",
  amber3: "color(display-p3 0.178 0.128 0.049)",
  amber4: "color(display-p3 0.239 0.156 0)",
  amber5: "color(display-p3 0.29 0.193 0)",
  amber6: "color(display-p3 0.344 0.245 0.076)",
  amber7: "color(display-p3 0.422 0.314 0.141)",
  amber8: "color(display-p3 0.535 0.399 0.189)",
  amber9: "color(display-p3 1 0.77 0.26)",
  amber10: "color(display-p3 1 0.87 0.15)",
  amber11: "color(display-p3 1 0.8 0.29)",
  amber12: "color(display-p3 0.984 0.909 0.726)"
};
const amberDarkP3A = {
  amberA1: "color(display-p3 0.992 0.298 0 / 0.017)",
  amberA2: "color(display-p3 0.988 0.651 0 / 0.047)",
  amberA3: "color(display-p3 1 0.6 0 / 0.118)",
  amberA4: "color(display-p3 1 0.557 0 / 0.185)",
  amberA5: "color(display-p3 1 0.592 0 / 0.24)",
  amberA6: "color(display-p3 1 0.659 0.094 / 0.299)",
  amberA7: "color(display-p3 1 0.714 0.263 / 0.383)",
  amberA8: "color(display-p3 0.996 0.729 0.306 / 0.5)",
  amberA9: "color(display-p3 1 0.769 0.259)",
  amberA10: "color(display-p3 1 0.871 0.149)",
  amberA11: "color(display-p3 1 0.8 0.29)",
  amberA12: "color(display-p3 0.984 0.909 0.726)"
};
const orangeDark = {
  orange1: "#17120e",
  orange2: "#1e160f",
  orange3: "#331e0b",
  orange4: "#462100",
  orange5: "#562800",
  orange6: "#66350c",
  orange7: "#7e451d",
  orange8: "#a35829",
  orange9: "#f76b15",
  orange10: "#ff801f",
  orange11: "#ffa057",
  orange12: "#ffe0c2"
};
const orangeDarkA = {
  orangeA1: "#ec360007",
  orangeA2: "#fe6d000e",
  orangeA3: "#fb6a0025",
  orangeA4: "#ff590039",
  orangeA5: "#ff61004a",
  orangeA6: "#fd75045c",
  orangeA7: "#ff832c75",
  orangeA8: "#fe84389d",
  orangeA9: "#fe6d15f7",
  orangeA10: "#ff801f",
  orangeA11: "#ffa057",
  orangeA12: "#ffe0c2"
};
const orangeDarkP3 = {
  orange1: "color(display-p3 0.088 0.07 0.057)",
  orange2: "color(display-p3 0.113 0.089 0.061)",
  orange3: "color(display-p3 0.189 0.12 0.056)",
  orange4: "color(display-p3 0.262 0.132 0)",
  orange5: "color(display-p3 0.315 0.168 0.016)",
  orange6: "color(display-p3 0.376 0.219 0.088)",
  orange7: "color(display-p3 0.465 0.283 0.147)",
  orange8: "color(display-p3 0.601 0.359 0.201)",
  orange9: "color(display-p3 0.9 0.45 0.2)",
  orange10: "color(display-p3 0.98 0.51 0.23)",
  orange11: "color(display-p3 1 0.63 0.38)",
  orange12: "color(display-p3 0.98 0.883 0.775)"
};
const orangeDarkP3A = {
  orangeA1: "color(display-p3 0.961 0.247 0 / 0.022)",
  orangeA2: "color(display-p3 0.992 0.529 0 / 0.051)",
  orangeA3: "color(display-p3 0.996 0.486 0 / 0.131)",
  orangeA4: "color(display-p3 0.996 0.384 0 / 0.211)",
  orangeA5: "color(display-p3 1 0.455 0 / 0.265)",
  orangeA6: "color(display-p3 1 0.529 0.129 / 0.332)",
  orangeA7: "color(display-p3 1 0.569 0.251 / 0.429)",
  orangeA8: "color(display-p3 1 0.584 0.302 / 0.572)",
  orangeA9: "color(display-p3 1 0.494 0.216 / 0.895)",
  orangeA10: "color(display-p3 1 0.522 0.235 / 0.979)",
  orangeA11: "color(display-p3 1 0.63 0.38)",
  orangeA12: "color(display-p3 0.98 0.883 0.775)"
};
const gray = {
  gray1: "#fcfcfc",
  gray2: "#f9f9f9",
  gray3: "#f0f0f0",
  gray4: "#e8e8e8",
  gray5: "#e0e0e0",
  gray6: "#d9d9d9",
  gray7: "#cecece",
  gray8: "#bbbbbb",
  gray9: "#8d8d8d",
  gray10: "#838383",
  gray11: "#646464",
  gray12: "#202020"
};
const grayA = {
  grayA1: "#00000003",
  grayA2: "#00000006",
  grayA3: "#0000000f",
  grayA4: "#00000017",
  grayA5: "#0000001f",
  grayA6: "#00000026",
  grayA7: "#00000031",
  grayA8: "#00000044",
  grayA9: "#00000072",
  grayA10: "#0000007c",
  grayA11: "#0000009b",
  grayA12: "#000000df"
};
const grayP3 = {
  gray1: "color(display-p3 0.988 0.988 0.988)",
  gray2: "color(display-p3 0.975 0.975 0.975)",
  gray3: "color(display-p3 0.939 0.939 0.939)",
  gray4: "color(display-p3 0.908 0.908 0.908)",
  gray5: "color(display-p3 0.88 0.88 0.88)",
  gray6: "color(display-p3 0.849 0.849 0.849)",
  gray7: "color(display-p3 0.807 0.807 0.807)",
  gray8: "color(display-p3 0.732 0.732 0.732)",
  gray9: "color(display-p3 0.553 0.553 0.553)",
  gray10: "color(display-p3 0.512 0.512 0.512)",
  gray11: "color(display-p3 0.392 0.392 0.392)",
  gray12: "color(display-p3 0.125 0.125 0.125)"
};
const grayP3A = {
  grayA1: "color(display-p3 0 0 0 / 0.012)",
  grayA2: "color(display-p3 0 0 0 / 0.024)",
  grayA3: "color(display-p3 0 0 0 / 0.063)",
  grayA4: "color(display-p3 0 0 0 / 0.09)",
  grayA5: "color(display-p3 0 0 0 / 0.122)",
  grayA6: "color(display-p3 0 0 0 / 0.153)",
  grayA7: "color(display-p3 0 0 0 / 0.192)",
  grayA8: "color(display-p3 0 0 0 / 0.267)",
  grayA9: "color(display-p3 0 0 0 / 0.447)",
  grayA10: "color(display-p3 0 0 0 / 0.486)",
  grayA11: "color(display-p3 0 0 0 / 0.608)",
  grayA12: "color(display-p3 0 0 0 / 0.875)"
};
const mauve = {
  mauve1: "#fdfcfd",
  mauve2: "#faf9fb",
  mauve3: "#f2eff3",
  mauve4: "#eae7ec",
  mauve5: "#e3dfe6",
  mauve6: "#dbd8e0",
  mauve7: "#d0cdd7",
  mauve8: "#bcbac7",
  mauve9: "#8e8c99",
  mauve10: "#84828e",
  mauve11: "#65636d",
  mauve12: "#211f26"
};
const mauveA = {
  mauveA1: "#55005503",
  mauveA2: "#2b005506",
  mauveA3: "#30004010",
  mauveA4: "#20003618",
  mauveA5: "#20003820",
  mauveA6: "#14003527",
  mauveA7: "#10003332",
  mauveA8: "#08003145",
  mauveA9: "#05001d73",
  mauveA10: "#0500197d",
  mauveA11: "#0400119c",
  mauveA12: "#020008e0"
};
const mauveP3 = {
  mauve1: "color(display-p3 0.991 0.988 0.992)",
  mauve2: "color(display-p3 0.98 0.976 0.984)",
  mauve3: "color(display-p3 0.946 0.938 0.952)",
  mauve4: "color(display-p3 0.915 0.906 0.925)",
  mauve5: "color(display-p3 0.886 0.876 0.901)",
  mauve6: "color(display-p3 0.856 0.846 0.875)",
  mauve7: "color(display-p3 0.814 0.804 0.84)",
  mauve8: "color(display-p3 0.735 0.728 0.777)",
  mauve9: "color(display-p3 0.555 0.549 0.596)",
  mauve10: "color(display-p3 0.514 0.508 0.552)",
  mauve11: "color(display-p3 0.395 0.388 0.424)",
  mauve12: "color(display-p3 0.128 0.122 0.147)"
};
const mauveP3A = {
  mauveA1: "color(display-p3 0.349 0.024 0.349 / 0.012)",
  mauveA2: "color(display-p3 0.184 0.024 0.349 / 0.024)",
  mauveA3: "color(display-p3 0.129 0.008 0.255 / 0.063)",
  mauveA4: "color(display-p3 0.094 0.012 0.216 / 0.095)",
  mauveA5: "color(display-p3 0.098 0.008 0.224 / 0.126)",
  mauveA6: "color(display-p3 0.055 0.004 0.18 / 0.153)",
  mauveA7: "color(display-p3 0.067 0.008 0.184 / 0.197)",
  mauveA8: "color(display-p3 0.02 0.004 0.176 / 0.271)",
  mauveA9: "color(display-p3 0.02 0.004 0.106 / 0.451)",
  mauveA10: "color(display-p3 0.012 0.004 0.09 / 0.491)",
  mauveA11: "color(display-p3 0.016 0 0.059 / 0.612)",
  mauveA12: "color(display-p3 0.008 0 0.027 / 0.879)"
};
const slate = {
  slate1: "#fcfcfd",
  slate2: "#f9f9fb",
  slate3: "#f0f0f3",
  slate4: "#e8e8ec",
  slate5: "#e0e1e6",
  slate6: "#d9d9e0",
  slate7: "#cdced6",
  slate8: "#b9bbc6",
  slate9: "#8b8d98",
  slate10: "#80838d",
  slate11: "#60646c",
  slate12: "#1c2024"
};
const slateA = {
  slateA1: "#00005503",
  slateA2: "#00005506",
  slateA3: "#0000330f",
  slateA4: "#00002d17",
  slateA5: "#0009321f",
  slateA6: "#00002f26",
  slateA7: "#00062e32",
  slateA8: "#00083046",
  slateA9: "#00051d74",
  slateA10: "#00071b7f",
  slateA11: "#0007149f",
  slateA12: "#000509e3"
};
const slateP3 = {
  slate1: "color(display-p3 0.988 0.988 0.992)",
  slate2: "color(display-p3 0.976 0.976 0.984)",
  slate3: "color(display-p3 0.94 0.941 0.953)",
  slate4: "color(display-p3 0.908 0.909 0.925)",
  slate5: "color(display-p3 0.88 0.881 0.901)",
  slate6: "color(display-p3 0.85 0.852 0.876)",
  slate7: "color(display-p3 0.805 0.808 0.838)",
  slate8: "color(display-p3 0.727 0.733 0.773)",
  slate9: "color(display-p3 0.547 0.553 0.592)",
  slate10: "color(display-p3 0.503 0.512 0.549)",
  slate11: "color(display-p3 0.379 0.392 0.421)",
  slate12: "color(display-p3 0.113 0.125 0.14)"
};
const slateP3A = {
  slateA1: "color(display-p3 0.024 0.024 0.349 / 0.012)",
  slateA2: "color(display-p3 0.024 0.024 0.349 / 0.024)",
  slateA3: "color(display-p3 0.004 0.004 0.204 / 0.059)",
  slateA4: "color(display-p3 0.012 0.012 0.184 / 0.091)",
  slateA5: "color(display-p3 0.004 0.039 0.2 / 0.122)",
  slateA6: "color(display-p3 0.008 0.008 0.165 / 0.15)",
  slateA7: "color(display-p3 0.008 0.027 0.184 / 0.197)",
  slateA8: "color(display-p3 0.004 0.031 0.176 / 0.275)",
  slateA9: "color(display-p3 0.004 0.02 0.106 / 0.455)",
  slateA10: "color(display-p3 0.004 0.027 0.098 / 0.499)",
  slateA11: "color(display-p3 0 0.02 0.063 / 0.62)",
  slateA12: "color(display-p3 0 0.012 0.031 / 0.887)"
};
const sage = {
  sage1: "#fbfdfc",
  sage2: "#f7f9f8",
  sage3: "#eef1f0",
  sage4: "#e6e9e8",
  sage5: "#dfe2e0",
  sage6: "#d7dad9",
  sage7: "#cbcfcd",
  sage8: "#b8bcba",
  sage9: "#868e8b",
  sage10: "#7c8481",
  sage11: "#5f6563",
  sage12: "#1a211e"
};
const sageA = {
  sageA1: "#00804004",
  sageA2: "#00402008",
  sageA3: "#002d1e11",
  sageA4: "#001f1519",
  sageA5: "#00180820",
  sageA6: "#00140d28",
  sageA7: "#00140a34",
  sageA8: "#000f0847",
  sageA9: "#00110b79",
  sageA10: "#00100a83",
  sageA11: "#000a07a0",
  sageA12: "#000805e5"
};
const sageP3 = {
  sage1: "color(display-p3 0.986 0.992 0.988)",
  sage2: "color(display-p3 0.97 0.977 0.974)",
  sage3: "color(display-p3 0.935 0.944 0.94)",
  sage4: "color(display-p3 0.904 0.913 0.909)",
  sage5: "color(display-p3 0.875 0.885 0.88)",
  sage6: "color(display-p3 0.844 0.854 0.849)",
  sage7: "color(display-p3 0.8 0.811 0.806)",
  sage8: "color(display-p3 0.725 0.738 0.732)",
  sage9: "color(display-p3 0.531 0.556 0.546)",
  sage10: "color(display-p3 0.492 0.515 0.506)",
  sage11: "color(display-p3 0.377 0.395 0.389)",
  sage12: "color(display-p3 0.107 0.129 0.118)"
};
const sageP3A = {
  sageA1: "color(display-p3 0.024 0.514 0.267 / 0.016)",
  sageA2: "color(display-p3 0.02 0.267 0.145 / 0.032)",
  sageA3: "color(display-p3 0.008 0.184 0.125 / 0.067)",
  sageA4: "color(display-p3 0.012 0.094 0.051 / 0.095)",
  sageA5: "color(display-p3 0.008 0.098 0.035 / 0.126)",
  sageA6: "color(display-p3 0.004 0.078 0.027 / 0.157)",
  sageA7: "color(display-p3 0 0.059 0.039 / 0.2)",
  sageA8: "color(display-p3 0.004 0.047 0.031 / 0.275)",
  sageA9: "color(display-p3 0.004 0.059 0.035 / 0.471)",
  sageA10: "color(display-p3 0 0.047 0.031 / 0.51)",
  sageA11: "color(display-p3 0 0.031 0.02 / 0.624)",
  sageA12: "color(display-p3 0 0.027 0.012 / 0.895)"
};
const olive = {
  olive1: "#fcfdfc",
  olive2: "#f8faf8",
  olive3: "#eff1ef",
  olive4: "#e7e9e7",
  olive5: "#dfe2df",
  olive6: "#d7dad7",
  olive7: "#cccfcc",
  olive8: "#b9bcb8",
  olive9: "#898e87",
  olive10: "#7f847d",
  olive11: "#60655f",
  olive12: "#1d211c"
};
const oliveA = {
  oliveA1: "#00550003",
  oliveA2: "#00490007",
  oliveA3: "#00200010",
  oliveA4: "#00160018",
  oliveA5: "#00180020",
  oliveA6: "#00140028",
  oliveA7: "#000f0033",
  oliveA8: "#040f0047",
  oliveA9: "#050f0078",
  oliveA10: "#040e0082",
  oliveA11: "#020a00a0",
  oliveA12: "#010600e3"
};
const oliveP3 = {
  olive1: "color(display-p3 0.989 0.992 0.989)",
  olive2: "color(display-p3 0.974 0.98 0.973)",
  olive3: "color(display-p3 0.939 0.945 0.937)",
  olive4: "color(display-p3 0.907 0.914 0.905)",
  olive5: "color(display-p3 0.878 0.885 0.875)",
  olive6: "color(display-p3 0.846 0.855 0.843)",
  olive7: "color(display-p3 0.803 0.812 0.8)",
  olive8: "color(display-p3 0.727 0.738 0.723)",
  olive9: "color(display-p3 0.541 0.556 0.532)",
  olive10: "color(display-p3 0.5 0.515 0.491)",
  olive11: "color(display-p3 0.38 0.395 0.374)",
  olive12: "color(display-p3 0.117 0.129 0.111)"
};
const oliveP3A = {
  oliveA1: "color(display-p3 0.024 0.349 0.024 / 0.012)",
  oliveA2: "color(display-p3 0.024 0.302 0.024 / 0.028)",
  oliveA3: "color(display-p3 0.008 0.129 0.008 / 0.063)",
  oliveA4: "color(display-p3 0.012 0.094 0.012 / 0.095)",
  oliveA5: "color(display-p3 0.035 0.098 0.008 / 0.126)",
  oliveA6: "color(display-p3 0.027 0.078 0.004 / 0.157)",
  oliveA7: "color(display-p3 0.02 0.059 0 / 0.2)",
  oliveA8: "color(display-p3 0.02 0.059 0.004 / 0.279)",
  oliveA9: "color(display-p3 0.02 0.051 0.004 / 0.467)",
  oliveA10: "color(display-p3 0.024 0.047 0 / 0.51)",
  oliveA11: "color(display-p3 0.012 0.039 0 / 0.628)",
  oliveA12: "color(display-p3 0.008 0.024 0 / 0.891)"
};
const sand = {
  sand1: "#fdfdfc",
  sand2: "#f9f9f8",
  sand3: "#f1f0ef",
  sand4: "#e9e8e6",
  sand5: "#e2e1de",
  sand6: "#dad9d6",
  sand7: "#cfceca",
  sand8: "#bcbbb5",
  sand9: "#8d8d86",
  sand10: "#82827c",
  sand11: "#63635e",
  sand12: "#21201c"
};
const sandA = {
  sandA1: "#55550003",
  sandA2: "#25250007",
  sandA3: "#20100010",
  sandA4: "#1f150019",
  sandA5: "#1f180021",
  sandA6: "#19130029",
  sandA7: "#19140035",
  sandA8: "#1915014a",
  sandA9: "#0f0f0079",
  sandA10: "#0c0c0083",
  sandA11: "#080800a1",
  sandA12: "#060500e3"
};
const sandP3 = {
  sand1: "color(display-p3 0.992 0.992 0.989)",
  sand2: "color(display-p3 0.977 0.977 0.973)",
  sand3: "color(display-p3 0.943 0.942 0.936)",
  sand4: "color(display-p3 0.913 0.912 0.903)",
  sand5: "color(display-p3 0.885 0.883 0.873)",
  sand6: "color(display-p3 0.854 0.852 0.839)",
  sand7: "color(display-p3 0.813 0.81 0.794)",
  sand8: "color(display-p3 0.738 0.734 0.713)",
  sand9: "color(display-p3 0.553 0.553 0.528)",
  sand10: "color(display-p3 0.511 0.511 0.488)",
  sand11: "color(display-p3 0.388 0.388 0.37)",
  sand12: "color(display-p3 0.129 0.126 0.111)"
};
const sandP3A = {
  sandA1: "color(display-p3 0.349 0.349 0.024 / 0.012)",
  sandA2: "color(display-p3 0.161 0.161 0.024 / 0.028)",
  sandA3: "color(display-p3 0.067 0.067 0.008 / 0.063)",
  sandA4: "color(display-p3 0.129 0.129 0.012 / 0.099)",
  sandA5: "color(display-p3 0.098 0.067 0.008 / 0.126)",
  sandA6: "color(display-p3 0.102 0.075 0.004 / 0.161)",
  sandA7: "color(display-p3 0.098 0.098 0.004 / 0.208)",
  sandA8: "color(display-p3 0.086 0.075 0.004 / 0.287)",
  sandA9: "color(display-p3 0.051 0.051 0.004 / 0.471)",
  sandA10: "color(display-p3 0.047 0.047 0 / 0.514)",
  sandA11: "color(display-p3 0.031 0.031 0 / 0.632)",
  sandA12: "color(display-p3 0.024 0.02 0 / 0.891)"
};
const tomato = {
  tomato1: "#fffcfc",
  tomato2: "#fff8f7",
  tomato3: "#feebe7",
  tomato4: "#ffdcd3",
  tomato5: "#ffcdc2",
  tomato6: "#fdbdaf",
  tomato7: "#f5a898",
  tomato8: "#ec8e7b",
  tomato9: "#e54d2e",
  tomato10: "#dd4425",
  tomato11: "#d13415",
  tomato12: "#5c271f"
};
const tomatoA = {
  tomatoA1: "#ff000003",
  tomatoA2: "#ff200008",
  tomatoA3: "#f52b0018",
  tomatoA4: "#ff35002c",
  tomatoA5: "#ff2e003d",
  tomatoA6: "#f92d0050",
  tomatoA7: "#e7280067",
  tomatoA8: "#db250084",
  tomatoA9: "#df2600d1",
  tomatoA10: "#d72400da",
  tomatoA11: "#cd2200ea",
  tomatoA12: "#460900e0"
};
const tomatoP3 = {
  tomato1: "color(display-p3 0.998 0.989 0.988)",
  tomato2: "color(display-p3 0.994 0.974 0.969)",
  tomato3: "color(display-p3 0.985 0.924 0.909)",
  tomato4: "color(display-p3 0.996 0.868 0.835)",
  tomato5: "color(display-p3 0.98 0.812 0.77)",
  tomato6: "color(display-p3 0.953 0.75 0.698)",
  tomato7: "color(display-p3 0.917 0.673 0.611)",
  tomato8: "color(display-p3 0.875 0.575 0.502)",
  tomato9: "color(display-p3 0.831 0.345 0.231)",
  tomato10: "color(display-p3 0.802 0.313 0.2)",
  tomato11: "color(display-p3 0.755 0.259 0.152)",
  tomato12: "color(display-p3 0.335 0.165 0.132)"
};
const tomatoP3A = {
  tomatoA1: "color(display-p3 0.675 0.024 0.024 / 0.012)",
  tomatoA2: "color(display-p3 0.757 0.145 0.02 / 0.032)",
  tomatoA3: "color(display-p3 0.831 0.184 0.012 / 0.091)",
  tomatoA4: "color(display-p3 0.976 0.192 0.004 / 0.165)",
  tomatoA5: "color(display-p3 0.918 0.192 0.004 / 0.232)",
  tomatoA6: "color(display-p3 0.847 0.173 0.004 / 0.302)",
  tomatoA7: "color(display-p3 0.788 0.165 0.004 / 0.389)",
  tomatoA8: "color(display-p3 0.749 0.153 0.004 / 0.499)",
  tomatoA9: "color(display-p3 0.78 0.149 0 / 0.769)",
  tomatoA10: "color(display-p3 0.757 0.141 0 / 0.8)",
  tomatoA11: "color(display-p3 0.755 0.259 0.152)",
  tomatoA12: "color(display-p3 0.335 0.165 0.132)"
};
const red = {
  red1: "#fffcfc",
  red2: "#fff7f7",
  red3: "#feebec",
  red4: "#ffdbdc",
  red5: "#ffcdce",
  red6: "#fdbdbe",
  red7: "#f4a9aa",
  red8: "#eb8e90",
  red9: "#e5484d",
  red10: "#dc3e42",
  red11: "#ce2c31",
  red12: "#641723"
};
const redA = {
  redA1: "#ff000003",
  redA2: "#ff000008",
  redA3: "#f3000d14",
  redA4: "#ff000824",
  redA5: "#ff000632",
  redA6: "#f8000442",
  redA7: "#df000356",
  redA8: "#d2000571",
  redA9: "#db0007b7",
  redA10: "#d10005c1",
  redA11: "#c40006d3",
  redA12: "#55000de8"
};
const redP3 = {
  red1: "color(display-p3 0.998 0.989 0.988)",
  red2: "color(display-p3 0.995 0.971 0.971)",
  red3: "color(display-p3 0.985 0.925 0.925)",
  red4: "color(display-p3 0.999 0.866 0.866)",
  red5: "color(display-p3 0.984 0.812 0.811)",
  red6: "color(display-p3 0.955 0.751 0.749)",
  red7: "color(display-p3 0.915 0.675 0.672)",
  red8: "color(display-p3 0.872 0.575 0.572)",
  red9: "color(display-p3 0.83 0.329 0.324)",
  red10: "color(display-p3 0.798 0.294 0.285)",
  red11: "color(display-p3 0.744 0.234 0.222)",
  red12: "color(display-p3 0.36 0.115 0.143)"
};
const redP3A = {
  redA1: "color(display-p3 0.675 0.024 0.024 / 0.012)",
  redA2: "color(display-p3 0.863 0.024 0.024 / 0.028)",
  redA3: "color(display-p3 0.792 0.008 0.008 / 0.075)",
  redA4: "color(display-p3 1 0.008 0.008 / 0.134)",
  redA5: "color(display-p3 0.918 0.008 0.008 / 0.189)",
  redA6: "color(display-p3 0.831 0.02 0.004 / 0.251)",
  redA7: "color(display-p3 0.741 0.016 0.004 / 0.33)",
  redA8: "color(display-p3 0.698 0.012 0.004 / 0.428)",
  redA9: "color(display-p3 0.749 0.008 0 / 0.675)",
  redA10: "color(display-p3 0.714 0.012 0 / 0.714)",
  redA11: "color(display-p3 0.744 0.234 0.222)",
  redA12: "color(display-p3 0.36 0.115 0.143)"
};
const ruby = {
  ruby1: "#fffcfd",
  ruby2: "#fff7f8",
  ruby3: "#feeaed",
  ruby4: "#ffdce1",
  ruby5: "#ffced6",
  ruby6: "#f8bfc8",
  ruby7: "#efacb8",
  ruby8: "#e592a3",
  ruby9: "#e54666",
  ruby10: "#dc3b5d",
  ruby11: "#ca244d",
  ruby12: "#64172b"
};
const rubyA = {
  rubyA1: "#ff005503",
  rubyA2: "#ff002008",
  rubyA3: "#f3002515",
  rubyA4: "#ff002523",
  rubyA5: "#ff002a31",
  rubyA6: "#e4002440",
  rubyA7: "#ce002553",
  rubyA8: "#c300286d",
  rubyA9: "#db002cb9",
  rubyA10: "#d2002cc4",
  rubyA11: "#c10030db",
  rubyA12: "#550016e8"
};
const rubyP3 = {
  ruby1: "color(display-p3 0.998 0.989 0.992)",
  ruby2: "color(display-p3 0.995 0.971 0.974)",
  ruby3: "color(display-p3 0.983 0.92 0.928)",
  ruby4: "color(display-p3 0.987 0.869 0.885)",
  ruby5: "color(display-p3 0.968 0.817 0.839)",
  ruby6: "color(display-p3 0.937 0.758 0.786)",
  ruby7: "color(display-p3 0.897 0.685 0.721)",
  ruby8: "color(display-p3 0.851 0.588 0.639)",
  ruby9: "color(display-p3 0.83 0.323 0.408)",
  ruby10: "color(display-p3 0.795 0.286 0.375)",
  ruby11: "color(display-p3 0.728 0.211 0.311)",
  ruby12: "color(display-p3 0.36 0.115 0.171)"
};
const rubyP3A = {
  rubyA1: "color(display-p3 0.675 0.024 0.349 / 0.012)",
  rubyA2: "color(display-p3 0.863 0.024 0.024 / 0.028)",
  rubyA3: "color(display-p3 0.804 0.008 0.11 / 0.079)",
  rubyA4: "color(display-p3 0.91 0.008 0.125 / 0.13)",
  rubyA5: "color(display-p3 0.831 0.004 0.133 / 0.185)",
  rubyA6: "color(display-p3 0.745 0.004 0.118 / 0.244)",
  rubyA7: "color(display-p3 0.678 0.004 0.114 / 0.314)",
  rubyA8: "color(display-p3 0.639 0.004 0.125 / 0.412)",
  rubyA9: "color(display-p3 0.753 0 0.129 / 0.679)",
  rubyA10: "color(display-p3 0.714 0 0.125 / 0.714)",
  rubyA11: "color(display-p3 0.728 0.211 0.311)",
  rubyA12: "color(display-p3 0.36 0.115 0.171)"
};
const crimson = {
  crimson1: "#fffcfd",
  crimson2: "#fef7f9",
  crimson3: "#ffe9f0",
  crimson4: "#fedce7",
  crimson5: "#facedd",
  crimson6: "#f3bed1",
  crimson7: "#eaacc3",
  crimson8: "#e093b2",
  crimson9: "#e93d82",
  crimson10: "#df3478",
  crimson11: "#cb1d63",
  crimson12: "#621639"
};
const crimsonA = {
  crimsonA1: "#ff005503",
  crimsonA2: "#e0004008",
  crimsonA3: "#ff005216",
  crimsonA4: "#f8005123",
  crimsonA5: "#e5004f31",
  crimsonA6: "#d0004b41",
  crimsonA7: "#bf004753",
  crimsonA8: "#b6004a6c",
  crimsonA9: "#e2005bc2",
  crimsonA10: "#d70056cb",
  crimsonA11: "#c4004fe2",
  crimsonA12: "#530026e9"
};
const crimsonP3 = {
  crimson1: "color(display-p3 0.998 0.989 0.992)",
  crimson2: "color(display-p3 0.991 0.969 0.976)",
  crimson3: "color(display-p3 0.987 0.917 0.941)",
  crimson4: "color(display-p3 0.975 0.866 0.904)",
  crimson5: "color(display-p3 0.953 0.813 0.864)",
  crimson6: "color(display-p3 0.921 0.755 0.817)",
  crimson7: "color(display-p3 0.88 0.683 0.761)",
  crimson8: "color(display-p3 0.834 0.592 0.694)",
  crimson9: "color(display-p3 0.843 0.298 0.507)",
  crimson10: "color(display-p3 0.807 0.266 0.468)",
  crimson11: "color(display-p3 0.731 0.195 0.388)",
  crimson12: "color(display-p3 0.352 0.111 0.221)"
};
const crimsonP3A = {
  crimsonA1: "color(display-p3 0.675 0.024 0.349 / 0.012)",
  crimsonA2: "color(display-p3 0.757 0.02 0.267 / 0.032)",
  crimsonA3: "color(display-p3 0.859 0.008 0.294 / 0.083)",
  crimsonA4: "color(display-p3 0.827 0.008 0.298 / 0.134)",
  crimsonA5: "color(display-p3 0.753 0.008 0.275 / 0.189)",
  crimsonA6: "color(display-p3 0.682 0.004 0.247 / 0.244)",
  crimsonA7: "color(display-p3 0.62 0.004 0.251 / 0.318)",
  crimsonA8: "color(display-p3 0.6 0.004 0.251 / 0.408)",
  crimsonA9: "color(display-p3 0.776 0 0.298 / 0.702)",
  crimsonA10: "color(display-p3 0.737 0 0.275 / 0.734)",
  crimsonA11: "color(display-p3 0.731 0.195 0.388)",
  crimsonA12: "color(display-p3 0.352 0.111 0.221)"
};
const pink = {
  pink1: "#fffcfe",
  pink2: "#fef7fb",
  pink3: "#fee9f5",
  pink4: "#fbdcef",
  pink5: "#f6cee7",
  pink6: "#efbfdd",
  pink7: "#e7acd0",
  pink8: "#dd93c2",
  pink9: "#d6409f",
  pink10: "#cf3897",
  pink11: "#c2298a",
  pink12: "#651249"
};
const pinkA = {
  pinkA1: "#ff00aa03",
  pinkA2: "#e0008008",
  pinkA3: "#f4008c16",
  pinkA4: "#e2008b23",
  pinkA5: "#d1008331",
  pinkA6: "#c0007840",
  pinkA7: "#b6006f53",
  pinkA8: "#af006f6c",
  pinkA9: "#c8007fbf",
  pinkA10: "#c2007ac7",
  pinkA11: "#b60074d6",
  pinkA12: "#59003bed"
};
const pinkP3 = {
  pink1: "color(display-p3 0.998 0.989 0.996)",
  pink2: "color(display-p3 0.992 0.97 0.985)",
  pink3: "color(display-p3 0.981 0.917 0.96)",
  pink4: "color(display-p3 0.963 0.867 0.932)",
  pink5: "color(display-p3 0.939 0.815 0.899)",
  pink6: "color(display-p3 0.907 0.756 0.859)",
  pink7: "color(display-p3 0.869 0.683 0.81)",
  pink8: "color(display-p3 0.825 0.59 0.751)",
  pink9: "color(display-p3 0.775 0.297 0.61)",
  pink10: "color(display-p3 0.748 0.27 0.581)",
  pink11: "color(display-p3 0.698 0.219 0.528)",
  pink12: "color(display-p3 0.363 0.101 0.279)"
};
const pinkP3A = {
  pinkA1: "color(display-p3 0.675 0.024 0.675 / 0.012)",
  pinkA2: "color(display-p3 0.757 0.02 0.51 / 0.032)",
  pinkA3: "color(display-p3 0.765 0.008 0.529 / 0.083)",
  pinkA4: "color(display-p3 0.737 0.008 0.506 / 0.134)",
  pinkA5: "color(display-p3 0.663 0.004 0.451 / 0.185)",
  pinkA6: "color(display-p3 0.616 0.004 0.424 / 0.244)",
  pinkA7: "color(display-p3 0.596 0.004 0.412 / 0.318)",
  pinkA8: "color(display-p3 0.573 0.004 0.404 / 0.412)",
  pinkA9: "color(display-p3 0.682 0 0.447 / 0.702)",
  pinkA10: "color(display-p3 0.655 0 0.424 / 0.73)",
  pinkA11: "color(display-p3 0.698 0.219 0.528)",
  pinkA12: "color(display-p3 0.363 0.101 0.279)"
};
const plum = {
  plum1: "#fefcff",
  plum2: "#fdf7fd",
  plum3: "#fbebfb",
  plum4: "#f7def8",
  plum5: "#f2d1f3",
  plum6: "#e9c2ec",
  plum7: "#deade3",
  plum8: "#cf91d8",
  plum9: "#ab4aba",
  plum10: "#a144af",
  plum11: "#953ea3",
  plum12: "#53195d"
};
const plumA = {
  plumA1: "#aa00ff03",
  plumA2: "#c000c008",
  plumA3: "#cc00cc14",
  plumA4: "#c200c921",
  plumA5: "#b700bd2e",
  plumA6: "#a400b03d",
  plumA7: "#9900a852",
  plumA8: "#9000a56e",
  plumA9: "#89009eb5",
  plumA10: "#7f0092bb",
  plumA11: "#730086c1",
  plumA12: "#40004be6"
};
const plumP3 = {
  plum1: "color(display-p3 0.995 0.988 0.999)",
  plum2: "color(display-p3 0.988 0.971 0.99)",
  plum3: "color(display-p3 0.973 0.923 0.98)",
  plum4: "color(display-p3 0.953 0.875 0.966)",
  plum5: "color(display-p3 0.926 0.825 0.945)",
  plum6: "color(display-p3 0.89 0.765 0.916)",
  plum7: "color(display-p3 0.84 0.686 0.877)",
  plum8: "color(display-p3 0.775 0.58 0.832)",
  plum9: "color(display-p3 0.624 0.313 0.708)",
  plum10: "color(display-p3 0.587 0.29 0.667)",
  plum11: "color(display-p3 0.543 0.263 0.619)",
  plum12: "color(display-p3 0.299 0.114 0.352)"
};
const plumP3A = {
  plumA1: "color(display-p3 0.675 0.024 1 / 0.012)",
  plumA2: "color(display-p3 0.58 0.024 0.58 / 0.028)",
  plumA3: "color(display-p3 0.655 0.008 0.753 / 0.079)",
  plumA4: "color(display-p3 0.627 0.008 0.722 / 0.126)",
  plumA5: "color(display-p3 0.58 0.004 0.69 / 0.177)",
  plumA6: "color(display-p3 0.537 0.004 0.655 / 0.236)",
  plumA7: "color(display-p3 0.49 0.004 0.616 / 0.314)",
  plumA8: "color(display-p3 0.471 0.004 0.6 / 0.42)",
  plumA9: "color(display-p3 0.451 0 0.576 / 0.687)",
  plumA10: "color(display-p3 0.42 0 0.529 / 0.71)",
  plumA11: "color(display-p3 0.543 0.263 0.619)",
  plumA12: "color(display-p3 0.299 0.114 0.352)"
};
const purple = {
  purple1: "#fefcfe",
  purple2: "#fbf7fe",
  purple3: "#f7edfe",
  purple4: "#f2e2fc",
  purple5: "#ead5f9",
  purple6: "#e0c4f4",
  purple7: "#d1afec",
  purple8: "#be93e4",
  purple9: "#8e4ec6",
  purple10: "#8347b9",
  purple11: "#8145b5",
  purple12: "#402060"
};
const purpleA = {
  purpleA1: "#aa00aa03",
  purpleA2: "#8000e008",
  purpleA3: "#8e00f112",
  purpleA4: "#8d00e51d",
  purpleA5: "#8000db2a",
  purpleA6: "#7a01d03b",
  purpleA7: "#6d00c350",
  purpleA8: "#6600c06c",
  purpleA9: "#5c00adb1",
  purpleA10: "#53009eb8",
  purpleA11: "#52009aba",
  purpleA12: "#250049df"
};
const purpleP3 = {
  purple1: "color(display-p3 0.995 0.988 0.996)",
  purple2: "color(display-p3 0.983 0.971 0.993)",
  purple3: "color(display-p3 0.963 0.931 0.989)",
  purple4: "color(display-p3 0.937 0.888 0.981)",
  purple5: "color(display-p3 0.904 0.837 0.966)",
  purple6: "color(display-p3 0.86 0.774 0.942)",
  purple7: "color(display-p3 0.799 0.69 0.91)",
  purple8: "color(display-p3 0.719 0.583 0.874)",
  purple9: "color(display-p3 0.523 0.318 0.751)",
  purple10: "color(display-p3 0.483 0.289 0.7)",
  purple11: "color(display-p3 0.473 0.281 0.687)",
  purple12: "color(display-p3 0.234 0.132 0.363)"
};
const purpleP3A = {
  purpleA1: "color(display-p3 0.675 0.024 0.675 / 0.012)",
  purpleA2: "color(display-p3 0.443 0.024 0.722 / 0.028)",
  purpleA3: "color(display-p3 0.506 0.008 0.835 / 0.071)",
  purpleA4: "color(display-p3 0.451 0.004 0.831 / 0.114)",
  purpleA5: "color(display-p3 0.431 0.004 0.788 / 0.165)",
  purpleA6: "color(display-p3 0.384 0.004 0.745 / 0.228)",
  purpleA7: "color(display-p3 0.357 0.004 0.71 / 0.31)",
  purpleA8: "color(display-p3 0.322 0.004 0.702 / 0.416)",
  purpleA9: "color(display-p3 0.298 0 0.639 / 0.683)",
  purpleA10: "color(display-p3 0.271 0 0.58 / 0.71)",
  purpleA11: "color(display-p3 0.473 0.281 0.687)",
  purpleA12: "color(display-p3 0.234 0.132 0.363)"
};
const violet = {
  violet1: "#fdfcfe",
  violet2: "#faf8ff",
  violet3: "#f4f0fe",
  violet4: "#ebe4ff",
  violet5: "#e1d9ff",
  violet6: "#d4cafe",
  violet7: "#c2b5f5",
  violet8: "#aa99ec",
  violet9: "#6e56cf",
  violet10: "#654dc4",
  violet11: "#6550b9",
  violet12: "#2f265f"
};
const violetA = {
  violetA1: "#5500aa03",
  violetA2: "#4900ff07",
  violetA3: "#4400ee0f",
  violetA4: "#4300ff1b",
  violetA5: "#3600ff26",
  violetA6: "#3100fb35",
  violetA7: "#2d01dd4a",
  violetA8: "#2b00d066",
  violetA9: "#2400b7a9",
  violetA10: "#2300abb2",
  violetA11: "#1f0099af",
  violetA12: "#0b0043d9"
};
const violetP3 = {
  violet1: "color(display-p3 0.991 0.988 0.995)",
  violet2: "color(display-p3 0.978 0.974 0.998)",
  violet3: "color(display-p3 0.953 0.943 0.993)",
  violet4: "color(display-p3 0.916 0.897 1)",
  violet5: "color(display-p3 0.876 0.851 1)",
  violet6: "color(display-p3 0.825 0.793 0.981)",
  violet7: "color(display-p3 0.752 0.712 0.943)",
  violet8: "color(display-p3 0.654 0.602 0.902)",
  violet9: "color(display-p3 0.417 0.341 0.784)",
  violet10: "color(display-p3 0.381 0.306 0.741)",
  violet11: "color(display-p3 0.383 0.317 0.702)",
  violet12: "color(display-p3 0.179 0.15 0.359)"
};
const violetP3A = {
  violetA1: "color(display-p3 0.349 0.024 0.675 / 0.012)",
  violetA2: "color(display-p3 0.161 0.024 0.863 / 0.028)",
  violetA3: "color(display-p3 0.204 0.004 0.871 / 0.059)",
  violetA4: "color(display-p3 0.196 0.004 1 / 0.102)",
  violetA5: "color(display-p3 0.165 0.008 1 / 0.15)",
  violetA6: "color(display-p3 0.153 0.004 0.906 / 0.208)",
  violetA7: "color(display-p3 0.141 0.004 0.796 / 0.287)",
  violetA8: "color(display-p3 0.133 0.004 0.753 / 0.397)",
  violetA9: "color(display-p3 0.114 0 0.675 / 0.659)",
  violetA10: "color(display-p3 0.11 0 0.627 / 0.695)",
  violetA11: "color(display-p3 0.383 0.317 0.702)",
  violetA12: "color(display-p3 0.179 0.15 0.359)"
};
const iris = {
  iris1: "#fdfdff",
  iris2: "#f8f8ff",
  iris3: "#f0f1fe",
  iris4: "#e6e7ff",
  iris5: "#dadcff",
  iris6: "#cbcdff",
  iris7: "#b8baf8",
  iris8: "#9b9ef0",
  iris9: "#5b5bd6",
  iris10: "#5151cd",
  iris11: "#5753c6",
  iris12: "#272962"
};
const irisA = {
  irisA1: "#0000ff02",
  irisA2: "#0000ff07",
  irisA3: "#0011ee0f",
  irisA4: "#000bff19",
  irisA5: "#000eff25",
  irisA6: "#000aff34",
  irisA7: "#0008e647",
  irisA8: "#0008d964",
  irisA9: "#0000c0a4",
  irisA10: "#0000b6ae",
  irisA11: "#0600abac",
  irisA12: "#000246d8"
};
const irisP3 = {
  iris1: "color(display-p3 0.992 0.992 0.999)",
  iris2: "color(display-p3 0.972 0.973 0.998)",
  iris3: "color(display-p3 0.943 0.945 0.992)",
  iris4: "color(display-p3 0.902 0.906 1)",
  iris5: "color(display-p3 0.857 0.861 1)",
  iris6: "color(display-p3 0.799 0.805 0.987)",
  iris7: "color(display-p3 0.721 0.727 0.955)",
  iris8: "color(display-p3 0.61 0.619 0.918)",
  iris9: "color(display-p3 0.357 0.357 0.81)",
  iris10: "color(display-p3 0.318 0.318 0.774)",
  iris11: "color(display-p3 0.337 0.326 0.748)",
  iris12: "color(display-p3 0.154 0.161 0.371)"
};
const irisP3A = {
  irisA1: "color(display-p3 0.02 0.02 1 / 0.008)",
  irisA2: "color(display-p3 0.024 0.024 0.863 / 0.028)",
  irisA3: "color(display-p3 0.004 0.071 0.871 / 0.059)",
  irisA4: "color(display-p3 0.012 0.051 1 / 0.099)",
  irisA5: "color(display-p3 0.008 0.035 1 / 0.142)",
  irisA6: "color(display-p3 0 0.02 0.941 / 0.2)",
  irisA7: "color(display-p3 0.004 0.02 0.847 / 0.279)",
  irisA8: "color(display-p3 0.004 0.024 0.788 / 0.389)",
  irisA9: "color(display-p3 0 0 0.706 / 0.644)",
  irisA10: "color(display-p3 0 0 0.667 / 0.683)",
  irisA11: "color(display-p3 0.337 0.326 0.748)",
  irisA12: "color(display-p3 0.154 0.161 0.371)"
};
const indigo = {
  indigo1: "#fdfdfe",
  indigo2: "#f7f9ff",
  indigo3: "#edf2fe",
  indigo4: "#e1e9ff",
  indigo5: "#d2deff",
  indigo6: "#c1d0ff",
  indigo7: "#abbdf9",
  indigo8: "#8da4ef",
  indigo9: "#3e63dd",
  indigo10: "#3358d4",
  indigo11: "#3a5bc7",
  indigo12: "#1f2d5c"
};
const indigoA = {
  indigoA1: "#00008002",
  indigoA2: "#0040ff08",
  indigoA3: "#0047f112",
  indigoA4: "#0044ff1e",
  indigoA5: "#0044ff2d",
  indigoA6: "#003eff3e",
  indigoA7: "#0037ed54",
  indigoA8: "#0034dc72",
  indigoA9: "#0031d2c1",
  indigoA10: "#002ec9cc",
  indigoA11: "#002bb7c5",
  indigoA12: "#001046e0"
};
const indigoP3 = {
  indigo1: "color(display-p3 0.992 0.992 0.996)",
  indigo2: "color(display-p3 0.971 0.977 0.998)",
  indigo3: "color(display-p3 0.933 0.948 0.992)",
  indigo4: "color(display-p3 0.885 0.914 1)",
  indigo5: "color(display-p3 0.831 0.87 1)",
  indigo6: "color(display-p3 0.767 0.814 0.995)",
  indigo7: "color(display-p3 0.685 0.74 0.957)",
  indigo8: "color(display-p3 0.569 0.639 0.916)",
  indigo9: "color(display-p3 0.276 0.384 0.837)",
  indigo10: "color(display-p3 0.234 0.343 0.801)",
  indigo11: "color(display-p3 0.256 0.354 0.755)",
  indigo12: "color(display-p3 0.133 0.175 0.348)"
};
const indigoP3A = {
  indigoA1: "color(display-p3 0.02 0.02 0.51 / 0.008)",
  indigoA2: "color(display-p3 0.024 0.161 0.863 / 0.028)",
  indigoA3: "color(display-p3 0.008 0.239 0.886 / 0.067)",
  indigoA4: "color(display-p3 0.004 0.247 1 / 0.114)",
  indigoA5: "color(display-p3 0.004 0.235 1 / 0.169)",
  indigoA6: "color(display-p3 0.004 0.208 0.984 / 0.232)",
  indigoA7: "color(display-p3 0.004 0.176 0.863 / 0.314)",
  indigoA8: "color(display-p3 0.004 0.165 0.812 / 0.432)",
  indigoA9: "color(display-p3 0 0.153 0.773 / 0.726)",
  indigoA10: "color(display-p3 0 0.137 0.737 / 0.765)",
  indigoA11: "color(display-p3 0.256 0.354 0.755)",
  indigoA12: "color(display-p3 0.133 0.175 0.348)"
};
const blue = {
  blue1: "#fbfdff",
  blue2: "#f4faff",
  blue3: "#e6f4fe",
  blue4: "#d5efff",
  blue5: "#c2e5ff",
  blue6: "#acd8fc",
  blue7: "#8ec8f6",
  blue8: "#5eb1ef",
  blue9: "#0090ff",
  blue10: "#0588f0",
  blue11: "#0d74ce",
  blue12: "#113264"
};
const blueA = {
  blueA1: "#0080ff04",
  blueA2: "#008cff0b",
  blueA3: "#008ff519",
  blueA4: "#009eff2a",
  blueA5: "#0093ff3d",
  blueA6: "#0088f653",
  blueA7: "#0083eb71",
  blueA8: "#0084e6a1",
  blueA9: "#0090ff",
  blueA10: "#0086f0fa",
  blueA11: "#006dcbf2",
  blueA12: "#002359ee"
};
const blueP3 = {
  blue1: "color(display-p3 0.986 0.992 0.999)",
  blue2: "color(display-p3 0.96 0.979 0.998)",
  blue3: "color(display-p3 0.912 0.956 0.991)",
  blue4: "color(display-p3 0.853 0.932 1)",
  blue5: "color(display-p3 0.788 0.894 0.998)",
  blue6: "color(display-p3 0.709 0.843 0.976)",
  blue7: "color(display-p3 0.606 0.777 0.947)",
  blue8: "color(display-p3 0.451 0.688 0.917)",
  blue9: "color(display-p3 0.247 0.556 0.969)",
  blue10: "color(display-p3 0.234 0.523 0.912)",
  blue11: "color(display-p3 0.15 0.44 0.84)",
  blue12: "color(display-p3 0.102 0.193 0.379)"
};
const blueP3A = {
  blueA1: "color(display-p3 0.024 0.514 1 / 0.016)",
  blueA2: "color(display-p3 0.024 0.514 0.906 / 0.04)",
  blueA3: "color(display-p3 0.012 0.506 0.914 / 0.087)",
  blueA4: "color(display-p3 0.008 0.545 1 / 0.146)",
  blueA5: "color(display-p3 0.004 0.502 0.984 / 0.212)",
  blueA6: "color(display-p3 0.004 0.463 0.922 / 0.291)",
  blueA7: "color(display-p3 0.004 0.431 0.863 / 0.393)",
  blueA8: "color(display-p3 0 0.427 0.851 / 0.55)",
  blueA9: "color(display-p3 0 0.412 0.961 / 0.753)",
  blueA10: "color(display-p3 0 0.376 0.886 / 0.765)",
  blueA11: "color(display-p3 0.15 0.44 0.84)",
  blueA12: "color(display-p3 0.102 0.193 0.379)"
};
const cyan = {
  cyan1: "#fafdfe",
  cyan2: "#f2fafb",
  cyan3: "#def7f9",
  cyan4: "#caf1f6",
  cyan5: "#b5e9f0",
  cyan6: "#9ddde7",
  cyan7: "#7dcedc",
  cyan8: "#3db9cf",
  cyan9: "#00a2c7",
  cyan10: "#0797b9",
  cyan11: "#107d98",
  cyan12: "#0d3c48"
};
const cyanA = {
  cyanA1: "#0099cc05",
  cyanA2: "#009db10d",
  cyanA3: "#00c2d121",
  cyanA4: "#00bcd435",
  cyanA5: "#01b4cc4a",
  cyanA6: "#00a7c162",
  cyanA7: "#009fbb82",
  cyanA8: "#00a3c0c2",
  cyanA9: "#00a2c7",
  cyanA10: "#0094b7f8",
  cyanA11: "#007491ef",
  cyanA12: "#00323ef2"
};
const cyanP3 = {
  cyan1: "color(display-p3 0.982 0.992 0.996)",
  cyan2: "color(display-p3 0.955 0.981 0.984)",
  cyan3: "color(display-p3 0.888 0.965 0.975)",
  cyan4: "color(display-p3 0.821 0.941 0.959)",
  cyan5: "color(display-p3 0.751 0.907 0.935)",
  cyan6: "color(display-p3 0.671 0.862 0.9)",
  cyan7: "color(display-p3 0.564 0.8 0.854)",
  cyan8: "color(display-p3 0.388 0.715 0.798)",
  cyan9: "color(display-p3 0.282 0.627 0.765)",
  cyan10: "color(display-p3 0.264 0.583 0.71)",
  cyan11: "color(display-p3 0.08 0.48 0.63)",
  cyan12: "color(display-p3 0.108 0.232 0.277)"
};
const cyanP3A = {
  cyanA1: "color(display-p3 0.02 0.608 0.804 / 0.02)",
  cyanA2: "color(display-p3 0.02 0.557 0.647 / 0.044)",
  cyanA3: "color(display-p3 0.004 0.694 0.796 / 0.114)",
  cyanA4: "color(display-p3 0.004 0.678 0.784 / 0.181)",
  cyanA5: "color(display-p3 0.004 0.624 0.733 / 0.248)",
  cyanA6: "color(display-p3 0.004 0.584 0.706 / 0.33)",
  cyanA7: "color(display-p3 0.004 0.541 0.667 / 0.436)",
  cyanA8: "color(display-p3 0 0.533 0.667 / 0.612)",
  cyanA9: "color(display-p3 0 0.482 0.675 / 0.718)",
  cyanA10: "color(display-p3 0 0.435 0.608 / 0.738)",
  cyanA11: "color(display-p3 0.08 0.48 0.63)",
  cyanA12: "color(display-p3 0.108 0.232 0.277)"
};
const teal = {
  teal1: "#fafefd",
  teal2: "#f3fbf9",
  teal3: "#e0f8f3",
  teal4: "#ccf3ea",
  teal5: "#b8eae0",
  teal6: "#a1ded2",
  teal7: "#83cdc1",
  teal8: "#53b9ab",
  teal9: "#12a594",
  teal10: "#0d9b8a",
  teal11: "#008573",
  teal12: "#0d3d38"
};
const tealA = {
  tealA1: "#00cc9905",
  tealA2: "#00aa800c",
  tealA3: "#00c69d1f",
  tealA4: "#00c39633",
  tealA5: "#00b49047",
  tealA6: "#00a6855e",
  tealA7: "#0099807c",
  tealA8: "#009783ac",
  tealA9: "#009e8ced",
  tealA10: "#009684f2",
  tealA11: "#008573",
  tealA12: "#00332df2"
};
const tealP3 = {
  teal1: "color(display-p3 0.983 0.996 0.992)",
  teal2: "color(display-p3 0.958 0.983 0.976)",
  teal3: "color(display-p3 0.895 0.971 0.952)",
  teal4: "color(display-p3 0.831 0.949 0.92)",
  teal5: "color(display-p3 0.761 0.914 0.878)",
  teal6: "color(display-p3 0.682 0.864 0.825)",
  teal7: "color(display-p3 0.581 0.798 0.756)",
  teal8: "color(display-p3 0.433 0.716 0.671)",
  teal9: "color(display-p3 0.297 0.637 0.581)",
  teal10: "color(display-p3 0.275 0.599 0.542)",
  teal11: "color(display-p3 0.08 0.5 0.43)",
  teal12: "color(display-p3 0.11 0.235 0.219)"
};
const tealP3A = {
  tealA1: "color(display-p3 0.024 0.757 0.514 / 0.016)",
  tealA2: "color(display-p3 0.02 0.647 0.467 / 0.044)",
  tealA3: "color(display-p3 0.004 0.741 0.557 / 0.106)",
  tealA4: "color(display-p3 0.004 0.702 0.537 / 0.169)",
  tealA5: "color(display-p3 0.004 0.643 0.494 / 0.24)",
  tealA6: "color(display-p3 0.004 0.569 0.447 / 0.318)",
  tealA7: "color(display-p3 0.004 0.518 0.424 / 0.42)",
  tealA8: "color(display-p3 0 0.506 0.424 / 0.569)",
  tealA9: "color(display-p3 0 0.482 0.404 / 0.702)",
  tealA10: "color(display-p3 0 0.451 0.369 / 0.726)",
  tealA11: "color(display-p3 0.08 0.5 0.43)",
  tealA12: "color(display-p3 0.11 0.235 0.219)"
};
const jade = {
  jade1: "#fbfefd",
  jade2: "#f4fbf7",
  jade3: "#e6f7ed",
  jade4: "#d6f1e3",
  jade5: "#c3e9d7",
  jade6: "#acdec8",
  jade7: "#8bceb6",
  jade8: "#56ba9f",
  jade9: "#29a383",
  jade10: "#26997b",
  jade11: "#208368",
  jade12: "#1d3b31"
};
const jadeA = {
  jadeA1: "#00c08004",
  jadeA2: "#00a3460b",
  jadeA3: "#00ae4819",
  jadeA4: "#00a85129",
  jadeA5: "#00a2553c",
  jadeA6: "#009a5753",
  jadeA7: "#00945f74",
  jadeA8: "#00976ea9",
  jadeA9: "#00916bd6",
  jadeA10: "#008764d9",
  jadeA11: "#007152df",
  jadeA12: "#002217e2"
};
const jadeP3 = {
  jade1: "color(display-p3 0.986 0.996 0.992)",
  jade2: "color(display-p3 0.962 0.983 0.969)",
  jade3: "color(display-p3 0.912 0.965 0.932)",
  jade4: "color(display-p3 0.858 0.941 0.893)",
  jade5: "color(display-p3 0.795 0.909 0.847)",
  jade6: "color(display-p3 0.715 0.864 0.791)",
  jade7: "color(display-p3 0.603 0.802 0.718)",
  jade8: "color(display-p3 0.44 0.72 0.629)",
  jade9: "color(display-p3 0.319 0.63 0.521)",
  jade10: "color(display-p3 0.299 0.592 0.488)",
  jade11: "color(display-p3 0.15 0.5 0.37)",
  jade12: "color(display-p3 0.142 0.229 0.194)"
};
const jadeP3A = {
  jadeA1: "color(display-p3 0.024 0.757 0.514 / 0.016)",
  jadeA2: "color(display-p3 0.024 0.612 0.22 / 0.04)",
  jadeA3: "color(display-p3 0.012 0.596 0.235 / 0.087)",
  jadeA4: "color(display-p3 0.008 0.588 0.255 / 0.142)",
  jadeA5: "color(display-p3 0.004 0.561 0.251 / 0.204)",
  jadeA6: "color(display-p3 0.004 0.525 0.278 / 0.287)",
  jadeA7: "color(display-p3 0.004 0.506 0.29 / 0.397)",
  jadeA8: "color(display-p3 0 0.506 0.337 / 0.561)",
  jadeA9: "color(display-p3 0 0.459 0.298 / 0.683)",
  jadeA10: "color(display-p3 0 0.42 0.271 / 0.702)",
  jadeA11: "color(display-p3 0.15 0.5 0.37)",
  jadeA12: "color(display-p3 0.142 0.229 0.194)"
};
const green = {
  green1: "#fbfefc",
  green2: "#f4fbf6",
  green3: "#e6f6eb",
  green4: "#d6f1df",
  green5: "#c4e8d1",
  green6: "#adddc0",
  green7: "#8eceaa",
  green8: "#5bb98b",
  green9: "#30a46c",
  green10: "#2b9a66",
  green11: "#218358",
  green12: "#193b2d"
};
const greenA = {
  greenA1: "#00c04004",
  greenA2: "#00a32f0b",
  greenA3: "#00a43319",
  greenA4: "#00a83829",
  greenA5: "#019c393b",
  greenA6: "#00963c52",
  greenA7: "#00914071",
  greenA8: "#00924ba4",
  greenA9: "#008f4acf",
  greenA10: "#008647d4",
  greenA11: "#00713fde",
  greenA12: "#002616e6"
};
const greenP3 = {
  green1: "color(display-p3 0.986 0.996 0.989)",
  green2: "color(display-p3 0.963 0.983 0.967)",
  green3: "color(display-p3 0.913 0.964 0.925)",
  green4: "color(display-p3 0.859 0.94 0.879)",
  green5: "color(display-p3 0.796 0.907 0.826)",
  green6: "color(display-p3 0.718 0.863 0.761)",
  green7: "color(display-p3 0.61 0.801 0.675)",
  green8: "color(display-p3 0.451 0.715 0.559)",
  green9: "color(display-p3 0.332 0.634 0.442)",
  green10: "color(display-p3 0.308 0.595 0.417)",
  green11: "color(display-p3 0.19 0.5 0.32)",
  green12: "color(display-p3 0.132 0.228 0.18)"
};
const greenP3A = {
  greenA1: "color(display-p3 0.024 0.757 0.267 / 0.016)",
  greenA2: "color(display-p3 0.024 0.565 0.129 / 0.036)",
  greenA3: "color(display-p3 0.012 0.596 0.145 / 0.087)",
  greenA4: "color(display-p3 0.008 0.588 0.145 / 0.142)",
  greenA5: "color(display-p3 0.004 0.541 0.157 / 0.204)",
  greenA6: "color(display-p3 0.004 0.518 0.157 / 0.283)",
  greenA7: "color(display-p3 0.004 0.486 0.165 / 0.389)",
  greenA8: "color(display-p3 0 0.478 0.2 / 0.55)",
  greenA9: "color(display-p3 0 0.455 0.165 / 0.667)",
  greenA10: "color(display-p3 0 0.416 0.153 / 0.691)",
  greenA11: "color(display-p3 0.19 0.5 0.32)",
  greenA12: "color(display-p3 0.132 0.228 0.18)"
};
const grass = {
  grass1: "#fbfefb",
  grass2: "#f5fbf5",
  grass3: "#e9f6e9",
  grass4: "#daf1db",
  grass5: "#c9e8ca",
  grass6: "#b2ddb5",
  grass7: "#94ce9a",
  grass8: "#65ba74",
  grass9: "#46a758",
  grass10: "#3e9b4f",
  grass11: "#2a7e3b",
  grass12: "#203c25"
};
const grassA = {
  grassA1: "#00c00004",
  grassA2: "#0099000a",
  grassA3: "#00970016",
  grassA4: "#009f0725",
  grassA5: "#00930536",
  grassA6: "#008f0a4d",
  grassA7: "#018b0f6b",
  grassA8: "#008d199a",
  grassA9: "#008619b9",
  grassA10: "#007b17c1",
  grassA11: "#006514d5",
  grassA12: "#002006df"
};
const grassP3 = {
  grass1: "color(display-p3 0.986 0.996 0.985)",
  grass2: "color(display-p3 0.966 0.983 0.964)",
  grass3: "color(display-p3 0.923 0.965 0.917)",
  grass4: "color(display-p3 0.872 0.94 0.865)",
  grass5: "color(display-p3 0.811 0.908 0.802)",
  grass6: "color(display-p3 0.733 0.864 0.724)",
  grass7: "color(display-p3 0.628 0.803 0.622)",
  grass8: "color(display-p3 0.477 0.72 0.482)",
  grass9: "color(display-p3 0.38 0.647 0.378)",
  grass10: "color(display-p3 0.344 0.598 0.342)",
  grass11: "color(display-p3 0.263 0.488 0.261)",
  grass12: "color(display-p3 0.151 0.233 0.153)"
};
const grassP3A = {
  grassA1: "color(display-p3 0.024 0.757 0.024 / 0.016)",
  grassA2: "color(display-p3 0.024 0.565 0.024 / 0.036)",
  grassA3: "color(display-p3 0.059 0.576 0.008 / 0.083)",
  grassA4: "color(display-p3 0.035 0.565 0.008 / 0.134)",
  grassA5: "color(display-p3 0.047 0.545 0.008 / 0.197)",
  grassA6: "color(display-p3 0.031 0.502 0.004 / 0.275)",
  grassA7: "color(display-p3 0.012 0.482 0.004 / 0.377)",
  grassA8: "color(display-p3 0 0.467 0.008 / 0.522)",
  grassA9: "color(display-p3 0.008 0.435 0 / 0.624)",
  grassA10: "color(display-p3 0.008 0.388 0 / 0.659)",
  grassA11: "color(display-p3 0.263 0.488 0.261)",
  grassA12: "color(display-p3 0.151 0.233 0.153)"
};
const brown = {
  brown1: "#fefdfc",
  brown2: "#fcf9f6",
  brown3: "#f6eee7",
  brown4: "#f0e4d9",
  brown5: "#ebdaca",
  brown6: "#e4cdb7",
  brown7: "#dcbc9f",
  brown8: "#cea37e",
  brown9: "#ad7f58",
  brown10: "#a07553",
  brown11: "#815e46",
  brown12: "#3e332e"
};
const brownA = {
  brownA1: "#aa550003",
  brownA2: "#aa550009",
  brownA3: "#a04b0018",
  brownA4: "#9b4a0026",
  brownA5: "#9f4d0035",
  brownA6: "#a04e0048",
  brownA7: "#a34e0060",
  brownA8: "#9f4a0081",
  brownA9: "#823c00a7",
  brownA10: "#723300ac",
  brownA11: "#522100b9",
  brownA12: "#140600d1"
};
const brownP3 = {
  brown1: "color(display-p3 0.995 0.992 0.989)",
  brown2: "color(display-p3 0.987 0.976 0.964)",
  brown3: "color(display-p3 0.959 0.936 0.909)",
  brown4: "color(display-p3 0.934 0.897 0.855)",
  brown5: "color(display-p3 0.909 0.856 0.798)",
  brown6: "color(display-p3 0.88 0.808 0.73)",
  brown7: "color(display-p3 0.841 0.742 0.639)",
  brown8: "color(display-p3 0.782 0.647 0.514)",
  brown9: "color(display-p3 0.651 0.505 0.368)",
  brown10: "color(display-p3 0.601 0.465 0.344)",
  brown11: "color(display-p3 0.485 0.374 0.288)",
  brown12: "color(display-p3 0.236 0.202 0.183)"
};
const brownP3A = {
  brownA1: "color(display-p3 0.675 0.349 0.024 / 0.012)",
  brownA2: "color(display-p3 0.675 0.349 0.024 / 0.036)",
  brownA3: "color(display-p3 0.573 0.314 0.012 / 0.091)",
  brownA4: "color(display-p3 0.545 0.302 0.008 / 0.146)",
  brownA5: "color(display-p3 0.561 0.29 0.004 / 0.204)",
  brownA6: "color(display-p3 0.553 0.294 0.004 / 0.271)",
  brownA7: "color(display-p3 0.557 0.286 0.004 / 0.361)",
  brownA8: "color(display-p3 0.549 0.275 0.004 / 0.487)",
  brownA9: "color(display-p3 0.447 0.22 0 / 0.632)",
  brownA10: "color(display-p3 0.388 0.188 0 / 0.655)",
  brownA11: "color(display-p3 0.485 0.374 0.288)",
  brownA12: "color(display-p3 0.236 0.202 0.183)"
};
const bronze = {
  bronze1: "#fdfcfc",
  bronze2: "#fdf7f5",
  bronze3: "#f6edea",
  bronze4: "#efe4df",
  bronze5: "#e7d9d3",
  bronze6: "#dfcdc5",
  bronze7: "#d3bcb3",
  bronze8: "#c2a499",
  bronze9: "#a18072",
  bronze10: "#957468",
  bronze11: "#7d5e54",
  bronze12: "#43302b"
};
const bronzeA = {
  bronzeA1: "#55000003",
  bronzeA2: "#cc33000a",
  bronzeA3: "#92250015",
  bronzeA4: "#80280020",
  bronzeA5: "#7423002c",
  bronzeA6: "#7324003a",
  bronzeA7: "#6c1f004c",
  bronzeA8: "#671c0066",
  bronzeA9: "#551a008d",
  bronzeA10: "#4c150097",
  bronzeA11: "#3d0f00ab",
  bronzeA12: "#1d0600d4"
};
const bronzeP3 = {
  bronze1: "color(display-p3 0.991 0.988 0.988)",
  bronze2: "color(display-p3 0.989 0.97 0.961)",
  bronze3: "color(display-p3 0.958 0.932 0.919)",
  bronze4: "color(display-p3 0.929 0.894 0.877)",
  bronze5: "color(display-p3 0.898 0.853 0.832)",
  bronze6: "color(display-p3 0.861 0.805 0.778)",
  bronze7: "color(display-p3 0.812 0.739 0.706)",
  bronze8: "color(display-p3 0.741 0.647 0.606)",
  bronze9: "color(display-p3 0.611 0.507 0.455)",
  bronze10: "color(display-p3 0.563 0.461 0.414)",
  bronze11: "color(display-p3 0.471 0.373 0.336)",
  bronze12: "color(display-p3 0.251 0.191 0.172)"
};
const bronzeP3A = {
  bronzeA1: "color(display-p3 0.349 0.024 0.024 / 0.012)",
  bronzeA2: "color(display-p3 0.71 0.22 0.024 / 0.04)",
  bronzeA3: "color(display-p3 0.482 0.2 0.008 / 0.083)",
  bronzeA4: "color(display-p3 0.424 0.133 0.004 / 0.122)",
  bronzeA5: "color(display-p3 0.4 0.145 0.004 / 0.169)",
  bronzeA6: "color(display-p3 0.388 0.125 0.004 / 0.224)",
  bronzeA7: "color(display-p3 0.365 0.11 0.004 / 0.295)",
  bronzeA8: "color(display-p3 0.341 0.102 0.004 / 0.393)",
  bronzeA9: "color(display-p3 0.29 0.094 0 / 0.546)",
  bronzeA10: "color(display-p3 0.255 0.082 0 / 0.585)",
  bronzeA11: "color(display-p3 0.471 0.373 0.336)",
  bronzeA12: "color(display-p3 0.251 0.191 0.172)"
};
const gold = {
  gold1: "#fdfdfc",
  gold2: "#faf9f2",
  gold3: "#f2f0e7",
  gold4: "#eae6db",
  gold5: "#e1dccf",
  gold6: "#d8d0bf",
  gold7: "#cbc0aa",
  gold8: "#b9a88d",
  gold9: "#978365",
  gold10: "#8c7a5e",
  gold11: "#71624b",
  gold12: "#3b352b"
};
const goldA = {
  goldA1: "#55550003",
  goldA2: "#9d8a000d",
  goldA3: "#75600018",
  goldA4: "#6b4e0024",
  goldA5: "#60460030",
  goldA6: "#64440040",
  goldA7: "#63420055",
  goldA8: "#633d0072",
  goldA9: "#5332009a",
  goldA10: "#492d00a1",
  goldA11: "#362100b4",
  goldA12: "#130c00d4"
};
const goldP3 = {
  gold1: "color(display-p3 0.992 0.992 0.989)",
  gold2: "color(display-p3 0.98 0.976 0.953)",
  gold3: "color(display-p3 0.947 0.94 0.909)",
  gold4: "color(display-p3 0.914 0.904 0.865)",
  gold5: "color(display-p3 0.88 0.865 0.816)",
  gold6: "color(display-p3 0.84 0.818 0.756)",
  gold7: "color(display-p3 0.788 0.753 0.677)",
  gold8: "color(display-p3 0.715 0.66 0.565)",
  gold9: "color(display-p3 0.579 0.517 0.41)",
  gold10: "color(display-p3 0.538 0.479 0.38)",
  gold11: "color(display-p3 0.433 0.386 0.305)",
  gold12: "color(display-p3 0.227 0.209 0.173)"
};
const goldP3A = {
  goldA1: "color(display-p3 0.349 0.349 0.024 / 0.012)",
  goldA2: "color(display-p3 0.592 0.514 0.024 / 0.048)",
  goldA3: "color(display-p3 0.4 0.357 0.012 / 0.091)",
  goldA4: "color(display-p3 0.357 0.298 0.008 / 0.134)",
  goldA5: "color(display-p3 0.345 0.282 0.004 / 0.185)",
  goldA6: "color(display-p3 0.341 0.263 0.004 / 0.244)",
  goldA7: "color(display-p3 0.345 0.235 0.004 / 0.322)",
  goldA8: "color(display-p3 0.345 0.22 0.004 / 0.436)",
  goldA9: "color(display-p3 0.286 0.18 0 / 0.589)",
  goldA10: "color(display-p3 0.255 0.161 0 / 0.62)",
  goldA11: "color(display-p3 0.433 0.386 0.305)",
  goldA12: "color(display-p3 0.227 0.209 0.173)"
};
const sky = {
  sky1: "#f9feff",
  sky2: "#f1fafd",
  sky3: "#e1f6fd",
  sky4: "#d1f0fa",
  sky5: "#bee7f5",
  sky6: "#a9daed",
  sky7: "#8dcae3",
  sky8: "#60b3d7",
  sky9: "#7ce2fe",
  sky10: "#74daf8",
  sky11: "#00749e",
  sky12: "#1d3e56"
};
const skyA = {
  skyA1: "#00d5ff06",
  skyA2: "#00a4db0e",
  skyA3: "#00b3ee1e",
  skyA4: "#00ace42e",
  skyA5: "#00a1d841",
  skyA6: "#0092ca56",
  skyA7: "#0089c172",
  skyA8: "#0085bf9f",
  skyA9: "#00c7fe83",
  skyA10: "#00bcf38b",
  skyA11: "#00749e",
  skyA12: "#002540e2"
};
const skyP3 = {
  sky1: "color(display-p3 0.98 0.995 0.999)",
  sky2: "color(display-p3 0.953 0.98 0.99)",
  sky3: "color(display-p3 0.899 0.963 0.989)",
  sky4: "color(display-p3 0.842 0.937 0.977)",
  sky5: "color(display-p3 0.777 0.9 0.954)",
  sky6: "color(display-p3 0.701 0.851 0.921)",
  sky7: "color(display-p3 0.604 0.785 0.879)",
  sky8: "color(display-p3 0.457 0.696 0.829)",
  sky9: "color(display-p3 0.585 0.877 0.983)",
  sky10: "color(display-p3 0.555 0.845 0.959)",
  sky11: "color(display-p3 0.193 0.448 0.605)",
  sky12: "color(display-p3 0.145 0.241 0.329)"
};
const skyP3A = {
  skyA1: "color(display-p3 0.02 0.804 1 / 0.02)",
  skyA2: "color(display-p3 0.024 0.592 0.757 / 0.048)",
  skyA3: "color(display-p3 0.004 0.655 0.886 / 0.102)",
  skyA4: "color(display-p3 0.004 0.604 0.851 / 0.157)",
  skyA5: "color(display-p3 0.004 0.565 0.792 / 0.224)",
  skyA6: "color(display-p3 0.004 0.502 0.737 / 0.299)",
  skyA7: "color(display-p3 0.004 0.459 0.694 / 0.397)",
  skyA8: "color(display-p3 0 0.435 0.682 / 0.542)",
  skyA9: "color(display-p3 0.004 0.71 0.965 / 0.416)",
  skyA10: "color(display-p3 0.004 0.647 0.914 / 0.444)",
  skyA11: "color(display-p3 0.193 0.448 0.605)",
  skyA12: "color(display-p3 0.145 0.241 0.329)"
};
const mint = {
  mint1: "#f9fefd",
  mint2: "#f2fbf9",
  mint3: "#ddf9f2",
  mint4: "#c8f4e9",
  mint5: "#b3ecde",
  mint6: "#9ce0d0",
  mint7: "#7ecfbd",
  mint8: "#4cbba5",
  mint9: "#86ead4",
  mint10: "#7de0cb",
  mint11: "#027864",
  mint12: "#16433c"
};
const mintA = {
  mintA1: "#00d5aa06",
  mintA2: "#00b18a0d",
  mintA3: "#00d29e22",
  mintA4: "#00cc9937",
  mintA5: "#00c0914c",
  mintA6: "#00b08663",
  mintA7: "#00a17d81",
  mintA8: "#009e7fb3",
  mintA9: "#00d3a579",
  mintA10: "#00c39982",
  mintA11: "#007763fd",
  mintA12: "#00312ae9"
};
const mintP3 = {
  mint1: "color(display-p3 0.98 0.995 0.992)",
  mint2: "color(display-p3 0.957 0.985 0.977)",
  mint3: "color(display-p3 0.888 0.972 0.95)",
  mint4: "color(display-p3 0.819 0.951 0.916)",
  mint5: "color(display-p3 0.747 0.918 0.873)",
  mint6: "color(display-p3 0.668 0.87 0.818)",
  mint7: "color(display-p3 0.567 0.805 0.744)",
  mint8: "color(display-p3 0.42 0.724 0.649)",
  mint9: "color(display-p3 0.62 0.908 0.834)",
  mint10: "color(display-p3 0.585 0.871 0.797)",
  mint11: "color(display-p3 0.203 0.463 0.397)",
  mint12: "color(display-p3 0.136 0.259 0.236)"
};
const mintP3A = {
  mintA1: "color(display-p3 0.02 0.804 0.608 / 0.02)",
  mintA2: "color(display-p3 0.02 0.647 0.467 / 0.044)",
  mintA3: "color(display-p3 0.004 0.761 0.553 / 0.114)",
  mintA4: "color(display-p3 0.004 0.741 0.545 / 0.181)",
  mintA5: "color(display-p3 0.004 0.678 0.51 / 0.255)",
  mintA6: "color(display-p3 0.004 0.616 0.463 / 0.334)",
  mintA7: "color(display-p3 0.004 0.549 0.412 / 0.432)",
  mintA8: "color(display-p3 0 0.529 0.392 / 0.581)",
  mintA9: "color(display-p3 0.004 0.765 0.569 / 0.381)",
  mintA10: "color(display-p3 0.004 0.69 0.51 / 0.416)",
  mintA11: "color(display-p3 0.203 0.463 0.397)",
  mintA12: "color(display-p3 0.136 0.259 0.236)"
};
const lime = {
  lime1: "#fcfdfa",
  lime2: "#f8faf3",
  lime3: "#eef6d6",
  lime4: "#e2f0bd",
  lime5: "#d3e7a6",
  lime6: "#c2da91",
  lime7: "#abc978",
  lime8: "#8db654",
  lime9: "#bdee63",
  lime10: "#b0e64c",
  lime11: "#5c7c2f",
  lime12: "#37401c"
};
const limeA = {
  limeA1: "#66990005",
  limeA2: "#6b95000c",
  limeA3: "#96c80029",
  limeA4: "#8fc60042",
  limeA5: "#81bb0059",
  limeA6: "#72aa006e",
  limeA7: "#61990087",
  limeA8: "#559200ab",
  limeA9: "#93e4009c",
  limeA10: "#8fdc00b3",
  limeA11: "#375f00d0",
  limeA12: "#1e2900e3"
};
const limeP3 = {
  lime1: "color(display-p3 0.989 0.992 0.981)",
  lime2: "color(display-p3 0.975 0.98 0.954)",
  lime3: "color(display-p3 0.939 0.965 0.851)",
  lime4: "color(display-p3 0.896 0.94 0.76)",
  lime5: "color(display-p3 0.843 0.903 0.678)",
  lime6: "color(display-p3 0.778 0.852 0.599)",
  lime7: "color(display-p3 0.694 0.784 0.508)",
  lime8: "color(display-p3 0.585 0.707 0.378)",
  lime9: "color(display-p3 0.78 0.928 0.466)",
  lime10: "color(display-p3 0.734 0.896 0.397)",
  lime11: "color(display-p3 0.386 0.482 0.227)",
  lime12: "color(display-p3 0.222 0.25 0.128)"
};
const limeP3A = {
  limeA1: "color(display-p3 0.412 0.608 0.02 / 0.02)",
  limeA2: "color(display-p3 0.514 0.592 0.024 / 0.048)",
  limeA3: "color(display-p3 0.584 0.765 0.008 / 0.15)",
  limeA4: "color(display-p3 0.561 0.757 0.004 / 0.24)",
  limeA5: "color(display-p3 0.514 0.698 0.004 / 0.322)",
  limeA6: "color(display-p3 0.443 0.627 0 / 0.4)",
  limeA7: "color(display-p3 0.376 0.561 0.004 / 0.491)",
  limeA8: "color(display-p3 0.333 0.529 0 / 0.624)",
  limeA9: "color(display-p3 0.588 0.867 0 / 0.534)",
  limeA10: "color(display-p3 0.561 0.827 0 / 0.604)",
  limeA11: "color(display-p3 0.386 0.482 0.227)",
  limeA12: "color(display-p3 0.222 0.25 0.128)"
};
const yellow = {
  yellow1: "#fdfdf9",
  yellow2: "#fefce9",
  yellow3: "#fffab8",
  yellow4: "#fff394",
  yellow5: "#ffe770",
  yellow6: "#f3d768",
  yellow7: "#e4c767",
  yellow8: "#d5ae39",
  yellow9: "#ffe629",
  yellow10: "#ffdc00",
  yellow11: "#9e6c00",
  yellow12: "#473b1f"
};
const yellowA = {
  yellowA1: "#aaaa0006",
  yellowA2: "#f4dd0016",
  yellowA3: "#ffee0047",
  yellowA4: "#ffe3016b",
  yellowA5: "#ffd5008f",
  yellowA6: "#ebbc0097",
  yellowA7: "#d2a10098",
  yellowA8: "#c99700c6",
  yellowA9: "#ffe100d6",
  yellowA10: "#ffdc00",
  yellowA11: "#9e6c00",
  yellowA12: "#2e2000e0"
};
const yellowP3 = {
  yellow1: "color(display-p3 0.992 0.992 0.978)",
  yellow2: "color(display-p3 0.995 0.99 0.922)",
  yellow3: "color(display-p3 0.997 0.982 0.749)",
  yellow4: "color(display-p3 0.992 0.953 0.627)",
  yellow5: "color(display-p3 0.984 0.91 0.51)",
  yellow6: "color(display-p3 0.934 0.847 0.474)",
  yellow7: "color(display-p3 0.876 0.785 0.46)",
  yellow8: "color(display-p3 0.811 0.689 0.313)",
  yellow9: "color(display-p3 1 0.92 0.22)",
  yellow10: "color(display-p3 0.977 0.868 0.291)",
  yellow11: "color(display-p3 0.6 0.44 0)",
  yellow12: "color(display-p3 0.271 0.233 0.137)"
};
const yellowP3A = {
  yellowA1: "color(display-p3 0.675 0.675 0.024 / 0.024)",
  yellowA2: "color(display-p3 0.953 0.855 0.008 / 0.079)",
  yellowA3: "color(display-p3 0.988 0.925 0.004 / 0.251)",
  yellowA4: "color(display-p3 0.98 0.875 0.004 / 0.373)",
  yellowA5: "color(display-p3 0.969 0.816 0.004 / 0.491)",
  yellowA6: "color(display-p3 0.875 0.71 0 / 0.526)",
  yellowA7: "color(display-p3 0.769 0.604 0 / 0.542)",
  yellowA8: "color(display-p3 0.725 0.549 0 / 0.687)",
  yellowA9: "color(display-p3 1 0.898 0 / 0.781)",
  yellowA10: "color(display-p3 0.969 0.812 0 / 0.71)",
  yellowA11: "color(display-p3 0.6 0.44 0)",
  yellowA12: "color(display-p3 0.271 0.233 0.137)"
};
const amber = {
  amber1: "#fefdfb",
  amber2: "#fefbe9",
  amber3: "#fff7c2",
  amber4: "#ffee9c",
  amber5: "#fbe577",
  amber6: "#f3d673",
  amber7: "#e9c162",
  amber8: "#e2a336",
  amber9: "#ffc53d",
  amber10: "#ffba18",
  amber11: "#ab6400",
  amber12: "#4f3422"
};
const amberA = {
  amberA1: "#c0800004",
  amberA2: "#f4d10016",
  amberA3: "#ffde003d",
  amberA4: "#ffd40063",
  amberA5: "#f8cf0088",
  amberA6: "#eab5008c",
  amberA7: "#dc9b009d",
  amberA8: "#da8a00c9",
  amberA9: "#ffb300c2",
  amberA10: "#ffb300e7",
  amberA11: "#ab6400",
  amberA12: "#341500dd"
};
const amberP3 = {
  amber1: "color(display-p3 0.995 0.992 0.985)",
  amber2: "color(display-p3 0.994 0.986 0.921)",
  amber3: "color(display-p3 0.994 0.969 0.782)",
  amber4: "color(display-p3 0.989 0.937 0.65)",
  amber5: "color(display-p3 0.97 0.902 0.527)",
  amber6: "color(display-p3 0.936 0.844 0.506)",
  amber7: "color(display-p3 0.89 0.762 0.443)",
  amber8: "color(display-p3 0.85 0.65 0.3)",
  amber9: "color(display-p3 1 0.77 0.26)",
  amber10: "color(display-p3 0.959 0.741 0.274)",
  amber11: "color(display-p3 0.64 0.4 0)",
  amber12: "color(display-p3 0.294 0.208 0.145)"
};
const amberP3A = {
  amberA1: "color(display-p3 0.757 0.514 0.024 / 0.016)",
  amberA2: "color(display-p3 0.902 0.804 0.008 / 0.079)",
  amberA3: "color(display-p3 0.965 0.859 0.004 / 0.22)",
  amberA4: "color(display-p3 0.969 0.82 0.004 / 0.35)",
  amberA5: "color(display-p3 0.933 0.796 0.004 / 0.475)",
  amberA6: "color(display-p3 0.875 0.682 0.004 / 0.495)",
  amberA7: "color(display-p3 0.804 0.573 0 / 0.557)",
  amberA8: "color(display-p3 0.788 0.502 0 / 0.699)",
  amberA9: "color(display-p3 1 0.686 0 / 0.742)",
  amberA10: "color(display-p3 0.945 0.643 0 / 0.726)",
  amberA11: "color(display-p3 0.64 0.4 0)",
  amberA12: "color(display-p3 0.294 0.208 0.145)"
};
const orange = {
  orange1: "#fefcfb",
  orange2: "#fff7ed",
  orange3: "#ffefd6",
  orange4: "#ffdfb5",
  orange5: "#ffd19a",
  orange6: "#ffc182",
  orange7: "#f5ae73",
  orange8: "#ec9455",
  orange9: "#f76b15",
  orange10: "#ef5f00",
  orange11: "#cc4e00",
  orange12: "#582d1d"
};
const orangeA = {
  orangeA1: "#c0400004",
  orangeA2: "#ff8e0012",
  orangeA3: "#ff9c0029",
  orangeA4: "#ff91014a",
  orangeA5: "#ff8b0065",
  orangeA6: "#ff81007d",
  orangeA7: "#ed6c008c",
  orangeA8: "#e35f00aa",
  orangeA9: "#f65e00ea",
  orangeA10: "#ef5f00",
  orangeA11: "#cc4e00",
  orangeA12: "#431200e2"
};
const orangeP3 = {
  orange1: "color(display-p3 0.995 0.988 0.985)",
  orange2: "color(display-p3 0.994 0.968 0.934)",
  orange3: "color(display-p3 0.989 0.938 0.85)",
  orange4: "color(display-p3 1 0.874 0.687)",
  orange5: "color(display-p3 1 0.821 0.583)",
  orange6: "color(display-p3 0.975 0.767 0.545)",
  orange7: "color(display-p3 0.919 0.693 0.486)",
  orange8: "color(display-p3 0.877 0.597 0.379)",
  orange9: "color(display-p3 0.9 0.45 0.2)",
  orange10: "color(display-p3 0.87 0.409 0.164)",
  orange11: "color(display-p3 0.76 0.34 0)",
  orange12: "color(display-p3 0.323 0.185 0.127)"
};
const orangeP3A = {
  orangeA1: "color(display-p3 0.757 0.267 0.024 / 0.016)",
  orangeA2: "color(display-p3 0.886 0.533 0.008 / 0.067)",
  orangeA3: "color(display-p3 0.922 0.584 0.008 / 0.15)",
  orangeA4: "color(display-p3 1 0.604 0.004 / 0.314)",
  orangeA5: "color(display-p3 1 0.569 0.004 / 0.416)",
  orangeA6: "color(display-p3 0.949 0.494 0.004 / 0.455)",
  orangeA7: "color(display-p3 0.839 0.408 0 / 0.514)",
  orangeA8: "color(display-p3 0.804 0.349 0 / 0.62)",
  orangeA9: "color(display-p3 0.878 0.314 0 / 0.8)",
  orangeA10: "color(display-p3 0.843 0.29 0 / 0.836)",
  orangeA11: "color(display-p3 0.76 0.34 0)",
  orangeA12: "color(display-p3 0.323 0.185 0.127)"
};
const blackA = {
  blackA1: "rgba(0, 0, 0, 0.05)",
  blackA2: "rgba(0, 0, 0, 0.1)",
  blackA3: "rgba(0, 0, 0, 0.15)",
  blackA4: "rgba(0, 0, 0, 0.2)",
  blackA5: "rgba(0, 0, 0, 0.3)",
  blackA6: "rgba(0, 0, 0, 0.4)",
  blackA7: "rgba(0, 0, 0, 0.5)",
  blackA8: "rgba(0, 0, 0, 0.6)",
  blackA9: "rgba(0, 0, 0, 0.7)",
  blackA10: "rgba(0, 0, 0, 0.8)",
  blackA11: "rgba(0, 0, 0, 0.9)",
  blackA12: "rgba(0, 0, 0, 0.95)"
};
const blackP3A = {
  blackA1: "color(display-p3 0 0 0 / 0.05)",
  blackA2: "color(display-p3 0 0 0 / 0.1)",
  blackA3: "color(display-p3 0 0 0 / 0.15)",
  blackA4: "color(display-p3 0 0 0 / 0.2)",
  blackA5: "color(display-p3 0 0 0 / 0.3)",
  blackA6: "color(display-p3 0 0 0 / 0.4)",
  blackA7: "color(display-p3 0 0 0 / 0.5)",
  blackA8: "color(display-p3 0 0 0 / 0.6)",
  blackA9: "color(display-p3 0 0 0 / 0.7)",
  blackA10: "color(display-p3 0 0 0 / 0.8)",
  blackA11: "color(display-p3 0 0 0 / 0.9)",
  blackA12: "color(display-p3 0 0 0 / 0.95)"
};
const whiteA = {
  whiteA1: "rgba(255, 255, 255, 0.05)",
  whiteA2: "rgba(255, 255, 255, 0.1)",
  whiteA3: "rgba(255, 255, 255, 0.15)",
  whiteA4: "rgba(255, 255, 255, 0.2)",
  whiteA5: "rgba(255, 255, 255, 0.3)",
  whiteA6: "rgba(255, 255, 255, 0.4)",
  whiteA7: "rgba(255, 255, 255, 0.5)",
  whiteA8: "rgba(255, 255, 255, 0.6)",
  whiteA9: "rgba(255, 255, 255, 0.7)",
  whiteA10: "rgba(255, 255, 255, 0.8)",
  whiteA11: "rgba(255, 255, 255, 0.9)",
  whiteA12: "rgba(255, 255, 255, 0.95)"
};
const whiteP3A = {
  whiteA1: "color(display-p3 1 1 1 / 0.05)",
  whiteA2: "color(display-p3 1 1 1 / 0.1)",
  whiteA3: "color(display-p3 1 1 1 / 0.15)",
  whiteA4: "color(display-p3 1 1 1 / 0.2)",
  whiteA5: "color(display-p3 1 1 1 / 0.3)",
  whiteA6: "color(display-p3 1 1 1 / 0.4)",
  whiteA7: "color(display-p3 1 1 1 / 0.5)",
  whiteA8: "color(display-p3 1 1 1 / 0.6)",
  whiteA9: "color(display-p3 1 1 1 / 0.7)",
  whiteA10: "color(display-p3 1 1 1 / 0.8)",
  whiteA11: "color(display-p3 1 1 1 / 0.9)",
  whiteA12: "color(display-p3 1 1 1 / 0.95)"
};
const RadixColors = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  amber,
  amberA,
  amberDark,
  amberDarkA,
  amberDarkP3,
  amberDarkP3A,
  amberP3,
  amberP3A,
  blackA,
  blackP3A,
  blue,
  blueA,
  blueDark,
  blueDarkA,
  blueDarkP3,
  blueDarkP3A,
  blueP3,
  blueP3A,
  bronze,
  bronzeA,
  bronzeDark,
  bronzeDarkA,
  bronzeDarkP3,
  bronzeDarkP3A,
  bronzeP3,
  bronzeP3A,
  brown,
  brownA,
  brownDark,
  brownDarkA,
  brownDarkP3,
  brownDarkP3A,
  brownP3,
  brownP3A,
  crimson,
  crimsonA,
  crimsonDark,
  crimsonDarkA,
  crimsonDarkP3,
  crimsonDarkP3A,
  crimsonP3,
  crimsonP3A,
  cyan,
  cyanA,
  cyanDark,
  cyanDarkA,
  cyanDarkP3,
  cyanDarkP3A,
  cyanP3,
  cyanP3A,
  gold,
  goldA,
  goldDark,
  goldDarkA,
  goldDarkP3,
  goldDarkP3A,
  goldP3,
  goldP3A,
  grass,
  grassA,
  grassDark,
  grassDarkA,
  grassDarkP3,
  grassDarkP3A,
  grassP3,
  grassP3A,
  gray,
  grayA,
  grayDark,
  grayDarkA,
  grayDarkP3,
  grayDarkP3A,
  grayP3,
  grayP3A,
  green,
  greenA,
  greenDark,
  greenDarkA,
  greenDarkP3,
  greenDarkP3A,
  greenP3,
  greenP3A,
  indigo,
  indigoA,
  indigoDark,
  indigoDarkA,
  indigoDarkP3,
  indigoDarkP3A,
  indigoP3,
  indigoP3A,
  iris,
  irisA,
  irisDark,
  irisDarkA,
  irisDarkP3,
  irisDarkP3A,
  irisP3,
  irisP3A,
  jade,
  jadeA,
  jadeDark,
  jadeDarkA,
  jadeDarkP3,
  jadeDarkP3A,
  jadeP3,
  jadeP3A,
  lime,
  limeA,
  limeDark,
  limeDarkA,
  limeDarkP3,
  limeDarkP3A,
  limeP3,
  limeP3A,
  mauve,
  mauveA,
  mauveDark,
  mauveDarkA,
  mauveDarkP3,
  mauveDarkP3A,
  mauveP3,
  mauveP3A,
  mint,
  mintA,
  mintDark,
  mintDarkA,
  mintDarkP3,
  mintDarkP3A,
  mintP3,
  mintP3A,
  olive,
  oliveA,
  oliveDark,
  oliveDarkA,
  oliveDarkP3,
  oliveDarkP3A,
  oliveP3,
  oliveP3A,
  orange,
  orangeA,
  orangeDark,
  orangeDarkA,
  orangeDarkP3,
  orangeDarkP3A,
  orangeP3,
  orangeP3A,
  pink,
  pinkA,
  pinkDark,
  pinkDarkA,
  pinkDarkP3,
  pinkDarkP3A,
  pinkP3,
  pinkP3A,
  plum,
  plumA,
  plumDark,
  plumDarkA,
  plumDarkP3,
  plumDarkP3A,
  plumP3,
  plumP3A,
  purple,
  purpleA,
  purpleDark,
  purpleDarkA,
  purpleDarkP3,
  purpleDarkP3A,
  purpleP3,
  purpleP3A,
  red,
  redA,
  redDark,
  redDarkA,
  redDarkP3,
  redDarkP3A,
  redP3,
  redP3A,
  ruby,
  rubyA,
  rubyDark,
  rubyDarkA,
  rubyDarkP3,
  rubyDarkP3A,
  rubyP3,
  rubyP3A,
  sage,
  sageA,
  sageDark,
  sageDarkA,
  sageDarkP3,
  sageDarkP3A,
  sageP3,
  sageP3A,
  sand,
  sandA,
  sandDark,
  sandDarkA,
  sandDarkP3,
  sandDarkP3A,
  sandP3,
  sandP3A,
  sky,
  skyA,
  skyDark,
  skyDarkA,
  skyDarkP3,
  skyDarkP3A,
  skyP3,
  skyP3A,
  slate,
  slateA,
  slateDark,
  slateDarkA,
  slateDarkP3,
  slateDarkP3A,
  slateP3,
  slateP3A,
  teal,
  tealA,
  tealDark,
  tealDarkA,
  tealDarkP3,
  tealDarkP3A,
  tealP3,
  tealP3A,
  tomato,
  tomatoA,
  tomatoDark,
  tomatoDarkA,
  tomatoDarkP3,
  tomatoDarkP3A,
  tomatoP3,
  tomatoP3A,
  violet,
  violetA,
  violetDark,
  violetDarkA,
  violetDarkP3,
  violetDarkP3A,
  violetP3,
  violetP3A,
  whiteA,
  whiteP3A,
  yellow,
  yellowA,
  yellowDark,
  yellowDarkA,
  yellowDarkP3,
  yellowDarkP3A,
  yellowP3,
  yellowP3A
}, Symbol.toStringTag, { value: "Module" }));
function multiplyMatrices(A2, B2) {
  let m3 = A2.length;
  if (!Array.isArray(A2[0])) {
    A2 = [A2];
  }
  if (!Array.isArray(B2[0])) {
    B2 = B2.map((x2) => [x2]);
  }
  let p2 = B2[0].length;
  let B_cols = B2[0].map((_2, i) => B2.map((x2) => x2[i]));
  let product = A2.map(
    (row2) => B_cols.map((col) => {
      let ret = 0;
      if (!Array.isArray(row2)) {
        for (let c4 of col) {
          ret += row2 * c4;
        }
        return ret;
      }
      for (let i = 0; i < row2.length; i++) {
        ret += row2[i] * (col[i] || 0);
      }
      return ret;
    })
  );
  if (m3 === 1) {
    product = product[0];
  }
  if (p2 === 1) {
    return product.map((x2) => x2[0]);
  }
  return product;
}
function isString(str) {
  return type(str) === "string";
}
function type(o2) {
  let str = Object.prototype.toString.call(o2);
  return (str.match(/^\[object\s+(.*?)\]$/)[1] || "").toLowerCase();
}
function toPrecision(n2, precision) {
  n2 = +n2;
  precision = +precision;
  let integerLength = (Math.floor(n2) + "").length;
  if (precision > integerLength) {
    return +n2.toFixed(precision - integerLength);
  } else {
    let p10 = 10 ** (integerLength - precision);
    return Math.round(n2 / p10) * p10;
  }
}
function parseFunction(str) {
  if (!str) {
    return;
  }
  str = str.trim();
  const isFunctionRegex = /^([a-z]+)\((.+?)\)$/i;
  const isNumberRegex = /^-?[\d.]+$/;
  let parts = str.match(isFunctionRegex);
  if (parts) {
    let args = [];
    parts[2].replace(/\/?\s*([-\w.]+(?:%|deg)?)/g, ($0, arg) => {
      if (/%$/.test(arg)) {
        arg = new Number(arg.slice(0, -1) / 100);
        arg.type = "<percentage>";
      } else if (/deg$/.test(arg)) {
        arg = new Number(+arg.slice(0, -3));
        arg.type = "<angle>";
        arg.unit = "deg";
      } else if (isNumberRegex.test(arg)) {
        arg = new Number(arg);
        arg.type = "<number>";
      }
      if ($0.startsWith("/")) {
        arg = arg instanceof Number ? arg : new Number(arg);
        arg.alpha = true;
      }
      args.push(arg);
    });
    return {
      name: parts[1].toLowerCase(),
      rawName: parts[1],
      rawArgs: parts[2],
      // An argument could be (as of css-color-4):
      // a number, percentage, degrees (hue), ident (in color())
      args
    };
  }
}
function last(arr) {
  return arr[arr.length - 1];
}
function interpolate(start, end, p2) {
  if (isNaN(start)) {
    return end;
  }
  if (isNaN(end)) {
    return start;
  }
  return start + (end - start) * p2;
}
function interpolateInv(start, end, value) {
  return (value - start) / (end - start);
}
function mapRange(from2, to2, value) {
  return interpolate(to2[0], to2[1], interpolateInv(from2[0], from2[1], value));
}
function parseCoordGrammar(coordGrammars) {
  return coordGrammars.map((coordGrammar2) => {
    return coordGrammar2.split("|").map((type2) => {
      type2 = type2.trim();
      let range2 = type2.match(/^(<[a-z]+>)\[(-?[.\d]+),\s*(-?[.\d]+)\]?$/);
      if (range2) {
        let ret = new String(range2[1]);
        ret.range = [+range2[2], +range2[3]];
        return ret;
      }
      return type2;
    });
  });
}
var util = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  interpolate,
  interpolateInv,
  isString,
  last,
  mapRange,
  multiplyMatrices,
  parseCoordGrammar,
  parseFunction,
  toPrecision,
  type
});
class Hooks {
  add(name, callback2, first) {
    if (typeof arguments[0] != "string") {
      for (var name in arguments[0]) {
        this.add(name, arguments[0][name], arguments[1]);
      }
      return;
    }
    (Array.isArray(name) ? name : [name]).forEach(function(name2) {
      this[name2] = this[name2] || [];
      if (callback2) {
        this[name2][first ? "unshift" : "push"](callback2);
      }
    }, this);
  }
  run(name, env) {
    this[name] = this[name] || [];
    this[name].forEach(function(callback2) {
      callback2.call(env && env.context ? env.context : env, env);
    });
  }
}
const hooks = new Hooks();
var defaults = {
  gamut_mapping: "lch.c",
  precision: 5,
  deltaE: "76"
  // Default deltaE method
};
const WHITES = {
  // for compatibility, the four-digit chromaticity-derived ones everyone else uses
  D50: [0.3457 / 0.3585, 1, (1 - 0.3457 - 0.3585) / 0.3585],
  D65: [0.3127 / 0.329, 1, (1 - 0.3127 - 0.329) / 0.329]
};
function getWhite(name) {
  if (Array.isArray(name)) {
    return name;
  }
  return WHITES[name];
}
function adapt$1(W1, W2, XYZ, options2 = {}) {
  W1 = getWhite(W1);
  W2 = getWhite(W2);
  if (!W1 || !W2) {
    throw new TypeError(
      `Missing white point to convert ${!W1 ? "from" : ""}${!W1 && !W2 ? "/" : ""}${!W2 ? "to" : ""}`
    );
  }
  if (W1 === W2) {
    return XYZ;
  }
  let env = { W1, W2, XYZ, options: options2 };
  hooks.run("chromatic-adaptation-start", env);
  if (!env.M) {
    if (env.W1 === WHITES.D65 && env.W2 === WHITES.D50) {
      env.M = [
        [1.0479298208405488, 0.022946793341019088, -0.05019222954313557],
        [0.029627815688159344, 0.990434484573249, -0.01707382502938514],
        [-0.009243058152591178, 0.015055144896577895, 0.7518742899580008]
      ];
    } else if (env.W1 === WHITES.D50 && env.W2 === WHITES.D65) {
      env.M = [
        [0.9554734527042182, -0.023098536874261423, 0.0632593086610217],
        [-0.028369706963208136, 1.0099954580058226, 0.021041398966943008],
        [0.012314001688319899, -0.020507696433477912, 1.3303659366080753]
      ];
    }
  }
  hooks.run("chromatic-adaptation-end", env);
  if (env.M) {
    return multiplyMatrices(env.M, env.XYZ);
  } else {
    throw new TypeError("Only Bradford CAT with white points D50 and D65 supported for now.");
  }
}
const ε$4 = 75e-6;
const _ColorSpace = class _ColorSpace {
  constructor(options2) {
    var _a2, _b2, _c;
    this.id = options2.id;
    this.name = options2.name;
    this.base = options2.base ? _ColorSpace.get(options2.base) : null;
    this.aliases = options2.aliases;
    if (this.base) {
      this.fromBase = options2.fromBase;
      this.toBase = options2.toBase;
    }
    let coords = options2.coords ?? this.base.coords;
    for (let name in coords) {
      if (!("name" in coords[name])) {
        coords[name].name = name;
      }
    }
    this.coords = coords;
    let white2 = options2.white ?? this.base.white ?? "D65";
    this.white = getWhite(white2);
    this.formats = options2.formats ?? {};
    for (let name in this.formats) {
      let format = this.formats[name];
      format.type || (format.type = "function");
      format.name || (format.name = name);
    }
    if (options2.cssId && !((_a2 = this.formats.functions) == null ? void 0 : _a2.color)) {
      this.formats.color = { id: options2.cssId };
      Object.defineProperty(this, "cssId", { value: options2.cssId });
    } else if (((_b2 = this.formats) == null ? void 0 : _b2.color) && !((_c = this.formats) == null ? void 0 : _c.color.id)) {
      this.formats.color.id = this.id;
    }
    this.referred = options2.referred;
    Object.defineProperty(this, "path", {
      value: getPath(this).reverse(),
      writable: false,
      enumerable: true,
      configurable: true
    });
    hooks.run("colorspace-init-end", this);
  }
  inGamut(coords, { epsilon = ε$4 } = {}) {
    if (this.isPolar) {
      coords = this.toBase(coords);
      return this.base.inGamut(coords, { epsilon });
    }
    let coordMeta = Object.values(this.coords);
    return coords.every((c4, i) => {
      let meta = coordMeta[i];
      if (meta.type !== "angle" && meta.range) {
        if (Number.isNaN(c4)) {
          return true;
        }
        let [min2, max2] = meta.range;
        return (min2 === void 0 || c4 >= min2 - epsilon) && (max2 === void 0 || c4 <= max2 + epsilon);
      }
      return true;
    });
  }
  get cssId() {
    var _a2, _b2;
    return ((_b2 = (_a2 = this.formats.functions) == null ? void 0 : _a2.color) == null ? void 0 : _b2.id) || this.id;
  }
  get isPolar() {
    for (let id in this.coords) {
      if (this.coords[id].type === "angle") {
        return true;
      }
    }
    return false;
  }
  getFormat(format) {
    if (typeof format === "object") {
      format = processFormat(format, this);
      return format;
    }
    let ret;
    if (format === "default") {
      ret = Object.values(this.formats)[0];
    } else {
      ret = this.formats[format];
    }
    if (ret) {
      ret = processFormat(ret, this);
      return ret;
    }
    return null;
  }
  // We cannot rely on simple === because then ColorSpace objects cannot be proxied
  equals(space) {
    if (!space) {
      return false;
    }
    return this === space || this.id === space.id;
  }
  to(space, coords) {
    if (arguments.length === 1) {
      [space, coords] = [space.space, space.coords];
    }
    space = _ColorSpace.get(space);
    if (this.equals(space)) {
      return coords;
    }
    coords = coords.map((c4) => Number.isNaN(c4) ? 0 : c4);
    let myPath = this.path;
    let otherPath = space.path;
    let connectionSpace, connectionSpaceIndex;
    for (let i = 0; i < myPath.length; i++) {
      if (myPath[i].equals(otherPath[i])) {
        connectionSpace = myPath[i];
        connectionSpaceIndex = i;
      } else {
        break;
      }
    }
    if (!connectionSpace) {
      throw new Error(
        `Cannot convert between color spaces ${this} and ${space}: no connection space was found`
      );
    }
    for (let i = myPath.length - 1; i > connectionSpaceIndex; i--) {
      coords = myPath[i].toBase(coords);
    }
    for (let i = connectionSpaceIndex + 1; i < otherPath.length; i++) {
      coords = otherPath[i].fromBase(coords);
    }
    return coords;
  }
  from(space, coords) {
    if (arguments.length === 1) {
      [space, coords] = [space.space, space.coords];
    }
    space = _ColorSpace.get(space);
    return space.to(this, coords);
  }
  toString() {
    return `${this.name} (${this.id})`;
  }
  getMinCoords() {
    let ret = [];
    for (let id in this.coords) {
      let meta = this.coords[id];
      let range2 = meta.range || meta.refRange;
      ret.push((range2 == null ? void 0 : range2.min) ?? 0);
    }
    return ret;
  }
  // Returns array of unique color spaces
  static get all() {
    return [...new Set(Object.values(_ColorSpace.registry))];
  }
  static register(id, space) {
    if (arguments.length === 1) {
      space = arguments[0];
      id = space.id;
    }
    space = this.get(space);
    if (this.registry[id] && this.registry[id] !== space) {
      throw new Error(`Duplicate color space registration: '${id}'`);
    }
    this.registry[id] = space;
    if (arguments.length === 1 && space.aliases) {
      for (let alias of space.aliases) {
        this.register(alias, space);
      }
    }
    return space;
  }
  /**
   * Lookup ColorSpace object by name
   * @param {ColorSpace | string} name
   */
  static get(space, ...alternatives) {
    if (!space || space instanceof _ColorSpace) {
      return space;
    }
    let argType = type(space);
    if (argType === "string") {
      let ret = _ColorSpace.registry[space.toLowerCase()];
      if (!ret) {
        throw new TypeError(`No color space found with id = "${space}"`);
      }
      return ret;
    }
    if (alternatives.length) {
      return _ColorSpace.get(...alternatives);
    }
    throw new TypeError(`${space} is not a valid color space`);
  }
  /**
   * Get metadata about a coordinate of a color space
   *
   * @static
   * @param {Array | string} ref
   * @param {ColorSpace | string} [workingSpace]
   * @return {Object}
   */
  static resolveCoord(ref, workingSpace) {
    var _a2;
    let coordType = type(ref);
    let space, coord;
    if (coordType === "string") {
      if (ref.includes(".")) {
        [space, coord] = ref.split(".");
      } else {
        [space, coord] = [, ref];
      }
    } else if (Array.isArray(ref)) {
      [space, coord] = ref;
    } else {
      space = ref.space;
      coord = ref.coordId;
    }
    space = _ColorSpace.get(space);
    if (!space) {
      space = workingSpace;
    }
    if (!space) {
      throw new TypeError(
        `Cannot resolve coordinate reference ${ref}: No color space specified and relative references are not allowed here`
      );
    }
    coordType = type(coord);
    if (coordType === "number" || coordType === "string" && coord >= 0) {
      let meta = Object.entries(space.coords)[coord];
      if (meta) {
        return { space, id: meta[0], index: coord, ...meta[1] };
      }
    }
    space = _ColorSpace.get(space);
    let normalizedCoord = coord.toLowerCase();
    let i = 0;
    for (let id in space.coords) {
      let meta = space.coords[id];
      if (id.toLowerCase() === normalizedCoord || ((_a2 = meta.name) == null ? void 0 : _a2.toLowerCase()) === normalizedCoord) {
        return { space, id, index: i, ...meta };
      }
      i++;
    }
    throw new TypeError(
      `No "${coord}" coordinate found in ${space.name}. Its coordinates are: ${Object.keys(
        space.coords
      ).join(", ")}`
    );
  }
};
__publicField(_ColorSpace, "registry", {});
__publicField(_ColorSpace, "DEFAULT_FORMAT", {
  type: "functions",
  name: "color"
});
let ColorSpace = _ColorSpace;
function getPath(space) {
  let ret = [space];
  for (let s2 = space; s2 = s2.base; ) {
    ret.push(s2);
  }
  return ret;
}
function processFormat(format, { coords } = {}) {
  if (format.coords && !format.coordGrammar) {
    format.type || (format.type = "function");
    format.name || (format.name = "color");
    format.coordGrammar = parseCoordGrammar(format.coords);
    let coordFormats = Object.entries(coords).map(([id, coordMeta], i) => {
      let outputType = format.coordGrammar[i][0];
      let fromRange = coordMeta.range || coordMeta.refRange;
      let toRange = outputType.range, suffix = "";
      if (outputType == "<percentage>") {
        toRange = [0, 100];
        suffix = "%";
      } else if (outputType == "<angle>") {
        suffix = "deg";
      }
      return { fromRange, toRange, suffix };
    });
    format.serializeCoords = (coords2, precision) => {
      return coords2.map((c4, i) => {
        let { fromRange, toRange, suffix } = coordFormats[i];
        if (fromRange && toRange) {
          c4 = mapRange(fromRange, toRange, c4);
        }
        c4 = toPrecision(c4, precision);
        if (suffix) {
          c4 += suffix;
        }
        return c4;
      });
    };
  }
  return format;
}
var XYZ_D65 = new ColorSpace({
  id: "xyz-d65",
  name: "XYZ D65",
  coords: {
    x: { name: "X" },
    y: { name: "Y" },
    z: { name: "Z" }
  },
  white: "D65",
  formats: {
    color: {
      ids: ["xyz-d65", "xyz"]
    }
  },
  aliases: ["xyz"]
});
class RGBColorSpace extends ColorSpace {
  /**
   * Creates a new RGB ColorSpace.
   * If coords are not specified, they will use the default RGB coords.
   * Instead of `fromBase()` and `toBase()` functions,
   * you can specify to/from XYZ matrices and have `toBase()` and `fromBase()` automatically generated.
   * @param {*} options - Same options as {@link ColorSpace} plus:
   * @param {number[][]} options.toXYZ_M - Matrix to convert to XYZ
   * @param {number[][]} options.fromXYZ_M - Matrix to convert from XYZ
   */
  constructor(options2) {
    if (!options2.coords) {
      options2.coords = {
        r: {
          range: [0, 1],
          name: "Red"
        },
        g: {
          range: [0, 1],
          name: "Green"
        },
        b: {
          range: [0, 1],
          name: "Blue"
        }
      };
    }
    if (!options2.base) {
      options2.base = XYZ_D65;
    }
    if (options2.toXYZ_M && options2.fromXYZ_M) {
      options2.toBase ?? (options2.toBase = (rgb) => {
        let xyz = multiplyMatrices(options2.toXYZ_M, rgb);
        if (this.white !== this.base.white) {
          xyz = adapt$1(this.white, this.base.white, xyz);
        }
        return xyz;
      });
      options2.fromBase ?? (options2.fromBase = (xyz) => {
        xyz = adapt$1(this.base.white, this.white, xyz);
        return multiplyMatrices(options2.fromXYZ_M, xyz);
      });
    }
    options2.referred ?? (options2.referred = "display");
    super(options2);
  }
}
function parse(str, { meta } = {}) {
  var _a2, _b2, _c, _d, _e;
  let env = { str: (_a2 = String(str)) == null ? void 0 : _a2.trim() };
  hooks.run("parse-start", env);
  if (env.color) {
    return env.color;
  }
  env.parsed = parseFunction(env.str);
  if (env.parsed) {
    let name = env.parsed.name;
    if (name === "color") {
      let id = env.parsed.args.shift();
      let alpha2 = env.parsed.rawArgs.indexOf("/") > 0 ? env.parsed.args.pop() : 1;
      for (let space of ColorSpace.all) {
        let colorSpec = space.getFormat("color");
        if (colorSpec) {
          if (id === colorSpec.id || ((_b2 = colorSpec.ids) == null ? void 0 : _b2.includes(id))) {
            const coords = Object.keys(space.coords).map((_2, i) => env.parsed.args[i] || 0);
            if (meta) {
              meta.formatId = "color";
            }
            return { spaceId: space.id, coords, alpha: alpha2 };
          }
        }
      }
      let didYouMean = "";
      if (id in ColorSpace.registry) {
        let cssId = (_e = (_d = (_c = ColorSpace.registry[id].formats) == null ? void 0 : _c.functions) == null ? void 0 : _d.color) == null ? void 0 : _e.id;
        if (cssId) {
          didYouMean = `Did you mean color(${cssId})?`;
        }
      }
      throw new TypeError(`Cannot parse color(${id}). ` + (didYouMean || "Missing a plugin?"));
    } else {
      for (let space of ColorSpace.all) {
        let format = space.getFormat(name);
        if (format && format.type === "function") {
          let alpha2 = 1;
          if (format.lastAlpha || last(env.parsed.args).alpha) {
            alpha2 = env.parsed.args.pop();
          }
          let coords = env.parsed.args;
          let types;
          if (format.coordGrammar) {
            types = Object.entries(space.coords).map(([id, coordMeta], i) => {
              var _a3;
              let coordGrammar2 = format.coordGrammar[i];
              let providedType = (_a3 = coords[i]) == null ? void 0 : _a3.type;
              let type2 = coordGrammar2.find((c4) => c4 == providedType);
              if (!type2) {
                let coordName = coordMeta.name || id;
                throw new TypeError(`${providedType} not allowed for ${coordName} in ${name}()`);
              }
              let fromRange = type2.range;
              if (providedType === "<percentage>") {
                fromRange || (fromRange = [0, 1]);
              }
              let toRange = coordMeta.range || coordMeta.refRange;
              if (fromRange && toRange) {
                coords[i] = mapRange(fromRange, toRange, coords[i]);
              }
              return type2;
            });
          }
          if (meta) {
            Object.assign(meta, { formatId: format.name, types });
          }
          return {
            spaceId: space.id,
            coords,
            alpha: alpha2
          };
        }
      }
    }
  } else {
    for (let space of ColorSpace.all) {
      for (let formatId in space.formats) {
        let format = space.formats[formatId];
        if (format.type !== "custom") {
          continue;
        }
        if (format.test && !format.test(env.str)) {
          continue;
        }
        let color2 = format.parse(env.str);
        if (color2) {
          color2.alpha ?? (color2.alpha = 1);
          if (meta) {
            meta.formatId = formatId;
          }
          return color2;
        }
      }
    }
  }
  throw new TypeError(`Could not parse ${str} as a color. Missing a plugin?`);
}
function getColor(color2) {
  if (!color2) {
    throw new TypeError("Empty color reference");
  }
  if (isString(color2)) {
    color2 = parse(color2);
  }
  let space = color2.space || color2.spaceId;
  if (!(space instanceof ColorSpace)) {
    color2.space = ColorSpace.get(space);
  }
  if (color2.alpha === void 0) {
    color2.alpha = 1;
  }
  return color2;
}
function getAll(color2, space) {
  space = ColorSpace.get(space);
  return space.from(color2);
}
function get(color2, prop) {
  let { space, index: index2 } = ColorSpace.resolveCoord(prop, color2.space);
  let coords = getAll(color2, space);
  return coords[index2];
}
function setAll(color2, space, coords) {
  space = ColorSpace.get(space);
  color2.coords = space.to(color2.space, coords);
  return color2;
}
function set(color2, prop, value) {
  color2 = getColor(color2);
  if (arguments.length === 2 && type(arguments[1]) === "object") {
    let object = arguments[1];
    for (let p2 in object) {
      set(color2, p2, object[p2]);
    }
  } else {
    if (typeof value === "function") {
      value = value(get(color2, prop));
    }
    let { space, index: index2 } = ColorSpace.resolveCoord(prop, color2.space);
    let coords = getAll(color2, space);
    coords[index2] = value;
    setAll(color2, space, coords);
  }
  return color2;
}
var XYZ_D50 = new ColorSpace({
  id: "xyz-d50",
  name: "XYZ D50",
  white: "D50",
  base: XYZ_D65,
  fromBase: (coords) => adapt$1(XYZ_D65.white, "D50", coords),
  toBase: (coords) => adapt$1("D50", XYZ_D65.white, coords),
  formats: {
    color: {}
  }
});
const ε$3 = 216 / 24389;
const ε3$1 = 24 / 116;
const κ$1 = 24389 / 27;
let white$1 = WHITES.D50;
var lab = new ColorSpace({
  id: "lab",
  name: "Lab",
  coords: {
    l: {
      refRange: [0, 100],
      name: "L"
    },
    a: {
      refRange: [-125, 125]
    },
    b: {
      refRange: [-125, 125]
    }
  },
  // Assuming XYZ is relative to D50, convert to CIE Lab
  // from CIE standard, which now defines these as a rational fraction
  white: white$1,
  base: XYZ_D50,
  // Convert D50-adapted XYX to Lab
  //  CIE 15.3:2004 section 8.2.1.1
  fromBase(XYZ) {
    let xyz = XYZ.map((value, i) => value / white$1[i]);
    let f2 = xyz.map((value) => value > ε$3 ? Math.cbrt(value) : (κ$1 * value + 16) / 116);
    return [
      116 * f2[1] - 16,
      // L
      500 * (f2[0] - f2[1]),
      // a
      200 * (f2[1] - f2[2])
      // b
    ];
  },
  // Convert Lab to D50-adapted XYZ
  // Same result as CIE 15.3:2004 Appendix D although the derivation is different
  // http://www.brucelindbloom.com/index.html?Eqn_RGB_XYZ_Matrix.html
  toBase(Lab) {
    let f2 = [];
    f2[1] = (Lab[0] + 16) / 116;
    f2[0] = Lab[1] / 500 + f2[1];
    f2[2] = f2[1] - Lab[2] / 200;
    let xyz = [
      f2[0] > ε3$1 ? Math.pow(f2[0], 3) : (116 * f2[0] - 16) / κ$1,
      Lab[0] > 8 ? Math.pow((Lab[0] + 16) / 116, 3) : Lab[0] / κ$1,
      f2[2] > ε3$1 ? Math.pow(f2[2], 3) : (116 * f2[2] - 16) / κ$1
    ];
    return xyz.map((value, i) => value * white$1[i]);
  },
  formats: {
    lab: {
      coords: [
        "<number> | <percentage>",
        "<number> | <percentage>[-1,1]",
        "<number> | <percentage>[-1,1]"
      ]
    }
  }
});
function constrain(angle) {
  return (angle % 360 + 360) % 360;
}
function adjust(arc, angles) {
  if (arc === "raw") {
    return angles;
  }
  let [a1, a2] = angles.map(constrain);
  let angleDiff = a2 - a1;
  if (arc === "increasing") {
    if (angleDiff < 0) {
      a2 += 360;
    }
  } else if (arc === "decreasing") {
    if (angleDiff > 0) {
      a1 += 360;
    }
  } else if (arc === "longer") {
    if (-180 < angleDiff && angleDiff < 180) {
      if (angleDiff > 0) {
        a1 += 360;
      } else {
        a2 += 360;
      }
    }
  } else if (arc === "shorter") {
    if (angleDiff > 180) {
      a1 += 360;
    } else if (angleDiff < -180) {
      a2 += 360;
    }
  }
  return [a1, a2];
}
var lch = new ColorSpace({
  id: "lch",
  name: "LCH",
  coords: {
    l: {
      refRange: [0, 100],
      name: "Lightness"
    },
    c: {
      refRange: [0, 150],
      name: "Chroma"
    },
    h: {
      refRange: [0, 360],
      type: "angle",
      name: "Hue"
    }
  },
  base: lab,
  fromBase(Lab) {
    let [L2, a2, b2] = Lab;
    let hue2;
    const ε2 = 0.02;
    if (Math.abs(a2) < ε2 && Math.abs(b2) < ε2) {
      hue2 = NaN;
    } else {
      hue2 = Math.atan2(b2, a2) * 180 / Math.PI;
    }
    return [
      L2,
      // L is still L
      Math.sqrt(a2 ** 2 + b2 ** 2),
      // Chroma
      constrain(hue2)
      // Hue, in degrees [0 to 360)
    ];
  },
  toBase(LCH) {
    let [Lightness, Chroma, Hue] = LCH;
    if (Chroma < 0) {
      Chroma = 0;
    }
    if (isNaN(Hue)) {
      Hue = 0;
    }
    return [
      Lightness,
      // L is still L
      Chroma * Math.cos(Hue * Math.PI / 180),
      // a
      Chroma * Math.sin(Hue * Math.PI / 180)
      // b
    ];
  },
  formats: {
    lch: {
      coords: ["<number> | <percentage>", "<number> | <percentage>", "<number> | <angle>"]
    }
  }
});
const Gfactor = 25 ** 7;
const π$1 = Math.PI;
const r2d = 180 / π$1;
const d2r$1 = π$1 / 180;
function deltaE2000(color2, sample2, { kL = 1, kC = 1, kH = 1 } = {}) {
  let [L1, a1, b1] = lab.from(color2);
  let C1 = lch.from(lab, [L1, a1, b1])[1];
  let [L2, a2, b2] = lab.from(sample2);
  let C2 = lch.from(lab, [L2, a2, b2])[1];
  if (C1 < 0) {
    C1 = 0;
  }
  if (C2 < 0) {
    C2 = 0;
  }
  let Cbar = (C1 + C2) / 2;
  let C7 = Cbar ** 7;
  let G = 0.5 * (1 - Math.sqrt(C7 / (C7 + Gfactor)));
  let adash1 = (1 + G) * a1;
  let adash2 = (1 + G) * a2;
  let Cdash1 = Math.sqrt(adash1 ** 2 + b1 ** 2);
  let Cdash2 = Math.sqrt(adash2 ** 2 + b2 ** 2);
  let h12 = adash1 === 0 && b1 === 0 ? 0 : Math.atan2(b1, adash1);
  let h22 = adash2 === 0 && b2 === 0 ? 0 : Math.atan2(b2, adash2);
  if (h12 < 0) {
    h12 += 2 * π$1;
  }
  if (h22 < 0) {
    h22 += 2 * π$1;
  }
  h12 *= r2d;
  h22 *= r2d;
  let ΔL = L2 - L1;
  let ΔC = Cdash2 - Cdash1;
  let hdiff = h22 - h12;
  let hsum = h12 + h22;
  let habs = Math.abs(hdiff);
  let Δh;
  if (Cdash1 * Cdash2 === 0) {
    Δh = 0;
  } else if (habs <= 180) {
    Δh = hdiff;
  } else if (hdiff > 180) {
    Δh = hdiff - 360;
  } else if (hdiff < -180) {
    Δh = hdiff + 360;
  } else {
    console.log("the unthinkable has happened");
  }
  let ΔH = 2 * Math.sqrt(Cdash2 * Cdash1) * Math.sin(Δh * d2r$1 / 2);
  let Ldash = (L1 + L2) / 2;
  let Cdash = (Cdash1 + Cdash2) / 2;
  let Cdash7 = Math.pow(Cdash, 7);
  let hdash;
  if (Cdash1 * Cdash2 === 0) {
    hdash = hsum;
  } else if (habs <= 180) {
    hdash = hsum / 2;
  } else if (hsum < 360) {
    hdash = (hsum + 360) / 2;
  } else {
    hdash = (hsum - 360) / 2;
  }
  let lsq = (Ldash - 50) ** 2;
  let SL = 1 + 0.015 * lsq / Math.sqrt(20 + lsq);
  let SC = 1 + 0.045 * Cdash;
  let T2 = 1;
  T2 -= 0.17 * Math.cos((hdash - 30) * d2r$1);
  T2 += 0.24 * Math.cos(2 * hdash * d2r$1);
  T2 += 0.32 * Math.cos((3 * hdash + 6) * d2r$1);
  T2 -= 0.2 * Math.cos((4 * hdash - 63) * d2r$1);
  let SH = 1 + 0.015 * Cdash * T2;
  let Δθ = 30 * Math.exp(-1 * ((hdash - 275) / 25) ** 2);
  let RC = 2 * Math.sqrt(Cdash7 / (Cdash7 + Gfactor));
  let RT = -1 * Math.sin(2 * Δθ * d2r$1) * RC;
  let dE = (ΔL / (kL * SL)) ** 2;
  dE += (ΔC / (kC * SC)) ** 2;
  dE += (ΔH / (kH * SH)) ** 2;
  dE += RT * (ΔC / (kC * SC)) * (ΔH / (kH * SH));
  return Math.sqrt(dE);
}
const ε$2 = 75e-6;
function inGamut(color2, space = color2.space, { epsilon = ε$2 } = {}) {
  color2 = getColor(color2);
  space = ColorSpace.get(space);
  let coords = color2.coords;
  if (space !== color2.space) {
    coords = space.from(color2);
  }
  return space.inGamut(coords, { epsilon });
}
function clone(color2) {
  return {
    space: color2.space,
    coords: color2.coords.slice(),
    alpha: color2.alpha
  };
}
function toGamut(color2, { method = defaults.gamut_mapping, space = color2.space } = {}) {
  if (isString(arguments[1])) {
    space = arguments[1];
  }
  space = ColorSpace.get(space);
  if (inGamut(color2, space, { epsilon: 0 })) {
    return getColor(color2);
  }
  let spaceColor = to(color2, space);
  if (method !== "clip" && !inGamut(color2, space)) {
    let clipped = toGamut(clone(spaceColor), { method: "clip", space });
    if (deltaE2000(color2, clipped) > 2) {
      let coordMeta = ColorSpace.resolveCoord(method);
      let mapSpace = coordMeta.space;
      let coordId = coordMeta.id;
      let mappedColor = to(spaceColor, mapSpace);
      let bounds = coordMeta.range || coordMeta.refRange;
      let min2 = bounds[0];
      let ε2 = 0.01;
      let low = min2;
      let high = get(mappedColor, coordId);
      while (high - low > ε2) {
        let clipped2 = clone(mappedColor);
        clipped2 = toGamut(clipped2, { space, method: "clip" });
        let deltaE2 = deltaE2000(mappedColor, clipped2);
        if (deltaE2 - 2 < ε2) {
          low = get(mappedColor, coordId);
        } else {
          high = get(mappedColor, coordId);
        }
        set(mappedColor, coordId, (low + high) / 2);
      }
      spaceColor = to(mappedColor, space);
    } else {
      spaceColor = clipped;
    }
  }
  if (method === "clip" || // Dumb coord clipping
  // finish off smarter gamut mapping with clip to get rid of ε, see #17
  !inGamut(spaceColor, space, { epsilon: 0 })) {
    let bounds = Object.values(space.coords).map((c4) => c4.range || []);
    spaceColor.coords = spaceColor.coords.map((c4, i) => {
      let [min2, max2] = bounds[i];
      if (min2 !== void 0) {
        c4 = Math.max(min2, c4);
      }
      if (max2 !== void 0) {
        c4 = Math.min(c4, max2);
      }
      return c4;
    });
  }
  if (space !== color2.space) {
    spaceColor = to(spaceColor, color2.space);
  }
  color2.coords = spaceColor.coords;
  return color2;
}
toGamut.returns = "color";
function to(color2, space, { inGamut: inGamut2 } = {}) {
  color2 = getColor(color2);
  space = ColorSpace.get(space);
  let coords = space.from(color2);
  let ret = { space, coords, alpha: color2.alpha };
  if (inGamut2) {
    ret = toGamut(ret);
  }
  return ret;
}
to.returns = "color";
function serialize(color2, {
  precision = defaults.precision,
  format = "default",
  inGamut: inGamut$1 = true,
  ...customOptions
} = {}) {
  var _a2;
  let ret;
  color2 = getColor(color2);
  let formatId = format;
  format = color2.space.getFormat(format) ?? color2.space.getFormat("default") ?? ColorSpace.DEFAULT_FORMAT;
  inGamut$1 || (inGamut$1 = format.toGamut);
  let coords = color2.coords;
  coords = coords.map((c4) => c4 ? c4 : 0);
  if (inGamut$1 && !inGamut(color2)) {
    coords = toGamut(clone(color2), inGamut$1 === true ? void 0 : inGamut$1).coords;
  }
  if (format.type === "custom") {
    customOptions.precision = precision;
    if (format.serialize) {
      ret = format.serialize(coords, color2.alpha, customOptions);
    } else {
      throw new TypeError(
        `format ${formatId} can only be used to parse colors, not for serialization`
      );
    }
  } else {
    let name = format.name || "color";
    if (format.serializeCoords) {
      coords = format.serializeCoords(coords, precision);
    } else {
      if (precision !== null) {
        coords = coords.map((c4) => toPrecision(c4, precision));
      }
    }
    let args = [...coords];
    if (name === "color") {
      let cssId = format.id || ((_a2 = format.ids) == null ? void 0 : _a2[0]) || color2.space.id;
      args.unshift(cssId);
    }
    let alpha2 = color2.alpha;
    if (precision !== null) {
      alpha2 = toPrecision(alpha2, precision);
    }
    let strAlpha = color2.alpha < 1 && !format.noAlpha ? `${format.commas ? "," : " /"} ${alpha2}` : "";
    ret = `${name}(${args.join(format.commas ? ", " : " ")}${strAlpha})`;
  }
  return ret;
}
const toXYZ_M$5 = [
  [0.6369580483012914, 0.14461690358620832, 0.1688809751641721],
  [0.2627002120112671, 0.6779980715188708, 0.05930171646986196],
  [0, 0.028072693049087428, 1.060985057710791]
];
const fromXYZ_M$5 = [
  [1.716651187971268, -0.355670783776392, -0.25336628137366],
  [-0.666684351832489, 1.616481236634939, 0.0157685458139111],
  [0.017639857445311, -0.042770613257809, 0.942103121235474]
];
var REC2020Linear = new RGBColorSpace({
  id: "rec2020-linear",
  name: "Linear REC.2020",
  white: "D65",
  toXYZ_M: toXYZ_M$5,
  fromXYZ_M: fromXYZ_M$5,
  formats: {
    color: {}
  }
});
const α = 1.09929682680944;
const β = 0.018053968510807;
var REC2020 = new RGBColorSpace({
  id: "rec2020",
  name: "REC.2020",
  base: REC2020Linear,
  // Non-linear transfer function from Rec. ITU-R BT.2020-2 table 4
  toBase(RGB) {
    return RGB.map(function(val) {
      if (val < β * 4.5) {
        return val / 4.5;
      }
      return Math.pow((val + α - 1) / α, 1 / 0.45);
    });
  },
  fromBase(RGB) {
    return RGB.map(function(val) {
      if (val >= β) {
        return α * Math.pow(val, 0.45) - (α - 1);
      }
      return 4.5 * val;
    });
  },
  formats: {
    color: {}
  }
});
const toXYZ_M$4 = [
  [0.4865709486482162, 0.26566769316909306, 0.1982172852343625],
  [0.2289745640697488, 0.6917385218365064, 0.079286914093745],
  [0, 0.04511338185890264, 1.043944368900976]
];
const fromXYZ_M$4 = [
  [2.493496911941425, -0.9313836179191239, -0.40271078445071684],
  [-0.8294889695615747, 1.7626640603183463, 0.023624685841943577],
  [0.03584583024378447, -0.07617238926804182, 0.9568845240076872]
];
var P3Linear = new RGBColorSpace({
  id: "p3-linear",
  name: "Linear P3",
  white: "D65",
  toXYZ_M: toXYZ_M$4,
  fromXYZ_M: fromXYZ_M$4
});
const toXYZ_M$3 = [
  [0.41239079926595934, 0.357584339383878, 0.1804807884018343],
  [0.21263900587151027, 0.715168678767756, 0.07219231536073371],
  [0.01933081871559182, 0.11919477979462598, 0.9505321522496607]
];
const fromXYZ_M$3 = [
  [3.2409699419045226, -1.537383177570094, -0.4986107602930034],
  [-0.9692436362808796, 1.8759675015077202, 0.04155505740717559],
  [0.05563007969699366, -0.20397695888897652, 1.0569715142428786]
];
var sRGBLinear = new RGBColorSpace({
  id: "srgb-linear",
  name: "Linear sRGB",
  white: "D65",
  toXYZ_M: toXYZ_M$3,
  fromXYZ_M: fromXYZ_M$3,
  formats: {
    color: {}
  }
});
var KEYWORDS = {
  aliceblue: [240 / 255, 248 / 255, 1],
  antiquewhite: [250 / 255, 235 / 255, 215 / 255],
  aqua: [0, 1, 1],
  aquamarine: [127 / 255, 1, 212 / 255],
  azure: [240 / 255, 1, 1],
  beige: [245 / 255, 245 / 255, 220 / 255],
  bisque: [1, 228 / 255, 196 / 255],
  black: [0, 0, 0],
  blanchedalmond: [1, 235 / 255, 205 / 255],
  blue: [0, 0, 1],
  blueviolet: [138 / 255, 43 / 255, 226 / 255],
  brown: [165 / 255, 42 / 255, 42 / 255],
  burlywood: [222 / 255, 184 / 255, 135 / 255],
  cadetblue: [95 / 255, 158 / 255, 160 / 255],
  chartreuse: [127 / 255, 1, 0],
  chocolate: [210 / 255, 105 / 255, 30 / 255],
  coral: [1, 127 / 255, 80 / 255],
  cornflowerblue: [100 / 255, 149 / 255, 237 / 255],
  cornsilk: [1, 248 / 255, 220 / 255],
  crimson: [220 / 255, 20 / 255, 60 / 255],
  cyan: [0, 1, 1],
  darkblue: [0, 0, 139 / 255],
  darkcyan: [0, 139 / 255, 139 / 255],
  darkgoldenrod: [184 / 255, 134 / 255, 11 / 255],
  darkgray: [169 / 255, 169 / 255, 169 / 255],
  darkgreen: [0, 100 / 255, 0],
  darkgrey: [169 / 255, 169 / 255, 169 / 255],
  darkkhaki: [189 / 255, 183 / 255, 107 / 255],
  darkmagenta: [139 / 255, 0, 139 / 255],
  darkolivegreen: [85 / 255, 107 / 255, 47 / 255],
  darkorange: [1, 140 / 255, 0],
  darkorchid: [153 / 255, 50 / 255, 204 / 255],
  darkred: [139 / 255, 0, 0],
  darksalmon: [233 / 255, 150 / 255, 122 / 255],
  darkseagreen: [143 / 255, 188 / 255, 143 / 255],
  darkslateblue: [72 / 255, 61 / 255, 139 / 255],
  darkslategray: [47 / 255, 79 / 255, 79 / 255],
  darkslategrey: [47 / 255, 79 / 255, 79 / 255],
  darkturquoise: [0, 206 / 255, 209 / 255],
  darkviolet: [148 / 255, 0, 211 / 255],
  deeppink: [1, 20 / 255, 147 / 255],
  deepskyblue: [0, 191 / 255, 1],
  dimgray: [105 / 255, 105 / 255, 105 / 255],
  dimgrey: [105 / 255, 105 / 255, 105 / 255],
  dodgerblue: [30 / 255, 144 / 255, 1],
  firebrick: [178 / 255, 34 / 255, 34 / 255],
  floralwhite: [1, 250 / 255, 240 / 255],
  forestgreen: [34 / 255, 139 / 255, 34 / 255],
  fuchsia: [1, 0, 1],
  gainsboro: [220 / 255, 220 / 255, 220 / 255],
  ghostwhite: [248 / 255, 248 / 255, 1],
  gold: [1, 215 / 255, 0],
  goldenrod: [218 / 255, 165 / 255, 32 / 255],
  gray: [128 / 255, 128 / 255, 128 / 255],
  green: [0, 128 / 255, 0],
  greenyellow: [173 / 255, 1, 47 / 255],
  grey: [128 / 255, 128 / 255, 128 / 255],
  honeydew: [240 / 255, 1, 240 / 255],
  hotpink: [1, 105 / 255, 180 / 255],
  indianred: [205 / 255, 92 / 255, 92 / 255],
  indigo: [75 / 255, 0, 130 / 255],
  ivory: [1, 1, 240 / 255],
  khaki: [240 / 255, 230 / 255, 140 / 255],
  lavender: [230 / 255, 230 / 255, 250 / 255],
  lavenderblush: [1, 240 / 255, 245 / 255],
  lawngreen: [124 / 255, 252 / 255, 0],
  lemonchiffon: [1, 250 / 255, 205 / 255],
  lightblue: [173 / 255, 216 / 255, 230 / 255],
  lightcoral: [240 / 255, 128 / 255, 128 / 255],
  lightcyan: [224 / 255, 1, 1],
  lightgoldenrodyellow: [250 / 255, 250 / 255, 210 / 255],
  lightgray: [211 / 255, 211 / 255, 211 / 255],
  lightgreen: [144 / 255, 238 / 255, 144 / 255],
  lightgrey: [211 / 255, 211 / 255, 211 / 255],
  lightpink: [1, 182 / 255, 193 / 255],
  lightsalmon: [1, 160 / 255, 122 / 255],
  lightseagreen: [32 / 255, 178 / 255, 170 / 255],
  lightskyblue: [135 / 255, 206 / 255, 250 / 255],
  lightslategray: [119 / 255, 136 / 255, 153 / 255],
  lightslategrey: [119 / 255, 136 / 255, 153 / 255],
  lightsteelblue: [176 / 255, 196 / 255, 222 / 255],
  lightyellow: [1, 1, 224 / 255],
  lime: [0, 1, 0],
  limegreen: [50 / 255, 205 / 255, 50 / 255],
  linen: [250 / 255, 240 / 255, 230 / 255],
  magenta: [1, 0, 1],
  maroon: [128 / 255, 0, 0],
  mediumaquamarine: [102 / 255, 205 / 255, 170 / 255],
  mediumblue: [0, 0, 205 / 255],
  mediumorchid: [186 / 255, 85 / 255, 211 / 255],
  mediumpurple: [147 / 255, 112 / 255, 219 / 255],
  mediumseagreen: [60 / 255, 179 / 255, 113 / 255],
  mediumslateblue: [123 / 255, 104 / 255, 238 / 255],
  mediumspringgreen: [0, 250 / 255, 154 / 255],
  mediumturquoise: [72 / 255, 209 / 255, 204 / 255],
  mediumvioletred: [199 / 255, 21 / 255, 133 / 255],
  midnightblue: [25 / 255, 25 / 255, 112 / 255],
  mintcream: [245 / 255, 1, 250 / 255],
  mistyrose: [1, 228 / 255, 225 / 255],
  moccasin: [1, 228 / 255, 181 / 255],
  navajowhite: [1, 222 / 255, 173 / 255],
  navy: [0, 0, 128 / 255],
  oldlace: [253 / 255, 245 / 255, 230 / 255],
  olive: [128 / 255, 128 / 255, 0],
  olivedrab: [107 / 255, 142 / 255, 35 / 255],
  orange: [1, 165 / 255, 0],
  orangered: [1, 69 / 255, 0],
  orchid: [218 / 255, 112 / 255, 214 / 255],
  palegoldenrod: [238 / 255, 232 / 255, 170 / 255],
  palegreen: [152 / 255, 251 / 255, 152 / 255],
  paleturquoise: [175 / 255, 238 / 255, 238 / 255],
  palevioletred: [219 / 255, 112 / 255, 147 / 255],
  papayawhip: [1, 239 / 255, 213 / 255],
  peachpuff: [1, 218 / 255, 185 / 255],
  peru: [205 / 255, 133 / 255, 63 / 255],
  pink: [1, 192 / 255, 203 / 255],
  plum: [221 / 255, 160 / 255, 221 / 255],
  powderblue: [176 / 255, 224 / 255, 230 / 255],
  purple: [128 / 255, 0, 128 / 255],
  rebeccapurple: [102 / 255, 51 / 255, 153 / 255],
  red: [1, 0, 0],
  rosybrown: [188 / 255, 143 / 255, 143 / 255],
  royalblue: [65 / 255, 105 / 255, 225 / 255],
  saddlebrown: [139 / 255, 69 / 255, 19 / 255],
  salmon: [250 / 255, 128 / 255, 114 / 255],
  sandybrown: [244 / 255, 164 / 255, 96 / 255],
  seagreen: [46 / 255, 139 / 255, 87 / 255],
  seashell: [1, 245 / 255, 238 / 255],
  sienna: [160 / 255, 82 / 255, 45 / 255],
  silver: [192 / 255, 192 / 255, 192 / 255],
  skyblue: [135 / 255, 206 / 255, 235 / 255],
  slateblue: [106 / 255, 90 / 255, 205 / 255],
  slategray: [112 / 255, 128 / 255, 144 / 255],
  slategrey: [112 / 255, 128 / 255, 144 / 255],
  snow: [1, 250 / 255, 250 / 255],
  springgreen: [0, 1, 127 / 255],
  steelblue: [70 / 255, 130 / 255, 180 / 255],
  tan: [210 / 255, 180 / 255, 140 / 255],
  teal: [0, 128 / 255, 128 / 255],
  thistle: [216 / 255, 191 / 255, 216 / 255],
  tomato: [1, 99 / 255, 71 / 255],
  turquoise: [64 / 255, 224 / 255, 208 / 255],
  violet: [238 / 255, 130 / 255, 238 / 255],
  wheat: [245 / 255, 222 / 255, 179 / 255],
  white: [1, 1, 1],
  whitesmoke: [245 / 255, 245 / 255, 245 / 255],
  yellow: [1, 1, 0],
  yellowgreen: [154 / 255, 205 / 255, 50 / 255]
};
let coordGrammar = Array(3).fill("<percentage> | <number>[0, 255]");
let coordGrammarNumber = Array(3).fill("<number>[0, 255]");
var sRGB = new RGBColorSpace({
  id: "srgb",
  name: "sRGB",
  base: sRGBLinear,
  fromBase: (rgb) => {
    return rgb.map((val) => {
      let sign2 = val < 0 ? -1 : 1;
      let abs2 = val * sign2;
      if (abs2 > 31308e-7) {
        return sign2 * (1.055 * abs2 ** (1 / 2.4) - 0.055);
      }
      return 12.92 * val;
    });
  },
  toBase: (rgb) => {
    return rgb.map((val) => {
      let sign2 = val < 0 ? -1 : 1;
      let abs2 = val * sign2;
      if (abs2 < 0.04045) {
        return val / 12.92;
      }
      return sign2 * ((abs2 + 0.055) / 1.055) ** 2.4;
    });
  },
  formats: {
    rgb: {
      coords: coordGrammar
    },
    rgb_number: {
      name: "rgb",
      commas: true,
      coords: coordGrammarNumber,
      noAlpha: true
    },
    color: {
      /* use defaults */
    },
    rgba: {
      coords: coordGrammar,
      commas: true,
      lastAlpha: true
    },
    rgba_number: {
      name: "rgba",
      commas: true,
      coords: coordGrammarNumber
    },
    hex: {
      type: "custom",
      toGamut: true,
      test: (str) => /^#([a-f0-9]{3,4}){1,2}$/i.test(str),
      parse(str) {
        if (str.length <= 5) {
          str = str.replace(/[a-f0-9]/gi, "$&$&");
        }
        let rgba = [];
        str.replace(/[a-f0-9]{2}/gi, (component) => {
          rgba.push(parseInt(component, 16) / 255);
        });
        return {
          spaceId: "srgb",
          coords: rgba.slice(0, 3),
          alpha: rgba.slice(3)[0]
        };
      },
      serialize: (coords, alpha2, {
        collapse = true
        // collapse to 3-4 digit hex when possible?
      } = {}) => {
        if (alpha2 < 1) {
          coords.push(alpha2);
        }
        coords = coords.map((c4) => Math.round(c4 * 255));
        let collapsible = collapse && coords.every((c4) => c4 % 17 === 0);
        let hex2 = coords.map((c4) => {
          if (collapsible) {
            return (c4 / 17).toString(16);
          }
          return c4.toString(16).padStart(2, "0");
        }).join("");
        return "#" + hex2;
      }
    },
    keyword: {
      type: "custom",
      test: (str) => /^[a-z]+$/i.test(str),
      parse(str) {
        str = str.toLowerCase();
        let ret = { spaceId: "srgb", coords: null, alpha: 1 };
        if (str === "transparent") {
          ret.coords = KEYWORDS.black;
          ret.alpha = 0;
        } else {
          ret.coords = KEYWORDS[str];
        }
        if (ret.coords) {
          return ret;
        }
      }
    }
  }
});
var P3 = new RGBColorSpace({
  id: "p3",
  name: "P3",
  base: P3Linear,
  // Gamma encoding/decoding is the same as sRGB
  fromBase: sRGB.fromBase,
  toBase: sRGB.toBase,
  formats: {
    color: {
      id: "display-p3"
    }
  }
});
defaults.display_space = sRGB;
if (typeof CSS !== "undefined" && CSS.supports) {
  for (let space of [lab, REC2020, P3]) {
    let coords = space.getMinCoords();
    let color2 = { space, coords, alpha: 1 };
    let str = serialize(color2);
    if (CSS.supports("color", str)) {
      defaults.display_space = space;
      break;
    }
  }
}
function display(color2, { space = defaults.display_space, ...options2 } = {}) {
  let ret = serialize(color2, options2);
  if (typeof CSS === "undefined" || CSS.supports("color", ret) || !defaults.display_space) {
    ret = new String(ret);
    ret.color = color2;
  } else {
    let fallbackColor = to(color2, space);
    ret = new String(serialize(fallbackColor, options2));
    ret.color = fallbackColor;
  }
  return ret;
}
function distance(color1, color2, space = "lab") {
  space = ColorSpace.get(space);
  let coords1 = space.from(color1);
  let coords2 = space.from(color2);
  return Math.sqrt(
    coords1.reduce((acc, c12, i) => {
      let c22 = coords2[i];
      if (isNaN(c12) || isNaN(c22)) {
        return acc;
      }
      return acc + (c22 - c12) ** 2;
    }, 0)
  );
}
function equals(color1, color2) {
  color1 = getColor(color1);
  color2 = getColor(color2);
  return color1.space === color2.space && color1.alpha === color2.alpha && color1.coords.every((c4, i) => c4 === color2.coords[i]);
}
function getLuminance(color2) {
  return get(color2, [XYZ_D65, "y"]);
}
function setLuminance(color2, value) {
  set(color2, [XYZ_D65, "y"], value);
}
function register$2(Color3) {
  Object.defineProperty(Color3.prototype, "luminance", {
    get() {
      return getLuminance(this);
    },
    set(value) {
      setLuminance(this, value);
    }
  });
}
var luminance = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  getLuminance,
  register: register$2,
  setLuminance
});
function contrastWCAG21(color1, color2) {
  color1 = getColor(color1);
  color2 = getColor(color2);
  let Y1 = Math.max(getLuminance(color1), 0);
  let Y2 = Math.max(getLuminance(color2), 0);
  if (Y2 > Y1) {
    [Y1, Y2] = [Y2, Y1];
  }
  return (Y1 + 0.05) / (Y2 + 0.05);
}
const normBG = 0.56;
const normTXT = 0.57;
const revTXT = 0.62;
const revBG = 0.65;
const blkThrs = 0.022;
const blkClmp = 1.414;
const loClip = 0.1;
const deltaYmin = 5e-4;
const scaleBoW = 1.14;
const loBoWoffset = 0.027;
const scaleWoB = 1.14;
function fclamp(Y2) {
  if (Y2 >= blkThrs) {
    return Y2;
  }
  return Y2 + (blkThrs - Y2) ** blkClmp;
}
function linearize(val) {
  let sign2 = val < 0 ? -1 : 1;
  let abs2 = Math.abs(val);
  return sign2 * Math.pow(abs2, 2.4);
}
function contrastAPCA(background, foreground) {
  foreground = getColor(foreground);
  background = getColor(background);
  let S2;
  let C2;
  let Sapc;
  let R2, G, B2;
  foreground = to(foreground, "srgb");
  [R2, G, B2] = foreground.coords;
  let lumTxt = linearize(R2) * 0.2126729 + linearize(G) * 0.7151522 + linearize(B2) * 0.072175;
  background = to(background, "srgb");
  [R2, G, B2] = background.coords;
  let lumBg = linearize(R2) * 0.2126729 + linearize(G) * 0.7151522 + linearize(B2) * 0.072175;
  let Ytxt = fclamp(lumTxt);
  let Ybg = fclamp(lumBg);
  let BoW = Ybg > Ytxt;
  if (Math.abs(Ybg - Ytxt) < deltaYmin) {
    C2 = 0;
  } else {
    if (BoW) {
      S2 = Ybg ** normBG - Ytxt ** normTXT;
      C2 = S2 * scaleBoW;
    } else {
      S2 = Ybg ** revBG - Ytxt ** revTXT;
      C2 = S2 * scaleWoB;
    }
  }
  if (Math.abs(C2) < loClip) {
    Sapc = 0;
  } else if (C2 > 0) {
    Sapc = C2 - loBoWoffset;
  } else {
    Sapc = C2 + loBoWoffset;
  }
  return Sapc * 100;
}
function contrastMichelson(color1, color2) {
  color1 = getColor(color1);
  color2 = getColor(color2);
  let Y1 = Math.max(getLuminance(color1), 0);
  let Y2 = Math.max(getLuminance(color2), 0);
  if (Y2 > Y1) {
    [Y1, Y2] = [Y2, Y1];
  }
  let denom = Y1 + Y2;
  return denom === 0 ? 0 : (Y1 - Y2) / denom;
}
const max = 5e4;
function contrastWeber(color1, color2) {
  color1 = getColor(color1);
  color2 = getColor(color2);
  let Y1 = Math.max(getLuminance(color1), 0);
  let Y2 = Math.max(getLuminance(color2), 0);
  if (Y2 > Y1) {
    [Y1, Y2] = [Y2, Y1];
  }
  return Y2 === 0 ? max : (Y1 - Y2) / Y2;
}
function contrastLstar(color1, color2) {
  color1 = getColor(color1);
  color2 = getColor(color2);
  let L1 = get(color1, [lab, "l"]);
  let L2 = get(color2, [lab, "l"]);
  return Math.abs(L1 - L2);
}
const ε$1 = 216 / 24389;
const ε3 = 24 / 116;
const κ = 24389 / 27;
let white = WHITES.D65;
var lab_d65 = new ColorSpace({
  id: "lab-d65",
  name: "Lab D65",
  coords: {
    l: {
      refRange: [0, 100],
      name: "L"
    },
    a: {
      refRange: [-125, 125]
    },
    b: {
      refRange: [-125, 125]
    }
  },
  // Assuming XYZ is relative to D65, convert to CIE Lab
  // from CIE standard, which now defines these as a rational fraction
  white,
  base: XYZ_D65,
  // Convert D65-adapted XYZ to Lab
  //  CIE 15.3:2004 section 8.2.1.1
  fromBase(XYZ) {
    let xyz = XYZ.map((value, i) => value / white[i]);
    let f2 = xyz.map((value) => value > ε$1 ? Math.cbrt(value) : (κ * value + 16) / 116);
    return [
      116 * f2[1] - 16,
      // L
      500 * (f2[0] - f2[1]),
      // a
      200 * (f2[1] - f2[2])
      // b
    ];
  },
  // Convert Lab to D65-adapted XYZ
  // Same result as CIE 15.3:2004 Appendix D although the derivation is different
  // http://www.brucelindbloom.com/index.html?Eqn_RGB_XYZ_Matrix.html
  toBase(Lab) {
    let f2 = [];
    f2[1] = (Lab[0] + 16) / 116;
    f2[0] = Lab[1] / 500 + f2[1];
    f2[2] = f2[1] - Lab[2] / 200;
    let xyz = [
      f2[0] > ε3 ? Math.pow(f2[0], 3) : (116 * f2[0] - 16) / κ,
      Lab[0] > 8 ? Math.pow((Lab[0] + 16) / 116, 3) : Lab[0] / κ,
      f2[2] > ε3 ? Math.pow(f2[2], 3) : (116 * f2[2] - 16) / κ
    ];
    return xyz.map((value, i) => value * white[i]);
  },
  formats: {
    "lab-d65": {
      coords: [
        "<number> | <percentage>",
        "<number> | <percentage>[-1,1]",
        "<number> | <percentage>[-1,1]"
      ]
    }
  }
});
const phi = Math.pow(5, 0.5) * 0.5 + 0.5;
function contrastDeltaPhi(color1, color2) {
  color1 = getColor(color1);
  color2 = getColor(color2);
  let Lstr1 = get(color1, [lab_d65, "l"]);
  let Lstr2 = get(color2, [lab_d65, "l"]);
  let deltaPhiStar = Math.abs(Math.pow(Lstr1, phi) - Math.pow(Lstr2, phi));
  let contrast2 = Math.pow(deltaPhiStar, 1 / phi) * Math.SQRT2 - 40;
  return contrast2 < 7.5 ? 0 : contrast2;
}
var contrastMethods = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  contrastAPCA,
  contrastDeltaPhi,
  contrastLstar,
  contrastMichelson,
  contrastWCAG21,
  contrastWeber
});
function contrast(background, foreground, o2 = {}) {
  if (isString(o2)) {
    o2 = { algorithm: o2 };
  }
  let { algorithm, ...rest } = o2;
  if (!algorithm) {
    let algorithms = Object.keys(contrastMethods).map((a2) => a2.replace(/^contrast/, "")).join(", ");
    throw new TypeError(
      `contrast() function needs a contrast algorithm. Please specify one of: ${algorithms}`
    );
  }
  background = getColor(background);
  foreground = getColor(foreground);
  for (let a2 in contrastMethods) {
    if ("contrast" + algorithm.toLowerCase() === a2.toLowerCase()) {
      return contrastMethods[a2](background, foreground, rest);
    }
  }
  throw new TypeError(`Unknown contrast algorithm: ${algorithm}`);
}
function uv(color2) {
  let [X, Y2, Z] = getAll(color2, XYZ_D65);
  let denom = X + 15 * Y2 + 3 * Z;
  return [4 * X / denom, 9 * Y2 / denom];
}
function xy(color2) {
  let [X, Y2, Z] = getAll(color2, XYZ_D65);
  let sum = X + Y2 + Z;
  return [X / sum, Y2 / sum];
}
function register$1(Color3) {
  Object.defineProperty(Color3.prototype, "uv", {
    get() {
      return uv(this);
    }
  });
  Object.defineProperty(Color3.prototype, "xy", {
    get() {
      return xy(this);
    }
  });
}
var chromaticity = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  register: register$1,
  uv,
  xy
});
function deltaE76(color2, sample2) {
  return distance(color2, sample2, "lab");
}
const π = Math.PI;
const d2r = π / 180;
function deltaECMC(color2, sample2, { l: l2 = 2, c: c4 = 1 } = {}) {
  let [L1, a1, b1] = lab.from(color2);
  let [, C1, H1] = lch.from(lab, [L1, a1, b1]);
  let [L2, a2, b2] = lab.from(sample2);
  let C2 = lch.from(lab, [L2, a2, b2])[1];
  if (C1 < 0) {
    C1 = 0;
  }
  if (C2 < 0) {
    C2 = 0;
  }
  let ΔL = L1 - L2;
  let ΔC = C1 - C2;
  let Δa = a1 - a2;
  let Δb = b1 - b2;
  let H2 = Δa ** 2 + Δb ** 2 - ΔC ** 2;
  let SL = 0.511;
  if (L1 >= 16) {
    SL = 0.040975 * L1 / (1 + 0.01765 * L1);
  }
  let SC = 0.0638 * C1 / (1 + 0.0131 * C1) + 0.638;
  let T2;
  if (Number.isNaN(H1)) {
    H1 = 0;
  }
  if (H1 >= 164 && H1 <= 345) {
    T2 = 0.56 + Math.abs(0.2 * Math.cos((H1 + 168) * d2r));
  } else {
    T2 = 0.36 + Math.abs(0.4 * Math.cos((H1 + 35) * d2r));
  }
  let C4 = Math.pow(C1, 4);
  let F2 = Math.sqrt(C4 / (C4 + 1900));
  let SH = SC * (F2 * T2 + 1 - F2);
  let dE = (ΔL / (l2 * SL)) ** 2;
  dE += (ΔC / (c4 * SC)) ** 2;
  dE += H2 / SH ** 2;
  return Math.sqrt(dE);
}
const Yw$1 = 203;
var XYZ_Abs_D65 = new ColorSpace({
  // Absolute CIE XYZ, with a D65 whitepoint,
  // as used in most HDR colorspaces as a starting point.
  // SDR spaces are converted per BT.2048
  // so that diffuse, media white is 203 cd/m²
  id: "xyz-abs-d65",
  name: "Absolute XYZ D65",
  coords: {
    x: {
      refRange: [0, 9504.7],
      name: "Xa"
    },
    y: {
      refRange: [0, 1e4],
      name: "Ya"
    },
    z: {
      refRange: [0, 10888.3],
      name: "Za"
    }
  },
  base: XYZ_D65,
  fromBase(XYZ) {
    return XYZ.map((v2) => Math.max(v2 * Yw$1, 0));
  },
  toBase(AbsXYZ) {
    return AbsXYZ.map((v2) => Math.max(v2 / Yw$1, 0));
  }
});
const b$1 = 1.15;
const g = 0.66;
const n$1 = 2610 / 2 ** 14;
const ninv$1 = 2 ** 14 / 2610;
const c1$2 = 3424 / 2 ** 12;
const c2$2 = 2413 / 2 ** 7;
const c3$2 = 2392 / 2 ** 7;
const p = 1.7 * 2523 / 2 ** 5;
const pinv = 2 ** 5 / (1.7 * 2523);
const d = -0.56;
const d0 = 16295499532821565e-27;
const XYZtoCone_M = [
  [0.41478972, 0.579999, 0.014648],
  [-0.20151, 1.120649, 0.0531008],
  [-0.0166008, 0.2648, 0.6684799]
];
const ConetoXYZ_M = [
  [1.9242264357876067, -1.0047923125953657, 0.037651404030618],
  [0.35031676209499907, 0.7264811939316552, -0.06538442294808501],
  [-0.09098281098284752, -0.3127282905230739, 1.5227665613052603]
];
const ConetoIab_M = [
  [0.5, 0.5, 0],
  [3.524, -4.066708, 0.542708],
  [0.199076, 1.096799, -1.295875]
];
const IabtoCone_M = [
  [1, 0.1386050432715393, 0.05804731615611886],
  [0.9999999999999999, -0.1386050432715393, -0.05804731615611886],
  [0.9999999999999998, -0.09601924202631895, -0.8118918960560388]
];
var Jzazbz = new ColorSpace({
  id: "jzazbz",
  name: "Jzazbz",
  coords: {
    jz: {
      refRange: [0, 1],
      name: "Jz"
    },
    az: {
      refRange: [-0.5, 0.5]
    },
    bz: {
      refRange: [-0.5, 0.5]
    }
  },
  base: XYZ_Abs_D65,
  fromBase(XYZ) {
    let [Xa, Ya, Za] = XYZ;
    let Xm = b$1 * Xa - (b$1 - 1) * Za;
    let Ym = g * Ya - (g - 1) * Xa;
    let LMS = multiplyMatrices(XYZtoCone_M, [Xm, Ym, Za]);
    let PQLMS = LMS.map(function(val) {
      let num = c1$2 + c2$2 * (val / 1e4) ** n$1;
      let denom = 1 + c3$2 * (val / 1e4) ** n$1;
      return (num / denom) ** p;
    });
    let [Iz, az, bz] = multiplyMatrices(ConetoIab_M, PQLMS);
    let Jz = (1 + d) * Iz / (1 + d * Iz) - d0;
    return [Jz, az, bz];
  },
  toBase(Jzazbz2) {
    let [Jz, az, bz] = Jzazbz2;
    let Iz = (Jz + d0) / (1 + d - d * (Jz + d0));
    let PQLMS = multiplyMatrices(IabtoCone_M, [Iz, az, bz]);
    let LMS = PQLMS.map(function(val) {
      let num = c1$2 - val ** pinv;
      let denom = c3$2 * val ** pinv - c2$2;
      let x2 = 1e4 * (num / denom) ** ninv$1;
      return x2;
    });
    let [Xm, Ym, Za] = multiplyMatrices(ConetoXYZ_M, LMS);
    let Xa = (Xm + (b$1 - 1) * Za) / b$1;
    let Ya = (Ym + (g - 1) * Xa) / g;
    return [Xa, Ya, Za];
  },
  formats: {
    // https://drafts.csswg.org/css-color-hdr/#Jzazbz
    color: {}
  }
});
var jzczhz = new ColorSpace({
  id: "jzczhz",
  name: "JzCzHz",
  coords: {
    jz: {
      refRange: [0, 1],
      name: "Jz"
    },
    cz: {
      refRange: [0, 1],
      name: "Chroma"
    },
    hz: {
      refRange: [0, 360],
      type: "angle",
      name: "Hue"
    }
  },
  base: Jzazbz,
  fromBase(jzazbz) {
    let [Jz, az, bz] = jzazbz;
    let hue2;
    const ε2 = 2e-4;
    if (Math.abs(az) < ε2 && Math.abs(bz) < ε2) {
      hue2 = NaN;
    } else {
      hue2 = Math.atan2(bz, az) * 180 / Math.PI;
    }
    return [
      Jz,
      // Jz is still Jz
      Math.sqrt(az ** 2 + bz ** 2),
      // Chroma
      constrain(hue2)
      // Hue, in degrees [0 to 360)
    ];
  },
  toBase(jzczhz2) {
    return [
      jzczhz2[0],
      // Jz is still Jz
      jzczhz2[1] * Math.cos(jzczhz2[2] * Math.PI / 180),
      // az
      jzczhz2[1] * Math.sin(jzczhz2[2] * Math.PI / 180)
      // bz
    ];
  },
  formats: {
    color: {}
  }
});
function deltaEJz(color2, sample2) {
  let [Jz1, Cz1, Hz1] = jzczhz.from(color2);
  let [Jz2, Cz2, Hz2] = jzczhz.from(sample2);
  let ΔJ = Jz1 - Jz2;
  let ΔC = Cz1 - Cz2;
  if (Number.isNaN(Hz1) && Number.isNaN(Hz2)) {
    Hz1 = 0;
    Hz2 = 0;
  } else if (Number.isNaN(Hz1)) {
    Hz1 = Hz2;
  } else if (Number.isNaN(Hz2)) {
    Hz2 = Hz1;
  }
  let Δh = Hz1 - Hz2;
  let ΔH = 2 * Math.sqrt(Cz1 * Cz2) * Math.sin(Δh / 2 * (Math.PI / 180));
  return Math.sqrt(ΔJ ** 2 + ΔC ** 2 + ΔH ** 2);
}
const c1$1 = 3424 / 4096;
const c2$1 = 2413 / 128;
const c3$1 = 2392 / 128;
const m1 = 2610 / 16384;
const m2 = 2523 / 32;
const im1 = 16384 / 2610;
const im2 = 32 / 2523;
const XYZtoLMS_M$1 = [
  [0.3592, 0.6976, -0.0358],
  [-0.1922, 1.1004, 0.0755],
  [7e-3, 0.0749, 0.8434]
];
const LMStoIPT_M = [
  [2048 / 4096, 2048 / 4096, 0],
  [6610 / 4096, -13613 / 4096, 7003 / 4096],
  [17933 / 4096, -17390 / 4096, -543 / 4096]
];
const IPTtoLMS_M = [
  [0.9999888965628402, 0.008605050147287059, 0.11103437159861648],
  [1.00001110343716, -0.008605050147287059, -0.11103437159861648],
  [1.0000320633910054, 0.56004913547279, -0.3206339100541203]
];
const LMStoXYZ_M$1 = [
  [2.0701800566956137, -1.326456876103021, 0.20661600684785517],
  [0.3649882500326575, 0.6804673628522352, -0.04542175307585323],
  [-0.04959554223893211, -0.04942116118675749, 1.1879959417328034]
];
var ictcp = new ColorSpace({
  id: "ictcp",
  name: "ICTCP",
  // From BT.2100-2 page 7:
  // During production, signal values are expected to exceed the
  // range E′ = [0.0 : 1.0]. This provides processing headroom and avoids
  // signal degradation during cascaded processing. Such values of E′,
  // below 0.0 or exceeding 1.0, should not be clipped during production
  // and exchange.
  // Values below 0.0 should not be clipped in reference displays (even
  // though they represent “negative” light) to allow the black level of
  // the signal (LB) to be properly set using test signals known as “PLUGE”
  coords: {
    i: {
      refRange: [0, 1],
      // Constant luminance,
      name: "I"
    },
    ct: {
      refRange: [-0.5, 0.5],
      // Full BT.2020 gamut in range [-0.5, 0.5]
      name: "CT"
    },
    cp: {
      refRange: [-0.5, 0.5],
      name: "CP"
    }
  },
  base: XYZ_Abs_D65,
  fromBase(XYZ) {
    let LMS = multiplyMatrices(XYZtoLMS_M$1, XYZ);
    return LMStoICtCp(LMS);
  },
  toBase(ICtCp) {
    let LMS = ICtCptoLMS(ICtCp);
    return multiplyMatrices(LMStoXYZ_M$1, LMS);
  },
  formats: {
    color: {}
  }
});
function LMStoICtCp(LMS) {
  let PQLMS = LMS.map(function(val) {
    let num = c1$1 + c2$1 * (val / 1e4) ** m1;
    let denom = 1 + c3$1 * (val / 1e4) ** m1;
    return (num / denom) ** m2;
  });
  return multiplyMatrices(LMStoIPT_M, PQLMS);
}
function ICtCptoLMS(ICtCp) {
  let PQLMS = multiplyMatrices(IPTtoLMS_M, ICtCp);
  let LMS = PQLMS.map(function(val) {
    let num = Math.max(val ** im2 - c1$1, 0);
    let denom = c2$1 - c3$1 * val ** im2;
    return 1e4 * (num / denom) ** im1;
  });
  return LMS;
}
function deltaEITP(color2, sample2) {
  let [I1, T1, P1] = ictcp.from(color2);
  let [I2, T2, P2] = ictcp.from(sample2);
  return 720 * Math.sqrt((I1 - I2) ** 2 + 0.25 * (T1 - T2) ** 2 + (P1 - P2) ** 2);
}
const XYZtoLMS_M = [
  [0.8190224432164319, 0.3619062562801221, -0.12887378261216414],
  [0.0329836671980271, 0.9292868468965546, 0.03614466816999844],
  [0.048177199566046255, 0.26423952494422764, 0.6335478258136937]
];
const LMStoXYZ_M = [
  [1.2268798733741557, -0.5578149965554813, 0.28139105017721583],
  [-0.04057576262431372, 1.1122868293970594, -0.07171106666151701],
  [-0.07637294974672142, -0.4214933239627914, 1.5869240244272418]
];
const LMStoLab_M = [
  [0.2104542553, 0.793617785, -0.0040720468],
  [1.9779984951, -2.428592205, 0.4505937099],
  [0.0259040371, 0.7827717662, -0.808675766]
];
const LabtoLMS_M = [
  [0.9999999984505198, 0.39633779217376786, 0.2158037580607588],
  [1.0000000088817609, -0.10556134232365635, -0.06385417477170591],
  [1.0000000546724108, -0.08948418209496575, -1.2914855378640917]
];
var OKLab = new ColorSpace({
  id: "oklab",
  name: "Oklab",
  coords: {
    l: {
      refRange: [0, 1],
      name: "L"
    },
    a: {
      refRange: [-0.4, 0.4]
    },
    b: {
      refRange: [-0.4, 0.4]
    }
  },
  // Note that XYZ is relative to D65
  white: "D65",
  base: XYZ_D65,
  fromBase(XYZ) {
    let LMS = multiplyMatrices(XYZtoLMS_M, XYZ);
    let LMSg = LMS.map((val) => Math.cbrt(val));
    return multiplyMatrices(LMStoLab_M, LMSg);
  },
  toBase(OKLab2) {
    let LMSg = multiplyMatrices(LabtoLMS_M, OKLab2);
    let LMS = LMSg.map((val) => val ** 3);
    return multiplyMatrices(LMStoXYZ_M, LMS);
  },
  formats: {
    oklab: {
      coords: [
        "<percentage> | <number>",
        "<number> | <percentage>[-1,1]",
        "<number> | <percentage>[-1,1]"
      ]
    }
  }
});
function deltaEOK(color2, sample2) {
  let [L1, a1, b1] = OKLab.from(color2);
  let [L2, a2, b2] = OKLab.from(sample2);
  let ΔL = L1 - L2;
  let Δa = a1 - a2;
  let Δb = b1 - b2;
  return Math.sqrt(ΔL ** 2 + Δa ** 2 + Δb ** 2);
}
var deltaEMethods = {
  deltaE76,
  deltaECMC,
  deltaE2000,
  deltaEJz,
  deltaEITP,
  deltaEOK
};
function deltaE(c12, c22, o2 = {}) {
  if (isString(o2)) {
    o2 = { method: o2 };
  }
  let { method = defaults.deltaE, ...rest } = o2;
  c12 = getColor(c12);
  c22 = getColor(c22);
  for (let m3 in deltaEMethods) {
    if ("deltae" + method.toLowerCase() === m3.toLowerCase()) {
      return deltaEMethods[m3](c12, c22, rest);
    }
  }
  throw new TypeError(`Unknown deltaE method: ${method}`);
}
function lighten(color2, amount = 0.25) {
  let space = ColorSpace.get("oklch", "lch");
  let lightness = [space, "l"];
  return set(color2, lightness, (l2) => l2 * (1 + amount));
}
function darken(color2, amount = 0.25) {
  let space = ColorSpace.get("oklch", "lch");
  let lightness = [space, "l"];
  return set(color2, lightness, (l2) => l2 * (1 - amount));
}
var variations = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  darken,
  lighten
});
function mix(c12, c22, p2 = 0.5, o2 = {}) {
  [c12, c22] = [getColor(c12), getColor(c22)];
  if (type(p2) === "object") {
    [p2, o2] = [0.5, p2];
  }
  let { space, outputSpace, premultiplied } = o2;
  let r2 = range(c12, c22, { space, outputSpace, premultiplied });
  return r2(p2);
}
function steps(c12, c22, options2 = {}) {
  let colorRange;
  if (isRange(c12)) {
    [colorRange, options2] = [c12, c22];
    [c12, c22] = colorRange.rangeArgs.colors;
  }
  let { maxDeltaE, deltaEMethod, steps: steps2 = 2, maxSteps = 1e3, ...rangeOptions } = options2;
  if (!colorRange) {
    [c12, c22] = [getColor(c12), getColor(c22)];
    colorRange = range(c12, c22, rangeOptions);
  }
  let totalDelta = deltaE(c12, c22);
  let actualSteps = maxDeltaE > 0 ? Math.max(steps2, Math.ceil(totalDelta / maxDeltaE) + 1) : steps2;
  let ret = [];
  if (maxSteps !== void 0) {
    actualSteps = Math.min(actualSteps, maxSteps);
  }
  if (actualSteps === 1) {
    ret = [{ p: 0.5, color: colorRange(0.5) }];
  } else {
    let step = 1 / (actualSteps - 1);
    ret = Array.from({ length: actualSteps }, (_2, i) => {
      let p2 = i * step;
      return { p: p2, color: colorRange(p2) };
    });
  }
  if (maxDeltaE > 0) {
    let maxDelta = ret.reduce((acc, cur, i) => {
      if (i === 0) {
        return 0;
      }
      let ΔΕ = deltaE(cur.color, ret[i - 1].color, deltaEMethod);
      return Math.max(acc, ΔΕ);
    }, 0);
    while (maxDelta > maxDeltaE) {
      maxDelta = 0;
      for (let i = 1; i < ret.length && ret.length < maxSteps; i++) {
        let prev2 = ret[i - 1];
        let cur = ret[i];
        let p2 = (cur.p + prev2.p) / 2;
        let color2 = colorRange(p2);
        maxDelta = Math.max(maxDelta, deltaE(color2, prev2.color), deltaE(color2, cur.color));
        ret.splice(i, 0, { p: p2, color: colorRange(p2) });
        i++;
      }
    }
  }
  ret = ret.map((a2) => a2.color);
  return ret;
}
function range(color1, color2, options2 = {}) {
  if (isRange(color1)) {
    let [r2, options3] = [color1, color2];
    return range(...r2.rangeArgs.colors, { ...r2.rangeArgs.options, ...options3 });
  }
  let { space, outputSpace, progression, premultiplied } = options2;
  color1 = getColor(color1);
  color2 = getColor(color2);
  color1 = clone(color1);
  color2 = clone(color2);
  let rangeArgs = { colors: [color1, color2], options: options2 };
  if (space) {
    space = ColorSpace.get(space);
  } else {
    space = ColorSpace.registry[defaults.interpolationSpace] || color1.space;
  }
  outputSpace = outputSpace ? ColorSpace.get(outputSpace) : space;
  color1 = to(color1, space);
  color2 = to(color2, space);
  color1 = toGamut(color1);
  color2 = toGamut(color2);
  if (space.coords.h && space.coords.h.type === "angle") {
    let arc = options2.hue = options2.hue || "shorter";
    let hue2 = [space, "h"];
    let [θ1, θ2] = [get(color1, hue2), get(color2, hue2)];
    [θ1, θ2] = adjust(arc, [θ1, θ2]);
    set(color1, hue2, θ1);
    set(color2, hue2, θ2);
  }
  if (premultiplied) {
    color1.coords = color1.coords.map((c4) => c4 * color1.alpha);
    color2.coords = color2.coords.map((c4) => c4 * color2.alpha);
  }
  return Object.assign(
    (p2) => {
      p2 = progression ? progression(p2) : p2;
      let coords = color1.coords.map((start, i) => {
        let end = color2.coords[i];
        return interpolate(start, end, p2);
      });
      let alpha2 = interpolate(color1.alpha, color2.alpha, p2);
      let ret = { space, coords, alpha: alpha2 };
      if (premultiplied) {
        ret.coords = ret.coords.map((c4) => c4 / alpha2);
      }
      if (outputSpace !== space) {
        ret = to(ret, outputSpace);
      }
      return ret;
    },
    {
      rangeArgs
    }
  );
}
function isRange(val) {
  return type(val) === "function" && !!val.rangeArgs;
}
defaults.interpolationSpace = "lab";
function register(Color3) {
  Color3.defineFunction("mix", mix, { returns: "color" });
  Color3.defineFunction("range", range, { returns: "function<color>" });
  Color3.defineFunction("steps", steps, { returns: "array<color>" });
}
var interpolation = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  isRange,
  mix,
  range,
  register,
  steps
});
var HSL = new ColorSpace({
  id: "hsl",
  name: "HSL",
  coords: {
    h: {
      refRange: [0, 360],
      type: "angle",
      name: "Hue"
    },
    s: {
      range: [0, 100],
      name: "Saturation"
    },
    l: {
      range: [0, 100],
      name: "Lightness"
    }
  },
  base: sRGB,
  // Adapted from https://en.wikipedia.org/wiki/HSL_and_HSV#From_RGB
  fromBase: (rgb) => {
    let max2 = Math.max(...rgb);
    let min2 = Math.min(...rgb);
    let [r2, g2, b2] = rgb;
    let [h3, s2, l2] = [NaN, 0, (min2 + max2) / 2];
    let d2 = max2 - min2;
    if (d2 !== 0) {
      s2 = l2 === 0 || l2 === 1 ? 0 : (max2 - l2) / Math.min(l2, 1 - l2);
      switch (max2) {
        case r2:
          h3 = (g2 - b2) / d2 + (g2 < b2 ? 6 : 0);
          break;
        case g2:
          h3 = (b2 - r2) / d2 + 2;
          break;
        case b2:
          h3 = (r2 - g2) / d2 + 4;
      }
      h3 = h3 * 60;
    }
    return [h3, s2 * 100, l2 * 100];
  },
  // Adapted from https://en.wikipedia.org/wiki/HSL_and_HSV#HSL_to_RGB_alternative
  toBase: (hsl) => {
    let [h3, s2, l2] = hsl;
    h3 = h3 % 360;
    if (h3 < 0) {
      h3 += 360;
    }
    s2 /= 100;
    l2 /= 100;
    function f2(n2) {
      let k2 = (n2 + h3 / 30) % 12;
      let a2 = s2 * Math.min(l2, 1 - l2);
      return l2 - a2 * Math.max(-1, Math.min(k2 - 3, 9 - k2, 1));
    }
    return [f2(0), f2(8), f2(4)];
  },
  formats: {
    hsl: {
      toGamut: true,
      coords: ["<number> | <angle>", "<percentage>", "<percentage>"]
    },
    hsla: {
      coords: ["<number> | <angle>", "<percentage>", "<percentage>"],
      commas: true,
      lastAlpha: true
    }
  }
});
var HSV = new ColorSpace({
  id: "hsv",
  name: "HSV",
  coords: {
    h: {
      refRange: [0, 360],
      type: "angle",
      name: "Hue"
    },
    s: {
      range: [0, 100],
      name: "Saturation"
    },
    v: {
      range: [0, 100],
      name: "Value"
    }
  },
  base: HSL,
  // https://en.wikipedia.org/wiki/HSL_and_HSV#Interconversion
  fromBase(hsl) {
    let [h3, s2, l2] = hsl;
    s2 /= 100;
    l2 /= 100;
    let v2 = l2 + s2 * Math.min(l2, 1 - l2);
    return [
      h3,
      // h is the same
      v2 === 0 ? 0 : 200 * (1 - l2 / v2),
      // s
      100 * v2
    ];
  },
  // https://en.wikipedia.org/wiki/HSL_and_HSV#Interconversion
  toBase(hsv) {
    let [h3, s2, v2] = hsv;
    s2 /= 100;
    v2 /= 100;
    let l2 = v2 * (1 - s2 / 2);
    return [
      h3,
      // h is the same
      l2 === 0 || l2 === 1 ? 0 : (v2 - l2) / Math.min(l2, 1 - l2) * 100,
      l2 * 100
    ];
  },
  formats: {
    color: {
      toGamut: true
    }
  }
});
var hwb = new ColorSpace({
  id: "hwb",
  name: "HWB",
  coords: {
    h: {
      refRange: [0, 360],
      type: "angle",
      name: "Hue"
    },
    w: {
      range: [0, 100],
      name: "Whiteness"
    },
    b: {
      range: [0, 100],
      name: "Blackness"
    }
  },
  base: HSV,
  fromBase(hsv) {
    let [h3, s2, v2] = hsv;
    return [h3, v2 * (100 - s2) / 100, 100 - v2];
  },
  toBase(hwb2) {
    let [h3, w2, b2] = hwb2;
    w2 /= 100;
    b2 /= 100;
    let sum = w2 + b2;
    if (sum >= 1) {
      let gray2 = w2 / sum;
      return [h3, 0, gray2 * 100];
    }
    let v2 = 1 - b2;
    let s2 = v2 === 0 ? 0 : 1 - w2 / v2;
    return [h3, s2 * 100, v2 * 100];
  },
  formats: {
    hwb: {
      toGamut: true,
      coords: ["<number> | <angle>", "<percentage>", "<percentage>"]
    }
  }
});
const toXYZ_M$2 = [
  [0.5766690429101305, 0.1855582379065463, 0.1882286462349947],
  [0.29734497525053605, 0.6273635662554661, 0.07529145849399788],
  [0.02703136138641234, 0.07068885253582723, 0.9913375368376388]
];
const fromXYZ_M$2 = [
  [2.0415879038107465, -0.5650069742788596, -0.34473135077832956],
  [-0.9692436362808795, 1.8759675015077202, 0.04155505740717557],
  [0.013444280632031142, -0.11836239223101838, 1.0151749943912054]
];
var A98Linear = new RGBColorSpace({
  id: "a98rgb-linear",
  name: "Linear Adobe® 98 RGB compatible",
  white: "D65",
  toXYZ_M: toXYZ_M$2,
  fromXYZ_M: fromXYZ_M$2
});
var a98rgb = new RGBColorSpace({
  id: "a98rgb",
  name: "Adobe® 98 RGB compatible",
  base: A98Linear,
  toBase: (RGB) => RGB.map((val) => Math.pow(Math.abs(val), 563 / 256) * Math.sign(val)),
  fromBase: (RGB) => RGB.map((val) => Math.pow(Math.abs(val), 256 / 563) * Math.sign(val)),
  formats: {
    color: {
      id: "a98-rgb"
    }
  }
});
const toXYZ_M$1 = [
  [0.7977604896723027, 0.13518583717574031, 0.0313493495815248],
  [0.2880711282292934, 0.7118432178101014, 8565396060525902e-20],
  [0, 0, 0.8251046025104601]
];
const fromXYZ_M$1 = [
  [1.3457989731028281, -0.25558010007997534, -0.05110628506753401],
  [-0.5446224939028347, 1.5082327413132781, 0.02053603239147973],
  [0, 0, 1.2119675456389454]
];
var ProPhotoLinear = new RGBColorSpace({
  id: "prophoto-linear",
  name: "Linear ProPhoto",
  white: "D50",
  base: XYZ_D50,
  toXYZ_M: toXYZ_M$1,
  fromXYZ_M: fromXYZ_M$1
});
const Et = 1 / 512;
const Et2 = 16 / 512;
var prophoto = new RGBColorSpace({
  id: "prophoto",
  name: "ProPhoto",
  base: ProPhotoLinear,
  toBase(RGB) {
    return RGB.map((v2) => v2 < Et2 ? v2 / 16 : v2 ** 1.8);
  },
  fromBase(RGB) {
    return RGB.map((v2) => v2 >= Et ? v2 ** (1 / 1.8) : 16 * v2);
  },
  formats: {
    color: {
      id: "prophoto-rgb"
    }
  }
});
var oklch = new ColorSpace({
  id: "oklch",
  name: "Oklch",
  coords: {
    l: {
      refRange: [0, 1],
      name: "Lightness"
    },
    c: {
      refRange: [0, 0.4],
      name: "Chroma"
    },
    h: {
      refRange: [0, 360],
      type: "angle",
      name: "Hue"
    }
  },
  white: "D65",
  base: OKLab,
  fromBase(oklab) {
    let [L2, a2, b2] = oklab;
    let h3;
    const ε2 = 2e-4;
    if (Math.abs(a2) < ε2 && Math.abs(b2) < ε2) {
      h3 = NaN;
    } else {
      h3 = Math.atan2(b2, a2) * 180 / Math.PI;
    }
    return [
      L2,
      // OKLab L is still L
      Math.sqrt(a2 ** 2 + b2 ** 2),
      // Chroma
      constrain(h3)
      // Hue, in degrees [0 to 360)
    ];
  },
  // Convert from polar form
  toBase(oklch2) {
    let [L2, C2, h3] = oklch2;
    let a2, b2;
    if (isNaN(h3)) {
      a2 = 0;
      b2 = 0;
    } else {
      a2 = C2 * Math.cos(h3 * Math.PI / 180);
      b2 = C2 * Math.sin(h3 * Math.PI / 180);
    }
    return [L2, a2, b2];
  },
  formats: {
    oklch: {
      coords: ["<number> | <percentage>", "<number> | <percentage>[0,1]", "<number> | <angle>"]
    }
  }
});
const Yw = 203;
const n = 2610 / 2 ** 14;
const ninv = 2 ** 14 / 2610;
const m = 2523 / 2 ** 5;
const minv = 2 ** 5 / 2523;
const c1 = 3424 / 2 ** 12;
const c2 = 2413 / 2 ** 7;
const c3 = 2392 / 2 ** 7;
var rec2100Pq = new RGBColorSpace({
  id: "rec2100pq",
  name: "REC.2100-PQ",
  base: REC2020Linear,
  toBase(RGB) {
    return RGB.map(function(val) {
      let x2 = (Math.max(val ** minv - c1, 0) / (c2 - c3 * val ** minv)) ** ninv;
      return x2 * 1e4 / Yw;
    });
  },
  fromBase(RGB) {
    return RGB.map(function(val) {
      let x2 = Math.max(val * Yw / 1e4, 0);
      let num = c1 + c2 * x2 ** n;
      let denom = 1 + c3 * x2 ** n;
      return (num / denom) ** m;
    });
  },
  formats: {
    color: {
      id: "rec2100-pq"
    }
  }
});
const a = 0.17883277;
const b = 0.28466892;
const c = 0.55991073;
const scale = 3.7743;
var rec2100Hlg = new RGBColorSpace({
  id: "rec2100hlg",
  cssid: "rec2100-hlg",
  name: "REC.2100-HLG",
  referred: "scene",
  base: REC2020Linear,
  toBase(RGB) {
    return RGB.map(function(val) {
      if (val <= 0.5) {
        return val ** 2 / 3 * scale;
      }
      return (Math.exp((val - c) / a) + b) / 12 * scale;
    });
  },
  fromBase(RGB) {
    return RGB.map(function(val) {
      val /= scale;
      if (val <= 1 / 12) {
        return Math.sqrt(3 * val);
      }
      return a * Math.log(12 * val - b) + c;
    });
  },
  formats: {
    color: {
      id: "rec2100-hlg"
    }
  }
});
const CATs = {};
hooks.add("chromatic-adaptation-start", (env) => {
  if (env.options.method) {
    env.M = adapt(env.W1, env.W2, env.options.method);
  }
});
hooks.add("chromatic-adaptation-end", (env) => {
  if (!env.M) {
    env.M = adapt(env.W1, env.W2, env.options.method);
  }
});
function defineCAT({ id, toCone_M, fromCone_M }) {
  CATs[id] = arguments[0];
}
function adapt(W1, W2, id = "Bradford") {
  let method = CATs[id];
  let [ρs, γs, βs] = multiplyMatrices(method.toCone_M, W1);
  let [ρd, γd, βd] = multiplyMatrices(method.toCone_M, W2);
  let scale2 = [
    [ρd / ρs, 0, 0],
    [0, γd / γs, 0],
    [0, 0, βd / βs]
  ];
  let scaled_cone_M = multiplyMatrices(scale2, method.toCone_M);
  let adapt_M = multiplyMatrices(method.fromCone_M, scaled_cone_M);
  return adapt_M;
}
defineCAT({
  id: "von Kries",
  toCone_M: [
    [0.40024, 0.7076, -0.08081],
    [-0.2263, 1.16532, 0.0457],
    [0, 0, 0.91822]
  ],
  fromCone_M: [
    [1.8599364, -1.1293816, 0.2198974],
    [0.3611914, 0.6388125, -64e-7],
    [0, 0, 1.0890636]
  ]
});
defineCAT({
  id: "Bradford",
  // Convert an array of XYZ values in the range 0.0 - 1.0
  // to cone fundamentals
  toCone_M: [
    [0.8951, 0.2664, -0.1614],
    [-0.7502, 1.7135, 0.0367],
    [0.0389, -0.0685, 1.0296]
  ],
  // and back
  fromCone_M: [
    [0.9869929, -0.1470543, 0.1599627],
    [0.4323053, 0.5183603, 0.0492912],
    [-85287e-7, 0.0400428, 0.9684867]
  ]
});
defineCAT({
  id: "CAT02",
  // with complete chromatic adaptation to W2, so D = 1.0
  toCone_M: [
    [0.7328, 0.4296, -0.1624],
    [-0.7036, 1.6975, 61e-4],
    [3e-3, 0.0136, 0.9834]
  ],
  fromCone_M: [
    [1.0961238, -0.278869, 0.1827452],
    [0.454369, 0.4735332, 0.0720978],
    [-96276e-7, -5698e-6, 1.0153256]
  ]
});
defineCAT({
  id: "CAT16",
  toCone_M: [
    [0.401288, 0.650173, -0.051461],
    [-0.250268, 1.204414, 0.045854],
    [-2079e-6, 0.048952, 0.953127]
  ],
  // the extra precision is needed to avoid roundtripping errors
  fromCone_M: [
    [1.862067855087233, -1.011254630531685, 0.1491867754444518],
    [0.3875265432361372, 0.6214474419314753, -0.008973985167612518],
    [-0.01584149884933386, -0.03412293802851557, 1.04996443687785]
  ]
});
Object.assign(WHITES, {
  // whitepoint values from ASTM E308-01 with 10nm spacing, 1931 2 degree observer
  // all normalized to Y (luminance) = 1.00000
  // Illuminant A is a tungsten electric light, giving a very warm, orange light.
  A: [1.0985, 1, 0.35585],
  // Illuminant C was an early approximation to daylight: illuminant A with a blue filter.
  C: [0.98074, 1, 1.18232],
  // The daylight series of illuminants simulate natural daylight.
  // The color temperature (in degrees Kelvin/100) ranges from
  // cool, overcast daylight (D50) to bright, direct sunlight (D65).
  D55: [0.95682, 1, 0.92149],
  D75: [0.94972, 1, 1.22638],
  // Equal-energy illuminant, used in two-stage CAT16
  E: [1, 1, 1],
  // The F series of illuminants represent fluorescent lights
  F2: [0.99186, 1, 0.67393],
  F7: [0.95041, 1, 1.08747],
  F11: [1.00962, 1, 0.6435]
});
WHITES.ACES = [0.32168 / 0.33767, 1, (1 - 0.32168 - 0.33767) / 0.33767];
const toXYZ_M = [
  [0.6624541811085053, 0.13400420645643313, 0.1561876870049078],
  [0.27222871678091454, 0.6740817658111484, 0.05368951740793705],
  [-0.005574649490394108, 0.004060733528982826, 1.0103391003129971]
];
const fromXYZ_M = [
  [1.6410233796943257, -0.32480329418479, -0.23642469523761225],
  [-0.6636628587229829, 1.6153315916573379, 0.016756347685530137],
  [0.011721894328375376, -0.008284441996237409, 0.9883948585390215]
];
var ACEScg = new RGBColorSpace({
  id: "acescg",
  name: "ACEScg",
  // ACEScg – A scene-referred, linear-light encoding of ACES Data
  // https://docs.acescentral.com/specifications/acescg/
  // uses the AP1 primaries, see section 4.3.1 Color primaries
  coords: {
    r: {
      range: [0, 65504],
      name: "Red"
    },
    g: {
      range: [0, 65504],
      name: "Green"
    },
    b: {
      range: [0, 65504],
      name: "Blue"
    }
  },
  referred: "scene",
  white: WHITES.ACES,
  toXYZ_M,
  fromXYZ_M,
  formats: {
    color: {}
  }
});
const ε = 2 ** -16;
const ACES_min_nonzero = -0.35828683;
const ACES_cc_max = (Math.log2(65504) + 9.72) / 17.52;
var acescc = new RGBColorSpace({
  id: "acescc",
  name: "ACEScc",
  // see S-2014-003 ACEScc – A Logarithmic Encoding of ACES Data
  // https://docs.acescentral.com/specifications/acescc/
  // uses the AP1 primaries, see section 4.3.1 Color primaries
  // Appendix A: "Very small ACES scene referred values below 7 1/4 stops
  // below 18% middle gray are encoded as negative ACEScc values.
  // These values should be preserved per the encoding in Section 4.4
  // so that all positive ACES values are maintained."
  coords: {
    r: {
      range: [ACES_min_nonzero, ACES_cc_max],
      name: "Red"
    },
    g: {
      range: [ACES_min_nonzero, ACES_cc_max],
      name: "Green"
    },
    b: {
      range: [ACES_min_nonzero, ACES_cc_max],
      name: "Blue"
    }
  },
  referred: "scene",
  base: ACEScg,
  // from section 4.4.2 Decoding Function
  toBase(RGB) {
    const low = (9.72 - 15) / 17.52;
    return RGB.map(function(val) {
      if (val <= low) {
        return (2 ** (val * 17.52 - 9.72) - ε) * 2;
      } else if (val < ACES_cc_max) {
        return 2 ** (val * 17.52 - 9.72);
      } else {
        return 65504;
      }
    });
  },
  // Non-linear encoding function from S-2014-003, section 4.4.1 Encoding Function
  fromBase(RGB) {
    return RGB.map(function(val) {
      if (val <= 0) {
        return (Math.log2(ε) + 9.72) / 17.52;
      } else if (val < ε) {
        return (Math.log2(ε + val * 0.5) + 9.72) / 17.52;
      } else {
        return (Math.log2(val) + 9.72) / 17.52;
      }
    });
  },
  // encoded media white (rgb 1,1,1) => linear  [ 222.861, 222.861, 222.861 ]
  // encoded media black (rgb 0,0,0) => linear [ 0.0011857, 0.0011857, 0.0011857]
  formats: {
    color: {}
  }
});
var spaces = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  A98RGB: a98rgb,
  A98RGB_Linear: A98Linear,
  ACEScc: acescc,
  ACEScg,
  HSL,
  HSV,
  HWB: hwb,
  ICTCP: ictcp,
  JzCzHz: jzczhz,
  Jzazbz,
  LCH: lch,
  Lab: lab,
  Lab_D65: lab_d65,
  OKLCH: oklch,
  OKLab,
  P3,
  P3_Linear: P3Linear,
  ProPhoto: prophoto,
  ProPhoto_Linear: ProPhotoLinear,
  REC_2020: REC2020,
  REC_2020_Linear: REC2020Linear,
  REC_2100_HLG: rec2100Hlg,
  REC_2100_PQ: rec2100Pq,
  XYZ_ABS_D65: XYZ_Abs_D65,
  XYZ_D50,
  XYZ_D65,
  sRGB,
  sRGB_Linear: sRGBLinear
});
class Color2 {
  /**
   * Creates an instance of Color.
   * Signatures:
   * - `new Color(stringToParse)`
   * - `new Color(otherColor)`
   * - `new Color({space, coords, alpha})`
   * - `new Color(space, coords, alpha)`
   * - `new Color(spaceId, coords, alpha)`
   */
  constructor(...args) {
    let color2;
    if (args.length === 1) {
      color2 = getColor(args[0]);
    }
    let space, coords, alpha2;
    if (color2) {
      space = color2.space || color2.spaceId;
      coords = color2.coords;
      alpha2 = color2.alpha;
    } else {
      [space, coords, alpha2] = args;
    }
    Object.defineProperty(this, "space", {
      value: ColorSpace.get(space),
      writable: false,
      enumerable: true,
      configurable: true
      // see note in https://262.ecma-international.org/8.0/#sec-proxy-object-internal-methods-and-internal-slots-get-p-receiver
    });
    this.coords = coords ? coords.slice() : [0, 0, 0];
    this.alpha = alpha2 < 1 ? alpha2 : 1;
    for (let i = 0; i < this.coords.length; i++) {
      if (this.coords[i] === "NaN") {
        this.coords[i] = NaN;
      }
    }
    for (let id in this.space.coords) {
      Object.defineProperty(this, id, {
        get: () => this.get(id),
        set: (value) => this.set(id, value)
      });
    }
  }
  get spaceId() {
    return this.space.id;
  }
  clone() {
    return new Color2(this.space, this.coords, this.alpha);
  }
  toJSON() {
    return {
      spaceId: this.spaceId,
      coords: this.coords,
      alpha: this.alpha
    };
  }
  display(...args) {
    let ret = display(this, ...args);
    ret.color = new Color2(ret.color);
    return ret;
  }
  /**
   * Get a color from the argument passed
   * Basically gets us the same result as new Color(color) but doesn't clone an existing color object
   */
  static get(color2, ...args) {
    if (color2 instanceof Color2) {
      return color2;
    }
    return new Color2(color2, ...args);
  }
  static defineFunction(name, code, o2 = code) {
    let { instance = true, returns } = o2;
    let func = function(...args) {
      let ret = code(...args);
      if (returns === "color") {
        ret = Color2.get(ret);
      } else if (returns === "function<color>") {
        let f2 = ret;
        ret = function(...args2) {
          let ret2 = f2(...args2);
          return Color2.get(ret2);
        };
        Object.assign(ret, f2);
      } else if (returns === "array<color>") {
        ret = ret.map((c4) => Color2.get(c4));
      }
      return ret;
    };
    if (!(name in Color2)) {
      Color2[name] = func;
    }
    if (instance) {
      Color2.prototype[name] = function(...args) {
        return func(this, ...args);
      };
    }
  }
  static defineFunctions(o2) {
    for (let name in o2) {
      Color2.defineFunction(name, o2[name], o2[name]);
    }
  }
  static extend(exports) {
    if (exports.register) {
      exports.register(Color2);
    } else {
      for (let name in exports) {
        Color2.defineFunction(name, exports[name]);
      }
    }
  }
}
Color2.defineFunctions({
  get,
  getAll,
  set,
  setAll,
  to,
  equals,
  inGamut,
  toGamut,
  distance,
  toString: serialize
});
Object.assign(Color2, {
  util,
  hooks,
  WHITES,
  Space: ColorSpace,
  spaces: ColorSpace.registry,
  parse,
  // Global defaults one may want to configure
  defaults
});
for (let key of Object.keys(spaces)) {
  ColorSpace.register(spaces[key]);
}
for (let id in ColorSpace.registry) {
  addSpaceAccessors(id, ColorSpace.registry[id]);
}
hooks.add("colorspace-init-end", (space) => {
  var _a2;
  addSpaceAccessors(space.id, space);
  (_a2 = space.aliases) == null ? void 0 : _a2.forEach((alias) => {
    addSpaceAccessors(alias, space);
  });
});
function addSpaceAccessors(id, space) {
  Object.keys(space.coords);
  Object.values(space.coords).map((c4) => c4.name);
  let propId = id.replace(/-/g, "_");
  Object.defineProperty(Color2.prototype, propId, {
    // Convert coords to coords in another colorspace and return them
    // Source colorspace: this.spaceId
    // Target colorspace: id
    get() {
      let ret = this.getAll(id);
      if (typeof Proxy === "undefined") {
        return ret;
      }
      return new Proxy(ret, {
        has: (obj, property) => {
          try {
            ColorSpace.resolveCoord([space, property]);
            return true;
          } catch (e2) {
          }
          return Reflect.has(obj, property);
        },
        get: (obj, property, receiver) => {
          if (property && typeof property !== "symbol" && !(property in obj)) {
            let { index: index2 } = ColorSpace.resolveCoord([space, property]);
            if (index2 >= 0) {
              return obj[index2];
            }
          }
          return Reflect.get(obj, property, receiver);
        },
        set: (obj, property, value, receiver) => {
          if (property && typeof property !== "symbol" && !(property in obj) || property >= 0) {
            let { index: index2 } = ColorSpace.resolveCoord([space, property]);
            if (index2 >= 0) {
              obj[index2] = value;
              this.setAll(id, obj);
              return true;
            }
          }
          return Reflect.set(obj, property, value, receiver);
        }
      });
    },
    // Convert coords in another colorspace to internal coords and set them
    // Target colorspace: this.spaceId
    // Source colorspace: id
    set(coords) {
      this.setAll(id, coords);
    },
    configurable: true,
    enumerable: true
  });
}
Color2.extend(deltaEMethods);
Color2.extend({ deltaE });
Object.assign(Color2, { deltaEMethods });
Color2.extend(variations);
Color2.extend({ contrast });
Color2.extend(chromaticity);
Color2.extend(luminance);
Color2.extend(interpolation);
Color2.extend(contrastMethods);
var NEWTON_ITERATIONS = 4;
var NEWTON_MIN_SLOPE = 1e-3;
var SUBDIVISION_PRECISION = 1e-7;
var SUBDIVISION_MAX_ITERATIONS = 10;
var kSplineTableSize = 11;
var kSampleStepSize = 1 / (kSplineTableSize - 1);
var float32ArraySupported = typeof Float32Array === "function";
function A(aA1, aA2) {
  return 1 - 3 * aA2 + 3 * aA1;
}
function B(aA1, aA2) {
  return 3 * aA2 - 6 * aA1;
}
function C(aA1) {
  return 3 * aA1;
}
function calcBezier(aT, aA1, aA2) {
  return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT;
}
function getSlope(aT, aA1, aA2) {
  return 3 * A(aA1, aA2) * aT * aT + 2 * B(aA1, aA2) * aT + C(aA1);
}
function binarySubdivide(aX, aA, aB, mX1, mX2) {
  var currentX, currentT, i = 0;
  do {
    currentT = aA + (aB - aA) / 2;
    currentX = calcBezier(currentT, mX1, mX2) - aX;
    if (currentX > 0) {
      aB = currentT;
    } else {
      aA = currentT;
    }
  } while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
  return currentT;
}
function newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
  for (var i = 0; i < NEWTON_ITERATIONS; ++i) {
    var currentSlope = getSlope(aGuessT, mX1, mX2);
    if (currentSlope === 0) {
      return aGuessT;
    }
    var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
    aGuessT -= currentX / currentSlope;
  }
  return aGuessT;
}
function LinearEasing(x2) {
  return x2;
}
var src = function bezier(mX1, mY1, mX2, mY2) {
  if (!(0 <= mX1 && mX1 <= 1 && 0 <= mX2 && mX2 <= 1)) {
    throw new Error("bezier x values must be in [0, 1] range");
  }
  if (mX1 === mY1 && mX2 === mY2) {
    return LinearEasing;
  }
  var sampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);
  for (var i = 0; i < kSplineTableSize; ++i) {
    sampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
  }
  function getTForX(aX) {
    var intervalStart = 0;
    var currentSample = 1;
    var lastSample = kSplineTableSize - 1;
    for (; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample) {
      intervalStart += kSampleStepSize;
    }
    --currentSample;
    var dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
    var guessForT = intervalStart + dist * kSampleStepSize;
    var initialSlope = getSlope(guessForT, mX1, mX2);
    if (initialSlope >= NEWTON_MIN_SLOPE) {
      return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
    } else if (initialSlope === 0) {
      return guessForT;
    } else {
      return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
    }
  }
  return function BezierEasing2(x2) {
    if (x2 === 0) {
      return 0;
    }
    if (x2 === 1) {
      return 1;
    }
    return calcBezier(getTForX(x2), mY1, mY2);
  };
};
const BezierEasing = /* @__PURE__ */ getDefaultExportFromCjs(src);
const arrayOf12 = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
const grayScaleNames = ["gray", "mauve", "slate", "sage", "olive", "sand"];
const scaleNames = [
  ...grayScaleNames,
  "tomato",
  "red",
  "ruby",
  "crimson",
  "pink",
  "plum",
  "purple",
  "violet",
  "iris",
  "indigo",
  "blue",
  "cyan",
  "teal",
  "jade",
  "green",
  "grass",
  "brown",
  "orange",
  "sky",
  "mint",
  "lime",
  "yellow",
  "amber"
];
const lightColors = Object.fromEntries(
  scaleNames.map((scaleName) => [
    scaleName,
    Object.values(RadixColors[`${scaleName}P3`]).map((str) => new Color2(str).to("oklch"))
  ])
);
const darkColors = Object.fromEntries(
  scaleNames.map((scaleName) => [
    scaleName,
    Object.values(RadixColors[`${scaleName}DarkP3`]).map((str) => new Color2(str).to("oklch"))
  ])
);
const lightGrayColors = Object.fromEntries(
  grayScaleNames.map((scaleName) => [
    scaleName,
    Object.values(RadixColors[`${scaleName}P3`]).map((str) => new Color2(str).to("oklch"))
  ])
);
const darkGrayColors = Object.fromEntries(
  grayScaleNames.map((scaleName) => [
    scaleName,
    Object.values(RadixColors[`${scaleName}DarkP3`]).map((str) => new Color2(str).to("oklch"))
  ])
);
const generateRadixColors = ({
  appearance,
  ...args
}) => {
  const allScales = appearance === "light" ? lightColors : darkColors;
  const grayScales = appearance === "light" ? lightGrayColors : darkGrayColors;
  const backgroundColor = new Color2(args.background).to("oklch");
  const grayBaseColor = new Color2(args.gray).to("oklch");
  const grayScaleColors = getScaleFromColor(grayBaseColor, grayScales, backgroundColor);
  const accentBaseColor = new Color2(args.accent).to("oklch");
  let accentScaleColors = getScaleFromColor(accentBaseColor, allScales, backgroundColor);
  const backgroundHex = backgroundColor.to("srgb").toString({ format: "hex" });
  const accentBaseHex = accentBaseColor.to("srgb").toString({ format: "hex" });
  if (accentBaseHex === "#000" || accentBaseHex === "#fff") {
    accentScaleColors = grayScaleColors.map((color2) => color2.clone());
  }
  const [accent9Color, accentContrastColor] = getStep9Colors(accentScaleColors, accentBaseColor);
  accentScaleColors[8] = accent9Color;
  accentScaleColors[9] = getButtonHoverColor(accent9Color, [accentScaleColors]);
  accentScaleColors[10].coords[1] = Math.min(
    Math.max(accentScaleColors[8].coords[1], accentScaleColors[7].coords[1]),
    accentScaleColors[10].coords[1]
  );
  accentScaleColors[11].coords[1] = Math.min(
    Math.max(accentScaleColors[8].coords[1], accentScaleColors[7].coords[1]),
    accentScaleColors[11].coords[1]
  );
  const accentScaleHex = accentScaleColors.map(
    (color2) => color2.to("srgb").toString({ format: "hex" })
  );
  const accentScaleAlphaHex = accentScaleHex.map(
    (color2) => getAlphaColorSrgb(color2, backgroundHex)
  );
  const accentContrastColorHex = accentContrastColor.to("srgb").toString({ format: "hex" });
  const grayScaleHex = grayScaleColors.map(
    (color2) => color2.to("srgb").toString({ format: "hex" })
  );
  const grayScaleAlphaHex = grayScaleHex.map(
    (color2) => getAlphaColorSrgb(color2, backgroundHex)
  );
  const accentSurfaceHex = appearance === "light" ? getAlphaColorSrgb(accentScaleHex[1], backgroundHex, 0.8) : getAlphaColorSrgb(accentScaleHex[1], backgroundHex, 0.5);
  return {
    accentScale: accentScaleHex,
    accentScaleAlpha: accentScaleAlphaHex,
    // accentScaleWideGamut: accentScaleWideGamut,
    // accentScaleAlphaWideGamut: accentScaleAlphaWideGamutString,
    accentContrast: accentContrastColorHex,
    grayScale: grayScaleHex,
    grayScaleAlpha: grayScaleAlphaHex,
    // grayScaleWideGamut: grayScaleWideGamut,
    // grayScaleAlphaWideGamut: grayScaleAlphaWideGamutString,
    //
    graySurface: appearance === "light" ? "#ffffffcc" : "rgba(0, 0, 0, 0.05)",
    graySurfaceSolid: appearance === "light" ? "#ffffff" : "#111111",
    // graySurfaceWideGamut:
    //     appearance === 'light' ? 'color(display-p3 1 1 1 / 80%)' : 'color(display-p3 0 0 0 / 5%)',
    //
    accentSurface: accentSurfaceHex,
    // accentSurfaceWideGamut: accentSurfaceWideGamutString,
    background: backgroundHex
  };
};
const getColorObject = ({
  appearance,
  ...args
}) => {
  const allColors = generateRadixColors({
    appearance,
    accent: args.accent,
    gray: args.gray,
    background: args.background
  });
  const colors2 = allColors.accentScale.reduce((a2, v2, i) => ({ ...a2, ["color" + (i + 1)]: v2 }), {});
  const colorsAlpha = allColors.accentScaleAlpha.reduce((a2, v2, i) => ({ ...a2, ["colora" + (i + 1)]: v2 }), {});
  const colorsGray = allColors.grayScale.reduce((a2, v2, i) => ({ ...a2, ["colorg" + (i + 1)]: v2 }), {});
  const colorsGrayAlpha = allColors.grayScaleAlpha.reduce((a2, v2, i) => ({ ...a2, ["colorga" + (i + 1)]: v2 }), {});
  const colorContrast = { "colorContrast": allColors.accentContrast };
  const colorBackground = { "colorBackground": allColors.background };
  const accentSurface = { "accentSurface": allColors.accentSurface };
  const graySurface = { "graySurface": allColors.graySurface };
  const graySurfaceSolid = { "graySurfaceSolid": allColors.graySurfaceSolid };
  return { ...colors2, ...colorsAlpha, ...colorsGray, ...colorsGrayAlpha, ...colorContrast, ...colorBackground, ...accentSurface, ...graySurface, ...graySurfaceSolid };
};
function getStep9Colors(scale2, accentBaseColor) {
  const referenceBackgroundColor = scale2[0];
  const distance2 = accentBaseColor.deltaEOK(referenceBackgroundColor) * 100;
  if (distance2 < 25) {
    return [scale2[8], getTextColor(scale2[8])];
  }
  return [accentBaseColor, getTextColor(accentBaseColor)];
}
function getButtonHoverColor(source, scales2) {
  const [L2, C2, H2] = source.coords;
  const newL = L2 > 0.4 ? L2 - 0.03 / (L2 + 0.1) : L2 + 0.03 / (L2 + 0.1);
  const newC = L2 > 0.4 && !isNaN(H2) ? C2 * 0.93 + 0 : C2;
  const buttonHoverColor = new Color2("oklch", [newL, newC, H2]);
  let closestColor = buttonHoverColor;
  let minDistance = Infinity;
  scales2.forEach((scale2) => {
    for (const color2 of scale2) {
      const distance2 = buttonHoverColor.deltaEOK(color2);
      if (distance2 < minDistance) {
        minDistance = distance2;
        closestColor = color2;
      }
    }
  });
  buttonHoverColor.coords[1] = closestColor.coords[1];
  buttonHoverColor.coords[2] = closestColor.coords[2];
  return buttonHoverColor;
}
function getScaleFromColor(source, scales2, backgroundColor) {
  let allColors = [];
  Object.entries(scales2).forEach(([name, scale22]) => {
    for (const color2 of scale22) {
      const distance2 = source.deltaEOK(color2);
      allColors.push({ scale: name, distance: distance2, color: color2 });
    }
  });
  allColors.sort((a22, b22) => a22.distance - b22.distance);
  let closestColors = allColors.filter(
    (color2, i, arr) => i === arr.findIndex((value) => value.scale === color2.scale)
  );
  const grayScaleNamesStr = grayScaleNames;
  const allAreGrays = closestColors.every((color2) => grayScaleNamesStr.includes(color2.scale));
  if (!allAreGrays && grayScaleNamesStr.includes(closestColors[0].scale)) {
    while (grayScaleNamesStr.includes(closestColors[1].scale)) {
      closestColors.splice(1, 1);
    }
  }
  let colorA = closestColors[0];
  let colorB = closestColors[1];
  const a2 = colorB.distance;
  const b2 = colorA.distance;
  const c4 = colorA.color.deltaEOK(colorB.color);
  const cosA = (b2 ** 2 + c4 ** 2 - a2 ** 2) / (2 * b2 * c4);
  const radA = Math.acos(cosA);
  const sinA = Math.sin(radA);
  const cosB = (a2 ** 2 + c4 ** 2 - b2 ** 2) / (2 * a2 * c4);
  const radB = Math.acos(cosB);
  const sinB = Math.sin(radB);
  const tanC1 = cosA / sinA;
  const tanC2 = cosB / sinB;
  const ratio = Math.max(0, tanC1 / tanC2) * 0.5;
  const scaleA = scales2[colorA.scale];
  const scaleB = scales2[colorB.scale];
  const scale2 = arrayOf12.map(
    (i) => new Color2(Color2.mix(scaleA[i], scaleB[i], ratio)).to("oklch")
  );
  const baseColor = scale2.slice().sort((a22, b22) => source.deltaEOK(a22) - source.deltaEOK(b22))[0];
  const ratioC = source.coords[1] / baseColor.coords[1];
  scale2.forEach((color2) => {
    color2.coords[1] = Math.min(source.coords[1] * 1.5, color2.coords[1] * ratioC);
    color2.coords[2] = source.coords[2];
  });
  if (scale2[0].coords[0] > 0.5) {
    const lightnessScale2 = scale2.map(({ coords }) => coords[0]);
    const backgroundL2 = Math.max(0, Math.min(1, backgroundColor.coords[0]));
    const newLightnessScale2 = transposeProgressionStart(
      backgroundL2,
      // Add white as the first "step" of the light scale
      [1, ...lightnessScale2],
      lightModeEasing
    );
    newLightnessScale2.shift();
    newLightnessScale2.forEach((lightness, i) => {
      scale2[i].coords[0] = lightness;
    });
    return scale2;
  }
  let ease = [...darkModeEasing];
  const referenceBackgroundColorL = scale2[0].coords[0];
  const backgroundColorL = Math.max(0, Math.min(1, backgroundColor.coords[0]));
  const ratioL = backgroundColorL / referenceBackgroundColorL;
  if (ratioL > 1) {
    const maxRatio = 1.5;
    for (let i = 0; i < ease.length; i++) {
      const metaRatio = (ratioL - 1) * (maxRatio / (maxRatio - 1));
      ease[i] = ratioL > maxRatio ? 0 : Math.max(0, ease[i] * (1 - metaRatio));
    }
  }
  const lightnessScale = scale2.map(({ coords }) => coords[0]);
  const backgroundL = backgroundColor.coords[0];
  const newLightnessScale = transposeProgressionStart(backgroundL, lightnessScale, ease);
  newLightnessScale.forEach((lightness, i) => {
    scale2[i].coords[0] = lightness;
  });
  return scale2;
}
function getTextColor(background) {
  const white2 = new Color2("oklch", [1, 0, 0]);
  if (Math.abs(white2.contrastAPCA(background)) < 40) {
    const [L2, C2, H2] = background.coords;
    return new Color2("oklch", [0.25, Math.max(0.08 * C2, 0.04), H2]);
  }
  return white2;
}
function getAlphaColor(targetRgb, backgroundRgb, rgbPrecision, alphaPrecision, targetAlpha) {
  const [tr, tg, tb] = targetRgb.map((c4) => Math.round(c4 * rgbPrecision));
  const [br, bg, bb] = backgroundRgb.map((c4) => Math.round(c4 * rgbPrecision));
  if (tr === void 0 || tg === void 0 || tb === void 0 || br === void 0 || bg === void 0 || bb === void 0) {
    throw Error("Color is undefined");
  }
  let desiredRgb = 0;
  if (tr > br) {
    desiredRgb = rgbPrecision;
  } else if (tb > bb) {
    desiredRgb = rgbPrecision;
  }
  const alphaR = (tr - br) / (desiredRgb - br);
  const alphaG = (tg - bg) / (desiredRgb - bg);
  const alphaB = (tb - bb) / (desiredRgb - bb);
  const isPureGray = [alphaR, alphaG, alphaB].every((alpha2) => alpha2 === alphaR);
  if (!targetAlpha && isPureGray) {
    const V2 = desiredRgb / rgbPrecision;
    return [V2, V2, V2, alphaR];
  }
  const clampRgb = (n2) => isNaN(n2) ? 0 : Math.min(rgbPrecision, Math.max(0, n2));
  const clampA = (n2) => isNaN(n2) ? 0 : Math.min(alphaPrecision, Math.max(0, n2));
  const maxAlpha = targetAlpha ?? Math.max(alphaR, alphaG, alphaB);
  const A2 = clampA(Math.ceil(maxAlpha * alphaPrecision)) / alphaPrecision;
  let R2 = clampRgb((br * (1 - A2) - tr) / A2 * -1);
  let G = clampRgb((bg * (1 - A2) - tg) / A2 * -1);
  let B2 = clampRgb((bb * (1 - A2) - tb) / A2 * -1);
  R2 = Math.ceil(R2);
  G = Math.ceil(G);
  B2 = Math.ceil(B2);
  const blendedR = blendAlpha(R2, A2, br);
  const blendedG = blendAlpha(G, A2, bg);
  const blendedB = blendAlpha(B2, A2, bb);
  if (desiredRgb === 0) {
    if (tr <= br && tr !== blendedR) {
      R2 = tr > blendedR ? R2 + 1 : R2 - 1;
    }
    if (tg <= bg && tg !== blendedG) {
      G = tg > blendedG ? G + 1 : G - 1;
    }
    if (tb <= bb && tb !== blendedB) {
      B2 = tb > blendedB ? B2 + 1 : B2 - 1;
    }
  }
  if (desiredRgb === rgbPrecision) {
    if (tr >= br && tr !== blendedR) {
      R2 = tr > blendedR ? R2 + 1 : R2 - 1;
    }
    if (tg >= bg && tg !== blendedG) {
      G = tg > blendedG ? G + 1 : G - 1;
    }
    if (tb >= bb && tb !== blendedB) {
      B2 = tb > blendedB ? B2 + 1 : B2 - 1;
    }
  }
  R2 = R2 / rgbPrecision;
  G = G / rgbPrecision;
  B2 = B2 / rgbPrecision;
  return [R2, G, B2, A2];
}
function blendAlpha(foreground, alpha2, background, round2 = true) {
  if (round2) {
    return Math.round(background * (1 - alpha2)) + Math.round(foreground * alpha2);
  }
  return background * (1 - alpha2) + foreground * alpha2;
}
function getAlphaColorSrgb(targetColor, backgroundColor, targetAlpha) {
  const [r2, g2, b2, a2] = getAlphaColor(
    new Color2(targetColor).to("srgb").coords,
    new Color2(backgroundColor).to("srgb").coords,
    255,
    255,
    targetAlpha
  );
  return formatHex(new Color2("srgb", [r2, g2, b2], a2).toString({ format: "hex" }));
}
function formatHex(str) {
  if (!str.startsWith("#")) {
    return str;
  }
  if (str.length === 4) {
    const hash2 = str.charAt(0);
    const r2 = str.charAt(1);
    const g2 = str.charAt(2);
    const b2 = str.charAt(3);
    return hash2 + r2 + r2 + g2 + g2 + b2 + b2;
  }
  if (str.length === 5) {
    const hash2 = str.charAt(0);
    const r2 = str.charAt(1);
    const g2 = str.charAt(2);
    const b2 = str.charAt(3);
    const a2 = str.charAt(4);
    return hash2 + r2 + r2 + g2 + g2 + b2 + b2 + a2 + a2;
  }
  return str;
}
const darkModeEasing = [1, 0, 1, 0];
const lightModeEasing = [0, 2, 0, 2];
function transposeProgressionStart(to2, arr, curve) {
  return arr.map((n2, i, arr2) => {
    const lastIndex = arr2.length - 1;
    const diff2 = arr2[0] - to2;
    const fn = BezierEasing(...curve);
    return n2 - diff2 * fn(1 - i / lastIndex);
  });
}
var RangeWrapper = "_1ymxees0";
var RangeLabel = "_1ymxees1";
var Slider = "_1ymxees2";
const Range = ({ id, name, label, minValue = -100, maxValue = 100, step = 5, onChange: onChange2, defaultValue = 0, disabled = false, ariaLabel = "Range slider" }) => {
  const [currentValue, setCurrentValue] = useState(defaultValue);
  const handleChange = (event) => {
    event.preventDefault();
    const value = parseFloat(event.target.value);
    setCurrentValue(value);
    onChange2 == null ? void 0 : onChange2(value);
  };
  return /* @__PURE__ */ React__default.createElement("div", { className: RangeWrapper }, /* @__PURE__ */ React__default.createElement("label", { className: RangeLabel, htmlFor: id }, label + " : " + currentValue), /* @__PURE__ */ React__default.createElement(
    "input",
    {
      className: Slider,
      "aria-label": ariaLabel,
      type: "range",
      value: currentValue,
      min: minValue,
      max: maxValue,
      step,
      onChange: handleChange,
      id,
      name,
      disabled
    }
  ));
};
const ShowCardButton = ({ label, icon: icon2, onClick }) => {
  return /* @__PURE__ */ React__default.createElement("button", { onClick, className: showButton }, /* @__PURE__ */ React__default.createElement("div", { className: showButtonLabel }, /* @__PURE__ */ React__default.createElement("div", { className: showButtonIcon }, /* @__PURE__ */ React__default.createElement(Icon$2, { size: 16, icon: icon2, color: theme.colours.brand.colorContrast })), label));
};
var wrapper = "_16xbfyt0";
var importantInfos = "_16xbfyt1";
var importantInfosLogin = "_16xbfyt2";
var important = "_16xbfyt3";
var AvatarRoot = "_16xbfyt4";
var AvatarImage = "_16xbfyt5";
var AvatarFallback = "_16xbfyt6";
var chevron = "_16xbfyt7";
const MenuCard = (props) => {
  const handleClickNavigation = () => {
    props.onClick();
  };
  const handleNavigation = (event) => {
    if (event.code === "Space" || event.code === "Enter")
      props.onClick();
  };
  return /* @__PURE__ */ React__default.createElement("div", { onClick: handleClickNavigation, tabIndex: 0, onKeyDown: handleNavigation, className: `${wrapper}` }, /* @__PURE__ */ React__default.createElement(Icon$2, { size: 20, icon: props.icon }), props.title, /* @__PURE__ */ React__default.createElement(Icon$2, { size: 16, icon: "ChevronRight", className: chevron }));
};
const ProfilMenuCard = (props) => {
  const handleClickNavigation = () => {
    props.onClick();
  };
  const handleNavigation = (event) => {
    if (event.code === "Space" || event.code === "Enter")
      props.onClick();
  };
  const initial = props.fullName.split(" ").reduce((acc, curr) => acc + curr.charAt(0), "").slice(0, 2) || "NA";
  return /* @__PURE__ */ React__default.createElement("div", { onClick: handleClickNavigation, tabIndex: 0, onKeyDown: handleNavigation, className: `${wrapper} ${important}` }, /* @__PURE__ */ React__default.createElement($cddcb0b647441e34$export$be92b6f5f03c0fe9, { className: AvatarRoot }, /* @__PURE__ */ React__default.createElement(
    $cddcb0b647441e34$export$3e431a229df88919,
    {
      className: AvatarImage,
      src: props.picture,
      alt: props.fullName
    }
  ), /* @__PURE__ */ React__default.createElement($cddcb0b647441e34$export$fb8d7f40caaeea67, { className: AvatarFallback, delayMs: 600 }, initial)), /* @__PURE__ */ React__default.createElement("div", { className: importantInfos }, /* @__PURE__ */ React__default.createElement("h2", null, props.title), /* @__PURE__ */ React__default.createElement("span", { className: importantInfosLogin }, props.login)), /* @__PURE__ */ React__default.createElement(Icon$2, { size: 16, icon: "ChevronRight", className: chevron }));
};
var ProgressBarMain = "z41deo0";
var ProgressBarLabels = "z41deo1";
var ProgressBarBar = "z41deo2";
const ProgressBar = ({ labelMax, labelSeparator = "/", labelCurrent, value }) => {
  return /* @__PURE__ */ React__default.createElement("div", { className: ProgressBarMain }, /* @__PURE__ */ React__default.createElement("div", { className: ProgressBarLabels }, /* @__PURE__ */ React__default.createElement("span", null, labelCurrent), /* @__PURE__ */ React__default.createElement("span", null, labelSeparator), /* @__PURE__ */ React__default.createElement("span", null, labelMax)), /* @__PURE__ */ React__default.createElement("progress", { className: ProgressBarBar, value: value || 0, max: 100 }));
};
var row = "_1hqt2rw0";
var hiddenItemBar = "_1hqt2rw2";
var itemBar = "_1hqt2rw3";
var itemDate = "_1hqt2rw4";
var itemInfo = "_1hqt2rw5";
var mapWrapper = "_1hqt2rw6";
const chunk = (arr, size2) => Array.from(
  { length: Math.ceil(arr.length / size2) },
  (v2, i) => arr.slice(i * size2, i * size2 + size2)
);
const ActivityStream = (props) => {
  var _a2;
  const getIcon = (method) => {
    switch (method) {
      case "POST":
        return "Ajouter";
      case "PUT":
        return "Crayon";
      case "DELETE":
        return "Poubelle";
      default:
        return "Box";
    }
  };
  return /* @__PURE__ */ React__default.createElement("div", { className: mapWrapper }, (_a2 = props.groups) == null ? void 0 : _a2.map((g2, index2) => chunk(g2.activities, 3).map(
    (activities, index22) => /* @__PURE__ */ React__default.createElement("div", { className: row, key: index22 }, index22 % 2 === 1 && Array.from({ length: 3 - activities.length }, (v2, i) => i).map((i) => /* @__PURE__ */ React__default.createElement("div", { key: i, className: hiddenItemBar })), activities.map((activity) => /* @__PURE__ */ React__default.createElement("div", { className: itemBar }, /* @__PURE__ */ React__default.createElement("div", { className: itemInfo }, /* @__PURE__ */ React__default.createElement(Icon$2, { size: 20, icon: getIcon(activity.methode ?? "") }), " ", /* @__PURE__ */ React__default.createElement("span", null, activity.description)), /* @__PURE__ */ React__default.createElement("div", { className: itemDate }, activity.date, " ", activity.time))), index22 % 2 === 0 && Array.from({ length: 3 - activities.length }, (v2, i) => i).map((i) => /* @__PURE__ */ React__default.createElement("div", { key: i, className: hiddenItemBar })))
  )));
};
const $cb5cc270b50c6fcd$var$POPOVER_NAME = "Popover";
const [$cb5cc270b50c6fcd$var$createPopoverContext, $cb5cc270b50c6fcd$export$c8393c9e73286932] = $c512c27ab02ef895$export$50c7b4e9d9f19c1($cb5cc270b50c6fcd$var$POPOVER_NAME, [
  $cf1ac5d9fe0e8206$export$722aac194ae923
]);
const $cb5cc270b50c6fcd$var$usePopperScope = $cf1ac5d9fe0e8206$export$722aac194ae923();
const [$cb5cc270b50c6fcd$var$PopoverProvider, $cb5cc270b50c6fcd$var$usePopoverContext] = $cb5cc270b50c6fcd$var$createPopoverContext($cb5cc270b50c6fcd$var$POPOVER_NAME);
const $cb5cc270b50c6fcd$export$5b6b19405a83ff9d = (props) => {
  const { __scopePopover, children, open: openProp, defaultOpen, onOpenChange, modal = false } = props;
  const popperScope = $cb5cc270b50c6fcd$var$usePopperScope(__scopePopover);
  const triggerRef = useRef(null);
  const [hasCustomAnchor, setHasCustomAnchor] = useState(false);
  const [open = false, setOpen] = $71cd76cc60e0454e$export$6f32135080cb4c3({
    prop: openProp,
    defaultProp: defaultOpen,
    onChange: onOpenChange
  });
  return /* @__PURE__ */ createElement($cf1ac5d9fe0e8206$export$be92b6f5f03c0fe9, popperScope, /* @__PURE__ */ createElement($cb5cc270b50c6fcd$var$PopoverProvider, {
    scope: __scopePopover,
    contentId: $1746a345f3d73bb7$export$f680877a34711e37(),
    triggerRef,
    open,
    onOpenChange: setOpen,
    onOpenToggle: useCallback(
      () => setOpen(
        (prevOpen) => !prevOpen
      ),
      [
        setOpen
      ]
    ),
    hasCustomAnchor,
    onCustomAnchorAdd: useCallback(
      () => setHasCustomAnchor(true),
      []
    ),
    onCustomAnchorRemove: useCallback(
      () => setHasCustomAnchor(false),
      []
    ),
    modal
  }, children));
};
const $cb5cc270b50c6fcd$var$TRIGGER_NAME = "PopoverTrigger";
const $cb5cc270b50c6fcd$export$7dacb05d26466c3 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopePopover, ...triggerProps } = props;
  const context = $cb5cc270b50c6fcd$var$usePopoverContext($cb5cc270b50c6fcd$var$TRIGGER_NAME, __scopePopover);
  const popperScope = $cb5cc270b50c6fcd$var$usePopperScope(__scopePopover);
  const composedTriggerRef = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, context.triggerRef);
  const trigger = /* @__PURE__ */ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.button, _extends$1({
    type: "button",
    "aria-haspopup": "dialog",
    "aria-expanded": context.open,
    "aria-controls": context.contentId,
    "data-state": $cb5cc270b50c6fcd$var$getState(context.open)
  }, triggerProps, {
    ref: composedTriggerRef,
    onClick: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onClick, context.onOpenToggle)
  }));
  return context.hasCustomAnchor ? trigger : /* @__PURE__ */ createElement($cf1ac5d9fe0e8206$export$b688253958b8dfe7, _extends$1({
    asChild: true
  }, popperScope), trigger);
});
const $cb5cc270b50c6fcd$var$PORTAL_NAME = "PopoverPortal";
const [$cb5cc270b50c6fcd$var$PortalProvider, $cb5cc270b50c6fcd$var$usePortalContext] = $cb5cc270b50c6fcd$var$createPopoverContext($cb5cc270b50c6fcd$var$PORTAL_NAME, {
  forceMount: void 0
});
const $cb5cc270b50c6fcd$export$dd679ffb4362d2d4 = (props) => {
  const { __scopePopover, forceMount, children, container } = props;
  const context = $cb5cc270b50c6fcd$var$usePopoverContext($cb5cc270b50c6fcd$var$PORTAL_NAME, __scopePopover);
  return /* @__PURE__ */ createElement($cb5cc270b50c6fcd$var$PortalProvider, {
    scope: __scopePopover,
    forceMount
  }, /* @__PURE__ */ createElement($921a889cee6df7e8$export$99c2b779aa4e8b8b, {
    present: forceMount || context.open
  }, /* @__PURE__ */ createElement($f1701beae083dbae$export$602eac185826482c, {
    asChild: true,
    container
  }, children)));
};
const $cb5cc270b50c6fcd$var$CONTENT_NAME = "PopoverContent";
const $cb5cc270b50c6fcd$export$d7e1f420b25549ff = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const portalContext = $cb5cc270b50c6fcd$var$usePortalContext($cb5cc270b50c6fcd$var$CONTENT_NAME, props.__scopePopover);
  const { forceMount = portalContext.forceMount, ...contentProps } = props;
  const context = $cb5cc270b50c6fcd$var$usePopoverContext($cb5cc270b50c6fcd$var$CONTENT_NAME, props.__scopePopover);
  return /* @__PURE__ */ createElement($921a889cee6df7e8$export$99c2b779aa4e8b8b, {
    present: forceMount || context.open
  }, context.modal ? /* @__PURE__ */ createElement($cb5cc270b50c6fcd$var$PopoverContentModal, _extends$1({}, contentProps, {
    ref: forwardedRef
  })) : /* @__PURE__ */ createElement($cb5cc270b50c6fcd$var$PopoverContentNonModal, _extends$1({}, contentProps, {
    ref: forwardedRef
  })));
});
const $cb5cc270b50c6fcd$var$PopoverContentModal = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const context = $cb5cc270b50c6fcd$var$usePopoverContext($cb5cc270b50c6fcd$var$CONTENT_NAME, props.__scopePopover);
  const contentRef = useRef(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, contentRef);
  const isRightClickOutsideRef = useRef(false);
  useEffect(() => {
    const content = contentRef.current;
    if (content) return hideOthers(content);
  }, []);
  return /* @__PURE__ */ createElement($am6gm$RemoveScroll, {
    as: $5e63c961fc1ce211$export$8c6ed5c666ac1360,
    allowPinchZoom: true
  }, /* @__PURE__ */ createElement($cb5cc270b50c6fcd$var$PopoverContentImpl, _extends$1({}, props, {
    ref: composedRefs,
    trapFocus: context.open,
    disableOutsidePointerEvents: true,
    onCloseAutoFocus: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onCloseAutoFocus, (event) => {
      var _context$triggerRef$c;
      event.preventDefault();
      if (!isRightClickOutsideRef.current) (_context$triggerRef$c = context.triggerRef.current) === null || _context$triggerRef$c === void 0 || _context$triggerRef$c.focus();
    }),
    onPointerDownOutside: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerDownOutside, (event) => {
      const originalEvent = event.detail.originalEvent;
      const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
      const isRightClick = originalEvent.button === 2 || ctrlLeftClick;
      isRightClickOutsideRef.current = isRightClick;
    }, {
      checkForDefaultPrevented: false
    }),
    onFocusOutside: $e42e1063c40fb3ef$export$b9ecd428b558ff10(
      props.onFocusOutside,
      (event) => event.preventDefault(),
      {
        checkForDefaultPrevented: false
      }
    )
  })));
});
const $cb5cc270b50c6fcd$var$PopoverContentNonModal = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const context = $cb5cc270b50c6fcd$var$usePopoverContext($cb5cc270b50c6fcd$var$CONTENT_NAME, props.__scopePopover);
  const hasInteractedOutsideRef = useRef(false);
  const hasPointerDownOutsideRef = useRef(false);
  return /* @__PURE__ */ createElement($cb5cc270b50c6fcd$var$PopoverContentImpl, _extends$1({}, props, {
    ref: forwardedRef,
    trapFocus: false,
    disableOutsidePointerEvents: false,
    onCloseAutoFocus: (event) => {
      var _props$onCloseAutoFoc;
      (_props$onCloseAutoFoc = props.onCloseAutoFocus) === null || _props$onCloseAutoFoc === void 0 || _props$onCloseAutoFoc.call(props, event);
      if (!event.defaultPrevented) {
        var _context$triggerRef$c2;
        if (!hasInteractedOutsideRef.current) (_context$triggerRef$c2 = context.triggerRef.current) === null || _context$triggerRef$c2 === void 0 || _context$triggerRef$c2.focus();
        event.preventDefault();
      }
      hasInteractedOutsideRef.current = false;
      hasPointerDownOutsideRef.current = false;
    },
    onInteractOutside: (event) => {
      var _props$onInteractOuts, _context$triggerRef$c3;
      (_props$onInteractOuts = props.onInteractOutside) === null || _props$onInteractOuts === void 0 || _props$onInteractOuts.call(props, event);
      if (!event.defaultPrevented) {
        hasInteractedOutsideRef.current = true;
        if (event.detail.originalEvent.type === "pointerdown") hasPointerDownOutsideRef.current = true;
      }
      const target = event.target;
      const targetIsTrigger = (_context$triggerRef$c3 = context.triggerRef.current) === null || _context$triggerRef$c3 === void 0 ? void 0 : _context$triggerRef$c3.contains(target);
      if (targetIsTrigger) event.preventDefault();
      if (event.detail.originalEvent.type === "focusin" && hasPointerDownOutsideRef.current) event.preventDefault();
    }
  }));
});
const $cb5cc270b50c6fcd$var$PopoverContentImpl = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopePopover, trapFocus, onOpenAutoFocus, onCloseAutoFocus, disableOutsidePointerEvents, onEscapeKeyDown, onPointerDownOutside, onFocusOutside, onInteractOutside, ...contentProps } = props;
  const context = $cb5cc270b50c6fcd$var$usePopoverContext($cb5cc270b50c6fcd$var$CONTENT_NAME, __scopePopover);
  const popperScope = $cb5cc270b50c6fcd$var$usePopperScope(__scopePopover);
  $3db38b7d1fb3fe6a$export$b7ece24a22aeda8c();
  return /* @__PURE__ */ createElement($d3863c46a17e8a28$export$20e40289641fbbb6, {
    asChild: true,
    loop: true,
    trapped: trapFocus,
    onMountAutoFocus: onOpenAutoFocus,
    onUnmountAutoFocus: onCloseAutoFocus
  }, /* @__PURE__ */ createElement($5cb92bef7577960e$export$177fb62ff3ec1f22, {
    asChild: true,
    disableOutsidePointerEvents,
    onInteractOutside,
    onEscapeKeyDown,
    onPointerDownOutside,
    onFocusOutside,
    onDismiss: () => context.onOpenChange(false)
  }, /* @__PURE__ */ createElement($cf1ac5d9fe0e8206$export$7c6e2c02157bb7d2, _extends$1({
    "data-state": $cb5cc270b50c6fcd$var$getState(context.open),
    role: "dialog",
    id: context.contentId
  }, popperScope, contentProps, {
    ref: forwardedRef,
    style: {
      ...contentProps.style,
      "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
      "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
      "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }))));
});
function $cb5cc270b50c6fcd$var$getState(open) {
  return open ? "open" : "closed";
}
const $cb5cc270b50c6fcd$export$be92b6f5f03c0fe9 = $cb5cc270b50c6fcd$export$5b6b19405a83ff9d;
const $cb5cc270b50c6fcd$export$41fb9f06171c75f4 = $cb5cc270b50c6fcd$export$7dacb05d26466c3;
const $cb5cc270b50c6fcd$export$602eac185826482c = $cb5cc270b50c6fcd$export$dd679ffb4362d2d4;
const $cb5cc270b50c6fcd$export$7c6e2c02157bb7d2 = $cb5cc270b50c6fcd$export$d7e1f420b25549ff;
var resetBtnRadix = "_1dbaox34";
var PopoverContent = "_1dbaox35";
const MyButton = React__default.forwardRef((props, forwardedRef) => /* @__PURE__ */ React__default.createElement("div", { ...props, ref: forwardedRef }, props.children));
const PopoverButton = (props) => {
  const { children, onClick, ...button2 } = props;
  return /* @__PURE__ */ React__default.createElement($cb5cc270b50c6fcd$export$be92b6f5f03c0fe9, null, /* @__PURE__ */ React__default.createElement($cb5cc270b50c6fcd$export$41fb9f06171c75f4, { asChild: true, className: resetBtnRadix }, /* @__PURE__ */ React__default.createElement(MyButton, null, /* @__PURE__ */ React__default.createElement(Button, { ...button2 }))), /* @__PURE__ */ React__default.createElement($cb5cc270b50c6fcd$export$602eac185826482c, null, /* @__PURE__ */ React__default.createElement($cb5cc270b50c6fcd$export$7c6e2c02157bb7d2, { className: PopoverContent, sideOffset: 8 }, /* @__PURE__ */ React__default.createElement(Card, { shadow: true }, children))));
};
var FilterOptionWrapper = "_15yq9zq0";
var FilterOptionLabel = "_15yq9zq1";
const FilterOption = (props) => {
  const { name, label, checked } = props;
  return /* @__PURE__ */ React__default.createElement("div", { className: FilterOptionWrapper }, /* @__PURE__ */ React__default.createElement("input", { type: "checkbox", id: name, ...props, checked }), /* @__PURE__ */ React__default.createElement("label", { className: FilterOptionLabel, htmlFor: name }, label));
};
var CloseButton = "m5ynaf0";
const SaveModal = ({ title: title2, isOpened, onContinue, onAbort, onSave, labelContinue, labelSave, labelAbort, children }) => {
  const ref = useRef(null);
  useEffect(() => {
    if (isOpened) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }
  }, [isOpened]);
  const onMouseDown = (event) => {
    var _a2;
    if (event.target != ref.current && !((_a2 = ref.current) == null ? void 0 : _a2.contains(event.target))) {
      onContinue();
    }
  };
  useEscapeTo(() => {
    if (isOpened)
      onContinue();
  }, [isOpened]);
  return /* @__PURE__ */ React__default.createElement("div", { onMouseDown, className: classNames$1(isOpened && show, backdrop) }, /* @__PURE__ */ React__default.createElement(
    "div",
    {
      className: classNames$1(modaleContainer, MediumSize$1, isOpened && show),
      ref,
      onMouseDown
    },
    /* @__PURE__ */ React__default.createElement("div", { className: CloseButton, onClick: () => onContinue() }, /* @__PURE__ */ React__default.createElement(Icon$2, { size: 16, icon: "Supprimer" })),
    /* @__PURE__ */ React__default.createElement("div", { className: TitleStyle }, title2),
    children,
    /* @__PURE__ */ React__default.createElement("div", { className: buttonContainer$1 }, /* @__PURE__ */ React__default.createElement(Button, { label: labelContinue, onClick: onContinue, type: "secondary" }), /* @__PURE__ */ React__default.createElement(Button, { label: labelSave, onClick: onSave, type: "primary" }), /* @__PURE__ */ React__default.createElement(Button, { label: labelAbort, onClick: onAbort, type: "negative" }))
  ));
};
export {
  AccordionPanel,
  AccountCell,
  AccountSelectRenderer,
  ActionsHistory,
  ActivityStream,
  AreaChart,
  WeAvatar as Avatar,
  BadgeStatus,
  BankDisplay,
  BarChart,
  Breadcrumbs,
  BtnAlert,
  BtnLangue,
  BtnProfil,
  Button,
  Card,
  CardOperation,
  CardPreview,
  CardSeeMoreButton,
  Carousel,
  CarouselMenu,
  CellAmount,
  ChatBox,
  Checkbox,
  Code,
  Color$2 as Color,
  CurrencyTab,
  DatePickerInput as DatePicker,
  DocumentPreview,
  DoubleZoneCard,
  DoughnutChart,
  FilterOption,
  FinancialChart,
  HelloClient,
  Iban,
  Icon$2 as Icon,
  Icon$1 as IconWithBadge,
  ImportFile,
  Information,
  InformationMessage,
  Input$3 as Input,
  LastTransactions,
  Loader,
  Menu$2 as Menu,
  MenuCard,
  Message,
  DialogModal as Modal,
  NewSelect,
  OrdersToSignNumber as OrderToSignNumber,
  POSSIBLE_LOGO,
  Pagination,
  PopoverButton,
  Profil,
  ProfilMenuCard,
  ProgressBar as Progress,
  ProgressBar$1 as ProgressBar,
  Radio,
  Range,
  RangeDatePickerInput,
  RelativeRightPanel,
  RightPanel,
  SaveModal,
  SearchBar,
  SelectInput as Select,
  ShowCardButton as ShowCardbutton,
  SingleDoughnut,
  Skeleton,
  Status,
  Switch,
  TableBody as TBody,
  TableCell as TD,
  TableHeader as TH,
  TableHead as THead,
  TableRow as TR,
  Table,
  TableSkeleton,
  Tabs,
  ThemeChooser,
  Toasts,
  TooltipUI as Tooltip,
  TopBar,
  TypeAnimation$1 as TypeAnimation,
  demoDarkV2,
  demoLightV2,
  getColorObject,
  theme,
  useBankName,
  useInitial,
  useToast
};
